// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  function $parcel$import(url) {  url = importMap[url] || url;  return import(distDir + url);}newRequire.load = $parcel$import;function $parcel$resolve(url) {  url = importMap[url] || url;  return new URL(distDir + url, import.meta.url).toString();}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"bjDQT":[function(require,module,exports,__globalThis) {
module.bundle.extendImportMap({
    "avQxI": "throbber.bbc8b20e.css",
    "i714p": "robot-head.628dddc9.png",
    "9bEYu": "admin.5df64557.js",
    "bL10l": "appTemplate.ae242800.js",
    "kPp95": "toggleSwitch.6d842bcb.css",
    "g8Cys": "sortableTable.50cceabb.css",
    "g781u": "reports.c402fd41.css",
    "bYKjy": "profileMenu.1c3171aa.css",
    "j9kbL": "mainAdmin.02af16d2.js",
    "5Sc7W": "pages.28bdc88b.js",
    "flCyB": "pages.b8676075.css",
    "dg6sl": "editArticle.cb045ca8.js",
    "hrkRR": "richText.0586c1d2.js",
    "7K9xZ": "richText.4436f762.css",
    "bE9my": "forms.d1dc62f9.js",
    "9Fb94": "forms.12b519c8.css",
    "bK8fB": "images.3b24f457.js",
    "bxpOq": "absence.159c64f0.js",
    "aKkyU": "calendar.8b230944.js",
    "8cXsz": "calendar.398cac24.css",
    "5O65E": "absence.7c9023e5.js",
    "60gHn": "absence.543ff468.css",
    "9Po7t": "employees.dd5b5377.js",
    "5Kl07": "employees.4bbc2023.js",
    "h7aRS": "employees.3b39b486.js",
    "gYtbo": "employees.919dff6f.js",
    "cSNDa": "users.86a39d41.js",
    "32R7G": "users.f0a86bae.css",
    "hNcIZ": "groups.9d0b5d2a.js",
    "grC4I": "companySettings.058f3caf.js",
    "2Xkst": "companySettings.b2d8244b.css",
    "lWrHY": "absenceSettings.d06d55fc.js",
    "cVp6C": "absenceSettings.21041204.css",
    "dkN3N": "employeeDbSettings.7d9b9f4e.js",
    "iX2HR": "submissions.bf66f783.js",
    "e0Zay": "submissions.7a24cb47.css",
    "XefME": "auditLogs.0c071da4.js",
    "dsIdL": "auditLogs.cf8448d0.css",
    "1If8o": "menus.fee78305.js",
    "2vu7w": "reminders.5ce716cc.js",
    "dNk50": "announcements.66a01022.js",
    "7IrpG": "announcements.bfdd3d4c.css",
    "iGS3i": "listAccounts.7a75ff08.js",
    "kHsOd": "listAccounts.8d17e33d.css",
    "89OUI": "manageUsers.f3c75750.js",
    "3cSOe": "adminSettings.582bb138.js",
    "lNR8S": "restore.af897e7a.js",
    "2H5CU": "rollout.7b797b93.js",
    "fslUQ": "editAccount.0c5df2ac.js",
    "kwimj": "training.26d98915.js",
    "4KPyw": "yourProfile.9d36bd66.js",
    "DVySg": "audit.437320ad.js",
    "bdq8I": "audit.8866938c.css",
    "j3AUn": "settings.f8e2c474.js",
    "1ZZMc": "articleEdit.f3b9b5c9.js",
    "lES5o": "templatesDrafts.d14dc207.js",
    "hZRjj": "appTemplate.fe1989f8.css",
    "bWjly": "externalCss.3f3e85f6.js",
    "bOsTI": "skeleton.f26a2d5e.css",
    "h0Jmt": "spinner.06226fd5.css",
    "80v8O": "closeButton.1e148836.css",
    "hMhSG": "contracts.c24b23f7.css",
    "dDLTL": "printButton.c0e030fd.css",
    "3iu2b": "generic-logo.12e6878c.webp",
    "5YGUx": "logo-admin.9ed7b91b.svg",
    "3RQPc": "logo-yhr.fcd2164a.svg",
    "dwcwW": "client.d31af4fa.js",
    "glxJL": "serviceWorker.js"
});

},{}],"9jmdF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _reactHotToast = require("react-hot-toast");
var _reactHotToastDefault = parcelHelpers.interopDefault(_reactHotToast);
var _throbber = require("./components/common/throbber");
var _throbberDefault = parcelHelpers.interopDefault(_throbber);
var _devInfo = require("./components/common/devInfo");
var _devInfoDefault = parcelHelpers.interopDefault(_devInfo);
var _reactQuery = require("react-query");
var _devtools = require("react-query/devtools");
var _app = require("./app");
var _appDefault = parcelHelpers.interopDefault(_app);
var _capacitor = require("./utilities/capacitor");
const handleServerIsDown = (serverIsDown)=>{
    const serverDownElement = document.getElementById("server-down");
    if (serverIsDown && !serverDownElement) {
        const serverDown = document.createElement("div");
        serverDown.id = "server-down";
        serverDown.innerHTML = `
        <div class="server-down">
          <p>YourHR.space is currently down for maintenance.</p>
          <p>Please check back soon.</p>
        </div>
      `;
        return document.body.appendChild(serverDown);
    }
};
// Check if running as Capacitor app
if ((0, _capacitor.isCapacitorApp)()) {
    document.querySelector("body").classList.add("app");
    // remove viewport meta tag
    const viewport = document.querySelector('meta[name="viewport"]');
    if (viewport) viewport.remove();
    // add meta tags to prevent user scaling / pinch zoom on Capacitor app
    const meta = document.createElement("meta");
    meta.name = "viewport";
    meta.content = "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0";
    document.head.appendChild(meta);
}
const handleQueryError = (error)=>{
    if (error.toasterMessage) (0, _reactHotToastDefault.default).error(`${error.toasterMessage}`, {
        id: error.toasterMessage
    });
    if (error.status === 503) return handleServerIsDown(true);
    handleServerIsDown(false);
};
const queryClient = new (0, _reactQuery.QueryClient)({
    defaultOptions: {
        queries: {
            onError: handleQueryError
        },
        mutations: {
            onError: handleQueryError
        }
    }
});
if ("serviceWorker" in navigator) navigator.serviceWorker.register(require("8403ed68ae3e45d2"), {
    scope: "/"
}).then(()=>{
    console.log("SW Registered!");
}).catch(()=>{
    console.log("SW Registration Failed");
});
(0, _reactDomDefault.default).render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
    fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "throbber-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _throbberDefault.default), {})
    }),
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactQuery.QueryClientProvider), {
        client: queryClient,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appDefault.default), {}),
            false
        ]
    })
}), document.getElementById("root"));

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","react-dom":"7k58v","react-hot-toast":"jcNGA","./components/common/throbber":"c8mQZ","./components/common/devInfo":"ehPaH","react-query":"41hyj","react-query/devtools":"kskQG","./app":"94jhf","./utilities/capacitor":"lTR78","8403ed68ae3e45d2":"hJioV","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"i3K7E":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"5f3fX"}],"5f3fX":[function(require,module,exports,__globalThis) {
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
require("ea59cf80247f96ff");
var f = require("3fd2a064dc1f3641"), g = 60103;
exports.Fragment = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var h = Symbol.for;
    g = h("react.element");
    exports.Fragment = h("react.fragment");
}
var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: m.current
    };
}
exports.jsx = q;
exports.jsxs = q;

},{"ea59cf80247f96ff":"2kuA9","3fd2a064dc1f3641":"6wC8C"}],"2kuA9":[function(require,module,exports,__globalThis) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

},{}],"6wC8C":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"junte"}],"junte":[function(require,module,exports,__globalThis) {
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var l = require("f790cf940e488cc5"), n = 60103, p = 60106;
exports.Fragment = 60107;
exports.StrictMode = 60108;
exports.Profiler = 60114;
var q = 60109, r = 60110, t = 60112;
exports.Suspense = 60113;
var u = 60115, v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var w = Symbol.for;
    n = w("react.element");
    p = w("react.portal");
    exports.Fragment = w("react.fragment");
    exports.StrictMode = w("react.strict_mode");
    exports.Profiler = w("react.profiler");
    q = w("react.provider");
    r = w("react.context");
    t = w("react.forward_ref");
    exports.Suspense = w("react.suspense");
    u = w("react.memo");
    v = w("react.lazy");
}
var x = "function" === typeof Symbol && Symbol.iterator;
function y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = x && a[x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, B = {};
function C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = B;
    this.updater = c || A;
}
C.prototype.isReactComponent = {};
C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error(z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function D() {}
D.prototype = C.prototype;
function E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = B;
    this.updater = c || A;
}
var F = E.prototype = new D;
F.constructor = E;
l(F, C.prototype);
F.isPureReactComponent = !0;
var G = {
    current: null
}, H = Object.prototype.hasOwnProperty, I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)H.call(b, e) && !I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: G.current
    };
}
function K(a, b) {
    return {
        $$typeof: n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === n;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var M = /\/+/g;
function N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case n:
                case p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace(M, "$&/") + "/"), O(d, b, c, "", function(a) {
        return a;
    })) : null != d && (L(d) && (d = K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace(M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + N(k, g);
        h += O(k, b, c, f, d);
    }
    else if (f = y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + N(k, g++), h += O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error(z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var R = {
    current: null
};
function S() {
    var a = R.current;
    if (null === a) throw Error(z(321));
    return a;
}
var T = {
    ReactCurrentDispatcher: R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: l
};
exports.Children = {
    map: P,
    forEach: function(a, b, c) {
        P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!L(a)) throw Error(z(143));
        return a;
    }
};
exports.Component = C;
exports.PureComponent = E;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = T;
exports.cloneElement = function(a, b, c) {
    if (null === a || void 0 === a) throw Error(z(267, a));
    var e = l({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)H.call(b, f) && !I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
exports.createContext = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: q,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = J;
exports.createFactory = function(a) {
    var b = J.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: t,
        render: a
    };
};
exports.isValidElement = L;
exports.lazy = function(a) {
    return {
        $$typeof: v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: Q
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.useCallback = function(a, b) {
    return S().useCallback(a, b);
};
exports.useContext = function(a, b) {
    return S().useContext(a, b);
};
exports.useDebugValue = function() {};
exports.useEffect = function(a, b) {
    return S().useEffect(a, b);
};
exports.useImperativeHandle = function(a, b, c) {
    return S().useImperativeHandle(a, b, c);
};
exports.useLayoutEffect = function(a, b) {
    return S().useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return S().useMemo(a, b);
};
exports.useReducer = function(a, b, c) {
    return S().useReducer(a, b, c);
};
exports.useRef = function(a) {
    return S().useRef(a);
};
exports.useState = function(a) {
    return S().useState(a);
};
exports.version = "17.0.2";

},{"f790cf940e488cc5":"2kuA9"}],"7k58v":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"l7vtx"}],"l7vtx":[function(require,module,exports,__globalThis) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';
var aa = require("5393afc8c463ef07"), m = require("dc13beaf0535b548"), r = require("ece50e903283a22f");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!aa) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return m({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    aa.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = m({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return m({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = m({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        r.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, r.unstable_scheduleCallback(r.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = r.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = r.unstable_UserBlockingPriority, ed = r.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    m(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = m({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = m({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = m({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = m({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = m({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = m({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = m({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = m({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = m({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = m({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = m({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = m({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return m({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = r.unstable_runWithPriority, Of = r.unstable_scheduleCallback, Pf = r.unstable_cancelCallback, Qf = r.unstable_shouldYield, Rf = r.unstable_requestPaint, Sf = r.unstable_now, Tf = r.unstable_getCurrentPriorityLevel, Uf = r.unstable_ImmediatePriority, Vf = r.unstable_UserBlockingPriority, Wf = r.unstable_NormalPriority, Xf = r.unstable_LowPriority, Yf = r.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = m({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = m({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new aa.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : m({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = m({}, e, {
                    value: void 0
                });
                d = m({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = m({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

},{"5393afc8c463ef07":"6wC8C","dc13beaf0535b548":"2kuA9","ece50e903283a22f":"6Nc0e"}],"6Nc0e":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"b0s7d"}],"b0s7d":[function(require,module,exports,__globalThis) {
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var f, g, h, k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var t = null, u = null, w = function() {
        if (null !== t) try {
            var a = exports.unstable_now();
            t(!0, a);
            t = null;
        } catch (b) {
            throw setTimeout(w, 0), b;
        }
    };
    f = function(a) {
        null !== t ? setTimeout(f, 0, a) : (t = a, setTimeout(w, 0));
    };
    g = function(a, b) {
        u = setTimeout(a, b);
    };
    h = function() {
        clearTimeout(u);
    };
    exports.unstable_shouldYield = function() {
        return !1;
    };
    k = exports.unstable_forceFrameRate = function() {};
} else {
    var x = window.setTimeout, y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var A = !1, B = null, C = -1, D = 5, E = 0;
    exports.unstable_shouldYield = function() {
        return exports.unstable_now() >= E;
    };
    k = function() {};
    exports.unstable_forceFrameRate = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var F = new MessageChannel, G = F.port2;
    F.port1.onmessage = function() {
        if (null !== B) {
            var a = exports.unstable_now();
            E = a + D;
            try {
                B(!0, a) ? G.postMessage(null) : (A = !1, B = null);
            } catch (b) {
                throw G.postMessage(null), b;
            }
        } else A = !1;
    };
    f = function(a) {
        B = a;
        A || (A = !0, G.postMessage(null));
    };
    g = function(a, b) {
        C = x(function() {
            a(exports.unstable_now());
        }, b);
    };
    h = function() {
        y(C);
        C = -1;
    };
}
function H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > I(n, c)) void 0 !== r && 0 > I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var L = [], M = [], N = 1, O = null, P = 3, Q = !1, R = !1, S = !1;
function T(a) {
    for(var b = J(M); null !== b;){
        if (null === b.callback) K(M);
        else if (b.startTime <= a) K(M), b.sortIndex = b.expirationTime, H(L, b);
        else break;
        b = J(M);
    }
}
function U(a) {
    S = !1;
    T(a);
    if (!R) {
        if (null !== J(L)) R = !0, f(V);
        else {
            var b = J(M);
            null !== b && g(U, b.startTime - a);
        }
    }
}
function V(a, b) {
    R = !1;
    S && (S = !1, h());
    Q = !0;
    var c = P;
    try {
        T(b);
        for(O = J(L); null !== O && (!(O.expirationTime > b) || a && !exports.unstable_shouldYield());){
            var d = O.callback;
            if ("function" === typeof d) {
                O.callback = null;
                P = O.priorityLevel;
                var e = d(O.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? O.callback = e : O === J(L) && K(L);
                T(b);
            } else K(L);
            O = J(L);
        }
        if (null !== O) var m = !0;
        else {
            var n = J(M);
            null !== n && g(U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        O = null, P = c, Q = !1;
    }
}
var W = k;
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    R || Q || (R = !0, f(V));
};
exports.unstable_getCurrentPriorityLevel = function() {
    return P;
};
exports.unstable_getFirstCallbackNode = function() {
    return J(L);
};
exports.unstable_next = function(a) {
    switch(P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = P;
    }
    var c = P;
    P = b;
    try {
        return a();
    } finally{
        P = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = W;
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = P;
    P = a;
    try {
        return b();
    } finally{
        P = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, H(M, a), null === J(L) && a === J(M) && (S ? h() : S = !0, g(U, c - d))) : (a.sortIndex = e, H(L, a), R || Q || (R = !0, f(V)));
    return a;
};
exports.unstable_wrapCallback = function(a) {
    var b = P;
    return function() {
        var c = P;
        P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            P = c;
        }
    };
};

},{}],"jcNGA":[function(require,module,exports,__globalThis) {
"use client";
"use strict";
var se = Object.create;
var k = Object.defineProperty;
var ae = Object.getOwnPropertyDescriptor;
var ie = Object.getOwnPropertyNames;
var ne = Object.getPrototypeOf, ce = Object.prototype.hasOwnProperty;
var pe = (e, t)=>{
    for(var o in t)k(e, o, {
        get: t[o],
        enumerable: !0
    });
}, G = (e, t, o, s)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let a of ie(t))!ce.call(e, a) && a !== o && k(e, a, {
        get: ()=>t[a],
        enumerable: !(s = ae(t, a)) || s.enumerable
    });
    return e;
};
var j = (e, t, o)=>(o = e != null ? se(ne(e)) : {}, G(t || !e || !e.__esModule ? k(o, "default", {
        value: e,
        enumerable: !0
    }) : o, e)), de = (e)=>G(k({}, "__esModule", {
        value: !0
    }), e);
var Ue = {};
pe(Ue, {
    CheckmarkIcon: ()=>U,
    ErrorIcon: ()=>C,
    LoaderIcon: ()=>L,
    ToastBar: ()=>N,
    ToastIcon: ()=>$,
    Toaster: ()=>oe,
    default: ()=>Le,
    resolveValue: ()=>g,
    toast: ()=>i,
    useToaster: ()=>M,
    useToasterStore: ()=>w
});
module.exports = de(Ue);
var me = (e)=>typeof e == "function", g = (e, t)=>me(e) ? e(t) : e;
var J = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), _ = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();
var A = require("cff97412359109c");
var le = 20, Y = "default";
var K = (e, t)=>{
    let { toastLimit: o } = e.settings;
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, o)
            };
        case 1:
            return {
                ...e,
                toasts: e.toasts.map((r)=>r.id === t.toast.id ? {
                        ...r,
                        ...t.toast
                    } : r)
            };
        case 2:
            let { toast: s } = t;
            return K(e, {
                type: e.toasts.find((r)=>r.id === s.id) ? 1 : 0,
                toast: s
            });
        case 3:
            let { toastId: a } = t;
            return {
                ...e,
                toasts: e.toasts.map((r)=>r.id === a || a === void 0 ? {
                        ...r,
                        dismissed: !0,
                        visible: !1
                    } : r)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((r)=>r.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let n = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((r)=>({
                        ...r,
                        pauseDuration: r.pauseDuration + n
                    }))
            };
    }
}, V = [], Z = {
    toasts: [],
    pausedAt: void 0,
    settings: {
        toastLimit: le
    }
}, T = {}, ee = (e, t = Y)=>{
    T[t] = K(T[t] || Z, e), V.forEach(([o, s])=>{
        o === t && s(T[t]);
    });
}, Q = (e)=>Object.keys(T).forEach((t)=>ee(e, t)), te = (e)=>Object.keys(T).find((t)=>T[t].toasts.some((o)=>o.id === e)), P = (e = Y)=>(t)=>{
        ee(t, e);
    }, ue = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, w = (e = {}, t = Y)=>{
    let [o, s] = (0, A.useState)(T[t] || Z), a = (0, A.useRef)(T[t]);
    (0, A.useEffect)(()=>(a.current !== T[t] && s(T[t]), V.push([
            t,
            s
        ]), ()=>{
            let r = V.findIndex(([u])=>u === t);
            r > -1 && V.splice(r, 1);
        }), [
        t
    ]);
    let n = o.toasts.map((r)=>{
        var u, x, y;
        return {
            ...e,
            ...e[r.type],
            ...r,
            removeDelay: r.removeDelay || ((u = e[r.type]) == null ? void 0 : u.removeDelay) || (e == null ? void 0 : e.removeDelay),
            duration: r.duration || ((x = e[r.type]) == null ? void 0 : x.duration) || (e == null ? void 0 : e.duration) || ue[r.type],
            style: {
                ...e.style,
                ...(y = e[r.type]) == null ? void 0 : y.style,
                ...r.style
            }
        };
    });
    return {
        ...o,
        toasts: n
    };
};
var Te = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        dismissed: !1,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || J()
    }), D = (e)=>(t, o)=>{
        let s = Te(t, e, o);
        return P(s.toasterId || te(s.id))({
            type: 2,
            toast: s
        }), s.id;
    }, i = (e, t)=>D("blank")(e, t);
i.error = D("error");
i.success = D("success");
i.loading = D("loading");
i.custom = D("custom");
i.dismiss = (e, t)=>{
    let o = {
        type: 3,
        toastId: e
    };
    t ? P(t)(o) : Q(o);
};
i.dismissAll = (e)=>i.dismiss(void 0, e);
i.remove = (e, t)=>{
    let o = {
        type: 4,
        toastId: e
    };
    t ? P(t)(o) : Q(o);
};
i.removeAll = (e)=>i.remove(void 0, e);
i.promise = (e, t, o)=>{
    let s = i.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return typeof e == "function" && (e = e()), e.then((a)=>{
        let n = t.success ? g(t.success, a) : void 0;
        return n ? i.success(n, {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }) : i.dismiss(s), a;
    }).catch((a)=>{
        let n = t.error ? g(t.error, a) : void 0;
        n ? i.error(n, {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        }) : i.dismiss(s);
    }), e;
};
var l = require("cff97412359109c");
var ye = 1e3, M = (e, t = "default")=>{
    let { toasts: o, pausedAt: s } = w(e, t), a = (0, l.useRef)(new Map).current, n = (0, l.useCallback)((c, m = ye)=>{
        if (a.has(c)) return;
        let p = setTimeout(()=>{
            a.delete(c), r({
                type: 4,
                toastId: c
            });
        }, m);
        a.set(c, p);
    }, []);
    (0, l.useEffect)(()=>{
        if (s) return;
        let c = Date.now(), m = o.map((p)=>{
            if (p.duration === 1 / 0) return;
            let I = (p.duration || 0) + p.pauseDuration - (c - p.createdAt);
            if (I < 0) {
                p.visible && i.dismiss(p.id);
                return;
            }
            return setTimeout(()=>i.dismiss(p.id, t), I);
        });
        return ()=>{
            m.forEach((p)=>p && clearTimeout(p));
        };
    }, [
        o,
        s,
        t
    ]);
    let r = (0, l.useCallback)(P(t), [
        t
    ]), u = (0, l.useCallback)(()=>{
        r({
            type: 5,
            time: Date.now()
        });
    }, [
        r
    ]), x = (0, l.useCallback)((c, m)=>{
        r({
            type: 1,
            toast: {
                id: c,
                height: m
            }
        });
    }, [
        r
    ]), y = (0, l.useCallback)(()=>{
        s && r({
            type: 6,
            time: Date.now()
        });
    }, [
        s,
        r
    ]), d = (0, l.useCallback)((c, m)=>{
        let { reverseOrder: p = !1, gutter: I = 8, defaultPosition: X } = m || {}, W = o.filter((f)=>(f.position || X) === (c.position || X) && f.height), re = W.findIndex((f)=>f.id === c.id), q = W.filter((f, H)=>H < re && f.visible).length;
        return W.filter((f)=>f.visible).slice(...p ? [
            q + 1
        ] : [
            0,
            q
        ]).reduce((f, H)=>f + (H.height || 0) + I, 0);
    }, [
        o
    ]);
    return (0, l.useEffect)(()=>{
        o.forEach((c)=>{
            if (c.dismissed) n(c.id, c.removeDelay);
            else {
                let m = a.get(c.id);
                m && (clearTimeout(m), a.delete(c.id));
            }
        });
    }, [
        o,
        n
    ]), {
        toasts: o,
        handlers: {
            updateHeight: x,
            startPause: u,
            endPause: y,
            calculateOffset: d
        }
    };
};
var h = j(require("cff97412359109c")), v = require("eb1a85e6ba4f13eb");
var S = j(require("cff97412359109c")), E = require("eb1a85e6ba4f13eb");
var R = require("eb1a85e6ba4f13eb"), ge = R.keyframes`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, he = R.keyframes`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, xe = R.keyframes`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, C = (0, R.styled)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${ge} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${he} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e)=>e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${xe} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;
var F = require("eb1a85e6ba4f13eb"), be = F.keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, L = (0, F.styled)("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e)=>e.secondary || "#e0e0e0"};
  border-right-color: ${(e)=>e.primary || "#616161"};
  animation: ${be} 1s linear infinite;
`;
var O = require("eb1a85e6ba4f13eb"), Se = O.keyframes`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, Ae = O.keyframes`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, U = (0, O.styled)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${Se} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${Ae} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e)=>e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var Pe = (0, E.styled)("div")`
  position: absolute;
`, Re = (0, E.styled)("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, Ee = E.keyframes`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, ve = (0, E.styled)("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${Ee} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, $ = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? S.createElement(ve, null, t) : t : o === "blank" ? null : S.createElement(Re, null, S.createElement(L, {
        ...s
    }), o !== "loading" && S.createElement(Pe, null, o === "error" ? S.createElement(C, {
        ...s
    }) : S.createElement(U, {
        ...s
    })));
};
var De = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, Oe = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, Ie = "0%{opacity:0;} 100%{opacity:1;}", ke = "0%{opacity:1;} 100%{opacity:0;}", _e = (0, v.styled)("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, Ve = (0, v.styled)("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, we = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [a, n] = _() ? [
        Ie,
        ke
    ] : [
        De(s),
        Oe(s)
    ];
    return {
        animation: t ? `${(0, v.keyframes)(a)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${(0, v.keyframes)(n)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, N = h.memo(({ toast: e, position: t, style: o, children: s })=>{
    let a = e.height ? we(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, n = h.createElement($, {
        toast: e
    }), r = h.createElement(Ve, {
        ...e.ariaProps
    }, g(e.message, e));
    return h.createElement(_e, {
        className: e.className,
        style: {
            ...a,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: n,
        message: r
    }) : h.createElement(h.Fragment, null, n, r));
});
var B = require("eb1a85e6ba4f13eb"), b = j(require("cff97412359109c"));
(0, B.setup)(b.createElement);
var Me = ({ id: e, className: t, style: o, onHeightUpdate: s, children: a })=>{
    let n = b.useCallback((r)=>{
        if (r) {
            let u = ()=>{
                let x = r.getBoundingClientRect().height;
                s(e, x);
            };
            u(), new MutationObserver(u).observe(r, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return b.createElement("div", {
        ref: n,
        className: t,
        style: o
    }, a);
}, Ce = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, a = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: _() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...a
    };
}, Fe = B.css`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, z = 16, oe = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: a, toasterId: n, containerStyle: r, containerClassName: u })=>{
    let { toasts: x, handlers: y } = M(o, n);
    return b.createElement("div", {
        "data-rht-toaster": n || "",
        style: {
            position: "fixed",
            zIndex: 9999,
            top: z,
            left: z,
            right: z,
            bottom: z,
            pointerEvents: "none",
            ...r
        },
        className: u,
        onMouseEnter: y.startPause,
        onMouseLeave: y.endPause
    }, x.map((d)=>{
        let c = d.position || t, m = y.calculateOffset(d, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), p = Ce(c, m);
        return b.createElement(Me, {
            id: d.id,
            key: d.id,
            onHeightUpdate: y.updateHeight,
            className: d.visible ? Fe : "",
            style: p
        }, d.type === "custom" ? g(d.message, d) : a ? a(d) : b.createElement(N, {
            toast: d,
            position: c
        }));
    }));
};
var Le = i;

},{"cff97412359109c":"6wC8C","eb1a85e6ba4f13eb":"9mg9Q"}],"9mg9Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "css", ()=>u);
parcelHelpers.export(exports, "extractCss", ()=>r);
parcelHelpers.export(exports, "glob", ()=>b);
parcelHelpers.export(exports, "keyframes", ()=>h);
parcelHelpers.export(exports, "setup", ()=>m);
parcelHelpers.export(exports, "styled", ()=>w);
let e = {
    data: ""
}, t = (t)=>{
    if ("object" == typeof window) {
        let e = (t ? t.querySelector("#_goober") : window._goober) || Object.assign(document.createElement("style"), {
            innerHTML: " ",
            id: "_goober"
        });
        return e.nonce = window.__nonce__, e.parentNode || (t || document.head).appendChild(e), e.firstChild;
    }
    return t || e;
}, r = (e)=>{
    let r = t(e), a = r.data;
    return r.data = "", a;
}, a = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, l = /\/\*[^]*?\*\/|  +/g, n = /\n+/g, o = (e, t)=>{
    let r = "", a = "", l = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : a += "f" == n[1] ? o(c, n) : n + "{" + o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? a += o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = "-" == n[1] ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), l += o.p ? o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && l ? t + "{" + l + "}" : l) + a;
}, c = {}, i = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + i(e[r]);
        return t;
    }
    return e;
}, s = (e, t, r, s, p)=>{
    let u = i(e), d = c[u] || (c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = a.exec(e.replace(l, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace(n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace(n, " ").trim();
            return o[0];
        })(e);
        c[d] = o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && c.g;
    return r && (c.g = c[d]), ((e, t, r, a)=>{
        a ? t.data = t.data.replace(a, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })(c[d], t, s, f), d;
}, p = (e, t, r)=>e.reduce((e, a, l)=>{
        let n = t[l];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : o(e, "") : !1 === e ? "" : e;
        }
        return e + a + (null == n ? "" : n);
    }, "");
function u(e) {
    let r = this || {}, a = e.call ? e(r.p) : e;
    return s(a.unshift ? a.raw ? p(a, [].slice.call(arguments, 1), r.p) : a.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : a, t(r.target), r.g, r.o, r.k);
}
let d, f, g, b = u.bind({
    g: 1
}), h = u.bind({
    k: 1
});
function m(e, t, r, a) {
    o.p = t, d = e, f = r, g = a;
}
function w(e, t) {
    let r = this || {};
    return function() {
        let a = arguments;
        function l(n, o) {
            let c = Object.assign({}, n), i = c.className || l.className;
            r.p = Object.assign({
                theme: f && f()
            }, c), r.o = /go\d/.test(i), c.className = u.apply(r, a) + (i ? " " + i : ""), t && (c.ref = o);
            let s = e;
            return e[0] && (s = c.as || e, delete c.as), g && s[0] && g(c), d(s, c);
        }
        return t ? t(l) : l;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"iVc5x":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"c8mQZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
require("20e1831a7c29326d");
const Throbber = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "throbber",
        role: "alertdialog",
        "aria-live": "assertive",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "throbber-element",
            "aria-hidden": "true",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "throbber-triangle"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "throbber-triangle"
                })
            ]
        })
    });
};
exports.default = Throbber;

},{"react/jsx-runtime":"i3K7E","20e1831a7c29326d":"3IQi1","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3IQi1":[function(require,module,exports,__globalThis) {
module.exports = require("595600661762cedd")(module.bundle.resolve("avQxI"));

},{"595600661762cedd":"efVvj"}],"efVvj":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"eobNX"}],"eobNX":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"ehPaH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useStore = require("../hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
var _devInfoScss = require("../../../scss/components/devInfo.scss");
var _robotHeadPng = require("../../../resources/robot-head.png");
var _robotHeadPngDefault = parcelHelpers.interopDefault(_robotHeadPng);
const DevInfo = ()=>{
    const isAdmin = ""; //useStore((state) => state.getIsAdmin());
    const subdomain = ""; //useStore((state) => state.subdomain);
    const clientRef = ""; //useStore((state) => state.clientRef);
    const path = ""; //useStore((state) => state.getPathParts()?.join("/"));
    const [show, setShow] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
};
exports.default = DevInfo;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","../hooks/useStore":"l1Yj7","../../../scss/components/devInfo.scss":"3LitS","../../../resources/robot-head.png":"biTVw","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"l1Yj7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _zustand = require("zustand");
var _clientjs = require("clientjs");
var _accessLevelsJson = require("../../components/json/accessLevels.json");
var _accessLevelsJsonDefault = parcelHelpers.interopDefault(_accessLevelsJson);
var _utilities = require("../../utilities");
var _utilitiesDefault = parcelHelpers.interopDefault(_utilities);
const client = new (0, _clientjs.ClientJS)();
const fingerprint = client.getFingerprint(); // for 2fa
const getDarkMode = ()=>{
    if (localStorage.getItem("toggleDarkMode") === "true" || localStorage.getItem("toggleDarkMode") === "false") return !!(localStorage.getItem("toggleDarkMode") === "true");
    if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) return true;
    return false;
};
const getUserTabs = (currentUser, settings)=>{
    var _displayTabs_employeeSeniorManager, _displayTabs_employeeManager;
    if (!currentUser || !settings) return {};
    const displayTabs = settings === null || settings === void 0 ? void 0 : settings.employeeTabs;
    const output = {
        profile: (displayTabs === null || displayTabs === void 0 ? void 0 : displayTabs.profile) || [],
        payroll: (displayTabs === null || displayTabs === void 0 ? void 0 : displayTabs.payroll) || [],
        employee: (displayTabs === null || displayTabs === void 0 ? void 0 : displayTabs.employee) || []
    };
    if (currentUser === null || currentUser === void 0 ? void 0 : currentUser.isSeniorManager) output.employee = (displayTabs === null || displayTabs === void 0 ? void 0 : (_displayTabs_employeeSeniorManager = displayTabs.employeeSeniorManager) === null || _displayTabs_employeeSeniorManager === void 0 ? void 0 : _displayTabs_employeeSeniorManager.length) > 0 ? displayTabs === null || displayTabs === void 0 ? void 0 : displayTabs.employeeSeniorManager : displayTabs === null || displayTabs === void 0 ? void 0 : displayTabs.employee;
    else if (currentUser === null || currentUser === void 0 ? void 0 : currentUser.isManager) output.employee = (displayTabs === null || displayTabs === void 0 ? void 0 : (_displayTabs_employeeManager = displayTabs.employeeManager) === null || _displayTabs_employeeManager === void 0 ? void 0 : _displayTabs_employeeManager.length) > 0 ? displayTabs === null || displayTabs === void 0 ? void 0 : displayTabs.employeeManager : displayTabs === null || displayTabs === void 0 ? void 0 : displayTabs.employee;
    return output;
};
const useStore = (0, _zustand.create)((set)=>({
        getPathParts: (0, _utilitiesDefault.default).getPathParts,
        getIsAdmin: (0, _utilitiesDefault.default).getIsAdmin,
        getClientRef: (0, _utilitiesDefault.default).getClientRef,
        loggedIn: !!(localStorage.getItem("loggedIn") === "true"),
        setLoggedIn: (loggedIn)=>{
            localStorage.setItem("loggedIn", loggedIn);
            set({
                loggedIn
            });
        },
        clientRef: (0, _utilitiesDefault.default).getClientRef(),
        setClientRef: (clientRef = null)=>{
            const ref = clientRef || (0, _utilitiesDefault.default).getClientRef();
            localStorage.setItem("clientRef", ref);
            set({
                clientRef: ref
            });
        },
        clientDetails: localStorage.getItem("clientDetails"),
        setClientDetails: (clientDetails)=>{
            try {
                localStorage.setItem("clientDetails", clientDetails);
            } catch (error) {
                if ((error === null || error === void 0 ? void 0 : error.name) !== "QuotaExceededError") throw error;
                console.warn("Unable to cache client details in localStorage", error);
            }
            set({
                clientDetails
            });
        },
        authToken: localStorage.getItem("authToken"),
        setAuthToken: (authToken)=>{
            localStorage.setItem("authToken", authToken);
            set({
                authToken
            });
        },
        pageTitle: "YourHR.space",
        setPageTitle: (pageTitle)=>{
            // get current stored page title
            const currentTitle = useStore.getState().pageTitle;
            // if the current title is not the same as the new title
            if (currentTitle !== pageTitle) // set the new title
            set({
                pageTitle
            });
        },
        test: false,
        setTest: (test)=>set({
                test
            }),
        baseURL: "/",
        subdomain: (0, _utilitiesDefault.default).getSubdomain(),
        fingerprint: fingerprint,
        accessLevels: (0, _accessLevelsJsonDefault.default),
        hasUnsavedChanges: false,
        setHasUnsavedChanges: (hasUnsavedChanges)=>{
            set({
                hasUnsavedChanges
            });
        },
        hasJustSaved: false,
        setHasJustSaved: (hasJustSaved)=>{
            set({
                hasJustSaved
            });
        },
        focussedComponent: null,
        setFocusedComponent: (componentRef)=>set(()=>({
                    focusedComponent: componentRef
                })),
        clearFocusedComponent: ()=>set(()=>({
                    focusedComponent: null
                })),
        userTabs: {},
        setUserTabs: (userTabs)=>set({
                userTabs
            }),
        currentUser: {},
        setCurrentUser: (currentUser)=>{
            useStore.getState().setUserTabs(getUserTabs(currentUser, useStore.getState().settings));
            return set({
                currentUser
            });
        },
        isCurrentUserLoading: false,
        setIsCurrentUserLoading: (isCurrentUserLoading)=>set({
                isCurrentUserLoading
            }),
        settings: {},
        setSettings: (settings)=>{
            useStore.getState().setUserTabs(getUserTabs(useStore.getState().currentUser, settings));
            return set({
                settings
            });
        },
        isSettingsLoading: false,
        setIsSettingsLoading: (isSettingsLoading)=>set({
                isSettingsLoading
            }),
        showModal: false,
        setShowModal: (showModal)=>set({
                showModal
            }),
        modalContent: null,
        setModalContent: (modalContent)=>set({
                modalContent
            }),
        mobileMenuToggle: false,
        setMobileMenuToggle: (mobileMenuToggle)=>set({
                mobileMenuToggle
            }),
        activeMenuCategoryId: null,
        setActiveMenuCategoryId: (activeMenuCategoryId)=>set({
                activeMenuCategoryId
            }),
        toggleMenuTop: !!(localStorage.getItem("toggleMenuTop") === "true"),
        setToggleMenuTop: (toggleMenuTop)=>{
            localStorage.setItem("toggleMenuTop", toggleMenuTop);
            set({
                toggleMenuTop
            });
        },
        toggleDarkMode: getDarkMode(),
        setToggleDarkMode: (toggleDarkMode)=>{
            localStorage.setItem("toggleDarkMode", toggleDarkMode);
            if (toggleDarkMode) document.querySelector(":root").classList.add("theme-dark");
            else document.querySelector(":root").classList.remove("theme-dark");
            set({
                toggleDarkMode
            });
        },
        toggleHighContrast: !!(localStorage.getItem("toggleHighContrast") === "true"),
        setToggleHighContrast: (toggleHighContrast)=>{
            localStorage.setItem("toggleHighContrast", toggleHighContrast);
            if (toggleHighContrast) {
                document.querySelector(":root").classList.add("theme-high-contrast");
                document.querySelector(":root").classList.add("theme-large-text");
            } else {
                document.querySelector(":root").classList.remove("theme-high-contrast");
                document.querySelector(":root").classList.remove("theme-large-text");
            }
            set({
                toggleHighContrast
            });
        },
        toggleSideMenuMobile: false,
        setToggleSideMenuMobile: (toggleSideMenuMobile)=>set({
                toggleSideMenuMobile
            }),
        toggleEmployeeDbMenu: true,
        setToggleEmployeeDbMenu: (toggleEmployeeDbMenu)=>set({
                toggleEmployeeDbMenu
            }),
        setToggleSettingsMenu: (toggleSettingsMenu)=>set({
                toggleSettingsMenu
            })
    }));
exports.default = useStore;

},{"zustand":"g9tnf","clientjs":"7T74F","../../components/json/accessLevels.json":"QTpCA","../../utilities":"fkdv9","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"g9tnf":[function(require,module,exports,__globalThis) {
'use strict';
var vanilla = require("a19f4edd89926025");
var ReactExports = require("e3cb921f47249eac");
var useSyncExternalStoreExports = require("1e8ad8cf8d3b3c90");
var useDebugValue = ReactExports.useDebugValue;
var useSyncExternalStoreWithSelector = useSyncExternalStoreExports.useSyncExternalStoreWithSelector;
var didWarnAboutEqualityFn = false;
var identity = function identity(arg) {
    return arg;
};
function useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = identity;
    var slice = useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    useDebugValue(slice);
    return slice;
}
var createImpl = function createImpl(createState) {
    var api = typeof createState === 'function' ? vanilla.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var create = function create(createState) {
    return createState ? createImpl(createState) : createImpl;
};
var react = function(createState) {
    return create(createState);
};
exports.create = create;
exports.default = react;
exports.useStore = useStore;
Object.keys(vanilla).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function() {
            return vanilla[k];
        }
    });
});
module.exports = react;
module.exports.create = create;
module.exports.useStore = useStore;
module.exports.createStore = vanilla.createStore;
exports.default = module.exports;

},{"a19f4edd89926025":"jaCtL","e3cb921f47249eac":"6wC8C","1e8ad8cf8d3b3c90":"05hgV"}],"jaCtL":[function(require,module,exports,__globalThis) {
'use strict';
var createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === 'function' ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== 'object' || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var createStore = function createStore(createState) {
    return createState ? createStoreImpl(createState) : createStoreImpl;
};
var vanilla = function(createState) {
    return createStore(createState);
};
exports.createStore = createStore;
exports.default = vanilla;
module.exports = vanilla;
module.exports.createStore = createStore;
exports.default = module.exports;

},{}],"05hgV":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("d1848724d1e53763");

},{"d1848724d1e53763":"fSi9x"}],"fSi9x":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("d57a74df6bca20fd"), shim = require("5be634d856d1f9fa");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore = shim.useSyncExternalStore, useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    useDebugValue(value);
    return value;
};

},{"d57a74df6bca20fd":"6wC8C","5be634d856d1f9fa":"bbbWX"}],"bbbWX":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("3e3e060a1c619377");

},{"3e3e060a1c619377":"eDEOL"}],"eDEOL":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("a18024ece7b3cd12");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    useEffect(function() {
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    useDebugValue(value);
    return value;
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
exports.useSyncExternalStore = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;

},{"a18024ece7b3cd12":"6wC8C"}],"7T74F":[function(require,module,exports,__globalThis) {
var global = arguments[3];
!function(e, i) {
    var t, n;
    module.exports = i();
}(this, function() {
    return function(e) {
        var i = {};
        function t(n) {
            if (i[n]) return i[n].exports;
            var o = i[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
        }
        return t.m = e, t.c = i, t.d = function(e, i, n) {
            t.o(e, i) || Object.defineProperty(e, i, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, i) {
            if (1 & i && (e = t(e)), 8 & i) return e;
            if (4 & i && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & i && "string" != typeof e) for(var o in e)t.d(n, o, (function(i) {
                return e[i];
            }).bind(null, o));
            return n;
        }, t.n = function(e) {
            var i = e && e.__esModule ? function() {
                return e["default"];
            } : function() {
                return e;
            };
            return t.d(i, "a", i), i;
        }, t.o = function(e, i) {
            return Object.prototype.hasOwnProperty.call(e, i);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, i, t) {
            "use strict";
            var n, o, r = t(1)(), a = t(3), s = t(4), l = t(6), u = function() {
                var e = new s;
                return n = e.getResult(), o = new l, this;
            };
            u.prototype = {
                getSoftwareVersion: function() {
                    return "0.1.11";
                },
                getBrowserData: function() {
                    return n;
                },
                getFingerprint: function() {
                    var e = "|", i = n.ua, t = this.getScreenPrint(), o = this.getPlugins(), r = this.getFonts(), s = this.isLocalStorage(), l = this.isSessionStorage(), u = this.getTimeZone(), c = this.getLanguage(), d = this.getSystemLanguage(), b = this.isCookie(), m = this.getCanvasPrint();
                    return a(i + e + t + e + o + e + r + e + s + e + l + e + u + e + c + e + d + e + b + e + m, 256);
                },
                getCustomFingerprint: function() {
                    for(var e = "|", i = "", t = 0; t < arguments.length; t++)i += arguments[t] + e;
                    return a(i, 256);
                },
                getUserAgent: function() {
                    return n.ua;
                },
                getUserAgentLowerCase: function() {
                    return n.ua.toLowerCase();
                },
                getBrowser: function() {
                    return n.browser.name;
                },
                getBrowserVersion: function() {
                    return n.browser.version;
                },
                getBrowserMajorVersion: function() {
                    return n.browser.major;
                },
                isIE: function() {
                    return /IE/i.test(n.browser.name);
                },
                isChrome: function() {
                    return /Chrome/i.test(n.browser.name);
                },
                isFirefox: function() {
                    return /Firefox/i.test(n.browser.name);
                },
                isSafari: function() {
                    return /Safari/i.test(n.browser.name);
                },
                isMobileSafari: function() {
                    return /Mobile\sSafari/i.test(n.browser.name);
                },
                isOpera: function() {
                    return /Opera/i.test(n.browser.name);
                },
                getEngine: function() {
                    return n.engine.name;
                },
                getEngineVersion: function() {
                    return n.engine.version;
                },
                getOS: function() {
                    return n.os.name;
                },
                getOSVersion: function() {
                    return n.os.version;
                },
                isWindows: function() {
                    return /Windows/i.test(n.os.name);
                },
                isMac: function() {
                    return /Mac/i.test(n.os.name);
                },
                isLinux: function() {
                    return /Linux/i.test(n.os.name);
                },
                isUbuntu: function() {
                    return /Ubuntu/i.test(n.os.name);
                },
                isSolaris: function() {
                    return /Solaris/i.test(n.os.name);
                },
                getDevice: function() {
                    return n.device.model;
                },
                getDeviceType: function() {
                    return n.device.type;
                },
                getDeviceVendor: function() {
                    return n.device.vendor;
                },
                getCPU: function() {
                    return n.cpu.architecture;
                },
                isMobile: function() {
                    var e = n.ua || navigator.vendor || window.opera;
                    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(e) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e.substr(0, 4));
                },
                isMobileMajor: function() {
                    return this.isMobileAndroid() || this.isMobileBlackBerry() || this.isMobileIOS() || this.isMobileOpera() || this.isMobileWindows();
                },
                isMobileAndroid: function() {
                    return !!n.ua.match(/Android/i);
                },
                isMobileOpera: function() {
                    return !!n.ua.match(/Opera Mini/i);
                },
                isMobileWindows: function() {
                    return !!n.ua.match(/IEMobile/i);
                },
                isMobileBlackBerry: function() {
                    return !!n.ua.match(/BlackBerry/i);
                },
                isMobileIOS: function() {
                    return !!n.ua.match(/iPhone|iPad|iPod/i);
                },
                isIphone: function() {
                    return !!n.ua.match(/iPhone/i);
                },
                isIpad: function() {
                    return !!n.ua.match(/iPad/i);
                },
                isIpod: function() {
                    return !!n.ua.match(/iPod/i);
                },
                getScreenPrint: function() {
                    return "Current Resolution: " + this.getCurrentResolution() + ", Available Resolution: " + this.getAvailableResolution() + ", Color Depth: " + this.getColorDepth() + ", Device XDPI: " + this.getDeviceXDPI() + ", Device YDPI: " + this.getDeviceYDPI();
                },
                getColorDepth: function() {
                    return screen.colorDepth;
                },
                getCurrentResolution: function() {
                    return screen.width + "x" + screen.height;
                },
                getAvailableResolution: function() {
                    return screen.availWidth + "x" + screen.availHeight;
                },
                getDeviceXDPI: function() {
                    return screen.deviceXDPI;
                },
                getDeviceYDPI: function() {
                    return screen.deviceYDPI;
                },
                getPlugins: function() {
                    for(var e = "", i = 0; i < navigator.plugins.length; i++)i == navigator.plugins.length - 1 ? e += navigator.plugins[i].name : e += navigator.plugins[i].name + ", ";
                    return e;
                },
                isJava: function() {
                    return navigator.javaEnabled();
                },
                getJavaVersion: function() {
                    throw new Error("Please use client.java.js or client.js if you need this functionality!");
                },
                isFlash: function() {
                    return !!navigator.plugins["Shockwave Flash"];
                },
                getFlashVersion: function() {
                    throw new Error("Please use client.flash.js or client.js if you need this functionality!");
                },
                isSilverlight: function() {
                    return !!navigator.plugins["Silverlight Plug-In"];
                },
                getSilverlightVersion: function() {
                    return this.isSilverlight() ? navigator.plugins["Silverlight Plug-In"].description : "";
                },
                isMimeTypes: function() {
                    return !(!navigator.mimeTypes || !navigator.mimeTypes.length);
                },
                getMimeTypes: function() {
                    var e = "";
                    if (navigator.mimeTypes) for(var i = 0; i < navigator.mimeTypes.length; i++)i == navigator.mimeTypes.length - 1 ? e += navigator.mimeTypes[i].description : e += navigator.mimeTypes[i].description + ", ";
                    return e;
                },
                isFont: function(e) {
                    return o.detect(e);
                },
                getFonts: function() {
                    for(var e = [
                        "Abadi MT Condensed Light",
                        "Adobe Fangsong Std",
                        "Adobe Hebrew",
                        "Adobe Ming Std",
                        "Agency FB",
                        "Aharoni",
                        "Andalus",
                        "Angsana New",
                        "AngsanaUPC",
                        "Aparajita",
                        "Arab",
                        "Arabic Transparent",
                        "Arabic Typesetting",
                        "Arial Baltic",
                        "Arial Black",
                        "Arial CE",
                        "Arial CYR",
                        "Arial Greek",
                        "Arial TUR",
                        "Arial",
                        "Batang",
                        "BatangChe",
                        "Bauhaus 93",
                        "Bell MT",
                        "Bitstream Vera Serif",
                        "Bodoni MT",
                        "Bookman Old Style",
                        "Braggadocio",
                        "Broadway",
                        "Browallia New",
                        "BrowalliaUPC",
                        "Calibri Light",
                        "Calibri",
                        "Californian FB",
                        "Cambria Math",
                        "Cambria",
                        "Candara",
                        "Castellar",
                        "Casual",
                        "Centaur",
                        "Century Gothic",
                        "Chalkduster",
                        "Colonna MT",
                        "Comic Sans MS",
                        "Consolas",
                        "Constantia",
                        "Copperplate Gothic Light",
                        "Corbel",
                        "Cordia New",
                        "CordiaUPC",
                        "Courier New Baltic",
                        "Courier New CE",
                        "Courier New CYR",
                        "Courier New Greek",
                        "Courier New TUR",
                        "Courier New",
                        "DFKai-SB",
                        "DaunPenh",
                        "David",
                        "DejaVu LGC Sans Mono",
                        "Desdemona",
                        "DilleniaUPC",
                        "DokChampa",
                        "Dotum",
                        "DotumChe",
                        "Ebrima",
                        "Engravers MT",
                        "Eras Bold ITC",
                        "Estrangelo Edessa",
                        "EucrosiaUPC",
                        "Euphemia",
                        "Eurostile",
                        "FangSong",
                        "Forte",
                        "FrankRuehl",
                        "Franklin Gothic Heavy",
                        "Franklin Gothic Medium",
                        "FreesiaUPC",
                        "French Script MT",
                        "Gabriola",
                        "Gautami",
                        "Georgia",
                        "Gigi",
                        "Gisha",
                        "Goudy Old Style",
                        "Gulim",
                        "GulimChe",
                        "GungSeo",
                        "Gungsuh",
                        "GungsuhChe",
                        "Haettenschweiler",
                        "Harrington",
                        "Hei S",
                        "HeiT",
                        "Heisei Kaku Gothic",
                        "Hiragino Sans GB",
                        "Impact",
                        "Informal Roman",
                        "IrisUPC",
                        "Iskoola Pota",
                        "JasmineUPC",
                        "KacstOne",
                        "KaiTi",
                        "Kalinga",
                        "Kartika",
                        "Khmer UI",
                        "Kino MT",
                        "KodchiangUPC",
                        "Kokila",
                        "Kozuka Gothic Pr6N",
                        "Lao UI",
                        "Latha",
                        "Leelawadee",
                        "Levenim MT",
                        "LilyUPC",
                        "Lohit Gujarati",
                        "Loma",
                        "Lucida Bright",
                        "Lucida Console",
                        "Lucida Fax",
                        "Lucida Sans Unicode",
                        "MS Gothic",
                        "MS Mincho",
                        "MS PGothic",
                        "MS PMincho",
                        "MS Reference Sans Serif",
                        "MS UI Gothic",
                        "MV Boli",
                        "Magneto",
                        "Malgun Gothic",
                        "Mangal",
                        "Marlett",
                        "Matura MT Script Capitals",
                        "Meiryo UI",
                        "Meiryo",
                        "Menlo",
                        "Microsoft Himalaya",
                        "Microsoft JhengHei",
                        "Microsoft New Tai Lue",
                        "Microsoft PhagsPa",
                        "Microsoft Sans Serif",
                        "Microsoft Tai Le",
                        "Microsoft Uighur",
                        "Microsoft YaHei",
                        "Microsoft Yi Baiti",
                        "MingLiU",
                        "MingLiU-ExtB",
                        "MingLiU_HKSCS",
                        "MingLiU_HKSCS-ExtB",
                        "Miriam Fixed",
                        "Miriam",
                        "Mongolian Baiti",
                        "MoolBoran",
                        "NSimSun",
                        "Narkisim",
                        "News Gothic MT",
                        "Niagara Solid",
                        "Nyala",
                        "PMingLiU",
                        "PMingLiU-ExtB",
                        "Palace Script MT",
                        "Palatino Linotype",
                        "Papyrus",
                        "Perpetua",
                        "Plantagenet Cherokee",
                        "Playbill",
                        "Prelude Bold",
                        "Prelude Condensed Bold",
                        "Prelude Condensed Medium",
                        "Prelude Medium",
                        "PreludeCompressedWGL Black",
                        "PreludeCompressedWGL Bold",
                        "PreludeCompressedWGL Light",
                        "PreludeCompressedWGL Medium",
                        "PreludeCondensedWGL Black",
                        "PreludeCondensedWGL Bold",
                        "PreludeCondensedWGL Light",
                        "PreludeCondensedWGL Medium",
                        "PreludeWGL Black",
                        "PreludeWGL Bold",
                        "PreludeWGL Light",
                        "PreludeWGL Medium",
                        "Raavi",
                        "Rachana",
                        "Rockwell",
                        "Rod",
                        "Sakkal Majalla",
                        "Sawasdee",
                        "Script MT Bold",
                        "Segoe Print",
                        "Segoe Script",
                        "Segoe UI Light",
                        "Segoe UI Semibold",
                        "Segoe UI Symbol",
                        "Segoe UI",
                        "Shonar Bangla",
                        "Showcard Gothic",
                        "Shruti",
                        "SimHei",
                        "SimSun",
                        "SimSun-ExtB",
                        "Simplified Arabic Fixed",
                        "Simplified Arabic",
                        "Snap ITC",
                        "Sylfaen",
                        "Symbol",
                        "Tahoma",
                        "Times New Roman Baltic",
                        "Times New Roman CE",
                        "Times New Roman CYR",
                        "Times New Roman Greek",
                        "Times New Roman TUR",
                        "Times New Roman",
                        "TlwgMono",
                        "Traditional Arabic",
                        "Trebuchet MS",
                        "Tunga",
                        "Tw Cen MT Condensed Extra Bold",
                        "Ubuntu",
                        "Umpush",
                        "Univers",
                        "Utopia",
                        "Utsaah",
                        "Vani",
                        "Verdana",
                        "Vijaya",
                        "Vladimir Script",
                        "Vrinda",
                        "Webdings",
                        "Wide Latin",
                        "Wingdings"
                    ], i = "", t = 0; t < e.length; t++)o.detect(e[t]) && (i += t == e.length - 1 ? e[t] : e[t] + ", ");
                    return i;
                },
                isLocalStorage: function() {
                    try {
                        return !!r.localStorage;
                    } catch (e) {
                        return !0;
                    }
                },
                isSessionStorage: function() {
                    try {
                        return !!r.sessionStorage;
                    } catch (e) {
                        return !0;
                    }
                },
                isCookie: function() {
                    return navigator.cookieEnabled;
                },
                getTimeZone: function() {
                    var e, i;
                    return e = new Date, (i = String(-e.getTimezoneOffset() / 60)) < 0 ? "-" + ("0" + (i *= -1)).slice(-2) : "+" + ("0" + i).slice(-2);
                },
                getLanguage: function() {
                    return navigator.language;
                },
                getSystemLanguage: function() {
                    return navigator.systemLanguage || window.navigator.language;
                },
                isCanvas: function() {
                    var e = document.createElement("canvas");
                    try {
                        return !(!e.getContext || !e.getContext("2d"));
                    } catch (i) {
                        return !1;
                    }
                },
                getCanvasPrint: function() {
                    var e, i = document.createElement("canvas");
                    try {
                        e = i.getContext("2d");
                    } catch (n) {
                        return "";
                    }
                    var t = "ClientJS,org <canvas> 1.0";
                    return e.textBaseline = "top", e.font = "14px 'Arial'", e.textBaseline = "alphabetic", e.fillStyle = "#f60", e.fillRect(125, 1, 62, 20), e.fillStyle = "#069", e.fillText(t, 2, 15), e.fillStyle = "rgba(102, 204, 0, 0.7)", e.fillText(t, 4, 17), i.toDataURL();
                }
            }, i.ClientJS = u;
        },
        function(e, i, t) {
            "use strict";
            var n = t(2);
            e.exports = function() {
                return "object" == typeof global && global && global.Math === Math && global.Array === Array ? global : n;
            };
        },
        function(e, i, t) {
            "use strict";
            "undefined" != typeof self ? e.exports = self : "undefined" != typeof window ? e.exports = window : e.exports = Function("return this")();
        },
        function(e, i, t) {
            e.exports = function(e, i) {
                var t, n, o, r, a, s, l, u;
                for(t = 3 & e.length, n = e.length - t, o = i, a = 3432918353, s = 461845907, u = 0; u < n;)l = 255 & e.charCodeAt(u) | (255 & e.charCodeAt(++u)) << 8 | (255 & e.charCodeAt(++u)) << 16 | (255 & e.charCodeAt(++u)) << 24, ++u, o = 27492 + (65535 & (r = 5 * (65535 & (o = (o ^= l = (65535 & (l = (l = (65535 & l) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 13 | o >>> 19)) + ((5 * (o >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (r >>> 16) & 65535) << 16);
                switch(l = 0, t){
                    case 3:
                        l ^= (255 & e.charCodeAt(u + 2)) << 16;
                    case 2:
                        l ^= (255 & e.charCodeAt(u + 1)) << 8;
                    case 1:
                        o ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & e.charCodeAt(u))) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295;
                }
                return o ^= e.length, o = 2246822507 * (65535 & (o ^= o >>> 16)) + ((2246822507 * (o >>> 16) & 65535) << 16) & 4294967295, o = 3266489909 * (65535 & (o ^= o >>> 13)) + ((3266489909 * (o >>> 16) & 65535) << 16) & 4294967295, (o ^= o >>> 16) >>> 0;
            };
        },
        function(e, i, t) {
            var n;
            !function(o, r) {
                "use strict";
                var a = "function", s = "undefined", l = "object", u = "string", c = "model", d = "name", b = "type", m = "vendor", w = "version", g = "architecture", p = "console", f = "mobile", h = "tablet", v = "smarttv", y = "wearable", x = "embedded", k = "Amazon", S = "Apple", C = "ASUS", M = "BlackBerry", P = "Firefox", T = "Google", B = "Huawei", A = "LG", L = "Microsoft", U = "Motorola", E = "Opera", G = "Samsung", N = "Sony", j = "Xiaomi", _ = "Zebra", R = "Facebook", D = function(e) {
                    var i = {};
                    for(var t in e)i[e[t].toUpperCase()] = e[t];
                    return i;
                }, I = function(e, i) {
                    return typeof e === u && -1 !== O(i).indexOf(O(e));
                }, O = function(e) {
                    return e.toLowerCase();
                }, z = function(e, i) {
                    if (typeof e === u) return e = e.replace(/^\s\s*/, "").replace(/\s\s*$/, ""), typeof i === s ? e : e.substring(0, 255);
                }, F = function(e, i) {
                    for(var t, n, o, s, u, c, d = 0; d < i.length && !u;){
                        var b = i[d], m = i[d + 1];
                        for(t = n = 0; t < b.length && !u;)if (u = b[t++].exec(e)) for(o = 0; o < m.length; o++)c = u[++n], typeof (s = m[o]) === l && s.length > 0 ? 2 == s.length ? typeof s[1] == a ? this[s[0]] = s[1].call(this, c) : this[s[0]] = s[1] : 3 == s.length ? typeof s[1] !== a || s[1].exec && s[1].test ? this[s[0]] = c ? c.replace(s[1], s[2]) : r : this[s[0]] = c ? s[1].call(this, c, s[2]) : r : 4 == s.length && (this[s[0]] = c ? s[3].call(this, c.replace(s[1], s[2])) : r) : this[s] = c || r;
                        d += 2;
                    }
                }, q = function(e, i) {
                    for(var t in i)if (typeof i[t] === l && i[t].length > 0) {
                        for(var n = 0; n < i[t].length; n++)if (I(i[t][n], e)) return "?" === t ? r : t;
                    } else if (I(i[t], e)) return "?" === t ? r : t;
                    return e;
                }, W = {
                    ME: "4.90",
                    "NT 3.11": "NT3.51",
                    "NT 4.0": "NT4.0",
                    2e3: "NT 5.0",
                    XP: [
                        "NT 5.1",
                        "NT 5.2"
                    ],
                    Vista: "NT 6.0",
                    7: "NT 6.1",
                    8: "NT 6.2",
                    8.1: "NT 6.3",
                    10: [
                        "NT 6.4",
                        "NT 10.0"
                    ],
                    RT: "ARM"
                }, V = {
                    browser: [
                        [
                            /\b(?:crmo|crios)\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Chrome"
                            ]
                        ],
                        [
                            /edg(?:e|ios|a)?\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Edge"
                            ]
                        ],
                        [
                            /(opera mini)\/([-\w\.]+)/i,
                            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /opios[\/ ]+([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Opera Mini"
                            ]
                        ],
                        [
                            /\bopr\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                E
                            ]
                        ],
                        [
                            /(kindle)\/([\w\.]+)/i,
                            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                            /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
                            /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
                            /(?:ms|\()(ie) ([\w\.]+)/i,
                            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
                            /(weibo)__([\d\.]+)/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "UCBrowser"
                            ]
                        ],
                        [
                            /\bqbcore\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "WeChat(Win) Desktop"
                            ]
                        ],
                        [
                            /micromessenger\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "WeChat"
                            ]
                        ],
                        [
                            /konqueror\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Konqueror"
                            ]
                        ],
                        [
                            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
                        ],
                        [
                            w,
                            [
                                d,
                                "IE"
                            ]
                        ],
                        [
                            /yabrowser\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Yandex"
                            ]
                        ],
                        [
                            /(avast|avg)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /(.+)/,
                                "$1 Secure Browser"
                            ],
                            w
                        ],
                        [
                            /\bfocus\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Firefox Focus"
                            ]
                        ],
                        [
                            /\bopt\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Opera Touch"
                            ]
                        ],
                        [
                            /coc_coc\w+\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Coc Coc"
                            ]
                        ],
                        [
                            /dolfin\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Dolphin"
                            ]
                        ],
                        [
                            /coast\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Opera Coast"
                            ]
                        ],
                        [
                            /miuibrowser\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "MIUI Browser"
                            ]
                        ],
                        [
                            /fxios\/([-\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                P
                            ]
                        ],
                        [
                            /\bqihu|(qi?ho?o?|360)browser/i
                        ],
                        [
                            [
                                d,
                                "360 Browser"
                            ]
                        ],
                        [
                            /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /(.+)/,
                                "$1 Browser"
                            ],
                            w
                        ],
                        [
                            /(comodo_dragon)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /_/g,
                                " "
                            ],
                            w
                        ],
                        [
                            /(electron)\/([\w\.]+) safari/i,
                            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                            /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /(metasr)[\/ ]?([\w\.]+)/i,
                            /(lbbrowser)/i
                        ],
                        [
                            d
                        ],
                        [
                            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
                        ],
                        [
                            [
                                d,
                                R
                            ],
                            w
                        ],
                        [
                            /safari (line)\/([\w\.]+)/i,
                            /\b(line)\/([\w\.]+)\/iab/i,
                            /(chromium|instagram)[\/ ]([-\w\.]+)/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /\bgsa\/([\w\.]+) .*safari\//i
                        ],
                        [
                            w,
                            [
                                d,
                                "GSA"
                            ]
                        ],
                        [
                            /headlesschrome(?:\/([\w\.]+)| )/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Chrome Headless"
                            ]
                        ],
                        [
                            / wv\).+(chrome)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                "Chrome WebView"
                            ],
                            w
                        ],
                        [
                            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Android Browser"
                            ]
                        ],
                        [
                            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /version\/([\w\.]+) .*mobile\/\w+ (safari)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Mobile Safari"
                            ]
                        ],
                        [
                            /version\/([\w\.]+) .*(mobile ?safari|safari)/i
                        ],
                        [
                            w,
                            d
                        ],
                        [
                            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
                        ],
                        [
                            d,
                            [
                                w,
                                q,
                                {
                                    "1.0": "/8",
                                    1.2: "/1",
                                    1.3: "/3",
                                    "2.0": "/412",
                                    "2.0.2": "/416",
                                    "2.0.3": "/417",
                                    "2.0.4": "/419",
                                    "?": "/"
                                }
                            ]
                        ],
                        [
                            /(webkit|khtml)\/([\w\.]+)/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /(navigator|netscape\d?)\/([-\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                "Netscape"
                            ],
                            w
                        ],
                        [
                            /mobile vr; rv:([\w\.]+)\).+firefox/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Firefox Reality"
                            ]
                        ],
                        [
                            /ekiohf.+(flow)\/([\w\.]+)/i,
                            /(swiftfox)/i,
                            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                            /(firefox)\/([\w\.]+)/i,
                            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                            /(links) \(([\w\.]+)/i
                        ],
                        [
                            d,
                            w
                        ]
                    ],
                    cpu: [
                        [
                            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
                        ],
                        [
                            [
                                g,
                                "amd64"
                            ]
                        ],
                        [
                            /(ia32(?=;))/i
                        ],
                        [
                            [
                                g,
                                O
                            ]
                        ],
                        [
                            /((?:i[346]|x)86)[;\)]/i
                        ],
                        [
                            [
                                g,
                                "ia32"
                            ]
                        ],
                        [
                            /\b(aarch64|arm(v?8e?l?|_?64))\b/i
                        ],
                        [
                            [
                                g,
                                "arm64"
                            ]
                        ],
                        [
                            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
                        ],
                        [
                            [
                                g,
                                "armhf"
                            ]
                        ],
                        [
                            /windows (ce|mobile); ppc;/i
                        ],
                        [
                            [
                                g,
                                "arm"
                            ]
                        ],
                        [
                            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
                        ],
                        [
                            [
                                g,
                                /ower/,
                                "",
                                O
                            ]
                        ],
                        [
                            /(sun4\w)[;\)]/i
                        ],
                        [
                            [
                                g,
                                "sparc"
                            ]
                        ],
                        [
                            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                        ],
                        [
                            [
                                g,
                                O
                            ]
                        ]
                    ],
                    device: [
                        [
                            /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
                        ],
                        [
                            c,
                            [
                                m,
                                G
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
                            /samsung[- ]([-\w]+)/i,
                            /sec-(sgh\w+)/i
                        ],
                        [
                            c,
                            [
                                m,
                                G
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\((ip(?:hone|od)[\w ]*);/i
                        ],
                        [
                            c,
                            [
                                m,
                                S
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\((ipad);[-\w\),; ]+apple/i,
                            /applecoremedia\/[\w\.]+ \((ipad)/i,
                            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
                        ],
                        [
                            c,
                            [
                                m,
                                S
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
                        ],
                        [
                            c,
                            [
                                m,
                                B
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /(?:huawei|honor)([-\w ]+)[;\)]/i,
                            /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i
                        ],
                        [
                            c,
                            [
                                m,
                                B
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(poco[\w ]+)(?: bui|\))/i,
                            /\b; (\w+) build\/hm\1/i,
                            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
                        ],
                        [
                            [
                                c,
                                /_/g,
                                " "
                            ],
                            [
                                m,
                                j
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
                        ],
                        [
                            [
                                c,
                                /_/g,
                                " "
                            ],
                            [
                                m,
                                j
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /; (\w+) bui.+ oppo/i,
                            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007)\b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "OPPO"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /vivo (\w+)(?: bui|\))/i,
                            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Vivo"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(rmx[12]\d{3})(?: bui|;|\))/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Realme"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                            /\bmot(?:orola)?[- ](\w*)/i,
                            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
                        ],
                        [
                            c,
                            [
                                m,
                                U
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
                        ],
                        [
                            c,
                            [
                                m,
                                U
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
                        ],
                        [
                            c,
                            [
                                m,
                                A
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                            /\blg-?([\d\w]+) bui/i
                        ],
                        [
                            c,
                            [
                                m,
                                A
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(ideatab[-\w ]+)/i,
                            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Lenovo"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /(?:maemo|nokia).*(n900|lumia \d+)/i,
                            /nokia[-_ ]?([-\w\.]*)/i
                        ],
                        [
                            [
                                c,
                                /_/g,
                                " "
                            ],
                            [
                                m,
                                "Nokia"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(pixel c)\b/i
                        ],
                        [
                            c,
                            [
                                m,
                                T
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
                        ],
                        [
                            c,
                            [
                                m,
                                T
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
                        ],
                        [
                            c,
                            [
                                m,
                                N
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /sony tablet [ps]/i,
                            /\b(?:sony)?sgp\w+(?: bui|\))/i
                        ],
                        [
                            [
                                c,
                                "Xperia Tablet"
                            ],
                            [
                                m,
                                N
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            / (kb2005|in20[12]5|be20[12][59])\b/i,
                            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
                        ],
                        [
                            c,
                            [
                                m,
                                "OnePlus"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(alexa)webm/i,
                            /(kf[a-z]{2}wi)( bui|\))/i,
                            /(kf[a-z]+)( bui|\)).+silk\//i
                        ],
                        [
                            c,
                            [
                                m,
                                k
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
                        ],
                        [
                            [
                                c,
                                /(.+)/g,
                                "Fire Phone $1"
                            ],
                            [
                                m,
                                k
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(playbook);[-\w\),; ]+(rim)/i
                        ],
                        [
                            c,
                            m,
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b((?:bb[a-f]|st[hv])100-\d)/i,
                            /\(bb10; (\w+)/i
                        ],
                        [
                            c,
                            [
                                m,
                                M
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
                        ],
                        [
                            c,
                            [
                                m,
                                C
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
                        ],
                        [
                            c,
                            [
                                m,
                                C
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(nexus 9)/i
                        ],
                        [
                            c,
                            [
                                m,
                                "HTC"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                            /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i
                        ],
                        [
                            m,
                            [
                                c,
                                /_/g,
                                " "
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Acer"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /droid.+; (m[1-5] note) bui/i,
                            /\bmz-([-\w]{2,})/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Meizu"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Sharp"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                            /(hp) ([\w ]+\w)/i,
                            /(asus)-?(\w+)/i,
                            /(microsoft); (lumia[\w ]+)/i,
                            /(lenovo)[-_ ]?([-\w]+)/i,
                            /(jolla)/i,
                            /(oppo) ?([\w ]+) bui/i
                        ],
                        [
                            m,
                            c,
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(archos) (gamepad2?)/i,
                            /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                            /(kindle)\/([\w\.]+)/i,
                            /(nook)[\w ]+build\/(\w+)/i,
                            /(dell) (strea[kpr\d ]*[\dko])/i,
                            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                            /(trinity)[- ]*(t\d{3}) bui/i,
                            /(gigaset)[- ]+(q\w{1,9}) bui/i,
                            /(vodafone) ([\w ]+)(?:\)| bui)/i
                        ],
                        [
                            m,
                            c,
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /(surface duo)/i
                        ],
                        [
                            c,
                            [
                                m,
                                L
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /droid [\d\.]+; (fp\du?)(?: b|\))/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Fairphone"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(u304aa)/i
                        ],
                        [
                            c,
                            [
                                m,
                                "AT&T"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\bsie-(\w*)/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Siemens"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(rct\w+) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "RCA"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b(venue[\d ]{2,7}) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Dell"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b(q(?:mv|ta)\w+) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Verizon"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Barnes & Noble"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b(tm\d{3}\w+) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "NuVision"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b(k88) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "ZTE"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b(nx\d{3}j) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "ZTE"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(gen\d{3}) b.+49h/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Swiss"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(zur\d{3}) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Swiss"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b((zeki)?tb.*\b) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Zeki"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b([yr]\d{2}) b/i,
                            /\b(dragon[- ]+touch |dt)(\w{5}) b/i
                        ],
                        [
                            [
                                m,
                                "Dragon Touch"
                            ],
                            c,
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b(ns-?\w{0,9}) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Insignia"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b((nxa|next)-?\w{0,9}) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "NextBook"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
                        ],
                        [
                            [
                                m,
                                "Voice"
                            ],
                            c,
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(lvtel\-)?(v1[12]) b/i
                        ],
                        [
                            [
                                m,
                                "LvTel"
                            ],
                            c,
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(ph-1) /i
                        ],
                        [
                            c,
                            [
                                m,
                                "Essential"
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /\b(v(100md|700na|7011|917g).*\b) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Envizen"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b(trio[-\w\. ]+) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "MachSpeed"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\btu_(1491) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Rotor"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /(shield[\w ]+) b/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Nvidia"
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /(sprint) (\w+)/i
                        ],
                        [
                            m,
                            c,
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(kin\.[onetw]{3})/i
                        ],
                        [
                            [
                                c,
                                /\./g,
                                " "
                            ],
                            [
                                m,
                                L
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
                        ],
                        [
                            c,
                            [
                                m,
                                _
                            ],
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
                        ],
                        [
                            c,
                            [
                                m,
                                _
                            ],
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(ouya)/i,
                            /(nintendo) ([wids3utch]+)/i
                        ],
                        [
                            m,
                            c,
                            [
                                b,
                                p
                            ]
                        ],
                        [
                            /droid.+; (shield) bui/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Nvidia"
                            ],
                            [
                                b,
                                p
                            ]
                        ],
                        [
                            /(playstation [345portablevi]+)/i
                        ],
                        [
                            c,
                            [
                                m,
                                N
                            ],
                            [
                                b,
                                p
                            ]
                        ],
                        [
                            /\b(xbox(?: one)?(?!; xbox))[\); ]/i
                        ],
                        [
                            c,
                            [
                                m,
                                L
                            ],
                            [
                                b,
                                p
                            ]
                        ],
                        [
                            /smart-tv.+(samsung)/i
                        ],
                        [
                            m,
                            [
                                b,
                                v
                            ]
                        ],
                        [
                            /hbbtv.+maple;(\d+)/i
                        ],
                        [
                            [
                                c,
                                /^/,
                                "SmartTV"
                            ],
                            [
                                m,
                                G
                            ],
                            [
                                b,
                                v
                            ]
                        ],
                        [
                            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
                        ],
                        [
                            [
                                m,
                                A
                            ],
                            [
                                b,
                                v
                            ]
                        ],
                        [
                            /(apple) ?tv/i
                        ],
                        [
                            m,
                            [
                                c,
                                "Apple TV"
                            ],
                            [
                                b,
                                v
                            ]
                        ],
                        [
                            /crkey/i
                        ],
                        [
                            [
                                c,
                                "Chromecast"
                            ],
                            [
                                m,
                                T
                            ],
                            [
                                b,
                                v
                            ]
                        ],
                        [
                            /droid.+aft(\w)( bui|\))/i
                        ],
                        [
                            c,
                            [
                                m,
                                k
                            ],
                            [
                                b,
                                v
                            ]
                        ],
                        [
                            /\(dtv[\);].+(aquos)/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Sharp"
                            ],
                            [
                                b,
                                v
                            ]
                        ],
                        [
                            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                            /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i
                        ],
                        [
                            [
                                m,
                                z
                            ],
                            [
                                c,
                                z
                            ],
                            [
                                b,
                                v
                            ]
                        ],
                        [
                            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
                        ],
                        [
                            [
                                b,
                                v
                            ]
                        ],
                        [
                            /((pebble))app/i
                        ],
                        [
                            m,
                            c,
                            [
                                b,
                                y
                            ]
                        ],
                        [
                            /droid.+; (glass) \d/i
                        ],
                        [
                            c,
                            [
                                m,
                                T
                            ],
                            [
                                b,
                                y
                            ]
                        ],
                        [
                            /droid.+; (wt63?0{2,3})\)/i
                        ],
                        [
                            c,
                            [
                                m,
                                _
                            ],
                            [
                                b,
                                y
                            ]
                        ],
                        [
                            /(quest( 2)?)/i
                        ],
                        [
                            c,
                            [
                                m,
                                R
                            ],
                            [
                                b,
                                y
                            ]
                        ],
                        [
                            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                b,
                                x
                            ]
                        ],
                        [
                            /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
                        ],
                        [
                            c,
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
                        ],
                        [
                            c,
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
                        ],
                        [
                            [
                                b,
                                h
                            ]
                        ],
                        [
                            /(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i
                        ],
                        [
                            [
                                b,
                                f
                            ]
                        ],
                        [
                            /(android[-\w\. ]{0,9});.+buil/i
                        ],
                        [
                            c,
                            [
                                m,
                                "Generic"
                            ]
                        ]
                    ],
                    engine: [
                        [
                            /windows.+ edge\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "EdgeHTML"
                            ]
                        ],
                        [
                            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Blink"
                            ]
                        ],
                        [
                            /(presto)\/([\w\.]+)/i,
                            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                            /ekioh(flow)\/([\w\.]+)/i,
                            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                            /(icab)[\/ ]([23]\.[\d\.]+)/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /rv\:([\w\.]{1,9})\b.+(gecko)/i
                        ],
                        [
                            w,
                            d
                        ]
                    ],
                    os: [
                        [
                            /microsoft (windows) (vista|xp)/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /(windows) nt 6\.2; (arm)/i,
                            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
                            /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
                        ],
                        [
                            d,
                            [
                                w,
                                q,
                                W
                            ]
                        ],
                        [
                            /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
                        ],
                        [
                            [
                                d,
                                "Windows"
                            ],
                            [
                                w,
                                q,
                                W
                            ]
                        ],
                        [
                            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                            /cfnetwork\/.+darwin/i
                        ],
                        [
                            [
                                w,
                                /_/g,
                                "."
                            ],
                            [
                                d,
                                "iOS"
                            ]
                        ],
                        [
                            /(mac os x) ?([\w\. ]*)/i,
                            /(macintosh|mac_powerpc\b)(?!.+haiku)/i
                        ],
                        [
                            [
                                d,
                                "Mac OS"
                            ],
                            [
                                w,
                                /_/g,
                                "."
                            ]
                        ],
                        [
                            /droid ([\w\.]+)\b.+(android[- ]x86)/i
                        ],
                        [
                            w,
                            d
                        ],
                        [
                            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                            /(blackberry)\w*\/([\w\.]*)/i,
                            /(tizen|kaios)[\/ ]([\w\.]+)/i,
                            /\((series40);/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /\(bb(10);/i
                        ],
                        [
                            w,
                            [
                                d,
                                M
                            ]
                        ],
                        [
                            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Symbian"
                            ]
                        ],
                        [
                            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Firefox OS"
                            ]
                        ],
                        [
                            /web0s;.+rt(tv)/i,
                            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "webOS"
                            ]
                        ],
                        [
                            /crkey\/([\d\.]+)/i
                        ],
                        [
                            w,
                            [
                                d,
                                "Chromecast"
                            ]
                        ],
                        [
                            /(cros) [\w]+ ([\w\.]+\w)/i
                        ],
                        [
                            [
                                d,
                                "Chromium OS"
                            ],
                            w
                        ],
                        [
                            /(nintendo|playstation) ([wids345portablevuch]+)/i,
                            /(xbox); +xbox ([^\);]+)/i,
                            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                            /(mint)[\/\(\) ]?(\w*)/i,
                            /(mageia|vectorlinux)[; ]/i,
                            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                            /(hurd|linux) ?([\w\.]*)/i,
                            /(gnu) ?([\w\.]*)/i,
                            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                            /(haiku) (\w+)/i
                        ],
                        [
                            d,
                            w
                        ],
                        [
                            /(sunos) ?([\w\.\d]*)/i
                        ],
                        [
                            [
                                d,
                                "Solaris"
                            ],
                            w
                        ],
                        [
                            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
                            /(unix) ?([\w\.]*)/i
                        ],
                        [
                            d,
                            w
                        ]
                    ]
                }, H = function(e, i) {
                    if (typeof e === l && (i = e, e = r), !(this instanceof H)) return new H(e, i).getResult();
                    var t = e || (typeof o !== s && o.navigator && o.navigator.userAgent ? o.navigator.userAgent : ""), n = i ? function(e, i) {
                        var t = {};
                        for(var n in e)i[n] && i[n].length % 2 == 0 ? t[n] = i[n].concat(e[n]) : t[n] = e[n];
                        return t;
                    }(V, i) : V;
                    return this.getBrowser = function() {
                        var e, i = {};
                        return i.name = r, i.version = r, F.call(i, t, n.browser), i.major = typeof (e = i.version) === u ? e.replace(/[^\d\.]/g, "").split(".")[0] : r, i;
                    }, this.getCPU = function() {
                        var e = {};
                        return e.architecture = r, F.call(e, t, n.cpu), e;
                    }, this.getDevice = function() {
                        var e = {};
                        return e.vendor = r, e.model = r, e.type = r, F.call(e, t, n.device), e;
                    }, this.getEngine = function() {
                        var e = {};
                        return e.name = r, e.version = r, F.call(e, t, n.engine), e;
                    }, this.getOS = function() {
                        var e = {};
                        return e.name = r, e.version = r, F.call(e, t, n.os), e;
                    }, this.getResult = function() {
                        return {
                            ua: this.getUA(),
                            browser: this.getBrowser(),
                            engine: this.getEngine(),
                            os: this.getOS(),
                            device: this.getDevice(),
                            cpu: this.getCPU()
                        };
                    }, this.getUA = function() {
                        return t;
                    }, this.setUA = function(e) {
                        return t = typeof e === u && e.length > 255 ? z(e, 255) : e, this;
                    }, this.setUA(t), this;
                };
                H.VERSION = "0.7.30", H.BROWSER = D([
                    d,
                    w,
                    "major"
                ]), H.CPU = D([
                    g
                ]), H.DEVICE = D([
                    c,
                    m,
                    b,
                    p,
                    f,
                    v,
                    h,
                    y,
                    x
                ]), H.ENGINE = H.OS = D([
                    d,
                    w
                ]), typeof i !== s ? (typeof e !== s && e.exports && (i = e.exports = H), i.UAParser = H) : t(5) ? (n = (function() {
                    return H;
                }).call(i, t, i, e)) === r || (e.exports = n) : typeof o !== s && (o.UAParser = H);
                var K = typeof o !== s && (o.jQuery || o.Zepto);
                if (K && !K.ua) {
                    var Y = new H;
                    K.ua = Y.getResult(), K.ua.get = function() {
                        return Y.getUA();
                    }, K.ua.set = function(e) {
                        Y.setUA(e);
                        var i = Y.getResult();
                        for(var t in i)K.ua[t] = i[t];
                    };
                }
            }("object" == typeof window ? window : this);
        },
        function(e, i) {
            (function(i) {
                e.exports = i;
            }).call(this, {});
        },
        function(e, i) {
            e.exports = function() {
                var e = [
                    "monospace",
                    "sans-serif",
                    "serif"
                ], i = document.getElementsByTagName("body")[0], t = document.createElement("span");
                t.style.fontSize = "72px", t.innerHTML = "mmmmmmmmmmlli";
                var n = {}, o = {};
                for(var r in e)t.style.fontFamily = e[r], i.appendChild(t), n[e[r]] = t.offsetWidth, o[e[r]] = t.offsetHeight, i.removeChild(t);
                this.detect = function(r) {
                    var a = !1;
                    for(var s in e){
                        t.style.fontFamily = r + "," + e[s], i.appendChild(t);
                        var l = t.offsetWidth != n[e[s]] || t.offsetHeight != o[e[s]];
                        i.removeChild(t), a = a || l;
                    }
                    return a;
                };
            };
        }
    ]);
});

},{}],"QTpCA":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('[{"level":0.3,"description":"Guest","colour":"#aaa","symbol":"G"},{"level":0.5,"description":"Payroll","colour":"#34a853","symbol":"P"},{"level":1,"description":"Employee"},{"level":2,"description":"Manager","colour":"#2d8ada","symbol":"M"},{"level":2.5,"description":"Manager Plus","colour":"#2d8ada","symbol":"M+"},{"level":3,"description":"HR","colour":"#ad77ca","symbol":"HR"},{"level":3.2,"description":"Super HR","colour":"#ad77ca","symbol":"HR+"},{"level":3.6,"description":"Director","colour":"#ea4335","symbol":"D"},{"level":4,"description":"Administrator","colour":"#fabf13","symbol":"\u2605"},{"level":6,"description":"Developer","colour":"#e94186","symbol":"</>"}]');

},{}],"fkdv9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _luxon = require("luxon");
var _capacitor = require("./utilities/capacitor");
const utils = {};
utils.getSubdomain = ()=>{
    // When running as Capacitor app, always return 'app'
    const isCapacitor = (0, _capacitor.isCapacitorApp)();
    console.log("isCapacitorApp check:", isCapacitor);
    if (isCapacitor) {
        console.log("Running as Capacitor app, returning 'app' subdomain");
        return "app";
    }
    const parts = window.location.host.split(".");
    console.log("Host parts:", parts);
    if (parts.length >= 2) {
        console.log("Returning subdomain:", parts[0]);
        return parts[0];
    }
    console.log("No subdomain found, returning null");
    return null;
};
utils.getPathParts = ()=>{
    const pathParts = window.location.pathname.replace("/", "");
    return pathParts && (pathParts === null || pathParts === void 0 ? void 0 : pathParts.split("/")) || [];
};
utils.getIsAdmin = ()=>{
    if (localStorage.getItem("admin") === undefined) return utils.getSubdomain(), false;
    return !!(localStorage.getItem("admin") === "true");
};
utils.getClientRef = ()=>{
    if (utils.getIsAdmin()) {
        const pathParts = utils.getPathParts();
        if (pathParts.length > 0) return pathParts[0] === "admin" ? "master" : pathParts[0] || null;
        return "admin";
    }
    return localStorage.getItem("clientRef") || utils.getSubdomain() || null;
};
utils.getContrastingColor = (color)=>{
    // Expand shorthand hex notation
    color = expandHex(color);
    // Convert input color to RGB values
    var colorRgb = hexToRgb(color);
    // Get the luminance of the input color
    var colorLuminance = (0.299 * colorRgb.r + 0.587 * colorRgb.g + 0.114 * colorRgb.b) / 255;
    // Return "black" if the luminance is greater than or equal to 0.5, else return "white"
    return colorLuminance >= 0.5 ? "black" : "white";
};
utils.extractYoutubeId = (url)=>{
    if (!(url === null || url === void 0 ? void 0 : url.match)) return;
    const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url === null || url === void 0 ? void 0 : url.match(regExp);
    if (match && match[2]) return match[2];
    return null;
};
// Return ordinal suffix for a number (3rd, 5th etc)
utils.getOrdinalSuffix = (day)=>{
    if (!day || typeof day !== "number") return;
    if (day >= 11 && day <= 13) return "th";
    else switch(day % 10){
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
};
// Convert weeks to days
utils.getDaysFromWeeks = (weeks = 0)=>{
    var _this;
    weeks = parseFloat(weeks);
    const daysPerWeek = 5;
    return (_this = weeks * daysPerWeek) === null || _this === void 0 ? void 0 : _this.toFixed(1);
};
// Return formatted date string
utils.getFormattedDate = (date, format = "d MMMM yyyy", friendly = false)=>{
    if (!date) return null;
    const dateObj = (0, _luxon.DateTime).fromISO(date);
    if (!dateObj.isValid) return null;
    let formattedDate;
    if (format === "full") {
        const day = dateObj.day;
        const ordinalSuffix = utils.getOrdinalSuffix(day);
        formattedDate = dateObj.toFormat(`EEEE, d'${ordinalSuffix}' MMMM`);
    } else formattedDate = dateObj.toFormat(format);
    if (!friendly) return formattedDate;
    const today = (0, _luxon.DateTime).local();
    const yesterday = today.minus({
        days: 1
    });
    const todayFormatted = today.toFormat(format);
    const yesterdayFormatted = yesterday.toFormat(format);
    return formattedDate === todayFormatted ? "Today" : formattedDate === yesterdayFormatted ? "Yesterday" : formattedDate;
};
// Return formatted date string with time
utils.getFormattedDateTime = (date)=>{
    if (!date) return "-";
    const dateObj = (0, _luxon.DateTime).fromISO(date);
    if (!dateObj.isValid) return "-";
    const formattedDate = dateObj.toFormat("d MMMM yyyy, h:mm a");
    return formattedDate;
};
utils.convertToUKDate = (isoDate, addDays = 0)=>{
    return (0, _luxon.DateTime).fromISO(isoDate, {
        zone: "utc"
    }) // Parse as UTC/GMT
    .setZone("Europe/London").plus({
        days: addDays
    }).toISODate(); // Return only the date part
};
// Ensure 'regularDays' value is correct format for select options
const defaultRegularDays = [
    false,
    true,
    true,
    true,
    true,
    true,
    false,
    false
];
utils.formatRegularWorkingDays = (regularDays = defaultRegularDays)=>{
    if (Array.isArray(regularDays) && regularDays.length === 0) regularDays = defaultRegularDays;
    const days = [];
    const keys = Object.keys(regularDays);
    keys === null || keys === void 0 ? void 0 : keys.forEach((key)=>{
        if (regularDays[key] && key > 0) days.push({
            value: parseInt(key),
            label: (0, _luxon.DateTime).fromObject({
                weekday: parseInt(key)
            }).toFormat("cccc")
        });
    });
    return days;
};
// Remove any HTML tags
utils.stripTags = (str, retainLinebreaks = false)=>{
    if (!str || typeof str !== "string") return;
    if (retainLinebreaks) str = str.replace(/<\/(p|div|h1|h2|h3|h4|h5|h6)>|<br\s*\/?>/g, "[BREAK]");
    str = str.replace(/(<([^>]+)>)/gi, "");
    if (retainLinebreaks) str = str.replace(/\[BREAK\]/g, "<br />");
    return str;
};
// Parse text and make substitutions
utils.parseShortcuts = (str, substitutions = {})=>{
    if (!str || typeof str !== "string") return;
    if (!substitutions || typeof substitutions !== "object") return;
    // Replace any substitutions
    for(const key in substitutions)if (substitutions.hasOwnProperty(key)) {
        let value = substitutions[key] || "<span class='text-missing'>(information missing)</span>";
        if (key === "e") value = `<a href="mailto:${value}">${value}</a>`;
        str = str.replace(new RegExp(`\\[${key}\\]`, "gi"), value);
    }
    return str;
};
// Access a nested object property by path
utils.getNested = (obj, path, defaultValue = null)=>{
    if (!obj || typeof obj !== "object") return defaultValue;
    if (!path || typeof path !== "string") return defaultValue;
    const pathArray = path.split(".");
    let value = obj;
    for(let i = 0; i < pathArray.length; i++){
        const key = pathArray[i];
        if (value.hasOwnProperty(key)) value = value[key];
        else return defaultValue;
    }
    return value;
};
// Deep find a nested object by key and value
utils.findNested = (obj, key, value)=>{
    for(const prop in obj)if (obj.hasOwnProperty(prop)) {
        if (prop === key && obj[prop] === value) return obj;
        else if (typeof obj[prop] === "object") {
            const nestedResult = utils.findNested(obj[prop], key, value);
            if (nestedResult) return nestedResult;
        }
    }
    return null;
};
// Convert an array into another format, e.g. for react-select
utils.generateSelectOptions = (data = [], valueKey, labelKey, outputValue = "value", outputLabel = "label")=>{
    var _data_filter;
    const options = data === null || data === void 0 ? void 0 : (_data_filter = data.filter((item)=>{
        if (typeof item === "object") return !!(item === null || item === void 0 ? void 0 : item[labelKey]);
        if (typeof item === "string") return !!item;
        return true;
    })) === null || _data_filter === void 0 ? void 0 : _data_filter.map((item)=>{
        const isObject = typeof item === "object";
        const option = {
            [outputValue]: isObject ? item === null || item === void 0 ? void 0 : item[valueKey] : item,
            [outputLabel]: isObject ? item === null || item === void 0 ? void 0 : item[labelKey] : item
        };
        return option;
    });
    return options;
};
// Parse output from react-select into valid data for submission
utils.parseSelectOptions = (data)=>{
    if (!data || !Array.isArray(data) && typeof data != "object" && typeof data != "string") return null;
    if (typeof data === "string") return data;
    if (typeof data === "object" && !Array.isArray(data)) return data.value || null;
    const parsedData = data.map((item)=>{
        return item.value;
    });
    return parsedData;
};
// Validate a password
utils.isPasswordInvalid = (password, confirm)=>{
    if (!password || !confirm) return "Please enter a password and confirmation";
    if (password !== confirm) return "Passwords do not match";
    if (password.length < 8) return "Password must be at least 8 characters";
    if (password.length > 26) return "Password must be fewer than 26 characters";
    if (!password.match(/^$|[a-z]+/)) return "Password must contain a lowercase letter";
    if (!password.match(/^$|[A-Z]+/)) return "Password must contain an uppercase letter";
    if (!password.match(/^$|[0-9]+/)) return "Password must contain a number";
    if (!password.match(/^$|[^a-zA-Z0-9]+/)) return "Password must contain a symbol";
    return null;
};
utils.getTitleFromLongContent = (str, maxLen = 50)=>{
    if (!str || typeof str !== "string") return;
    // Split the string by any line breaks, '</p>', '<br />' or '<br>',
    // as well as sentence-ending punctuation (. ! ?)
    const splitPoints = [
        "\n",
        "</p>",
        "<br />",
        "<br>",
        ".",
        "!",
        "?"
    ];
    let splitStr = str;
    let foundSplitPoint = false;
    for(let i = 0; i < splitPoints.length; i++){
        const splitIndex = splitStr.indexOf(splitPoints[i]);
        if (splitIndex !== -1 && splitIndex < splitStr.length - 1) {
            if (splitPoints[i] === ".") // Check if the period is followed by a space
            {
                if (splitIndex + 1 >= splitStr.length || splitStr[splitIndex + 1] === " ") foundSplitPoint = true;
            } else foundSplitPoint = true;
            if (foundSplitPoint) {
                splitStr = splitStr.substring(0, splitIndex);
                // Only split on the first sentence-ending punctuation found
                if (splitPoints[i] === "." || splitPoints[i] === "!" || splitPoints[i] === "?") break;
            }
        }
    }
    // Remove any HTML tags, and truncate
    const truncated = utils.truncateString(splitStr, maxLen);
    // If we have split the string, but the truncated string does not already
    // end with an ellipsis, add one to the end
    if (foundSplitPoint && truncated.at(-1) !== "\u2026") return truncated + "\u2026";
    return truncated;
};
// Truncate a string to a certain length, retaining whole words
utils.truncateString = (str = "", maxLen = 50, brSplit = 0, retainLinebreaks = false)=>{
    if (!str || typeof str !== "string") return;
    // Remove any HTML tags
    const plainTextStr = utils.stripTags(str, retainLinebreaks);
    // Limit the output string to 50 characters
    let truncatedStr = plainTextStr.substring(0, maxLen);
    if (truncatedStr.length === maxLen) {
        // Use the last whole word as a cut-off point
        const lastSpaceIndex = truncatedStr.lastIndexOf(" ");
        if (lastSpaceIndex !== -1) truncatedStr = truncatedStr.substring(0, lastSpaceIndex);
    }
    const textHasChanged = plainTextStr !== truncatedStr;
    truncatedStr = utils.breakSplit(truncatedStr, brSplit);
    return !textHasChanged ? truncatedStr : truncatedStr + "\u2026";
};
// add a zero-width break at the specified interval
utils.breakSplit = (text, limit = 0)=>{
    if (limit === 0) return text;
    // split string into words
    const words = text.split(" ");
    // hold lines of text in an array
    const lines = [];
    // loop through each word
    words.forEach((word, index)=>{
        const lastLine = lines[lines.length - 1];
        // get total number of characters for all elements in last line
        const lastLineLength = lastLine ? lastLine.reduce((acc, val)=>acc + val.length, 0) : 0;
        // would adding this word to the last line exceed the limit?
        if (lastLine && lastLineLength + word.length <= limit) lastLine.push(word);
        else {
            // is the word longer than the limit?
            if (word.length > limit) {
                // add breakpoints at the specified interval
                const regex = new RegExp(`(.{${limit}})`, "g");
                word = word.replace(regex, "$1\u00AD"); //200B
            }
            // create a new line
            lines.push([
                word
            ]);
        }
    });
    // join the lines with spaces
    return lines.map((line)=>line.join(" ")).join(" ");
};
// convert a camelCase string to a sentence
utils.camelCaseToSentence = (str)=>{
    if (!str || typeof str !== "string") return;
    // Use a regular expression to split the string at uppercase letters, spaces, underscores, and hyphens
    const words = str.split(/(?=[A-Z])|_|-/);
    // Filter out empty strings and convert all words to lowercase, except the first one
    const sentenceCaseWords = words.filter((word)=>word.trim() !== "").map((word, index)=>{
        if (index === 0) return word.charAt(0).toUpperCase() + word.slice(1);
        else return word.toLowerCase();
    });
    // Join the words with spaces to form the sentence case string
    return sentenceCaseWords.join(" ");
};
// convert an array to CSV
utils.arrayToCsv = (data, delimiter = ",")=>{
    // get all the properties to use as headings
    let headings = [];
    data.forEach((row)=>{
        if (row && typeof row === "object") Object.keys(row).forEach((key)=>{
            if (!headings.includes(key)) headings.push(key);
        });
    });
    const rows = [];
    // loop through each item in the array and add the values to a new array
    data.forEach((row)=>{
        if (row && typeof row === "object") {
            const newRow = [];
            headings.forEach((heading)=>{
                newRow.push(row[heading] || "");
            });
            rows.push(newRow);
        }
    });
    // add the headings to the start of the array
    rows.unshift(headings);
    // convert the array to a CSV string
    return utils.arrayToCsvString(rows, delimiter);
};
utils.arrayToCsvString = (data, delimiter = ",")=>{
    var _data_map;
    if (!data || !Array.isArray(data)) return;
    return (_data_map = data.map((row)=>{
        var _row_map_map_map // quote it
        , _row_map_map // escape double quotes
        , _row_map // convert every value to String
        ;
        return row === null || row === void 0 ? void 0 : (_row_map = row.map(String)) === null || _row_map === void 0 ? void 0 : (_row_map_map = _row_map.map((v)=>v.replaceAll('"', '""'))) === null || _row_map_map === void 0 ? void 0 : (_row_map_map_map = _row_map_map.map((v)=>`"${v}"`)) === null || _row_map_map_map === void 0 ? void 0 : _row_map_map_map.join(delimiter);
    })) === null || _data_map === void 0 ? void 0 : _data_map.join("\r\n"); // rows starting on new lines
};
// Get the icon name for a file based on its MIME type
utils.getMimeIcon = (mime = "")=>{
    if (mime.substring(0, 5) === "video") return "video";
    if (mime.substring(0, 5) === "audio") return "music";
    if (mime.substring(0, 5) === "image") return "jpg";
    if (mime.search("excel") >= 0 || mime.search("spreadsheet") >= 0) return "excel";
    if (mime.search("word") >= 0) return "word";
    if (mime === "application/gzip" || mime === "application/zip") return "zip";
    if (mime === "application/pdf") return "pdf";
    return "text";
};
// Intercept links to anchors, and scroll to them (prevent react router from navigating)
utils.interceptAnchorLinks = (containerSelector)=>{
    setTimeout(()=>{
        const container = document.querySelector(containerSelector) || document;
        const links = container.querySelectorAll("a");
        links.forEach((link)=>{
            const href = link.getAttribute("href");
            // Skip if listener already added
            if (link.dataset.listenerAdded === "true") return;
            // anchor links
            if (href && href.startsWith("#")) link.addEventListener("click", (e)=>{
                e.preventDefault();
                const element = document.querySelector(href) || document.querySelector(`a[name="${href.replace("#", "")}"]`);
                if (element) element.scrollIntoView({
                    behavior: "smooth"
                });
            });
            // file downloads
            if (link.getAttribute("target") === "file-download") link.addEventListener("click", (e)=>{
                e.preventDefault();
                const fileName = link.getAttribute("href");
                utils.downloadFileSlug(fileName);
            });
            // Mark as handled
            link.dataset.listenerAdded = "true";
        });
    }, 1000);
};
utils.downloadFileSlug = (fileSlug)=>{
    fetch(`${"https://rest.yourhr.space"}/file/${fileSlug}?account=${utils.getClientRef()}`, {
        method: "GET",
        headers: {
            "x-auth-token": localStorage.getItem("authToken"),
            ...(0, _capacitor.getCapacitorHeaders)()
        }
    }).then(async (res)=>{
        return res.blob();
    }).then((blob)=>{
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.setAttribute("target", "_blank");
        a.setAttribute("download", fileSlug);
        a.href = url;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(a.href);
        a.remove();
    }).catch((err)=>{
        console.error(err);
    });
};
function expandHex(hex) {
    // Check if shorthand hex notation is used (e.g. "#fff" instead of "#ffffff")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
    return hex;
}
function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
exports.default = utils;

},{"luxon":"24mCD","./utilities/capacitor":"lTR78","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"24mCD":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) _construct = Reflect.construct.bind();
    else _construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var LuxonError = /*#__PURE__*/ function(_Error) {
    _inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
/**
 * @private
 */ var InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    _inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}(LuxonError);
/**
 * @private
 */ var InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    _inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}(LuxonError);
/**
 * @private
 */ var InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    _inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}(LuxonError);
/**
 * @private
 */ var ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    _inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}(LuxonError);
/**
 * @private
 */ var InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    _inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}(LuxonError);
/**
 * @private
 */ var InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    _inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}(LuxonError);
/**
 * @private
 */ var ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    _inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}(LuxonError);
/**
 * @private
 */ var n = "numeric", s = "short", l = "long";
var DATE_SHORT = {
    year: n,
    month: n,
    day: n
};
var DATE_MED = {
    year: n,
    month: s,
    day: n
};
var DATE_MED_WITH_WEEKDAY = {
    year: n,
    month: s,
    day: n,
    weekday: s
};
var DATE_FULL = {
    year: n,
    month: l,
    day: n
};
var DATE_HUGE = {
    year: n,
    month: l,
    day: n,
    weekday: l
};
var TIME_SIMPLE = {
    hour: n,
    minute: n
};
var TIME_WITH_SECONDS = {
    hour: n,
    minute: n,
    second: n
};
var TIME_WITH_SHORT_OFFSET = {
    hour: n,
    minute: n,
    second: n,
    timeZoneName: s
};
var TIME_WITH_LONG_OFFSET = {
    hour: n,
    minute: n,
    second: n,
    timeZoneName: l
};
var TIME_24_SIMPLE = {
    hour: n,
    minute: n,
    hourCycle: "h23"
};
var TIME_24_WITH_SECONDS = {
    hour: n,
    minute: n,
    second: n,
    hourCycle: "h23"
};
var TIME_24_WITH_SHORT_OFFSET = {
    hour: n,
    minute: n,
    second: n,
    hourCycle: "h23",
    timeZoneName: s
};
var TIME_24_WITH_LONG_OFFSET = {
    hour: n,
    minute: n,
    second: n,
    hourCycle: "h23",
    timeZoneName: l
};
var DATETIME_SHORT = {
    year: n,
    month: n,
    day: n,
    hour: n,
    minute: n
};
var DATETIME_SHORT_WITH_SECONDS = {
    year: n,
    month: n,
    day: n,
    hour: n,
    minute: n,
    second: n
};
var DATETIME_MED = {
    year: n,
    month: s,
    day: n,
    hour: n,
    minute: n
};
var DATETIME_MED_WITH_SECONDS = {
    year: n,
    month: s,
    day: n,
    hour: n,
    minute: n,
    second: n
};
var DATETIME_MED_WITH_WEEKDAY = {
    year: n,
    month: s,
    day: n,
    weekday: s,
    hour: n,
    minute: n
};
var DATETIME_FULL = {
    year: n,
    month: l,
    day: n,
    hour: n,
    minute: n,
    timeZoneName: s
};
var DATETIME_FULL_WITH_SECONDS = {
    year: n,
    month: l,
    day: n,
    hour: n,
    minute: n,
    second: n,
    timeZoneName: s
};
var DATETIME_HUGE = {
    year: n,
    month: l,
    day: n,
    weekday: l,
    hour: n,
    minute: n,
    timeZoneName: l
};
var DATETIME_HUGE_WITH_SECONDS = {
    year: n,
    month: l,
    day: n,
    weekday: l,
    hour: n,
    minute: n,
    second: n,
    timeZoneName: l
};
/**
 * @interface
 */ var Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new ZoneIsAbstractError();
    };
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new ZoneIsAbstractError();
    };
    _proto.offset = function offset(ts) {
        throw new ZoneIsAbstractError();
    };
    _proto.equals = function equals(otherZone) {
        throw new ZoneIsAbstractError();
    };
    _createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new ZoneIsAbstractError();
            }
        },
        {
            key: "ianaName",
            get: function get() {
                return this.name;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var SystemZone = /*#__PURE__*/ function(_Zone) {
    _inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return parseZoneInfo(ts, format, locale);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    };
    _createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if (singleton$1 === null) singleton$1 = new SystemZone();
                return singleton$1;
            }
        }
    ]);
    return SystemZone;
}(Zone);
var dtfCache = new Map();
function makeDTF(zoneName) {
    var dtf = dtfCache.get(zoneName);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: zoneName,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            era: "short"
        });
        dtfCache.set(zoneName, dtf);
    }
    return dtf;
}
var typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fadOrBc = parsed[4], fHour = parsed[5], fMinute = parsed[6], fSecond = parsed[7];
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value;
        var pos = typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var ianaZoneCache = new Map();
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var IANAZone = /*#__PURE__*/ function(_Zone) {
    _inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        var zone = ianaZoneCache.get(name);
        if (zone === undefined) ianaZoneCache.set(name, zone = new IANAZone(name));
        return zone;
    };
    IANAZone.resetCache = function resetCache() {
        ianaZoneCache.clear();
        dtfCache.clear();
    };
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    };
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */ var _proto = IANAZone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return parseZoneInfo(ts, format, locale, this.name);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        if (!this.valid) return NaN;
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = makeDTF(this.name);
        var _ref2 = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], adOrBc = _ref2[3], hour = _ref2[4], minute = _ref2[5], second = _ref2[6];
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    };
    _createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}(Zone);
var _excluded = [
    "base"
], _excluded2 = [
    "padTo",
    "floor"
];
// todo - remap caching
var intlLFCache = {};
function getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        intlLFCache[key] = dtf;
    }
    return dtf;
}
var intlDTCache = new Map();
function getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = intlDTCache.get(key);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        intlDTCache.set(key, dtf);
    }
    return dtf;
}
var intlNumCache = new Map();
function getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = intlNumCache.get(key);
    if (inf === undefined) {
        inf = new Intl.NumberFormat(locString, opts);
        intlNumCache.set(key, inf);
    }
    return inf;
}
var intlRelCache = new Map();
function getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = _objectWithoutPropertiesLoose(_opts, _excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = intlRelCache.get(key);
    if (inf === undefined) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        intlRelCache.set(key, inf);
    }
    return inf;
}
var sysLocaleCache = null;
function systemLocale() {
    if (sysLocaleCache) return sysLocaleCache;
    else {
        sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return sysLocaleCache;
    }
}
var intlResolvedOptionsCache = new Map();
function getCachedIntResolvedOptions(locString) {
    var opts = intlResolvedOptionsCache.get(locString);
    if (opts === undefined) {
        opts = new Intl.DateTimeFormat(locString).resolvedOptions();
        intlResolvedOptionsCache.set(locString, opts);
    }
    return opts;
}
var weekInfoCache = new Map();
function getCachedWeekInfo(locString) {
    var data = weekInfoCache.get(locString);
    if (!data) {
        var locale = new Intl.Locale(locString);
        // browsers currently implement this as a property, but spec says it should be a getter function
        data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
        // minimalDays was removed from WeekInfo: https://github.com/tc39/proposal-intl-locale-info/issues/86
        if (!("minimalDays" in data)) data = _extends({}, fallbackWeekSettings, data);
        weekInfoCache.set(locString, data);
    }
    return data;
}
function parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    var xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var selectedStr;
        try {
            options = getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            var smaller = localeStr.substring(0, uIndex);
            options = getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = DateTime.utc(2009, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function listStuff(loc, length, englishFn, intlFn) {
    var mode = loc.listingMode();
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || getCachedIntResolvedOptions(loc.locale).numberingSystem === "latn";
}
/**
 * @private
 */ var PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = _objectWithoutPropertiesLoose(opts, _excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = _extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
            return padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        this.originalZone = undefined;
        var z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        var intlOpts = _extends({}, this.opts);
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(function(_ref) {
            var value = _ref.value;
            return value;
        }).join("");
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        var _this = this;
        var parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map(function(part) {
            if (part.type === "timeZoneName") {
                var offsetName = _this.originalZone.offsetName(_this.dt.ts, {
                    locale: _this.dt.locale,
                    format: _this.opts.timeZoneName
                });
                return _extends({}, part, {
                    value: offsetName
                });
            } else return part;
        });
        return parts;
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = _extends({
            style: "long"
        }, opts);
        if (!isEnglish && hasRelative()) this.rtf = getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
var fallbackWeekSettings = {
    firstDay: 1,
    minimalDays: 4,
    weekend: [
        6,
        7
    ]
};
/**
 * @private
 */ var Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || Settings.defaultLocale;
        // the system locale is useful for human-readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
        var numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
        var weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
        return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        sysLocaleCache = null;
        intlDTCache.clear();
        intlNumCache.clear();
        intlRelCache.clear();
        intlResolvedOptionsCache.clear();
        weekInfoCache.clear();
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, locale = _ref2.locale, numberingSystem = _ref2.numberingSystem, outputCalendar = _ref2.outputCalendar, weekSettings = _ref2.weekSettings;
        return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
    };
    function Locale(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
        var _parseLocaleString = parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.weekSettings = weekSettings;
        this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone(_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone(_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format) {
        var _this2 = this;
        if (format === void 0) format = false;
        return listStuff(this, length, months, function() {
            // Workaround for "ja" locale: formatToParts does not label all parts of the month
            // as "month" and for this locale there is no difference between "format" and "non-format".
            // As such, just use format() instead of formatToParts() and take the whole string
            var monthSpecialCase = _this2.intl === "ja" || _this2.intl.startsWith("ja-");
            format &= !monthSpecialCase;
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.monthsCache[formatStr][length]) {
                var mapper = !monthSpecialCase ? function(dt) {
                    return _this2.extract(dt, intl, "month");
                } : function(dt) {
                    return _this2.dtFormatter(dt, intl).format();
                };
                _this2.monthsCache[formatStr][length] = mapMonths(mapper);
            }
            return _this2.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format) {
        var _this3 = this;
        if (format === void 0) format = false;
        return listStuff(this, length, weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this3.weekdaysCache[formatStr][length]) _this3.weekdaysCache[formatStr][length] = mapWeekdays(function(dt) {
                return _this3.extract(dt, intl, "weekday");
            });
            return _this3.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1() {
        var _this4 = this;
        return listStuff(this, undefined, function() {
            return meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this4.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this4.meridiemCache = [
                    DateTime.utc(2016, 11, 13, 9),
                    DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this4.extract(dt, intl, "dayperiod");
                });
            }
            return _this4.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length) {
        var _this5 = this;
        return listStuff(this, length, eras, function() {
            var intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this5.eraCache[length]) _this5.eraCache[length] = [
                DateTime.utc(-40, 1, 1),
                DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this5.extract(dt, intl, "era");
            });
            return _this5.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || getCachedIntResolvedOptions(this.intl).locale.startsWith("en-us");
    };
    _proto4.getWeekSettings = function getWeekSettings() {
        if (this.weekSettings) return this.weekSettings;
        else if (!hasLocaleWeekInfo()) return fallbackWeekSettings;
        else return getCachedWeekInfo(this.locale);
    };
    _proto4.getStartOfWeek = function getStartOfWeek() {
        return this.getWeekSettings().firstDay;
    };
    _proto4.getMinDaysInFirstWeek = function getMinDaysInFirstWeek() {
        return this.getWeekSettings().minimalDays;
    };
    _proto4.getWeekendDays = function getWeekendDays() {
        return this.getWeekSettings().weekend;
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    _proto4.toString = function toString() {
        return "Locale(" + this.locale + ", " + this.numberingSystem + ", " + this.outputCalendar + ")";
    };
    _createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
var singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    _inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    };
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone(signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */ var _proto = FixedOffsetZone.prototype;
    /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */ _proto.offsetName = function offsetName() {
        return this.name;
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return formatOffset(this.fixed, format);
    };
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */ _proto.offset = function offset() {
        return this.fixed;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    };
    _createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "ianaName",
            get: function get() {
                if (this.fixed === 0) return "Etc/UTC";
                else return "Etc/GMT" + formatOffset(-this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if (singleton === null) singleton = new FixedOffsetZone(0);
                return singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}(Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var InvalidZone = /*#__PURE__*/ function(_Zone) {
    _inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    };
    _proto.formatOffset = function formatOffset() {
        return "";
    };
    _proto.offset = function offset() {
        return NaN;
    };
    _proto.equals = function equals() {
        return false;
    };
    _createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}(Zone);
/**
 * @private
 */ function normalizeZone(input, defaultZone) {
    if (isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof Zone) return input;
    else if (isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return SystemZone.instance;
        else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;
        else return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
    } else if (isNumber(input)) return FixedOffsetZone.instance(input);
    else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new InvalidZone(input);
}
var numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search(numberingSystems.hanidec) !== -1) value += hanidecChars.indexOf(str[i]);
            else for(var key in numberingSystemsUTF16){
                var _numberingSystemsUTF = numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
// cache of {numberingSystem: {append: regex}}
var digitRegexCache = new Map();
function resetDigitRegexCache() {
    digitRegexCache.clear();
}
function digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    var ns = numberingSystem || "latn";
    var appendCache = digitRegexCache.get(ns);
    if (appendCache === undefined) {
        appendCache = new Map();
        digitRegexCache.set(ns, appendCache);
    }
    var regex = appendCache.get(append);
    if (regex === undefined) {
        regex = new RegExp("" + numberingSystems[ns] + append);
        appendCache.set(append, regex);
    }
    return regex;
}
var now = function now() {
    return Date.now();
}, defaultZone = "system", defaultLocale = null, defaultNumberingSystem = null, defaultOutputCalendar = null, twoDigitCutoffYear = 60, throwOnInvalid, defaultWeekSettings = null;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        Locale.resetCache();
        IANAZone.resetCache();
        DateTime.resetCache();
        resetDigitRegexCache();
    };
    _createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return now;
            },
            set: function set(n) {
                now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return normalizeZone(defaultZone, SystemZone.instance);
            },
            set: function set(zone) {
                defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return defaultLocale;
            },
            set: function set(locale) {
                defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "defaultWeekSettings",
            get: function get() {
                return defaultWeekSettings;
            },
            set: function set(weekSettings) {
                defaultWeekSettings = validateWeekSettings(weekSettings);
            }
        },
        {
            key: "twoDigitCutoffYear",
            get: function get() {
                return twoDigitCutoffYear;
            },
            set: function set(cutoffYear) {
                twoDigitCutoffYear = cutoffYear % 100;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return throwOnInvalid;
            },
            set: function set(t) {
                throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
var Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
var nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function unitOutOfRange(unit, value) {
    return new Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function dayOfWeek(year, month, day) {
    var d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    var js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function computeOrdinal(year, month, day) {
    return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
function uncomputeOrdinal(year, ordinal) {
    var table = isLeapYear(year) ? leapLadder : nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
function isoWeekdayToLocal(isoWeekday, startOfWeek) {
    return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
/**
 * @private
 */ function gregorianToWeek(gregObj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = computeOrdinal(year, month, day), weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);
    var weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
    } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return _extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, timeObject(gregObj));
}
function weekToGregorian(weekData, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return _extends({
        year: year,
        month: month,
        day: day
    }, timeObject(weekData));
}
function gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = computeOrdinal(year, month, day);
    return _extends({
        year: year,
        ordinal: ordinal
    }, timeObject(gregData));
}
function ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return _extends({
        year: year,
        month: month,
        day: day
    }, timeObject(ordinalData));
}
/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */ function usesLocalWeekValues(obj, loc) {
    var hasLocaleWeekData = !isUndefined(obj.localWeekday) || !isUndefined(obj.localWeekNumber) || !isUndefined(obj.localWeekYear);
    if (hasLocaleWeekData) {
        var hasIsoWeekData = !isUndefined(obj.weekday) || !isUndefined(obj.weekNumber) || !isUndefined(obj.weekYear);
        if (hasIsoWeekData) throw new ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
        if (!isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
        if (!isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
        if (!isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
        delete obj.localWeekday;
        delete obj.localWeekNumber;
        delete obj.localWeekYear;
        return {
            minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
            startOfWeek: loc.getStartOfWeek()
        };
    } else return {
        minDaysInFirstWeek: 4,
        startOfWeek: 1
    };
}
function hasInvalidWeekData(obj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var validYear = isInteger(obj.weekYear), validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = integerBetween(obj.weekday, 1, 7);
    if (!validYear) return unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return unitOutOfRange("week", obj.weekNumber);
    else if (!validWeekday) return unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function hasInvalidOrdinalData(obj) {
    var validYear = isInteger(obj.year), validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
    if (!validYear) return unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function hasInvalidGregorianData(obj) {
    var validYear = isInteger(obj.year), validMonth = integerBetween(obj.month, 1, 12), validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
    if (!validYear) return unitOutOfRange("year", obj.year);
    else if (!validMonth) return unitOutOfRange("month", obj.month);
    else if (!validDay) return unitOutOfRange("day", obj.day);
    else return false;
}
function hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = integerBetween(minute, 0, 59), validSecond = integerBetween(second, 0, 59), validMillisecond = integerBetween(millisecond, 0, 999);
    if (!validHour) return unitOutOfRange("hour", hour);
    else if (!validMinute) return unitOutOfRange("minute", minute);
    else if (!validSecond) return unitOutOfRange("second", second);
    else if (!validMillisecond) return unitOutOfRange("millisecond", millisecond);
    else return false;
}
/**
 * @private
 */ // TYPES
function isUndefined(o) {
    return typeof o === "undefined";
}
function isNumber(o) {
    return typeof o === "number";
}
function isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function isString(o) {
    return typeof o === "string";
}
function isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
function hasLocaleWeekInfo() {
    try {
        return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function validateWeekSettings(settings) {
    if (settings == null) return null;
    else if (typeof settings !== "object") throw new InvalidArgumentError("Week settings must be an object");
    else {
        if (!integerBetween(settings.firstDay, 1, 7) || !integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some(function(v) {
            return !integerBetween(v, 1, 7);
        })) throw new InvalidArgumentError("Invalid week settings");
        return {
            firstDay: settings.firstDay,
            minimalDays: settings.minimalDays,
            weekend: Array.from(settings.weekend)
        };
    }
}
// NUMBERS AND STRINGS
function integerBetween(thing, bottom, top) {
    return isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function parseInteger(string) {
    if (isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function parseFloating(string) {
    if (isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if (isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function roundTo(number, digits, rounding) {
    if (rounding === void 0) rounding = "round";
    var factor = Math.pow(10, digits);
    switch(rounding){
        case "expand":
            return number > 0 ? Math.ceil(number * factor) / factor : Math.floor(number * factor) / factor;
        case "trunc":
            return Math.trunc(number * factor) / factor;
        case "round":
            return Math.round(number * factor) / factor;
        case "floor":
            return Math.floor(number * factor) / factor;
        case "ceil":
            return Math.ceil(number * factor) / factor;
        default:
            throw new RangeError("Value rounding " + rounding + " is out of range");
    }
}
// DATE BASICS
function isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
    var modMonth = floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
    var fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
    return -fwdlw + minDaysInFirstWeek - 1;
}
function weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
    var weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
    return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function untruncateYear(year) {
    if (year > 99) return year;
    else return year > Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = _extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || !Number.isFinite(numericValue)) throw new InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if (hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = asNumber(v);
    }
    return normalized;
}
/**
 * Returns the offset's value as a string
 * @param {number} ts - Epoch milliseconds for which to get the offset
 * @param {string} format - What style of offset to return.
 *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
 * @return {string}
 */ function formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + padStart(hours, 2) + ":" + padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + padStart(hours, 2) + padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function timeObject(obj) {
    return pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ var monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function months(length) {
    switch(length){
        case "narrow":
            return [].concat(monthsNarrow);
        case "short":
            return [].concat(monthsShort);
        case "long":
            return [].concat(monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat(weekdaysNarrow);
        case "short":
            return [].concat(weekdaysShort);
        case "long":
            return [].concat(weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var meridiems = [
    "AM",
    "PM"
];
var erasLong = [
    "Before Christ",
    "Anno Domini"
];
var erasShort = [
    "BC",
    "AD"
];
var erasNarrow = [
    "B",
    "A"
];
function eras(length) {
    switch(length){
        case "narrow":
            return [].concat(erasNarrow);
        case "short":
            return [].concat(erasShort);
        case "long":
            return [].concat(erasLong);
        default:
            return null;
    }
}
function meridiemForDateTime(dt) {
    return meridiems[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt, length) {
    return weekdays(length)[dt.weekday - 1];
}
function monthForDateTime(dt, length) {
    return months(length)[dt.month - 1];
}
function eraForDateTime(dt, length) {
    return eras(length)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = _createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var _macroTokenToFormatOpts = {
    D: DATE_SHORT,
    DD: DATE_MED,
    DDD: DATE_FULL,
    DDDD: DATE_HUGE,
    t: TIME_SIMPLE,
    tt: TIME_WITH_SECONDS,
    ttt: TIME_WITH_SHORT_OFFSET,
    tttt: TIME_WITH_LONG_OFFSET,
    T: TIME_24_SIMPLE,
    TT: TIME_24_WITH_SECONDS,
    TTT: TIME_24_WITH_SHORT_OFFSET,
    TTTT: TIME_24_WITH_LONG_OFFSET,
    f: DATETIME_SHORT,
    ff: DATETIME_MED,
    fff: DATETIME_FULL,
    ffff: DATETIME_HUGE,
    F: DATETIME_SHORT_WITH_SECONDS,
    FF: DATETIME_MED_WITH_SECONDS,
    FFF: DATETIME_FULL_WITH_SECONDS,
    FFFF: DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                // turn '' into a literal signal quote instead of just skipping the empty literal
                if (currentFull.length > 0 || bracketed) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull === "" ? "'" : currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return _macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, _extends({}, this.opts, opts));
        return df.format();
    };
    _proto.dtFormatter = function dtFormatter(dt, opts) {
        if (opts === void 0) opts = {};
        return this.loc.dtFormatter(dt, _extends({}, this.opts, opts));
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        return this.dtFormatter(dt, opts).format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        return this.dtFormatter(dt, opts).formatToParts();
    };
    _proto.formatInterval = function formatInterval(interval, opts) {
        var df = this.dtFormatter(interval.start, opts);
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        return this.dtFormatter(dt, opts).resolvedOptions();
    };
    _proto.num = function num(n, p, signDisplay) {
        if (p === void 0) p = 0;
        if (signDisplay === void 0) signDisplay = undefined;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return padStart(n, p);
        var opts = _extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        if (signDisplay) opts.signDisplay = signDisplay;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "n":
                    return _this.num(dt.localWeekNumber);
                case "nn":
                    return _this.num(dt.localWeekNumber, 2);
                case "ii":
                    return _this.num(dt.localWeekYear.toString().slice(-2), 2);
                case "iiii":
                    return _this.num(dt.localWeekYear, 4);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var invertLargest = this.opts.signMode === "negativeLargestOnly" ? -1 : 1;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "milliseconds";
                case "s":
                    return "seconds";
                case "m":
                    return "minutes";
                case "h":
                    return "hours";
                case "d":
                    return "days";
                case "w":
                    return "weeks";
                case "M":
                    return "months";
                case "y":
                    return "years";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur, info) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) {
                    var inversionFactor = info.isNegativeDuration && mapped !== info.largestUnit ? invertLargest : 1;
                    var signDisplay;
                    if (_this2.opts.signMode === "negativeLargestOnly" && mapped !== info.largestUnit) signDisplay = "never";
                    else if (_this2.opts.signMode === "all") signDisplay = "always";
                    else // "auto" and "negative" are the same, but "auto" has better support
                    signDisplay = "auto";
                    return _this2.num(lildur.get(mapped) * inversionFactor, token.length, signDisplay);
                } else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        })), durationInfo = {
            isNegativeDuration: collapsed < 0,
            // this relies on "collapsed" being based on "shiftTo", which builds up the object
            // in order
            largestUnit: Object.keys(collapsed.values)[0]
        };
        return stringifyTokens(tokens, tokenToString(collapsed, durationInfo));
    };
    return Formatter;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ var ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                _extends({}, mergedVals, val),
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
var offsetRegex = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/;
var isoExtendedZone = "(?:" + offsetRegex.source + "?(?:\\[(" + ianaRegex.source + ")\\])?)?";
var isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var isoTimeRegex = RegExp("" + isoTimeBaseRegex.source + isoExtendedZone);
var isoTimeExtensionRegex = RegExp("(?:[Tt]" + isoTimeRegex.source + ")?");
var isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
var extractISOOrdinalData = simpleParse("year", "ordinal");
var sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var sqlTimeRegex = RegExp(isoTimeBaseRegex.source + " ?(?:" + offsetRegex.source + "|(" + ianaRegex.source + "))?");
var sqlTimeExtensionRegex = RegExp("(?: " + sqlTimeRegex.source + ")?");
function int(match, pos, fallback) {
    var m = match[pos];
    return isUndefined(m) ? fallback : parseInteger(m);
}
function extractISOYmd(match, cursor) {
    var item = {
        year: int(match, cursor),
        month: int(match, cursor + 1, 1),
        day: int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function extractISOTime(match, cursor) {
    var item = {
        hours: int(match, cursor, 0),
        minutes: int(match, cursor + 1, 0),
        seconds: int(match, cursor + 2, 0),
        milliseconds: parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function extractIANAZone(match, cursor) {
    var zone = match[cursor] ? IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
var isoTimeOnly = RegExp("^T?" + isoTimeBaseRegex.source + "$");
// ISO duration parsing
var isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate(parseFloating(yearStr)),
            months: maybeNegate(parseFloating(monthStr)),
            weeks: maybeNegate(parseFloating(weekStr)),
            days: maybeNegate(parseFloating(dayStr)),
            hours: maybeNegate(parseFloating(hourStr)),
            minutes: maybeNegate(parseFloating(minuteStr)),
            seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
        month: monthsShort.indexOf(monthStr) + 1,
        day: parseInteger(dayStr),
        hour: parseInteger(hourStr),
        minute: parseInteger(minuteStr)
    };
    if (secondStr) result.second = parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new FixedOffsetZone(offset)
    ];
}
function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
var rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        FixedOffsetZone.utcInstance
    ];
}
function extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        FixedOffsetZone.utcInstance
    ];
}
var isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
var isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
var isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
var isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
var extractISOYmdTimeAndOffset = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOWeekTimeAndOffset = combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOOrdinalDateAndTime = combineExtractors(extractISOOrdinalData, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOTimeAndOffset = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
/*
 * @private
 */ function parseISODate(s) {
    return parse(s, [
        isoYmdWithTimeExtensionRegex,
        extractISOYmdTimeAndOffset
    ], [
        isoWeekWithTimeExtensionRegex,
        extractISOWeekTimeAndOffset
    ], [
        isoOrdinalWithTimeExtensionRegex,
        extractISOOrdinalDateAndTime
    ], [
        isoTimeCombinedRegex,
        extractISOTimeAndOffset
    ]);
}
function parseRFC2822Date(s) {
    return parse(preprocessRFC2822(s), [
        rfc2822,
        extractRFC2822
    ]);
}
function parseHTTPDate(s) {
    return parse(s, [
        rfc1123,
        extractRFC1123Or850
    ], [
        rfc850,
        extractRFC1123Or850
    ], [
        ascii,
        extractASCII
    ]);
}
function parseISODuration(s) {
    return parse(s, [
        isoDuration,
        extractISODuration
    ]);
}
var extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s) {
    return parse(s, [
        isoTimeOnly,
        extractISOTimeOnly
    ]);
}
var sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
var sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
var extractISOTimeOffsetAndIANAZone = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
function parseSQL(s) {
    return parse(s, [
        sqlYmdWithTimeExtensionRegex,
        extractISOYmdTimeAndOffset
    ], [
        sqlTimeCombinedRegex,
        extractISOTimeOffsetAndIANAZone
    ]);
}
var INVALID$2 = "Invalid Duration";
// unit conversion constants
var lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, casualMatrix = _extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, lowOrderMatrix), daysInYearAccurate = 365.2425, daysInMonthAccurate = 30.436875, accurateMatrix = _extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: daysInYearAccurate / 7,
        days: daysInYearAccurate,
        hours: daysInYearAccurate * 24,
        minutes: daysInYearAccurate * 1440,
        seconds: daysInYearAccurate * 86400,
        milliseconds: daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: daysInYearAccurate / 28,
        days: daysInYearAccurate / 4,
        hours: daysInYearAccurate * 24 / 4,
        minutes: daysInYearAccurate * 1440 / 4,
        seconds: daysInYearAccurate * 86400 / 4,
        milliseconds: daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: daysInMonthAccurate / 7,
        days: daysInMonthAccurate,
        hours: daysInMonthAccurate * 24,
        minutes: daysInMonthAccurate * 1440,
        seconds: daysInMonthAccurate * 86400,
        milliseconds: daysInMonthAccurate * 86400000
    }
}, lowOrderMatrix);
// units ordered by size
var orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var reverseUnits = orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : _extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new Duration(conf);
}
function durationToMillis(matrix, vals) {
    var _vals$milliseconds;
    var sum = (_vals$milliseconds = vals.milliseconds) != null ? _vals$milliseconds : 0;
    for(var _iterator = _createForOfIteratorHelperLoose(reverseUnits.slice(1)), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        if (vals[unit]) sum += vals[unit] * matrix[unit]["milliseconds"];
    }
    return sum;
}
// NB: mutates parameters
function normalizeValues(matrix, vals) {
    // the logic below assumes the overall value of the duration is positive
    // if this is not the case, factor is used to make it so
    var factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;
    orderedUnits$1.reduceRight(function(previous, current) {
        if (!isUndefined(vals[current])) {
            if (previous) {
                var previousVal = vals[previous] * factor;
                var conv = matrix[current][previous];
                // if (previousVal < 0):
                // lower order unit is negative (e.g. { years: 2, days: -2 })
                // normalize this by reducing the higher order unit by the appropriate amount
                // and increasing the lower order unit
                // this can never make the higher order unit negative, because this function only operates
                // on positive durations, so the amount of time represented by the lower order unit cannot
                // be larger than the higher order unit
                // else:
                // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
                // in this case we attempt to convert as much as possible from the lower order unit into
                // the higher order one
                //
                // Math.floor takes care of both of these cases, rounding away from 0
                // if previousVal < 0 it makes the absolute value larger
                // if previousVal >= it makes the absolute value smaller
                var rollUp = Math.floor(previousVal / conv);
                vals[current] += rollUp * factor;
                vals[previous] -= rollUp * conv * factor;
            }
            return current;
        } else return previous;
    }, null);
    // try to convert any decimals into smaller units if possible
    // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
    orderedUnits$1.reduce(function(previous, current) {
        if (!isUndefined(vals[current])) {
            if (previous) {
                var fraction = vals[previous] % 1;
                vals[previous] -= fraction;
                vals[current] += fraction * matrix[previous][current];
            }
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function removeZeroes(vals) {
    var newVals = {};
    for(var _i = 0, _Object$entries = Object.entries(vals); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value !== 0) newVals[key] = value;
    }
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var Duration = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        var matrix = accurate ? accurateMatrix : casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    };
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: normalizeObject(obj, Duration.normalizeUnit),
            loc: Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    };
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if (isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    };
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
        if (Settings.throwOnInvalid) throw new InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    };
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new InvalidUnitError(unit);
        return normalized;
    };
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    };
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = _extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID$2;
    };
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        if (!this.isValid) return INVALID$2;
        var showZeros = opts.showZeros !== false;
        var l = orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if (isUndefined(val) || val === 0 && !showZeros) return null;
            return _this.loc.numberFormatter(_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter(_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    };
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return _extends({}, this.values);
    };
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = _extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts, {
            includeOffset: false
        });
        var dateTime = DateTime.fromMillis(millis, {
            zone: "UTC"
        });
        return dateTime.toISOTime(opts);
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toString = function toString() {
        return this.toISO();
    };
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Duration { values: " + JSON.stringify(this.values) + " }";
        else return "Duration { Invalid, reason: " + this.invalidReason + " }";
    };
    _proto.toMillis = function toMillis() {
        if (!this.isValid) return NaN;
        return durationToMillis(this.matrix, this.values);
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _i2 = 0, _orderedUnits = orderedUnits$1; _i2 < _orderedUnits.length; _i2++){
            var k = _orderedUnits[_i2];
            if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return clone$1(this, {
            values: result
        }, true);
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    };
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++){
            var k = _Object$keys[_i3];
            result[k] = asNumber(fn(this.values[k], k));
        }
        return clone$1(this, {
            values: result
        }, true);
    };
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = _extends({}, this.values, normalizeObject(values, Duration.normalizeUnit));
        return clone$1(this, {
            values: mixed
        });
    };
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy, matrix = _ref.matrix;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        var opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return clone$1(this, opts);
    };
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    };
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        normalizeValues(this.matrix, vals);
        return clone$1(this, {
            values: vals
        }, true);
    };
    _proto.rescale = function rescale() {
        if (!this.isValid) return this;
        var vals = removeZeroes(this.normalize().shiftToAll().toObject());
        return clone$1(this, {
            values: vals
        }, true);
    };
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _i4 = 0, _orderedUnits2 = orderedUnits$1; _i4 < _orderedUnits2.length; _i4++){
            var k = _orderedUnits2[_i4];
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if (isNumber(vals[k])) own += vals[k];
                // only keep the integer part for now in the hopes of putting any decimal part
                // into a smaller unit later
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
            // otherwise, keep it in the wings to boil it later
            } else if (isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        normalizeValues(this.matrix, built);
        return clone$1(this, {
            values: built
        }, true);
    };
    _proto.shiftToAll = function shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    };
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i5 = 0, _Object$keys2 = Object.keys(this.values); _i5 < _Object$keys2.length; _i5++){
            var k = _Object$keys2[_i5];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return clone$1(this, {
            values: negated
        }, true);
    };
    _proto.removeZeros = function removeZeros() {
        if (!this.isValid) return this;
        var vals = removeZeroes(this.values);
        return clone$1(this, {
            values: vals
        }, true);
    };
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _i6 = 0, _orderedUnits3 = orderedUnits$1; _i6 < _orderedUnits3.length; _i6++){
            var u = _orderedUnits3[_i6];
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    _createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}(Symbol.for("nodejs.util.inspect.custom"));
var INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function validateStartEnd(start, end) {
    if (!start || !start.isValid) return Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return Interval.invalid("missing or invalid end");
    else if (end < start) return Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var Interval = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
        if (Settings.throwOnInvalid) throw new InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    };
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = friendlyDateTime(start), builtEnd = friendlyDateTime(end);
        var validateError = validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    };
    Interval.after = function after(start, duration) {
        var dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    };
    Interval.before = function before(end, duration) {
        var dur = Duration.fromDurationLike(duration), dt = friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    };
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    };
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    };
    _proto.count = function count(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit, opts);
        var end;
        if (opts != null && opts.useLocaleWeeks) end = this.end.reconfigure({
            locale: start.locale
        });
        else end = this.end;
        end = end.startOf(unit, opts);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    };
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    };
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    };
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    };
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    };
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    };
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    };
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map(friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(function(a, b) {
            return a.toMillis() - b.toMillis();
        }), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    };
    _proto.splitBy = function splitBy(duration) {
        var dur = Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    };
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    };
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    };
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    };
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    };
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    };
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    };
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    };
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    };
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    };
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = _createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    };
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    };
    _proto.toString = function toString() {
        if (!this.isValid) return INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    };
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Interval { start: " + this.s.toISO() + ", end: " + this.e.toISO() + " }";
        else return "Interval { Invalid, reason: " + this.invalidReason + " }";
    };
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID$1;
    };
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    };
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    };
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    };
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    };
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    _createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "lastDateTime",
            get: function get() {
                return this.isValid ? this.e ? this.e.minus(1) : null : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}(Symbol.for("nodejs.util.inspect.custom"));
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = Settings.defaultZone;
        var proto = DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    };
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return IANAZone.isValidZone(zone);
    };
    Info.normalizeZone = function normalizeZone$1(input) {
        return normalizeZone(input, Settings.defaultZone);
    };
    Info.getStartOfWeek = function getStartOfWeek(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj;
        return (locObj || Locale.create(locale)).getStartOfWeek();
    };
    Info.getMinimumDaysInFirstWeek = function getMinimumDaysInFirstWeek(_temp2) {
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj;
        return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
    };
    Info.getWeekendWeekdays = function getWeekendWeekdays(_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        // copy the array, because we cache it internally
        return (locObj || Locale.create(locale)).getWeekendDays().slice();
    };
    Info.months = function months(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj, _ref4$outputCalendar = _ref4.outputCalendar, outputCalendar = _ref4$outputCalendar === void 0 ? "gregory" : _ref4$outputCalendar;
        return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    };
    Info.monthsFormat = function monthsFormat(length, _temp5) {
        if (length === void 0) length = "long";
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale, _ref5$numberingSystem = _ref5.numberingSystem, numberingSystem = _ref5$numberingSystem === void 0 ? null : _ref5$numberingSystem, _ref5$locObj = _ref5.locObj, locObj = _ref5$locObj === void 0 ? null : _ref5$locObj, _ref5$outputCalendar = _ref5.outputCalendar, outputCalendar = _ref5$outputCalendar === void 0 ? "gregory" : _ref5$outputCalendar;
        return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    };
    Info.weekdays = function weekdays(length, _temp6) {
        if (length === void 0) length = "long";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale, _ref6$numberingSystem = _ref6.numberingSystem, numberingSystem = _ref6$numberingSystem === void 0 ? null : _ref6$numberingSystem, _ref6$locObj = _ref6.locObj, locObj = _ref6$locObj === void 0 ? null : _ref6$locObj;
        return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
    };
    Info.weekdaysFormat = function weekdaysFormat(length, _temp7) {
        if (length === void 0) length = "long";
        var _ref7 = _temp7 === void 0 ? {} : _temp7, _ref7$locale = _ref7.locale, locale = _ref7$locale === void 0 ? null : _ref7$locale, _ref7$numberingSystem = _ref7.numberingSystem, numberingSystem = _ref7$numberingSystem === void 0 ? null : _ref7$numberingSystem, _ref7$locObj = _ref7.locObj, locObj = _ref7$locObj === void 0 ? null : _ref7$locObj;
        return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    };
    Info.meridiems = function meridiems(_temp8) {
        var _ref8 = _temp8 === void 0 ? {} : _temp8, _ref8$locale = _ref8.locale, locale = _ref8$locale === void 0 ? null : _ref8$locale;
        return Locale.create(locale).meridiems();
    };
    Info.eras = function eras(length, _temp9) {
        if (length === void 0) length = "short";
        var _ref9 = _temp9 === void 0 ? {} : _temp9, _ref9$locale = _ref9.locale, locale = _ref9$locale === void 0 ? null : _ref9$locale;
        return Locale.create(locale, null, "gregory").eras(length);
    };
    Info.features = function features() {
        return {
            relative: hasRelative(),
            localeWeek: hasLocaleWeekInfo()
        };
    };
    return Info;
}();
function dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor(Duration.fromMillis(ms).as("days"));
}
function highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter + (b.year - a.year) * 4;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            dayDiff
        ]
    ];
    var results = {};
    var earlier = cursor;
    var lowestOrder, highWater;
    /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */ for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            lowestOrder = unit;
            results[unit] = differ(cursor, later);
            highWater = earlier.plus(results);
            if (highWater > later) {
                // we overshot the end point, backtrack cursor by 1
                results[unit]--;
                cursor = earlier.plus(results);
                // if we are still overshooting now, we need to backtrack again
                // this happens in certain situations when diffing times in different zones,
                // because this calculation ignores time zones
                if (cursor > later) {
                    // keep the "overshot by 1" around as highWater
                    highWater = cursor;
                    // backtrack cursor by 1
                    results[unit]--;
                    cursor = earlier.plus(results);
                }
            } else cursor = highWater;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function _diff(earlier, later, units, opts) {
    var _highOrderDiffs = highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus;
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[lowestOrder] = 1, _cursor$plus));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post(parseDigits(s));
        }
    };
}
var NBSP = String.fromCharCode(160);
var spaceOrNBSP = "[ " + NBSP + "]";
var spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
function stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace(spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map(fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return stripInsensitivities(s) === stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return signedOffset(h, m);
        },
        groups: groups
    };
}
function simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
/**
 * @param token
 * @param {Locale} loc
 */ function unitForToken(token, loc) {
    var one = digitRegex(loc), two = digitRegex(loc, "{2}"), three = digitRegex(loc, "{3}"), four = digitRegex(loc, "{4}"), six = digitRegex(loc, "{6}"), oneOrTwo = digitRegex(loc, "{1,2}"), oneToThree = digitRegex(loc, "{1,3}"), oneToSix = digitRegex(loc, "{1,6}"), oneToNine = digitRegex(loc, "{1,9}"), twoToFour = digitRegex(loc, "{2,4}"), fourToSix = digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp(escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return oneOf(loc.eras("short"), 0);
            case "GG":
                return oneOf(loc.eras("long"), 0);
            // years
            case "y":
                return intUnit(oneToSix);
            case "yy":
                return intUnit(twoToFour, untruncateYear);
            case "yyyy":
                return intUnit(four);
            case "yyyyy":
                return intUnit(fourToSix);
            case "yyyyyy":
                return intUnit(six);
            // months
            case "M":
                return intUnit(oneOrTwo);
            case "MM":
                return intUnit(two);
            case "MMM":
                return oneOf(loc.months("short", true), 1);
            case "MMMM":
                return oneOf(loc.months("long", true), 1);
            case "L":
                return intUnit(oneOrTwo);
            case "LL":
                return intUnit(two);
            case "LLL":
                return oneOf(loc.months("short", false), 1);
            case "LLLL":
                return oneOf(loc.months("long", false), 1);
            // dates
            case "d":
                return intUnit(oneOrTwo);
            case "dd":
                return intUnit(two);
            // ordinals
            case "o":
                return intUnit(oneToThree);
            case "ooo":
                return intUnit(three);
            // time
            case "HH":
                return intUnit(two);
            case "H":
                return intUnit(oneOrTwo);
            case "hh":
                return intUnit(two);
            case "h":
                return intUnit(oneOrTwo);
            case "mm":
                return intUnit(two);
            case "m":
                return intUnit(oneOrTwo);
            case "q":
                return intUnit(oneOrTwo);
            case "qq":
                return intUnit(two);
            case "s":
                return intUnit(oneOrTwo);
            case "ss":
                return intUnit(two);
            case "S":
                return intUnit(oneToThree);
            case "SSS":
                return intUnit(three);
            case "u":
                return simple(oneToNine);
            case "uu":
                return simple(oneOrTwo);
            case "uuu":
                return intUnit(one);
            // meridiem
            case "a":
                return oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return intUnit(four);
            case "kk":
                return intUnit(twoToFour, untruncateYear);
            // weekNumber (W)
            case "W":
                return intUnit(oneOrTwo);
            case "WW":
                return intUnit(two);
            // weekdays
            case "E":
            case "c":
                return intUnit(one);
            case "EEE":
                return oneOf(loc.weekdays("short", false), 1);
            case "EEEE":
                return oneOf(loc.weekdays("long", false), 1);
            case "ccc":
                return oneOf(loc.weekdays("short", true), 1);
            case "cccc":
                return oneOf(loc.weekdays("long", true), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour12: {
        numeric: "h",
        "2-digit": "hh"
    },
    hour24: {
        numeric: "H",
        "2-digit": "HH"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function tokenForPart(part, formatOpts, resolvedOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") {
        var isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    var style = formatOpts[type];
    // The user might have explicitly specified hour12 or hourCycle
    // if so, respect their decision
    // if not, refer back to the resolvedOpts, which are based on the locale
    var actualType = type;
    if (type === "hour") {
        if (formatOpts.hour12 != null) actualType = formatOpts.hour12 ? "hour12" : "hour24";
        else if (formatOpts.hourCycle != null) {
            if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") actualType = "hour12";
            else actualType = "hour24";
        } else // tokens only differentiate between 24 hours or not,
        // so we do not need to check hourCycle here, which is less supported anyways
        actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
    var val = partTypeStyleToTokenVal[actualType];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if (hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!isUndefined(matches.z)) zone = IANAZone.create(matches.z);
    if (!isUndefined(matches.Z)) {
        if (!zone) zone = new FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!isUndefined(matches.u)) matches.S = parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var dummyDateTimeCache = null;
function getDummyDateTime() {
    if (!dummyDateTimeCache) dummyDateTimeCache = DateTime.fromMillis(1555555555555);
    return dummyDateTimeCache;
}
function maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = Formatter.macroTokenToFormatOpts(token.val);
    var tokens = formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ var TokenParser = /*#__PURE__*/ function() {
    function TokenParser(locale, format) {
        this.locale = locale;
        this.format = format;
        this.tokens = expandMacroTokens(Formatter.parseFormat(format), locale);
        this.units = this.tokens.map(function(t) {
            return unitForToken(t, locale);
        });
        this.disqualifyingUnit = this.units.find(function(t) {
            return t.invalidReason;
        });
        if (!this.disqualifyingUnit) {
            var _buildRegex = buildRegex(this.units), regexString = _buildRegex[0], handlers = _buildRegex[1];
            this.regex = RegExp(regexString, "i");
            this.handlers = handlers;
        }
    }
    var _proto = TokenParser.prototype;
    _proto.explainFromTokens = function explainFromTokens(input) {
        if (!this.isValid) return {
            input: input,
            tokens: this.tokens,
            invalidReason: this.invalidReason
        };
        else {
            var _match = match(input, this.regex, this.handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? dateTimeFromMatches(matches) : [
                null,
                null,
                undefined
            ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
            if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) throw new ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
            return {
                input: input,
                tokens: this.tokens,
                regex: this.regex,
                rawMatches: rawMatches,
                matches: matches,
                result: result,
                zone: zone,
                specificOffset: specificOffset
            };
        }
    };
    _createClass(TokenParser, [
        {
            key: "isValid",
            get: function get() {
                return !this.disqualifyingUnit;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
            }
        }
    ]);
    return TokenParser;
}();
function explainFromTokens(locale, input, format) {
    var parser = new TokenParser(locale, format);
    return parser.explainFromTokens(input);
}
function parseFromTokens(locale, input, format) {
    var _explainFromTokens = explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    var formatter = Formatter.create(locale, formatOpts);
    var df = formatter.dtFormatter(getDummyDateTime());
    var parts = df.formatToParts();
    var resolvedOpts = df.resolvedOptions();
    return parts.map(function(p) {
        return tokenForPart(p, formatOpts, resolvedOpts);
    });
}
var INVALID = "Invalid DateTime";
var MAX_DATE = 8.64e15;
function unsupportedZone(zone) {
    return new Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
}
// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */ function possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = gregorianToWeek(dt.c);
    return dt.weekData;
}
/**
 * @param {DateTime} dt
 */ function possiblyCachedLocalWeekData(dt) {
    if (dt.localWeekData === null) dt.localWeekData = gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
    return dt.localWeekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new DateTime(_extends({}, current, alts, {
        old: current
    }));
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function objToTS(obj, offset, zone) {
    return fixOffset(objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = _extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = objToLocalTS(c);
    var _fixOffset = fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        var interpretationZone = parsedZone || zone, inst = DateTime.fromObject(parsed, _extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return DateTime.invalid(new Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? Formatter.create(Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function _toISODate(o, extended, precision) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += padStart(o.c.year, longFormat ? 6 : 4);
    if (precision === "year") return c;
    if (extended) {
        c += "-";
        c += padStart(o.c.month);
        if (precision === "month") return c;
        c += "-";
    } else {
        c += padStart(o.c.month);
        if (precision === "month") return c;
    }
    c += padStart(o.c.day);
    return c;
}
function _toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision) {
    var showSeconds = !suppressSeconds || o.c.millisecond !== 0 || o.c.second !== 0, c = "";
    switch(precision){
        case "day":
        case "month":
        case "year":
            break;
        default:
            c += padStart(o.c.hour);
            if (precision === "hour") break;
            if (extended) {
                c += ":";
                c += padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) {
                    c += ":";
                    c += padStart(o.c.second);
                }
            } else {
                c += padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) c += padStart(o.c.second);
            }
            if (precision === "second") break;
            if (showSeconds && (!suppressMilliseconds || o.c.millisecond !== 0)) {
                c += ".";
                c += padStart(o.c.millisecond, 3);
            }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += padStart(Math.trunc(o.o / 60));
            c += ":";
            c += padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
var defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
var orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
}
function normalizeUnitWithLocalWeeks(unit) {
    switch(unit.toLowerCase()){
        case "localweekday":
        case "localweekdays":
            return "localWeekday";
        case "localweeknumber":
        case "localweeknumbers":
            return "localWeekNumber";
        case "localweekyear":
        case "localweekyears":
            return "localWeekYear";
        default:
            return normalizeUnit(unit);
    }
}
// cache offsets for zones based on the current timestamp when this function is
// first called. When we are handling a datetime from components like (year,
// month, day, hour) in a time zone, we need a guess about what the timezone
// offset is so that we can convert into a UTC timestamp. One way is to find the
// offset of now in the zone. The actual date may have a different offset (for
// example, if we handle a date in June while we're in December in a zone that
// observes DST), but we can check and adjust that.
//
// When handling many dates, calculating the offset for now every time is
// expensive. It's just a guess, so we can cache the offset to use even if we
// are right on a time change boundary (we'll just correct in the other
// direction). Using a timestamp from first read is a slight optimization for
// handling dates close to the current date, since those dates will usually be
// in the same offset (we could set the timestamp statically, instead). We use a
// single timestamp for all zones to make things a bit more predictable.
//
// This is safe for quickDT (used by local() and utc()) because we don't fill in
// higher-order units from tsNow (as we do in fromObject, this requires that
// offset is calculated from tsNow).
/**
 * @param {Zone} zone
 * @return {number}
 */ function guessOffsetForZone(zone) {
    if (zoneOffsetTs === undefined) zoneOffsetTs = Settings.now();
    // Do not cache anything but IANA zones, because it is not safe to do so.
    // Guessing an offset which is not present in the zone can cause wrong results from fixOffset
    if (zone.type !== "iana") return zone.offset(zoneOffsetTs);
    var zoneName = zone.name;
    var offsetGuess = zoneOffsetGuessCache.get(zoneName);
    if (offsetGuess === undefined) {
        offsetGuess = zone.offset(zoneOffsetTs);
        zoneOffsetGuessCache.set(zoneName, offsetGuess);
    }
    return offsetGuess;
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function quickDT(obj, opts) {
    var zone = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zone.isValid) return DateTime.invalid(unsupportedZone(zone));
    var loc = Locale.fromObject(opts);
    var ts, o;
    // assume we have the higher-order units
    if (!isUndefined(obj.year)) {
        for(var _i = 0, _orderedUnits = orderedUnits; _i < _orderedUnits.length; _i++){
            var u = _orderedUnits[_i];
            if (isUndefined(obj[u])) obj[u] = defaultUnitValues[u];
        }
        var invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
        if (invalid) return DateTime.invalid(invalid);
        var offsetProvis = guessOffsetForZone(zone);
        var _objToTS = objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = Settings.now();
    return new DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function diffRelative(start, end, opts) {
    var round = isUndefined(opts.round) ? true : opts.round, rounding = isUndefined(opts.rounding) ? "trunc" : opts.rounding, format = function format(c, unit) {
        c = roundTo(c, round || opts.calendary ? 0 : 2, opts.calendary ? "round" : rounding);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator = _createForOfIteratorHelperLoose(opts.units), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * Timestamp to use for cached zone offset guesses (exposed for test)
 */ var zoneOffsetTs;
/**
 * Cache for zone offset guesses (exposed for test).
 *
 * This optimizes quickDT via guessOffsetForZone to avoid repeated calls of
 * zone.offset().
 */ var zoneOffsetGuessCache = new Map();
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var DateTime = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                // If an offset has been passed and we have not been called from
                // clone(), we can trust it and avoid the offset calculation.
                var ot = isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
                c = tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.localWeekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    };
    DateTime.local = function local() {
        var _lastOpts = lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.utc = function utc() {
        var _lastOpts2 = lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = FixedOffsetZone.utcInstance;
        return quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid(unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: Locale.fromObject(options)
        });
    };
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!isNumber(milliseconds)) throw new InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) // this isn't perfect because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: normalizeZone(options.zone, Settings.defaultZone),
            loc: Locale.fromObject(options)
        });
    };
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!isNumber(seconds)) throw new InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: normalizeZone(options.zone, Settings.defaultZone),
            loc: Locale.fromObject(options)
        });
    };
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid(unsupportedZone(zoneToUse));
        var loc = Locale.fromObject(opts);
        var normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues = usesLocalWeekValues(normalized, loc), minDaysInFirstWeek = _usesLocalWeekValues.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues.startOfWeek;
        var tsNow = Settings.now(), offsetProvis = !isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = orderedWeekUnits;
            defaultValues = defaultWeekUnitValues;
            objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
        } else if (containsOrdinal) {
            units = orderedOrdinalUnits;
            defaultValues = defaultOrdinalUnitValues;
            objNow = gregorianToOrdinal(objNow);
        } else {
            units = orderedUnits;
            defaultValues = defaultUnitValues;
        }
        // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator2 = _createForOfIteratorHelperLoose(units), _step2; !(_step2 = _iterator2()).done;){
            var u = _step2.value;
            var v = normalized[u];
            if (!isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
        // compute the actual time
        var gregorian = useWeekData ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? ordinalToGregorian(normalized) : normalized, _objToTS2 = objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        if (!inst.isValid) return DateTime.invalid(inst.invalid);
        return inst;
    };
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    };
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    };
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    };
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if (isUndefined(text) || isUndefined(fmt)) throw new InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    };
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    };
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    };
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
        if (Settings.throwOnInvalid) throw new InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    };
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    };
    DateTime.parseFormatForOpts = function parseFormatForOpts(formatOpts, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map(function(t) {
            return t ? t.val : null;
        }).join("");
    };
    DateTime.expandFormat = function expandFormat(fmt, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
        return expanded.map(function(t) {
            return t.val;
        }).join("");
    };
    DateTime.resetCache = function resetCache() {
        zoneOffsetTs = undefined;
        zoneOffsetGuessCache.clear();
    };
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    };
    /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */ _proto.getPossibleOffsets = function getPossibleOffsets() {
        if (!this.isValid || this.isOffsetFixed) return [
            this
        ];
        var dayMs = 86400000;
        var minuteMs = 60000;
        var localTS = objToLocalTS(this.c);
        var oEarlier = this.zone.offset(localTS - dayMs);
        var oLater = this.zone.offset(localTS + dayMs);
        var o1 = this.zone.offset(localTS - oEarlier * minuteMs);
        var o2 = this.zone.offset(localTS - oLater * minuteMs);
        if (o1 === o2) return [
            this
        ];
        var ts1 = localTS - o1 * minuteMs;
        var ts2 = localTS - o2 * minuteMs;
        var c1 = tsToObj(ts1, o1);
        var c2 = tsToObj(ts2, o2);
        if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) return [
            clone(this, {
                ts: ts1
            }),
            clone(this, {
                ts: ts2
            })
        ];
        return [
            this
        ];
    };
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    };
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone(FixedOffsetZone.instance(offset), opts);
    };
    _proto.toLocal = function toLocal() {
        return this.setZone(Settings.defaultZone);
    };
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = normalizeZone(zone, Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid(unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    };
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return clone(this, {
            loc: loc
        });
    };
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = normalizeObject(values, normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues2 = usesLocalWeekValues(normalized, this.loc), minDaysInFirstWeek = _usesLocalWeekValues2.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues2.startOfWeek;
        var settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday), containsOrdinal = !isUndefined(normalized.ordinal), containsGregorYear = !isUndefined(normalized.year), containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = weekToGregorian(_extends({}, gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), normalized), minDaysInFirstWeek, startOfWeek);
        else if (!isUndefined(normalized.ordinal)) mixed = ordinalToGregorian(_extends({}, gregorianToOrdinal(this.c), normalized));
        else {
            mixed = _extends({}, this.toObject(), normalized);
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if (isUndefined(normalized.day)) mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return clone(this, {
            ts: ts,
            o: o
        });
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return clone(this, adjustTime(this, dur));
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration).negate();
        return clone(this, adjustTime(this, dur));
    };
    _proto.startOf = function startOf(unit, _temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$useLocaleWeeks = _ref4.useLocaleWeeks, useLocaleWeeks = _ref4$useLocaleWeeks === void 0 ? false : _ref4$useLocaleWeeks;
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") {
            if (useLocaleWeeks) {
                var startOfWeek = this.loc.getStartOfWeek();
                var weekday = this.weekday;
                if (weekday < startOfWeek) o.weekNumber = this.weekNumber - 1;
                o.weekday = startOfWeek;
            } else o.weekday = 1;
        }
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    };
    _proto.endOf = function endOf(unit, opts) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit, opts).minus(1) : this;
    };
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID;
    };
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID;
    };
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    };
    _proto.toISO = function toISO(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format, _ref5$suppressSeconds = _ref5.suppressSeconds, suppressSeconds = _ref5$suppressSeconds === void 0 ? false : _ref5$suppressSeconds, _ref5$suppressMillise = _ref5.suppressMilliseconds, suppressMilliseconds = _ref5$suppressMillise === void 0 ? false : _ref5$suppressMillise, _ref5$includeOffset = _ref5.includeOffset, includeOffset = _ref5$includeOffset === void 0 ? true : _ref5$includeOffset, _ref5$extendedZone = _ref5.extendedZone, extendedZone = _ref5$extendedZone === void 0 ? false : _ref5$extendedZone, _ref5$precision = _ref5.precision, precision = _ref5$precision === void 0 ? "milliseconds" : _ref5$precision;
        if (!this.isValid) return null;
        precision = normalizeUnit(precision);
        var ext = format === "extended";
        var c = _toISODate(this, ext, precision);
        if (orderedUnits.indexOf(precision) >= 3) c += "T";
        c += _toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
        return c;
    };
    _proto.toISODate = function toISODate(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format, _ref6$precision = _ref6.precision, precision = _ref6$precision === void 0 ? "day" : _ref6$precision;
        if (!this.isValid) return null;
        return _toISODate(this, format === "extended", normalizeUnit(precision));
    };
    _proto.toISOWeekDate = function toISOWeekDate() {
        return toTechFormat(this, "kkkk-'W'WW-c");
    };
    _proto.toISOTime = function toISOTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$suppressMillise = _ref7.suppressMilliseconds, suppressMilliseconds = _ref7$suppressMillise === void 0 ? false : _ref7$suppressMillise, _ref7$suppressSeconds = _ref7.suppressSeconds, suppressSeconds = _ref7$suppressSeconds === void 0 ? false : _ref7$suppressSeconds, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includePrefix = _ref7.includePrefix, includePrefix = _ref7$includePrefix === void 0 ? false : _ref7$includePrefix, _ref7$extendedZone = _ref7.extendedZone, extendedZone = _ref7$extendedZone === void 0 ? false : _ref7$extendedZone, _ref7$format = _ref7.format, format = _ref7$format === void 0 ? "extended" : _ref7$format, _ref7$precision = _ref7.precision, precision = _ref7$precision === void 0 ? "milliseconds" : _ref7$precision;
        if (!this.isValid) return null;
        precision = normalizeUnit(precision);
        var c = includePrefix && orderedUnits.indexOf(precision) >= 3 ? "T" : "";
        return c + _toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
    };
    _proto.toRFC2822 = function toRFC2822() {
        return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    };
    _proto.toHTTP = function toHTTP() {
        return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    };
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return _toISODate(this, true);
    };
    _proto.toSQLTime = function toSQLTime(_temp7) {
        var _ref8 = _temp7 === void 0 ? {} : _temp7, _ref8$includeOffset = _ref8.includeOffset, includeOffset = _ref8$includeOffset === void 0 ? true : _ref8$includeOffset, _ref8$includeZone = _ref8.includeZone, includeZone = _ref8$includeZone === void 0 ? false : _ref8$includeZone, _ref8$includeOffsetSp = _ref8.includeOffsetSpace, includeOffsetSpace = _ref8$includeOffsetSp === void 0 ? true : _ref8$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return toTechFormat(this, fmt, true);
    };
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    };
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : INVALID;
    };
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "DateTime { ts: " + this.toISO() + ", zone: " + this.zone.name + ", locale: " + this.locale + " }";
        else return "DateTime { Invalid, reason: " + this.invalidReason + " }";
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    };
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    };
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    };
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = _extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    };
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    };
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = _extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = maybeArray(unit).map(Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = _diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    };
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    };
    _proto.until = function until(otherDateTime) {
        return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
    };
    _proto.hasSame = function hasSame(otherDateTime, unit, opts) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
    };
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    };
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return diffRelative(base, this.plus(padding), _extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    };
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, _extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    };
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new InvalidArgumentError("min requires all arguments be DateTimes");
        return bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    };
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new InvalidArgumentError("max requires all arguments be DateTimes");
        return bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    };
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return explainFromTokens(localeToUse, text, fmt);
    };
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    };
    DateTime.buildFormatParser = function buildFormatParser(fmt, options) {
        if (options === void 0) options = {};
        var _options2 = options, _options2$locale = _options2.locale, locale = _options2$locale === void 0 ? null : _options2$locale, _options2$numberingSy = _options2.numberingSystem, numberingSystem = _options2$numberingSy === void 0 ? null : _options2$numberingSy, localeToUse = Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return new TokenParser(localeToUse, fmt);
    };
    DateTime.fromFormatParser = function fromFormatParser(text, formatParser, opts) {
        if (opts === void 0) opts = {};
        if (isUndefined(text) || isUndefined(formatParser)) throw new InvalidArgumentError("fromFormatParser requires an input string and a format parser");
        var _opts2 = opts, _opts2$locale = _opts2.locale, locale = _opts2$locale === void 0 ? null : _opts2$locale, _opts2$numberingSyste = _opts2.numberingSystem, numberingSystem = _opts2$numberingSyste === void 0 ? null : _opts2$numberingSyste, localeToUse = Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        if (!localeToUse.equals(formatParser.locale)) throw new InvalidArgumentError("fromFormatParser called with a locale of " + localeToUse + ", " + ("but the format parser was created for " + formatParser.locale));
        var _formatParser$explain = formatParser.explainFromTokens(text), result = _formatParser$explain.result, zone = _formatParser$explain.zone, specificOffset = _formatParser$explain.specificOffset, invalidReason = _formatParser$explain.invalidReason;
        if (invalidReason) return DateTime.invalid(invalidReason);
        else return parseDataToDateTime(result, zone, opts, "format " + formatParser.format, text, specificOffset);
    };
    _createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "isWeekend",
            get: function get() {
                return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
            }
        },
        {
            key: "localWeekday",
            get: function get() {
                return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
            }
        },
        {
            key: "localWeekNumber",
            get: function get() {
                return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "localWeekYear",
            get: function get() {
                return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1,
                    day: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
            }
        },
        {
            key: "weeksInLocalWeekYear",
            get: function get() {
                return this.isValid ? weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}(Symbol.for("nodejs.util.inspect.custom"));
function friendlyDateTime(dateTimeish) {
    if (DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) return DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return DateTime.fromObject(dateTimeish);
    else throw new InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var VERSION = "3.7.2";
exports.DateTime = DateTime;
exports.Duration = Duration;
exports.FixedOffsetZone = FixedOffsetZone;
exports.IANAZone = IANAZone;
exports.Info = Info;
exports.Interval = Interval;
exports.InvalidZone = InvalidZone;
exports.Settings = Settings;
exports.SystemZone = SystemZone;
exports.VERSION = VERSION;
exports.Zone = Zone;

},{}],"lTR78":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isCapacitorApp", ()=>isCapacitorApp);
parcelHelpers.export(exports, "getCapacitorPlatform", ()=>getCapacitorPlatform);
parcelHelpers.export(exports, "getCapacitorHeaders", ()=>getCapacitorHeaders);
var _core = require("@capacitor/core");
const isCapacitorApp = ()=>{
    try {
        return (0, _core.Capacitor).isNativePlatform();
    } catch (error) {
        console.error("Error checking Capacitor platform:", error);
        return false;
    }
};
const getCapacitorPlatform = ()=>{
    try {
        return (0, _core.Capacitor).getPlatform();
    } catch (error) {
        console.error("Error getting Capacitor platform:", error);
        return "web";
    }
};
const getCapacitorHeaders = ()=>{
    return isCapacitorApp() ? {
        "x-client-type": "capacitor"
    } : {};
};

},{"@capacitor/core":"sq5Bf","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"sq5Bf":[function(require,module,exports,__globalThis) {
/*! Capacitor: https://capacitorjs.com/ - MIT License */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/******** END SYSTEM BARS PLUGIN ********/ parcelHelpers.export(exports, "Capacitor", ()=>Capacitor);
parcelHelpers.export(exports, "CapacitorCookies", ()=>CapacitorCookies);
parcelHelpers.export(exports, "CapacitorException", ()=>CapacitorException);
parcelHelpers.export(exports, "CapacitorHttp", ()=>CapacitorHttp);
parcelHelpers.export(exports, "ExceptionCode", ()=>ExceptionCode);
parcelHelpers.export(exports, "SystemBarType", ()=>SystemBarType);
parcelHelpers.export(exports, "SystemBars", ()=>SystemBars);
parcelHelpers.export(exports, "SystemBarsStyle", ()=>SystemBarsStyle);
parcelHelpers.export(exports, "WebPlugin", ()=>WebPlugin);
parcelHelpers.export(exports, "WebView", ()=>WebView);
parcelHelpers.export(exports, "buildRequestInit", ()=>buildRequestInit);
parcelHelpers.export(exports, "registerPlugin", ()=>registerPlugin);
var global = arguments[3];
var ExceptionCode;
(function(ExceptionCode) {
    /**
     * API is not implemented.
     *
     * This usually means the API can't be used because it is not implemented for
     * the current platform.
     */ ExceptionCode["Unimplemented"] = "UNIMPLEMENTED";
    /**
     * API is not available.
     *
     * This means the API can't be used right now because:
     *   - it is currently missing a prerequisite, such as network connectivity
     *   - it requires a particular platform or browser version
     */ ExceptionCode["Unavailable"] = "UNAVAILABLE";
})(ExceptionCode || (ExceptionCode = {}));
class CapacitorException extends Error {
    constructor(message, code, data){
        super(message);
        this.message = message;
        this.code = code;
        this.data = data;
    }
}
const getPlatformId = (win)=>{
    var _a, _b;
    if (win === null || win === void 0 ? void 0 : win.androidBridge) return 'android';
    else if ((_b = (_a = win === null || win === void 0 ? void 0 : win.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.bridge) return 'ios';
    else return 'web';
};
const createCapacitor = (win)=>{
    const capCustomPlatform = win.CapacitorCustomPlatform || null;
    const cap = win.Capacitor || {};
    const Plugins = cap.Plugins = cap.Plugins || {};
    const getPlatform = ()=>{
        return capCustomPlatform !== null ? capCustomPlatform.name : getPlatformId(win);
    };
    const isNativePlatform = ()=>getPlatform() !== 'web';
    const isPluginAvailable = (pluginName)=>{
        const plugin = registeredPlugins.get(pluginName);
        if (plugin === null || plugin === void 0 ? void 0 : plugin.platforms.has(getPlatform())) // JS implementation available for the current platform.
        return true;
        if (getPluginHeader(pluginName)) // Native implementation available.
        return true;
        return false;
    };
    const getPluginHeader = (pluginName)=>{
        var _a;
        return (_a = cap.PluginHeaders) === null || _a === void 0 ? void 0 : _a.find((h)=>h.name === pluginName);
    };
    const handleError = (err)=>win.console.error(err);
    const registeredPlugins = new Map();
    const registerPlugin = (pluginName, jsImplementations = {})=>{
        const registeredPlugin = registeredPlugins.get(pluginName);
        if (registeredPlugin) {
            console.warn(`Capacitor plugin "${pluginName}" already registered. Cannot register plugins twice.`);
            return registeredPlugin.proxy;
        }
        const platform = getPlatform();
        const pluginHeader = getPluginHeader(pluginName);
        let jsImplementation;
        const loadPluginImplementation = async ()=>{
            if (!jsImplementation && platform in jsImplementations) jsImplementation = typeof jsImplementations[platform] === 'function' ? jsImplementation = await jsImplementations[platform]() : jsImplementation = jsImplementations[platform];
            else if (capCustomPlatform !== null && !jsImplementation && 'web' in jsImplementations) jsImplementation = typeof jsImplementations['web'] === 'function' ? jsImplementation = await jsImplementations['web']() : jsImplementation = jsImplementations['web'];
            return jsImplementation;
        };
        const createPluginMethod = (impl, prop)=>{
            var _a, _b;
            if (pluginHeader) {
                const methodHeader = pluginHeader === null || pluginHeader === void 0 ? void 0 : pluginHeader.methods.find((m)=>prop === m.name);
                if (methodHeader) {
                    if (methodHeader.rtype === 'promise') return (options)=>cap.nativePromise(pluginName, prop.toString(), options);
                    else return (options, callback)=>cap.nativeCallback(pluginName, prop.toString(), options, callback);
                } else if (impl) return (_a = impl[prop]) === null || _a === void 0 ? void 0 : _a.bind(impl);
            } else if (impl) return (_b = impl[prop]) === null || _b === void 0 ? void 0 : _b.bind(impl);
            else throw new CapacitorException(`"${pluginName}" plugin is not implemented on ${platform}`, ExceptionCode.Unimplemented);
        };
        const createPluginMethodWrapper = (prop)=>{
            let remove;
            const wrapper = (...args)=>{
                const p = loadPluginImplementation().then((impl)=>{
                    const fn = createPluginMethod(impl, prop);
                    if (fn) {
                        const p = fn(...args);
                        remove = p === null || p === void 0 ? void 0 : p.remove;
                        return p;
                    } else throw new CapacitorException(`"${pluginName}.${prop}()" is not implemented on ${platform}`, ExceptionCode.Unimplemented);
                });
                if (prop === 'addListener') p.remove = async ()=>remove();
                return p;
            };
            // Some flair ✨
            wrapper.toString = ()=>`${prop.toString()}() { [capacitor code] }`;
            Object.defineProperty(wrapper, 'name', {
                value: prop,
                writable: false,
                configurable: false
            });
            return wrapper;
        };
        const addListener = createPluginMethodWrapper('addListener');
        const removeListener = createPluginMethodWrapper('removeListener');
        const addListenerNative = (eventName, callback)=>{
            const call = addListener({
                eventName
            }, callback);
            const remove = async ()=>{
                const callbackId = await call;
                removeListener({
                    eventName,
                    callbackId
                }, callback);
            };
            const p = new Promise((resolve)=>call.then(()=>resolve({
                        remove
                    })));
            p.remove = async ()=>{
                console.warn(`Using addListener() without 'await' is deprecated.`);
                await remove();
            };
            return p;
        };
        const proxy = new Proxy({}, {
            get (_, prop) {
                switch(prop){
                    // https://github.com/facebook/react/issues/20030
                    case '$$typeof':
                        return undefined;
                    case 'toJSON':
                        return ()=>({});
                    case 'addListener':
                        return pluginHeader ? addListenerNative : addListener;
                    case 'removeListener':
                        return removeListener;
                    default:
                        return createPluginMethodWrapper(prop);
                }
            }
        });
        Plugins[pluginName] = proxy;
        registeredPlugins.set(pluginName, {
            name: pluginName,
            proxy,
            platforms: new Set([
                ...Object.keys(jsImplementations),
                ...pluginHeader ? [
                    platform
                ] : []
            ])
        });
        return proxy;
    };
    // Add in convertFileSrc for web, it will already be available in native context
    if (!cap.convertFileSrc) cap.convertFileSrc = (filePath)=>filePath;
    cap.getPlatform = getPlatform;
    cap.handleError = handleError;
    cap.isNativePlatform = isNativePlatform;
    cap.isPluginAvailable = isPluginAvailable;
    cap.registerPlugin = registerPlugin;
    cap.Exception = CapacitorException;
    cap.DEBUG = !!cap.DEBUG;
    cap.isLoggingEnabled = !!cap.isLoggingEnabled;
    return cap;
};
const initCapacitorGlobal = (win)=>win.Capacitor = createCapacitor(win);
const Capacitor = /*#__PURE__*/ initCapacitorGlobal(typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {});
const registerPlugin = Capacitor.registerPlugin;
/**
 * Base class web plugins should extend.
 */ class WebPlugin {
    constructor(){
        this.listeners = {};
        this.retainedEventArguments = {};
        this.windowListeners = {};
    }
    addListener(eventName, listenerFunc) {
        let firstListener = false;
        const listeners = this.listeners[eventName];
        if (!listeners) {
            this.listeners[eventName] = [];
            firstListener = true;
        }
        this.listeners[eventName].push(listenerFunc);
        // If we haven't added a window listener for this event and it requires one,
        // go ahead and add it
        const windowListener = this.windowListeners[eventName];
        if (windowListener && !windowListener.registered) this.addWindowListener(windowListener);
        if (firstListener) this.sendRetainedArgumentsForEvent(eventName);
        const remove = async ()=>this.removeListener(eventName, listenerFunc);
        const p = Promise.resolve({
            remove
        });
        return p;
    }
    async removeAllListeners() {
        this.listeners = {};
        for(const listener in this.windowListeners)this.removeWindowListener(this.windowListeners[listener]);
        this.windowListeners = {};
    }
    notifyListeners(eventName, data, retainUntilConsumed) {
        const listeners = this.listeners[eventName];
        if (!listeners) {
            if (retainUntilConsumed) {
                let args = this.retainedEventArguments[eventName];
                if (!args) args = [];
                args.push(data);
                this.retainedEventArguments[eventName] = args;
            }
            return;
        }
        listeners.forEach((listener)=>listener(data));
    }
    hasListeners(eventName) {
        var _a;
        return !!((_a = this.listeners[eventName]) === null || _a === void 0 ? void 0 : _a.length);
    }
    registerWindowListener(windowEventName, pluginEventName) {
        this.windowListeners[pluginEventName] = {
            registered: false,
            windowEventName,
            pluginEventName,
            handler: (event)=>{
                this.notifyListeners(pluginEventName, event);
            }
        };
    }
    unimplemented(msg = 'not implemented') {
        return new Capacitor.Exception(msg, ExceptionCode.Unimplemented);
    }
    unavailable(msg = 'not available') {
        return new Capacitor.Exception(msg, ExceptionCode.Unavailable);
    }
    async removeListener(eventName, listenerFunc) {
        const listeners = this.listeners[eventName];
        if (!listeners) return;
        const index = listeners.indexOf(listenerFunc);
        this.listeners[eventName].splice(index, 1);
        // If there are no more listeners for this type of event,
        // remove the window listener
        if (!this.listeners[eventName].length) this.removeWindowListener(this.windowListeners[eventName]);
    }
    addWindowListener(handle) {
        window.addEventListener(handle.windowEventName, handle.handler);
        handle.registered = true;
    }
    removeWindowListener(handle) {
        if (!handle) return;
        window.removeEventListener(handle.windowEventName, handle.handler);
        handle.registered = false;
    }
    sendRetainedArgumentsForEvent(eventName) {
        const args = this.retainedEventArguments[eventName];
        if (!args) return;
        delete this.retainedEventArguments[eventName];
        args.forEach((arg)=>{
            this.notifyListeners(eventName, arg);
        });
    }
}
const WebView = /*#__PURE__*/ registerPlugin('WebView');
/******** END WEB VIEW PLUGIN ********/ /******** COOKIES PLUGIN ********/ /**
 * Safely web encode a string value (inspired by js-cookie)
 * @param str The string value to encode
 */ const encode = (str)=>encodeURIComponent(str).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
/**
 * Safely web decode a string value (inspired by js-cookie)
 * @param str The string value to decode
 */ const decode = (str)=>str.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
class CapacitorCookiesPluginWeb extends WebPlugin {
    async getCookies() {
        const cookies = document.cookie;
        const cookieMap = {};
        cookies.split(';').forEach((cookie)=>{
            if (cookie.length <= 0) return;
            // Replace first "=" with CAP_COOKIE to prevent splitting on additional "="
            let [key, value] = cookie.replace(/=/, 'CAP_COOKIE').split('CAP_COOKIE');
            key = decode(key).trim();
            value = decode(value).trim();
            cookieMap[key] = value;
        });
        return cookieMap;
    }
    async setCookie(options) {
        try {
            // Safely Encoded Key/Value
            const encodedKey = encode(options.key);
            const encodedValue = encode(options.value);
            // Clean & sanitize options
            const expires = options.expires ? `; expires=${options.expires.replace('expires=', '')}` : '';
            const path = (options.path || '/').replace('path=', ''); // Default is "path=/"
            const domain = options.url != null && options.url.length > 0 ? `domain=${options.url}` : '';
            document.cookie = `${encodedKey}=${encodedValue || ''}${expires}; path=${path}; ${domain};`;
        } catch (error) {
            return Promise.reject(error);
        }
    }
    async deleteCookie(options) {
        try {
            document.cookie = `${options.key}=; Max-Age=0`;
        } catch (error) {
            return Promise.reject(error);
        }
    }
    async clearCookies() {
        try {
            const cookies = document.cookie.split(';') || [];
            for (const cookie of cookies)document.cookie = cookie.replace(/^ +/, '').replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
        } catch (error) {
            return Promise.reject(error);
        }
    }
    async clearAllCookies() {
        try {
            await this.clearCookies();
        } catch (error) {
            return Promise.reject(error);
        }
    }
}
const CapacitorCookies = registerPlugin('CapacitorCookies', {
    web: ()=>new CapacitorCookiesPluginWeb()
});
// UTILITY FUNCTIONS
/**
 * Read in a Blob value and return it as a base64 string
 * @param blob The blob value to convert to a base64 string
 */ const readBlobAsBase64 = async (blob)=>new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            const base64String = reader.result;
            // remove prefix "data:application/pdf;base64,"
            resolve(base64String.indexOf(',') >= 0 ? base64String.split(',')[1] : base64String);
        };
        reader.onerror = (error)=>reject(error);
        reader.readAsDataURL(blob);
    });
/**
 * Normalize an HttpHeaders map by lowercasing all of the values
 * @param headers The HttpHeaders object to normalize
 */ const normalizeHttpHeaders = (headers = {})=>{
    const originalKeys = Object.keys(headers);
    const loweredKeys = Object.keys(headers).map((k)=>k.toLocaleLowerCase());
    const normalized = loweredKeys.reduce((acc, key, index)=>{
        acc[key] = headers[originalKeys[index]];
        return acc;
    }, {});
    return normalized;
};
/**
 * Builds a string of url parameters that
 * @param params A map of url parameters
 * @param shouldEncode true if you should encodeURIComponent() the values (true by default)
 */ const buildUrlParams = (params, shouldEncode = true)=>{
    if (!params) return null;
    const output = Object.entries(params).reduce((accumulator, entry)=>{
        const [key, value] = entry;
        let encodedValue;
        let item;
        if (Array.isArray(value)) {
            item = '';
            value.forEach((str)=>{
                encodedValue = shouldEncode ? encodeURIComponent(str) : str;
                item += `${key}=${encodedValue}&`;
            });
            // last character will always be "&" so slice it off
            item.slice(0, -1);
        } else {
            encodedValue = shouldEncode ? encodeURIComponent(value) : value;
            item = `${key}=${encodedValue}`;
        }
        return `${accumulator}&${item}`;
    }, '');
    // Remove initial "&" from the reduce
    return output.substr(1);
};
/**
 * Build the RequestInit object based on the options passed into the initial request
 * @param options The Http plugin options
 * @param extra Any extra RequestInit values
 */ const buildRequestInit = (options, extra = {})=>{
    const output = Object.assign({
        method: options.method || 'GET',
        headers: options.headers
    }, extra);
    // Get the content-type
    const headers = normalizeHttpHeaders(options.headers);
    const type = headers['content-type'] || '';
    // If body is already a string, then pass it through as-is.
    if (typeof options.data === 'string') output.body = options.data;
    else if (type.includes('application/x-www-form-urlencoded')) {
        const params = new URLSearchParams();
        for (const [key, value] of Object.entries(options.data || {}))params.set(key, value);
        output.body = params.toString();
    } else if (type.includes('multipart/form-data') || options.data instanceof FormData) {
        const form = new FormData();
        if (options.data instanceof FormData) options.data.forEach((value, key)=>{
            form.append(key, value);
        });
        else for (const key of Object.keys(options.data))form.append(key, options.data[key]);
        output.body = form;
        const headers = new Headers(output.headers);
        headers.delete('content-type'); // content-type will be set by `window.fetch` to includy boundary
        output.headers = headers;
    } else if (type.includes('application/json') || typeof options.data === 'object') output.body = JSON.stringify(options.data);
    return output;
};
// WEB IMPLEMENTATION
class CapacitorHttpPluginWeb extends WebPlugin {
    /**
     * Perform an Http request given a set of options
     * @param options Options to build the HTTP request
     */ async request(options) {
        const requestInit = buildRequestInit(options, options.webFetchExtra);
        const urlParams = buildUrlParams(options.params, options.shouldEncodeUrlParams);
        const url = urlParams ? `${options.url}?${urlParams}` : options.url;
        const response = await fetch(url, requestInit);
        const contentType = response.headers.get('content-type') || '';
        // Default to 'text' responseType so no parsing happens
        let { responseType = 'text' } = response.ok ? options : {};
        // If the response content-type is json, force the response to be json
        if (contentType.includes('application/json')) responseType = 'json';
        let data;
        let blob;
        switch(responseType){
            case 'arraybuffer':
            case 'blob':
                blob = await response.blob();
                data = await readBlobAsBase64(blob);
                break;
            case 'json':
                data = await response.json();
                break;
            case 'document':
            case 'text':
            default:
                data = await response.text();
        }
        // Convert fetch headers to Capacitor HttpHeaders
        const headers = {};
        response.headers.forEach((value, key)=>{
            headers[key] = value;
        });
        return {
            data,
            headers,
            status: response.status,
            url: response.url
        };
    }
    /**
     * Perform an Http GET request given a set of options
     * @param options Options to build the HTTP request
     */ async get(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'GET'
        }));
    }
    /**
     * Perform an Http POST request given a set of options
     * @param options Options to build the HTTP request
     */ async post(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'POST'
        }));
    }
    /**
     * Perform an Http PUT request given a set of options
     * @param options Options to build the HTTP request
     */ async put(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'PUT'
        }));
    }
    /**
     * Perform an Http PATCH request given a set of options
     * @param options Options to build the HTTP request
     */ async patch(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'PATCH'
        }));
    }
    /**
     * Perform an Http DELETE request given a set of options
     * @param options Options to build the HTTP request
     */ async delete(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'DELETE'
        }));
    }
}
const CapacitorHttp = registerPlugin('CapacitorHttp', {
    web: ()=>new CapacitorHttpPluginWeb()
});
/******** END HTTP PLUGIN ********/ /******** SYSTEM BARS PLUGIN ********/ /**
 * Available status bar styles.
 */ var SystemBarsStyle;
(function(SystemBarsStyle) {
    /**
     * Light system bar content on a dark background.
     *
     * @since 8.0.0
     */ SystemBarsStyle["Dark"] = "DARK";
    /**
     * For dark system bar content on a light background.
     *
     * @since 8.0.0
     */ SystemBarsStyle["Light"] = "LIGHT";
    /**
     * The style is based on the device appearance or the underlying content.
     * If the device is using Dark mode, the system bars content will be light.
     * If the device is using Light mode, the system bars content will be dark.
     *
     * @since 8.0.0
     */ SystemBarsStyle["Default"] = "DEFAULT";
})(SystemBarsStyle || (SystemBarsStyle = {}));
/**
 * Available system bar types.
 */ var SystemBarType;
(function(SystemBarType) {
    /**
     * The top status bar on both Android and iOS.
     *
     * @since 8.0.0
     */ SystemBarType["StatusBar"] = "StatusBar";
    /**
     * The navigation bar (or gesture bar on iOS) on both Android and iOS.
     *
     * @since 8.0.0
     */ SystemBarType["NavigationBar"] = "NavigationBar";
})(SystemBarType || (SystemBarType = {}));
class SystemBarsPluginWeb extends WebPlugin {
    async setStyle() {
        this.unavailable('not available for web');
    }
    async setAnimation() {
        this.unavailable('not available for web');
    }
    async show() {
        this.unavailable('not available for web');
    }
    async hide() {
        this.unavailable('not available for web');
    }
}
const SystemBars = registerPlugin('SystemBars', {
    web: ()=>new SystemBarsPluginWeb()
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3LitS":[function() {},{}],"biTVw":[function() {},{}],"41hyj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("./core");
parcelHelpers.exportAll(_core, exports);
var _react = require("./react");
parcelHelpers.exportAll(_react, exports);

},{"./core":"7hF1Q","./react":"cRsMD","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7hF1Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelledError", ()=>(0, _retryer.CancelledError));
parcelHelpers.export(exports, "QueryCache", ()=>(0, _queryCache.QueryCache));
parcelHelpers.export(exports, "QueryClient", ()=>(0, _queryClient.QueryClient));
parcelHelpers.export(exports, "QueryObserver", ()=>(0, _queryObserver.QueryObserver));
parcelHelpers.export(exports, "QueriesObserver", ()=>(0, _queriesObserver.QueriesObserver));
parcelHelpers.export(exports, "InfiniteQueryObserver", ()=>(0, _infiniteQueryObserver.InfiniteQueryObserver));
parcelHelpers.export(exports, "MutationCache", ()=>(0, _mutationCache.MutationCache));
parcelHelpers.export(exports, "MutationObserver", ()=>(0, _mutationObserver.MutationObserver));
parcelHelpers.export(exports, "setLogger", ()=>(0, _logger.setLogger));
parcelHelpers.export(exports, "notifyManager", ()=>(0, _notifyManager.notifyManager));
parcelHelpers.export(exports, "focusManager", ()=>(0, _focusManager.focusManager));
parcelHelpers.export(exports, "onlineManager", ()=>(0, _onlineManager.onlineManager));
parcelHelpers.export(exports, "hashQueryKey", ()=>(0, _utils.hashQueryKey));
parcelHelpers.export(exports, "isError", ()=>(0, _utils.isError));
parcelHelpers.export(exports, "isCancelledError", ()=>(0, _retryer.isCancelledError));
parcelHelpers.export(exports, "dehydrate", ()=>(0, _hydration.dehydrate)) // Types
;
parcelHelpers.export(exports, "hydrate", ()=>(0, _hydration.hydrate));
var _retryer = require("./retryer");
var _queryCache = require("./queryCache");
var _queryClient = require("./queryClient");
var _queryObserver = require("./queryObserver");
var _queriesObserver = require("./queriesObserver");
var _infiniteQueryObserver = require("./infiniteQueryObserver");
var _mutationCache = require("./mutationCache");
var _mutationObserver = require("./mutationObserver");
var _logger = require("./logger");
var _notifyManager = require("./notifyManager");
var _focusManager = require("./focusManager");
var _onlineManager = require("./onlineManager");
var _utils = require("./utils");
var _hydration = require("./hydration");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./retryer":false,"./queryCache":false,"./queryClient":"5mrU0","./queryObserver":"6Qgkq","./queriesObserver":false,"./infiniteQueryObserver":false,"./mutationCache":false,"./mutationObserver":false,"./logger":"9KKlr","./notifyManager":"bDyG0","./focusManager":false,"./onlineManager":false,"./utils":false,"./hydration":false,"./types":"k2xjG","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3SIgf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isCancelable", ()=>isCancelable);
parcelHelpers.export(exports, "CancelledError", ()=>CancelledError);
parcelHelpers.export(exports, "isCancelledError", ()=>isCancelledError) // CLASS
;
parcelHelpers.export(exports, "Retryer", ()=>Retryer);
var _focusManager = require("./focusManager");
var _onlineManager = require("./onlineManager");
var _utils = require("./utils");
function defaultRetryDelay(failureCount) {
    return Math.min(1000 * Math.pow(2, failureCount), 30000);
}
function isCancelable(value) {
    return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var CancelledError = function CancelledError(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
};
function isCancelledError(value) {
    return value instanceof CancelledError;
}
var Retryer = function Retryer(config) {
    var _this = this;
    var cancelRetry = false;
    var cancelFn;
    var continueFn;
    var promiseResolve;
    var promiseReject;
    this.abort = config.abort;
    this.cancel = function(cancelOptions) {
        return cancelFn == null ? void 0 : cancelFn(cancelOptions);
    };
    this.cancelRetry = function() {
        cancelRetry = true;
    };
    this.continueRetry = function() {
        cancelRetry = false;
    };
    this.continue = function() {
        return continueFn == null ? void 0 : continueFn();
    };
    this.failureCount = 0;
    this.isPaused = false;
    this.isResolved = false;
    this.isTransportCancelable = false;
    this.promise = new Promise(function(outerResolve, outerReject) {
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    var resolve = function resolve(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    var reject = function reject(value) {
        if (!_this.isResolved) {
            _this.isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    var pause = function pause() {
        return new Promise(function(continueResolve) {
            continueFn = continueResolve;
            _this.isPaused = true;
            config.onPause == null || config.onPause();
        }).then(function() {
            continueFn = undefined;
            _this.isPaused = false;
            config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    var run = function run() {
        // Do nothing if already resolved
        if (_this.isResolved) return;
        var promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        } // Create callback to cancel this fetch
        cancelFn = function cancelFn(cancelOptions) {
            if (!_this.isResolved) {
                reject(new CancelledError(cancelOptions));
                _this.abort == null || _this.abort(); // Cancel transport if supported
                if (isCancelable(promiseOrValue)) try {
                    promiseOrValue.cancel();
                } catch (_unused) {}
            }
        }; // Check if the transport layer support cancellation
        _this.isTransportCancelable = isCancelable(promiseOrValue);
        Promise.resolve(promiseOrValue).then(resolve).catch(function(error) {
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (_this.isResolved) return;
             // Do we need to retry the request?
            var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
            var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
            var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);
            if (cancelRetry || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            _this.failureCount++; // Notify on fail
            config.onFail == null || config.onFail(_this.failureCount, error); // Delay
            (0, _utils.sleep)(delay) // Pause if the document is not visible or when the device is offline
            .then(function() {
                if (!(0, _focusManager.focusManager).isFocused() || !(0, _onlineManager.onlineManager).isOnline()) return pause();
            }).then(function() {
                if (cancelRetry) reject(error);
                else run();
            });
        });
    }; // Start loop
    run();
};

},{"./focusManager":"2YpB3","./onlineManager":"hapna","./utils":"kvHnH","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2YpB3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusManager", ()=>FocusManager);
parcelHelpers.export(exports, "focusManager", ()=>focusManager);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _subscribable = require("./subscribable");
var _utils = require("./utils");
var FocusManager = /*#__PURE__*/ function(_Subscribable) {
    (0, _inheritsLooseDefault.default)(FocusManager, _Subscribable);
    function FocusManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onFocus) {
            var _window;
            if (!(0, _utils.isServer) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onFocus();
                }; // Listen to visibillitychange and focus
                window.addEventListener('visibilitychange', listener, false);
                window.addEventListener('focus', listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('visibilitychange', listener);
                    window.removeEventListener('focus', listener);
                };
            }
        };
        return _this;
    }
    var _proto = FocusManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(focused) {
            if (typeof focused === 'boolean') _this2.setFocused(focused);
            else _this2.onFocus();
        });
    };
    _proto.setFocused = function setFocused(focused) {
        this.focused = focused;
        if (focused) this.onFocus();
    };
    _proto.onFocus = function onFocus() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isFocused = function isFocused() {
        if (typeof this.focused === 'boolean') return this.focused;
         // document global can be unavailable in react native
        if (typeof document === 'undefined') return true;
        return [
            undefined,
            'visible',
            'prerender'
        ].includes(document.visibilityState);
    };
    return FocusManager;
}((0, _subscribable.Subscribable));
var focusManager = new FocusManager();

},{"@babel/runtime/helpers/esm/inheritsLoose":"kAl3N","./subscribable":"dPDca","./utils":"kvHnH","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kAl3N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"6G96F","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6G96F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"dPDca":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscribable", ()=>Subscribable);
var Subscribable = /*#__PURE__*/ function() {
    function Subscribable() {
        this.listeners = [];
    }
    var _proto = Subscribable.prototype;
    _proto.subscribe = function subscribe(listener) {
        var _this = this;
        var callback = listener || function() {
            return undefined;
        };
        this.listeners.push(callback);
        this.onSubscribe();
        return function() {
            _this.listeners = _this.listeners.filter(function(x) {
                return x !== callback;
            });
            _this.onUnsubscribe();
        };
    };
    _proto.hasListeners = function hasListeners() {
        return this.listeners.length > 0;
    };
    _proto.onSubscribe = function onSubscribe() {};
    _proto.onUnsubscribe = function onUnsubscribe() {};
    return Subscribable;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kvHnH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isServer", ()=>isServer);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "functionalUpdate", ()=>functionalUpdate);
parcelHelpers.export(exports, "isValidTimeout", ()=>isValidTimeout);
parcelHelpers.export(exports, "ensureQueryKeyArray", ()=>ensureQueryKeyArray);
parcelHelpers.export(exports, "difference", ()=>difference);
parcelHelpers.export(exports, "replaceAt", ()=>replaceAt);
parcelHelpers.export(exports, "timeUntilStale", ()=>timeUntilStale);
parcelHelpers.export(exports, "parseQueryArgs", ()=>parseQueryArgs);
parcelHelpers.export(exports, "parseMutationArgs", ()=>parseMutationArgs);
parcelHelpers.export(exports, "parseFilterArgs", ()=>parseFilterArgs);
parcelHelpers.export(exports, "parseMutationFilterArgs", ()=>parseMutationFilterArgs);
parcelHelpers.export(exports, "mapQueryStatusFilter", ()=>mapQueryStatusFilter);
parcelHelpers.export(exports, "matchQuery", ()=>matchQuery);
parcelHelpers.export(exports, "matchMutation", ()=>matchMutation);
parcelHelpers.export(exports, "hashQueryKeyByOptions", ()=>hashQueryKeyByOptions);
/**
 * Default query keys hash function.
 */ parcelHelpers.export(exports, "hashQueryKey", ()=>hashQueryKey);
/**
 * Hashes the value into a stable hash.
 */ parcelHelpers.export(exports, "stableValueHash", ()=>stableValueHash);
/**
 * Checks if key `b` partially matches with key `a`.
 */ parcelHelpers.export(exports, "partialMatchKey", ()=>partialMatchKey);
/**
 * Checks if `b` partially matches with `a`.
 */ parcelHelpers.export(exports, "partialDeepEqual", ()=>partialDeepEqual);
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ parcelHelpers.export(exports, "replaceEqualDeep", ()=>replaceEqualDeep);
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ parcelHelpers.export(exports, "shallowEqualObjects", ()=>shallowEqualObjects) // Copied from: https://github.com/jonschlinkert/is-plain-object
;
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isQueryKey", ()=>isQueryKey);
parcelHelpers.export(exports, "isError", ()=>isError);
parcelHelpers.export(exports, "sleep", ()=>sleep);
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ parcelHelpers.export(exports, "scheduleMicrotask", ()=>scheduleMicrotask);
parcelHelpers.export(exports, "getAbortController", ()=>getAbortController);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var isServer = typeof window === 'undefined';
function noop() {
    return undefined;
}
function functionalUpdate(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
    return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function ensureQueryKeyArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function difference(array1, array2) {
    return array1.filter(function(x) {
        return array2.indexOf(x) === -1;
    });
}
function replaceAt(array, index, value) {
    var copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function timeUntilStale(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
    if (!isQueryKey(arg1)) return arg1;
    if (typeof arg2 === 'function') return (0, _extendsDefault.default)({}, arg3, {
        queryKey: arg1,
        queryFn: arg2
    });
    return (0, _extendsDefault.default)({}, arg2, {
        queryKey: arg1
    });
}
function parseMutationArgs(arg1, arg2, arg3) {
    if (isQueryKey(arg1)) {
        if (typeof arg2 === 'function') return (0, _extendsDefault.default)({}, arg3, {
            mutationKey: arg1,
            mutationFn: arg2
        });
        return (0, _extendsDefault.default)({}, arg2, {
            mutationKey: arg1
        });
    }
    if (typeof arg1 === 'function') return (0, _extendsDefault.default)({}, arg2, {
        mutationFn: arg1
    });
    return (0, _extendsDefault.default)({}, arg1);
}
function parseFilterArgs(arg1, arg2, arg3) {
    return isQueryKey(arg1) ? [
        (0, _extendsDefault.default)({}, arg2, {
            queryKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function parseMutationFilterArgs(arg1, arg2) {
    return isQueryKey(arg1) ? (0, _extendsDefault.default)({}, arg2, {
        mutationKey: arg1
    }) : arg1;
}
function mapQueryStatusFilter(active, inactive) {
    if (active === true && inactive === true || active == null && inactive == null) return 'all';
    else if (active === false && inactive === false) return 'none';
    else {
        // At this point, active|inactive can only be true|false or false|true
        // so, when only one value is provided, the missing one has to be the negated value
        var isActive = active != null ? active : !inactive;
        return isActive ? 'active' : 'inactive';
    }
}
function matchQuery(filters, query) {
    var active = filters.active, exact = filters.exact, fetching = filters.fetching, inactive = filters.inactive, predicate = filters.predicate, queryKey = filters.queryKey, stale = filters.stale;
    if (isQueryKey(queryKey)) {
        if (exact) {
            if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) return false;
        } else if (!partialMatchKey(query.queryKey, queryKey)) return false;
    }
    var queryStatusFilter = mapQueryStatusFilter(active, inactive);
    if (queryStatusFilter === 'none') return false;
    else if (queryStatusFilter !== 'all') {
        var isActive = query.isActive();
        if (queryStatusFilter === 'active' && !isActive) return false;
        if (queryStatusFilter === 'inactive' && isActive) return false;
    }
    if (typeof stale === 'boolean' && query.isStale() !== stale) return false;
    if (typeof fetching === 'boolean' && query.isFetching() !== fetching) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function matchMutation(filters, mutation) {
    var exact = filters.exact, fetching = filters.fetching, predicate = filters.predicate, mutationKey = filters.mutationKey;
    if (isQueryKey(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) return false;
        } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function hashQueryKeyByOptions(queryKey, options) {
    var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
    return hashFn(queryKey);
}
function hashQueryKey(queryKey) {
    var asArray = ensureQueryKeyArray(queryKey);
    return stableValueHash(asArray);
}
function stableValueHash(value) {
    return JSON.stringify(value, function(_, val) {
        return isPlainObject(val) ? Object.keys(val).sort().reduce(function(result, key) {
            result[key] = val[key];
            return result;
        }, {}) : val;
    });
}
function partialMatchKey(a, b) {
    return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
}
function partialDeepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') return !Object.keys(b).some(function(key) {
        return !partialDeepEqual(a[key], b[key]);
    });
    return false;
}
function replaceEqualDeep(a, b) {
    if (a === b) return a;
    var array = Array.isArray(a) && Array.isArray(b);
    if (array || isPlainObject(a) && isPlainObject(b)) {
        var aSize = array ? a.length : Object.keys(a).length;
        var bItems = array ? b : Object.keys(b);
        var bSize = bItems.length;
        var copy = array ? [] : {};
        var equalItems = 0;
        for(var i = 0; i < bSize; i++){
            var key = array ? i : bItems[i];
            copy[key] = replaceEqualDeep(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function shallowEqualObjects(a, b) {
    if (a && !b || b && !a) return false;
    for(var key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function isPlainObject(o) {
    if (!hasObjectPrototype(o)) return false;
     // If has modified constructor
    var ctor = o.constructor;
    if (typeof ctor === 'undefined') return true;
     // If has modified prototype
    var prot = ctor.prototype;
    if (!hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty('isPrototypeOf')) return false;
     // Most likely a plain Object
    return true;
}
function hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function isQueryKey(value) {
    return typeof value === 'string' || Array.isArray(value);
}
function isError(value) {
    return value instanceof Error;
}
function sleep(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function scheduleMicrotask(callback) {
    Promise.resolve().then(callback).catch(function(error) {
        return setTimeout(function() {
            throw error;
        });
    });
}
function getAbortController() {
    if (typeof AbortController === 'function') return new AbortController();
}

},{"@babel/runtime/helpers/esm/extends":"dMXQY","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"dMXQY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hapna":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnlineManager", ()=>OnlineManager);
parcelHelpers.export(exports, "onlineManager", ()=>onlineManager);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _subscribable = require("./subscribable");
var _utils = require("./utils");
var OnlineManager = /*#__PURE__*/ function(_Subscribable) {
    (0, _inheritsLooseDefault.default)(OnlineManager, _Subscribable);
    function OnlineManager() {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.setup = function(onOnline) {
            var _window;
            if (!(0, _utils.isServer) && ((_window = window) == null ? void 0 : _window.addEventListener)) {
                var listener = function listener() {
                    return onOnline();
                }; // Listen to online
                window.addEventListener('online', listener, false);
                window.addEventListener('offline', listener, false);
                return function() {
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('online', listener);
                    window.removeEventListener('offline', listener);
                };
            }
        };
        return _this;
    }
    var _proto = OnlineManager.prototype;
    _proto.onSubscribe = function onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    };
    _proto.setEventListener = function setEventListener(setup) {
        var _this$cleanup2, _this2 = this;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup(function(online) {
            if (typeof online === 'boolean') _this2.setOnline(online);
            else _this2.onOnline();
        });
    };
    _proto.setOnline = function setOnline(online) {
        this.online = online;
        if (online) this.onOnline();
    };
    _proto.onOnline = function onOnline() {
        this.listeners.forEach(function(listener) {
            listener();
        });
    };
    _proto.isOnline = function isOnline() {
        if (typeof this.online === 'boolean') return this.online;
        if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') return true;
        return navigator.onLine;
    };
    return OnlineManager;
}((0, _subscribable.Subscribable));
var onlineManager = new OnlineManager();

},{"@babel/runtime/helpers/esm/inheritsLoose":"kAl3N","./subscribable":"dPDca","./utils":"kvHnH","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"g49HF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryCache", ()=>QueryCache);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _utils = require("./utils");
var _query = require("./query");
var _notifyManager = require("./notifyManager");
var _subscribable = require("./subscribable");
var QueryCache = /*#__PURE__*/ function(_Subscribable) {
    (0, _inheritsLooseDefault.default)(QueryCache, _Subscribable);
    function QueryCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.queries = [];
        _this.queriesMap = {};
        return _this;
    }
    var _proto = QueryCache.prototype;
    _proto.build = function build(client, options, state) {
        var _options$queryHash;
        var queryKey = options.queryKey;
        var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, _utils.hashQueryKeyByOptions)(queryKey, options);
        var query = this.get(queryHash);
        if (!query) {
            query = new (0, _query.Query)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey),
                meta: options.meta
            });
            this.add(query);
        }
        return query;
    };
    _proto.add = function add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: 'queryAdded',
                query: query
            });
        }
    };
    _proto.remove = function remove(query) {
        var queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter(function(x) {
                return x !== query;
            });
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: 'queryRemoved',
                query: query
            });
        }
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, _notifyManager.notifyManager).batch(function() {
            _this2.queries.forEach(function(query) {
                _this2.remove(query);
            });
        });
    };
    _proto.get = function get(queryHash) {
        return this.queriesMap[queryHash];
    };
    _proto.getAll = function getAll() {
        return this.queries;
    };
    _proto.find = function find(arg1, arg2) {
        var _parseFilterArgs = (0, _utils.parseFilterArgs)(arg1, arg2), filters = _parseFilterArgs[0];
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.queries.find(function(query) {
            return (0, _utils.matchQuery)(filters, query);
        });
    };
    _proto.findAll = function findAll(arg1, arg2) {
        var _parseFilterArgs2 = (0, _utils.parseFilterArgs)(arg1, arg2), filters = _parseFilterArgs2[0];
        return Object.keys(filters).length > 0 ? this.queries.filter(function(query) {
            return (0, _utils.matchQuery)(filters, query);
        }) : this.queries;
    };
    _proto.notify = function notify(event) {
        var _this3 = this;
        (0, _notifyManager.notifyManager).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(event);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        var _this4 = this;
        (0, _notifyManager.notifyManager).batch(function() {
            _this4.queries.forEach(function(query) {
                query.onFocus();
            });
        });
    };
    _proto.onOnline = function onOnline() {
        var _this5 = this;
        (0, _notifyManager.notifyManager).batch(function() {
            _this5.queries.forEach(function(query) {
                query.onOnline();
            });
        });
    };
    return QueryCache;
}((0, _subscribable.Subscribable));

},{"@babel/runtime/helpers/esm/inheritsLoose":"kAl3N","./utils":"kvHnH","./query":"ahDfQ","./notifyManager":"bDyG0","./subscribable":"dPDca","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ahDfQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Query", ()=>Query);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _utils = require("./utils");
var _notifyManager = require("./notifyManager");
var _logger = require("./logger");
var _retryer = require("./retryer"); // TYPES
var Query = /*#__PURE__*/ function() {
    function Query(config) {
        this.abortSignalConsumed = false;
        this.hadObservers = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || this.getDefaultState(this.options);
        this.state = this.initialState;
        this.meta = config.meta;
        this.scheduleGc();
    }
    var _proto = Query.prototype;
    _proto.setOptions = function setOptions(options) {
        var _this$options$cacheTi;
        this.options = (0, _extendsDefault.default)({}, this.defaultOptions, options);
        this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 300000);
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.scheduleGc = function scheduleGc() {
        var _this = this;
        this.clearGcTimeout();
        if ((0, _utils.isValidTimeout)(this.cacheTime)) this.gcTimeout = setTimeout(function() {
            _this.optionalRemove();
        }, this.cacheTime);
    };
    _proto.clearGcTimeout = function clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    };
    _proto.optionalRemove = function optionalRemove() {
        if (!this.observers.length) {
            if (this.state.isFetching) {
                if (this.hadObservers) this.scheduleGc();
            } else this.cache.remove(this);
        }
    };
    _proto.setData = function setData(updater, options) {
        var _this$options$isDataE, _this$options;
        var prevData = this.state.data; // Get the new data
        var data = (0, _utils.functionalUpdate)(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`
        if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) data = prevData;
        else if (this.options.structuralSharing !== false) // Structurally share data between prev and new data if needed
        data = (0, _utils.replaceEqualDeep)(prevData, data);
         // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: 'success',
            dataUpdatedAt: options == null ? void 0 : options.updatedAt
        });
        return data;
    };
    _proto.setState = function setState(state, setStateOptions) {
        this.dispatch({
            type: 'setState',
            state: state,
            setStateOptions: setStateOptions
        });
    };
    _proto.cancel = function cancel(options) {
        var _this$retryer;
        var promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, _utils.noop)).catch((0, _utils.noop)) : Promise.resolve();
    };
    _proto.destroy = function destroy() {
        this.clearGcTimeout();
        this.cancel({
            silent: true
        });
    };
    _proto.reset = function reset() {
        this.destroy();
        this.setState(this.initialState);
    };
    _proto.isActive = function isActive() {
        return this.observers.some(function(observer) {
            return observer.options.enabled !== false;
        });
    };
    _proto.isFetching = function isFetching() {
        return this.state.isFetching;
    };
    _proto.isStale = function isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function(observer) {
            return observer.getCurrentResult().isStale;
        });
    };
    _proto.isStaleByTime = function isStaleByTime(staleTime) {
        if (staleTime === void 0) staleTime = 0;
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, _utils.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    };
    _proto.onFocus = function onFocus() {
        var _this$retryer2;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnWindowFocus();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    };
    _proto.onOnline = function onOnline() {
        var _this$retryer3;
        var observer = this.observers.find(function(x) {
            return x.shouldFetchOnReconnect();
        });
        if (observer) observer.refetch();
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) {
            this.observers.push(observer);
            this.hadObservers = true; // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: 'observerAdded',
                query: this,
                observer: observer
            });
        }
    };
    _proto.removeObserver = function removeObserver(observer) {
        if (this.observers.indexOf(observer) !== -1) {
            this.observers = this.observers.filter(function(x) {
                return x !== observer;
            });
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.retryer.isTransportCancelable || this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                if (this.cacheTime) this.scheduleGc();
                else this.cache.remove(this);
            }
            this.cache.notify({
                type: 'observerRemoved',
                query: this,
                observer: observer
            });
        }
    };
    _proto.getObserversCount = function getObserversCount() {
        return this.observers.length;
    };
    _proto.invalidate = function invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: 'invalidate'
        });
    };
    _proto.fetch = function fetch(options, fetchOptions) {
        var _this2 = this, _this$options$behavio, _context$fetchOptions, _abortController$abor;
        if (this.state.isFetching) {
            if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            var observer = this.observers.find(function(x) {
                return x.options.queryFn;
            });
            if (observer) this.setOptions(observer.options);
        }
        var queryKey = (0, _utils.ensureQueryKeyArray)(this.queryKey);
        var abortController = (0, _utils.getAbortController)(); // Create query function context
        var queryFnContext = {
            queryKey: queryKey,
            pageParam: undefined,
            meta: this.meta
        };
        Object.defineProperty(queryFnContext, 'signal', {
            enumerable: true,
            get: function get() {
                if (abortController) {
                    _this2.abortSignalConsumed = true;
                    return abortController.signal;
                }
                return undefined;
            }
        }); // Create fetch function
        var fetchFn = function fetchFn() {
            if (!_this2.options.queryFn) return Promise.reject('Missing queryFn');
            _this2.abortSignalConsumed = false;
            return _this2.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        var context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: queryKey,
            state: this.state,
            fetchFn: fetchFn,
            meta: this.meta
        };
        if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
            var _this$options$behavio2;
            (_this$options$behavio2 = this.options.behavior) == null || _this$options$behavio2.onFetch(context);
        } // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: 'fetch',
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        } // Try to fetch the data
        this.retryer = new (0, _retryer.Retryer)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
            onSuccess: function onSuccess(data) {
                _this2.setData(data); // Notify cache callback
                _this2.cache.config.onSuccess == null || _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onError: function onError(error) {
                // Optimistically update state if needed
                if (!((0, _retryer.isCancelledError)(error) && error.silent)) _this2.dispatch({
                    type: 'error',
                    error: error
                });
                if (!(0, _retryer.isCancelledError)(error)) {
                    // Notify cache callback
                    _this2.cache.config.onError == null || _this2.cache.config.onError(error, _this2); // Log error
                    (0, _logger.getLogger)().error(error);
                } // Remove query after fetching if cache time is 0
                if (_this2.cacheTime === 0) _this2.optionalRemove();
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: 'failed'
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: 'pause'
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: 'continue'
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay
        });
        this.promise = this.retryer.promise;
        return this.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = this.reducer(this.state, action);
        (0, _notifyManager.notifyManager).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onQueryUpdate(action);
            });
            _this3.cache.notify({
                query: _this3,
                type: 'queryUpdated',
                action: action
            });
        });
    };
    _proto.getDefaultState = function getDefaultState(options) {
        var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
        var hasInitialData = typeof options.initialData !== 'undefined';
        var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
        var hasData = typeof data !== 'undefined';
        return {
            data: data,
            dataUpdateCount: 0,
            dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
            error: null,
            errorUpdateCount: 0,
            errorUpdatedAt: 0,
            fetchFailureCount: 0,
            fetchMeta: null,
            isFetching: false,
            isInvalidated: false,
            isPaused: false,
            status: hasData ? 'success' : 'idle'
        };
    };
    _proto.reducer = function reducer(state, action) {
        var _action$meta, _action$dataUpdatedAt;
        switch(action.type){
            case 'failed':
                return (0, _extendsDefault.default)({}, state, {
                    fetchFailureCount: state.fetchFailureCount + 1
                });
            case 'pause':
                return (0, _extendsDefault.default)({}, state, {
                    isPaused: true
                });
            case 'continue':
                return (0, _extendsDefault.default)({}, state, {
                    isPaused: false
                });
            case 'fetch':
                return (0, _extendsDefault.default)({}, state, {
                    fetchFailureCount: 0,
                    fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                    isFetching: true,
                    isPaused: false
                }, !state.dataUpdatedAt && {
                    error: null,
                    status: 'loading'
                });
            case 'success':
                return (0, _extendsDefault.default)({}, state, {
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                    error: null,
                    fetchFailureCount: 0,
                    isFetching: false,
                    isInvalidated: false,
                    isPaused: false,
                    status: 'success'
                });
            case 'error':
                var error = action.error;
                if ((0, _retryer.isCancelledError)(error) && error.revert && this.revertState) return (0, _extendsDefault.default)({}, this.revertState);
                return (0, _extendsDefault.default)({}, state, {
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    isFetching: false,
                    isPaused: false,
                    status: 'error'
                });
            case 'invalidate':
                return (0, _extendsDefault.default)({}, state, {
                    isInvalidated: true
                });
            case 'setState':
                return (0, _extendsDefault.default)({}, state, action.state);
            default:
                return state;
        }
    };
    return Query;
}();

},{"@babel/runtime/helpers/esm/extends":"dMXQY","./utils":"kvHnH","./notifyManager":"bDyG0","./logger":"9KKlr","./retryer":"3SIgf","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"bDyG0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotifyManager", ()=>NotifyManager);
parcelHelpers.export(exports, "notifyManager", ()=>notifyManager);
var _utils = require("./utils"); // TYPES
var NotifyManager = /*#__PURE__*/ function() {
    function NotifyManager() {
        this.queue = [];
        this.transactions = 0;
        this.notifyFn = function(callback) {
            callback();
        };
        this.batchNotifyFn = function(callback) {
            callback();
        };
    }
    var _proto = NotifyManager.prototype;
    _proto.batch = function batch(callback) {
        var result;
        this.transactions++;
        try {
            result = callback();
        } finally{
            this.transactions--;
            if (!this.transactions) this.flush();
        }
        return result;
    };
    _proto.schedule = function schedule(callback) {
        var _this = this;
        if (this.transactions) this.queue.push(callback);
        else (0, _utils.scheduleMicrotask)(function() {
            _this.notifyFn(callback);
        });
    };
    _proto.batchCalls = function batchCalls(callback) {
        var _this2 = this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this2.schedule(function() {
                callback.apply(void 0, args);
            });
        };
    };
    _proto.flush = function flush() {
        var _this3 = this;
        var queue = this.queue;
        this.queue = [];
        if (queue.length) (0, _utils.scheduleMicrotask)(function() {
            _this3.batchNotifyFn(function() {
                queue.forEach(function(callback) {
                    _this3.notifyFn(callback);
                });
            });
        });
    };
    _proto.setNotifyFunction = function setNotifyFunction(fn) {
        this.notifyFn = fn;
    };
    _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
        this.batchNotifyFn = fn;
    };
    return NotifyManager;
}(); // SINGLETON
var notifyManager = new NotifyManager();

},{"./utils":"kvHnH","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9KKlr":[function(require,module,exports,__globalThis) {
// TYPES
// FUNCTIONS
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLogger", ()=>getLogger);
parcelHelpers.export(exports, "setLogger", ()=>setLogger);
var logger = console;
function getLogger() {
    return logger;
}
function setLogger(newLogger) {
    logger = newLogger;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5mrU0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClient", ()=>QueryClient);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _utils = require("./utils");
var _queryCache = require("./queryCache");
var _mutationCache = require("./mutationCache");
var _focusManager = require("./focusManager");
var _onlineManager = require("./onlineManager");
var _notifyManager = require("./notifyManager");
var _infiniteQueryBehavior = require("./infiniteQueryBehavior");
var QueryClient = /*#__PURE__*/ function() {
    function QueryClient(config) {
        if (config === void 0) config = {};
        this.queryCache = config.queryCache || new (0, _queryCache.QueryCache)();
        this.mutationCache = config.mutationCache || new (0, _mutationCache.MutationCache)();
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
    }
    var _proto = QueryClient.prototype;
    _proto.mount = function mount() {
        var _this = this;
        this.unsubscribeFocus = (0, _focusManager.focusManager).subscribe(function() {
            if ((0, _focusManager.focusManager).isFocused() && (0, _onlineManager.onlineManager).isOnline()) {
                _this.mutationCache.onFocus();
                _this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, _onlineManager.onlineManager).subscribe(function() {
            if ((0, _focusManager.focusManager).isFocused() && (0, _onlineManager.onlineManager).isOnline()) {
                _this.mutationCache.onOnline();
                _this.queryCache.onOnline();
            }
        });
    };
    _proto.unmount = function unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
    };
    _proto.isFetching = function isFetching(arg1, arg2) {
        var _parseFilterArgs = (0, _utils.parseFilterArgs)(arg1, arg2), filters = _parseFilterArgs[0];
        filters.fetching = true;
        return this.queryCache.findAll(filters).length;
    };
    _proto.isMutating = function isMutating(filters) {
        return this.mutationCache.findAll((0, _extendsDefault.default)({}, filters, {
            fetching: true
        })).length;
    };
    _proto.getQueryData = function getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    };
    _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref) {
            var queryKey = _ref.queryKey, state = _ref.state;
            var data = state.data;
            return [
                queryKey,
                data
            ];
        });
    };
    _proto.setQueryData = function setQueryData(queryKey, updater, options) {
        var parsedOptions = (0, _utils.parseQueryArgs)(queryKey);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(updater, options);
    };
    _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
        var _this2 = this;
        return (0, _notifyManager.notifyManager).batch(function() {
            return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function(_ref2) {
                var queryKey = _ref2.queryKey;
                return [
                    queryKey,
                    _this2.setQueryData(queryKey, updater, options)
                ];
            });
        });
    };
    _proto.getQueryState = function getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    };
    _proto.removeQueries = function removeQueries(arg1, arg2) {
        var _parseFilterArgs2 = (0, _utils.parseFilterArgs)(arg1, arg2), filters = _parseFilterArgs2[0];
        var queryCache = this.queryCache;
        (0, _notifyManager.notifyManager).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                queryCache.remove(query);
            });
        });
    };
    _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
        var _this3 = this;
        var _parseFilterArgs3 = (0, _utils.parseFilterArgs)(arg1, arg2, arg3), filters = _parseFilterArgs3[0], options = _parseFilterArgs3[1];
        var queryCache = this.queryCache;
        var refetchFilters = (0, _extendsDefault.default)({}, filters, {
            active: true
        });
        return (0, _notifyManager.notifyManager).batch(function() {
            queryCache.findAll(filters).forEach(function(query) {
                query.reset();
            });
            return _this3.refetchQueries(refetchFilters, options);
        });
    };
    _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
        var _this4 = this;
        var _parseFilterArgs4 = (0, _utils.parseFilterArgs)(arg1, arg2, arg3), filters = _parseFilterArgs4[0], _parseFilterArgs4$ = _parseFilterArgs4[1], cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;
        if (typeof cancelOptions.revert === 'undefined') cancelOptions.revert = true;
        var promises = (0, _notifyManager.notifyManager).batch(function() {
            return _this4.queryCache.findAll(filters).map(function(query) {
                return query.cancel(cancelOptions);
            });
        });
        return Promise.all(promises).then((0, _utils.noop)).catch((0, _utils.noop));
    };
    _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
        var _ref3, _filters$refetchActiv, _filters$refetchInact, _this5 = this;
        var _parseFilterArgs5 = (0, _utils.parseFilterArgs)(arg1, arg2, arg3), filters = _parseFilterArgs5[0], options = _parseFilterArgs5[1];
        var refetchFilters = (0, _extendsDefault.default)({}, filters, {
            // if filters.refetchActive is not provided and filters.active is explicitly false,
            // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
            active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
            inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
        });
        return (0, _notifyManager.notifyManager).batch(function() {
            _this5.queryCache.findAll(filters).forEach(function(query) {
                query.invalidate();
            });
            return _this5.refetchQueries(refetchFilters, options);
        });
    };
    _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
        var _this6 = this;
        var _parseFilterArgs6 = (0, _utils.parseFilterArgs)(arg1, arg2, arg3), filters = _parseFilterArgs6[0], options = _parseFilterArgs6[1];
        var promises = (0, _notifyManager.notifyManager).batch(function() {
            return _this6.queryCache.findAll(filters).map(function(query) {
                return query.fetch(undefined, (0, _extendsDefault.default)({}, options, {
                    meta: {
                        refetchPage: filters == null ? void 0 : filters.refetchPage
                    }
                }));
            });
        });
        var promise = Promise.all(promises).then((0, _utils.noop));
        if (!(options == null ? void 0 : options.throwOnError)) promise = promise.catch((0, _utils.noop));
        return promise;
    };
    _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, _utils.parseQueryArgs)(arg1, arg2, arg3);
        var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === 'undefined') defaultedOptions.retry = false;
        var query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    };
    _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, _utils.noop)).catch((0, _utils.noop));
    };
    _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
        var parsedOptions = (0, _utils.parseQueryArgs)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, _infiniteQueryBehavior.infiniteQueryBehavior)();
        return this.fetchQuery(parsedOptions);
    };
    _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, _utils.noop)).catch((0, _utils.noop));
    };
    _proto.cancelMutations = function cancelMutations() {
        var _this7 = this;
        var promises = (0, _notifyManager.notifyManager).batch(function() {
            return _this7.mutationCache.getAll().map(function(mutation) {
                return mutation.cancel();
            });
        });
        return Promise.all(promises).then((0, _utils.noop)).catch((0, _utils.noop));
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        return this.getMutationCache().resumePausedMutations();
    };
    _proto.executeMutation = function executeMutation(options) {
        return this.mutationCache.build(this, options).execute();
    };
    _proto.getQueryCache = function getQueryCache() {
        return this.queryCache;
    };
    _proto.getMutationCache = function getMutationCache() {
        return this.mutationCache;
    };
    _proto.getDefaultOptions = function getDefaultOptions() {
        return this.defaultOptions;
    };
    _proto.setDefaultOptions = function setDefaultOptions(options) {
        this.defaultOptions = options;
    };
    _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
        var result = this.queryDefaults.find(function(x) {
            return (0, _utils.hashQueryKey)(queryKey) === (0, _utils.hashQueryKey)(x.queryKey);
        });
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    };
    _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
        var _this$queryDefaults$f;
        return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function(x) {
            return (0, _utils.partialMatchKey)(queryKey, x.queryKey);
        })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
    };
    _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
        var result = this.mutationDefaults.find(function(x) {
            return (0, _utils.hashQueryKey)(mutationKey) === (0, _utils.hashQueryKey)(x.mutationKey);
        });
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    };
    _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
        var _this$mutationDefault;
        return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function(x) {
            return (0, _utils.partialMatchKey)(mutationKey, x.mutationKey);
        })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
    };
    _proto.defaultQueryOptions = function defaultQueryOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        var defaultedOptions = (0, _extendsDefault.default)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
            _defaulted: true
        });
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, _utils.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
        return defaultedOptions;
    };
    _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
        return this.defaultQueryOptions(options);
    };
    _proto.defaultMutationOptions = function defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return (0, _extendsDefault.default)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
            _defaulted: true
        });
    };
    _proto.clear = function clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    };
    return QueryClient;
}();

},{"@babel/runtime/helpers/esm/extends":"dMXQY","./utils":"kvHnH","./queryCache":"g49HF","./mutationCache":"i2wVP","./focusManager":"2YpB3","./onlineManager":"hapna","./notifyManager":"bDyG0","./infiniteQueryBehavior":"whHJw","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"i2wVP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationCache", ()=>MutationCache);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _notifyManager = require("./notifyManager");
var _mutation = require("./mutation");
var _utils = require("./utils");
var _subscribable = require("./subscribable"); // TYPES
var MutationCache = /*#__PURE__*/ function(_Subscribable) {
    (0, _inheritsLooseDefault.default)(MutationCache, _Subscribable);
    function MutationCache(config) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.config = config || {};
        _this.mutations = [];
        _this.mutationId = 0;
        return _this;
    }
    var _proto = MutationCache.prototype;
    _proto.build = function build(client, options, state) {
        var mutation = new (0, _mutation.Mutation)({
            mutationCache: this,
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
            meta: options.meta
        });
        this.add(mutation);
        return mutation;
    };
    _proto.add = function add(mutation) {
        this.mutations.push(mutation);
        this.notify(mutation);
    };
    _proto.remove = function remove(mutation) {
        this.mutations = this.mutations.filter(function(x) {
            return x !== mutation;
        });
        mutation.cancel();
        this.notify(mutation);
    };
    _proto.clear = function clear() {
        var _this2 = this;
        (0, _notifyManager.notifyManager).batch(function() {
            _this2.mutations.forEach(function(mutation) {
                _this2.remove(mutation);
            });
        });
    };
    _proto.getAll = function getAll() {
        return this.mutations;
    };
    _proto.find = function find(filters) {
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.mutations.find(function(mutation) {
            return (0, _utils.matchMutation)(filters, mutation);
        });
    };
    _proto.findAll = function findAll(filters) {
        return this.mutations.filter(function(mutation) {
            return (0, _utils.matchMutation)(filters, mutation);
        });
    };
    _proto.notify = function notify(mutation) {
        var _this3 = this;
        (0, _notifyManager.notifyManager).batch(function() {
            _this3.listeners.forEach(function(listener) {
                listener(mutation);
            });
        });
    };
    _proto.onFocus = function onFocus() {
        this.resumePausedMutations();
    };
    _proto.onOnline = function onOnline() {
        this.resumePausedMutations();
    };
    _proto.resumePausedMutations = function resumePausedMutations() {
        var pausedMutations = this.mutations.filter(function(x) {
            return x.state.isPaused;
        });
        return (0, _notifyManager.notifyManager).batch(function() {
            return pausedMutations.reduce(function(promise, mutation) {
                return promise.then(function() {
                    return mutation.continue().catch((0, _utils.noop));
                });
            }, Promise.resolve());
        });
    };
    return MutationCache;
}((0, _subscribable.Subscribable));

},{"@babel/runtime/helpers/esm/inheritsLoose":"kAl3N","./notifyManager":"bDyG0","./mutation":"9Y6eq","./utils":"kvHnH","./subscribable":"dPDca","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9Y6eq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mutation", ()=>Mutation);
parcelHelpers.export(exports, "getDefaultState", ()=>getDefaultState);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _logger = require("./logger");
var _notifyManager = require("./notifyManager");
var _retryer = require("./retryer");
var _utils = require("./utils"); // TYPES
var Mutation = /*#__PURE__*/ function() {
    function Mutation(config) {
        this.options = (0, _extendsDefault.default)({}, config.defaultOptions, config.options);
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.observers = [];
        this.state = config.state || getDefaultState();
        this.meta = config.meta;
    }
    var _proto = Mutation.prototype;
    _proto.setState = function setState(state) {
        this.dispatch({
            type: 'setState',
            state: state
        });
    };
    _proto.addObserver = function addObserver(observer) {
        if (this.observers.indexOf(observer) === -1) this.observers.push(observer);
    };
    _proto.removeObserver = function removeObserver(observer) {
        this.observers = this.observers.filter(function(x) {
            return x !== observer;
        });
    };
    _proto.cancel = function cancel() {
        if (this.retryer) {
            this.retryer.cancel();
            return this.retryer.promise.then((0, _utils.noop)).catch((0, _utils.noop));
        }
        return Promise.resolve();
    };
    _proto.continue = function _continue() {
        if (this.retryer) {
            this.retryer.continue();
            return this.retryer.promise;
        }
        return this.execute();
    };
    _proto.execute = function execute() {
        var _this = this;
        var data;
        var restored = this.state.status === 'loading';
        var promise = Promise.resolve();
        if (!restored) {
            this.dispatch({
                type: 'loading',
                variables: this.options.variables
            });
            promise = promise.then(function() {
                // Notify cache callback
                _this.mutationCache.config.onMutate == null || _this.mutationCache.config.onMutate(_this.state.variables, _this);
            }).then(function() {
                return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
            }).then(function(context) {
                if (context !== _this.state.context) _this.dispatch({
                    type: 'loading',
                    context: context,
                    variables: _this.state.variables
                });
            });
        }
        return promise.then(function() {
            return _this.executeMutation();
        }).then(function(result) {
            data = result; // Notify cache callback
            _this.mutationCache.config.onSuccess == null || _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
        }).then(function() {
            return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
        }).then(function() {
            return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
        }).then(function() {
            _this.dispatch({
                type: 'success',
                data: data
            });
            return data;
        }).catch(function(error) {
            // Notify cache callback
            _this.mutationCache.config.onError == null || _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error
            (0, _logger.getLogger)().error(error);
            return Promise.resolve().then(function() {
                return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
            }).then(function() {
                return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
            }).then(function() {
                _this.dispatch({
                    type: 'error',
                    error: error
                });
                throw error;
            });
        });
    };
    _proto.executeMutation = function executeMutation() {
        var _this2 = this, _this$options$retry;
        this.retryer = new (0, _retryer.Retryer)({
            fn: function fn() {
                if (!_this2.options.mutationFn) return Promise.reject('No mutationFn found');
                return _this2.options.mutationFn(_this2.state.variables);
            },
            onFail: function onFail() {
                _this2.dispatch({
                    type: 'failed'
                });
            },
            onPause: function onPause() {
                _this2.dispatch({
                    type: 'pause'
                });
            },
            onContinue: function onContinue() {
                _this2.dispatch({
                    type: 'continue'
                });
            },
            retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
            retryDelay: this.options.retryDelay
        });
        return this.retryer.promise;
    };
    _proto.dispatch = function dispatch(action) {
        var _this3 = this;
        this.state = reducer(this.state, action);
        (0, _notifyManager.notifyManager).batch(function() {
            _this3.observers.forEach(function(observer) {
                observer.onMutationUpdate(action);
            });
            _this3.mutationCache.notify(_this3);
        });
    };
    return Mutation;
}();
function getDefaultState() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        isPaused: false,
        status: 'idle',
        variables: undefined
    };
}
function reducer(state, action) {
    switch(action.type){
        case 'failed':
            return (0, _extendsDefault.default)({}, state, {
                failureCount: state.failureCount + 1
            });
        case 'pause':
            return (0, _extendsDefault.default)({}, state, {
                isPaused: true
            });
        case 'continue':
            return (0, _extendsDefault.default)({}, state, {
                isPaused: false
            });
        case 'loading':
            return (0, _extendsDefault.default)({}, state, {
                context: action.context,
                data: undefined,
                error: null,
                isPaused: false,
                status: 'loading',
                variables: action.variables
            });
        case 'success':
            return (0, _extendsDefault.default)({}, state, {
                data: action.data,
                error: null,
                status: 'success',
                isPaused: false
            });
        case 'error':
            return (0, _extendsDefault.default)({}, state, {
                data: undefined,
                error: action.error,
                failureCount: state.failureCount + 1,
                isPaused: false,
                status: 'error'
            });
        case 'setState':
            return (0, _extendsDefault.default)({}, state, action.state);
        default:
            return state;
    }
}

},{"@babel/runtime/helpers/esm/extends":"dMXQY","./logger":"9KKlr","./notifyManager":"bDyG0","./retryer":"3SIgf","./utils":"kvHnH","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"whHJw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "infiniteQueryBehavior", ()=>infiniteQueryBehavior);
parcelHelpers.export(exports, "getNextPageParam", ()=>getNextPageParam);
parcelHelpers.export(exports, "getPreviousPageParam", ()=>getPreviousPageParam);
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ parcelHelpers.export(exports, "hasNextPage", ()=>hasNextPage);
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ parcelHelpers.export(exports, "hasPreviousPage", ()=>hasPreviousPage);
var _retryer = require("./retryer");
var _utils = require("./utils");
function infiniteQueryBehavior() {
    return {
        onFetch: function onFetch(context) {
            context.fetchFn = function() {
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
                var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
                var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                var abortController = (0, _utils.getAbortController)();
                var abortSignal = abortController == null ? void 0 : abortController.signal;
                var newPageParams = oldPageParams;
                var cancelled = false; // Get query function
                var queryFn = context.options.queryFn || function() {
                    return Promise.reject('Missing queryFn');
                };
                var buildNewPages = function buildNewPages(pages, param, page, previous) {
                    newPageParams = previous ? [
                        param
                    ].concat(newPageParams) : [].concat(newPageParams, [
                        param
                    ]);
                    return previous ? [
                        page
                    ].concat(pages) : [].concat(pages, [
                        page
                    ]);
                }; // Create function to fetch a page
                var fetchPage = function fetchPage(pages, manual, param, previous) {
                    if (cancelled) return Promise.reject('Cancelled');
                    if (typeof param === 'undefined' && !manual && pages.length) return Promise.resolve(pages);
                    var queryFnContext = {
                        queryKey: context.queryKey,
                        signal: abortSignal,
                        pageParam: param,
                        meta: context.meta
                    };
                    var queryFnResult = queryFn(queryFnContext);
                    var promise = Promise.resolve(queryFnResult).then(function(page) {
                        return buildNewPages(pages, param, page, previous);
                    });
                    if ((0, _retryer.isCancelable)(queryFnResult)) {
                        var promiseAsAny = promise;
                        promiseAsAny.cancel = queryFnResult.cancel;
                    }
                    return promise;
                };
                var promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    var manual = typeof pageParam !== 'undefined';
                    var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    var _manual = typeof pageParam !== 'undefined';
                    var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);
                    promise = fetchPage(oldPages, _manual, _param, true);
                } else (function() {
                    newPageParams = [];
                    var manual = typeof context.options.getNextPageParam === 'undefined';
                    var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    var _loop = function _loop(i) {
                        promise = promise.then(function(pages) {
                            var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                            if (shouldFetchNextPage) {
                                var _param2 = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);
                                return fetchPage(pages, manual, _param2);
                            }
                            return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                        });
                    };
                    for(var i = 1; i < oldPages.length; i++)_loop(i);
                })();
                var finalPromise = promise.then(function(pages) {
                    return {
                        pages: pages,
                        pageParams: newPageParams
                    };
                });
                var finalPromiseAsAny = finalPromise;
                finalPromiseAsAny.cancel = function() {
                    cancelled = true;
                    abortController == null || abortController.abort();
                    if ((0, _retryer.isCancelable)(promise)) promise.cancel();
                };
                return finalPromise;
            };
        }
    };
}
function getNextPageParam(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
function hasNextPage(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        var nextPageParam = getNextPageParam(options, pages);
        return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
    }
}
function hasPreviousPage(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        var previousPageParam = getPreviousPageParam(options, pages);
        return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
    }
}

},{"./retryer":"3SIgf","./utils":"kvHnH","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6Qgkq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryObserver", ()=>QueryObserver);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _utils = require("./utils");
var _notifyManager = require("./notifyManager");
var _focusManager = require("./focusManager");
var _subscribable = require("./subscribable");
var _logger = require("./logger");
var _retryer = require("./retryer");
var QueryObserver = /*#__PURE__*/ function(_Subscribable) {
    (0, _inheritsLooseDefault.default)(QueryObserver, _Subscribable);
    function QueryObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.options = options;
        _this.trackedProps = [];
        _this.selectError = null;
        _this.bindMethods();
        _this.setOptions(options);
        return _this;
    }
    var _proto = QueryObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    };
    _proto.onSubscribe = function onSubscribe() {
        if (this.listeners.length === 1) {
            this.currentQuery.addObserver(this);
            if (shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) this.destroy();
    };
    _proto.shouldFetchOnReconnect = function shouldFetchOnReconnect() {
        return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    };
    _proto.shouldFetchOnWindowFocus = function shouldFetchOnWindowFocus() {
        return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    };
    _proto.destroy = function destroy() {
        this.listeners = [];
        this.clearTimers();
        this.currentQuery.removeObserver(this);
    };
    _proto.setOptions = function setOptions(options, notifyOptions) {
        var prevOptions = this.options;
        var prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryObserverOptions(options);
        if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') throw new Error('Expected enabled to be a boolean');
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        var mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        var nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    };
    _proto.getOptimisticResult = function getOptimisticResult(options) {
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return this.createResult(query, defaultedOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.trackResult = function trackResult(result, defaultedOptions) {
        var _this2 = this;
        var trackedResult = {};
        var trackProp = function trackProp(key) {
            if (!_this2.trackedProps.includes(key)) _this2.trackedProps.push(key);
        };
        Object.keys(result).forEach(function(key) {
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: function get() {
                    trackProp(key);
                    return result[key];
                }
            });
        });
        if (defaultedOptions.useErrorBoundary || defaultedOptions.suspense) trackProp('error');
        return trackedResult;
    };
    _proto.getNextResult = function getNextResult(options) {
        var _this3 = this;
        return new Promise(function(resolve, reject) {
            var unsubscribe = _this3.subscribe(function(result) {
                if (!result.isFetching) {
                    unsubscribe();
                    if (result.isError && (options == null ? void 0 : options.throwOnError)) reject(result.error);
                    else resolve(result);
                }
            });
        });
    };
    _proto.getCurrentQuery = function getCurrentQuery() {
        return this.currentQuery;
    };
    _proto.remove = function remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    };
    _proto.refetch = function refetch(options) {
        return this.fetch((0, _extendsDefault.default)({}, options, {
            meta: {
                refetchPage: options == null ? void 0 : options.refetchPage
            }
        }));
    };
    _proto.fetchOptimistic = function fetchOptimistic(options) {
        var _this4 = this;
        var defaultedOptions = this.client.defaultQueryObserverOptions(options);
        var query = this.client.getQueryCache().build(this.client, defaultedOptions);
        return query.fetch().then(function() {
            return _this4.createResult(query, defaultedOptions);
        });
    };
    _proto.fetch = function fetch(fetchOptions) {
        var _this5 = this;
        return this.executeFetch(fetchOptions).then(function() {
            _this5.updateResult();
            return _this5.currentResult;
        });
    };
    _proto.executeFetch = function executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        var promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, _utils.noop));
        return promise;
    };
    _proto.updateStaleTimeout = function updateStaleTimeout() {
        var _this6 = this;
        this.clearStaleTimeout();
        if ((0, _utils.isServer) || this.currentResult.isStale || !(0, _utils.isValidTimeout)(this.options.staleTime)) return;
        var time = (0, _utils.timeUntilStale)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        var timeout = time + 1;
        this.staleTimeoutId = setTimeout(function() {
            if (!_this6.currentResult.isStale) _this6.updateResult();
        }, timeout);
    };
    _proto.computeRefetchInterval = function computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    };
    _proto.updateRefetchInterval = function updateRefetchInterval(nextInterval) {
        var _this7 = this;
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, _utils.isServer) || this.options.enabled === false || !(0, _utils.isValidTimeout)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(function() {
            if (_this7.options.refetchIntervalInBackground || (0, _focusManager.focusManager).isFocused()) _this7.executeFetch();
        }, this.currentRefetchInterval);
    };
    _proto.updateTimers = function updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    };
    _proto.clearTimers = function clearTimers() {
        this.clearStaleTimeout();
        this.clearRefetchInterval();
    };
    _proto.clearStaleTimeout = function clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    };
    _proto.clearRefetchInterval = function clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    };
    _proto.createResult = function createResult(query, options) {
        var prevQuery = this.currentQuery;
        var prevOptions = this.options;
        var prevResult = this.currentResult;
        var prevResultState = this.currentResultState;
        var prevResultOptions = this.currentResultOptions;
        var queryChange = query !== prevQuery;
        var queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        var prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        var state = query.state;
        var dataUpdatedAt = state.dataUpdatedAt, error = state.error, errorUpdatedAt = state.errorUpdatedAt, isFetching = state.isFetching, status = state.status;
        var isPreviousData = false;
        var isPlaceholderData = false;
        var data; // Optimistically set result in fetching state if needed
        if (options.optimisticResults) {
            var mounted = this.hasListeners();
            var fetchOnMount = !mounted && shouldFetchOnMount(query, options);
            var fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                isFetching = true;
                if (!dataUpdatedAt) status = 'loading';
            }
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdateCount && (prevQueryResult == null ? void 0 : prevQueryResult.isSuccess) && status !== 'error') {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== 'undefined') {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                if (options.structuralSharing !== false) data = (0, _utils.replaceEqualDeep)(prevResult == null ? void 0 : prevResult.data, data);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                (0, _logger.getLogger)().error(selectError);
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && (status === 'loading' || status === 'idle')) {
            var placeholderData; // Memoize placeholder data
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== 'undefined') try {
                    placeholderData = options.select(placeholderData);
                    if (options.structuralSharing !== false) placeholderData = (0, _utils.replaceEqualDeep)(prevResult == null ? void 0 : prevResult.data, placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    (0, _logger.getLogger)().error(selectError);
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== 'undefined') {
                status = 'success';
                data = placeholderData;
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = 'error';
        }
        var result = {
            status: status,
            isLoading: status === 'loading',
            isSuccess: status === 'success',
            isError: status === 'error',
            isIdle: status === 'idle',
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && status !== 'loading',
            isLoadingError: status === 'error' && state.dataUpdatedAt === 0,
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: status === 'error' && state.dataUpdatedAt !== 0,
            isStale: isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    };
    _proto.shouldNotifyListeners = function shouldNotifyListeners(result, prevResult) {
        if (!prevResult) return true;
        var _this$options = this.options, notifyOnChangeProps = _this$options.notifyOnChangeProps, notifyOnChangePropsExclusions = _this$options.notifyOnChangePropsExclusions;
        if (!notifyOnChangeProps && !notifyOnChangePropsExclusions) return true;
        if (notifyOnChangeProps === 'tracked' && !this.trackedProps.length) return true;
        var includedProps = notifyOnChangeProps === 'tracked' ? this.trackedProps : notifyOnChangeProps;
        return Object.keys(result).some(function(key) {
            var typedKey = key;
            var changed = result[typedKey] !== prevResult[typedKey];
            var isIncluded = includedProps == null ? void 0 : includedProps.some(function(x) {
                return x === key;
            });
            var isExcluded = notifyOnChangePropsExclusions == null ? void 0 : notifyOnChangePropsExclusions.some(function(x) {
                return x === key;
            });
            return changed && !isExcluded && (!includedProps || isIncluded);
        });
    };
    _proto.updateResult = function updateResult(notifyOptions) {
        var prevResult = this.currentResult;
        this.currentResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify if something has changed
        if ((0, _utils.shallowEqualObjects)(this.currentResult, prevResult)) return;
         // Determine which callbacks to trigger
        var defaultNotifyOptions = {
            cache: true
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && this.shouldNotifyListeners(this.currentResult, prevResult)) defaultNotifyOptions.listeners = true;
        this.notify((0, _extendsDefault.default)({}, defaultNotifyOptions, notifyOptions));
    };
    _proto.updateQuery = function updateQuery() {
        var query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        var prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    };
    _proto.onQueryUpdate = function onQueryUpdate(action) {
        var notifyOptions = {};
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error' && !(0, _retryer.isCancelledError)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    };
    _proto.notify = function notify(notifyOptions) {
        var _this8 = this;
        (0, _notifyManager.notifyManager).batch(function() {
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                _this8.options.onSuccess == null || _this8.options.onSuccess(_this8.currentResult.data);
                _this8.options.onSettled == null || _this8.options.onSettled(_this8.currentResult.data, null);
            } else if (notifyOptions.onError) {
                _this8.options.onError == null || _this8.options.onError(_this8.currentResult.error);
                _this8.options.onSettled == null || _this8.options.onSettled(undefined, _this8.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) _this8.listeners.forEach(function(listener) {
                listener(_this8.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) _this8.client.getQueryCache().notify({
                query: _this8.currentQuery,
                type: 'observerResultsUpdated'
            });
        });
    };
    return QueryObserver;
}((0, _subscribable.Subscribable));
function shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}
function shouldFetchOnMount(query, options) {
    return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}
function shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        var value = typeof field === 'function' ? field(query) : field;
        return value === 'always' || value !== false && isStale(query, options);
    }
    return false;
}
function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}
function isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}

},{"@babel/runtime/helpers/esm/extends":"dMXQY","@babel/runtime/helpers/esm/inheritsLoose":"kAl3N","./utils":"kvHnH","./notifyManager":"bDyG0","./focusManager":"2YpB3","./subscribable":"dPDca","./logger":"9KKlr","./retryer":"3SIgf","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fqcSo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationObserver", ()=>MutationObserver);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _mutation = require("./mutation");
var _notifyManager = require("./notifyManager");
var _subscribable = require("./subscribable");
var MutationObserver = /*#__PURE__*/ function(_Subscribable) {
    (0, _inheritsLooseDefault.default)(MutationObserver, _Subscribable);
    function MutationObserver(client, options) {
        var _this;
        _this = _Subscribable.call(this) || this;
        _this.client = client;
        _this.setOptions(options);
        _this.bindMethods();
        _this.updateResult();
        return _this;
    }
    var _proto = MutationObserver.prototype;
    _proto.bindMethods = function bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    };
    _proto.setOptions = function setOptions(options) {
        this.options = this.client.defaultMutationOptions(options);
    };
    _proto.onUnsubscribe = function onUnsubscribe() {
        if (!this.listeners.length) {
            var _this$currentMutation;
            (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.removeObserver(this);
        }
    };
    _proto.onMutationUpdate = function onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        var notifyOptions = {
            listeners: true
        };
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error') notifyOptions.onError = true;
        this.notify(notifyOptions);
    };
    _proto.getCurrentResult = function getCurrentResult() {
        return this.currentResult;
    };
    _proto.reset = function reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    };
    _proto.mutate = function mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, (0, _extendsDefault.default)({}, this.options, {
            variables: typeof variables !== 'undefined' ? variables : this.options.variables
        }));
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    };
    _proto.updateResult = function updateResult() {
        var state = this.currentMutation ? this.currentMutation.state : (0, _mutation.getDefaultState)();
        var result = (0, _extendsDefault.default)({}, state, {
            isLoading: state.status === 'loading',
            isSuccess: state.status === 'success',
            isError: state.status === 'error',
            isIdle: state.status === 'idle',
            mutate: this.mutate,
            reset: this.reset
        });
        this.currentResult = result;
    };
    _proto.notify = function notify(options) {
        var _this2 = this;
        (0, _notifyManager.notifyManager).batch(function() {
            // First trigger the mutate callbacks
            if (_this2.mutateOptions) {
                if (options.onSuccess) {
                    _this2.mutateOptions.onSuccess == null || _this2.mutateOptions.onSuccess(_this2.currentResult.data, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(_this2.currentResult.data, null, _this2.currentResult.variables, _this2.currentResult.context);
                } else if (options.onError) {
                    _this2.mutateOptions.onError == null || _this2.mutateOptions.onError(_this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                    _this2.mutateOptions.onSettled == null || _this2.mutateOptions.onSettled(undefined, _this2.currentResult.error, _this2.currentResult.variables, _this2.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) _this2.listeners.forEach(function(listener) {
                listener(_this2.currentResult);
            });
        });
    };
    return MutationObserver;
}((0, _subscribable.Subscribable));

},{"@babel/runtime/helpers/esm/extends":"dMXQY","@babel/runtime/helpers/esm/inheritsLoose":"kAl3N","./mutation":"9Y6eq","./notifyManager":"bDyG0","./subscribable":"dPDca","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"k2xjG":[function(require,module,exports,__globalThis) {

},{}],"cRsMD":[function(require,module,exports,__globalThis) {
// Side effects
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClientProvider", ()=>(0, _queryClientProvider.QueryClientProvider));
parcelHelpers.export(exports, "useQueryClient", ()=>(0, _queryClientProvider.useQueryClient));
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundary.QueryErrorResetBoundary));
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundary.useQueryErrorResetBoundary));
parcelHelpers.export(exports, "useIsFetching", ()=>(0, _useIsFetching.useIsFetching));
parcelHelpers.export(exports, "useIsMutating", ()=>(0, _useIsMutating.useIsMutating));
parcelHelpers.export(exports, "useMutation", ()=>(0, _useMutation.useMutation));
parcelHelpers.export(exports, "useQuery", ()=>(0, _useQuery.useQuery));
parcelHelpers.export(exports, "useQueries", ()=>(0, _useQueries.useQueries));
parcelHelpers.export(exports, "useInfiniteQuery", ()=>(0, _useInfiniteQuery.useInfiniteQuery));
parcelHelpers.export(exports, "useHydrate", ()=>(0, _hydrate.useHydrate)) // Types
;
parcelHelpers.export(exports, "Hydrate", ()=>(0, _hydrate.Hydrate));
var _setBatchUpdatesFn = require("./setBatchUpdatesFn");
var _setLogger = require("./setLogger");
var _queryClientProvider = require("./QueryClientProvider");
var _queryErrorResetBoundary = require("./QueryErrorResetBoundary");
var _useIsFetching = require("./useIsFetching");
var _useIsMutating = require("./useIsMutating");
var _useMutation = require("./useMutation");
var _useQuery = require("./useQuery");
var _useQueries = require("./useQueries");
var _useInfiniteQuery = require("./useInfiniteQuery");
var _hydrate = require("./Hydrate");
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./setBatchUpdatesFn":"ixeLv","./setLogger":"3zxAN","./QueryClientProvider":"Ddlb9","./QueryErrorResetBoundary":false,"./useIsFetching":false,"./useIsMutating":"jLb4I","./useMutation":"cOSkT","./useQuery":"44UNG","./useQueries":false,"./useInfiniteQuery":false,"./Hydrate":false,"./types":"9c14V","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ixeLv":[function(require,module,exports,__globalThis) {
var _core = require("../core");
var _reactBatchedUpdates = require("./reactBatchedUpdates");
(0, _core.notifyManager).setBatchNotifyFunction((0, _reactBatchedUpdates.unstable_batchedUpdates));

},{"../core":"7hF1Q","./reactBatchedUpdates":"fO53z"}],"fO53z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_batchedUpdates", ()=>unstable_batchedUpdates);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var unstable_batchedUpdates = (0, _reactDomDefault.default).unstable_batchedUpdates;

},{"react-dom":"7k58v","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3zxAN":[function(require,module,exports,__globalThis) {
var _core = require("../core");
var _logger = require("./logger");
(0, _core.setLogger)((0, _logger.logger));

},{"../core":"7hF1Q","./logger":"t7Jrh"}],"t7Jrh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "logger", ()=>logger);
var logger = console;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"Ddlb9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQueryClient", ()=>useQueryClient);
parcelHelpers.export(exports, "QueryClientProvider", ()=>QueryClientProvider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var defaultContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(undefined);
var QueryClientSharingContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(false); // if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function getQueryClientContext(contextSharing) {
    if (contextSharing && typeof window !== 'undefined') {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = defaultContext;
        return window.ReactQueryClientContext;
    }
    return defaultContext;
}
var useQueryClient = function useQueryClient() {
    var queryClient = (0, _reactDefault.default).useContext(getQueryClientContext((0, _reactDefault.default).useContext(QueryClientSharingContext)));
    if (!queryClient) throw new Error('No QueryClient set, use QueryClientProvider to set one');
    return queryClient;
};
var QueryClientProvider = function QueryClientProvider(_ref) {
    var client = _ref.client, _ref$contextSharing = _ref.contextSharing, contextSharing = _ref$contextSharing === void 0 ? false : _ref$contextSharing, children = _ref.children;
    (0, _reactDefault.default).useEffect(function() {
        client.mount();
        return function() {
            client.unmount();
        };
    }, [
        client
    ]);
    var Context = getQueryClientContext(contextSharing);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(QueryClientSharingContext.Provider, {
        value: contextSharing
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Context.Provider, {
        value: client
    }, children));
};

},{"react":"6wC8C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7naCX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>useQueryErrorResetBoundary);
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>QueryErrorResetBoundary);
var _react = require("react"); // CONTEXT
var _reactDefault = parcelHelpers.interopDefault(_react);
function createValue() {
    var _isReset = false;
    return {
        clearReset: function clearReset() {
            _isReset = false;
        },
        reset: function reset() {
            _isReset = true;
        },
        isReset: function isReset() {
            return _isReset;
        }
    };
}
var QueryErrorResetBoundaryContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(createValue()); // HOOK
var useQueryErrorResetBoundary = function useQueryErrorResetBoundary() {
    return (0, _reactDefault.default).useContext(QueryErrorResetBoundaryContext);
}; // COMPONENT
var QueryErrorResetBoundary = function QueryErrorResetBoundary(_ref) {
    var children = _ref.children;
    var value = (0, _reactDefault.default).useMemo(function() {
        return createValue();
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === 'function' ? children(value) : children);
};

},{"react":"6wC8C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"jLb4I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsMutating", ()=>useIsMutating);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _notifyManager = require("../core/notifyManager");
var _utils = require("../core/utils");
var _queryClientProvider = require("./QueryClientProvider");
function useIsMutating(arg1, arg2) {
    var mountedRef = (0, _reactDefault.default).useRef(false);
    var filters = (0, _utils.parseMutationFilterArgs)(arg1, arg2);
    var queryClient = (0, _queryClientProvider.useQueryClient)();
    var _React$useState = (0, _reactDefault.default).useState(queryClient.isMutating(filters)), isMutating = _React$useState[0], setIsMutating = _React$useState[1];
    var filtersRef = (0, _reactDefault.default).useRef(filters);
    filtersRef.current = filters;
    var isMutatingRef = (0, _reactDefault.default).useRef(isMutating);
    isMutatingRef.current = isMutating;
    (0, _reactDefault.default).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = queryClient.getMutationCache().subscribe((0, _notifyManager.notifyManager).batchCalls(function() {
            if (mountedRef.current) {
                var newIsMutating = queryClient.isMutating(filtersRef.current);
                if (isMutatingRef.current !== newIsMutating) setIsMutating(newIsMutating);
            }
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        queryClient
    ]);
    return isMutating;
}

},{"react":"6wC8C","../core/notifyManager":"bDyG0","../core/utils":"kvHnH","./QueryClientProvider":"Ddlb9","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"cOSkT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMutation", ()=>useMutation);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _notifyManager = require("../core/notifyManager");
var _utils = require("../core/utils");
var _mutationObserver = require("../core/mutationObserver");
var _queryClientProvider = require("./QueryClientProvider");
var _utils1 = require("./utils"); // HOOK
function useMutation(arg1, arg2, arg3) {
    var mountedRef = (0, _reactDefault.default).useRef(false);
    var _React$useState = (0, _reactDefault.default).useState(0), forceUpdate = _React$useState[1];
    var options = (0, _utils.parseMutationArgs)(arg1, arg2, arg3);
    var queryClient = (0, _queryClientProvider.useQueryClient)();
    var obsRef = (0, _reactDefault.default).useRef();
    if (!obsRef.current) obsRef.current = new (0, _mutationObserver.MutationObserver)(queryClient, options);
    else obsRef.current.setOptions(options);
    var currentResult = obsRef.current.getCurrentResult();
    (0, _reactDefault.default).useEffect(function() {
        mountedRef.current = true;
        var unsubscribe = obsRef.current.subscribe((0, _notifyManager.notifyManager).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        }));
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, []);
    var mutate = (0, _reactDefault.default).useCallback(function(variables, mutateOptions) {
        obsRef.current.mutate(variables, mutateOptions).catch((0, _utils.noop));
    }, []);
    if (currentResult.error && (0, _utils1.shouldThrowError)(undefined, obsRef.current.options.useErrorBoundary, [
        currentResult.error
    ])) throw currentResult.error;
    return (0, _extendsDefault.default)({}, currentResult, {
        mutate: mutate,
        mutateAsync: currentResult.mutate
    });
}

},{"@babel/runtime/helpers/esm/extends":"dMXQY","react":"6wC8C","../core/notifyManager":"bDyG0","../core/utils":"kvHnH","../core/mutationObserver":"fqcSo","./QueryClientProvider":"Ddlb9","./utils":"i1pfW","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"i1pfW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldThrowError", ()=>shouldThrowError);
function shouldThrowError(suspense, _useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === 'function') return _useErrorBoundary.apply(void 0, params);
     // Allow useErrorBoundary to override suspense's throwing behavior
    if (typeof _useErrorBoundary === 'boolean') return _useErrorBoundary; // If suspense is enabled default to throwing errors
    return !!suspense;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"44UNG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQuery", ()=>useQuery);
var _core = require("../core");
var _utils = require("../core/utils");
var _useBaseQuery = require("./useBaseQuery"); // HOOK
function useQuery(arg1, arg2, arg3) {
    var parsedOptions = (0, _utils.parseQueryArgs)(arg1, arg2, arg3);
    return (0, _useBaseQuery.useBaseQuery)(parsedOptions, (0, _core.QueryObserver));
}

},{"../core":"7hF1Q","../core/utils":"kvHnH","./useBaseQuery":"2S8cl","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2S8cl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBaseQuery", ()=>useBaseQuery);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _notifyManager = require("../core/notifyManager");
var _queryErrorResetBoundary = require("./QueryErrorResetBoundary");
var _queryClientProvider = require("./QueryClientProvider");
var _utils = require("./utils");
function useBaseQuery(options, Observer) {
    var mountedRef = (0, _reactDefault.default).useRef(false);
    var _React$useState = (0, _reactDefault.default).useState(0), forceUpdate = _React$useState[1];
    var queryClient = (0, _queryClientProvider.useQueryClient)();
    var errorResetBoundary = (0, _queryErrorResetBoundary.useQueryErrorResetBoundary)();
    var defaultedOptions = queryClient.defaultQueryObserverOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions.optimisticResults = true; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, _notifyManager.notifyManager).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, _notifyManager.notifyManager).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, _notifyManager.notifyManager).batchCalls(defaultedOptions.onSettled);
    if (defaultedOptions.suspense) {
        // Always set stale time when using suspense to prevent
        // fetching again when directly mounting after suspending
        if (typeof defaultedOptions.staleTime !== 'number') defaultedOptions.staleTime = 1000;
         // Set cache time to 1 if the option has been set to 0
        // when using suspense to prevent infinite loop of fetches
        if (defaultedOptions.cacheTime === 0) defaultedOptions.cacheTime = 1;
    }
    if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) defaultedOptions.retryOnMount = false;
    }
    var _React$useState2 = (0, _reactDefault.default).useState(function() {
        return new Observer(queryClient, defaultedOptions);
    }), observer = _React$useState2[0];
    var result = observer.getOptimisticResult(defaultedOptions);
    (0, _reactDefault.default).useEffect(function() {
        mountedRef.current = true;
        errorResetBoundary.clearReset();
        var unsubscribe = observer.subscribe((0, _notifyManager.notifyManager).batchCalls(function() {
            if (mountedRef.current) forceUpdate(function(x) {
                return x + 1;
            });
        })); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return function() {
            mountedRef.current = false;
            unsubscribe();
        };
    }, [
        errorResetBoundary,
        observer
    ]);
    (0, _reactDefault.default).useEffect(function() {
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if (defaultedOptions.suspense && result.isLoading) throw observer.fetchOptimistic(defaultedOptions).then(function(_ref) {
        var data = _ref.data;
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch(function(error) {
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });
     // Handle error boundary
    if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, _utils.shouldThrowError)(defaultedOptions.suspense, defaultedOptions.useErrorBoundary, [
        result.error,
        observer.getCurrentQuery()
    ])) throw result.error;
     // Handle result property usage tracking
    if (defaultedOptions.notifyOnChangeProps === 'tracked') result = observer.trackResult(result, defaultedOptions);
    return result;
}

},{"react":"6wC8C","../core/notifyManager":"bDyG0","./QueryErrorResetBoundary":"7naCX","./QueryClientProvider":"Ddlb9","./utils":"i1pfW","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9c14V":[function(require,module,exports,__globalThis) {

},{}],"kskQG":[function(require,module,exports,__globalThis) {
module.exports = {
    ReactQueryDevtools: function() {
        return null;
    },
    ReactQueryDevtoolsPanel: function() {
        return null;
    }
};

},{}],"94jhf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _reactQuery = require("react-query");
var _login = require("./login");
var _loginDefault = parcelHelpers.interopDefault(_login);
var _tokenLogin = require("./components/tokenLogin");
var _tokenLoginDefault = parcelHelpers.interopDefault(_tokenLogin);
var _useStore = require("./components/hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
var _useAppState = require("./components/hooks/useAppState");
var _useAppStateDefault = parcelHelpers.interopDefault(_useAppState);
var _useFetchAdminConfig = require("./components/hooks/fetch/useFetchAdminConfig");
var _activityTracker = require("./components/common/ActivityTracker");
const Admin = /*#__PURE__*/ (0, _react.lazy)(()=>require("2568f8ff17e3ac16"));
const Client = /*#__PURE__*/ (0, _react.lazy)(()=>require("c5340815d6be9761"));
const ExternalCss = /*#__PURE__*/ (0, _react.lazy)(()=>require("ccc15060741301f2"));
// check if token has been passed in URL to log in
const urlParams = new URLSearchParams(window.location.search);
const token = urlParams.get("token");
// add event listener to check for dark mode change
window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", (event)=>{
    (0, _useStoreDefault.default).getState().setToggleDarkMode(event.matches);
});
if (localStorage.getItem("toggleDarkMode") === "true") document.querySelector(":root").classList.add("theme-dark");
const App = ()=>{
    var _config_helpText, _JSON_parse_theme, _JSON_parse;
    (0, _useAppStateDefault.default)();
    const setAuthToken = (0, _useStoreDefault.default)((state)=>state.setAuthToken);
    const subdomain = (0, _useStoreDefault.default)((state)=>state.subdomain);
    const clientRef = (0, _useStoreDefault.default)((state)=>state.clientRef);
    const clientDetails = (0, _useStoreDefault.default)((state)=>state.clientDetails);
    const baseURL = (0, _useStoreDefault.default)((state)=>state.baseURL);
    const loggedIn = (0, _useStoreDefault.default)((state)=>state.loggedIn);
    const setLoggedIn = (0, _useStoreDefault.default)((state)=>state.setLoggedIn);
    const toggleDarkMode = (0, _useStoreDefault.default)((state)=>state.toggleDarkMode);
    const toggleHighContrast = (0, _useStoreDefault.default)((state)=>state.toggleHighContrast);
    const pathParts = (0, _useStoreDefault.default)((state)=>state.getPathParts());
    const currentPage = pathParts && pathParts[pathParts.length - 1];
    const { data: config, isLoading: isConfigLoading } = (0, _useFetchAdminConfig.useFetchAdminConfig)({});
    const privacyPolicy = config === null || config === void 0 ? void 0 : (_config_helpText = config.helpText) === null || _config_helpText === void 0 ? void 0 : _config_helpText.find((helpItem)=>(helpItem === null || helpItem === void 0 ? void 0 : helpItem.title) === "Privacy policy");
    (0, _react.useEffect)(()=>{
        if (toggleDarkMode) document.querySelector(":root").classList.add("theme-dark");
        if (toggleHighContrast) {
            document.querySelector(":root").classList.add("theme-high-contrast");
            document.querySelector(":root").classList.add("theme-large-text");
        }
    }, []);
    // Listen for session expiration events
    (0, _react.useEffect)(()=>{
        const handleSessionExpired = ()=>{
            doLogin(false);
        };
        window.addEventListener("sessionExpired", handleSessionExpired);
        return ()=>{
            window.removeEventListener("sessionExpired", handleSessionExpired);
        };
    }, []);
    const queryClient = (0, _reactQuery.useQueryClient)();
    const doLogin = (loggedIn = true, token = null, admin = false)=>{
        setLoggedIn(loggedIn);
        const thisToken = loggedIn ? token : null;
        localStorage.setItem("authToken", thisToken);
        localStorage.setItem("loggedIn", loggedIn);
        localStorage.setItem("admin", admin);
        if (loggedIn) // Only set lastActivity when logging in
        localStorage.setItem("lastActivity", Date.now().toString());
        setAuthToken(thisToken);
        // clear UseQuery cache (API calls)
        queryClient.invalidateQueries();
        queryClient.clear();
    };
    // if token has been passed, log out any existing user
    (0, _react.useEffect)(()=>{
        if (token) doLogin(false);
    }, [
        token
    ]);
    const parsedCss = (_JSON_parse = JSON.parse(clientDetails)) === null || _JSON_parse === void 0 ? void 0 : (_JSON_parse_theme = _JSON_parse.theme) === null || _JSON_parse_theme === void 0 ? void 0 : _JSON_parse_theme.css;
    const clientCss = parsedCss ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("style", {
        children: parsedCss
    }) : clientRef ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExternalCss, {
        url: `${"https://rest.yourhr.space"}/css/${clientRef}`
    }) : null;
    // ADMIN
    if (subdomain === "admin") return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _activityTracker.ActivityTracker), {
        onTimeout: ()=>doLogin(false),
        children: [
            clientCss,
            !loggedIn && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.BrowserRouter), {
                basename: baseURL,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loginDefault.default), {
                    onLogin: doLogin
                })
            }),
            loggedIn && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Admin, {
                onLogin: doLogin
            })
        ]
    });
    // CLIENT
    if (token) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tokenLoginDefault.default), {
        token: token,
        onLogin: doLogin
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _activityTracker.ActivityTracker), {
        onTimeout: ()=>doLogin(false),
        children: [
            !loggedIn && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.BrowserRouter), {
                basename: baseURL,
                children: [
                    currentPage === "privacy-policy" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            isConfigLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: "Loading privacy policy..."
                            }),
                            !isConfigLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                style: {
                                    padding: "2rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                        children: privacyPolicy === null || privacyPolicy === void 0 ? void 0 : privacyPolicy.title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: privacyPolicy === null || privacyPolicy === void 0 ? void 0 : privacyPolicy.content
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    currentPage !== "privacy-policy" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loginDefault.default), {
                        onLogin: doLogin
                    })
                ]
            }),
            clientCss,
            loggedIn && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Client, {
                onLogin: doLogin
            })
        ]
    });
};
exports.default = App;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","react-router-dom":"4I6p1","react-query":"41hyj","2568f8ff17e3ac16":"9MEvS","c5340815d6be9761":"1Z2D4","./login":"9qtKj","./components/tokenLogin":"38bNK","ccc15060741301f2":"1kpl0","./components/hooks/useStore":"l1Yj7","./components/hooks/useAppState":"W9TJl","./components/hooks/fetch/useFetchAdminConfig":"9sPBO","./components/common/ActivityTracker":"i7xnh","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4I6p1":[function(require,module,exports,__globalThis) {
/**
 * React Router DOM v6.30.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _reactRouter.AbortedDeferredError));
parcelHelpers.export(exports, "Await", ()=>(0, _reactRouter.Await));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Navigate", ()=>(0, _reactRouter.Navigate));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _reactRouter.NavigationType));
parcelHelpers.export(exports, "Outlet", ()=>(0, _reactRouter.Outlet));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "Routes", ()=>(0, _reactRouter.Routes));
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>(0, _reactRouter.UNSAFE_DataRouterContext));
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>(0, _reactRouter.UNSAFE_DataRouterStateContext));
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>(0, _reactRouter.UNSAFE_LocationContext));
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>(0, _reactRouter.UNSAFE_NavigationContext));
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>(0, _reactRouter.UNSAFE_RouteContext));
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>(0, _reactRouter.UNSAFE_useRouteId));
parcelHelpers.export(exports, "createMemoryRouter", ()=>(0, _reactRouter.createMemoryRouter));
parcelHelpers.export(exports, "createPath", ()=>(0, _reactRouter.createPath));
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>(0, _reactRouter.createRoutesFromChildren));
parcelHelpers.export(exports, "createRoutesFromElements", ()=>(0, _reactRouter.createRoutesFromElements));
parcelHelpers.export(exports, "defer", ()=>(0, _reactRouter.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _reactRouter.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _reactRouter.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _reactRouter.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _reactRouter.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _reactRouter.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _reactRouter.redirectDocument));
parcelHelpers.export(exports, "renderMatches", ()=>(0, _reactRouter.renderMatches));
parcelHelpers.export(exports, "replace", ()=>(0, _reactRouter.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _reactRouter.resolvePath));
parcelHelpers.export(exports, "useActionData", ()=>(0, _reactRouter.useActionData));
parcelHelpers.export(exports, "useAsyncError", ()=>(0, _reactRouter.useAsyncError));
parcelHelpers.export(exports, "useAsyncValue", ()=>(0, _reactRouter.useAsyncValue));
parcelHelpers.export(exports, "useBlocker", ()=>(0, _reactRouter.useBlocker));
parcelHelpers.export(exports, "useHref", ()=>(0, _reactRouter.useHref));
parcelHelpers.export(exports, "useInRouterContext", ()=>(0, _reactRouter.useInRouterContext));
parcelHelpers.export(exports, "useLoaderData", ()=>(0, _reactRouter.useLoaderData));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useMatch", ()=>(0, _reactRouter.useMatch));
parcelHelpers.export(exports, "useMatches", ()=>(0, _reactRouter.useMatches));
parcelHelpers.export(exports, "useNavigate", ()=>(0, _reactRouter.useNavigate));
parcelHelpers.export(exports, "useNavigation", ()=>(0, _reactRouter.useNavigation));
parcelHelpers.export(exports, "useNavigationType", ()=>(0, _reactRouter.useNavigationType));
parcelHelpers.export(exports, "useOutlet", ()=>(0, _reactRouter.useOutlet));
parcelHelpers.export(exports, "useOutletContext", ()=>(0, _reactRouter.useOutletContext));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useResolvedPath", ()=>(0, _reactRouter.useResolvedPath));
parcelHelpers.export(exports, "useRevalidator", ()=>(0, _reactRouter.useRevalidator));
parcelHelpers.export(exports, "useRouteError", ()=>(0, _reactRouter.useRouteError));
parcelHelpers.export(exports, "useRouteLoaderData", ()=>(0, _reactRouter.useRouteLoaderData));
parcelHelpers.export(exports, "useRoutes", ()=>(0, _reactRouter.useRoutes));
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>(0, _router.UNSAFE_ErrorResponseImpl));
//#endregion
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "ScrollRestoration", ()=>ScrollRestoration);
parcelHelpers.export(exports, "UNSAFE_FetchersContext", ()=>FetchersContext);
parcelHelpers.export(exports, "UNSAFE_ViewTransitionContext", ()=>ViewTransitionContext);
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", ()=>useScrollRestoration);
parcelHelpers.export(exports, "createBrowserRouter", ()=>createBrowserRouter);
parcelHelpers.export(exports, "createHashRouter", ()=>createHashRouter);
parcelHelpers.export(exports, "createSearchParams", ()=>createSearchParams);
parcelHelpers.export(exports, "unstable_HistoryRouter", ()=>HistoryRouter);
parcelHelpers.export(exports, "unstable_usePrompt", ()=>usePrompt);
parcelHelpers.export(exports, "useBeforeUnload", ()=>useBeforeUnload);
parcelHelpers.export(exports, "useFetcher", ()=>useFetcher);
parcelHelpers.export(exports, "useFetchers", ()=>useFetchers);
parcelHelpers.export(exports, "useFormAction", ()=>useFormAction);
parcelHelpers.export(exports, "useLinkClickHandler", ()=>useLinkClickHandler);
parcelHelpers.export(exports, "useSearchParams", ()=>useSearchParams);
parcelHelpers.export(exports, "useSubmit", ()=>useSubmit);
parcelHelpers.export(exports, "useViewTransitionState", ()=>useViewTransitionState);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactRouter = require("react-router");
var _router = require("@remix-run/router");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const defaultMethod = "get";
const defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function createSearchParams(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
const supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if (isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!isFormDataSubmitterSupported()) {
            let { name, type, value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action,
        method: method.toLowerCase(),
        encType,
        formData,
        body
    };
}
const _excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], _excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], _excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function createBrowserRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = _extends({}, state, {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, _router.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const ViewTransitionContext = /*#__PURE__*/ _react.createContext({
    isTransitioning: false
});
const FetchersContext = /*#__PURE__*/ _react.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
const FLUSH_SYNC = "flushSync";
const flushSyncImpl = _reactDom[FLUSH_SYNC];
const USE_ID = "useId";
const useIdImpl = _react[USE_ID];
function startTransitionSafe(cb) {
    if (startTransitionImpl) startTransitionImpl(cb);
    else cb();
}
function flushSyncSafe(cb) {
    if (flushSyncImpl) flushSyncImpl(cb);
    else cb();
}
class Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let [pendingState, setPendingState] = _react.useState();
    let [vtContext, setVtContext] = _react.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = _react.useState();
    let [transition, setTransition] = _react.useState();
    let [interruption, setInterruption] = _react.useState();
    let fetcherData = _react.useRef(new Map());
    let { v7_startTransition } = future || {};
    let optInStartTransition = _react.useCallback((cb)=>{
        if (v7_startTransition) startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = _react.useCallback((newState, _ref2)=>{
        let { deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    _react.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    _react.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    _react.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    _react.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = _react.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ _react.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const MemoizedDataRoutes = /*#__PURE__*/ _react.memo(DataRoutes);
function DataRoutes(_ref3) {
    let { routes, future, state } = _ref3;
    return (0, _reactRouter.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function BrowserRouter(_ref4) {
    let { basename, children, future, window: window1 } = _ref4;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function HashRouter(_ref5) {
    let { basename, children, future, window: window1 } = _ref5;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function HistoryRouter(_ref6) {
    let { basename, children, future, history } = _ref6;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const Link = /*#__PURE__*/ _react.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick, relative, reloadDocument, replace, state, target, to, preventScrollReset, viewTransition } = _ref7, rest = _objectWithoutPropertiesLoose(_ref7, _excluded);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if (isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, _router.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, _reactRouter.useHref)(to, {
        relative
    });
    let internalOnClick = useLinkClickHandler(to, {
        replace,
        state,
        target,
        preventScrollReset,
        relative,
        viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react.createElement("a", _extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const NavLink = /*#__PURE__*/ _react.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive = false, className: classNameProp = "", end = false, style: styleProp, to, viewTransition, children } = _ref8, rest = _objectWithoutPropertiesLoose(_ref8, _excluded2);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, _reactRouter.useLocation)();
    let routerState = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    let { navigator, basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, _router.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive,
        isPending,
        isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ _react.createElement(Link, _extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const Form = /*#__PURE__*/ _react.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey, navigate, reloadDocument, replace, state, method = defaultMethod, action, onSubmit, relative, preventScrollReset, viewTransition } = _ref9, props = _objectWithoutPropertiesLoose(_ref9, _excluded3);
    let submit = useSubmit();
    let formAction = useFormAction(action, {
        relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey,
            method: submitMethod,
            navigate,
            replace,
            state,
            relative,
            preventScrollReset,
            viewTransition
        });
    };
    return /*#__PURE__*/ _react.createElement("form", _extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function ScrollRestoration(_ref0) {
    let { getKey, storageKey } = _ref0;
    useScrollRestoration({
        getKey,
        storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
// Internal hooks
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext((0, _reactRouter.UNSAFE_DataRouterContext));
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function useLinkClickHandler(to, _temp) {
    let { target, replace: replaceProp, state, preventScrollReset, relative, viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, _reactRouter.useNavigate)();
    let location = (0, _reactRouter.useLocation)();
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative
    });
    return _react.useCallback((event)=>{
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, _reactRouter.createPath)(location) === (0, _reactRouter.createPath)(path);
            navigate(to, {
                replace,
                state,
                preventScrollReset,
                relative,
                viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function useSearchParams(defaultInit) {
    let defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    let hasSetSearchParamsRef = _react.useRef(false);
    let location = (0, _reactRouter.useLocation)();
    let searchParams = _react.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, _reactRouter.useNavigate)();
    let setSearchParams = _react.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let fetcherId = 0;
let getUniqueFetcherId = ()=>"__" + String(++fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function useSubmit() {
    let { router } = useDataRouterContext(DataRouterHook.UseSubmit);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let currentRouteId = (0, _reactRouter.UNSAFE_useRouteId)();
    return _react.useCallback(function(target, options) {
        if (options === void 0) options = {};
        validateClientSideSubmission();
        let { action, method, encType, formData, body } = getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData,
                body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData,
            body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function useFormAction(action, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let routeContext = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    !routeContext && (0, _router.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = _extends({}, (0, _reactRouter.useResolvedPath)(action ? action : ".", {
        relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, _reactRouter.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, _reactRouter.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function useFetcher(_temp3) {
    var _route$matches;
    let { key } = _temp3 === void 0 ? {} : _temp3;
    let { router } = useDataRouterContext(DataRouterHook.UseFetcher);
    let state = useDataRouterState(DataRouterStateHook.UseFetcher);
    let fetcherData = _react.useContext(FetchersContext);
    let route = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, _router.UNSAFE_invariant)(false);
    !route && (0, _router.UNSAFE_invariant)(false);
    !(routeId != null) && (0, _router.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = useIdImpl ? useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = _react.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey(getUniqueFetcherId());
    // Registration/cleanup
    _react.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = _react.useCallback((href, opts)=>{
        !routeId && (0, _router.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = useSubmit();
    let submit = _react.useCallback((target, opts)=>{
        submitImpl(target, _extends({}, opts, {
            navigate: false,
            fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = _react.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
            return /*#__PURE__*/ _react.createElement(Form, _extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, _router.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = _react.useMemo(()=>_extends({
            Form: FetcherForm,
            submit,
            load
        }, fetcher, {
            data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function useFetchers() {
    let state = useDataRouterState(DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return _extends({}, fetcher, {
            key
        });
    });
}
const SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function useScrollRestoration(_temp4) {
    let { getKey, storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router } = useDataRouterContext(DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition, preventScrollReset } = useDataRouterState(DataRouterStateHook.UseScrollRestoration);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let location = (0, _reactRouter.useLocation)();
    let matches = (0, _reactRouter.useMatches)();
    let navigation = (0, _reactRouter.useNavigation)();
    // Trigger manual scroll restoration while we're active
    _react.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    usePageHide(_react.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey(_extends({}, location, {
                    pathname: (0, _router.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration(savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function useBeforeUnload(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function usePageHide(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function usePrompt(_ref10) {
    let { when, message } = _ref10;
    let blocker = (0, _reactRouter.useBlocker)(when);
    _react.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    _react.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function useViewTransitionState(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = _react.useContext(ViewTransitionContext);
    !(vtContext != null) && (0, _router.UNSAFE_invariant)(false);
    let { basename } = useDataRouterContext(DataRouterHook.useViewTransitionState);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, _router.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, _router.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, _router.matchPath)(path.pathname, nextPath) != null || (0, _router.matchPath)(path.pathname, currentPath) != null;
}

},{"react":"6wC8C","react-dom":"7k58v","react-router":"8tRkF","@remix-run/router":"bBTGZ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8tRkF":[function(require,module,exports,__globalThis) {
/**
 * React Router v6.30.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _router.AbortedDeferredError));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _router.Action));
parcelHelpers.export(exports, "createPath", ()=>(0, _router.createPath));
parcelHelpers.export(exports, "defer", ()=>(0, _router.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _router.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _router.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _router.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _router.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _router.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _router.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _router.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _router.redirectDocument));
parcelHelpers.export(exports, "replace", ()=>(0, _router.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _router.resolvePath));
parcelHelpers.export(exports, "Await", ()=>Await);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Navigate", ()=>Navigate);
parcelHelpers.export(exports, "Outlet", ()=>Outlet);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "Routes", ()=>Routes);
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>DataRouterContext);
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>DataRouterStateContext);
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>LocationContext);
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>NavigationContext);
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>RouteContext);
parcelHelpers.export(exports, "UNSAFE_logV6DeprecationWarnings", ()=>logV6DeprecationWarnings);
parcelHelpers.export(exports, "UNSAFE_mapRouteProperties", ()=>mapRouteProperties);
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>useRouteId);
parcelHelpers.export(exports, "UNSAFE_useRoutesImpl", ()=>useRoutesImpl);
parcelHelpers.export(exports, "createMemoryRouter", ()=>createMemoryRouter);
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "createRoutesFromElements", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "renderMatches", ()=>renderMatches);
parcelHelpers.export(exports, "useActionData", ()=>useActionData);
parcelHelpers.export(exports, "useAsyncError", ()=>useAsyncError);
parcelHelpers.export(exports, "useAsyncValue", ()=>useAsyncValue);
parcelHelpers.export(exports, "useBlocker", ()=>useBlocker);
parcelHelpers.export(exports, "useHref", ()=>useHref);
parcelHelpers.export(exports, "useInRouterContext", ()=>useInRouterContext);
parcelHelpers.export(exports, "useLoaderData", ()=>useLoaderData);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
parcelHelpers.export(exports, "useMatches", ()=>useMatches);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
parcelHelpers.export(exports, "useNavigation", ()=>useNavigation);
parcelHelpers.export(exports, "useNavigationType", ()=>useNavigationType);
parcelHelpers.export(exports, "useOutlet", ()=>useOutlet);
parcelHelpers.export(exports, "useOutletContext", ()=>useOutletContext);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useResolvedPath", ()=>useResolvedPath);
parcelHelpers.export(exports, "useRevalidator", ()=>useRevalidator);
parcelHelpers.export(exports, "useRouteError", ()=>useRouteError);
parcelHelpers.export(exports, "useRouteLoaderData", ()=>useRouteLoaderData);
parcelHelpers.export(exports, "useRoutes", ()=>useRoutes);
var _react = require("react");
var _router = require("@remix-run/router");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const DataRouterContext = /*#__PURE__*/ _react.createContext(null);
const DataRouterStateContext = /*#__PURE__*/ _react.createContext(null);
const AwaitContext = /*#__PURE__*/ _react.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const NavigationContext = /*#__PURE__*/ _react.createContext(null);
const LocationContext = /*#__PURE__*/ _react.createContext(null);
const RouteContext = /*#__PURE__*/ _react.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const RouteErrorContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function useHref(to, _temp) {
    let { relative } = _temp === void 0 ? {} : _temp;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { hash, pathname, search } = useResolvedPath(to, {
        relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search,
        hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function useLocation() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    return _react.useContext(LocationContext).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function useMatch(pattern) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { pathname } = useLocation();
    return _react.useMemo(()=>(0, _router.matchPath)(pattern, (0, _router.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function useIsomorphicLayoutEffect(cb) {
    let isStatic = _react.useContext(NavigationContext).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function useNavigate() {
    let { isDataRoute } = _react.useContext(RouteContext);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let dataRouterContext = _react.useContext(DataRouterContext);
    let { basename, future, navigator } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const OutletContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function useOutletContext() {
    return _react.useContext(OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function useOutlet(context) {
    let outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /*#__PURE__*/ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function useParams() {
    let { matches } = _react.useContext(RouteContext);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function useResolvedPath(to, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { future } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return _react.useMemo(()=>(0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function useRoutesImpl(routes, locationArg, dataRouterState, future) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { navigator } = _react.useContext(NavigationContext);
    let { matches: parentMatches } = _react.useContext(RouteContext);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = useLocation();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, _router.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, _router.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, _router.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = _renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        value: {
            location: _extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, _router.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    let error = useRouteError();
    let message = (0, _router.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const defaultErrorElement = /*#__PURE__*/ _react.createElement(DefaultErrorComponent, null);
class RenderErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ _react.createElement(RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function RenderedRoute(_ref) {
    let { routeContext, match, children } = _ref;
    let dataRouterContext = _react.useContext(DataRouterContext);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, _router.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData, errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ _react.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ _react.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet,
                    matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}(DataRouterHook || {});
var DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}(DataRouterStateHook || {});
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
function useRouteContext(hookName) {
    let route = _react.useContext(RouteContext);
    !route && (0, _router.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function useCurrentRouteId(hookName) {
    let route = useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, _router.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function useRouteId() {
    return useCurrentRouteId(DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function useNavigation() {
    let state = useDataRouterState(DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function useRevalidator() {
    let dataRouterContext = useDataRouterContext(DataRouterHook.UseRevalidator);
    let state = useDataRouterState(DataRouterStateHook.UseRevalidator);
    return _react.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function useMatches() {
    let { matches, loaderData } = useDataRouterState(DataRouterStateHook.UseMatches);
    return _react.useMemo(()=>matches.map((m)=>(0, _router.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function useLoaderData() {
    let state = useDataRouterState(DataRouterStateHook.UseLoaderData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function useRouteLoaderData(routeId) {
    let state = useDataRouterState(DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function useActionData() {
    let state = useDataRouterState(DataRouterStateHook.UseActionData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function useRouteError() {
    var _state$errors;
    let error = _react.useContext(RouteErrorContext);
    let state = useDataRouterState(DataRouterStateHook.UseRouteError);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function useAsyncValue() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function useAsyncError() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._error;
}
let blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function useBlocker(shouldBlock) {
    let { router, basename } = useDataRouterContext(DataRouterHook.UseBlocker);
    let state = useDataRouterState(DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = _react.useState("");
    let blockerFunction = _react.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation, nextLocation, historyAction } = arg;
        return shouldBlock({
            currentLocation: _extends({}, currentLocation, {
                pathname: (0, _router.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: _extends({}, nextLocation, {
                pathname: (0, _router.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    _react.useEffect(()=>{
        let key = String(++blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    _react.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, _router.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function useNavigateStable() {
    let { router } = useDataRouterContext(DataRouterHook.UseNavigateStable);
    let id = useCurrentRouteId(DataRouterStateHook.UseNavigateStable);
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, _extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const alreadyWarned$1 = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned$1[key]) alreadyWarned$1[key] = true;
}
const alreadyWarned = {};
function warnOnce(key, message) {}
const logDeprecation = (flag, msg, link)=>warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function logV6DeprecationWarnings(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        if (v7_startTransition && startTransitionImpl) startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    _react.useEffect(()=>logV6DeprecationWarnings(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function DataRoutes(_ref2) {
    let { routes, future, state } = _ref2;
    return useRoutesImpl(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function MemoryRouter(_ref3) {
    let { basename, children, initialEntries, initialIndex, future } = _ref3;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createMemoryHistory)({
        initialEntries,
        initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>logV6DeprecationWarnings(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function Navigate(_ref4) {
    let { to, replace, state, relative } = _ref4;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { future, static: isStatic } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let navigate = useNavigate();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, _router.resolveTo)(to, (0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    _react.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace,
            state,
            relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function Outlet(props) {
    return useOutlet(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function Route(_props) {
    (0, _router.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function Router(_ref5) {
    let { basename: basenameProp = "/", children = null, location: locationProp, navigationType = (0, _router.Action).Pop, navigator, static: staticProp = false, future } = _ref5;
    !!useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = _react.useMemo(()=>({
            basename,
            navigator,
            static: staticProp,
            future: _extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, _router.parsePath)(locationProp);
    let { pathname = "/", search = "", hash = "", state = null, key = "default" } = locationProp;
    let locationContext = _react.useMemo(()=>{
        let trailingPathname = (0, _router.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search,
                hash,
                state,
                key
            },
            navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function Routes(_ref6) {
    let { children, location } = _ref6;
    return useRoutes(createRoutesFromChildren(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function Await(_ref7) {
    let { children, errorElement, resolve } = _ref7;
    return /*#__PURE__*/ _react.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ _react.createElement(ResolveAwait, null, children));
}
var AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}(AwaitRenderStatus || {});
const neverSettledPromise = new Promise(()=>{});
class AwaitErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children, errorElement, resolve } = this.props;
        let promise = null;
        let status = AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? AwaitRenderStatus.error : "_data" in promise ? AwaitRenderStatus.success : AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === AwaitRenderStatus.error && promise._error instanceof (0, _router.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw neverSettledPromise;
        if (status === AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function ResolveAwait(_ref8) {
    let { children } = _ref8;
    let data = useAsyncValue();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function createRoutesFromChildren(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    _react.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === _react.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        !(element.type === Route) && (0, _router.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, _router.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function renderMatches(matches) {
    return _renderMatches(matches);
}
function mapRouteProperties(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ _react.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ _react.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ _react.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function createMemoryRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes,
        mapRouteProperties,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

},{"react":"6wC8C","@remix-run/router":"bBTGZ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"bBTGZ":[function(require,module,exports,__globalThis) {
/**
 * @remix-run/router v1.23.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
//#endregion
parcelHelpers.export(exports, "AbortedDeferredError", ()=>AbortedDeferredError);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>IDLE_BLOCKER);
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>IDLE_FETCHER);
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>IDLE_NAVIGATION);
parcelHelpers.export(exports, "UNSAFE_DEFERRED_SYMBOL", ()=>UNSAFE_DEFERRED_SYMBOL);
parcelHelpers.export(exports, "UNSAFE_DeferredData", ()=>DeferredData);
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>ErrorResponseImpl);
parcelHelpers.export(exports, "UNSAFE_convertRouteMatchToUiMatch", ()=>convertRouteMatchToUiMatch);
parcelHelpers.export(exports, "UNSAFE_convertRoutesToDataRoutes", ()=>convertRoutesToDataRoutes);
parcelHelpers.export(exports, "UNSAFE_decodePath", ()=>decodePath);
parcelHelpers.export(exports, "UNSAFE_getResolveToMatches", ()=>getResolveToMatches);
parcelHelpers.export(exports, "UNSAFE_invariant", ()=>invariant);
parcelHelpers.export(exports, "UNSAFE_warning", ()=>warning);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createPath", ()=>createPath);
parcelHelpers.export(exports, "createRouter", ()=>createRouter);
parcelHelpers.export(exports, "createStaticHandler", ()=>createStaticHandler);
parcelHelpers.export(exports, "data", ()=>data);
parcelHelpers.export(exports, "defer", ()=>defer);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "getStaticContextFromError", ()=>getStaticContextFromError);
parcelHelpers.export(exports, "getToPathname", ()=>getToPathname);
parcelHelpers.export(exports, "isDataWithResponseInit", ()=>isDataWithResponseInit);
parcelHelpers.export(exports, "isDeferredData", ()=>isDeferredData);
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>isRouteErrorResponse);
parcelHelpers.export(exports, "joinPaths", ()=>joinPaths);
parcelHelpers.export(exports, "json", ()=>json);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "matchRoutes", ()=>matchRoutes);
parcelHelpers.export(exports, "normalizePathname", ()=>normalizePathname);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "redirect", ()=>redirect);
parcelHelpers.export(exports, "redirectDocument", ()=>redirectDocument);
parcelHelpers.export(exports, "replace", ()=>replace);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "resolveTo", ()=>resolveTo);
parcelHelpers.export(exports, "stripBasename", ()=>stripBasename);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
const PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    let { initialEntries = [
        "/"
    ], initialIndex, v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = Action.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = Action.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = Action.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = Action.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action,
                location: nextLocation,
                delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname, search, hash } = window1.location;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname = "/", search = "", hash = "" } = parsePath(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    let { pathname = "/", search = "", hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = Action.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action,
            location: history.location,
            delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : createPath(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push,
        replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
const immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            let indexRoute = _extends({}, route, mapRouteProperties(route), {
                id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    let pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    let matches = null;
    let decoded = decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    let { route, pathname, params } = match;
    return {
        id: route.id,
        pathname,
        params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path,
            score: computeScore(path, route.index),
            routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const paramRe = /^:[\w-]+$/;
const dynamicSegmentValue = 3;
const indexRouteValue = 2;
const emptySegmentValue = 1;
const staticSegmentValue = 10;
const splatPenalty = -2;
const isSplat = (s)=>s === "*";
function computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter((s)=>!isSplat(s)).reduce((score, segment)=>score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue), initialScore);
}
function compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            invariant(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName, isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params,
        pathname: matchedPathname,
        pathnameBase,
        pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        warning(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const isAbsoluteUrl = (url)=>ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search = "", hash = "" } = typeof to === "string" ? parsePath(to) : to;
    let pathname;
    if (toPathname) {
        if (isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = removeDoubleSlashes(toPathname);
                warning(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = resolvePathname(toPathname.substring(1), "/");
            else pathname = resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    let pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
const removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const joinPaths = (paths)=>removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const json = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers
    }));
};
class DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function data(data, init) {
    return new DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class AbortedDeferredError extends Error {
}
class DeferredData {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new AbortedDeferredError("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const defer = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirectDocument = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const replace = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class ErrorResponseImpl {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const validMutationMethods = new Set(validMutationMethodsArr);
const validRequestMethodsArr = [
    "get",
    ...validMutationMethodsArr
];
const validRequestMethods = new Set(validRequestMethodsArr);
const redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches, route } = getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location, delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, IDLE_BLOCKER));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData,
            loaderData,
            historyAction: pendingAction,
            location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset,
            blockers
        }), {
            viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = Action.Push;
        if (userReplace === true) historyAction = Action.Replace;
        else if (userReplace === false) ;
        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = Action.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation,
            nextLocation,
            historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, IDLE_BLOCKER);
                    updateState({
                        blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : matchRoutes(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches
            }, {
                flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            findNearestBoundary(matches).route.id,
            {
                type: ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited, matches: updatedMatches, loaderData, errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, _extends({
            matches: updatedMatches || matches
        }, getActionDataForCommit(pendingActionResult), {
            loaderData,
            errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = getSubmittingNavigation(location, submission);
        updateState({
            navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches, error, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: ResultType.error,
                            error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: ResultType.error,
            error: getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if (isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission,
                replace
            });
            return {
                shortCircuited: true
            };
        }
        if (isDeferredResult(result)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
            return {
                matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState(_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData
                } : {}), {
                    flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, _extends({
                matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = _extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return _extends({
            matches,
            loaderData,
            errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = matchRoutes(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync
            });
            return;
        }
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        let match = getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId,
            path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            }
        } else {
            if (isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if (isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
        invariant(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset
        });
        redirect = findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            invariant(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches,
                loaderData,
                errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors,
                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if (isDeferredResult(result)) result = await resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if (isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if (isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission, fetcherSubmission, preventScrollReset, replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        invariant(location, "Expected a Location header on the redirect Response");
        location = normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if (ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? Action.Replace : Action.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod, formAction, formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if (redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: _extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation,
                // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if (isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: ResultType.redirect,
                response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: ResultType.error,
                    error: getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults,
            fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation, nextLocation, historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation,
            nextLocation,
            historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = getInternalRouterError(404, {
            pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches, route } = getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route,
            error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = matchRoutes(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize,
        subscribe,
        enableScrollRestoration,
        navigate,
        fetch,
        revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose,
        getBlocker,
        deleteBlocker,
        patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    let future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext, skipLoaderErrorBubbling, dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD") {
            let error = getInternalRouterError(405, {
                method
            });
            let { matches: methodNotAllowedMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if (isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return _extends({
            location,
            basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId, requestContext, dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
            method
        });
        else if (!matches) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : getTargetMatch(matches, location);
        if (routeId && !match) throw getInternalRouterError(403, {
            pathname: location.pathname,
            routeId
        });
        else if (!match) // This should never hit I don't think?
        throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if (isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if (isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return isResponse(result) ? result : _extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if (isDataStrategyResult(e) && isResponse(e.result)) {
                if (e.type === ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if (isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isDeferredResult(result)) {
            let error = getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if (isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return _extends({}, context, {
                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: _extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return _extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return _extends({}, context, {
            matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await callDataStrategyImpl(dataStrategy || defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if (isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if (isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes,
        query,
        queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    let newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path,
                submission: {
                    formMethod,
                    formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path,
                    submission: {
                        formMethod,
                        formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod,
        formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path,
        submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>isSameRoute(newRoute, existingRoute)));
    let newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        warning(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function defaultDataStrategy(_ref4) {
    let { matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: ResultType.data,
                result: undefined
            });
        };
        return _extends({}, match, {
            shouldLoad,
            resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request,
        params: matches[0].params,
        fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw getInternalRouterError(405, {
                        method: request.method,
                        pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw getInternalRouterError(404, {
                pathname
            });
        } else result = await runHandler(handler);
        invariant(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result, type } = dataStrategyResult;
    if (isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: ResultType.error,
                error: e
            };
        }
        if (type === ResultType.error) return {
            type: ResultType.error,
            error: new ErrorResponseImpl(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: ResultType.data,
            data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === ResultType.error) {
        if (isDataWithResponseInit(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: ResultType.error,
                error: new ErrorResponseImpl(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: isRouteErrorResponse(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: ResultType.error,
            error: result,
            statusCode: isRouteErrorResponse(result) ? result.status : undefined
        };
    }
    if (isDeferredData(result)) {
        var _result$init5, _result$init6;
        return {
            type: ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if (isDataWithResponseInit(result)) {
        var _result$init7, _result$init8;
        return {
            type: ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if (ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL(stripHashFromPath(location)).toString();
    let init = {
        signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        let { formMethod, formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if (isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData,
        errors,
        statusCode: statusCode || 200,
        loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData, errors } = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key, match, controller } = rf;
        let result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData,
        errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = _extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route
            }
        ],
        route
    };
}
function getInternalRouterError(status, _temp5) {
    let { pathname, routeId, method, type, message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if (isRedirectResult(result)) return {
            key,
            result
        };
    }
}
function stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === ResultType.data || result.type === ResultType.error);
}
function isRedirectDataStrategyResultResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isDeferredData(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
async function resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if (isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key, routeId, controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if (isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            invariant(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: ResultType.error,
            error: e
        };
    }
    return {
        type: ResultType.data,
        data: result.deferredData.data
    };
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function getTargetMatch(matches, location) {
    let search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    let { formMethod, formAction, formEncType, text, formData, json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json: undefined,
        text
    };
    else if (formData != null) return {
        formMethod,
        formAction,
        formEncType,
        formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data
        };
        return fetcher;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9MEvS":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.load("9bEYu").then(()=>module.bundle.root('kNRcS'));

},{}],"1Z2D4":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.load("dwcwW").then(()=>module.bundle.root('ekasV'));

},{}],"9qtKj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _akarIcons = require("akar-icons");
var _tipMessage = require("./components/common/tipMessage");
var _tipMessageDefault = parcelHelpers.interopDefault(_tipMessage);
var _useCustomNavigate = require("./components/hooks/useCustomNavigate");
var _useCustomNavigateDefault = parcelHelpers.interopDefault(_useCustomNavigate);
var _submitButton = require("./components/common/submitButton");
var _submitButtonDefault = parcelHelpers.interopDefault(_submitButton);
var _logo = require("./components/logo");
var _logoDefault = parcelHelpers.interopDefault(_logo);
var _error = require("./components/common/error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _throbber = require("./components/common/throbber");
var _throbberDefault = parcelHelpers.interopDefault(_throbber);
var _modalContent = require("./components/common/modalContent");
var _modalContentDefault = parcelHelpers.interopDefault(_modalContent);
var _useFetchAccounts = require("./components/hooks/fetch/useFetchAccounts");
var _useFetchAdminConfig = require("./components/hooks/fetch/useFetchAdminConfig");
var _useStore = require("./components/hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
var _capacitor = require("./utilities/capacitor");
const Login = ({ onLogin })=>{
    const navigate = (0, _useCustomNavigateDefault.default)();
    const fingerprint = (0, _useStoreDefault.default)((state)=>state.fingerprint);
    const subdomain = (0, _useStoreDefault.default)((state)=>state.subdomain);
    const initClientRef = (0, _useStoreDefault.default)((state)=>state.subdomain);
    const setClientRef = (0, _useStoreDefault.default)((state)=>state.setClientRef);
    const clientDetails = (0, _useStoreDefault.default)((state)=>state.clientDetails);
    const [loggingIn, setLoggingIn] = (0, _react.useState)(false);
    const [loginError, setLoginError] = (0, _react.useState)(null);
    const [slideClass, setSlideClass] = (0, _react.useState)(false);
    const [loginUsername, setLoginUsername] = (0, _react.useState)(null);
    const [loginPassword, setLoginPassword] = (0, _react.useState)(null);
    const [loginTwoFactorCode, setLoginTwoFactorCode] = (0, _react.useState)(null);
    const [loginEmail, setLoginEmail] = (0, _react.useState)(null);
    const [loginTwoFactorNeeded, setLoginTwoFactorNeeded] = (0, _react.useState)(false);
    const [loginClient, setLoginClient] = (0, _react.useState)(initClientRef);
    const [loginCompanies, setLoginCompanies] = (0, _react.useState)(JSON.parse(localStorage.getItem("clientsList")));
    const [helpTextTitle, setHelpTextTitle] = (0, _react.useState)(null);
    const [helpText, setHelpText] = (0, _react.useState)(null);
    const { data: config, isLoading: isConfigLoading } = (0, _useFetchAdminConfig.useFetchAdminConfig)({});
    (0, _react.useEffect)(()=>{
        var _config_helpText;
        const helpItemConfig = config === null || config === void 0 ? void 0 : (_config_helpText = config.helpText) === null || _config_helpText === void 0 ? void 0 : _config_helpText.find((helpItem)=>(helpItem === null || helpItem === void 0 ? void 0 : helpItem.title) === helpTextTitle);
        setHelpText(helpItemConfig === null || helpItemConfig === void 0 ? void 0 : helpItemConfig.content);
    }, [
        config,
        helpTextTitle
    ]);
    const { data: account, isLoading: isAccountLoading } = (0, _useFetchAccounts.useFetchAccount)({
        account: subdomain,
        retry: false
    });
    (0, _react.useEffect)(()=>{
        if (account === null || account === void 0 ? void 0 : account.browserTitle) document.title = (account === null || account === void 0 ? void 0 : account.browserTitle) || "YourHR.space";
    }, [
        account
    ]);
    const resetLoginErrorTimeout = ()=>{
        setTimeout(()=>{
            setLoginError(null);
        }, 4000);
    };
    // authenticate login details
    const doAuthenticateLogin = (data, client = null)=>{
        navigate("/");
        client = client || loginClient;
        console.log("Logging in for client: " + client);
        const postData = {
            username: data === null || data === void 0 ? void 0 : data.username,
            password: data === null || data === void 0 ? void 0 : data.password,
            fingerprint
        };
        if (data === null || data === void 0 ? void 0 : data.twoFactorCode) postData.twoFactorCode = data === null || data === void 0 ? void 0 : data.twoFactorCode;
        console.log("Authenticating login for client: " + client, data, postData);
        fetch("https://rest.yourhr.space/auth/" + client, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(0, _capacitor.getCapacitorHeaders)()
            },
            body: JSON.stringify(postData)
        }).then((res)=>{
            if (res.ok) {
                console.log("Login successful");
                return res.text().then((token)=>{
                    setLoggingIn(false);
                    onLogin(true, token);
                });
            } else if (res.status === 401) {
                console.log("Login attempted - 2FA needed");
                setSlideClass(null);
                setLoginTwoFactorNeeded(true);
                setLoggingIn(false);
            } else {
                console.log("Login failed");
                return res.text().then((errMsg)=>{
                    if (errMsg === "Invalid username or password") {
                        console.log("Invalid username or password");
                        setLoginError(errMsg);
                        setSlideClass(null);
                    } else if (data === null || data === void 0 ? void 0 : data.twoFactorCode) {
                        console.log("Invalid 2FA code");
                        setLoginError("\uD83D\uDE15 The security code you entered was incorrect");
                    } else {
                        console.log("Cannot login", errMsg);
                        setLoginError("\uD83D\uDE15 Oh dear - we were unable to log you in. Have you mistyped something?");
                    }
                    resetLoginErrorTimeout();
                    setLoggingIn(false);
                });
            }
        }).catch((err1)=>{
            console.error(err1);
            setLoggingIn(false);
        });
    };
    // authenticate admin login details
    const doAuthenticateAdminLogin = (data)=>{
        navigate("/");
        const postData = {
            username: data.username,
            password: data.password
        };
        fetch("https://rest.yourhr.space/admin/auth/", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(0, _capacitor.getCapacitorHeaders)()
            },
            body: JSON.stringify(postData)
        }).then((res)=>{
            if (res.ok) return res.text().then((token)=>{
                setLoggingIn(false);
                onLogin(true, token, true);
            });
            else return res.text().then((errMsg)=>{
                setLoggingIn(false);
                setLoginError(errMsg);
                resetLoginErrorTimeout();
            });
        }).catch((err1)=>{
            console.error(err1);
            setLoggingIn(false);
        });
    };
    // get all accounts associated with username
    const doFindCompanies = (data = {})=>{
        console.log("Finding companies for username: " + (data === null || data === void 0 ? void 0 : data.username));
        fetch("https://rest.yourhr.space/accounts/" + (data === null || data === void 0 ? void 0 : data.username), {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                ...(0, _capacitor.getCapacitorHeaders)()
            }
        }).then((res)=>{
            if (res.ok) return res.text().then((accounts)=>{
                var _companies_accounts, _companies_accounts1;
                const companies = JSON.parse(accounts);
                console.log("Found companies", companies === null || companies === void 0 ? void 0 : companies.accounts);
                if ((companies === null || companies === void 0 ? void 0 : (_companies_accounts = companies.accounts) === null || _companies_accounts === void 0 ? void 0 : _companies_accounts.length) === 1) {
                    const foundClientRef = companies.accounts[0].clientRef;
                    setClientRef(foundClientRef);
                    setLoginClient(foundClientRef);
                    console.log("Set client ref to " + foundClientRef);
                    doAuthenticateLogin({
                        username: data === null || data === void 0 ? void 0 : data.username,
                        password: data === null || data === void 0 ? void 0 : data.password,
                        twoFactorCode: data === null || data === void 0 ? void 0 : data.loginTwoFactorCode
                    }, foundClientRef);
                } else if ((companies === null || companies === void 0 ? void 0 : (_companies_accounts1 = companies.accounts) === null || _companies_accounts1 === void 0 ? void 0 : _companies_accounts1.length) > 1) {
                    setLoggingIn(false);
                    console.log("Multiple companies found - user to enter email");
                    setSlideClass("login-container--slides__slide2");
                } else {
                    console.log("No companies found");
                    setLoginError("\uD83D\uDE15 Oh dear - we were unable to find your account. Have you mistyped something?");
                    resetLoginErrorTimeout();
                    setLoggingIn(false);
                }
            });
            else return res.text().then((errMsg)=>{
                console.error(err);
                setLoggingIn(false);
            });
        }).catch((err1)=>{
            console.error(err1);
            setLoggingIn(false);
        });
    };
    // when the login button is clicked...
    const doLogin = (data = {})=>{
        console.log("Log in clicked", data, loginClient);
        setLoginUsername(data === null || data === void 0 ? void 0 : data.username);
        setLoginPassword(data === null || data === void 0 ? void 0 : data.password);
        setLoginTwoFactorCode(data === null || data === void 0 ? void 0 : data.twoFactorCode);
        if (!(data === null || data === void 0 ? void 0 : data.clientRef) && loginClient && loginClient !== "app") {
            console.log("Setting client ref to " + loginClient);
            data.clientRef = loginClient;
        }
        // already logging in? return
        if (loggingIn || !(data === null || data === void 0 ? void 0 : data.username) || !(data === null || data === void 0 ? void 0 : data.password)) return null;
        // set logging in to true
        setLoggingIn(true);
        // if subdomain is admin, authenticate admin login
        if (subdomain === "admin") {
            console.log("Admin login");
            return doAuthenticateAdminLogin(data);
        }
        // if subdomain is app, find companies for username
        if (subdomain === "app") {
            console.log("App login");
            if (data === null || data === void 0 ? void 0 : data.clientRef) {
                console.log("Client ref specified by user: " + (data === null || data === void 0 ? void 0 : data.clientRef));
                setClientRef(data === null || data === void 0 ? void 0 : data.clientRef);
                return doLoginClient(data === null || data === void 0 ? void 0 : data.clientRef, data);
            }
            return doFindCompanies(data);
        }
        // if we've got a client ref from URL, authenticate login
        if (initClientRef) {
            console.log("Login for subdomain: " + initClientRef);
            return doAuthenticateLogin(data);
        }
        // if we've got a client ref from login, authenticate login
        if (data === null || data === void 0 ? void 0 : data.clientRef) {
            console.log("Login for client: " + (data === null || data === void 0 ? void 0 : data.clientRef));
            doLoginClient(data === null || data === void 0 ? void 0 : data.clientRef, data);
        }
    };
    // for app - if multiple companies found, narrow down using email
    const doLoginEmail = (data)=>{
        console.log("Logging in with email: " + data.email + " and username: " + loginUsername);
        setLoggingIn(true);
        setLoginEmail(data.email);
        fetch("https://rest.yourhr.space/accounts/" + loginUsername + "?email=" + data.email, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                ...(0, _capacitor.getCapacitorHeaders)()
            }
        }).then((res)=>{
            if (res.ok) return res.text().then((accounts)=>{
                var _companies_accounts, _companies_accounts1;
                const companies = JSON.parse(accounts);
                if ((companies === null || companies === void 0 ? void 0 : (_companies_accounts = companies.accounts) === null || _companies_accounts === void 0 ? void 0 : _companies_accounts.length) === 1) {
                    const foundClientRef = companies.accounts[0].clientRef;
                    console.log("Found company: " + foundClientRef);
                    localStorage.setItem("clientRef", foundClientRef);
                    setLoginClient(foundClientRef);
                    doAuthenticateLogin({
                        username: loginUsername,
                        password: loginPassword,
                        twoFactorCode: loginTwoFactorCode
                    }, foundClientRef);
                } else if ((companies === null || companies === void 0 ? void 0 : (_companies_accounts1 = companies.accounts) === null || _companies_accounts1 === void 0 ? void 0 : _companies_accounts1.length) > 1) {
                    console.log("Multiple companies found - user to select from list", companies === null || companies === void 0 ? void 0 : companies.accounts);
                    setLoggingIn(false);
                    const companiesList = JSON.stringify(companies === null || companies === void 0 ? void 0 : companies.accounts);
                    localStorage.setItem("clientsList", companiesList);
                    setLoginCompanies(companies === null || companies === void 0 ? void 0 : companies.accounts);
                    setSlideClass("login-container--slides__slide3");
                } else {
                    console.log("No companies found");
                    setLoginError("\uD83D\uDE15 Oh dear - we were unable to find your account. Have you mistyped something?");
                    resetLoginErrorTimeout();
                    setLoggingIn(false);
                }
            });
            else return res.text().then((errMsg)=>{
                console.error(err);
                setLoggingIn(false);
            });
        }).catch((err1)=>{
            setLoggingIn(true);
            console.error(err1);
            setLoggingIn(false);
        });
    };
    const doLoginClient = (clientRef, data = {})=>{
        // client = clientRef || loginClient;
        const twoFactorCode = (data === null || data === void 0 ? void 0 : data.twoFactorCode) || loginTwoFactorCode;
        const authData = {
            username: (data === null || data === void 0 ? void 0 : data.username) || loginUsername,
            password: (data === null || data === void 0 ? void 0 : data.password) || loginPassword
        };
        if (twoFactorCode) authData.twoFactorCode = twoFactorCode;
        console.log("Setting client and logging in for client: " + clientRef, authData);
        localStorage.setItem("clientRef", clientRef);
        setLoginClient(clientRef);
        setLoggingIn(true);
        doAuthenticateLogin(authData, clientRef);
    };
    const doResetLogin = ()=>{
        setSlideClass(null);
        setLoginError(null);
        setLoginTwoFactorNeeded(false);
        setLoggingIn(false);
        setLoginUsername(null);
        setLoginPassword(null);
    };
    const containerClass = subdomain === "admin" ? "login-container login-container__admin" : "login-container";
    const slidesClass = "login-container--slides" + (slideClass ? ` ${slideClass}` : "");
    const logoClient = loginClient === "master" && subdomain === "app" ? "app" : loginClient;
    const isAccountOK = !!(account || clientDetails || subdomain === "admin" || subdomain === "app");
    const isModalLoading = !!isConfigLoading;
    const doShowHelp = ()=>{
        setHelpTextTitle("Trouble logging in");
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: containerClass,
                children: [
                    isAccountLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _throbberDefault.default), {}),
                    !isAccountLoading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "login-container--panel",
                        children: [
                            !isAccountOK && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoDefault.default), {
                                        clientRef: "app"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                        children: "Have you mistyped your URL?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                            className: "button-unstyled button-unstyled__link button-unstyled__flex",
                                            onClick: doShowHelp,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.Question), {}),
                                                " Help and information"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            isAccountOK && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "login-container--logo",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoDefault.default), {
                                            clientRef: logoClient
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                        className: "login-container--title",
                                        children: "Welcome to YourHR.space"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: slidesClass,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoginUsernamePassword, {
                                                loggingIn: loggingIn,
                                                clientsList: loginCompanies,
                                                clientRef: loginClient,
                                                twoFactorNeeded: loginTwoFactorNeeded,
                                                showingModal: !!helpTextTitle,
                                                onLogin: doLogin,
                                                onShowModal: setHelpTextTitle,
                                                onRestart: doResetLogin
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoginEmail, {
                                                onLogin: doLoginEmail,
                                                loggingIn: loggingIn,
                                                email: loginEmail
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoginClientSelect, {
                                                onLogin: doLoginClient,
                                                loggingIn: loggingIn,
                                                clientsList: loginCompanies,
                                                clientRef: loginClient
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    loginError && !helpTextTitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                        message: loginError
                    })
                ]
            }),
            helpTextTitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalContentDefault.default), {
                content: helpText,
                loading: isModalLoading,
                type: helpTextTitle === "Forgotten password" ? "resetPassword" : "content",
                onClose: ()=>{
                    setHelpTextTitle(null);
                }
            })
        ]
    });
};
const LoginUsernamePassword = ({ loggingIn, clientsList, twoFactorNeeded, showingModal = false, onShowModal, onLogin, onRestart })=>{
    var _errors_twoFactorCode, _errors_username, _errors_password;
    const subdomain = (0, _useStoreDefault.default)((state)=>state.subdomain);
    const { register, handleSubmit, watch, formState: { errors } } = (0, _reactHookForm.useForm)({
        mode: "onBlur"
    });
    const clientsSelect = subdomain && subdomain === "app" && clientsList && Array.isArray(clientsList) ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("select", {
        className: "login-container--input",
        disabled: loggingIn,
        placeholder: "Organisation",
        "aria-label": "Organisation",
        name: "clientRef",
        defaultValue: "",
        required: true,
        ...register("clientRef", {
            required: {
                value: false
            }
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                value: "",
                disabled: true,
                hidden: true,
                children: "Organisation:"
            }),
            clientsList === null || clientsList === void 0 ? void 0 : clientsList.map((client, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                    value: client.clientRef,
                    children: client.description
                }, key))
        ]
    }) : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            onSubmit: handleSubmit(onLogin),
            className: "login-container--slide",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    className: "login-container--heading",
                    children: "Login"
                }),
                twoFactorNeeded ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                children: "You have been emailed a security code."
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: "Please check your email, and enter the provided code below"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tipMessageDefault.default), {
                            content: errors === null || errors === void 0 ? void 0 : (_errors_twoFactorCode = errors.twoFactorCode) === null || _errors_twoFactorCode === void 0 ? void 0 : _errors_twoFactorCode.message,
                            visible: !showingModal && (errors === null || errors === void 0 ? void 0 : errors.twoFactorCode) ? true : false,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                className: "login-container--input",
                                disabled: loggingIn,
                                placeholder: "Enter 6-digit security code",
                                type: "number",
                                "aria-label": "Please enter security code",
                                autoFocus: true,
                                required: true,
                                name: "twoFactorCode",
                                ...register("twoFactorCode", {
                                    required: {
                                        value: true,
                                        message: "Please enter the security code as provided by email"
                                    }
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tipMessageDefault.default), {
                            content: errors === null || errors === void 0 ? void 0 : (_errors_username = errors.username) === null || _errors_username === void 0 ? void 0 : _errors_username.message,
                            visible: !showingModal && (errors === null || errors === void 0 ? void 0 : errors.username) ? true : false,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                className: "login-container--input",
                                disabled: loggingIn,
                                placeholder: "Username",
                                type: "text",
                                "aria-label": "Username",
                                autoFocus: true,
                                required: true,
                                name: "username",
                                ...register("username", {
                                    required: {
                                        value: true,
                                        message: "Please enter a username"
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tipMessageDefault.default), {
                            content: errors === null || errors === void 0 ? void 0 : (_errors_password = errors.password) === null || _errors_password === void 0 ? void 0 : _errors_password.message,
                            visible: !showingModal && (errors === null || errors === void 0 ? void 0 : errors.password) ? true : false,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                className: "login-container--input",
                                disabled: loggingIn,
                                placeholder: "Password",
                                type: "password",
                                "aria-label": "Password",
                                required: true,
                                name: "password",
                                ...register("password", {
                                    required: {
                                        value: true,
                                        message: "Please enter a password"
                                    }
                                })
                            })
                        }),
                        clientsSelect
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "login-container--buttons-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _submitButtonDefault.default), {
                            label: "Sign in",
                            labelDisabled: "Signing in...",
                            disabled: loggingIn,
                            isForm: true,
                            onSubmit: handleSubmit(onLogin)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "login-container--links",
                            children: subdomain !== "admin" && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    twoFactorNeeded && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        onClick: onRestart,
                                        type: "button",
                                        className: "button-unstyled button-unstyled__link button-unstyled__underline",
                                        "aria-label": "Forgot your password?",
                                        children: "Return to login screen"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        onClick: ()=>{
                                            onShowModal("Forgotten password");
                                        },
                                        type: "button",
                                        className: "button-unstyled button-unstyled__link button-unstyled__underline",
                                        "aria-label": "Forgot your password?",
                                        children: "Forgot your password?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        onClick: ()=>{
                                            onShowModal("Trouble logging in");
                                        },
                                        type: "button",
                                        className: "button-unstyled button-unstyled__link button-unstyled__underline",
                                        "aria-label": "Trouble logging in?",
                                        children: "Trouble logging in?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        onClick: ()=>{
                                            onShowModal("Privacy policy");
                                        },
                                        type: "button",
                                        className: "button-unstyled button-unstyled__link button-unstyled__underline",
                                        "aria-label": "Privacy policy",
                                        children: "Privacy policy"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const LoginEmail = ({ loggingIn, email, onLogin })=>{
    var _errors_email;
    const { register, handleSubmit, formState: { errors } } = (0, _reactHookForm.useForm)({
        mode: "onBlur"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        onSubmit: handleSubmit(onLogin),
        className: "login-container--slide",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "login-container--heading",
                children: "Please enter your e-mail address"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tipMessageDefault.default), {
                content: errors === null || errors === void 0 ? void 0 : (_errors_email = errors.email) === null || _errors_email === void 0 ? void 0 : _errors_email.message,
                visible: (errors === null || errors === void 0 ? void 0 : errors.email) ? true : false,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    className: "login-container--input",
                    disabled: loggingIn,
                    placeholder: "myname@email.com",
                    type: "text",
                    "aria-label": "Registered e-mail address",
                    required: true,
                    name: "email",
                    defaultValue: email,
                    ...register("email", {
                        required: {
                            value: true,
                            message: "Please enter your email"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "login-container--buttons-container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _submitButtonDefault.default), {
                    label: "Sign in",
                    labelDisabled: "Signing in...",
                    disabled: loggingIn,
                    isForm: true,
                    onSubmit: handleSubmit(onLogin)
                })
            })
        ]
    });
};
const LoginClientSelect = ({ loggingIn, onLogin, clientsList, clientRef })=>{
    const clientButtons = clientsList && Array.isArray(clientsList) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: clientsList === null || clientsList === void 0 ? void 0 : clientsList.map((client, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _submitButtonDefault.default), {
                label: client.description,
                labelDisabled: "Signing in...",
                disabled: loggingIn && clientRef === client.clientRef,
                isForm: true,
                onSubmit: ()=>{
                    onLogin(client.clientRef);
                }
            }, key))
    }) : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "login-container--slide",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "login-container--buttons-container login-container--buttons-container__wide",
            children: clientButtons
        })
    });
};
exports.default = Login;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","react-hook-form":"9V3w9","akar-icons":"b8xdj","./components/common/tipMessage":"iTkkf","./components/hooks/useCustomNavigate":"5zfEN","./components/common/submitButton":"4bi2T","./components/logo":"6ETRJ","./components/common/error":"bKeff","./components/common/throbber":"c8mQZ","./components/common/modalContent":"kCwqK","./components/hooks/fetch/useFetchAccounts":"e8Uk6","./components/hooks/fetch/useFetchAdminConfig":"9sPBO","./components/hooks/useStore":"l1Yj7","./utilities/capacitor":"lTR78","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9V3w9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Controller", ()=>Controller);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "FormProvider", ()=>FormProvider);
parcelHelpers.export(exports, "FormStateSubscribe", ()=>FormStateSubscribe);
parcelHelpers.export(exports, "Watch", ()=>Watch);
parcelHelpers.export(exports, "appendErrors", ()=>appendErrors);
parcelHelpers.export(exports, "createFormControl", ()=>createFormControl);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "useController", ()=>useController);
parcelHelpers.export(exports, "useFieldArray", ()=>useFieldArray);
parcelHelpers.export(exports, "useForm", ()=>useForm);
parcelHelpers.export(exports, "useFormContext", ()=>useFormContext);
parcelHelpers.export(exports, "useFormState", ()=>useFormState);
parcelHelpers.export(exports, "useWatch", ()=>useWatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var isCheckBoxInput = (element)=>element.type === 'checkbox';
var isDateObject = (value1)=>value1 instanceof Date;
var isNullOrUndefined = (value1)=>value1 == null;
const isObjectType = (value1)=>typeof value1 === 'object';
var isObject = (value1)=>!isNullOrUndefined(value1) && !Array.isArray(value1) && isObjectType(value1) && !isDateObject(value1);
var getEventValue = (event)=>isObject(event) && event.target ? isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var isNameInFieldArray = (names, name)=>name.split('.').some((part, index, arr)=>!isNaN(Number(part)) && names.has(arr.slice(0, index).join('.')));
var isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function cloneObject(data) {
    if (data instanceof Date) return new Date(data);
    const isFileListInstance = typeof FileList !== 'undefined' && data instanceof FileList;
    if (isWeb && (data instanceof Blob || isFileListInstance)) return data;
    const isArray = Array.isArray(data);
    if (!isArray && !(isObject(data) && isPlainObject(data))) return data;
    const copy = isArray ? [] : Object.create(Object.getPrototypeOf(data));
    for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) copy[key] = cloneObject(data[key]);
    return copy;
}
const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
    SUBMIT: 'submit',
    TRIGGER: 'trigger',
    VALID: 'valid'
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
const ROOT_ERROR_TYPE = 'root';
const PROTOTYPE_KEYWORDS = [
    '__proto__',
    'constructor',
    'prototype'
];
const IS_KEY_RE = /^\w*$/;
var isKey = (value1)=>IS_KEY_RE.test(value1);
var isUndefined = (val)=>val === undefined;
const FIELD_PATH_RE = /[.[\]'"]/;
var stringToPath = (input)=>input.split(FIELD_PATH_RE).filter(Boolean);
var get = (object, path, defaultValue)=>{
    if (!path || !isObject(object)) return defaultValue;
    const paths = isKey(path) ? [
        path
    ] : stringToPath(path);
    if (paths.some((key)=>PROTOTYPE_KEYWORDS.includes(key))) return defaultValue;
    const result = paths.reduce((result, key)=>{
        return isNullOrUndefined(result) ? undefined : result[key];
    }, object);
    return isUndefined(result) || result === object ? isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var isBoolean = (value1)=>typeof value1 === 'boolean';
var isFunction = (value1)=>typeof value1 === 'function';
var set = (object, path, value1)=>{
    let index = -1;
    const tempPath = isKey(path) ? [
        path
    ] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (PROTOTYPE_KEYWORDS.includes(key)) return;
        object[key] = newValue;
        object = object[key];
    }
};
/**
 * Separate context for `control` to prevent unnecessary rerenders.
 * Internal hooks that only need control use this instead of full form context.
 */ const HookFormControlContext = (0, _reactDefault.default).createContext(null);
HookFormControlContext.displayName = 'HookFormControlContext';
/**
 * @internal Internal hook to access only control from context.
 */ const useFormControlContext = ()=>(0, _reactDefault.default).useContext(HookFormControlContext);
var getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {};
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
const useIsomorphicLayoutEffect = isWeb ? (0, _reactDefault.default).useLayoutEffect : (0, _reactDefault.default).useEffect;
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function useFormState(props) {
    const formControl = useFormControlContext();
    const { control = formControl, disabled, name, exact } = props || {};
    const [formState, updateFormState] = (0, _reactDefault.default).useState(()=>({
            ...control._formState,
            defaultValues: control._defaultValues
        }));
    const _localProxyFormState = (0, _reactDefault.default).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    useIsomorphicLayoutEffect(()=>control._subscribe({
            name,
            formState: _localProxyFormState.current,
            exact,
            callback: (formState)=>{
                !disabled && updateFormState({
                    ...control._formState,
                    ...formState,
                    defaultValues: control._defaultValues
                });
            }
        }), [
        name,
        disabled,
        exact
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        _localProxyFormState.current.isValid && control._setValid(true);
    }, [
        control
    ]);
    return (0, _reactDefault.default).useMemo(()=>getProxyFormState(formState, control, _localProxyFormState.current, false), [
        formState,
        control
    ]);
}
var isString = (value1)=>typeof value1 === 'string';
var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
var isPrimitive = (value1)=>isNullOrUndefined(value1) || !isObjectType(value1);
const isEmptyObjectWithCustomPrototype = (object, keys)=>keys.length === 0 && !Array.isArray(object) && !isPlainObject(object);
function deepEqual(object1, object2, visited = new WeakMap()) {
    if (object1 === object2) return true;
    if (isPrimitive(object1) || isPrimitive(object2)) return Object.is(object1, object2);
    if (isDateObject(object1) && isDateObject(object2)) return Object.is(object1.getTime(), object2.getTime());
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    if (isEmptyObjectWithCustomPrototype(object1, keys1) || isEmptyObjectWithCustomPrototype(object2, keys2)) return Object.is(object1, object2);
    if (!keys1.length && Array.isArray(object1) !== Array.isArray(object2)) return false;
    const visitedPairs = visited.get(object1);
    if (visitedPairs && visitedPairs.has(object2)) return true;
    if (visitedPairs) visitedPairs.add(object2);
    else {
        const ws = new WeakSet();
        ws.add(object2);
        visited.set(object1, ws);
    }
    for (const key of keys1){
        const val1 = object1[key];
        if (!(key in object2)) return false;
        if (key !== 'ref') {
            const val2 = object2[key];
            if (isDateObject(val1) && isDateObject(val2) || (isObject(val1) || Array.isArray(val1)) && (isObject(val2) || Array.isArray(val2)) ? !deepEqual(val1, val2, visited) : !Object.is(val1, val2)) return false;
        }
    }
    return true;
}
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function useWatch(props) {
    const formControl = useFormControlContext();
    const { control = formControl, name, defaultValue, disabled, exact, compute } = props || {};
    const _defaultValue = (0, _reactDefault.default).useRef(defaultValue);
    const _compute = (0, _reactDefault.default).useRef(compute);
    const _computeFormValues = (0, _reactDefault.default).useRef(undefined);
    const _prevControl = (0, _reactDefault.default).useRef(control);
    const _prevName = (0, _reactDefault.default).useRef(name);
    _compute.current = compute;
    const [value1, updateValue] = (0, _reactDefault.default).useState(()=>{
        const defaultValue = control._getWatch(name, _defaultValue.current);
        return _compute.current ? _compute.current(defaultValue) : defaultValue;
    });
    const getCurrentOutput = (0, _reactDefault.default).useCallback((values)=>{
        const formValues = generateWatchOutput(name, control._names, values || control._formValues, false, _defaultValue.current);
        return _compute.current ? _compute.current(formValues) : formValues;
    }, [
        control._formValues,
        control._names,
        name
    ]);
    const refreshValue = (0, _reactDefault.default).useCallback((values)=>{
        if (!disabled) {
            const formValues = generateWatchOutput(name, control._names, values || control._formValues, false, _defaultValue.current);
            if (_compute.current) {
                const computedFormValues = _compute.current(formValues);
                if (!deepEqual(computedFormValues, _computeFormValues.current)) {
                    updateValue(computedFormValues);
                    _computeFormValues.current = computedFormValues;
                }
            } else updateValue(formValues);
        }
    }, [
        control._formValues,
        control._names,
        disabled,
        name
    ]);
    useIsomorphicLayoutEffect(()=>{
        if (_prevControl.current !== control || !deepEqual(_prevName.current, name)) {
            _prevControl.current = control;
            _prevName.current = name;
            refreshValue();
        }
        return control._subscribe({
            name,
            formState: {
                values: true
            },
            exact,
            callback: (formState)=>{
                refreshValue(formState.values);
            }
        });
    }, [
        control,
        exact,
        name,
        refreshValue
    ]);
    (0, _reactDefault.default).useEffect(()=>control._removeUnmounted());
    // If name or control changed for this render, synchronously reflect the
    // latest value so callers (like useController) see the correct value
    // immediately on the same render.
    // Optimize: Check control reference first before expensive deepEqual
    const controlChanged = _prevControl.current !== control;
    const prevName = _prevName.current;
    // Cache the computed output to avoid duplicate calls within the same render
    // We include shouldReturnImmediate in deps to ensure proper recomputation
    const computedOutput = (0, _reactDefault.default).useMemo(()=>{
        if (disabled) return null;
        const nameChanged = !controlChanged && !deepEqual(prevName, name);
        const shouldReturnImmediate = controlChanged || nameChanged;
        return shouldReturnImmediate ? getCurrentOutput() : null;
    }, [
        disabled,
        controlChanged,
        name,
        prevName,
        getCurrentOutput
    ]);
    return computedOutput !== null ? computedOutput : value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function useController(props) {
    const formControl = useFormControlContext();
    const { name, disabled, control = formControl, shouldUnregister, defaultValue, exact = true } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const defaultValueMemo = (0, _reactDefault.default).useMemo(()=>get(control._formValues, name, get(control._defaultValues, name, defaultValue)), [
        control,
        name,
        defaultValue
    ]);
    const value1 = useWatch({
        control,
        name,
        defaultValue: defaultValueMemo,
        exact
    });
    const formState = useFormState({
        control,
        name,
        exact
    });
    const _props = (0, _reactDefault.default).useRef(props);
    const _proxyRef = (0, _reactDefault.default).useRef(null);
    const _registerProps = (0, _reactDefault.default).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    _props.current = props;
    const fieldState = (0, _reactDefault.default).useMemo(()=>Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!get(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!get(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!get(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!get(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>get(formState.errors, name)
            }
        }), [
        formState,
        name
    ]);
    const onChange = (0, _reactDefault.default).useCallback((event)=>{
        const value1 = getEventValue(event);
        if (!get(control._fields, name)) _registerProps.current = control.register(name, {
            ..._props.current.rules,
            value: value1
        });
        return _registerProps.current.onChange({
            target: {
                value: getEventValue(event),
                name: name
            },
            type: EVENTS.CHANGE
        });
    }, [
        name,
        control
    ]);
    const onBlur = (0, _reactDefault.default).useCallback(()=>_registerProps.current.onBlur({
            target: {
                value: get(control._formValues, name),
                name: name
            },
            type: EVENTS.BLUR
        }), [
        name,
        control._formValues
    ]);
    const ref = (0, _reactDefault.default).useCallback((elm)=>{
        if (elm) _proxyRef.current = {
            focus: ()=>isFunction(elm.focus) && elm.focus(),
            select: ()=>isFunction(elm.select) && elm.select(),
            setCustomValidity: (message)=>isFunction(elm.setCustomValidity) && elm.setCustomValidity(message),
            reportValidity: ()=>isFunction(elm.reportValidity) && elm.reportValidity()
        };
        const field = get(control._fields, name);
        if (field && field._f && elm) field._f.ref = _proxyRef.current;
    }, [
        control._fields,
        name
    ]);
    const field = (0, _reactDefault.default).useMemo(()=>({
            name,
            value: value1,
            ...isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange,
            onBlur,
            ref
        }), [
        name,
        disabled,
        formState.disabled,
        onChange,
        onBlur,
        ref,
        value1
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        control.register(name, {
            ..._props.current.rules,
            ...isBoolean(_props.current.disabled) ? {
                disabled: _props.current.disabled
            } : {}
        });
        const updateMounted = (name, value1)=>{
            const field = get(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = cloneObject(get(shouldUnregister ? control._defaultValues : control._options.values || control._defaultValues, name, get(control._options.defaultValues, name, _props.current.defaultValue)));
            set(control._defaultValues, name, value1);
            if (isUndefined(get(control._formValues, name))) set(control._formValues, name, value1);
        }
        !isArrayField && control.register(name);
        if (_proxyRef.current) {
            const field = get(control._fields, name);
            if (field && field._f) field._f.ref = _proxyRef.current;
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        control._setDisabledField({
            disabled,
            name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return (0, _reactDefault.default).useMemo(()=>({
            field,
            formState,
            fieldState
        }), [
        field,
        formState,
        fieldState
    ]);
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const Controller = (props)=>props.render(useController(props));
const flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if (isObjectType(obj[key]) && obj[key] !== null) {
        const nested = flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const HookFormContext = (0, _reactDefault.default).createContext(null);
HookFormContext.displayName = 'HookFormContext';
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const useFormContext = ()=>(0, _reactDefault.default).useContext(HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://react.dev/reference/react/useContext) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const FormProvider = ({ children, watch, getValues, getFieldState, setError, clearErrors, setValue, setValues, trigger, formState, resetField, reset, handleSubmit, unregister, control, register, setFocus, subscribe })=>{
    const memoizedValue = (0, _reactDefault.default).useMemo(()=>({
            watch,
            getValues,
            getFieldState,
            setError,
            clearErrors,
            setValue,
            setValues,
            trigger,
            formState,
            resetField,
            reset,
            handleSubmit,
            unregister,
            control,
            register,
            setFocus,
            subscribe
        }), [
        clearErrors,
        control,
        formState,
        getFieldState,
        getValues,
        handleSubmit,
        register,
        reset,
        resetField,
        setError,
        setFocus,
        setValue,
        setValues,
        subscribe,
        trigger,
        unregister,
        watch
    ]);
    return (0, _reactDefault.default).createElement(HookFormContext.Provider, {
        value: memoizedValue
    }, (0, _reactDefault.default).createElement(HookFormControlContext.Provider, {
        value: memoizedValue.control
    }, children));
};
const POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function Form(props) {
    const methods = useFormContext();
    const [mounted, setMounted] = (0, _reactDefault.default).useState(false);
    const { control = methods.control, onSubmit, children, action, method = POST_REQUEST, headers, encType, onError, render, onSuccess, validateStatus, ...rest } = props;
    const submit = (0, _reactDefault.default).useCallback(async (event)=>{
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = flatten(data);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data,
                event,
                method,
                formData,
                formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers['Content-Type'],
                    encType
                ].some((value1)=>value1 && value1.includes('json'));
                const response = await fetch(String(action), {
                    method,
                    headers: {
                        ...headers,
                        ...encType && encType !== 'multipart/form-data' ? {
                            'Content-Type': encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error
                });
            }
        })(event);
        if (hasError && control) {
            control._subjects.state.next({
                isSubmitSuccessful: false
            });
            control.setError('root.server', {
                type
            });
        }
    }, [
        control,
        onSubmit,
        method,
        action,
        headers,
        encType,
        validateStatus,
        onError,
        onSuccess
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, render({
        submit
    })) : (0, _reactDefault.default).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
const FormStateSubscribe = ({ control, disabled, exact, name, render })=>render(useFormState({
        control,
        name,
        disabled,
        exact
    }));
var appendErrors = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe
    };
};
function extractFormValues(fieldsState, formValues) {
    const values = {};
    for(const key in fieldsState)if (fieldsState.hasOwnProperty(key)) {
        const fieldState = fieldsState[key];
        const fieldValue = formValues[key];
        if (fieldState && isObject(fieldState) && fieldValue) {
            const nestedFieldsState = extractFormValues(fieldState, fieldValue);
            if (isObject(nestedFieldsState)) values[key] = nestedFieldsState;
        } else if (fieldsState[key]) values[key] = fieldValue;
    }
    return values;
}
var isEmptyObject = (value1)=>isObject(value1) && !Object.keys(value1).length;
var isFileInput = (element)=>element.type === 'file';
var isHTMLElement = (value1)=>{
    if (!isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var isMultipleSelect = (element)=>element.type === `select-multiple`;
var isRadioInput = (element)=>element.type === 'radio';
var isRadioOrCheckbox = (ref)=>isRadioInput(ref) || isCheckBoxInput(ref);
var live = (ref)=>isHTMLElement(ref) && ref.isConnected;
function baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length){
        if (isNullOrUndefined(object)) {
            object = undefined;
            break;
        }
        object = object[updatePath[index]];
        index++;
    }
    return object;
}
function isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) return false;
    }
    return true;
}
function unset(object, path) {
    if (isString(path) && Object.prototype.hasOwnProperty.call(object, path)) {
        delete object[path];
        return object;
    }
    const paths = Array.isArray(path) ? path : isKey(path) ? [
        path
    ] : stringToPath(path);
    const childObject = paths.length === 1 ? object : baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && (isObject(childObject) && isEmptyObject(childObject) || Array.isArray(childObject) && isEmptyArray(childObject))) unset(object, paths.slice(0, -1));
    return object;
}
var objectHasFunction = (data)=>{
    for(const key in data){
        if (isFunction(data[key])) return true;
    }
    return false;
};
function isTraversable(value1) {
    return Array.isArray(value1) || isObject(value1) && !objectHasFunction(value1);
}
function markFieldsDirty(data, fields = {}) {
    for(const key in data){
        const value1 = data[key];
        if (isTraversable(value1)) {
            fields[key] = Array.isArray(value1) ? [] : {};
            markFieldsDirty(value1, fields[key]);
        } else if (!isUndefined(value1)) fields[key] = true;
    }
    return fields;
}
function pruneDirtyFields(value1) {
    if (value1 === false) return undefined;
    if (value1 === true) return true;
    if (Array.isArray(value1)) {
        const result = value1.map((value1)=>pruneDirtyFields(value1));
        return result.some((value1)=>value1 !== undefined) ? result : undefined;
    }
    if (isObject(value1)) {
        const result = {};
        for(const key in value1){
            const pruned = pruneDirtyFields(value1[key]);
            if (!isUndefined(pruned)) result[key] = pruned;
        }
        return Object.keys(result).length ? result : undefined;
    }
    return undefined;
}
function getDirtyFields(data, formValues, dirtyFieldsFromValues) {
    if (!dirtyFieldsFromValues) dirtyFieldsFromValues = markFieldsDirty(formValues);
    for(const key in data){
        const value1 = data[key];
        if (isTraversable(value1)) {
            if (isUndefined(formValues) || isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = markFieldsDirty(value1, Array.isArray(value1) ? [] : {});
            else getDirtyFields(value1, isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else {
            const formValue = formValues[key];
            dirtyFieldsFromValues[key] = !deepEqual(value1, formValue);
        }
    }
    return pruneDirtyFields(dirtyFieldsFromValues) || {};
}
const defaultResult = {
    value: false,
    isValid: false
};
const validResult = {
    value: true,
    isValid: true
};
var getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !isUndefined(options[0].attributes.value) ? isUndefined(options[0].value) || options[0].value === '' ? validResult : {
            value: options[0].value,
            isValid: true
        } : validResult : defaultResult;
    }
    return defaultResult;
};
var getFieldValueAs = (value1, { valueAsNumber, valueAsDate, setValueAs })=>isUndefined(value1) ? value1 : valueAsNumber ? value1 === '' ? NaN : value1 ? +value1 : value1 : valueAsDate && isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
const defaultReturn = {
    isValid: false,
    value: null
};
var getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, defaultReturn) : defaultReturn;
function getFieldValue(_f) {
    const ref = _f.ref;
    if (isFileInput(ref)) return ref.files;
    if (isRadioInput(ref)) return getRadioValue(_f.refs).value;
    if (isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if (isCheckBoxInput(ref)) return getCheckboxValue(_f.refs).value;
    return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = get(_fields, name);
        field && set(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields,
        shouldUseNativeValidation
    };
};
var isRegex = (value1)=>value1 instanceof RegExp;
var getRuleValue = (rule)=>isUndefined(rule) ? rule : isRegex(rule) ? rule.source : isObject(rule) ? isRegex(rule.value) ? rule.value.source : rule.value : rule;
var getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
        isOnBlur: mode === VALIDATION_MODE.onBlur,
        isOnChange: mode === VALIDATION_MODE.onChange,
        isOnAll: mode === VALIDATION_MODE.all,
        isOnTouch: mode === VALIDATION_MODE.onTouched
    });
const ASYNC_FUNCTION = 'AsyncFunction';
var hasPromiseValidation = (fieldReference)=>{
    if (!fieldReference || !fieldReference.validate) return false;
    if (isFunction(fieldReference.validate)) return fieldReference.validate.constructor.name === ASYNC_FUNCTION;
    if (isObject(fieldReference.validate)) for(const key in fieldReference.validate){
        if (fieldReference.validate[key].constructor.name === ASYNC_FUNCTION) return true;
    }
    return false;
};
var hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
var isWatched = (name, _names, isBlurEvent)=>{
    if (isBlurEvent) return false;
    if (_names.watchAll || _names.watch.has(name)) return true;
    for (const watchName of _names.watch){
        if (name.startsWith(watchName) && name.charAt(watchName.length) === '.') return true;
    }
    return false;
};
const iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = get(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if (iterateFieldsByAction(currentField, action)) break;
                }
            } else if (isObject(currentField)) {
                if (iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
function schemaErrorLookup(errors, _fields, name) {
    const error = get(errors, name);
    if (error || isKey(name)) return {
        error,
        name
    };
    const names = name.split('.');
    while(names.length){
        const fieldName = names.join('.');
        const field = get(_fields, fieldName);
        const foundError = get(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        if (foundError && foundError.root && foundError.root.type) return {
            name: `${fieldName}.root`,
            error: foundError.root
        };
        names.pop();
    }
    return {
        name
    };
}
var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name, ...formState } = formStateData;
    const keys = Object.keys(formState);
    return !keys.length || isRoot && keys.length >= Object.keys(_proxyFormState).length || keys.find((key)=>_proxyFormState[key] === (!isRoot || VALIDATION_MODE.all));
};
var shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var unsetEmptyArray = (ref, name)=>!compact(get(ref, name)).length && unset(ref, name);
var updateFieldArrayRootError = (errors, error, name)=>{
    const existingErrors = get(errors, name);
    const fieldArrayErrors = Array.isArray(existingErrors) ? existingErrors : [];
    set(fieldArrayErrors, ROOT_ERROR_TYPE, error[name]);
    set(errors, name, fieldArrayErrors);
    return errors;
};
function getValidateError(result, ref, type = 'validate') {
    if (isString(result) || Array.isArray(result) && result.every(isString) || isBoolean(result) && !result) return {
        type,
        message: isString(result) ? result : '',
        ref
    };
}
var getValueAndMessage = (validationData)=>isObject(validationData) && !isRegex(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount } = field._f;
    const inputValue = get(formValues, name);
    if (!mount || disabledFieldNames.has(name)) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            const validityMessage = isBoolean(message) ? '' : message || '';
            if (refs) refs.forEach((ref)=>ref.setCustomValidity(validityMessage));
            else inputRef.setCustomValidity(validityMessage);
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || isFileInput(ref)) && isUndefined(ref.value) && isUndefined(inputValue) || isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue)) || isBoolean(inputValue) && !inputValue || isCheckBox && !getCheckboxValue(refs).isValid || isRadio && !getRadioValue(refs).isValid)) {
        const { value: value1, message } = isString(required) ? {
            value: !!required,
            message: required
        } : getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if (isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if (isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && (isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if (isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true
};
const FORM_ERROR_TYPE = 'form';
const DEFAULT_FORM_STATE = {
    submitCount: 0,
    isDirty: false,
    isReady: false,
    isValidating: false,
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {}
};
function createFormControl(props = {}) {
    let _options = {
        ...defaultOptions,
        ...props
    };
    let _formState = {
        ...cloneObject(DEFAULT_FORM_STATE),
        isLoading: isFunction(_options.defaultValues),
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = isObject(_options.defaultValues) || isObject(_options.values) ? cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false,
        keepIsValid: false
    };
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
        registerName: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    let _valuesSubscriberCount = 0;
    let _validationModeBeforeSubmit = getValidationModes(_options.mode);
    let _validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const defaultProxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _proxyFormState = {
        ...defaultProxyFormState
    };
    let _proxySubscribeFormState = {
        ..._proxyFormState
    };
    const _subjects = {
        array: createSubject(),
        state: createSubject()
    };
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _setValid = async (shouldUpdateValid)=>{
        if (_state.keepIsValid) return;
        if (!_options.disabled && (_proxyFormState.isValid || _proxySubscribeFormState.isValid || shouldUpdateValid)) {
            let isValid;
            if (_options.resolver) {
                isValid = isEmptyObject((await _runSchema()).errors);
                _updateIsValidating();
            } else isValid = await executeBuiltInValidation({
                fields: _fields,
                onlyCheckValid: true,
                eventType: EVENTS.VALID
            });
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields || _proxySubscribeFormState.isValidating || _proxySubscribeFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? set(_formState.validatingFields, name, isValidating) : unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _updateDirtyFields = ()=>{
        _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
    };
    const _setFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !_options.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get(_fields, name))) {
                const fieldValues = method(get(_fields, name), args.argA, args.argB);
                shouldSetValues && set(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray(get(_formState.errors, name))) {
                const errors = method(get(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if ((_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && shouldUpdateFieldsAndState && Array.isArray(get(_formState.touchedFields, name))) {
                const touchedFields = method(get(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) _updateDirtyFields();
            _subjects.state.next({
                name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else set(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        set(_formState.errors, name, error);
        _formState.errors = {
            ..._formState.errors
        };
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const hasExplicitNullIntermediate = (name)=>{
        const segments = isKey(name) ? [
            name
        ] : stringToPath(name);
        let formValues = _formValues;
        let defaultValues = _defaultValues;
        for(let i = 0; i < segments.length - 1; i++){
            const key = segments[i];
            formValues = isNullOrUndefined(formValues) ? formValues : formValues[key];
            defaultValues = isNullOrUndefined(defaultValues) ? defaultValues : defaultValues[key];
            if (formValues === null && defaultValues !== null) return true;
        }
        return false;
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = get(_fields, name);
        if (field) {
            if (hasExplicitNullIntermediate(name)) return;
            const wasUnsetInFormValues = isUndefined(get(_formValues, name));
            const defaultValue = get(_formValues, name, isUndefined(value1) ? get(_defaultValues, name) : value1);
            isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? set(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            if (_state.mount && !_state.action) {
                _setValid();
                if (wasUnsetInFormValues && _formState.isDirty && (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty)) {
                    const isDirty = _getDirty();
                    if (!isDirty) {
                        _formState.isDirty = false;
                        _subjects.state.next({
                            ..._formState
                        });
                    }
                }
                if (props.shouldUnregister && wasUnsetInFormValues && !isUndefined(get(_formValues, name)) && isWatched(name, _names)) _state.watch = true;
            }
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name
        };
        if (!_options.disabled) {
            if (!isBlurEvent || shouldDirty) {
                const isCurrentFieldPristine = deepEqual(get(_defaultValues, name), fieldValue);
                if (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = !isCurrentFieldPristine || _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                isPreviousDirty = !!get(_formState.dirtyFields, name);
                if (isCurrentFieldPristine !== _formState.isDirty) _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
                else isCurrentFieldPristine ? unset(_formState.dirtyFields, name) : set(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = get(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    set(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || (_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = get(_formState.errors, name);
        const shouldUpdateValid = (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isBoolean(isValid) && _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(_options.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? set(_formState.errors, name, error) : unset(_formState.errors, name);
            _formState.errors = {
                ..._formState.errors
            };
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) || !isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && isBoolean(isValid) ? {
                    isValid
                } : {},
                errors: _formState.errors,
                name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _runSchema = async (name)=>{
        _updateIsValidating(name, true);
        return await _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors } = await _runSchema(names);
        _updateIsValidating(names);
        if (names) {
            for (const name of names){
                const error = get(errors, name);
                error ? _names.array.has(name) && isObject(error) && !Object.keys(error).some((key)=>!Number.isNaN(Number(key))) ? updateFieldArrayRootError(_formState.errors, {
                    [name]: error
                }, name) : set(_formState.errors, name, error) : unset(_formState.errors, name);
            }
            _formState.errors = {
                ..._formState.errors
            };
        } else _formState.errors = errors;
        return errors;
    };
    const validateForm = async ({ name, eventType })=>{
        if (props.validate) {
            const result = await props.validate({
                formValues: _formValues,
                formState: _formState,
                name,
                eventType
            });
            if (isObject(result)) for(const key in result){
                const error = result[key];
                if (error) setError(`${FORM_ERROR_TYPE}.${key}`, {
                    message: isString(error.message) ? error.message : '',
                    type: error.type || INPUT_VALIDATION_RULES.validate
                });
            }
            else if (isString(result) || !result) setError(FORM_ERROR_TYPE, {
                message: result || '',
                type: INPUT_VALIDATION_RULES.validate
            });
            else clearErrors(FORM_ERROR_TYPE);
            return result;
        }
        return true;
    };
    const executeBuiltInValidation = async ({ fields, onlyCheckValid, name, eventType, context = {
        valid: true,
        runRootValidation: false
    } })=>{
        if (props.validate) {
            context.runRootValidation = true;
            const result = await validateForm({
                name,
                eventType
            });
            if (!result) {
                context.valid = false;
                if (onlyCheckValid) return context.valid;
            }
        }
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && hasPromiseValidation(field._f);
                    const shouldTrackIsValidatingState = _proxyFormState.validatingFields || _proxyFormState.isValidating || _proxySubscribeFormState.validatingFields || _proxySubscribeFormState.isValidating;
                    if (isPromiseFunction && shouldTrackIsValidatingState) _updateIsValidating([
                        _f.name
                    ], true);
                    const fieldError = await validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !onlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && shouldTrackIsValidatingState) _updateIsValidating([
                        _f.name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (onlyCheckValid) break;
                    }
                    !onlyCheckValid && (get(fieldError, _f.name) ? isFieldArrayRoot ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : set(_formState.errors, _f.name, fieldError[_f.name]) : unset(_formState.errors, _f.name));
                    if (props.shouldUseNativeValidation && fieldError[_f.name]) break;
                }
                !isEmptyObject(fieldValue) && await executeBuiltInValidation({
                    context,
                    onlyCheckValid,
                    fields: fieldValue,
                    name: name,
                    eventType
                });
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = get(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!live(ref)) : !live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!_options.disabled && (name && data && set(_formValues, name, data), !deepEqual(_state.mount ? _formValues : _defaultValues, _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : isUndefined(defaultValue) ? _defaultValues : isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>compact(get(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? get(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {}, skipClone = false, skipRender = false)=>{
        const field = get(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && set(_formValues, name, getFieldValueAs(value1, fieldReference));
                fieldValue = isHTMLElement(fieldReference.ref) && isNullOrUndefined(value1) ? '' : value1;
                if (isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) fieldReference.refs.forEach((checkboxRef)=>{
                        if (!checkboxRef.defaultChecked || !checkboxRef.disabled) {
                            if (Array.isArray(fieldValue)) checkboxRef.checked = !!fieldValue.find((data)=>data === checkboxRef.value);
                            else checkboxRef.checked = fieldValue === checkboxRef.value || !!fieldValue;
                        }
                    });
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if (isFileInput(fieldReference.ref)) fieldReference.ref.value = '';
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type && !skipRender) _subjects.state.next({
                        name,
                        values: skipClone ? _formValues : cloneObject(_formValues)
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, !skipRender);
        options.shouldValidate && trigger(name);
    };
    const setFieldValues = (name, value1, options, skipClone = false, skipRender = false)=>{
        for(const fieldKey in value1){
            if (!value1.hasOwnProperty(fieldKey)) return;
            const fieldValue = value1[fieldKey];
            const fieldName = name + '.' + fieldKey;
            const field = get(_fields, fieldName);
            (_names.array.has(name) || isObject(fieldValue) || field && !field._f) && !isDateObject(fieldValue) ? setFieldValues(fieldName, fieldValue, options, skipClone, skipRender) : setFieldValue(fieldName, fieldValue, options, skipClone, skipRender);
        }
    };
    const _setValue = (name, value1, options, skipClone, skipStateEmit = false)=>{
        const field = get(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = skipClone ? value1 : cloneObject(value1);
        const previousValue = get(_formValues, name);
        const isValueUnchanged = deepEqual(previousValue, cloneValue);
        if (!isValueUnchanged) set(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: skipClone ? _formValues : cloneObject(_formValues)
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields || _proxySubscribeFormState.isDirty || _proxySubscribeFormState.dirtyFields) && options.shouldDirty) {
                _updateDirtyFields();
                if (!skipStateEmit) _subjects.state.next({
                    name,
                    dirtyFields: _formState.dirtyFields,
                    isDirty: _getDirty(name, cloneValue)
                });
            }
        } else {
            const isEmpty = Array.isArray(cloneValue) && !cloneValue.length || isEmptyObject(cloneValue);
            if (!field || field._f || isNullOrUndefined(cloneValue) || isEmpty) setFieldValue(name, cloneValue, options, skipClone, skipStateEmit);
            else setFieldValues(name, cloneValue, options, skipClone, skipStateEmit);
        }
        if (!isValueUnchanged && !skipStateEmit) {
            const watched = isWatched(name, _names);
            const values = skipClone ? _formValues : cloneObject(_formValues);
            _subjects.state.next({
                ...watched && _formState,
                name: _state.mount || watched ? name : undefined,
                values
            });
        }
    };
    const setValue = (name, value1, options = {})=>_setValue(name, value1, options, false);
    const setValues = (formValues, options = {})=>{
        const updatedFormValues = isFunction(formValues) ? formValues(_formValues) : formValues;
        if (!deepEqual(_formValues, updatedFormValues)) {
            _formValues = {
                ..._formValues,
                ...updatedFormValues
            };
            for (const fieldName of _names.mount)_setValue(fieldName, get(updatedFormValues, fieldName), options, true, true);
            _subjects.state.next({
                ..._formState,
                name: undefined,
                type: undefined,
                ..._valuesSubscriberCount ? {
                    values: _formValues
                } : {}
            });
            if (options.shouldValidate) _setValid();
        }
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = get(_fields, name);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || deepEqual(fieldValue, get(_formValues, name, fieldValue));
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type ? getFieldValue(field._f) : getEventValue(event);
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const hasNoValidationEffect = !hasValidation(field._f) && !props.validate && !_options.resolver && !get(_formState.errors, name) && !field._f.deps;
            const shouldSkipValidation = hasNoValidationEffect || skipValidation(isBlurEvent, get(_formState.touchedFields, name), _formState.isSubmitted, _validationModeAfterSubmit, _validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set(_formValues, name, fieldValue);
            if (isBlurEvent) {
                if (!target || !target.readOnly) {
                    field._f.onBlur && field._f.onBlur(event);
                    delayErrorCallback && delayErrorCallback(0);
                }
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.state.next({
                name,
                type: event.type,
                ..._valuesSubscriberCount ? {
                    values: cloneObject(_formValues)
                } : {}
            });
            if (shouldSkipValidation) {
                if ((!hasNoValidationEffect || !_formState.isValid) && (_proxyFormState.isValid || _proxySubscribeFormState.isValid)) {
                    if (_options.mode === 'onBlur') {
                        if (isBlurEvent) _setValid();
                    } else if (!isBlurEvent) _setValid();
                }
                return shouldRender && _subjects.state.next({
                    name,
                    ...watched ? {} : fieldState
                });
            }
            if (!_options.resolver && props.validate) await validateForm({
                name: name,
                eventType: event.type
            });
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors } = await _runSchema([
                    name
                ]);
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (!isFieldValueUpdated) {
                    !isEmptyObject(fieldState) && _subjects.state.next(fieldState);
                    return;
                }
                const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = isEmptyObject(errors);
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) isValid = await executeBuiltInValidation({
                        fields: _fields,
                        onlyCheckValid: true,
                        name: name,
                        eventType: event.type
                    });
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && (!Array.isArray(field._f.deps) || field._f.deps.length > 0) && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if (get(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>get(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = get(_fields, fieldName);
                return await executeBuiltInValidation({
                    fields: field && field._f ? {
                        [fieldName]: field
                    } : field,
                    eventType: EVENTS.TRIGGER
                });
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _setValid();
        } else validationResult = isValid = await executeBuiltInValidation({
            fields: _fields,
            name,
            eventType: EVENTS.TRIGGER
        });
        _subjects.state.next({
            ...!isString(name) || (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isValid !== _formState.isValid ? {} : {
                name
            },
            ..._options.resolver || !name ? {
                isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames, config)=>{
        let values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        if (config) values = extractFormValues(config.dirtyFields ? _formState.dirtyFields : _formState.touchedFields, values);
        return isUndefined(fieldNames) ? values : isString(fieldNames) ? get(values, fieldNames) : fieldNames.map((name)=>get(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!get((formState || _formState).errors, name),
            isDirty: !!get((formState || _formState).dirtyFields, name),
            error: get((formState || _formState).errors, name),
            isValidating: !!get(_formState.validatingFields, name),
            isTouched: !!get((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        const names = name ? convertToArrayPayload(name) : undefined;
        names === null || names === void 0 || names.forEach((inputName)=>unset(_formState.errors, inputName));
        if (names) names.forEach((inputName)=>{
            _subjects.state.next({
                name: inputName,
                errors: _formState.errors
            });
        });
        else _subjects.state.next({
            errors: {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = (get(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = get(_formState.errors, name) || {};
        const { ref: currentRef, message, type, ...restOfErrorTree } = currentError;
        set(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>{
        if (isFunction(name)) {
            _valuesSubscriberCount++;
            const { unsubscribe } = _subjects.state.subscribe({
                next: (payload)=>'values' in payload && name(payload.values || _getWatch(undefined, defaultValue), payload)
            });
            let called = false;
            return {
                unsubscribe: ()=>{
                    if (called) return;
                    called = true;
                    _valuesSubscriberCount--;
                    unsubscribe();
                }
            };
        }
        return _getWatch(name, defaultValue, true);
    };
    const _subscribe = (props)=>{
        var _a;
        const needsValues = !!((_a = props.formState) === null || _a === void 0 ? void 0 : _a.values);
        if (needsValues) _valuesSubscriberCount++;
        const { unsubscribe } = _subjects.state.subscribe({
            next: (formState)=>{
                if (shouldSubscribeByName(props.name, formState.name, props.exact) && shouldRenderFormState(formState, props.formState || _proxyFormState, _setFormState, props.reRenderRoot)) {
                    const snapshot = {
                        ..._formValues
                    };
                    props.callback({
                        values: snapshot,
                        ..._formState,
                        ...formState,
                        defaultValues: _defaultValues
                    });
                }
            }
        });
        if (!needsValues) return unsubscribe;
        let called = false;
        return ()=>{
            if (called) return;
            called = true;
            _valuesSubscriberCount--;
            unsubscribe();
        };
    };
    const subscribe = (props)=>{
        _state.mount = true;
        _proxySubscribeFormState = {
            ..._proxySubscribeFormState,
            ...props.formState
        };
        return _subscribe({
            ...props,
            formState: {
                ...defaultProxyFormState,
                ...props.formState
            }
        });
    };
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                unset(_fields, fieldName);
                unset(_formValues, fieldName);
            }
            !options.keepError && unset(_formState.errors, fieldName);
            !options.keepDirty && unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && unset(_defaultValues, fieldName);
        }
        _subjects.state.next({
            values: cloneObject(_formValues)
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _setValid();
    };
    const _setDisabledField = ({ disabled, name })=>{
        if (isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) {
            const wasDisabled = _names.disabled.has(name);
            const isDisabled = !!disabled;
            const disabledStateChanged = wasDisabled !== isDisabled;
            disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
            disabledStateChanged && _state.mount && !_state.action && _setValid();
        }
    };
    const register = (name, options = {})=>{
        let field = get(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled) || isBoolean(_options.disabled);
        const shouldRevalidateRemount = !_names.registerName.has(name) && field && field._f && !field._f.mount;
        set(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name
                    }
                },
                name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field && !shouldRevalidateRemount) _setDisabledField({
            disabled: isBoolean(options.disabled) ? options.disabled : _options.disabled,
            name
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled || _options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: getRuleValue(options.min),
                max: getRuleValue(options.max),
                minLength: getRuleValue(options.minLength),
                maxLength: getRuleValue(options.maxLength),
                pattern: getRuleValue(options.pattern)
            } : {},
            name,
            onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    _names.registerName.add(name);
                    register(name, options);
                    _names.registerName.delete(name);
                    field = get(_fields, name);
                    const fieldRef = isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    set(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter(live),
                                    fieldRef,
                                    ...Array.isArray(get(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = get(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !(isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && !_options.shouldUseNativeValidation && iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if (isBoolean(disabled)) {
            _subjects.state.next({
                disabled
            });
            iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = get(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors, values } = await _runSchema();
                _updateIsValidating();
                _formState.errors = errors;
                fieldValues = cloneObject(values);
            } else await executeBuiltInValidation({
                fields: _fields,
                eventType: EVENTS.SUBMIT
            });
            if (_names.disabled.size) for (const name of _names.disabled)unset(fieldValues, name);
            unset(_formState.errors, ROOT_ERROR_TYPE);
            if (isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if (get(_fields, name)) {
            if (isUndefined(options.defaultValue)) setValue(name, cloneObject(get(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                set(_defaultValues, name, cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, cloneObject(get(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _setValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const isEmptyResetValues = isEmptyObject(formValues);
        const values = cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys(getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck)){
                    const isDirty = get(_formState.dirtyFields, fieldName);
                    const existingValue = get(_formValues, fieldName);
                    const newValue = get(values, fieldName);
                    if (isDirty && !isUndefined(existingValue)) set(values, fieldName, existingValue);
                    else if (!isDirty && !isUndefined(newValue)) setValue(fieldName, newValue);
                }
            } else {
                if (isWeb && isUndefined(formValues)) for (const name of _names.mount){
                    const field = get(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if (isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest('form');
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                if (keepStateOptions.keepFieldsRef) for (const fieldName of _names.mount)setValue(fieldName, get(values, fieldName));
                else _fields = {};
            }
            if (_options.shouldUnregister) {
                _formValues = keepStateOptions.keepDefaultValues ? cloneObject(_defaultValues) : {};
                if (keepStateOptions.keepFieldsRef) for (const fieldName of _names.mount)set(_formValues, fieldName, get(values, fieldName));
            } else _formValues = cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.state.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            registerName: new Set(),
            disabled: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ''
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues || !_options.shouldUnregister && !isEmptyObject(values);
        _state.watch = !!_options.shouldUnregister;
        _state.keepIsValid = !!keepStateOptions.keepIsValid;
        _state.action = false;
        if (!keepStateOptions.keepErrors) _formState.errors = {};
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : keepStateOptions.keepValues ? _getDirty() : !!(keepStateOptions.keepDefaultValues && !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false,
            defaultValues: _defaultValues
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset(isFunction(formValues) ? formValues(_formValues) : formValues, {
            ..._options.resetOptions,
            ...keepStateOptions
        });
    const setFocus = (name, options = {})=>{
        const field = get(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) setTimeout(()=>{
                fieldRef.focus();
                options.shouldSelect && isFunction(fieldRef.select) && fieldRef.select();
            });
        }
    };
    const _setFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    const resetDefaultValues = (values, options = {})=>{
        _defaultValues = cloneObject(values);
        if (!options.keepDirty) {
            const newDirtyFields = getDirtyFields(_defaultValues, _formValues);
            _formState.dirtyFields = newDirtyFields;
            _formState.isDirty = !isEmptyObject(newDirtyFields);
        }
        if (!options.keepIsValid) _setValid();
        _subjects.state.next({
            ..._formState,
            defaultValues: _defaultValues
        });
    };
    const methods = {
        control: {
            register,
            unregister,
            getFieldState,
            handleSubmit,
            setError,
            _subscribe,
            _runSchema,
            _updateIsValidating,
            _focusError,
            _getWatch,
            _getDirty,
            _setValid,
            _setFieldArray,
            _setDisabledField,
            _setErrors,
            _getFieldArray,
            _reset,
            _resetDefaultValues,
            _removeUnmounted,
            _disableForm,
            _subjects,
            _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
                _validationModeBeforeSubmit = getValidationModes(_options.mode);
                _validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
            }
        },
        subscribe,
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        setValues,
        getValues,
        reset,
        resetField,
        resetDefaultValues,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState
    };
    return {
        ...methods,
        formControl: methods
    };
}
var generateId = ()=>{
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
var getFocusFieldName = (name, index, options = {})=>options.shouldFocus || isUndefined(options.shouldFocus) ? options.focusName || `${name}.${isUndefined(options.focusIndex) ? index : options.focusIndex}.` : '';
var appendAt = (data, value1)=>[
        ...data,
        ...convertToArrayPayload(value1)
    ];
var fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if (isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var prependAt = (data, value1)=>[
        ...convertToArrayPayload(value1),
        ...convertToArrayPayload(data)
    ];
function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index)=>isUndefined(index) ? [] : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b)=>a - b));
var swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
var updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function useFieldArray(props) {
    const formControl = useFormControlContext();
    const { control = formControl, name, keyName = 'id', disabled, shouldUnregister, rules } = props;
    const [fields, setFields] = (0, _reactDefault.default).useState(control._getFieldArray(name));
    const ids = (0, _reactDefault.default).useRef(control._getFieldArray(name).map(generateId));
    const _actioned = (0, _reactDefault.default).useRef(false);
    if (!disabled) control._names.array.add(name);
    (0, _reactDefault.default).useMemo(()=>!disabled && rules && fields.length >= 0 && control.register(name, rules), [
        control,
        name,
        fields.length,
        rules,
        disabled
    ]);
    useIsomorphicLayoutEffect(()=>{
        if (disabled) return;
        return control._subjects.array.subscribe({
            next: ({ values, name: fieldArrayName })=>{
                if (fieldArrayName === name || !fieldArrayName) {
                    const fieldValues = get(values, name);
                    if (Array.isArray(fieldValues)) {
                        setFields(fieldValues);
                        ids.current = fieldValues.map(generateId);
                    } else if (!fieldArrayName) {
                        setFields([]);
                        ids.current = [];
                    }
                }
            }
        }).unsubscribe;
    }, [
        control,
        name,
        disabled
    ]);
    const updateValues = (0, _reactDefault.default).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._setFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        if (disabled) return;
        const appendValue = convertToArrayPayload(cloneObject(value1));
        const updatedFieldArrayValues = appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = appendAt(ids.current, appendValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, appendAt, {
            argA: fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        if (disabled) return;
        const prependValue = convertToArrayPayload(cloneObject(value1));
        const updatedFieldArrayValues = prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = getFocusFieldName(name, 0, options);
        ids.current = prependAt(ids.current, prependValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, prependAt, {
            argA: fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        if (disabled) return;
        const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
        ids.current = removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        !Array.isArray(get(control._fields, name)) && set(control._fields, name, undefined);
        control._setFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        if (disabled) return;
        const insertValue = convertToArrayPayload(cloneObject(value1));
        const updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = getFocusFieldName(name, index, options);
        ids.current = insert(ids.current, index, insertValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, insert, {
            argA: index,
            argB: fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        if (disabled) return;
        const updatedFieldArrayValues = control._getFieldArray(name);
        swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        if (disabled) return;
        const updatedFieldArrayValues = control._getFieldArray(name);
        moveArrayAt(updatedFieldArrayValues, from, to);
        moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        if (disabled) return;
        const updateValue = cloneObject(value1);
        const updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, updatedFieldArrayValues, updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        if (disabled) return;
        const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value1));
        ids.current = updatedFieldArrayValues.map(generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, _reactDefault.default).useEffect(()=>{
        if (disabled) return;
        control._state.action = false;
        isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        const validationModes = getValidationModes(control._options.mode);
        if (_actioned.current && (!validationModes.isOnSubmit || control._formState.isSubmitted) && !getValidationModes(control._options.reValidateMode).isOnSubmit && !validationModes.isOnBlur) {
            if (control._options.resolver) control._runSchema([
                name
            ]).then((result)=>{
                control._updateIsValidating([
                    name
                ]);
                const error = get(result.errors, name);
                const existingError = get(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? set(control._formState.errors, name, error) : unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = get(control._fields, name);
                if (field && field._f && !(getValidationModes(control._options.reValidateMode).isOnSubmit && getValidationModes(control._options.mode).isOnSubmit)) validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!isEmptyObject(error) && control._subjects.state.next({
                        errors: updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.state.next({
            name,
            values: cloneObject(control._formValues)
        });
        control._names.focus && iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = '';
        control._setValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control,
        disabled
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (!disabled) !get(control._formValues, name) && control._setFieldArray(name);
        return ()=>{
            if (disabled) return;
            const shouldKeepFieldArrayValues = !(control._options.shouldUnregister || shouldUnregister);
            const updateMounted = (name, value1)=>{
                const field = get(control._fields, name);
                if (field && field._f) field._f.mount = value1;
            };
            if (_actioned.current && shouldKeepFieldArrayValues) control._subjects.state.next({
                name,
                values: cloneObject(control._formValues)
            });
            shouldKeepFieldArrayValues ? updateMounted(name, false) : control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister,
        disabled
    ]);
    return {
        swap: (0, _reactDefault.default).useCallback(swap, [
            updateValues,
            name,
            control,
            disabled
        ]),
        move: (0, _reactDefault.default).useCallback(move, [
            updateValues,
            name,
            control,
            disabled
        ]),
        prepend: (0, _reactDefault.default).useCallback(prepend, [
            updateValues,
            name,
            control,
            disabled
        ]),
        append: (0, _reactDefault.default).useCallback(append, [
            updateValues,
            name,
            control,
            disabled
        ]),
        remove: (0, _reactDefault.default).useCallback(remove, [
            updateValues,
            name,
            control,
            disabled
        ]),
        insert: (0, _reactDefault.default).useCallback(insert$1, [
            updateValues,
            name,
            control,
            disabled
        ]),
        update: (0, _reactDefault.default).useCallback(update, [
            updateValues,
            name,
            control,
            disabled
        ]),
        replace: (0, _reactDefault.default).useCallback(replace, [
            updateValues,
            name,
            control,
            disabled
        ]),
        fields: (0, _reactDefault.default).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    ...isBoolean(disabled) ? {
                        disabled
                    } : {},
                    [keyName]: ids.current[index] || generateId()
                })), [
            fields,
            keyName,
            disabled
        ])
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function useForm(props = {}) {
    const _formControl = (0, _reactDefault.default).useRef(undefined);
    const _values = (0, _reactDefault.default).useRef(undefined);
    const _formControlProp = (0, _reactDefault.default).useRef(props.formControl);
    const [formState, updateFormState] = (0, _reactDefault.default).useState(()=>({
            ...cloneObject(DEFAULT_FORM_STATE),
            isLoading: isFunction(props.defaultValues),
            errors: props.errors || {},
            disabled: props.disabled || false,
            defaultValues: isFunction(props.defaultValues) ? undefined : props.defaultValues
        }));
    if (!_formControl.current || props.formControl && _formControlProp.current !== props.formControl) {
        _formControlProp.current = props.formControl;
        if (props.formControl) {
            _formControl.current = {
                ...props.formControl,
                formState
            };
            if (props.defaultValues && !isFunction(props.defaultValues)) props.formControl.reset(props.defaultValues, props.resetOptions);
        } else {
            const { formControl, ...rest } = createFormControl(props);
            _formControl.current = {
                ...rest,
                formState
            };
        }
    }
    const control = _formControl.current.control;
    control._options = props;
    useIsomorphicLayoutEffect(()=>{
        const sub = control._subscribe({
            formState: control._proxyFormState,
            callback: ()=>updateFormState({
                    ...control._formState,
                    defaultValues: control._defaultValues
                }),
            reRenderRoot: true
        });
        updateFormState((data)=>({
                ...data,
                isReady: true
            }));
        control._formState.isReady = true;
        return sub;
    }, [
        control
    ]);
    (0, _reactDefault.default).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (props.mode) control._options.mode = props.mode;
        if (props.reValidateMode) control._options.reValidateMode = props.reValidateMode;
    }, [
        control,
        props.mode,
        props.reValidateMode
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (props.errors) {
            control._setErrors(props.errors);
            control._focusError();
        }
    }, [
        control,
        props.errors
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        props.shouldUnregister && control._subjects.state.next({
            values: control._getWatch()
        });
    }, [
        control,
        props.shouldUnregister
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        var _a;
        if (props.values && !deepEqual(props.values, _values.current)) {
            control._reset(props.values, {
                keepFieldsRef: true,
                ...control._options.resetOptions
            });
            if (!((_a = control._options.resetOptions) === null || _a === void 0 ? void 0 : _a.keepIsValid)) control._setValid();
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        control,
        props.values
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (!control._state.mount) {
            control._setValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = (0, _reactDefault.default).useMemo(()=>getProxyFormState(formState, control), [
        control,
        formState
    ]);
    return _formControl.current;
}
/**
 * Watch component that subscribes to form field changes and re-renders when watched fields update.
 *
 * @param control - The form control object from useForm
 * @param name - Can be field name, array of field names, or undefined to watch the entire form
 * @param disabled - Disable subscription
 * @param exact - Whether to watch exact field names or not
 * @param defaultValue - The default value to use if the field is not yet set
 * @param compute - Function to compute derived values from watched fields
 * @param render - The function that receives watched values and returns ReactNode
 * @returns The result of calling render function with watched values
 *
 * @example
 * The `Watch` component only re-render when the values of `foo`, `bar`, and `baz.qux` change.
 * The types of `foo`, `bar`, and `baz.qux` are precisely inferred.
 *
 * ```tsx
 * const { control } = useForm();
 *
 * <Watch
 *   control={control}
 *   names={['foo', 'bar', 'baz.qux']}
 *   render={([foo, bar, baz_qux]) => <div>{foo}{bar}{baz_qux}</div>}
 * />
 * ```
 */ const Watch = (props)=>props.render(useWatch({
        name: props.names,
        ...props
    }));

},{"react":"6wC8C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"b8xdj":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var React = require("2328eaf961e3276f");
var PropTypes = require("7ccc74630ac05605");
function _interopDefaultLegacy(e) {
    return e && typeof e === 'object' && 'default' in e ? e : {
        'default': e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/ _interopDefaultLegacy(PropTypes);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var _excluded$6N = [
    "color",
    "size"
];
var ArrowLeft = function ArrowLeft(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6N);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11 5l-7 7 7 7"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 12h16"
    }));
};
ArrowLeft.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6M = [
    "color",
    "size"
];
var ArrowRight = function ArrowRight(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6M);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 12h16"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13 5l7 7-7 7"
    }));
};
ArrowRight.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6L = [
    "color",
    "size"
];
var ArrowUp = function ArrowUp(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6L);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 20V4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 11l7-7 7 7"
    }));
};
ArrowUp.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6K = [
    "color",
    "size"
];
var ArrowDown = function ArrowDown(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6K);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 20V4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 13l7 7 7-7"
    }));
};
ArrowDown.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6J = [
    "color",
    "size"
];
var ArrowDownLeft = function ArrowDownLeft(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6J);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 18L18 6"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 8v10h10"
    }));
};
ArrowDownLeft.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6I = [
    "color",
    "size"
];
var ArrowUpLeft = function ArrowUpLeft(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6I);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 6l12 12"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 6H6v10"
    }));
};
ArrowUpLeft.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6H = [
    "color",
    "size"
];
var ArrowUpRight = function ArrowUpRight(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6H);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18 6L6 18"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 6h10v10"
    }));
};
ArrowUpRight.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6G = [
    "color",
    "size"
];
var ArrowDownRight = function ArrowDownRight(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6G);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18 18L6 6"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 18h10V8"
    }));
};
ArrowDownRight.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6F = [
    "color",
    "size"
];
var ChevronLeft = function ChevronLeft(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6F);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 4l-8 8 8 8"
    }));
};
ChevronLeft.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6E = [
    "color",
    "size"
];
var ChevronRight = function ChevronRight(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6E);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 4l8 8-8 8"
    }));
};
ChevronRight.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6D = [
    "color",
    "size"
];
var ChevronUp = function ChevronUp(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6D);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 15l8-8 8 8"
    }));
};
ChevronUp.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6C = [
    "color",
    "size"
];
var ChevronDown = function ChevronDown(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6C);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 9l8 8 8-8"
    }));
};
ChevronDown.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6B = [
    "color",
    "size"
];
var ArrowCycle = function ArrowCycle(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6B);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 12c0 6-4.39 10-9.806 10C7.792 22 4.24 19.665 3 16"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 12C2 6 6.39 2 11.806 2 16.209 2 19.76 4.335 21 8"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7 17l-4-1-1 4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 7l4 1 1-4"
    }));
};
ArrowCycle.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6A = [
    "color",
    "size"
];
var ArrowClockwise = function ArrowClockwise(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6A);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19.734 16.06a8.923 8.923 0 0 1-3.915 3.978 8.706 8.706 0 0 1-5.471.832 8.795 8.795 0 0 1-4.887-2.64 9.067 9.067 0 0 1-2.388-5.079 9.136 9.136 0 0 1 1.044-5.53 8.904 8.904 0 0 1 4.069-3.815 8.7 8.7 0 0 1 5.5-.608c1.85.401 3.366 1.313 4.62 2.755.151.16.735.806 1.22 1.781"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.069 7.813l5.04.907L21 3.59"
    }));
};
ArrowClockwise.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6z = [
    "color",
    "size"
];
var ArrowCounterClockwise = function ArrowCounterClockwise(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6z);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4.266 16.06a8.923 8.923 0 0 0 3.915 3.978 8.706 8.706 0 0 0 5.471.832 8.796 8.796 0 0 0 4.887-2.64 9.067 9.067 0 0 0 2.388-5.079 9.137 9.137 0 0 0-1.044-5.53 8.904 8.904 0 0 0-4.068-3.815 8.7 8.7 0 0 0-5.5-.608c-1.85.401-3.367 1.313-4.62 2.755-.152.16-.736.806-1.22 1.781"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8.931 7.813l-5.04.907L3 3.59"
    }));
};
ArrowCounterClockwise.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6y = [
    "color",
    "size"
];
var ArrowBackThick = function ArrowBackThick(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6y);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 11l7-9v5c11.953 0 13.332 9.678 13 15-.502-2.685-.735-7-13-7v5l-7-9z"
    }));
};
ArrowBackThick.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6x = [
    "color",
    "size"
];
var ArrowBackThickFill = function ArrowBackThickFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6x);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 2a1 1 0 0 0-1.79-.614l-7 9a1 1 0 0 0 0 1.228l7 9A1 1 0 0 0 10 20v-3.99c5.379.112 7.963 1.133 9.261 2.243 1.234 1.055 1.46 2.296 1.695 3.596l.061.335a1 1 0 0 0 1.981-.122c.171-2.748-.086-6.73-2.027-10.061C19.087 8.768 15.694 6.282 10 6.022V2z"
    }));
};
ArrowBackThickFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6w = [
    "color",
    "size"
];
var ArrowForwardThick = function ArrowForwardThick(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6w);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 11l-7-9v5C3.047 7 1.668 16.678 2 22c.502-2.685.735-7 13-7v5l7-9z"
    }));
};
ArrowForwardThick.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6v = [
    "color",
    "size"
];
var ArrowForwardThickFill = function ArrowForwardThickFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6v);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.675 1.054a1 1 0 0 1 1.114.332l7 9a1 1 0 0 1 0 1.228l-7 9A1 1 0 0 1 14 20v-3.99c-5.379.112-7.963 1.133-9.261 2.243-1.234 1.055-1.46 2.296-1.695 3.596l-.061.335a1 1 0 0 1-1.981-.122c-.172-2.748.086-6.73 2.027-10.061C4.913 8.768 8.305 6.282 14 6.022V2a1 1 0 0 1 .675-.946z"
    }));
};
ArrowForwardThickFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6u = [
    "color",
    "size"
];
var Width = function Width(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6u);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 12H2m20 0l-4 4m4-4l-4-4M2 12l4 4m-4-4l4-4"
    }));
};
Width.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6t = [
    "color",
    "size"
];
var Height = function Height(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6t);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 22V2m0 20l-4-4m4 4l4-4M12 2L8 6m4-4l4 4"
    }));
};
Height.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6s = [
    "color",
    "size"
];
var Enlarge = function Enlarge(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6s);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14.5 9.5L21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"
    }));
};
Enlarge.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6r = [
    "color",
    "size"
];
var Reduce = function Reduce(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6r);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 10l7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"
    }));
};
Reduce.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6q = [
    "color",
    "size"
];
var ArrowLeftThick = function ArrowLeftThick(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6q);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 12l7-9v4.99L21 8v8H10v5l-7-9z"
    }));
};
ArrowLeftThick.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6p = [
    "color",
    "size"
];
var ArrowDownThick = function ArrowDownThick(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6p);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 21l9-7h-4.99L16 3H8v11H3l9 7z"
    }));
};
ArrowDownThick.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6o = [
    "color",
    "size"
];
var ArrowRightThick = function ArrowRightThick(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6o);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21 12l-7-9v4.99L3 8v8h11v5l7-9z"
    }));
};
ArrowRightThick.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6n = [
    "color",
    "size"
];
var ArrowUpThick = function ArrowUpThick(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6n);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 3l9 7h-4.99L16 21H8V10H3l9-7z"
    }));
};
ArrowUpThick.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6m = [
    "color",
    "size"
];
var ArrowBack = function ArrowBack(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6m);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 5l-5 5 5 5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 10h8c5.523 0 10 4.477 10 10v1"
    }));
};
ArrowBack.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6l = [
    "color",
    "size"
];
var ArrowForward = function ArrowForward(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6l);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 5l5 5-5 5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21 10h-8C7.477 10 3 14.477 3 20v1"
    }));
};
ArrowForward.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6k = [
    "color",
    "size"
];
var TriangleLeft = function TriangleLeft(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6k);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7 12l8-6v12l-8-6z"
    }));
};
TriangleLeft.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6j = [
    "color",
    "size"
];
var TriangleRight = function TriangleRight(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6j);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 12L9 6v12l8-6z"
    }));
};
TriangleRight.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6i = [
    "color",
    "size"
];
var TriangleUp = function TriangleUp(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6i);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 7l-6 8h12l-6-8z"
    }));
};
TriangleUp.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6h = [
    "color",
    "size"
];
var TriangleDown = function TriangleDown(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6h);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 17L6 9h12l-6 8z"
    }));
};
TriangleDown.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6g = [
    "color",
    "size"
];
var CircleTriangleRight = function CircleTriangleRight(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6g);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 12l-6-4v8l6-4z"
    }));
};
CircleTriangleRight.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6f = [
    "color",
    "size"
];
var CircleTriangleLeft = function CircleTriangleLeft(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6f);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 12l6-4v8l-6-4z"
    }));
};
CircleTriangleLeft.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6e = [
    "color",
    "size"
];
var CircleTriangleUp = function CircleTriangleUp(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6e);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 8l-4 6h8l-4-6z"
    }));
};
CircleTriangleUp.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6d = [
    "color",
    "size"
];
var CircleTriangleDown = function CircleTriangleDown(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6d);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 16l-4-6h8l-4 6z"
    }));
};
CircleTriangleDown.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6c = [
    "color",
    "size"
];
var CircleChevronLeft = function CircleChevronLeft(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6c);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13.5 8l-4 4 4 4"
    }));
};
CircleChevronLeft.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6b = [
    "color",
    "size"
];
var CircleChevronRight = function CircleChevronRight(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6b);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10.5 8l4 4-4 4"
    }));
};
CircleChevronRight.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6a = [
    "color",
    "size"
];
var CircleChevronUp = function CircleChevronUp(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6a);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 13.5l4-4 4 4"
    }));
};
CircleChevronUp.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$69 = [
    "color",
    "size"
];
var CircleChevronDown = function CircleChevronDown(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$69);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 10.5l4 4 4-4"
    }));
};
CircleChevronDown.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$68 = [
    "color",
    "size"
];
var CircleTriangleRightFill = function CircleTriangleRightFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$68);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm-2 7.8c0-.295.152-.566.396-.705a.71.71 0 0 1 .77.04l4.5 3.2A.815.815 0 0 1 16 12a.815.815 0 0 1-.334.666l-4.5 3.2a.71.71 0 0 1-.77.04A.809.809 0 0 1 10 15.2V8.8z"
    }));
};
CircleTriangleRightFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$67 = [
    "color",
    "size"
];
var CircleTriangleLeftFill = function CircleTriangleLeftFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$67);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm2 7.8a.809.809 0 0 0-.396-.705.71.71 0 0 0-.77.04l-4.5 3.2A.815.815 0 0 0 8 12c0 .268.125.517.334.666l4.5 3.2a.71.71 0 0 0 .77.04A.809.809 0 0 0 14 15.2V8.8z"
    }));
};
CircleTriangleLeftFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$66 = [
    "color",
    "size"
];
var CircleTriangleUpFill = function CircleTriangleUpFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$66);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM8.8 14a.809.809 0 0 1-.705-.396.71.71 0 0 1 .04-.77l3.2-4.5A.815.815 0 0 1 12 8c.268 0 .517.125.666.334l3.2 4.5a.71.71 0 0 1 .04.77.809.809 0 0 1-.706.396H8.8z"
    }));
};
CircleTriangleUpFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$65 = [
    "color",
    "size"
];
var CircleTriangleDownFill = function CircleTriangleDownFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$65);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm-3.2 9a.809.809 0 0 0-.705.396.71.71 0 0 0 .04.77l3.2 4.5A.815.815 0 0 0 12 16a.815.815 0 0 0 .666-.334l3.2-4.5a.71.71 0 0 0 .04-.77A.809.809 0 0 0 15.2 10H8.8z"
    }));
};
CircleTriangleDownFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$64 = [
    "color",
    "size"
];
var CircleChevronLeftFill = function CircleChevronLeftFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$64);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm2.207 7.707a1 1 0 0 0-1.414-1.414l-4 4a1 1 0 0 0 0 1.414l4 4a1 1 0 0 0 1.414-1.414L10.914 12l3.293-3.293z"
    }));
};
CircleChevronLeftFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$63 = [
    "color",
    "size"
];
var CircleChevronRightFill = function CircleChevronRightFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$63);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM9.793 8.707a1 1 0 0 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L13.086 12 9.793 8.707z"
    }));
};
CircleChevronRightFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$62 = [
    "color",
    "size"
];
var CircleChevronUpFill = function CircleChevronUpFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$62);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM8.707 14.207a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L12 10.914l-3.293 3.293z"
    }));
};
CircleChevronUpFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$61 = [
    "color",
    "size"
];
var CircleChevronDownFill = function CircleChevronDownFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$61);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM8.707 9.793a1 1 0 0 0-1.414 1.414l4 4a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L12 13.086 8.707 9.793z"
    }));
};
CircleChevronDownFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$60 = [
    "color",
    "size"
];
var ChevronHorizontal = function ChevronHorizontal(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$60);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 8l4 4-4 4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7 8l-4 4 4 4"
    }));
};
ChevronHorizontal.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5$ = [
    "color",
    "size"
];
var ChevronVertical = function ChevronVertical(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5$);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 17l4 4 4-4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 7l4-4 4 4"
    }));
};
ChevronVertical.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5_ = [
    "color",
    "size"
];
var ArrowUpDown = function ArrowUpDown(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5_);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 3v18M6 3l4 4M6 3L2 7"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18 21V3m0 18l4-4m-4 4l-4-4"
    }));
};
ArrowUpDown.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5Z = [
    "color",
    "size"
];
var ArrowRightLeft = function ArrowRightLeft(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5Z);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21 6H3m18 0l-4 4m4-4l-4-4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 18h18M3 18l4 4m-4-4l4-4"
    }));
};
ArrowRightLeft.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5Y = [
    "color",
    "size"
];
var ArrowShuffle = function ArrowShuffle(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5Y);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 19h3.908a2 2 0 0 0 1.682-.919L11.5 12l3.91-6.082A2 2 0 0 1 17.091 5H22m0 14h-4.908a2 2 0 0 1-1.682-.919L13.428 15M2 5h3.908a2 2 0 0 1 1.682.918L9.571 9"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 2l3 3-3 3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 16l3 3-3 3"
    }));
};
ArrowShuffle.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5X = [
    "color",
    "size"
];
var ArrowRepeat = function ArrowRepeat(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5X);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18 2l3 3-3 3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 22l-3-3 3-3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21 5H10a7 7 0 0 0-7 7"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 19h11a7 7 0 0 0 7-7"
    }));
};
ArrowRepeat.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5W = [
    "color",
    "size"
];
var ForkRight = function ForkRight(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5W);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 3v18M9 3l4 4M9 3L5 7"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 10l4 4-4 4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 21v0a7 7 0 0 1 7-7h4"
    }));
};
ForkRight.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5V = [
    "color",
    "size"
];
var ForkLeft = function ForkLeft(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5V);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 3v18m0-18l-4 4m4-4l4 4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 10l-4 4 4 4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 21v0a7 7 0 0 0-7-7H4"
    }));
};
ForkLeft.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5U = [
    "color",
    "size"
];
var TriangleLeftFill = function TriangleLeftFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5U);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 6a1 1 0 0 0-1.6-.8l-8 6a1 1 0 0 0 0 1.6l8 6A1 1 0 0 0 16 18V6z"
    }));
};
TriangleLeftFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5T = [
    "color",
    "size"
];
var TriangleRightFill = function TriangleRightFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5T);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 6a1 1 0 0 1 1.6-.8l8 6a1 1 0 0 1 0 1.6l-8 6A1 1 0 0 1 8 18V6z"
    }));
};
TriangleRightFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5S = [
    "color",
    "size"
];
var TriangleUpFill = function TriangleUpFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5S);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 16a1 1 0 0 1-.8-1.6l6-8a1 1 0 0 1 1.6 0l6 8A1 1 0 0 1 18 16H6z"
    }));
};
TriangleUpFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5R = [
    "color",
    "size"
];
var TriangleDownFill = function TriangleDownFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5R);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 8a1 1 0 0 0-.8 1.6l6 8a1 1 0 0 0 1.6 0l6-8A1 1 0 0 0 18 8H6z"
    }));
};
TriangleDownFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5Q = [
    "color",
    "size"
];
var ChevronDownSmall = function ChevronDownSmall(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5Q);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 10l6 6 6-6"
    }));
};
ChevronDownSmall.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5P = [
    "color",
    "size"
];
var ChevronUpSmall = function ChevronUpSmall(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5P);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 14l6-6 6 6"
    }));
};
ChevronUpSmall.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5O = [
    "color",
    "size"
];
var ChevronRightSmall = function ChevronRightSmall(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5O);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 6l6 6-6 6"
    }));
};
ChevronRightSmall.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5N = [
    "color",
    "size"
];
var ChevronLeftSmall = function ChevronLeftSmall(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5N);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 6l-6 6 6 6"
    }));
};
ChevronLeftSmall.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5M = [
    "color",
    "size"
];
var Plus = function Plus(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5M);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 20v-8m0 0V4m0 8h8m-8 0H4"
    }));
};
Plus.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5L = [
    "color",
    "size"
];
var Minus = function Minus(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5L);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20 12H4"
    }));
};
Minus.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5K = [
    "color",
    "size"
];
var Cross = function Cross(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5K);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20 20L4 4m16 0L4 20"
    }));
};
Cross.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5J = [
    "color",
    "size"
];
var Check = function Check(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5J);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 12l6 6L20 6"
    }));
};
Check.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5I = [
    "color",
    "size"
];
var Question = function Question(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5I);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10 8.484C10.5 7.494 11 7 12 7c1.246 0 2 .989 2 1.978s-.5 1.483-2 2.473V13m0 3.5v.5"
    }));
};
Question.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5H = [
    "color",
    "size"
];
var CircleAlert = function CircleAlert(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5H);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 7v6m0 3.5v.5"
    }));
};
CircleAlert.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5G = [
    "color",
    "size"
];
var CircleX = function CircleX(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5G);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 15L9 9m6 0l-6 6"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }));
};
CircleX.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5F = [
    "color",
    "size"
];
var CircleCheck = function CircleCheck(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5F);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 12.5l3 3 5-6"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }));
};
CircleCheck.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5E = [
    "color",
    "size"
];
var CirclePlus = function CirclePlus(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5E);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 8v4m0 0v4m0-4h4m-4 0H8"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }));
};
CirclePlus.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5D = [
    "color",
    "size"
];
var CircleMinus = function CircleMinus(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5D);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 12H8"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }));
};
CircleMinus.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5C = [
    "color",
    "size"
];
var TriangleAlert = function TriangleAlert(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5C);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 9v5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 17.5v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2.232 19.016L10.35 3.052c.713-1.403 2.59-1.403 3.302 0l8.117 15.964C22.45 20.36 21.544 22 20.116 22H3.883c-1.427 0-2.334-1.64-1.65-2.984z"
    }));
};
TriangleAlert.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5B = [
    "color",
    "size"
];
var Stop = function Stop(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5B);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 2L2 8.156V16l6 6h8l6-6V8.156L16 2H8z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 12H8"
    }));
};
Stop.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5A = [
    "color",
    "size"
];
var Info = function Info(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5A);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 7h.01"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10 11h2v5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10 16h4"
    }));
};
Info.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5z = [
    "color",
    "size"
];
var Play = function Play(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5z);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 4v16"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20 12L6 20"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20 12L6 4"
    }));
};
Play.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5y = [
    "color",
    "size"
];
var Pause = function Pause(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5y);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7 5v14M17 5v14"
    }));
};
Pause.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5x = [
    "color",
    "size"
];
var Command = function Command(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5x);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9.3 17.85a3.15 3.15 0 1 1-3.15-3.15h11.7a3.15 3.15 0 1 1-3.15 3.15V6.15a3.15 3.15 0 1 1 3.15 3.15H6.15A3.15 3.15 0 1 1 9.3 6.15v11.7z"
    }));
};
Command.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5w = [
    "color",
    "size"
];
var SoundDown = function SoundDown(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5w);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 12h-6"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 14.959V9.04C2 8.466 2.448 8 3 8h3.586a.98.98 0 0 0 .707-.305l3-3.388c.63-.656 1.707-.191 1.707.736v13.914c0 .934-1.09 1.395-1.716.726l-2.99-3.369A.98.98 0 0 0 6.578 16H3c-.552 0-1-.466-1-1.041z"
    }));
};
SoundDown.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5v = [
    "color",
    "size"
];
var SoundOn = function SoundOn(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5v);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 14.959V9.04C2 8.466 2.448 8 3 8h3.586a.98.98 0 0 0 .707-.305l3-3.388c.63-.656 1.707-.191 1.707.736v13.914c0 .934-1.09 1.395-1.716.726l-2.99-3.369A.98.98 0 0 0 6.578 16H3c-.552 0-1-.466-1-1.041z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 8.5c1.333 1.778 1.333 5.222 0 7"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 5c3.988 3.808 4.012 10.217 0 14"
    }));
};
SoundOn.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5u = [
    "color",
    "size"
];
var SoundOff = function SoundOff(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5u);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 15l-6-6m6 0l-6 6"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 14.959V9.04C2 8.466 2.448 8 3 8h3.586a.98.98 0 0 0 .707-.305l3-3.388c.63-.656 1.707-.191 1.707.736v13.914c0 .934-1.09 1.395-1.716.726l-2.99-3.369A.98.98 0 0 0 6.578 16H3c-.552 0-1-.466-1-1.041z"
    }));
};
SoundOff.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5t = [
    "color",
    "size"
];
var SoundUp = function SoundUp(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5t);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 9v3m0 0v3m0-3h3m-3 0h-3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 14.959V9.04C2 8.466 2.448 8 3 8h3.586a.98.98 0 0 0 .707-.305l3-3.388c.63-.656 1.707-.191 1.707.736v13.914c0 .934-1.09 1.395-1.716.726l-2.99-3.369A.98.98 0 0 0 6.578 16H3c-.552 0-1-.466-1-1.041z"
    }));
};
SoundUp.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5s = [
    "color",
    "size"
];
var Infinite = function Infinite(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5s);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5.636 16C2.91 16 2 14 2 12s.91-4 3.636-4c3.637 0 9.091 8 12.728 8C21.09 16 22 14 22 12s-.91-4-3.636-4c-3.637 0-9.091 8-12.728 8z"
    }));
};
Infinite.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5r = [
    "color",
    "size"
];
var AirplayAudio = function AirplayAudio(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5r);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 16l6 5H6l6-5z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 18a9.956 9.956 0 0 1-2-6C2 6.477 6.477 2 12 2s10 4.477 10 10a9.956 9.956 0 0 1-2 6"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17.123 15.125a6 6 0 1 0-10.247-.002"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 12a2 2 0 1 0-4 0"
    }));
};
AirplayAudio.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5q = [
    "color",
    "size"
];
var AirplayVideo = function AirplayVideo(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5q);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 16l6 5H6l6-5z"
    }));
};
AirplayVideo.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5p = [
    "color",
    "size"
];
var Miniplayer = function Miniplayer(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5p);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "4",
        width: "20",
        height: "16",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "13",
        y: "13",
        width: "9",
        height: "7",
        rx: "2"
    }));
};
Miniplayer.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5o = [
    "color",
    "size"
];
var TextAlignLeft = function TextAlignLeft(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5o);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 6h18M3 12h10M3 18h15"
    }));
};
TextAlignLeft.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5n = [
    "color",
    "size"
];
var TextAlignCenter = function TextAlignCenter(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5n);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 6h18M7 12h10M5 18h14"
    }));
};
TextAlignCenter.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5m = [
    "color",
    "size"
];
var TextAlignRight = function TextAlignRight(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5m);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 6h18m-10 6h10M6 18h15"
    }));
};
TextAlignRight.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5l = [
    "color",
    "size"
];
var TextAlignJustified = function TextAlignJustified(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5l);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 6h18M3 12h18M3 18h18"
    }));
};
TextAlignJustified.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5k = [
    "color",
    "size"
];
var Mention = function Mention(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5k);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10c2.252 0 4.33-.744 6.001-2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 8v4c0 1 .6 3 3 3s3-2 3-3"
    }));
};
Mention.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5j = [
    "color",
    "size"
];
var Heart = function Heart(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5j);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7 3C4.239 3 2 5.216 2 7.95c0 2.207.875 7.445 9.488 12.74a.985.985 0 0 0 1.024 0C21.125 15.395 22 10.157 22 7.95 22 5.216 19.761 3 17 3s-5 3-5 3-2.239-3-5-3z"
    }));
};
Heart.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5i = [
    "color",
    "size"
];
var FullScreen = function FullScreen(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5i);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 7V2h5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 7V2h-5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7 22H2v-5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 22h5v-5"
    }));
};
FullScreen.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5h = [
    "color",
    "size"
];
var NormalScreen = function NormalScreen(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5h);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7 2v5H2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 2v5h5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 17h5v5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 17h-5v5"
    }));
};
NormalScreen.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5g = [
    "color",
    "size"
];
var AlignLeft = function AlignLeft(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5g);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 3v18"
    }), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "6",
        y: "6",
        width: "16",
        height: "4"
    }), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "6",
        y: "14",
        width: "10",
        height: "4"
    }));
};
AlignLeft.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5f = [
    "color",
    "size"
];
var AlignHorizontalCenter = function AlignHorizontalCenter(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5f);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 3v18"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 6h4v4h-4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 10H4V6h4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 14h2v4h-2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 14H6v4h2"
    }));
};
AlignHorizontalCenter.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5e = [
    "color",
    "size"
];
var AlignRight = function AlignRight(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5e);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 3v18"
    }), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "6",
        width: "16",
        height: "4"
    }), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "8",
        y: "14",
        width: "10",
        height: "4"
    }));
};
AlignRight.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5d = [
    "color",
    "size"
];
var AlignTop = function AlignTop(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5d);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21 2H3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 22V6h4v16H6z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 16V6h4v10h-4z"
    }));
};
AlignTop.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5c = [
    "color",
    "size"
];
var AlignVerticalCenter = function AlignVerticalCenter(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5c);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21 12H3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 16v4h4v-4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 16v2h4v-2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 8V6h4v2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10 8V4H6v4"
    }));
};
AlignVerticalCenter.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5b = [
    "color",
    "size"
];
var AlignBottom = function AlignBottom(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5b);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21 22H3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 18V2h4v16H6z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 18V8h4v10h-4z"
    }));
};
AlignBottom.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5a = [
    "color",
    "size"
];
var ShareBox = function ShareBox(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5a);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 3v12m0-12L8 7m4-4l4 4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 17l.621 2.485A2 2 0 0 0 4.561 21H19.439a2 2 0 0 0 1.94-1.515L22 17"
    }));
};
ShareBox.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$59 = [
    "color",
    "size"
];
var Download = function Download(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$59);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 15V3m0 12l-4-4m4 4l4-4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 17l.621 2.485A2 2 0 0 0 4.561 21H19.439a2 2 0 0 0 1.94-1.515L22 17"
    }));
};
Download.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$58 = [
    "color",
    "size"
];
var AlignToTop = function AlignToTop(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$58);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 22V7"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 14l7-7 7 7"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 2h18"
    }));
};
AlignToTop.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$57 = [
    "color",
    "size"
];
var AlignToMiddle = function AlignToMiddle(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$57);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21 12H3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 2v6"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 22v-6"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 5l3 3 3-3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 19l3-3 3 3"
    }));
};
AlignToMiddle.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$56 = [
    "color",
    "size"
];
var AlignToBottom = function AlignToBottom(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$56);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 22h18"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 2v15"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 10l7 7 7-7"
    }));
};
AlignToBottom.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$55 = [
    "color",
    "size"
];
var Block = function Block(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$55);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 19L19 5"
    }));
};
Block.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$54 = [
    "color",
    "size"
];
var MoreHorizontalFill = function MoreHorizontalFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$54);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"
    }));
};
MoreHorizontalFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$53 = [
    "color",
    "size"
];
var MoreVerticalFill = function MoreVerticalFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$53);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 18a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
    }));
};
MoreVerticalFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$52 = [
    "color",
    "size"
];
var Wifi = function Wifi(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$52);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 10c6-6.667 14-6.667 20 0"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 14c3.6-4 8.4-4 12 0"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "18",
        r: "1"
    }));
};
Wifi.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$51 = [
    "color",
    "size"
];
var Bluetooth = function Bluetooth(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$51);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 7l12 10-6 5V2l6 5L5 17"
    }));
};
Bluetooth.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$50 = [
    "color",
    "size"
];
var Location = function Location(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$50);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "10",
        r: "3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 2a8 8 0 0 0-8 8c0 1.892.402 3.13 1.5 4.5L12 22l6.5-7.5c1.098-1.37 1.5-2.608 1.5-4.5a8 8 0 0 0-8-8z"
    }));
};
Location.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4$ = [
    "color",
    "size"
];
var LinkChain = function LinkChain(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4$);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13.544 10.456a4.368 4.368 0 0 0-6.176 0l-3.089 3.088a4.367 4.367 0 1 0 6.177 6.177L12 18.177"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10.456 13.544a4.368 4.368 0 0 0 6.176 0l3.089-3.088a4.367 4.367 0 1 0-6.177-6.177L12 5.823"
    }));
};
LinkChain.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4_ = [
    "color",
    "size"
];
var LinkOut = function LinkOut(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4_);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13.5 10.5L21 3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 3h5v5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5"
    }));
};
LinkOut.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4Z = [
    "color",
    "size"
];
var SignOut = function SignOut(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4Z);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13 12h9m0 0l-3.333-4M22 12l-3.333 4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 7V5.174a2 2 0 0 0-2.166-1.993l-8 .666A2 2 0 0 0 2 5.84v12.32a2 2 0 0 0 1.834 1.993l8 .667A2 2 0 0 0 14 18.826V17"
    }));
};
SignOut.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4Y = [
    "color",
    "size"
];
var Hashtag = function Hashtag(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4Y);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10 3L6 21"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18 3l-4 18"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 8h17"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 16h17"
    }));
};
Hashtag.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4X = [
    "color",
    "size"
];
var Grid = function Grid(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4X);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "3",
        y: "3",
        width: "7",
        height: "7",
        rx: "1"
    }), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "3",
        y: "14",
        width: "7",
        height: "7",
        rx: "1"
    }), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "14",
        y: "3",
        width: "7",
        height: "7",
        rx: "1"
    }), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "14",
        y: "14",
        width: "7",
        height: "7",
        rx: "1"
    }));
};
Grid.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4W = [
    "color",
    "size"
];
var LinkOn = function LinkOn(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4W);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 12h6"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 6h1a6 6 0 0 1 0 12h-1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 18H8A6 6 0 0 1 8 6h1"
    }));
};
LinkOn.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4V = [
    "color",
    "size"
];
var LinkOff = function LinkOff(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4V);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 6h1a6 6 0 0 1 0 12h-1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 18H8A6 6 0 0 1 8 6h1"
    }));
};
LinkOff.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4U = [
    "color",
    "size"
];
var ChatBubble = function ChatBubble(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4U);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
    }));
};
ChatBubble.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4T = [
    "color",
    "size"
];
var ChatAdd = function ChatAdd(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4T);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 8v3m0 0v3m0-3h3m-3 0H9"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
    }));
};
ChatAdd.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4S = [
    "color",
    "size"
];
var ChatRemove = function ChatRemove(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4S);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 11H9"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
    }));
};
ChatRemove.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4R = [
    "color",
    "size"
];
var ZoomIn = function ZoomIn(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4R);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21 21l-4.486-4.494M19 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10.5 7v3.5m0 0V14m0-3.5H14m-3.5 0H7"
    }));
};
ZoomIn.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4Q = [
    "color",
    "size"
];
var ZoomOut = function ZoomOut(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4Q);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21 21l-4.486-4.494M19 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13 10.5H8"
    }));
};
ZoomOut.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4P = [
    "color",
    "size"
];
var Box = function Box(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4P);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "4"
    }));
};
Box.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4O = [
    "color",
    "size"
];
var CheckBox = function CheckBox(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4O);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 12l2.25 2L15 10"
    }));
};
CheckBox.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4N = [
    "color",
    "size"
];
var CheckBoxFill = function CheckBoxFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4N);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 2a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5H7zm8.73 8.684a1 1 0 1 0-1.46-1.368l-3.083 3.29-1.523-1.353a1 1 0 0 0-1.328 1.494l2.25 2a1 1 0 0 0 1.393-.063l3.75-4z"
    }));
};
CheckBoxFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4M = [
    "color",
    "size"
];
var Rss = function Rss(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4M);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 10.418c6.068-.319 9.9 3.514 9.582 9.582"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "5",
        cy: "19",
        r: "1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 4.03C14.114 3.5 20.501 9.887 19.97 20"
    }));
};
Rss.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4L = [
    "color",
    "size"
];
var Backspace = function Backspace(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4L);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 15l-6-6m6 0l-6 6"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7.4 4.8A2 2 0 0 1 9 4h11a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H9a2 2 0 0 1-1.6-.8l-4.5-6a2 2 0 0 1 0-2.4l4.5-6z"
    }));
};
Backspace.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4K = [
    "color",
    "size"
];
var BackspaceFill = function BackspaceFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4K);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.6 4.2A3 3 0 0 1 9 3h11a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H9a3 3 0 0 1-2.4-1.2l-4.5-6a3 3 0 0 1 0-3.6l4.5-6zm11.107 5.507a1 1 0 0 0-1.414-1.414L14 10.586l-2.293-2.293a1 1 0 1 0-1.414 1.414L12.586 12l-2.293 2.293a1 1 0 0 0 1.414 1.414L14 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L15.414 12l2.293-2.293z"
    }));
};
BackspaceFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4J = [
    "color",
    "size"
];
var DoubleCheck = function DoubleCheck(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4J);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 12l5.25 5 2.625-3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 12l5.25 5L22 7"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 7l-3.5 4"
    }));
};
DoubleCheck.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4I = [
    "color",
    "size"
];
var DragVerticalFill = function DragVerticalFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4I);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 18a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 18a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
    }));
};
DragVerticalFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4H = [
    "color",
    "size"
];
var DragHorizontalFill = function DragHorizontalFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4H);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
    }));
};
DragHorizontalFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4G = [
    "color",
    "size"
];
var DotGridFill = function DotGridFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4G);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm8 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm10 2a2 2 0 1 0-4 0 2 2 0 0 0 4 0zM4 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm10 2a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm6-2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM6 20a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm6-2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm10 2a2 2 0 1 0-4 0 2 2 0 0 0 4 0z"
    }));
};
DotGridFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4F = [
    "color",
    "size"
];
var ChatDots = function ChatDots(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4F);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 11v.01"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 11v.01"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 11v.01"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
    }));
};
ChatDots.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4E = [
    "color",
    "size"
];
var ChatError = function ChatError(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4E);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9.879 8.879L12 11m0 0l2.121 2.121M12 11l2.121-2.121M12 11l-2.121 2.121"
    }));
};
ChatError.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4D = [
    "color",
    "size"
];
var Health = function Health(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4D);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v5H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h5v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-5h5a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-5V3z"
    }));
};
Health.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4C = [
    "color",
    "size"
];
var QuestionFill = function QuestionFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4C);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm-1.108 7.935c.23-.453.4-.668.541-.78.106-.084.25-.155.567-.155.625 0 1 .47 1 .978 0 .278-.054.416-.202.592-.207.246-.59.545-1.348 1.046l-.45.296V13a1 1 0 1 0 2 0v-1.017c.542-.374.997-.732 1.327-1.124.477-.566.673-1.17.673-1.881C15 7.508 13.867 6 12 6c-.684 0-1.289.176-1.808.587-.484.383-.814.91-1.084 1.445a1 1 0 1 0 1.784.903zM13 16.5a1 1 0 1 0-2 0v.5a1 1 0 1 0 2 0v-.5z"
    }));
};
QuestionFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4B = [
    "color",
    "size"
];
var CircleAlertFill = function CircleAlertFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4B);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm1 6a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0V7zm0 9.5a1 1 0 1 0-2 0v.5a1 1 0 1 0 2 0v-.5z"
    }));
};
CircleAlertFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4A = [
    "color",
    "size"
];
var CircleXFill = function CircleXFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4A);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm3.707 8.707a1 1 0 0 0-1.414-1.414L12 10.586 9.707 8.293a1 1 0 1 0-1.414 1.414L10.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L12 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L13.414 12l2.293-2.293z"
    }));
};
CircleXFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4z = [
    "color",
    "size"
];
var CirclePlusFill = function CirclePlusFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4z);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm1 15a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 1 1 2 0v3h3a1 1 0 1 1 0 2h-3v3z"
    }));
};
CirclePlusFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4y = [
    "color",
    "size"
];
var CircleMinusFill = function CircleMinusFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4y);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM8 11a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8z"
    }));
};
CircleMinusFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4x = [
    "color",
    "size"
];
var CircleCheckFill = function CircleCheckFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4x);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm4.768 9.14a1 1 0 1 0-1.536-1.28l-4.3 5.159-2.225-2.226a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.475-.067l5-6z"
    }));
};
CircleCheckFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4w = [
    "color",
    "size"
];
var TriangleAlertFill = function TriangleAlertFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4w);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.543 2.598a2.821 2.821 0 0 0-5.086 0L1.341 18.563C.37 20.469 1.597 23 3.883 23h16.233c2.287 0 3.512-2.53 2.543-4.437L14.543 2.598zM12 8a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1zm0 8.5a1 1 0 0 1 1 1v.5a1 1 0 1 1-2 0v-.5a1 1 0 0 1 1-1z"
    }));
};
TriangleAlertFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4v = [
    "color",
    "size"
];
var StopFill = function StopFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4v);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 1a1 1 0 0 0-.716.302l-6 6.156A1 1 0 0 0 1 8.156V16a1 1 0 0 0 .293.707l6 6A1 1 0 0 0 8 23h8a1 1 0 0 0 .707-.293l6-6A1 1 0 0 0 23 16V8.156a1 1 0 0 0-.284-.698l-6-6.156A1 1 0 0 0 16 1H8zm0 10a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8z"
    }));
};
StopFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4u = [
    "color",
    "size"
];
var InfoFill = function InfoFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4u);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm-.5 5a1 1 0 1 0 0 2h.5a1 1 0 1 0 0-2h-.5zM10 10a1 1 0 1 0 0 2h1v3h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-4a1 1 0 0 0-1-1h-2z"
    }));
};
InfoFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4t = [
    "color",
    "size"
];
var CloudDownload = function CloudDownload(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4t);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 22v-9m0 9l-2.5-2m2.5 2l2.5-2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5.034 9.117A4.002 4.002 0 0 0 6 17h1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.83 7.138a5.5 5.5 0 0 0-10.796 1.98S5.187 10 5.5 10.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 17a5 5 0 1 0-1.17-9.862L14.5 7.5"
    }));
};
CloudDownload.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4s = [
    "color",
    "size"
];
var CloudUpload = function CloudUpload(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4s);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 12v9m0-9l-2.5 2m2.5-2l2.5 2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5.034 9.117A4.002 4.002 0 0 0 6 17h1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.83 7.138a5.5 5.5 0 0 0-10.796 1.98S5.187 10 5.5 10.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 17a5 5 0 1 0-1.17-9.862L14.5 7.5"
    }));
};
CloudUpload.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4r = [
    "color",
    "size"
];
var Network = function Network(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4r);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "18",
        cy: "5",
        r: "3"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "18",
        cy: "19",
        r: "3"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "6",
        cy: "12",
        r: "3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.408 6.512l-6.814 3.975m6.814 7.001l-6.814-3.975"
    }));
};
Network.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4q = [
    "color",
    "size"
];
var ToggleOff = function ToggleOff(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4q);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "7",
        width: "20",
        height: "10",
        rx: "5"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "7",
        cy: "12",
        r: "5"
    }));
};
ToggleOff.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4p = [
    "color",
    "size"
];
var ToggleOn = function ToggleOn(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4p);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "7",
        width: "20",
        height: "10",
        rx: "5"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "17",
        cy: "12",
        r: "5"
    }));
};
ToggleOn.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4o = [
    "color",
    "size"
];
var ToggleOffFill = function ToggleOffFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4o);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 7a5 5 0 0 0 0 10h10a5 5 0 0 0 0-10H7zm0 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
    }));
};
ToggleOffFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4n = [
    "color",
    "size"
];
var ToggleOnFill = function ToggleOnFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4n);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 7a5 5 0 0 0 0 10h10a5 5 0 0 0 0-10H7zm10 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
    }));
};
ToggleOnFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4m = [
    "color",
    "size"
];
var ThreeLineHorizontal = function ThreeLineHorizontal(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4m);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 6h14M5 12h14M5 18h14"
    }));
};
ThreeLineHorizontal.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4l = [
    "color",
    "size"
];
var ThreeLineVertical = function ThreeLineVertical(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4l);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 19V5m6 14V5M6 19V5"
    }));
};
ThreeLineVertical.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4k = [
    "color",
    "size"
];
var TwoLineHorizontal = function TwoLineHorizontal(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4k);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 9h14M5 15h14"
    }));
};
TwoLineHorizontal.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4j = [
    "color",
    "size"
];
var TwoLineVertical = function TwoLineVertical(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4j);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 19V5M9 19V5"
    }));
};
TwoLineVertical.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4i = [
    "color",
    "size"
];
var PointerLeftFill = function PointerLeftFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4i);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.6 4.2A3 3 0 0 1 9 3h11a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H9a3 3 0 0 1-2.4-1.2l-4.5-6a3 3 0 0 1 0-3.6l4.5-6z"
    }));
};
PointerLeftFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4h = [
    "color",
    "size"
];
var PointerRightFill = function PointerRightFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4h);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.9 4.2A3 3 0 0 0 15.5 3h-11a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h11a3 3 0 0 0 2.4-1.2l4.5-6a3 3 0 0 0 0-3.6l-4.5-6z"
    }));
};
PointerRightFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4g = [
    "color",
    "size"
];
var PointerUpFill = function PointerUpFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4g);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.05 6.35a3 3 0 0 1 1.2 2.4v11a3 3 0 0 1-3 3h-12a3 3 0 0 1-3-3v-11a3 3 0 0 1 1.2-2.4l6-4.5a3 3 0 0 1 3.6 0l6 4.5z"
    }));
};
PointerUpFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4f = [
    "color",
    "size"
];
var PointerDownFill = function PointerDownFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4f);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.05 17.65a3 3 0 0 0 1.2-2.4v-11a3 3 0 0 0-3-3h-12a3 3 0 0 0-3 3v11a3 3 0 0 0 1.2 2.4l6 4.5a3 3 0 0 0 3.6 0l6-4.5z"
    }));
};
PointerDownFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4e = [
    "color",
    "size"
];
var ChatApprove = function ChatApprove(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4e);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 11l2.25 2L15 9"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
    }));
};
ChatApprove.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4d = [
    "color",
    "size"
];
var ChatQuestion = function ChatQuestion(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4d);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10 8.484C10.5 7.494 11 7 12 7c1.246 0 2 .989 2 1.978s-.5 1.033-2 2.022v1m0 2.5v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
    }));
};
ChatQuestion.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4c = [
    "color",
    "size"
];
var ChatEdit = function ChatEdit(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4c);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.207 6.793a1 1 0 0 0-1.418.003l-4.55 4.597a2 2 0 0 0-.54 1.015l-.18.896a1 1 0 0 0 1.177 1.177l.896-.18a2 2 0 0 0 1.015-.54l4.597-4.55a1 1 0 0 0 .003-1.418l-1-1z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12.5 9.5l1 1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
    }));
};
ChatEdit.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4b = [
    "color",
    "size"
];
var Cursor = function Cursor(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4b);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 3l7 19 2.051-6.154a6 6 0 0 1 3.795-3.795L22 10 3 3z"
    }));
};
Cursor.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4a = [
    "color",
    "size"
];
var Frame = function Frame(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4a);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 3v18"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18 3v18"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 6h18"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 18h18"
    }));
};
Frame.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$49 = [
    "color",
    "size"
];
var Slice = function Slice(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$49);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13 21H3l10-10v10z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 19L21 3v4l-8 8"
    }));
};
Slice.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$48 = [
    "color",
    "size"
];
var Percentage = function Percentage(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$48);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 19L19 5"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "7",
        cy: "7",
        r: "3"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "17",
        cy: "17",
        r: "3"
    }));
};
Percentage.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$47 = [
    "color",
    "size"
];
var CheckIn = function CheckIn(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$47);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 2a6 6 0 0 0-6 6c0 1.419.302 2.348 1.125 3.375L12 17l4.875-5.625C17.698 10.348 18 9.419 18 8a6 6 0 0 0-6-6z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 15.143C3.149 15.87 2 16.881 2 18c0 2.21 4.477 4 10 4s10-1.79 10-4c0-1.119-1.149-2.13-3-2.857"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "8",
        r: "1"
    }));
};
CheckIn.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$46 = [
    "color",
    "size"
];
var Video = function Video(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$46);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "4",
        width: "20",
        height: "16",
        rx: "4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 12l-5-3v6l5-3z"
    }));
};
Video.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$45 = [
    "color",
    "size"
];
var Cut = function Cut(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$45);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "7",
        cy: "18",
        r: "3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 15L7 3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 15l3-4.5M17 3l-3 4.5"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "17",
        cy: "18",
        r: "3"
    }));
};
Cut.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$44 = [
    "color",
    "size"
];
var Filter = function Filter(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$44);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("ellipse", {
        cx: "12",
        cy: "5",
        rx: "9",
        ry: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 5c0 2.23 3.871 6.674 5.856 8.805A4.197 4.197 0 0 1 10 16.657V19a2 2 0 0 0 2 2v0a2 2 0 0 0 2-2v-2.343c0-1.061.421-2.075 1.144-2.852C17.13 11.674 21 7.231 21 5"
    }));
};
Filter.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$43 = [
    "color",
    "size"
];
var SettingsHorizontal = function SettingsHorizontal(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$43);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 5h4m14 0H11m-8 7h12m6 0h-2M3 19h2m16 0H9"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "9",
        cy: "5",
        r: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "17",
        cy: "12",
        r: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "7",
        cy: "19",
        r: "2"
    }));
};
SettingsHorizontal.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$42 = [
    "color",
    "size"
];
var SettingsVertical = function SettingsVertical(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$42);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 3v4m0 14V11m-7-8v12m0 6v-2M5 3v2m0 16V9"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "19",
        cy: "9",
        r: "2",
        transform: "rotate(90 19 9)"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "17",
        r: "2",
        transform: "rotate(90 12 17)"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "5",
        cy: "7",
        r: "2",
        transform: "rotate(90 5 7)"
    }));
};
SettingsVertical.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$41 = [
    "color",
    "size"
];
var Ascending = function Ascending(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$41);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 3v18M6 3l3 3.333M6 3L3 6.333"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 21h8l-1-4h-7v4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 14h6l-1-4h-5v4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 7h4l-1-4h-3v4z"
    }));
};
Ascending.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$40 = [
    "color",
    "size"
];
var Descending = function Descending(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$40);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 21V3m0 18l3-3.333M6 21l-3-3.333"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 3h8l-1 4h-7V3z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 10h6l-1 4h-5v-4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 17h4l-1 4h-3v-4z"
    }));
};
Descending.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3$ = [
    "color",
    "size"
];
var StatisticUp = function StatisticUp(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3$);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 3v16a2 2 0 0 0 2 2h16"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7 14l4-4 4 4 6-6"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18 8h3v3"
    }));
};
StatisticUp.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3_ = [
    "color",
    "size"
];
var StatisticDown = function StatisticDown(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3_);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 3v16a2 2 0 0 0 2 2h16"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7 9l4 4 4-4 6 6"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18 15h3v-3"
    }));
};
StatisticDown.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3Z = [
    "color",
    "size"
];
var PanelRight = function PanelRight(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3Z);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "3",
        width: "20",
        height: "18",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 3v18"
    }));
};
PanelRight.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3Y = [
    "color",
    "size"
];
var PanelLeft = function PanelLeft(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3Y);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "3",
        width: "20",
        height: "18",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 3v18"
    }));
};
PanelLeft.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3X = [
    "color",
    "size"
];
var PanelSplit = function PanelSplit(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3X);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "3",
        width: "20",
        height: "18",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 3v18"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 12H9"
    }));
};
PanelSplit.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3W = [
    "color",
    "size"
];
var Dashboard = function Dashboard(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3W);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 5a2 2 0 0 1 2-2h6v18H4a2 2 0 0 1-2-2V5z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 3h6a2 2 0 0 1 2 2v5h-8V3z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 14h8v5a2 2 0 0 1-2 2h-6v-7z"
    }));
};
Dashboard.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3V = [
    "color",
    "size"
];
var PanelBottom = function PanelBottom(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3V);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "3",
        width: "20",
        height: "18",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 15H2"
    }));
};
PanelBottom.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3U = [
    "color",
    "size"
];
var PanelTop = function PanelTop(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3U);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "3",
        width: "20",
        height: "18",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 9H2"
    }));
};
PanelTop.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3T = [
    "color",
    "size"
];
var PanelSplitRow = function PanelSplitRow(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3T);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "3",
        width: "20",
        height: "18",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 3v18"
    }));
};
PanelSplitRow.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3S = [
    "color",
    "size"
];
var PanelSplitColumn = function PanelSplitColumn(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3S);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "3",
        width: "20",
        height: "18",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 12H2"
    }));
};
PanelSplitColumn.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3R = [
    "color",
    "size"
];
var Language = function Language(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3R);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 19c3.771 0 5.657 0 6.828-1.172C22 16.657 22 14.771 22 11c0-3.771 0-5.657-1.172-6.828C19.657 3 17.771 3 14 3h-4C6.229 3 4.343 3 3.172 4.172 2 5.343 2 7.229 2 11c0 3.771 0 5.657 1.172 6.828.653.654 1.528.943 2.828 1.07"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 19c-1.236 0-2.598.5-3.841 1.145-1.998 1.037-2.997 1.556-3.489 1.225-.492-.33-.399-1.355-.212-3.404L6.5 17.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5.5 13.5l1-2m0 0l1.106-2.211a1 1 0 0 1 1.788 0L10.5 11.5m-4 0h4m0 0l1 2m1-6h1.982V9c0 .5-.496 1.5-1.487 1.5m3.964-3v2m0 0v4m0-4H18.5"
    }));
};
Language.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3Q = [
    "color",
    "size"
];
var Sort = function Sort(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3Q);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 6h18M6 12h12m-9 6h6"
    }));
};
Sort.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3P = [
    "color",
    "size"
];
var Equal = function Equal(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3P);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 14H8"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 10H8"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }));
};
Equal.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3O = [
    "color",
    "size"
];
var EqualFill = function EqualFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3O);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm6 2a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1zm1-5a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8z"
    }));
};
EqualFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3N = [
    "color",
    "size"
];
var Radio = function Radio(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3N);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z"
    }));
};
Radio.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3M = [
    "color",
    "size"
];
var RadioFill = function RadioFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3M);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"
    }));
};
RadioFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3L = [
    "color",
    "size"
];
var Save = function Save(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3L);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7 21h10a4 4 0 0 0 4-4V7.414a1 1 0 0 0-.293-.707l-3.414-3.414A1 1 0 0 0 16.586 3H7a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 3h6v3a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V3z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11 17h2"
    }));
};
Save.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3K = [
    "color",
    "size"
];
var AugmentedReality = function AugmentedReality(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3K);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10.971 6.617a2 2 0 0 1 2.058 0l3.486 2.092a1 1 0 0 1 .485.857v4.302a2 2 0 0 1-.971 1.715l-3 1.8a2 2 0 0 1-2.058 0l-3-1.8A2 2 0 0 1 7 13.868V9.566a1 1 0 0 1 .486-.857l3.485-2.092z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7 9l5 2.759m0 0L17 9m-5 2.759V17"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 2H4a2 2 0 0 0-2 2v2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18 22h2a2 2 0 0 0 2-2v-2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 6V4a2 2 0 0 0-2-2h-2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 18v2a2 2 0 0 0 2 2h2"
    }));
};
AugmentedReality.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3J = [
    "color",
    "size"
];
var History = function History(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3J);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4.266 16.06a8.923 8.923 0 0 0 3.915 3.978 8.706 8.706 0 0 0 5.471.832 8.795 8.795 0 0 0 4.887-2.64 9.067 9.067 0 0 0 2.388-5.079 9.135 9.135 0 0 0-1.044-5.53 8.903 8.903 0 0 0-4.069-3.815 8.7 8.7 0 0 0-5.5-.608c-1.85.401-3.366 1.313-4.62 2.755-.151.16-.735.806-1.22 1.781M7.5 8l-3.609.72L3 5m9 4v4l3 2"
    }));
};
History.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3I = [
    "color",
    "size"
];
var XSmall = function XSmall(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3I);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 17L7 7m10 0L7 17"
    }));
};
XSmall.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3H = [
    "color",
    "size"
];
var Ribbon = function Ribbon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3H);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 5v14.586c0 .89 1.077 1.337 1.707.707L12 14l6.293 6.293c.63.63 1.707.184 1.707-.707V5a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2z"
    }));
};
Ribbon.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3G = [
    "color",
    "size"
];
var Phone = function Phone(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3G);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10.554 6.24L7.171 2.335c-.39-.45-1.105-.448-1.558.006L2.831 5.128c-.828.829-1.065 2.06-.586 3.047a29.207 29.207 0 0 0 13.561 13.58c.986.479 2.216.242 3.044-.587l2.808-2.813c.455-.455.456-1.174.002-1.564l-3.92-3.365c-.41-.352-1.047-.306-1.458.106l-1.364 1.366a.462.462 0 0 1-.553.088 14.557 14.557 0 0 1-5.36-5.367.463.463 0 0 1 .088-.554l1.36-1.361c.412-.414.457-1.054.101-1.465z"
    }));
};
Phone.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3F = [
    "color",
    "size"
];
var Attach = function Attach(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3F);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 7.91V16a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V6a4 4 0 0 0-4-4v0a4 4 0 0 0-4 4v9.182a2 2 0 0 0 2 2v0a2 2 0 0 0 2-2V8"
    }));
};
Attach.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3E = [
    "color",
    "size"
];
var Thunder = function Thunder(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3E);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17.684 3.603c.521-.659.03-1.603-.836-1.603h-6.716c-.375 0-.722.192-.909.502l-5.082 8.456c-.401.666.103 1.497.908 1.497h3.429l-3.23 8.065c-.467 1.02.795 1.953 1.643 1.215L20 9.331h-6.849l4.533-5.728z"
    }));
};
Thunder.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3D = [
    "color",
    "size"
];
var Send = function Send(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3D);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9.912 12H4L2.023 4.135A.662.662 0 0 1 2 3.995c-.022-.721.772-1.221 1.46-.891L22 12 3.46 20.896c-.68.327-1.464-.159-1.46-.867a.66.66 0 0 1 .033-.186L3.5 15"
    }));
};
Send.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3C = [
    "color",
    "size"
];
var Sun = function Sun(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3C);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 3V2m0 20v-1m9-9h1M2 12h1m15.5-6.5L20 4M4 20l1.5-1.5M4 4l1.5 1.5m13 13L20 20"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "4"
    }));
};
Sun.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3B = [
    "color",
    "size"
];
var Moon = function Moon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3B);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20.958 15.325c.204-.486-.379-.9-.868-.684a7.684 7.684 0 0 1-3.101.648c-4.185 0-7.577-3.324-7.577-7.425a7.28 7.28 0 0 1 1.134-3.91c.284-.448-.057-1.068-.577-.936C5.96 4.041 3 7.613 3 11.862 3 16.909 7.175 21 12.326 21c3.9 0 7.24-2.345 8.632-5.675z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.611 3.103c-.53-.354-1.162.278-.809.808l.63.945a2.332 2.332 0 0 1 0 2.588l-.63.945c-.353.53.28 1.162.81.808l.944-.63a2.332 2.332 0 0 1 2.588 0l.945.63c.53.354 1.162-.278.808-.808l-.63-.945a2.332 2.332 0 0 1 0-2.588l.63-.945c.354-.53-.278-1.162-.809-.808l-.944.63a2.332 2.332 0 0 1-2.588 0l-.945-.63z"
    }));
};
Moon.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3A = [
    "color",
    "size"
];
var Pencil = function Pencil(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3A);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4.333 16.048L16.57 3.81a2.56 2.56 0 0 1 3.62 3.619L7.951 19.667a2 2 0 0 1-1.022.547L3 21l.786-3.93a2 2 0 0 1 .547-1.022z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14.5 6.5l3 3"
    }));
};
Pencil.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3z = [
    "color",
    "size"
];
var Pin = function Pin(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3z);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 10.726l-3 .505L11.23 2l-.504 3M12 16.881l-.77 2.042 7.693-7.692-2.042.769m-1.804 3.077L21 21M3.538 9.692l6.154-6.154.236.341a52.22 52.22 0 0 0 7.376 8.518l.235.218-4.924 4.923-.218-.234A52.22 52.22 0 0 0 3.88 9.928l-.34-.236z"
    }));
};
Pin.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3y = [
    "color",
    "size"
];
var Draft = function Draft(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3y);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13.5 6v4H16m-1.315-8H10a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.242a2 2 0 0 0-.602-1.43L16.083 2.57A2 2 0 0 0 14.685 2z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 18v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2"
    }));
};
Draft.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3x = [
    "color",
    "size"
];
var EyeOpen = function EyeOpen(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3x);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21.257 10.962c.474.62.474 1.457 0 2.076C19.764 14.987 16.182 19 12 19c-4.182 0-7.764-4.013-9.257-5.962a1.692 1.692 0 0 1 0-2.076C4.236 9.013 7.818 5 12 5c4.182 0 7.764 4.013 9.257 5.962z"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "3"
    }));
};
EyeOpen.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3w = [
    "color",
    "size"
];
var EyeSlashed = function EyeSlashed(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3w);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6.873 17.129c-1.845-1.31-3.305-3.014-4.13-4.09a1.693 1.693 0 0 1 0-2.077C4.236 9.013 7.818 5 12 5c1.876 0 3.63.807 5.13 1.874"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14.13 9.887a3 3 0 1 0-4.243 4.242"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 20L20 4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10 18.704A7.124 7.124 0 0 0 12 19c4.182 0 7.764-4.013 9.257-5.962a1.694 1.694 0 0 0-.001-2.078A22.939 22.939 0 0 0 19.57 9"
    }));
};
EyeSlashed.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3v = [
    "color",
    "size"
];
var EyeClosed = function EyeClosed(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3v);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 10s3.5 4 10 4 10-4 10-4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 11.645L2 14"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 14l-1.996-2.352"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8.914 13.68L8 16.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.063 13.688L16 16.5"
    }));
};
EyeClosed.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3u = [
    "color",
    "size"
];
var Airpods = function Airpods(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3u);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 7c0 2.21 1.644 4 4 4s4-1.79 4-4-1.644-4-4-4-4 1.79-4 4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10 7c0 2.21-1.644 4-4 4S2 9.21 2 7s1.644-4 4-4 4 1.79 4 4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 7v12a2 2 0 0 0 2 2v0a2 2 0 0 0 2-2v-8"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 17h4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 17h4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10 7v12a2 2 0 0 1-2 2v0a2 2 0 0 1-2-2v-8"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20 4v0a5.408 5.408 0 0 0 0 6v0"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 4v0a5.408 5.408 0 0 1 0 6v0"
    }));
};
Airpods.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3t = [
    "color",
    "size"
];
var Paper = function Paper(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3t);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 4v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.342a2 2 0 0 0-.602-1.43l-4.44-4.342A2 2 0 0 0 13.56 2H6a2 2 0 0 0-2 2z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 2v4a2 2 0 0 0 2 2h4"
    }));
};
Paper.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3s = [
    "color",
    "size"
];
var File = function File(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3s);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 4v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.342a2 2 0 0 0-.602-1.43l-4.44-4.342A2 2 0 0 0 13.56 2H6a2 2 0 0 0-2 2z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 13h6"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 17h3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 2v4a2 2 0 0 0 2 2h4"
    }));
};
File.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3r = [
    "color",
    "size"
];
var Headphone = function Headphone(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3r);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 13.565C2 11.512 4 11 6 11v9a4 4 0 0 1-4-4v-2.435z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 13.565C22 11.512 20 11 18 11v9a4 4 0 0 0 4-4v-2.435z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 20V10a6 6 0 1 1 12 0v10"
    }));
};
Headphone.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3q = [
    "color",
    "size"
];
var MobileDevice = function MobileDevice(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3q);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "6",
        y: "2",
        width: "12",
        height: "20",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.95 18h.1"
    }));
};
MobileDevice.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3p = [
    "color",
    "size"
];
var TabletDevice = function TabletDevice(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3p);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "4",
        y: "2",
        width: "16",
        height: "20",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11 18h2"
    }));
};
TabletDevice.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3o = [
    "color",
    "size"
];
var LaptopDevice = function LaptopDevice(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3o);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9H4V7z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 19h20"
    }));
};
LaptopDevice.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3n = [
    "color",
    "size"
];
var DesktopDevice = function DesktopDevice(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3n);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 20h8"
    }));
};
DesktopDevice.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3m = [
    "color",
    "size"
];
var WatchDevice = function WatchDevice(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3m);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 22h6"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 2h6"
    }));
};
WatchDevice.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3l = [
    "color",
    "size"
];
var Wallet = function Wallet(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3l);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 8h20"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 12h7c0 1 .6 3 3 3s3-2 3-3h7"
    }));
};
Wallet.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3k = [
    "color",
    "size"
];
var Search = function Search(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3k);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21 21l-4.486-4.494M19 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0z"
    }));
};
Search.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3j = [
    "color",
    "size"
];
var LockOn = function LockOn(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3j);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "3",
        y: "10",
        width: "18",
        height: "12",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 6a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v4H6V6z"
    }));
};
LockOn.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3i = [
    "color",
    "size"
];
var LockOff = function LockOff(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3i);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "3",
        y: "10",
        width: "18",
        height: "12",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 10V5a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v1"
    }));
};
LockOff.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3h = [
    "color",
    "size"
];
var Camera = function Camera(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3h);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6.233 5.834l.445-2.226A2 2 0 0 1 8.64 2h6.72a2 2 0 0 1 1.962 1.608l.445 2.226a1.879 1.879 0 0 0 1.387 1.454A3.758 3.758 0 0 1 22 10.934V18a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4v-7.066a3.758 3.758 0 0 1 2.846-3.646 1.879 1.879 0 0 0 1.387-1.454z"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "14",
        r: "4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11 6h2"
    }));
};
Camera.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3g = [
    "color",
    "size"
];
var Image = function Image(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3g);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6z"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "8.5",
        cy: "8.5",
        r: "2.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14.526 12.621L6 22h12.133A3.867 3.867 0 0 0 22 18.133V18c0-.466-.175-.645-.49-.99l-4.03-4.395a2 2 0 0 0-2.954.006z"
    }));
};
Image.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3f = [
    "color",
    "size"
];
var Folder = function Folder(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3f);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 19V9a2 2 0 0 0-2-2h-6.764a2 2 0 0 1-1.789-1.106l-.894-1.788A2 2 0 0 0 8.763 3H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2z"
    }));
};
Folder.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3e = [
    "color",
    "size"
];
var FolderAdd = function FolderAdd(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3e);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 19V9a2 2 0 0 0-2-2h-6.764a2 2 0 0 1-1.789-1.106l-.894-1.788A2 2 0 0 0 8.763 3H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 11v3m0 0v3m0-3h3m-3 0H9"
    }));
};
FolderAdd.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3d = [
    "color",
    "size"
];
var Calendar = function Calendar(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3d);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "4",
        width: "20",
        height: "18",
        rx: "4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 2v4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 2v4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 10h20"
    }));
};
Calendar.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3c = [
    "color",
    "size"
];
var Bell = function Bell(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3c);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12.721 5.003L11.255 5c-3.344-.008-6.247 2.709-6.27 6v3.79c0 .79-.1 1.561-.531 2.218l-.287.438C3.73 18.11 4.2 19 4.985 19h14.03c.785 0 1.254-.89.818-1.554l-.287-.438c-.43-.657-.531-1.429-.531-2.219v-3.788c-.04-3.292-2.95-5.99-6.294-5.998z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 19a3 3 0 1 1-6 0"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 2a2 2 0 0 1 2 2v1h-4V4a2 2 0 0 1 2-2z"
    }));
};
Bell.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3b = [
    "color",
    "size"
];
var BatteryEmpty = function BatteryEmpty(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3b);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "6",
        width: "18",
        height: "12",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20 10h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H20v-4z"
    }));
};
BatteryEmpty.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3a = [
    "color",
    "size"
];
var BatteryLow = function BatteryLow(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3a);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "6",
        width: "18",
        height: "12",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7 10v4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20 10h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H20v-4z"
    }));
};
BatteryLow.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$39 = [
    "color",
    "size"
];
var BatteryMedium = function BatteryMedium(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$39);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "6",
        width: "18",
        height: "12",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20 10h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H20v-4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7 10v4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11 10v4"
    }));
};
BatteryMedium.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$38 = [
    "color",
    "size"
];
var BatteryFull = function BatteryFull(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$38);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "6",
        width: "18",
        height: "12",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7 10v4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11 10v4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 10v4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20 10h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H20v-4z"
    }));
};
BatteryFull.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$37 = [
    "color",
    "size"
];
var Flashlight = function Flashlight(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$37);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 4v1c0 1.636 2 4 3 5l.75 9.01A3.26 3.26 0 0 0 12 22v0a3.26 3.26 0 0 0 3.25-2.99L16 10c1-1 3-3.364 3-5V4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 11v2"
    }), /*#__PURE__*/ React__default["default"].createElement("ellipse", {
        cx: "12",
        cy: "4",
        rx: "7",
        ry: "2"
    }));
};
Flashlight.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$36 = [
    "color",
    "size"
];
var Calculator = function Calculator(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$36);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v5H2V6z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18.5 16.5h-3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 11h10v7a4 4 0 0 1-4 4h-6V11z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 11H2v7a4 4 0 0 0 4 4h6V11z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5.5 18L7 16.5m0 0L8.5 15M7 16.5L8.5 18M7 16.5L5.5 15"
    }));
};
Calculator.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$35 = [
    "color",
    "size"
];
var Alarm = function Alarm(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$35);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "13",
        r: "9"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.5 9.5L12 13"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 19l1 3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 19l-1 3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 5l3-3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 2l3 3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 4V2"
    }));
};
Alarm.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$34 = [
    "color",
    "size"
];
var Globe = function Globe(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$34);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("ellipse", {
        cx: "12",
        cy: "12",
        rx: "10",
        ry: "4",
        transform: "rotate(90 12 12)"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 12h20"
    }));
};
Globe.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$33 = [
    "color",
    "size"
];
var BookOpen = function BookOpen(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$33);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 6s1.5-2 5-2 5 2 5 2v14s-1.5-1-5-1-5 1-5 1V6z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 6s1.5-2 5-2 5 2 5 2v14s-1.5-1-5-1-5 1-5 1V6z"
    }));
};
BookOpen.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$32 = [
    "color",
    "size"
];
var Cloud = function Cloud(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$32);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5.034 11.117A4.002 4.002 0 0 0 6 19h11a5 5 0 1 0-1.17-9.862L14.5 9.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.83 9.138a5.5 5.5 0 0 0-10.796 1.98S5.187 12 5.5 12.5"
    }));
};
Cloud.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$31 = [
    "color",
    "size"
];
var Envelope = function Envelope(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$31);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 8l7.501 6.001a4 4 0 0 0 4.998 0L22 8"
    }));
};
Envelope.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$30 = [
    "color",
    "size"
];
var ShoppingBag = function ShoppingBag(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$30);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3.977 9.84A2 2 0 0 1 5.971 8h12.058a2 2 0 0 1 1.994 1.84l.803 10A2 2 0 0 1 18.833 22H5.167a2 2 0 0 1-1.993-2.16l.803-10z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 11V6a4 4 0 0 0-4-4v0a4 4 0 0 0-4 4v5"
    }));
};
ShoppingBag.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2$ = [
    "color",
    "size"
];
var Gift = function Gift(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2$);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "3",
        y: "8",
        width: "18",
        height: "14",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 5a3 3 0 1 0-3 3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 8a3 3 0 1 0-3-3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 5v17"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21 15H3"
    }));
};
Gift.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2_ = [
    "color",
    "size"
];
var Map = function Map(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2_);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8.368 4.79l-2.736-.913A2 2 0 0 0 3 5.775v11.783a2 2 0 0 0 1.368 1.898l4 1.333a2 2 0 0 0 1.264 0l4.736-1.578a2 2 0 0 1 1.264 0l2.736.912A2 2 0 0 0 21 18.224V6.442a2 2 0 0 0-1.367-1.898l-4-1.333a2 2 0 0 0-1.265 0L9.631 4.789a2 2 0 0 1-1.264 0z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 5v16"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 3v16"
    }));
};
Map.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2Z = [
    "color",
    "size"
];
var Shield = function Shield(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2Z);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13.147 21.197l1.67-1.168a13.393 13.393 0 0 0 5.447-13.624.837.837 0 0 0-.453-.586L12 2 4.19 5.819a.837.837 0 0 0-.454.586 13.393 13.393 0 0 0 5.448 13.624l1.67 1.168a2 2 0 0 0 2.293 0z"
    }));
};
Shield.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2Y = [
    "color",
    "size"
];
var Tag = function Tag(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2Y);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.244 21.366a2.164 2.164 0 0 1-3.061 0l-8.549-8.549A2.164 2.164 0 0 1 3 11.287V5.163C3 3.97 3.97 3 5.164 3h6.123c.573 0 1.124.228 1.53.634l8.549 8.549a2.164 2.164 0 0 1 0 3.061l-6.122 6.122z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6.5 6.5L7 7"
    }));
};
Tag.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2X = [
    "color",
    "size"
];
var Gear = function Gear(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2X);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 3.269C14 2.568 13.432 2 12.731 2H11.27C10.568 2 10 2.568 10 3.269v0c0 .578-.396 1.074-.935 1.286-.085.034-.17.07-.253.106-.531.23-1.162.16-1.572-.249v0a1.269 1.269 0 0 0-1.794 0L4.412 5.446a1.269 1.269 0 0 0 0 1.794v0c.41.41.48 1.04.248 1.572a7.946 7.946 0 0 0-.105.253c-.212.539-.708.935-1.286.935v0C2.568 10 2 10.568 2 11.269v1.462C2 13.432 2.568 14 3.269 14v0c.578 0 1.074.396 1.286.935.034.085.07.17.105.253.231.531.161 1.162-.248 1.572v0a1.269 1.269 0 0 0 0 1.794l1.034 1.034a1.269 1.269 0 0 0 1.794 0v0c.41-.41 1.04-.48 1.572-.249.083.037.168.072.253.106.539.212.935.708.935 1.286v0c0 .701.568 1.269 1.269 1.269h1.462c.701 0 1.269-.568 1.269-1.269v0c0-.578.396-1.074.935-1.287.085-.033.17-.068.253-.104.531-.232 1.162-.161 1.571.248v0a1.269 1.269 0 0 0 1.795 0l1.034-1.034a1.269 1.269 0 0 0 0-1.794v0c-.41-.41-.48-1.04-.249-1.572.037-.083.072-.168.106-.253.212-.539.708-.935 1.286-.935v0c.701 0 1.269-.568 1.269-1.269V11.27c0-.701-.568-1.269-1.269-1.269v0c-.578 0-1.074-.396-1.287-.935a7.755 7.755 0 0 0-.105-.253c-.23-.531-.16-1.162.249-1.572v0a1.269 1.269 0 0 0 0-1.794l-1.034-1.034a1.269 1.269 0 0 0-1.794 0v0c-.41.41-1.04.48-1.572.249a7.913 7.913 0 0 0-.253-.106C14.396 4.343 14 3.847 14 3.27v0z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z"
    }));
};
Gear.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2W = [
    "color",
    "size"
];
var Flag = function Flag(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2W);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 15h13.865a1 1 0 0 0 .768-1.64L15 9l3.633-4.36A1 1 0 0 0 17.865 3H4v18"
    }));
};
Flag.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2V = [
    "color",
    "size"
];
var Ticket = function Ticket(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2V);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8.707 3.293c-.39.39-.369 1.021-.138 1.523a2.83 2.83 0 0 1-3.753 3.753c-.502-.23-1.133-.252-1.523.138l-.586.586a1 1 0 0 0 0 1.414l10.586 10.586a1 1 0 0 0 1.414 0l.586-.586c.39-.39.369-1.021.138-1.523a2.83 2.83 0 0 1 3.753-3.753c.502.23 1.133.252 1.523-.138l.586-.586a1 1 0 0 0 0-1.414L10.707 2.707a1 1 0 0 0-1.414 0l-.586.586z"
    }));
};
Ticket.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2U = [
    "color",
    "size"
];
var Bug = function Bug(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2U);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 9a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v5a7 7 0 0 1-7 7v0a7 7 0 0 1-7-7V9z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 6v-.425c0-.981.384-1.96 1.326-2.238 1.525-.45 3.823-.45 5.348 0C15.616 3.615 16 4.594 16 5.575V6"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18.5 7.5L22 4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5.5 7.5L2 4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 18l-4 3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 12H1.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22.5 12H19"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18 18l4 3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 13v8"
    }));
};
Bug.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2T = [
    "color",
    "size"
];
var Copy = function Copy(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2T);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 4v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7.242a2 2 0 0 0-.602-1.43L16.083 2.57A2 2 0 0 0 14.685 2H10a2 2 0 0 0-2 2z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 18v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2"
    }));
};
Copy.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2S = [
    "color",
    "size"
];
var Lifesaver = function Lifesaver(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2S);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_73_30)"
    }, /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10",
        transform: "rotate(45 12 12)"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "4",
        transform: "rotate(45 12 12)"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19.071 4.929l-4.243 4.243"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9.172 14.828l-4.243 4.243"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19.071 19.071l-4.243-4.243"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9.172 9.172L4.929 4.929"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_73_30"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
Lifesaver.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2R = [
    "color",
    "size"
];
var Star = function Star(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2R);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.074 2.633c.32-.844 1.531-.844 1.852 0l2.07 5.734c.145.38.514.633.926.633h5.087c.94 0 1.35 1.17.611 1.743L18 14a.968.968 0 0 0-.322 1.092L19 20.695c.322.9-.72 1.673-1.508 1.119l-4.917-3.12a1 1 0 0 0-1.15 0l-4.917 3.12c-.787.554-1.83-.22-1.508-1.119l1.322-5.603A.968.968 0 0 0 6 14l-3.62-3.257C1.64 10.17 2.052 9 2.99 9h5.087a.989.989 0 0 0 .926-.633l2.07-5.734z"
    }));
};
Star.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2Q = [
    "color",
    "size"
];
var BatteryCharging = function BatteryCharging(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2Q);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "6",
        width: "18",
        height: "12",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20 10h1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H20v-4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.4 9L9 12h4l-2.4 3"
    }));
};
BatteryCharging.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2P = [
    "color",
    "size"
];
var Trophy = function Trophy(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2P);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v5a7 7 0 0 1-7 7v0a7 7 0 0 1-7-7V4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 22h6l-3-5-3 5z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 4H4a2 2 0 0 0-2 2v1.239a4 4 0 0 0 2.128 3.535L5.5 11.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 4h1a2 2 0 0 1 2 2v.637a5 5 0 0 1-2.66 4.419l-.84.444"
    }));
};
Trophy.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2O = [
    "color",
    "size"
];
var Leaf = function Leaf(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2O);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 18C19.954 18 20.917 7.83 20.994 2.997a.983.983 0 0 0-1.006-.988C3 2.321 3 10.557 3 18v4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 18s0-6 8-7"
    }));
};
Leaf.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2N = [
    "color",
    "size"
];
var Schedule = function Schedule(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2N);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 20H6a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h11a4 4 0 0 1 4 4v3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 2v2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 2v2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 8h19"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18.5 15.643l-1.5 1.5"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "17",
        cy: "17",
        r: "5"
    }));
};
Schedule.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2M = [
    "color",
    "size"
];
var Money = function Money(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2M);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7z"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 9v0a4 4 0 0 0 4-4v0"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18 19v0a4 4 0 0 1 4-4v0"
    }));
};
Money.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2L = [
    "color",
    "size"
];
var Scissor = function Scissor(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2L);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8.252 18.459C7.462 19.764 7.107 21 5.7 21 4.209 21 3 19.757 3 18.223s1.209-2.778 2.7-2.778c1.4 0 2.55 1.095 2.686 2.498a.846.846 0 0 1-.134.515zm0 0l1.948-3.476m5.548 3.476C16.538 19.764 16.893 21 18.3 21c1.491 0 2.7-1.243 2.7-2.777s-1.209-2.778-2.7-2.778c-1.4 0-2.55 1.095-2.687 2.498-.017.182.04.36.135.515zm0 0L7.093 3.346a.659.659 0 0 0-1.1-.081c-1.704 2.19-1.534 5.35.395 7.333l9.36 7.86zm-3.797-6.63l4.953-8.494a.66.66 0 0 1 1.098-.076c1.707 2.194 1.537 5.358-.395 7.345L16.5 11.742"
    }));
};
Scissor.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2K = [
    "color",
    "size"
];
var Coin = function Coin(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2K);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("ellipse", {
        cx: "9.5",
        cy: "10",
        rx: "9.5",
        ry: "10",
        transform: "matrix(-1 0 0 1 20 2)"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13 8.8a3.583 3.583 0 0 0-2.25-.8C8.679 8 7 9.79 7 12s1.679 4 3.75 4c.844 0 1.623-.298 2.25-.8"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10 2c4.333 0 13 1 13 10s-8.667 10-13 10"
    }));
};
Coin.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2J = [
    "color",
    "size"
];
var Telescope = function Telescope(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2J);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7 21l6-8 8 8"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5.228 7.303l13.532-5.06a1 1 0 0 1 1.108.285l.19.22A8 8 0 0 1 22 7.973v.616a1 1 0 0 1-.65.937l-13.536 5.06-2.586-7.283z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2.66 11.371a2 2 0 0 1 1.193-2.545l1.694-.624 1.944 5.473-1.64.612a2 2 0 0 1-2.585-1.205l-.606-1.711z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13 13v9"
    }));
};
Telescope.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2I = [
    "color",
    "size"
];
var Planet = function Planet(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2I);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "8"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8.399 4.849C5.372 2.582 2.972 1.489 2.23 2.23c-1.174 1.174 2.248 6.5 7.643 11.895 5.396 5.395 10.722 8.817 11.895 7.643.431-.43.243-1.421-.435-2.769"
    }));
};
Planet.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2H = [
    "color",
    "size"
];
var GameController = function GameController(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2H);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 15l-2.968 2.968A2.362 2.362 0 0 1 2 16.298V15l1.357-6.784A4 4 0 0 1 7.279 5h9.442a4 4 0 0 1 3.922 3.216L22 15v1.297a2.362 2.362 0 0 1-4.032 1.67L15 15H9z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 5l1 2h4l1-2"
    }));
};
GameController.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2G = [
    "color",
    "size"
];
var VrAr = function VrAr(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2G);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 10a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-3.868a2 2 0 0 1-1.715-.971l-1.56-2.6a1 1 0 0 0-1.714 0l-1.56 2.6A2 2 0 0 1 7.868 19H4a2 2 0 0 1-2-2v-7z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3.813 6.781A4 4 0 0 1 7.14 5h9.718a4 4 0 0 1 3.328 1.781L21 8H3l.813-1.219z"
    }));
};
VrAr.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2F = [
    "color",
    "size"
];
var Computing = function Computing(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2F);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "5",
        y: "5",
        width: "14",
        height: "14",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 5V2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 5V3l1-1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 22v-3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 22v-3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 8H2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 8h-3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 16h-3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 16H3l-1 1"
    }));
};
Computing.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2E = [
    "color",
    "size"
];
var Inbox = function Inbox(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2E);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3.304 6.132A4 4 0 0 1 7.209 3h9.582a4 4 0 0 1 3.905 3.132l.147.662a23.997 23.997 0 0 1 0 10.412l-.147.662A4 4 0 0 1 16.791 21H7.21a4 4 0 0 1-3.905-3.132l-.147-.662a24 24 0 0 1 0-10.412l.147-.662z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2.5 13h6.338c0 1 .973 3 3.405 3 2.433 0 3.406-2 3.406-3H21.5"
    }));
};
Inbox.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2D = [
    "color",
    "size"
];
var LightBulb = function LightBulb(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2D);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10 22h4M5 9a7 7 0 0 1 14 0 6.972 6.972 0 0 1-3 5.734l-.542 2.566a2 2 0 0 1-1.977 1.7h-2.962a2 2 0 0 1-1.977-1.7L8 14.745A6.992 6.992 0 0 1 5 9z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 15h8"
    }));
};
LightBulb.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2C = [
    "color",
    "size"
];
var Chess = function Chess(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2C);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13.533 3.81L8 2l1 4-5.37 4.475A1.75 1.75 0 0 0 3 11.82v0c0 .617.537 1.088 1.127.986L9 12l-2.097 7h10.614l1.283-5.745c.913-4.088-1.386-8.21-5.267-9.445z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 21a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1H4v-1z"
    }));
};
Chess.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2B = [
    "color",
    "size"
];
var TrashCan = function TrashCan(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2B);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 6h16l-1.58 14.22A2 2 0 0 1 16.432 22H7.568a2 2 0 0 1-1.988-1.78L4 6z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7.345 3.147A2 2 0 0 1 9.154 2h5.692a2 2 0 0 1 1.81 1.147L18 6H6l1.345-2.853z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 6h20"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10 11v5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 11v5"
    }));
};
TrashCan.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2A = [
    "color",
    "size"
];
var Microphone = function Microphone(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2A);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "8",
        y: "2",
        width: "8",
        height: "13",
        rx: "4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18 16.292A7.98 7.98 0 0 1 12 19a7.98 7.98 0 0 1-6-2.708"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 19v3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10 22h4"
    }));
};
Microphone.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2z = [
    "color",
    "size"
];
var Coffee = function Coffee(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2z);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11 7c4.418 0 8 .895 8 2s-3.582 2-8 2-8-.895-8-2c0-.357.375-.693 1.033-.984"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 9v9.343c0 1.061.44 2.08 1.409 2.513C5.624 21.399 7.711 22 11 22c3.29 0 5.377-.601 6.591-1.144.968-.433 1.409-1.452 1.409-2.513V9"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 10v0a3 3 0 0 1 3 3v0a3 3 0 0 1-3 3v0"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7 3v4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11 2v2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 4v3"
    }));
};
Coffee.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2y = [
    "color",
    "size"
];
var CreditCard = function CreditCard(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2y);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "4",
        width: "20",
        height: "16",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 10.016A2.794 2.794 0 0 0 9.857 9C8.28 9 7 10.343 7 12s1.28 3 2.857 3c.854 0 1.62-.393 2.143-1.016M17 12c0 1.657-1.28 3-2.857 3-1.578 0-2.857-1.343-2.857-3s1.279-3 2.857-3C15.72 9 17 10.343 17 12z"
    }));
};
CreditCard.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2x = [
    "color",
    "size"
];
var Utensils = function Utensils(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2x);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11 8V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v5a4 4 0 0 0 4 4h1a4 4 0 0 0 4-4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 16V2h3a4 4 0 0 1 4 4v10h-4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 16v5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 12v9a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-9"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 6V2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 6V2"
    }));
};
Utensils.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2w = [
    "color",
    "size"
];
var Radish = function Radish(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2w);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 10H8c-2.188 0-3.698 1.415-3.935 3.282-.325 2.56.529 4.105 3.634 5.128 1.394.46 2.579 1.464 3.01 2.868l.223.722.095-.082a8 8 0 0 1 2.175-1.331l1.921-.789c3.286-1.348 5.22-3.408 4.826-6.516C19.712 11.415 18.188 10 16 10z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.964 6.97s-3.075.306-4.685-1.035C5.669 4.593 6.036 2.03 6.036 2.03s3.075-.306 4.686 1.035c1.61 1.342 1.242 3.905 1.242 3.905z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12.036 6.97s3.075.306 4.685-1.035c1.61-1.342 1.243-3.905 1.243-3.905s-3.075-.306-4.685 1.035c-1.61 1.342-1.243 3.905-1.243 3.905z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 11.5c-.5 1-3.134 1.5-7 1.5s-6.5-.5-7-1.5"
    }));
};
Radish.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2v = [
    "color",
    "size"
];
var Clipboard = function Clipboard(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2v);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.5 4H18a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8.621 3.515A2 2 0 0 1 10.561 2h2.877a2 2 0 0 1 1.94 1.515L16 6H8l.621-2.485z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 12h6"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 16h6"
    }));
};
Clipboard.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2u = [
    "color",
    "size"
];
var Bicycle = function Bicycle(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2u);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "6",
        cy: "15",
        r: "4"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "18",
        cy: "15",
        r: "4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 15l2-7h7.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 5h3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18 15L15 5h4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 5h.5A1.5 1.5 0 0 1 21 6.5v0A1.5 1.5 0 0 1 19.5 8H19"
    }));
};
Bicycle.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2t = [
    "color",
    "size"
];
var Plane = function Plane(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2t);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 11l-2 4 3.408 1.363a4 4 0 0 1 2.229 2.229L9 22l4-2-1.21-2.42a2 2 0 0 1 .679-2.56L14 14l4 7 3-4-2.29-7.469.715-.714c1.412-1.412 2.71-3.682 1.075-5.317-1.635-1.635-3.91-.34-5.316 1.077l-.72.708L7 3 3 6l7 4-1.02 1.531a2 2 0 0 1-2.56.68L4 11z"
    }));
};
Plane.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2s = [
    "color",
    "size"
];
var PlaneFill = function PlaneFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2s);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 11l-2 4 3.408 1.363a4 4 0 0 1 2.229 2.229L9 22l4-2-1.21-2.42a2 2 0 0 1 .679-2.56L14 14l4 7 3-4-2.29-7.469.715-.714c1.412-1.412 2.71-3.682 1.075-5.317-1.635-1.635-3.91-.34-5.316 1.077l-.72.708L7 3 3 6l7 4-1.02 1.531a2 2 0 0 1-2.56.68L4 11z"
    }));
};
PlaneFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2r = [
    "color",
    "size"
];
var Jar = function Jar(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2r);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 9l1.164 8.926a3.875 3.875 0 0 0 2.844 3.243v0c3.27.872 6.713.872 9.984 0v0a3.875 3.875 0 0 0 2.844-3.243L21 9"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5.035 7.266C3.763 7.661 3 8.165 3 8.714 3 9.977 7.03 11 12 11s9-1.023 9-2.286c0-.55-.764-1.054-2.037-1.448"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 4l-3 .51C4.159 4.874 3 5.407 3 6c0 1.105 4.03 2 9 2s9-.895 9-2c0-.592-1.159-1.125-3-1.49L15 4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 4v0a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v0"
    }));
};
Jar.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2q = [
    "color",
    "size"
];
var Glasses = function Glasses(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2q);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "6",
        cy: "14",
        r: "4"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "18",
        cy: "14",
        r: "4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10 14l.211-.106a4 4 0 0 1 3.578 0L14 14"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 6l2.838 6.623a2 2 0 0 1 .162.788V14"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 6l-2.838 6.623A2 2 0 0 0 2 13.41V14"
    }));
};
Glasses.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2p = [
    "color",
    "size"
];
var Plant = function Plant(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2p);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.964 6.97s-3.075.306-4.685-1.035C5.669 4.593 6.036 2.03 6.036 2.03s3.075-.306 4.686 1.035c1.61 1.342 1.242 3.905 1.242 3.905z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12.036 6.97s3.075.306 4.685-1.035c1.61-1.342 1.243-3.905 1.243-3.905s-3.075-.306-4.685 1.035c-1.61 1.342-1.243 3.905-1.243 3.905z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 11a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 14h14l-2 8H7l-2-8z"
    }));
};
Plant.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2o = [
    "color",
    "size"
];
var Edit = function Edit(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2o);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16.474 5.408l2.118 2.117m-.756-3.982L12.109 9.27a2.118 2.118 0 0 0-.58 1.082L11 13l2.648-.53c.41-.082.786-.283 1.082-.579l5.727-5.727a1.853 1.853 0 1 0-2.621-2.621z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 15v3a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h3"
    }));
};
Edit.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2n = [
    "color",
    "size"
];
var TrashBin = function TrashBin(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2n);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 4l2.303 14.076a4 4 0 0 0 2.738 3.167l.328.104a12 12 0 0 0 7.262 0l.328-.104a4 4 0 0 0 2.738-3.166L21 4"
    }), /*#__PURE__*/ React__default["default"].createElement("ellipse", {
        cx: "12",
        cy: "4",
        rx: "9",
        ry: "2"
    }));
};
TrashBin.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2m = [
    "color",
    "size"
];
var SunFill = function SunFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2m);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 1a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1zM3.293 3.293a1 1 0 0 1 1.414 0l1.5 1.5a1 1 0 0 1-1.414 1.414l-1.5-1.5a1 1 0 0 1 0-1.414zm17.414 0a1 1 0 0 1 0 1.414l-1.5 1.5a1 1 0 1 1-1.414-1.414l1.5-1.5a1 1 0 0 1 1.414 0zM1 12a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1zm19 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1zM6.207 17.793a1 1 0 0 1 0 1.414l-1.5 1.5a1 1 0 0 1-1.414-1.414l1.5-1.5a1 1 0 0 1 1.414 0zm11.586 0a1 1 0 0 1 1.414 0l1.5 1.5a1 1 0 0 1-1.414 1.414l-1.5-1.5a1 1 0 0 1 0-1.414zM12 20a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1z"
    }));
};
SunFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2l = [
    "color",
    "size"
];
var MoonFill = function MoonFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2l);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20.958 15.325c.204-.486-.379-.9-.868-.684a7.684 7.684 0 0 1-3.101.648c-4.185 0-7.577-3.324-7.577-7.425a7.28 7.28 0 0 1 1.134-3.91c.284-.448-.057-1.068-.577-.936C5.96 4.041 3 7.613 3 11.862 3 16.909 7.175 21 12.326 21c3.9 0 7.24-2.345 8.632-5.675z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.611 3.103c-.53-.354-1.162.278-.809.808l.63.945a2.332 2.332 0 0 1 0 2.588l-.63.945c-.353.53.28 1.162.81.808l.944-.63a2.332 2.332 0 0 1 2.588 0l.945.63c.53.354 1.162-.278.808-.808l-.63-.945a2.332 2.332 0 0 1 0-2.588l.63-.945c.354-.53-.278-1.162-.809-.808l-.944.63a2.332 2.332 0 0 1-2.588 0l-.945-.63z"
    }));
};
MoonFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2k = [
    "color",
    "size"
];
var KeyCap = function KeyCap(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2k);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7 3s3 .5 5 .5 5-.5 5-.5l1 9s-3 1-6 1-6-1-6-1l1-9z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3.869 8.147l-.862 10.294c-.03.366.04.733.205 1.06l.197.393A2.01 2.01 0 0 0 5.206 21h13.588a2.01 2.01 0 0 0 1.797-1.106l.197-.392c.165-.328.236-.695.205-1.06l-.862-10.295a3.99 3.99 0 0 0-.79-2.068L17 3s-3 .5-5 .5S6.978 3 6.978 3l-2.32 3.08a3.99 3.99 0 0 0-.79 2.067z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 12l-2.5 8M18 12l2.5 8"
    }));
};
KeyCap.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2j = [
    "color",
    "size"
];
var Newspaper = function Newspaper(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2j);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 21h12a4 4 0 0 0 4-4V5a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v13c0 1.657-.343 3-2 3z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 10a2 2 0 0 1 2-2h2v10.5c0 1.38-.62 2.5-2 2.5s-2-1.12-2-2.5V10z"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "8",
        r: "1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11 14h6"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11 17h3"
    }));
};
Newspaper.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2i = [
    "color",
    "size"
];
var Door = function Door(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2i);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 2h11a3 3 0 0 1 3 3v14a1 1 0 0 1-1 1h-3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 2l7.588 1.518A3 3 0 0 1 15 6.459V20.78a1 1 0 0 1-1.196.98l-7.196-1.438A2 2 0 0 1 5 18.36V2z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 12v2"
    }));
};
Door.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2h = [
    "color",
    "size"
];
var Water = function Water(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2h);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 22a8 8 0 0 1-8-8c0-3.502 2.71-6.303 5.093-8.87L12 2l2.907 3.13C17.29 7.698 20 10.499 20 14a8 8 0 0 1-8 8z"
    }));
};
Water.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2g = [
    "color",
    "size"
];
var Fire = function Fire(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2g);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 22c-4.97 0-9-2.582-9-7v-.088C3 12.794 4.338 11.1 6.375 10c1.949-1.052 3.101-2.99 2.813-5l-.563-3 2.086.795c3.757 1.43 6.886 3.912 8.914 7.066A8.495 8.495 0 0 1 21 14.464V15c0 1.562-.504 2.895-1.375 3.965"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 22c-1.657 0-3-1.433-3-3.2 0-1.4 1.016-2.521 1.91-3.548L12 14l1.09 1.252C13.984 16.28 15 17.4 15 18.8c0 1.767-1.343 3.2-3 3.2z"
    }));
};
Fire.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2f = [
    "color",
    "size"
];
var Air = function Air(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2f);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 8h7a3 3 0 1 0-3-3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 16h11a3 3 0 1 1-3 3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 12h17a3 3 0 1 0-3-3"
    }));
};
Air.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2e = [
    "color",
    "size"
];
var Home = function Home(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2e);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21 19v-6.733a4 4 0 0 0-1.245-2.9L13.378 3.31a2 2 0 0 0-2.755 0L4.245 9.367A4 4 0 0 0 3 12.267V19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z"
    }));
};
Home.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2d = [
    "color",
    "size"
];
var Umbrella = function Umbrella(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2d);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 4c-4.915 0-8.91 3.378-8.999 8.817a.18.18 0 0 0 .182.183.188.188 0 0 0 .17-.11C3.876 11.767 4.782 11.5 6 11.5c1.185 0 1.964.227 2.456 1.302.054.12.172.198.304.198a.366.366 0 0 0 .326-.224C9.56 11.729 10.901 11.5 12 11.5M12 4c4.916 0 8.91 3.378 8.998 8.817a.18.18 0 0 1-.18.183.188.188 0 0 1-.17-.11c-.525-1.123-1.43-1.39-2.648-1.39-1.185 0-1.964.227-2.456 1.302a.336.336 0 0 1-.304.198.366.366 0 0 1-.326-.224C14.44 11.729 13.099 11.5 12 11.5M12 4V2m0 9.5V20a2 2 0 1 1-4 0"
    }));
};
Umbrella.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2c = [
    "color",
    "size"
];
var TogoCup = function TogoCup(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2c);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 5.4A2.4 2.4 0 0 1 5.4 3h13.2A2.4 2.4 0 0 1 21 5.4v0a.6.6 0 0 1-.6.6H3.6a.6.6 0 0 1-.6-.6v0z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 6h14l-1.555 14.218A2 2 0 0 1 15.457 22H8.543a2 2 0 0 1-1.988-1.782L5 6z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6.313 18l-.875-8h13.125l-.875 8H6.313z"
    }));
};
TogoCup.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2b = [
    "color",
    "size"
];
var Devices = function Devices(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2b);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10 15H4V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 18h12"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 9.2c0-.663.597-1.2 1.333-1.2h5.334C21.403 8 22 8.537 22 9.2v9.6c0 .663-.597 1.2-1.333 1.2h-5.334C14.597 20 14 19.463 14 18.8V9.2z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18 17h.01"
    }));
};
Devices.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2a = [
    "color",
    "size"
];
var ShippingBoxV1 = function ShippingBoxV1(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2a);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.029 2.54a2 2 0 0 1 1.942 0l7.515 4.174a1 1 0 0 1 .514.874v8.235a2 2 0 0 1-1.029 1.748l-7 3.89a2 2 0 0 1-1.942 0l-7-3.89A2 2 0 0 1 3 15.824V7.588a1 1 0 0 1 .514-.874L11.03 2.54z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 7l9 5m0 0l9-5m-9 5v9.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7.5 9.5l9-5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 12.328L9 14"
    }));
};
ShippingBoxV1.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$29 = [
    "color",
    "size"
];
var ShippingBoxV2 = function ShippingBoxV2(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$29);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.029 2.54a2 2 0 0 1 1.942 0l7.515 4.174a1 1 0 0 1 .514.874v8.235a2 2 0 0 1-1.029 1.748l-7 3.89a2 2 0 0 1-1.942 0l-7-3.89A2 2 0 0 1 3 15.824V7.588a1 1 0 0 1 .514-.874L11.03 2.54z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7.5 4.5l9 5V13"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 12.328L9 14"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 7l9 5m0 0l9-5m-9 5v9.5"
    }));
};
ShippingBoxV2.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$28 = [
    "color",
    "size"
];
var Cart = function Cart(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$28);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 7h13.79a2 2 0 0 1 1.99 2.199l-.6 6A2 2 0 0 1 18.19 17H8.64a2 2 0 0 1-1.962-1.608L5 7z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 7l-.81-3.243A1 1 0 0 0 3.22 3H2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 21h2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 21h2"
    }));
};
Cart.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$27 = [
    "color",
    "size"
];
var Basket = function Basket(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$27);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2.31 11.242A1 1 0 0 1 3.28 10h17.44a1 1 0 0 1 .97 1.242l-1.811 7.243A2 2 0 0 1 17.939 20H6.061a2 2 0 0 1-1.94-1.515L2.31 11.243z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 14v2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 14v2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 10l4-6"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18 10l-4-6"
    }));
};
Basket.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$26 = [
    "color",
    "size"
];
var OpenEnvelope = function OpenEnvelope(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$26);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 11.083a4 4 0 0 1 1.706-3.277l6-4.2a4 4 0 0 1 4.588 0l6 4.2A4 4 0 0 1 22 11.083V19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7.917z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2.5 9.5l7.001 5.501a4 4 0 0 0 4.998 0L21.5 9.5"
    }));
};
OpenEnvelope.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$25 = [
    "color",
    "size"
];
var Clock = function Clock(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$25);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 16l-2.414-2.414A2 2 0 0 1 12 12.172V6"
    }));
};
Clock.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$24 = [
    "color",
    "size"
];
var Truck = function Truck(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$24);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10 17h6V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a1 1 0 0 0 1 1h1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 16v-4a4 4 0 0 0-4-4h-2v9h5a1 1 0 0 0 1-1z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15 17a3 3 0 1 0 6 0h-6z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 14h-2"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "7",
        cy: "17",
        r: "3"
    }));
};
Truck.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$23 = [
    "color",
    "size"
];
var WineGlass = function WineGlass(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$23);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 13c6 0 8-4.477 8-10H4c0 5.523 2 10 8 10z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 13v7"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 8h14"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 22h8l-4-2-4 2z"
    }));
};
WineGlass.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$22 = [
    "color",
    "size"
];
var VapeKit = function VapeKit(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$22);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 10a1 1 0 0 1 1-1h6v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V10z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13 15a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v6h-8v-6z"
    }), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "15",
        y: "9",
        width: "4",
        height: "3"
    }), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "6",
        y: "4",
        width: "4",
        height: "5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 4V2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 9V6"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 17v-5"
    }));
};
VapeKit.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$21 = [
    "color",
    "size"
];
var Briefcase = function Briefcase(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$21);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "3",
        y: "7",
        width: "18",
        height: "12",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1H9V6z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10 12l.211.106a4 4 0 0 0 3.578 0L14 12"
    }));
};
Briefcase.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$20 = [
    "color",
    "size"
];
var Boat = function Boat(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$20);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16.926 19.381l-4.302 1.414a2 2 0 0 1-1.248 0L7.074 19.38a4 4 0 0 1-2.623-2.794L3 11l9 1 9-1-1.451 5.587a4 4 0 0 1-2.623 2.794z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6.497 7.257A2 2 0 0 1 8.354 6h7.292a2 2 0 0 1 1.857 1.257L19 11l-7 1-7-1 1.497-3.743z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 3v3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11 3h2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 12v4"
    }));
};
Boat.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1$ = [
    "color",
    "size"
];
var Crown = function Crown(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1$);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 8l1.304 1.043a4 4 0 0 0 5.995-1.181L12 3l2.701 4.862a4 4 0 0 0 5.995 1.18L22 8l-1.754 8.77a2.564 2.564 0 0 1-1.367 1.79v0a15.381 15.381 0 0 1-13.758 0v0a2.564 2.564 0 0 1-1.367-1.79L2 8z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 15c2.596 1.333 5.404 1.333 8 0"
    }));
};
Crown.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1_ = [
    "color",
    "size"
];
var Sword = function Sword(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1_);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18 3l4-1-1 4-10 10-2.5-.5L8 13 18 3z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 20l2 2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 14l1 4 4 1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 18l-3 3"
    }));
};
Sword.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1Z = [
    "color",
    "size"
];
var DoubleSword = function DoubleSword(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1Z);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 19.2L3.8 21m.9-7.2l.9 3.6m0 0l3.6.9m-3.6-.9l-2.7 2.7M16.4 3.9l-9 9 .45 2.25 2.25.45 9-9L20 3l-3.6.9z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 19.2L20.2 21m-.9-7.2l-.9 3.6m0 0l2.7 2.7m-2.7-2.7l-1.8.45-1.8.45M9.3 11L4.9 6.6 4 3l3.6.9L12 8.3m.1 5.5l1.8 1.8 2.25-.45.45-2.25-1.8-1.8"
    }));
};
DoubleSword.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1Y = [
    "color",
    "size"
];
var Key = function Key(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1Y);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 18l2-2h2l1.36-1.36a6.5 6.5 0 1 0-3.997-3.992L2 18v4h4l2-2v-2z"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "17",
        cy: "7",
        r: "1"
    }));
};
Key.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1X = [
    "color",
    "size"
];
var Dental = function Dental(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1X);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 4.363C9 2.732 3 1.23 3 8.277c0 5.492 1.188 9.756 3.005 12.141.645.847 2.216.584 2.888-.265a1.22 1.22 0 0 0 .174-.328l1.063-2.8c.654-1.72 3.086-1.72 3.74 0l1.063 2.8c.045.116.097.23.174.328.672.85 2.243 1.112 2.888.265C19.812 18.033 21 13.77 21 8.277c0-7.046-6-5.545-9-3.914zm0 0L15 6"
    }));
};
Dental.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1W = [
    "color",
    "size"
];
var Cake = function Cake(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1W);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 13a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 13l2.914 2.331c1.187.95 2.9.855 3.975-.22v0a2.985 2.985 0 0 1 4.222 0v0a2.985 2.985 0 0 0 3.975.22L21 13"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 6a2 2 0 0 1-2-2c0-.876.677-1.576 1.273-2.217L12 1l.727.783C13.323 2.424 14 3.124 14 4a2 2 0 0 1-2 2z"
    }));
};
Cake.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1V = [
    "color",
    "size"
];
var BookClose = function BookClose(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1V);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 4.222v15.556C4 21.005 5.023 22 6.286 22h11.428C18.977 22 20 21.005 20 19.778V8.444a2 2 0 0 0-2-2H6.286C5.023 6.444 4 5.45 4 4.222zm0 0C4 2.995 5.023 2 6.286 2h9.143c1.262 0 2.285.995 2.285 2.222v2.222"
    }));
};
BookClose.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1U = [
    "color",
    "size"
];
var Sparkles = function Sparkles(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1U);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 2l.19.94a4 4 0 0 0 2.57 2.974L8 6l-.24.086A4 4 0 0 0 5.19 9.06L5 10l-.19-.94a4 4 0 0 0-2.57-2.974L2 6l.24-.086A4 4 0 0 0 4.81 2.94L5 2z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 16l.23 1.276a2 2 0 0 0 1.219 1.501L10 19l-.551.223a2 2 0 0 0-1.22 1.5L8 22l-.23-1.276a2 2 0 0 0-1.219-1.501L6 19l.551-.223a2 2 0 0 0 1.22-1.5L8 16z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 3l.556 2.654a8 8 0 0 0 5.213 5.92L23 12l-1.231.426a8 8 0 0 0-5.213 5.92L16 21l-.556-2.654a8 8 0 0 0-5.213-5.92L9 12l1.231-.426a8 8 0 0 0 5.213-5.92L16 3z"
    }));
};
Sparkles.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1T = [
    "color",
    "size"
];
var Music = function Music(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1T);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 18V5.716a2 2 0 0 1 1.696-1.977l9-1.385A2 2 0 0 1 21 4.331V16"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 9l13-2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 18a3 3 0 1 1-6 0c0-1.657 1.343-2 3-2s3 .343 3 2z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21 16a3 3 0 1 1-6 0c0-1.657 1.343-2 3-2s3 .343 3 2z"
    }));
};
Music.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1S = [
    "color",
    "size"
];
var MusicNote = function MusicNote(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1S);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 4v14"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 7.674v-.657a4 4 0 0 0-2.901-3.846l-2.824-.807A1 1 0 0 0 12 3.326V7l5.725 1.636A1 1 0 0 0 19 7.674z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 18a3 3 0 1 1-6 0c0-1.657 1.343-2 3-2s3 .343 3 2z"
    }));
};
MusicNote.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1R = [
    "color",
    "size"
];
var MusicAlbum = function MusicAlbum(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1R);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 16.5V8.78a1 1 0 0 1 .757-.97l6-1.5A1 1 0 0 1 17 7.28V15"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 11l8-2"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "7.5",
        cy: "16.5",
        r: "1.5"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "15.5",
        cy: "15.5",
        r: "1.5"
    }));
};
MusicAlbum.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1Q = [
    "color",
    "size"
];
var MusicAlbumFill = function MusicAlbumFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1Q);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 5c0-2.21 1.792-4 4.002-4h13.996C21.208 1 23 2.79 23 5v14a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4V5zm19 7a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-8 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
    }));
};
MusicAlbumFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1P = [
    "color",
    "size"
];
var Dice6 = function Dice6(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1P);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 8h.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8.25 7.75v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8.25 11.75v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8.25 15.75v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.5 8h.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.75 7.75v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.75 11.75v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.75 15.75v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 12h.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.5 12h.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 16h.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.5 16h.5"
    }));
};
Dice6.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1O = [
    "color",
    "size"
];
var Dice5 = function Dice5(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1O);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 8h.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.5 8h.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 12h.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12.25 11.75v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 16h.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.5 16h.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8.25 7.75v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8.25 15.75v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.75 7.75v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.75 15.75v.5"
    }));
};
Dice5.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1N = [
    "color",
    "size"
];
var Bank = function Bank(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1N);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20 11V8l-8-5-8 5v3h16z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3 21h18"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5 20v-5h2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 20v-5h2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11 20v-5h2"
    }));
};
Bank.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1M = [
    "color",
    "size"
];
var PaperAirplane = function PaperAirplane(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1M);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9.474 16l9.181 3.284a1.1 1.1 0 0 0 1.462-.887L21.99 4.239c.114-.862-.779-1.505-1.567-1.13L2.624 11.605c-.88.42-.814 1.69.106 2.017l2.44.868 1.33.467M13 17.26l-1.99 3.326c-.65.808-1.959.351-1.959-.683V17.24a2 2 0 0 1 .53-1.356l3.871-4.2"
    }));
};
PaperAirplane.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1L = [
    "color",
    "size"
];
var HomeAlt1 = function HomeAlt1(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1L);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21 19v-6.733a4 4 0 0 0-1.245-2.9L13.378 3.31a2 2 0 0 0-2.755 0L4.245 9.367A4 4 0 0 0 3 12.267V19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 15a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6H9v-6z"
    }));
};
HomeAlt1.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1K = [
    "color",
    "size"
];
var CreditCardAlt1 = function CreditCardAlt1(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1K);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "4",
        width: "20",
        height: "16",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "6",
        y: "8",
        width: "2",
        height: "2"
    }));
};
CreditCardAlt1.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1J = [
    "color",
    "size"
];
var Receipt = function Receipt(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1J);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 21H7a4 4 0 0 1-4-4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v13c0 1.657.343 3 2 3z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21 10a2 2 0 0 0-2-2h-2v10.5c0 1.38.62 2.5 2 2.5s2-1.12 2-2.5V10z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13 11H7"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13 7H7"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10 15H7"
    }));
};
Receipt.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1I = [
    "color",
    "size"
];
var Hammer = function Hammer(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1I);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 22l-2-2 1-1 2 2-1 1z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9 13l2 2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 12l-8 8"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20 4l-1 1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9.707 7.707a1 1 0 0 1 0-1.414l4.086-4.086a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 0 1.414l-4.086 4.086a1 1 0 0 1-1.414 0L9.707 7.707z"
    }));
};
Hammer.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1H = [
    "color",
    "size"
];
var Data = function Data(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1H);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("ellipse", {
        cx: "12",
        cy: "6",
        rx: "8",
        ry: "3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6.037 12C4.77 12.53 4 13.232 4 14c0 1.657 3.582 3 8 3s8-1.343 8-3c0-.768-.77-1.47-2.037-2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 6v4c0 1.657 3.582 3 8 3s8-1.343 8-3V6"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 14v4c0 1.657 3.582 3 8 3s8-1.343 8-3v-4"
    }));
};
Data.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1G = [
    "color",
    "size"
];
var Dice4 = function Dice4(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1G);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 8h.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.5 8h.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 16h.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.5 16h.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8.25 7.75v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8.25 15.75v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.75 7.75v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.75 15.75v.5"
    }));
};
Dice4.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1F = [
    "color",
    "size"
];
var Dice3 = function Dice3(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1F);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12.25 11.75v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8.25 7.75v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.75 15.75v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 8h.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 12h.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.5 16h.5"
    }));
};
Dice3.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1E = [
    "color",
    "size"
];
var Dice2 = function Dice2(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1E);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8.25 7.75v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.75 15.75v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 8h.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.5 16h.5"
    }));
};
Dice2.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1D = [
    "color",
    "size"
];
var Dice1 = function Dice1(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1D);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12.25 11.75v.5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 12h.5"
    }));
};
Dice1.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1C = [
    "color",
    "size"
];
var PriceCut = function PriceCut(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1C);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2 7v8a2 2 0 0 0 2 2h1M2 7V5a2 2 0 0 1 2-2h2M2 7a4 4 0 0 0 4-4m0 0h13m-9.236 9A3 3 0 0 1 14 7.764M2 20L20 2m1.22 16.047l.549-6.261c.075-.865-.598-1.63-1.504-1.71l-.82-.071m1.776 8.042l-.137 1.566c-.076.864-.872 1.501-1.778 1.422l-1.64-.144m3.555-2.844c-1.813-.158-3.405 1.115-3.556 2.844m0 0L7 19.958m4.347-3.477c.409.52.94.785 1.67.849 1.359.119 2.553-.836 2.666-2.133.061-.696-.085-1.269-.551-1.743"
    }));
};
PriceCut.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1B = [
    "color",
    "size"
];
var Person = function Person(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1B);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "7",
        r: "5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 14h.352a3 3 0 0 1 2.976 2.628l.391 3.124A2 2 0 0 1 18.734 22H5.266a2 2 0 0 1-1.985-2.248l.39-3.124A3 3 0 0 1 6.649 14H7"
    }));
};
Person.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1A = [
    "color",
    "size"
];
var PersonAdd = function PersonAdd(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1A);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "7",
        r: "5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 22H5.266a2 2 0 0 1-1.985-2.248l.39-3.124A3 3 0 0 1 6.649 14H7"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 14v4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 16h4"
    }));
};
PersonAdd.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1z = [
    "color",
    "size"
];
var PersonCheck = function PersonCheck(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1z);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "7",
        r: "5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 22H5.266a2 2 0 0 1-1.985-2.248l.39-3.124A3 3 0 0 1 6.649 14H7"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 16.5l1.5 1.5 2.5-3"
    }));
};
PersonCheck.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1y = [
    "color",
    "size"
];
var PersonCross = function PersonCross(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1y);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "7",
        r: "5"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 22H5.266a2 2 0 0 1-1.985-2.248l.39-3.124A3 3 0 0 1 6.649 14H7"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21 18l-3-3m3 0l-3 3"
    }));
};
PersonCross.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1x = [
    "color",
    "size"
];
var FaceVeryHappy = function FaceVeryHappy(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1x);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 9.05v-.1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 9.05v-.1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 18a4 4 0 0 0 4-4H8a4 4 0 0 0 4 4z"
    }));
};
FaceVeryHappy.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1w = [
    "color",
    "size"
];
var FaceHappy = function FaceHappy(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1w);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 9.05v-.1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 9.05v-.1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 14c-.5 1.5-1.79 3-4 3s-3.5-1.5-4-3"
    }));
};
FaceHappy.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1v = [
    "color",
    "size"
];
var FaceNeutral = function FaceNeutral(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1v);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 9.05v-.1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 9.05v-.1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 14h8"
    }));
};
FaceNeutral.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1u = [
    "color",
    "size"
];
var FaceSad = function FaceSad(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1u);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 9.05v-.1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 9.05v-.1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 16c-.5-1.5-1.79-3-4-3s-3.5 1.5-4 3"
    }));
};
FaceSad.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1t = [
    "color",
    "size"
];
var FaceVerySad = function FaceVerySad(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1t);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 9.05v-.1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 9.05v-.1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 13a4 4 0 0 1 4 4H8a4 4 0 0 1 4-4z"
    }));
};
FaceVerySad.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1s = [
    "color",
    "size"
];
var FaceWink = function FaceWink(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1s);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7 9h2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 9.05v-.1"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 15c-.5 1-1.79 2-4 2s-3.5-1-4-2"
    }));
};
FaceWink.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1r = [
    "color",
    "size"
];
var ThumbsUp = function ThumbsUp(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1r);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.605 5.782l.23-2.369c.091-.952.98-1.598 1.878-1.366 1.351.35 2.3 1.605 2.3 3.044v3.035c0 .675 0 1.013.146 1.26.083.141.197.26.333.345.24.151.567.151 1.22.151h.396c1.703 0 2.554 0 3.078.39.393.293.67.722.78 1.208.146.65-.181 1.463-.836 3.087l-.326.81a3.261 3.261 0 0 0-.226 1.48c.232 2.874-2.047 5.295-4.833 5.136l-10.424-.599c-1.139-.065-1.708-.098-2.222-.553-.515-.455-.612-.924-.805-1.861a14.324 14.324 0 0 1 .055-6.037c.283-1.248 1.475-1.92 2.706-1.76 3.264.42 6.223-2.019 6.55-5.4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7 11.5l-.137.457A14.983 14.983 0 0 0 7 21"
    }));
};
ThumbsUp.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1q = [
    "color",
    "size"
];
var ThumbsDown = function ThumbsDown(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1q);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12.395 18.218l-.23 2.369c-.091.952-.98 1.598-1.878 1.366-1.351-.35-2.3-1.605-2.3-3.044v-3.035c0-.675 0-1.013-.146-1.26a1.018 1.018 0 0 0-.333-.345c-.24-.151-.567-.151-1.22-.151h-.396c-1.703 0-2.554 0-3.078-.39a2.073 2.073 0 0 1-.78-1.208c-.146-.65.181-1.463.836-3.087l.327-.81c.188-.468.265-.975.225-1.48-.232-2.874 2.047-5.295 4.833-5.135l10.424.598c1.139.065 1.708.098 2.222.553.515.455.612.924.805 1.861a14.317 14.317 0 0 1-.055 6.037c-.283 1.248-1.475 1.92-2.706 1.76-3.264-.42-6.223 2.019-6.55 5.4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 12.5l.137-.457c.887-2.956.84-6.115-.137-9.043"
    }));
};
ThumbsDown.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1p = [
    "color",
    "size"
];
var VictoryHand = function VictoryHand(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1p);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 11l-1-7.272c0-.466.185-.913.515-1.243 1.024-1.024 2.777-.44 2.982.994L16 10l1.508-6.328a1.682 1.682 0 0 1 3.276.73L19 16"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 16c-.536 4-3.358 6-7.5 6C7.358 22 4 20 4 16"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 16v-4a2 2 0 1 1 4 0m4 1v-2a2 2 0 1 0-4 0v4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13.692 17H11a2 2 0 1 1 0-4h4c2.21 0 4.5 2 3.5 5"
    }));
};
VictoryHand.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1o = [
    "color",
    "size"
];
var PointingUp = function PointingUp(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1o);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 16l.87-11.735a2.102 2.102 0 0 0-4.181-.433L15 9"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 15v-3a2 2 0 1 0-4 0v4"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 13v-1.5a2 2 0 1 0-4 0V15"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 13v-2a2 2 0 1 0-4 0v2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 16c-.536 4-3.358 6-7.5 6C7.358 22 4 20 4 16"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13.692 17H11a2 2 0 1 1 0-4h4c2.21 0 4.5 2 3.5 5"
    }));
};
PointingUp.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1n = [
    "color",
    "size"
];
var RockOn = function RockOn(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1n);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 16l.87-11.735a2.102 2.102 0 0 0-4.181-.433L15 9"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 11l-.713-4.279a2.06 2.06 0 0 0-4.083.525L4 16"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 13v-1.5a2 2 0 1 0-4 0V15"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16 13v-2a2 2 0 1 0-4 0v2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19 16c-.536 4-3.358 6-7.5 6C7.358 22 4 20 4 16"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13.692 17H11a2 2 0 1 1 0-4h4c2.21 0 4.5 2 3.5 5"
    }));
};
RockOn.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1m = [
    "color",
    "size"
];
var PeopleMultiple = function PeopleMultiple(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1m);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "7",
        cy: "6",
        r: "3"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10 13H5.818a3 3 0 0 0-2.964 2.537L2.36 18.69A2 2 0 0 0 4.337 21H9"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21.64 18.691l-.494-3.154A3 3 0 0 0 18.182 13h-2.364a3 3 0 0 0-2.964 2.537l-.493 3.154A2 2 0 0 0 14.337 21h5.326a2 2 0 0 0 1.976-2.309z"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "17",
        cy: "6",
        r: "3"
    }));
};
PeopleMultiple.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1l = [
    "color",
    "size"
];
var PeopleGroup = function PeopleGroup(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1l);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16.719 19.752l-.64-5.124A3 3 0 0 0 13.101 12h-2.204a3 3 0 0 0-2.976 2.628l-.641 5.124A2 2 0 0 0 9.266 22h5.468a2 2 0 0 0 1.985-2.248z"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "5",
        r: "3"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "4",
        cy: "9",
        r: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "20",
        cy: "9",
        r: "2"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4 14h-.306a2 2 0 0 0-1.973 1.671l-.333 2A2 2 0 0 0 3.361 20H7"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20 14h.306a2 2 0 0 1 1.973 1.671l.333 2A2 2 0 0 1 20.639 20H17"
    }));
};
PeopleGroup.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1k = [
    "color",
    "size"
];
var Hand = function Hand(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1k);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20 16V8.5c0-.828-.641-1.5-1.48-1.5C18 7 17 7.3 17 8.5v-3c0-.828-.641-1.5-1.48-1.5-.507 0-1.52.3-1.52 1.5v-2c0-.828-.641-1.5-1.48-1.5-.84 0-1.52.672-1.52 1.5v2C11 4.3 10.007 4 9.5 4 8.66 4 8 4.691 8 5.52V14"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11 5.5V11"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 5.5V11"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17 5.5V11"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20 16c0 4-3.134 6-7 6s-5.196-1-8.196-6l-1.571-2.605c-.536-.868-.107-1.994.881-2.314a1.657 1.657 0 0 1 1.818.552L8 14.033"
    }));
};
Hand.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1j = [
    "color",
    "size"
];
var PointerHand = function PointerHand(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1j);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20 16V9.5c0-.828-.641-1.5-1.48-1.5C18 8 17 8.3 17 9.5M8 14V5.52"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20 16c0 4-3.134 6-7 6s-5.196-1-8.196-6l-1.571-2.605c-.536-.868-.107-1.994.881-2.314a1.657 1.657 0 0 1 1.818.552L8 14.033"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14 11V7.5A1.5 1.5 0 0 1 15.5 6v0A1.5 1.5 0 0 1 17 7.5V11"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11 11V6.5A1.5 1.5 0 0 1 12.5 5v0A1.5 1.5 0 0 1 14 6.5V11"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8 11V2.5A1.5 1.5 0 0 1 9.5 1v0A1.5 1.5 0 0 1 11 2.5V11"
    }));
};
PointerHand.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1i = [
    "color",
    "size"
];
var FacebookFill = function FacebookFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1i);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_65_70)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 12.067C0 18.033 4.333 22.994 10 24v-8.667H7V12h3V9.333c0-3 1.933-4.666 4.667-4.666.866 0 1.8.133 2.666.266V8H15.8c-1.467 0-1.8.733-1.8 1.667V12h3.2l-.533 3.333H14V24c5.667-1.006 10-5.966 10-11.933C24 5.43 18.6 0 12 0S0 5.43 0 12.067z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_65_70"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
FacebookFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1h = [
    "color",
    "size"
];
var TwitterFill = function TwitterFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1h);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M23.643 4.937c-.835.37-1.732.62-2.675.733a4.67 4.67 0 0 0 2.048-2.578 9.3 9.3 0 0 1-2.958 1.13 4.66 4.66 0 0 0-7.938 4.25 13.229 13.229 0 0 1-9.602-4.868c-.4.69-.63 1.49-.63 2.342A4.66 4.66 0 0 0 3.96 9.824a4.647 4.647 0 0 1-2.11-.583v.06a4.66 4.66 0 0 0 3.737 4.568 4.692 4.692 0 0 1-2.104.08 4.661 4.661 0 0 0 4.352 3.234 9.348 9.348 0 0 1-5.786 1.995 9.5 9.5 0 0 1-1.112-.065 13.175 13.175 0 0 0 7.14 2.093c8.57 0 13.255-7.098 13.255-13.254 0-.2-.005-.402-.014-.602a9.47 9.47 0 0 0 2.323-2.41l.002-.003z"
    }));
};
TwitterFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1g = [
    "color",
    "size"
];
var LinkedinBoxFill = function LinkedinBoxFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1g);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 2.838A1.838 1.838 0 0 1 2.838 1H21.16A1.837 1.837 0 0 1 23 2.838V21.16A1.838 1.838 0 0 1 21.161 23H2.838A1.838 1.838 0 0 1 1 21.161V2.838zm8.708 6.55h2.979v1.496c.43-.86 1.53-1.634 3.183-1.634 3.169 0 3.92 1.713 3.92 4.856v5.822h-3.207v-5.106c0-1.79-.43-2.8-1.522-2.8-1.515 0-2.145 1.089-2.145 2.8v5.106H9.708V9.388zm-5.5 10.403h3.208V9.25H4.208v10.54zM7.875 5.812a2.063 2.063 0 1 1-4.125 0 2.063 2.063 0 0 1 4.125 0z"
    }));
};
LinkedinBoxFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1f = [
    "color",
    "size"
];
var DribbbleFill = function DribbbleFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1f);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_67_12)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 0C5.375 0 0 5.375 0 12s5.375 12 12 12c6.612 0 12-5.375 12-12S18.612 0 12 0zm7.926 5.531a10.202 10.202 0 0 1 2.317 6.378c-.338-.065-3.722-.755-7.132-.325-.079-.17-.144-.352-.222-.534a30.53 30.53 0 0 0-.676-1.484c3.774-1.536 5.492-3.748 5.713-4.035zM12 1.771c2.603 0 4.985.975 6.794 2.576-.182.26-1.731 2.33-5.375 3.696-1.68-3.084-3.54-5.61-3.827-6A10.424 10.424 0 0 1 12 1.77zm-4.36.962c.273.365 2.095 2.903 3.8 5.922-4.79 1.276-9.02 1.25-9.475 1.25.664-3.176 2.812-5.818 5.675-7.172zm-5.896 9.28v-.312c.443.013 5.414.078 10.53-1.458.299.573.572 1.158.832 1.744-.13.039-.273.078-.403.117-5.284 1.705-8.096 6.364-8.33 6.755a10.226 10.226 0 0 1-2.629-6.846zM12 22.256c-2.369 0-4.555-.807-6.286-2.16.182-.378 2.264-4.387 8.043-6.404.026-.013.04-.013.065-.026 1.445 3.735 2.03 6.872 2.187 7.77-1.237.534-2.59.82-4.009.82zm5.714-1.757c-.104-.625-.651-3.618-1.992-7.302 3.215-.507 6.026.326 6.378.443-.443 2.85-2.083 5.31-4.386 6.859z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_67_12"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
DribbbleFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1e = [
    "color",
    "size"
];
var RedditFill = function RedditFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1e);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_67_13)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zm-4.312-.942c.194.277.304.604.316.942a1.751 1.751 0 0 1-.972 1.596c.014.176.014.352 0 .528 0 2.688-3.132 4.872-6.996 4.872-3.864 0-6.996-2.184-6.996-4.872a3.444 3.444 0 0 1 0-.528 1.75 1.75 0 1 1 1.932-2.868 8.568 8.568 0 0 1 4.68-1.476l.888-4.164a.372.372 0 0 1 .444-.288l2.94.588a1.2 1.2 0 1 1-.156.732L13.2 5.58l-.78 3.744a8.544 8.544 0 0 1 4.62 1.476 1.751 1.751 0 0 1 2.648.258zM8.206 12.533a1.2 1.2 0 1 0 1.996 1.334 1.2 1.2 0 0 0-1.996-1.334zm3.806 4.891c1.065.044 2.113-.234 2.964-.876a.335.335 0 1 0-.468-.48A3.936 3.936 0 0 1 12 16.8a3.924 3.924 0 0 1-2.496-.756.324.324 0 0 0-.456.456 4.608 4.608 0 0 0 2.964.924zm2.081-3.178c.198.132.418.25.655.25a1.199 1.199 0 0 0 1.212-1.248 1.2 1.2 0 1 0-1.867.998z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_67_13"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
RedditFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1d = [
    "color",
    "size"
];
var TumblrFill = function TumblrFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1d);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_66_158)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18.895 22.517c-.798.867-2.646 1.456-4.301 1.483h-.182c-5.557 0-6.766-4.164-6.766-6.594v-6.748H5.458a.454.454 0 0 1-.324-.137.472.472 0 0 1-.134-.33V7.003c0-.164.05-.324.142-.458a.782.782 0 0 1 .376-.29c2.855-1.026 3.748-3.562 3.87-5.49.035-.516.297-.765.738-.765H13.4a.451.451 0 0 1 .33.134.468.468 0 0 1 .137.333V5.87h3.823c.121 0 .238.05.324.137a.472.472 0 0 1 .134.33v3.83a.472.472 0 0 1-.134.33.454.454 0 0 1-.324.138h-3.84v6.245c0 1.568 1.015 2.001 1.64 2.001a4.537 4.537 0 0 0 1.488-.321.973.973 0 0 1 .595-.106.483.483 0 0 1 .34.37l1.012 3.014c.068.237.14.498-.03.68z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_66_158"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
TumblrFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1c = [
    "color",
    "size"
];
var PinterestFill = function PinterestFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1c);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_67_11)"
    }, /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip1_67_11)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M0 12c0 5.123 3.211 9.497 7.73 11.218-.11-.937-.227-2.482.025-3.566.217-.932 1.401-5.938 1.401-5.938s-.357-.715-.357-1.774c0-1.66.962-2.9 2.161-2.9 1.02 0 1.512.765 1.512 1.682 0 1.025-.653 2.557-.99 3.978-.281 1.189.597 2.159 1.769 2.159 2.123 0 3.756-2.239 3.756-5.471 0-2.861-2.056-4.86-4.991-4.86-3.398 0-5.393 2.549-5.393 5.184 0 1.027.395 2.127.889 2.726a.36.36 0 0 1 .083.343c-.091.378-.293 1.189-.332 1.355-.053.218-.173.265-.4.159-1.492-.694-2.424-2.875-2.424-4.627 0-3.769 2.737-7.229 7.892-7.229 4.144 0 7.365 2.953 7.365 6.899 0 4.117-2.595 7.431-6.199 7.431-1.211 0-2.348-.63-2.738-1.373 0 0-.599 2.282-.744 2.84-.282 1.084-1.064 2.456-1.549 3.235C9.584 23.815 10.77 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12z"
    }))), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_67_11"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    })), /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip1_67_11"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
PinterestFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1b = [
    "color",
    "size"
];
var VkFill = function VkFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1b);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.45 5.948c.166-.546 0-.948-.795-.948H20.03c-.668 0-.976.347-1.143.73 0 0-1.335 3.196-3.226 5.272-.612.602-.89.793-1.224.793-.167 0-.418-.191-.418-.738V5.948c0-.656-.184-.948-.74-.948H9.151c-.417 0-.668.304-.668.593 0 .621.946.765 1.043 2.513v3.798c0 .833-.153.984-.487.984-.89 0-3.055-3.211-4.34-6.885C4.45 5.288 4.198 5 3.527 5H.9c-.75 0-.9.347-.9.73 0 .682.89 4.07 4.145 8.551C6.315 17.341 9.37 19 12.153 19c1.669 0 1.875-.368 1.875-1.003v-2.313c0-.737.158-.884.687-.884.39 0 1.057.192 2.615 1.667C19.11 18.216 19.403 19 20.405 19h2.625c.75 0 1.126-.368.91-1.096-.238-.724-1.088-1.775-2.215-3.022-.612-.71-1.53-1.475-1.809-1.858-.389-.491-.278-.71 0-1.147 0 0 3.2-4.426 3.533-5.929z"
    }));
};
VkFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1a = [
    "color",
    "size"
];
var YoutubeFill = function YoutubeFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1a);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_100_7)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M23.5 6.507a2.786 2.786 0 0 0-.766-1.27 3.05 3.05 0 0 0-1.338-.742C19.518 4 11.994 4 11.994 4a76.624 76.624 0 0 0-9.39.47 3.16 3.16 0 0 0-1.338.76c-.37.356-.638.795-.778 1.276A29.09 29.09 0 0 0 0 12c-.012 1.841.151 3.68.488 5.494.137.479.404.916.775 1.269.371.353.833.608 1.341.743 1.903.494 9.39.494 9.39.494a76.8 76.8 0 0 0 9.402-.47 3.05 3.05 0 0 0 1.338-.742c.37-.353.633-.792.765-1.27A28.38 28.38 0 0 0 24 12.023a26.579 26.579 0 0 0-.5-5.517zM9.602 15.424V8.577l6.26 3.424-6.26 3.423z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_100_7"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
YoutubeFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$19 = [
    "color",
    "size"
];
var InstagramFill = function InstagramFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$19);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.465 1.066C8.638 1.012 9.012 1 12 1c2.988 0 3.362.013 4.534.066 1.172.053 1.972.24 2.672.511.733.277 1.398.71 1.948 1.27.56.549.992 1.213 1.268 1.947.272.7.458 1.5.512 2.67C22.988 8.639 23 9.013 23 12c0 2.988-.013 3.362-.066 4.535-.053 1.17-.24 1.97-.512 2.67a5.396 5.396 0 0 1-1.268 1.949c-.55.56-1.215.992-1.948 1.268-.7.272-1.5.458-2.67.512-1.174.054-1.548.066-4.536.066-2.988 0-3.362-.013-4.535-.066-1.17-.053-1.97-.24-2.67-.512a5.397 5.397 0 0 1-1.949-1.268 5.392 5.392 0 0 1-1.269-1.948c-.271-.7-.457-1.5-.511-2.67C1.012 15.361 1 14.987 1 12c0-2.988.013-3.362.066-4.534.053-1.172.24-1.972.511-2.672a5.396 5.396 0 0 1 1.27-1.948 5.392 5.392 0 0 1 1.947-1.269c.7-.271 1.5-.457 2.67-.511zm8.98 1.98c-1.16-.053-1.508-.064-4.445-.064-2.937 0-3.285.011-4.445.064-1.073.049-1.655.228-2.043.379-.513.2-.88.437-1.265.822a3.412 3.412 0 0 0-.822 1.265c-.151.388-.33.97-.379 2.043-.053 1.16-.064 1.508-.064 4.445 0 2.937.011 3.285.064 4.445.049 1.073.228 1.655.379 2.043.176.477.457.91.822 1.265.355.365.788.646 1.265.822.388.151.97.33 2.043.379 1.16.053 1.507.064 4.445.064 2.938 0 3.285-.011 4.445-.064 1.073-.049 1.655-.228 2.043-.379.513-.2.88-.437 1.265-.822.365-.355.646-.788.822-1.265.151-.388.33-.97.379-2.043.053-1.16.064-1.508.064-4.445 0-2.937-.011-3.285-.064-4.445-.049-1.073-.228-1.655-.379-2.043-.2-.513-.437-.88-.822-1.265a3.413 3.413 0 0 0-1.265-.822c-.388-.151-.97-.33-2.043-.379zm-5.85 12.345a3.669 3.669 0 0 0 4-5.986 3.67 3.67 0 1 0-4 5.986zM8.002 8.002a5.654 5.654 0 1 1 7.996 7.996 5.654 5.654 0 0 1-7.996-7.996zm10.906-.814a1.337 1.337 0 1 0-1.89-1.89 1.337 1.337 0 0 0 1.89 1.89z"
    }));
};
InstagramFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$18 = [
    "color",
    "size"
];
var FigmaFill = function FigmaFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$18);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_100_5)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.415 0C5.968 0 4 2.053 4 4.568c0 1.529.728 2.887 1.847 3.716A4.613 4.613 0 0 0 4 12c0 1.53.728 2.887 1.847 3.716A4.613 4.613 0 0 0 4 19.432C4 21.947 5.968 24 8.415 24c2.446 0 4.415-2.053 4.415-4.568V15.57a4.307 4.307 0 0 0 2.755.999C18.032 16.568 20 14.515 20 12c0-1.53-.727-2.887-1.847-3.716A4.613 4.613 0 0 0 20 4.568C20 2.053 18.032 0 15.585 0h-7.17zM5.659 4.568c0-1.591 1.242-2.865 2.756-2.865h2.755v5.73H8.415c-1.514 0-2.756-1.275-2.756-2.865zm9.926 2.864H12.83v-5.73h2.755c1.515 0 2.756 1.275 2.756 2.866 0 1.59-1.241 2.864-2.756 2.864zM5.66 12c0-1.59 1.242-2.865 2.756-2.865h2.755v5.73H8.415C6.9 14.865 5.659 13.59 5.659 12zm7.17 0c0-1.59 1.242-2.865 2.756-2.865 1.515 0 2.756 1.274 2.756 2.865 0 1.59-1.241 2.865-2.756 2.865-1.514 0-2.755-1.274-2.755-2.865zm-7.17 7.432c0-1.59 1.242-2.864 2.756-2.864h2.755v2.864c0 1.591-1.24 2.865-2.755 2.865-1.514 0-2.756-1.274-2.756-2.865z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_100_5"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
FigmaFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$17 = [
    "color",
    "size"
];
var GithubFill = function GithubFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$17);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_100_4)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0 0 24 12c0-6.63-5.37-12-12-12z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_100_4"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
GithubFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$16 = [
    "color",
    "size"
];
var TelegramFill = function TelegramFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$16);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_331_272)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zM12.43 8.859c-1.167.485-3.5 1.49-6.998 3.014-.568.226-.866.447-.893.663-.046.366.412.51 1.034.705.085.027.173.054.263.084.613.199 1.437.432 1.865.441.389.008.823-.152 1.302-.48 3.268-2.207 4.955-3.322 5.061-3.346.075-.017.179-.039.249.024.07.062.063.18.056.212-.046.193-1.84 1.862-2.77 2.726-.29.269-.495.46-.537.504-.094.097-.19.19-.282.279-.57.548-.996.96.024 1.632.49.323.882.59 1.273.856.427.291.853.581 1.405.943.14.092.274.187.405.28.497.355.944.673 1.496.623.32-.03.652-.331.82-1.23.397-2.126 1.179-6.73 1.36-8.628a2.111 2.111 0 0 0-.02-.472.506.506 0 0 0-.172-.325c-.143-.117-.365-.142-.465-.14-.451.008-1.143.249-4.476 1.635z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_331_272"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
TelegramFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$15 = [
    "color",
    "size"
];
var DropboxFill = function DropboxFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$15);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6 2l6 3.75L6 9.5 0 5.75 6 2zm12 0l6 3.75-6 3.75-6-3.75L18 2zM0 13.25L6 9.5l6 3.75L6 17l-6-3.75zM18 9.5l6 3.75L18 17l-6-3.75 6-3.75zM6 18.25l6-3.75 6 3.75L12 22l-6-3.75z"
    }));
};
DropboxFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$14 = [
    "color",
    "size"
];
var GoogleFill = function GoogleFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$14);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21.456 10.154c.123.659.19 1.348.19 2.067 0 5.624-3.764 9.623-9.449 9.623A9.841 9.841 0 0 1 2.353 12a9.841 9.841 0 0 1 9.844-9.844c2.658 0 4.879.978 6.583 2.566l-2.775 2.775V7.49c-1.033-.984-2.344-1.489-3.808-1.489-3.248 0-5.888 2.744-5.888 5.993 0 3.248 2.64 5.998 5.888 5.998 2.947 0 4.953-1.685 5.365-3.999h-5.365v-3.839h9.26z"
    }));
};
GoogleFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$13 = [
    "color",
    "size"
];
var GoogleContainedFill = function GoogleContainedFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$13);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_399_293)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 0C5.372 0 0 5.373 0 12s5.372 12 12 12c6.627 0 12-5.373 12-12S18.627 0 12 0zm.14 19.018c-3.868 0-7-3.14-7-7.018 0-3.878 3.132-7.018 7-7.018 1.89 0 3.47.697 4.682 1.829l-1.974 1.978v-.004c-.735-.702-1.667-1.062-2.708-1.062-2.31 0-4.187 1.956-4.187 4.273 0 2.315 1.877 4.277 4.187 4.277 2.096 0 3.522-1.202 3.816-2.852H12.14v-2.737h6.585c.088.47.135.96.135 1.474 0 4.01-2.677 6.86-6.72 6.86z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_399_293"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
GoogleContainedFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$12 = [
    "color",
    "size"
];
var AndroidFill = function AndroidFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$12);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17.532 15.106a1.003 1.003 0 1 1 .001-2.007 1.003 1.003 0 0 1 0 2.007zm-11.044 0a1.003 1.003 0 1 1 .001-2.007 1.003 1.003 0 0 1 0 2.007zm11.4-6.018l2.006-3.459a.413.413 0 1 0-.721-.407l-2.027 3.5a12.243 12.243 0 0 0-5.13-1.108c-1.85 0-3.595.398-5.141 1.098l-2.027-3.5a.413.413 0 1 0-.72.407l1.995 3.458C2.696 10.947.345 14.417 0 18.523h24c-.334-4.096-2.675-7.565-6.112-9.435z"
    }));
};
AndroidFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$11 = [
    "color",
    "size"
];
var BitcoinFill = function BitcoinFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$11);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_399_390)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.385 15.275c1.111-.004 3.54-.013 3.512-1.558-.027-1.58-2.36-1.485-3.497-1.438-.127.005-.24.01-.332.011l.052 2.987c.075-.002.165-.002.265-.002z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.267 10.922c.927-.001 2.95-.003 2.926-1.408-.026-1.437-1.969-1.352-2.918-1.31-.107.005-.2.009-.278.01l.047 2.709.223-.001z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.096 23.641c6.43 1.603 12.942-2.31 14.545-8.738C25.244 8.474 21.33 1.962 14.9.36 8.474-1.244 1.962 2.67.36 9.1c-1.603 6.428 2.31 12.94 8.737 14.542zm4.282-17.02c1.754.124 3.15.638 3.333 2.242.136 1.174-.344 1.889-1.123 2.303 1.3.288 2.125 1.043 1.995 2.771-.161 2.145-1.748 2.748-4.026 2.918l.038 2.25-1.356.025-.039-2.22c-.351.006-.711.01-1.084.008l.04 2.23-1.356.024-.04-2.254-.383.003c-.194.001-.39.002-.586.006l-1.766.03.241-1.624s1.004-.002.986-.017c.384-.008.481-.285.502-.459L8.693 11.3l.097-.002h.046a1.101 1.101 0 0 0-.144-.007l-.044-2.54c-.057-.274-.241-.59-.79-.58.015-.02-.986.017-.986.017L6.846 6.74l1.872-.032v.007c.281-.005.57-.015.863-.026l-.038-2.229 1.356-.023.038 2.184c.362-.013.726-.027 1.083-.033l-.038-2.17 1.357-.024.039 2.229z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_399_390"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
BitcoinFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$10 = [
    "color",
    "size"
];
var SpotifyFill = function SpotifyFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$10);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_399_388)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.995 0C5.381 0 0 5.382 0 11.996 0 18.616 5.381 24 11.995 24 18.615 24 24 18.615 24 11.996 24 5.382 18.615 0 11.995 0zM5.908 16.404a14.548 14.548 0 0 1 4.238-.638c2.414 0 4.797.612 6.892 1.77.125.068.238.292.29.572.05.28.03.567-.052.716a.61.61 0 0 1-.834.24A13.107 13.107 0 0 0 6.277 18.03a.61.61 0 0 1-.771-.402c-.107-.35.114-1.13.402-1.224zm-.523-4.42a18.154 18.154 0 0 1 4.76-.635c2.894 0 5.767.7 8.31 2.026.179.09.31.244.37.432a.747.747 0 0 1-.052.578c-.227.444-.493.743-.66.743a.769.769 0 0 1-.35-.086 16.33 16.33 0 0 0-7.617-1.854 16.34 16.34 0 0 0-4.366.585.749.749 0 0 1-.92-.525c-.112-.422.145-1.16.525-1.264zM5.25 9.098a.88.88 0 0 1-1.073-.641c-.123-.498.188-1.076.64-1.19a22.365 22.365 0 0 1 5.328-.649c3.45 0 6.756.776 9.824 2.307a.888.888 0 0 1 .4 1.19c-.143.288-.453.598-.795.598a.924.924 0 0 1-.388-.087 20.026 20.026 0 0 0-9.041-2.126c-1.635 0-3.282.201-4.895.598z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_399_388"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
SpotifyFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$$ = [
    "color",
    "size"
];
var SoundcloudFill = function SoundcloudFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$$);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M1.16 16.466c.049 0 .09-.039.098-.093l.27-2.022-.27-2.069c-.007-.054-.05-.093-.099-.093-.05 0-.094.04-.1.093l-.236 2.069.236 2.021c.006.055.05.094.1.094z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M.272 15.697c.048 0 .088-.036.095-.09l.209-1.256-.209-1.28c-.007-.053-.047-.09-.095-.09-.051 0-.09.037-.098.09L0 14.351l.174 1.256c.008.053.047.09.098.09z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M2.22 11.897a.122.122 0 0 0-.12-.114.12.12 0 0 0-.119.114l-.224 2.454.224 2.364a.12.12 0 0 0 .12.112.121.121 0 0 0 .12-.113l.254-2.363-.254-2.454z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3.052 16.922a.143.143 0 0 0 .14-.132l.241-2.439-.24-2.522a.143.143 0 0 0-.141-.132.14.14 0 0 0-.14.133l-.213 2.521.212 2.439a.14.14 0 0 0 .141.133z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4.01 16.962a.162.162 0 0 0 .162-.152l.226-2.459-.226-2.34a.162.162 0 0 0-.162-.151.16.16 0 0 0-.16.152l-.2 2.34.2 2.458a.16.16 0 0 0 .16.152z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5.37 14.352l-.212-3.805a.184.184 0 0 0-.182-.173.183.183 0 0 0-.182.173l-.188 3.805.188 2.458a.183.183 0 0 0 .364 0l.212-2.458z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5.951 16.987a.201.201 0 0 0 .201-.192v.002l.199-2.444-.199-4.676a.203.203 0 0 0-.405 0l-.174 4.676.175 2.443a.201.201 0 0 0 .203.19z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M6.931 9.076a.222.222 0 0 0-.223.212l-.162 5.065.162 2.418a.221.221 0 0 0 .223.211.22.22 0 0 0 .223-.211l.185-2.418-.185-5.065a.22.22 0 0 0-.223-.212z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7.92 16.987a.24.24 0 0 0 .244-.232v.002l.17-2.404-.17-5.235a.24.24 0 0 0-.243-.232.238.238 0 0 0-.243.232l-.153 5.235.153 2.404c.002.129.11.23.243.23z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8.918 16.985a.26.26 0 0 0 .263-.252v.002l.157-2.381-.157-5.103a.26.26 0 0 0-.263-.25.26.26 0 0 0-.264.25l-.138 5.103.139 2.38c.003.14.119.25.263.25z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10.349 14.354l-.142-4.917a.28.28 0 0 0-.284-.27.28.28 0 0 0-.285.271l-.127 4.916.127 2.366a.28.28 0 0 0 .285.27.28.28 0 0 0 .284-.273v.003l.142-2.366z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10.935 16.994c.165 0 .301-.13.304-.29l.129-2.349-.129-5.85a.301.301 0 0 0-.304-.291.303.303 0 0 0-.305.291l-.115 5.848.115 2.352c.003.158.14.289.305.289z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.944 7.664a.322.322 0 0 0-.327.31l-.133 6.382.134 2.315a.32.32 0 0 0 .325.308.32.32 0 0 0 .324-.311v.003l.146-2.315-.146-6.381a.32.32 0 0 0-.323-.311z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12.866 16.996l8.181.004C22.678 17 24 15.732 24 14.167c0-1.564-1.322-2.832-2.953-2.832-.404 0-.79.079-1.142.22C19.672 9.003 17.44 7 14.718 7c-.665 0-1.314.126-1.887.339-.223.083-.283.168-.285.333v8.989a.349.349 0 0 0 .32.335z"
    }));
};
SoundcloudFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$_ = [
    "color",
    "size"
];
var CodepenFill = function CodepenFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$_);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_419_281)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.372.19c.38-.253.875-.253 1.256 0L23.492 7.4c.317.21.508.565.508.946v7.308c0 .38-.19.736-.508.947l-10.864 7.21c-.38.252-.875.252-1.256 0L.508 16.6A1.136 1.136 0 0 1 0 15.654V8.346c0-.38.19-.736.508-.947L11.372.19zm-9.1 10.273v3.058l2.288-1.54-2.288-1.518zm4.337 2.878L3.18 15.648l7.684 5.1v-4.583L6.61 13.341zm6.527 2.824v4.582l7.684-5.1-3.43-2.306-4.254 2.824zm6.303-4.183l2.29 1.54v-3.06l-2.29 1.52zm1.371-3.636l-3.41 2.263-4.264-2.868V3.253l7.674 5.093zm-9.946-5.093V7.74l-4.263 2.868L3.19 8.346l7.674-5.093zM12 9.715l-3.35 2.254L12 14.192l3.35-2.223L12 9.715z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_419_281"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
CodepenFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$Z = [
    "color",
    "size"
];
var WhatsappFill = function WhatsappFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$Z);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_615_275)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.415 14.382c-.298-.149-1.759-.867-2.031-.967-.272-.099-.47-.148-.669.15-.198.296-.767.966-.94 1.164-.174.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.019-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.297-.497.1-.198.05-.371-.025-.52-.074-.149-.668-1.612-.916-2.207-.241-.579-.486-.5-.668-.51-.174-.008-.372-.01-.57-.01-.198 0-.52.074-.792.372-.273.297-1.04 1.016-1.04 2.479 0 1.462 1.064 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.872.118.57-.085 1.758-.719 2.006-1.413.247-.694.247-1.289.173-1.413-.074-.124-.272-.198-.57-.347zm-5.422 7.403h-.004a9.87 9.87 0 0 1-5.032-1.378l-.36-.214-3.742.982.999-3.648-.235-.374a9.861 9.861 0 0 1-1.511-5.26c.002-5.45 4.436-9.884 9.889-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.892 6.993c-.002 5.45-4.436 9.885-9.884 9.885zm8.412-18.297A11.815 11.815 0 0 0 11.992 0C5.438 0 .102 5.335.1 11.892c-.001 2.096.546 4.142 1.587 5.945L0 24l6.304-1.654a11.881 11.881 0 0 0 5.684 1.448h.005c6.554 0 11.89-5.335 11.892-11.893a11.821 11.821 0 0 0-3.48-8.413"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_615_275"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
WhatsappFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$Y = [
    "color",
    "size"
];
var LinkedinFill = function LinkedinFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$Y);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.429 8.969h3.714v1.85c.535-1.064 1.907-2.02 3.968-2.02 3.951 0 4.889 2.118 4.889 6.004V22h-4v-6.312c0-2.213-.535-3.461-1.897-3.461-1.889 0-2.674 1.345-2.674 3.46V22h-4V8.969zM2.57 21.83h4V8.799h-4V21.83zM7.143 4.55a2.53 2.53 0 0 1-.753 1.802A2.573 2.573 0 0 1 4.57 7.1a2.59 2.59 0 0 1-1.818-.747A2.548 2.548 0 0 1 2 4.55c0-.677.27-1.325.753-1.803A2.583 2.583 0 0 1 4.571 2c.682 0 1.336.269 1.819.747.482.478.753 1.126.753 1.803z"
    }));
};
LinkedinFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$X = [
    "color",
    "size"
];
var VimeoFill = function VimeoFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$X);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21.99 7.16c-.092 2.027-1.52 4.8-4.28 8.323C14.857 19.161 12.44 21 10.462 21c-1.225 0-2.26-1.122-3.106-3.359-.564-2.055-1.127-4.11-1.697-6.16-.627-2.237-1.3-3.359-2.025-3.359-.155 0-.707.33-1.645.98L1 7.837c1.035-.906 2.06-1.805 3.066-2.71 1.38-1.185 2.422-1.805 3.112-1.868 1.633-.153 2.64.951 3.02 3.325.408 2.556.69 4.15.851 4.77.472 2.124.99 3.183 1.553 3.183.437 0 1.099-.688 1.979-2.066.88-1.378 1.351-2.425 1.415-3.143.126-1.19-.345-1.782-1.415-1.782-.5 0-1.018.114-1.553.342 1.03-3.353 3.002-4.982 5.913-4.885 2.157.057 3.175 1.446 3.049 4.156z"
    }));
};
VimeoFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$W = [
    "color",
    "size"
];
var MediumFill = function MediumFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$W);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4.372 7.264a.784.784 0 0 0-.252-.658L2.252 4.339V4H8.05l4.482 9.905L16.472 4H22v.339L20.403 5.88a.472.472 0 0 0-.177.452v11.334a.472.472 0 0 0 .177.452l1.56 1.542V20h-7.844v-.339l1.616-1.58c.159-.16.159-.207.159-.451V8.468l-4.492 11.494h-.606L5.566 8.468v7.704c-.043.323.064.65.29.884l2.101 2.568v.338H2v-.338l2.1-2.568a1.03 1.03 0 0 0 .272-.884V7.264z"
    }));
};
MediumFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$V = [
    "color",
    "size"
];
var ZoomFill = function ZoomFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$V);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_822_311)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zM6 16.2h9V9.6a1.8 1.8 0 0 0-1.8-1.8h-9v6.6A1.8 1.8 0 0 0 6 16.2zm10.2-2.4l3.6 2.4V7.8l-3.6 2.4v3.6z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_822_311"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
ZoomFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$U = [
    "color",
    "size"
];
var SlackFill = function SlackFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$U);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.066 1a2.2 2.2 0 1 0 .001 4.4h2.2V3.2a2.202 2.202 0 0 0-2.2-2.2zm0 5.867H3.2a2.2 2.2 0 0 0 0 4.4h5.866a2.2 2.2 0 1 0 0-4.4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23 9.066a2.2 2.2 0 0 0-4.4 0v2.2h2.2a2.2 2.2 0 0 0 2.2-2.2zm-5.867 0V3.2a2.2 2.2 0 0 0-4.4 0v5.866a2.2 2.2 0 1 0 4.4 0z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.933 23a2.2 2.2 0 1 0 0-4.4h-2.2v2.2c-.001 1.213.984 2.198 2.2 2.2zm0-5.868H20.8a2.2 2.2 0 0 0 0-4.4h-5.866a2.2 2.2 0 0 0-.001 4.4z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 14.933a2.2 2.2 0 0 0 4.4 0v-2.2H3.2a2.2 2.2 0 0 0-2.2 2.2zm5.867 0v5.866a2.2 2.2 0 0 0 4.4.001v-5.866a2.2 2.2 0 0 0-4.4-.001z"
    }));
};
SlackFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$T = [
    "color",
    "size"
];
var StackOverflowFill = function StackOverflowFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$T);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M18.372 20.222v-5.358h1.79V22H4v-7.136h1.79v5.358h12.582z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7.768 14.356l8.79 1.824.372-1.755L8.14 12.6l-.372 1.756zm1.162-4.157l8.14 3.764.744-1.617-8.14-3.787-.744 1.64zm2.256-3.973l6.907 5.705 1.14-1.363-6.907-5.704-1.14 1.362zM15.651 2L14.21 3.062l5.35 7.16L21 9.159 15.651 2zm-8.07 16.42h8.977v-1.778H7.581v1.778z"
    }));
};
StackOverflowFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$S = [
    "color",
    "size"
];
var TwitchFill = function TwitchFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$S);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.547 1L1 4.776v15.433h5.5V23h3.093l2.922-2.791h4.47L23 14.462V1H2.547zm18.39 12.478l-3.438 3.283H12l-2.922 2.791v-2.79h-4.64V2.97h16.499v10.508zm-3.438-6.731v5.74h-2.062v-5.74H17.5zm-5.499 0v5.74H9.938v-5.74H12z"
    }));
};
TwitchFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$R = [
    "color",
    "size"
];
var SnapchatFill = function SnapchatFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$R);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_822_337)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5.829 4.533c-.6 1.344-.363 3.752-.267 5.436-.648.359-1.48-.271-1.951-.271-.49 0-1.075.322-1.167.802-.066.346.089.85 1.201 1.289.43.17 1.453.37 1.69.928.333.784-1.71 4.403-4.918 4.931a.498.498 0 0 0-.416.519c.056.975 2.242 1.357 3.211 1.507.099.134.179.7.306 1.131.057.193.204.424.582.424.493 0 1.312-.38 2.738-.144 1.398.233 2.712 2.215 5.235 2.215 2.345 0 3.744-1.991 5.09-2.215.779-.129 1.448-.088 2.196.058.515.101.977.157 1.124-.349.129-.437.208-.992.305-1.123.96-.149 3.156-.53 3.211-1.505a.498.498 0 0 0-.416-.519c-3.154-.52-5.259-4.128-4.918-4.931.236-.557 1.252-.755 1.69-.928.814-.321 1.222-.716 1.213-1.173-.011-.585-.715-.934-1.233-.934-.527 0-1.284.624-1.897.286.096-1.698.332-4.095-.267-5.438C17.036 1.986 14.511.7 11.987.7 9.479.7 6.973 1.968 5.829 4.533z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_822_337"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
SnapchatFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$Q = [
    "color",
    "size"
];
var OctocatFill = function OctocatFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$Q);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8.422 20.081c0 .896.01 1.753.016 2.285a.617.617 0 0 0 .422.58c2.078.686 4.317.718 6.414.091l.292-.087a.67.67 0 0 0 .478-.638c.005-.733.017-2.017.017-3.53 0-1.372-.477-2.25-1.031-2.707 3.399-.366 6.97-1.61 6.97-7.227 0-1.61-.592-2.91-1.566-3.934.153-.366.688-1.866-.153-3.878 0 0-1.28-.403-4.201 1.5a14.76 14.76 0 0 0-3.82-.494c-1.298 0-2.597.165-3.819.494C5.52.65 4.24 1.036 4.24 1.036c-.84 2.012-.306 3.512-.153 3.878a5.565 5.565 0 0 0-1.566 3.934c0 5.598 3.552 6.86 6.951 7.227-.439.366-.84 1.006-.973 1.957-.879.384-3.075 1.006-4.45-1.207-.286-.44-1.146-1.519-2.349-1.5-1.28.018-.516.695.02.97.648.347 1.393 1.646 1.565 2.067.306.823 1.299 2.396 5.137 1.72z"
    }));
};
OctocatFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$P = [
    "color",
    "size"
];
var DiscordFill = function DiscordFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$P);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M20.317 4.492c-1.53-.69-3.17-1.2-4.885-1.49a.075.075 0 0 0-.079.036c-.21.369-.444.85-.608 1.23a18.566 18.566 0 0 0-5.487 0 12.36 12.36 0 0 0-.617-1.23A.077.077 0 0 0 8.562 3c-1.714.29-3.354.8-4.885 1.491a.07.07 0 0 0-.032.027C.533 9.093-.32 13.555.099 17.961a.08.08 0 0 0 .031.055 20.03 20.03 0 0 0 5.993 2.98.078.078 0 0 0 .084-.026c.462-.62.874-1.275 1.226-1.963.021-.04.001-.088-.041-.104a13.201 13.201 0 0 1-1.872-.878.075.075 0 0 1-.008-.125c.126-.093.252-.19.372-.287a.075.075 0 0 1 .078-.01c3.927 1.764 8.18 1.764 12.061 0a.075.075 0 0 1 .079.009c.12.098.245.195.372.288a.075.075 0 0 1-.006.125c-.598.344-1.22.635-1.873.877a.075.075 0 0 0-.041.105c.36.687.772 1.341 1.225 1.962a.077.077 0 0 0 .084.028 19.963 19.963 0 0 0 6.002-2.981.076.076 0 0 0 .032-.054c.5-5.094-.838-9.52-3.549-13.442a.06.06 0 0 0-.031-.028zM8.02 15.278c-1.182 0-2.157-1.069-2.157-2.38 0-1.312.956-2.38 2.157-2.38 1.21 0 2.176 1.077 2.157 2.38 0 1.312-.956 2.38-2.157 2.38zm7.975 0c-1.183 0-2.157-1.069-2.157-2.38 0-1.312.955-2.38 2.157-2.38 1.21 0 2.176 1.077 2.157 2.38 0 1.312-.946 2.38-2.157 2.38z"
    }));
};
DiscordFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$O = [
    "color",
    "size"
];
var BehanceFill = function BehanceFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$O);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_1599_271)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 7h-7V5h7v2zm1.726 10c-.442 1.297-2.029 3-5.101 3-3.074 0-5.564-1.729-5.564-5.675 0-3.91 2.325-5.92 5.466-5.92 3.082 0 4.964 1.782 5.375 4.426.078.506.109 1.188.095 2.14H15.97c.13 3.211 3.483 3.312 4.588 2.029h3.168zm-7.686-4h4.965c-.105-1.547-1.136-2.219-2.477-2.219-1.466 0-2.277.768-2.488 2.219zm-9.574 6.988H0V5.021h6.953c5.476.081 5.58 5.444 2.72 6.906 3.461 1.26 3.577 8.061-3.207 8.061zM3 11h3.584c2.508 0 2.906-3-.312-3H3v3zm3.391 3H3v3.016h3.341c3.055 0 2.868-3.016.05-3.016z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_1599_271"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
BehanceFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$N = [
    "color",
    "size"
];
var PostgresqlFill = function PostgresqlFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$N);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16.805 1a9.85 9.85 0 0 0-2.603.37l-.06.018a10.629 10.629 0 0 0-1.615-.151c-1.113-.019-2.07.243-2.84.68-.76-.256-2.336-.697-3.997-.609-1.157.061-2.419.402-3.354 1.36-.933.958-1.426 2.44-1.322 4.457.028.557.191 1.464.463 2.64.27 1.175.652 2.55 1.127 3.805.475 1.256.996 2.384 1.81 3.15.406.384.965.707 1.624.68.463-.018.882-.215 1.243-.506.176.225.364.323.535.414.215.114.425.192.642.244.39.094 1.059.22 1.84.091.267-.043.548-.127.828-.247.01.302.022.598.035.898.038.95.063 1.827.357 2.596.047.126.176.773.687 1.344.51.572 1.51.928 2.648.692.803-.167 1.825-.468 2.503-1.404.67-.926.973-2.255 1.033-4.409.015-.116.033-.215.052-.308l.16.014h.018c.857.038 1.787-.08 2.564-.43.688-.31 1.208-.622 1.587-1.177.095-.137.199-.303.227-.59.028-.285-.14-.733-.421-.939-.563-.414-.916-.257-1.295-.18-.373.08-.753.124-1.136.133 1.093-1.784 1.876-3.68 2.323-5.358.264-.99.413-1.903.425-2.701.012-.798-.055-1.505-.548-2.117-1.541-1.91-3.708-2.438-5.384-2.456-.052-.001-.104-.002-.156-.001V1zm-.044.587c1.585-.015 3.611.417 5.065 2.22.327.405.424.997.413 1.727-.012.729-.151 1.601-.405 2.557-.493 1.852-1.425 4.01-2.738 5.948a.724.724 0 0 0 .15.079c.274.11.898.204 2.145-.044.313-.065.543-.108.781.068a.478.478 0 0 1 .173.39.635.635 0 0 1-.123.308c-.24.351-.716.684-1.326.958-.539.244-1.313.371-1.999.379-.344.003-.661-.023-.93-.104l-.018-.006c-.104.971-.343 2.89-.498 3.765-.125.706-.343 1.267-.76 1.687-.416.42-1.004.673-1.796.838-.981.204-1.696-.016-2.157-.393-.46-.375-.671-.874-.798-1.18-.087-.21-.132-.483-.176-.848a18.073 18.073 0 0 1-.097-1.315 45.725 45.725 0 0 1-.028-2.313c-.41.364-.92.606-1.467.697-.65.107-1.232.002-1.579-.082a2.19 2.19 0 0 1-.49-.185c-.162-.083-.315-.177-.417-.363a.5.5 0 0 1-.054-.35.559.559 0 0 1 .206-.303c.188-.148.435-.23.808-.306.68-.135.917-.228 1.061-.339.123-.095.262-.287.508-.57a1.166 1.166 0 0 1-.003-.037 2.864 2.864 0 0 1-1.257-.329c-.141.145-.865.888-1.748 1.918-.371.431-.781.678-1.214.696-.433.018-.824-.194-1.156-.506-.665-.626-1.195-1.703-1.657-2.92-.46-1.218-.836-2.574-1.102-3.729-.268-1.155-.426-2.086-.448-2.535-.1-1.909.36-3.195 1.15-4.006.79-.811 1.872-1.118 2.928-1.177 1.894-.106 3.693.535 4.057.673.701-.462 1.604-.75 2.733-.732a7.185 7.185 0 0 1 1.588.2l.019-.008c.229-.078.462-.144.698-.196a9.362 9.362 0 0 1 1.957-.23v-.002zm.143.614h-.137a8.502 8.502 0 0 0-1.61.176 7.048 7.048 0 0 1 2.692 2.062c.435.539.795 1.13 1.07 1.76.104.242.174.447.213.605.02.08.034.147.038.217a.392.392 0 0 1-.011.132l-.006.012c.029.803-.176 1.347-.201 2.113-.019.556.127 1.209.163 1.92.034.67-.049 1.405-.497 2.127.038.044.072.088.108.132 1.185-1.81 2.04-3.814 2.495-5.521.243-.92.373-1.753.384-2.413.01-.66-.117-1.139-.279-1.338-1.268-1.573-2.983-1.974-4.422-1.985zm-4.525.235c-1.117.002-1.919.33-2.526.82-.627.507-1.047 1.2-1.323 1.911a7.898 7.898 0 0 0-.485 2.213l.013-.007c.337-.184.78-.367 1.254-.473.475-.106.986-.139 1.449.035.463.175.846.584.985 1.206.665 2.986-.207 4.096-.529 4.933a8.628 8.628 0 0 0-.313.929c.041-.01.082-.02.122-.024a1.06 1.06 0 0 1 .51.1c.324.13.546.402.666.714.031.082.054.17.067.26.014.038.02.077.019.117a49.059 49.059 0 0 0 .012 3.426c.022.494.054.928.095 1.271.04.342.098.602.135.69.12.294.297.678.617.939.32.26.777.434 1.614.26.726-.151 1.174-.36 1.474-.663.298-.301.477-.72.591-1.363.171-.963.515-3.754.556-4.28-.018-.395.042-.7.172-.932.135-.238.343-.384.522-.463.09-.04.174-.066.243-.085a5.487 5.487 0 0 0-.23-.298 4.065 4.065 0 0 1-.629-1.007 7.578 7.578 0 0 0-.243-.443c-.125-.22-.284-.495-.45-.804-.333-.619-.695-1.369-.883-2.1-.187-.729-.215-1.484.265-2.017.426-.473 1.172-.669 2.293-.559-.033-.096-.053-.176-.109-.304a7.125 7.125 0 0 0-.983-1.617c-.95-1.178-2.487-2.346-4.863-2.384h-.108v-.001zm-6.276.047c-.12 0-.24.004-.36.01-.954.053-1.856.322-2.501.986-.647.663-1.072 1.751-.98 3.553.019.34.172 1.296.434 2.43.262 1.136.634 2.471 1.08 3.65.446 1.18.988 2.207 1.502 2.693.259.243.484.341.688.333.205-.01.451-.124.753-.475a40.03 40.03 0 0 1 1.71-1.877 3.206 3.206 0 0 1-.932-1.307 3.116 3.116 0 0 1-.17-1.58c.097-.678.11-1.312.099-1.812-.012-.488-.048-.812-.048-1.015V8.044c-.001-1.056.188-2.103.559-3.095.264-.682.658-1.375 1.249-1.936-.58-.185-1.61-.467-2.725-.52a7.4 7.4 0 0 0-.36-.01h.002zm11.714 4.842c-.641.008-1.001.169-1.19.379-.268.298-.293.82-.127 1.464.165.644.507 1.365.829 1.963.16.3.316.57.442.788.127.22.22.376.276.51.052.122.11.23.168.331.248-.509.293-1.008.267-1.529-.033-.644-.187-1.303-.164-1.97.025-.78.184-1.289.198-1.892a5.639 5.639 0 0 0-.699-.044zm-7.78.105a2.743 2.743 0 0 0-.582.068 4.49 4.49 0 0 0-1.09.412c-.115.06-.226.13-.33.209l-.02.018c.006.134.033.459.045.936.01.523-.002 1.19-.106 1.91-.226 1.568.946 2.866 2.324 2.868.08-.322.213-.648.345-.992.384-1.003 1.139-1.734.503-4.589-.104-.467-.31-.656-.594-.763a1.431 1.431 0 0 0-.495-.077zm7.48.187h.048c.062.002.12.009.17.02a.396.396 0 0 1 .13.051.153.153 0 0 1 .071.1v.008a.215.215 0 0 1-.034.124.614.614 0 0 1-.104.137.646.646 0 0 1-.364.195.57.57 0 0 1-.388-.095.569.569 0 0 1-.123-.108.235.235 0 0 1-.06-.116.151.151 0 0 1 .04-.118.361.361 0 0 1 .111-.082 1.256 1.256 0 0 1 .504-.118v.002zm-7.388.154c.05 0 .103.005.157.012.144.02.273.057.371.112.048.025.09.057.126.097.019.022.033.046.042.073.009.027.012.055.009.083a.274.274 0 0 1-.071.141.608.608 0 0 1-.135.12.619.619 0 0 1-.424.103.694.694 0 0 1-.396-.209.652.652 0 0 1-.112-.15.25.25 0 0 1-.039-.162c.014-.1.099-.15.18-.18a.842.842 0 0 1 .29-.036l.002-.004zm8.56 6.732h-.003c-.139.05-.253.07-.35.11a.423.423 0 0 0-.225.197c-.06.105-.11.292-.095.61a.49.49 0 0 0 .14.064c.161.048.432.08.735.075.602-.007 1.344-.143 1.738-.321.323-.146.623-.336.891-.564-1.317.264-2.06.194-2.517.011a1.247 1.247 0 0 1-.314-.183zm-7.588.086h-.02c-.05.004-.123.02-.263.172-.33.358-.444.582-.716.792-.27.21-.623.321-1.327.461-.223.044-.35.093-.436.132.028.022.025.028.066.049.103.055.236.103.342.13.303.073.8.159 1.319.073.518-.086 1.058-.327 1.518-.953.08-.108.088-.268.023-.44-.067-.17-.211-.318-.313-.36a.632.632 0 0 0-.193-.054v-.002z"
    }));
};
PostgresqlFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$M = [
    "color",
    "size"
];
var MastodonFill = function MastodonFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$M);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12.158 0c-3.068.025-6.02.357-7.74 1.147 0 0-3.41 1.526-3.41 6.733 0 1.192-.024 2.617.014 4.129.123 5.091.933 10.11 5.64 11.355 2.171.575 4.035.695 5.535.613 2.722-.151 4.25-.972 4.25-.972l-.09-1.974s-1.945.613-4.13.538c-2.163-.074-4.448-.233-4.798-2.89a5.448 5.448 0 0 1-.048-.745s2.124.519 4.816.642c1.647.076 3.19-.096 4.759-.283 3.007-.36 5.625-2.212 5.954-3.905.519-2.667.476-6.508.476-6.508 0-5.207-3.411-6.733-3.411-6.733C18.255.357 15.302.025 12.233 0h-.075zM8.686 4.068c1.278 0 2.245.491 2.885 1.474l.622 1.043.623-1.043c.64-.983 1.607-1.474 2.885-1.474 1.105 0 1.995.388 2.675 1.146.658.757.986 1.781.986 3.07v6.303h-2.497V8.47c0-1.29-.543-1.945-1.628-1.945-1.2 0-1.802.777-1.802 2.313v3.349h-2.483v-3.35c0-1.535-.601-2.312-1.802-2.312-1.085 0-1.628.655-1.628 1.945v6.118H5.024V8.283c0-1.288.328-2.312.987-3.07.68-.757 1.57-1.145 2.675-1.145z"
    }));
};
MastodonFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$L = [
    "color",
    "size"
];
var TiktokFill = function TiktokFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$L);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19.321 5.562a5.124 5.124 0 0 1-.443-.258 6.228 6.228 0 0 1-1.137-.966c-.849-.971-1.166-1.956-1.282-2.645h.004c-.097-.573-.057-.943-.05-.943h-3.865v14.943c0 .2 0 .399-.008.595 0 .024-.003.046-.004.073 0 .01 0 .022-.003.033v.009a3.28 3.28 0 0 1-1.65 2.604 3.226 3.226 0 0 1-1.6.422c-1.8 0-3.26-1.468-3.26-3.281 0-1.814 1.46-3.282 3.26-3.282.341 0 .68.054 1.004.16l.005-3.936A7.178 7.178 0 0 0 4.76 10.71a7.583 7.583 0 0 0-1.655 2.04c-.163.281-.779 1.412-.853 3.246-.047 1.04.266 2.12.415 2.565v.01c.093.262.457 1.158 1.049 1.913a7.856 7.856 0 0 0 1.674 1.58v-.01l.009.01c1.87 1.27 3.945 1.187 3.945 1.187.359-.015 1.562 0 2.928-.647 1.515-.718 2.377-1.787 2.377-1.787a7.43 7.43 0 0 0 1.296-2.153c.35-.92.466-2.022.466-2.462V8.273c.047.028.672.441.672.441s.9.577 2.303.952c1.006.267 2.363.324 2.363.324V6.153c-.475.052-1.44-.098-2.429-.59z"
    }));
};
TiktokFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$K = [
    "color",
    "size"
];
var UnsplashFill = function UnsplashFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$K);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.25 2h7.5v5.625h-7.5V2zM2 10.75h6.268v5.675h7.517V10.75H22V22H2V10.75z"
    }));
};
UnsplashFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$J = [
    "color",
    "size"
];
var ProductHuntFill = function ProductHuntFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$J);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_2601_269)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M15.402 10.2c0 .992-.808 1.8-1.8 1.8H10.2V8.4h3.402c.992 0 1.8.808 1.8 1.8zM24 12c0 6.629-5.371 12-12 12S0 18.629 0 12 5.371 0 12 0s12 5.371 12 12zm-6.198-1.8c0-2.318-1.883-4.2-4.2-4.2H7.8v12h2.4v-3.6h3.402c2.317 0 4.2-1.882 4.2-4.2z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_2601_269"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
ProductHuntFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$I = [
    "color",
    "size"
];
var YelpFill = function YelpFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$I);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.98 11.264l4.701 2.278a1.075 1.075 0 0 1 .6 1.074 1.066 1.066 0 0 1-.81.927L4.393 16.8a1.088 1.088 0 0 1-1.187-.492 1.069 1.069 0 0 1-.146-.429 9.159 9.159 0 0 1 .424-3.996 1.07 1.07 0 0 1 .606-.645 1.085 1.085 0 0 1 .888.026z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.862 20.879l3.5-3.861a1.08 1.08 0 0 1 1.205-.277 1.076 1.076 0 0 1 .673 1.03l-.183 5.195a1.066 1.066 0 0 1-.396.793 1.083 1.083 0 0 1-.861.226 9.401 9.401 0 0 1-3.748-1.506 1.074 1.074 0 0 1-.46-.758 1.065 1.065 0 0 1 .27-.842z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.16 15.74l4.975 1.606a1.08 1.08 0 0 1 .657.596 1.064 1.064 0 0 1-.017.884 9.312 9.312 0 0 1-2.487 3.166 1.082 1.082 0 0 1-1.602-.258l-2.773-4.408a1.065 1.065 0 0 1 .065-1.226 1.078 1.078 0 0 1 1.182-.36z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.219 12.588l-5.029 1.433a1.085 1.085 0 0 1-1.169-.4A1.065 1.065 0 0 1 14 12.393l2.926-4.308a1.075 1.075 0 0 1 .755-.464 1.085 1.085 0 0 1 .85.257 9.222 9.222 0 0 1 2.379 3.25 1.069 1.069 0 0 1-.691 1.46z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.469.468a15.12 15.12 0 0 0-2.585.946 1.077 1.077 0 0 0-.564.65 1.063 1.063 0 0 0 .097.851l4.915 8.456a1.076 1.076 0 0 0 1.212.499 1.066 1.066 0 0 0 .799-1.034V1.072A1.065 1.065 0 0 0 11.622.06a1.084 1.084 0 0 0-.437-.057c-.918.072-1.826.228-2.715.465z"
    }));
};
YelpFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$H = [
    "color",
    "size"
];
var XFill = function XFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$H);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13.808 10.469L20.88 2h-1.676l-6.142 7.353L8.158 2H2.5l7.418 11.12L2.5 22h1.676l6.486-7.765L15.842 22H21.5l-7.693-11.531zm-2.296 2.748l-.752-1.107L4.78 3.3h2.575l4.826 7.11.751 1.107 6.273 9.242h-2.574l-5.12-7.541z"
    }));
};
XFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$G = [
    "color",
    "size"
];
var ThreadsFill = function ThreadsFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$G);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M17.692 11.123a8.547 8.547 0 0 0-.315-.142c-.185-3.414-2.05-5.368-5.182-5.388h-.042c-1.873 0-3.431.8-4.39 2.255l1.722 1.181c.716-1.087 1.84-1.318 2.669-1.318h.028c1.031.006 1.81.306 2.313.89.367.426.612 1.015.733 1.757a13.176 13.176 0 0 0-2.96-.143c-2.977.172-4.892 1.909-4.763 4.322.065 1.223.675 2.277 1.717 2.964.88.582 2.015.866 3.194.802 1.558-.085 2.78-.68 3.632-1.766.647-.825 1.056-1.894 1.237-3.241.742.448 1.292 1.037 1.596 1.745.516 1.205.546 3.184-1.068 4.797-1.415 1.414-3.116 2.025-5.686 2.044-2.851-.02-5.008-.935-6.41-2.717-1.313-1.67-1.991-4.08-2.016-7.165.025-3.085.703-5.496 2.016-7.165 1.402-1.782 3.558-2.696 6.41-2.717 2.871.02 5.065.94 6.521 2.73.714.879 1.252 1.983 1.607 3.27l2.018-.538c-.43-1.585-1.107-2.95-2.027-4.083C18.38 1.2 15.65.024 12.134 0h-.014C8.61.024 5.912 1.205 4.099 3.51c-1.614 2.05-2.446 4.904-2.474 8.482v.016c.028 3.578.86 6.431 2.474 8.482 1.813 2.305 4.511 3.486 8.02 3.51h.015c3.12-.022 5.319-.838 7.13-2.649 2.371-2.368 2.3-5.336 1.518-7.158-.56-1.307-1.629-2.368-3.09-3.07zm-5.387 5.065c-1.305.074-2.66-.512-2.728-1.766-.05-.93.662-1.969 2.808-2.092.246-.015.487-.021.724-.021.78 0 1.508.075 2.171.22-.247 3.088-1.697 3.59-2.975 3.66z"
    }));
};
ThreadsFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$F = [
    "color",
    "size"
];
var Circle = function Circle(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$F);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10"
    }));
};
Circle.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$E = [
    "color",
    "size"
];
var CircleFill = function CircleFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$E);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "11"
    }));
};
CircleFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$D = [
    "color",
    "size"
];
var Triangle = function Triangle(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$D);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10.293 4.793c.78-1.277 2.634-1.277 3.414 0l7.433 12.164C21.955 18.29 20.996 20 19.434 20H4.566c-1.562 0-2.52-1.71-1.706-3.043l7.433-12.164z"
    }));
};
Triangle.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$C = [
    "color",
    "size"
];
var TriangleFill = function TriangleFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$C);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10.285 3.858c.777-1.294 2.653-1.294 3.43 0l8.468 14.113c.8 1.333-.16 3.029-1.715 3.029H3.532c-1.554 0-2.514-1.696-1.715-3.029l8.468-14.113z"
    }));
};
TriangleFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$B = [
    "color",
    "size"
];
var Square = function Square(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$B);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "18",
        rx: "2"
    }));
};
Square.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$A = [
    "color",
    "size"
];
var SquareFill = function SquareFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$A);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("rect", {
        x: "2",
        y: "2",
        width: "20",
        height: "20",
        rx: "2"
    }));
};
SquareFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$z = [
    "color",
    "size"
];
var Tetragon = function Tetragon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$z);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M3.575 13.388a1.962 1.962 0 0 1 0-2.776l7.037-7.037a1.962 1.962 0 0 1 2.776 0l7.037 7.037a1.963 1.963 0 0 1 0 2.776l-7.037 7.037a1.963 1.963 0 0 1-2.776 0l-7.037-7.037z"
    }));
};
Tetragon.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$y = [
    "color",
    "size"
];
var TetragonFill = function TetragonFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$y);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10.61 2.576a1.966 1.966 0 0 1 2.78 0l8.034 8.034a1.966 1.966 0 0 1 0 2.78l-8.034 8.034a1.966 1.966 0 0 1-2.78 0L2.576 13.39a1.966 1.966 0 0 1 0-2.78l8.034-8.034z"
    }));
};
TetragonFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$x = [
    "color",
    "size"
];
var Pentagon = function Pentagon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$x);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10.75 3a2 2 0 0 1 2.5 0l7.63 6.103a2 2 0 0 1 .63 2.246l-3.031 8.334A2 2 0 0 1 16.599 21H7.401a2 2 0 0 1-1.88-1.317l-3.03-8.334a2 2 0 0 1 .63-2.246L10.75 3z"
    }));
};
Pentagon.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$w = [
    "color",
    "size"
];
var PentagonFill = function PentagonFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$w);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.126 2.219a3 3 0 0 1 3.748 0l7.63 6.104a3 3 0 0 1 .945 3.367l-3.03 8.335A3 3 0 0 1 16.599 22H7.401a3 3 0 0 1-2.82-1.975l-3.03-8.334a3 3 0 0 1 .945-3.368l7.63-6.104z"
    }));
};
PentagonFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$v = [
    "color",
    "size"
];
var Hexagon = function Hexagon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$v);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.029 2.54a2 2 0 0 1 1.942 0l7 3.888A2 2 0 0 1 21 8.177v7.646a2 2 0 0 1-1.029 1.748l-7 3.89a2 2 0 0 1-1.942 0l-7-3.89A2 2 0 0 1 3 15.824V8.177a2 2 0 0 1 1.029-1.749l7-3.888z"
    }));
};
Hexagon.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$u = [
    "color",
    "size"
];
var HexagonFill = function HexagonFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$u);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.036 1.53a2 2 0 0 1 1.928 0l8 4.4A2 2 0 0 1 22 7.683v8.634a2 2 0 0 1-1.036 1.753l-8 4.4a2 2 0 0 1-1.928 0l-8-4.4A2 2 0 0 1 2 16.317V7.683A2 2 0 0 1 3.036 5.93l8-4.4z"
    }));
};
HexagonFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$t = [
    "color",
    "size"
];
var Heptagon = function Heptagon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$t);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.114 2.438a2 2 0 0 1 1.772 0l6.275 3.1a2 2 0 0 1 1.066 1.358l1.569 7.047a2 2 0 0 1-.374 1.662l-4.371 5.623a2 2 0 0 1-1.579.772H8.528a2 2 0 0 1-1.579-.772l-4.371-5.623a2 2 0 0 1-.374-1.662l1.569-7.047a2 2 0 0 1 1.066-1.359l6.275-3.1z"
    }));
};
Heptagon.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$s = [
    "color",
    "size"
];
var HeptagonFill = function HeptagonFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$s);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.114 1.438a2 2 0 0 1 1.772 0l7.077 3.495a2 2 0 0 1 1.066 1.359l1.767 7.937a2 2 0 0 1-.374 1.662l-4.926 6.337a2 2 0 0 1-1.579.772H8.083a2 2 0 0 1-1.579-.772L1.578 15.89a2 2 0 0 1-.374-1.662l1.767-7.937a2 2 0 0 1 1.066-1.359l7.077-3.495z"
    }));
};
HeptagonFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$r = [
    "color",
    "size"
];
var Octagon = function Octagon(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$r);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.235 2.317a2 2 0 0 1 1.53 0l5.54 2.295a2 2 0 0 1 1.083 1.082l2.295 5.54a2 2 0 0 1 0 1.531l-2.295 5.54a2 2 0 0 1-1.082 1.083l-5.54 2.295a2 2 0 0 1-1.531 0l-5.54-2.295a2 2 0 0 1-1.083-1.082l-2.295-5.54a2 2 0 0 1 0-1.531l2.295-5.54a2 2 0 0 1 1.082-1.083l5.54-2.295z"
    }));
};
Octagon.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$q = [
    "color",
    "size"
];
var OctagonFill = function OctagonFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$q);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.235 1.317a2 2 0 0 1 1.53 0l6.248 2.588a2 2 0 0 1 1.082 1.082l2.588 6.248a2 2 0 0 1 0 1.53l-2.588 6.248a2 2 0 0 1-1.082 1.082l-6.248 2.588a2 2 0 0 1-1.53 0l-6.248-2.588a2 2 0 0 1-1.082-1.082l-2.588-6.248a2 2 0 0 1 0-1.53l2.588-6.248a2 2 0 0 1 1.082-1.082l6.248-2.588z"
    }));
};
OctagonFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$p = [
    "color",
    "size"
];
var Oval = function Oval(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$p);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("ellipse", {
        cx: "12",
        cy: "12",
        rx: "8",
        ry: "10"
    }));
};
Oval.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$o = [
    "color",
    "size"
];
var Parallelogram = function Parallelogram(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$o);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5.586 6.45A2 2 0 0 1 7.509 5h11.84a2 2 0 0 1 1.923 2.55l-2.858 10A2 2 0 0 1 16.491 19H4.651a2 2 0 0 1-1.923-2.55l2.858-10z"
    }));
};
Parallelogram.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$n = [
    "color",
    "size"
];
var Diamond = function Diamond(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$n);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4.511 13.542c-.681-.852-.681-2.232 0-3.084l6.256-7.82c.68-.85 1.785-.85 2.466 0l6.256 7.82c.681.852.681 2.232 0 3.084l-6.256 7.82c-.68.85-1.785.85-2.466 0l-6.256-7.82z"
    }));
};
Diamond.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$m = [
    "color",
    "size"
];
var BootstrapFill = function BootstrapFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$m);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.985 2c-1.37 0-2.383 1.199-2.337 2.498.043 1.25-.013 2.867-.42 4.186-.41 1.322-1.1 2.16-2.228 2.268v1.215c1.128.107 1.819.945 2.227 2.268.408 1.319.464 2.936.42 4.185-.045 1.3.968 2.499 2.338 2.499h14.032c1.37 0 2.383-1.199 2.337-2.499-.043-1.249.013-2.866.42-4.185.409-1.323 1.098-2.16 2.226-2.268v-1.215c-1.128-.108-1.817-.946-2.226-2.268-.407-1.32-.463-2.937-.42-4.186C21.4 3.198 20.386 2 19.017 2H4.985zM16.27 13.769c0 1.79-1.335 2.875-3.55 2.875H8.949a.407.407 0 0 1-.407-.407V6.881a.407.407 0 0 1 .407-.406h3.75c1.847 0 3.06 1 3.06 2.537 0 1.078-.816 2.043-1.855 2.213v.056c1.415.155 2.367 1.135 2.367 2.488zM12.31 7.764h-2.15v3.038h1.811c1.4 0 2.172-.564 2.172-1.572 0-.944-.664-1.466-1.833-1.466zm-2.15 4.243v3.347h2.23c1.457 0 2.23-.585 2.23-1.684 0-1.1-.794-1.663-2.324-1.663h-2.136z"
    }));
};
BootstrapFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$l = [
    "color",
    "size"
];
var ReactFill = function ReactFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$l);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_950_642)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M24 11.689c0-1.59-1.991-3.097-5.044-4.031.705-3.111.392-5.587-.988-6.38a2.145 2.145 0 0 0-1.096-.273v1.09c.225 0 .406.045.558.128.665.382.954 1.834.729 3.703-.054.46-.142.944-.25 1.438a23.706 23.706 0 0 0-3.106-.533 23.857 23.857 0 0 0-2.035-2.446c1.595-1.482 3.092-2.294 4.11-2.294V1c-1.346 0-3.107.959-4.888 2.622C10.21 1.97 8.448 1.02 7.103 1.02v1.09c1.013 0 2.515.808 4.11 2.28-.685.72-1.37 1.536-2.021 2.441a22.844 22.844 0 0 0-3.111.538c-.113-.489-.196-.963-.255-1.418-.23-1.87.054-3.322.715-3.708.146-.088.337-.128.562-.128v-1.09c-.41 0-.783.088-1.105.273-1.375.793-1.683 3.263-.974 6.365C1.981 8.603 0 10.104 0 11.689c0 1.59 1.991 3.097 5.044 4.03-.705 3.112-.392 5.588.988 6.38.318.186.69.274 1.1.274 1.346 0 3.107-.959 4.888-2.622 1.78 1.653 3.541 2.602 4.887 2.602a2.18 2.18 0 0 0 1.105-.274c1.375-.792 1.683-3.262.974-6.364C22.019 14.781 24 13.274 24 11.689zm-6.37-3.263a22.023 22.023 0 0 1-.66 1.932 26.444 26.444 0 0 0-1.345-2.319c.695.103 1.365.23 2.006.387zm-2.24 5.21c-.381.66-.773 1.287-1.179 1.869a25.453 25.453 0 0 1-4.412.005 25.457 25.457 0 0 1-2.201-3.806 26.064 26.064 0 0 1 2.192-3.82 25.455 25.455 0 0 1 4.411-.006c.406.582.803 1.204 1.184 1.86.372.64.71 1.29 1.018 1.946a27.41 27.41 0 0 1-1.013 1.952zM16.97 13c.264.655.49 1.311.675 1.947-.64.157-1.316.289-2.015.391A27.044 27.044 0 0 0 16.97 13zm-4.96 5.22c-.455-.47-.91-.993-1.36-1.566.44.02.89.035 1.345.035.46 0 .915-.01 1.36-.035-.44.573-.895 1.096-1.345 1.566zm-3.64-2.882a22.113 22.113 0 0 1-2.006-.386c.181-.631.406-1.282.66-1.932.201.39.412.782.642 1.174.23.391.464.773.704 1.144zm3.615-10.18c.455.47.91.993 1.36 1.566-.44-.02-.89-.035-1.345-.035-.46 0-.915.01-1.36.035.44-.573.895-1.096 1.345-1.566zM8.365 8.04a27.02 27.02 0 0 0-1.34 2.333 20.96 20.96 0 0 1-.675-1.947c.64-.152 1.316-.284 2.015-.386zm-4.427 6.124c-1.732-.738-2.852-1.707-2.852-2.475s1.12-1.742 2.852-2.475c.42-.181.88-.343 1.355-.494.279.958.646 1.956 1.1 2.979a23.165 23.165 0 0 0-1.085 2.964 14.875 14.875 0 0 1-1.37-.499zm2.632 6.99c-.665-.38-.954-1.834-.729-3.702.054-.46.142-.945.25-1.439.958.235 2.005.416 3.106.534a23.87 23.87 0 0 0 2.035 2.446c-1.595 1.482-3.092 2.294-4.11 2.294a1.167 1.167 0 0 1-.552-.132zm11.604-3.727c.23 1.869-.054 3.322-.715 3.708-.146.088-.337.127-.562.127-1.013 0-2.515-.807-4.11-2.28.685-.718 1.37-1.535 2.021-2.44a22.843 22.843 0 0 0 3.111-.538c.113.494.2.968.255 1.423zm1.883-3.263c-.42.181-.88.343-1.355.494a23.482 23.482 0 0 0-1.1-2.979c.45-1.017.811-2.01 1.085-2.964.485.151.944.318 1.375.499 1.732.738 2.852 1.707 2.852 2.475-.005.768-1.125 1.742-2.857 2.475z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.995 13.925a2.236 2.236 0 1 0 0-4.472 2.236 2.236 0 0 0 0 4.472z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_950_642"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
ReactFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$k = [
    "color",
    "size"
];
var AngularFill = function AngularFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$k);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10.174 12.594h3.652L12 8.095l-1.826 4.499z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 1L2 4.652l1.525 13.541L12 23l8.475-4.807L22 4.652 12 1zm6.24 16.786h-2.33l-1.257-3.212H9.347L8.09 17.786H5.76L12 3.431l6.24 14.355z"
    }));
};
AngularFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$j = [
    "color",
    "size"
];
var VueFill = function VueFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$j);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M19.114 2H15l-3 4.9L9.429 2H0l12 21L24 2h-4.886zM3 3.75h2.914L12 14.6l6.086-10.85H21L12 19.5 3 3.75z"
    }));
};
VueFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$i = [
    "color",
    "size"
];
var JavascriptFill = function JavascriptFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$i);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_950_640)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0h24v24H0V0zm18.347 20.12c-1.113 0-1.742-.58-2.225-1.37l-1.833 1.065c.662 1.308 2.015 2.306 4.11 2.306 2.142 0 3.737-1.112 3.737-3.143 0-1.883-1.082-2.72-2.998-3.543l-.564-.241c-.968-.42-1.387-.693-1.387-1.37 0-.547.42-.966 1.08-.966.647 0 1.064.273 1.451.966l1.756-1.127c-.743-1.307-1.773-1.806-3.207-1.806-2.014 0-3.303 1.288-3.303 2.98 0 1.835 1.08 2.704 2.708 3.397l.564.242c1.029.45 1.642.724 1.642 1.497 0 .646-.597 1.113-1.531 1.113zm-8.74-.015c-.775 0-1.098-.53-1.452-1.16l-1.836 1.112c.532 1.126 1.578 2.06 3.383 2.06 1.999 0 3.368-1.063 3.368-3.398v-7.7h-2.255v7.67c0 1.127-.468 1.416-1.209 1.416z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_950_640"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
JavascriptFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$h = [
    "color",
    "size"
];
var NodeFill = function NodeFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$h);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 23.956c-.342 0-.66-.089-.957-.243l-3.029-1.738c-.455-.242-.227-.33-.09-.374.614-.198.728-.242 1.366-.595.068-.044.16-.022.228.022l2.323 1.343c.09.044.205.044.273 0l9.087-5.084c.09-.044.136-.132.136-.242V6.899c0-.11-.045-.198-.136-.242l-9.087-5.061c-.091-.044-.205-.044-.273 0L2.754 6.657c-.091.044-.137.154-.137.242v10.146c0 .088.046.198.137.242l2.482 1.387c1.344.66 2.186-.11 2.186-.88V7.78c0-.132.114-.264.274-.264h1.161c.137 0 .273.11.273.264v10.013c0 1.739-.979 2.751-2.687 2.751-.524 0-.934 0-2.095-.55l-2.391-1.32A1.847 1.847 0 0 1 1 17.067V6.921c0-.66.364-1.276.957-1.606L11.044.23a2.095 2.095 0 0 1 1.912 0l9.088 5.084c.592.33.956.946.956 1.606v10.146c0 .66-.364 1.276-.956 1.607l-9.088 5.083a2.4 2.4 0 0 1-.956.198zm2.801-6.977c-3.985 0-4.805-1.76-4.805-3.257 0-.132.114-.264.273-.264h1.184c.137 0 .25.088.25.22.183 1.166.707 1.738 3.121 1.738 1.913 0 2.733-.418 2.733-1.408 0-.572-.228-.99-3.211-1.276-2.483-.243-4.031-.77-4.031-2.685 0-1.783 1.548-2.84 4.145-2.84 2.915 0 4.35.969 4.532 3.082a.347.347 0 0 1-.069.198c-.045.044-.113.088-.182.088h-1.184a.265.265 0 0 1-.25-.198c-.274-1.21-.98-1.607-2.847-1.607-2.096 0-2.346.704-2.346 1.232 0 .639.296.837 3.12 1.189 2.801.352 4.122.858 4.122 2.75-.023 1.938-1.662 3.038-4.555 3.038z"
    }));
};
NodeFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$g = [
    "color",
    "size"
];
var HtmlFill = function HtmlFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$g);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_950_633)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M5.08 0h1.082v1.069h.99V0h1.082v3.236H7.152V2.153h-.99v1.083H5.081V0z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M9.656 1.073h-.952V0h2.987v1.073h-.953v2.163H9.656V1.073z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12.165 0h1.128l.694 1.137L14.68 0h1.128v3.236h-1.077V1.632l-.744 1.151h-.019l-.745-1.15v1.603h-1.058V0z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16.346 0h1.083v2.167h1.52v1.07h-2.603V0z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.046 22.072L3 4.717h18L18.953 22.07 11.99 24l-6.944-1.928zm4.137-9.5l-.194-2.18h8.145l.19-2.128H6.664l.574 6.437h7.377l-.247 2.76-2.374.642h-.002l-2.37-.64-.152-1.697H7.332l.298 3.342 4.36 1.21 4.367-1.21.532-5.964.052-.571H9.183z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_950_633"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
HtmlFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$f = [
    "color",
    "size"
];
var CssFill = function CssFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$f);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M7.502 0h2.578v1.078h-1.5v1.078h1.5v1.078H7.502V0z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10.595 0h2.579v.938h-1.5v.187h1.5v2.156h-2.579v-.984h1.5v-.188h-1.5V0z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13.69 0h2.577v.938h-1.5v.187h1.5v2.156H13.69v-.984h1.5v-.188h-1.5V0z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.991 24l-6.944-1.928L3 4.717h18L18.954 22.07 11.991 24zM7.047 12.573l.191 2.128h7.377l-.247 2.76-2.374.642h-.002l-2.37-.64-.152-1.697H7.333l.298 3.342 4.36 1.21 4.367-1.21.532-5.964.052-.571.384-4.309H6.664l.194 2.129h8.136l-.194 2.18H7.047z"
    }));
};
CssFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$e = [
    "color",
    "size"
];
var VercelFill = function VercelFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$e);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 1l12 21H0L12 1z"
    }));
};
VercelFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$d = [
    "color",
    "size"
];
var NextjsFill = function NextjsFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$d);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_950_641)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.214.006c-.052.005-.216.022-.364.033C7.442.347 4.25 2.186 2.226 5.013a11.88 11.88 0 0 0-2.118 5.243c-.096.66-.108.854-.108 1.748s.012 1.089.108 1.748c.652 4.507 3.86 8.293 8.209 9.696.779.251 1.6.422 2.533.526.364.04 1.936.04 2.3 0 1.611-.179 2.977-.578 4.323-1.265.207-.105.247-.134.219-.157-.02-.014-.899-1.194-1.955-2.62l-1.919-2.593-2.404-3.559a342.499 342.499 0 0 0-2.422-3.556c-.009-.003-.018 1.578-.023 3.51-.007 3.38-.01 3.516-.052 3.596a.426.426 0 0 1-.206.213c-.075.038-.14.045-.495.045H7.81l-.108-.068a.44.44 0 0 1-.157-.172l-.05-.105.005-4.704.007-4.706.073-.092a.644.644 0 0 1 .174-.143c.096-.047.133-.051.54-.051.478 0 .558.018.682.154.035.038 1.337 2 2.895 4.362l4.734 7.172 1.9 2.878.097-.063a12.318 12.318 0 0 0 2.465-2.163 11.947 11.947 0 0 0 2.825-6.135c.096-.66.108-.854.108-1.748s-.012-1.088-.108-1.748C23.24 5.75 20.032 1.963 15.683.56a12.6 12.6 0 0 0-2.498-.523c-.226-.024-1.776-.05-1.97-.03zm4.913 7.26a.473.473 0 0 1 .237.276c.018.06.023 1.365.018 4.305l-.007 4.218-.743-1.14-.746-1.14v-3.066c0-1.983.009-3.097.023-3.151a.478.478 0 0 1 .232-.296c.097-.05.132-.054.5-.054.347 0 .408.005.486.047z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_950_641"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
NextjsFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$c = [
    "color",
    "size"
];
var ReduxFill = function ReduxFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$c);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_950_630)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16.63 16.563c.885-.092 1.557-.863 1.527-1.788a1.723 1.723 0 0 0-1.71-1.665h-.062c-.947.03-1.68.832-1.65 1.788.032.463.215.863.49 1.14-1.039 2.067-2.627 3.577-5.01 4.841-1.618.864-3.298 1.172-4.977.956-1.375-.185-2.444-.802-3.116-1.819-.977-1.51-1.068-3.145-.244-4.779.58-1.171 1.497-2.035 2.077-2.466-.122-.401-.305-1.08-.397-1.573C-.871 14.436-.412 18.814.93 20.88c1.008 1.542 3.054 2.498 5.315 2.498.61 0 1.221-.062 1.832-.216 3.91-.77 6.872-3.114 8.552-6.598zm5.375-3.823c-2.321-2.744-5.742-4.255-9.651-4.255h-.489a1.677 1.677 0 0 0-1.496-.925h-.062c-.946.031-1.68.833-1.649 1.789.03.925.794 1.664 1.71 1.664h.062a1.721 1.721 0 0 0 1.496-1.048h.55c2.321 0 4.52.678 6.505 2.004 1.527 1.018 2.627 2.343 3.237 3.947.52 1.294.49 2.558-.06 3.638-.856 1.634-2.291 2.528-4.185 2.528-1.221 0-2.382-.37-2.993-.648a18.07 18.07 0 0 1-1.374 1.11c1.313.617 2.657.956 3.94.956 2.932 0 5.1-1.634 5.925-3.268.885-1.788.824-4.871-1.466-7.492zM6.49 17.087c.03.925.794 1.665 1.71 1.665h.061c.947-.03 1.68-.832 1.65-1.788a1.723 1.723 0 0 0-1.71-1.665h-.062c-.061 0-.153 0-.214.03-1.252-2.096-1.771-4.377-1.588-6.844.122-1.85.733-3.453 1.802-4.779.886-1.14 2.596-1.695 3.757-1.726 3.237-.062 4.611 4.008 4.703 5.642.397.092 1.069.308 1.527.462C17.759 3.09 14.706.5 11.773.5 9.025.5 6.49 2.504 5.482 5.464c-1.405 3.946-.489 7.738 1.222 10.729-.153.216-.245.555-.214.894z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_950_630"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
ReduxFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$b = [
    "color",
    "size"
];
var PythonFill = function PythonFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$b);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_950_629)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M11.914 0C5.82 0 6.2 2.656 6.2 2.656l.007 2.752h5.814v.826H3.9S0 5.789 0 11.969c0 6.18 3.403 5.96 3.403 5.96h2.03v-2.867s-.109-3.42 3.35-3.42h5.766s3.24.052 3.24-3.148V3.202S18.28 0 11.913 0zM8.708 1.85c.578 0 1.046.47 1.046 1.052 0 .581-.468 1.051-1.046 1.051-.579 0-1.046-.47-1.046-1.051 0-.582.467-1.052 1.046-1.052z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12.087 24c6.092 0 5.712-2.656 5.712-2.656l-.007-2.752h-5.814v-.826h8.123s3.9.445 3.9-5.735c0-6.18-3.404-5.96-3.404-5.96h-2.03v2.867s.109 3.42-3.35 3.42H9.452s-3.24-.052-3.24 3.148v5.292S5.72 24 12.087 24zm3.206-1.85c-.579 0-1.046-.47-1.046-1.052 0-.581.467-1.051 1.046-1.051.578 0 1.046.47 1.046 1.051 0 .582-.468 1.052-1.046 1.052z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_950_629"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
PythonFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$a = [
    "color",
    "size"
];
var GraphqlFill = function GraphqlFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$a);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_950_628)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.384 4.187a2.132 2.132 0 0 0 1.171.018l6.326 11.182a2.126 2.126 0 0 0-.593 1.038H5.71a2.148 2.148 0 0 0-.64-1.079l6.313-11.159zm-.921-.565c.018.02.038.039.057.058L4.193 14.865a2.11 2.11 0 0 0-.09-.022V9.156A2.122 2.122 0 0 0 5.481 8.14a2.142 2.142 0 0 0 .19-1.694l4.792-2.823zm3.57-.835a2.134 2.134 0 1 0-4.079-.04L5.159 5.573A2.131 2.131 0 0 0 1.785 6a2.146 2.146 0 0 0 1.322 3.143v5.715A2.147 2.147 0 0 0 1.79 18a2.13 2.13 0 0 0 3.368.43l4.795 2.826a2.151 2.151 0 0 0-.086.605C9.868 23.044 10.82 24 12 24a2.138 2.138 0 0 0 2.012-2.848l4.751-2.8a2.128 2.128 0 0 0 3.44-.352 2.138 2.138 0 0 0-1.384-3.159v-5.68A2.147 2.147 0 0 0 22.215 6a2.133 2.133 0 0 0-3.401-.398l-4.78-2.816zm-.599.937l.075-.072 4.808 2.833a2.142 2.142 0 0 0 .203 1.654 2.12 2.12 0 0 0 1.303 1v5.72a2.074 2.074 0 0 0-.078.023L13.434 3.724zm4.895 13.858l-4.774 2.814a2.124 2.124 0 0 0-1.554-.674c-.606 0-1.152.252-1.54.658l-4.785-2.82c.012-.039.023-.078.032-.118H18.29c.012.047.025.094.04.14z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_950_628"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
GraphqlFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$9 = [
    "color",
    "size"
];
var PhpFill = function PhpFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$9);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 5.5C5.271 5.5 0 8.355 0 12s5.271 6.5 12 6.5 12-2.855 12-6.5-5.271-6.5-12-6.5zm-1.246 2h1.31l-.416 2h1.17c.742 0 1.24.104 1.524.363.277.256.361.676.25 1.248l-.52 2.389H12.74l.479-2.209c.058-.303.035-.514-.067-.625-.101-.111-.324-.166-.658-.166h-1.049l-.633 3H9.5l1.254-6zM5 9.5h2.666c1.271 0 2.041.852 1.74 2.123C9.056 13.1 8.12 13.5 6.396 13.5h-.824L5.311 15H3.986L5 9.5zm10.5 0h2.666c1.271 0 2.041.852 1.74 2.123-.35 1.477-1.287 1.877-3.01 1.877h-.824l-.261 1.5h-1.325L15.5 9.5zm-9.365 1l-.377 2h.855c.74 0 1.428-.084 1.543-1.188.043-.427-.135-.812-.99-.812H6.135zm10.5 0l-.377 2h.855c.74 0 1.428-.084 1.543-1.188.043-.427-.134-.812-.99-.812h-1.031z"
    }));
};
PhpFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$8 = [
    "color",
    "size"
];
var JqueryFill = function JqueryFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$8);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_950_626)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M13.301 5.601c-.628-1.528-.54-3.247.367-4.63L14.346 0c-1.254 2.35-.06 5.236 1.86 6.749a6.343 6.343 0 0 0 1.698.95c.164.06.35.124.52.167 2.146.54 3.895.167 4.936-1.389-.032.048-.073.124-.125.22-.464.86-1.822 3.377-5.76 2.587-.075-.015-.147-.04-.219-.063l-.064-.022-.046-.015a2.119 2.119 0 0 0-.064-.021 5.8 5.8 0 0 1-.174-.063c-1.585-.604-2.944-1.876-3.607-3.499z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M8.12 2.966c-1.537 2.295-1.453 5.368-.254 7.796a10.242 10.242 0 0 0 .762 1.301c.209.313.439.66.708.902.111.127.227.25.345.371l.068.07.023.023a10.22 10.22 0 0 0 .367.353l.001.001.002.002a10.623 10.623 0 0 0 .465.397l.04.032c.14.112.283.222.43.327l.006.004.007.005c.047.034.095.067.143.099l.053.036a3.109 3.109 0 0 1 .093.064c.105.07.211.137.319.203l.03.017.015.01a11.466 11.466 0 0 0 .351.201l.031.016.04.022c.052.028.104.057.158.084l.03.015a9.941 9.941 0 0 0 .47.224l.032.013a10.315 10.315 0 0 0 .451.186l.03.011c.103.04.206.076.31.112l.052.018.088.029c.039.012.078.026.116.039.109.038.218.075.332.095C22.168 17.408 24 11.068 24 11.068c-1.651 2.468-4.849 3.646-8.261 2.726a9.54 9.54 0 0 1-.45-.135c-.04-.012-.08-.026-.12-.04l-.015-.005a8.82 8.82 0 0 1-.314-.112l-.003-.002a10.08 10.08 0 0 1-.512-.21l-.056-.025a9.272 9.272 0 0 1-.58-.287l-.042-.022-.12-.064a9.64 9.64 0 0 1-.325-.19 10.318 10.318 0 0 1-.62-.41 10.976 10.976 0 0 1-.429-.326l-.035-.029a6.304 6.304 0 0 1-.061-.05c-1.494-1.224-2.678-2.897-3.24-4.793-.59-1.968-.463-4.176.559-5.968L8.12 2.966z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M1.524 5.637C-.6 8.807-.336 12.932 1.287 16.3c.03.065.063.129.095.192l.024.048.03.059a2.987 2.987 0 0 0 .08.155l.013.025.07.13.015.027c.05.092.102.184.155.276l.017.03a9.464 9.464 0 0 0 .251.413l.018.03.059.093c.084.13.17.261.26.39v.001a.085.085 0 0 0 .007.009l.024.033.02.028c.078.11.157.22.238.328l.09.118a18.083 18.083 0 0 0 .608.746l.006.007.005.005.007.008a15.627 15.627 0 0 0 .658.697l.03.03.071.07a12.947 12.947 0 0 0 .346.326l.033.03.026.022a18.342 18.342 0 0 0 .38.33l.056.047c.085.07.171.14.258.208l.137.109c.096.073.192.145.289.215l.016.012.09.066.028.02c.088.064.177.124.267.184l.014.01a5.661 5.661 0 0 1 .12.083 15.577 15.577 0 0 0 .507.319l.054.032a14.516 14.516 0 0 0 .459.26l.053.029.059.032c.059.032.117.064.177.095l.025.012.03.015.034.017c.02.01.041.02.062.032.124.061.248.121.374.18l.047.021.032.015a13.238 13.238 0 0 0 .953.39l.01.003.042.016a13.91 13.91 0 0 0 .69.228c.116.039.233.077.353.1 10.277 1.946 13.262-6.41 13.262-6.41-2.507 3.39-6.957 4.285-11.174 3.289a5.368 5.368 0 0 1-.47-.137l-.118-.037c-.152-.048-.303-.1-.453-.153l-.062-.023c-.135-.05-.267-.1-.4-.154l-.112-.046c-.145-.06-.289-.121-.431-.186l-.046-.02a17.296 17.296 0 0 1-.404-.194l-.041-.022a5.56 5.56 0 0 1-.064-.031l-.214-.113-.068-.036a6.057 6.057 0 0 0-.067-.036l-.12-.066c-.114-.063-.226-.13-.338-.197l-.043-.025-.07-.04a16.203 16.203 0 0 1-.516-.332l-.043-.03a12.657 12.657 0 0 1-1.225-.929 15.269 15.269 0 0 1-.352-.307l-.016-.015a16.412 16.412 0 0 1-.448-.428 11.175 11.175 0 0 1-.25-.255l-.034-.034a13.54 13.54 0 0 1-.38-.414l-.006-.006-.002-.003c-.106-.12-.21-.244-.312-.368l-.082-.101a13.975 13.975 0 0 1-.307-.395c-.088-.12-.175-.238-.26-.359-2.34-3.314-3.181-7.886-1.31-11.64L1.524 5.637z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_950_626"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
JqueryFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$7 = [
    "color",
    "size"
];
var SassFill = function SassFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$7);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_950_625)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 0c6.6 0 12 5.4 12 12s-5.4 12-12 12S0 18.6 0 12 5.4 0 12 0zM9.6 15.975c.15.675.15 1.275 0 1.8L9.525 18c0 .075-.075.15-.075.15-.15.3-.3.525-.525.825-.675.75-1.65 1.05-2.1.825-.45-.225-.225-1.35.6-2.175.9-.9 2.1-1.5 2.1-1.5l.075-.15zM19.5 5.1c-.525-2.1-4.05-2.85-7.425-1.65-1.95.75-4.125 1.875-5.7 3.3-1.875 1.725-2.1 3.225-2.025 3.825C4.8 12.75 7.8 14.25 9.075 15.3 8.7 15.45 6 16.8 5.4 18.225c-.675 1.5.075 2.55.6 2.625 1.575.45 3.225-.375 4.05-1.65.825-1.275.75-2.85.375-3.675a3.532 3.532 0 0 1 1.8-.075c2.1.225 2.55 1.575 2.4 2.1-.15.525-.525.825-.675.975-.15.075-.225.15-.15.15 0 .075.075.075.225.075.15 0 1.125-.45 1.125-1.5.075-1.275-1.2-2.7-3.375-2.7-.9 0-1.5.075-1.875.225 0-.075-.075-.075-.075-.075-1.35-1.425-3.825-2.475-3.75-4.425 0-.675.3-2.55 4.8-4.8 3.675-1.875 6.675-1.35 7.2-.225.75 1.575-1.575 4.575-5.4 5.025-1.5.15-2.25-.375-2.4-.6-.225-.225-.225-.225-.3-.225-.15.075-.075.225 0 .375.15.3.6.825 1.425 1.125.675.225 2.4.375 4.5-.45 2.325-.9 4.125-3.375 3.6-5.475V5.1z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_950_625"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
SassFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$6 = [
    "color",
    "size"
];
var GatsbyFill = function GatsbyFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$6);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_950_624)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M12 0C5.323 0 0 5.317 0 12s5.317 12 12 12 12-5.323 12-12S18.683 0 12 0zM2.608 12.101l9.29 9.286c-5.114.005-9.29-4.171-9.29-9.286zm11.477 9.083L2.821 9.909C3.76 5.733 7.515 2.603 12 2.603a9.493 9.493 0 0 1 7.616 3.861l-1.355 1.147A7.666 7.666 0 0 0 11.9 4.267 7.57 7.57 0 0 0 4.693 9.38l9.814 9.819c2.4-.837 4.277-2.923 4.8-5.43h-4.07V12h6.155c0 4.485-3.13 8.245-7.307 9.184z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_950_624"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
GatsbyFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$5 = [
    "color",
    "size"
];
var NpmFill = function NpmFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$5);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_950_637)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 0H0v24h24V0zM2.578 2.578H21.42V21.42H16.67V7.33h-4.752V21.42h-9.34V2.578z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_950_637"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
NpmFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$4 = [
    "color",
    "size"
];
var YarnFill = function YarnFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$4);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_950_623)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.994 11.675C23.825 5.23 18.561.013 12.004 0 5.21-.005-.3 5.668.013 12.556c.28 6.216 5.344 11.296 11.71 11.441 6.81.157 12.449-5.4 12.271-12.322zM7.92 7.525c-.145.28-.258.575-.336.879-.025.018-.02.05-.032.073 0 .05 0 .1-.014.147v.328c.017.05.012.1.017.15.029.065-.019.146.054.198.088.3.187.594.347.861.05.084.042.129-.031.194-.381.349-.723.734-.987 1.183-.472.802-.648 1.679-.648 2.6a.323.323 0 0 1-.016.104.275.275 0 0 1-.062.105c-.609.667-.936 1.427-.786 2.348.076.467.212.91.49 1.298a.395.395 0 0 1 .089.273c-.018.404.144.732.488.939.58.351 1.207.477 1.875.328a.735.735 0 0 0 .133-.052c.068-.032.137-.063.198-.053.068.01.128.063.189.115.035.03.07.06.107.084.381.228.809.286 1.238.267 1.044-.044 2.085-.107 3.121-.252.342-.047.67-.133.95-.343a.64.64 0 0 1 .198-.1c1.049-.346 2.052-.798 2.967-1.406.555-.364 1.137-.662 1.794-.808.359-.078.62-.315.78-.648.408-.844-.217-1.79-1.19-1.799-.658-.005-1.263.2-1.843.49a8.696 8.696 0 0 0-.615.352c-.19.115-.38.231-.579.333l-.029.017c-.04.024-.083.049-.136.046v-.1c.052-1.395-.401-2.607-1.328-3.646-.056-.062-.046-.102-.005-.162a6.753 6.753 0 0 0 .831-1.6c.344-.973.413-1.972.308-2.987-.05-.489-.15-.966-.356-1.417-.18-.385-.515-.567-.93-.474-.111.023-.149-.01-.194-.102a4.747 4.747 0 0 0-.468-.817.886.886 0 0 0-.685-.36c-.444-.025-.75.216-1.008.539-.194.243-.34.519-.458.805-.036.087-.08.136-.15.162a.382.382 0 0 1-.094.02 3.28 3.28 0 0 0-2.014.97 1.34 1.34 0 0 1-.543.349c-.293.097-.496.299-.637.57z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M14.947 15.813c0 .242-.056.478-.086.713-.026.207-.005.231.205.195.472-.082.9-.28 1.311-.515.441-.251.861-.537 1.332-.726a3.013 3.013 0 0 1 1.134-.243c.343 0 .582.186.624.48.04.272-.11.533-.384.59-.781.166-1.456.551-2.113.98-.882.569-1.842.98-2.841 1.295-.037.01-.085.019-.108.041-.236.25-.548.292-.863.333-.884.116-1.773.168-2.665.22a3.049 3.049 0 0 1-.77-.026c-.41-.08-.583-.233-.645-.57-.056-.301.086-.587.388-.784l.116-.073a1.306 1.306 0 0 1-.398-.364c-.05-.069-.076-.026-.092.031l-.15.57c-.034.126-.076.25-.129.37-.152.348-.43.516-.797.55a1.976 1.976 0 0 1-1.065-.215c-.23-.113-.299-.283-.223-.533.04-.134.116-.25.207-.391-.317.063-.456-.121-.566-.344a2.374 2.374 0 0 1-.231-1.54c.081-.424.33-.77.63-1.069.175-.175.228-.344.223-.59-.04-1.425.498-2.595 1.605-3.499.097-.081.195-.165.297-.239.063-.044.07-.073.018-.138-.286-.36-.509-.75-.61-1.204-.117-.511.057-.955.314-1.38.037-.057.094-.086.158-.11.323-.116.595-.291.842-.538.555-.555 1.243-.81 2.03-.776.1.005.144-.024.175-.118.117-.344.264-.675.461-.98a1.26 1.26 0 0 1 .26-.31c.194-.16.36-.137.49.076.242.386.428.8.616 1.215.048.105.084.142.194.07a2.03 2.03 0 0 1 .417-.189c.116-.04.184-.013.234.108.147.354.226.724.27 1.104.013.105.037.207.024.312-.008.228.003.457.005.688 0 .102-.036.205-.005.309-.023.624-.189 1.214-.43 1.786-.225.535-.553 1.01-.881 1.485-.129.183-.126.186.042.336.818.737 1.27 1.663 1.42 2.743.006.042.004.087.004.131-.034.1.003.197.005.294.009.148-.025.296 0 .44z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_950_623"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
YarnFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$3 = [
    "color",
    "size"
];
var DjangoFill = function DjangoFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$3);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.172 0h-4.176v5.932c-.623-.15-1.14-.2-1.816-.2C4.816 5.731 2 8.305 2 12.273c0 4.118 2.655 6.263 7.755 6.268 1.703 0 3.278-.15 5.417-.53V0zM9.734 8.977c.516 0 .92.05 1.408.2v6.248c-.596.075-.972.1-1.434.1-2.14 0-3.305-1.142-3.305-3.21 0-2.125 1.22-3.338 3.331-3.338z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22 15.233V6.215h-4.17v7.675c0 3.387-.188 4.674-.785 5.786-.57 1.087-1.462 1.8-3.305 2.606L17.615 24c1.843-.862 2.735-1.643 3.412-2.88.726-1.288.973-2.782.973-5.887z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M21.584 0H17.41v3.993h4.175V0z"
    }));
};
DjangoFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$2 = [
    "color",
    "size"
];
var VscodeFill = function VscodeFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$2);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_950_639)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M.228 8.37s-.584-.427.117-.995L1.98 5.897s.467-.497.962-.064l15.081 11.542v5.534s-.007.87-1.11.774L.227 8.369z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M4.116 11.937L.228 15.509s-.4.3 0 .837l1.805 1.66s.429.465 1.062-.065l4.121-3.158-3.1-2.846z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M10.94 11.966l7.13-5.502-.047-5.505s-.305-1.202-1.32-.576L7.216 9.11l3.724 2.856z"
    }), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M16.912 23.69c.414.428.916.288.916.288l5.556-2.767c.711-.49.611-1.098.611-1.098V3.588c0-.726-.735-.977-.735-.977L18.444.264c-1.052-.657-1.741.119-1.741.119s.886-.645 1.32.576v21.85c0 .15-.032.297-.095.43-.127.259-.402.5-1.062.4l.046.051z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_950_639"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
VscodeFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded$1 = [
    "color",
    "size"
];
var TypescriptFill = function TypescriptFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded$1);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("g", {
        clipPath: "url(#clip0_2147_271)"
    }, /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M23.429 0H.57A.571.571 0 0 0 0 .571V23.43c0 .315.255.571.571.571H23.43a.571.571 0 0 0 .571-.571V.57A.571.571 0 0 0 23.429 0zm-9.143 12.826h-2.857v8.888H9.143v-8.888H6.286v-1.969h8v1.969zm.64 8.38v-2.375s1.298.978 2.855.978 1.497-1.018 1.497-1.158c0-1.477-4.412-1.477-4.412-4.751 0-4.452 6.429-2.695 6.429-2.695l-.08 2.116s-1.078-.719-2.296-.719c-1.218 0-1.657.58-1.657 1.198 0 1.597 4.452 1.438 4.452 4.652 0 4.95-6.788 2.755-6.788 2.755z"
    })), /*#__PURE__*/ React__default["default"].createElement("defs", null, /*#__PURE__*/ React__default["default"].createElement("clipPath", {
        id: "clip0_2147_271"
    }, /*#__PURE__*/ React__default["default"].createElement("rect", {
        width: "24",
        height: "24"
    }))));
};
TypescriptFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
var _excluded = [
    "color",
    "size"
];
var GitlabFill = function GitlabFill(_ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '24' : _ref$size, otherProps = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ React__default["default"].createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color
    }, otherProps), /*#__PURE__*/ React__default["default"].createElement("path", {
        d: "M22.749 9.769l-.031-.08-3.027-7.9a.788.788 0 0 0-.782-.495.81.81 0 0 0-.456.17.81.81 0 0 0-.268.408L16.14 8.125H7.865L5.822 1.872a.794.794 0 0 0-.269-.409.81.81 0 0 0-.926-.05c-.14.09-.25.22-.312.376L1.283 9.684l-.03.08a5.62 5.62 0 0 0 1.864 6.496l.01.008.028.02 4.61 3.453 2.282 1.726 1.39 1.049a.935.935 0 0 0 1.13 0l1.389-1.05 2.281-1.726 4.639-3.473.011-.01A5.623 5.623 0 0 0 22.75 9.77z"
    }));
};
GitlabFill.propTypes = {
    color: PropTypes__default["default"].string,
    size: PropTypes__default["default"].oneOfType([
        PropTypes__default["default"].string,
        PropTypes__default["default"].number
    ])
};
exports.Air = Air;
exports.AirplayAudio = AirplayAudio;
exports.AirplayVideo = AirplayVideo;
exports.Airpods = Airpods;
exports.Alarm = Alarm;
exports.AlignBottom = AlignBottom;
exports.AlignHorizontalCenter = AlignHorizontalCenter;
exports.AlignLeft = AlignLeft;
exports.AlignRight = AlignRight;
exports.AlignToBottom = AlignToBottom;
exports.AlignToMiddle = AlignToMiddle;
exports.AlignToTop = AlignToTop;
exports.AlignTop = AlignTop;
exports.AlignVerticalCenter = AlignVerticalCenter;
exports.AndroidFill = AndroidFill;
exports.AngularFill = AngularFill;
exports.ArrowBack = ArrowBack;
exports.ArrowBackThick = ArrowBackThick;
exports.ArrowBackThickFill = ArrowBackThickFill;
exports.ArrowClockwise = ArrowClockwise;
exports.ArrowCounterClockwise = ArrowCounterClockwise;
exports.ArrowCycle = ArrowCycle;
exports.ArrowDown = ArrowDown;
exports.ArrowDownLeft = ArrowDownLeft;
exports.ArrowDownRight = ArrowDownRight;
exports.ArrowDownThick = ArrowDownThick;
exports.ArrowForward = ArrowForward;
exports.ArrowForwardThick = ArrowForwardThick;
exports.ArrowForwardThickFill = ArrowForwardThickFill;
exports.ArrowLeft = ArrowLeft;
exports.ArrowLeftThick = ArrowLeftThick;
exports.ArrowRepeat = ArrowRepeat;
exports.ArrowRight = ArrowRight;
exports.ArrowRightLeft = ArrowRightLeft;
exports.ArrowRightThick = ArrowRightThick;
exports.ArrowShuffle = ArrowShuffle;
exports.ArrowUp = ArrowUp;
exports.ArrowUpDown = ArrowUpDown;
exports.ArrowUpLeft = ArrowUpLeft;
exports.ArrowUpRight = ArrowUpRight;
exports.ArrowUpThick = ArrowUpThick;
exports.Ascending = Ascending;
exports.Attach = Attach;
exports.AugmentedReality = AugmentedReality;
exports.Backspace = Backspace;
exports.BackspaceFill = BackspaceFill;
exports.Bank = Bank;
exports.Basket = Basket;
exports.BatteryCharging = BatteryCharging;
exports.BatteryEmpty = BatteryEmpty;
exports.BatteryFull = BatteryFull;
exports.BatteryLow = BatteryLow;
exports.BatteryMedium = BatteryMedium;
exports.BehanceFill = BehanceFill;
exports.Bell = Bell;
exports.Bicycle = Bicycle;
exports.BitcoinFill = BitcoinFill;
exports.Block = Block;
exports.Bluetooth = Bluetooth;
exports.Boat = Boat;
exports.BookClose = BookClose;
exports.BookOpen = BookOpen;
exports.BootstrapFill = BootstrapFill;
exports.Box = Box;
exports.Briefcase = Briefcase;
exports.Bug = Bug;
exports.Cake = Cake;
exports.Calculator = Calculator;
exports.Calendar = Calendar;
exports.Camera = Camera;
exports.Cart = Cart;
exports.ChatAdd = ChatAdd;
exports.ChatApprove = ChatApprove;
exports.ChatBubble = ChatBubble;
exports.ChatDots = ChatDots;
exports.ChatEdit = ChatEdit;
exports.ChatError = ChatError;
exports.ChatQuestion = ChatQuestion;
exports.ChatRemove = ChatRemove;
exports.Check = Check;
exports.CheckBox = CheckBox;
exports.CheckBoxFill = CheckBoxFill;
exports.CheckIn = CheckIn;
exports.Chess = Chess;
exports.ChevronDown = ChevronDown;
exports.ChevronDownSmall = ChevronDownSmall;
exports.ChevronHorizontal = ChevronHorizontal;
exports.ChevronLeft = ChevronLeft;
exports.ChevronLeftSmall = ChevronLeftSmall;
exports.ChevronRight = ChevronRight;
exports.ChevronRightSmall = ChevronRightSmall;
exports.ChevronUp = ChevronUp;
exports.ChevronUpSmall = ChevronUpSmall;
exports.ChevronVertical = ChevronVertical;
exports.Circle = Circle;
exports.CircleAlert = CircleAlert;
exports.CircleAlertFill = CircleAlertFill;
exports.CircleCheck = CircleCheck;
exports.CircleCheckFill = CircleCheckFill;
exports.CircleChevronDown = CircleChevronDown;
exports.CircleChevronDownFill = CircleChevronDownFill;
exports.CircleChevronLeft = CircleChevronLeft;
exports.CircleChevronLeftFill = CircleChevronLeftFill;
exports.CircleChevronRight = CircleChevronRight;
exports.CircleChevronRightFill = CircleChevronRightFill;
exports.CircleChevronUp = CircleChevronUp;
exports.CircleChevronUpFill = CircleChevronUpFill;
exports.CircleFill = CircleFill;
exports.CircleMinus = CircleMinus;
exports.CircleMinusFill = CircleMinusFill;
exports.CirclePlus = CirclePlus;
exports.CirclePlusFill = CirclePlusFill;
exports.CircleTriangleDown = CircleTriangleDown;
exports.CircleTriangleDownFill = CircleTriangleDownFill;
exports.CircleTriangleLeft = CircleTriangleLeft;
exports.CircleTriangleLeftFill = CircleTriangleLeftFill;
exports.CircleTriangleRight = CircleTriangleRight;
exports.CircleTriangleRightFill = CircleTriangleRightFill;
exports.CircleTriangleUp = CircleTriangleUp;
exports.CircleTriangleUpFill = CircleTriangleUpFill;
exports.CircleX = CircleX;
exports.CircleXFill = CircleXFill;
exports.Clipboard = Clipboard;
exports.Clock = Clock;
exports.Cloud = Cloud;
exports.CloudDownload = CloudDownload;
exports.CloudUpload = CloudUpload;
exports.CodepenFill = CodepenFill;
exports.Coffee = Coffee;
exports.Coin = Coin;
exports.Command = Command;
exports.Computing = Computing;
exports.Copy = Copy;
exports.CreditCard = CreditCard;
exports.CreditCardAlt1 = CreditCardAlt1;
exports.Cross = Cross;
exports.Crown = Crown;
exports.CssFill = CssFill;
exports.Cursor = Cursor;
exports.Cut = Cut;
exports.Dashboard = Dashboard;
exports.Data = Data;
exports.Dental = Dental;
exports.Descending = Descending;
exports.DesktopDevice = DesktopDevice;
exports.Devices = Devices;
exports.Diamond = Diamond;
exports.Dice1 = Dice1;
exports.Dice2 = Dice2;
exports.Dice3 = Dice3;
exports.Dice4 = Dice4;
exports.Dice5 = Dice5;
exports.Dice6 = Dice6;
exports.DiscordFill = DiscordFill;
exports.DjangoFill = DjangoFill;
exports.Door = Door;
exports.DotGridFill = DotGridFill;
exports.DoubleCheck = DoubleCheck;
exports.DoubleSword = DoubleSword;
exports.Download = Download;
exports.Draft = Draft;
exports.DragHorizontalFill = DragHorizontalFill;
exports.DragVerticalFill = DragVerticalFill;
exports.DribbbleFill = DribbbleFill;
exports.DropboxFill = DropboxFill;
exports.Edit = Edit;
exports.Enlarge = Enlarge;
exports.Envelope = Envelope;
exports.Equal = Equal;
exports.EqualFill = EqualFill;
exports.EyeClosed = EyeClosed;
exports.EyeOpen = EyeOpen;
exports.EyeSlashed = EyeSlashed;
exports.FaceHappy = FaceHappy;
exports.FaceNeutral = FaceNeutral;
exports.FaceSad = FaceSad;
exports.FaceVeryHappy = FaceVeryHappy;
exports.FaceVerySad = FaceVerySad;
exports.FaceWink = FaceWink;
exports.FacebookFill = FacebookFill;
exports.FigmaFill = FigmaFill;
exports.File = File;
exports.Filter = Filter;
exports.Fire = Fire;
exports.Flag = Flag;
exports.Flashlight = Flashlight;
exports.Folder = Folder;
exports.FolderAdd = FolderAdd;
exports.ForkLeft = ForkLeft;
exports.ForkRight = ForkRight;
exports.Frame = Frame;
exports.FullScreen = FullScreen;
exports.GameController = GameController;
exports.GatsbyFill = GatsbyFill;
exports.Gear = Gear;
exports.Gift = Gift;
exports.GithubFill = GithubFill;
exports.GitlabFill = GitlabFill;
exports.Glasses = Glasses;
exports.Globe = Globe;
exports.GoogleContainedFill = GoogleContainedFill;
exports.GoogleFill = GoogleFill;
exports.GraphqlFill = GraphqlFill;
exports.Grid = Grid;
exports.Hammer = Hammer;
exports.Hand = Hand;
exports.Hashtag = Hashtag;
exports.Headphone = Headphone;
exports.Health = Health;
exports.Heart = Heart;
exports.Height = Height;
exports.Heptagon = Heptagon;
exports.HeptagonFill = HeptagonFill;
exports.Hexagon = Hexagon;
exports.HexagonFill = HexagonFill;
exports.History = History;
exports.Home = Home;
exports.HomeAlt1 = HomeAlt1;
exports.HtmlFill = HtmlFill;
exports.Image = Image;
exports.Inbox = Inbox;
exports.Infinite = Infinite;
exports.Info = Info;
exports.InfoFill = InfoFill;
exports.InstagramFill = InstagramFill;
exports.Jar = Jar;
exports.JavascriptFill = JavascriptFill;
exports.JqueryFill = JqueryFill;
exports.Key = Key;
exports.KeyCap = KeyCap;
exports.Language = Language;
exports.LaptopDevice = LaptopDevice;
exports.Leaf = Leaf;
exports.Lifesaver = Lifesaver;
exports.LightBulb = LightBulb;
exports.LinkChain = LinkChain;
exports.LinkOff = LinkOff;
exports.LinkOn = LinkOn;
exports.LinkOut = LinkOut;
exports.LinkedinBoxFill = LinkedinBoxFill;
exports.LinkedinFill = LinkedinFill;
exports.Location = Location;
exports.LockOff = LockOff;
exports.LockOn = LockOn;
exports.Map = Map;
exports.MastodonFill = MastodonFill;
exports.MediumFill = MediumFill;
exports.Mention = Mention;
exports.Microphone = Microphone;
exports.Miniplayer = Miniplayer;
exports.Minus = Minus;
exports.MobileDevice = MobileDevice;
exports.Money = Money;
exports.Moon = Moon;
exports.MoonFill = MoonFill;
exports.MoreHorizontalFill = MoreHorizontalFill;
exports.MoreVerticalFill = MoreVerticalFill;
exports.Music = Music;
exports.MusicAlbum = MusicAlbum;
exports.MusicAlbumFill = MusicAlbumFill;
exports.MusicNote = MusicNote;
exports.Network = Network;
exports.Newspaper = Newspaper;
exports.NextjsFill = NextjsFill;
exports.NodeFill = NodeFill;
exports.NormalScreen = NormalScreen;
exports.NpmFill = NpmFill;
exports.Octagon = Octagon;
exports.OctagonFill = OctagonFill;
exports.OctocatFill = OctocatFill;
exports.OpenEnvelope = OpenEnvelope;
exports.Oval = Oval;
exports.PanelBottom = PanelBottom;
exports.PanelLeft = PanelLeft;
exports.PanelRight = PanelRight;
exports.PanelSplit = PanelSplit;
exports.PanelSplitColumn = PanelSplitColumn;
exports.PanelSplitRow = PanelSplitRow;
exports.PanelTop = PanelTop;
exports.Paper = Paper;
exports.PaperAirplane = PaperAirplane;
exports.Parallelogram = Parallelogram;
exports.Pause = Pause;
exports.Pencil = Pencil;
exports.Pentagon = Pentagon;
exports.PentagonFill = PentagonFill;
exports.PeopleGroup = PeopleGroup;
exports.PeopleMultiple = PeopleMultiple;
exports.Percentage = Percentage;
exports.Person = Person;
exports.PersonAdd = PersonAdd;
exports.PersonCheck = PersonCheck;
exports.PersonCross = PersonCross;
exports.Phone = Phone;
exports.PhpFill = PhpFill;
exports.Pin = Pin;
exports.PinterestFill = PinterestFill;
exports.Plane = Plane;
exports.PlaneFill = PlaneFill;
exports.Planet = Planet;
exports.Plant = Plant;
exports.Play = Play;
exports.Plus = Plus;
exports.PointerDownFill = PointerDownFill;
exports.PointerHand = PointerHand;
exports.PointerLeftFill = PointerLeftFill;
exports.PointerRightFill = PointerRightFill;
exports.PointerUpFill = PointerUpFill;
exports.PointingUp = PointingUp;
exports.PostgresqlFill = PostgresqlFill;
exports.PriceCut = PriceCut;
exports.ProductHuntFill = ProductHuntFill;
exports.PythonFill = PythonFill;
exports.Question = Question;
exports.QuestionFill = QuestionFill;
exports.Radio = Radio;
exports.RadioFill = RadioFill;
exports.Radish = Radish;
exports.ReactFill = ReactFill;
exports.Receipt = Receipt;
exports.RedditFill = RedditFill;
exports.Reduce = Reduce;
exports.ReduxFill = ReduxFill;
exports.Ribbon = Ribbon;
exports.RockOn = RockOn;
exports.Rss = Rss;
exports.SassFill = SassFill;
exports.Save = Save;
exports.Schedule = Schedule;
exports.Scissor = Scissor;
exports.Search = Search;
exports.Send = Send;
exports.SettingsHorizontal = SettingsHorizontal;
exports.SettingsVertical = SettingsVertical;
exports.ShareBox = ShareBox;
exports.Shield = Shield;
exports.ShippingBoxV1 = ShippingBoxV1;
exports.ShippingBoxV2 = ShippingBoxV2;
exports.ShoppingBag = ShoppingBag;
exports.SignOut = SignOut;
exports.SlackFill = SlackFill;
exports.Slice = Slice;
exports.SnapchatFill = SnapchatFill;
exports.Sort = Sort;
exports.SoundDown = SoundDown;
exports.SoundOff = SoundOff;
exports.SoundOn = SoundOn;
exports.SoundUp = SoundUp;
exports.SoundcloudFill = SoundcloudFill;
exports.Sparkles = Sparkles;
exports.SpotifyFill = SpotifyFill;
exports.Square = Square;
exports.SquareFill = SquareFill;
exports.StackOverflowFill = StackOverflowFill;
exports.Star = Star;
exports.StatisticDown = StatisticDown;
exports.StatisticUp = StatisticUp;
exports.Stop = Stop;
exports.StopFill = StopFill;
exports.Sun = Sun;
exports.SunFill = SunFill;
exports.Sword = Sword;
exports.TabletDevice = TabletDevice;
exports.Tag = Tag;
exports.TelegramFill = TelegramFill;
exports.Telescope = Telescope;
exports.Tetragon = Tetragon;
exports.TetragonFill = TetragonFill;
exports.TextAlignCenter = TextAlignCenter;
exports.TextAlignJustified = TextAlignJustified;
exports.TextAlignLeft = TextAlignLeft;
exports.TextAlignRight = TextAlignRight;
exports.ThreadsFill = ThreadsFill;
exports.ThreeLineHorizontal = ThreeLineHorizontal;
exports.ThreeLineVertical = ThreeLineVertical;
exports.ThumbsDown = ThumbsDown;
exports.ThumbsUp = ThumbsUp;
exports.Thunder = Thunder;
exports.Ticket = Ticket;
exports.TiktokFill = TiktokFill;
exports.ToggleOff = ToggleOff;
exports.ToggleOffFill = ToggleOffFill;
exports.ToggleOn = ToggleOn;
exports.ToggleOnFill = ToggleOnFill;
exports.TogoCup = TogoCup;
exports.TrashBin = TrashBin;
exports.TrashCan = TrashCan;
exports.Triangle = Triangle;
exports.TriangleAlert = TriangleAlert;
exports.TriangleAlertFill = TriangleAlertFill;
exports.TriangleDown = TriangleDown;
exports.TriangleDownFill = TriangleDownFill;
exports.TriangleFill = TriangleFill;
exports.TriangleLeft = TriangleLeft;
exports.TriangleLeftFill = TriangleLeftFill;
exports.TriangleRight = TriangleRight;
exports.TriangleRightFill = TriangleRightFill;
exports.TriangleUp = TriangleUp;
exports.TriangleUpFill = TriangleUpFill;
exports.Trophy = Trophy;
exports.Truck = Truck;
exports.TumblrFill = TumblrFill;
exports.TwitchFill = TwitchFill;
exports.TwitterFill = TwitterFill;
exports.TwoLineHorizontal = TwoLineHorizontal;
exports.TwoLineVertical = TwoLineVertical;
exports.TypescriptFill = TypescriptFill;
exports.Umbrella = Umbrella;
exports.UnsplashFill = UnsplashFill;
exports.Utensils = Utensils;
exports.VapeKit = VapeKit;
exports.VercelFill = VercelFill;
exports.VictoryHand = VictoryHand;
exports.Video = Video;
exports.VimeoFill = VimeoFill;
exports.VkFill = VkFill;
exports.VrAr = VrAr;
exports.VscodeFill = VscodeFill;
exports.VueFill = VueFill;
exports.Wallet = Wallet;
exports.WatchDevice = WatchDevice;
exports.Water = Water;
exports.WhatsappFill = WhatsappFill;
exports.Width = Width;
exports.Wifi = Wifi;
exports.WineGlass = WineGlass;
exports.XFill = XFill;
exports.XSmall = XSmall;
exports.YarnFill = YarnFill;
exports.YelpFill = YelpFill;
exports.YoutubeFill = YoutubeFill;
exports.ZoomFill = ZoomFill;
exports.ZoomIn = ZoomIn;
exports.ZoomOut = ZoomOut;

},{"2328eaf961e3276f":"6wC8C","7ccc74630ac05605":"6YTRF"}],"6YTRF":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"8e6Ix"}],"8e6Ix":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"5Lb6h"}],"5Lb6h":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"iTkkf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@tippyjs/react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const TipMessage = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default), {
        visible: props.visible,
        placement: "right",
        animation: false,
        popperOptions: {
            modifiers: [
                {
                    name: "flip",
                    options: {
                        fallbackPlacements: [
                            "top",
                            "bottom"
                        ]
                    }
                }
            ]
        },
        content: props.content,
        children: props.children
    });
};
exports.default = TipMessage;

},{"react/jsx-runtime":"i3K7E","@tippyjs/react":"hmQMl","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hmQMl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tippy", ()=>(0, _tippyJsDefault.default));
parcelHelpers.export(exports, "useSingleton", ()=>useSingleton);
var _tippyJs = require("tippy.js");
var _tippyJsDefault = parcelHelpers.interopDefault(_tippyJs);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
function preserveRef(ref, node) {
    if (ref) {
        if (typeof ref === 'function') ref(node);
        if (({}).hasOwnProperty.call(ref, 'current')) ref.current = node;
    }
}
function ssrSafeCreateDiv() {
    return isBrowser && document.createElement('div');
}
function toDataAttributes(attrs) {
    var dataAttrs = {
        'data-placement': attrs.placement
    };
    if (attrs.referenceHidden) dataAttrs['data-reference-hidden'] = '';
    if (attrs.escaped) dataAttrs['data-escaped'] = '';
    return dataAttrs;
}
function deepEqual(x, y) {
    if (x === y) return true;
    else if (typeof x === 'object' && x != null && typeof y === 'object' && y != null) {
        if (Object.keys(x).length !== Object.keys(y).length) return false;
        for(var prop in x){
            if (y.hasOwnProperty(prop)) {
                if (!deepEqual(x[prop], y[prop])) return false;
            } else return false;
        }
        return true;
    } else return false;
}
function uniqueByShape(arr) {
    var output = [];
    arr.forEach(function(item) {
        if (!output.find(function(outputItem) {
            return deepEqual(item, outputItem);
        })) output.push(item);
    });
    return output;
}
function deepPreserveProps(instanceProps, componentProps) {
    var _instanceProps$popper, _componentProps$poppe;
    return Object.assign({}, componentProps, {
        popperOptions: Object.assign({}, instanceProps.popperOptions, componentProps.popperOptions, {
            modifiers: uniqueByShape([].concat(((_instanceProps$popper = instanceProps.popperOptions) == null ? void 0 : _instanceProps$popper.modifiers) || [], ((_componentProps$poppe = componentProps.popperOptions) == null ? void 0 : _componentProps$poppe.modifiers) || []))
        })
    });
}
var useIsomorphicLayoutEffect = isBrowser ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
function useMutableBox(initialValue) {
    // Using refs instead of state as it's recommended to not store imperative
    // values in state due to memory problems in React(?)
    var ref = (0, _react.useRef)();
    if (!ref.current) ref.current = typeof initialValue === 'function' ? initialValue() : initialValue;
    return ref.current;
}
function updateClassName(box, action, classNames) {
    classNames.split(/\s+/).forEach(function(name) {
        if (name) box.classList[action](name);
    });
}
var classNamePlugin = {
    name: 'className',
    defaultValue: '',
    fn: function fn(instance) {
        var box = instance.popper.firstElementChild;
        var isDefaultRenderFn = function isDefaultRenderFn() {
            var _instance$props$rende;
            return !!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy);
        };
        function add() {
            if (instance.props.className && !isDefaultRenderFn()) return;
            updateClassName(box, 'add', instance.props.className);
        }
        function remove() {
            if (isDefaultRenderFn()) updateClassName(box, 'remove', instance.props.className);
        }
        return {
            onCreate: add,
            onBeforeUpdate: remove,
            onAfterUpdate: add
        };
    }
};
function TippyGenerator(tippy) {
    function Tippy(_ref) {
        var children = _ref.children, content = _ref.content, visible = _ref.visible, singleton = _ref.singleton, render = _ref.render, reference = _ref.reference, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$ignoreAttributes = _ref.ignoreAttributes, ignoreAttributes = _ref$ignoreAttributes === void 0 ? true : _ref$ignoreAttributes, __source = _ref.__source, __self = _ref.__self, restOfNativeProps = _objectWithoutPropertiesLoose(_ref, [
            "children",
            "content",
            "visible",
            "singleton",
            "render",
            "reference",
            "disabled",
            "ignoreAttributes",
            "__source",
            "__self"
        ]);
        var isControlledMode = visible !== undefined;
        var isSingletonMode = singleton !== undefined;
        var _useState = (0, _react.useState)(false), mounted = _useState[0], setMounted = _useState[1];
        var _useState2 = (0, _react.useState)({}), attrs = _useState2[0], setAttrs = _useState2[1];
        var _useState3 = (0, _react.useState)(), singletonContent = _useState3[0], setSingletonContent = _useState3[1];
        var mutableBox = useMutableBox(function() {
            return {
                container: ssrSafeCreateDiv(),
                renders: 1
            };
        });
        var props = Object.assign({
            ignoreAttributes: ignoreAttributes
        }, restOfNativeProps, {
            content: mutableBox.container
        });
        if (isControlledMode) {
            props.trigger = 'manual';
            props.hideOnClick = false;
        }
        if (isSingletonMode) disabled = true;
        var computedProps = props;
        var plugins = props.plugins || [];
        if (render) computedProps = Object.assign({}, props, {
            plugins: isSingletonMode && singleton.data != null ? [].concat(plugins, [
                {
                    fn: function fn() {
                        return {
                            onTrigger: function onTrigger(instance, event) {
                                var node = singleton.data.children.find(function(_ref2) {
                                    var instance = _ref2.instance;
                                    return instance.reference === event.currentTarget;
                                });
                                instance.state.$$activeSingletonInstance = node.instance;
                                setSingletonContent(node.content);
                            }
                        };
                    }
                }
            ]) : plugins,
            render: function render() {
                return {
                    popper: mutableBox.container
                };
            }
        });
        var deps = [
            reference
        ].concat(children ? [
            children.type
        ] : []); // CREATE
        useIsomorphicLayoutEffect(function() {
            var element = reference;
            if (reference && reference.hasOwnProperty('current')) element = reference.current;
            var instance = tippy(element || mutableBox.ref || ssrSafeCreateDiv(), Object.assign({}, computedProps, {
                plugins: [
                    classNamePlugin
                ].concat(props.plugins || [])
            }));
            mutableBox.instance = instance;
            if (disabled) instance.disable();
            if (visible) instance.show();
            if (isSingletonMode) singleton.hook({
                instance: instance,
                content: content,
                props: computedProps,
                setSingletonContent: setSingletonContent
            });
            setMounted(true);
            return function() {
                instance.destroy();
                singleton == null || singleton.cleanup(instance);
            };
        }, deps); // UPDATE
        useIsomorphicLayoutEffect(function() {
            var _instance$popperInsta;
            // Prevent this effect from running on 1st render
            if (mutableBox.renders === 1) {
                mutableBox.renders++;
                return;
            }
            var instance = mutableBox.instance;
            instance.setProps(deepPreserveProps(instance.props, computedProps)); // Fixes #264
            (_instance$popperInsta = instance.popperInstance) == null || _instance$popperInsta.forceUpdate();
            if (disabled) instance.disable();
            else instance.enable();
            if (isControlledMode) {
                if (visible) instance.show();
                else instance.hide();
            }
            if (isSingletonMode) singleton.hook({
                instance: instance,
                content: content,
                props: computedProps,
                setSingletonContent: setSingletonContent
            });
        });
        useIsomorphicLayoutEffect(function() {
            var _instance$props$poppe;
            if (!render) return;
            var instance = mutableBox.instance;
            instance.setProps({
                popperOptions: Object.assign({}, instance.props.popperOptions, {
                    modifiers: [].concat((((_instance$props$poppe = instance.props.popperOptions) == null ? void 0 : _instance$props$poppe.modifiers) || []).filter(function(_ref3) {
                        var name = _ref3.name;
                        return name !== '$$tippyReact';
                    }), [
                        {
                            name: '$$tippyReact',
                            enabled: true,
                            phase: 'beforeWrite',
                            requires: [
                                'computeStyles'
                            ],
                            fn: function fn(_ref4) {
                                var _state$modifiersData;
                                var state = _ref4.state;
                                var hideData = (_state$modifiersData = state.modifiersData) == null ? void 0 : _state$modifiersData.hide; // WARNING: this is a high-risk path that can cause an infinite
                                // loop. This expression _must_ evaluate to false when required
                                if (attrs.placement !== state.placement || attrs.referenceHidden !== (hideData == null ? void 0 : hideData.isReferenceHidden) || attrs.escaped !== (hideData == null ? void 0 : hideData.hasPopperEscaped)) setAttrs({
                                    placement: state.placement,
                                    referenceHidden: hideData == null ? void 0 : hideData.isReferenceHidden,
                                    escaped: hideData == null ? void 0 : hideData.hasPopperEscaped
                                });
                                state.attributes.popper = {};
                            }
                        }
                    ])
                })
            });
        }, [
            attrs.placement,
            attrs.referenceHidden,
            attrs.escaped
        ].concat(deps));
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children ? /*#__PURE__*/ (0, _react.cloneElement)(children, {
            ref: function ref(node) {
                mutableBox.ref = node;
                preserveRef(children.ref, node);
            }
        }) : null, mounted && /*#__PURE__*/ (0, _reactDom.createPortal)(render ? render(toDataAttributes(attrs), singletonContent, mutableBox.instance) : content, mutableBox.container));
    }
    return Tippy;
}
function useSingletonGenerator(createSingleton) {
    return function useSingleton(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$overrides = _ref.overrides, overrides = _ref$overrides === void 0 ? [] : _ref$overrides;
        var _useState = (0, _react.useState)(false), mounted = _useState[0], setMounted = _useState[1];
        var mutableBox = useMutableBox({
            children: [],
            renders: 1
        });
        useIsomorphicLayoutEffect(function() {
            if (!mounted) {
                setMounted(true);
                return;
            }
            var children = mutableBox.children, sourceData = mutableBox.sourceData;
            if (!sourceData) return;
            var instance = createSingleton(children.map(function(child) {
                return child.instance;
            }), Object.assign({}, sourceData.props, {
                popperOptions: sourceData.instance.props.popperOptions,
                overrides: overrides,
                plugins: [
                    classNamePlugin
                ].concat(sourceData.props.plugins || [])
            }));
            mutableBox.instance = instance;
            if (disabled) instance.disable();
            return function() {
                instance.destroy();
                mutableBox.children = children.filter(function(_ref2) {
                    var instance = _ref2.instance;
                    return !instance.state.isDestroyed;
                });
            };
        }, [
            mounted
        ]);
        useIsomorphicLayoutEffect(function() {
            if (!mounted) return;
            if (mutableBox.renders === 1) {
                mutableBox.renders++;
                return;
            }
            var children = mutableBox.children, instance = mutableBox.instance, sourceData = mutableBox.sourceData;
            if (!(instance && sourceData)) return;
            var _sourceData$props = sourceData.props, content = _sourceData$props.content, props = _objectWithoutPropertiesLoose(_sourceData$props, [
                "content"
            ]);
            instance.setProps(deepPreserveProps(instance.props, Object.assign({}, props, {
                overrides: overrides
            })));
            instance.setInstances(children.map(function(child) {
                return child.instance;
            }));
            if (disabled) instance.disable();
            else instance.enable();
        });
        return (0, _react.useMemo)(function() {
            var source = {
                data: mutableBox,
                hook: function hook(data) {
                    mutableBox.sourceData = data;
                    mutableBox.setSingletonContent = data.setSingletonContent;
                },
                cleanup: function cleanup() {
                    mutableBox.sourceData = null;
                }
            };
            var target = {
                hook: function hook(data) {
                    var _mutableBox$instance, _mutableBox$instance2;
                    mutableBox.children = mutableBox.children.filter(function(_ref3) {
                        var instance = _ref3.instance;
                        return data.instance !== instance;
                    });
                    mutableBox.children.push(data);
                    if (((_mutableBox$instance = mutableBox.instance) == null ? void 0 : _mutableBox$instance.state.isMounted) && ((_mutableBox$instance2 = mutableBox.instance) == null ? void 0 : _mutableBox$instance2.state.$$activeSingletonInstance) === data.instance) mutableBox.setSingletonContent == null || mutableBox.setSingletonContent(data.content);
                    if (mutableBox.instance && !mutableBox.instance.state.isDestroyed) mutableBox.instance.setInstances(mutableBox.children.map(function(child) {
                        return child.instance;
                    }));
                },
                cleanup: function cleanup(instance) {
                    mutableBox.children = mutableBox.children.filter(function(data) {
                        return data.instance !== instance;
                    });
                    if (mutableBox.instance && !mutableBox.instance.state.isDestroyed) mutableBox.instance.setInstances(mutableBox.children.map(function(child) {
                        return child.instance;
                    }));
                }
            };
            return [
                source,
                target
            ];
        }, []);
    };
}
var forwardRef = function(Tippy, defaultProps) {
    return /*#__PURE__*/ (0, _react.forwardRef)(function TippyWrapper(_ref, _ref2) {
        var children = _ref.children, props = _objectWithoutPropertiesLoose(_ref, [
            "children"
        ]);
        return(/*#__PURE__*/ // If I spread them separately here, Babel adds the _extends ponyfill for
        // some reason
        (0, _reactDefault.default).createElement(Tippy, Object.assign({}, defaultProps, props), children ? /*#__PURE__*/ (0, _react.cloneElement)(children, {
            ref: function ref(node) {
                preserveRef(_ref2, node);
                preserveRef(children.ref, node);
            }
        }) : null));
    });
};
var useSingleton = /*#__PURE__*/ useSingletonGenerator((0, _tippyJs.createSingleton));
var index = /*#__PURE__*/ forwardRef(/*#__PURE__*/ TippyGenerator((0, _tippyJsDefault.default)));
exports.default = index;

},{"tippy.js":"c1ome","react":"6wC8C","react-dom":"7k58v","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"c1ome":[function(require,module,exports,__globalThis) {
/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateFill", ()=>animateFill);
parcelHelpers.export(exports, "createSingleton", ()=>createSingleton);
parcelHelpers.export(exports, "delegate", ()=>delegate);
parcelHelpers.export(exports, "followCursor", ()=>followCursor);
parcelHelpers.export(exports, "hideAll", ()=>hideAll);
parcelHelpers.export(exports, "inlinePositioning", ()=>inlinePositioning);
parcelHelpers.export(exports, "roundArrow", ()=>ROUND_ARROW);
parcelHelpers.export(exports, "sticky", ()=>sticky);
var _core = require("@popperjs/core");
var ROUND_ARROW = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var BOX_CLASS = "tippy-box";
var CONTENT_CLASS = "tippy-content";
var BACKDROP_CLASS = "tippy-backdrop";
var ARROW_CLASS = "tippy-arrow";
var SVG_ARROW_CLASS = "tippy-svg-arrow";
var TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function normalizeToArray(value) {
    return [].concat(value);
}
function pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function getBasePlacement(placement) {
    return placement.split('-')[0];
}
function arrayFrom(value) {
    return [].slice.call(value);
}
function removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function div() {
    return document.createElement('div');
}
function isElement(value) {
    return [
        'Element',
        'Fragment'
    ].some(function(type) {
        return isType(value, type);
    });
}
function isNodeList(value) {
    return isType(value, 'NodeList');
}
function isMouseEvent(value) {
    return isType(value, 'MouseEvent');
}
function isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function getArrayOfElements(value) {
    if (isElement(value)) return [
        value
    ];
    if (isNodeList(value)) return arrayFrom(value);
    if (Array.isArray(value)) return value;
    return arrayFrom(document.querySelectorAll(value));
}
function setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute('data-state', state);
    });
}
function getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
        var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        'transitionend',
        'webkitTransitionEnd'
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var currentInput = {
    isTouch: false
};
var lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function onDocumentTouchStart() {
    if (currentInput.isTouch) return;
    currentInput.isTouch = true;
    if (window.performance) document.addEventListener('mousemove', onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function onDocumentMouseMove() {
    var now = performance.now();
    if (now - lastMouseMoveTime < 20) {
        currentInput.isTouch = false;
        document.removeEventListener('mousemove', onDocumentMouseMove);
    }
    lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function onWindowBlur() {
    var activeElement = document.activeElement;
    if (isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function bindGlobalEventListeners() {
    document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
    window.addEventListener('blur', onWindowBlur);
}
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var isIE11 = isBrowser ? !!window.msCrypto : false;
function createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        'indicates a potential memory leak.'
    ].join(' ');
}
function clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}
function getDevMessage(message) {
    return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function getFormattedMessage(message) {
    return [
        getDevMessage(message),
        'color: #00C584; font-size: 1.3em; font-weight: bold;',
        'line-height: 1.5',
        'color: #a6a095;'
    ];
} // Assume warnings and errors never have the same message
var visitedMessages;
function resetVisitedMessages() {
    visitedMessages = new Set();
}
function warnWhen(condition, message) {
    if (condition && !visitedMessages.has(message)) {
        var _console;
        visitedMessages.add(message);
        (_console = console).warn.apply(_console, getFormattedMessage(message));
    }
}
function errorWhen(condition, message) {
    if (condition && !visitedMessages.has(message)) {
        var _console2;
        visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, getFormattedMessage(message));
    }
}
function validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    errorWhen(didPassFalsyValue, [
        'tippy() was passed',
        '`' + String(targets) + '`',
        'as its targets (first) argument. Valid types are: String, Element,',
        'Element[], or NodeList.'
    ].join(' '));
    errorWhen(didPassPlainObject, [
        'tippy() was passed a plain object which is not supported as an argument',
        'for virtual positioning. Use props.getReferenceClientRect instead.'
    ].join(' '));
}
var pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
};
var defaultProps = Object.assign({
    appendTo: TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: 'auto',
        expanded: 'auto'
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
}, pluginProps, renderProps);
var defaultKeys = Object.keys(defaultProps);
var setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        defaultProps[key] = partialProps[key];
    });
};
function getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
        plugins: plugins
    }))) : defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
        if (!valueAsString) return acc;
        if (key === 'content') acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
        content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
}
function validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
        var didPassUnknownProp = !hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'
        ].join(' '));
    });
}
var innerHTML = function innerHTML() {
    return 'innerHTML';
};
function dangerouslySetInnerHTML(element, html) {
    element[innerHTML()] = html;
}
function createArrowElement(value) {
    var arrow = div();
    if (value === true) arrow.className = ARROW_CLASS;
    else {
        arrow.className = SVG_ARROW_CLASS;
        if (isElement(value)) arrow.appendChild(value);
        else dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function setContent(content, props) {
    if (isElement(props.content)) {
        dangerouslySetInnerHTML(content, '');
        content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
        if (props.allowHTML) dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains(CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains(BACKDROP_CLASS);
        })
    };
}
function render(instance) {
    var popper = div();
    var box = div();
    box.className = BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = div();
    content.className = CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute('data-theme', nextProps.theme);
        else box.removeAttribute('data-theme');
        if (typeof nextProps.animation === 'string') box.setAttribute('data-animation', nextProps.animation);
        else box.removeAttribute('data-animation');
        if (nextProps.inertia) box.setAttribute('data-inertia', '');
        else box.removeAttribute('data-inertia');
        box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute('role', nextProps.role);
        else box.removeAttribute('role');
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild(createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild(createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
render.$$tippy = true;
var idCounter = 1;
var mouseMoveListeners = []; // Used by `hideAll()`
var mountedInstances = [];
function createTippy(reference, passedProps) {
    var props = evaluateProps(reference, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = idCounter++;
    var popperInstance = null;
    var plugins = unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener('mouseenter', function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener('mouseleave', function() {
        if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === 'hold';
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') return 0;
        return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, '').trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
            else node.removeAttribute('aria-expanded');
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
        mouseMoveListeners = mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if (currentInput.isTouch) {
            if (didTouchMove || event.type === 'mousedown') return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if (normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return actualContains(el, actualTarget);
        })) {
            if (currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) return;
        } else invokeHook('onClickOutside', [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener('mousedown', onDocumentPress, true);
        doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
        doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
        doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener('mousedown', onDocumentPress, true);
        doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
        doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
        doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                updateTransitionEndListener(box, 'remove', listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
        updateTransitionEndListener(box, 'add', listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on('touchstart', onTrigger, {
                passive: true
            });
            on('touchend', onMouseLeave, {
                passive: true
            });
        }
        splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === 'manual') return;
            on(eventType, onTrigger);
            switch(eventType){
                case 'mouseenter':
                    on('mouseleave', onMouseLeave);
                    break;
                case 'focus':
                    on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
                    break;
                case 'focusin':
                    on('focusout', onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === 'click') isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: '$$tippy',
            enabled: true,
            phase: 'beforeWrite',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        'placement',
                        'reference-hidden',
                        'escaped'
                    ].forEach(function(attr) {
                        if (attr === 'placement') box.setAttribute('data-placement', state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, '');
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: 'offset',
                options: {
                    offset: offset
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: 'flip',
                options: {
                    padding: 5
                }
            },
            {
                name: 'computeStyles',
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: 'arrow',
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, _core.createPopper)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') parentNode = node.parentNode;
        else parentNode = invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook('onTrigger', [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if (currentInput.isTouch && touchValue === 'hold' && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook('onUntrigger', [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && [
            'mouseleave',
            'mousemove'
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook('onBeforeUpdate', [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = evaluateProps(reference, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute('aria-expanded');
        });
        else if (nextProps.triggerTarget) reference.removeAttribute('aria-expanded');
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook('onAfterUpdate', [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
        var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute('disabled')) return;
        invokeHook('onShow', [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'visible';
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = 'none';
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                setTransitionDuration([
                    _box,
                    _content
                ], duration);
                setVisibilityState([
                    _box,
                    _content
                ], 'visible');
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook('onMount', [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook('onShown', [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook('onHide', [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'hidden';
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                setTransitionDuration([
                    box,
                    content
                ], duration);
                setVisibilityState([
                    box,
                    content
                ], 'hidden');
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        mountedInstances = mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook('onHidden', [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook('onDestroy', [
            instance
        ]);
    }
}
function tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
    bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return isElement(targets) ? instances[0] : instances;
}
tippy.defaultProps = defaultProps;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;
var hideAll = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var applyStylesModifier = Object.assign({}, (0, _core.applyStyles), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var createSingleton = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat('content').reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = tippy(div(), Object.assign({}, removeProperties(optionalProps, [
        'overrides'
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === 'number') return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var BUBBLING_EVENTS_MAP = {
    mouseover: 'mouseenter',
    focusin: 'focus',
    click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function delegate(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = removeProperties(props, [
        'target'
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: 'manual',
        touch: false
    });
    var childProps = Object.assign({
        touch: defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = tippy(targets, parentProps);
    var normalizedReturnValue = normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') return;
        if (event.type !== 'touchstart' && trigger.indexOf(BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, 'touchstart', onTrigger, TOUCH_OPTIONS);
        on(reference, 'mouseover', onTrigger);
        on(reference, 'focusin', onTrigger);
        on(reference, 'click', onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var animateFill = {
    name: 'animateFill',
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute('data-animatefill', '');
                    box.style.overflow = 'hidden';
                    instance.setProps({
                        arrow: false,
                        animation: 'shift-away'
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    setVisibilityState([
                        backdrop
                    ], 'visible');
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = '0ms';
            },
            onHide: function onHide() {
                if (backdrop) setVisibilityState([
                    backdrop
                ], 'hidden');
            }
        };
    }
};
function createBackdropElement() {
    var backdrop = div();
    backdrop.className = BACKDROP_CLASS;
    setVisibilityState([
        backdrop
    ], 'hidden');
    return backdrop;
}
var mouseCoords = {
    clientX: 0,
    clientY: 0
};
var activeInstances = [];
function storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function addMouseCoordsListener(doc) {
    doc.addEventListener('mousemove', storeMouseCoords);
}
function removeMouseCoordsListener(doc) {
    doc.removeEventListener('mousemove', storeMouseCoords);
}
var followCursor = {
    name: 'followCursor',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === 'initial' && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener('mousemove', onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener('mousemove', onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === 'initial') {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === 'horizontal' ? rect.top : y;
                    var right = followCursor === 'vertical' ? rect.right : x;
                    var bottom = followCursor === 'horizontal' ? rect.bottom : y;
                    var left = followCursor === 'vertical' ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            activeInstances = activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if (activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove(mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if (isMouseEvent(event)) mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === 'focus';
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var inlinePositioning = {
    name: 'inlinePositioning',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: 'tippyInlinePositioning',
            enabled: true,
            phase: 'afterWrite',
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return getInlineBoundingClientRect(getBasePlacement(placement), reference.getBoundingClientRect(), arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps(getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if (isMouseEvent(event)) {
                    var rects = arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case 'top':
        case 'bottom':
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === 'top';
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case 'left':
        case 'right':
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var sticky = {
    name: 'sticky',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
            if (currentRefRect && areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
tippy.setDefaultProps({
    render: render
});
exports.default = tippy;

},{"@popperjs/core":"6K23B","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6K23B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
parcelHelpers.export(exports, "createPopperBase", ()=>(0, _createPopperJs.createPopper));
parcelHelpers.export(exports, "createPopper", ()=>(0, _popperJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper));
var _enumsJs = require("./enums.js");
parcelHelpers.exportAll(_enumsJs, exports);
var _indexJs = require("./modifiers/index.js"); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.exportAll(_indexJs, exports);
var _createPopperJs = require("./createPopper.js");
var _popperJs = require("./popper.js");
var _popperLiteJs = require("./popper-lite.js");

},{"./enums.js":false,"./modifiers/index.js":"kYKbc","./createPopper.js":false,"./popper.js":"2UiG1","./popper-lite.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7Bkmf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "top", ()=>top);
parcelHelpers.export(exports, "bottom", ()=>bottom);
parcelHelpers.export(exports, "right", ()=>right);
parcelHelpers.export(exports, "left", ()=>left);
parcelHelpers.export(exports, "auto", ()=>auto);
parcelHelpers.export(exports, "basePlacements", ()=>basePlacements);
parcelHelpers.export(exports, "start", ()=>start);
parcelHelpers.export(exports, "end", ()=>end);
parcelHelpers.export(exports, "clippingParents", ()=>clippingParents);
parcelHelpers.export(exports, "viewport", ()=>viewport);
parcelHelpers.export(exports, "popper", ()=>popper);
parcelHelpers.export(exports, "reference", ()=>reference);
parcelHelpers.export(exports, "variationPlacements", ()=>variationPlacements);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "beforeRead", ()=>beforeRead);
parcelHelpers.export(exports, "read", ()=>read);
parcelHelpers.export(exports, "afterRead", ()=>afterRead);
parcelHelpers.export(exports, "beforeMain", ()=>beforeMain);
parcelHelpers.export(exports, "main", ()=>main);
parcelHelpers.export(exports, "afterMain", ()=>afterMain);
parcelHelpers.export(exports, "beforeWrite", ()=>beforeWrite);
parcelHelpers.export(exports, "write", ()=>write);
parcelHelpers.export(exports, "afterWrite", ()=>afterWrite);
parcelHelpers.export(exports, "modifierPhases", ()=>modifierPhases);
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [
    top,
    bottom,
    right,
    left
];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []);
var placements = /*#__PURE__*/ [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []); // modifiers that need to read the DOM
var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers
var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kYKbc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyStyles", ()=>(0, _applyStylesJsDefault.default));
parcelHelpers.export(exports, "arrow", ()=>(0, _arrowJsDefault.default));
parcelHelpers.export(exports, "computeStyles", ()=>(0, _computeStylesJsDefault.default));
parcelHelpers.export(exports, "eventListeners", ()=>(0, _eventListenersJsDefault.default));
parcelHelpers.export(exports, "flip", ()=>(0, _flipJsDefault.default));
parcelHelpers.export(exports, "hide", ()=>(0, _hideJsDefault.default));
parcelHelpers.export(exports, "offset", ()=>(0, _offsetJsDefault.default));
parcelHelpers.export(exports, "popperOffsets", ()=>(0, _popperOffsetsJsDefault.default));
parcelHelpers.export(exports, "preventOverflow", ()=>(0, _preventOverflowJsDefault.default));
var _applyStylesJs = require("./applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _arrowJs = require("./arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _computeStylesJs = require("./computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _eventListenersJs = require("./eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _flipJs = require("./flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _hideJs = require("./hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _offsetJs = require("./offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _popperOffsetsJs = require("./popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _preventOverflowJs = require("./preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);

},{"./applyStyles.js":"PcOf9","./arrow.js":false,"./computeStyles.js":false,"./eventListeners.js":false,"./flip.js":false,"./hide.js":false,"./offset.js":false,"./popperOffsets.js":false,"./preventOverflow.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"PcOf9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNodeNameJs = require("../dom-utils/getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("../dom-utils/instanceOf.js"); // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow
function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: applyStyles,
    effect: effect,
    requires: [
        'computeStyles'
    ]
};

},{"../dom-utils/getNodeName.js":"cJ8CL","../dom-utils/instanceOf.js":"eTJIP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"cJ8CL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeName);
function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"eTJIP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function isElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, _getWindowJsDefault.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

},{"./getWindow.js":"jNJJN","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"jNJJN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindow);
function getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"dA1Jf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _containsJs = require("../dom-utils/contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _withinJs = require("../utils/within.js");
var _mergePaddingObjectJs = require("../utils/mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("../utils/expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
};
function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var axis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var isVertical = [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = (0, _getLayoutRectJsDefault.default)(arrowElement);
    var minProp = axis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
    var maxProp = axis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, _getOffsetParentJsDefault.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, _withinJs.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, _containsJsDefault.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

},{"../utils/getBasePlacement.js":"1zwgy","../dom-utils/getLayoutRect.js":"4c3wj","../dom-utils/contains.js":"kQkFm","../dom-utils/getOffsetParent.js":"2YbOZ","../utils/getMainAxisFromPlacement.js":"fX5ih","../utils/within.js":"7fTva","../utils/mergePaddingObject.js":"3enf3","../utils/expandToHashMap.js":"hVlpH","../enums.js":"7Bkmf","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"1zwgy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBasePlacement);
var _enumsJs = require("../enums.js");
function getBasePlacement(placement) {
    return placement.split('-')[0];
}

},{"../enums.js":"7Bkmf","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4c3wj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getLayoutRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js"); // Returns the layout rect of an element relative to its offsetParent. Layout
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
function getLayoutRect(element) {
    var clientRect = (0, _getBoundingClientRectJsDefault.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

},{"./getBoundingClientRect.js":"047KY","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"047KY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBoundingClientRect);
var _instanceOfJs = require("./instanceOf.js");
var _mathJs = require("../utils/math.js");
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, _instanceOfJs.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, _mathJs.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, _mathJs.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, _instanceOfJs.isElement)(element) ? (0, _getWindowJsDefault.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, _isLayoutViewportJsDefault.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

},{"./instanceOf.js":"eTJIP","../utils/math.js":"jmZCY","./getWindow.js":"jNJJN","./isLayoutViewport.js":"fKSDY","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"jmZCY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "round", ()=>round);
var max = Math.max;
var min = Math.min;
var round = Math.round;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fKSDY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isLayoutViewport);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test((0, _userAgentJsDefault.default)());
}

},{"../utils/userAgent.js":"fgAET","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fgAET":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUAString);
function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kQkFm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
var _instanceOfJs = require("./instanceOf.js");
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, _instanceOfJs.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

},{"./instanceOf.js":"eTJIP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2YbOZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOffsetParent);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _isTableElementJs = require("./isTableElement.js");
var _isTableElementJsDefault = parcelHelpers.interopDefault(_isTableElementJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function getTrueOffsetParent(element) {
    if (!(0, _instanceOfJs.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, _getComputedStyleJsDefault.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, _userAgentJsDefault.default)());
    var isIE = /Trident/i.test((0, _userAgentJsDefault.default)());
    if (isIE && (0, _instanceOfJs.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, _getComputedStyleJsDefault.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, _getParentNodeJsDefault.default)(element);
    if ((0, _instanceOfJs.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, _instanceOfJs.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, _getNodeNameJsDefault.default)(currentNode)) < 0){
        var css = (0, _getComputedStyleJsDefault.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function getOffsetParent(element) {
    var window = (0, _getWindowJsDefault.default)(element);
    var offsetParent = getTrueOffsetParent(element);
    while(offsetParent && (0, _isTableElementJsDefault.default)(offsetParent) && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')offsetParent = getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, _getNodeNameJsDefault.default)(offsetParent) === 'html' || (0, _getNodeNameJsDefault.default)(offsetParent) === 'body' && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')) return window;
    return offsetParent || getContainingBlock(element) || window;
}

},{"./getWindow.js":"jNJJN","./getNodeName.js":"cJ8CL","./getComputedStyle.js":"h2fM7","./instanceOf.js":"eTJIP","./isTableElement.js":"6tS3O","./getParentNode.js":"5PXD0","../utils/userAgent.js":"fgAET","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"h2fM7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getComputedStyle);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getComputedStyle(element) {
    return (0, _getWindowJsDefault.default)(element).getComputedStyle(element);
}

},{"./getWindow.js":"jNJJN","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6tS3O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isTableElement);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
function isTableElement(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, _getNodeNameJsDefault.default)(element)) >= 0;
}

},{"./getNodeName.js":"cJ8CL","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5PXD0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getParentNode);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _instanceOfJs = require("./instanceOf.js");
function getParentNode(element) {
    if ((0, _getNodeNameJsDefault.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, _instanceOfJs.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, _getDocumentElementJsDefault.default)(element) // fallback
    );
}

},{"./getNodeName.js":"cJ8CL","./getDocumentElement.js":"jAloG","./instanceOf.js":"eTJIP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"jAloG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentElement);
var _instanceOfJs = require("./instanceOf.js");
function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, _instanceOfJs.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

},{"./instanceOf.js":"eTJIP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fX5ih":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMainAxisFromPlacement);
function getMainAxisFromPlacement(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7fTva":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "within", ()=>within);
parcelHelpers.export(exports, "withinMaxClamp", ()=>withinMaxClamp);
var _mathJs = require("./math.js");
function within(min, value, max) {
    return (0, _mathJs.max)(min, (0, _mathJs.min)(value, max));
}
function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
}

},{"./math.js":"jmZCY","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3enf3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergePaddingObject);
var _getFreshSideObjectJs = require("./getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
function mergePaddingObject(paddingObject) {
    return Object.assign({}, (0, _getFreshSideObjectJsDefault.default)(), paddingObject);
}

},{"./getFreshSideObject.js":"eACJT","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"eACJT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getFreshSideObject);
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hVlpH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>expandToHashMap);
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5LIiR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapToStyles", ()=>mapToStyles);
var _enumsJs = require("../enums.js");
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getWindowJs = require("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("../dom-utils/getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _mathJs = require("../utils/math.js"); // eslint-disable-next-line import/no-unused-modules
var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, _mathJs.round)(x * dpr) / dpr || 0,
        y: (0, _mathJs.round)(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, _enumsJs.left);
    var sideY = (0, _enumsJs.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, _getOffsetParentJsDefault.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, _getWindowJsDefault.default)(popper)) {
            offsetParent = (0, _getDocumentElementJsDefault.default)(popper);
            if ((0, _getComputedStyleJsDefault.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, _enumsJs.top) || (placement === (0, _enumsJs.left) || placement === (0, _enumsJs.right)) && variation === (0, _enumsJs.end)) {
            sideY = (0, _enumsJs.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, _enumsJs.left) || (placement === (0, _enumsJs.top) || placement === (0, _enumsJs.bottom)) && variation === (0, _enumsJs.end)) {
            sideX = (0, _enumsJs.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, _getWindowJsDefault.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, _getBasePlacementJsDefault.default)(state.placement),
        variation: (0, _getVariationJsDefault.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
};

},{"../enums.js":"7Bkmf","../dom-utils/getOffsetParent.js":"2YbOZ","../dom-utils/getWindow.js":"jNJJN","../dom-utils/getDocumentElement.js":"jAloG","../dom-utils/getComputedStyle.js":"h2fM7","../utils/getBasePlacement.js":"1zwgy","../utils/getVariation.js":"b1HKb","../utils/math.js":"jmZCY","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"b1HKb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getVariation);
function getVariation(placement) {
    return placement.split('-')[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fgYJA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getWindowJs = require("../dom-utils/getWindow.js"); // eslint-disable-next-line import/no-unused-modules
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var passive = {
    passive: true
};
function effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, _getWindowJsDefault.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
    });
    if (resize) window.addEventListener('resize', instance.update, passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, passive);
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
};

},{"../dom-utils/getWindow.js":"jNJJN","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"dlF8S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getOppositePlacementJs = require("../utils/getOppositePlacement.js");
var _getOppositePlacementJsDefault = parcelHelpers.interopDefault(_getOppositePlacementJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getOppositeVariationPlacementJs = require("../utils/getOppositeVariationPlacement.js");
var _getOppositeVariationPlacementJsDefault = parcelHelpers.interopDefault(_getOppositeVariationPlacementJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _computeAutoPlacementJs = require("../utils/computeAutoPlacement.js");
var _computeAutoPlacementJsDefault = parcelHelpers.interopDefault(_computeAutoPlacementJs);
var _enumsJs = require("../enums.js");
var _getVariationJs = require("../utils/getVariation.js"); // eslint-disable-next-line import/no-unused-modules
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
function getExpandedFallbackPlacements(placement) {
    if ((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto)) return [];
    var oppositePlacement = (0, _getOppositePlacementJsDefault.default)(placement);
    return [
        (0, _getOppositeVariationPlacementJsDefault.default)(placement),
        oppositePlacement,
        (0, _getOppositeVariationPlacementJsDefault.default)(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, _getOppositePlacementJsDefault.default)(preferredPlacement)
    ] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto) ? (0, _computeAutoPlacementJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
        var isStartVariation = (0, _getVariationJsDefault.default)(placement) === (0, _enumsJs.start);
        var isVertical = [
            (0, _enumsJs.top),
            (0, _enumsJs.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, _enumsJs.right) : (0, _enumsJs.left) : isStartVariation ? (0, _enumsJs.bottom) : (0, _enumsJs.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var altVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

},{"../utils/getOppositePlacement.js":"a4neE","../utils/getBasePlacement.js":"1zwgy","../utils/getOppositeVariationPlacement.js":"9vjm0","../utils/detectOverflow.js":"jyype","../utils/computeAutoPlacement.js":"8keoO","../enums.js":"7Bkmf","../utils/getVariation.js":"b1HKb","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"a4neE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositePlacement);
var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9vjm0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositeVariationPlacement);
var hash = {
    start: 'end',
    end: 'start'
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"jyype":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>detectOverflow);
var _getClippingRectJs = require("../dom-utils/getClippingRect.js");
var _getClippingRectJsDefault = parcelHelpers.interopDefault(_getClippingRectJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getBoundingClientRectJs = require("../dom-utils/getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _computeOffsetsJs = require("./computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
var _rectToClientRectJs = require("./rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _enumsJs = require("../enums.js");
var _instanceOfJs = require("../dom-utils/instanceOf.js");
var _mergePaddingObjectJs = require("./mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("./expandToHashMap.js"); // eslint-disable-next-line import/no-unused-modules
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
function detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, _enumsJs.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, _enumsJs.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, _enumsJs.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
    var altContext = elementContext === (0, _enumsJs.popper) ? (0, _enumsJs.reference) : (0, _enumsJs.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, _getClippingRectJsDefault.default)((0, _instanceOfJs.isElement)(element) ? element : element.contextElement || (0, _getDocumentElementJsDefault.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, _getBoundingClientRectJsDefault.default)(state.elements.reference);
    var popperOffsets = (0, _computeOffsetsJsDefault.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, _rectToClientRectJsDefault.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, _enumsJs.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, _enumsJs.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, _enumsJs.right),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, _enumsJs.top),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

},{"../dom-utils/getClippingRect.js":"ap5pb","../dom-utils/getDocumentElement.js":"jAloG","../dom-utils/getBoundingClientRect.js":"047KY","./computeOffsets.js":"2apcB","./rectToClientRect.js":"jJmQZ","../enums.js":"7Bkmf","../dom-utils/instanceOf.js":"eTJIP","./mergePaddingObject.js":"3enf3","./expandToHashMap.js":"hVlpH","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ap5pb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getClippingRect);
var _enumsJs = require("../enums.js");
var _getViewportRectJs = require("./getViewportRect.js");
var _getViewportRectJsDefault = parcelHelpers.interopDefault(_getViewportRectJs);
var _getDocumentRectJs = require("./getDocumentRect.js");
var _getDocumentRectJsDefault = parcelHelpers.interopDefault(_getDocumentRectJs);
var _listScrollParentsJs = require("./listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _rectToClientRectJs = require("../utils/rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _mathJs = require("../utils/math.js");
function getInnerBoundingClientRect(element, strategy) {
    var rect = (0, _getBoundingClientRectJsDefault.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, _enumsJs.viewport) ? (0, _rectToClientRectJsDefault.default)((0, _getViewportRectJsDefault.default)(element, strategy)) : (0, _instanceOfJs.isElement)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : (0, _rectToClientRectJsDefault.default)((0, _getDocumentRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element) {
    var clippingParents = (0, _listScrollParentsJsDefault.default)((0, _getParentNodeJsDefault.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, _getComputedStyleJsDefault.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, _instanceOfJs.isHTMLElement)(element) ? (0, _getOffsetParentJsDefault.default)(element) : element;
    if (!(0, _instanceOfJs.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, _instanceOfJs.isElement)(clippingParent) && (0, _containsJsDefault.default)(clippingParent, clipperElement) && (0, _getNodeNameJsDefault.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, _mathJs.max)(rect.top, accRect.top);
        accRect.right = (0, _mathJs.min)(rect.right, accRect.right);
        accRect.bottom = (0, _mathJs.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _mathJs.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

},{"../enums.js":"7Bkmf","./getViewportRect.js":"9x4kK","./getDocumentRect.js":"9U5i5","./listScrollParents.js":"467BI","./getOffsetParent.js":"2YbOZ","./getDocumentElement.js":"jAloG","./getComputedStyle.js":"h2fM7","./instanceOf.js":"eTJIP","./getBoundingClientRect.js":"047KY","./getParentNode.js":"5PXD0","./contains.js":"kQkFm","./getNodeName.js":"cJ8CL","../utils/rectToClientRect.js":"jJmQZ","../utils/math.js":"jmZCY","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9x4kK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getViewportRect);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getViewportRect(element, strategy) {
    var win = (0, _getWindowJsDefault.default)(element);
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, _isLayoutViewportJsDefault.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, _getWindowScrollBarXJsDefault.default)(element),
        y: y
    };
}

},{"./getWindow.js":"jNJJN","./getDocumentElement.js":"jAloG","./getWindowScrollBarX.js":"hTuU0","./isLayoutViewport.js":"fKSDY","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hTuU0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScrollBarX);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, _getBoundingClientRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)).left + (0, _getWindowScrollJsDefault.default)(element).scrollLeft;
}

},{"./getBoundingClientRect.js":"047KY","./getDocumentElement.js":"jAloG","./getWindowScroll.js":"iDmTO","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"iDmTO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScroll);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getWindowScroll(node) {
    var win = (0, _getWindowJsDefault.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

},{"./getWindow.js":"jNJJN","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9U5i5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentRect);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _mathJs = require("../utils/math.js"); // Gets the entire size of the scrollable document area, even extending outside
function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var winScroll = (0, _getWindowScrollJsDefault.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, _mathJs.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, _mathJs.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, _getWindowScrollBarXJsDefault.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, _getComputedStyleJsDefault.default)(body || html).direction === 'rtl') x += (0, _mathJs.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

},{"./getDocumentElement.js":"jAloG","./getComputedStyle.js":"h2fM7","./getWindowScrollBarX.js":"hTuU0","./getWindowScroll.js":"iDmTO","../utils/math.js":"jmZCY","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"467BI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>listScrollParents);
var _getScrollParentJs = require("./getScrollParent.js");
var _getScrollParentJsDefault = parcelHelpers.interopDefault(_getScrollParentJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, _getScrollParentJsDefault.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, _getWindowJsDefault.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, _isScrollParentJsDefault.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents((0, _getParentNodeJsDefault.default)(target)));
}

},{"./getScrollParent.js":"jwM8s","./getParentNode.js":"5PXD0","./getWindow.js":"jNJJN","./isScrollParent.js":"llwdi","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"jwM8s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollParent);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
function getScrollParent(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, _getNodeNameJsDefault.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, _instanceOfJs.isHTMLElement)(node) && (0, _isScrollParentJsDefault.default)(node)) return node;
    return getScrollParent((0, _getParentNodeJsDefault.default)(node));
}

},{"./getParentNode.js":"5PXD0","./isScrollParent.js":"llwdi","./getNodeName.js":"cJ8CL","./instanceOf.js":"eTJIP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"llwdi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isScrollParent);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, _getComputedStyleJsDefault.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

},{"./getComputedStyle.js":"h2fM7","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"jJmQZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rectToClientRect);
function rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2apcB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeOffsets);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getMainAxisFromPlacementJs = require("./getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _enumsJs = require("../enums.js");
function computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, _getBasePlacementJsDefault.default)(placement) : null;
    var variation = placement ? (0, _getVariationJsDefault.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, _enumsJs.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, _enumsJs.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, _enumsJs.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, _enumsJs.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, _enumsJs.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, _enumsJs.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

},{"./getBasePlacement.js":"1zwgy","./getVariation.js":"b1HKb","./getMainAxisFromPlacement.js":"fX5ih","../enums.js":"7Bkmf","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8keoO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeAutoPlacement);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("./detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
function computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, _enumsJs.placements) : _options$allowedAutoP;
    var variation = (0, _getVariationJsDefault.default)(placement);
    var placements = variation ? flipVariations ? (0, _enumsJs.variationPlacements) : (0, _enumsJs.variationPlacements).filter(function(placement) {
        return (0, _getVariationJsDefault.default)(placement) === variation;
    }) : (0, _enumsJs.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, _getBasePlacementJsDefault.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

},{"./getVariation.js":"b1HKb","../enums.js":"7Bkmf","./detectOverflow.js":"jyype","./getBasePlacement.js":"1zwgy","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"47qvM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        (0, _enumsJs.top),
        (0, _enumsJs.right),
        (0, _enumsJs.bottom),
        (0, _enumsJs.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, _detectOverflowJsDefault.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, _detectOverflowJsDefault.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: hide
};

},{"../enums.js":"7Bkmf","../utils/detectOverflow.js":"jyype","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"g8iqA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distanceAndSkiddingToXY", ()=>distanceAndSkiddingToXY);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
    var invertDistance = [
        (0, _enumsJs.left),
        (0, _enumsJs.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, _enumsJs.placements).reduce(function(acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: offset
};

},{"../utils/getBasePlacement.js":"1zwgy","../enums.js":"7Bkmf","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kuwfh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _computeOffsetsJs = require("../utils/computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, _computeOffsetsJsDefault.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
};

},{"../utils/computeOffsets.js":"2apcB","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8YqOK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _getAltAxisJs = require("../utils/getAltAxis.js");
var _getAltAxisJsDefault = parcelHelpers.interopDefault(_getAltAxisJs);
var _withinJs = require("../utils/within.js");
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getFreshSideObjectJs = require("../utils/getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
var _mathJs = require("../utils/math.js");
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, _detectOverflowJsDefault.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var variation = (0, _getVariationJsDefault.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var altAxis = (0, _getAltAxisJsDefault.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var altSide = mainAxis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, _enumsJs.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, _enumsJs.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, _getLayoutRectJsDefault.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, _getFreshSideObjectJsDefault.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, _withinJs.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, _getOffsetParentJsDefault.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, _withinJs.within)(tether ? (0, _mathJs.min)(min, tetherMin) : min, offset, tether ? (0, _mathJs.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var _altSide = mainAxis === 'x' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, _enumsJs.top),
            (0, _enumsJs.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, _withinJs.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, _withinJs.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

},{"../enums.js":"7Bkmf","../utils/getBasePlacement.js":"1zwgy","../utils/getMainAxisFromPlacement.js":"fX5ih","../utils/getAltAxis.js":"kuN9z","../utils/within.js":"7fTva","../dom-utils/getLayoutRect.js":"4c3wj","../dom-utils/getOffsetParent.js":"2YbOZ","../utils/detectOverflow.js":"jyype","../utils/getVariation.js":"b1HKb","../utils/getFreshSideObject.js":"eACJT","../utils/math.js":"jmZCY","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kuN9z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getAltAxis);
function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"qg2Nd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>popperGenerator);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _detectOverflowJsDefault.default));
var _getCompositeRectJs = require("./dom-utils/getCompositeRect.js");
var _getCompositeRectJsDefault = parcelHelpers.interopDefault(_getCompositeRectJs);
var _getLayoutRectJs = require("./dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _listScrollParentsJs = require("./dom-utils/listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _orderModifiersJs = require("./utils/orderModifiers.js");
var _orderModifiersJsDefault = parcelHelpers.interopDefault(_orderModifiersJs);
var _debounceJs = require("./utils/debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _mergeByNameJs = require("./utils/mergeByName.js");
var _mergeByNameJsDefault = parcelHelpers.interopDefault(_mergeByNameJs);
var _detectOverflowJs = require("./utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _instanceOfJs = require("./dom-utils/instanceOf.js");
var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, _instanceOfJs.isElement)(reference) ? (0, _listScrollParentsJsDefault.default)(reference) : reference.contextElement ? (0, _listScrollParentsJsDefault.default)(reference.contextElement) : [],
                    popper: (0, _listScrollParentsJsDefault.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, _orderModifiersJsDefault.default)((0, _mergeByNameJsDefault.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, _getCompositeRectJsDefault.default)(reference, (0, _getOffsetParentJsDefault.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, _getLayoutRectJsDefault.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, _debounceJsDefault.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var createPopper = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules

},{"./dom-utils/getCompositeRect.js":"beHMd","./dom-utils/getLayoutRect.js":"4c3wj","./dom-utils/listScrollParents.js":"467BI","./dom-utils/getOffsetParent.js":"2YbOZ","./utils/orderModifiers.js":"m9PcW","./utils/debounce.js":"d3RBd","./utils/mergeByName.js":"PtCjb","./utils/detectOverflow.js":false,"./dom-utils/instanceOf.js":"eTJIP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"beHMd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getCompositeRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getNodeScrollJs = require("./getNodeScroll.js");
var _getNodeScrollJsDefault = parcelHelpers.interopDefault(_getNodeScrollJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _mathJs = require("../utils/math.js");
function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, _mathJs.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, _mathJs.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, _instanceOfJs.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, _instanceOfJs.isHTMLElement)(offsetParent) && isElementScaled(offsetParent);
    var documentElement = (0, _getDocumentElementJsDefault.default)(offsetParent);
    var rect = (0, _getBoundingClientRectJsDefault.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _getNodeNameJsDefault.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, _isScrollParentJsDefault.default)(documentElement)) scroll = (0, _getNodeScrollJsDefault.default)(offsetParent);
        if ((0, _instanceOfJs.isHTMLElement)(offsetParent)) {
            offsets = (0, _getBoundingClientRectJsDefault.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, _getWindowScrollBarXJsDefault.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

},{"./getBoundingClientRect.js":"047KY","./getNodeScroll.js":"7DVhw","./getNodeName.js":"cJ8CL","./instanceOf.js":"eTJIP","./getWindowScrollBarX.js":"hTuU0","./getDocumentElement.js":"jAloG","./isScrollParent.js":"llwdi","../utils/math.js":"jmZCY","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7DVhw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeScroll);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _instanceOfJs = require("./instanceOf.js");
var _getHTMLElementScrollJs = require("./getHTMLElementScroll.js");
var _getHTMLElementScrollJsDefault = parcelHelpers.interopDefault(_getHTMLElementScrollJs);
function getNodeScroll(node) {
    if (node === (0, _getWindowJsDefault.default)(node) || !(0, _instanceOfJs.isHTMLElement)(node)) return (0, _getWindowScrollJsDefault.default)(node);
    else return (0, _getHTMLElementScrollJsDefault.default)(node);
}

},{"./getWindowScroll.js":"iDmTO","./getWindow.js":"jNJJN","./instanceOf.js":"eTJIP","./getHTMLElementScroll.js":"51vAo","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"51vAo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHTMLElementScroll);
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"m9PcW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>orderModifiers);
var _enumsJs = require("../enums.js"); // source: https://stackoverflow.com/questions/49875255
function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase
    return (0, _enumsJs.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

},{"../enums.js":"7Bkmf","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"d3RBd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>debounce);
function debounce(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"PtCjb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeByName);
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2UiG1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopper", ()=>createPopper) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator));
parcelHelpers.export(exports, "defaultModifiers", ()=>defaultModifiers);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
var _createPopperJs = require("./createPopper.js");
var _eventListenersJs = require("./modifiers/eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _popperOffsetsJs = require("./modifiers/popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _computeStylesJs = require("./modifiers/computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _applyStylesJs = require("./modifiers/applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _offsetJs = require("./modifiers/offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _flipJs = require("./modifiers/flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _preventOverflowJs = require("./modifiers/preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);
var _arrowJs = require("./modifiers/arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _hideJs = require("./modifiers/hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _popperLiteJs = require("./popper-lite.js");
var _indexJs = require("./modifiers/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var defaultModifiers = [
    (0, _eventListenersJsDefault.default),
    (0, _popperOffsetsJsDefault.default),
    (0, _computeStylesJsDefault.default),
    (0, _applyStylesJsDefault.default),
    (0, _offsetJsDefault.default),
    (0, _flipJsDefault.default),
    (0, _preventOverflowJsDefault.default),
    (0, _arrowJsDefault.default),
    (0, _hideJsDefault.default)
];
var createPopper = /*#__PURE__*/ (0, _createPopperJs.popperGenerator)({
    defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

},{"./createPopper.js":"qg2Nd","./modifiers/eventListeners.js":"fgYJA","./modifiers/popperOffsets.js":"kuwfh","./modifiers/computeStyles.js":"5LIiR","./modifiers/applyStyles.js":"PcOf9","./modifiers/offset.js":"g8iqA","./modifiers/flip.js":"dlF8S","./modifiers/preventOverflow.js":"8YqOK","./modifiers/arrow.js":"dA1Jf","./modifiers/hide.js":"47qvM","./popper-lite.js":false,"./modifiers/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5zfEN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reactRouterDom = require("react-router-dom");
var _confirmdialog = require("primereact/confirmdialog");
var _useStore = require("./useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
const useCustomNavigate = ()=>{
    // const setPathParts = useStore((state) => state.setPathParts);
    const hasUnsavedChanges = (0, _useStoreDefault.default)((state)=>state.hasUnsavedChanges);
    const setHasUnsavedChanges = (0, _useStoreDefault.default)((state)=>state.setHasUnsavedChanges);
    const navigate = (0, _reactRouterDom.useNavigate)();
    const doNavigate = (path)=>{
        setHasUnsavedChanges(false);
        // setPathParts(path?.split("/")?.filter(Boolean) || []);
        navigate(path);
    };
    // Intercept navigation with prompt
    const doCheck = (path)=>{
        // If there are no unsaved changes, navigate
        if (!hasUnsavedChanges) return doNavigate(path);
        (0, _confirmdialog.confirmDialog)({
            message: "You have unsaved changes. Are you sure you want to proceed?",
            accept: ()=>{
                doNavigate(path);
            },
            className: "confirm-dialog",
            acceptClassName: "button",
            rejectClassName: "button button__invert"
        });
    };
    return doCheck;
};
exports.default = useCustomNavigate;

},{"react-router-dom":"4I6p1","primereact/confirmdialog":"9Gq2y","./useStore":"l1Yj7","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9Gq2y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConfirmDialog", ()=>ConfirmDialog);
parcelHelpers.export(exports, "confirmDialog", ()=>confirmDialog);
var _react = require("react");
var _api = require("primereact/api");
var _button = require("primereact/button");
var _dialog = require("primereact/dialog");
var _hooks = require("primereact/hooks");
var _overlayservice = require("primereact/overlayservice");
var _portal = require("primereact/portal");
var _utils = require("primereact/utils");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var confirmDialog = function confirmDialog() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    props = _objectSpread(_objectSpread({}, props), {
        visible: props.visible === undefined ? true : props.visible
    });
    props.visible && (0, _overlayservice.OverlayService).emit('confirm-dialog', props);
    var show = function show() {
        var updatedProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, _overlayservice.OverlayService).emit('confirm-dialog', _objectSpread(_objectSpread(_objectSpread({}, props), updatedProps), {
            visible: true
        }));
    };
    var hide = function hide() {
        (0, _overlayservice.OverlayService).emit('confirm-dialog', {
            visible: false
        });
    };
    return {
        show: show,
        hide: hide
    };
};
var ConfirmDialog = /*#__PURE__*/ _react.memo(/*#__PURE__*/ _react.forwardRef(function(props, ref) {
    var _React$useState = _react.useState(props.visible), _React$useState2 = _slicedToArray(_React$useState, 2), visibleState = _React$useState2[0], setVisibleState = _React$useState2[1];
    var _React$useState3 = _react.useState(false), _React$useState4 = _slicedToArray(_React$useState3, 2), reshowState = _React$useState4[0], setReshowState = _React$useState4[1];
    var confirmProps = _react.useRef(null);
    var getCurrentProps = function getCurrentProps() {
        return confirmProps.current || props;
    };
    var getPropValue = function getPropValue(key) {
        return (confirmProps.current || props)[key];
    };
    var callbackFromProp = function callbackFromProp(key) {
        for(var _len = arguments.length, param = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)param[_key - 1] = arguments[_key];
        return (0, _utils.ObjectUtils).getPropValue(getPropValue(key), param);
    };
    var acceptLabel = getPropValue('acceptLabel') || (0, _api.localeOption)('accept');
    var rejectLabel = getPropValue('rejectLabel') || (0, _api.localeOption)('reject');
    var accept = function accept() {
        callbackFromProp('accept');
        hide('accept');
    };
    var reject = function reject() {
        callbackFromProp('reject');
        hide('reject');
    };
    var show = function show() {
        setVisibleState(true);
    };
    var hide = function hide() {
        var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cancel';
        setVisibleState(false);
        callbackFromProp('onHide', result);
    };
    var confirm = function confirm(updatedProps) {
        if (updatedProps.tagKey === props.tagKey) {
            var isVisibleChanged = visibleState !== updatedProps.visible;
            var targetChanged = getPropValue('target') !== updatedProps.target;
            if (targetChanged && !props.target) {
                hide();
                confirmProps.current = updatedProps;
                setReshowState(true);
            } else if (isVisibleChanged) {
                confirmProps.current = updatedProps;
                updatedProps.visible ? show() : hide();
            }
        }
    };
    _react.useEffect(function() {
        props.visible ? show() : hide();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.visible
    ]);
    _react.useEffect(function() {
        if (!props.target && !props.message) (0, _overlayservice.OverlayService).on('confirm-dialog', confirm);
        return function() {
            (0, _overlayservice.OverlayService).off('confirm-dialog', confirm);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.target
    ]);
    (0, _hooks.useUpdateEffect)(function() {
        reshowState && show();
    }, [
        reshowState
    ]);
    (0, _hooks.useUnmountEffect)(function() {
        (0, _overlayservice.OverlayService).off('confirm-dialog', confirm);
    });
    _react.useImperativeHandle(ref, function() {
        return {
            props: props,
            confirm: confirm
        };
    });
    var createFooter = function createFooter() {
        var acceptClassName = (0, _utils.classNames)('p-confirm-dialog-accept', getPropValue('acceptClassName'));
        var rejectClassName = (0, _utils.classNames)('p-confirm-dialog-reject', {
            'p-button-text': !getPropValue('rejectClassName')
        }, getPropValue('rejectClassName'));
        var content = /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _button.Button), {
            label: rejectLabel,
            icon: getPropValue('rejectIcon'),
            className: rejectClassName,
            onClick: reject
        }), /*#__PURE__*/ _react.createElement((0, _button.Button), {
            label: acceptLabel,
            icon: getPropValue('acceptIcon'),
            className: acceptClassName,
            onClick: accept,
            autoFocus: true
        }));
        if (getPropValue('footer')) {
            var defaultContentOptions = {
                accept: accept,
                reject: reject,
                acceptClassName: acceptClassName,
                rejectClassName: rejectClassName,
                acceptLabel: acceptLabel,
                rejectLabel: rejectLabel,
                element: content,
                props: getCurrentProps()
            };
            return (0, _utils.ObjectUtils).getJSXElement(getPropValue('footer'), defaultContentOptions);
        }
        return content;
    };
    var createElement = function createElement() {
        var currentProps = getCurrentProps();
        var className = (0, _utils.classNames)('p-confirm-dialog', getPropValue('className'));
        var otherProps = (0, _utils.ObjectUtils).findDiffKeys(currentProps, ConfirmDialog.defaultProps);
        var message = (0, _utils.ObjectUtils).getJSXElement(getPropValue('message'), currentProps);
        var icon = (0, _utils.IconUtils).getJSXIcon(getPropValue('icon'), {
            className: 'p-confirm-dialog-icon'
        }, {
            props: currentProps
        });
        var footer = createFooter();
        return /*#__PURE__*/ _react.createElement((0, _dialog.Dialog), _extends({
            visible: visibleState
        }, otherProps, {
            className: className,
            footer: footer,
            onHide: hide,
            breakpoints: getPropValue('breakpoints')
        }), icon, /*#__PURE__*/ _react.createElement("span", {
            className: "p-confirm-dialog-message"
        }, message));
    };
    var element = createElement();
    return /*#__PURE__*/ _react.createElement((0, _portal.Portal), {
        element: element,
        appendTo: getPropValue('appendTo')
    });
}));
ConfirmDialog.displayName = 'ConfirmDialog';
ConfirmDialog.defaultProps = {
    __TYPE: 'ConfirmDialog',
    tagKey: undefined,
    visible: undefined,
    message: null,
    rejectLabel: null,
    acceptLabel: null,
    icon: null,
    rejectIcon: null,
    acceptIcon: null,
    rejectClassName: null,
    acceptClassName: null,
    className: null,
    appendTo: null,
    footer: null,
    breakpoints: null,
    onHide: null,
    accept: null,
    reject: null
};

},{"react":"6wC8C","primereact/api":"5sLxO","primereact/button":"24Mwm","primereact/dialog":"8MQX5","primereact/hooks":"9RLkJ","primereact/overlayservice":"81M7F","primereact/portal":"5ahww","primereact/utils":"2f5Fe","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5sLxO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FilterMatchMode", ()=>FilterMatchMode);
parcelHelpers.export(exports, "FilterOperator", ()=>FilterOperator);
parcelHelpers.export(exports, "FilterService", ()=>FilterService);
parcelHelpers.export(exports, "MessageSeverity", ()=>MessageSeverity);
parcelHelpers.export(exports, "PrimeIcons", ()=>PrimeIcons);
parcelHelpers.export(exports, "SortOrder", ()=>SortOrder);
parcelHelpers.export(exports, "addLocale", ()=>addLocale);
parcelHelpers.export(exports, "ariaLabel", ()=>ariaLabel);
parcelHelpers.export(exports, "default", ()=>PrimeReact);
parcelHelpers.export(exports, "locale", ()=>locale);
parcelHelpers.export(exports, "localeOption", ()=>localeOption);
parcelHelpers.export(exports, "localeOptions", ()=>localeOptions);
parcelHelpers.export(exports, "updateLocaleOption", ()=>updateLocaleOption);
parcelHelpers.export(exports, "updateLocaleOptions", ()=>updateLocaleOptions);
var _utils = require("primereact/utils");
var FilterMatchMode = Object.freeze({
    STARTS_WITH: 'startsWith',
    CONTAINS: 'contains',
    NOT_CONTAINS: 'notContains',
    ENDS_WITH: 'endsWith',
    EQUALS: 'equals',
    NOT_EQUALS: 'notEquals',
    IN: 'in',
    LESS_THAN: 'lt',
    LESS_THAN_OR_EQUAL_TO: 'lte',
    GREATER_THAN: 'gt',
    GREATER_THAN_OR_EQUAL_TO: 'gte',
    BETWEEN: 'between',
    DATE_IS: 'dateIs',
    DATE_IS_NOT: 'dateIsNot',
    DATE_BEFORE: 'dateBefore',
    DATE_AFTER: 'dateAfter',
    CUSTOM: 'custom'
});
var FilterOperator = Object.freeze({
    AND: 'and',
    OR: 'or'
});
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var FilterService = {
    filter: function filter(value, fields, filterValue, filterMatchMode, filterLocale) {
        var filteredItems = [];
        if (!value) return filteredItems;
        var _iterator = _createForOfIteratorHelper(value), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var item = _step.value;
                if (typeof item === 'string') {
                    if (this.filters[filterMatchMode](item, filterValue, filterLocale)) {
                        filteredItems.push(item);
                        continue;
                    }
                } else {
                    var _iterator2 = _createForOfIteratorHelper(fields), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var field = _step2.value;
                            var fieldValue = (0, _utils.ObjectUtils).resolveFieldData(item, field);
                            if (this.filters[filterMatchMode](fieldValue, filterValue, filterLocale)) {
                                filteredItems.push(item);
                                break;
                            }
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return filteredItems;
    },
    filters: {
        startsWith: function startsWith(value, filter, filterLocale) {
            if (filter === undefined || filter === null || filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, _utils.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, _utils.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.slice(0, filterValue.length) === filterValue;
        },
        contains: function contains(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, _utils.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, _utils.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.indexOf(filterValue) !== -1;
        },
        notContains: function notContains(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, _utils.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, _utils.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.indexOf(filterValue) === -1;
        },
        endsWith: function endsWith(value, filter, filterLocale) {
            if (filter === undefined || filter === null || filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            var filterValue = (0, _utils.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
            var stringValue = (0, _utils.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale);
            return stringValue.indexOf(filterValue, stringValue.length - filterValue.length) !== -1;
        },
        equals: function equals(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() === filter.getTime();
            else return (0, _utils.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale) === (0, _utils.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
        },
        notEquals: function notEquals(value, filter, filterLocale) {
            if (filter === undefined || filter === null || typeof filter === 'string' && filter.trim() === '') return false;
            if (value === undefined || value === null) return true;
            if (value.getTime && filter.getTime) return value.getTime() !== filter.getTime();
            else return (0, _utils.ObjectUtils).removeAccents(value.toString()).toLocaleLowerCase(filterLocale) !== (0, _utils.ObjectUtils).removeAccents(filter.toString()).toLocaleLowerCase(filterLocale);
        },
        "in": function _in(value, filter) {
            if (filter === undefined || filter === null || filter.length === 0) return true;
            for(var i = 0; i < filter.length; i++){
                if ((0, _utils.ObjectUtils).equals(value, filter[i])) return true;
            }
            return false;
        },
        between: function between(value, filter) {
            if (filter == null || filter[0] == null || filter[1] == null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime) return filter[0].getTime() <= value.getTime() && value.getTime() <= filter[1].getTime();
            else return filter[0] <= value && value <= filter[1];
        },
        lt: function lt(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() < filter.getTime();
            else return value < filter;
        },
        lte: function lte(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() <= filter.getTime();
            else return value <= filter;
        },
        gt: function gt(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() > filter.getTime();
            else return value > filter;
        },
        gte: function gte(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            if (value.getTime && filter.getTime) return value.getTime() >= filter.getTime();
            else return value >= filter;
        },
        dateIs: function dateIs(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.toDateString() === filter.toDateString();
        },
        dateIsNot: function dateIsNot(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.toDateString() !== filter.toDateString();
        },
        dateBefore: function dateBefore(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.getTime() < filter.getTime();
        },
        dateAfter: function dateAfter(value, filter) {
            if (filter === undefined || filter === null) return true;
            if (value === undefined || value === null) return false;
            return value.getTime() > filter.getTime();
        }
    },
    register: function register(rule, fn) {
        this.filters[rule] = fn;
    }
};
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var PrimeReact = /*#__PURE__*/ _createClass(function PrimeReact() {
    _classCallCheck(this, PrimeReact);
});
_defineProperty(PrimeReact, "ripple", false);
_defineProperty(PrimeReact, "inputStyle", 'outlined');
_defineProperty(PrimeReact, "locale", 'en');
_defineProperty(PrimeReact, "appendTo", null);
_defineProperty(PrimeReact, "cssTransition", true);
_defineProperty(PrimeReact, "autoZIndex", true);
_defineProperty(PrimeReact, "nonce", null);
_defineProperty(PrimeReact, "nullSortOrder", 1);
_defineProperty(PrimeReact, "zIndex", {
    modal: 1100,
    overlay: 1000,
    menu: 1000,
    tooltip: 1100,
    toast: 1200
});
_defineProperty(PrimeReact, "filterMatchModeOptions", {
    text: [
        FilterMatchMode.STARTS_WITH,
        FilterMatchMode.CONTAINS,
        FilterMatchMode.NOT_CONTAINS,
        FilterMatchMode.ENDS_WITH,
        FilterMatchMode.EQUALS,
        FilterMatchMode.NOT_EQUALS
    ],
    numeric: [
        FilterMatchMode.EQUALS,
        FilterMatchMode.NOT_EQUALS,
        FilterMatchMode.LESS_THAN,
        FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
        FilterMatchMode.GREATER_THAN,
        FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
    ],
    date: [
        FilterMatchMode.DATE_IS,
        FilterMatchMode.DATE_IS_NOT,
        FilterMatchMode.DATE_BEFORE,
        FilterMatchMode.DATE_AFTER
    ]
});
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var locales = {
    en: {
        startsWith: 'Starts with',
        contains: 'Contains',
        notContains: 'Not contains',
        endsWith: 'Ends with',
        equals: 'Equals',
        notEquals: 'Not equals',
        noFilter: 'No Filter',
        filter: 'Filter',
        lt: 'Less than',
        lte: 'Less than or equal to',
        gt: 'Greater than',
        gte: 'Greater than or equal to',
        dateIs: 'Date is',
        dateIsNot: 'Date is not',
        dateBefore: 'Date is before',
        dateAfter: 'Date is after',
        custom: 'Custom',
        clear: 'Clear',
        close: 'Close',
        apply: 'Apply',
        matchAll: 'Match All',
        matchAny: 'Match Any',
        addRule: 'Add Rule',
        removeRule: 'Remove Rule',
        accept: 'Yes',
        reject: 'No',
        choose: 'Choose',
        upload: 'Upload',
        cancel: 'Cancel',
        dayNames: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
        dayNamesShort: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ],
        dayNamesMin: [
            'Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa'
        ],
        monthNames: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        monthNamesShort: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        today: 'Today',
        weekHeader: 'Wk',
        firstDayOfWeek: 0,
        dateFormat: 'mm/dd/yy',
        weak: 'Weak',
        medium: 'Medium',
        strong: 'Strong',
        passwordPrompt: 'Enter a password',
        emptyFilterMessage: 'No available options',
        emptyMessage: 'No results found',
        aria: {
            trueLabel: 'True',
            falseLabel: 'False',
            nullLabel: 'Not Selected',
            pageLabel: 'Page',
            firstPageLabel: 'First Page',
            lastPageLabel: 'Last Page',
            nextPageLabel: 'Next Page',
            previousPageLabel: 'Previous Page',
            selectLabel: 'Select',
            unselectLabel: 'Unselect',
            expandLabel: 'Expand',
            collapseLabel: 'Collapse'
        }
    }
};
function locale(locale) {
    locale && (PrimeReact.locale = locale);
    return {
        locale: PrimeReact.locale,
        options: locales[PrimeReact.locale]
    };
}
function addLocale(locale, options) {
    locales[locale] = _objectSpread(_objectSpread({}, locales['en']), options);
}
function updateLocaleOption(key, value, locale) {
    localeOptions(locale)[key] = value;
}
function updateLocaleOptions(options, locale) {
    var _locale = locale || PrimeReact.locale;
    locales[_locale] = _objectSpread(_objectSpread({}, locales[_locale]), options);
}
function localeOption(key, locale) {
    var _locale = locale || PrimeReact.locale;
    try {
        return localeOptions(_locale)[key];
    } catch (error) {
        throw new Error("The ".concat(key, " option is not found in the current locale('").concat(_locale, "')."));
    }
}
function ariaLabel(key) {
    var _locale = PrimeReact.locale;
    try {
        return localeOptions(_locale)['aria'][key];
    } catch (error) {
        throw new Error("The ".concat(key, " option is not found in the current locale('").concat(_locale, "')."));
    }
}
function localeOptions(locale) {
    var _locale = locale || PrimeReact.locale;
    return locales[_locale];
}
var MessageSeverity = Object.freeze({
    SUCCESS: 'success',
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error'
});
var PrimeIcons = Object.freeze({
    ALIGN_CENTER: 'pi pi-align-center',
    ALIGN_JUSTIFY: 'pi pi-align-justify',
    ALIGN_LEFT: 'pi pi-align-left',
    ALIGN_RIGHT: 'pi pi-align-right',
    AMAZON: 'pi pi-amazon',
    ANDROID: 'pi pi-android',
    ANGLE_DOUBLE_DOWN: 'pi pi-angle-double-down',
    ANGLE_DOUBLE_LEFT: 'pi pi-angle-double-left',
    ANGLE_DOUBLE_RIGHT: 'pi pi-angle-double-right',
    ANGLE_DOUBLE_UP: 'pi pi-angle-double-up',
    ANGLE_DOWN: 'pi pi-angle-down',
    ANGLE_LEFT: 'pi pi-angle-left',
    ANGLE_RIGHT: 'pi pi-angle-right',
    ANGLE_UP: 'pi pi-angle-up',
    APPLE: 'pi pi-apple',
    ARROW_CIRCLE_DOWN: 'pi pi-arrow-circle-down',
    ARROW_CIRCLE_LEFT: 'pi pi-arrow-circle-left',
    ARROW_CIRCLE_RIGHT: 'pi pi-arrow-circle-right',
    ARROW_CIRCLE_UP: 'pi pi-arrow-circle-up',
    ARROW_DOWN: 'pi pi-arrow-down',
    ARROW_DOWN_LEFT: 'pi pi-arrow-down-left',
    ARROW_DOWN_RIGHT: 'pi pi-arrow-down-right',
    ARROW_LEFT: 'pi pi-arrow-left',
    ARROW_RIGHT: 'pi pi-arrow-right',
    ARROW_UP: 'pi pi-arrow-up',
    ARROW_UP_LEFT: 'pi pi-arrow-up-left',
    ARROW_UP_RIGHT: 'pi pi-arrow-up-right',
    ARROWS_H: 'pi pi-arrows-h',
    ARROWS_V: 'pi pi-arrows-v',
    AT: 'pi pi-at',
    BACKWARD: 'pi pi-backward',
    BAN: 'pi pi-ban',
    BARS: 'pi pi-bars',
    BELL: 'pi pi-bell',
    BOLT: 'pi pi-bolt',
    BOOK: 'pi pi-book',
    BOOKMARK: 'pi pi-bookmark',
    BOOKMARK_FILL: 'pi pi-bookmark-fill',
    BOX: 'pi pi-box',
    BRIEFCASE: 'pi pi-briefcase',
    BUILDING: 'pi pi-building',
    CALENDAR: 'pi pi-calendar',
    CALENDAR_MINUS: 'pi pi-calendar-minus',
    CALENDAR_PLUS: 'pi pi-calendar-plus',
    CALENDAR_TIMES: 'pi pi-calendar-times',
    CAMERA: 'pi pi-camera',
    CAR: 'pi pi-car',
    CARET_DOWN: 'pi pi-caret-down',
    CARET_LEFT: 'pi pi-caret-left',
    CARET_RIGHT: 'pi pi-caret-right',
    CARET_UP: 'pi pi-caret-up',
    CHART_BAR: 'pi pi-chart-bar',
    CHART_LINE: 'pi pi-chart-line',
    CHART_PIE: 'pi pi-chart-pie',
    CHECK: 'pi pi-check',
    CHECK_CIRCLE: 'pi pi-check-circle',
    CHECK_SQUARE: 'pi pi-check-square',
    CHEVRON_CIRCLE_DOWN: 'pi pi-chevron-circle-down',
    CHEVRON_CIRCLE_LEFT: 'pi pi-chevron-circle-left',
    CHEVRON_CIRCLE_RIGHT: 'pi pi-chevron-circle-right',
    CHEVRON_CIRCLE_UP: 'pi pi-chevron-circle-up',
    CHEVRON_DOWN: 'pi pi-chevron-down',
    CHEVRON_LEFT: 'pi pi-chevron-left',
    CHEVRON_RIGHT: 'pi pi-chevron-right',
    CHEVRON_UP: 'pi pi-chevron-up',
    CIRCLE: 'pi pi-circle',
    CIRCLE_FILL: 'pi pi-circle-fill',
    CLOCK: 'pi pi-clock',
    CLONE: 'pi pi-clone',
    CLOUD: 'pi pi-cloud',
    CLOUD_DOWNLOAD: 'pi pi-cloud-download',
    CLOUD_UPLOAD: 'pi pi-cloud-upload',
    CODE: 'pi pi-code',
    COG: 'pi pi-cog',
    COMMENT: 'pi pi-comment',
    COMMENTS: 'pi pi-comments',
    COMPASS: 'pi pi-compass',
    COPY: 'pi pi-copy',
    CREDIT_CARD: 'pi pi-credit-card',
    DATABASE: 'pi pi-database',
    DESKTOP: 'pi pi-desktop',
    DIRECTIONS: 'pi pi-directions',
    DIRECTIONS_ALT: 'pi pi-directions-alt',
    DISCORD: 'pi pi-discord',
    DOLLAR: 'pi pi-dollar',
    DOWNLOAD: 'pi pi-download',
    EJECT: 'pi pi-eject',
    ELLIPSIS_H: 'pi pi-ellipsis-h',
    ELLIPSIS_V: 'pi pi-ellipsis-v',
    ENVELOPE: 'pi pi-envelope',
    EURO: 'pi pi-euro',
    EXCLAMATION_CIRCLE: 'pi pi-exclamation-circle',
    EXCLAMATION_TRIANGLE: 'pi pi-exclamation-triangle',
    EXTERNAL_LINK: 'pi pi-external-link',
    EYE: 'pi pi-eye',
    EYE_SLASH: 'pi pi-eye-slash',
    FACEBOOK: 'pi pi-facebook',
    FAST_BACKWARD: 'pi pi-fast-backward',
    FAST_FORWARD: 'pi pi-fast-forward',
    FILE: 'pi pi-file',
    FILE_EXCEL: 'pi pi-file-excel',
    FILE_PDF: 'pi pi-file-pdf',
    FILTER: 'pi pi-filter',
    FILTER_FILL: 'pi pi-filter-fill',
    FILTER_SLASH: 'pi pi-filter-slash',
    FLAG: 'pi pi-flag',
    FLAG_FILL: 'pi pi-flag-fill',
    FOLDER: 'pi pi-folder',
    FOLDER_OPEN: 'pi pi-folder-open',
    FORWARD: 'pi pi-forward',
    GITHUB: 'pi pi-github',
    GLOBE: 'pi pi-globe',
    GOOGLE: 'pi pi-google',
    HASHTAG: 'pi pi-hashtag',
    HEART: 'pi pi-heart',
    HEART_FILL: 'pi pi-heart-fill',
    HISTORY: 'pi pi-history',
    HOME: 'pi pi-home',
    ID_CARD: 'pi pi-id-card',
    IMAGE: 'pi pi-image',
    IMAGES: 'pi pi-images',
    INBOX: 'pi pi-inbox',
    INFO: 'pi pi-info',
    INFO_CIRCLE: 'pi pi-info-circle',
    INSTAGRAM: 'pi pi-instagram',
    KEY: 'pi pi-key',
    LINK: 'pi pi-link',
    LINKEDIN: 'pi pi-linkedin',
    LIST: 'pi pi-list',
    LOCK: 'pi pi-lock',
    LOCK_OPEN: 'pi pi-lock-open',
    MAP: 'pi pi-map',
    MAP_MARKER: 'pi pi-map-marker',
    MICROSOFT: 'pi pi-microsoft',
    MINUS: 'pi pi-minus',
    MINUS_CIRCLE: 'pi pi-minus-circle',
    MOBILE: 'pi pi-mobile',
    MONEY_BILL: 'pi pi-money-bill',
    MOON: 'pi pi-moon',
    PALETTE: 'pi pi-palette',
    PAPERCLIP: 'pi pi-paperclip',
    PAUSE: 'pi pi-pause',
    PAYPAL: 'pi pi-paypal',
    PENCIL: 'pi pi-pencil',
    PERCENTAGE: 'pi pi-percentage',
    PHONE: 'pi pi-phone',
    PLAY: 'pi pi-play',
    PLUS: 'pi pi-plus',
    PLUS_CIRCLE: 'pi pi-plus-circle',
    POUND: 'pi pi-pound',
    POWER_OFF: 'pi pi-power-off',
    PRIME: 'pi pi-prime',
    PRINT: 'pi pi-print',
    QRCODE: 'pi pi-qrcode',
    QUESTION: 'pi pi-question',
    QUESTION_CIRCLE: 'pi pi-question-circle',
    REDDIT: 'pi pi-reddit',
    REFRESH: 'pi pi-refresh',
    REPLAY: 'pi pi-replay',
    REPLY: 'pi pi-reply',
    SAVE: 'pi pi-save',
    SEARCH: 'pi pi-search',
    SEARCH_MINUS: 'pi pi-search-minus',
    SEARCH_PLUS: 'pi pi-search-plus',
    SEND: 'pi pi-send',
    SERVER: 'pi pi-server',
    SHARE_ALT: 'pi pi-share-alt',
    SHIELD: 'pi pi-shield',
    SHOPPING_BAG: 'pi pi-shopping-bag',
    SHOPPING_CART: 'pi pi-shopping-cart',
    SIGN_IN: 'pi pi-sign-in',
    SIGN_OUT: 'pi pi-sign-out',
    SITEMAP: 'pi pi-sitemap',
    SLACK: 'pi pi-slack',
    SLIDERS_H: 'pi pi-sliders-h',
    SLIDERS_V: 'pi pi-sliders-v',
    SORT: 'pi pi-sort',
    SORT_ALPHA_DOWN: 'pi pi-sort-alpha-down',
    SORT_ALPHA_ALT_DOWN: 'pi pi-sort-alpha-alt-down',
    SORT_ALPHA_UP: 'pi pi-sort-alpha-up',
    SORT_ALPHA_ALT_UP: 'pi pi-sort-alpha-alt-up',
    SORT_ALT: 'pi pi-sort-alt',
    SORT_ALT_SLASH: 'pi pi-sort-slash',
    SORT_AMOUNT_DOWN: 'pi pi-sort-amount-down',
    SORT_AMOUNT_DOWN_ALT: 'pi pi-sort-amount-down-alt',
    SORT_AMOUNT_UP: 'pi pi-sort-amount-up',
    SORT_AMOUNT_UP_ALT: 'pi pi-sort-amount-up-alt',
    SORT_DOWN: 'pi pi-sort-down',
    SORT_NUMERIC_DOWN: 'pi pi-sort-numeric-down',
    SORT_NUMERIC_ALT_DOWN: 'pi pi-sort-numeric-alt-down',
    SORT_NUMERIC_UP: 'pi pi-sort-numeric-up',
    SORT_NUMERIC_ALT_UP: 'pi pi-sort-numeric-alt-up',
    SORT_UP: 'pi pi-sort-up',
    SPINNER: 'pi pi-spinner',
    STAR: 'pi pi-star',
    STAR_FILL: 'pi pi-star-fill',
    STEP_BACKWARD: 'pi pi-step-backward',
    STEP_BACKWARD_ALT: 'pi pi-step-backward-alt',
    STEP_FORWARD: 'pi pi-step-forward',
    STEP_FORWARD_ALT: 'pi pi-step-forward-alt',
    STOP: 'pi pi-stop',
    STOP_CIRCLE: 'pi pi-stop-circle',
    SUN: 'pi pi-sun',
    SYNC: 'pi pi-sync',
    TABLE: 'pi pi-table',
    TABLET: 'pi pi-tablet',
    TAG: 'pi pi-tag',
    TAGS: 'pi pi-tags',
    TELEGRAM: 'pi pi-telegram',
    TH_LARGE: 'pi pi-th-large',
    THUMBS_DOWN: 'pi pi-thumbs-down',
    THUMBS_UP: 'pi pi-thumbs-up',
    TICKET: 'pi pi-ticket',
    TIMES: 'pi pi-times',
    TIMES_CIRCLE: 'pi pi-times-circle',
    TRASH: 'pi pi-trash',
    TWITTER: 'pi pi-twitter',
    UNDO: 'pi pi-undo',
    UNLOCK: 'pi pi-unlock',
    UPLOAD: 'pi pi-upload',
    USER: 'pi pi-user',
    USER_EDIT: 'pi pi-user-edit',
    USER_MINUS: 'pi pi-user-minus',
    USER_PLUS: 'pi pi-user-plus',
    USERS: 'pi pi-users',
    VIDEO: 'pi pi-video',
    VIMEO: 'pi pi-vimeo',
    VOLUME_DOWN: 'pi pi-volume-down',
    VOLUME_OFF: 'pi pi-volume-off',
    VOLUME_UP: 'pi pi-volume-up',
    WALLET: 'pi pi-wallet',
    WHATSAPP: 'pi pi-whatsapp',
    WIFI: 'pi pi-wifi',
    WINDOW_MAXIMIZE: 'pi pi-window-maximize',
    WINDOW_MINIMIZE: 'pi pi-window-minimize',
    YOUTUBE: 'pi pi-youtube'
});
var SortOrder = Object.freeze({
    DESC: -1,
    UNSORTED: 0,
    ASC: 1
});

},{"primereact/utils":"2f5Fe","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2f5Fe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConnectedOverlayScrollHandler", ()=>ConnectedOverlayScrollHandler);
parcelHelpers.export(exports, "DomHandler", ()=>DomHandler);
parcelHelpers.export(exports, "EventBus", ()=>EventBus);
parcelHelpers.export(exports, "IconUtils", ()=>IconUtils);
parcelHelpers.export(exports, "ObjectUtils", ()=>ObjectUtils);
parcelHelpers.export(exports, "UniqueComponentId", ()=>UniqueComponentId);
parcelHelpers.export(exports, "ZIndexUtils", ()=>ZIndexUtils);
parcelHelpers.export(exports, "classNames", ()=>classNames);
parcelHelpers.export(exports, "mask", ()=>mask);
var _react = require("react");
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest();
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function classNames() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (args) {
        var classes = [];
        for(var i = 0; i < args.length; i++){
            var className = args[i];
            if (!className) continue;
            var type = _typeof(className);
            if (type === 'string' || type === 'number') classes.push(className);
            else if (type === 'object') {
                var _classes = Array.isArray(className) ? className : Object.entries(className).map(function(_ref) {
                    var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
                    return !!value ? key : null;
                });
                classes = _classes.length ? classes.concat(_classes.filter(function(c) {
                    return !!c;
                })) : classes;
            }
        }
        return classes.join(' ');
    }
    return undefined;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var DomHandler = /*#__PURE__*/ function() {
    function DomHandler() {
        _classCallCheck(this, DomHandler);
    }
    _createClass(DomHandler, null, [
        {
            key: "innerWidth",
            value: /**
     * All data- properties like data-test-id
     */ /**
     * All ARIA properties like aria-label and focus-target for https://www.npmjs.com/package/@q42/floating-focus-a11y
     */ function innerWidth(el) {
                if (el) {
                    var width = el.offsetWidth;
                    var style = getComputedStyle(el);
                    width += parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
                    return width;
                }
                return 0;
            }
        },
        {
            key: "width",
            value: function width(el) {
                if (el) {
                    var width = el.offsetWidth;
                    var style = getComputedStyle(el);
                    width -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
                    return width;
                }
                return 0;
            }
        },
        {
            key: "getBrowserLanguage",
            value: function getBrowserLanguage() {
                return navigator.userLanguage || navigator.languages && navigator.languages.length && navigator.languages[0] || navigator.language || navigator.browserLanguage || navigator.systemLanguage || 'en';
            }
        },
        {
            key: "getWindowScrollTop",
            value: function getWindowScrollTop() {
                var doc = document.documentElement;
                return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
            }
        },
        {
            key: "getWindowScrollLeft",
            value: function getWindowScrollLeft() {
                var doc = document.documentElement;
                return (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
            }
        },
        {
            key: "getOuterWidth",
            value: function getOuterWidth(el, margin) {
                if (el) {
                    var width = el.offsetWidth || el.getBoundingClientRect().width;
                    if (margin) {
                        var style = getComputedStyle(el);
                        width += parseFloat(style.marginLeft) + parseFloat(style.marginRight);
                    }
                    return width;
                }
                return 0;
            }
        },
        {
            key: "getOuterHeight",
            value: function getOuterHeight(el, margin) {
                if (el) {
                    var height = el.offsetHeight || el.getBoundingClientRect().height;
                    if (margin) {
                        var style = getComputedStyle(el);
                        height += parseFloat(style.marginTop) + parseFloat(style.marginBottom);
                    }
                    return height;
                }
                return 0;
            }
        },
        {
            key: "getClientHeight",
            value: function getClientHeight(el, margin) {
                if (el) {
                    var height = el.clientHeight;
                    if (margin) {
                        var style = getComputedStyle(el);
                        height += parseFloat(style.marginTop) + parseFloat(style.marginBottom);
                    }
                    return height;
                }
                return 0;
            }
        },
        {
            key: "getClientWidth",
            value: function getClientWidth(el, margin) {
                if (el) {
                    var width = el.clientWidth;
                    if (margin) {
                        var style = getComputedStyle(el);
                        width += parseFloat(style.marginLeft) + parseFloat(style.marginRight);
                    }
                    return width;
                }
                return 0;
            }
        },
        {
            key: "getViewport",
            value: function getViewport() {
                var win = window, d = document, e = d.documentElement, g = d.getElementsByTagName('body')[0], w = win.innerWidth || e.clientWidth || g.clientWidth, h = win.innerHeight || e.clientHeight || g.clientHeight;
                return {
                    width: w,
                    height: h
                };
            }
        },
        {
            key: "getOffset",
            value: function getOffset(el) {
                if (el) {
                    var rect = el.getBoundingClientRect();
                    return {
                        top: rect.top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0),
                        left: rect.left + (window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0)
                    };
                }
                return {
                    top: 'auto',
                    left: 'auto'
                };
            }
        },
        {
            key: "index",
            value: function index(element) {
                if (element) {
                    var children = element.parentNode.childNodes;
                    var num = 0;
                    for(var i = 0; i < children.length; i++){
                        if (children[i] === element) return num;
                        if (children[i].nodeType === 1) num++;
                    }
                }
                return -1;
            }
        },
        {
            key: "addMultipleClasses",
            value: function addMultipleClasses(element, className) {
                if (element && className) {
                    if (element.classList) {
                        var styles = className.split(' ');
                        for(var i = 0; i < styles.length; i++)element.classList.add(styles[i]);
                    } else {
                        var _styles = className.split(' ');
                        for(var _i = 0; _i < _styles.length; _i++)element.className += ' ' + _styles[_i];
                    }
                }
            }
        },
        {
            key: "removeMultipleClasses",
            value: function removeMultipleClasses(element, className) {
                if (element && className) {
                    if (element.classList) {
                        var styles = className.split(' ');
                        for(var i = 0; i < styles.length; i++)element.classList.remove(styles[i]);
                    } else {
                        var _styles2 = className.split(' ');
                        for(var _i2 = 0; _i2 < _styles2.length; _i2++)element.className = element.className.replace(new RegExp('(^|\\b)' + _styles2[_i2].split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                    }
                }
            }
        },
        {
            key: "addClass",
            value: function addClass(element, className) {
                if (element && className) {
                    if (element.classList) element.classList.add(className);
                    else element.className += ' ' + className;
                }
            }
        },
        {
            key: "removeClass",
            value: function removeClass(element, className) {
                if (element && className) {
                    if (element.classList) element.classList.remove(className);
                    else element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
                }
            }
        },
        {
            key: "hasClass",
            value: function hasClass(element, className) {
                if (element) {
                    if (element.classList) return element.classList.contains(className);
                    else return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
                }
                return false;
            }
        },
        {
            key: "find",
            value: function find(element, selector) {
                return element ? Array.from(element.querySelectorAll(selector)) : [];
            }
        },
        {
            key: "findSingle",
            value: function findSingle(element, selector) {
                if (element) return element.querySelector(selector);
                return null;
            }
        },
        {
            key: "getHeight",
            value: function getHeight(el) {
                if (el) {
                    var height = el.offsetHeight;
                    var style = getComputedStyle(el);
                    height -= parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
                    return height;
                }
                return 0;
            }
        },
        {
            key: "getWidth",
            value: function getWidth(el) {
                if (el) {
                    var width = el.offsetWidth;
                    var style = getComputedStyle(el);
                    width -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
                    return width;
                }
                return 0;
            }
        },
        {
            key: "alignOverlay",
            value: function alignOverlay(overlay, target, appendTo) {
                var calculateMinWidth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
                if (overlay && target) {
                    if (appendTo === 'self') this.relativePosition(overlay, target);
                    else {
                        calculateMinWidth && (overlay.style.minWidth = DomHandler.getOuterWidth(target) + 'px');
                        this.absolutePosition(overlay, target);
                    }
                }
            }
        },
        {
            key: "absolutePosition",
            value: function absolutePosition(element, target) {
                if (element) {
                    var elementDimensions = element.offsetParent ? {
                        width: element.offsetWidth,
                        height: element.offsetHeight
                    } : this.getHiddenElementDimensions(element);
                    var elementOuterHeight = elementDimensions.height;
                    var elementOuterWidth = elementDimensions.width;
                    var targetOuterHeight = target.offsetHeight;
                    var targetOuterWidth = target.offsetWidth;
                    var targetOffset = target.getBoundingClientRect();
                    var windowScrollTop = this.getWindowScrollTop();
                    var windowScrollLeft = this.getWindowScrollLeft();
                    var viewport = this.getViewport();
                    var top, left;
                    if (targetOffset.top + targetOuterHeight + elementOuterHeight > viewport.height) {
                        top = targetOffset.top + windowScrollTop - elementOuterHeight;
                        if (top < 0) top = windowScrollTop;
                        element.style.transformOrigin = 'bottom';
                    } else {
                        top = targetOuterHeight + targetOffset.top + windowScrollTop;
                        element.style.transformOrigin = 'top';
                    }
                    if (targetOffset.left + targetOuterWidth + elementOuterWidth > viewport.width) left = Math.max(0, targetOffset.left + windowScrollLeft + targetOuterWidth - elementOuterWidth);
                    else left = targetOffset.left + windowScrollLeft;
                    element.style.top = top + 'px';
                    element.style.left = left + 'px';
                }
            }
        },
        {
            key: "relativePosition",
            value: function relativePosition(element, target) {
                if (element) {
                    var elementDimensions = element.offsetParent ? {
                        width: element.offsetWidth,
                        height: element.offsetHeight
                    } : this.getHiddenElementDimensions(element);
                    var targetHeight = target.offsetHeight;
                    var targetOffset = target.getBoundingClientRect();
                    var viewport = this.getViewport();
                    var top, left;
                    if (targetOffset.top + targetHeight + elementDimensions.height > viewport.height) {
                        top = -1 * elementDimensions.height;
                        if (targetOffset.top + top < 0) top = -1 * targetOffset.top;
                        element.style.transformOrigin = 'bottom';
                    } else {
                        top = targetHeight;
                        element.style.transformOrigin = 'top';
                    }
                    if (elementDimensions.width > viewport.width) // element wider then viewport and cannot fit on screen (align at left side of viewport)
                    left = targetOffset.left * -1;
                    else if (targetOffset.left + elementDimensions.width > viewport.width) // element wider then viewport but can be fit on screen (align at right side of viewport)
                    left = (targetOffset.left + elementDimensions.width - viewport.width) * -1;
                    else // element fits on screen (align with target)
                    left = 0;
                    element.style.top = top + 'px';
                    element.style.left = left + 'px';
                }
            }
        },
        {
            key: "flipfitCollision",
            value: function flipfitCollision(element, target) {
                var _this = this;
                var my = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'left top';
                var at = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'left bottom';
                var callback = arguments.length > 4 ? arguments[4] : undefined;
                if (element && target) {
                    var targetOffset = target.getBoundingClientRect();
                    var viewport = this.getViewport();
                    var myArr = my.split(' ');
                    var atArr = at.split(' ');
                    var getPositionValue = function getPositionValue(arr, isOffset) {
                        return isOffset ? +arr.substring(arr.search(/(\+|-)/g)) || 0 : arr.substring(0, arr.search(/(\+|-)/g)) || arr;
                    };
                    var position = {
                        my: {
                            x: getPositionValue(myArr[0]),
                            y: getPositionValue(myArr[1] || myArr[0]),
                            offsetX: getPositionValue(myArr[0], true),
                            offsetY: getPositionValue(myArr[1] || myArr[0], true)
                        },
                        at: {
                            x: getPositionValue(atArr[0]),
                            y: getPositionValue(atArr[1] || atArr[0]),
                            offsetX: getPositionValue(atArr[0], true),
                            offsetY: getPositionValue(atArr[1] || atArr[0], true)
                        }
                    };
                    var myOffset = {
                        left: function left() {
                            var totalOffset = position.my.offsetX + position.at.offsetX;
                            return totalOffset + targetOffset.left + (position.my.x === 'left' ? 0 : -1 * (position.my.x === 'center' ? _this.getOuterWidth(element) / 2 : _this.getOuterWidth(element)));
                        },
                        top: function top() {
                            var totalOffset = position.my.offsetY + position.at.offsetY;
                            return totalOffset + targetOffset.top + (position.my.y === 'top' ? 0 : -1 * (position.my.y === 'center' ? _this.getOuterHeight(element) / 2 : _this.getOuterHeight(element)));
                        }
                    };
                    var alignWithAt = {
                        count: {
                            x: 0,
                            y: 0
                        },
                        left: function left() {
                            var left = myOffset.left();
                            var scrollLeft = DomHandler.getWindowScrollLeft();
                            element.style.left = left + scrollLeft + 'px';
                            if (this.count.x === 2) {
                                element.style.left = scrollLeft + 'px';
                                this.count.x = 0;
                            } else if (left < 0) {
                                this.count.x++;
                                position.my.x = 'left';
                                position.at.x = 'right';
                                position.my.offsetX *= -1;
                                position.at.offsetX *= -1;
                                this.right();
                            }
                        },
                        right: function right() {
                            var left = myOffset.left() + DomHandler.getOuterWidth(target);
                            var scrollLeft = DomHandler.getWindowScrollLeft();
                            element.style.left = left + scrollLeft + 'px';
                            if (this.count.x === 2) {
                                element.style.left = viewport.width - DomHandler.getOuterWidth(element) + scrollLeft + 'px';
                                this.count.x = 0;
                            } else if (left + DomHandler.getOuterWidth(element) > viewport.width) {
                                this.count.x++;
                                position.my.x = 'right';
                                position.at.x = 'left';
                                position.my.offsetX *= -1;
                                position.at.offsetX *= -1;
                                this.left();
                            }
                        },
                        top: function top() {
                            var top = myOffset.top();
                            var scrollTop = DomHandler.getWindowScrollTop();
                            element.style.top = top + scrollTop + 'px';
                            if (this.count.y === 2) {
                                element.style.left = scrollTop + 'px';
                                this.count.y = 0;
                            } else if (top < 0) {
                                this.count.y++;
                                position.my.y = 'top';
                                position.at.y = 'bottom';
                                position.my.offsetY *= -1;
                                position.at.offsetY *= -1;
                                this.bottom();
                            }
                        },
                        bottom: function bottom() {
                            var top = myOffset.top() + DomHandler.getOuterHeight(target);
                            var scrollTop = DomHandler.getWindowScrollTop();
                            element.style.top = top + scrollTop + 'px';
                            if (this.count.y === 2) {
                                element.style.left = viewport.height - DomHandler.getOuterHeight(element) + scrollTop + 'px';
                                this.count.y = 0;
                            } else if (top + DomHandler.getOuterHeight(target) > viewport.height) {
                                this.count.y++;
                                position.my.y = 'bottom';
                                position.at.y = 'top';
                                position.my.offsetY *= -1;
                                position.at.offsetY *= -1;
                                this.top();
                            }
                        },
                        center: function center(axis) {
                            if (axis === 'y') {
                                var top = myOffset.top() + DomHandler.getOuterHeight(target) / 2;
                                element.style.top = top + DomHandler.getWindowScrollTop() + 'px';
                                if (top < 0) this.bottom();
                                else if (top + DomHandler.getOuterHeight(target) > viewport.height) this.top();
                            } else {
                                var left = myOffset.left() + DomHandler.getOuterWidth(target) / 2;
                                element.style.left = left + DomHandler.getWindowScrollLeft() + 'px';
                                if (left < 0) this.left();
                                else if (left + DomHandler.getOuterWidth(element) > viewport.width) this.right();
                            }
                        }
                    };
                    alignWithAt[position.at.x]('x');
                    alignWithAt[position.at.y]('y');
                    if (this.isFunction(callback)) callback(position);
                }
            }
        },
        {
            key: "findCollisionPosition",
            value: function findCollisionPosition(position) {
                if (position) {
                    var isAxisY = position === 'top' || position === 'bottom';
                    var myXPosition = position === 'left' ? 'right' : 'left';
                    var myYPosition = position === 'top' ? 'bottom' : 'top';
                    if (isAxisY) return {
                        axis: 'y',
                        my: "center ".concat(myYPosition),
                        at: "center ".concat(position)
                    };
                    return {
                        axis: 'x',
                        my: "".concat(myXPosition, " center"),
                        at: "".concat(position, " center")
                    };
                }
            }
        },
        {
            key: "getParents",
            value: function getParents(element) {
                var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                return element['parentNode'] === null ? parents : this.getParents(element.parentNode, parents.concat([
                    element.parentNode
                ]));
            }
        },
        {
            key: "getScrollableParents",
            value: function getScrollableParents(element) {
                var scrollableParents = [];
                if (element) {
                    var parents = this.getParents(element);
                    var overflowRegex = /(auto|scroll)/;
                    var overflowCheck = function overflowCheck(node) {
                        var styleDeclaration = node ? getComputedStyle(node) : null;
                        return styleDeclaration && (overflowRegex.test(styleDeclaration.getPropertyValue('overflow')) || overflowRegex.test(styleDeclaration.getPropertyValue('overflowX')) || overflowRegex.test(styleDeclaration.getPropertyValue('overflowY')));
                    };
                    var _iterator = _createForOfIteratorHelper(parents), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var parent = _step.value;
                            var scrollSelectors = parent.nodeType === 1 && parent.dataset['scrollselectors'];
                            if (scrollSelectors) {
                                var selectors = scrollSelectors.split(',');
                                var _iterator2 = _createForOfIteratorHelper(selectors), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var selector = _step2.value;
                                        var el = this.findSingle(parent, selector);
                                        if (el && overflowCheck(el)) scrollableParents.push(el);
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                            }
                            if (parent.nodeType !== 9 && overflowCheck(parent)) scrollableParents.push(parent);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                return scrollableParents;
            }
        },
        {
            key: "getHiddenElementOuterHeight",
            value: function getHiddenElementOuterHeight(element) {
                if (element) {
                    element.style.visibility = 'hidden';
                    element.style.display = 'block';
                    var elementHeight = element.offsetHeight;
                    element.style.display = 'none';
                    element.style.visibility = 'visible';
                    return elementHeight;
                }
                return 0;
            }
        },
        {
            key: "getHiddenElementOuterWidth",
            value: function getHiddenElementOuterWidth(element) {
                if (element) {
                    element.style.visibility = 'hidden';
                    element.style.display = 'block';
                    var elementWidth = element.offsetWidth;
                    element.style.display = 'none';
                    element.style.visibility = 'visible';
                    return elementWidth;
                }
                return 0;
            }
        },
        {
            key: "getHiddenElementDimensions",
            value: function getHiddenElementDimensions(element) {
                var dimensions = {};
                if (element) {
                    element.style.visibility = 'hidden';
                    element.style.display = 'block';
                    dimensions.width = element.offsetWidth;
                    dimensions.height = element.offsetHeight;
                    element.style.display = 'none';
                    element.style.visibility = 'visible';
                }
                return dimensions;
            }
        },
        {
            key: "fadeIn",
            value: function fadeIn(element, duration) {
                if (element) {
                    element.style.opacity = 0;
                    var last = +new Date();
                    var opacity = 0;
                    var tick = function tick() {
                        opacity = +element.style.opacity + (new Date().getTime() - last) / duration;
                        element.style.opacity = opacity;
                        last = +new Date();
                        if (+opacity < 1) window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
                    };
                    tick();
                }
            }
        },
        {
            key: "fadeOut",
            value: function fadeOut(element, duration) {
                if (element) {
                    var opacity = 1, interval = 50, gap = interval / duration;
                    var fading = setInterval(function() {
                        opacity -= gap;
                        if (opacity <= 0) {
                            opacity = 0;
                            clearInterval(fading);
                        }
                        element.style.opacity = opacity;
                    }, interval);
                }
            }
        },
        {
            key: "getUserAgent",
            value: function getUserAgent() {
                return navigator.userAgent;
            }
        },
        {
            key: "isIOS",
            value: function isIOS() {
                return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window['MSStream'];
            }
        },
        {
            key: "isAndroid",
            value: function isAndroid() {
                return /(android)/i.test(navigator.userAgent);
            }
        },
        {
            key: "isTouchDevice",
            value: function isTouchDevice() {
                return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
            }
        },
        {
            key: "isFunction",
            value: function isFunction(obj) {
                return !!(obj && obj.constructor && obj.call && obj.apply);
            }
        },
        {
            key: "appendChild",
            value: function appendChild(element, target) {
                if (this.isElement(target)) target.appendChild(element);
                else if (target.el && target.el.nativeElement) target.el.nativeElement.appendChild(element);
                else throw new Error('Cannot append ' + target + ' to ' + element);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(element, target) {
                if (this.isElement(target)) target.removeChild(element);
                else if (target.el && target.el.nativeElement) target.el.nativeElement.removeChild(element);
                else throw new Error('Cannot remove ' + element + ' from ' + target);
            }
        },
        {
            key: "isElement",
            value: function isElement(obj) {
                return (typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) === 'object' ? obj instanceof HTMLElement : obj && _typeof(obj) === 'object' && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === 'string';
            }
        },
        {
            key: "scrollInView",
            value: function scrollInView(container, item) {
                var borderTopValue = getComputedStyle(container).getPropertyValue('borderTopWidth');
                var borderTop = borderTopValue ? parseFloat(borderTopValue) : 0;
                var paddingTopValue = getComputedStyle(container).getPropertyValue('paddingTop');
                var paddingTop = paddingTopValue ? parseFloat(paddingTopValue) : 0;
                var containerRect = container.getBoundingClientRect();
                var itemRect = item.getBoundingClientRect();
                var offset = itemRect.top + document.body.scrollTop - (containerRect.top + document.body.scrollTop) - borderTop - paddingTop;
                var scroll = container.scrollTop;
                var elementHeight = container.clientHeight;
                var itemHeight = this.getOuterHeight(item);
                if (offset < 0) container.scrollTop = scroll + offset;
                else if (offset + itemHeight > elementHeight) container.scrollTop = scroll + offset - elementHeight + itemHeight;
            }
        },
        {
            key: "clearSelection",
            value: function clearSelection() {
                if (window.getSelection) {
                    if (window.getSelection().empty) window.getSelection().empty();
                    else if (window.getSelection().removeAllRanges && window.getSelection().rangeCount > 0 && window.getSelection().getRangeAt(0).getClientRects().length > 0) window.getSelection().removeAllRanges();
                } else if (document['selection'] && document['selection'].empty) try {
                    document['selection'].empty();
                } catch (error) {
                //ignore IE bug
                }
            }
        },
        {
            key: "calculateScrollbarWidth",
            value: function calculateScrollbarWidth(el) {
                if (el) {
                    var style = getComputedStyle(el);
                    return el.offsetWidth - el.clientWidth - parseFloat(style.borderLeftWidth) - parseFloat(style.borderRightWidth);
                } else {
                    if (this.calculatedScrollbarWidth != null) return this.calculatedScrollbarWidth;
                    var scrollDiv = document.createElement('div');
                    scrollDiv.className = 'p-scrollbar-measure';
                    document.body.appendChild(scrollDiv);
                    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
                    document.body.removeChild(scrollDiv);
                    this.calculatedScrollbarWidth = scrollbarWidth;
                    return scrollbarWidth;
                }
            }
        },
        {
            key: "getBrowser",
            value: function getBrowser() {
                if (!this.browser) {
                    var matched = this.resolveUserAgent();
                    this.browser = {};
                    if (matched.browser) {
                        this.browser[matched.browser] = true;
                        this.browser['version'] = matched.version;
                    }
                    if (this.browser['chrome']) this.browser['webkit'] = true;
                    else if (this.browser['webkit']) this.browser['safari'] = true;
                }
                return this.browser;
            }
        },
        {
            key: "resolveUserAgent",
            value: function resolveUserAgent() {
                var ua = navigator.userAgent.toLowerCase();
                var match = /(chrome)[ ]([\w.]+)/.exec(ua) || /(webkit)[ ]([\w.]+)/.exec(ua) || /(opera)(?:.*version|)[ ]([\w.]+)/.exec(ua) || /(msie) ([\w.]+)/.exec(ua) || ua.indexOf('compatible') < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];
                return {
                    browser: match[1] || '',
                    version: match[2] || '0'
                };
            }
        },
        {
            key: "isVisible",
            value: function isVisible(element) {
                // https://stackoverflow.com/a/59096915/502366 (in future use IntersectionObserver)
                return element && (element.clientHeight !== 0 || element.getClientRects().length !== 0 || getComputedStyle(element).display !== 'none');
            }
        },
        {
            key: "isExist",
            value: function isExist(element) {
                return element !== null && typeof element !== 'undefined' && element.nodeName && element.parentNode;
            }
        },
        {
            key: "hasDOM",
            value: function hasDOM() {
                return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
            }
        },
        {
            key: "getFocusableElements",
            value: function getFocusableElements(element) {
                var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var focusableElements = DomHandler.find(element, "button:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])".concat(selector, ",\n                [href][clientHeight][clientWidth]:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                input:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                select:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                textarea:not([tabindex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                [tabIndex]:not([tabIndex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector, ",\n                [contenteditable]:not([tabIndex = \"-1\"]):not([disabled]):not([style*=\"display:none\"]):not([hidden])").concat(selector));
                var visibleFocusableElements = [];
                var _iterator3 = _createForOfIteratorHelper(focusableElements), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var focusableElement = _step3.value;
                        if (getComputedStyle(focusableElement).display !== 'none' && getComputedStyle(focusableElement).visibility !== 'hidden') visibleFocusableElements.push(focusableElement);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                return visibleFocusableElements;
            }
        },
        {
            key: "getFirstFocusableElement",
            value: function getFirstFocusableElement(element, selector) {
                var focusableElements = DomHandler.getFocusableElements(element, selector);
                return focusableElements.length > 0 ? focusableElements[0] : null;
            }
        },
        {
            key: "getLastFocusableElement",
            value: function getLastFocusableElement(element, selector) {
                var focusableElements = DomHandler.getFocusableElements(element, selector);
                return focusableElements.length > 0 ? focusableElements[focusableElements.length - 1] : null;
            }
        },
        {
            key: "focus",
            value: function focus(el, scrollTo) {
                var preventScroll = scrollTo === undefined ? true : !scrollTo;
                el && document.activeElement !== el && el.focus({
                    preventScroll: preventScroll
                });
            }
        },
        {
            key: "getCursorOffset",
            value: function getCursorOffset(el, prevText, nextText, currentText) {
                if (el) {
                    var style = getComputedStyle(el);
                    var ghostDiv = document.createElement('div');
                    ghostDiv.style.position = 'absolute';
                    ghostDiv.style.top = '0px';
                    ghostDiv.style.left = '0px';
                    ghostDiv.style.visibility = 'hidden';
                    ghostDiv.style.pointerEvents = 'none';
                    ghostDiv.style.overflow = style.overflow;
                    ghostDiv.style.width = style.width;
                    ghostDiv.style.height = style.height;
                    ghostDiv.style.padding = style.padding;
                    ghostDiv.style.border = style.border;
                    ghostDiv.style.overflowWrap = style.overflowWrap;
                    ghostDiv.style.whiteSpace = style.whiteSpace;
                    ghostDiv.style.lineHeight = style.lineHeight;
                    ghostDiv.innerHTML = prevText.replace(/\r\n|\r|\n/g, '<br />');
                    var ghostSpan = document.createElement('span');
                    ghostSpan.textContent = currentText;
                    ghostDiv.appendChild(ghostSpan);
                    var text = document.createTextNode(nextText);
                    ghostDiv.appendChild(text);
                    document.body.appendChild(ghostDiv);
                    var offsetLeft = ghostSpan.offsetLeft, offsetTop = ghostSpan.offsetTop, clientHeight = ghostSpan.clientHeight;
                    document.body.removeChild(ghostDiv);
                    return {
                        left: Math.abs(offsetLeft - el.scrollLeft),
                        top: Math.abs(offsetTop - el.scrollTop) + clientHeight
                    };
                }
                return {
                    top: 'auto',
                    left: 'auto'
                };
            }
        },
        {
            key: "invokeElementMethod",
            value: function invokeElementMethod(element, methodName, args) {
                element[methodName].apply(element, args);
            }
        },
        {
            key: "isClickable",
            value: function isClickable(element) {
                var targetNode = element.nodeName;
                var parentNode = element.parentElement && element.parentElement.nodeName;
                return targetNode === 'INPUT' || targetNode === 'TEXTAREA' || targetNode === 'BUTTON' || targetNode === 'A' || parentNode === 'INPUT' || parentNode === 'TEXTAREA' || parentNode === 'BUTTON' || parentNode === 'A' || this.hasClass(element, 'p-button') || this.hasClass(element.parentElement, 'p-button') || this.hasClass(element.parentElement, 'p-checkbox') || this.hasClass(element.parentElement, 'p-radiobutton');
            }
        },
        {
            key: "applyStyle",
            value: function applyStyle(element, style) {
                if (typeof style === 'string') element.style.cssText = this.style;
                else for(var prop in this.style)element.style[prop] = style[prop];
            }
        },
        {
            key: "exportCSV",
            value: function exportCSV(csv, filename) {
                var blob = new Blob([
                    csv
                ], {
                    type: 'application/csv;charset=utf-8;'
                });
                if (window.navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(blob, filename + '.csv');
                else {
                    var isDownloaded = DomHandler.saveAs({
                        name: filename + '.csv',
                        src: URL.createObjectURL(blob)
                    });
                    if (!isDownloaded) {
                        csv = 'data:text/csv;charset=utf-8,' + csv;
                        window.open(encodeURI(csv));
                    }
                }
            }
        },
        {
            key: "saveAs",
            value: function saveAs(file) {
                if (file) {
                    var link = document.createElement('a');
                    if (link.download !== undefined) {
                        var name = file.name, src = file.src;
                        link.setAttribute('href', src);
                        link.setAttribute('download', name);
                        link.style.display = 'none';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        return true;
                    }
                }
                return false;
            }
        },
        {
            key: "createInlineStyle",
            value: function createInlineStyle(nonce) {
                var styleElement = document.createElement('style');
                try {
                    if (!nonce) nonce = undefined;
                } catch (error) {
                // NOOP
                }
                nonce && styleElement.setAttribute('nonce', nonce);
                document.head.appendChild(styleElement);
                return styleElement;
            }
        },
        {
            key: "removeInlineStyle",
            value: function removeInlineStyle(styleElement) {
                if (this.isExist(styleElement)) {
                    try {
                        document.head.removeChild(styleElement);
                    } catch (error) {
                    // style element may have already been removed in a fast refresh
                    }
                    styleElement = null;
                }
                return styleElement;
            }
        },
        {
            key: "getTargetElement",
            value: function getTargetElement(target) {
                if (!target) return null;
                if (target === 'document') return document;
                else if (target === 'window') return window;
                else if (_typeof(target) === 'object' && target.hasOwnProperty('current')) return this.isExist(target.current) ? target.current : null;
                else {
                    var isFunction = function isFunction(obj) {
                        return !!(obj && obj.constructor && obj.call && obj.apply);
                    };
                    var element = isFunction(target) ? target() : target;
                    return element && element.nodeType === 9 || this.isExist(element) ? element : null;
                }
            }
        },
        {
            key: "getAttributeNames",
            value: function getAttributeNames(node) {
                var index, rv, attrs;
                rv = [];
                attrs = node.attributes;
                for(index = 0; index < attrs.length; ++index)rv.push(attrs[index].nodeName);
                rv.sort();
                return rv;
            }
        },
        {
            key: "isEqualElement",
            value: function isEqualElement(elm1, elm2) {
                var attrs1, attrs2, name, node1, node2;
                // Compare attributes without order sensitivity
                attrs1 = DomHandler.getAttributeNames(elm1);
                attrs2 = DomHandler.getAttributeNames(elm2);
                if (attrs1.join(',') !== attrs2.join(',')) // console.log("Found nodes with different sets of attributes; not equiv");
                return false;
                // ...and values
                // unless you want to compare DOM0 event handlers
                // (onclick="...")
                for(var index = 0; index < attrs1.length; ++index){
                    name = attrs1[index];
                    if (name === 'style') {
                        var astyle = elm1.style;
                        var bstyle = elm2.style;
                        var rexDigitsOnly = /^\d+$/;
                        for(var _i3 = 0, _Object$keys = Object.keys(astyle); _i3 < _Object$keys.length; _i3++){
                            var key = _Object$keys[_i3];
                            if (!rexDigitsOnly.test(key) && astyle[key] !== bstyle[key]) // Not equivalent, stop
                            //console.log("Found nodes with mis-matched values for attribute '" + name + "'; not equiv");
                            return false;
                        }
                    } else {
                        if (elm1.getAttribute(name) !== elm2.getAttribute(name)) // console.log("Found nodes with mis-matched values for attribute '" + name + "'; not equiv");
                        return false;
                    }
                }
                // Walk the children
                for(node1 = elm1.firstChild, node2 = elm2.firstChild; node1 && node2; node1 = node1.nextSibling, node2 = node2.nextSibling){
                    if (node1.nodeType !== node2.nodeType) // display("Found nodes of different types; not equiv");
                    return false;
                    if (node1.nodeType === 1) {
                        // Element
                        if (!DomHandler.isEqualElement(node1, node2)) return false;
                    } else if (node1.nodeValue !== node2.nodeValue) // console.log("Found nodes with mis-matched nodeValues; not equiv");
                    return false;
                }
                if (node1 || node2) // One of the elements had more nodes than the other
                // console.log("Found more children of one element than the other; not equivalent");
                return false;
                // Seem the same
                return true;
            }
        }
    ]);
    return DomHandler;
}();
_defineProperty(DomHandler, "DATA_PROPS", [
    'data-'
]);
_defineProperty(DomHandler, "ARIA_PROPS", [
    'aria',
    'focus-target'
]);
var ConnectedOverlayScrollHandler = /*#__PURE__*/ function() {
    function ConnectedOverlayScrollHandler(element) {
        var listener = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {};
        _classCallCheck(this, ConnectedOverlayScrollHandler);
        this.element = element;
        this.listener = listener;
    }
    _createClass(ConnectedOverlayScrollHandler, [
        {
            key: "bindScrollListener",
            value: function bindScrollListener() {
                this.scrollableParents = DomHandler.getScrollableParents(this.element);
                for(var i = 0; i < this.scrollableParents.length; i++)this.scrollableParents[i].addEventListener('scroll', this.listener);
            }
        },
        {
            key: "unbindScrollListener",
            value: function unbindScrollListener() {
                if (this.scrollableParents) for(var i = 0; i < this.scrollableParents.length; i++)this.scrollableParents[i].removeEventListener('scroll', this.listener);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.unbindScrollListener();
                this.element = null;
                this.listener = null;
                this.scrollableParents = null;
            }
        }
    ]);
    return ConnectedOverlayScrollHandler;
}();
function EventBus() {
    var allHandlers = new Map();
    return {
        on: function on(type, handler) {
            var handlers = allHandlers.get(type);
            if (!handlers) handlers = [
                handler
            ];
            else handlers.push(handler);
            allHandlers.set(type, handlers);
        },
        off: function off(type, handler) {
            var handlers = allHandlers.get(type);
            handlers && handlers.splice(handlers.indexOf(handler) >>> 0, 1);
        },
        emit: function emit(type, evt) {
            var handlers = allHandlers.get(type);
            handlers && handlers.slice().forEach(function(handler) {
                return handler(evt);
            });
        }
    };
}
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$1(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function mask(el, options) {
    var defaultOptions = {
        mask: null,
        slotChar: '_',
        autoClear: true,
        unmask: false,
        readOnly: false,
        onComplete: null,
        onChange: null,
        onFocus: null,
        onBlur: null
    };
    options = _objectSpread$1(_objectSpread$1({}, defaultOptions), options);
    var tests, partialPosition, len, firstNonMaskPos, defs, androidChrome, lastRequiredNonMaskPos, oldVal, focusText, caretTimeoutId, buffer, defaultBuffer;
    var caret = function caret(first, last) {
        var range, begin, end;
        if (!el.offsetParent || el !== document.activeElement) return;
        if (typeof first === 'number') {
            begin = first;
            end = typeof last === 'number' ? last : begin;
            if (el.setSelectionRange) el.setSelectionRange(begin, end);
            else if (el['createTextRange']) {
                range = el['createTextRange']();
                range.collapse(true);
                range.moveEnd('character', end);
                range.moveStart('character', begin);
                range.select();
            }
        } else {
            if (el.setSelectionRange) {
                begin = el.selectionStart;
                end = el.selectionEnd;
            } else if (document['selection'] && document['selection'].createRange) {
                range = document['selection'].createRange();
                begin = 0 - range.duplicate().moveStart('character', -100000);
                end = begin + range.text.length;
            }
            return {
                begin: begin,
                end: end
            };
        }
    };
    var isCompleted = function isCompleted() {
        for(var i = firstNonMaskPos; i <= lastRequiredNonMaskPos; i++){
            if (tests[i] && buffer[i] === getPlaceholder(i)) return false;
        }
        return true;
    };
    var getPlaceholder = function getPlaceholder(i) {
        if (i < options.slotChar.length) return options.slotChar.charAt(i);
        return options.slotChar.charAt(0);
    };
    var getValue = function getValue() {
        return options.unmask ? getUnmaskedValue() : el && el.value;
    };
    var seekNext = function seekNext(pos) {
        while(++pos < len && !tests[pos]);
        return pos;
    };
    var seekPrev = function seekPrev(pos) {
        while(--pos >= 0 && !tests[pos]);
        return pos;
    };
    var shiftL = function shiftL(begin, end) {
        var i, j;
        if (begin < 0) return;
        for(i = begin, j = seekNext(end); i < len; i++)if (tests[i]) {
            if (j < len && tests[i].test(buffer[j])) {
                buffer[i] = buffer[j];
                buffer[j] = getPlaceholder(j);
            } else break;
            j = seekNext(j);
        }
        writeBuffer();
        caret(Math.max(firstNonMaskPos, begin));
    };
    var shiftR = function shiftR(pos) {
        var i, c, j, t;
        for(i = pos, c = getPlaceholder(pos); i < len; i++)if (tests[i]) {
            j = seekNext(i);
            t = buffer[i];
            buffer[i] = c;
            if (j < len && tests[j].test(t)) c = t;
            else break;
        }
    };
    var handleAndroidInput = function handleAndroidInput(e) {
        var curVal = el.value;
        var pos = caret();
        if (oldVal && oldVal.length && oldVal.length > curVal.length) {
            // a deletion or backspace happened
            checkVal(true);
            while(pos.begin > 0 && !tests[pos.begin - 1])pos.begin--;
            if (pos.begin === 0) while(pos.begin < firstNonMaskPos && !tests[pos.begin])pos.begin++;
            caret(pos.begin, pos.begin);
        } else {
            checkVal(true);
            while(pos.begin < len && !tests[pos.begin])pos.begin++;
            caret(pos.begin, pos.begin);
        }
        if (options.onComplete && isCompleted()) options.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var onBlur = function onBlur(e) {
        checkVal();
        options.onBlur && options.onBlur(e);
        updateModel(e);
        if (el.value !== focusText) {
            var event = document.createEvent('HTMLEvents');
            event.initEvent('change', true, false);
            el.dispatchEvent(event);
        }
    };
    var onKeyDown = function onKeyDown(e) {
        if (options.readOnly) return;
        var k = e.which || e.keyCode, pos, begin, end;
        var iPhone = /iphone/i.test(DomHandler.getUserAgent());
        oldVal = el.value;
        //backspace, delete, and escape get special treatment
        if (k === 8 || k === 46 || iPhone && k === 127) {
            pos = caret();
            begin = pos.begin;
            end = pos.end;
            if (end - begin === 0) {
                begin = k !== 46 ? seekPrev(begin) : end = seekNext(begin - 1);
                end = k === 46 ? seekNext(end) : end;
            }
            clearBuffer(begin, end);
            shiftL(begin, end - 1);
            updateModel(e);
            e.preventDefault();
        } else if (k === 13) {
            // enter
            onBlur(e);
            updateModel(e);
        } else if (k === 27) {
            // escape
            el.value = focusText;
            caret(0, checkVal());
            updateModel(e);
            e.preventDefault();
        }
    };
    var onKeyPress = function onKeyPress(e) {
        if (options.readOnly) return;
        var k = e.which || e.keyCode, pos = caret(), p, c, next, completed;
        if (e.ctrlKey || e.altKey || e.metaKey || k < 32) //Ignore
        return;
        else if (k && k !== 13) {
            if (pos.end - pos.begin !== 0) {
                clearBuffer(pos.begin, pos.end);
                shiftL(pos.begin, pos.end - 1);
            }
            p = seekNext(pos.begin - 1);
            if (p < len) {
                c = String.fromCharCode(k);
                if (tests[p].test(c)) {
                    shiftR(p);
                    buffer[p] = c;
                    writeBuffer();
                    next = seekNext(p);
                    if (/android/i.test(DomHandler.getUserAgent())) {
                        //Path for CSP Violation on FireFox OS 1.1
                        var proxy = function proxy() {
                            caret(next);
                        };
                        setTimeout(proxy, 0);
                    } else caret(next);
                    if (pos.begin <= lastRequiredNonMaskPos) completed = isCompleted();
                }
            }
            e.preventDefault();
        }
        updateModel(e);
        if (options.onComplete && completed) options.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var clearBuffer = function clearBuffer(start, end) {
        var i;
        for(i = start; i < end && i < len; i++)if (tests[i]) buffer[i] = getPlaceholder(i);
    };
    var writeBuffer = function writeBuffer() {
        el.value = buffer.join('');
    };
    var checkVal = function checkVal(allow) {
        //try to place characters where they belong
        var test = el.value, lastMatch = -1, i, c, pos;
        for(i = 0, pos = 0; i < len; i++)if (tests[i]) {
            buffer[i] = getPlaceholder(i);
            while(pos++ < test.length){
                c = test.charAt(pos - 1);
                if (tests[i].test(c)) {
                    buffer[i] = c;
                    lastMatch = i;
                    break;
                }
            }
            if (pos > test.length) {
                clearBuffer(i + 1, len);
                break;
            }
        } else {
            if (buffer[i] === test.charAt(pos)) pos++;
            if (i < partialPosition) lastMatch = i;
        }
        if (allow) writeBuffer();
        else if (lastMatch + 1 < partialPosition) {
            if (options.autoClear || buffer.join('') === defaultBuffer) {
                // Invalid value. Remove it and replace it with the
                // mask, which is the default behavior.
                if (el.value) el.value = '';
                clearBuffer(0, len);
            } else // Invalid value, but we opt to show the value to the
            // user and allow them to correct their mistake.
            writeBuffer();
        } else {
            writeBuffer();
            el.value = el.value.substring(0, lastMatch + 1);
        }
        return partialPosition ? i : firstNonMaskPos;
    };
    var onFocus = function onFocus(e) {
        if (options.readOnly) return;
        clearTimeout(caretTimeoutId);
        var pos;
        focusText = el.value;
        pos = checkVal();
        caretTimeoutId = setTimeout(function() {
            if (el !== document.activeElement) return;
            writeBuffer();
            if (pos === options.mask.replace('?', '').length) caret(0, pos);
            else caret(pos);
        }, 10);
        if (options.onFocus) options.onFocus(e);
    };
    var onInput = function onInput(event) {
        if (androidChrome) handleAndroidInput(event);
        else handleInputChange(event);
    };
    var handleInputChange = function handleInputChange(e) {
        if (options.readOnly) return;
        var pos = checkVal(true);
        caret(pos);
        updateModel(e);
        if (options.onComplete && isCompleted()) options.onComplete({
            originalEvent: e,
            value: getValue()
        });
    };
    var getUnmaskedValue = function getUnmaskedValue() {
        var unmaskedBuffer = [];
        for(var i = 0; i < buffer.length; i++){
            var c = buffer[i];
            if (tests[i] && c !== getPlaceholder(i)) unmaskedBuffer.push(c);
        }
        return unmaskedBuffer.join('');
    };
    var updateModel = function updateModel(e) {
        if (options.onChange) {
            var val = getValue().replace(options.slotChar, '');
            options.onChange({
                originalEvent: e,
                value: defaultBuffer !== val ? val : ''
            });
        }
    };
    var bindEvents = function bindEvents() {
        el.addEventListener('focus', onFocus);
        el.addEventListener('blur', onBlur);
        el.addEventListener('keydown', onKeyDown);
        el.addEventListener('keypress', onKeyPress);
        el.addEventListener('input', onInput);
        el.addEventListener('paste', handleInputChange);
    };
    var unbindEvents = function unbindEvents() {
        el.removeEventListener('focus', onFocus);
        el.removeEventListener('blur', onBlur);
        el.removeEventListener('keydown', onKeyDown);
        el.removeEventListener('keypress', onKeyPress);
        el.removeEventListener('input', onInput);
        el.removeEventListener('paste', handleInputChange);
    };
    var init = function init() {
        tests = [];
        partialPosition = options.mask.length;
        len = options.mask.length;
        firstNonMaskPos = null;
        defs = {
            9: '[0-9]',
            a: '[A-Za-z]',
            '*': '[A-Za-z0-9]'
        };
        var ua = DomHandler.getUserAgent();
        androidChrome = /chrome/i.test(ua) && /android/i.test(ua);
        var maskTokens = options.mask.split('');
        for(var i = 0; i < maskTokens.length; i++){
            var c = maskTokens[i];
            if (c === '?') {
                len--;
                partialPosition = i;
            } else if (defs[c]) {
                tests.push(new RegExp(defs[c]));
                if (firstNonMaskPos === null) firstNonMaskPos = tests.length - 1;
                if (i < partialPosition) lastRequiredNonMaskPos = tests.length - 1;
            } else tests.push(null);
        }
        buffer = [];
        for(var _i = 0; _i < maskTokens.length; _i++){
            var _c = maskTokens[_i];
            if (_c !== '?') {
                if (defs[_c]) buffer.push(getPlaceholder(_i));
                else buffer.push(_c);
            }
        }
        defaultBuffer = buffer.join('');
    };
    if (el && options.mask) {
        init();
        bindEvents();
    }
    return {
        init: init,
        bindEvents: bindEvents,
        unbindEvents: unbindEvents,
        updateModel: updateModel,
        getValue: getValue
    };
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread();
}
var ObjectUtils = /*#__PURE__*/ function() {
    function ObjectUtils() {
        _classCallCheck(this, ObjectUtils);
    }
    _createClass(ObjectUtils, null, [
        {
            key: "equals",
            value: function equals(obj1, obj2, field) {
                if (field && obj1 && _typeof(obj1) === 'object' && obj2 && _typeof(obj2) === 'object') return this.resolveFieldData(obj1, field) === this.resolveFieldData(obj2, field);
                else return this.deepEquals(obj1, obj2);
            }
        },
        {
            key: "deepEquals",
            value: function deepEquals(a, b) {
                if (a === b) return true;
                if (a && b && _typeof(a) == 'object' && _typeof(b) == 'object') {
                    var arrA = Array.isArray(a), arrB = Array.isArray(b), i, length, key;
                    if (arrA && arrB) {
                        length = a.length;
                        if (length !== b.length) return false;
                        for(i = length; i-- !== 0;){
                            if (!this.deepEquals(a[i], b[i])) return false;
                        }
                        return true;
                    }
                    if (arrA !== arrB) return false;
                    var dateA = a instanceof Date, dateB = b instanceof Date;
                    if (dateA !== dateB) return false;
                    if (dateA && dateB) return a.getTime() === b.getTime();
                    var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
                    if (regexpA !== regexpB) return false;
                    if (regexpA && regexpB) return a.toString() === b.toString();
                    var keys = Object.keys(a);
                    length = keys.length;
                    if (length !== Object.keys(b).length) return false;
                    for(i = length; i-- !== 0;){
                        if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
                    }
                    for(i = length; i-- !== 0;){
                        key = keys[i];
                        if (!this.deepEquals(a[key], b[key])) return false;
                    }
                    return true;
                }
                /*eslint no-self-compare: "off"*/ return a !== a && b !== b;
            }
        },
        {
            key: "resolveFieldData",
            value: function resolveFieldData(data, field) {
                if (data && Object.keys(data).length && field) {
                    if (this.isFunction(field)) return field(data);
                    else if (ObjectUtils.isNotEmpty(data[field])) return data[field];
                    else if (field.indexOf('.') === -1) return data[field];
                    else {
                        var fields = field.split('.');
                        var value = data;
                        for(var i = 0, len = fields.length; i < len; ++i){
                            if (value == null) return null;
                            value = value[fields[i]];
                        }
                        return value;
                    }
                } else return null;
            }
        },
        {
            key: "isFunction",
            value: function isFunction(obj) {
                return !!(obj && obj.constructor && obj.call && obj.apply);
            }
        },
        {
            key: "isLetter",
            value: function isLetter(_char) {
                return _char && (_char.toUpperCase() != _char.toLowerCase() || _char.codePointAt(0) > 127);
            }
        },
        {
            key: "findDiffKeys",
            value: function findDiffKeys(obj1, obj2) {
                if (!obj1 || !obj2) return {};
                return Object.keys(obj1).filter(function(key) {
                    return !obj2.hasOwnProperty(key);
                }).reduce(function(result, current) {
                    result[current] = obj1[current];
                    return result;
                }, {});
            }
        },
        {
            key: "reduceKeys",
            value: function reduceKeys(obj, startsWiths) {
                var result = {};
                if (!obj || !startsWiths || startsWiths.length === 0) return result;
                Object.keys(obj).filter(function(key) {
                    return startsWiths.some(function(value) {
                        return key.startsWith(value);
                    });
                }).forEach(function(key) {
                    result[key] = obj[key];
                    delete obj[key];
                });
                return result;
            }
        },
        {
            key: "reorderArray",
            value: function reorderArray(value, from, to) {
                var target;
                if (value && from !== to) {
                    if (to >= value.length) {
                        target = to - value.length;
                        while(target-- + 1)value.push(undefined);
                    }
                    value.splice(to, 0, value.splice(from, 1)[0]);
                }
            }
        },
        {
            key: "findIndexInList",
            value: function findIndexInList(value, list, dataKey) {
                var _this = this;
                if (list) return dataKey ? list.findIndex(function(item) {
                    return _this.equals(item, value, dataKey);
                }) : list.findIndex(function(item) {
                    return item === value;
                });
                return -1;
            }
        },
        {
            key: "getJSXElement",
            value: function getJSXElement(obj) {
                for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
                return this.isFunction(obj) ? obj.apply(void 0, params) : obj;
            }
        },
        {
            key: "getPropValue",
            value: function getPropValue(obj) {
                for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
                var methodParams = params;
                if (params && params.length === 1) methodParams = params[0];
                return this.isFunction(obj) ? obj.apply(void 0, _toConsumableArray(methodParams)) : obj;
            }
        },
        {
            key: "getRefElement",
            value: function getRefElement(ref) {
                if (ref) return _typeof(ref) === 'object' && ref.hasOwnProperty('current') ? ref.current : ref;
                return null;
            }
        },
        {
            key: "combinedRefs",
            value: function combinedRefs(innerRef, forwardRef) {
                if (innerRef && forwardRef) {
                    if (typeof forwardRef === 'function') forwardRef(innerRef.current);
                    else forwardRef.current = innerRef.current;
                }
            }
        },
        {
            key: "removeAccents",
            value: function removeAccents(str) {
                if (str && str.search(/[\xC0-\xFF]/g) > -1) str = str.replace(/[\xC0-\xC5]/g, 'A').replace(/[\xC6]/g, 'AE').replace(/[\xC7]/g, 'C').replace(/[\xC8-\xCB]/g, 'E').replace(/[\xCC-\xCF]/g, 'I').replace(/[\xD0]/g, 'D').replace(/[\xD1]/g, 'N').replace(/[\xD2-\xD6\xD8]/g, 'O').replace(/[\xD9-\xDC]/g, 'U').replace(/[\xDD]/g, 'Y').replace(/[\xDE]/g, 'P').replace(/[\xE0-\xE5]/g, 'a').replace(/[\xE6]/g, 'ae').replace(/[\xE7]/g, 'c').replace(/[\xE8-\xEB]/g, 'e').replace(/[\xEC-\xEF]/g, 'i').replace(/[\xF1]/g, 'n').replace(/[\xF2-\xF6\xF8]/g, 'o').replace(/[\xF9-\xFC]/g, 'u').replace(/[\xFE]/g, 'p').replace(/[\xFD\xFF]/g, 'y');
                return str;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty(value) {
                return value === null || value === undefined || value === '' || Array.isArray(value) && value.length === 0 || !(value instanceof Date) && _typeof(value) === 'object' && Object.keys(value).length === 0;
            }
        },
        {
            key: "isNotEmpty",
            value: function isNotEmpty(value) {
                return !this.isEmpty(value);
            }
        },
        {
            key: "sort",
            value: function sort(value1, value2) {
                var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                var locale = arguments.length > 3 ? arguments[3] : undefined;
                var nullSortOrder = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
                var result = ObjectUtils.compare(value1, value2, locale, order);
                var finalSortOrder = order;
                // nullSortOrder == 1 means Excel like sort nulls at bottom
                if (ObjectUtils.isEmpty(value1) || ObjectUtils.isEmpty(value2)) finalSortOrder = nullSortOrder === 1 ? order : nullSortOrder;
                return finalSortOrder * result;
            }
        },
        {
            key: "compare",
            value: function compare(value1, value2, locale) {
                var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
                var result = -1;
                var emptyValue1 = ObjectUtils.isEmpty(value1);
                var emptyValue2 = ObjectUtils.isEmpty(value2);
                if (emptyValue1 && emptyValue2) result = 0;
                else if (emptyValue1) result = order;
                else if (emptyValue2) result = -order;
                else if (typeof value1 === 'string' && typeof value2 === 'string') result = value1.localeCompare(value2, locale, {
                    numeric: true
                });
                else result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
                return result;
            }
        }
    ]);
    return ObjectUtils;
}();
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var IconUtils = /*#__PURE__*/ function() {
    function IconUtils() {
        _classCallCheck(this, IconUtils);
    }
    _createClass(IconUtils, null, [
        {
            key: "getJSXIcon",
            value: function getJSXIcon(icon) {
                var iconProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var content = null;
                if (icon !== null) {
                    var iconType = _typeof(icon);
                    var className = classNames(iconProps.className, iconType === 'string' && icon);
                    content = /*#__PURE__*/ _react.createElement("span", _extends({}, iconProps, {
                        className: className
                    }));
                    if (iconType !== 'string') {
                        var defaultContentOptions = _objectSpread({
                            iconProps: iconProps,
                            element: content
                        }, options);
                        return ObjectUtils.getJSXElement(icon, defaultContentOptions);
                    }
                }
                return content;
            }
        }
    ]);
    return IconUtils;
}();
var lastId = 0;
function UniqueComponentId() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'pr_id_';
    lastId++;
    return "".concat(prefix).concat(lastId);
}
function handler() {
    var zIndexes = [];
    var generateZIndex = function generateZIndex(key, autoZIndex) {
        var baseZIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 999;
        var lastZIndex = getLastZIndex(key, autoZIndex, baseZIndex);
        var newZIndex = lastZIndex.value + (lastZIndex.key === key ? 0 : baseZIndex) + 1;
        zIndexes.push({
            key: key,
            value: newZIndex
        });
        return newZIndex;
    };
    var revertZIndex = function revertZIndex(zIndex) {
        zIndexes = zIndexes.filter(function(obj) {
            return obj.value !== zIndex;
        });
    };
    var getCurrentZIndex = function getCurrentZIndex(key, autoZIndex) {
        return getLastZIndex(key, autoZIndex).value;
    };
    var getLastZIndex = function getLastZIndex(key, autoZIndex) {
        var baseZIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        return _toConsumableArray(zIndexes).reverse().find(function(obj) {
            return autoZIndex ? true : obj.key === key;
        }) || {
            key: key,
            value: baseZIndex
        };
    };
    var getZIndex = function getZIndex(el) {
        return el ? parseInt(el.style.zIndex, 10) || 0 : 0;
    };
    return {
        get: getZIndex,
        set: function set(key, el, autoZIndex, baseZIndex) {
            if (el) el.style.zIndex = String(generateZIndex(key, autoZIndex, baseZIndex));
        },
        clear: function clear(el) {
            if (el) {
                revertZIndex(ZIndexUtils.get(el));
                el.style.zIndex = '';
            }
        },
        getCurrent: function getCurrent(key, autoZIndex) {
            return getCurrentZIndex(key, autoZIndex);
        }
    };
}
var ZIndexUtils = handler();

},{"react":"6wC8C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"24Mwm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>Button);
var _react = require("react");
var _ripple = require("primereact/ripple");
var _tooltip = require("primereact/tooltip");
var _utils = require("primereact/utils");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var Button = /*#__PURE__*/ _react.memo(/*#__PURE__*/ _react.forwardRef(function(props, ref) {
    var elementRef = _react.useRef(ref);
    _react.useEffect(function() {
        (0, _utils.ObjectUtils).combinedRefs(elementRef, ref);
    }, [
        elementRef,
        ref
    ]);
    if (props.visible === false) return null;
    var createIcon = function createIcon() {
        var icon = props.loading ? props.loadingIcon : props.icon;
        var className = (0, _utils.classNames)('p-button-icon p-c', _defineProperty({
            'p-button-loading-icon': props.loading
        }, "p-button-icon-".concat(props.iconPos), props.label));
        return (0, _utils.IconUtils).getJSXIcon(icon, {
            className: className
        }, {
            props: props
        });
    };
    var createLabel = function createLabel() {
        if (props.label) return /*#__PURE__*/ _react.createElement("span", {
            className: "p-button-label p-c"
        }, props.label);
        return !props.children && !props.label && /*#__PURE__*/ _react.createElement("span", {
            className: "p-button-label p-c",
            dangerouslySetInnerHTML: {
                __html: '&nbsp;'
            }
        });
    };
    var createBadge = function createBadge() {
        if (props.badge) {
            var badgeClassName = (0, _utils.classNames)('p-badge', props.badgeClassName);
            return /*#__PURE__*/ _react.createElement("span", {
                className: badgeClassName
            }, props.badge);
        }
        return null;
    };
    var disabled = props.disabled || props.loading;
    var showTooltip = !disabled || props.tooltipOptions && props.tooltipOptions.showOnDisabled;
    var hasTooltip = (0, _utils.ObjectUtils).isNotEmpty(props.tooltip) && showTooltip;
    var otherProps = (0, _utils.ObjectUtils).findDiffKeys(props, Button.defaultProps);
    var className = (0, _utils.classNames)('p-button p-component', props.className, _defineProperty({
        'p-button-icon-only': (props.icon || props.loading && props.loadingIcon) && !props.label && !props.children,
        'p-button-vertical': (props.iconPos === 'top' || props.iconPos === 'bottom') && props.label,
        'p-disabled': disabled,
        'p-button-loading': props.loading,
        'p-button-loading-label-only': props.loading && !props.icon && props.label
    }, "p-button-loading-".concat(props.iconPos), props.loading && props.loadingIcon && props.label));
    var icon = createIcon();
    var label = createLabel();
    var badge = createBadge();
    var defaultAriaLabel = props.label ? props.label + (props.badge ? ' ' + props.badge : '') : props['aria-label'];
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("button", _extends({
        ref: elementRef,
        "aria-label": defaultAriaLabel
    }, otherProps, {
        className: className,
        disabled: disabled
    }), icon, label, props.children, badge, /*#__PURE__*/ _react.createElement((0, _ripple.Ripple), null)), hasTooltip && /*#__PURE__*/ _react.createElement((0, _tooltip.Tooltip), _extends({
        target: elementRef,
        content: props.tooltip
    }, props.tooltipOptions)));
}));
Button.displayName = 'Button';
Button.defaultProps = {
    __TYPE: 'Button',
    label: null,
    icon: null,
    iconPos: 'left',
    badge: null,
    badgeClassName: null,
    tooltip: null,
    tooltipOptions: null,
    disabled: false,
    loading: false,
    loadingIcon: 'pi pi-spinner pi-spin',
    visible: true
};

},{"react":"6wC8C","primereact/ripple":"501Po","primereact/tooltip":"eY1yM","primereact/utils":"2f5Fe","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"501Po":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Ripple", ()=>Ripple);
var _react = require("react");
var _api = require("primereact/api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _hooks = require("primereact/hooks");
var _utils = require("primereact/utils");
var Ripple = /*#__PURE__*/ _react.memo(/*#__PURE__*/ _react.forwardRef(function() {
    var inkRef = _react.useRef(null);
    var targetRef = _react.useRef(null);
    var getTarget = function getTarget() {
        return inkRef.current && inkRef.current.parentElement;
    };
    var bindEvents = function bindEvents() {
        if (targetRef.current) {
            targetRef.current.addEventListener('mousedown', onMouseDown);
            (0, _utils.DomHandler).isTouchDevice() && targetRef.current.addEventListener('touchstart', onTouchStart);
        }
    };
    var unbindEvents = function unbindEvents() {
        if (targetRef.current) {
            targetRef.current.removeEventListener('mousedown', onMouseDown);
            (0, _utils.DomHandler).isTouchDevice() && targetRef.current.removeEventListener('touchstart', onTouchStart);
        }
    };
    var onTouchStart = function onTouchStart(event) {
        var offset = (0, _utils.DomHandler).getOffset(targetRef.current);
        var offsetX = event.targetTouches[0].pageX - offset.left + document.body.scrollTop - (0, _utils.DomHandler).getWidth(inkRef.current) / 2;
        var offsetY = event.targetTouches[0].pageY - offset.top + document.body.scrollLeft - (0, _utils.DomHandler).getHeight(inkRef.current) / 2;
        activateRipple(offsetX, offsetY);
    };
    var onMouseDown = function onMouseDown(event) {
        if ((0, _utils.DomHandler).isTouchDevice()) // already started ripple with onTouchStart
        return;
        var offset = (0, _utils.DomHandler).getOffset(targetRef.current);
        var offsetX = event.pageX - offset.left + document.body.scrollTop - (0, _utils.DomHandler).getWidth(inkRef.current) / 2;
        var offsetY = event.pageY - offset.top + document.body.scrollLeft - (0, _utils.DomHandler).getHeight(inkRef.current) / 2;
        activateRipple(offsetX, offsetY);
    };
    var activateRipple = function activateRipple(offsetX, offsetY) {
        if (!inkRef.current || getComputedStyle(inkRef.current, null).display === 'none') return;
        (0, _utils.DomHandler).removeClass(inkRef.current, 'p-ink-active');
        if (!(0, _utils.DomHandler).getHeight(inkRef.current) && !(0, _utils.DomHandler).getWidth(inkRef.current)) {
            var d = Math.max((0, _utils.DomHandler).getOuterWidth(targetRef.current), (0, _utils.DomHandler).getOuterHeight(targetRef.current));
            inkRef.current.style.height = d + 'px';
            inkRef.current.style.width = d + 'px';
        }
        inkRef.current.style.top = offsetY + 'px';
        inkRef.current.style.left = offsetX + 'px';
        (0, _utils.DomHandler).addClass(inkRef.current, 'p-ink-active');
    };
    var onAnimationEnd = function onAnimationEnd(event) {
        (0, _utils.DomHandler).removeClass(event.currentTarget, 'p-ink-active');
    };
    (0, _hooks.useMountEffect)(function() {
        if (inkRef.current) {
            targetRef.current = getTarget();
            bindEvents();
        }
    });
    (0, _hooks.useUpdateEffect)(function() {
        if (inkRef.current && !targetRef.current) {
            targetRef.current = getTarget();
            bindEvents();
        }
    });
    (0, _hooks.useUnmountEffect)(function() {
        if (inkRef.current) {
            targetRef.current = null;
            unbindEvents();
        }
    });
    return (0, _apiDefault.default).ripple ? /*#__PURE__*/ _react.createElement("span", {
        role: "presentation",
        ref: inkRef,
        className: "p-ink",
        onAnimationEnd: onAnimationEnd
    }) : null;
}));
Ripple.displayName = 'Ripple';
Ripple.defaultProps = {
    __TYPE: 'Ripple'
};

},{"react":"6wC8C","primereact/api":"5sLxO","primereact/hooks":"9RLkJ","primereact/utils":"2f5Fe","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9RLkJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-enable */ parcelHelpers.export(exports, "useEventListener", ()=>useEventListener);
parcelHelpers.export(exports, "useInterval", ()=>useInterval);
parcelHelpers.export(exports, "useLocalStorage", ()=>useLocalStorage);
parcelHelpers.export(exports, "useMountEffect", ()=>useMountEffect);
parcelHelpers.export(exports, "useOverlayListener", ()=>useOverlayListener);
parcelHelpers.export(exports, "useOverlayScrollListener", ()=>useOverlayScrollListener);
parcelHelpers.export(exports, "usePrevious", ()=>usePrevious);
parcelHelpers.export(exports, "useResizeListener", ()=>useResizeListener);
parcelHelpers.export(exports, "useSessionStorage", ()=>useSessionStorage);
parcelHelpers.export(exports, "useStorage", ()=>useStorage);
parcelHelpers.export(exports, "useTimeout", ()=>useTimeout);
parcelHelpers.export(exports, "useUnmountEffect", ()=>useUnmountEffect);
parcelHelpers.export(exports, "useUpdateEffect", ()=>useUpdateEffect);
var _react = require("react");
var _utils = require("primereact/utils");
var usePrevious = function usePrevious(newValue) {
    var ref = _react.useRef(undefined);
    _react.useEffect(function() {
        ref.current = newValue;
    });
    return ref.current;
};
/* eslint-disable */ var useMountEffect = function useMountEffect(fn) {
    return _react.useEffect(fn, []);
};
/* eslint-enable */ /* eslint-disable */ var useUpdateEffect = function useUpdateEffect(fn, deps) {
    var mounted = _react.useRef(false);
    return _react.useEffect(function() {
        if (!mounted.current) {
            mounted.current = true;
            return;
        }
        return fn && fn();
    }, deps);
};
/* eslint-enable */ /* eslint-disable */ var useUnmountEffect = function useUnmountEffect(fn) {
    return _react.useEffect(function() {
        return fn;
    }, []);
};
/* eslint-enable */ /* eslint-disable */ var useEventListener = function useEventListener(_ref) {
    var _ref$target = _ref.target, target = _ref$target === void 0 ? 'document' : _ref$target, type = _ref.type, listener = _ref.listener, options = _ref.options, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    var targetRef = _react.useRef(null);
    var listenerRef = _react.useRef(null);
    var prevOptions = usePrevious(options);
    var bind = function bind() {
        var bindOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ((0, _utils.ObjectUtils).isNotEmpty(bindOptions.target)) {
            unbind();
            (bindOptions.when || when) && (targetRef.current = (0, _utils.DomHandler).getTargetElement(bindOptions.target));
        }
        if (!listenerRef.current && targetRef.current) {
            listenerRef.current = function(event) {
                return listener && listener(event);
            };
            targetRef.current.addEventListener(type, listenerRef.current, options);
        }
    };
    var unbind = function unbind() {
        if (listenerRef.current) {
            targetRef.current.removeEventListener(type, listenerRef.current, options);
            listenerRef.current = null;
        }
    };
    _react.useEffect(function() {
        if (when) targetRef.current = (0, _utils.DomHandler).getTargetElement(target);
        else {
            unbind();
            targetRef.current = null;
        }
    }, [
        target,
        when
    ]);
    _react.useEffect(function() {
        if (listenerRef.current && (listenerRef.current !== listener || prevOptions !== options)) {
            unbind();
            when && bind();
        }
    }, [
        listener,
        options
    ]);
    useUnmountEffect(function() {
        unbind();
    });
    return [
        bind,
        unbind
    ];
};
/* eslint-enable */ function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
/* eslint-disable */ var useOverlayScrollListener = function useOverlayScrollListener(_ref) {
    var target = _ref.target, listener = _ref.listener, options = _ref.options, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    var targetRef = _react.useRef(null);
    var listenerRef = _react.useRef(null);
    var scrollableParents = _react.useRef([]);
    var prevOptions = usePrevious(options);
    var bind = function bind() {
        var bindOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ((0, _utils.ObjectUtils).isNotEmpty(bindOptions.target)) {
            unbind();
            (bindOptions.when || when) && (targetRef.current = (0, _utils.DomHandler).getTargetElement(bindOptions.target));
        }
        if (!listenerRef.current && targetRef.current) {
            var nodes = scrollableParents.current = (0, _utils.DomHandler).getScrollableParents(targetRef.current);
            listenerRef.current = function(event) {
                return listener && listener(event);
            };
            nodes.forEach(function(node) {
                return node.addEventListener('scroll', listenerRef.current, options);
            });
        }
    };
    var unbind = function unbind() {
        if (listenerRef.current) {
            var nodes = scrollableParents.current;
            nodes.forEach(function(node) {
                return node.removeEventListener('scroll', listenerRef.current, options);
            });
            listenerRef.current = null;
        }
    };
    _react.useEffect(function() {
        if (when) targetRef.current = (0, _utils.DomHandler).getTargetElement(target);
        else {
            unbind();
            targetRef.current = null;
        }
    }, [
        target,
        when
    ]);
    _react.useEffect(function() {
        if (listenerRef.current && (listenerRef.current !== listener || prevOptions !== options)) {
            unbind();
            when && bind();
        }
    }, [
        listener,
        options
    ]);
    useUnmountEffect(function() {
        unbind();
    });
    return [
        bind,
        unbind
    ];
};
/* eslint-enable */ var useResizeListener = function useResizeListener(_ref) {
    var listener = _ref.listener;
    return useEventListener({
        target: 'window',
        type: 'resize',
        listener: listener
    });
};
var useOverlayListener = function useOverlayListener(_ref) {
    var target = _ref.target, overlay = _ref.overlay, _listener = _ref.listener, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    var targetRef = _react.useRef(null);
    var overlayRef = _react.useRef(null);
    /**
   * The parameters of the 'listener' method in the following event handlers;
   * @param {Event} event A click event of the document.
   * @param {string} options.type The custom type to detect event.
   * @param {boolean} options.valid It is controlled by PrimeReact. It is determined whether it is valid or not according to some custom validation.
   */ var _useEventListener = useEventListener({
        type: 'click',
        listener: function listener(event) {
            _listener && _listener(event, {
                type: 'outside',
                valid: event.which !== 3 && isOutsideClicked(event)
            });
        }
    }), _useEventListener2 = _slicedToArray(_useEventListener, 2), bindDocumentClickListener = _useEventListener2[0], unbindDocumentClickListener = _useEventListener2[1];
    var _useResizeListener = useResizeListener({
        listener: function listener(event) {
            _listener && _listener(event, {
                type: 'resize',
                valid: !(0, _utils.DomHandler).isTouchDevice()
            });
        }
    }), _useResizeListener2 = _slicedToArray(_useResizeListener, 2), bindWindowResizeListener = _useResizeListener2[0], unbindWindowResizeListener = _useResizeListener2[1];
    var _useOverlayScrollList = useOverlayScrollListener({
        target: targetRef,
        listener: function listener(event) {
            _listener && _listener(event, {
                type: 'scroll',
                valid: true
            });
        }
    }), _useOverlayScrollList2 = _slicedToArray(_useOverlayScrollList, 2), bindOverlayScrollListener = _useOverlayScrollList2[0], unbindOverlayScrollListener = _useOverlayScrollList2[1];
    var isOutsideClicked = function isOutsideClicked(event) {
        return targetRef.current && !(targetRef.current.isSameNode(event.target) || targetRef.current.contains(event.target) || overlayRef.current && overlayRef.current.contains(event.target));
    };
    var bind = function bind() {
        bindDocumentClickListener();
        bindWindowResizeListener();
        bindOverlayScrollListener();
    };
    var unbind = function unbind() {
        unbindDocumentClickListener();
        unbindWindowResizeListener();
        unbindOverlayScrollListener();
    };
    _react.useEffect(function() {
        if (when) {
            targetRef.current = (0, _utils.DomHandler).getTargetElement(target);
            overlayRef.current = (0, _utils.DomHandler).getTargetElement(overlay);
        } else {
            unbind();
            targetRef.current = overlayRef.current = null;
        }
    }, [
        target,
        overlay,
        when
    ]);
    _react.useEffect(function() {
        unbind();
    // when && bind();
    }, [
        when
    ]);
    useUnmountEffect(function() {
        unbind();
    });
    return [
        bind,
        unbind
    ];
};
/* eslint-enable */ /* eslint-disable */ var useInterval = function useInterval(fn) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var when = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var timeout = _react.useRef(null);
    var savedCallback = _react.useRef(null);
    var clear = _react.useCallback(function() {
        return clearInterval(timeout.current);
    }, [
        timeout.current
    ]);
    _react.useEffect(function() {
        savedCallback.current = fn;
    });
    _react.useEffect(function() {
        function callback() {
            savedCallback.current();
        }
        if (when) {
            timeout.current = setInterval(callback, delay);
            return clear;
        } else clear();
    }, [
        delay,
        when
    ]);
    useUnmountEffect(function() {
        clear();
    });
    return [
        clear
    ];
};
/* eslint-enable */ /**
 * Hook to wrap around useState that stores the value in the browser local/session storage.
 *
 * @param {any} initialValue the initial value to store
 * @param {string} key the key to store the value in local/session storage
 * @param {string} storage either 'local' or 'session' for what type of storage
 * @returns a stateful value, and a function to update it.
 */ var useStorage = function useStorage(initialValue, key) {
    var storage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'local';
    // Since the local storage API isn't available in server-rendering environments,
    // we check that typeof window !== 'undefined' to make SSR and SSG work properly.
    var storageAvailable = typeof window !== 'undefined';
    // subscribe to window storage event so changes in one tab to a stored value
    // are properly reflected in all tabs
    var _useEventListener = useEventListener({
        target: 'window',
        type: 'storage',
        listener: function listener(event) {
            var area = storage === 'local' ? window.localStorage : window.sessionStorage;
            if (event.storageArea === area && event.key === key) setStoredValue(event.newValue || undefined);
        }
    }), _useEventListener2 = _slicedToArray(_useEventListener, 2), bindWindowStorageListener = _useEventListener2[0], unbindWindowStorageListener = _useEventListener2[1];
    var _React$useState = _react.useState(function() {
        if (!storageAvailable) return initialValue;
        try {
            var item = storage === 'local' ? window.localStorage.getItem(key) : window.sessionStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            // If error also return initialValue
            return initialValue;
        }
    }), _React$useState2 = _slicedToArray(_React$useState, 2), storedValue = _React$useState2[0], setStoredValue = _React$useState2[1];
    var setValue = function setValue(value) {
        try {
            // Allow value to be a function so we have same API as useState
            var valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            if (storageAvailable) {
                var serializedValue = JSON.stringify(valueToStore);
                storage === 'local' ? window.localStorage.setItem(key, serializedValue) : window.sessionStorage.setItem(key, serializedValue);
            }
        } catch (error) {
            throw new Error("PrimeReact useStorage: Failed to serialize the value at key: ".concat(key));
        }
    };
    _react.useEffect(function() {
        bindWindowStorageListener();
        return function() {
            return unbindWindowStorageListener();
        };
    }, []);
    return [
        storedValue,
        setValue
    ];
};
/**
 * Hook to wrap around useState that stores the value in the browser local storage.
 *
 * @param {any} initialValue the initial value to store
 * @param {string} key the key to store the value in local storage
 * @returns a stateful value, and a function to update it.
 */ var useLocalStorage = function useLocalStorage(initialValue, key) {
    return useStorage(initialValue, key, 'local');
};
/**
 * Hook to wrap around useState that stores the value in the browser session storage.
 *
 * @param {any} initialValue the initial value to store
 * @param {string} key the key to store the value in session storage
 * @returns a stateful value, and a function to update it.
 */ var useSessionStorage = function useSessionStorage(initialValue, key) {
    return useStorage(initialValue, key, 'session');
};
/* eslint-enable */ /* eslint-disable */ var useTimeout = function useTimeout(fn) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var when = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var timeout = _react.useRef(null);
    var savedCallback = _react.useRef(null);
    var clear = _react.useCallback(function() {
        return clearTimeout(timeout.current);
    }, [
        timeout.current
    ]);
    _react.useEffect(function() {
        savedCallback.current = fn;
    });
    _react.useEffect(function() {
        function callback() {
            savedCallback.current();
        }
        if (when) {
            timeout.current = setTimeout(callback, delay);
            return clear;
        } else clear();
    }, [
        delay,
        when
    ]);
    useUnmountEffect(function() {
        clear();
    });
    return [
        clear
    ];
};

},{"react":"6wC8C","primereact/utils":"2f5Fe","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"eY1yM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tooltip", ()=>Tooltip);
var _react = require("react");
var _api = require("primereact/api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _hooks = require("primereact/hooks");
var _portal = require("primereact/portal");
var _utils = require("primereact/utils");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var Tooltip = /*#__PURE__*/ _react.memo(/*#__PURE__*/ _react.forwardRef(function(props, ref) {
    var _React$useState = _react.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), visibleState = _React$useState2[0], setVisibleState = _React$useState2[1];
    var _React$useState3 = _react.useState(props.position), _React$useState4 = _slicedToArray(_React$useState3, 2), positionState = _React$useState4[0], setPositionState = _React$useState4[1];
    var _React$useState5 = _react.useState(''), _React$useState6 = _slicedToArray(_React$useState5, 2), classNameState = _React$useState6[0], setClassNameState = _React$useState6[1];
    var elementRef = _react.useRef(null);
    var textRef = _react.useRef(null);
    var currentTargetRef = _react.useRef(null);
    var containerSize = _react.useRef(null);
    var allowHide = _react.useRef(true);
    var timeouts = _react.useRef({});
    var currentMouseEvent = _react.useRef(null);
    var _useResizeListener = (0, _hooks.useResizeListener)({
        listener: function listener(event) {
            !(0, _utils.DomHandler).isTouchDevice() && hide(event);
        }
    }), _useResizeListener2 = _slicedToArray(_useResizeListener, 2), bindWindowResizeListener = _useResizeListener2[0], unbindWindowResizeListener = _useResizeListener2[1];
    var _useOverlayScrollList = (0, _hooks.useOverlayScrollListener)({
        target: currentTargetRef.current,
        listener: function listener(event) {
            hide(event);
        },
        when: visibleState
    }), _useOverlayScrollList2 = _slicedToArray(_useOverlayScrollList, 2), bindOverlayScrollListener = _useOverlayScrollList2[0], unbindOverlayScrollListener = _useOverlayScrollList2[1];
    var isTargetContentEmpty = function isTargetContentEmpty(target) {
        return !(props.content || getTargetOption(target, 'tooltip'));
    };
    var isContentEmpty = function isContentEmpty(target) {
        return !(props.content || getTargetOption(target, 'tooltip') || props.children);
    };
    var isMouseTrack = function isMouseTrack(target) {
        return getTargetOption(target, 'mousetrack') || props.mouseTrack;
    };
    var isDisabled = function isDisabled(target) {
        return getTargetOption(target, 'disabled') === 'true' || hasTargetOption(target, 'disabled') || props.disabled;
    };
    var isShowOnDisabled = function isShowOnDisabled(target) {
        return getTargetOption(target, 'showondisabled') || props.showOnDisabled;
    };
    var isAutoHide = function isAutoHide() {
        return getTargetOption(currentTargetRef.current, 'autohide') || props.autoHide;
    };
    var getTargetOption = function getTargetOption(target, option) {
        return hasTargetOption(target, "data-pr-".concat(option)) ? target.getAttribute("data-pr-".concat(option)) : null;
    };
    var hasTargetOption = function hasTargetOption(target, option) {
        return target && target.hasAttribute(option);
    };
    var getEvents = function getEvents(target) {
        var showEvents = [
            getTargetOption(target, 'showevent') || props.showEvent
        ];
        var hideEvents = [
            getTargetOption(target, 'hideevent') || props.hideEvent
        ];
        if (isMouseTrack(target)) {
            showEvents = [
                'mousemove'
            ];
            hideEvents = [
                'mouseleave'
            ];
        } else {
            var event = getTargetOption(target, 'event') || props.event;
            if (event === 'focus') {
                showEvents = [
                    'focus'
                ];
                hideEvents = [
                    'blur'
                ];
            }
            if (event === 'both') {
                showEvents = [
                    'focus',
                    'mouseenter'
                ];
                hideEvents = [
                    'blur',
                    'mouseleave'
                ];
            }
        }
        return {
            showEvents: showEvents,
            hideEvents: hideEvents
        };
    };
    var getPosition = function getPosition(target) {
        return getTargetOption(target, 'position') || positionState;
    };
    var getMouseTrackPosition = function getMouseTrackPosition(target) {
        var top = getTargetOption(target, 'mousetracktop') || props.mouseTrackTop;
        var left = getTargetOption(target, 'mousetrackleft') || props.mouseTrackLeft;
        return {
            top: top,
            left: left
        };
    };
    var updateText = function updateText(target, callback) {
        if (textRef.current) {
            var content = getTargetOption(target, 'tooltip') || props.content;
            if (content) {
                textRef.current.innerHTML = ''; // remove children
                textRef.current.appendChild(document.createTextNode(content));
                callback();
            } else if (props.children) callback();
        }
    };
    var updateTooltipState = function updateTooltipState(position) {
        updateText(currentTargetRef.current, function() {
            var _currentMouseEvent$cu = currentMouseEvent.current, x = _currentMouseEvent$cu.pageX, y = _currentMouseEvent$cu.pageY;
            if (props.autoZIndex && !(0, _utils.ZIndexUtils).get(elementRef.current)) (0, _utils.ZIndexUtils).set('tooltip', elementRef.current, (0, _apiDefault.default).autoZIndex, props.baseZIndex || (0, _apiDefault.default).zIndex['tooltip']);
            elementRef.current.style.left = '';
            elementRef.current.style.top = '';
            // GitHub #2695 disable pointer events when autohiding
            if (isAutoHide()) elementRef.current.style.pointerEvents = 'none';
            if ((isMouseTrack(currentTargetRef.current) || position == 'mouse') && !containerSize.current) containerSize.current = {
                width: (0, _utils.DomHandler).getOuterWidth(elementRef.current),
                height: (0, _utils.DomHandler).getOuterHeight(elementRef.current)
            };
            align(currentTargetRef.current, {
                x: x,
                y: y
            }, position);
        });
    };
    var show = function show(e) {
        currentTargetRef.current = e.currentTarget;
        var disabled = isDisabled(currentTargetRef.current);
        var empty = isContentEmpty(isShowOnDisabled(currentTargetRef.current) && disabled ? currentTargetRef.current.firstChild : currentTargetRef.current);
        if (empty || disabled) return;
        currentMouseEvent.current = e;
        if (visibleState) applyDelay('updateDelay', updateTooltipState);
        else {
            // #2653 give the callback a chance to return false and not continue with display
            var success = sendCallback(props.onBeforeShow, {
                originalEvent: e,
                target: currentTargetRef.current
            });
            if (success) applyDelay('showDelay', function() {
                setVisibleState(true);
                sendCallback(props.onShow, {
                    originalEvent: e,
                    target: currentTargetRef.current
                });
            });
        }
    };
    var hide = function hide(e) {
        clearTimeouts();
        if (visibleState) {
            var success = sendCallback(props.onBeforeHide, {
                originalEvent: e,
                target: currentTargetRef.current
            });
            if (success) applyDelay('hideDelay', function() {
                if (!isAutoHide() && allowHide.current === false) return;
                (0, _utils.ZIndexUtils).clear(elementRef.current);
                (0, _utils.DomHandler).removeClass(elementRef.current, 'p-tooltip-active');
                setVisibleState(false);
                sendCallback(props.onHide, {
                    originalEvent: e,
                    target: currentTargetRef.current
                });
            });
        }
    };
    var align = function align(target, coordinate, position) {
        var left = 0, top = 0, currentPosition = position || positionState;
        if ((isMouseTrack(target) || currentPosition == 'mouse') && coordinate) {
            var _containerSize = {
                width: (0, _utils.DomHandler).getOuterWidth(elementRef.current),
                height: (0, _utils.DomHandler).getOuterHeight(elementRef.current)
            };
            left = coordinate.x;
            top = coordinate.y;
            var _getMouseTrackPositio = getMouseTrackPosition(target), mouseTrackTop = _getMouseTrackPositio.top, mouseTrackLeft = _getMouseTrackPositio.left;
            switch(currentPosition){
                case 'left':
                    left -= _containerSize.width + mouseTrackLeft;
                    top -= _containerSize.height / 2 - mouseTrackTop;
                    break;
                case 'right':
                case 'mouse':
                    left += mouseTrackLeft;
                    top -= _containerSize.height / 2 - mouseTrackTop;
                    break;
                case 'top':
                    left -= _containerSize.width / 2 - mouseTrackLeft;
                    top -= _containerSize.height + mouseTrackTop;
                    break;
                case 'bottom':
                    left -= _containerSize.width / 2 - mouseTrackLeft;
                    top += mouseTrackTop;
                    break;
            }
            if (left <= 0 || containerSize.current.width > _containerSize.width) {
                elementRef.current.style.left = '0px';
                elementRef.current.style.right = window.innerWidth - _containerSize.width - left + 'px';
            } else {
                elementRef.current.style.right = '';
                elementRef.current.style.left = left + 'px';
            }
            elementRef.current.style.top = top + 'px';
            (0, _utils.DomHandler).addClass(elementRef.current, 'p-tooltip-active');
        } else {
            var pos = (0, _utils.DomHandler).findCollisionPosition(currentPosition);
            var my = getTargetOption(target, 'my') || props.my || pos.my;
            var at = getTargetOption(target, 'at') || props.at || pos.at;
            elementRef.current.style.padding = '0px';
            (0, _utils.DomHandler).flipfitCollision(elementRef.current, target, my, at, function(calculatedPosition) {
                var _calculatedPosition$a = calculatedPosition.at, atX = _calculatedPosition$a.x, atY = _calculatedPosition$a.y;
                var myX = calculatedPosition.my.x;
                var newPosition = props.at ? atX !== 'center' && atX !== myX ? atX : atY : calculatedPosition.at["".concat(pos.axis)];
                elementRef.current.style.padding = '';
                setPositionState(newPosition);
                updateContainerPosition(newPosition);
                (0, _utils.DomHandler).addClass(elementRef.current, 'p-tooltip-active');
            });
        }
    };
    var updateContainerPosition = function updateContainerPosition(position) {
        if (elementRef.current) {
            var style = getComputedStyle(elementRef.current);
            if (position === 'left') elementRef.current.style.left = parseFloat(style.left) - parseFloat(style.paddingLeft) * 2 + 'px';
            else if (position === 'top') elementRef.current.style.top = parseFloat(style.top) - parseFloat(style.paddingTop) * 2 + 'px';
        }
    };
    var onMouseEnter = function onMouseEnter() {
        if (!isAutoHide()) allowHide.current = false;
    };
    var onMouseLeave = function onMouseLeave(e) {
        if (!isAutoHide()) {
            allowHide.current = true;
            hide(e);
        }
    };
    var bindTargetEvent = function bindTargetEvent(target) {
        if (target) {
            var _getEvents = getEvents(target), showEvents = _getEvents.showEvents, hideEvents = _getEvents.hideEvents;
            var currentTarget = getTarget(target);
            showEvents.forEach(function(event) {
                return currentTarget.addEventListener(event, show);
            });
            hideEvents.forEach(function(event) {
                return currentTarget.addEventListener(event, hide);
            });
        }
    };
    var unbindTargetEvent = function unbindTargetEvent(target) {
        if (target) {
            var _getEvents2 = getEvents(target), showEvents = _getEvents2.showEvents, hideEvents = _getEvents2.hideEvents;
            var currentTarget = getTarget(target);
            showEvents.forEach(function(event) {
                return currentTarget.removeEventListener(event, show);
            });
            hideEvents.forEach(function(event) {
                return currentTarget.removeEventListener(event, hide);
            });
        }
    };
    var applyDelay = function applyDelay(delayProp, callback) {
        clearTimeouts();
        var delay = getTargetOption(currentTargetRef.current, delayProp.toLowerCase()) || props[delayProp];
        !!delay ? timeouts.current["".concat(delayProp)] = setTimeout(function() {
            return callback();
        }, delay) : callback();
    };
    var sendCallback = function sendCallback(callback) {
        if (callback) {
            for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
            var result = callback.apply(void 0, params);
            if (result === undefined) result = true;
            return result;
        }
        return true;
    };
    var clearTimeouts = function clearTimeouts() {
        Object.values(timeouts.current).forEach(function(t) {
            return clearTimeout(t);
        });
    };
    var getTarget = function getTarget(target) {
        if (target) {
            if (isShowOnDisabled(target)) {
                if (!target.hasWrapper) {
                    var wrapper = document.createElement('span');
                    target.parentNode.insertBefore(wrapper, target);
                    wrapper.appendChild(target);
                    target.hasWrapper = true;
                    return wrapper;
                } else return target.parentElement;
            } else if (target.hasWrapper) {
                var _target$parentElement;
                (_target$parentElement = target.parentElement).replaceWith.apply(_target$parentElement, _toConsumableArray(target.parentElement.childNodes));
                delete target.hasWrapper;
            }
            return target;
        }
        return null;
    };
    var updateTargetEvents = function updateTargetEvents(target) {
        unloadTargetEvents(target);
        loadTargetEvents(target);
    };
    var loadTargetEvents = function loadTargetEvents(target) {
        setTargetEventOperations(target || props.target, bindTargetEvent);
    };
    var unloadTargetEvents = function unloadTargetEvents(target) {
        setTargetEventOperations(target || props.target, unbindTargetEvent);
    };
    var setTargetEventOperations = function setTargetEventOperations(target, operation) {
        target = (0, _utils.ObjectUtils).getRefElement(target);
        if (target) {
            if ((0, _utils.DomHandler).isElement(target)) operation(target);
            else {
                var setEvent = function setEvent(target) {
                    var element = (0, _utils.DomHandler).find(document, target);
                    element.forEach(function(el) {
                        operation(el);
                    });
                };
                if (target instanceof Array) target.forEach(function(t) {
                    setEvent(t);
                });
                else setEvent(target);
            }
        }
    };
    (0, _hooks.useMountEffect)(function() {
        loadTargetEvents();
        if (visibleState && currentTargetRef.current && isDisabled(currentTargetRef.current)) hide();
    });
    (0, _hooks.useUpdateEffect)(function() {
        loadTargetEvents();
        return function() {
            unloadTargetEvents();
        };
    }, [
        show,
        hide,
        props.target
    ]);
    (0, _hooks.useUpdateEffect)(function() {
        if (visibleState) {
            var position = getPosition(currentTargetRef.current);
            var classname = getTargetOption(currentTargetRef.current, 'classname');
            setPositionState(position);
            setClassNameState(classname);
            updateTooltipState(position);
            bindWindowResizeListener();
            bindOverlayScrollListener();
        } else {
            setPositionState(props.position);
            setClassNameState('');
            currentTargetRef.current = null;
            containerSize.current = null;
            allowHide.current = true;
        }
        return function() {
            unbindWindowResizeListener();
            unbindOverlayScrollListener();
        };
    }, [
        visibleState
    ]);
    (0, _hooks.useUpdateEffect)(function() {
        if (visibleState) applyDelay('updateDelay', function() {
            updateText(currentTargetRef.current, function() {
                align(currentTargetRef.current);
            });
        });
    }, [
        props.content
    ]);
    (0, _hooks.useUnmountEffect)(function() {
        clearTimeouts();
        unloadTargetEvents();
        (0, _utils.ZIndexUtils).clear(elementRef.current);
    });
    _react.useImperativeHandle(ref, function() {
        return {
            props: props,
            updateTargetEvents: updateTargetEvents,
            loadTargetEvents: loadTargetEvents,
            unloadTargetEvents: unloadTargetEvents,
            show: show,
            hide: hide,
            getElement: function getElement() {
                return elementRef.current;
            },
            getTarget: function getTarget() {
                return currentTargetRef.current;
            }
        };
    });
    var createElement = function createElement() {
        var otherProps = (0, _utils.ObjectUtils).findDiffKeys(props, Tooltip.defaultProps);
        var tooltipClassName = (0, _utils.classNames)('p-tooltip p-component', _defineProperty({}, "p-tooltip-".concat(positionState), true), props.className, classNameState);
        var empty = isTargetContentEmpty(currentTargetRef.current);
        return /*#__PURE__*/ _react.createElement("div", _extends({
            id: props.id,
            ref: elementRef,
            className: tooltipClassName,
            style: props.style,
            role: "tooltip",
            "aria-hidden": visibleState
        }, otherProps, {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        }), /*#__PURE__*/ _react.createElement("div", {
            className: "p-tooltip-arrow"
        }), /*#__PURE__*/ _react.createElement("div", {
            ref: textRef,
            className: "p-tooltip-text"
        }, empty && props.children));
    };
    if (visibleState) {
        var element = createElement();
        return /*#__PURE__*/ _react.createElement((0, _portal.Portal), {
            element: element,
            appendTo: props.appendTo,
            visible: true
        });
    }
    return null;
}));
Tooltip.displayName = 'Tooltip';
Tooltip.defaultProps = {
    __TYPE: 'Tooltip',
    appendTo: null,
    at: null,
    autoHide: true,
    autoZIndex: true,
    baseZIndex: 0,
    className: null,
    content: null,
    disabled: false,
    event: null,
    hideDelay: 0,
    hideEvent: 'mouseleave',
    id: null,
    mouseTrack: false,
    mouseTrackLeft: 5,
    mouseTrackTop: 5,
    my: null,
    onBeforeHide: null,
    onBeforeShow: null,
    onHide: null,
    onShow: null,
    position: 'right',
    showDelay: 0,
    showEvent: 'mouseenter',
    showOnDisabled: false,
    style: null,
    target: null,
    updateDelay: 0
};

},{"react":"6wC8C","primereact/api":"5sLxO","primereact/hooks":"9RLkJ","primereact/portal":"5ahww","primereact/utils":"2f5Fe","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5ahww":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Portal", ()=>Portal);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _api = require("primereact/api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _hooks = require("primereact/hooks");
var _utils = require("primereact/utils");
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var Portal = /*#__PURE__*/ _react.memo(function(props) {
    var _React$useState = _react.useState(props.visible && (0, _utils.DomHandler).hasDOM()), _React$useState2 = _slicedToArray(_React$useState, 2), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    (0, _hooks.useMountEffect)(function() {
        if ((0, _utils.DomHandler).hasDOM() && !mountedState) {
            setMountedState(true);
            props.onMounted && props.onMounted();
        }
    });
    (0, _hooks.useUpdateEffect)(function() {
        props.onMounted && props.onMounted();
    }, [
        mountedState
    ]);
    (0, _hooks.useUnmountEffect)(function() {
        props.onUnmounted && props.onUnmounted();
    });
    var element = props.element || props.children;
    if (element && mountedState) {
        var appendTo = props.appendTo || (0, _apiDefault.default).appendTo || document.body;
        return appendTo === 'self' ? element : /*#__PURE__*/ (0, _reactDomDefault.default).createPortal(element, appendTo);
    }
    return null;
});
Portal.displayName = 'Portal';
Portal.defaultProps = {
    __TYPE: 'Portal',
    element: null,
    appendTo: null,
    visible: false,
    onMounted: null,
    onUnmounted: null
};

},{"react":"6wC8C","react-dom":"7k58v","primereact/api":"5sLxO","primereact/hooks":"9RLkJ","primereact/utils":"2f5Fe","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8MQX5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dialog", ()=>Dialog);
var _react = require("react");
var _api = require("primereact/api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _csstransition = require("primereact/csstransition");
var _hooks = require("primereact/hooks");
var _portal = require("primereact/portal");
var _ripple = require("primereact/ripple");
var _utils = require("primereact/utils");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var Dialog = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
    var _React$useState = _react.useState(props.id), _React$useState2 = _slicedToArray(_React$useState, 2), idState = _React$useState2[0], setIdState = _React$useState2[1];
    var _React$useState3 = _react.useState(false), _React$useState4 = _slicedToArray(_React$useState3, 2), maskVisibleState = _React$useState4[0], setMaskVisibleState = _React$useState4[1];
    var _React$useState5 = _react.useState(false), _React$useState6 = _slicedToArray(_React$useState5, 2), visibleState = _React$useState6[0], setVisibleState = _React$useState6[1];
    var _React$useState7 = _react.useState(props.maximized), _React$useState8 = _slicedToArray(_React$useState7, 2), maximizedState = _React$useState8[0], setMaximizedState = _React$useState8[1];
    var dialogRef = _react.useRef(null);
    var maskRef = _react.useRef(null);
    var contentRef = _react.useRef(null);
    var headerRef = _react.useRef(null);
    var footerRef = _react.useRef(null);
    var closeRef = _react.useRef(null);
    var dragging = _react.useRef(false);
    var resizing = _react.useRef(false);
    var lastPageX = _react.useRef(null);
    var lastPageY = _react.useRef(null);
    var styleElement = _react.useRef(null);
    var attributeSelector = _react.useRef('');
    var maximized = props.onMaximize ? props.maximized : maximizedState;
    var _useEventListener = (0, _hooks.useEventListener)({
        type: 'keydown',
        listener: function listener(event) {
            return onKeyDown(event);
        }
    }), _useEventListener2 = _slicedToArray(_useEventListener, 2), bindDocumentKeyDownListener = _useEventListener2[0], unbindDocumentKeyDownListener = _useEventListener2[1];
    var _useEventListener3 = (0, _hooks.useEventListener)({
        type: 'mousemove',
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onResize(event);
        }
    }), _useEventListener4 = _slicedToArray(_useEventListener3, 2), bindDocumentResizeListener = _useEventListener4[0], unbindDocumentResizeListener = _useEventListener4[1];
    var _useEventListener5 = (0, _hooks.useEventListener)({
        type: 'mouseup',
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onResizeEnd(event);
        }
    }), _useEventListener6 = _slicedToArray(_useEventListener5, 2), bindDocumentResizeEndListener = _useEventListener6[0], unbindDocumentResizEndListener = _useEventListener6[1];
    var _useEventListener7 = (0, _hooks.useEventListener)({
        type: 'mousemove',
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onDrag(event);
        }
    }), _useEventListener8 = _slicedToArray(_useEventListener7, 2), bindDocumentDragListener = _useEventListener8[0], unbindDocumentDragListener = _useEventListener8[1];
    var _useEventListener9 = (0, _hooks.useEventListener)({
        type: 'mouseup',
        target: function target() {
            return window.document;
        },
        listener: function listener(event) {
            return onDragEnd(event);
        }
    }), _useEventListener10 = _slicedToArray(_useEventListener9, 2), bindDocumentDragEndListener = _useEventListener10[0], unbindDocumentDragEndListener = _useEventListener10[1];
    var onClose = function onClose(event) {
        props.onHide();
        event.preventDefault();
    };
    var focus = function focus() {
        var activeElement = document.activeElement;
        var isActiveElementInDialog = activeElement && dialogRef.current && dialogRef.current.contains(activeElement);
        if (!isActiveElementInDialog && props.closable && props.showHeader) closeRef.current.focus();
    };
    var onMaskClick = function onMaskClick(event) {
        if (props.dismissableMask && props.modal && maskRef.current === event.target) onClose(event);
        props.onMaskClick && props.onMaskClick(event);
    };
    var toggleMaximize = function toggleMaximize(event) {
        if (props.onMaximize) props.onMaximize({
            originalEvent: event,
            maximized: !maximized
        });
        else setMaximizedState(function(prevMaximized) {
            return !prevMaximized;
        });
        event.preventDefault();
    };
    var onKeyDown = function onKeyDown(event) {
        var currentTarget = event.currentTarget;
        if (!currentTarget || !currentTarget.primeDialogParams) return;
        var params = currentTarget.primeDialogParams;
        var paramLength = params.length;
        var dialogId = params[paramLength - 1] ? params[paramLength - 1].id : undefined;
        if (dialogId !== idState) return;
        var dialog = document.getElementById(dialogId);
        if (props.closable && props.closeOnEscape && event.key === 'Escape') {
            onClose(event);
            event.stopImmediatePropagation();
            params.splice(paramLength - 1, 1);
        } else if (event.key === 'Tab') {
            event.preventDefault();
            var focusableElements = (0, _utils.DomHandler).getFocusableElements(dialog);
            if (focusableElements && focusableElements.length > 0) {
                if (!document.activeElement) focusableElements[0].focus();
                else {
                    var focusedIndex = focusableElements.indexOf(document.activeElement);
                    if (event.shiftKey) {
                        if (focusedIndex === -1 || focusedIndex === 0) focusableElements[focusableElements.length - 1].focus();
                        else focusableElements[focusedIndex - 1].focus();
                    } else if (focusedIndex === -1 || focusedIndex === focusableElements.length - 1) focusableElements[0].focus();
                    else focusableElements[focusedIndex + 1].focus();
                }
            }
        }
    };
    var onDragStart = function onDragStart(event) {
        if ((0, _utils.DomHandler).hasClass(event.target, 'p-dialog-header-icon') || (0, _utils.DomHandler).hasClass(event.target.parentElement, 'p-dialog-header-icon')) return;
        if (props.draggable) {
            dragging.current = true;
            lastPageX.current = event.pageX;
            lastPageY.current = event.pageY;
            dialogRef.current.style.margin = '0';
            (0, _utils.DomHandler).addClass(document.body, 'p-unselectable-text');
            props.onDragStart && props.onDragStart(event);
        }
    };
    var onDrag = function onDrag(event) {
        if (dragging.current) {
            var width = (0, _utils.DomHandler).getOuterWidth(dialogRef.current);
            var height = (0, _utils.DomHandler).getOuterHeight(dialogRef.current);
            var deltaX = event.pageX - lastPageX.current;
            var deltaY = event.pageY - lastPageY.current;
            var offset = dialogRef.current.getBoundingClientRect();
            var leftPos = offset.left + deltaX;
            var topPos = offset.top + deltaY;
            var viewport = (0, _utils.DomHandler).getViewport();
            dialogRef.current.style.position = 'fixed';
            if (props.keepInViewport) {
                if (leftPos >= props.minX && leftPos + width < viewport.width) {
                    lastPageX.current = event.pageX;
                    dialogRef.current.style.left = leftPos + 'px';
                }
                if (topPos >= props.minY && topPos + height < viewport.height) {
                    lastPageY.current = event.pageY;
                    dialogRef.current.style.top = topPos + 'px';
                }
            } else {
                lastPageX.current = event.pageX;
                dialogRef.current.style.left = leftPos + 'px';
                lastPageY.current = event.pageY;
                dialogRef.current.style.top = topPos + 'px';
            }
            props.onDrag && props.onDrag(event);
        }
    };
    var onDragEnd = function onDragEnd(event) {
        if (dragging.current) {
            dragging.current = false;
            (0, _utils.DomHandler).removeClass(document.body, 'p-unselectable-text');
            props.onDragEnd && props.onDragEnd(event);
        }
    };
    var onResizeStart = function onResizeStart(event) {
        if (props.resizable) {
            resizing.current = true;
            lastPageX.current = event.pageX;
            lastPageY.current = event.pageY;
            (0, _utils.DomHandler).addClass(document.body, 'p-unselectable-text');
            props.onResizeStart && props.onResizeStart(event);
        }
    };
    var convertToPx = function convertToPx(value, property, viewport) {
        !viewport && (viewport = (0, _utils.DomHandler).getViewport());
        var val = parseInt(value);
        if (/^(\d+|(\.\d+))(\.\d+)?%$/.test(value)) return val * (viewport[property] / 100);
        return val;
    };
    var onResize = function onResize(event) {
        if (resizing.current) {
            var deltaX = event.pageX - lastPageX.current;
            var deltaY = event.pageY - lastPageY.current;
            var width = (0, _utils.DomHandler).getOuterWidth(dialogRef.current);
            var height = (0, _utils.DomHandler).getOuterHeight(dialogRef.current);
            var offset = dialogRef.current.getBoundingClientRect();
            var viewport = (0, _utils.DomHandler).getViewport();
            var hasBeenDragged = !parseInt(dialogRef.current.style.top) || !parseInt(dialogRef.current.style.left);
            var minWidth = convertToPx(dialogRef.current.style.minWidth, 'width', viewport);
            var minHeight = convertToPx(dialogRef.current.style.minHeight, 'height', viewport);
            var newWidth = width + deltaX;
            var newHeight = height + deltaY;
            if (hasBeenDragged) {
                newWidth += deltaX;
                newHeight += deltaY;
            }
            if ((!minWidth || newWidth > minWidth) && offset.left + newWidth < viewport.width) dialogRef.current.style.width = newWidth + 'px';
            if ((!minHeight || newHeight > minHeight) && offset.top + newHeight < viewport.height) dialogRef.current.style.height = newHeight + 'px';
            lastPageX.current = event.pageX;
            lastPageY.current = event.pageY;
            props.onResize && props.onResize(event);
        }
    };
    var onResizeEnd = function onResizeEnd(event) {
        if (resizing.current) {
            resizing.current = false;
            (0, _utils.DomHandler).removeClass(document.body, 'p-unselectable-text');
            props.onResizeEnd && props.onResizeEnd(event);
        }
    };
    var resetPosition = function resetPosition() {
        dialogRef.current.style.position = '';
        dialogRef.current.style.left = '';
        dialogRef.current.style.top = '';
        dialogRef.current.style.margin = '';
    };
    var getPositionClass = function getPositionClass() {
        var positions = [
            'center',
            'left',
            'right',
            'top',
            'top-left',
            'top-right',
            'bottom',
            'bottom-left',
            'bottom-right'
        ];
        var pos = positions.find(function(item) {
            return item === props.position || item.replace('-', '') === props.position;
        });
        return pos ? "p-dialog-".concat(pos) : '';
    };
    var onEnter = function onEnter() {
        dialogRef.current.setAttribute(attributeSelector.current, '');
    };
    var onEntered = function onEntered() {
        props.onShow && props.onShow();
        if (props.focusOnShow) focus();
        enableDocumentSettings();
    };
    var onExiting = function onExiting() {
        if (props.modal) (0, _utils.DomHandler).addClass(maskRef.current, 'p-component-overlay-leave');
        if (props.blockScroll) (0, _utils.DomHandler).removeClass(document.body, 'p-overflow-hidden');
    };
    var onExited = function onExited() {
        dragging.current = false;
        (0, _utils.ZIndexUtils).clear(maskRef.current);
        setMaskVisibleState(false);
        disableDocumentSettings();
    };
    var enableDocumentSettings = function enableDocumentSettings() {
        bindGlobalListeners();
        if (props.blockScroll || props.maximizable && maximized) (0, _utils.DomHandler).addClass(document.body, 'p-overflow-hidden');
    };
    var disableDocumentSettings = function disableDocumentSettings() {
        unbindGlobalListeners();
        var isMaximized = props.maximizable && maximized;
        if (props.modal) {
            var hasBlockScroll = document.primeDialogParams && document.primeDialogParams.some(function(param) {
                return param.hasBlockScroll;
            });
            if (hasBlockScroll || isMaximized) (0, _utils.DomHandler).removeClass(document.body, 'p-overflow-hidden');
        } else if (props.blockScroll || isMaximized) (0, _utils.DomHandler).removeClass(document.body, 'p-overflow-hidden');
    };
    var bindGlobalListeners = function bindGlobalListeners() {
        if (props.draggable) {
            bindDocumentDragListener();
            bindDocumentDragEndListener();
        }
        if (props.resizable) {
            bindDocumentResizeListener();
            bindDocumentResizeEndListener();
        }
        bindDocumentKeyDownListener();
        var newParam = {
            id: idState,
            hasBlockScroll: props.blockScroll
        };
        document.primeDialogParams = document.primeDialogParams ? [].concat(_toConsumableArray(document.primeDialogParams), [
            newParam
        ]) : [
            newParam
        ];
    };
    var unbindGlobalListeners = function unbindGlobalListeners() {
        unbindDocumentDragListener();
        unbindDocumentDragEndListener();
        unbindDocumentResizeListener();
        unbindDocumentResizEndListener();
        unbindDocumentKeyDownListener();
        document.primeDialogParams = document.primeDialogParams && document.primeDialogParams.filter(function(param) {
            return param.id !== idState;
        });
    };
    var createStyle = function createStyle() {
        if (!styleElement.current) {
            styleElement.current = (0, _utils.DomHandler).createInlineStyle((0, _apiDefault.default).nonce);
            var innerHTML = '';
            for(var breakpoint in props.breakpoints)innerHTML += "\n                    @media screen and (max-width: ".concat(breakpoint, ") {\n                        .p-dialog[").concat(attributeSelector.current, "] {\n                            width: ").concat(props.breakpoints[breakpoint], " !important;\n                        }\n                    }\n                ");
            styleElement.current.innerHTML = innerHTML;
        }
    };
    var changeScrollOnMaximizable = function changeScrollOnMaximizable() {
        if (!props.blockScroll) {
            var funcName = maximized ? 'addClass' : 'removeClass';
            (0, _utils.DomHandler)[funcName](document.body, 'p-overflow-hidden');
        }
    };
    (0, _hooks.useMountEffect)(function() {
        var unqiueId = (0, _utils.UniqueComponentId)();
        if (!idState) setIdState(unqiueId);
        if (!attributeSelector.current) attributeSelector.current = unqiueId;
        if (props.visible) setMaskVisibleState(true);
        if (props.breakpoints) createStyle();
    });
    (0, _hooks.useUpdateEffect)(function() {
        if (props.visible && !maskVisibleState) setMaskVisibleState(true);
        if (props.visible !== visibleState && maskVisibleState) setVisibleState(props.visible);
    });
    (0, _hooks.useUpdateEffect)(function() {
        if (maskVisibleState) {
            (0, _utils.ZIndexUtils).set('modal', maskRef.current, (0, _apiDefault.default).autoZIndex, props.baseZIndex || (0, _apiDefault.default).zIndex['modal']);
            setVisibleState(true);
        }
    }, [
        maskVisibleState
    ]);
    (0, _hooks.useUpdateEffect)(function() {
        changeScrollOnMaximizable();
    }, [
        props.maximized,
        maximizedState
    ]);
    (0, _hooks.useUnmountEffect)(function() {
        disableDocumentSettings();
        (0, _utils.DomHandler).removeInlineStyle(styleElement.current);
        (0, _utils.ZIndexUtils).clear(maskRef.current);
    });
    _react.useImperativeHandle(ref, function() {
        return {
            props: props,
            resetPosition: resetPosition,
            getElement: function getElement() {
                return dialogRef.current;
            },
            getMask: function getMask() {
                return maskRef.current;
            },
            getContent: function getContent() {
                return contentRef.current;
            },
            getHeader: function getHeader() {
                return headerRef.current;
            },
            getFooter: function getFooter() {
                return footerRef.current;
            },
            getCloseButton: function getCloseButton() {
                return closeRef.current;
            }
        };
    });
    var createCloseIcon = function createCloseIcon() {
        if (props.closable) {
            var ariaLabel = props.ariaCloseIconLabel || (0, _api.localeOption)('close');
            return /*#__PURE__*/ _react.createElement("button", {
                ref: closeRef,
                type: "button",
                className: "p-dialog-header-icon p-dialog-header-close p-link",
                "aria-label": ariaLabel,
                onClick: onClose
            }, /*#__PURE__*/ _react.createElement("span", {
                className: "p-dialog-header-close-icon pi pi-times",
                "aria-hidden": "true"
            }), /*#__PURE__*/ _react.createElement((0, _ripple.Ripple), null));
        }
        return null;
    };
    var createMaximizeIcon = function createMaximizeIcon() {
        var iconClassName = (0, _utils.classNames)('p-dialog-header-maximize-icon pi', {
            'pi-window-maximize': !maximized,
            'pi-window-minimize': maximized
        });
        if (props.maximizable) return /*#__PURE__*/ _react.createElement("button", {
            type: "button",
            className: "p-dialog-header-icon p-dialog-header-maximize p-link",
            onClick: toggleMaximize
        }, /*#__PURE__*/ _react.createElement("span", {
            className: iconClassName
        }), /*#__PURE__*/ _react.createElement((0, _ripple.Ripple), null));
        return null;
    };
    var createHeader = function createHeader() {
        if (props.showHeader) {
            var closeIcon = createCloseIcon();
            var maximizeIcon = createMaximizeIcon();
            var icons = (0, _utils.ObjectUtils).getJSXElement(props.icons, props);
            var header = (0, _utils.ObjectUtils).getJSXElement(props.header, props);
            var headerId = idState + '_header';
            var headerClassName = (0, _utils.classNames)('p-dialog-header', props.headerClassName);
            return /*#__PURE__*/ _react.createElement("div", {
                ref: headerRef,
                style: props.headerStyle,
                className: headerClassName,
                onMouseDown: onDragStart
            }, /*#__PURE__*/ _react.createElement("div", {
                id: headerId,
                className: "p-dialog-title"
            }, header), /*#__PURE__*/ _react.createElement("div", {
                className: "p-dialog-header-icons"
            }, icons, maximizeIcon, closeIcon));
        }
        return null;
    };
    var createContent = function createContent() {
        var className = (0, _utils.classNames)('p-dialog-content', props.contentClassName);
        var contentId = idState + '_content';
        return /*#__PURE__*/ _react.createElement("div", {
            id: contentId,
            ref: contentRef,
            className: className,
            style: props.contentStyle
        }, props.children);
    };
    var createFooter = function createFooter() {
        var footer = (0, _utils.ObjectUtils).getJSXElement(props.footer, props);
        return footer && /*#__PURE__*/ _react.createElement("div", {
            ref: footerRef,
            className: "p-dialog-footer"
        }, footer);
    };
    var createResizer = function createResizer() {
        if (props.resizable) return /*#__PURE__*/ _react.createElement("span", {
            className: "p-resizable-handle",
            style: {
                zIndex: 90
            },
            onMouseDown: onResizeStart
        });
        return null;
    };
    var createElement = function createElement() {
        var otherProps = (0, _utils.ObjectUtils).findDiffKeys(props, Dialog.defaultProps);
        var className = (0, _utils.classNames)('p-dialog p-component', props.className, {
            'p-dialog-rtl': props.rtl,
            'p-dialog-maximized': maximized,
            'p-dialog-default': !maximized
        });
        var maskClassName = (0, _utils.classNames)('p-dialog-mask', getPositionClass(), {
            'p-component-overlay p-component-overlay-enter': props.modal,
            'p-dialog-visible': maskVisibleState,
            'p-dialog-draggable': props.draggable,
            'p-dialog-resizable': props.resizable
        }, props.maskClassName);
        var header = createHeader();
        var content = createContent();
        var footer = createFooter();
        var resizer = createResizer();
        var headerId = idState + '_header';
        var contentId = idState + '_content';
        var transitionTimeout = {
            enter: props.position === 'center' ? 150 : 300,
            exit: props.position === 'center' ? 150 : 300
        };
        return /*#__PURE__*/ _react.createElement("div", {
            ref: maskRef,
            style: props.maskStyle,
            className: maskClassName,
            onClick: onMaskClick
        }, /*#__PURE__*/ _react.createElement((0, _csstransition.CSSTransition), {
            nodeRef: dialogRef,
            classNames: "p-dialog",
            timeout: transitionTimeout,
            "in": visibleState,
            options: props.transitionOptions,
            unmountOnExit: true,
            onEnter: onEnter,
            onEntered: onEntered,
            onExiting: onExiting,
            onExited: onExited
        }, /*#__PURE__*/ _react.createElement("div", _extends({
            ref: dialogRef,
            id: idState,
            className: className,
            style: props.style,
            onClick: props.onClick,
            role: "dialog"
        }, otherProps, {
            "aria-labelledby": headerId,
            "aria-describedby": contentId,
            "aria-modal": props.modal
        }), header, content, footer, resizer)));
    };
    var createDialog = function createDialog() {
        var element = createElement();
        return /*#__PURE__*/ _react.createElement((0, _portal.Portal), {
            element: element,
            appendTo: props.appendTo,
            visible: true
        });
    };
    return maskVisibleState && createDialog();
});
Dialog.displayName = 'Dialog';
Dialog.defaultProps = {
    __TYPE: 'Dialog',
    appendTo: null,
    ariaCloseIconLabel: null,
    baseZIndex: 0,
    blockScroll: false,
    breakpoints: null,
    className: null,
    closable: true,
    closeOnEscape: true,
    contentClassName: null,
    contentStyle: null,
    dismissableMask: false,
    draggable: true,
    focusOnShow: true,
    footer: null,
    header: null,
    headerClassName: null,
    headerStyle: null,
    icons: null,
    id: null,
    keepInViewport: true,
    maskClassName: null,
    maskStyle: null,
    maximizable: false,
    maximized: false,
    minX: 0,
    minY: 0,
    modal: true,
    onClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragStart: null,
    onHide: null,
    onMaskClick: null,
    onMaximize: null,
    onResize: null,
    onResizeEnd: null,
    onResizeStart: null,
    onShow: null,
    position: 'center',
    resizable: true,
    rtl: false,
    showHeader: true,
    style: null,
    transitionOptions: null,
    visible: false
};

},{"react":"6wC8C","primereact/api":"5sLxO","primereact/csstransition":"lJlsK","primereact/hooks":"9RLkJ","primereact/portal":"5ahww","primereact/ripple":"501Po","primereact/utils":"2f5Fe","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"lJlsK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSTransition", ()=>CSSTransition);
var _react = require("react");
var _reactTransitionGroup = require("react-transition-group");
var _api = require("primereact/api");
var _apiDefault = parcelHelpers.interopDefault(_api);
var _hooks = require("primereact/hooks");
var _utils = require("primereact/utils");
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var CSSTransition = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
    var disabled = props.disabled || props.options && props.options.disabled || !(0, _apiDefault.default).cssTransition;
    var onEnter = function onEnter(node, isAppearing) {
        props.onEnter && props.onEnter(node, isAppearing); // component
        props.options && props.options.onEnter && props.options.onEnter(node, isAppearing); // user option
    };
    var onEntering = function onEntering(node, isAppearing) {
        props.onEntering && props.onEntering(node, isAppearing); // component
        props.options && props.options.onEntering && props.options.onEntering(node, isAppearing); // user option
    };
    var onEntered = function onEntered(node, isAppearing) {
        props.onEntered && props.onEntered(node, isAppearing); // component
        props.options && props.options.onEntered && props.options.onEntered(node, isAppearing); // user option
    };
    var onExit = function onExit(node) {
        props.onExit && props.onExit(node); // component
        props.options && props.options.onExit && props.options.onExit(node); // user option
    };
    var onExiting = function onExiting(node) {
        props.onExiting && props.onExiting(node); // component
        props.options && props.options.onExiting && props.options.onExiting(node); // user option
    };
    var onExited = function onExited(node) {
        props.onExited && props.onExited(node); // component
        props.options && props.options.onExited && props.options.onExited(node); // user option
    };
    (0, _hooks.useUpdateEffect)(function() {
        if (disabled) {
            // no animation
            var node = (0, _utils.ObjectUtils).getRefElement(props.nodeRef);
            if (props["in"]) {
                onEnter(node, true);
                onEntering(node, true);
                onEntered(node, true);
            } else {
                onExit(node);
                onExiting(node);
                onExited(node);
            }
        }
    }, [
        props["in"]
    ]);
    if (disabled) return props["in"] ? props.children : null;
    else {
        var immutableProps = {
            nodeRef: props.nodeRef,
            "in": props["in"],
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited
        };
        var mutableProps = {
            classNames: props.classNames,
            timeout: props.timeout,
            unmountOnExit: props.unmountOnExit
        };
        var mergedProps = _objectSpread(_objectSpread(_objectSpread({}, mutableProps), props.options || {}), immutableProps);
        return /*#__PURE__*/ _react.createElement((0, _reactTransitionGroup.CSSTransition), mergedProps, props.children);
    }
});
CSSTransition.displayName = 'CSSTransition';
CSSTransition.defaultProps = {
    __TYPE: 'CSSTransition'
};

},{"react":"6wC8C","react-transition-group":"cq1PT","primereact/api":"5sLxO","primereact/hooks":"9RLkJ","primereact/utils":"2f5Fe","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"cq1PT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSTransition", ()=>(0, _csstransitionDefault.default));
parcelHelpers.export(exports, "ReplaceTransition", ()=>(0, _replaceTransitionDefault.default));
parcelHelpers.export(exports, "SwitchTransition", ()=>(0, _switchTransitionDefault.default));
parcelHelpers.export(exports, "TransitionGroup", ()=>(0, _transitionGroupDefault.default));
parcelHelpers.export(exports, "Transition", ()=>(0, _transitionDefault.default));
parcelHelpers.export(exports, "config", ()=>(0, _configDefault.default));
var _csstransition = require("./CSSTransition");
var _csstransitionDefault = parcelHelpers.interopDefault(_csstransition);
var _replaceTransition = require("./ReplaceTransition");
var _replaceTransitionDefault = parcelHelpers.interopDefault(_replaceTransition);
var _switchTransition = require("./SwitchTransition");
var _switchTransitionDefault = parcelHelpers.interopDefault(_switchTransition);
var _transitionGroup = require("./TransitionGroup");
var _transitionGroupDefault = parcelHelpers.interopDefault(_transitionGroup);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);

},{"./CSSTransition":"9NOg7","./ReplaceTransition":false,"./SwitchTransition":false,"./TransitionGroup":false,"./Transition":false,"./config":false,"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9NOg7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _addClass = require("dom-helpers/addClass");
var _addClassDefault = parcelHelpers.interopDefault(_addClass);
var _removeClass = require("dom-helpers/removeClass");
var _removeClassDefault = parcelHelpers.interopDefault(_removeClass);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _propTypes1 = require("./utils/PropTypes");
var _reflow = require("./utils/reflow");
var _addClass1 = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, _addClassDefault.default)(node, c);
    });
};
var removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, _removeClassDefault.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, _reflow.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            _addClass1(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) removeClass(node, baseClassName);
        if (activeClassName) removeClass(node, activeClassName);
        if (doneClassName) removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionDefault.default), (0, _extendsDefault.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, _reactDefault.default).Component);
CSSTransition.defaultProps = {
    classNames: ''
};
CSSTransition.propTypes = {};
exports.default = CSSTransition;

},{"@babel/runtime/helpers/esm/extends":"dMXQY","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"7WHlQ","@babel/runtime/helpers/esm/inheritsLoose":"kAl3N","prop-types":"6YTRF","dom-helpers/addClass":"7TcXc","dom-helpers/removeClass":"9jZC6","react":"6wC8C","./Transition":"3NIR9","./utils/PropTypes":"b8pak","./utils/reflow":"ec1RY","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7WHlQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7TcXc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addClass);
var _hasClass = require("./hasClass");
var _hasClassDefault = parcelHelpers.interopDefault(_hasClass);
function addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, _hasClassDefault.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

},{"./hasClass":"6uPCN","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6uPCN":[function(require,module,exports,__globalThis) {
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hasClass);
function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9jZC6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>removeClass);
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);
    else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3NIR9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNMOUNTED", ()=>UNMOUNTED);
parcelHelpers.export(exports, "EXITED", ()=>EXITED);
parcelHelpers.export(exports, "ENTERING", ()=>ENTERING);
parcelHelpers.export(exports, "ENTERED", ()=>ENTERED);
parcelHelpers.export(exports, "EXITING", ()=>EXITING);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _propTypes1 = require("./utils/PropTypes");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _reflow = require("./utils/reflow");
var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var Transition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === ENTERING) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, _reflow.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, _reactDomDefault.default).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, _reactDefault.default).cloneElement((0, _reactDefault.default).Children.only(children), childProps)));
    };
    return Transition;
}((0, _reactDefault.default).Component);
Transition.contextType = (0, _transitionGroupContextDefault.default);
Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
exports.default = Transition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"7WHlQ","@babel/runtime/helpers/esm/inheritsLoose":"kAl3N","prop-types":"6YTRF","react":"6wC8C","react-dom":"7k58v","./config":"9Q8OY","./utils/PropTypes":"b8pak","./TransitionGroupContext":"0Wnru","./utils/reflow":"ec1RY","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9Q8OY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    disabled: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"b8pak":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutsShape", ()=>timeoutsShape);
parcelHelpers.export(exports, "classNamesShape", ()=>classNamesShape);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var timeoutsShape = null;
var classNamesShape = null;

},{"prop-types":"6YTRF","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"0Wnru":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = (0, _reactDefault.default).createContext(null);

},{"react":"6wC8C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ec1RY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceReflow", ()=>forceReflow);
var forceReflow = function forceReflow(node) {
    return node.scrollTop;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"81M7F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OverlayService", ()=>OverlayService);
var _utils = require("primereact/utils");
var OverlayService = (0, _utils.EventBus)();

},{"primereact/utils":"2f5Fe","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4bi2T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _svg = require("./svg");
var _svgDefault = parcelHelpers.interopDefault(_svg);
var _react = require("react");
const SubmitButton = ({ label, icon, disabled: initDisabled, isForm, onSubmit })=>{
    const [disabled, setDisabled] = (0, _react.useState)(initDisabled);
    (0, _react.useEffect)(()=>{
        setDisabled(initDisabled);
    }, [
        initDisabled
    ]);
    icon = icon || "arrow-right";
    const hoverEffectClass = icon === "tick" ? "icon icon__scale" : "icon";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        disabled: disabled,
        "aria-label": label,
        className: !disabled ? "button button__arrow" : "button button__arrow button__disabled",
        type: isForm ? "form" : "button",
        onClick: onSubmit,
        children: [
            label,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgDefault.default), {
                src: icon,
                className: hoverEffectClass,
                label: label
            })
        ]
    });
};
exports.default = SubmitButton;

},{"react/jsx-runtime":"i3K7E","./svg":"4pImm","react":"6wC8C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4pImm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _ = require("inline:../../../resources/svg/*");
const SVG = (props)=>{
    const { src: svgFile, label, className } = props;
    // create a temporary element and append SVG file contents to get the <svg> inner HTML
    const placeholder = document.createElement("div");
    placeholder.innerHTML = _[`${svgFile}.svg`];
    const svgElement = placeholder.querySelector("svg");
    let svgInner = svgElement === null || svgElement === void 0 ? void 0 : svgElement.innerHTML;
    if (label) svgInner += `<title>${label}</title>`;
    let svgProps = {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        title: label,
        viewBox: svgElement === null || svgElement === void 0 ? void 0 : svgElement.getAttribute("viewBox"),
        className: className ? `svg ${className}` : "svg",
        dangerouslySetInnerHTML: {
            __html: svgInner
        }
    };
    delete svgProps.svgFile;
    delete svgProps.label;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        ...svgProps
    });
};
exports.default = SVG;

},{"react/jsx-runtime":"i3K7E","inline:../../../resources/svg/*":"8AIZc","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8AIZc":[function(require,module,exports,__globalThis) {
const _temp0 = require("8b358bc5b6a0adee");
const _temp1 = require("286119683754398b");
const _temp2 = require("3636fc43c7c6c1a5");
const _temp3 = require("435705f3699bdb62");
const _temp4 = require("2eef4d61d033f5cd");
const _temp5 = require("88f6f8e6a5a85187");
const _temp6 = require("fe8b304f2bfe2287");
const _temp7 = require("aaede4962f9e5143");
const _temp8 = require("e738851e82859c3b");
const _temp9 = require("a013c7d778709a11");
const _temp10 = require("145648a8ddc695ef");
const _temp11 = require("fb1484880106ca95");
const _temp12 = require("eb11f91dec34e978");
const _temp13 = require("d1c3c696e6ba2d7b");
const _temp14 = require("a97989c1fd797ab5");
const _temp15 = require("fe6819b44e280e6c");
const _temp16 = require("1942195807c7f181");
const _temp17 = require("1265dd3dd491b44c");
const _temp18 = require("e386e1c9e5fe477a");
const _temp19 = require("a9ed79ec4747336d");
const _temp20 = require("f45606ef1ac971fe");
const _temp21 = require("8a439d676a66c04");
const _temp22 = require("3f8b0dea8fac80ed");
const _temp23 = require("cae56919e4aedb2f");
const _temp24 = require("9c49619c21aa149d");
const _temp25 = require("a9557baa4fa1f9df");
const _temp26 = require("a3411afbabf0696d");
const _temp27 = require("3ffd898dbfc40c4f");
const _temp28 = require("4c79c3ee5274405f");
const _temp29 = require("cf74b6dca07802b4");
const _temp30 = require("e58ce53c552976c9");
const _temp31 = require("528edb230bce51a1");
const _temp32 = require("f6c36686cc055a83");
const _temp33 = require("9fd55d91cc39d6c9");
const _temp34 = require("a4c441de999eb411");
const _temp35 = require("96bcdaa200eee3d9");
const _temp36 = require("a9246157ce90e743");
const _temp37 = require("ef63277e99bcb0de");
const _temp38 = require("b651a7a41af6ba28");
const _temp39 = require("740cd363e355f386");
const _temp40 = require("3c6e8f7e467a5dd5");
const _temp41 = require("7146bc11dac1b067");
const _temp42 = require("246255b4557ce689");
const _temp43 = require("86bd736d680462db");
const _temp44 = require("5f119a43f7d89df");
const _temp45 = require("1a23d9b21943bd0c");
const _temp46 = require("81a6eb3489edb83b");
const _temp47 = require("7b3ca567e73563cf");
const _temp48 = require("d8e2668584b2df47");
const _temp49 = require("f2c1838c1f00b672");
const _temp50 = require("c5a9e04d1d2bdcd1");
const _temp51 = require("4e467594a8cccc0d");
const _temp52 = require("94d32de0f9d3cf65");
const _temp53 = require("7448a67b6efd06a2");
module.exports = {
    "arrow-down.svg": _temp0,
    "arrow-right.svg": _temp1,
    "asterisk.svg": _temp2,
    "bold.svg": _temp3,
    "bullets.svg": _temp4,
    "close.svg": _temp5,
    "dark.svg": _temp6,
    "download.svg": _temp7,
    "excel.svg": _temp8,
    "fetchError.svg": _temp9,
    "h2.svg": _temp10,
    "h3.svg": _temp11,
    "highlight.svg": _temp12,
    "home.svg": _temp13,
    "import.svg": _temp14,
    "inset.svg": _temp15,
    "italic.svg": _temp16,
    "jpg.svg": _temp17,
    "light.svg": _temp18,
    "list.svg": _temp19,
    "low-vision.svg": _temp20,
    "menu-dots.svg": _temp21,
    "menu-hr.svg": _temp22,
    "menu-hs.svg": _temp23,
    "menu-ops.svg": _temp24,
    "menu-td.svg": _temp25,
    "messages.svg": _temp26,
    "music.svg": _temp27,
    "notifications.svg": _temp28,
    "outset.svg": _temp29,
    "pdf.svg": _temp30,
    "piechart.svg": _temp31,
    "powerpoint.svg": _temp32,
    "printer.svg": _temp33,
    "profile.svg": _temp34,
    "question.svg": _temp35,
    "rolodex.svg": _temp36,
    "search.svg": _temp37,
    "tableDeleteColumn.svg": _temp38,
    "tableDeleteRow.svg": _temp39,
    "tableInsertColumn.svg": _temp40,
    "tableInsertRow.svg": _temp41,
    "text.svg": _temp42,
    "tick.svg": _temp43,
    "triangles.svg": _temp44,
    "undraw_access_denied_re_awnf.svg": _temp45,
    "undraw_dropdown_menu_re_jqqs.svg": _temp46,
    "undraw_empty_re_opql.svg": _temp47,
    "undraw_engineering_team_a7n2.svg": _temp48,
    "undraw_folder_files_re_2cbm.svg": _temp49,
    "video.svg": _temp50,
    "wellbeing.svg": _temp51,
    "word.svg": _temp52,
    "zip.svg": _temp53
};

},{"8b358bc5b6a0adee":"glNZs","286119683754398b":"kWqX1","3636fc43c7c6c1a5":"7NJTR","435705f3699bdb62":"gjUVx","2eef4d61d033f5cd":"9j7At","88f6f8e6a5a85187":"e282U","fe8b304f2bfe2287":"9ofz1","aaede4962f9e5143":"bWAao","e738851e82859c3b":"jzr8H","a013c7d778709a11":"7VwD2","145648a8ddc695ef":"9ydOJ","fb1484880106ca95":"8iMcX","eb11f91dec34e978":"egwQu","d1c3c696e6ba2d7b":"iVvSC","a97989c1fd797ab5":"3sUwW","fe6819b44e280e6c":"2ak2I","1942195807c7f181":"bR9ok","1265dd3dd491b44c":"1Um46","e386e1c9e5fe477a":"3smmR","a9ed79ec4747336d":"f9V0y","f45606ef1ac971fe":"gWrUq","8a439d676a66c04":"8ofEG","3f8b0dea8fac80ed":"aJ8Hl","cae56919e4aedb2f":"dzQG4","9c49619c21aa149d":"73FLB","a9557baa4fa1f9df":"cXcyt","a3411afbabf0696d":"fUFr7","3ffd898dbfc40c4f":"aTyvv","4c79c3ee5274405f":"b3I6R","cf74b6dca07802b4":"l5n3A","e58ce53c552976c9":"9NpEW","528edb230bce51a1":"b0bgC","f6c36686cc055a83":"jpm5M","9fd55d91cc39d6c9":"eesJc","a4c441de999eb411":"3K4rA","96bcdaa200eee3d9":"kb1TZ","a9246157ce90e743":"dKSdt","ef63277e99bcb0de":"kMlK1","b651a7a41af6ba28":"jcFB6","740cd363e355f386":"aS9Vh","3c6e8f7e467a5dd5":"f5zUE","7146bc11dac1b067":"bicvn","246255b4557ce689":"DGC1Q","86bd736d680462db":"eJL36","5f119a43f7d89df":"9RNXw","1a23d9b21943bd0c":"cvPQX","81a6eb3489edb83b":"c0b7C","7b3ca567e73563cf":"1i2mM","d8e2668584b2df47":"hdsGO","f2c1838c1f00b672":"cJdhw","c5a9e04d1d2bdcd1":"ajDTq","4e467594a8cccc0d":"dXvfw","94d32de0f9d3cf65":"iGeFY","7448a67b6efd06a2":"jb0x4"}],"glNZs":[function(require,module,exports,__globalThis) {
module.exports="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18.457\" height=\"10.383\" viewBox=\"0 0 18.457 10.383\">\n  <path id=\"Path_10218\" data-name=\"Path 10218\" d=\"M198.229,14.383a1.712,1.712,0,0,0,1.223-.511l7.669-7.881a1.175,1.175,0,0,0,0-1.648,1.146,1.146,0,0,0-1.631,0l-7.261,7.471-7.259-7.471a1.142,1.142,0,0,0-1.631,0,1.175,1.175,0,0,0,0,1.648L197,13.872a1.71,1.71,0,0,0,1.223.511Z\" transform=\"translate(-189 -4)\" fill=\"#fff\" fill-rule=\"evenodd\"/>\n</svg>\n";
},{}],"kWqX1":[function(require,module,exports,__globalThis) {
module.exports="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"9.372\" height=\"14.599\" viewBox=\"0 0 9.372 14.599\">\n  <path id=\"Path_10038\" data-name=\"Path 10038\" d=\"M7.3,9.372a1.277,1.277,0,0,0,.967-.461L14.332,1.8a1.17,1.17,0,0,0,0-1.488.83.83,0,0,0-1.29,0L7.3,7.053,1.557.309a.827.827,0,0,0-1.29,0,1.17,1.17,0,0,0,0,1.488L6.331,8.911a1.275,1.275,0,0,0,.967.461Z\" transform=\"translate(0 14.599) rotate(-90)\" fill=\"#fff\" fill-rule=\"evenodd\"/>\n</svg>\n";
},{}],"7NJTR":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?>\n<svg\n   xmlns:dc=\"http://purl.org/dc/elements/1.1/\"\n   xmlns:cc=\"http://creativecommons.org/ns#\"\n   xmlns:rdf=\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\"\n   xmlns:svg=\"http://www.w3.org/2000/svg\"\n   xmlns=\"http://www.w3.org/2000/svg\"\n   xmlns:sodipodi=\"http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd\"\n   xmlns:inkscape=\"http://www.inkscape.org/namespaces/inkscape\"\n   viewBox=\"0 -256 1792 1792\"\n   id=\"svg3037\"\n   version=\"1.1\"\n   inkscape:version=\"0.48.3.1 r9886\"\n   width=\"100%\"\n   height=\"100%\"\n   sodipodi:docname=\"asterisk_font_awesome.svg\">\n  <metadata\n     id=\"metadata3047\">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about=\"\">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource=\"http://purl.org/dc/dcmitype/StillImage\" />\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id=\"defs3045\" />\n  <sodipodi:namedview\n     pagecolor=\"#ffffff\"\n     bordercolor=\"#666666\"\n     borderopacity=\"1\"\n     objecttolerance=\"10\"\n     gridtolerance=\"10\"\n     guidetolerance=\"10\"\n     inkscape:pageopacity=\"0\"\n     inkscape:pageshadow=\"2\"\n     inkscape:window-width=\"640\"\n     inkscape:window-height=\"480\"\n     id=\"namedview3043\"\n     showgrid=\"false\"\n     inkscape:zoom=\"0.13169643\"\n     inkscape:cx=\"896\"\n     inkscape:cy=\"896\"\n     inkscape:window-x=\"0\"\n     inkscape:window-y=\"25\"\n     inkscape:window-maximized=\"0\"\n     inkscape:current-layer=\"svg3037\" />\n  <g\n     transform=\"matrix(1,0,0,-1,53.152542,1308.2034)\"\n     id=\"g3039\">\n    <path\n       d=\"m 1482,486 q 46,-26 59.5,-77.5 Q 1555,357 1529,311 L 1465,201 Q 1439,155 1387.5,141.5 1336,128 1290,154 L 1024,307 V 0 q 0,-52 -38,-90 -38,-38 -90,-38 H 768 q -52,0 -90,38 -38,38 -38,90 V 307 L 374,154 Q 328,128 276.5,141.5 225,155 199,201 L 135,311 Q 109,357 122.5,408.5 136,460 182,486 L 448,640 182,794 Q 136,820 122.5,871.5 109,923 135,969 l 64,110 q 26,46 77.5,59.5 Q 328,1152 374,1126 L 640,973 v 307 q 0,52 38,90 38,38 90,38 h 128 q 52,0 90,-38 38,-38 38,-90 V 973 l 266,153 q 46,26 97.5,12.5 51.5,-13.5 77.5,-59.5 l 64,-110 q 26,-46 12.5,-97.5 Q 1528,820 1482,794 L 1216,640 z\"\n       id=\"path3041\"\n       inkscape:connector-curvature=\"0\"\n       style=\"fill:currentColor\" />\n  </g>\n</svg>\n";
},{}],"gjUVx":[function(require,module,exports,__globalThis) {
module.exports="<svg viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M 315.845 150.151 C 315.845 105.89 286.52 83.763 227.867 83.763 L 172.816 83.763 L 172.816 224.634 L 217.615 224.634 C 250.36 224.634 274.917 218.156 291.287 205.202 C 307.66 192.249 315.845 173.896 315.845 150.151 Z M 328.259 337.979 C 328.259 311.349 318.548 291.558 299.111 278.605 C 279.685 265.656 248.921 259.173 206.824 259.173 L 171.736 259.173 L 171.736 415.696 L 213.296 415.696 C 289.938 415.696 328.259 389.791 328.259 337.979 Z M 368.202 335.821 C 368.202 411.74 316.209 449.703 212.221 449.703 L 146.913 449.703 C 139.355 449.703 134.944 449.075 133.686 447.814 C 132.429 446.557 131.798 442.15 131.798 434.588 L 131.798 65.41 C 131.798 57.858 132.429 53.445 133.686 52.19 C 134.944 50.927 139.355 50.298 146.913 50.298 L 227.867 50.298 C 313.149 50.298 355.784 83.047 355.784 148.529 C 355.784 198.547 332.039 228.947 284.54 239.741 C 311.887 247.662 332.664 259.628 346.882 275.637 C 361.095 291.652 368.202 311.713 368.202 335.821 Z\" style=\"white-space: pre; stroke: rgb(0, 0, 0);\"/>\n</svg>";
},{}],"9j7At":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g transform=\"matrix(4.907876, 0, 0, 4.907876, -39.990047, -1336.698608)\" style=\"\">\n    <g transform=\"matrix(1, 0, 0, 1, -4.109362, -4)\">\n      <ellipse style=\"stroke-width: 7px;\" cx=\"30.777\" cy=\"299.288\" rx=\"10.526\" ry=\"10.526\"/>\n      <path d=\"M 54.853 299.288 L 102.881 299.288\" style=\"fill: rgb(216, 216, 216); stroke-linecap: round; stroke-width: 7px;\"/>\n      <path d=\"M 51.353 299.288 C 51.353 297.355 52.92 295.788 54.853 295.788 L 102.881 295.788 C 104.814 295.788 106.381 297.355 106.381 299.288 C 106.381 301.221 104.814 302.788 102.881 302.788 L 54.853 302.788 C 52.92 302.788 51.353 301.221 51.353 299.288 Z\" style=\"\"/>\n    </g>\n    <g transform=\"matrix(1, 0, 0, 1, -4.109362, 24.008396)\">\n      <ellipse style=\"stroke-width: 7px;\" cx=\"30.777\" cy=\"299.288\" rx=\"10.526\" ry=\"10.526\"/>\n      <path d=\"M 54.853 299.288 L 102.881 299.288\" style=\"fill: rgb(216, 216, 216); stroke-linecap: round; stroke-width: 7px;\"/>\n      <path d=\"M 51.353 299.288 C 51.353 297.355 52.92 295.788 54.853 295.788 L 102.881 295.788 C 104.814 295.788 106.381 297.355 106.381 299.288 C 106.381 301.221 104.814 302.788 102.881 302.788 L 54.853 302.788 C 52.92 302.788 51.353 301.221 51.353 299.288 Z\" style=\"\"/>\n    </g>\n    <g transform=\"matrix(1, 0, 0, 1, -4.109362, 52.016792)\">\n      <ellipse style=\"stroke-width: 7px;\" cx=\"30.777\" cy=\"299.288\" rx=\"10.526\" ry=\"10.526\"/>\n      <path d=\"M 54.853 299.288 L 102.881 299.288\" style=\"fill: rgb(216, 216, 216); stroke-linecap: round; stroke-width: 7px;\"/>\n      <path d=\"M 51.353 299.288 C 51.353 297.355 52.92 295.788 54.853 295.788 L 102.881 295.788 C 104.814 295.788 106.381 297.355 106.381 299.288 C 106.381 301.221 104.814 302.788 102.881 302.788 L 54.853 302.788 C 52.92 302.788 51.353 301.221 51.353 299.288 Z\" style=\"\"/>\n    </g>\n  </g>\n</svg>";
},{}],"e282U":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M -35.891 215.552 L 535.891 215.801 C 554.848 215.801 570.216 231.169 570.216 250.124 C 570.216 269.082 554.848 284.449 535.891 284.449 L -35.891 284.2 C -54.848 284.2 -70.216 268.832 -70.216 249.876 C -70.215 230.919 -54.848 215.552 -35.891 215.552 Z\" style=\"\" transform=\"matrix(0.707107, 0.707107, -0.707107, 0.707107, 250.000356, -103.553243)\"/>\n  <path d=\"M 201.953 219.864 L 380.504 219.864 C 388.611 219.886 396.047 223.192 401.356 228.501 C 406.665 233.81 409.993 241.245 409.993 249.353 C 409.993 257.46 406.665 264.895 401.356 270.204 C 396.047 275.513 388.611 278.819 380.504 278.841 L 201.953 278.841 C 193.846 278.819 186.41 275.513 181.101 270.204 C 175.792 264.895 172.464 257.46 172.464 249.353 C 172.464 241.245 175.792 233.81 181.101 228.501 C 186.41 223.192 193.846 219.886 201.953 219.864 Z M 181.808 229.208 C 176.625 234.391 173.464 241.45 173.464 249.353 C 173.464 257.255 176.625 264.314 181.808 269.497 C 186.991 274.68 194.05 277.863 201.953 277.841 L 380.504 277.841 C 388.407 277.863 395.466 274.68 400.649 269.497 C 405.832 264.314 408.993 257.255 408.993 249.353 C 408.993 241.45 405.832 234.391 400.649 229.208 C 395.466 224.025 388.407 220.842 380.504 220.864 L 201.953 220.864 C 194.05 220.842 186.991 224.025 181.808 229.208 Z\" style=\"fill: none;\" transform=\"matrix(0.707107, 0.707107, -0.707107, 0.707107, 112.220451, -251.625656)\"/>\n  <path d=\"M -35.892 284.448 L 535.891 284.199 C 554.848 284.199 570.216 268.832 570.216 249.876 C 570.216 230.918 554.848 215.552 535.891 215.552 L -35.892 215.8 C -54.848 215.8 -70.216 231.168 -70.216 250.125 C -70.215 269.081 -54.848 284.448 -35.892 284.448 Z\" style=\"\" transform=\"matrix(-0.707107, 0.707107, -0.707107, -0.707107, 603.553391, 250)\"/>\n</svg>";
},{}],"9ofz1":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M 195.84 12.758 C 233.168 13.816 271.507 26.173 302.822 46.12 C 334.077 66.028 362.331 95.948 381.109 130.419 C 399.805 164.738 410.918 207.493 410.873 252.065 C 410.207 296.187 398.614 338.391 379.669 372.182 C 360.639 406.123 332.329 435.485 301.158 454.946 C 269.927 474.444 231.824 486.409 194.791 487.267 C 165.825 487.938 134.688 481.605 105.184 468.409 C 99.582 462.813 93.3 457.326 90.141 450.954 C 86.821 444.258 92.134 436.542 99.187 429.522 C 101.293 428.24 103.063 426.974 104.247 425.802 C 110.498 419.614 123.295 419.291 131.236 414.725 C 144.751 409.588 157.18 402.406 169.026 393.455 C 192.154 375.979 209.149 354.035 221.411 326.919 C 233.696 299.752 239.347 271.403 237.886 240.641 C 236.421 209.785 228.375 180.705 210.325 152.331 C 196.321 129.393 178.94 112.366 157.547 99.01 C 142.637 89.702 127.431 83.151 111.057 79.504 C 98.808 64.99 99.612 50.815 111.295 33.78 C 112.679 31.76 120.52 26.99 125.404 23.708 C 149.019 15.78 173.105 12.113 195.84 12.758 Z M 176.082 69.321 C 200.805 84.756 223.539 107.759 240.04 133.837 C 260.048 166.611 271.189 204.085 272.846 238.98 C 274.508 273.969 267.217 310.568 253.302 341.34 C 239.365 372.161 216.905 401.145 190.126 421.379 C 188.764 422.408 187.518 423.389 186.373 424.324 L 148.486 444.754 L 146.19 446.144 C 145.629 446.194 145.054 446.244 144.465 446.295 C 160.755 450.867 161.695 453.025 193.98 452.277 C 226.157 451.531 255.118 442.428 282.622 425.257 C 310.186 408.048 332.279 385.138 349.139 355.065 C 366.084 324.843 375.865 291.294 375.875 251.783 C 376.512 211.872 367.1 177.865 350.374 147.162 C 333.731 116.612 311.667 93.251 284.019 75.639 C 256.431 58.066 227.282 48.663 194.848 47.744 C 162.305 46.821 160.966 48.892 144.337 53.628 C 155.514 57.898 151.309 53.855 176.082 69.321 Z\" style=\"\"/>\n</svg>";
},{}],"bWAao":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"iso-8859-1\"?>\r\n<!-- Generator: Adobe Illustrator 19.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\r\n<svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\r\n\t viewBox=\"0 0 471.2 471.2\" style=\"enable-background:new 0 0 471.2 471.2;\" xml:space=\"preserve\">\r\n<g>\r\n\t<g>\r\n\t\t<path d=\"M457.7,230.15c-7.5,0-13.5,6-13.5,13.5v122.8c0,33.4-27.2,60.5-60.5,60.5H87.5c-33.4,0-60.5-27.2-60.5-60.5v-124.8\r\n\t\t\tc0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v124.8c0,48.3,39.3,87.5,87.5,87.5h296.2c48.3,0,87.5-39.3,87.5-87.5v-122.8\r\n\t\t\tC471.2,236.25,465.2,230.15,457.7,230.15z\"/>\r\n\t\t<path d=\"M226.1,346.75c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.8-85.8c5.3-5.3,5.3-13.8,0-19.1c-5.3-5.3-13.8-5.3-19.1,0l-62.7,62.8\r\n\t\t\tV30.75c0-7.5-6-13.5-13.5-13.5s-13.5,6-13.5,13.5v273.9l-62.8-62.8c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1\r\n\t\t\tL226.1,346.75z\"/>\r\n\t</g>\r\n</g>\r\n</svg>\r\n";
},{}],"jzr8H":[function(require,module,exports,__globalThis) {
module.exports="<svg width=\"382px\" height=\"512px\" version=\"1.1\" style=\"shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd\" viewBox=\"0 0 17.69 23.65\" xmlns=\"http://www.w3.org/2000/svg\">\r\n  <g id=\"Vrstva_x0020_1\">\r\n    <path class=\"fil0\" d=\"M3.08 0l7.91 0 6.7 6.99 0 13.58c0,1.7 -1.38,3.08 -3.08,3.08l-11.53 0c-1.7,0 -3.08,-1.38 -3.08,-3.08l0 -17.49c0,-1.7 1.38,-3.08 3.08,-3.08z\" style=\"fill: rgb(0, 115, 59);\"></path>\r\n    <polygon class=\"fil1\" points=\"10.98,0 10.98,6.93 17.69,6.93 \" style=\"fill: rgb(255, 255, 255); fill-opacity: 0.3;\"></polygon>\r\n    <path class=\"fil2\" d=\"M5.21 17.35l3.14 0 0 1.19 -3.14 0 0 -1.19zm4.12 -6.08l3.15 0 0 1.18 -3.15 0 0 -1.18zm-4.12 0l3.14 0 0 1.18 -3.14 0 0 -1.18zm4.12 2l3.15 0 0 1.19 -3.15 0 0 -1.19zm-4.12 0l3.14 0 0 1.19 -3.14 0 0 -1.19zm4.12 2.08l3.15 0 0 1.19 -3.15 0 0 -1.19zm-4.12 0l3.14 0 0 1.19 -3.14 0 0 -1.19zm4.12 2l3.15 0 0 1.19 -3.15 0 0 -1.19z\" style=\"fill: rgb(255, 255, 255);\"></path>\r\n  </g>\r\n</svg>";
},{}],"7VwD2":[function(require,module,exports,__globalThis) {
module.exports="<svg viewBox=\"0 0 500 387\" xmlns=\"http://www.w3.org/2000/svg\" xmlnsBx=\"https://boxy-svg.com\">\n  <g transform=\"matrix(1.804549, 0, 0, 1.804549, -771.530823, -131.476715)\" style=\"\">\n    <path d=\"M 566.086 82.127 L 693.38 281.396 L 438.792 281.396 L 566.086 82.127 Z\" style=\"stroke-linejoin: round; stroke-linecap: round; stroke-width: 7.56107px; fill: rgb(116, 173, 219);\" class=\"fill-primary-faded\" bxShape=\"triangle 438.792 82.127 254.588 199.269 0.5 0 1@ec5df86e\"/>\n    <path d=\"M 700.508 285.301 L 431.665 285.301 L 566.087 74.874 L 700.508 285.301 Z M 445.92 277.491 L 686.253 277.491 L 566.087 89.381 L 445.92 277.491 Z\" style=\"fill: rgb(28, 119, 193);\" class=\"fill-primary\"/>\n    <g transform=\"matrix(1.032807, 0, 0, 1.032807, -17.800989, -0.595898)\" style=\"\">\n      <!-- <title>eyes</title> -->\n      <g transform=\"matrix(1, 0, 0, 1, 11.136991, -0.54973)\">\n        <!-- <title>eye</title> -->\n        <ellipse class=\"stroke-outline\" style=\"stroke: rgb(0, 0, 0);\" cx=\"525.018\" cy=\"191.704\" rx=\"7.476\" ry=\"7.476\"/>\n        <ellipse style=\"fill: rgb(255, 255, 255);\" cx=\"527.414\" cy=\"189.741\" rx=\"3.531\" ry=\"3.531\"/>\n        <ellipse style=\"fill: rgb(255, 255, 255);\" cx=\"522.473\" cy=\"195.003\" rx=\"2.071\" ry=\"2.071\"/>\n      </g>\n      <g transform=\"matrix(1, 0, 0, 1, 69.508522, 0.539529)\">\n        <!-- <title>eye</title> -->\n        <ellipse class=\"stroke-outline\" style=\"stroke: rgb(0, 0, 0);\" cx=\"525.018\" cy=\"191.704\" rx=\"7.476\" ry=\"7.476\"/>\n        <ellipse style=\"fill: rgb(255, 255, 255);\" cx=\"527.414\" cy=\"189.741\" rx=\"3.531\" ry=\"3.531\"/>\n        <ellipse style=\"fill: rgb(255, 255, 255);\" cx=\"522.473\" cy=\"195.003\" rx=\"2.071\" ry=\"2.071\" transform=\"matrix(1, 0, 0, 1, 1.213774, 0.958274)\"/>\n      </g>\n    </g>\n    <g transform=\"matrix(1.032807, 0, 0, 1.032807, 32.495953, 44.282055)\" style=\"\">\n      <!-- <title>Mouth</title> -->\n      <path class=\"stroke-outline\" style=\"stroke: rgb(0, 0, 0); stroke-linecap: round; fill: none;\" d=\"M 508.722 169.83 C 513.966 164.586 522.353 164.993 526.5 169.14\"/>\n    </g>\n    <g transform=\"matrix(1.032807, 0, 0, 1.032807, 30.875952, 44.282055)\" style=\"\">\n      <!-- <title>eyebrows</title> -->\n      <path class=\"stroke-outline\" style=\"stroke: rgb(0, 0, 0); stroke-linecap: round; fill: none;\" d=\"M 485.131 133.116 C 485.131 138.301 477.685 145.516 473.852 149.349\"/>\n      <path class=\"stroke-outline\" style=\"stroke: rgb(0, 0, 0); stroke-linecap: round; fill: none;\" d=\"M 562.568 151.064 C 562.568 145.879 555.122 138.664 551.289 134.831\" transform=\"matrix(-1, 0, 0, -1, 1113.856995, 285.894989)\"/>\n    </g>\n  </g>\n</svg>";
},{}],"9ydOJ":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M 233.728 378.218 C 233.728 381.55 232.063 383.218 228.731 383.218 L 212.656 383.218 C 209.323 383.218 207.658 381.55 207.658 378.218 L 207.658 257.856 L 72.297 257.856 L 72.297 378.218 C 72.297 381.55 70.63 383.218 67.298 383.218 L 51.226 383.218 C 47.891 383.218 46.223 381.55 46.223 378.218 L 46.223 123.211 C 46.223 119.878 47.891 118.211 51.226 118.211 L 67.298 118.211 C 70.63 118.211 72.297 119.878 72.297 123.211 L 72.297 235.359 L 207.658 235.359 L 207.658 123.211 C 207.658 119.878 209.323 118.211 212.656 118.211 L 228.731 118.211 C 232.063 118.211 233.728 119.878 233.728 123.211 L 233.728 378.218 Z M 303.06 384.646 C 300.443 384.646 298.479 384.587 297.167 384.469 C 295.856 384.349 294.905 383.993 294.312 383.398 C 293.716 382.801 293.358 381.848 293.24 380.54 C 293.12 379.231 293.059 377.267 293.059 374.646 L 293.416 366.789 C 293.416 363.696 294.371 361.195 296.276 359.289 L 355.206 294.288 C 399.014 246.907 420.921 210.952 420.921 186.429 C 420.921 172.142 416.159 160.235 406.636 150.71 C 397.349 141.426 385.8 136.785 371.989 136.785 C 352.704 136.785 332.584 142.139 311.632 152.854 C 308.299 154.522 306.394 153.807 305.919 150.71 L 303.775 138.923 C 303.06 134.876 304.251 132.377 307.348 131.424 C 319.489 125.948 330.443 121.899 340.203 119.281 C 349.965 116.661 359.966 115.354 370.204 115.354 C 393.063 115.354 411.279 121.067 424.849 132.495 C 440.088 144.877 447.704 162.498 447.704 185.355 C 447.704 194.164 445.563 203.809 441.277 214.287 C 436.993 224.761 431.041 235.715 423.422 247.142 C 418.66 253.809 411.934 262.5 403.24 273.216 C 394.55 283.929 384.609 295.357 373.418 307.501 C 365.086 316.55 356.812 325.716 348.597 335.003 C 340.384 344.29 332.108 353.458 323.775 362.507 L 448.775 362.507 C 452.11 362.507 453.778 364.172 453.778 367.504 L 453.778 379.647 C 453.778 382.98 452.11 384.646 448.775 384.646 L 303.06 384.646 Z\" style=\"white-space: pre;\"/>\n</svg>";
},{}],"8iMcX":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M 232.654 376.981 C 232.654 380.315 230.986 381.981 227.653 381.981 L 211.578 381.981 C 208.244 381.981 206.577 380.315 206.577 376.981 L 206.577 256.596 L 71.193 256.596 L 71.193 376.981 C 71.193 380.315 69.523 381.981 66.188 381.981 L 50.116 381.981 C 46.781 381.981 45.113 380.315 45.113 376.981 L 45.113 121.924 C 45.113 118.591 46.781 116.924 50.116 116.924 L 66.188 116.924 C 69.523 116.924 71.193 118.591 71.193 121.924 L 71.193 234.093 L 206.577 234.093 L 206.577 121.924 C 206.577 118.591 208.244 116.924 211.578 116.924 L 227.653 116.924 C 230.986 116.924 232.654 118.591 232.654 121.924 L 232.654 376.981 Z M 297.356 377.339 C 293.783 376.387 292.234 373.647 292.711 369.124 L 294.14 355.19 C 294.617 352.334 296.521 351.619 299.853 353.046 C 309.858 357.096 319.324 359.955 328.254 361.623 C 337.185 363.289 347.603 364.239 359.51 364.478 C 378.323 364.716 394.159 359.953 407.02 350.191 C 422.023 340.188 429.525 325.54 429.525 306.25 C 429.525 272.433 404.163 255.525 353.44 255.525 L 334.864 255.525 C 331.767 255.525 330.219 254.214 330.219 251.597 L 330.219 238.378 C 330.219 235.283 331.767 233.736 334.864 233.736 L 336.651 233.736 C 362.132 233.736 382.016 230.997 396.302 225.517 C 417.975 217.184 428.811 202.181 428.811 180.509 C 428.811 173.602 426.965 167.232 423.274 161.399 C 419.582 155.563 414.641 150.621 408.449 146.574 C 402.734 143.239 396.304 140.619 389.159 138.713 C 382.015 136.809 374.514 135.856 366.654 135.856 C 358.558 135.856 349.628 136.929 339.863 139.07 C 330.1 141.214 320.693 144.071 311.643 147.642 C 308.548 148.834 306.763 147.883 306.286 144.788 L 304.857 131.569 C 304.143 128.236 305.689 125.855 309.5 124.425 C 320.217 120.851 330.22 118.232 339.505 116.566 C 348.793 114.9 358.678 114.066 369.154 114.066 C 393.209 114.066 412.856 119.185 428.096 129.423 C 445.482 141.095 454.176 158.122 454.176 180.509 C 454.176 196.466 448.459 210.278 437.025 221.947 C 427.502 232.186 415.12 239.69 399.877 244.453 C 407.498 245.403 414.582 247.427 421.13 250.525 C 427.68 253.619 433.335 257.905 438.098 263.385 C 443.575 269.34 447.744 276.067 450.603 283.567 C 453.458 291.068 454.886 299.344 454.886 308.395 C 454.886 320.301 452.447 331.078 447.567 340.723 C 442.684 350.368 435.717 358.643 426.667 365.551 C 417.857 371.98 407.736 377.04 396.302 380.731 C 384.872 384.424 372.131 386.151 358.081 385.913 C 345.459 385.673 334.565 384.959 325.397 383.767 C 316.228 382.577 306.881 380.434 297.356 377.339 Z\" style=\"white-space: pre;\"/>\n</svg>";
},{}],"egwQu":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M 491.289 99.745 C 490.168 76.92 480.527 52.909 463.387 35.625 C 439.166 12.808 411.71 5.564 389.458 7.211 C 366.998 9.573 346.713 20.188 335.939 30.143 L 113.897 224.048 L 105.352 232.536 L 98.2 242.496 C 97.199 244.491 94.693 249.572 94.307 251.794 L 57.973 359.929 L 15.638 403.937 C 13.136 406.898 12.392 407.814 11.696 412.504 C 11.245 415.547 12.027 418.649 14.913 423.299 C 16.848 426.419 22.035 430.459 22.036 430.461 L 106.566 487.45 C 106.566 487.45 109.933 490.018 113.711 490.607 C 117.368 491.179 121.557 486.854 121.557 486.854 L 151.651 455.577 L 260.555 416.705 C 265.797 414.277 265.907 413.981 269.742 410.829 L 274.748 405.794 L 281.957 397.93 L 469.024 166.406 C 484.017 147.349 491.814 122.567 491.289 99.745 Z M 97.472 366.759 L 95.8 365.02 L 122.005 285.652 L 222.669 390.292 L 146.322 417.544 L 97.472 366.759 Z M 439.886 142.721 L 256.401 369.812 L 141.221 250.07 L 361.238 57.903 L 361.283 57.854 L 361.338 57.794 C 366.878 51.725 377.801 45.68 392.213 44.804 C 406.985 43.209 422.212 46.509 436.709 62.069 C 447.88 72.776 453.009 86.286 453.312 101.514 C 454.178 116.729 449.977 130.76 439.886 142.721 Z\" style=\"stroke-width: 3px;\"/>\n  <path d=\"M 154.12 425.488 L 0.191 425.488\" style=\"fill: rgb(216, 216, 216); stroke-width: 30px;\"/>\n</svg>";
},{}],"iVvSC":[function(require,module,exports,__globalThis) {
module.exports="<svg id=\"Group_10825\" data-name=\"Group 10825\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16.178\" height=\"16.17\" viewBox=\"0 0 16.178 16.17\">\n  <path id=\"Path_10045\" data-name=\"Path 10045\" d=\"M12.115,14.062c0-.008-8.087,0-8.087,0s0-5.054,0-5.054a1.011,1.011,0,0,0-2.022,0v5.054a2.021,2.021,0,0,0,2.022,2.022h8.087a2.021,2.021,0,0,0,2.016-2.022V9.008a1.011,1.011,0,0,0-2.022,0l.005,5.054Z\" transform=\"translate(0.022 0.086)\" fill=\"#691b71\" fill-rule=\"evenodd\"/>\n  <path id=\"Path_10046\" data-name=\"Path 10046\" d=\"M14.534,7.851A.981.981,0,0,0,15.949,7.7a1.075,1.075,0,0,0-.142-1.473L8.787.266a1.1,1.1,0,0,0-1.435,0L.37,6.2A1.074,1.074,0,0,0,.228,7.675a.98.98,0,0,0,1.413.148L8.081,2.375l6.445,5.481.007-.005Z\" transform=\"translate(0 0)\" fill=\"#691b71\" fill-rule=\"evenodd\"/>\n</svg>\n";
},{}],"3sUwW":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g transform=\"matrix(1, 0, 0, 1, 12.272491, 11.983011)\">\n    <path d=\"M 133.12 325.872 L 133.12 404.41 C 133.073 408.612 133.682 410.414 134.903 413.314 C 136.328 416.559 137.306 417.988 139.777 420.519 C 142.311 422.992 143.734 423.95 146.975 425.368 C 149.875 426.592 151.645 427.19 155.851 427.142 L 405.413 427.142 C 409.619 427.189 411.413 426.581 414.313 425.359 C 417.562 423.936 418.993 422.953 421.52 420.484 C 423.993 417.951 424.951 416.529 426.37 413.287 C 427.594 410.386 428.191 408.616 428.144 404.41 L 428.144 161.966 C 428.194 157.871 427.614 156.082 426.368 153.113 C 425.114 150.141 424.238 148.477 421.275 145.653 L 328.977 55.392 C 326.168 52.58 324.544 51.753 321.645 50.57 C 318.743 49.389 317.003 48.845 313.026 48.892 L 155.851 48.892 C 151.645 48.845 149.852 49.452 146.953 50.675 C 143.733 52.079 142.291 53.001 139.761 55.533 C 137.227 58.067 136.296 59.531 134.894 62.746 C 133.67 65.647 133.073 67.417 133.12 71.622 L 133.12 150.04 C 133.336 155.555 131.324 159.777 127.551 163.387 C 123.974 167.145 119.763 168.911 114.179 168.911 C 108.596 168.911 104.34 167.102 100.764 163.342 C 96.992 159.736 95.024 155.49 95.238 149.97 L 95.238 71.634 C 95.469 63.799 97.18 54.524 100.009 47.975 C 102.791 41.281 107.935 33.725 112.982 28.738 C 117.968 23.692 125.534 18.553 132.229 15.771 C 138.775 12.941 148.029 11.241 155.864 11.01 L 313.027 11.01 C 320.428 11.212 329.441 12.78 335.96 15.497 C 342.518 18.112 350.034 23.285 355.468 28.314 L 447.752 118.56 C 453.053 124.041 458.52 131.712 461.288 138.43 C 464.158 145.102 465.81 154.351 466.026 161.974 L 466.026 404.398 C 465.795 412.233 464.084 421.509 461.255 428.058 C 458.475 434.75 453.324 442.277 448.289 447.29 C 443.279 452.323 435.728 457.483 429.035 460.263 C 422.488 463.092 413.235 464.793 405.4 465.024 L 155.864 465.024 C 148.029 464.793 138.753 463.083 132.203 460.254 C 125.509 457.471 117.952 452.327 112.967 447.28 C 107.92 442.294 102.781 434.728 99.999 428.032 C 97.169 421.485 95.469 412.233 95.238 404.398 L 95.238 325.803 C 95.022 320.287 97.034 316.065 100.808 312.456 C 104.385 308.698 108.595 306.931 114.179 306.931 C 119.762 306.931 124.018 308.741 127.595 312.501 C 131.366 316.105 133.334 320.353 133.12 325.872 Z\" style=\"stroke-width: 50px;\"/>\n    <path d=\"M 344.55 41.162 L 344.55 122.094 C 344.532 126.2 345.112 127.852 346.245 130.554 C 347.612 133.664 348.507 134.974 350.88 137.402 C 353.314 139.777 354.623 140.654 357.728 142.016 C 360.43 143.151 362.037 143.716 366.141 143.698 L 447.154 143.698 C 452.67 143.482 456.892 145.494 460.502 149.268 C 464.26 152.845 466.026 157.055 466.026 162.639 C 466.026 168.222 464.216 172.478 460.456 176.055 C 456.852 179.826 452.604 181.794 447.085 181.58 L 366.174 181.58 C 358.492 181.349 349.362 179.67 342.95 176.898 C 336.389 174.171 328.954 169.109 324.068 164.164 C 319.123 159.279 314.067 151.834 311.341 145.273 C 308.569 138.861 306.899 129.756 306.668 122.073 L 306.668 41.093 C 306.452 35.576 308.463 31.354 312.237 27.745 C 315.814 23.987 320.025 22.221 325.609 22.221 C 331.192 22.221 335.448 24.031 339.025 27.791 C 342.796 31.395 344.764 35.642 344.55 41.162 Z\" style=\"stroke-width: 50px;\"/>\n    <path d=\"M 9.429 242.851 C 9.429 237.291 11.28 233.06 15.144 229.483 C 18.868 225.697 23.299 223.707 29.028 223.91 L 289.147 223.91 C 294.873 223.705 299.286 225.74 303.015 229.527 C 306.877 233.101 308.684 237.289 308.684 242.851 C 308.684 248.411 306.834 252.643 302.969 256.22 C 299.245 260.005 294.814 261.996 289.085 261.792 L 28.966 261.792 C 23.24 261.998 18.828 259.963 15.1 256.176 C 11.236 252.6 9.429 248.412 9.429 242.851 Z\" style=\"stroke-width: 50px;\"/>\n    <path d=\"M 185.875 140.829 C 189.611 136.78 193.972 135.33 199.22 135.33 C 204.467 135.33 208.876 136.827 212.614 140.877 L 297.117 225.385 L 277.125 238.777 L 297.851 259.588 L 212.566 344.872 C 208.83 348.921 204.469 350.371 199.22 350.371 C 193.976 350.371 189.519 348.826 185.778 344.775 C 181.729 341.039 180.279 336.678 180.279 331.43 C 180.279 326.183 181.777 321.775 185.826 318.036 L 261.012 242.851 L 258.334 240.173 L 185.778 167.617 C 181.729 163.881 180.279 159.52 180.279 154.271 C 180.279 149.026 181.824 144.569 185.875 140.829 Z\" style=\"stroke-width: 50px;\"/>\n  </g>\n</svg>";
},{}],"2ak2I":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g transform=\"matrix(-1, 0, 0, 1, 498.620483, 11.574997)\">\n    <path d=\"M 184.594 94.017 L 432.219 94.017\" style=\"fill: rgb(216, 216, 216); stroke-linecap: round; stroke-width: 36px;\"/>\n    <path d=\"M 166.594 94.017 C 166.594 84.076 174.653 76.017 184.594 76.017 L 432.219 76.017 C 442.16 76.017 450.219 84.076 450.219 94.017 C 450.219 103.958 442.16 112.017 432.219 112.017 L 184.594 112.017 C 174.653 112.017 166.594 103.958 166.594 94.017 Z\" style=\"\"/>\n    <path d=\"M 184.594 382.833 L 432.219 382.833\" style=\"stroke-linecap: round; fill: none; stroke-width: 36px;\"/>\n    <path d=\"M 166.594 382.833 C 166.594 372.892 174.653 364.833 184.594 364.833 L 432.219 364.833 C 442.16 364.833 450.219 372.892 450.219 382.833 C 450.219 392.774 442.16 400.833 432.219 400.833 L 184.594 400.833 C 174.653 400.833 166.594 392.774 166.594 382.833 Z\" style=\"\"/>\n    <path d=\"M 71.392 318.41 C 57.812 326.949 51.022 322.68 51.022 305.608 L 51.027 159.853 C 51.027 142.782 57.812 138.513 71.392 147.045 L 187.332 219.923 C 200.912 228.461 200.912 236.994 187.332 245.533 L 71.392 318.41 Z\" style=\"\"/>\n    <path d=\"M 289.917 235.622 L 432.219 235.622\" style=\"stroke-linecap: round; fill: rgb(237, 9, 9); stroke-width: 36px;\"/>\n    <path d=\"M 271.917 235.622 C 271.917 225.681 279.976 217.622 289.917 217.622 L 432.219 217.622 C 442.16 217.622 450.219 225.681 450.219 235.622 C 450.219 245.563 442.16 253.622 432.219 253.622 L 289.917 253.622 C 279.976 253.622 271.917 245.563 271.917 235.622 Z\" style=\"\"/>\n  </g>\n</svg>";
},{}],"bR9ok":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M 216.25 439.649 C 214.98 444.371 212.003 446.722 207.311 446.722 L 185.207 446.722 C 180.519 446.722 178.8 444.371 180.075 439.649 L 249.663 180.553 C 250.938 175.84 253.92 173.479 258.607 173.479 L 280.711 173.479 C 285.404 173.479 287.111 175.84 285.843 180.553 L 216.25 439.649 Z M 270.685 78.026 C 272.485 71.297 276.394 65.487 282.394 60.609 C 288.396 55.72 294.746 53.278 301.445 53.278 C 308.138 53.278 313.261 55.72 316.805 60.609 C 320.354 65.487 321.223 71.297 319.424 78.026 C 317.608 84.755 313.639 90.478 307.517 95.195 C 301.395 99.908 294.985 102.264 288.289 102.264 C 281.586 102.264 276.524 99.908 273.108 95.195 C 269.68 90.478 268.875 84.755 270.685 78.026 Z\" style=\"line-height: 203.372px; white-space: pre; stroke: rgb(0, 0, 0);\"/>\n</svg>";
},{}],"1Um46":[function(require,module,exports,__globalThis) {
module.exports="<svg width=\"382px\" height=\"512px\" version=\"1.1\" style=\"shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd\" viewBox=\"0 0 17.69 23.65\" xmlns=\"http://www.w3.org/2000/svg\">\r\n  <g id=\"Vrstva_x0020_1\">\r\n    <path class=\"fil0\" d=\"M3.08 0l7.91 0 6.7 6.99 0 13.58c0,1.7 -1.38,3.08 -3.08,3.08l-11.53 0c-1.7,0 -3.08,-1.38 -3.08,-3.08l0 -17.49c0,-1.7 1.38,-3.08 3.08,-3.08z\" style=\"fill: rgb(10, 201, 99);\"></path>\r\n    <polygon class=\"fil1\" points=\"10.98,0 10.98,6.93 17.69,6.93 \" style=\"fill: rgb(255, 255, 255); fill-opacity: 0.3;\"></polygon>\r\n    <path class=\"fil2\" d=\"M11.85 11.82l-6.01 0c-0.45,0 -0.82,0.37 -0.82,0.82l0 3.82c0,0.45 0.37,0.82 0.82,0.82l6.01 0c0.45,0 0.81,-0.37 0.81,-0.82l0 -3.82c0,-0.45 -0.36,-0.82 -0.81,-0.82zm-4.37 1.03c0.49,0 0.88,0.4 0.88,0.88 0,0.49 -0.39,0.89 -0.88,0.89 -0.49,0 -0.89,-0.4 -0.89,-0.89 0,-0.48 0.4,-0.88 0.89,-0.88zm4.64 3.61c0,0.15 -0.12,0.28 -0.27,0.28l-6.01 0c-0.15,0 -0.27,-0.13 -0.27,-0.28l0 -0.16 1.09 -1.09 0.9 0.9c0.11,0.11 0.28,0.11 0.39,0l2.26 -2.26 1.91 1.91 0 0.7 0 0z\" style=\"fill: rgb(255, 255, 255);\"></path>\r\n  </g>\r\n</svg>";
},{}],"3smmR":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g transform=\"matrix(1.081728, 0, 0, 1.081728, -21.240707, -21.240719)\" style=\"\">\n    <path d=\"M 341.82 250 C 341.82 300.711 300.711 341.82 250 341.82 C 199.289 341.82 158.18 300.711 158.18 250 C 158.18 199.289 199.289 158.18 250 158.18 C 300.711 158.18 341.82 199.289 341.82 250 Z M 250.748 188.588 C 216.418 188.588 188.588 216.418 188.588 250.748 C 188.588 285.078 216.418 312.908 250.748 312.908 C 285.078 312.908 312.908 285.078 312.908 250.748 C 312.908 216.418 285.078 188.588 250.748 188.588 Z\" style=\"\"/>\n    <path d=\"M 342.32 250 C 342.32 275.458 331.959 298.601 315.28 315.28 C 298.601 331.959 275.458 342.32 250 342.32 C 224.542 342.32 201.399 331.959 184.72 315.28 C 168.041 298.601 157.68 275.458 157.68 250 C 157.68 224.542 168.041 201.399 184.72 184.72 C 201.399 168.041 224.542 157.68 250 157.68 C 275.458 157.68 298.601 168.041 315.28 184.72 C 331.959 201.399 342.32 224.542 342.32 250 Z M 314.573 185.427 C 298.02 168.874 275.253 158.68 250 158.68 C 224.747 158.68 201.98 168.874 185.427 185.427 C 168.874 201.98 158.68 224.747 158.68 250 C 158.68 275.253 168.874 298.02 185.427 314.573 C 201.98 331.126 224.747 341.32 250 341.32 C 275.253 341.32 298.02 331.126 314.573 314.573 C 331.126 298.02 341.32 275.253 341.32 250 C 341.32 224.747 331.126 201.98 314.573 185.427 Z M 313.408 250.748 C 313.408 268.015 306.367 283.744 295.055 295.055 C 283.744 306.367 268.015 313.408 250.748 313.408 C 233.481 313.408 217.752 306.367 206.441 295.055 C 195.129 283.744 188.088 268.015 188.088 250.748 C 188.088 233.481 195.129 217.752 206.441 206.441 C 217.752 195.129 233.481 188.088 250.748 188.088 C 268.015 188.088 283.744 195.129 295.055 206.441 C 306.367 217.752 313.408 233.481 313.408 250.748 Z M 294.348 207.148 C 283.162 195.962 267.811 189.088 250.748 189.088 C 233.685 189.088 218.334 195.962 207.148 207.148 C 195.962 218.334 189.088 233.685 189.088 250.748 C 189.088 267.811 195.962 283.162 207.148 294.348 C 218.334 305.534 233.685 312.408 250.748 312.408 C 267.811 312.408 283.162 305.534 294.348 294.348 C 305.534 283.162 312.408 267.811 312.408 250.748 C 312.408 233.685 305.534 218.334 294.348 207.148 Z\" style=\"fill: none;\"/>\n    <g transform=\"matrix(1, 0, 0, 1, 0.000008, 17.48349)\">\n      <path d=\"M 213.88 40.486 L 286.166 40.486 C 295.447 40.486 302.97 48.232 302.971 57.787 C 302.971 67.343 295.447 75.089 286.166 75.089 L 213.88 75.089 C 204.599 75.089 197.074 67.343 197.074 57.787 C 197.075 48.232 204.599 40.486 213.88 40.486 Z\" style=\"\" transform=\"matrix(0, -1, 1, 0, 192.235008, 307.810005)\"/>\n      <path d=\"M 213.835 389.944 L 286.121 389.944 C 295.402 389.944 302.925 397.69 302.926 407.245 C 302.926 416.801 295.402 424.547 286.121 424.547 L 213.835 424.547 C 204.554 424.547 197.029 416.801 197.029 407.245 C 197.03 397.69 204.554 389.944 213.835 389.944 Z\" style=\"\" transform=\"matrix(0, -1, 1, 0, -157.267998, 657.223)\"/>\n    </g>\n    <g transform=\"matrix(0, 1.000001, -1.000001, 0, 482.516724, -0.000238)\">\n      <path d=\"M 213.88 40.486 L 286.166 40.486 C 295.447 40.486 302.97 48.232 302.971 57.787 C 302.971 67.343 295.447 75.089 286.166 75.089 L 213.88 75.089 C 204.599 75.089 197.074 67.343 197.074 57.787 C 197.075 48.232 204.599 40.486 213.88 40.486 Z\" style=\"\" transform=\"matrix(0, -1, 1, 0, 192.235008, 307.810005)\"/>\n      <path d=\"M 213.835 389.944 L 286.121 389.944 C 295.402 389.944 302.925 397.69 302.926 407.245 C 302.926 416.801 295.402 424.547 286.121 424.547 L 213.835 424.547 C 204.554 424.547 197.029 416.801 197.029 407.245 C 197.03 397.69 204.554 389.944 213.835 389.944 Z\" style=\"\" transform=\"matrix(0, -1, 1, 0, -157.267998, 657.223)\"/>\n    </g>\n    <g transform=\"matrix(0.707107, 0.707107, -0.707107, 0.707107, 237.637299, -91.190804)\">\n      <path d=\"M 213.88 40.486 L 286.166 40.486 C 295.447 40.486 302.97 48.232 302.971 57.787 C 302.971 67.343 295.447 75.089 286.166 75.089 L 213.88 75.089 C 204.599 75.089 197.074 67.343 197.074 57.787 C 197.075 48.232 204.599 40.486 213.88 40.486 Z\" style=\"\" transform=\"matrix(0, -1, 1, 0, 192.235008, 307.810005)\"/>\n      <path d=\"M 213.835 389.944 L 286.121 389.944 C 295.402 389.944 302.925 397.69 302.926 407.245 C 302.926 416.801 295.402 424.547 286.121 424.547 L 213.835 424.547 C 204.554 424.547 197.029 416.801 197.029 407.245 C 197.03 397.69 204.554 389.944 213.835 389.944 Z\" style=\"\" transform=\"matrix(0, -1, 1, 0, -157.267998, 657.223)\"/>\n    </g>\n    <g transform=\"matrix(0.707107, -0.707107, 0.707107, 0.707107, -91.190804, 262.362701)\">\n      <path d=\"M 213.88 40.486 L 286.166 40.486 C 295.447 40.486 302.97 48.232 302.971 57.787 C 302.971 67.343 295.447 75.089 286.166 75.089 L 213.88 75.089 C 204.599 75.089 197.074 67.343 197.074 57.787 C 197.075 48.232 204.599 40.486 213.88 40.486 Z\" style=\"\" transform=\"matrix(0, -1, 1, 0, 192.235008, 307.810005)\"/>\n      <path d=\"M 213.835 389.944 L 286.121 389.944 C 295.402 389.944 302.925 397.69 302.926 407.245 C 302.926 416.801 295.402 424.547 286.121 424.547 L 213.835 424.547 C 204.554 424.547 197.029 416.801 197.029 407.245 C 197.03 397.69 204.554 389.944 213.835 389.944 Z\" style=\"\" transform=\"matrix(0, -1, 1, 0, -157.267998, 657.223)\"/>\n    </g>\n  </g>\n</svg>";
},{}],"f9V0y":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g transform=\"matrix(4.907876, 0, 0, 4.907876, -31.990049, -1336.698608)\" style=\"\"/>\n  <g style=\"\" transform=\"matrix(4.899107, 0, 0, 4.899107, -1655.536987, -977.885864)\">\n    <g transform=\"matrix(1, 0, 0, 1, 325.168427, -76.639404)\">\n      <path d=\"M 54.853 299.288 L 102.881 299.288\" style=\"fill: rgb(216, 216, 216); stroke-width: 7px; stroke-linecap: round;\"/>\n      <path d=\"M 51.353 299.288 C 51.353 297.355 52.92 295.788 54.853 295.788 L 102.881 295.788 C 104.814 295.788 106.381 297.355 106.381 299.288 C 106.381 301.221 104.814 302.788 102.881 302.788 L 54.853 302.788 C 52.92 302.788 51.353 301.221 51.353 299.288 Z\" style=\"\"/>\n    </g>\n    <g transform=\"matrix(1, 0, 0, 1, 325.168427, -48.631008)\">\n      <path d=\"M 54.853 299.288 L 102.881 299.288\" style=\"fill: rgb(216, 216, 216); stroke-width: 7px; stroke-linecap: round;\"/>\n      <path d=\"M 51.353 299.288 C 51.353 297.355 52.92 295.788 54.853 295.788 L 102.881 295.788 C 104.814 295.788 106.381 297.355 106.381 299.288 C 106.381 301.221 104.814 302.788 102.881 302.788 L 54.853 302.788 C 52.92 302.788 51.353 301.221 51.353 299.288 Z\" style=\"\"/>\n    </g>\n    <path d=\"M 380.022 278.665 L 428.05 278.665\" style=\"fill: rgb(216, 216, 216); stroke-width: 7px; stroke-linecap: round;\"/>\n    <path d=\"M 376.522 278.665 C 376.522 276.732 378.089 275.165 380.022 275.165 L 428.05 275.165 C 429.983 275.165 431.55 276.732 431.55 278.665 C 431.55 280.598 429.983 282.165 428.05 282.165 L 380.022 282.165 C 378.089 282.165 376.522 280.598 376.522 278.665 Z\" style=\"fill: none;\"/>\n    <path d=\"M 376.522 278.665 C 376.522 276.732 378.089 275.165 380.022 275.165 L 428.05 275.165 C 429.983 275.165 431.55 276.732 431.55 278.665 C 431.55 280.598 429.983 282.165 428.05 282.165 L 380.022 282.165 C 378.089 282.165 376.522 280.598 376.522 278.665 Z\" style=\"\"/>\n    <path d=\"M 357.621 232.665 C 357.621 232.931 357.488 233.063 357.222 233.063 L 356.057 233.063 C 355.791 233.063 355.658 232.931 355.658 232.665 L 355.658 214.181 C 355.071 214.674 354.521 215.139 354.009 215.575 C 353.497 216.011 352.957 216.475 352.388 216.968 C 352.18 217.139 351.99 217.12 351.82 216.911 L 351.251 216.229 C 351.194 216.134 351.166 216.034 351.166 215.93 C 351.166 215.826 351.213 215.736 351.308 215.66 L 355.715 211.963 C 355.791 211.887 355.905 211.85 356.057 211.85 L 356.824 211.85 C 357.222 211.85 357.455 211.883 357.521 211.949 C 357.587 212.015 357.621 212.248 357.621 212.646 L 357.621 232.665 Z\" style=\"white-space: pre; fill: none;\"/>\n    <path d=\"M 359.119 232.726 C 359.086 233.05 358.895 233.714 358.579 234.028 C 358.264 234.34 357.545 234.53 357.222 234.563 L 355.996 234.561 C 355.673 234.529 355.015 234.34 354.7 234.028 C 354.384 233.714 354.191 232.989 354.158 232.665 L 354.158 217.42 C 353.87 217.666 353.576 217.919 353.293 218.164 C 353.019 218.346 352.386 218.558 351.939 218.575 C 351.504 218.471 350.903 218.107 350.668 217.872 L 350.003 217.075 L 349.956 216.986 L 349.939 216.956 C 349.821 216.717 349.666 216.253 349.666 215.93 C 349.666 215.461 350.097 214.777 350.344 214.511 L 354.747 210.82 C 355.053 210.61 355.677 210.394 356.057 210.35 L 356.829 210.35 C 357.338 210.358 358.137 210.579 358.584 210.89 C 358.894 211.335 359.112 212.136 359.121 212.646 L 359.119 232.726 Z\" style=\"\"/>\n    <path d=\"M 349.687 260.544 C 349.478 260.544 349.322 260.539 349.218 260.53 C 349.113 260.52 349.038 260.492 348.99 260.444 C 348.943 260.397 348.914 260.321 348.905 260.217 C 348.895 260.113 348.891 259.956 348.891 259.748 L 348.919 259.122 C 348.919 258.876 348.995 258.677 349.147 258.525 L 353.839 253.35 C 357.327 249.577 359.071 246.714 359.071 244.762 C 359.071 243.624 358.692 242.676 357.933 241.918 C 357.194 241.179 356.275 240.809 355.175 240.809 C 353.64 240.809 352.038 241.236 350.369 242.089 C 350.104 242.221 349.952 242.164 349.914 241.918 L 349.744 240.98 C 349.687 240.657 349.782 240.458 350.028 240.382 C 350.995 239.946 351.867 239.624 352.644 239.416 C 353.422 239.207 354.218 239.103 355.033 239.103 C 356.853 239.103 358.303 239.558 359.384 240.468 C 360.597 241.454 361.204 242.856 361.204 244.676 C 361.204 245.378 361.033 246.146 360.692 246.98 C 360.35 247.814 359.877 248.686 359.27 249.596 C 358.891 250.127 358.355 250.819 357.663 251.672 C 356.971 252.525 356.18 253.435 355.289 254.402 C 354.625 255.122 353.967 255.852 353.313 256.591 C 352.658 257.331 352 258.061 351.336 258.781 L 361.289 258.781 C 361.554 258.781 361.687 258.914 361.687 259.179 L 361.687 260.146 C 361.687 260.411 361.554 260.544 361.289 260.544 L 349.687 260.544 Z\" style=\"white-space: pre; fill: none;\"/>\n    <path d=\"M 349.687 262.044 C 349.454 262.044 349.168 262.029 349.025 262.017 C 348.766 261.97 348.237 261.741 347.926 261.502 C 347.69 261.195 347.458 260.618 347.411 260.351 C 347.398 260.194 347.393 259.905 347.393 259.681 L 347.42 259.074 C 347.467 258.589 347.736 257.912 348.036 257.517 L 352.738 252.332 C 356.136 248.677 357.571 246.324 357.571 244.762 C 357.571 243.892 357.438 243.45 356.857 242.964 C 356.387 242.402 356.006 242.309 355.175 242.309 C 353.832 242.309 352.514 242.657 350.995 243.452 C 350.69 243.573 349.999 243.645 349.53 243.549 C 349.06 243.258 348.55 242.543 348.438 242.185 L 348.262 241.209 C 348.226 240.891 348.284 240.317 348.419 239.943 C 348.638 239.606 349.062 239.229 349.372 239.046 L 349.368 239.035 L 349.412 239.014 C 350.428 238.559 351.417 238.195 352.258 237.966 C 353.131 237.739 354.12 237.603 355.033 237.603 C 357.083 237.603 359.017 238.274 360.346 239.317 C 361.764 240.575 362.704 242.552 362.704 244.676 C 362.704 245.543 362.456 246.6 362.079 247.551 C 361.702 248.457 361.133 249.5 360.491 250.467 C 360.094 251.021 359.531 251.751 358.827 252.617 C 358.119 253.49 357.296 254.437 356.392 255.419 C 355.824 256.034 355.265 256.652 354.706 257.281 L 352.471 257.281 L 354.705 257.281 C 354.615 257.382 354.526 257.483 354.436 257.585 C 353.848 258.249 353.659 258.459 353.339 258.813 L 354.727 257.281 L 361.35 257.283 C 361.675 257.316 362.335 257.507 362.648 257.82 C 362.961 258.133 363.154 258.855 363.187 259.179 L 363.185 260.207 C 363.152 260.532 362.961 261.192 362.648 261.505 C 362.335 261.818 361.613 262.011 361.289 262.044 L 349.687 262.044 Z M 351.208 240.648 L 351.193 240.599 C 351.188 240.584 351.197 240.615 351.213 240.681 L 351.208 240.648 Z\" style=\"\"/>\n    <path d=\"M 349.317 288.893 C 349.033 288.817 348.91 288.599 348.948 288.239 L 349.061 287.13 C 349.099 286.903 349.251 286.846 349.516 286.96 C 350.312 287.282 351.066 287.509 351.777 287.642 C 352.488 287.775 353.317 287.851 354.265 287.869 C 355.763 287.888 357.023 287.509 358.047 286.732 C 359.241 285.936 359.839 284.77 359.839 283.234 C 359.839 280.542 357.82 279.196 353.782 279.196 L 352.303 279.196 C 352.057 279.196 351.933 279.092 351.933 278.883 L 351.933 277.831 C 351.933 277.585 352.057 277.462 352.303 277.462 L 352.445 277.462 C 354.474 277.462 356.057 277.244 357.194 276.808 C 358.919 276.144 359.782 274.95 359.782 273.225 C 359.782 272.675 359.635 272.168 359.341 271.703 C 359.047 271.239 358.654 270.845 358.161 270.523 C 357.706 270.258 357.194 270.049 356.625 269.898 C 356.057 269.746 355.459 269.67 354.834 269.67 C 354.189 269.67 353.478 269.755 352.701 269.926 C 351.924 270.097 351.175 270.324 350.455 270.608 C 350.208 270.703 350.066 270.627 350.028 270.381 L 349.914 269.329 C 349.857 269.063 349.981 268.874 350.284 268.76 C 351.137 268.476 351.933 268.267 352.673 268.134 C 353.412 268.002 354.199 267.935 355.033 267.935 C 356.948 267.935 358.512 268.343 359.725 269.158 C 361.109 270.087 361.801 271.443 361.801 273.225 C 361.801 274.495 361.346 275.594 360.436 276.523 C 359.677 277.338 358.692 277.936 357.478 278.315 C 358.085 278.391 358.649 278.552 359.17 278.798 C 359.692 279.045 360.142 279.386 360.521 279.822 C 360.957 280.296 361.289 280.831 361.516 281.429 C 361.744 282.026 361.858 282.685 361.858 283.405 C 361.858 284.353 361.663 285.211 361.275 285.978 C 360.886 286.746 360.332 287.405 359.611 287.955 C 358.91 288.467 358.104 288.87 357.194 289.163 C 356.284 289.457 355.27 289.595 354.151 289.576 C 353.147 289.557 352.279 289.5 351.549 289.405 C 350.82 289.31 350.076 289.14 349.317 288.893 Z\" style=\"white-space: pre; fill: none;\"/>\n    <path d=\"M 348.863 290.322 C 348.527 290.19 347.977 289.779 347.704 289.408 C 347.539 289.039 347.441 288.429 347.456 288.086 L 347.584 286.841 L 347.604 286.782 C 347.718 286.441 348.215 285.797 348.678 285.512 C 349.112 285.416 349.777 285.467 350.081 285.57 C 350.81 285.869 351.419 286.051 352.053 286.168 C 352.696 286.29 353.399 286.354 354.292 286.369 C 355.558 286.421 356.452 286.124 357.235 285.471 C 358.162 284.975 358.339 284.44 358.339 283.234 C 358.339 282.223 358.229 281.864 357.492 281.454 C 356.725 280.903 355.635 280.678 353.782 280.696 L 352.256 280.695 C 351.965 280.671 351.399 280.486 351.059 280.265 C 350.756 279.916 350.476 279.196 350.433 278.883 L 350.435 277.767 C 350.468 277.453 350.658 276.799 350.968 276.49 C 351.278 276.183 351.991 275.995 352.303 275.962 L 352.446 275.962 C 354.374 275.968 355.698 275.796 356.665 275.404 C 357.35 275.169 357.643 274.959 357.919 274.537 C 358.227 274.157 358.282 273.875 358.282 273.225 C 358.282 272.872 358.265 272.745 358.066 272.494 C 357.88 272.165 357.733 272.022 357.394 271.811 C 357.037 271.597 356.711 271.467 356.234 271.346 C 355.769 271.215 355.366 271.17 354.834 271.17 C 354.279 271.17 353.729 271.234 353.022 271.391 C 352.301 271.548 351.599 271.764 350.937 272.028 C 350.62 272.114 349.91 272.1 349.455 271.945 C 349.054 271.625 348.644 270.977 348.557 270.661 L 348.545 270.618 L 348.42 269.46 L 348.428 269.46 C 348.422 269.104 348.529 268.534 348.708 268.169 C 348.966 267.851 349.522 267.466 349.81 267.337 C 350.71 267.039 351.613 266.803 352.411 266.657 C 353.217 266.517 354.135 266.435 355.033 266.435 C 357.141 266.435 359.141 267.009 360.576 267.923 C 362.199 269.121 363.301 271.094 363.301 273.225 C 363.301 274.787 362.587 276.394 361.527 277.553 C 361.377 277.701 361.241 277.832 361.115 277.948 L 359.407 277.259 C 359.444 277.273 359.561 277.325 359.82 277.446 C 360.184 277.628 360.557 277.87 360.901 278.141 C 360.37 278.606 360.033 278.796 359.6 279.03 L 361.037 278.252 C 361.256 278.433 361.46 278.626 361.638 278.821 C 362.154 279.403 362.63 280.176 362.92 280.9 C 363.184 281.631 363.358 282.554 363.358 283.405 C 363.358 284.522 363.058 285.73 362.61 286.662 C 362.127 287.571 361.33 288.507 360.493 289.169 C 359.686 289.745 358.666 290.256 357.652 290.592 C 356.614 290.915 355.353 291.088 354.122 291.076 C 353.083 291.055 352.13 290.991 351.353 290.892 C 350.556 290.785 349.687 290.587 348.863 290.322 Z\" style=\"\"/>\n  </g>\n</svg>";
},{}],"gWrUq":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg width=\"24\" height=\"24\" viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M 248.966 68.753 C 203.856 68.753 166.511 78.31 135.529 92.61 L 45.213 2.293 L 10.472 37.034 L 91.919 118.506 C 27.719 166.465 4.87 231.967 4.526 232.999 L 1.946 240.763 L 4.526 248.526 C 5.066 250.173 61.428 412.772 248.966 412.772 C 294.05 412.772 331.371 403.215 362.353 388.915 L 452.719 479.281 L 487.46 444.54 L 405.963 363.044 C 470.188 315.085 493.062 249.583 493.406 248.551 L 495.985 240.787 L 493.406 233.023 C 492.865 231.353 436.503 68.753 248.966 68.753 Z M 54.229 240.787 C 56.76 234.989 60.961 226.39 67.03 216.488 L 211.178 360.636 C 107.668 344.715 65.261 266.216 54.229 240.787 Z M 281.422 361.349 L 97.643 177.546 C 105.972 169.168 115.726 160.986 126.832 153.419 L 324.737 351.3 C 311.617 355.87 297.195 359.285 281.422 361.349 Z M 371.051 328.131 L 333.189 290.27 C 341.887 275.626 347.243 258.821 347.243 240.763 C 347.243 229.117 344.811 218.061 340.978 207.619 C 336.506 212.778 330.069 216.218 322.674 216.218 C 309.087 216.218 298.104 205.211 298.104 191.649 C 298.104 180.863 305.18 171.944 314.861 168.652 C 297.343 152.608 274.272 142.485 248.966 142.485 C 230.907 142.485 214.102 147.841 199.459 156.539 L 173.169 130.25 C 194.864 122.707 219.827 117.892 248.966 117.892 C 380.436 117.892 431.393 212.41 443.702 240.738 C 436.307 257.765 414.931 298.255 371.051 328.131 Z\" style=\"stroke-width: 0px;\"/>\n</svg>";
},{}],"8ofEG":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 321 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <ellipse style=\"\" cx=\"160.5\" cy=\"89.752\" rx=\"58.494\" ry=\"58.494\"/>\n  <ellipse style=\"\" cx=\"160.5\" cy=\"408.654\" rx=\"58.494\" ry=\"58.494\"/>\n  <ellipse style=\"\" cx=\"160.5\" cy=\"249.203\" rx=\"58.494\" ry=\"58.494\"/>\n</svg>";
},{}],"aJ8Hl":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.2.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 21.1 23.9\" style=\"enable-background:new 0 0 21.1 23.9;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n</style>\n<g id=\"Path_10213\">\n\t<path class=\"st0\" d=\"M15,13.5l-0.7-0.3l0.6-0.5c1.5-1.3,2.3-3.1,2.3-5.1c0-1.8-0.7-3.5-2-4.7s-2.9-2-4.7-2c-1.8,0-3.5,0.7-4.7,2\n\t\tc-1.3,1.2-2,2.9-2,4.7c0,1.9,0.8,3.8,2.3,5.1l0.6,0.5l-0.7,0.3C3,15.2,1,18.4,1,22c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9\n\t\tc0-4.2,3.4-7.7,7.7-7.7c4.2,0,7.7,3.4,7.7,7.7c0,0.5,0.4,0.9,0.9,0.9S20,22.5,20,22C20,18.4,18.1,15.2,15,13.5z M10.5,12.5\n\t\tc-2.7,0-4.8-2.2-4.8-4.8c0-2.7,2.2-4.8,4.8-4.8c2.6,0,4.8,2.2,4.8,4.8C15.3,10.3,13.2,12.5,10.5,12.5z\"/>\n</g>\n</svg>\n";
},{}],"dzQG4":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.2.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 22.4 20.9\" style=\"enable-background:new 0 0 22.4 20.9;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n</style>\n<g id=\"Group_10804\" transform=\"translate(0 0)\">\n\t<g id=\"Path_10025\">\n\t\t<path class=\"st0\" d=\"M19.8,2.5c-2.3-2.3-5.9-2.4-8.4-0.4l-0.3,0.3l-0.3-0.3c-1.2-1-2.6-1.4-4-1.4c-1.6,0-3.2,0.6-4.4,1.8\n\t\t\tC1.1,3.7,0.4,5.4,0.5,7.1c0.1,1.9,0.8,3.8,2,5.3c0.8,1.2,1.8,2.3,2.7,3.3c0.9,1,1.9,2,3,3c0.6,0.5,1.1,1,1.4,1.2\n\t\t\tc0.8,0.7,2.1,0.7,2.9,0c0.3-0.2,0.8-0.7,1.4-1.2c1-1,2.1-2,3-3c1-1,1.9-2.2,2.7-3.3l0,0c1.2-1.5,1.9-3.4,2-5.3\n\t\t\tC21.7,5.4,21,3.7,19.8,2.5z M11.4,18.5l-0.3,0.3l-0.3-0.3c-0.4-0.3-8.5-7.1-8.5-11.5C2.2,5.8,2.7,4.6,3.6,3.7C5.4,2,8.2,2,10,3.7\n\t\t\tl1.1,1.1l1.1-1.1c1.8-1.7,4.6-1.7,6.4,0c0.9,0.8,1.3,2,1.3,3.2c0,0.1,0,0.1,0,0.2C19.9,11.4,11.8,18.3,11.4,18.5z\"/>\n\t</g>\n</g>\n</svg>\n";
},{}],"73FLB":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.2.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 22.9 28.4\" style=\"enable-background:new 0 0 22.9 28.4;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n</style>\n<g>\n\t<path id=\"Path_10243\" class=\"st0\" d=\"M6.9,17.4c-0.2,0-0.3,0-0.5,0c-1.4,0.1-2.8,0.5-4,1.2l0,0l-2,1.3c-0.3,0.2-0.5,0.6-0.3,1\n\t\ts0.6,0.5,1,0.3c0,0,0,0,0,0c0,0,0,0,0,0l2-1.3c2.1-1.2,4.6-1.3,6.9-0.4l0,0l4.8,1.7c0.2,0.1,0.3,0.2,0.4,0.4\n\t\tc0.1,0.2,0.1,0.4,0.1,0.7c0,0.2-0.2,0.3-0.3,0.4c-0.2,0.1-0.5,0.2-0.7,0.1l-5.2-1.2c-0.4-0.1-0.8,0.1-0.9,0.5\n\t\tc-0.1,0.4,0.1,0.8,0.5,0.9c0,0,0,0,0.1,0l0,0l5.2,1.2l0,0c0.6,0.2,1.3,0.1,1.8-0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0,0.2,0,0.3-0.1\n\t\tl3.7-2.2c0,0,0.1,0,0.1,0c0.3-0.3,0.8-0.2,1.1,0.1s0.2,0.8-0.1,1.1l-4.9,3.8c-0.6,0.4-1.3,0.6-2,0.4h0l-8.9-2c-0.2,0-0.4,0-0.5,0.1\n\t\tl-4.3,2.4c-0.3,0.2-0.5,0.6-0.3,1c0.2,0.3,0.6,0.5,0.9,0.3l0,0L5.4,26l8.6,2h0c1.1,0.3,2.3,0,3.2-0.7l4.9-3.8l0,0\n\t\tc1-0.8,1.1-2.1,0.4-3.1c-0.8-1-2.1-1.1-3.1-0.4l0.1,0l-2.6,1.6c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.6-0.6-1-1.2-1.2l0,0l-4.8-1.7l0,0\n\t\tC9.4,17.6,8.2,17.4,6.9,17.4\"/>\n\t<g id=\"Group_10804\" transform=\"translate(0 0)\">\n\t\t<g id=\"Path_10025\">\n\t\t\t<path class=\"st1\" d=\"M19.8,1.6c-1.7-1.6-4.3-1.8-6.1-0.3l-0.1,0.1l-0.1-0.1c-0.9-0.7-1.9-1-2.9-1c-1.2,0-2.3,0.4-3.2,1.3\n\t\t\t\tC6.5,2.4,6,3.7,6,4.9c0.1,1.4,0.6,2.7,1.4,3.8c0.6,0.8,1.2,1.6,1.9,2.3c0.6,0.7,1.3,1.4,2.1,2.1c0.5,0.4,0.8,0.7,1,0.9\n\t\t\t\tc0.7,0.5,1.6,0.5,2.3,0c0.1-0.1,0.5-0.4,1-0.9c0.7-0.7,1.4-1.3,2.1-2.1c0.7-0.7,1.3-1.5,1.9-2.3l0,0c0.9-1.1,1.3-2.4,1.4-3.8\n\t\t\t\tC21.1,3.7,20.6,2.4,19.8,1.6z M13.7,12.7L13.7,12.7h-0.2c-0.2-0.2-5.9-4.9-5.8-7.8c0-0.8,0.3-1.6,0.9-2.2c1.2-1.1,3-1.1,4.2,0\n\t\t\t\tl0.9,0.9l0.9-0.9c1.2-1.1,3-1.1,4.2,0c0.6,0.6,0.9,1.4,0.9,2.2C19.5,7.8,13.9,12.5,13.7,12.7z\"/>\n\t\t</g>\n\t</g>\n</g>\n</svg>\n";
},{}],"cXcyt":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 26.2.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 24.9 21.9\" style=\"enable-background:new 0 0 24.9 21.9;\" xml:space=\"preserve\">\n<style type=\"text/css\">\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n</style>\n<g id=\"Group_10818\" transform=\"translate(0 0)\">\n\t<g id=\"Path_10033\">\n\t\t<path class=\"st0\" d=\"M21.9,3.6l-7.4,0L12,1.1c-0.4-0.4-0.9-0.6-1.4-0.6H3.1c-1.4,0-2.6,1.2-2.6,2.6v15.7c0,1.5,1.2,2.6,2.6,2.6\n\t\t\th18.8c0.8,0,1.4-0.3,1.9-0.8c0.5-0.5,0.8-1.2,0.8-1.9V6.3C24.6,4.8,23.4,3.6,21.9,3.6z M22.4,19.3H2.6V2.6l7.9,0l2.5,2.5\n\t\t\tc0.4,0.4,0.9,0.6,1.4,0.6h7.9V19.3z\"/>\n\t</g>\n</g>\n</svg>\n";
},{}],"fUFr7":[function(require,module,exports,__globalThis) {
module.exports="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"26.768\" height=\"26.761\" viewBox=\"0 0 26.768 26.761\">\n  <path id=\"Path_10147\" data-name=\"Path 10147\" d=\"M13.372,23.413a10.046,10.046,0,1,1,8.648-4.922,1.688,1.688,0,0,0-.167,1.317l.84,2.847-2.874-.82A1.673,1.673,0,0,0,18.5,22a10.022,10.022,0,0,1-5.131,1.41Zm11.259,3.279A1.674,1.674,0,0,0,26.7,24.624c-.167-.586-1.45-5.062-1.449-5.078a13.381,13.381,0,1,0-5.7,5.707L24.636,26.7h-.005Z\" transform=\"translate(0 -0.001)\" fill=\"#1283a6\" fill-rule=\"evenodd\"/>\n</svg>\n";
},{}],"aTyvv":[function(require,module,exports,__globalThis) {
module.exports="<svg width=\"382px\" height=\"512px\" version=\"1.1\" style=\"shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd\" viewBox=\"0 0 24.33 32.53\" xmlns=\"http://www.w3.org/2000/svg\">\r\n  <g id=\"Vrstva_x0020_1\">\r\n    <path class=\"fil0\" d=\"M4.23 0l10.88 0 9.22 9.61 0 18.69c0,2.33 -1.9,4.23 -4.23,4.23l-15.87 0c-2.34,0 -4.23,-1.9 -4.23,-4.23l0 -24.07c0,-2.34 1.89,-4.23 4.23,-4.23z\" style=\"fill: rgb(153, 0, 204);\"></path>\r\n    <polygon class=\"fil1\" points=\"15.1,0 15.1,9.53 24.33,9.53 \" style=\"fill: rgb(255, 255, 255); fill-opacity: 0.3;\"></polygon>\r\n    <path class=\"fil2\" d=\"M15.07 21.38c0.31,-0.52 0.52,-1.18 0.56,-1.83 0.02,-0.42 -0.07,-0.86 -0.27,-1.27 -0.32,-0.65 -0.86,-1.01 -1.39,-1.37 -0.39,-0.26 -0.76,-0.51 -1.02,-0.86l-0.05 -0.06c-0.15,-0.21 -0.33,-0.45 -0.36,-0.65 -0.02,-0.2 -0.21,-0.34 -0.4,-0.33 -0.21,0.02 -0.36,0.18 -0.36,0.39l0 6.86c-0.32,-0.2 -0.72,-0.32 -1.16,-0.32 -1.06,0 -1.92,0.69 -1.92,1.54 0,0.85 0.86,1.54 1.92,1.54 1.06,0 1.93,-0.69 1.93,-1.54l0 -4.49c0.58,0.23 1.52,0.79 1.78,2.1 -0.05,0.07 -0.09,0.15 -0.15,0.21 -0.14,0.16 -0.12,0.4 0.04,0.55 0.16,0.14 0.4,0.12 0.54,-0.04 0.1,-0.12 0.2,-0.25 0.28,-0.4 0.01,-0.01 0.02,-0.02 0.03,-0.03z\" style=\"fill: rgb(255, 255, 255);\"></path>\r\n  </g>\r\n</svg>";
},{}],"b3I6R":[function(require,module,exports,__globalThis) {
module.exports="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"26.641\" height=\"26.64\" viewBox=\"0 0 26.641 26.64\">\n  <path id=\"Path_10028\" data-name=\"Path 10028\" d=\"M26.558,22.17a1.669,1.669,0,0,1-1.592,1.141H16.645a3.327,3.327,0,1,1-6.653,0H1.666a1.664,1.664,0,0,1-1-3A6.642,6.642,0,0,0,3.34,14.985v-5a9.986,9.986,0,1,1,19.972,0v5a6.625,6.625,0,0,0,2.664,5.328,1.669,1.669,0,0,1,.583,1.856m-6.3-7.176V10A6.938,6.938,0,0,0,6.392,10v5a9.69,9.69,0,0,1-1.387,5H21.646A9.7,9.7,0,0,1,20.258,14.993Z\" transform=\"translate(0)\" fill=\"#1283a6\" fill-rule=\"evenodd\"/>\n</svg>\n";
},{}],"l5n3A":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g transform=\"matrix(1, 0, 0, 1, 2.379505, 11.574997)\">\n    <path d=\"M 184.594 94.017 L 432.219 94.017\" style=\"fill: rgb(216, 216, 216); stroke-linecap: round; stroke-width: 36px;\"/>\n    <path d=\"M 166.594 94.017 C 166.594 84.076 174.653 76.017 184.594 76.017 L 432.219 76.017 C 442.16 76.017 450.219 84.076 450.219 94.017 C 450.219 103.958 442.16 112.017 432.219 112.017 L 184.594 112.017 C 174.653 112.017 166.594 103.958 166.594 94.017 Z\" style=\"\"/>\n    <path d=\"M 184.594 382.833 L 432.219 382.833\" style=\"stroke-linecap: round; fill: none; stroke-width: 36px;\"/>\n    <path d=\"M 166.594 382.833 C 166.594 372.892 174.653 364.833 184.594 364.833 L 432.219 364.833 C 442.16 364.833 450.219 372.892 450.219 382.833 C 450.219 392.774 442.16 400.833 432.219 400.833 L 184.594 400.833 C 174.653 400.833 166.594 392.774 166.594 382.833 Z\" style=\"\"/>\n    <path d=\"M 71.392 318.41 C 57.812 326.949 51.022 322.68 51.022 305.608 L 51.027 159.853 C 51.027 142.782 57.812 138.513 71.392 147.045 L 187.332 219.923 C 200.912 228.461 200.912 236.994 187.332 245.533 L 71.392 318.41 Z\" style=\"\"/>\n    <path d=\"M 289.917 235.622 L 432.219 235.622\" style=\"stroke-linecap: round; fill: rgb(237, 9, 9); stroke-width: 36px;\"/>\n    <path d=\"M 271.917 235.622 C 271.917 225.681 279.976 217.622 289.917 217.622 L 432.219 217.622 C 442.16 217.622 450.219 225.681 450.219 235.622 C 450.219 245.563 442.16 253.622 432.219 253.622 L 289.917 253.622 C 279.976 253.622 271.917 245.563 271.917 235.622 Z\" style=\"\"/>\n  </g>\n</svg>";
},{}],"9NpEW":[function(require,module,exports,__globalThis) {
module.exports="<svg width=\"382px\" height=\"512px\" version=\"1.1\" style=\"shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd\" viewBox=\"0 0 29.93 40.02\" xmlns=\"http://www.w3.org/2000/svg\">\r\n  <g id=\"Vrstva_x0020_1\">\r\n    <path class=\"fil0\" d=\"M5.21 0l13.38 0 11.34 11.82 0 22.99c0,2.88 -2.33,5.21 -5.2,5.21l-19.52 0c-2.88,0 -5.21,-2.33 -5.21,-5.21l0 -29.6c0,-2.88 2.33,-5.21 5.21,-5.21z\" style=\"fill: rgb(229, 37, 42);\"></path>\r\n    <polygon class=\"fil1\" points=\"18.58,0 18.58,11.73 29.93,11.73 \" style=\"fill: rgb(255, 255, 255); fill-opacity: 0.3;\"></polygon>\r\n    <path class=\"fil2\" d=\"M5.79 29.86l0 -7.31 3.11 0c0.77,0 1.38,0.21 1.84,0.64 0.46,0.42 0.69,0.99 0.69,1.7 0,0.71 -0.23,1.28 -0.69,1.7 -0.46,0.43 -1.07,0.64 -1.84,0.64l-1.24 0 0 2.63 -1.87 0zm1.87 -4.22l1.03 0c0.28,0 0.5,-0.06 0.65,-0.2 0.15,-0.13 0.23,-0.31 0.23,-0.55 0,-0.24 -0.08,-0.42 -0.23,-0.55 -0.15,-0.14 -0.37,-0.2 -0.65,-0.2l-1.03 0 0 1.5zm4.54 4.22l0 -7.31 2.59 0c0.51,0 0.99,0.07 1.44,0.22 0.45,0.15 0.86,0.36 1.22,0.65 0.36,0.28 0.65,0.66 0.86,1.14 0.2,0.48 0.31,1.03 0.31,1.65 0,0.61 -0.11,1.16 -0.31,1.64 -0.21,0.48 -0.5,0.86 -0.86,1.14 -0.36,0.29 -0.77,0.5 -1.22,0.65 -0.45,0.15 -0.93,0.22 -1.44,0.22l-2.59 0zm1.83 -1.59l0.54 0c0.29,0 0.56,-0.03 0.81,-0.1 0.24,-0.07 0.47,-0.18 0.69,-0.33 0.21,-0.15 0.38,-0.36 0.5,-0.64 0.12,-0.28 0.18,-0.61 0.18,-0.99 0,-0.39 -0.06,-0.72 -0.18,-1 -0.12,-0.28 -0.29,-0.49 -0.5,-0.64 -0.22,-0.15 -0.45,-0.26 -0.69,-0.33 -0.25,-0.07 -0.52,-0.1 -0.81,-0.1l-0.54 0 0 4.13zm5.53 1.59l0 -7.31 5.2 0 0 1.59 -3.33 0 0 1.17 2.66 0 0 1.58 -2.66 0 0 2.97 -1.87 0z\" style=\"fill: rgb(255, 255, 255);\"></path>\r\n  </g>\r\n</svg>";
},{}],"b0bgC":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg width=\"36\" height=\"36\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"ai ai-CreditCard\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:bx=\"https://boxy-svg.com\">\n  <defs/>\n  <path style=\"stroke: rgb(0, 0, 0); stroke-width: 37.0347px;\" transform=\"matrix(0.030584, 0, 0, 0.030584, -9.91667, -8.977173)\" d=\"M 1025.554 731.821 A 326.818 326.818 0 1 1 775.443 372.143 L 701.364 690.455 Z\" bx:shape=\"pie 701.364 690.455 0 326.818 97.271 13.101 1@38014c25\"/>\n  <path style=\"stroke: rgb(0, 0, 0); stroke-width: 9.09859px;\" transform=\"matrix(0.12449, 0, 0, 0.124487, -72.414977, -42.028144)\" d=\"M 712.037 352.247 A 70.089 70.089 0 0 1 765.442 429.264 L 696.502 420.53 A 0.598 0.598 0 0 0 696.047 419.873 Z\" bx:shape=\"pie 695.909 420.455 0.598 70.089 13.303 97.22 1@e729ba8b\"/>\n</svg>";
},{}],"jpm5M":[function(require,module,exports,__globalThis) {
module.exports="<svg width=\"382px\" height=\"512px\" version=\"1.1\" style=\"shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd\" viewBox=\"0 0 24.33 32.53\" xmlns=\"http://www.w3.org/2000/svg\">\r\n  <g id=\"Vrstva_x0020_1\">\r\n    <path class=\"fil0\" d=\"M4.23 0l10.88 0 9.22 9.61 0 18.69c0,2.33 -1.9,4.23 -4.23,4.23l-15.87 0c-2.34,0 -4.23,-1.9 -4.23,-4.23l0 -24.07c0,-2.34 1.89,-4.23 4.23,-4.23z\" style=\"fill: rgb(224, 51, 3);\"></path>\r\n    <polygon class=\"fil1\" points=\"15.1,0 15.1,9.53 24.33,9.53 \" style=\"fill: rgb(255, 255, 255); fill-opacity: 0.3;\"></polygon>\r\n    <path class=\"fil2\" d=\"M11.76 16.13c-2.44,0.12 -4.38,2.15 -4.35,4.62 0.04,2.46 2.04,4.47 4.5,4.5 2.48,0.04 4.51,-1.9 4.62,-4.34 0.01,-0.12 -0.09,-0.22 -0.21,-0.22l-4.13 0c-0.12,0 -0.22,-0.1 -0.22,-0.21l0 -4.14c0,-0.12 -0.09,-0.21 -0.21,-0.21zm1.1 -0.67l0 4.13c0,0.12 0.09,0.21 0.21,0.21l4.14 0c0.12,0 0.21,-0.1 0.21,-0.22 -0.11,-2.34 -1.99,-4.22 -4.34,-4.33 -0.12,-0.01 -0.22,0.09 -0.22,0.21z\" style=\"fill: rgb(255, 255, 255);\"></path>\r\n  </g>\r\n</svg>";
},{}],"eesJc":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg class=\"svg-icon\" style=\"width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;\" viewBox=\"0 0 1024 1024\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M725.333333 1024h-426.666666A128 128 0 0 1 170.666667 896V768H128A128 128 0 0 1 0 640v-256A128 128 0 0 1 128 256H170.666667V128A128 128 0 0 1 298.666667 0h426.666666A128 128 0 0 1 853.333333 128V256h42.666667a128 128 0 0 1 128 128v256a128 128 0 0 1-128 128H853.333333v128a128 128 0 0 1-128 128z m-426.666666-469.333333A42.666667 42.666667 0 0 0 256 597.333333v298.666667a42.666667 42.666667 0 0 0 42.666667 42.666667h426.666666a42.666667 42.666667 0 0 0 42.666667-42.666667V597.333333a42.666667 42.666667 0 0 0-42.666667-42.666666h-426.666666zM853.333333 682.666667h42.666667a42.666667 42.666667 0 0 0 42.666667-42.666667v-256a42.666667 42.666667 0 0 0-42.666667-42.666667h-768A42.666667 42.666667 0 0 0 85.333333 384v256A42.666667 42.666667 0 0 0 128 682.666667H170.666667v-85.333334a128 128 0 0 1 128-128h426.666666A128 128 0 0 1 853.333333 597.333333v85.333334zM256 256h512V128A42.666667 42.666667 0 0 0 725.333333 85.333333h-426.666666A42.666667 42.666667 0 0 0 256 128V256z m298.666667 597.333333h-170.666667a42.666667 42.666667 0 0 1 0-85.333333h170.666667a42.666667 42.666667 0 0 1 0 85.333333z m85.333333-128h-256a42.666667 42.666667 0 0 1 0-85.333333h256a42.666667 42.666667 0 0 1 0 85.333333z\" fill=\"#000000\" /></svg>";
},{}],"3K4rA":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 436 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g id=\"Group_10938\" data-name=\"Group 10938\" transform=\"matrix(1, 0, 0, 1, -337.847504, -53.801102)\">\n    <path id=\"Path_10242\" data-name=\"Path 10242\" d=\"M 710.606 211.048 C 710.615 91.908 581.647 17.436 478.464 76.998 C 385.955 130.398 374.071 259.237 455.249 328.661 C 383.854 366.036 339.133 439.978 339.183 520.564 C 339.183 544.392 364.977 559.285 385.613 547.371 C 395.19 541.841 401.091 531.622 401.091 520.564 C 399.697 401.432 527.79 325.465 631.658 383.825 C 680.993 411.544 711.267 463.979 710.606 520.564 C 710.606 544.392 736.4 559.285 757.036 547.371 C 766.614 541.841 772.512 531.622 772.512 520.564 C 772.553 439.981 727.834 366.044 656.446 328.661 C 690.86 299.285 710.656 256.293 710.606 211.048 Z M 555.837 303.995 C 484.353 303.995 439.675 226.61 475.417 164.704 C 511.159 102.796 600.515 102.796 636.257 164.704 C 644.392 178.794 648.683 194.777 648.699 211.048 C 648.757 262.373 607.161 304.006 555.837 303.995\" fill-rule=\"evenodd\" style=\"\"/>\n  </g>\n</svg>";
},{}],"kb1TZ":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 321 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M 62.307 154.29 C 39.855 156.22 32.378 154.989 14.259 153.222 C 11.408 152.944 7.761 146.908 7.039 144.136 C 2.929 128.338 3.71 97.258 10.871 83.966 C 24.083 59.445 31.05 51.285 46.102 40.189 C 132.634 -23.602 273.56 -4.127 310.805 106.877 C 333.225 173.699 272.776 237.205 234.083 267.584 C 217.104 280.915 196.605 289.45 180.122 303.388 C 174.245 308.357 172.722 315.847 170.497 323.214 C 168.636 329.377 174.738 342.488 168.301 342.527 C 149.189 342.646 125.604 341.412 108.054 342.552 C 101.452 342.981 101.187 291.651 116.337 276.004 C 140.363 251.185 164.899 240.406 184.444 228.521 C 215.663 209.539 248.857 165.306 235.326 121.416 C 211.241 43.293 90.993 62.145 75.403 101.338 C 69.785 115.462 77.453 152.987 62.307 154.29 Z\"/>\n  <path d=\"M 190.149 447.171 C 190.149 474.423 167.358 496.515 139.243 496.515 C 111.13 496.515 88.338 474.423 88.338 447.171 C 88.338 419.917 111.13 397.826 139.243 397.826 C 167.358 397.826 190.149 419.917 190.149 447.171 Z\" />\n</svg>";
},{}],"dKSdt":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg width=\"36\" height=\"36\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"ai ai-CreditCard\" xmlns=\"http://www.w3.org/2000/svg\">\n  <rect x=\"1.262\" y=\"5.618\" width=\"21.457\" height=\"17.166\" rx=\"2\" style=\"stroke: rgb(0, 0, 0); stroke-width: 1.2px;\"/>\n  <g transform=\"matrix(0.41632, 0, 0, 0.41632, 11.532222, 9.506387)\" style=\"\">\n    <circle cx=\"12\" cy=\"7\" r=\"5\" style=\"stroke: rgb(0, 0, 0); stroke-width: 3.09244px;\"/>\n    <path d=\"M17 14h.352a3 3 0 0 1 2.976 2.628l.391 3.124A2 2 0 0 1 18.734 22H5.266a2 2 0 0 1-1.985-2.248l.39-3.124A3 3 0 0 1 6.649 14H7\" style=\"stroke: rgb(0, 0, 0); stroke-width: 3.09244px;\"/>\n  </g>\n  <line style=\"fill: rgb(216, 216, 216); stroke: rgb(0, 0, 0); stroke-width: 1.2px;\" x1=\"4.041\" y1=\"11.597\" x2=\"9.364\" y2=\"11.597\"/>\n  <line style=\"fill: rgb(216, 216, 216); stroke: rgb(0, 0, 0); stroke-width: 1.2px;\" x1=\"4.041\" y1=\"14.639\" x2=\"8.565\" y2=\"14.639\"/>\n  <line style=\"fill: rgb(216, 216, 216); stroke: rgb(0, 0, 0); stroke-width: 1.2px;\" x1=\"4.041\" y1=\"17.681\" x2=\"9.364\" y2=\"17.681\"/>\n  <line style=\"fill: rgb(216, 216, 216); stroke: rgb(0, 0, 0); stroke-width: 1.2px;\" x1=\"4.059\" y1=\"3.485\" x2=\"19.941\" y2=\"3.485\"/>\n  <line style=\"fill: rgb(216, 216, 216); stroke: rgb(0, 0, 0); stroke-width: 1.2px;\" x1=\"6.494\" y1=\"1.415\" x2=\"17.506\" y2=\"1.415\"/>\n</svg>";
},{}],"kMlK1":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 495 415\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g id=\"Group_10910\" data-name=\"Group 10910\" transform=\"matrix(20.030941, 0, 0, 20.030941, 0, 0)\" style=\"\">\n    <path d=\"M 18.438 9.219 C 18.438 11.657 17.324 14.152 15.738 15.738 C 14.152 17.324 11.657 18.438 9.219 18.438 C 6.781 18.438 4.286 17.324 2.7 15.738 C 1.114 14.152 0 11.657 0 9.219 C 0 6.781 1.114 4.286 2.7 2.7 C 4.286 1.114 6.781 0 9.219 0 C 11.657 0 14.152 1.114 15.738 2.7 C 17.324 4.286 18.438 6.781 18.438 9.219 Z M 13.617 4.822 C 12.409 3.614 11.044 3 9.219 3 C 7.394 3 6.029 3.614 4.822 4.822 C 3.614 6.029 3 7.394 3 9.219 C 3 11.044 3.614 12.409 4.822 13.617 C 6.029 14.824 7.394 15.438 9.219 15.438 C 11.044 15.438 12.409 14.824 13.617 13.617 C 14.824 12.409 15.438 11.044 15.438 9.219 C 15.438 7.394 14.824 6.029 13.617 4.822 Z\" style=\"stroke: none; stroke-width: 0px;\" stroke=\"#1283a6\"/>\n  </g>\n  <rect x=\"172.964\" y=\"220.364\" width=\"236.529\" height=\"57.977\" rx=\"30\" ry=\"30\" style=\"\" transform=\"matrix(0.831657, 0.555289, -0.555289, 0.831657, 287.700378, -33.765728)\"/>\n</svg>";
},{}],"jcFB6":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g transform=\"matrix(0, 4.191974, -4.191918, 0, 2686.956787, -547.472778)\" style=\"\">\n    <path d=\"M 238.041 531.248 L 238.041 559.209 L 142.435 559.209 L 142.435 531.248 L 238.041 531.248 Z M 149.435 552.209 L 231.041 552.209 L 231.041 538.248 L 149.435 538.248 L 149.435 552.209 Z\" style=\"\"/>\n    <path d=\"M 238.041 603.484 L 238.041 631.445 L 142.435 631.445 L 142.435 603.484 L 238.041 603.484 Z M 149.435 624.445 L 231.041 624.445 L 231.041 610.484 L 149.435 610.484 L 149.435 624.445 Z\" style=\"\"/>\n    <g transform=\"matrix(1.004275, 0, 0, 0.874231, -1.657875, 73.46685)\">\n      <path d=\"M 179.899 567.451 C 181.387 566.218 183.594 566.425 184.827 567.913 L 202.721 589.51 C 203.954 590.998 203.747 593.205 202.259 594.438 C 200.771 595.671 198.564 595.464 197.331 593.976 L 179.437 572.379 C 178.204 570.891 178.411 568.684 179.899 567.451 Z\" style=\"\"/>\n      <path d=\"M 179.899 594.438 C 178.411 593.205 178.204 590.998 179.437 589.51 L 197.331 567.913 C 198.564 566.425 200.771 566.218 202.259 567.451 C 203.747 568.684 203.954 570.891 202.721 572.379 L 184.827 593.976 C 183.594 595.464 181.387 595.671 179.899 594.438 Z\" style=\"\" transform=\"matrix(-1, 0, 0, -1, 382.158005, 1161.888977)\"/>\n    </g>\n  </g>\n</svg>";
},{}],"aS9Vh":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g transform=\"matrix(4.191946, 0, 0, 4.191946, -547.467407, -2186.973145)\" style=\"\">\n    <path d=\"M 238.041 531.248 L 238.041 559.209 L 142.435 559.209 L 142.435 531.248 L 238.041 531.248 Z M 149.435 552.209 L 231.041 552.209 L 231.041 538.248 L 149.435 538.248 L 149.435 552.209 Z\" style=\"\"/>\n    <path d=\"M 238.041 603.484 L 238.041 631.445 L 142.435 631.445 L 142.435 603.484 L 238.041 603.484 Z M 149.435 624.445 L 231.041 624.445 L 231.041 610.484 L 149.435 610.484 L 149.435 624.445 Z\" style=\"\"/>\n    <g transform=\"matrix(1.004275, 0, 0, 0.874231, -1.657875, 73.46685)\">\n      <path d=\"M 179.899 567.451 C 181.387 566.218 183.594 566.425 184.827 567.913 L 202.721 589.51 C 203.954 590.998 203.747 593.205 202.259 594.438 C 200.771 595.671 198.564 595.464 197.331 593.976 L 179.437 572.379 C 178.204 570.891 178.411 568.684 179.899 567.451 Z\" style=\"\"/>\n      <path d=\"M 179.899 594.438 C 178.411 593.205 178.204 590.998 179.437 589.51 L 197.331 567.913 C 198.564 566.425 200.771 566.218 202.259 567.451 C 203.747 568.684 203.954 570.891 202.721 572.379 L 184.827 593.976 C 183.594 595.464 181.387 595.671 179.899 594.438 Z\" style=\"\" transform=\"matrix(-1, 0, 0, -1, 382.158005, 1161.888977)\"/>\n    </g>\n  </g>\n</svg>";
},{}],"f5zUE":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g transform=\"matrix(0, -4.106153, 4.106098, 0, -2115.950684, 503.524231)\" style=\"\">\n    <path d=\"M 105.08 531.22 L 105.08 559.181 L 9.474 559.181 L 9.474 531.22 L 105.08 531.22 Z M 16.474 552.181 L 98.08 552.181 L 98.08 538.22 L 16.474 538.22 L 16.474 552.181 Z\" style=\"\"/>\n    <path d=\"M 104.667 603.456 L 104.667 631.417 L 9.061 631.417 L 9.061 603.456 L 104.667 603.456 Z M 16.061 624.417 L 97.667 624.417 L 97.667 610.456 L 16.061 610.456 L 16.061 624.417 Z\" style=\"\"/>\n    <path d=\"M 114.424 567.338 L 114.424 595.299 L 33.485 595.299 L 33.485 567.338 L 114.424 567.338 Z\" style=\"\"/>\n  </g>\n</svg>";
},{}],"bicvn":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g transform=\"matrix(4.106126, 0, 0, 4.106126, 17.477514, -2136.966797)\" style=\"\">\n    <path d=\"M 105.08 531.22 L 105.08 559.181 L 9.474 559.181 L 9.474 531.22 L 105.08 531.22 Z M 16.474 552.181 L 98.08 552.181 L 98.08 538.22 L 16.474 538.22 L 16.474 552.181 Z\" style=\"\"/>\n    <path d=\"M 104.667 603.456 L 104.667 631.417 L 9.061 631.417 L 9.061 603.456 L 104.667 603.456 Z M 16.061 624.417 L 97.667 624.417 L 97.667 610.456 L 16.061 610.456 L 16.061 624.417 Z\" style=\"\"/>\n    <path d=\"M 114.424 567.338 L 114.424 595.299 L 33.485 595.299 L 33.485 567.338 L 114.424 567.338 Z\" style=\"\"/>\n  </g>\n</svg>";
},{}],"DGC1Q":[function(require,module,exports,__globalThis) {
module.exports="<svg width=\"382px\" height=\"512px\" version=\"1.1\" style=\"shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd\" viewBox=\"0 0 24.33 32.53\" xmlns=\"http://www.w3.org/2000/svg\">\r\n  <g id=\"Vrstva_x0020_1\">\r\n    <path class=\"fil0\" d=\"M4.23 0l10.88 0 9.22 9.61 0 18.69c0,2.33 -1.9,4.23 -4.23,4.23l-15.87 0c-2.34,0 -4.23,-1.9 -4.23,-4.23l0 -24.07c0,-2.34 1.89,-4.23 4.23,-4.23z\" style=\"fill: rgb(37, 29, 54);\"></path>\r\n    <polygon class=\"fil1\" points=\"15.1,0 15.1,9.53 24.33,9.53 \" style=\"fill: rgb(255, 255, 255); fill-opacity: 0.3;\"></polygon>\r\n    <path class=\"fil2\" d=\"M16.45 21.21l-8.57 0c-0.4,0 -0.72,0.32 -0.72,0.72 0,0.39 0.32,0.71 0.72,0.71l8.57 0c0.4,0 0.72,-0.32 0.72,-0.71 0,-0.4 -0.32,-0.72 -0.72,-0.72l0 0zm0 2.86l-8.57 0c-0.4,0 -0.72,0.32 -0.72,0.72 0,0.39 0.32,0.71 0.72,0.71l8.57 0c0.4,0 0.72,-0.32 0.72,-0.71 0,-0.4 -0.32,-0.72 -0.72,-0.72l0 0zm-4.36 -8.57l-4.21 0c-0.4,0 -0.72,0.31 -0.72,0.71 0,0.4 0.32,0.71 0.72,0.71l4.21 0c0.4,0 0.72,-0.31 0.72,-0.71 0,-0.4 -0.32,-0.71 -0.72,-0.71l0 0zm4.36 2.85l-8.57 0c-0.4,0 -0.72,0.32 -0.72,0.72 0,0.39 0.32,0.71 0.72,0.71l8.57 0c0.4,0 0.72,-0.32 0.72,-0.71 0,-0.4 -0.32,-0.72 -0.72,-0.72l0 0z\" style=\"fill: rgb(255, 255, 255);\"></path>\r\n  </g>\r\n</svg>";
},{}],"eJL36":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg viewBox=\"0 0 500 500\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M 27.593 241.155 L 193.286 406.847 L 469.441 75.462\" style=\"fill: none; stroke-width: 50px; stroke-linecap: round; stroke-linejoin: round;\"/>\n  <path d=\"M 9.915 223.477 C 0.152 233.241 0.152 249.07 9.915 258.833 L 175.608 424.525 L 194.966 443.882 L 212.492 422.852 L 488.647 91.467 C 497.486 80.86 496.053 65.096 485.446 56.256 C 474.839 47.417 459.075 48.85 450.236 59.457 L 191.606 369.812 L 45.271 223.477 C 35.507 213.714 19.678 213.714 9.915 223.477 Z\" style=\"fill: none;\"/>\n  <path d=\"M 56.474 228.822 L 125.38 297.728 L 194.285 366.633 L 318.04 218.127 L 441.795 69.62 C 444.404 66.684 447.708 64.223 451.261 62.393 C 454.814 60.564 458.616 59.365 462.221 58.954 C 465.845 58.709 469.811 59.231 473.644 60.418 C 477.478 61.605 481.178 63.458 484.269 65.875 C 487.206 68.484 489.667 71.788 491.497 75.342 C 493.327 78.895 494.525 82.698 494.936 86.302 C 495.182 89.925 494.673 93.875 493.499 97.692 C 492.324 101.51 490.484 105.195 488.066 108.287 L 353.67 269.557 L 220.597 428.534 C 216.523 432.448 216.365 433.087 211.872 436.294 C 207.379 439.501 203.175 440.801 197.906 440.801 C 191.938 440.801 185.864 438.25 180.521 435.572 C 176.428 433.52 169.648 427.363 169.648 427.363 L 94.403 352.029 L 13.779 271.405 C 11.093 268.551 8.899 265.059 7.376 261.369 C 5.854 257.679 5.003 253.79 5.003 250.142 C 5.003 246.491 5.883 242.573 7.434 238.854 C 8.985 235.135 11.207 231.617 13.89 228.766 C 16.745 226.081 20.237 223.886 23.927 222.364 C 27.617 220.841 31.505 219.99 35.154 219.99 C 38.803 219.99 42.706 220.856 46.411 222.392 C 50.115 223.929 53.621 226.137 56.474 228.822 Z\" style=\"\"/>\n</svg>";
},{}],"9RNXw":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg width=\"25.235\" height=\"20\" viewBox=\"0 0 25.235 20\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g id=\"Group_10943\" data-name=\"Group 10943\" transform=\"translate(-450.765 -879)\"/>\n  <path d=\"M 14.098 4.012 L 6.055 18 L 22.141 18 L 14.098 4.012 M 14.098 1.006 C 14.435 1.006 14.773 1.173 14.965 1.508 L 24.736 18.502 C 25.12 19.168 24.638 20 23.869 20 L 4.327 20 C 3.558 20 3.076 19.168 3.46 18.502 L 13.231 1.508 C 13.423 1.173 13.761 1.006 14.098 1.006 Z\"/>\n  <path d=\"M 10.35 3.042 L 3.148 15.567 L 5.06 15.567 C 5.62 14.658 6.77 12.785 11.341 4.684 L 10.35 3.042 M 10.327 0 C 10.639 0 10.951 0.155 11.129 0.464 L 13.657 4.649 C 6.749 16.911 6.986 16.158 6.198 17.567 L 1.289 17.567 C 0.578 17.567 0.133 16.798 0.488 16.181 L 9.525 0.464 C 9.703 0.155 10.015 0 10.327 0 Z\" stroke=\"none\" style=\"\"/>\n</svg>";
},{}],"cvPQX":[function(require,module,exports,__globalThis) {
module.exports="<svg style=\"background:#fff\" xmlns=\"http://www.w3.org/2000/svg\" data-name=\"Layer 1\" width=\"742.41705\" height=\"712.57302\" viewBox=\"0 0 742.41705 712.57302\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><path id=\"aa38b2e7-2ea9-4025-adcf-83f87c0cfc4a-229\" data-name=\"Path 968\" d=\"M853.60644,262.60547h-3.9v-106.977a61.915,61.915,0,0,0-61.915-61.915h-226.65a61.915,61.915,0,0,0-61.916,61.914v586.884a61.915,61.915,0,0,0,61.915,61.915h226.648a61.915,61.915,0,0,0,61.915-61.915v-403.758h3.9Z\" transform=\"translate(-228.79147 -93.71349)\" fill=\"#3f3d56\"/><path id=\"f27259c2-0089-4137-bfd8-cb22dff914f1-230\" data-name=\"Path 969\" d=\"M837.00647,151.48149v595.175a46.959,46.959,0,0,1-46.942,46.952h-231.3a46.966,46.966,0,0,1-46.973-46.952v-595.175a46.965,46.965,0,0,1,46.971-46.951h28.058a22.329,22.329,0,0,0,20.656,30.74h131.868a22.329,22.329,0,0,0,20.656-30.74h30.055a46.959,46.959,0,0,1,46.951,46.942Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-bg\"/><circle id=\"fc31cc31-f989-45cc-bd1e-521a0ee1871b\" data-name=\"Ellipse 18\" cx=\"445.56497\" cy=\"200.129\" r=\"96.565\" class=\"svg-fill-secondary\"/><path id=\"a573942c-3bf3-4c43-b474-689725a927f7-231\" data-name=\"Path 39\" d=\"M779.67245,494.30947h-205.537a3.81,3.81,0,0,1-3.806-3.806V439.51949a3.811,3.811,0,0,1,3.806-3.806h205.537a3.811,3.811,0,0,1,3.806,3.806v50.985a3.811,3.811,0,0,1-3.806,3.806Zm-205.537-57.074a2.286,2.286,0,0,0-2.284,2.284v50.985a2.286,2.286,0,0,0,2.284,2.284h205.537a2.286,2.286,0,0,0,2.284-2.284v-50.985a2.286,2.286,0,0,0-2.284-2.284Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-light-grey\"/><path id=\"fb5feb1e-1fe2-48fa-806d-0a2b51d12b49-232\" data-name=\"Path 40\" d=\"M637.69945,454.07448a2.66449,2.66449,0,0,0,0,5.329h125.605a2.665,2.665,0,0,0,.2041-5.32611q-.0585-.00221-.11713-.0019h-125.692Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-light-grey\"/><path id=\"bcb9932f-0864-4b7e-b0ed-f7254bb9b8bf-233\" data-name=\"Path 41\" d=\"M637.69945,470.05846a2.66449,2.66449,0,0,0,0,5.329h125.605a2.665,2.665,0,0,0,.2041-5.32611q-.0585-.00219-.11713-.00189h-125.692Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-light-grey\"/><path id=\"f88e2a8b-becc-4da9-bd36-af011daaaaf2-234\" data-name=\"Path 42\" d=\"M779.67245,579.28947h-205.537a3.81,3.81,0,0,1-3.806-3.806V524.49949a3.811,3.811,0,0,1,3.806-3.806h205.537a3.811,3.811,0,0,1,3.806,3.806v50.985A3.811,3.811,0,0,1,779.67245,579.28947Zm-205.537-57.074a2.286,2.286,0,0,0-2.284,2.284v50.985a2.286,2.286,0,0,0,2.284,2.284h205.537a2.286,2.286,0,0,0,2.284-2.284v-50.985a2.286,2.286,0,0,0-2.284-2.284Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-light-grey\"/><path id=\"e192d34f-2ccc-4f79-b47a-46430e4d87f6-235\" data-name=\"Path 43\" d=\"M637.69945,539.33047a2.66449,2.66449,0,0,0,0,5.329h125.605a2.665,2.665,0,0,0,.087-5.328h-125.692Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-light-grey\"/><path id=\"b230677c-48cc-4ee6-87d6-a753204ffe47-236\" data-name=\"Path 44\" d=\"M637.69945,555.3185a2.66449,2.66449,0,0,0,0,5.329h125.605a2.665,2.665,0,0,0,.087-5.328h-125.692Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-light-grey\"/><path id=\"b88a2a79-0ae3-4fd9-9894-02e0db9a2271-237\" data-name=\"Path 39-2\" d=\"M779.67245,664.54748h-205.537a3.81,3.81,0,0,1-3.806-3.806V609.7575a3.811,3.811,0,0,1,3.806-3.806h205.537a3.811,3.811,0,0,1,3.806,3.806v50.985a3.811,3.811,0,0,1-3.806,3.806Zm-205.537-57.074a2.286,2.286,0,0,0-2.284,2.284v50.985a2.286,2.286,0,0,0,2.284,2.284h205.537a2.286,2.286,0,0,0,2.284-2.284v-50.985a2.286,2.286,0,0,0-2.284-2.284Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-light-grey\"/><path id=\"aa2394a9-8b56-4a12-a2cd-a583e6ea12eb-238\" data-name=\"Path 40-2\" d=\"M637.69945,624.59148a2.66449,2.66449,0,1,0,0,5.329h125.605a2.665,2.665,0,0,0,.2041-5.32611q-.0585-.00219-.11713-.00189h-125.692Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-light-grey\"/><path id=\"bc352cb2-8959-4b51-bd18-df6817a9a47e-239\" data-name=\"Path 41-2\" d=\"M637.69945,640.57846a2.66449,2.66449,0,0,0,0,5.329h125.605a2.665,2.665,0,0,0,.2041-5.32611q-.0585-.0022-.11713-.00189h-125.692Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-light-grey\"/><path id=\"b30ee82f-5b3a-4aa4-9db7-ead828191937-240\" data-name=\"Path 970\" d=\"M969.27042,806.28651h-738.541c-1.071,0-1.938-.468-1.938-1.045s.868-1.045,1.938-1.045H969.27054c1.06994,0,1.938.468,1.938,1.045S970.34146,806.28651,969.27042,806.28651Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-light-grey\"/><g id=\"f24cf2fd-107c-4150-a0f1-6f6b12d88bf3\" data-name=\"Group 58\"><path id=\"a2b576eb-bb95-4480-aa60-cd8aa023fe61-241\" data-name=\"Path 438\" d=\"M937.99248,765.52151a19.4741,19.4741,0,0,1-18.806-3.313c-6.587-5.528-8.652-14.636-10.332-23.07l-4.97-24.945,10.405,7.165c7.483,5.152,15.134,10.47,20.316,17.933s7.443,17.651,3.28,25.726\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-light-grey\"/><path id=\"fe1c5433-44e0-47a6-8430-329cbd7c4dea-242\" data-name=\"Path 439\" d=\"M936.38547,797.45852c1.31-9.542,2.657-19.206,1.738-28.849-.816-8.565-3.429-16.93-8.749-23.789a39.57365,39.57365,0,0,0-10.153-9.2c-1.015-.641-1.95.968-.939,1.606a37.62192,37.62192,0,0,1,14.881,17.956c3.24,8.241,3.76,17.224,3.2,25.977-.338,5.294-1.053,10.553-1.774,15.805a.964.964,0,0,0,.65,1.144.936.936,0,0,0,1.144-.65Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-grey\"/><path id=\"f0043cfc-c9b9-4981-8afd-8c13c1b6f93f-243\" data-name=\"Path 442\" d=\"M926.95847,782.14846a14.336,14.336,0,0,1-12.491,6.447c-6.323-.3-11.595-4.713-16.34-8.9l-14.035-12.395,9.289-.444c6.68-.32,13.533-.618,19.9,1.442s12.231,7.018,13.394,13.6\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-light-grey\"/><path id=\"b883c521-5e9e-4a38-b47c-4f8b0cd8c6cd-244\" data-name=\"Path 443\" d=\"M940.08649,802.94344c-6.3-11.156-13.618-23.555-26.685-27.518a29.77874,29.77874,0,0,0-11.224-1.159c-1.192.1-.894,1.94.3,1.837a27.6648,27.6648,0,0,1,17.912,4.739c5.051,3.438,8.983,8.217,12.311,13.286,2.039,3.1,3.865,6.341,5.691,9.573C938.97147,804.73348,940.67746,803.98843,940.08649,802.94344Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-grey\"/></g><g id=\"b241f6a5-c54d-499c-8ecd-4235a19d143f\" data-name=\"Group 59\"><circle id=\"bfaee8a8-2192-45bf-83cb-a2f223d41a02\" data-name=\"Ellipse 5\" cx=\"370.98597\" cy=\"370.985\" r=\"15.986\" class=\"svg-fill-secondary\"/><path id=\"ae47602b-fb54-4e88-955d-49b260f35f7f-245\" data-name=\"Path 40-3\" d=\"M592.12445,461.71247c-.184,0-.333,1.193-.333,2.664s.149,2.665.333,2.665h15.719c.184.024.336-1.149.339-2.62a5.94291,5.94291,0,0,0-.328-2.708h-15.73Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-light-grey\"/></g><g id=\"a1e1e52b-75f8-4aa9-8279-faf451e6aae1\" data-name=\"Group 60\"><circle id=\"fa3a3ce2-c232-40ee-81b4-25b83d5b931c\" data-name=\"Ellipse 5-2\" cx=\"370.98597\" cy=\"456.278\" r=\"15.986\" class=\"svg-fill-secondary\"/><path id=\"aaaffa69-7c16-47ec-b12d-87139789d2df-246\" data-name=\"Path 40-4\" d=\"M592.12445,547.00547c-.184,0-.333,1.193-.333,2.664s.149,2.665.333,2.665h15.719c.184.024.336-1.149.339-2.62a5.94291,5.94291,0,0,0-.328-2.708h-15.73Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-light-grey\"/></g><g id=\"fd2b54c2-3dec-4fb6-9f72-e6c667a136b8\" data-name=\"Group 61\"><circle id=\"abc19202-5605-459b-9c25-b430addb8839\" data-name=\"Ellipse 5-3\" cx=\"370.98597\" cy=\"541.53599\" r=\"15.986\" class=\"svg-fill-secondary\"/><path id=\"f69fbb38-8754-494b-94fa-96f6df4fd0e7-247\" data-name=\"Path 40-5\" d=\"M592.12445,632.26346c-.184,0-.333,1.193-.333,2.664s.149,2.665.333,2.665h15.719c.184.024.336-1.149.339-2.62a5.943,5.943,0,0,0-.328-2.708h-15.73Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-light-grey\"/></g><rect x=\"670.35645\" y=\"260.34249\" width=\"8\" height=\"67\" transform=\"translate(-239.05506 469.193) rotate(-45)\" class=\"svg-fill-bg\"/><rect x=\"670.35645\" y=\"260.34249\" width=\"8\" height=\"67\" transform=\"translate(176.50097 -484.49103) rotate(45)\" class=\"svg-fill-bg\"/><path d=\"M319.05083,549.84841a10.05579,10.05579,0,0,0,5.38778-14.44741l23.56521-26.86373-18.39547-2.53779-19.5577,25.89933a10.11027,10.11027,0,0,0,9.00018,17.9496Z\" transform=\"translate(-228.79147 -93.71349)\" fill=\"#9f616a\"/><polygon points=\"118.679 694.215 102.244 694.214 94.425 630.82 118.682 630.821 118.679 694.215\" fill=\"#9f616a\"/><path d=\"M351.66209,803.8602l-52.99477-.002v-.6703a20.62815,20.62815,0,0,1,20.627-20.62671h.00131l32.3674.00131Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-grey\"/><polygon points=\"204.713 680.461 189.017 685.334 162.751 627.11 185.917 619.918 204.713 680.461\" fill=\"#9f616a\"/><path d=\"M442.23214,788.14677,391.62055,803.8602l-.19877-.64014a20.62813,20.62813,0,0,1,13.58247-25.81574l.00126-.00039,30.91186-9.59713Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-grey\"/><path id=\"ae9bdfa9-f7e0-4b2f-8168-ca8868d01318-248\" data-name=\"Path 973\" d=\"M334.88445,495.65649l-24.34114,27.8773,19.05613,1.71471Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-light-grey\"/><path id=\"b88343d2-9c47-4183-8a8a-427a73d8d9be-249\" data-name=\"Path 975\" d=\"M325.37344,531.58948s-8.455,4.227-9.512,23.251,3.171,68.7,3.171,68.7-4.227,22.194,0,42.274-4.227,93,1.057,93,32.762,3.171,33.819,0,2.114-50.729,2.114-50.729,8.455-24.308,0-39.1c0,0,29.52086,51.54832,48.615,90.889,4.17891,8.61,35.933-1.057,30.649-10.569s-17.966-52.843-17.966-52.843-9.512-31.706-26.421-45.445l8.455-67.639s17.967-45.445,7.4-51.786S325.37344,531.58948,325.37344,531.58948Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-grey\"/><circle id=\"fdc24b21-a9e1-47f2-b2e4-7458730b7c21\" data-name=\"Ellipse 182\" cx=\"128.28696\" cy=\"238.129\" r=\"27.478\" fill=\"#a0616a\"/><path id=\"ac268c91-41f4-49c7-bce6-773e5eb69fa2-250\" data-name=\"Path 976\" d=\"M387.72745,361.43447l-34.16,20.08s-13.08,7.366-17.966,20.08c-5.208,13.55-2.181,32.628,0,36.99,4.227,8.455-1.773,29.592-1.773,29.592l-5.284,48.615s-19.023,17.966-4.227,20.08,41.217-1.057,57.07,0,33.819,3.171,28.535-7.4-11.625-17.967-5.284-39.1c4.962-16.54,4.747-78.383,4.419-104.5a21.025,21.025,0,0,0-10.211-17.767Z\" transform=\"translate(-228.79147 -93.71349)\" fill=\"#e5e5e5\"/><path id=\"aebed2c8-94ca-417e-8b11-27e17cbf3024-251\" data-name=\"Path 980\" d=\"M372.40744,394.72649l3.17,64.468-30.726,62.223-5.211-1.983,31.706-58.127Z\" transform=\"translate(-228.79147 -93.71349)\" opacity=\"0.1\" style=\"isolation:isolate\"/><path id=\"e13ea0c4-bc86-4025-9528-1665a42d3372-252\" data-name=\"Path 982\" d=\"M407.27945,472.93247v-7.4l-35.929,59.186Z\" transform=\"translate(-228.79147 -93.71349)\" opacity=\"0.1\" style=\"isolation:isolate\"/><path id=\"eb3190ba-6b3f-4b2b-91d1-1543e580b413-253\" data-name=\"Path 983\" d=\"M337.57645,306.38749l-4.539-1.816s9.5-10.457,22.713-9.548l-3.717-4.092s9.085-3.637,17.345,5.91c4.342,5.019,9.365,10.919,12.5,17.564h4.865l-2.03,4.471,7.106,4.471-7.294-.8a24.73921,24.73921,0,0,1-.69,11.579l.2,3.534s-8.459-13.089-8.459-14.905v4.547s-4.543-4.092-4.543-6.82l-2.478,3.183-1.239-5-15.28,5,2.476-4.094-9.5,1.364,3.717-5s-10.737,5.91-11.15,10.912-5.781,11.366-5.781,11.366l-2.478-4.547S325.60443,313.20747,337.57645,306.38749Z\" transform=\"translate(-228.79147 -93.71349)\" class=\"svg-fill-grey\"/><path d=\"M355.35408,552.83885a10.05581,10.05581,0,0,0,2.73778-15.17434l18.42263-30.62-18.55382.76775-14.64995,28.95959a10.11028,10.11028,0,0,0,12.04336,16.067Z\" transform=\"translate(-228.79147 -93.71349)\" fill=\"#9f616a\"/><path id=\"a62f6567-f472-4931-86f9-ff652851a370-254\" data-name=\"Path 981\" d=\"M397.24046,375.17548l7.926-1.585s23.779,17.438,16.381,52.314-40.16,87.719-40.16,87.719-7.4,9.512-9.512,11.625-6.341,0-4.227,3.171-3.171,5.284-3.171,5.284-23.251,0-21.137-8.455,38.047-68.7,38.047-68.7l-5.284-56.013S371.87446,373.0615,397.24046,375.17548Z\" transform=\"translate(-228.79147 -93.71349)\" fill=\"#e5e5e5\"/></svg>";
},{}],"c0b7C":[function(require,module,exports,__globalThis) {
module.exports="<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<svg data-name=\"Layer 1\" width=\"801.18574\" height=\"580.5\" viewBox=\"0 0 801.2 318\" xmlns=\"http://www.w3.org/2000/svg\">\n  <polygon points=\"618.281 24.047 630.721 2.5 605.841 2.5 618.281 24.047 630.721 2.5 605.841 2.5 618.281 24.047\" class=\"svg-fill-secondary\"/>\n  <path d=\"M993.41062,211.65425H687.92426a7.18489,7.18489,0,0,0-7.18228,7.18228V463.0341a7.18489,7.18489,0,0,0,7.18228,7.18225H993.41062a7.18487,7.18487,0,0,0,7.18225-7.18225V218.83653A7.1849,7.1849,0,0,0,993.41062,211.65425Z\" transform=\"translate(-199.40713 -159.75)\" class=\"svg-fill-bg\"/>\n  <path d=\"M993.41062,211.65425H687.92426a7.18489,7.18489,0,0,0-7.18228,7.18228V463.0341a7.18489,7.18489,0,0,0,7.18228,7.18225H993.41062a7.18487,7.18487,0,0,0,7.18225-7.18225V218.83653A7.1849,7.1849,0,0,0,993.41062,211.65425ZM997.72,463.0341a4.3159,4.3159,0,0,1-4.30939,4.30939H687.92426a4.31588,4.31588,0,0,1-4.30936-4.30939V218.83653a4.31585,4.31585,0,0,1,4.30936-4.30935H993.41062a4.31586,4.31586,0,0,1,4.30939,4.30935Z\" transform=\"translate(-199.40713 -159.75)\" fill=\"#3f3d56\"/>\n  <path id=\"bdfa4fc8-4cb4-40eb-9316-b2c126b9d895-367\" data-name=\"b7b74475-3363-467c-a0a1-8003b6263e2a\" d=\"M769.18888,240.85622a5.6949,5.6949,0,0,0,0,11.38827H911.959a5.6949,5.6949,0,1,0,.187-11.38827h0q-.09348-.00156-.187,0Z\" transform=\"translate(-199.40713 -159.75)\" class=\"svg-fill-light-grey\"/>\n  <path id=\"ba5c2980-9af9-481d-8c77-79bdfacc1013-368\" data-name=\"b7b74475-3363-467c-a0a1-8003b6263e2a\" d=\"M769.18888,287.10622a5.6949,5.6949,0,0,0,0,11.38827H911.959a5.6949,5.6949,0,1,0,.187-11.38827h0q-.09348-.00156-.187,0Z\" transform=\"translate(-199.40713 -159.75)\" class=\"svg-fill-light-grey\"/>\n  <path id=\"b2c440dc-2978-421d-842d-61ca392e7a22-369\" data-name=\"b7b74475-3363-467c-a0a1-8003b6263e2a\" d=\"M769.18888,333.35622a5.6949,5.6949,0,0,0,0,11.38827H911.959a5.6949,5.6949,0,1,0,.187-11.38827h0q-.09348-.00156-.187,0Z\" transform=\"translate(-199.40713 -159.75)\" class=\"svg-fill-light-grey\"/>\n  <path id=\"fd456212-3b0e-49ae-973c-3928d43fcb5e-370\" data-name=\"b7b74475-3363-467c-a0a1-8003b6263e2a\" d=\"M769.18888,379.60622a5.6949,5.6949,0,0,0,0,11.38827H911.959a5.6949,5.6949,0,1,0,.187-11.38827h0q-.09348-.00156-.187,0Z\" transform=\"translate(-199.40713 -159.75)\" class=\"svg-fill-light-grey\"/>\n  <path id=\"b6f2880d-9a57-4c5b-8223-e7bf3dd6e24d-371\" data-name=\"b7b74475-3363-467c-a0a1-8003b6263e2a\" d=\"M769.18888,425.85622a5.6949,5.6949,0,0,0,0,11.38827H911.959a5.6949,5.6949,0,1,0,.187-11.38827h0q-.09348-.00156-.187,0Z\" transform=\"translate(-199.40713 -159.75)\" class=\"svg-fill-light-grey\"/>\n  <path d=\"M823.40713,196.25h-623a1,1,0,0,1,0-2h623a1,1,0,0,1,0,2Z\" transform=\"translate(-199.40713 -159.75)\" class=\"svg-fill-light-grey\"/>\n  <circle cx=\"23.50787\" cy=\"11.5\" r=\"11\" fill=\"#3f3d56\"/>\n  <circle cx=\"61.50787\" cy=\"11.5\" r=\"11\" fill=\"#3f3d56\"/>\n  <circle cx=\"99.50787\" cy=\"11.5\" r=\"11\" fill=\"#3f3d56\"/>\n  <path d=\"M780.915,182.75h-81a11.5,11.5,0,0,1,0-23h81a11.5,11.5,0,0,1,0,23Z\" transform=\"translate(-199.40713 -159.75)\" class=\"svg-fill-secondary\"/>\n</svg>";
},{}],"1i2mM":[function(require,module,exports,__globalThis) {
module.exports="<svg xmlns=\"http://www.w3.org/2000/svg\" data-name=\"Layer 1\" width=\"862.70323\" height=\"644.78592\" viewBox=\"0 0 862.70323 644.78592\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><polygon points=\"629.943 612.644 612.777 612.644 604.608 546.435 629.943 546.435 629.943 612.644\" fill=\"#9e616a\"/><path d=\"M807.65107,769.99215H795.34112l-2.19727-11.62205-5.62754,11.62205H754.86738A7.33919,7.33919,0,0,1,750.697,756.6135l26.07247-18.00658v-11.7495l27.42368,1.63683Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#2f2e41\"/><polygon points=\"731.923 590.981 718.148 601.224 672.085 552.969 692.415 537.851 731.923 590.981\" fill=\"#9e616a\"/><path d=\"M925.58816,737.04791,915.71,744.39344l-8.69827-8.015,2.41922,12.68419-26.19923,19.48211a7.33918,7.33918,0,0,1-11.32976-8.24721l10.17712-30.00728-7.0111-9.42842,22.98294-15.05066Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#2f2e41\"/><path d=\"M818.57583,398.64705s32.56879,28.13791,17.542,108.35207l-18.3454,78.59653,59.8294,99.2561-19.07664,23.20771-77.77961-107.4334-28.18529-66.11365L744.6516,416.843Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#2f2e41\"/><polygon points=\"599.447 425.746 597.488 456.084 603.483 585.365 631.692 580.452 637.083 488.406 599.447 425.746\" fill=\"#2f2e41\"/><polygon points=\"237.445 628.211 252.796 628.21 260.098 569.001 237.443 569.002 237.445 628.211\" fill=\"#ffb6b6\"/><path d=\"M402.178,750.80612l4.32074-.00018,16.86888-6.86018,9.0412,6.85913H432.41A19.26648,19.26648,0,0,1,451.67546,770.07v.62605l-49.49658.00183Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#2f2e41\"/><polygon points=\"296.932 618.538 311.905 621.918 332.071 565.772 309.972 560.782 296.932 618.538\" fill=\"#ffb6b6\"/><path d=\"M462.86463,740.39329l4.21465.9516,17.96568-2.97583,7.3082,8.68223.0012.00027a19.26648,19.26648,0,0,1,14.54854,23.03569l-.1379.61067L458.48379,759.7967Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#2f2e41\"/><path d=\"M386.6516,393.843c-7.19708,21.70636-6.43618,45.268,1.72992,70.55606l3.49087,142.37821S386.67128,700.146,403.4543,733.00177h24.34l12.05112-134.75129,1.5133-90.44591,52.18244,76.30583L460.30462,730.79868l29.9568,2.678,53.93408-159.1909L477.6516,419.843Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#2f2e41\"/><path d=\"M667.346,332.01487c18.61732-16.77656,46.30893-25.21208,69.53714-15.805a115.466,115.466,0,0,0-51.888,59.93484c-3.6979,9.83846-6.78644,21.16623-15.88188,26.43349-5.65933,3.27753-12.70027,3.4377-19.04568,1.85557-6.34568-1.58237-12.16226-4.75415-17.89913-7.89422l-1.63218-.03691C637.86406,372.53682,648.72872,348.79142,667.346,332.01487Z\" transform=\"translate(-168.64838 -127.60704)\" class=\"svg-fill-grey\"/><path d=\"M736.75328,316.71942A98.69239,98.69239,0,0,0,681.847,342.64994a42.50049,42.50049,0,0,0-8.34534,10.37667,24.37584,24.37584,0,0,0-2.81751,12.51568c.10054,4.05833.67335,8.19792-.21438,12.21a14.92537,14.92537,0,0,1-7.42454,9.68865c-4.54586,2.613-9.7595,3.43673-14.886,4.0651-5.692.69769-11.61526,1.33219-16.54238,4.5248-.597.38683-1.16231-.56211-.56622-.94836,8.57235-5.5546,19.41969-3.5335,28.63724-7.24065,4.30108-1.72983,8.10691-4.76631,9.454-9.35719,1.17794-4.01452.5909-8.2838.45359-12.39207a26.01068,26.01068,0,0,1,2.299-12.34028,39.29038,39.29038,0,0,1,7.9156-10.65924,95.74917,95.74917,0,0,1,24.3333-17.41978A100.44256,100.44256,0,0,1,736.743,315.61475c.70319-.09065.70886,1.01461.01026,1.10467Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#fff\"/><path d=\"M686.44718,337.79134a14.807,14.807,0,0,1,1.63241-19.1039c.50628-.49873,1.30506.26457.79811.764a13.71094,13.71094,0,0,0-1.48216,17.77371c.41512.5769-.53561,1.13983-.94836.56623Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#fff\"/><path d=\"M670.36216,363.49127a28.53932,28.53932,0,0,0,20.3938-4.08346c.59834-.38471,1.16384.56412.56622.94836a29.68517,29.68517,0,0,1-21.23023,4.20607c-.70085-.12626-.42683-1.19655.27021-1.071Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#fff\"/><path d=\"M714.44656,321.9478a8.38148,8.38148,0,0,0,6.2686,4.89443c.7021.11732.42732,1.18753-.27021,1.071a9.39213,9.39213,0,0,1-6.94675-5.39917.57084.57084,0,0,1,.19107-.7573.55506.55506,0,0,1,.75729.19107Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#fff\"/><path d=\"M762.46124,397.11454c-.44048-.06079-.881-.12157-1.32791-.1756a110.37862,110.37862,0,0,0-17.88208-.90839c-.46221.00673-.93053.02051-1.39159.0405a116.3646,116.3646,0,0,0-41.75015,9.61014,113.00482,113.00482,0,0,0-15.16291,8.0555c-6.68773,4.23438-13.602,9.35764-21.078,11.08459a19.38584,19.38584,0,0,1-2.36217.42086l-30.88864-26.74546c-.03969-.096-.0858-.18531-.12584-.28162l-1.28212-1.01147c.23872-.17556.49008-.35251.72879-.52808.138-.10241.283-.19887.421-.30128.09422-.06639.18881-.13253.27-.19782.03128-.02222.0629-.04413.08811-.05934.08122-.06529.1636-.11732.23871-.17556q2.10345-1.4895,4.23516-2.95463c.00611-.007.00611-.007.0191-.00815a166.15689,166.15689,0,0,1,34.601-18.59939c.36686-.13859.73948-.28453,1.12045-.4109a107.831,107.831,0,0,1,16.93919-4.76651,95.32878,95.32878,0,0,1,9.5528-1.33433,79.272,79.272,0,0,1,24.72335,1.7516c16.14332,3.7433,30.90977,12.60785,39.65578,26.43254C762.02688,396.40555,762.24387,396.75367,762.46124,397.11454Z\" transform=\"translate(-168.64838 -127.60704)\" class=\"svg-fill-grey\"/><path d=\"M762.05235,397.44645a98.69236,98.69236,0,0,0-59.45156-12.3533A42.50006,42.50006,0,0,0,689.69,388.35387a24.3758,24.3758,0,0,0-9.78493,8.29673c-2.36313,3.30088-4.39808,6.951-7.52245,9.62a14.92533,14.92533,0,0,1-11.76132,3.26575c-5.2028-.6506-9.86156-3.13185-14.3331-5.71664-4.9648-2.86991-10.0762-5.92951-15.93241-6.34685-.70956-.05056-.5896-1.14861.11888-1.09812,10.1888.72611,17.633,8.8707,27.22462,11.46035,4.47564,1.20837,9.34256,1.07528,13.18213-1.77925,3.35754-2.49617,5.45923-6.25839,7.82305-9.62129a26.01082,26.01082,0,0,1,9.26529-8.46889,39.29037,39.29037,0,0,1,12.73777-3.74506,95.74907,95.74907,0,0,1,29.91669.7416,100.44263,100.44263,0,0,1,32.085,11.59611c.616.351-.04488,1.23688-.65689.88819Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#fff\"/><path d=\"M709.199,383.98345a14.807,14.807,0,0,1,12.80526-14.27057c.7045-.09339.88272.997.17729,1.0905a13.711,13.711,0,0,0-11.88443,13.29895c-.01588.71056-1.11391.58761-1.09812-.11888Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#fff\"/><path d=\"M680.88287,394.81911a28.53928,28.53928,0,0,0,18.74183,9.01806c.70936.05308.58963,1.15113-.11888,1.09812a29.68518,29.68518,0,0,1-19.4835-9.42375c-.48357-.52277.37961-1.21236.86055-.69243Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#fff\"/><path d=\"M741.09383,388.19084a8.38147,8.38147,0,0,0,2.05834,7.68205c.49.51638-.37378,1.20545-.86055.69243a9.39216,9.39216,0,0,1-2.29591-8.49336.57082.57082,0,0,1,.6085-.48962.55506.55506,0,0,1,.48962.6085Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#fff\"/><path d=\"M219.92162,754.74293c-1.45,5.44-5.26,9.97-9.86,13.27-.75.54-1.52,1.04-2.3,1.51-.24.14-.48.29-.73.42q-.405.24-.81.45h-21.63c-.39-.79-.77-1.59-1.15-2.38-9.27-19.48-15.78-40.5-14.67-61.91a79.25417,79.25417,0,0,1,5.17-24.25c5.94-15.47,16.78-28.86,31.69-35.6.37-.17.76-.34,1.14-.5-.12.43-.24.85-.36,1.28a110.78533,110.78533,0,0,0-3.38,17.59c-.06.46-.11.92-.15,1.39a116.05427,116.05427,0,0,0,3.72,42.69c.01.03.01995.07.03.1q1.27506,4.605,2.96,9.07c.88,2.35,1.83,4.67,2.87,6.95C216.80163,734.393,222.62157,744.593,219.92162,754.74293Z\" transform=\"translate(-168.64838 -127.60704)\" class=\"svg-fill-grey\"/><path d=\"M207.04162,646.203c-.21.28-.42005.55-.63.83a98.12885,98.12885,0,0,0-11.12,18.76c-.16.33-.31.66-.44,1a97.8135,97.8135,0,0,0-7.82,29.24,1.49,1.49,0,0,0-.02.21c-.25,2.36005-.4,4.74-.46,7.12a42.48011,42.48011,0,0,0,1.43,13.24,23.7688,23.7688,0,0,0,5.46,9.42c.25.27.5.54.77.8.2.21.42.42.63.62,2.02,1.93,4.23,3.72,6.13,5.79a21.43163,21.43163,0,0,1,2.35,3,14.90407,14.90407,0,0,1,1.6,12.1c-1.36,5.06-4.47,9.33-7.65,13.4-1.59,2.04-3.23,4.1-4.65,6.28-.51995.78-1,1.57-1.43994,2.38h-1.26c.42-.81.88-1.6,1.38-2.38,3.65-5.75,8.84-10.69,11.53-17.02,1.82-4.26995,2.37-9.11.07-13.3a17.68156,17.68156,0,0,0-2.43-3.38c-1.83-2.07-4.02-3.84-6.01-5.71-.5-.47-.99-.95-1.46-1.45a24.96377,24.96377,0,0,1-5.64-8.9,39.23028,39.23028,0,0,1-1.94-13.13c0-2.84.15-5.7.43-8.54.03-.36.07-.73.11-1.1a100.76663,100.76663,0,0,1,19.67-49.23c.2-.28.41-.55.62-.82C206.68163,644.87294,207.47161,645.653,207.04162,646.203Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#fff\"/><path d=\"M186.36526,696.67763a14.807,14.807,0,0,1-12.3542-14.66278.55275.55275,0,0,1,1.10455-.02415,13.711,13.711,0,0,0,11.51986,13.616c.70147.11439.42725,1.18471-.27021,1.071Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#fff\"/><path d=\"M193.164,726.22406a28.5393,28.5393,0,0,0,11.53315-17.308c.15106-.69512,1.22186-.42407,1.071.27021a29.68514,29.68514,0,0,1-12.0379,17.98619c-.58485.40629-1.1479-.54428-.56622-.94836Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#fff\"/><path d=\"M194.96075,665.676a8.38149,8.38149,0,0,0,7.89345-.97168c.57941-.41351,1.14186.53754.56622.94836a9.39215,9.39215,0,0,1-8.72989,1.09429.57082.57082,0,0,1-.40038-.67059.55507.55507,0,0,1,.6706-.40038Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#fff\"/><path d=\"M282.06158,684.87294c-.35.27-.71.54-1.06.82a110.362,110.362,0,0,0-13.29,12c-.32.33-.64.67-.95,1.01l-.01.01a116.347,116.347,0,0,0-22.66,36.14l-.03.09c-.01.03-.02.05-.03.08a114.44321,114.44321,0,0,0-5.03,16.42c-1.22,5.46-2.22,11.31-4.13,16.57-.29.81-.61,1.61-.95,2.38h-44.46c.15-.79.31-1.59.47-2.38a160.30168,160.30168,0,0,1,10.54-33.7c.16-.36.32-.72.5-1.08a108.30478,108.30478,0,0,1,8.61-15.35.0098.0098,0,0,1,.01-.01,94.95585,94.95585,0,0,1,5.8-7.69,79.11871,79.11871,0,0,1,18.72-16.24c.04-.03.09-.05.13-.08,14.04-8.71,30.68-12.86,46.59-9.27h.01C281.25158,684.68294,281.6516,684.773,282.06158,684.87294Z\" transform=\"translate(-168.64838 -127.60704)\" class=\"svg-fill-grey\"/><path d=\"M282.01159,685.403c-.34.09-.68.19-1.01.29a98.5888,98.5888,0,0,0-20.17,8.27c-.32.17-.64.35-.96.53a98.25544,98.25544,0,0,0-23.79,18.59.035.035,0,0,0-.01.02c-.08.08-.17.17-.24.25-1.6,1.72-3.14,3.51-4.6,5.35a42.769,42.769,0,0,0-6.82,11.43,23.67365,23.67365,0,0,0-1.31,10.81c.03.37.08.73.13,1.1.04.29.08.58.13.88.66,4.01,1.8,8.03,1.48,12.12a14.90913,14.90913,0,0,1-6.01,10.63,23.794,23.794,0,0,1-3.68,2.34,36.85232,36.85232,0,0,1-5.77,2.38h-3.93c.53-.15,1.05-.3,1.58-.45a48.21182,48.21182,0,0,0,5.53-1.93,26.912,26.912,0,0,0,3-1.48c4.02-2.31,7.37005-5.85,8.07-10.58.61-4.14-.57-8.28-1.27-12.33-.12-.7-.23-1.39-.29-2.08a24.43856,24.43856,0,0,1,.85-10.46,39.0623,39.0623,0,0,1,6.36-11.66,83.355,83.355,0,0,1,5.48-6.55q.36-.40494.75-.81a100.901,100.901,0,0,1,24.21-18.73h.01a99.28782,99.28782,0,0,1,21.1-8.74h.01c.33-.1.67-.2,1-.29C282.53161,684.12294,282.69158,685.213,282.01159,685.403Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#fff\"/><path d=\"M235.116,713.25243a14.807,14.807,0,0,1-1.03613-19.1455c.43212-.5642,1.32915.08079.89646.64574A13.711,13.711,0,0,0,235.97653,712.56c.49121.51367-.37215,1.20316-.86055.69243Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#fff\"/><path d=\"M222.75543,740.93692a28.53931,28.53931,0,0,0,19.62921-6.87574c.53912-.46406,1.2309.397.69242.86054a29.68514,29.68514,0,0,1-20.44051,7.11332c-.71159-.02772-.58885-1.12569.11888-1.09812Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#fff\"/><path d=\"M260.64411,693.67444a8.38149,8.38149,0,0,0,6.8875,3.97657c.71159.01869.58807,1.11668-.11888,1.09812a9.39215,9.39215,0,0,1-7.62917-4.38226.57083.57083,0,0,1,.08406-.77649.55507.55507,0,0,1,.77649.08406Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#fff\"/><path d=\"M625.03076,300.73673a11.59945,11.59945,0,0,1-17.7667.83759l-37.80039,16.44009,3.682-21.10161,35.3314-12.37668a11.66235,11.66235,0,0,1,16.55372,16.20061Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#ffb8b8\"/><path d=\"M599.80571,307.32525l-87.7976,39.10831-.18835-.06738-100.067-35.65889a32.95966,32.95966,0,0,1-14.78168-42.75569h0a32.92423,32.92423,0,0,1,46.9872-14.63652l74.4685,44.85908,72.21121-9.35878Z\" transform=\"translate(-168.64838 -127.60704)\" class=\"svg-fill-grey\"/><path d=\"M1031.35162,771.203a1.1865,1.1865,0,0,1-1.19,1.19h-860.29a1.19,1.19,0,0,1,0-2.38h860.29A1.1865,1.1865,0,0,1,1031.35162,771.203Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#ccc\"/><path d=\"M481.99193,424.40352l-88.50585-14.15674a16.89334,16.89334,0,0,1-9.95557-23.646l4.01367-8.02832-1.55908-84.34668A62.48156,62.48156,0,0,1,416.32152,239.572l8.63086-5.16064,4.36182-11.07666,40.22022.981.11718,14.52734,14.40381,22.96826-.00049.09522-.90381,125.01367-3.96972,12.90137,6.00244,15.00586Z\" transform=\"translate(-168.64838 -127.60704)\" class=\"svg-fill-grey\"/><circle cx=\"284.4591\" cy=\"45.40997\" r=\"36.54413\" fill=\"#ffb8b8\"/><path d=\"M415.05385,180.98352c-1.09-4.59187-.58956-11.05349.02641-15.677,1.61485-12.12129,8.3464-23.64474,18.57336-30.47048a13.37957,13.37957,0,0,1,6.66453-2.64845c2.41939-.101,5.04189,1.19418,5.78465,3.499a11.99254,11.99254,0,0,1,6.76552-6.709,21.1355,21.1355,0,0,1,9.63075-1.29746,35.19728,35.19728,0,0,1,29.36306,20.98947c.97609,2.3188,3.70246-6.24621,4.93916-4.05528a9.7407,9.7407,0,0,0,5.52388,4.85342c2.4233.67619,3.40756,10.66034,4.3612,8.33222a11.0984,11.0984,0,0,1-10.61055,15.47525c-2.46642-.09228-4.82489-.99947-7.262-1.39-8.71512-1.39642-17.96,4.92316-19.82312,13.55058a23.98689,23.98689,0,0,0-3.15565-7.021,8.1187,8.1187,0,0,0-6.51321-3.57866c-2.47957.09278-4.6591,1.7139-6.26793,3.60295s-2.81713,4.093-4.43782,5.97186c-4.7555,5.513-11.18745,18.3697-17.96453,17.432C425.30335,201.103,416.54206,187.25309,415.05385,180.98352Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#2f2e41\"/><path d=\"M674.01238,342.14754a7.1328,7.1328,0,0,0-4.80706-7.85363l-98.41317-32.77709a7.13219,7.13219,0,0,0-2.933-.3368l-24.66687,2.33267-14.15377,1.34255-26.11867,2.46833a7.15519,7.15519,0,0,0-6.38357,5.98973l-13.26135,82.8376a7.18646,7.18646,0,0,0,4.48439,7.79592l99.4404,38.38442a6.94669,6.94669,0,0,0,1.44636.38836,7.13621,7.13621,0,0,0,2.17571.01648l64.25546-9.52349a7.12057,7.12057,0,0,0,6.023-5.99919Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#fff\"/><path d=\"M490.01349,398.1102l99.44009,38.38234a.89711.89711,0,0,0,.457.05366l64.247-9.52224a.88347.88347,0,0,0,.7549-.75161l12.91979-85.06677a.90469.90469,0,0,0-.59937-.98151l-.66169-.22392-97.75762-32.54588a.67787.67787,0,0,0-.13742-.03318.88732.88732,0,0,0-.23-.01192l-60.16426,5.6932-4.77428.44794a.90314.90314,0,0,0-.7947.74781l-13.259,82.83439A.89735.89735,0,0,0,490.01349,398.1102Z\" transform=\"translate(-168.64838 -127.60704)\" class=\"svg-fill-primary\"/><path d=\"M508.28194,313.10237l60.16426-5.6932a.88732.88732,0,0,1,.23.01192.67787.67787,0,0,1,.13742.03318l97.75762,32.54588-25.78658,2.72965-9.65046,1.01669-27.46045,2.90123a1.939,1.939,0,0,1-.24081-.0029c-.04881-.01472-.09762-.02944-.15639-.04511Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#2f2e41\"/><path d=\"M487.75761,403.95209l99.44009,38.38233a6.72242,6.72242,0,0,0,1.4505.37968,7.22358,7.22358,0,0,0,2.17727.02722l64.247-9.52224a7.13521,7.13521,0,0,0,6.02839-6.00387l12.90982-85.06772a7.19014,7.19014,0,0,0-.4184-3.71669c-.06533-.15688-.13072-.31384-.207-.46172a6.99031,6.99031,0,0,0-2.26369-2.69758,7.13789,7.13789,0,0,0-1.91579-.97662l-.11659-.04131-98.29175-32.73751a8.95539,8.95539,0,0,0-1.22721-.29807,7.08573,7.08573,0,0,0-1.71463-.03323l-24.66295,2.32468-14.15253,1.35L502.917,307.3259a7.09173,7.09173,0,0,0-3.01853.99744,1.32948,1.32948,0,0,0-.20245.12125,1.1922,1.1922,0,0,0-.12992.09813,7.14818,7.14818,0,0,0-3.02682,4.76367l-13.2699,82.84346A7.19418,7.19418,0,0,0,487.75761,403.95209Zm10.54219-90.35694a5.29965,5.29965,0,0,1,1.26984-2.6713,4.65147,4.65147,0,0,1,.67571-.65875,5.31719,5.31719,0,0,1,2.32365-1.08389,4.059,4.059,0,0,1,.50915-.07189l43.98466-4.15521,20.96479-1.995c.14217-.01658.27254-.01418.40386-.02168a5.00673,5.00673,0,0,1,.94761.07043,4.14489,4.14489,0,0,1,.84467.20125l98.4084,32.77882c.07775.02754.14554.05407.22323.0816a5.218,5.218,0,0,1,2.27305,1.6537,5.25912,5.25912,0,0,1,1.12074,4.14541l-12.92068,85.07674a5.34916,5.34916,0,0,1-4.5086,4.50155l-64.257,9.52134a5.41346,5.41346,0,0,1-2.72281-.31038l-99.441-38.37237a5.40237,5.40237,0,0,1-3.35921-5.846Z\" transform=\"translate(-168.64838 -127.60704)\" class=\"svg-fill-secondary\"/><path d=\"M499.35216,308.99439a.87724.87724,0,0,1,.268-.38623,1.05132,1.05132,0,0,1,.129-.08817c.04169-.01607.08434-.04216.12611-.05828a.87349.87349,0,0,1,.62383-.01066l2.06994.73016,101.1157,35.66943,23.66513-2.5004,13.24288-1.39675,28.02932-2.96742,2.50639-.26279.48732-.05387a.9043.9043,0,0,1,.95216.65352.73938.73938,0,0,1,.02649.14313.893.893,0,0,1-.55014.92188.98843.98843,0,0,1-.24752.06673l-3.40944.35738-27.60268,2.91775-9.65046,1.01669-27.46045,2.90123a1.939,1.939,0,0,1-.24081-.0029c-.04881-.01472-.09762-.02944-.15639-.04511L500.24535,310.2651l-.3498-.1238a.67025.67025,0,0,1-.21942-.12146A.91016.91016,0,0,1,499.35216,308.99439Z\" transform=\"translate(-168.64838 -127.60704)\" class=\"svg-fill-secondary\"/><path d=\"M588.91905,442.97456a.89376.89376,0,0,1-.74251-1.01574l14.51687-96.33414a.894.894,0,0,1,1.017-.75056l.008.00129a.89377.89377,0,0,1,.74252,1.01574l-14.51687,96.33414a.894.894,0,0,1-1.017.75055Z\" transform=\"translate(-168.64838 -127.60704)\" class=\"svg-fill-secondary\"/><path d=\"M625.716,436.86342l-9.6548,1.01888,11.29337-95.5347s12.89458-2.33464,13.23951-1.39846C640.80631,341.50808,625.80805,436.25066,625.716,436.86342Z\" transform=\"translate(-168.64838 -127.60704)\" class=\"svg-fill-secondary\"/><polygon points=\"331.25 182.533 330.99 226.1 408.116 255.488 435.813 218.284 331.25 182.533\" class=\"svg-fill-secondary\"/><path d=\"M671.13144,337.72465a5.30105,5.30105,0,0,0-2.49688-1.73654l-98.40594-32.7777a5.10582,5.10582,0,0,0-.848-.20665,5.00894,5.00894,0,0,0-.95065-.07115l.15966-.99731.98511-.71323,23.36822-16.9188,78.04053,23.91705.13549,27.05154Z\" transform=\"translate(-168.64838 -127.60704)\" class=\"svg-fill-secondary\"/><path d=\"M503.829,380.07963a1.51326,1.51326,0,0,1,.326.06843l30.19365,9.91686a1.50014,1.50014,0,0,1-.93555,2.85069l-30.19364-9.91685a1.50039,1.50039,0,0,1,.60952-2.91913Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#fff\"/><path d=\"M589.34024,397.72852A11.59947,11.59947,0,0,1,573.433,389.7714L532.421,385.62792l13.53022-16.60628,36.87128,6.48065a11.66236,11.66236,0,0,1,6.5177,22.22623Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#ffb8b8\"/><path d=\"M564.115,391.14082l-95.70849-8.81836-.13135-.15088L398.42455,302.135a32.95967,32.95967,0,0,1,8.01319-44.52344h0a32.92425,32.92425,0,0,1,48.14355,10.209l43.02246,75.54443,67.56543,27.147Z\" transform=\"translate(-168.64838 -127.60704)\" class=\"svg-fill-grey\"/><path d=\"M804.33859,237.22376c-2.37688-17.43387-5.35788-36.15172-17.65411-48.7369a41.34992,41.34992,0,0,0-59.74384.61837c-8.95079,9.54876-12.90365,22.95672-13.2654,36.03983s2.55205,26.02081,5.78442,38.70347a119.28958,119.28958,0,0,0,49.78577-9.79937c3.92617-1.70407,7.789-3.63056,11.93689-4.68634,4.14784-1.05571,7.10454,1.60088,10.96292,3.45335l2.118-4.05545c1.73377,3.22659,7.10244,2.27017,9.04978-.83224C805.26007,244.82608,804.83352,240.853,804.33859,237.22376Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#2f2e41\"/><path d=\"M736.532,334.53244l-69.876,1.49441a11.05455,11.05455,0,1,0-4.93974,15.57383c9.26761.52674,81.77191,10.81733,86.0974,4.18549,4.39027-6.73106,27.82423-30.48612,27.82423-30.48612l-18.01271-25.64378Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#9e616a\"/><circle cx=\"584.91096\" cy=\"94.03525\" r=\"32.83012\" fill=\"#9e616a\"/><path d=\"M599.36147,299.184\" transform=\"translate(-168.64838 -127.60704)\" class=\"svg-fill-primary\"/><path d=\"M806.14195,284.81075c-3.86888-7.69981-5.74873-17.212-13.99671-19.70823-5.56965-1.68563-28.09691.84048-33.17312,3.6859-8.44356,4.73313-.79189,13.60234-5.77332,21.90214-5.41517,9.02271-20.132,27.12978-25.5472,36.15241-3.72279,6.20279,8.8171,24.40947,6.80408,31.358-2.01273,6.94848-2.10962,14.74736,1.31952,21.11722,3.06888,5.70141-1.37137,10.745,1.71521,16.437,3.20957,5.91962,7.14849,28.05274,4.16119,34.08785l-2,6c19.84682,1.16609,36.53459-22.54427,56.25813-25.04188,4.89894-.62032,9.98565-1.43073,14.02251-4.27435,5.94639-4.18864,8.29717-11.78923,9.76638-18.91282A159.32576,159.32576,0,0,0,806.14195,284.81075Z\" transform=\"translate(-168.64838 -127.60704)\" class=\"svg-fill-secondary\"/><path d=\"M835.89793,366.11245c-2.76443-7.54563-7.769-40.5366-7.769-40.5366l-31.32417-.91848,15.31443,37.772-41.79036,58.50283s.07739.12853.21808.35778a11.052,11.052,0,1,0,9.26964,11.74483.76305.76305,0,0,0,.95807-.16445C785.42465,427.035,838.66236,373.65815,835.89793,366.11245Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#9e616a\"/><path d=\"M839.0826,345.27741c-2.87511-12.13478-5.77152-24.33549-10.61887-35.82566s-11.78661-22.34286-21.54669-30.10543c-3.12048-2.48179-6.609-4.67232-10.52078-5.44389-3.91147-.77165-8.31967.09193-11.0667,2.98137-4.39621,4.62357-3.07339,12.0451-1.4611,18.21781Q791,322.40224,798.13123,349.70286q20.59418-2.18287,41.188-4.36591Z\" transform=\"translate(-168.64838 -127.60704)\" class=\"svg-fill-secondary\"/><path d=\"M793.7871,226.19592c-1.20908-7.942-2.47188-15.95043-5.31228-23.42857-2.8404-7.47821-7.41882-14.48249-13.98647-18.71882-10.39879-6.70709-23.862-5.41352-35.52074-1.55544-9.01622,2.9837-17.81761,7.51864-24.17574,14.8093-6.35848,7.29074-9.92957,17.69379-7.56439,27.22665q18.65464-4.40738,37.30893-8.81483l-1.36137.962a30.03765,30.03765,0,0,1,16.03083,20.8927,31.12209,31.12209,0,0,1-6.56554,25.84773q12.72244-4.51323,25.44489-9.0263c5.23526-1.85713,10.83833-3.997,13.94267-8.76047C795.62723,240.107,794.79091,232.78685,793.7871,226.19592Z\" transform=\"translate(-168.64838 -127.60704)\" fill=\"#2f2e41\"/></svg>";
},{}],"hdsGO":[function(require,module,exports,__globalThis) {
module.exports="<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"866.81006\" height=\"443.0676\" viewBox=\"0 0 866.81006 443.0676\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><path d=\"M828.33492,244.95227l-2.71537,21.6217-6.73908,53.70394h-135.38272c1.05718-12.03676,2.50247-29.36207,4.04646-48.06508,.15218-1.86793,.31188-3.74756,.46397-5.63886,3.87162-47.01432,8.10823-100.21632,8.10823-100.21632l17.79852,3.31574,34.53207,6.42112,14.07147,2.61514,37.68114,7.01655c18.78727,3.49074,31.7102,30.69301,28.13532,59.22608Z\" fill=\"#f2f2f2\"/><polygon points=\"725.93018 79.35764 742.57875 108.4915 710.5803 131.16867 696.93018 95.35764 725.93018 79.35764\" fill=\"#ffb6b6\"/><circle cx=\"704.73531\" cy=\"65.67545\" r=\"41.24406\" fill=\"#ffb6b6\"/><path d=\"M701.77389,74.8959c-3.27492-4.9842-1.98953-7.59113-4.73126-9.42283-.00005-.00005-1.10331-.7371-8.99943-1.15733h0c-1.76783-12.72387-3.9747-14.26689-3.97475-14.26694-2.54344-1.77835-6.31806-1.20052-8.66632-.11286-4.96648,2.3004-4.39069,7.26947-7.73471,8.22036-4.61947,1.31356-13.02411-6.09155-13.85211-14.56892-.67539-6.91516,3.77981-13.63146,5.54692-13.27617,1.75207,.35229,5.94686-5.00298,8.2118-4.92038,1.54677,.05641,7.86668-2.69052,9.56681-2.47576,1.85668,.23458,7.97849,3.42925,8.23359,2.69936,1.77276-5.07201,1.25174-6.47929,2.75595-7.93028,2.66541-2.57115,7.02574-.78067,13.86612,.18057,14.07429,1.97776,16.5307-2.66296,23.74347,.48255,3.64355,1.58896,6.69229,5.8742,12.64108,14.3798,8.31932,11.89498,12.47896,17.84248,12.50565,24.77939,.02721,7.0744-3.3985,6.62532-4.90327,17.09838-1.67502,11.65826,1.88393,16.98908-2.00412,20.77661-3.00495,2.92729-9.11284,3.62215-12.32198,1.05303-5.49439-4.39856,1.69602-15.0123-4.38413-22.76671-3.73224-4.75997-11.23802-6.87793-14.67632-4.52502-3.88767,2.66043-1.74599,10.46929-4.47987,11.20979-2.3411,.63413-5.77242-4.58808-6.34311-5.45663Z\" fill=\"#2f2e41\"/><path d=\"M797.8501,237.33762c-1.15039,19.66992-5.71973,25.87988-7.32031,49.10986-.34961,5.1001-.55957,11.02002-.55957,18.08008,0,1.7998,.00977,3.54004,.00977,5.24023,0,3.61963-.06934,7.04004-.49023,10.50977-.31934,2.77002-.86914,5.56006-1.7793,8.5h-88.83008c-.00977-.02002-.00977-.04004-.02051-.06006-.51953-2.25977-.84961-4.41992-1.09961-6.48975-.08008-.66016-.15039-1.31006-.20996-1.9502-.08008-.75-.15039-1.48975-.21973-2.21973-.27051-2.91016-.54004-5.66016-1.18066-8.29004-.85938-3.63037-2.41992-7.05029-5.62012-10.3501-1.30957-1.3501-2.61914-2.3999-3.89941-3.31982-.25-.17041-.49023-.34033-.74023-.51025-3.54004-2.43018-6.88965-4.18018-9.79004-9.14014-.0498-.06982-.08984-.1499-.12988-.21973-.5-.87012-1.7998-3.15039-2.74023-6.18994-.99023-3.16016-1.58984-7.13037-.50977-11.18994,2.57031-9.62012,12.08984-10.58008,19.87012-20.30029,.83984-1.0498,1.66992-2.20996,2.45996-3.5,3.51953-5.72021,4.46973-10.75977,5.58984-16.75,.17969-.97021,.33984-1.93018,.46973-2.85986,.10059-.7002,.19043-1.39014,.26074-2.07031,.61914-5.70996,.31934-10.62988-.41016-15.02979-2.37988-14.41016-9.40039-23.33008-4.44043-36.26025,1.56055-4.05957,3.77051-7.10986,6-9.71973,4.71973-5.53027,9.57031-9.12012,8.73047-16.25977-.85059-7.2002-6.31055-8.19043-6.91992-14.48047-.31055-3.17969,.72949-6.52979,2.67969-9.81982v-.00977c6.24023-10.59033,21.82031-20.34033,31.71973-20.03027,1.83008,.05029,3.4502,.45996,4.7998,1.25,4.89062,2.87988,2.85059,9.16992,10.34082,17.99023,5.56934,6.5498,11.86914,9.16992,14.25977,10.40967,9.46973,4.94043,17.16992,19.51025,22.39941,38.14014,.04004,.14014,.08008,.27979,.12012,.43018,3.23047,11.66992,5.51074,24.91992,6.64062,38.35986,.47949,5.68994,.75977,11.41016,.81934,17.06982,.05078,4.52002-.0498,8.44043-.25977,11.93018Z\" class=\"svg-fill-primary\"/><g><polygon points=\"731.33057 304.72776 729.52002 309.7678 728.38037 312.92747 725.73975 320.27756 722.68018 328.77756 703.01025 328.77756 706.31006 320.27756 707.84033 316.3176 710.38037 309.7678 714.64014 298.7678 731.33057 304.72776\" fill=\"#ffb6b6\"/><path d=\"M790.84033,167.82737c-.0498,.65039-.12012,1.37012-.19043,2.15039-.7793,7.93994-2.62012,22.1499-5.30957,38.35986-1.41992,8.5498-3.08008,17.66016-4.9502,26.70996-4.01953,19.52979-9.01953,38.76025-14.66992,51.3999-1.00977,2.28027-2.0498,4.34033-3.11035,6.16016-.80957,1.39014-1.66016,2.75977-2.5498,4.10986-2.87988,4.43018-6.11035,8.63037-9.45996,12.55029-.12988,.16992-.28027,.33008-.42969,.5-.54004,.63965-1.10059,1.27002-1.66016,1.8999-2.74023,3.08984-5.54004,5.96973-8.25,8.60986-3.2998,3.22021-6.48047,6.07031-9.33008,8.5h-31.94043l-.12988-.06006-4.59961-2.04004s1.30957-1.54004,3.5-4.44971c.4502-.59033,.92969-1.24023,1.4502-1.9502,.63965-.87012,1.33008-1.83008,2.06934-2.87012,1.54004-2.17969,3.29004-4.73975,5.16992-7.63965,3.64062-5.61035,7.79004-12.51025,11.98047-20.5,.48047-.93018,.96973-1.87012,1.45996-2.82031,.00977-.02979,.03027-.06006,.04004-.08984,.83008-1.62012,1.65039-3.29004,2.46973-4.99023,6.9502-14.45996,8.94043-26.45996,9.51074-30.34961,.7998-5.5,1.90918-13.19043,1.60938-21.65039-.2002-5.57959-1.00977-11.47998-2.93945-17.33984v-.00977c-.40039-1.22998-.85059-2.45996-1.36035-3.68018-.91016-2.18994-1.99023-4.3501-3.27051-6.47998-5.64941-9.37988-10.23926-9.77002-13.88965-19.99023-1.08008-3.02979-3.53027-9.86963-2.78027-17.08984v-.00977c.09082-.89014,.24023-1.79004,.44043-2.69043v-.00977c.0498-.25,.12012-.50977,.19043-.75977,.56934-2.20996,1.50977-4.40039,2.93945-6.48047,2.79004-4.03955,6.59961-6.43994,10.00977-7.86963l.01074-.01025c3.93945-1.63965,7.33984-1.98975,8-2.0498,14.60938-1.2998,25.93945,10.97998,32.12988,17.68994,2.38965,2.58984,4.58008,4.76025,6.58008,6.52979,15.56934,13.90039,19.83984,5.02002,20.94922,.43018,.16992-.70996,.26074-1.31982,.31055-1.72021Z\" class=\"svg-fill-primary\"/><path d=\"M790.89014,167.30784c0,.0498-.00977,.21973-.0498,.5,.01953-.15039,.03027-.30029,.04004-.44043,0-.02979,0-.0498,.00977-.05957Z\" class=\"svg-fill-primary\"/></g><path d=\"M711.47021,378.3176H175.42041c-4.98047,0-9.04004,4.0498-9.04004,9.03027,0,4.98975,4.05957,9.03955,9.04004,9.03955H711.47021c4.97949,0,9.03027-4.0498,9.03027-9.03955,0-4.98047-4.05078-9.03027-9.03027-9.03027Z\" class=\"svg-fill-grey\"/><path d=\"M592.51025,424.99778H294.37012c-4.97998,0-9.02979,4.0498-9.02979,9.02979s4.0498,9.04004,9.02979,9.04004h298.14014c4.97998,0,9.04004-4.06006,9.04004-9.04004s-4.06006-9.02979-9.04004-9.02979Z\" class=\"svg-fill-grey\"/><polygon points=\"235.06941 81.27476 268.85306 67.05703 283.34352 96.76248 247.84188 111.25294 235.06941 81.27476\" fill=\"#ffb6b6\"/><polygon points=\"235.06941 81.27476 268.85306 67.05703 283.34352 96.76248 247.84188 111.25294 235.06941 81.27476\" opacity=\".1\"/><path d=\"M239.87213,69.95512l33.32807,38.39973s-23.18474,73.17685-46.36949,79.69756-65.93162,38.39973-65.93162,38.39973l-53.61472-34.77712,26.08284-38.39973s63.03352-86.21827,79.69756-86.21827c16.66403,0,26.80736,2.89809,26.80736,2.89809Z\" class=\"svg-fill-primary\"/><path d=\"M194.84299,320.2779H117.26107l-4.90504-6.55697-20.02583-26.7711-4.60796-6.15845s-17.38856-31.87902-13.76594-60.85995c3.62262-28.98093,41.29783-35.50164,41.29783-35.50164h1.55049l46.12313,40.52979-2.75318,37.71872,14.60637,24.27153,20.06205,33.32807Z\" fill=\"#2f2e41\"/><polygon points=\"133.14986 320.2779 112.35603 320.2779 112.35603 289.48566 133.14986 320.2779\" fill=\"#2f2e41\"/><path d=\"M581.64421,273.53165l-2.58651,13.41818-6.41927,33.32807h-128.95789c1.00701-7.46988,2.38371-18.22178,3.85442-29.82865,.14496-1.15922,.29708-2.32569,.44195-3.49942,3.68789-29.17657,7.72344-62.19314,7.72344-62.19314l16.95386,2.05771,32.89328,3.98488,13.40368,1.62293,35.89291,4.35439c17.89569,2.16632,30.20533,19.04774,26.80011,36.75505Z\" fill=\"#f2f2f2\"/><path d=\"M764.14438,320.2779h-69.94541c1.06503-1.25341,1.66635-1.97793,1.66635-1.97793l20.96775-3.46324,43.20324-7.12937s1.97068,5.09342,4.10808,12.57055Z\" fill=\"#2f2e41\"/><polygon points=\"467.45495 95.76626 497.87302 138.78423 444.81392 140.36878 439.11853 99.94198 467.45495 95.76626\" fill=\"#a0616a\"/><polygon points=\"467.45495 95.76626 497.87302 138.78423 444.81392 140.36878 439.11853 99.94198 467.45495 95.76626\" opacity=\".1\"/><path id=\"uuid-ae755ff6-bb09-410e-86b1-7d1b81a37005-135\" d=\"M317.44601,184.89638c-3.90299-11.25913-12.8761-18.37174-20.04107-15.88668-7.16497,2.48507-9.80758,13.62542-5.90169,24.88804,1.49853,4.52036,4.05781,8.61612,7.46374,11.94459l17.13959,47.49655,22.1173-8.51819-19.24476-45.91882c.61482-4.72396,.08913-9.52647-1.53311-14.0055Z\" fill=\"#a0616a\"/><path d=\"M523.34731,162.97667l-.04173,43.84082-4.07898,16.19317-8.39004,33.30631-6.10768,30.63286-4.55003,22.82248-1.62293,8.15089c-1.22449,.81871-2.44173,1.60117-3.65888,2.3547h-105.97603c-6.02079-3.61536-9.38979-6.42652-9.38979-6.42652,0,0,1.66639-1.56499,3.57189-4.07907,3.21689-4.2457,7.10757-11.2011,4.72391-17.84501-.49992-1.39112-.63033-3.08648-.47821-4.97747,.97088-12.47627,14.05577-33.57447,14.05577-33.57447l-2.70971-31.31387-1.18823-13.72243,8.37769-66.9101,27.30728-15.87424,4.71449-.45614,46.53611-2.51407,19.23434,1.10845,.87664,.23915,18.79409,39.04457Z\" fill=\"#ccc\"/><g><polygon points=\"525.41397 320.2779 502.22923 320.2779 501.20763 309.77232 501.18587 309.56218 507.75009 309.11297 524.82716 307.9465 525.12415 314.23531 525.35604 319.06075 525.41397 320.2779\" fill=\"#ffb6b6\"/><path d=\"M531.12143,173.57645l9.73934,57.14315-7.948,56.23024-1.23891,8.75221-2.18807,15.45405-.67376,4.75291,.02176,.51438,.16663,3.85451h-27.53188l-1.01444-10.50559-.08685-.94192-2.07221-21.51831-.03617-.36226-4.39782-45.63046,8.62176-32.98031,.63767-2.42722v-.00716l3.75119-56.46939-2.90535-25.66256-.02892-.23915c.05793,.03626,.1087,.07252,.16663,.1087,.15221,.09419,.30433,.18838,.4492,.28983,16.92485,10.73748,27.01025,29.57509,26.56821,49.64435Z\" fill=\"#ccc\"/></g><path d=\"M415.74779,152.37881l-10.58745-10.95064s-22.66445,10.21757-23.79416,15.88619c-1.12971,5.66862-41.14649,88.92555-41.14649,88.92555l-17.40981-46.49871-22.66197,15.13029s18.1839,72.19186,35.18976,75.58099,74.00173-85.44603,74.00173-85.44603l6.40838-52.62764Z\" fill=\"#ccc\"/><path d=\"M845.64014,286.44749H21.16016c-11.66992,0-21.16016,9.5-21.16016,21.16992s9.49023,21.16016,21.16016,21.16016H845.64014c11.66992,0,21.16992-9.48975,21.16992-21.16016s-9.5-21.16992-21.16992-21.16992Z\" class=\"svg-fill-grey\"/><path d=\"M518.52213,221.93974l-1.60291,74.80242c-.15517,7.24107-6.06962,13.03015-13.31236,13.03015h-137.60256c-7.07149,0-12.90955-5.52763-13.29556-12.58857l-4.08931-74.80242c-.41702-7.62814,5.65604-14.04226,13.29556-14.04226h143.29478c7.46556,0,13.4723,6.13683,13.31236,13.60068Z\" fill=\"#3f3d56\"/><circle cx=\"296.38479\" cy=\"66.40952\" r=\"32.92181\" fill=\"#ffb6b6\"/><polygon points=\"241.32117 152.55077 244.94379 191.67503 269.57758 290.93471 248.29569 298.39388 212.34024 190.22598 207.37412 146.75458 241.32117 152.55077\" fill=\"#ffb6b6\"/><path d=\"M231.52213,221.93974l-1.60291,74.80242c-.15517,7.24107-6.06962,13.03015-13.31236,13.03015H79.0043c-7.07149,0-12.90955-5.52763-13.29556-12.58857l-4.08931-74.80242c-.41702-7.62814,5.65604-14.04226,13.29556-14.04226H218.20977c7.46556,0,13.4723,6.13683,13.31236,13.60068Z\" fill=\"#3f3d56\"/><ellipse cx=\"273.50003\" cy=\"298.7779\" rx=\"26\" ry=\"11.5\" fill=\"#ffb6b6\"/><path d=\"M190.24228,158.53237l14.85273-79.15844s41.29783-5.79619,42.74687,7.96976-1.03544,81.04198-1.03544,81.04198l-56.56416-9.85329Z\" class=\"svg-fill-primary\"/><path d=\"M283.09522,71.58597s20.36536-7.26838,28.95593-11.17911c8.59056-3.91073,25.65708,23.36637,26.03673,8.96042,.37965-14.40595-5.51755-20.44717-5.51755-20.44717,0,0-1.4726-31.51507-33.2233-27.57494,0,0,6.98375-15.76734-15.94076-18.20547-22.92451-2.43813-58.58934,52.92097-55.39531,61.19409,3.19403,8.27312,7.02295,15.11285-2.03888,23.95865-9.06183,8.8458-26.03033,58.76917-13.11998,72.20319,12.91035,13.43402,13.7575,19.26357,4.91188,27.62122-8.84562,8.35765-29.75425,26.53032-7.14719,29.68515,22.60706,3.15483-2.06828,.79851,14.7856-14.0263,16.85389-14.82481,41.44742-14.21933,32.26457-38.00455-9.18284-23.78522,6.77112-57.86925,4.77485-63.03995-1.99627-5.1707,4.4726-38.00496,4.4726-38.00496,0,0,15.05504-2.21189,16.1808,6.85974Z\" fill=\"#2f2e41\"/><g><circle cx=\"451.19104\" cy=\"75.49881\" r=\"35.83777\" fill=\"#a0616a\"/><path d=\"M454.05121,27.31743c-1.037,.60534-2.42604-.31053-2.75855-1.46432-.33251-1.1538,.05482-2.37882,.43892-3.51648l1.93363-5.72716c1.37137-4.06183,2.82687-8.26559,5.79693-11.35717,4.48283-4.66624,11.6071-5.85331,18.02037-4.99332,8.2359,1.1044,16.36189,5.56405,20.19135,12.93866,3.82945,7.37462,2.19911,17.66485-4.72046,22.26586,9.8619,11.30338,13.2996,23.9006,12.7568,38.89155-.5428,14.99095-16.87927,28.78752-27.53282,39.34806-2.37913-1.4422-4.54204-8.20095-3.23373-10.65626,1.3083-2.45531-.5662-5.29986,1.05409-7.56146,1.62029-2.2616,2.97587,1.33954,1.33779-.90922-1.03366-1.41901,3.00067-4.68353,1.46421-5.53283-7.43161-4.10794-9.9033-13.37111-14.57083-20.46464-5.62991-8.55611-15.26549-14.35039-25.46249-15.31167-5.61717-.52953-11.55014,.42955-16.15432,3.69062-4.60418,3.26106-7.5849,9.08853-6.51724,14.62867-2.76507-2.80756-4.14147-6.92204-3.62233-10.82826,.51914-3.90621,2.92243-7.51837,6.32483-9.50626-2.06881-6.84142-.29652-14.71105,4.50527-20.00518,4.80179-5.29413,24.28048-4.39244,31.29074-2.99911l-.54217-.93008Z\" fill=\"#2f2e41\"/><path d=\"M455.13987,53.47472c9.28487,1.0023,15.9888,9.04506,21.64971,16.47254,3.26282,4.28103,6.68059,9.00871,6.59868,14.39076-.08282,5.4414-3.72095,10.10859-5.45967,15.26538-2.84199,8.42894-.07214,18.45744,6.69308,24.23289-6.68479,1.26852-13.91123-3.74373-15.06525-10.44924-1.34341-7.80603,4.57394-15.34005,3.87313-23.22978-.61741-6.95094-6.09506-12.30052-10.75187-17.49772-4.65681-5.19721-9.03036-12.09377-6.88799-18.73508l-.64983-.44975Z\" fill=\"#2f2e41\"/></g><g><path id=\"uuid-aec20554-f6ec-4c5b-9d97-717cd04239bf-136\" d=\"M593.94738,290.97732c-9.19677,5.23093-13.95249,14.21631-10.62254,20.06865,3.32996,5.85234,13.48327,6.3548,22.68262,1.12078,3.70344-2.04037,6.86441-4.93798,9.21841-8.4504l38.6872-22.65576-11.01865-17.92815-36.96889,24.23796c-4.22349,.22844-8.33082,1.46525-11.97815,3.60692Z\" fill=\"#ffb6b6\"/><path d=\"M724.9347,124.84081c-1.15613-.45818-11.30029-4.29973-20.56133,.77222-10.63836,5.8263-12.28141,19.12643-12.85772,23.79133-1.33125,10.77601,2.59074,13.19133,3.41866,24.10068,1.54899,20.4102,5.63336-2.8739-.88939,6.44247-2.2578,3.22481-25.31723,53.19804-38.03446,62.98648-24.73342,19.03731-40.43943,32.44418-40.43943,32.44418l17.93045,19.47744s28.33331-7.54935,53.37617-23.81018c25.68825-16.67995,38.53244-25.0199,48.46938-41.33509,.85574-1.40497,21.33113-36.17595,10.33482-74.6244-2.50819-8.76995-7.10385-24.83851-20.74714-30.24513Z\" class=\"svg-fill-primary\"/></g><path d=\"M817.52213,221.93974l-1.60291,74.80242c-.15517,7.24107-6.06962,13.03015-13.31236,13.03015h-137.60256c-7.07149,0-12.90955-5.52763-13.29556-12.58857l-4.08931-74.80242c-.41702-7.62814,5.65604-14.04226,13.29556-14.04226h143.29478c7.46556,0,13.4723,6.13683,13.31236,13.60068Z\" fill=\"#3f3d56\"/></svg>";
},{}],"cJdhw":[function(require,module,exports,__globalThis) {
module.exports="<svg xmlns=\"http://www.w3.org/2000/svg\" data-name=\"Layer 1\" width=\"865.67004\" height=\"576.44344\" viewBox=\"0 0 865.67004 576.44344\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><path d=\"M716.98158,481.91549a11.79841,11.79841,0,0,0,9.17288-13.77266,11.5925,11.5925,0,0,0-.56729-1.96845l31.47108-27.12907-20.57508-5.82065-26.73111,26.65459a11.84062,11.84062,0,0,0-5.66184,15.631,11.52872,11.52872,0,0,0,12.89128,6.40523Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#ffb6b6\"/><path d=\"M921.34506,674.30605l1.14386-25.71947a83.066,83.066,0,0,1,38.74474-9.80778c-18.60844,15.21376-16.28294,44.54069-28.899,64.99961a49.96435,49.96435,0,0,1-36.63939,23.08922L880.123,736.402a83.72449,83.72449,0,0,1,17.647-67.84511A80.87311,80.87311,0,0,1,912.633,654.74678C916.36256,664.58091,921.34506,674.30605,921.34506,674.30605Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#f2f2f2\"/><polygon points=\"714.057 561.388 699.956 561.387 693.248 507 714.059 507.001 714.057 561.388\" fill=\"#ffb6b6\"/><path d=\"M884.81747,736.83421l-45.46566-.00168v-.57507a17.69746,17.69746,0,0,1,17.69651-17.69622h.00112l8.3049-6.30054,15.4951,6.3015,3.96888.00016Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#2f2e41\"/><polygon points=\"648.548 561.388 634.448 561.387 627.74 507 648.551 507.001 648.548 561.388\" fill=\"#ffb6b6\"/><path d=\"M819.30945,736.83421l-45.46566-.00168v-.57507a17.69744,17.69744,0,0,1,17.6965-17.69622h.00112l8.30491-6.30054,15.4951,6.3015,3.96887.00016Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#2f2e41\"/><path d=\"M809.61006,425.82623l91.71538,2.29289c17.41873,9.461,17.68323,29.93793,11.97593,54.24993,0,0,1.92669,14.45029-1.92672,18.3037s-5.78012,3.85342-3.85342,10.59689-8.253,17.75756-7.01655,18.994,4.12649,7.9799,4.12649,7.9799l-9.63353,54.91114s-6.74347,95.372-8.67018,97.29868-3.85341,0-1.92671,4.81677,3.85342,2.89006,1.92671,4.81677a70.94945,70.94945,0,0,0-4.81677,5.78012H858.21954s-1.756-9.63354-1.756-10.59689-1.92671-6.74347-1.92671-7.70683,1.70294-2.66628,1.70294-2.66628a31.6937,31.6937,0,0,0,1.18712-6.00389c0-1.92671,5.78012-76.10492,5.78012-76.10492l-11.56024-96.33533L823.7095,600.8615s0,82.84838-1.92671,84.77509-1.92671.96335-.96335,4.81676,4.81676,2.89006,1.9267,5.78012-3.85341-1.9267-2.89006,2.89006l.96336,4.81677-28.9006.41341s-3.85342-8.12024-1.92671-11.0103,1.8111-2.10117-.53948-6.8307-3.31393-5.69289-2.35058-6.65624.96335-6.08733.96335-6.08733l4.81677-92.17471s.96335-97.29868.96335-100.18874a9.60908,9.60908,0,0,0-.80026-4.3339v-3.92288l3.69032-13.90035Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#2f2e41\"/><path d=\"M715.92132,450.62325l15.5,12.5,84.5-65.5-5-114h0a46.03861,46.03861,0,0,0-17.02258,31.10257l-14.47736,64.39743Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e6e6e6\"/><path d=\"M795.92132,454.62325c29.91065,3.82254,57.46869-7.75858,83.50018-16.5,11.75165-3.9462,23.59021.17343,34.49988-6.5-4.71759-46.46695-.1372-98.808,9.88373-154.58624a13.21728,13.21728,0,0,0-8.98633-14.94638l-32.29116-9.2644-9.94172-10.96751L846.909,248.3769l-8.98765,16.24635-30.88769,20.87009a11.29194,11.29194,0,0,0-4.80756,11.28048A370.22031,370.22031,0,0,1,795.92132,454.62325Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e6e6e6\"/><path d=\"M891.38192,469.005a11.79841,11.79841,0,0,0,5.06679-15.75295,11.5916,11.5916,0,0,0-1.08288-1.739l22.87441-34.68684-21.38255.01435-18.44377,32.937a11.84063,11.84063,0,0,0-1.18191,16.58276,11.52872,11.52872,0,0,0,14.14984,2.64466Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#ffb6b6\"/><path d=\"M884.92132,436.62325l14,18,49-73-4.23791-74.16342a56.0961,56.0961,0,0,0-28.76209-45.83655h0l1,114Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e6e6e6\"/><circle cx=\"682.57563\" cy=\"44.50177\" r=\"31.33548\" fill=\"#ffb6b6\"/><path d=\"M829.77509,187.89a14.80718,14.80718,0,0,1,3.593.47152,51.13867,51.13867,0,0,0,7.03333,1.1794,32.59027,32.59027,0,0,1,29.18165,27.64337c1.82081-1.58751,5.96412-4.50771,9.36014-1.79372h0c.0517.04308.08187.06524.20128.00861,2.2554-1.06983,6.259-14.239,6.38024-25.83425.064-6.15432-.90487-14.01312-5.88225-16.50181l-.26223-.13112-.06894-.285c-.3324-1.38438-4.04789-3.7475-10.50507-5.58678-11.735-3.34247-29.22732-9.85366-39.07744-.27131-.74544,3.23044-3.17061,10.14359-5.62052,10.92719-2.71275.86732-5.05555,1.61583-5.42489,4.94353a101.999,101.999,0,0,0,.0671,14.21933,14.52178,14.52178,0,0,1,5.159-7.24693A10.22518,10.22518,0,0,1,829.77509,187.89Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#2f2e41\"/><path d=\"M1032.835,737.03172a1.18647,1.18647,0,0,1-1.19006,1.19H168.355a1.19,1.19,0,0,1,0-2.38h863.29A1.18651,1.18651,0,0,1,1032.835,737.03172Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#ccc\"/><path d=\"M524.442,262.90072,406.8168,289.36394a12.20139,12.20139,0,0,0-9.215,14.56508l32.25406,143.36459,138.20269-31.09275a6.05643,6.05643,0,0,0,2.99313-1.65173L539.00708,272.11575A12.20141,12.20141,0,0,0,524.442,262.90072Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e6e6e6\"/><path d=\"M481.71486,282.64153l-64.46158,14.50252a11.11125,11.11125,0,0,0-8.39446,13.26082l30.325,134.79013,122.744-27.61485-22.08437-98.16179A48.695,48.695,0,0,0,481.71486,282.64153Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#fff\"/><path d=\"M538.32333,410.31393l-80.92146,18.20566a2.70338,2.70338,0,1,0,1.18675,5.2749l80.92146-18.20565a2.70339,2.70339,0,1,0-1.18675-5.27491Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/><path d=\"M535.97648,399.88253,455.055,418.08818a2.70614,2.70614,0,0,0,1.188,5.28029l80.92146-18.20565a2.70614,2.70614,0,1,0-1.188-5.28029Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/><path d=\"M487.78753,399.7703l-35.07815,7.89186a2.70337,2.70337,0,1,0,1.18674,5.2749l35.07816-7.89185a2.70339,2.70339,0,1,0-1.18675-5.27491Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/><path d=\"M528.71675,367.61405l-80.92147,18.20566a2.70614,2.70614,0,0,0,1.188,5.28029l80.92146-18.20565a2.70614,2.70614,0,1,0-1.188-5.2803Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/><path d=\"M526.37111,357.188l-80.92147,18.20566a2.70338,2.70338,0,1,0,1.18675,5.2749l80.92146-18.20565a2.70338,2.70338,0,1,0-1.18674-5.27491Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/><path d=\"M478.18094,357.07042l-35.07815,7.89186a2.70614,2.70614,0,0,0,1.188,5.28029l35.07815-7.89186a2.70614,2.70614,0,1,0-1.188-5.28029Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/><path d=\"M519.11016,324.91417l-80.92147,18.20566a2.70614,2.70614,0,0,0,1.188,5.28029l80.92146-18.20565a2.70614,2.70614,0,1,0-1.188-5.2803Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e6e6e6\"/><path d=\"M516.76452,314.48815l-80.92147,18.20566a2.70614,2.70614,0,0,0,1.188,5.28029l80.92146-18.20565a2.70614,2.70614,0,1,0-1.188-5.2803Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e6e6e6\"/><path d=\"M468.57435,314.37054,433.4962,322.2624a2.70614,2.70614,0,0,0,1.188,5.28029l35.07815-7.89186a2.70614,2.70614,0,1,0-1.188-5.28029Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e6e6e6\"/><path d=\"M289.77873,429.24128a2.89533,2.89533,0,0,0-2.89209,2.89209V731.1807a2.89574,2.89574,0,0,0,2.89209,2.89258h374.9458a2.89537,2.89537,0,0,0,2.8916-2.89258V480.13679a2.89534,2.89534,0,0,0-2.8916-2.89258H449.5302a8.76523,8.76523,0,0,1-5.90674-2.28223l-48.37891-43.95752a6.77,6.77,0,0,0-4.5625-1.76318Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#3f3d56\"/><path d=\"M737.24238,351.02466,536.47946,264.71345a22.11557,22.11557,0,0,0-29.0187,11.56928l-105.19833,244.695,235.8847,101.41061a10.97749,10.97749,0,0,0,6.14956.76065l104.515-243.10564A22.11562,22.11562,0,0,0,737.24238,351.02466Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e6e6e6\"/><path d=\"M653.5401,334.53467,543.51692,287.23394a20.13964,20.13964,0,0,0-26.4269,10.5284L418.18347,527.82247l209.49968,90.06727L699.71249,450.347A88.26188,88.26188,0,0,0,653.5401,334.53467Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#fff\"/><path d=\"M600.77576,582.11364l-138.117-59.3787a4.9,4.9,0,1,0-3.87063,9.00322l138.117,59.3787a4.9,4.9,0,1,0,3.87063-9.00322Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/><path d=\"M608.43014,564.30928l-138.117-59.3787a4.905,4.905,0,0,0-3.87458,9.01242l138.117,59.3787a4.905,4.905,0,1,0,3.87459-9.01242Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/><path d=\"M537.83508,512.87513,477.9636,487.13542a4.9,4.9,0,1,0-3.87063,9.00323l59.87148,25.73971a4.9,4.9,0,1,0,3.87063-9.00323Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/><path d=\"M632.10815,509.23338l-138.117-59.3787a4.905,4.905,0,0,0-3.87459,9.01241l138.117,59.3787a4.905,4.905,0,1,0,3.87458-9.01241Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/><path d=\"M639.75858,491.43822l-138.117-59.3787a4.9,4.9,0,1,0-3.87063,9.00322l138.117,59.3787a4.9,4.9,0,1,0,3.87063-9.00322Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/><path d=\"M569.16748,439.99487,509.296,414.25516a4.905,4.905,0,0,0-3.87458,9.01242l59.87148,25.73971a4.905,4.905,0,1,0,3.87458-9.01242Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/><path d=\"M663.44055,436.35311l-138.117-59.37869a4.905,4.905,0,0,0-3.87458,9.01241l138.117,59.3787a4.905,4.905,0,1,0,3.87458-9.01242Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#6c63ff\"/><path d=\"M671.091,418.558,532.974,359.17926a4.905,4.905,0,0,0-3.87459,9.01241l138.117,59.3787A4.905,4.905,0,1,0,671.091,418.558Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#6c63ff\"/><path d=\"M600.49987,367.11461,540.62839,341.3749a4.905,4.905,0,0,0-3.87458,9.01242L596.62529,376.127a4.905,4.905,0,1,0,3.87458-9.01242Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#6c63ff\"/><path d=\"M451.442,439.90072,333.8168,466.36394a12.20139,12.20139,0,0,0-9.215,14.56508l32.25406,143.36459,138.20269-31.09275a6.05643,6.05643,0,0,0,2.99313-1.65173L466.00708,449.11575A12.20141,12.20141,0,0,0,451.442,439.90072Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e6e6e6\"/><path d=\"M408.71486,459.64153l-64.46158,14.50252a11.11125,11.11125,0,0,0-8.39446,13.26082l30.325,134.79013,122.74395-27.61485-22.08437-98.16179A48.695,48.695,0,0,0,408.71486,459.64153Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#fff\"/><path d=\"M465.32333,587.31393l-80.92146,18.20566a2.70338,2.70338,0,1,0,1.18675,5.2749l80.92146-18.20565a2.70339,2.70339,0,1,0-1.18675-5.27491Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/><path d=\"M462.97648,576.88253,382.055,595.08818a2.70614,2.70614,0,0,0,1.188,5.28029l80.92146-18.20565a2.70614,2.70614,0,1,0-1.188-5.28029Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/><path d=\"M414.78753,576.7703l-35.07815,7.89186a2.70337,2.70337,0,1,0,1.18674,5.2749l35.07816-7.89185a2.70339,2.70339,0,1,0-1.18675-5.27491Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/><path d=\"M455.71675,544.61405l-80.92147,18.20566a2.70614,2.70614,0,0,0,1.188,5.28029l80.92146-18.20565a2.70614,2.70614,0,1,0-1.188-5.2803Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/><path d=\"M453.37111,534.188l-80.92147,18.20566a2.70338,2.70338,0,1,0,1.18675,5.2749l80.92146-18.20565a2.70338,2.70338,0,1,0-1.18674-5.27491Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/><path d=\"M405.18094,534.07042l-35.07815,7.89186a2.70614,2.70614,0,0,0,1.188,5.28029l35.07815-7.89186a2.70614,2.70614,0,1,0-1.188-5.28029Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/><path d=\"M446.11016,501.91417l-80.92147,18.20566a2.70614,2.70614,0,0,0,1.188,5.28029l80.92146-18.20565a2.70614,2.70614,0,1,0-1.188-5.2803Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e6e6e6\"/><path d=\"M443.76452,491.48815l-80.92147,18.20566a2.70614,2.70614,0,0,0,1.188,5.28029l80.92146-18.20565a2.70614,2.70614,0,1,0-1.188-5.2803Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e6e6e6\"/><path d=\"M395.57435,491.37054,360.4962,499.2624a2.70614,2.70614,0,0,0,1.188,5.28029l35.07815-7.89186a2.70614,2.70614,0,1,0-1.188-5.28029Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e6e6e6\"/><path d=\"M287.29436,507.78715a2.89166,2.89166,0,0,0-2.89222,2.89117c0,.10846.089,222.82666.089,222.82666a2.89026,2.89026,0,0,0,2.874,2.56836H690.13762a2.88958,2.88958,0,0,0,2.874-2.56836L718.082,511.003a2.89272,2.89272,0,0,0-.71679-2.251,2.85868,2.85868,0,0,0-2.15625-.96484Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#3f3d56\"/><path d=\"M315.71659,520.11725a15.55483,15.55483,0,0,0-15.50879,15.374l.50293,172.60742A15.50883,15.50883,0,0,0,316.22,723.74322H571.89725A119.17426,119.17426,0,0,0,690.41043,617.83307l9.0669-80.46973a15.50838,15.50838,0,0,0-15.41162-17.24609Zm391.811,0-.0459-1h.0459Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#6c63ff\"/><path d=\"M427.39952,649.43435H328.3533a3.85894,3.85894,0,1,1,0-7.71789h99.04622C432.37608,641.647,432.42585,649.50444,427.39952,649.43435Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/><path d=\"M560.8259,669.62041H328.3533a3.85894,3.85894,0,1,1,0-7.71789H560.8259C565.80245,661.83306,565.85223,669.6905,560.8259,669.62041Z\" transform=\"translate(-167.16498 -161.77828)\" fill=\"#e4e4e4\"/></svg>";
},{}],"ajDTq":[function(require,module,exports,__globalThis) {
module.exports="<svg width=\"382px\" height=\"512px\" version=\"1.1\" style=\"shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd\" viewBox=\"0 0 17.69 23.65\" xmlns=\"http://www.w3.org/2000/svg\">\r\n  <defs></defs>\r\n  <g id=\"Vrstva_x0020_1\">\r\n    <path class=\"fil0\" d=\"M3.08 0l7.91 0 6.7 6.99 0 13.58c0,1.7 -1.38,3.08 -3.08,3.08l-11.53 0c-1.7,0 -3.08,-1.38 -3.08,-3.08l0 -17.49c0,-1.7 1.38,-3.08 3.08,-3.08z\" style=\"fill: rgb(250, 0, 0);\"></path>\r\n    <polygon class=\"fil1\" points=\"10.98,0 10.98,6.93 17.69,6.93 \" style=\"fill: rgb(255, 255, 255); fill-opacity: 0.3;\"></polygon>\r\n    <path class=\"fil2\" d=\"M12.94 12.66c-0.08,-0.06 -0.2,-0.06 -0.29,-0.02l-1.99 1 0 -0.72c0,-0.51 -0.4,-0.91 -0.91,-0.91l-4.24 0c-0.5,0 -0.91,0.4 -0.91,0.91l0 3.63c0,0.51 0.41,0.91 0.91,0.91l4.24 0c0.51,0 0.91,-0.4 0.91,-0.91l0 -0.72 1.99 1c0.15,0.07 0.33,0.01 0.41,-0.14 0.02,-0.04 0.03,-0.09 0.03,-0.14l0 -3.63c0,-0.11 -0.06,-0.21 -0.15,-0.26zm-5.31 3.29c-0.67,0 -1.21,-0.55 -1.21,-1.22 0,-0.67 0.54,-1.21 1.21,-1.21 0.67,0 1.21,0.54 1.21,1.21 0,0.67 -0.54,1.22 -1.21,1.22z\" style=\"fill: rgb(255, 255, 255);\"></path>\r\n  </g>\r\n</svg>";
},{}],"dXvfw":[function(require,module,exports,__globalThis) {
module.exports="<svg width=\"36\" height=\"36\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"ai ai-Heart\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs></defs>\n  <path d=\"M 12.036 1.576 C 12.747 0.984 12.962 0.144 15.041 0.144 C 16.085 0.144 17.22 0.646 17.897 1.315 C 18.575 1.986 19.085 3.118 19.085 4.155 C 19.085 5.583 18.298 9.2 12.828 12.764 C 12.378 12.952 11.617 12.949 11.166 12.759 C 5.694 9.194 4.916 5.582 4.916 4.155 C 4.916 3.118 5.426 1.986 6.103 1.316 C 6.78 0.646 7.915 0.144 8.958 0.144 C 11.039 0.144 11.327 0.936 12.036 1.576 Z M 12.054 4.833 L 11.2 3.568 C 11.2 3.568 10.237 2.144 8.958 2.144 C 8.321 2.144 7.935 2.317 7.511 2.737 C 7.087 3.156 6.916 3.53 6.916 4.155 C 6.916 5.399 7.196 8.099 12.001 10.932 C 16.805 8.099 17.085 5.4 17.085 4.155 C 17.085 3.53 16.914 3.156 16.49 2.737 C 16.066 2.317 15.679 2.144 15.041 2.144 C 13.764 2.144 12.803 3.568 12.803 3.568 Z\" style=\"stroke: none; fill: rgb(0, 0, 0);\"></path>\n  <g transform=\"matrix(-0.837431, -0.041991, -0.041991, 0.837431, 24.508875, 4.128722)\" style=\"\">\n    <path d=\"M 6.234 23.796 C 5.682 23.784 5.244 23.327 5.255 22.775 L 5.275 21.83 C 4.754 21.524 4.242 21.274 3.515 20.677 C 2.838 20.122 1.913 19.27 1.27 17.271 C 0.688 15.465 -0.005 12.28 0.528 7.403 C 0.813 4.8 1.782 3.437 2.575 2.964 C 3.537 2.393 4.01 2.619 4.388 2.688 C 4.547 2.734 5.333 2.811 5.978 3.57 C 6.52 4.207 6.975 5.635 6.45 7.665 C 5.626 10.852 6.056 11.44 6.056 11.44 L 7.093 12.373 C 6.519 11.955 5.997 12.298 5.906 12.514 C 5.772 12.83 5.639 12.888 5.57 12.92 C 5.508 12.948 5.344 13.001 5.237 13.012 C 5.146 13.022 4.923 13.004 4.801 12.962 C 4.637 12.905 4.341 12.662 4.251 12.499 C 4.069 12.17 4.219 11.567 4.288 11.457 C 4.323 11.401 4.388 11.317 4.429 11.271 C 4.541 11.145 4.797 10.917 5.067 10.746 C 5.556 10.436 6.674 10.045 7.605 10.413 C 8.56 10.791 9.24 12.371 9.547 13.468 C 9.856 14.575 9.788 14.178 10.175 15.26 C 10.399 15.693 11.48 16.719 11.967 18.201 C 12.448 19.667 11.992 22.47 11.992 22.47 C 12.013 22.69 11.992 22.47 11.992 22.47 C 11.956 23.065 11.879 23.56 11.354 23.732 C 10.829 23.904 10.264 23.619 10.092 23.094 C 10.092 23.094 9.759 22.756 10.092 23.094 C 9.876 21.662 10.329 19.898 10.067 18.825 C 9.808 17.762 9.018 16.584 9.081 16.615 C 8.679 16.414 7.902 14.99 7.815 13.896 C 7.733 12.865 7.147 12.383 6.869 12.273 C 6.567 12.153 6.447 11.9 6.126 12.104 C 5.991 12.189 5.808 12.345 5.773 12.385 C 5.776 12.38 5.96 12.185 5.979 12.155 C 6.031 12.072 6.178 11.851 6.001 11.531 C 5.912 11.369 5.618 11.128 5.456 11.072 C 5.338 11.031 5.118 11.014 5.031 11.023 C 4.932 11.033 4.779 11.082 4.731 11.104 C 4.69 11.123 4.629 11.162 4.625 11.164 L 4.228 11.564 L 4.366 12.508 C 4.366 12.508 3.508 11.058 4.514 7.165 C 4.904 5.655 4.75 5.213 4.454 4.865 C 4.262 4.639 4.171 4.671 4.171 4.671 L 4.016 4.612 L 3.896 4.605 C 3.896 4.605 3.878 4.516 3.598 4.683 C 3.149 4.95 2.747 5.504 2.516 7.621 C 2.017 12.182 2.622 14.943 3.174 16.658 C 3.664 18.182 4.219 18.53 4.783 19.131 C 5.172 19.546 6.242 20.455 6.286 20.47 C 6.67 20.813 7.07 21.053 7.203 21.49 L 7.282 22.06 L 7.255 22.817 C 7.243 23.369 6.786 23.807 6.234 23.796 Z\" style=\"fill: rgb(0, 0, 0); stroke: none;\"></path>\n    <path d=\"M 8.089 18.106 C 7.858 18.608 7.265 18.828 6.763 18.598 C 5.527 17.925 4.579 16.429 4.139 15.196 C 3.693 13.944 3.645 12.718 3.645 12.718 C 3.62 12.615 3.645 12.718 3.645 12.718 C 3.46 12.198 3.365 10.989 3.885 10.803 C 4.405 10.618 5.343 11.526 5.529 12.046 C 5.529 12.046 5.554 12.149 5.529 12.046 C 5.529 12.046 5.392 13.543 5.768 14.598 C 6.152 15.672 6.816 16.527 7.597 16.78 C 8.099 17.011 8.319 17.604 8.089 18.106 Z\" style=\"fill: rgb(0, 0, 0); stroke: none;\" transform=\"matrix(0.989012, 0.147835, -0.147835, 0.989012, 2.287347, -0.703586)\"></path>\n  </g>\n  <g transform=\"matrix(0.837431, -0.041991, 0.041991, 0.837431, -0.524172, 4.128722)\" style=\"\">\n    <path d=\"M 6.234 23.796 C 5.682 23.784 5.244 23.327 5.255 22.775 L 5.275 21.83 C 4.754 21.524 4.242 21.274 3.515 20.677 C 2.838 20.122 1.913 19.27 1.27 17.271 C 0.688 15.465 -0.005 12.28 0.528 7.403 C 0.813 4.8 1.782 3.437 2.575 2.964 C 3.537 2.393 4.01 2.619 4.388 2.688 C 4.547 2.734 5.333 2.811 5.978 3.57 C 6.52 4.207 6.975 5.635 6.45 7.665 C 5.626 10.852 6.056 11.44 6.056 11.44 L 7.093 12.373 C 6.519 11.955 5.997 12.298 5.906 12.514 C 5.772 12.83 5.639 12.888 5.57 12.92 C 5.508 12.948 5.344 13.001 5.237 13.012 C 5.146 13.022 4.923 13.004 4.801 12.962 C 4.637 12.905 4.341 12.662 4.251 12.499 C 4.069 12.17 4.219 11.567 4.288 11.457 C 4.323 11.401 4.388 11.317 4.429 11.271 C 4.541 11.145 4.797 10.917 5.067 10.746 C 5.556 10.436 6.674 10.045 7.605 10.413 C 8.56 10.791 9.24 12.371 9.547 13.468 C 9.856 14.575 9.788 14.178 10.175 15.26 C 10.399 15.693 11.48 16.719 11.967 18.201 C 12.448 19.667 11.992 22.47 11.992 22.47 C 12.013 22.69 11.992 22.47 11.992 22.47 C 11.956 23.065 11.879 23.56 11.354 23.732 C 10.829 23.904 10.264 23.619 10.092 23.094 C 10.092 23.094 9.759 22.756 10.092 23.094 C 9.876 21.662 10.329 19.898 10.067 18.825 C 9.808 17.762 9.018 16.584 9.081 16.615 C 8.679 16.414 7.902 14.99 7.815 13.896 C 7.733 12.865 7.147 12.383 6.869 12.273 C 6.567 12.153 6.447 11.9 6.126 12.104 C 5.991 12.189 5.808 12.345 5.773 12.385 C 5.776 12.38 5.96 12.185 5.979 12.155 C 6.031 12.072 6.178 11.851 6.001 11.531 C 5.912 11.369 5.618 11.128 5.456 11.072 C 5.338 11.031 5.118 11.014 5.031 11.023 C 4.932 11.033 4.779 11.082 4.731 11.104 C 4.69 11.123 4.629 11.162 4.625 11.164 L 4.228 11.564 L 4.366 12.508 C 4.366 12.508 3.508 11.058 4.514 7.165 C 4.904 5.655 4.75 5.213 4.454 4.865 C 4.262 4.639 4.171 4.671 4.171 4.671 L 4.016 4.612 L 3.896 4.605 C 3.896 4.605 3.878 4.516 3.598 4.683 C 3.149 4.95 2.747 5.504 2.516 7.621 C 2.017 12.182 2.622 14.943 3.174 16.658 C 3.664 18.182 4.219 18.53 4.783 19.131 C 5.172 19.546 6.242 20.455 6.286 20.47 C 6.67 20.813 7.07 21.053 7.203 21.49 L 7.282 22.06 L 7.255 22.817 C 7.243 23.369 6.786 23.807 6.234 23.796 Z\" style=\"fill: rgb(0, 0, 0); stroke: none;\"></path>\n    <path d=\"M 8.089 18.106 C 7.858 18.608 7.265 18.828 6.763 18.598 C 5.527 17.925 4.579 16.429 4.139 15.196 C 3.693 13.944 3.645 12.718 3.645 12.718 C 3.62 12.615 3.645 12.718 3.645 12.718 C 3.46 12.198 3.365 10.989 3.885 10.803 C 4.405 10.618 5.343 11.526 5.529 12.046 C 5.529 12.046 5.554 12.149 5.529 12.046 C 5.529 12.046 5.392 13.543 5.768 14.598 C 6.152 15.672 6.816 16.527 7.597 16.78 C 8.099 17.011 8.319 17.604 8.089 18.106 Z\" style=\"fill: rgb(0, 0, 0); stroke: none;\" transform=\"matrix(0.989012, 0.147835, -0.147835, 0.989012, 2.287347, -0.703586)\"></path>\n  </g>\n</svg>";
},{}],"iGeFY":[function(require,module,exports,__globalThis) {
module.exports="<svg width=\"382px\" height=\"512px\" version=\"1.1\" style=\"shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd\" viewBox=\"0 0 38.89 51.99\" xmlns=\"http://www.w3.org/2000/svg\">\r\n  <g id=\"Vrstva_x0020_1\">\r\n    <path class=\"fil0\" d=\"M6.76 0l17.4 0 14.73 15.36 0 29.87c0,3.73 -3.03,6.76 -6.77,6.76l-25.36 0c-3.73,0 -6.76,-3.03 -6.76,-6.76l0 -38.47c0,-3.73 3.03,-6.76 6.76,-6.76z\" style=\"fill: rgb(2, 99, 209);\"></path>\r\n    <polygon class=\"fil1\" points=\"24.14,0 24.14,15.24 38.89,15.24 \" style=\"fill: rgb(255, 255, 255); fill-opacity: 0.3;\"></polygon>\r\n    <path class=\"fil2\" d=\"M26.3 27.05l-13.71 0c-0.63,0 -1.15,-0.51 -1.15,-1.14 0,-0.63 0.52,-1.14 1.15,-1.14l13.71 0c0.63,0 1.14,0.51 1.14,1.14 0,0.63 -0.51,1.14 -1.14,1.14l0 0zm-4.57 13.71l-9.14 0c-0.63,0 -1.15,-0.51 -1.15,-1.14 0,-0.63 0.52,-1.14 1.15,-1.14l9.14 0c0.63,0 1.14,0.51 1.14,1.14 0,0.63 -0.51,1.14 -1.14,1.14l0 0zm4.57 -4.57l-13.71 0c-0.63,0 -1.15,-0.51 -1.15,-1.14 0,-0.63 0.52,-1.14 1.15,-1.14l13.71 0c0.63,0 1.14,0.51 1.14,1.14 0,0.63 -0.51,1.14 -1.14,1.14l0 0zm0 -4.57l-13.71 0c-0.63,0 -1.15,-0.51 -1.15,-1.14 0,-0.63 0.52,-1.14 1.15,-1.14l13.71 0c0.63,0 1.14,0.51 1.14,1.14 0,0.63 -0.51,1.14 -1.14,1.14l0 0z\" style=\"fill: rgb(255, 255, 255);\"></path>\r\n  </g>\r\n</svg>";
},{}],"jb0x4":[function(require,module,exports,__globalThis) {
module.exports="<svg width=\"382px\" height=\"512px\" version=\"1.1\" style=\"shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd\" viewBox=\"0 0 24.33 32.53\" xmlns=\"http://www.w3.org/2000/svg\">\r\n  <g id=\"Vrstva_x0020_1\">\r\n    <path class=\"fil0\" d=\"M4.23 0l10.88 0 9.22 9.61 0 18.69c0,2.33 -1.9,4.23 -4.23,4.23l-15.87 0c-2.34,0 -4.23,-1.9 -4.23,-4.23l0 -24.07c0,-2.34 1.89,-4.23 4.23,-4.23z\" style=\"fill: rgb(255, 177, 31);\"></path>\r\n    <polygon class=\"fil1\" points=\"15.1,0 15.1,9.53 24.33,9.53 \" style=\"fill: rgb(255, 255, 255); fill-opacity: 0.3;\"></polygon>\r\n    <path class=\"fil2\" d=\"M8.96 16.9l0 -2.22c0,-0.24 -0.19,-0.43 -0.43,-0.43l-1.2 0c-0.24,0 -0.43,0.19 -0.43,0.43l0 2.22 -0.67 1.96c-0.19,0.55 -0.1,1.16 0.24,1.63 0.33,0.47 0.88,0.75 1.46,0.75 0.58,0 1.12,-0.28 1.46,-0.75 0.34,-0.47 0.43,-1.08 0.24,-1.63l-0.67 -1.96zm-0.28 3.08c-0.34,0.49 -1.16,0.49 -1.51,0 -0.17,-0.24 -0.22,-0.56 -0.12,-0.84l0.22 -0.66 1.31 0 0.23 0.66c0.09,0.28 0.05,0.6 -0.13,0.84zm-3.41 -17.65l0 1.22c0,0.24 0.19,0.43 0.43,0.43l1.63 0 0 1.82 -1.63 0c-0.24,0 -0.43,0.19 -0.43,0.43l0 0.94c0,0.24 0.19,0.44 0.43,0.44l1.63 0 0 1.81 -1.63 0c-0.24,0 -0.43,0.19 -0.43,0.43l0 0.95c0,0.24 0.19,0.43 0.43,0.43l1.63 0 0 1.38c0,0.24 0.2,0.43 0.44,0.43l2.39 0c0.23,0 0.43,-0.19 0.43,-0.43l0 -0.95c0,-0.23 -0.2,-0.43 -0.43,-0.43l-1.64 0 0 -1.81 1.64 0c0.23,0 0.43,-0.19 0.43,-0.43l0 -0.95c0,-0.24 -0.2,-0.43 -0.43,-0.43l-1.64 0 0 -1.81 1.64 0c0.23,0 0.43,-0.2 0.43,-0.44l0 -0.94c0,-0.24 -0.2,-0.44 -0.43,-0.44l-1.64 0 0 -1.66c0,0 -3.25,0.01 -3.25,0.01z\" style=\"fill: rgb(255, 255, 255);\"></path>\r\n  </g>\r\n</svg>";
},{}],"6ETRJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _genericLogoWebp = require("url:../../resources/generic-logo.webp");
var _genericLogoWebpDefault = parcelHelpers.interopDefault(_genericLogoWebp);
var _logoAdminSvg = require("url:../../resources/logo-admin.svg");
var _logoAdminSvgDefault = parcelHelpers.interopDefault(_logoAdminSvg);
var _logoYhrSvg = require("url:../../resources/logo-yhr.svg");
var _logoYhrSvgDefault = parcelHelpers.interopDefault(_logoYhrSvg);
const Logo = ({ clientRef, className })=>{
    var _clientDetails_theme;
    if (clientRef === "admin" || clientRef === "app") {
        const thisLogo = clientRef === "admin" ? (0, _logoAdminSvgDefault.default) : (0, _logoYhrSvgDefault.default);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: thisLogo,
            alt: "YourHR.Space",
            className: "logo",
            width: "300"
        });
    }
    const clientDetails = localStorage.getItem("clientDetails") ? JSON.parse(localStorage.getItem("clientDetails")) : null;
    const clientThemeLogo = clientDetails === null || clientDetails === void 0 ? void 0 : (_clientDetails_theme = clientDetails.theme) === null || _clientDetails_theme === void 0 ? void 0 : _clientDetails_theme.logo;
    const logo = clientThemeLogo ? clientThemeLogo : clientRef ? `${"https://rest.yourhr.space"}/logo/${clientRef}` : (0, _genericLogoWebpDefault.default);
    const logoClassName = "logo" + (className ? ` ${className}` : "");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        src: logo,
        alt: "YourHR.Space",
        className: logoClassName,
        width: "300"
    });
};
exports.default = Logo;

},{"react/jsx-runtime":"i3K7E","url:../../resources/generic-logo.webp":"aOroM","url:../../resources/logo-admin.svg":"jBli0","url:../../resources/logo-yhr.svg":"cP2wL","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"aOroM":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("3iu2b");

},{}],"jBli0":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("5YGUx");

},{}],"cP2wL":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("3RQPc");

},{}],"bKeff":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const Error = ({ message, type, onMessageShown })=>{
    const [errorMessage, setErrorMessage] = (0, _react.useState)(message);
    (0, _react.useEffect)(()=>{
        setErrorMessage(message);
        if (message) setTimeout(()=>{
            if (onMessageShown) return onMessageShown();
            setErrorMessage(null);
        }, 3000);
    }, [
        message
    ]);
    let className = errorMessage ? "error-message active" : "error-message";
    className += type ? ` ${type}` : "";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: className,
        id: "error-message",
        children: message
    });
};
exports.default = Error;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kCwqK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _resetPasswordForm = require("./resetPasswordForm");
var _resetPasswordFormDefault = parcelHelpers.interopDefault(_resetPasswordForm);
var _messageUsersForm = require("./messageUsersForm");
var _messageUsersFormDefault = parcelHelpers.interopDefault(_messageUsersForm);
var _mainPageContent = require("../mainPageContent");
var _mainPageContentDefault = parcelHelpers.interopDefault(_mainPageContent);
var _closeButton = require("./closeButton");
var _closeButtonDefault = parcelHelpers.interopDefault(_closeButton);
var _printButton = require("./printButton");
var _printButtonDefault = parcelHelpers.interopDefault(_printButton);
var _spinner = require("./spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _modalScss = require("../../../scss/components/modal.scss");
const ModalContent = ({ articleId, userId, type, content, loading, messageUsers, isWide, messageInit, onClose, onSendMessage = null })=>{
    (0, _react.useEffect)(()=>{
        document.body.classList.add("print-mode");
    }, [
        content,
        articleId
    ]);
    const doClose = ()=>{
        document.body.classList.remove("print-mode");
        onClose && onClose();
    };
    const doPrint = ()=>{
        var _printComponent_current, _document_getElementById;
        const printEl = (_printComponent_current = printComponent.current) === null || _printComponent_current === void 0 ? void 0 : _printComponent_current.cloneNode(true);
        (_document_getElementById = document.getElementById("print-container")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.replaceChildren(printEl);
        window.print();
    };
    const printComponent = (0, _react.useRef)();
    if (!type || !content && !articleId && !messageUsers && !loading) return null;
    if (type === "content" && articleId) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mainPageContentDefault.default), {
        articleId: articleId,
        userId: userId,
        isModal: true,
        onClose: doClose
    });
    const articleContent = content && typeof content === "object" ? content : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        dangerouslySetInnerHTML: {
            __html: content
        }
    });
    const className = isWide ? "modal--content modal--content__wide" : "modal--content";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "modal",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "modal--overlay",
                onClick: doClose
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeButtonDefault.default), {
                className: "close-button__white",
                onClick: doClose
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _printButtonDefault.default), {
                className: "print-button__white",
                onClick: doPrint
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: className,
                ref: printComponent,
                children: loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            children: articleContent
                        }),
                        type === "resetPassword" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetPasswordFormDefault.default), {
                            onClose: doClose
                        }),
                        type === "messageUsers" && messageUsers && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messageUsersFormDefault.default), {
                            recipients: messageUsers,
                            introText: content,
                            title: content ? "" : null,
                            messageInit: messageInit,
                            onClose: doClose,
                            onSendMessage: onSendMessage
                        })
                    ]
                })
            })
        ]
    });
};
exports.default = ModalContent;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","./resetPasswordForm":"179Q7","./messageUsersForm":"bE1vX","../mainPageContent":"g6UeZ","./closeButton":"azTQI","./printButton":"ljrwG","./spinner":"lRuRG","../../../scss/components/modal.scss":"5QfYy","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"179Q7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _error = require("./error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _fetch = require("../../utilities/fetch");
var _useStore = require("../hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
var _resetPasswordFormScss = require("../../../scss/components/resetPasswordForm.scss");
const ResetPasswordForm = ({ onClose })=>{
    const clientRef = (0, _useStoreDefault.default)((state)=>state.clientRef);
    const [email, setEmail] = (0, _react.useState)("");
    const [error, setError] = (0, _react.useState)("");
    const [fetching, setFetching] = (0, _react.useState)(false);
    const [success, setSuccess] = (0, _react.useState)(false);
    const doChangeEmail = (e)=>{
        setEmail(e.target.value);
    };
    const doResetPassword = async ()=>{
        if (!email) return setError("Please enter your email address.");
        setFetching(true);
        try {
            const encodedEmail = encodeURIComponent(email);
            await (0, _fetch.request)({
                url: `/scripts/reset-password?account=${clientRef}&userId=${encodedEmail}`
            });
            // If the request is successful, show a success message
            setSuccess(true);
            setError("");
            setFetching(false);
            if (onClose) setTimeout(()=>{
                onClose();
            }, 3200);
        } catch (err) {
            console.error(err);
            setFetching(false);
            if ((err === null || err === void 0 ? void 0 : err.status) === 400 || (err === null || err === void 0 ? void 0 : err.status) === 404) // Display the specific error message from the API response
            setError(err === null || err === void 0 ? void 0 : err.bodyError);
            else // Display a generic error message for other errors
            setError("An error occurred while processing your request.");
        }
    };
    const buttonClass = fetching ? "button disabled" : "button";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Reset your password"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                className: "reset-password-form",
                onSubmit: (e)=>{
                    e.preventDefault();
                    doResetPassword();
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "email",
                        placeholder: "Enter your email address",
                        value: email,
                        autoFocus: true,
                        onChange: doChangeEmail
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: buttonClass,
                        type: "button",
                        disabled: fetching,
                        onClick: doResetPassword,
                        children: fetching ? "Resetting..." : "Reset password"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                message: error || success && "Password reset email sent.",
                type: success ? "success" : null,
                onMessageShown: ()=>{
                    setError("");
                    setSuccess("");
                }
            })
        ]
    });
};
exports.default = ResetPasswordForm;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","./error":"bKeff","../../utilities/fetch":"hAKRo","../hooks/useStore":"l1Yj7","../../../scss/components/resetPasswordForm.scss":"eq6Mk","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hAKRo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "request", ()=>request);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _core = require("@capacitor/core");
const client = (0, _axiosDefault.default).create({
    baseURL: "https://rest.yourhr.space"
});
// Add Capacitor header for all requests if running in native app
client.interceptors.request.use((config)=>{
    if ((0, _core.Capacitor).isNativePlatform()) config.headers["x-client-type"] = "capacitor";
    return config;
});
// client.interceptors.request.use((config) => {
//   console.log("Request Interceptor:");
//   console.log("URL:", config.url);
//   console.log("Method:", config.method);
//   console.log("Headers:", config.headers);
//   console.log("Data:", config.data);
//   console.log("Params:", config.params);
//   return config;
// });
let errorMsg;
const request = ({ ...options })=>{
    const authToken = localStorage.getItem("authToken");
    if (authToken) client.defaults.headers.common["x-auth-token"] = authToken;
    const onSuccess = (response)=>{
        if ((response === null || response === void 0 ? void 0 : response.status) === 204) {
            errorMsg = "Page has been temporarily unpublished";
            throw {
                toasterMessage: null,
                message: errorMsg,
                status: 204,
                response: {
                    status: 204
                }
            };
        }
        const serverDownElement = document.getElementById("server-down");
        if (serverDownElement) serverDownElement.remove();
        return response;
    };
    const onError = (error)=>{
        var _error_response_data, _error_response, _error_response1, _errorMessage_toString_replace, _errorMessage_toString, _error_response2, _error_response3, _error_response_data1, _error_response4;
        const errorMessage = (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) || (error === null || error === void 0 ? void 0 : (_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : _error_response1.data);
        const bodyError = errorMessage === null || errorMessage === void 0 ? void 0 : (_errorMessage_toString = errorMessage.toString()) === null || _errorMessage_toString === void 0 ? void 0 : (_errorMessage_toString_replace = _errorMessage_toString.replace(/(<([^>]+)>)/gi, "")) === null || _errorMessage_toString_replace === void 0 ? void 0 : _errorMessage_toString_replace.replace(/[\r\n]+/g, " ");
        if ((error === null || error === void 0 ? void 0 : error.code) === "ERR_NETWORK") errorMsg = "Network error - please check your connection.";
        else switch(error === null || error === void 0 ? void 0 : (_error_response2 = error.response) === null || _error_response2 === void 0 ? void 0 : _error_response2.status){
            case 204:
                options.noToaster = true;
                errorMsg = "Page has been temporarily unpublished";
                break;
            case 400:
                if (bodyError === null || bodyError === void 0 ? void 0 : bodyError.includes("is already taken")) options.noToaster = true;
                errorMsg = "Invalid submission - please check details";
                break;
            case 401:
            case 403:
                var _error_response_headers, _error_response5, _error_response6;
                // is the response type JSON? If so, return as if successful
                const contentType = error === null || error === void 0 ? void 0 : (_error_response5 = error.response) === null || _error_response5 === void 0 ? void 0 : (_error_response_headers = _error_response5.headers) === null || _error_response_headers === void 0 ? void 0 : _error_response_headers["content-type"];
                // does contentType contain "application/json"?
                if (contentType === null || contentType === void 0 ? void 0 : contentType.includes("application/json")) return error === null || error === void 0 ? void 0 : (_error_response6 = error.response) === null || _error_response6 === void 0 ? void 0 : _error_response6.data;
                else errorMsg = options.noToaster ? "Not authenticated to view this page" : "Unauthorised - please check your account privileges";
                break;
            case 404:
                options.noToaster = true;
                errorMsg = "Page not found";
                break;
            case 409:
                errorMsg = "Item already exists - please check details before resubmitting";
                break;
            case 413:
                errorMsg = "Too much data is being sent - rejected by server";
                break;
            case 498:
                errorMsg = "Your session has expired - please log in again";
                // Dispatch a custom event for session expiration
                window.dispatchEvent(new CustomEvent("sessionExpired"));
                break;
            case 503:
                errorMsg = null;
                options.noToaster = true;
                break;
            default:
                errorMsg = "Server error. If this error persists, please contact support.";
                break;
        }
        throw {
            toasterMessage: !options.noToaster && errorMsg,
            message: errorMsg,
            status: error === null || error === void 0 ? void 0 : (_error_response3 = error.response) === null || _error_response3 === void 0 ? void 0 : _error_response3.status,
            bodyError,
            missingFields: error === null || error === void 0 ? void 0 : (_error_response4 = error.response) === null || _error_response4 === void 0 ? void 0 : (_error_response_data1 = _error_response4.data) === null || _error_response_data1 === void 0 ? void 0 : _error_response_data1.missingFields
        };
    };
    return client(options).then(onSuccess).catch(onError);
};

},{"axios":"c1N5U","@capacitor/core":"sq5Bf","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"c1N5U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _axiosJsDefault.default));
parcelHelpers.export(exports, "create", ()=>create);
parcelHelpers.export(exports, "Axios", ()=>Axios);
parcelHelpers.export(exports, "AxiosError", ()=>AxiosError);
parcelHelpers.export(exports, "CanceledError", ()=>CanceledError);
parcelHelpers.export(exports, "isCancel", ()=>isCancel);
parcelHelpers.export(exports, "CancelToken", ()=>CancelToken);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
parcelHelpers.export(exports, "all", ()=>all);
parcelHelpers.export(exports, "Cancel", ()=>Cancel);
parcelHelpers.export(exports, "isAxiosError", ()=>isAxiosError);
parcelHelpers.export(exports, "spread", ()=>spread);
parcelHelpers.export(exports, "toFormData", ()=>toFormData);
parcelHelpers.export(exports, "AxiosHeaders", ()=>AxiosHeaders);
parcelHelpers.export(exports, "HttpStatusCode", ()=>HttpStatusCode);
parcelHelpers.export(exports, "formToJSON", ()=>formToJSON);
parcelHelpers.export(exports, "getAdapter", ()=>getAdapter);
parcelHelpers.export(exports, "mergeConfig", ()=>mergeConfig);
var _axiosJs = require("./lib/axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios, AxiosError, CanceledError, isCancel, CancelToken, VERSION, all, Cancel, isAxiosError, spread, toFormData, AxiosHeaders, HttpStatusCode, formToJSON, getAdapter, mergeConfig, create } = (0, _axiosJsDefault.default);

},{"./lib/axios.js":"7XGGS","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7XGGS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var _axiosJs = require("./core/Axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
var _mergeConfigJs = require("./core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _indexJs = require("./defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("./helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
var _canceledErrorJs = require("./cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _cancelTokenJs = require("./cancel/CancelToken.js");
var _cancelTokenJsDefault = parcelHelpers.interopDefault(_cancelTokenJs);
var _isCancelJs = require("./cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _dataJs = require("./env/data.js");
var _toFormDataJs = require("./helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _axiosErrorJs = require("./core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _spreadJs = require("./helpers/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
var _isAxiosErrorJs = require("./helpers/isAxiosError.js");
var _isAxiosErrorJsDefault = parcelHelpers.interopDefault(_isAxiosErrorJs);
var _axiosHeadersJs = require("./core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("./adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
var _httpStatusCodeJs = require("./helpers/HttpStatusCode.js");
var _httpStatusCodeJsDefault = parcelHelpers.interopDefault(_httpStatusCodeJs);
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
    const context = new (0, _axiosJsDefault.default)(defaultConfig);
    const instance = (0, _bindJsDefault.default)((0, _axiosJsDefault.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, _utilsJsDefault.default).extend(instance, (0, _axiosJsDefault.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, _utilsJsDefault.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return createInstance((0, _mergeConfigJsDefault.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const axios = createInstance((0, _indexJsDefault.default));
// Expose Axios class to allow class inheritance
axios.Axios = (0, _axiosJsDefault.default);
// Expose Cancel & CancelToken
axios.CanceledError = (0, _canceledErrorJsDefault.default);
axios.CancelToken = (0, _cancelTokenJsDefault.default);
axios.isCancel = (0, _isCancelJsDefault.default);
axios.VERSION = (0, _dataJs.VERSION);
axios.toFormData = (0, _toFormDataJsDefault.default);
// Expose AxiosError class
axios.AxiosError = (0, _axiosErrorJsDefault.default);
// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;
// Expose all/spread
axios.all = function all(promises) {
    return Promise.all(promises);
};
axios.spread = (0, _spreadJsDefault.default);
// Expose isAxiosError
axios.isAxiosError = (0, _isAxiosErrorJsDefault.default);
// Expose mergeConfig
axios.mergeConfig = (0, _mergeConfigJsDefault.default);
axios.AxiosHeaders = (0, _axiosHeadersJsDefault.default);
axios.formToJSON = (thing)=>(0, _formDataToJSONJsDefault.default)((0, _utilsJsDefault.default).isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = (0, _adaptersJsDefault.default).getAdapter;
axios.HttpStatusCode = (0, _httpStatusCodeJsDefault.default);
axios.default = axios;
// this module should only have a default export
exports.default = axios;

},{"./utils.js":"kanJJ","./helpers/bind.js":"2l9Cd","./core/Axios.js":"dMMDq","./core/mergeConfig.js":"b5guk","./defaults/index.js":"1Grsq","./helpers/formDataToJSON.js":"45Cmb","./cancel/CanceledError.js":"5XsYG","./cancel/CancelToken.js":"ecj9t","./cancel/isCancel.js":"dVh7S","./env/data.js":"4Suki","./helpers/toFormData.js":"frqiB","./core/AxiosError.js":"jlvie","./helpers/spread.js":"kDMOU","./helpers/isAxiosError.js":"hsk2L","./core/AxiosHeaders.js":"7q3bx","./adapters/adapters.js":"aL9we","./helpers/HttpStatusCode.js":"8f0Mb","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kanJJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var global = arguments[3];
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const { iterator, toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const hasOwnProperty = (({ hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Walk the prototype chain (excluding the shared Object.prototype) looking for
 * an own `prop`. This distinguishes genuine own/inherited members — including
 * class accessors and template prototypes — from members injected via
 * Object.prototype pollution (e.g. `Object.prototype.username = '...'`), which
 * live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null && obj !== Object.prototype){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        if (hasOwnProperty(obj, prop)) return true;
        obj = getPrototypeOf(obj);
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const getSafeProp = (obj, prop)=>obj != null && hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
const kindOf = ((cache)=>(thing)=>{
        const str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>kindOf(thing) === type;
};
const typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const isUndefined = typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const isArrayBuffer = kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const isString = typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const isFunction = typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const isNumber = typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const isPlainObject = (val)=>{
    if (!isObject(val)) return false;
    const prototype = getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || getPrototypeOf(prototype) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
    // Symbol.iterator as evidence the value is a tagged/iterable type rather
    // than a plain object, while ignoring keys injected onto Object.prototype.
    !hasOwnInPrototypeChain(val, toStringTag) && !hasOwnInPrototypeChain(val, iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!isObject(val) || isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const isDate = kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFile = kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const isBlob = kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const isFileList = kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const isStream = (val)=>isObject(val) && isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof global !== 'undefined') return global;
    return {};
}
const G = getGlobal();
const FormDataCtor = typeof G.FormData !== 'undefined' ? G.FormData : undefined;
const isFormData = (thing)=>{
    if (!thing) return false;
    if (FormDataCtor && thing instanceof FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!isFunction(thing.append)) return false;
    const kind = kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const isURLSearchParams = kindOfTest('URLSearchParams');
const [isReadableStream, isRequest, isResponse, isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map(kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function forEach(obj, fn, { allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if (isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if (isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function findKey(obj, key) {
    if (isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const _global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : global;
})();
const isContextDefined = (context)=>!isUndefined(context) && context !== _global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function merge(...objs) {
    const { caseless, skipUndefined } = isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if (isPlainObject(existing) && isPlainObject(val)) result[targetKey] = merge(existing, val);
        else if (isPlainObject(val)) result[targetKey] = merge({}, val);
        else if (isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || isBuffer(source)) continue;
        forEach(source, assignValue);
        if (typeof source !== 'object' || isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if (propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const extend = (a, b, thisArg, { allOwnKeys } = {})=>{
    forEach(b, (val, key)=>{
        if (thisArg && isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, _bindJsDefault.default)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const toArray = (thing)=>{
    if (!thing) return null;
    if (isArray(thing)) return thing;
    let i = thing.length;
    if (!isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const forEachEntry = (obj, fn)=>{
    const generator = obj && obj[iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const isHTMLForm = kindOfTest('HTMLFormElement');
const toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const isRegExp = kindOfTest('RegExp');
const reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const freezeMethods = (obj)=>{
    reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if (isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const noop = ()=>{};
const toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function isSpecCompliantForm(thing) {
    return !!(thing && isFunction(thing.append) && thing[toStringTag] === 'FormData' && thing[iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if (isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if (isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                const target = isArray(source) ? [] : {};
                forEach(source, (value, key)=>{
                    const reducedValue = visit(value);
                    !isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const isAsyncFn = kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const isThenable = (thing)=>thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const _setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        _global.addEventListener('message', ({ source, data })=>{
            if (source === _global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            _global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', isFunction(_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind(_global) : _setImmediate;
// *********************
const isIterable = (thing)=>thing != null && isFunction(thing[iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const isSafeIterable = (thing)=>thing != null && hasOwnInPrototypeChain(thing, iterator) && isIterable(thing);
exports.default = {
    isArray,
    isArrayBuffer,
    isBuffer,
    isFormData,
    isArrayBufferView,
    isString,
    isNumber,
    isBoolean,
    isObject,
    isPlainObject,
    isEmptyObject,
    isReadableStream,
    isRequest,
    isResponse,
    isHeaders,
    isUndefined,
    isDate,
    isFile,
    isReactNativeBlob,
    isReactNative,
    isBlob,
    isRegExp,
    isFunction,
    isStream,
    isURLSearchParams,
    isTypedArray,
    isFileList,
    forEach,
    merge,
    extend,
    trim,
    stripBOM,
    inherits,
    toFlatObject,
    kindOf,
    kindOfTest,
    endsWith,
    toArray,
    forEachEntry,
    matchAll,
    isHTMLForm,
    hasOwnProperty,
    hasOwnProp: hasOwnProperty,
    hasOwnInPrototypeChain,
    getSafeProp,
    reduceDescriptors,
    freezeMethods,
    toObjectSet,
    toCamelCase,
    noop,
    toFiniteNumber,
    findKey,
    global: _global,
    isContextDefined,
    isSpecCompliantForm,
    toJSONObject,
    isAsyncFn,
    isThenable,
    setImmediate: _setImmediate,
    asap,
    isIterable,
    isSafeIterable
};

},{"./helpers/bind.js":"2l9Cd","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2l9Cd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bind);
'use strict';
function bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"dMMDq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _buildURLJs = require("../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _interceptorManagerJs = require("./InterceptorManager.js");
var _interceptorManagerJsDefault = parcelHelpers.interopDefault(_interceptorManagerJs);
var _dispatchRequestJs = require("./dispatchRequest.js");
var _dispatchRequestJsDefault = parcelHelpers.interopDefault(_dispatchRequestJs);
var _mergeConfigJs = require("./mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _buildFullPathJs = require("./buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _validatorJs = require("../helpers/validator.js");
var _validatorJsDefault = parcelHelpers.interopDefault(_validatorJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _transitionalJs = require("../defaults/transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
'use strict';
const validators = (0, _validatorJsDefault.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, _interceptorManagerJsDefault.default)(),
            response: new (0, _interceptorManagerJsDefault.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const { transitional, paramsSerializer, headers } = config;
        if (transitional !== undefined) (0, _validatorJsDefault.default).assertOptions(transitional, {
            silentJSONParsing: validators.transitional(validators.boolean),
            forcedJSONParsing: validators.transitional(validators.boolean),
            clarifyTimeoutError: validators.transitional(validators.boolean),
            legacyInterceptorReqResOrdering: validators.transitional(validators.boolean),
            advertiseZstdAcceptEncoding: validators.transitional(validators.boolean),
            validateStatusUndefinedResolves: validators.transitional(validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, _utilsJsDefault.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, _validatorJsDefault.default).assertOptions(paramsSerializer, {
                encode: validators.function,
                serialize: validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, _validatorJsDefault.default).assertOptions(config, {
            baseUrl: validators.spelling('baseURL'),
            withXsrfToken: validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, _utilsJsDefault.default).merge(headers.common, headers[config.method]);
        headers && (0, _utilsJsDefault.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, _axiosHeadersJsDefault.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, _transitionalJsDefault.default);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, _dispatchRequestJsDefault.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, _dispatchRequestJsDefault.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, _utilsJsDefault.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
        return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
            method,
            url,
            data: config && (0, _utilsJsDefault.default).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, _utilsJsDefault.default).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
                method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url,
                data
            }));
        };
    }
    Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
exports.default = Axios;

},{"../utils.js":"kanJJ","../helpers/buildURL.js":"f8dzc","./InterceptorManager.js":"9j1Go","./dispatchRequest.js":"FzLfg","./mergeConfig.js":"b5guk","./buildFullPath.js":"3fZ5D","../helpers/validator.js":"9A4a8","./AxiosHeaders.js":"7q3bx","../defaults/transitional.js":"kTDNJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"f8dzc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * It replaces URL-encoded forms of `:`, `$`, `,`, and spaces with
 * their plain counterparts (`:`, `$`, `,`, `+`).
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "default", ()=>buildURL);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosURLSearchParamsJs = require("./AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
'use strict';
function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function buildURL(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, _utilsJsDefault.default).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, _utilsJsDefault.default).getSafeProp(_options, 'encode') || encode;
    const serializeFn = (0, _utilsJsDefault.default).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, _utilsJsDefault.default).isURLSearchParams(params) ? params.toString() : new (0, _axiosURLSearchParamsJsDefault.default)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

},{"../utils.js":"kanJJ","./AxiosURLSearchParams.js":"jBcs0","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"jBcs0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, _toFormDataJsDefault.default)(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, encode) : encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
exports.default = AxiosURLSearchParams;

},{"./toFormData.js":"frqiB","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"frqiB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_FORM_DATA_MAX_DEPTH", ()=>DEFAULT_FORM_DATA_MAX_DEPTH);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored
var _formDataJs = require("../platform/node/classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var Buffer = require("adfd9b103875c2dd").Buffer;
'use strict';
const DEFAULT_FORM_DATA_MAX_DEPTH = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function isVisitable(thing) {
    return (0, _utilsJsDefault.default).isPlainObject(thing) || (0, _utilsJsDefault.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function removeBrackets(key) {
    return (0, _utilsJsDefault.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function isFlatArray(arr) {
    return (0, _utilsJsDefault.default).isArray(arr) && !arr.some(isVisitable);
}
const predicates = (0, _utilsJsDefault.default).toFlatObject((0, _utilsJsDefault.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function toFormData(obj, formData, options) {
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, _formDataJsDefault.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, _utilsJsDefault.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, _utilsJsDefault.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? DEFAULT_FORM_DATA_MAX_DEPTH : options.maxDepth;
    const useBlob = _Blob && (0, _utilsJsDefault.default).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, _utilsJsDefault.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, _utilsJsDefault.default).isDate(value)) return value.toISOString();
        if ((0, _utilsJsDefault.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, _utilsJsDefault.default).isBlob(value)) throw new (0, _axiosErrorJsDefault.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, _utilsJsDefault.default).isArrayBuffer(value) || (0, _utilsJsDefault.default).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if (typeof Buffer !== 'undefined') return Buffer.from(value);
            throw new (0, _axiosErrorJsDefault.default)('Blob is not supported. Use a Buffer instead.', (0, _axiosErrorJsDefault.default).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, _axiosErrorJsDefault.default)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, _axiosErrorJsDefault.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, _utilsJsDefault.default).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, _utilsJsDefault.default).isReactNative(formData) && (0, _utilsJsDefault.default).isReactNativeBlob(value)) {
            formData.append(renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, _utilsJsDefault.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, _utilsJsDefault.default).isArray(value) && isFlatArray(value) || ((0, _utilsJsDefault.default).isFileList(value) || (0, _utilsJsDefault.default).endsWith(key, '[]')) && (arr = (0, _utilsJsDefault.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if (isVisitable(value)) return true;
        formData.append(renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign(predicates, {
        defaultVisitor,
        convertValue,
        isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, _utilsJsDefault.default).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, _utilsJsDefault.default).forEach(value, function each(el, key) {
            const result = !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, _utilsJsDefault.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
exports.default = toFormData;

},{"adfd9b103875c2dd":"kYMrW","../utils.js":"kanJJ","../core/AxiosError.js":"jlvie","../platform/node/classes/FormData.js":"4m2jT","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kYMrW":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
var base64 = require("9c62938f1dccc73c");
var ieee754 = require("aceacb6a4531a9d2");
var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
var K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    var b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = byteLength(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        var len = checked(obj.length) | 0;
        var buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

},{"9c62938f1dccc73c":"dNNCH","aceacb6a4531a9d2":"YAWcn"}],"dNNCH":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"YAWcn":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"jlvie":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
const REDACTED = '[REDACTED ****]';
function hasOwnOrPrototypeToJSON(source) {
    if ((0, _utilsJsDefault.default).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, _utilsJsDefault.default).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, _utilsJsDefault.default).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, _axiosHeadersJsDefault.default)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, _utilsJsDefault.default).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, _utilsJsDefault.default).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, _utilsJsDefault.default).isPlainObject(source) && hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? REDACTED : visit(value);
                if (!(0, _utilsJsDefault.default).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
class AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new AxiosError(error.message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, _utilsJsDefault.default).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, _utilsJsDefault.default).isArray(redactKeys) && redactKeys.length > 0 ? redactConfig(config, redactKeys) : (0, _utilsJsDefault.default).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
AxiosError.ECONNABORTED = 'ECONNABORTED';
AxiosError.ETIMEDOUT = 'ETIMEDOUT';
AxiosError.ECONNREFUSED = 'ECONNREFUSED';
AxiosError.ERR_NETWORK = 'ERR_NETWORK';
AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
AxiosError.ERR_CANCELED = 'ERR_CANCELED';
AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
exports.default = AxiosError;

},{"../utils.js":"kanJJ","./AxiosHeaders.js":"7q3bx","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7q3bx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _parseHeadersJs = require("../helpers/parseHeaders.js");
var _parseHeadersJsDefault = parcelHelpers.interopDefault(_parseHeadersJs);
var _sanitizeHeaderValueJs = require("../helpers/sanitizeHeaderValue.js");
'use strict';
const $internals = Symbol('internals');
function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, _utilsJsDefault.default).isArray(value) ? value.map(normalizeValue) : (0, _sanitizeHeaderValueJs.sanitizeHeaderValue)(String(value));
}
function parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, _utilsJsDefault.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, _utilsJsDefault.default).isString(value)) return;
    if ((0, _utilsJsDefault.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, _utilsJsDefault.default).isRegExp(filter)) return filter.test(value);
}
function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function buildAccessors(obj, header) {
    const accessorName = (0, _utilsJsDefault.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, _utilsJsDefault.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, _utilsJsDefault.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, _utilsJsDefault.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isString(header) && (header = header.trim()) && !isValidHeaderName(header)) setHeaders((0, _parseHeadersJsDefault.default)(header), valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isObject(header) && (0, _utilsJsDefault.default).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, _utilsJsDefault.default).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, _utilsJsDefault.default).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, _utilsJsDefault.default).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return parseTokens(value);
                if ((0, _utilsJsDefault.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, _utilsJsDefault.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = normalizeHeader(_header);
            if (_header) {
                const key = (0, _utilsJsDefault.default).findKey(self, _header);
                if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, _utilsJsDefault.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            const key = (0, _utilsJsDefault.default).findKey(headers, header);
            if (key) {
                self[key] = normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, _utilsJsDefault.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get('set-cookie') || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$internals] = this[$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = normalizeHeader(_header);
            if (!accessors[lHeader]) {
                buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, _utilsJsDefault.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, _utilsJsDefault.default).reduceDescriptors(AxiosHeaders.prototype, ({ value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, _utilsJsDefault.default).freezeMethods(AxiosHeaders);
exports.default = AxiosHeaders;

},{"../utils.js":"kanJJ","../helpers/parseHeaders.js":"gmhrM","../helpers/sanitizeHeaderValue.js":"fM35J","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"gmhrM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = (0, _utilsJsDefault.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ exports.default = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

},{"../utils.js":"kanJJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fM35J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sanitizeHeaderValue", ()=>sanitizeHeaderValue);
parcelHelpers.export(exports, "sanitizeByteStringHeaderValue", ()=>sanitizeByteStringHeaderValue);
parcelHelpers.export(exports, "toByteStringHeaderObject", ()=>toByteStringHeaderObject);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
function trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function sanitizeValue(value, invalidChars) {
    if ((0, _utilsJsDefault.default).isArray(value)) return value.map((item)=>sanitizeValue(item, invalidChars));
    return trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const sanitizeHeaderValue = (value)=>sanitizeValue(value, INVALID_UNICODE_HEADER_VALUE_CHARS);
const sanitizeByteStringHeaderValue = (value)=>sanitizeValue(value, INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function toByteStringHeaderObject(headers) {
    const byteStringHeaders = Object.create(null);
    (0, _utilsJsDefault.default).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = sanitizeByteStringHeaderValue(value);
    });
    return byteStringHeaders;
}

},{"../utils.js":"kanJJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4m2jT":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line strict
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9j1Go":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
class InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled,
            rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, _utilsJsDefault.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
exports.default = InterceptorManager;

},{"../utils.js":"kanJJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"FzLfg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dispatchRequest);
var _transformDataJs = require("./transformData.js");
var _transformDataJsDefault = parcelHelpers.interopDefault(_transformDataJs);
var _isCancelJs = require("../cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("../adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, _canceledErrorJsDefault.default)(null, config);
}
function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    config.headers = (0, _axiosHeadersJsDefault.default).from(config.headers);
    // Transform request data
    config.data = (0, _transformDataJsDefault.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, _adaptersJsDefault.default).getAdapter(config.adapter || (0, _indexJsDefault.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, _axiosHeadersJsDefault.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, _isCancelJsDefault.default)(reason)) {
            throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, _axiosHeadersJsDefault.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

},{"./transformData.js":"gqbC4","../cancel/isCancel.js":"dVh7S","../defaults/index.js":"1Grsq","../cancel/CanceledError.js":"5XsYG","../core/AxiosHeaders.js":"7q3bx","../adapters/adapters.js":"aL9we","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"gqbC4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transformData);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
function transformData(fns, response) {
    const config = this || (0, _indexJsDefault.default);
    const context = response || config;
    const headers = (0, _axiosHeadersJsDefault.default).from(context.headers);
    let data = context.data;
    (0, _utilsJsDefault.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

},{"../utils.js":"kanJJ","../defaults/index.js":"1Grsq","../core/AxiosHeaders.js":"7q3bx","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"1Grsq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _transitionalJs = require("./transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _toFormDataJs = require("../helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _toURLEncodedFormJs = require("../helpers/toURLEncodedForm.js");
var _toURLEncodedFormJsDefault = parcelHelpers.interopDefault(_toURLEncodedFormJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("../helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
'use strict';
const own = (obj, key)=>obj != null && (0, _utilsJsDefault.default).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function stringifySafely(rawValue, parser, encoder) {
    if ((0, _utilsJsDefault.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, _utilsJsDefault.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
    transitional: (0, _transitionalJsDefault.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, _utilsJsDefault.default).isObject(data);
            if (isObjectPayload && (0, _utilsJsDefault.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, _utilsJsDefault.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, _formDataToJSONJsDefault.default)(data)) : data;
            if ((0, _utilsJsDefault.default).isArrayBuffer(data) || (0, _utilsJsDefault.default).isBuffer(data) || (0, _utilsJsDefault.default).isStream(data) || (0, _utilsJsDefault.default).isFile(data) || (0, _utilsJsDefault.default).isBlob(data) || (0, _utilsJsDefault.default).isReadableStream(data)) return data;
            if ((0, _utilsJsDefault.default).isArrayBufferView(data)) return data.buffer;
            if ((0, _utilsJsDefault.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, _toURLEncodedFormJsDefault.default)(data, formSerializer).toString();
                if ((isFileList = (0, _utilsJsDefault.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, _toFormDataJsDefault.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = own(this, 'transitional') || defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, _utilsJsDefault.default).isResponse(data) || (0, _utilsJsDefault.default).isReadableStream(data)) return data;
            if (data && (0, _utilsJsDefault.default).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, _axiosErrorJsDefault.default).from(e, (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, this, null, own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, _indexJsDefault.default).classes.FormData,
        Blob: (0, _indexJsDefault.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, _utilsJsDefault.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    defaults.headers[method] = {};
});
exports.default = defaults;

},{"../utils.js":"kanJJ","../core/AxiosError.js":"jlvie","./transitional.js":"kTDNJ","../helpers/toFormData.js":"frqiB","../helpers/toURLEncodedForm.js":"21gVj","../platform/index.js":"iRXUF","../helpers/formDataToJSON.js":"45Cmb","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kTDNJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"21gVj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toURLEncodedForm);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
'use strict';
function toURLEncodedForm(data, options) {
    return (0, _toFormDataJsDefault.default)(data, new (0, _indexJsDefault.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, _indexJsDefault.default).isNode && (0, _utilsJsDefault.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

},{"../utils.js":"kanJJ","./toFormData.js":"frqiB","../platform/index.js":"iRXUF","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"iRXUF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./node/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("./common/utils.js");
exports.default = {
    ..._utilsJs,
    ...(0, _indexJsDefault.default)
};

},{"./node/index.js":"evjcq","./common/utils.js":"gJ5dS","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"evjcq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _urlsearchParamsJs = require("./classes/URLSearchParams.js");
var _urlsearchParamsJsDefault = parcelHelpers.interopDefault(_urlsearchParamsJs);
var _formDataJs = require("./classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var _blobJs = require("./classes/Blob.js");
var _blobJsDefault = parcelHelpers.interopDefault(_blobJs);
exports.default = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, _urlsearchParamsJsDefault.default),
        FormData: (0, _formDataJsDefault.default),
        Blob: (0, _blobJsDefault.default)
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

},{"./classes/URLSearchParams.js":"bhgeh","./classes/FormData.js":"8evui","./classes/Blob.js":"5AuKM","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"bhgeh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosURLSearchParamsJs = require("../../../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
'use strict';
exports.default = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, _axiosURLSearchParamsJsDefault.default);

},{"../../../helpers/AxiosURLSearchParams.js":"jBcs0","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8evui":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = typeof FormData !== 'undefined' ? FormData : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5AuKM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = typeof Blob !== 'undefined' ? Blob : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"gJ5dS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasBrowserEnv", ()=>hasBrowserEnv);
parcelHelpers.export(exports, "hasStandardBrowserWebWorkerEnv", ()=>hasStandardBrowserWebWorkerEnv);
parcelHelpers.export(exports, "hasStandardBrowserEnv", ()=>hasStandardBrowserEnv);
parcelHelpers.export(exports, "navigator", ()=>_navigator);
parcelHelpers.export(exports, "origin", ()=>origin);
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';
const _navigator = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf(_navigator.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const hasStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const origin = hasBrowserEnv && window.location.href || 'http://localhost';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"45Cmb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _toFormDataJs = require("./toFormData.js");
'use strict';
const MAX_DEPTH = (0, _toFormDataJs.DEFAULT_FORM_DATA_MAX_DEPTH);
function throwIfDepthExceeded(index) {
    if (index > MAX_DEPTH) throw new (0, _axiosErrorJsDefault.default)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + MAX_DEPTH, (0, _axiosErrorJsDefault.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    const path = [];
    const pattern = /\w+|\[(\w*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, _utilsJsDefault.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, _utilsJsDefault.default).hasOwnProp(target, name)) target[name] = (0, _utilsJsDefault.default).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, _utilsJsDefault.default).hasOwnProp(target, name) || !(0, _utilsJsDefault.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, _utilsJsDefault.default).isArray(target[name])) target[name] = arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, _utilsJsDefault.default).isFormData(formData) && (0, _utilsJsDefault.default).isFunction(formData.entries)) {
        const obj = {};
        (0, _utilsJsDefault.default).forEachEntry(formData, (name, value)=>{
            buildPath(parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
exports.default = formDataToJSON;

},{"../utils.js":"kanJJ","../core/AxiosError.js":"jlvie","./toFormData.js":"frqiB","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"dVh7S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isCancel);
'use strict';
function isCancel(value) {
    return !!(value && value.__CANCEL__);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5XsYG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
'use strict';
class CanceledError extends (0, _axiosErrorJsDefault.default) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, _axiosErrorJsDefault.default).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
exports.default = CanceledError;

},{"../core/AxiosError.js":"jlvie","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"aL9we":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _httpJs = require("./http.js");
var _httpJsDefault = parcelHelpers.interopDefault(_httpJs);
var _xhrJs = require("./xhr.js");
var _xhrJsDefault = parcelHelpers.interopDefault(_xhrJs);
var _fetchJs = require("./fetch.js");
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const knownAdapters = {
    http: (0, _httpJsDefault.default),
    xhr: (0, _xhrJsDefault.default),
    fetch: {
        get: _fetchJs.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, _utilsJsDefault.default).forEach(knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const isResolvedHandle = (adapter)=>(0, _utilsJsDefault.default).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function getAdapter(adapters, config) {
    adapters = (0, _utilsJsDefault.default).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!isResolvedHandle(nameOrAdapter)) {
            adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, _axiosErrorJsDefault.default)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, _utilsJsDefault.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, _axiosErrorJsDefault.default)(`There is no suitable adapter to dispatch the request ` + s, (0, _axiosErrorJsDefault.default).ERR_NOT_SUPPORT);
    }
    return adapter;
}
/**
 * Exports Axios adapters and utility to resolve an adapter
 */ exports.default = {
    /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: knownAdapters
};

},{"../utils.js":"kanJJ","./http.js":"4m2jT","./xhr.js":"eLTFe","./fetch.js":"eyYgF","../core/AxiosError.js":"jlvie","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"eLTFe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _settleJs = require("../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
var _transitionalJs = require("../defaults/transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _parseProtocolJs = require("../helpers/parseProtocol.js");
var _parseProtocolJsDefault = parcelHelpers.interopDefault(_parseProtocolJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _progressEventReducerJs = require("../helpers/progressEventReducer.js");
var _resolveConfigJs = require("../helpers/resolveConfig.js");
var _resolveConfigJsDefault = parcelHelpers.interopDefault(_resolveConfigJs);
var _sanitizeHeaderValueJs = require("../helpers/sanitizeHeaderValue.js");
const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
exports.default = isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, _resolveConfigJsDefault.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, _axiosHeadersJsDefault.default).from(_config.headers).normalize();
        let { responseType, onUploadProgress, onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, _axiosHeadersJsDefault.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config,
                request
            };
            (0, _settleJsDefault.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, _axiosErrorJsDefault.default)('Request aborted', (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, _axiosErrorJsDefault.default)(msg, (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, _transitionalJsDefault.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, _axiosErrorJsDefault.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, _axiosErrorJsDefault.default).ETIMEDOUT : (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, _utilsJsDefault.default).forEach((0, _sanitizeHeaderValueJs.toByteStringHeaderObject)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, _utilsJsDefault.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, _progressEventReducerJs.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, _progressEventReducerJs.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, _canceledErrorJsDefault.default)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, _parseProtocolJsDefault.default)(_config.url);
        if (protocol && !(0, _indexJsDefault.default).protocols.includes(protocol)) {
            reject(new (0, _axiosErrorJsDefault.default)('Unsupported protocol ' + protocol + ':', (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

},{"../utils.js":"kanJJ","../core/settle.js":"6rekF","../defaults/transitional.js":"kTDNJ","../core/AxiosError.js":"jlvie","../cancel/CanceledError.js":"5XsYG","../helpers/parseProtocol.js":"lMTrS","../platform/index.js":"iRXUF","../core/AxiosHeaders.js":"7q3bx","../helpers/progressEventReducer.js":"bPqIz","../helpers/resolveConfig.js":"4kK8Q","../helpers/sanitizeHeaderValue.js":"fM35J","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6rekF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>settle);
var _axiosErrorJs = require("./AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
'use strict';
function settle(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, _axiosErrorJsDefault.default)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST : (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, response.config, response.request, response));
}

},{"./AxiosError.js":"jlvie","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"lMTrS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseProtocol);
'use strict';
function parseProtocol(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"bPqIz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "progressEventReducer", ()=>progressEventReducer);
parcelHelpers.export(exports, "progressEventDecorator", ()=>progressEventDecorator);
parcelHelpers.export(exports, "asyncDecorator", ()=>asyncDecorator);
var _speedometerJs = require("./speedometer.js");
var _speedometerJsDefault = parcelHelpers.interopDefault(_speedometerJs);
var _throttleJs = require("./throttle.js");
var _throttleJsDefault = parcelHelpers.interopDefault(_throttleJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
const progressEventReducer = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, _speedometerJsDefault.default)(50, 250);
    return (0, _throttleJsDefault.default)((e)=>{
        if (!e || typeof e.loaded !== 'number') return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded,
            total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const progressEventDecorator = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable,
                total,
                loaded
            }),
        throttled[1]
    ];
};
const asyncDecorator = (fn)=>(...args)=>(0, _utilsJsDefault.default).asap(()=>fn(...args));

},{"./speedometer.js":"cmQPz","./throttle.js":"3kx2y","../utils.js":"kanJJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"cmQPz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
exports.default = speedometer;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3kx2y":[function(require,module,exports,__globalThis) {
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
exports.default = throttle;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4kK8Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _isURLSameOriginJs = require("./isURLSameOrigin.js");
var _isURLSameOriginJsDefault = parcelHelpers.interopDefault(_isURLSameOriginJs);
var _cookiesJs = require("./cookies.js");
var _cookiesJsDefault = parcelHelpers.interopDefault(_cookiesJs);
var _buildFullPathJs = require("../core/buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _mergeConfigJs = require("../core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _buildURLJs = require("./buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
const FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if (FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function resolveConfig(config) {
    const newConfig = (0, _mergeConfigJsDefault.default)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, _utilsJsDefault.default).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, _axiosHeadersJsDefault.default).from(headers);
    newConfig.url = (0, _buildURLJsDefault.default)((0, _buildFullPathJsDefault.default)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, _utilsJsDefault.default).getSafeProp(auth, 'username') || '';
        const password = (0, _utilsJsDefault.default).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, _axiosErrorJsDefault.default).from(e, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, _utilsJsDefault.default).isFormData(data)) {
        if ((0, _indexJsDefault.default).hasStandardBrowserEnv || (0, _indexJsDefault.default).hasStandardBrowserWebWorkerEnv || (0, _utilsJsDefault.default).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, _utilsJsDefault.default).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        setFormDataHeaders(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, _indexJsDefault.default).hasStandardBrowserEnv) {
        if ((0, _utilsJsDefault.default).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, _isURLSameOriginJsDefault.default)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, _cookiesJsDefault.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
exports.default = resolveConfig;

},{"../platform/index.js":"iRXUF","../utils.js":"kanJJ","../core/AxiosError.js":"jlvie","./isURLSameOrigin.js":"9esnp","./cookies.js":"fpHv0","../core/buildFullPath.js":"3fZ5D","../core/mergeConfig.js":"b5guk","../core/AxiosHeaders.js":"7q3bx","./buildURL.js":"f8dzc","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9esnp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, _indexJsDefault.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, _indexJsDefault.default).origin), (0, _indexJsDefault.default).navigator && /(msie|trident)/i.test((0, _indexJsDefault.default).navigator.userAgent)) : ()=>true;

},{"../platform/index.js":"iRXUF","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fpHv0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, _utilsJsDefault.default).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, _utilsJsDefault.default).isString(path)) cookie.push(`path=${path}`);
        if ((0, _utilsJsDefault.default).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, _utilsJsDefault.default).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};

},{"../utils.js":"kanJJ","../platform/index.js":"iRXUF","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3fZ5D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFullPath);
var _axiosErrorJs = require("./AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _isAbsoluteURLJs = require("../helpers/isAbsoluteURL.js");
var _isAbsoluteURLJsDefault = parcelHelpers.interopDefault(_isAbsoluteURLJs);
var _combineURLsJs = require("../helpers/combineURLs.js");
var _combineURLsJsDefault = parcelHelpers.interopDefault(_combineURLsJs);
'use strict';
const malformedHttpProtocol = /^https?:(?!\/\/)/i;
const httpProtocolControlCharacters = /[\t\n\r]/g;
function stripLeadingC0ControlOrSpace(url) {
    let i = 0;
    while(i < url.length && url.charCodeAt(i) <= 0x20)i++;
    return url.slice(i);
}
function normalizeURLForProtocolCheck(url) {
    return stripLeadingC0ControlOrSpace(url).replace(httpProtocolControlCharacters, '');
}
function assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string' && malformedHttpProtocol.test(normalizeURLForProtocolCheck(url))) throw new (0, _axiosErrorJsDefault.default)('Invalid URL: missing "//" after protocol', (0, _axiosErrorJsDefault.default).ERR_INVALID_URL, config);
}
function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls, config) {
    assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, _isAbsoluteURLJsDefault.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        assertValidHttpProtocolURL(baseURL, config);
        return (0, _combineURLsJsDefault.default)(baseURL, requestedURL);
    }
    return requestedURL;
}

},{"./AxiosError.js":"jlvie","../helpers/isAbsoluteURL.js":"i62st","../helpers/combineURLs.js":"g5Dhp","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"i62st":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAbsoluteURL);
'use strict';
function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"g5Dhp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>combineURLs);
'use strict';
function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"b5guk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeConfig);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
const headersToObject = (thing)=>thing instanceof (0, _axiosHeadersJsDefault.default) ? {
        ...thing
    } : thing;
function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, _utilsJsDefault.default).isPlainObject(target) && (0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge.call({
            caseless
        }, target, source);
        else if ((0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge({}, source);
        else if ((0, _utilsJsDefault.default).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, _utilsJsDefault.default).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, _utilsJsDefault.default).isUndefined(transitional2)) {
            if ((0, _utilsJsDefault.default).isPlainObject(transitional2)) {
                if ((0, _utilsJsDefault.default).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, _utilsJsDefault.default).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, _utilsJsDefault.default).isPlainObject(transitional1) && (0, _utilsJsDefault.default).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, _utilsJsDefault.default).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, _utilsJsDefault.default).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties(headersToObject(a), headersToObject(b), prop, true)
    };
    (0, _utilsJsDefault.default).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, _utilsJsDefault.default).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, _utilsJsDefault.default).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, _utilsJsDefault.default).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, _utilsJsDefault.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, _utilsJsDefault.default).hasOwnProp(config2, 'validateStatus') && (0, _utilsJsDefault.default).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, _utilsJsDefault.default).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}

},{"../utils.js":"kanJJ","./AxiosHeaders.js":"7q3bx","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"eyYgF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFetch", ()=>getFetch);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _composeSignalsJs = require("../helpers/composeSignals.js");
var _composeSignalsJsDefault = parcelHelpers.interopDefault(_composeSignalsJs);
var _trackStreamJs = require("../helpers/trackStream.js");
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _progressEventReducerJs = require("../helpers/progressEventReducer.js");
var _resolveConfigJs = require("../helpers/resolveConfig.js");
var _resolveConfigJsDefault = parcelHelpers.interopDefault(_resolveConfigJs);
var _settleJs = require("../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
var _estimateDataURLDecodedBytesJs = require("../helpers/estimateDataURLDecodedBytes.js");
var _estimateDataURLDecodedBytesJsDefault = parcelHelpers.interopDefault(_estimateDataURLDecodedBytesJs);
var _dataJs = require("../env/data.js");
var _sanitizeHeaderValueJs = require("../helpers/sanitizeHeaderValue.js");
const DEFAULT_CHUNK_SIZE = 65536;
const { isFunction } = (0, _utilsJsDefault.default);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const decodeURIComponentSafe = (value)=>{
    if (!(0, _utilsJsDefault.default).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const factory = (env)=>{
    const globalObject = (0, _utilsJsDefault.default).global !== undefined && (0, _utilsJsDefault.default).global !== null ? (0, _utilsJsDefault.default).global : globalThis;
    const { ReadableStream, TextEncoder } = globalObject;
    env = (0, _utilsJsDefault.default).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request, Response } = env;
    const isFetchSupported = envFetch ? isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = isFunction(Request);
    const isResponseSupported = isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, _indexJsDefault.default).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && test(()=>(0, _utilsJsDefault.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, _axiosErrorJsDefault.default)(`Response type '${type}' is not supported`, (0, _axiosErrorJsDefault.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, _utilsJsDefault.default).isBlob(body)) return body.size;
        if ((0, _utilsJsDefault.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, _indexJsDefault.default).origin, {
                method: 'POST',
                body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, _utilsJsDefault.default).isArrayBufferView(body) || (0, _utilsJsDefault.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, _utilsJsDefault.default).isURLSearchParams(body)) body = body + '';
        if ((0, _utilsJsDefault.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, _utilsJsDefault.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, withCredentials = 'same-origin', fetchOptions, maxContentLength, maxBodyLength } = (0, _resolveConfigJsDefault.default)(config);
        const hasMaxContentLength = (0, _utilsJsDefault.default).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, _utilsJsDefault.default).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, _utilsJsDefault.default).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, _composeSignalsJsDefault.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, _axiosErrorJsDefault.default)('Request body larger than maxBodyLength limit', (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, _utilsJsDefault.default).getSafeProp(configAuth, 'username') || '';
                const password = (0, _utilsJsDefault.default).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username,
                    password
                };
            }
            if (maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, _indexJsDefault.default).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa(encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, _estimateDataURLDecodedBytesJsDefault.default)(url);
                if (estimated > maxContentLength) throw new (0, _axiosErrorJsDefault.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, _utilsJsDefault.default).isReadableStream(data) || (0, _utilsJsDefault.default).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, _trackStreamJs.trackStream)(stream, DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, _utilsJsDefault.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, _progressEventReducerJs.progressEventDecorator)(requestContentLength, (0, _progressEventReducerJs.progressEventReducer)((0, _progressEventReducerJs.asyncDecorator)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, _axiosErrorJsDefault.default)('Stream request bodies are not supported by the current fetch implementation', (0, _axiosErrorJsDefault.default).ERR_NOT_SUPPORT, config, request);
            if (!(0, _utilsJsDefault.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, _utilsJsDefault.default).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, _dataJs.VERSION), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, _sanitizeHeaderValueJs.toByteStringHeaderObject)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, _axiosHeadersJsDefault.default).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, _utilsJsDefault.default).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, _axiosErrorJsDefault.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, _utilsJsDefault.default).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, _progressEventReducerJs.progressEventDecorator)(responseContentLength, (0, _progressEventReducerJs.progressEventReducer)((0, _progressEventReducerJs.asyncDecorator)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, _axiosErrorJsDefault.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, _trackStreamJs.trackStream)(response.body, DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, _utilsJsDefault.default).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, _axiosErrorJsDefault.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, _settleJsDefault.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, _axiosHeadersJsDefault.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config,
                    request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, _axiosErrorJsDefault.default)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, _axiosErrorJsDefault.default)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, _axiosErrorJsDefault.default)('Network Error', (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, _axiosErrorJsDefault.default).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const seedCache = new Map();
const getFetch = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request, Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : factory(env));
        map = target;
    }
    return target;
};
const adapter = getFetch();
exports.default = adapter;

},{"../platform/index.js":"iRXUF","../utils.js":"kanJJ","../core/AxiosError.js":"jlvie","../helpers/composeSignals.js":"89T3m","../helpers/trackStream.js":"2gAgR","../core/AxiosHeaders.js":"7q3bx","../helpers/progressEventReducer.js":"bPqIz","../helpers/resolveConfig.js":"4kK8Q","../core/settle.js":"6rekF","../helpers/estimateDataURLDecodedBytes.js":"fUUtu","../env/data.js":"4Suki","../helpers/sanitizeHeaderValue.js":"fM35J","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"89T3m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
const composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, _axiosErrorJsDefault.default) ? err : new (0, _canceledErrorJsDefault.default)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, _axiosErrorJsDefault.default)(`timeout of ${timeout}ms exceeded`, (0, _axiosErrorJsDefault.default).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>signal.addEventListener('abort', onabort, {
            once: true
        }));
    const { signal } = controller;
    signal.unsubscribe = ()=>(0, _utilsJsDefault.default).asap(unsubscribe);
    return signal;
};
exports.default = composeSignals;

},{"../cancel/CanceledError.js":"5XsYG","../core/AxiosError.js":"jlvie","../utils.js":"kanJJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2gAgR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "streamChunk", ()=>streamChunk);
parcelHelpers.export(exports, "readBytes", ()=>readBytes);
parcelHelpers.export(exports, "trackStream", ()=>trackStream);
const streamChunk = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const readBytes = async function*(iterable, chunkSize) {
    for await (const chunk of readStream(iterable))yield* streamChunk(chunk, chunkSize);
};
const readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done, value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const trackStream = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = readBytes(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done, value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fUUtu":[function(require,module,exports,__globalThis) {
/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: compute the exact percent-decoded UTF-8 byte length.
 *
 * @param {string} url
 * @returns {number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>estimateDataURLDecodedBytes);
const isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const isPercentEncodedByte = (str, i, len)=>i + 2 < len && isHexDigit(str.charCodeAt(i + 1)) && isHexDigit(str.charCodeAt(i + 2));
function estimateDataURLDecodedBytes(url) {
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) {
        let effectiveLen = body.length;
        const len = body.length; // cache length
        for(let i = 0; i < len; i++)if (body.charCodeAt(i) === 37 /* '%' */  && i + 2 < len) {
            const a = body.charCodeAt(i + 1);
            const b = body.charCodeAt(i + 2);
            const isHex = isHexDigit(a) && isHexDigit(b);
            if (isHex) {
                effectiveLen -= 2;
                i += 2;
            }
        }
        let pad = 0;
        let idx = len - 1;
        const tailIsPct3D = (j)=>j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
            body.charCodeAt(j - 1) === 51 && // '3'
            (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100); // 'D' or 'd'
        if (idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) {
                pad++;
                idx--;
            } else if (tailIsPct3D(idx)) {
                pad++;
                idx -= 3;
            }
        }
        if (pad === 1 && idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) pad++;
            else if (tailIsPct3D(idx)) pad++;
        }
        const groups = Math.floor(effectiveLen / 4);
        const bytes = groups * 3 - (pad || 0);
        return bytes > 0 ? bytes : 0;
    }
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4Suki":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
const VERSION = "1.18.1";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9A4a8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataJs = require("../env/data.js");
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
'use strict';
const validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, _dataJs.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, _axiosErrorJsDefault.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, _axiosErrorJsDefault.default).ERR_DEPRECATED);
        if (version && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, _axiosErrorJsDefault.default)('options must be an object', (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, _axiosErrorJsDefault.default)('option ' + opt + ' must be ' + result, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, _axiosErrorJsDefault.default)('Unknown option ' + opt, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION);
    }
}
exports.default = {
    assertOptions,
    validators
};

},{"../env/data.js":"4Suki","../core/AxiosError.js":"jlvie","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ecj9t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("./CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, _canceledErrorJsDefault.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token,
            cancel
        };
    }
}
exports.default = CancelToken;

},{"./CanceledError.js":"5XsYG","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kDMOU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>spread);
'use strict';
function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hsk2L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAxiosError);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
function isAxiosError(payload) {
    return (0, _utilsJsDefault.default).isObject(payload) && payload.isAxiosError === true;
}

},{"../utils.js":"kanJJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8f0Mb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries(HttpStatusCode).forEach(([key, value])=>{
    HttpStatusCode[value] = key;
});
exports.default = HttpStatusCode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"eq6Mk":[function() {},{}],"bE1vX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _error = require("./error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _reactHotToast = require("react-hot-toast");
var _reactHotToastDefault = parcelHelpers.interopDefault(_reactHotToast);
var _fetch = require("../../utilities/fetch");
var _useStore = require("../hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
var _messagesScss = require("../../../scss/components/messages.scss");
const MessageUsersForm = ({ recipients, title = null, messageInit = '', onClose, onSendMessage })=>{
    const clientRef = (0, _useStoreDefault.default)((state)=>state.clientRef);
    const [message, setMessage] = (0, _react.useState)(messageInit);
    const [error, setError] = (0, _react.useState)('');
    const [fetching, setFetching] = (0, _react.useState)(false);
    const [success, setSuccess] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        setMessage(messageInit);
    }, [
        messageInit
    ]);
    const doChangeMessage = (e)=>{
        setMessage(e.target.value);
    };
    const doSendMessage = async ()=>{
        const recipientsStr = recipients.join(',');
        if (!message) return setError('Please enter a message.');
        if (!recipientsStr) return setError('No recipients selected.');
        setFetching(true);
        try {
            await (0, _fetch.request)({
                url: `/messages/${recipientsStr}?account=${clientRef}`,
                method: 'POST',
                data: {
                    message
                }
            });
            // If the request is successful, show a success message
            setSuccess(true);
            setError('');
            setFetching(false);
            if (onSendMessage) onSendMessage();
            (0, _reactHotToastDefault.default).success('Message successfully sent');
            if (onClose) setTimeout(()=>{
                onClose();
            }, 1000);
        } catch (err) {
            console.error(err);
            setFetching(false);
            if ((err === null || err === void 0 ? void 0 : err.status) === 400 || (err === null || err === void 0 ? void 0 : err.status) === 404) // Display the specific error message from the API response
            setError(err === null || err === void 0 ? void 0 : err.bodyError);
            else // Display a generic error message for other errors
            setError('An error occurred while processing your request.');
        }
    };
    const buttonClass = fetching ? 'button disabled' : 'button';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            title === null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Message selected users"
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                className: "message-users-form",
                onSubmit: (e)=>{
                    e.preventDefault();
                    doSendMessage();
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                        placeholder: "Your message",
                        value: message,
                        autoFocus: true,
                        onChange: doChangeMessage
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: buttonClass,
                        type: "button",
                        disabled: fetching,
                        onClick: doSendMessage,
                        children: fetching ? 'Sending...' : 'Send message'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                message: error,
                type: success ? 'success' : null,
                onMessageShown: ()=>{
                    setError('');
                    setSuccess('');
                }
            })
        ]
    });
};
exports.default = MessageUsersForm;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","./error":"bKeff","react-hot-toast":"jcNGA","../../utilities/fetch":"hAKRo","../hooks/useStore":"l1Yj7","../../../scss/components/messages.scss":"7a3Vi","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7a3Vi":[function() {},{}],"g6UeZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fetch = require("../utilities/fetch");
var _reactRouterDom = require("react-router-dom");
var _skeleton = require("./common/skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _notice = require("./common/notice");
var _noticeDefault = parcelHelpers.interopDefault(_notice);
var _fetchError = require("./common/fetchError");
var _fetchErrorDefault = parcelHelpers.interopDefault(_fetchError);
var _formApiEmbed = require("./common/formApiEmbed");
var _formApiEmbedDefault = parcelHelpers.interopDefault(_formApiEmbed);
var _fileLibraryLinks = require("./common/fileLibraryLinks");
var _fileLibraryLinksDefault = parcelHelpers.interopDefault(_fileLibraryLinks);
var _youTubeEmbed = require("./common/youTubeEmbed");
var _youTubeEmbedDefault = parcelHelpers.interopDefault(_youTubeEmbed);
var _contractSign = require("./common/contractSign");
var _contractSignDefault = parcelHelpers.interopDefault(_contractSign);
var _modalContent = require("./common/modalContent");
var _modalContentDefault = parcelHelpers.interopDefault(_modalContent);
var _backButton = require("./common/backButton");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
var _spinner = require("./common/spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _userFileLibrary = require("./pages/components/userFileLibrary");
var _userFileLibraryDefault = parcelHelpers.interopDefault(_userFileLibrary);
var _mainPagePDFButton = require("./mainPagePDFButton");
var _mainPagePDFButtonDefault = parcelHelpers.interopDefault(_mainPagePDFButton);
var _utilities = require("../utilities");
var _utilitiesDefault = parcelHelpers.interopDefault(_utilities);
var _useParseContent = require("./hooks/useParseContent");
var _useParseContentDefault = parcelHelpers.interopDefault(_useParseContent);
var _useFetchPages = require("./hooks/fetch/useFetchPages");
var _useStore = require("./hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
var _useCustomNavigate = require("./hooks/useCustomNavigate");
var _useCustomNavigateDefault = parcelHelpers.interopDefault(_useCustomNavigate);
require("22833c5f9571c6df");
const MainPageContent = ({ articleId, userId, isModal, training = false, onClose })=>{
    var _data_content__image, _data_content_, _data_content__image1, _data_content_1, _content_map;
    const { pageSlug: reqPageSlug } = (0, _reactRouterDom.useParams)();
    const navigate = (0, _useCustomNavigateDefault.default)();
    const articleSlugOrId = articleId || reqPageSlug;
    const [pageSlug, setPageSlug] = (0, _react.useState)(articleSlugOrId);
    const [isContractSigned, setIsContractSigned] = (0, _react.useState)(false);
    const [isContractSubmitting, setIsContractSubmitting] = (0, _react.useState)(false);
    const setPageTitle = (0, _useStoreDefault.default)((state)=>state.setPageTitle);
    const { data, isLoading, error, isError } = (0, _useFetchPages.useFetchArticle)({
        slug: pageSlug,
        callback: ()=>{
            (0, _utilitiesDefault.default).interceptAnchorLinks(".main-content--scrollbox");
        }
    });
    (0, _react.useEffect)(()=>{
        data && setPageTitle(data === null || data === void 0 ? void 0 : data.description);
    }, [
        data
    ]);
    (0, _react.useEffect)(()=>{
        // custom scrollbar on content area
        if (!isModal) {
            require("5409ce5d63544b59");
            setPageSlug(articleSlugOrId);
        }
    }, [
        articleSlugOrId
    ]);
    const imageUrl = (data === null || data === void 0 ? void 0 : data.content) && (data === null || data === void 0 ? void 0 : (_data_content_ = data.content[0]) === null || _data_content_ === void 0 ? void 0 : (_data_content__image = _data_content_.image) === null || _data_content__image === void 0 ? void 0 : _data_content__image.imageUrl);
    const preventCrop = (data === null || data === void 0 ? void 0 : data.content) && !!(data === null || data === void 0 ? void 0 : (_data_content_1 = data.content[0]) === null || _data_content_1 === void 0 ? void 0 : (_data_content__image1 = _data_content_1.image) === null || _data_content__image1 === void 0 ? void 0 : _data_content__image1.preventCrop);
    const button = (data === null || data === void 0 ? void 0 : data.content) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mainPagePDFButtonDefault.default), {}) : "";
    const headingClass = data && !isLoading ? "main-content--heading" : "main-content--heading h1__skeleton";
    const content = (0, _useParseContentDefault.default)(data === null || data === void 0 ? void 0 : data.content, userId);
    const allContentStr = content === null || content === void 0 ? void 0 : (_content_map = content.map((section)=>{
        return section.content;
    })) === null || _content_map === void 0 ? void 0 : _content_map.join(" ");
    const hasMissingSubstitutions = (allContentStr === null || allContentStr === void 0 ? void 0 : allContentStr.includes("class='text-missing'")) || (allContentStr === null || allContentStr === void 0 ? void 0 : allContentStr.includes('class="text-missing"'));
    const doSignContract = async ()=>{
        setIsContractSubmitting(true);
        try {
            await (0, _fetch.request)({
                url: `/scripts/sign-document/${data === null || data === void 0 ? void 0 : data.id}`
            });
            setIsContractSigned(true);
            setIsContractSubmitting(false);
        } catch (err) {
            setIsContractSigned(true);
            setIsContractSubmitting(false);
        }
    };
    const hasForms = content === null || content === void 0 ? void 0 : content.some((section)=>(section === null || section === void 0 ? void 0 : section.contentType) === "form");
    const signedMessage = (data === null || data === void 0 ? void 0 : data.signed) ? `You signed this document on ${(0, _utilitiesDefault.default).getFormattedDateTime(data.signed)}` : "Thank you for signing this document.";
    const missingInfoMessage = "This document cannot be signed as your profile is currently missing some information (highlighted)";
    const isBusy = !!isLoading;
    const pageTitle = training ? "Training videos" : data === null || data === void 0 ? void 0 : data.description;
    const subTitle = training ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex flex__middle",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: data === null || data === void 0 ? void 0 : data.description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                label: "Back to videos",
                onClick: ()=>navigate("/training")
            })
        ]
    }) : null;
    // disable contract signing if viewing as modal
    if (isModal && data) data.isContract = false;
    const articleContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "main-content--content-column",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: headingClass,
                        children: !isLoading && !isError && (data || isError) ? pageTitle : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                            lines: "1"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "main-content--scrollbox",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "main-content--content-container",
                            "data-simplebar": !!!isModal,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "main-content--content-content",
                                children: [
                                    subTitle,
                                    !isLoading && !isError && content ? content.map((section, key)=>{
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                                            children: [
                                                (section === null || section === void 0 ? void 0 : section.contentType) !== "form" && (section === null || section === void 0 ? void 0 : section.contentType) !== "youtube" && (section === null || section === void 0 ? void 0 : section.contentType) !== "filesFolder" && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: section.content
                                                    },
                                                    className: "main-content--content-section"
                                                }, key),
                                                (section === null || section === void 0 ? void 0 : section.contentType) === "youtube" && (section === null || section === void 0 ? void 0 : section.youtubeUrl) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "main-content--content-section",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _youTubeEmbedDefault.default), {
                                                        url: section === null || section === void 0 ? void 0 : section.youtubeUrl
                                                    })
                                                }, key),
                                                (section === null || section === void 0 ? void 0 : section.contentType) === "filesFolder" && (section === null || section === void 0 ? void 0 : section.filesFolderId) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "main-content--content-section",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fileLibraryLinksDefault.default), {
                                                        id: section === null || section === void 0 ? void 0 : section.filesFolderId
                                                    })
                                                }, key),
                                                (section === null || section === void 0 ? void 0 : section.contentType) === "form" && (!(data === null || data === void 0 ? void 0 : data.isContract) || !(data === null || data === void 0 ? void 0 : data.signed)) && (section === null || section === void 0 ? void 0 : section.formId) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "main-content--content-section",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formApiEmbedDefault.default), {
                                                        id: section === null || section === void 0 ? void 0 : section.formId,
                                                        articleId: data === null || data === void 0 ? void 0 : data.id,
                                                        isContract: data === null || data === void 0 ? void 0 : data.isContract,
                                                        disabled: isModal,
                                                        contractSigned: (data === null || data === void 0 ? void 0 : data.signed) || hasMissingSubstitutions,
                                                        onSignContract: doSignContract
                                                    })
                                                }, key)
                                            ]
                                        }, key);
                                    }) : !isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                                        lines: "50",
                                        contain: true
                                    }),
                                    isContractSubmitting && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
                                    !isLoading && !isError && (data === null || data === void 0 ? void 0 : data.isContract) && ((data === null || data === void 0 ? void 0 : data.signed) || isContractSigned) && !isContractSubmitting && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noticeDefault.default), {
                                        type: "info",
                                        message: signedMessage
                                    }),
                                    (!hasForms || hasMissingSubstitutions) && (data === null || data === void 0 ? void 0 : data.isContract) && !(data === null || data === void 0 ? void 0 : data.signed) && !isContractSubmitting && !isContractSigned && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                        children: hasMissingSubstitutions ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noticeDefault.default), {
                                            type: "alert",
                                            message: missingInfoMessage
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contractSignDefault.default), {
                                            disabled: isBusy,
                                            onSubmit: doSignContract
                                        })
                                    }),
                                    (data === null || data === void 0 ? void 0 : data.userFileLibraryEnabled) && (data === null || data === void 0 ? void 0 : data.userFileLibrarySlug) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userFileLibraryDefault.default), {
                                            title: "Documents",
                                            helpText: "Select a document to open/download",
                                            slug: data === null || data === void 0 ? void 0 : data.userFileLibrarySlug,
                                            readOnly: true,
                                            hasFolders: false
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            !isError && imageUrl && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "main-content--image-column",
                children: !isLoading && !isError && imageUrl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: imageUrl,
                        srcSet: `${imageUrl}?size=tiny 50w,
                          ${imageUrl}?size=small 200w,
                          ${imageUrl}?size=medium 500w,
                          ${imageUrl}?size=large 1000w,
                          ${imageUrl}?size=full 2000w`,
                        sizes: "(max-width: 1300px) 92vw, (min-width: 1300px) 21vw",
                        alt: "",
                        className: "main-content--image",
                        "data-no-crop": preventCrop
                    })
                }) : isLoading && !isError && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                    image: true,
                    className: "main-content--image",
                    height: "20rem"
                })
            })
        ]
    });
    if (isModal) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalContentDefault.default), {
        type: "content",
        content: articleContent,
        isWide: true,
        onClose: onClose
    });
    const errorStatus = (error === null || error === void 0 ? void 0 : error.status) ? error.status : null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: imageUrl ? "main-content" : "main-content main-content__no-image",
        children: [
            errorStatus === 204 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noticeDefault.default), {
                message: "This page is currently under construction"
            }),
            errorStatus === 404 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fetchErrorDefault.default), {
                error: "Page not found",
                status: 404
            }),
            errorStatus && errorStatus !== 404 && errorStatus !== 204 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fetchErrorDefault.default), {
                error: error === null || error === void 0 ? void 0 : error.message,
                status: error === null || error === void 0 ? void 0 : error.status
            }),
            !isError && !errorStatus && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: articleContent
            }),
            !isLoading && !isError && !errorStatus && !(data === null || data === void 0 ? void 0 : data.underConstruction) && button
        ]
    });
};
exports.default = MainPageContent;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","../utilities/fetch":"hAKRo","react-router-dom":"4I6p1","./common/skeleton":"fLZ02","./common/notice":"bnY7j","./common/fetchError":"hJdxM","./common/formApiEmbed":"bHaM0","./common/fileLibraryLinks":"hL6QE","./common/youTubeEmbed":"g1aeh","./common/contractSign":"kmXGR","./common/modalContent":"kCwqK","./common/backButton":"9eXgB","./common/spinner":"lRuRG","./pages/components/userFileLibrary":"vk65v","./mainPagePDFButton":"iHhLW","../utilities":"fkdv9","./hooks/useParseContent":"b4Ak7","./hooks/fetch/useFetchPages":"gzbN3","./hooks/useStore":"l1Yj7","./hooks/useCustomNavigate":"5zfEN","22833c5f9571c6df":"aYo5H","5409ce5d63544b59":"k2xEc","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fLZ02":[function(require,module,exports,__globalThis) {
// Import React and the skeleton SCSS file
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
require("d4b2911eeab4174");
const Skeleton = ({ lines, image, type, className, contain = false, height = null, fixedWidth = false })=>{
    // Determine the class name for the skeleton image
    const imageClassName = className ? `skeleton-image ${className}` : "skeleton-image";
    // Determine the number of rows to render
    const rows = lines || 1;
    // Render a calendar skeleton if the type is "calendar"
    if (type === "calendar") {
        let cells = [];
        for(let r = 0; r < 42; r++)cells.push("");
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "skeleton-calendar",
            children: cells.map((cell, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}, index))
        });
    }
    // Render a grid skeleton if the type is "grid"
    if (type === "grid") {
        let cells = [];
        for(let r = 0; r < rows; r++)cells.push("");
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "skeleton-grid",
            children: cells.map((cell, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {})
                    ]
                }, index))
        });
    }
    if (type === "cover") return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "skeleton-cover",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "skeleton-line"
        })
    });
    // Render a messages skeleton if the type is "messages"
    if (type === "messages") {
        let cells = [];
        for(let r = 0; r < 5; r++)cells.push("");
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "skeleton-messages",
            children: cells.map((cell, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "skeleton-line"
                }, index))
        });
    }
    if (type === "files-thumbs") {
        let cells = [];
        for(let t = 0; t < 10; t++)cells.push("");
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "skeleton-files-thumbs",
            children: cells.map((cell, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}, index))
        });
    }
    if (type === "form-cols") return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "skeleton-form-cols",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {})
        ]
    });
    // Render an image skeleton if image is true
    if (image) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        className: imageClassName,
        style: height && {
            height: height
        },
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
    });
    // Render a skeleton without containing if contain is false
    if (!contain) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonRows, {
        rows: rows,
        fixedWidth: fixedWidth
    });
    // Render a contained skeleton
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "skeleton",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonRows, {
            rows: rows,
            fixedWidth: fixedWidth
        })
    });
};
const SkeletonRows = ({ rows, fixedWidth })=>{
    const output = [];
    const min = 95; // minimum width for skeleton line
    const max = 100; // maximum width for skeleton line
    for(let row = 1; row <= rows; row++){
        // generate random width for each skeleton line
        const randomWidthLarge = Math.floor(Math.random() * (max - min + 1) + min);
        const randomWidthSmall = Math.floor(Math.random() * 31 + 20);
        const thisWidth = rows === 1 // if there's only one row, set width to 100%
         ? 100 : row % 10 === 0 // every 10th row, set a small width
         ? randomWidthSmall : randomWidthLarge; // otherwise, set a large random width
        const thisStyle = fixedWidth ? {
            width: "100%"
        } // if fixedWidth prop is true, set width to 100%
         : {
            width: `calc(${thisWidth}% - 2rem)`
        };
        // set appropriate className based on row number
        const className = row % 10 === 0 ? "skeleton-line skeleton-line__end-paragraph" : "skeleton-line";
        output.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: className,
            style: thisStyle
        }, row));
    }
    return output; // return an array of divs to render
};
exports.default = Skeleton;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","d4b2911eeab4174":"bYSQs","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"bYSQs":[function(require,module,exports,__globalThis) {
module.exports = require("1f46ce124f48a7ee")(module.bundle.resolve("bOsTI"));

},{"1f46ce124f48a7ee":"efVvj"}],"bnY7j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _submitButton = require("./submitButton");
var _submitButtonDefault = parcelHelpers.interopDefault(_submitButton);
var _akarIcons = require("akar-icons");
const Notice = ({ type = "alert", message, buttonLabel = "Submit", onClick })=>{
    let icon;
    let className = "notice";
    switch(type){
        case "success":
            icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.Check), {
                width: "50",
                height: "50"
            });
            break;
        case "info":
            icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.Info), {
                width: "50",
                height: "50"
            });
            className = "notice notice__invert";
            break;
        case "alert":
            icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.CircleAlert), {
                width: "50",
                height: "50"
            });
            break;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: className,
        children: [
            icon,
            message,
            onClick && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _submitButtonDefault.default), {
                label: buttonLabel,
                onSubmit: onClick
            })
        ]
    });
};
exports.default = Notice;

},{"react/jsx-runtime":"i3K7E","./submitButton":"4bi2T","akar-icons":"b8xdj","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hJdxM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _svg = require("./svg");
var _svgDefault = parcelHelpers.interopDefault(_svg);
const FetchError = (props)=>{
    const { error, status } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "fetch-error",
        children: [
            status && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "fetch-error--status",
                children: [
                    "Error ",
                    status
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgDefault.default), {
                src: "fetchError",
                className: "fetch-error--image",
                label: error
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "fetch-error--error",
                children: error
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "fetch-error--contact-us",
                children: [
                    "If you're experiencing problems, please feel free to",
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        href: "#",
                        children: "contact us"
                    }),
                    " and we'll look into the issue for you"
                ]
            })
        ]
    });
};
exports.default = FetchError;

},{"react/jsx-runtime":"i3K7E","./svg":"4pImm","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"bHaM0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _fetchJs = require("../../utilities/fetch.js");
var _utilitiesJs = require("../../utilities.js");
var _utilitiesJsDefault = parcelHelpers.interopDefault(_utilitiesJs);
var _reactHotToast = require("react-hot-toast");
var _reactHotToastDefault = parcelHelpers.interopDefault(_reactHotToast);
var _form = require("./form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _submitButton = require("./submitButton");
var _submitButtonDefault = parcelHelpers.interopDefault(_submitButton);
var _contractSign = require("./contractSign");
var _contractSignDefault = parcelHelpers.interopDefault(_contractSign);
var _notice = require("./notice");
var _noticeDefault = parcelHelpers.interopDefault(_notice);
var _useFetchForms = require("../hooks/fetch/useFetchForms");
var _useFetchUsers = require("../hooks/fetch/useFetchUsers");
var _useStore = require("../hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
const ApiForm = ({ id, disabled, hideSubmit = false, isContract = false, contractSigned = null, onSignContract })=>{
    var _users_map;
    const currentUser = (0, _useStoreDefault.default)((state)=>state.currentUser);
    const clientRef = (0, _useStoreDefault.default)((state)=>state.clientRef);
    const [formFields, setFormFields] = (0, _react.useState)();
    const [submitting, setSubmitting] = (0, _react.useState)(false);
    const [submitted, setSubmitted] = (0, _react.useState)(false);
    const [hasPaging, setHasPaging] = (0, _react.useState)(false);
    const { data: form, isLoading } = (0, _useFetchForms.useFetchForm)({
        account: clientRef,
        formId: id
    });
    const { data: users, isLoading: isUsersLoading } = (0, _useFetchUsers.useFetchUsersBasic)({
        account: clientRef
    });
    const usersSelect = users === null || users === void 0 ? void 0 : (_users_map = users.map((option)=>{
        return {
            value: option.id,
            label: option.fullName
        };
    })) === null || _users_map === void 0 ? void 0 : _users_map.filter((option)=>{
        return !!option.value && !!option.label;
    });
    const getMappedField = (mapToField)=>{
        if (!mapToField) return null;
        return (0, _utilitiesJsDefault.default).getNested(currentUser, mapToField);
    };
    (0, _react.useEffect)(()=>{
        if (form === null || form === void 0 ? void 0 : form.formId) {
            var _form_fields;
            const data = form === null || form === void 0 ? void 0 : (_form_fields = form.fields) === null || _form_fields === void 0 ? void 0 : _form_fields.map((field)=>{
                if (field.type === "page") setHasPaging(true);
                return {
                    items: [
                        {
                            type: field.type,
                            required: field.required,
                            label: field.label,
                            name: field.fieldId,
                            caption: field.caption,
                            options: field.options,
                            default: getMappedField(field.mapToField)
                        }
                    ]
                };
            });
            if ((data === null || data === void 0 ? void 0 : data.length) > 0 && (form === null || form === void 0 ? void 0 : form.allowProxySubmit) && ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.isManager) || (currentUser === null || currentUser === void 0 ? void 0 : currentUser.isHR))) data.unshift({
                items: [
                    {
                        type: "select",
                        name: "userId",
                        label: "Submit on behalf of user",
                        options: usersSelect
                    }
                ]
            });
            if (!formFields || JSON.stringify(data) !== JSON.stringify(formFields)) setFormFields(data);
        }
    }, [
        form === null || form === void 0 ? void 0 : form.formId,
        users
    ]);
    // store callback for React hook form validation / submission
    // so we can submit form from parent
    const formSubmitCallbackRef = (0, _react.useRef)();
    function submitCallback(callback) {
        formSubmitCallbackRef.current = callback;
    }
    const doSubmit = async (data)=>{
        setSubmitting(true);
        const formData = new FormData();
        for (const [key, field] of Object.entries(data))if (key !== "id") {
            var _form_fields;
            // get form field
            const formField = form === null || form === void 0 ? void 0 : (_form_fields = form.fields) === null || _form_fields === void 0 ? void 0 : _form_fields.find((f)=>f.fieldId === key);
            if (field instanceof FileList) // Handle file uploads separately
            Array.from(field).forEach((file, index)=>{
                formData.append(`${key}_${index}`, file);
            });
            else if ((formField === null || formField === void 0 ? void 0 : formField.type) === "multiCheckbox") {
                let value = "";
                field.forEach((item, _index)=>{
                    var _item_label;
                    value += ((_item_label = item === null || item === void 0 ? void 0 : item.label) !== null && _item_label !== void 0 ? _item_label : item) + ", ";
                });
                value = value.slice(0, -2);
                console.log("value", value);
                formData.append(key, value);
            } else formData.append(key, (field === null || field === void 0 ? void 0 : field.value) || field);
        }
        try {
            const result = await (0, _fetchJs.request)({
                url: `/submissions/${form === null || form === void 0 ? void 0 : form.formId}`,
                data: formData,
                method: "POST",
                params: {
                    account: clientRef
                }
            });
            if (result.status === 200) {
                setSubmitted(true);
                if (isContract && onSignContract) onSignContract();
            }
        } catch (err) {
            if (err === null || err === void 0 ? void 0 : err.toasterMessage) (0, _reactHotToastDefault.default).error(`${err.toasterMessage}`);
        }
        setSubmitting(false);
    };
    const busy = !!(isLoading || isUsersLoading);
    const skeleton = !!isLoading;
    if (submitted) return !isContract ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noticeDefault.default), {
        type: "success",
        message: "Thank you - your form submission has been received"
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formDefault.default), {
                id: id,
                sections: formFields,
                autoFocus: false,
                ignorePaging: false,
                disabled: busy || submitting || disabled,
                registerCallback: submitCallback,
                onSubmit: doSubmit
            }),
            !hideSubmit && (isContract || !hasPaging) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form-submit-container",
                children: [
                    !isContract && !disabled && !hasPaging && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _submitButtonDefault.default), {
                        label: submitting ? "Submitting..." : "Submit form",
                        disabled: busy || submitting,
                        onSubmit: ()=>formSubmitCallbackRef.current()
                    }),
                    isContract && !contractSigned && !disabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contractSignDefault.default), {
                        disabled: busy || submitting,
                        onSubmit: ()=>formSubmitCallbackRef.current()
                    })
                ]
            })
        ]
    });
};
exports.default = ApiForm;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","../../utilities/fetch.js":"hAKRo","../../utilities.js":"fkdv9","react-hot-toast":"jcNGA","./form":"dUWg9","./submitButton":"4bi2T","./contractSign":"kmXGR","./notice":"bnY7j","../hooks/fetch/useFetchForms":"fXBsb","../hooks/fetch/useFetchUsers":"4DurT","../hooks/useStore":"l1Yj7","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"dUWg9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _akarIcons = require("akar-icons");
var _objectInspect = require("object-inspect");
var _objectInspectDefault = parcelHelpers.interopDefault(_objectInspect);
var _submitButton = require("./submitButton");
var _submitButtonDefault = parcelHelpers.interopDefault(_submitButton);
var _formError = require("./formError");
var _formErrorDefault = parcelHelpers.interopDefault(_formError);
var _skeleton = require("./skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _notice = require("./notice");
var _noticeDefault = parcelHelpers.interopDefault(_notice);
var _formInput = require("./formInput");
var _formInputDefault = parcelHelpers.interopDefault(_formInput);
var _editableText = require("./editableText");
var _editableTextDefault = parcelHelpers.interopDefault(_editableText);
var _formEditIcons = require("../pages/components/formEditIcons");
var _formEditIconsDefault = parcelHelpers.interopDefault(_formEditIcons);
var _icon = require("../common/icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _svg = require("./svg");
var _svgDefault = parcelHelpers.interopDefault(_svg);
var _useFetchForms = require("../hooks/fetch/useFetchForms");
var _useInterval = require("../hooks/useInterval");
var _useIntervalDefault = parcelHelpers.interopDefault(_useInterval);
var _useStore = require("../hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
var _useFocusComponent = require("../hooks/useFocusComponent");
var _useFocusComponentDefault = parcelHelpers.interopDefault(_useFocusComponent);
const scrollToTop = ()=>{
    setTimeout(()=>{
        const elementsToScroll = document.querySelectorAll(".main-container, .main-body-scrollable, .app-container, .main-content--scrollbox, .simplebar-content-wrapper");
        elementsToScroll.forEach((element)=>{
            element === null || element === void 0 ? void 0 : element.scrollTo(0, 0);
        });
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, 100);
};
const Form = ({ sections: sectionsInit, readOnlyFields, hideFields, id, notice, className, autoFocus = true, disabled = false, edit = false, busy = false, loading = false, registerCallback, registerFormRef, dependencies = null, clickToEdit = false, ignorePaging = true, modalMessage = null, actionButtons, actionButtonsHeading, warnUnsavedChanges = false, onSubmit, onBusy = null, onCompleted = null, onChangePage = null })=>{
    const isMountedRef = (0, _react.useRef)(true);
    const timeoutIdsRef = (0, _react.useRef)([]);
    const scheduleTimeout = (callback, delay = 0)=>{
        const timeoutId = setTimeout(()=>{
            timeoutIdsRef.current = timeoutIdsRef.current.filter((id)=>id !== timeoutId);
            if (!isMountedRef.current) return;
            callback();
        }, delay);
        timeoutIdsRef.current.push(timeoutId);
        return timeoutId;
    };
    // paging, for forms with field of type 'page' (page divider)
    const pages = [];
    if (Array.isArray(sectionsInit) && !ignorePaging) {
        let currentPage = [];
        sectionsInit.map((section)=>{
            var _section_items_, _section_items;
            if ((section === null || section === void 0 ? void 0 : (_section_items = section.items) === null || _section_items === void 0 ? void 0 : (_section_items_ = _section_items[0]) === null || _section_items_ === void 0 ? void 0 : _section_items_.type) !== "page") currentPage.push(section);
            else {
                pages.push(currentPage);
                currentPage = [];
            }
        });
        if (currentPage.length > 0) pages.push(currentPage);
    }
    if (ignorePaging) pages.push(sectionsInit);
    sectionsInit = pages[0];
    const hasPaging = !!!ignorePaging && !!(pages.length > 1);
    const [formPage, setFormPage] = (0, _react.useState)(0);
    const [sections, setSections] = (0, _react.useState)(sectionsInit);
    const hasUnsavedChanges = (0, _useStoreDefault.default)((state)=>state.hasUnsavedChanges);
    const setHasUnsavedChanges = (0, _useStoreDefault.default)((state)=>state.setHasUnsavedChanges);
    const hasJustSaved = (0, _useStoreDefault.default)((state)=>state.hasJustSaved);
    const setHasJustSaved = (0, _useStoreDefault.default)((state)=>state.setHasJustSaved);
    const pathParts = (0, _useStoreDefault.default)((state)=>state.getPathParts());
    const currentUser = (0, _useStoreDefault.default)((state)=>state.currentUser);
    const [isSubmitting, setIsSubmitting] = (0, _react.useState)(false);
    const adminEditingAccount = pathParts[0];
    const { isHR } = currentUser;
    (0, _react.useEffect)(()=>{
        setSections(pages[formPage] || sectionsInit);
    }, [
        formPage
    ]);
    (0, _react.useEffect)(()=>{
        setFormPage(0);
    }, [
        id
    ]);
    const { mutate: createField, isLoading: isCreating } = (0, _useFetchForms.useCreateFormField)({
        account: adminEditingAccount
    });
    const { ref: focusedRef, setFocused } = (0, _useFocusComponentDefault.default)(()=>{
        setCurrentEditName();
    });
    const reactHookForm = (0, _reactHookForm.useForm)({
        mode: "onBlur"
    });
    const initialValuesJSON = (0, _react.useRef)();
    // force re-render of react-select when data changes
    const [inputReRenderTrigger, setInputRerenderTrigger] = (0, _react.useState)(Math.random);
    const [formItems, setFormItems] = (0, _react.useState)();
    const [currentEditName, setCurrentEditName] = (0, _react.useState)();
    const [hiddenFields, setHiddenFields] = (0, _react.useState)([]);
    const [disabledFields, setDisabledFields] = (0, _react.useState)([]);
    const [visibleOptions, setVisibleOptions] = (0, _react.useState)([]);
    (0, _react.useEffect)(()=>{
        if (!registerCallback) return;
        let active = true;
        registerCallback((_e, mutateData)=>{
            if (!active || !isMountedRef.current) return;
            // When submitting via callback ref, merge in any additional mutate data.
            mutateData = mutateData || {};
            return reactHookForm.handleSubmit((data)=>{
                if (!active || !isMountedRef.current) return;
                const formValues = {
                    ...data,
                    ...mutateData
                };
                setCurrentEditName();
                onSubmit(formValues);
            })();
        });
        return ()=>{
            active = false;
        };
    }, [
        registerCallback,
        reactHookForm,
        onSubmit
    ]);
    (0, _react.useEffect)(()=>{
        if (!registerFormRef) return;
        registerFormRef(reactHookForm);
    }, [
        registerFormRef,
        reactHookForm
    ]);
    (0, _react.useEffect)(()=>{
        if (!(hasJustSaved && !disabled)) return;
        setHasUnsavedChanges(false);
        setHasJustSaved(false);
        initialValuesJSON.current = (0, _objectInspectDefault.default)(reactHookForm.getValues());
    }, [
        hasJustSaved,
        disabled,
        reactHookForm,
        setHasUnsavedChanges,
        setHasJustSaved
    ]);
    const currentHiddenFieldsRef = (0, _react.useRef)(hiddenFields);
    (0, _react.useEffect)(()=>{
        currentHiddenFieldsRef.current = hiddenFields;
    }, [
        hiddenFields
    ]);
    const doTriggerReRender = ()=>{
        setInputRerenderTrigger(Math.random);
    };
    const doCheckFormHasChanged = ()=>{
        if (!warnUnsavedChanges || disabled) return;
        const current = (0, _objectInspectDefault.default)(reactHookForm.getValues());
        const initial = initialValuesJSON.current;
        if (initial) {
            if (current !== initial && !hasUnsavedChanges) return setHasUnsavedChanges(true);
            if (current === initial && hasUnsavedChanges) return setHasUnsavedChanges(false);
        }
    };
    (0, _useIntervalDefault.default)(doCheckFormHasChanged, 1000);
    const doInitialiseForm = (newSections)=>{
        const currentFormItems = [];
        let formSections = newSections || sections;
        if (newSections) setSections(newSections);
        if (!disabled) setHasUnsavedChanges(false);
        initialValuesJSON.current = null;
        setInputRerenderTrigger(Math.random);
        reactHookForm.reset();
        scheduleTimeout(()=>{
            initialValuesJSON.current = (0, _objectInspectDefault.default)(reactHookForm.getValues());
        }, 100);
        formSections === null || formSections === void 0 ? void 0 : formSections.map((section)=>{
            var _section_items_filter, _section_items;
            (_section_items = section.items) === null || _section_items === void 0 ? void 0 : (_section_items_filter = _section_items.filter((item)=>{
                if (!hideFields || !hideFields.includes(item.name)) return true;
            })) === null || _section_items_filter === void 0 ? void 0 : _section_items_filter.map((item)=>{
                let defaultValue = typeof item.default === "undefined" ? item.value : item.default;
                if (item.type === "icon") {
                    reactHookForm.setValue(item.name, item.value);
                    currentFormItems.push({
                        ...item
                    });
                } else if (item.type === "number") {
                    const value = parseFloat(defaultValue);
                    reactHookForm.setValue(item.name, value);
                    item.value = value;
                    currentFormItems.push({
                        ...item
                    });
                } else if (item.type === "select") {
                    const options = Array.isArray(item === null || item === void 0 ? void 0 : item.options) && item.options.map((option)=>{
                        if (typeof option === "string") return {
                            value: option,
                            label: option
                        };
                        return option && Object.prototype.hasOwnProperty.call(option, "value") && option;
                    }) || [];
                    const parseValue = (value)=>{
                        if (Array.isArray(value)) return value.map((value)=>{
                            if (typeof value === "string" || typeof value === "number") return (options === null || options === void 0 ? void 0 : options.find((option)=>option.value == value)) || options[0];
                            return value;
                        });
                        if (typeof value === "string") return (options === null || options === void 0 ? void 0 : options.find((option)=>option.value == value || option.label == value)) || value;
                        if (typeof value === "number") return (options === null || options === void 0 ? void 0 : options.find((option)=>option.value == value)) || value;
                        return value;
                    };
                    defaultValue = defaultValue !== undefined && defaultValue !== null ? parseValue(defaultValue) : null;
                    if (!reactHookForm.getValues(item.name)) reactHookForm.setValue(item.name, defaultValue);
                    currentFormItems.push({
                        ...item,
                        value: defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.label
                    });
                } else if (item.type === "multiCheckbox") {
                    if (defaultValue) reactHookForm.setValue(item.name, defaultValue);
                    else reactHookForm.setValue(item.name, []);
                    currentFormItems.push({
                        ...item
                    });
                } else if (item.type === "payReview") {
                    if (item.default !== undefined && item.default !== null && typeof item.default === "object") reactHookForm.setValue(item.name, null);
                    else if (item.value !== undefined && item.value !== null && typeof item.value === "object") reactHookForm.setValue(item.name, null);
                    currentFormItems.push({
                        ...item
                    });
                } else {
                    if (item.default !== undefined && item.default !== null) reactHookForm.setValue(item.name, item.default);
                    else if (item.value !== undefined && item.value !== null) reactHookForm.setValue(item.name, item.value);
                    currentFormItems.push({
                        ...item
                    });
                }
            });
        });
        setFormItems(currentFormItems);
        scheduleTimeout(()=>{
            doOptionToggle(false);
        }, 0);
    };
    // When using click to edit, pressing enter should run doSubmit, which advances
    // to the next field
    const doOnKeyDown = (e)=>{
        if (!clickToEdit) return;
        const { key, target } = e;
        // is escape key pressed
        if (key === "Escape") // stop editing
        return setCurrentEditName();
        // Check if an input or textarea is focused
        if ([
            "INPUT",
            "TEXTAREA"
        ].includes(target.tagName)) return;
        if (key === "Enter" || key === "Tab") doSubmit();
    };
    (0, _react.useEffect)(()=>{
        doInitialiseForm();
    }, [
        id
    ]);
    (0, _react.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
            timeoutIdsRef.current.forEach((timeoutId)=>clearTimeout(timeoutId));
            timeoutIdsRef.current = [];
        };
    }, []);
    (0, _react.useEffect)(()=>{
        // Remove keydown event listener if the component is unmounted
        return ()=>{
            if (isMountedRef.current) document.body.removeEventListener("keydown", doOnKeyDown);
        };
    }, []);
    (0, _react.useEffect)(()=>{
        if (currentEditName) document.body.addEventListener("keydown", doOnKeyDown);
        return ()=>{
            document.body.removeEventListener("keydown", doOnKeyDown);
        };
    }, [
        currentEditName
    ]);
    (0, _react.useEffect)(()=>{
        doInitialiseForm(sectionsInit);
    }, [
        (0, _objectInspectDefault.default)(sectionsInit)
    ]);
    const validation = (type)=>{
        if (type && typeof type === "function") {
            const getValues = reactHookForm.getValues;
            return {
                validate: {
                    custom: (value)=>{
                        return type(value, getValues);
                    }
                }
            };
        }
        switch(type){
            case "password":
                return {
                    minLength: {
                        value: 8,
                        message: "Password must have at least 8 characters"
                    },
                    validate: {
                        hasLower: (value)=>value.match(/^$|[a-z]+/) ? true : false,
                        hasUpper: (value)=>value.match(/^$|[A-Z]+/) ? true : false,
                        hasNumber: (value)=>value.match(/^$|[0-9]+/) ? true : false,
                        hasSymbol: (value)=>value.match(/^$|[^a-zA-Z0-9]+/) ? true : false
                    }
                };
            case "url":
                return {
                    validate: {
                        isURL: (value)=>{
                            const isValidURL = /^(http:\/\/|https:\/\/)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}(:[0-9]{1,5})?(\/.*)?$/.test(value);
                            return !value || isValidURL || "Invalid URL. It should start with http:// or https://";
                        }
                    }
                };
            case "richtext":
                return {
                    validate: {
                        isContent: (value)=>{
                            const parsedContent = value === null || value === void 0 ? void 0 : value.replace(/<[^>]*>|&nbsp;|\s/g, "");
                            const isEmpty = !parsedContent || parsedContent === "";
                            return !isEmpty || "Please enter a message";
                        }
                    }
                };
            default:
                return null;
        }
    };
    const formatLineBreaks = (text)=>{
        if (text) return text.split("\n").map((item, key)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                children: [
                    item,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                ]
            }, key);
        });
        return null;
    };
    const getError = (field)=>{
        var _reactHookForm_formState_errors_field, _reactHookForm_formState_errors_field1, _reactHookForm_formState_errors_field2, _reactHookForm_formState_errors_field3, _reactHookForm_formState_errors_field4;
        if (((_reactHookForm_formState_errors_field = reactHookForm.formState.errors[field]) === null || _reactHookForm_formState_errors_field === void 0 ? void 0 : _reactHookForm_formState_errors_field.type) === "hasLower") return "Password must have at least 1 lowercase character (a-z)";
        if (((_reactHookForm_formState_errors_field1 = reactHookForm.formState.errors[field]) === null || _reactHookForm_formState_errors_field1 === void 0 ? void 0 : _reactHookForm_formState_errors_field1.type) === "hasUpper") return "Password must have at least 1 uppercase character (A-Z)";
        if (((_reactHookForm_formState_errors_field2 = reactHookForm.formState.errors[field]) === null || _reactHookForm_formState_errors_field2 === void 0 ? void 0 : _reactHookForm_formState_errors_field2.type) === "hasNumber") return "Password must have at least 1 number (0-9)";
        if (((_reactHookForm_formState_errors_field3 = reactHookForm.formState.errors[field]) === null || _reactHookForm_formState_errors_field3 === void 0 ? void 0 : _reactHookForm_formState_errors_field3.type) === "hasSymbol") return "Password must have at least 1 symbol (e.g. punctuation)";
        return (_reactHookForm_formState_errors_field4 = reactHookForm.formState.errors[field]) === null || _reactHookForm_formState_errors_field4 === void 0 ? void 0 : _reactHookForm_formState_errors_field4.message;
    };
    const loadingArr = [];
    for(let r = 0; r < 20; r++)loadingArr.push("");
    const doEditInput = (itemName)=>{
        setCurrentEditName(itemName);
        setFocused();
    };
    const doSubmit = (e, value)=>{
        if (clickToEdit) {
            var _e_target;
            const currentField = formItems.findIndex((field)=>field.name === currentEditName);
            var _ref;
            formItems[currentField].default = (_ref = value !== null && value !== void 0 ? value : e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value) !== null && _ref !== void 0 ? _ref : reactHookForm.getValues(currentEditName);
            setCurrentEditName();
            scheduleTimeout(()=>doFocusNextItem(e), 10);
        }
        if (e === null || e === void 0 ? void 0 : e.preventDefault) e === null || e === void 0 ? void 0 : e.preventDefault();
        return false;
    };
    const doFocusNextItem = (e)=>{
        if (clickToEdit) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            let currentField = formItems.findIndex((field)=>field.name === currentEditName);
            const lastIndex = formItems.length - 1;
            let nextField = lastIndex === currentField ? null : formItems[currentField + 1];
            scheduleTimeout(()=>{
                let isEditable = isEditableField(nextField);
                while(!isEditable && nextField){
                    currentField++;
                    nextField = lastIndex === currentField ? null : formItems[currentField + 1];
                    isEditable = isEditableField(nextField);
                }
                if (nextField && isEditable) return scheduleTimeout(()=>{
                    doEditInput(nextField.name);
                }, 10);
                doEditInput();
            }, 150);
        }
    };
    const formClassName = className ? `form ${className}` : "form";
    const getCaptionClassName = (item)=>{
        const classNames = [
            "form-caption"
        ];
        if (item === null || item === void 0 ? void 0 : item.captionType) classNames.push(`form-caption__${item.captionType}`);
        return classNames.join(" ");
    };
    const getLabel = (item, key)=>{
        if (item.label && (item.type !== "checkbox" || clickToEdit) && item.type !== "heading" && item.type !== "section" && item.type !== "page" && item.type !== "button") {
            const editClass = edit ? "label--edit" : "";
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form-label-and-caption-container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form-label-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                htmlFor: `sidebar-form-${key}`,
                                className: editClass,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                        children: item.labelComponent || item.label
                                    }),
                                    item.required && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgDefault.default), {
                                        src: "asterisk",
                                        className: "label--required-marker"
                                    })
                                ]
                            }),
                            !clickToEdit && item.actionIcons && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "title-action-buttons",
                                children: item.actionIcons.map((actionIcon, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "button-link",
                                        "aria-label": actionIcon.label,
                                        title: actionIcon.label,
                                        disabled: actionIcon.disabled,
                                        onClick: (e)=>{
                                            const formValues = reactHookForm.getValues();
                                            const formValue = formValues[item.name];
                                            actionIcon.action(formValue, e, reactHookForm.getValues, reactHookForm.setValue);
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                            type: "akar",
                                            strokeWidth: 2,
                                            src: actionIcon.icon
                                        })
                                    }, key))
                            })
                        ]
                    }),
                    clickToEdit && item.caption && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: getCaptionClassName(item),
                        children: item.caption
                    })
                ]
            });
        }
        return null;
    };
    const isEditableField = (item)=>{
        const currentHiddenFields = currentHiddenFieldsRef.current;
        if (!item) return false;
        if ((currentHiddenFields === null || currentHiddenFields === void 0 ? void 0 : currentHiddenFields.length) > 0 && currentHiddenFields.includes(item.name)) return false;
        if (item.type !== "displayOnly" && item.type !== "heading" && (!Array.isArray(readOnlyFields) || !readOnlyFields.includes(item.name))) return true;
        return false;
    };
    const canEdit = (item)=>{
        const canEdit = !!(clickToEdit && (!currentEditName || item.name === currentEditName) && isEditableField(item));
        return canEdit;
    };
    const itemClass = (item)=>{
        if (clickToEdit) return (item === null || item === void 0 ? void 0 : item.name) === currentEditName && canEdit(item) ? "form-item form--field-currently-editing" : "form-item";
        return "form-item";
    };
    const itemEditClass = (item)=>{
        return !canEdit(item) ? "form--click-to-edit form--click-to-edit__disabled" : "form--click-to-edit";
    };
    // do this when any input with options (e.g. select) is changed
    const doOptionToggle = (e, currentValues)=>{
        var _e_target;
        // Check if the changed field has reCalcFields defined and recalculate them
        if ((e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.name) && formItems) {
            const changedField = formItems.find((item)=>item.name === e.target.name);
            if (changedField === null || changedField === void 0 ? void 0 : changedField.reCalcFields) {
                const value = reactHookForm.getValues(e.target.name);
                for (const fieldToRecalc of changedField.reCalcFields){
                    const affectedField = formItems.find((item)=>item.name === fieldToRecalc);
                    if (affectedField === null || affectedField === void 0 ? void 0 : affectedField.onChangeAffect) {
                        for (const affect of affectedField.onChangeAffect)if (affect.calc) {
                            const newValue = affect.calc(affectedField.name, value, reactHookForm.getValues);
                            if (newValue !== null) reactHookForm.setValue(affect.name, newValue);
                        }
                    }
                }
            }
        }
        // show or hide any fields based on value of dependency fields
        if (dependencies) {
            const formValues = reactHookForm.getValues;
            const newHiddenFields = [];
            const newDisabledFields = [];
            const newVisibleOptions = [];
            for(const dependency in dependencies){
                const hasDependents = Array.isArray(dependencies[dependency].dependents);
                const hasDisableDependents = Array.isArray(dependencies[dependency].disableDependents);
                if (formValues().hasOwnProperty(dependency) && (hasDependents || hasDisableDependents)) {
                    const currentHiddenFields = [];
                    const currentVisibleOptions = [];
                    if (hasDependents) for (const dependent of dependencies[dependency].dependents){
                        const fieldWatch = formValues()[dependency];
                        let showField = true;
                        let changeVisibleOptions = false;
                        if (typeof dependencies[dependency].condition === "function") {
                            if (!dependencies[dependency].condition(fieldWatch, dependent, e)) showField = false;
                        } else switch(dependencies[dependency].condition){
                            case "filterEqual":
                                const allOptions = dependencies[dependency].values || {};
                                if (Array.isArray(fieldWatch)) {
                                    const mergedOptions = new Set();
                                    fieldWatch.forEach((selected)=>{
                                        const selectedValue = (selected === null || selected === void 0 ? void 0 : selected.value) || selected;
                                        const selectedOptions = allOptions[selectedValue];
                                        if (Array.isArray(selectedOptions)) selectedOptions.forEach((option)=>{
                                            mergedOptions.add(option);
                                        });
                                    });
                                    changeVisibleOptions = Array.from(mergedOptions);
                                } else {
                                    const selectedValue = (fieldWatch === null || fieldWatch === void 0 ? void 0 : fieldWatch.value) || fieldWatch;
                                    changeVisibleOptions = allOptions[selectedValue];
                                }
                                break;
                            case "notEqual":
                                if (Array.isArray(dependencies[dependency].values) && dependencies[dependency].values.findIndex((option)=>{
                                    return !!(option === fieldWatch || option === (fieldWatch === null || fieldWatch === void 0 ? void 0 : fieldWatch.value));
                                }) > -1) showField = false;
                                break;
                        }
                        if (changeVisibleOptions !== false) {
                            const currentSelectedFilter = [
                                ...visibleOptions
                            ].find((field)=>field.field === dependent);
                            if (currentSelectedFilter && currentSelectedFilter.options !== changeVisibleOptions) {
                                // Preserve valid selections, remove invalid ones
                                const currentValue = reactHookForm.getValues(dependent);
                                if (currentValue) {
                                    if (Array.isArray(currentValue)) {
                                        // For multi-select, filter out invalid options
                                        const validSelections = currentValue.filter((val)=>changeVisibleOptions.includes(val.value || val));
                                        reactHookForm.setValue(dependent, validSelections);
                                    } else {
                                        // For single select, clear only if current value is not in new options
                                        const isValid = changeVisibleOptions.includes(currentValue.value || currentValue);
                                        if (!isValid) reactHookForm.setValue(dependent, null);
                                    }
                                }
                            }
                            currentVisibleOptions.push({
                                field: dependent,
                                options: changeVisibleOptions
                            });
                        }
                        if (!showField) currentHiddenFields.push(dependent);
                    }
                    if (hasDisableDependents) {
                        const fieldWatch = formValues()[dependency];
                        for (const dependent of dependencies[dependency].disableDependents){
                            let disableField = false;
                            if (typeof dependencies[dependency].disableCondition === "function") disableField = !!dependencies[dependency].disableCondition(fieldWatch, dependent, e);
                            if (disableField) newDisabledFields.push(dependent);
                        }
                    }
                    newHiddenFields.push(...currentHiddenFields);
                    newVisibleOptions.push(...currentVisibleOptions);
                }
            }
            if (JSON.stringify(disabledFields) === JSON.stringify(newDisabledFields) && JSON.stringify(visibleOptions) === JSON.stringify(newVisibleOptions) && JSON.stringify(hiddenFields) === JSON.stringify(newHiddenFields)) return;
            setDisabledFields(newDisabledFields);
            setHiddenFields(newHiddenFields);
            setVisibleOptions(newVisibleOptions);
        }
    };
    (0, _react.useEffect)(()=>{
        // do not put this in a timeout - it breaks stuff
        doOptionToggle();
    }, []);
    const doActionButton = (action)=>{
        if (action === null || action === void 0 ? void 0 : action.action) {
            if (action === null || action === void 0 ? void 0 : action.submit) return reactHookForm.handleSubmit(action === null || action === void 0 ? void 0 : action.action)();
            return action === null || action === void 0 ? void 0 : action.action(id);
        }
    };
    const isFieldHidden = (item)=>{
        if ((hiddenFields === null || hiddenFields === void 0 ? void 0 : hiddenFields.length) > 0 && hiddenFields.findIndex((field)=>field === item.name) > -1 || item.type === "hidden" || item.display === false) return true;
        return false;
    };
    const sectionClass = clickToEdit ? "form-section sidebar-form--section form-section__click-to-edit" : "form-section sidebar-form--section";
    const actionButtonsClass = busy ? "button button__invert button__disabled" : "button button__invert";
    const getInputProps = (item, key, itemKey)=>{
        return {
            id: `${key}-${itemKey}`,
            itemKey,
            item,
            validation,
            busy,
            ...reactHookForm,
            Controller: (0, _reactHookForm.Controller),
            inputReRenderTrigger,
            autoFocus,
            disabled: disabled || item.disabled || edit || (disabledFields === null || disabledFields === void 0 ? void 0 : disabledFields.length) > 0 && disabledFields.includes(item.name),
            visibleOptions,
            formItems,
            readOnlyFields,
            doTriggerReRender,
            onOptionToggle: (e)=>scheduleTimeout(()=>{
                    doOptionToggle(e);
                }, 100)
        };
    };
    let numberOfFields = 0;
    const doInsertField = ()=>{
        const newField = {
            label: "New Field",
            type: "text",
            required: false
        };
        createField({
            id,
            ...newField
        }, {
            onSuccess: doInsertCallback
        });
    };
    function doInsertCallback(data) {
        const insertedField = Array.isArray(data === null || data === void 0 ? void 0 : data.data) && (data === null || data === void 0 ? void 0 : data.data[0]);
        if (insertedField) {
            insertedField.name = insertedField.fieldId;
            setSections([
                {
                    items: [
                        {
                            ...insertedField
                        }
                    ]
                }
            ]);
        }
    }
    function isItemPendingApproval(item) {
        // for employee db - check if field is pending approval
        if (!item.pendingApproval) return false;
        // don't return if user is current logged in user
        // i.e. users cannot approve their own changes
        if (item.pendingApproval !== undefined && id && id !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id)) return "true";
        return false;
    }
    const getFilteredFormSections = (sections)=>{
        if (!Array.isArray(sections)) return [];
        const filtered = sections === null || sections === void 0 ? void 0 : sections.filter((field)=>{
            if ((!hideFields || !hideFields.includes(field.name)) && !isFieldHidden(field)) return true;
        });
        return filtered;
    };
    const getIsSection = (items)=>{
        if ((items === null || items === void 0 ? void 0 : items.length) !== 1) return false;
        if (items[0].type === "section" || items[0].type === "page") return true;
        return false;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            notice && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noticeDefault.default), {
                message: notice
            }),
            actionButtons && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "drawer-action-buttons",
                "data-is-disabled": busy || disabled,
                children: [
                    actionButtonsHeading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "drawer-action-buttons-heading",
                        children: actionButtonsHeading
                    }),
                    actionButtons.map((actionButton, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: actionButtonsClass,
                            onClick: ()=>{
                                doActionButton(actionButton);
                            },
                            disabled: busy || disabled,
                            children: actionButton.label
                        }, key))
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                className: formClassName,
                "data-is-disabled": disabled,
                autoComplete: "off",
                onSubmit: doSubmit,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "hidden",
                        name: "id",
                        defaultValue: id,
                        ...reactHookForm.register("id")
                    }),
                    loading ? loadingArr.map((row, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: sectionClass,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                                lines: "2"
                            })
                        }, key)) : sections === null || sections === void 0 ? void 0 : sections.map((section, key)=>{
                        var _getFilteredFormSections, _getFilteredFormSections1;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {
                            children: (section.content || ((_getFilteredFormSections = getFilteredFormSections(section.items)) === null || _getFilteredFormSections === void 0 ? void 0 : _getFilteredFormSections.length) > 0) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    section.heading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: section.heading
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: sectionClass,
                                        "data-is-section": getIsSection(section.items),
                                        children: [
                                            typeof section.content === "function" ? section.content({
                                                busy,
                                                disabled
                                            }) : section.content,
                                            (_getFilteredFormSections1 = getFilteredFormSections(section.items)) === null || _getFilteredFormSections1 === void 0 ? void 0 : _getFilteredFormSections1.map((item, itemKey)=>{
                                                if (item === null || item === void 0 ? void 0 : item.hidden) return null;
                                                numberOfFields++;
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                                                    children: [
                                                        !isFieldHidden(item) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: itemClass(item),
                                                            "data-pending-approval": isItemPendingApproval(item),
                                                            ref: canEdit(item) && item.name === currentEditName ? focusedRef : null,
                                                            children: [
                                                                canEdit(item) && !clickToEdit && getLabel(item, `${key}-${itemKey}`),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formErrorDefault.default), {
                                                                    content: getError(item.name),
                                                                    visible: reactHookForm.formState.errors[item.name] ? true : false
                                                                }),
                                                                clickToEdit && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                    children: [
                                                                        item.name === currentEditName && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                            children: [
                                                                                getLabel(item, `${key}-${itemKey}`),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formInputDefault.default), {
                                                                                    ...getInputProps(item, key, itemKey),
                                                                                    focus: clickToEdit,
                                                                                    clickToEditEditing: true,
                                                                                    onEditFieldChange: doSubmit
                                                                                })
                                                                            ]
                                                                        }),
                                                                        item.name !== currentEditName && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: itemEditClass(item),
                                                                            children: [
                                                                                getLabel(item, `${key}-${itemKey}`),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formInputDefault.default), {
                                                                                    ...getInputProps(item, key, itemKey),
                                                                                    content: getError(item.name),
                                                                                    visible: reactHookForm.formState.errors[item.name] ? true : false,
                                                                                    clickToEdit: clickToEdit,
                                                                                    currentEditName: currentEditName,
                                                                                    onEdit: doEditInput
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                !clickToEdit && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                    children: [
                                                                        getLabel(item, `${key}-${itemKey}`),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formInputDefault.default), {
                                                                            ...getInputProps(item, key, itemKey),
                                                                            onEdit: doEditInput
                                                                        })
                                                                    ]
                                                                }),
                                                                item.caption && !clickToEdit && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: getCaptionClassName(item),
                                                                    children: formatLineBreaks(item.caption)
                                                                })
                                                            ]
                                                        }),
                                                        edit && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formEditIconsDefault.default), {
                                                            fieldId: item.name,
                                                            formId: id,
                                                            formSections: sections,
                                                            onSetSections: setSections,
                                                            onBusy: onBusy,
                                                            onCompleted: onCompleted
                                                        })
                                                    ]
                                                }, `${key}-${itemKey}`);
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, `${key}`);
                    }),
                    modalMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormModalMessage, {
                        message: modalMessage
                    })
                ]
            }),
            hasPaging && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "paging",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "button-unstyled button-unstyled__link",
                        disabled: formPage === 0,
                        onClick: async ()=>{
                            const valid = await reactHookForm.trigger();
                            if (valid && isMountedRef.current) {
                                scrollToTop();
                                setFormPage(formPage - 1);
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgDefault.default), {
                                src: "arrow-right",
                                label: "Go",
                                className: "icon"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "paging--label",
                                children: "Previous"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {}),
                    formPage < (pages === null || pages === void 0 ? void 0 : pages.length) - 1 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "button-unstyled button-unstyled__link",
                        onClick: async ()=>{
                            const valid = await reactHookForm.trigger();
                            if (valid && isMountedRef.current) {
                                scrollToTop();
                                setFormPage(formPage + 1);
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "paging--label",
                                children: "Next"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgDefault.default), {
                                src: "arrow-right",
                                label: "Go",
                                className: "icon"
                            })
                        ]
                    }),
                    formPage >= (pages === null || pages === void 0 ? void 0 : pages.length) - 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _submitButtonDefault.default), {
                        disabled: isSubmitting,
                        isForm: true,
                        label: isSubmitting ? "Submitting..." : "Submit form",
                        onSubmit: async ()=>{
                            const valid = await reactHookForm.trigger();
                            if (valid && isMountedRef.current) {
                                scrollToTop();
                                setIsSubmitting(true);
                                onSubmit(reactHookForm.getValues());
                            }
                        }
                    })
                ]
            }),
            numberOfFields === 0 && edit && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "flex flex__center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                    class: "button",
                    onClick: doInsertField,
                    "aria-label": "Insert first field into this form",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.CirclePlus), {}),
                        " Add a field"
                    ]
                })
            })
        ]
    });
};
const FormModalMessage = ({ message })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "form-modal-message",
        children: message
    });
};
exports.default = Form;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","react-hook-form":"9V3w9","akar-icons":"b8xdj","object-inspect":"9AYk2","./submitButton":"4bi2T","./formError":"CPMpt","./skeleton":"fLZ02","./notice":"bnY7j","./formInput":"bRShb","./editableText":"c6jrG","../pages/components/formEditIcons":"fo5oH","../common/icon":"8WxrN","./svg":"4pImm","../hooks/fetch/useFetchForms":"fXBsb","../hooks/useInterval":"cl66D","../hooks/useStore":"l1Yj7","../hooks/useFocusComponent":"eNeLi","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9AYk2":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}
var utilInspect = require("faefcb1694f2ad90");
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if (has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return isArray(obj) ? '[Array]' : '[Object]';
    var indent = getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if (indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !isRegExp(obj)) {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) return '[' + indentedJoin(xs, indent) + ']';
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) return utilInspect(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) return weakCollectionOf('WeakMap');
    if (isWeakSet(obj)) return weakCollectionOf('WeakSet');
    if (isWeakRef(obj)) return weakCollectionOf('WeakRef');
    if (isNumber(obj)) return markBoxed(inspect(Number(obj)));
    if (isBigInt(obj)) return markBoxed(inspect(bigIntValueOf.call(obj)));
    if (isBoolean(obj)) return markBoxed(booleanValueOf.call(obj));
    if (isString(obj)) return markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof global !== 'undefined' && obj === global) return '{ [object globalThis] }';
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}
function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}
function canTrustToString(obj) {
    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
}
function isArray(obj) {
    return toStr(obj) === '[object Array]' && canTrustToString(obj);
}
function isDate(obj) {
    return toStr(obj) === '[object Date]' && canTrustToString(obj);
}
function isRegExp(obj) {
    return toStr(obj) === '[object RegExp]' && canTrustToString(obj);
}
function isError(obj) {
    return toStr(obj) === '[object Error]' && canTrustToString(obj);
}
function isString(obj) {
    return toStr(obj) === '[object String]' && canTrustToString(obj);
}
function isNumber(obj) {
    return toStr(obj) === '[object Number]' && canTrustToString(obj);
}
function isBoolean(obj) {
    return toStr(obj) === '[object Boolean]' && canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !symToString) return false;
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) return false;
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function has(obj, key) {
    return hasOwn.call(obj, key);
}
function toStr(obj) {
    return objectToString.call(obj);
}
function nameOf(f) {
    if (f.name) return f.name;
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') return false;
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') return false;
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') return false;
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') return false;
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}
function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}
function markBoxed(str) {
    return 'Object(' + str + ')';
}
function weakCollectionOf(type) {
    return type + ' { ? }';
}
function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if (indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}
function indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if (isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

},{"faefcb1694f2ad90":"imd3F"}],"imd3F":[function(require,module,exports,__globalThis) {
"use strict";

},{}],"CPMpt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
const FormError = ({ content, visible })=>{
    if (!visible) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "form-user-error-tip",
        children: content
    });
};
exports.default = FormError;

},{"react/jsx-runtime":"i3K7E","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"bRShb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _akarIcons = require("akar-icons");
var _luxon = require("luxon");
var _selectWrapper = require("./selectWrapper");
var _selectWrapperDefault = parcelHelpers.interopDefault(_selectWrapper);
var _radioFormInputs = require("./radioFormInputs");
var _radioFormInputsDefault = parcelHelpers.interopDefault(_radioFormInputs);
var _tickbox = require("./tickbox");
var _tickboxDefault = parcelHelpers.interopDefault(_tickbox);
var _formError = require("./formError");
var _formErrorDefault = parcelHelpers.interopDefault(_formError);
var _iconPicker = require("./iconPicker");
var _iconPickerDefault = parcelHelpers.interopDefault(_iconPicker);
var _remainingLeave = require("./remainingLeave");
var _remainingLeaveDefault = parcelHelpers.interopDefault(_remainingLeave);
var _svg = require("./svg");
var _svgDefault = parcelHelpers.interopDefault(_svg);
var _colourPicker = require("./colourPicker");
var _colourPickerDefault = parcelHelpers.interopDefault(_colourPicker);
var _absenceTypePicker = require("./absenceTypePicker");
var _absenceTypePickerDefault = parcelHelpers.interopDefault(_absenceTypePicker);
var _periodOverride = require("./periodOverride");
var _periodOverrideDefault = parcelHelpers.interopDefault(_periodOverride);
var _notice = require("./notice");
var _noticeDefault = parcelHelpers.interopDefault(_notice);
var _workPatternSpecificsMatrix = require("./workPatternSpecificsMatrix");
var _workPatternSpecificsMatrixDefault = parcelHelpers.interopDefault(_workPatternSpecificsMatrix);
var _payReviewMatrix = require("./payReviewMatrix");
var _payReviewMatrixDefault = parcelHelpers.interopDefault(_payReviewMatrix);
var _useStore = require("../hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
const RichText = /*#__PURE__*/ (0, _react.lazy)(()=>require("1968c7935e439b29"));
const isReadOnly = (item, readOnlyFields)=>{
    if (readOnlyFields === null || readOnlyFields === void 0 ? void 0 : readOnlyFields.includes(item.name)) return true;
};
const normaliseMultiCheckboxValues = (values)=>{
    if (!Array.isArray(values)) return [];
    return values.filter((value)=>value !== null && value !== undefined && value !== false);
};
const getMultiCheckboxSortValue = (value)=>{
    var _value_value, _ref;
    if (value && typeof value === "object") return (_ref = (_value_value = value.value) !== null && _value_value !== void 0 ? _value_value : value.label) !== null && _ref !== void 0 ? _ref : "";
    return value !== null && value !== void 0 ? value : "";
};
const FormInput = ({ id, item, control, register = ()=>{}, setValue, getValues, validation = ()=>{}, busy, autoFocus, focus, disabled, creatable, inputReRenderTrigger, doTriggerReRender, clickToEdit, clickToEditEditing = false, currentEditName, formItems, readOnlyFields, visibleOptions, onEdit, onEditFieldChange, onOptionToggle })=>{
    const subdomain = (0, _useStoreDefault.default)((state)=>state.subdomain);
    if (subdomain === "app") autoFocus = false;
    if (!item) return null;
    if (clickToEdit && (item.type === "heading" || item.type === "section")) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
        children: item.label
    });
    if (clickToEdit && item.name !== currentEditName) {
        const formItem = formItems && (formItems === null || formItems === void 0 ? void 0 : formItems.find((formItem)=>formItem.name === item.name));
        const displayValue = ()=>{
            let currentValue = getValues(item.name);
            switch(item.type){
                case "number":
                    {
                        currentValue = parseFloat(currentValue);
                        if (isNaN(currentValue)) return "";
                        if (!item.currency) return currentValue;
                        const currencySymbol = (typeof item.currencySymbol === "function" ? item.currencySymbol(getValues) : item.currencySymbol) || "\xa3";
                        return `${currencySymbol} ${currentValue.toFixed(2)}`;
                    }
                case "displayOnly":
                    if (typeof item.calc === "function") return item.calc(getValues);
                    break;
                case "probationaryPeriod":
                    {
                        const unitFieldName = item.unitName || "employment--probationaryPeriodUnit";
                        const rawUnitValue = getValues === null || getValues === void 0 ? void 0 : getValues(unitFieldName);
                        var _rawUnitValue_value, _ref, _ref1;
                        const unitValue = (_ref1 = (_ref = (_rawUnitValue_value = rawUnitValue === null || rawUnitValue === void 0 ? void 0 : rawUnitValue.value) !== null && _rawUnitValue_value !== void 0 ? _rawUnitValue_value : rawUnitValue) !== null && _ref !== void 0 ? _ref : item.unitDefault) !== null && _ref1 !== void 0 ? _ref1 : "months";
                        const singularUnitValue = unitValue === "days" ? "day" : unitValue === "weeks" ? "week" : unitValue === "months" ? "month" : unitValue;
                        if (currentValue === null || currentValue === undefined || currentValue === "") return "";
                        return `${currentValue} ${Number(currentValue) === 1 ? singularUnitValue : unitValue}`;
                    }
                case "checkbox":
                    return currentValue ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.Check), {}) : "";
                case "date":
                    if (currentValue) {
                        const date = (0, _luxon.DateTime).fromISO(currentValue === null || currentValue === void 0 ? void 0 : currentValue.substring(0, 10));
                        return date.toFormat("dd/MM/yyyy");
                    }
                    return "-";
                case "select":
                case "multiCheckbox":
                    if (!Array.isArray(currentValue)) {
                        var _item_options;
                        const findOption = (_item_options = item.options) === null || _item_options === void 0 ? void 0 : _item_options.find((option)=>option.value === currentValue);
                        if (findOption) return findOption.label || findOption.value || findOption.toString();
                        if (currentValue && typeof currentValue === "object") return (currentValue === null || currentValue === void 0 ? void 0 : currentValue.label) || (currentValue === null || currentValue === void 0 ? void 0 : currentValue.value) || "";
                        return (currentValue === null || currentValue === void 0 ? void 0 : currentValue.label) || (currentValue === null || currentValue === void 0 ? void 0 : currentValue.value) || currentValue;
                    }
                    const values = currentValue.map((value, i)=>{
                        const outputValue = (value === null || value === void 0 ? void 0 : value.label) || (value === null || value === void 0 ? void 0 : value.value) || value;
                        return outputValue ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "select-preview-option",
                            children: outputValue
                        }, i) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Fragment), {}, i);
                    });
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: values.map((value)=>value)
                    });
                case "workPatternSpecifics":
                    if (!currentValue || typeof currentValue !== "object") return "-";
                    const configuredDays = Object.values(currentValue).filter((day)=>{
                        return !!((day === null || day === void 0 ? void 0 : day.startTime) && (day === null || day === void 0 ? void 0 : day.finishTime));
                    }).length;
                    if (configuredDays <= 0) return "No days configured";
                    return `${configuredDays} day${configuredDays === 1 ? "" : "s"} configured`;
                case "payReview":
                    {
                        var _formItems_find;
                        const payReviewFields = item.fields || (formItems === null || formItems === void 0 ? void 0 : (_formItems_find = formItems.find((formItem)=>formItem.name === item.name)) === null || _formItems_find === void 0 ? void 0 : _formItems_find.fields) || [];
                        const payReviewValues = Object.fromEntries(payReviewFields.map((field)=>{
                            var _getValues;
                            const fieldValue = (_getValues = getValues === null || getValues === void 0 ? void 0 : getValues(field.name)) !== null && _getValues !== void 0 ? _getValues : field.default;
                            const normalisedValue = fieldValue === null || typeof fieldValue === "undefined" ? "" : field.type === "date" && typeof fieldValue === "string" ? fieldValue.substring(0, 10) : fieldValue;
                            return [
                                field.key,
                                normalisedValue
                            ];
                        }));
                        const renderCell = (value)=>{
                            if (value === null || typeof value === "undefined" || value === "") return "-";
                            if (typeof value === "string" && value.length > 0) {
                                const dateValue = (0, _luxon.DateTime).fromISO(value.substring(0, 10));
                                if (dateValue.isValid) return dateValue.toFormat("dd/MM/yyyy");
                            }
                            return value;
                        };
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pay-review-readonly-table",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
                                className: "pay-review-readonly-table__table",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                                                    className: "pay-review-readonly-table__cell",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "pay-review-readonly-table__label",
                                                            children: "New Rate"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: renderCell(payReviewValues.newRate)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                                                    className: "pay-review-readonly-table__cell",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "pay-review-readonly-table__label",
                                                            children: "Effective Date"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: renderCell(payReviewValues.newRateEffectiveDate)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                                                    className: "pay-review-readonly-table__cell",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "pay-review-readonly-table__label",
                                                            children: "Bonus or Addition"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: renderCell(payReviewValues.bonusOrAddition)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                                                    className: "pay-review-readonly-table__cell",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "pay-review-readonly-table__label",
                                                            children: "Effective Date"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: renderCell(payReviewValues.bonusOrAdditionEffectiveDate)
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        });
                    }
            }
            if (typeof item.obfuscate === "function") {
                const obfuscateValue = currentValue || item.obfuscateDefault;
                const obfuscatedValue = item.obfuscate(obfuscateValue);
                if (currentValue && obfuscatedValue !== currentValue) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        obfuscatedValue,
                        " ",
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.EyeOpen), {})
                    ]
                });
                return obfuscatedValue;
            }
            return currentValue;
        };
        const canEditField = !!(formItem && formItem.type !== "displayOnly" && formItem.type !== "heading" && formItem.type !== "section" && formItem.type !== "notice" && formItem.type !== "error" && !isReadOnly(formItem, readOnlyFields));
        // if these values don't exist in the fetch result, initialise them
        // with dafaults to prevent 'unsaved changes' warnings
        if (formItem === null || formItem === void 0 ? void 0 : formItem.name) {
            let currentValue = getValues ? getValues(formItem.name) : "";
            if (typeof currentValue === "undefined" || currentValue === null) {
                let defaultValue = "";
                if (formItem.type === "checkbox") defaultValue = false;
                if (formItem.type === "multiCheckbox") defaultValue = normaliseMultiCheckboxValues(formItem.default);
                setValue(formItem.name, defaultValue);
            }
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            onClick: ()=>{
                if (canEditField) onEdit(formItem.name);
            },
            className: canEditField ? `form--click-to-edit-input${item.type === "probationaryPeriod" ? " form--click-to-edit-input__probationary" : ""}${item.type === "payReview" ? " form--click-to-edit-input__pay-review" : ""}` : `form--click-to-edit-input form--click-to-edit-input__cannot-edit${item.type === "probationaryPeriod" ? " form--click-to-edit-input__probationary" : ""}${item.type === "payReview" ? " form--click-to-edit-input__pay-review" : ""}`,
            children: displayValue()
        });
    }
    const itemDefault = typeof item.default !== "undefined" ? item.default : item.value;
    const defaultValue = Number.isNaN(itemDefault) ? "" : itemDefault;
    const doCheckForEnter = (e, allowDefaultAction = false)=>{
        if (!clickToEdit) return;
        const isDate = item.type === "date";
        // check enter has been pressed, and not shift and enter
        if (!e.shiftKey && (e.key === "Enter" || e.key === "Tab" && !isDate)) {
            if (!allowDefaultAction) {
                var _e_target;
                e.preventDefault();
                e.stopPropagation();
                (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.blur();
            }
            setTimeout(()=>{
                var _e_target;
                // submit the form
                const form = (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.form;
                form === null || form === void 0 ? void 0 : form.requestSubmit();
            }, 10);
        }
    };
    const doChangeAffect = (item, value)=>{
        if (!item.onChangeAffect) return;
        item.onChangeAffect.map((affect)=>{
            if ((affect === null || affect === void 0 ? void 0 : affect.name) && (affect === null || affect === void 0 ? void 0 : affect.calc)) {
                const affectedValue = affect.calc(item.name, value, getValues);
                if (affectedValue) setValue(affect === null || affect === void 0 ? void 0 : affect.name, affectedValue);
            }
            doTriggerReRender();
        });
    };
    switch(item === null || item === void 0 ? void 0 : item.type){
        case "hidden":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "hidden",
                name: item.name,
                value: item.value,
                ...register(item.name)
            });
        case "checkbox":
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form-input-flex-pair",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tickboxDefault.default), {
                        id: `sidebar-form-${id}`,
                        setValue: setValue,
                        name: item.name,
                        checked: defaultValue || false,
                        required: item.required,
                        disabled: disabled,
                        onChange: (val, e)=>{
                            const checked = e.target.checked;
                            if (item.onChangeAffect) item.onChangeAffect.map((affect)=>{
                                if ((affect === null || affect === void 0 ? void 0 : affect.name) && (affect === null || affect === void 0 ? void 0 : affect.calc)) affect.calc(item.name, checked, getValues);
                            });
                            onOptionToggle && onOptionToggle(e, val);
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "hidden",
                        name: item.name,
                        ...register(item.name, {
                            required: {
                                value: item.required ? true : false,
                                message: `Please tick: '${item.label}'`
                            },
                            ...validation(item.validate || item.type)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                        htmlFor: `sidebar-form-${id}`,
                        children: [
                            item.label,
                            item.required && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgDefault.default), {
                                src: "asterisk",
                                className: "label--required-marker"
                            })
                        ]
                    })
                ]
            });
        case "multiCheckbox":
            var _item_options, _item_options1;
            if (((_item_options = item.options) === null || _item_options === void 0 ? void 0 : _item_options.length) <= 0) return null;
            const currentValues = normaliseMultiCheckboxValues(getValues ? getValues(item.name) : []);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(FocusGrabber, {
                        enabled: clickToEditEditing
                    }),
                    (_item_options1 = item.options) === null || _item_options1 === void 0 ? void 0 : _item_options1.map((option, key)=>{
                        const value = typeof option === "string" ? option : option === null || option === void 0 ? void 0 : option.value;
                        const label = typeof (option === null || option === void 0 ? void 0 : option.label) === "string" ? option === null || option === void 0 ? void 0 : option.label : value;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-input-flex-pair",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tickboxDefault.default), {
                                    id: `sidebar-form-${id}-${key}`,
                                    register: register,
                                    setValue: (_name, isTicked)=>{
                                        const currentValues = normaliseMultiCheckboxValues(getValues ? getValues(item.name) : []);
                                        const newValues = [
                                            ...currentValues
                                        ];
                                        const foundIndex = newValues === null || newValues === void 0 ? void 0 : newValues.findIndex((item)=>item === value || (item === null || item === void 0 ? void 0 : item.value) === value);
                                        if (isTicked && foundIndex < 0) newValues.push(option);
                                        if (!isTicked && foundIndex > -1) newValues.splice(foundIndex, 1);
                                        if (item.sortValues) newValues.sort((a, b)=>{
                                            const aValue = getMultiCheckboxSortValue(a);
                                            const bValue = getMultiCheckboxSortValue(b);
                                            if (aValue < bValue) return -1;
                                            if (aValue > bValue) return 1;
                                            return 0;
                                        });
                                        if (setValue) setValue(item.name, newValues);
                                    },
                                    name: `${item.name}[${key}]`,
                                    checked: Array.isArray(currentValues) && !!((currentValues === null || currentValues === void 0 ? void 0 : currentValues.findIndex((item)=>{
                                        return item === value || (item === null || item === void 0 ? void 0 : item.value) === value;
                                    })) > -1),
                                    disabled: disabled
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: `sidebar-form-${id}-${key}`,
                                    children: label || ""
                                })
                            ]
                        }, key);
                    })
                ]
            });
        case "radio":
            var _item_value;
            const radioOptions = Array.isArray(item.options) && item.options.length > 0 && item.options.map((option, key)=>{
                if (typeof option === "string") return {
                    value: option,
                    label: option
                };
                return {
                    value: (option === null || option === void 0 ? void 0 : option.key) || (option === null || option === void 0 ? void 0 : option.value),
                    label: option === null || option === void 0 ? void 0 : option.value
                };
            });
            const itemValue = getValues && getValues(item.name) || ((_item_value = item.value) === null || _item_value === void 0 ? void 0 : _item_value.value) || item.value;
            const radioOnChange = (e, value)=>{
                onOptionToggle(e);
                doChangeAffect(item, value);
            };
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioFormInputsDefault.default), {
                name: item.name,
                value: itemValue,
                options: radioOptions,
                label: item.label,
                required: item.required,
                disabled: disabled,
                setValue: setValue,
                register: register,
                validation: validation,
                onChange: radioOnChange
            });
        case "select":
            var _filter, _this;
            const creatable1 = !!(item === null || item === void 0 ? void 0 : item.creatable);
            const filtered = visibleOptions === null || visibleOptions === void 0 ? void 0 : visibleOptions.find((filter)=>filter.field === item.name);
            const options = ((_this = (item === null || item === void 0 ? void 0 : item.options) && Array.isArray(item === null || item === void 0 ? void 0 : item.options) && item.options.map((option)=>{
                var _item_label;
                // email recipient selection, based on name being 'recipinet'
                if (((_item_label = item.label) === null || _item_label === void 0 ? void 0 : _item_label.toLowerCase()) === "recipient") {
                    // remove anything in square brackets
                    const regex = /\[.*?\]/g;
                    if (typeof option === "string") return {
                        value: option,
                        label: option.replace(regex, "")
                    };
                    var _option_label;
                    const labelSource = (_option_label = option === null || option === void 0 ? void 0 : option.label) !== null && _option_label !== void 0 ? _option_label : option === null || option === void 0 ? void 0 : option.value;
                    return {
                        value: option === null || option === void 0 ? void 0 : option.value,
                        label: typeof labelSource === "string" ? labelSource.replace(regex, "") : String(labelSource || "")
                    };
                }
                if (typeof option === "string") return {
                    value: option,
                    label: option
                };
                return option;
            })) === null || _this === void 0 ? void 0 : (_filter = _this.filter((option)=>{
                // Check if the options are to be filtered (i.e. some hidden)
                if (filtered && Array.isArray(filtered.options)) return !!filtered.options.includes(option.value);
                else return true;
            })) === null || _filter === void 0 ? void 0 : _filter.filter((option, i, self)=>{
                // unique options only
                return self.findIndex((o)=>o.value === option.value) === i;
            })) || [];
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectWrapperDefault.default), {
                name: item.name,
                required: item.required,
                "aria-required": item.required,
                isDisabled: busy || disabled,
                options: options,
                creatable: creatable1,
                value: getValues && getValues(item.name),
                autoFocus: !!(autoFocus && (id === "0-0" || focus || item.autoFocus)),
                setValue: setValue,
                renderTrigger: inputReRenderTrigger,
                placeholder: item.placeholder,
                isMulti: !!item.multi,
                onKeyDown: (e)=>{
                    doCheckForEnter(e, true);
                },
                onEditFieldChange: (_e, value)=>{
                    if (onOptionToggle && typeof onOptionToggle === "function") onOptionToggle();
                    doChangeAffect(item, value);
                    if (onEditFieldChange) onEditFieldChange(_e, value);
                }
            });
        case "textarea":
            var _item_label;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                id: `sidebar-form-${id}`,
                type: item.type === "password" ? item.type : "text",
                placeholder: null,
                required: item.required,
                "aria-required": item.required,
                disabled: busy || disabled,
                defaultValue: defaultValue,
                onKeyDown: doCheckForEnter,
                ...register(item.name, {
                    required: {
                        value: item.required ? true : false,
                        message: `Please enter ${(_item_label = item.label) === null || _item_label === void 0 ? void 0 : _item_label.toLowerCase()}`
                    },
                    ...validation(item.validate !== "undefined" ? item.validate : item.type)
                }),
                autoFocus: !!(autoFocus && (id === "0-0" || focus || item.autoFocus))
            });
        case "richtext":
            var _item_label1, _item_labelHidden;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: "Loading..."
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(RichText, {
                            name: item.name,
                            content: item.value,
                            editorRef: item.inputRef,
                            setValue: setValue,
                            disabled: disabled,
                            onCreate: item.onCreate,
                            autoFocus: !!(autoFocus && (id === "0-0" || focus || item.autoFocus))
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "hidden",
                            ...register(item.name, {
                                required: {
                                    value: item.required ? true : false,
                                    message: `Please enter ${((_item_label1 = item.label) === null || _item_label1 === void 0 ? void 0 : _item_label1.toLowerCase()) || ((_item_labelHidden = item.labelHidden) === null || _item_labelHidden === void 0 ? void 0 : _item_labelHidden.toLowerCase())}`
                                },
                                ...validation(item.validate !== "undefined" ? item.validate : item.type)
                            })
                        })
                    ]
                })
            });
        case "absenceType":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHookForm.Controller), {
                name: item.name,
                control: control,
                defaultValue: item.value,
                rules: validation("text"),
                render: ({ field })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _absenceTypePickerDefault.default), {
                        name: field.name,
                        value: field.value,
                        onChange: field.onChange,
                        onBlur: field.onBlur,
                        disabled: busy || disabled
                    })
            });
        case "icon":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconPickerDefault.default), {
                icon: item.value,
                name: item.name,
                iconStyle: {
                    width: "5rem",
                    height: "5rem",
                    maxWidth: "5rem",
                    maxHeight: "5rem"
                },
                register: register,
                setValue: setValue,
                disabled: disabled
            });
        case "colour":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _colourPickerDefault.default), {
                name: item.name,
                colour: item.value || item.colour,
                register: register,
                setValue: setValue,
                disabled: busy || disabled
            });
        case "periodOverride":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHookForm.Controller), {
                name: item.name,
                control: control,
                defaultValue: item.value,
                render: ({ field })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _periodOverrideDefault.default), {
                        ref: field.ref,
                        id: `sidebar-form-${id}`,
                        disabled: busy || disabled,
                        value: field.value,
                        onChange: field.onChange,
                        onBlur: field.onBlur
                    })
            });
        case "number":
            {
                var _item_label2;
                const currencySymbol = item.currency ? (typeof item.currencySymbol === "function" ? item.currencySymbol(getValues) : item.currencySymbol) || "\xa3" : null;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: item.currency ? "input-number-prefix-container" : "",
                    style: item.currency ? {
                        "--currency-symbol": `"${currencySymbol}"`
                    } : undefined,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        id: `sidebar-form-${id}`,
                        type: "number",
                        min: "0",
                        max: item.max,
                        step: item.step || 1,
                        required: item.required,
                        "aria-required": item.required,
                        disabled: busy || disabled,
                        defaultValue: parseFloat(defaultValue) || "",
                        ...register(item.name, {
                            valueAsNumber: true,
                            required: {
                                value: item.required ? true : false,
                                message: `Please enter ${item === null || item === void 0 ? void 0 : (_item_label2 = item.label) === null || _item_label2 === void 0 ? void 0 : _item_label2.toLowerCase()}`
                            },
                            ...validation(item.validate || item.type)
                        }),
                        onKeyDown: doCheckForEnter,
                        onChange: (e)=>{
                            var _item_reCalcFields, _item_reCalcFields1;
                            const numericValue = parseFloat(e.target.value);
                            setValue(item.name, isNaN(numericValue) ? "" : numericValue);
                            if (item.onChangeAffect) item.onChangeAffect.map((affect)=>{
                                if ((affect === null || affect === void 0 ? void 0 : affect.name) && (affect === null || affect === void 0 ? void 0 : affect.calc)) {
                                    const watchValue = parseFloat(e.target.value);
                                    const affectedValue = affect.calc(item.name, watchValue, getValues);
                                    setValue(affect === null || affect === void 0 ? void 0 : affect.name, affectedValue);
                                }
                            });
                            if ((_item_reCalcFields = item.reCalcFields) === null || _item_reCalcFields === void 0 ? void 0 : _item_reCalcFields.length) item.reCalcFields.map((fieldName)=>{
                                if (fieldName) {
                                    const field = formItems.find((formItem)=>formItem.name === fieldName);
                                    if (field === null || field === void 0 ? void 0 : field.onChangeAffect) field.onChangeAffect.map((affect)=>{
                                        if ((affect === null || affect === void 0 ? void 0 : affect.name) && (affect === null || affect === void 0 ? void 0 : affect.calc)) {
                                            const watchValue = getValues(field.name);
                                            const affectedValue = affect.calc(fieldName, watchValue, getValues);
                                            setValue(affect === null || affect === void 0 ? void 0 : affect.name, affectedValue);
                                        }
                                    });
                                }
                            });
                            if (item.onChangeAffect || ((_item_reCalcFields1 = item.reCalcFields) === null || _item_reCalcFields1 === void 0 ? void 0 : _item_reCalcFields1.length)) doTriggerReRender();
                        },
                        autoFocus: !!(autoFocus && (id === "0-0" || focus || item.autoFocus))
                    })
                });
            }
        case "date":
            var _item_label3;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                id: `sidebar-form-${id}`,
                type: "date",
                required: item.required,
                "aria-required": item.required,
                disabled: busy || disabled,
                defaultValue: defaultValue,
                ...register(item.name, {
                    required: {
                        value: item.required ? true : false,
                        message: `Please enter ${item === null || item === void 0 ? void 0 : (_item_label3 = item.label) === null || _item_label3 === void 0 ? void 0 : _item_label3.toLowerCase()}`
                    },
                    onBlur: (e)=>item.onChange ? item.onChange(e.target.value) : null,
                    ...validation(item.validate || item.type)
                }),
                autoFocus: !!(autoFocus && (id === "0-0" || focus || item.autoFocus)),
                onChange: (e)=>{
                    if (item.onChangeAffect) item.onChangeAffect.map((affect)=>{
                        if ((affect === null || affect === void 0 ? void 0 : affect.name) && (affect === null || affect === void 0 ? void 0 : affect.calc)) {
                            const watchValue = e.target.value;
                            const affectedValue = affect.calc(item.name, watchValue, getValues);
                            setValue(affect === null || affect === void 0 ? void 0 : affect.name, affectedValue);
                        }
                    });
                },
                onKeyDown: doCheckForEnter
            });
        case "probationaryPeriod":
            {
                var _item_label4;
                const unitFieldName = item.unitName || "employment--probationaryPeriodUnit";
                var _item_unitDefault, _ref;
                const unitDefaultValue = (_ref = (_item_unitDefault = item.unitDefault) !== null && _item_unitDefault !== void 0 ? _item_unitDefault : getValues === null || getValues === void 0 ? void 0 : getValues(unitFieldName)) !== null && _ref !== void 0 ? _ref : "months";
                const unitOptions = [
                    {
                        value: "days",
                        label: "Days"
                    },
                    {
                        value: "weeks",
                        label: "Weeks"
                    },
                    {
                        value: "months",
                        label: "Months"
                    }
                ];
                const selectedUnitValue = getValues === null || getValues === void 0 ? void 0 : getValues(unitFieldName);
                var _selectedUnitValue_value, _ref1;
                const selectedUnitValueString = (_ref1 = (_selectedUnitValue_value = selectedUnitValue === null || selectedUnitValue === void 0 ? void 0 : selectedUnitValue.value) !== null && _selectedUnitValue_value !== void 0 ? _selectedUnitValue_value : selectedUnitValue) !== null && _ref1 !== void 0 ? _ref1 : unitDefaultValue;
                const selectedUnitOption = unitOptions.find((option)=>option.value === selectedUnitValueString) || unitOptions[2];
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-input-flex form-input-flex__tight probationary-period-field",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "form-input probationary-period-input",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                id: `sidebar-form-${id}`,
                                type: "number",
                                min: "0",
                                step: "1",
                                required: item.required,
                                "aria-required": item.required,
                                disabled: busy || disabled,
                                defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : "",
                                ...register(item.name, {
                                    valueAsNumber: true,
                                    required: {
                                        value: item.required ? true : false,
                                        message: `Please enter ${item === null || item === void 0 ? void 0 : (_item_label4 = item.label) === null || _item_label4 === void 0 ? void 0 : _item_label4.toLowerCase()}`
                                    },
                                    ...validation(item.validate || item.type)
                                }),
                                onKeyDown: doCheckForEnter,
                                onChange: (e)=>{
                                    const numericValue = parseFloat(e.target.value);
                                    setValue(item.name, isNaN(numericValue) ? "" : numericValue);
                                    if (item.onChangeAffect) item.onChangeAffect.forEach((affect)=>{
                                        if ((affect === null || affect === void 0 ? void 0 : affect.name) && (affect === null || affect === void 0 ? void 0 : affect.calc)) {
                                            const watchValue = isNaN(numericValue) ? "" : numericValue;
                                            const affectedValue = affect.calc(item.name, watchValue, getValues);
                                            setValue(affect === null || affect === void 0 ? void 0 : affect.name, affectedValue);
                                        }
                                    });
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "form-input probationary-period-select",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectWrapperDefault.default), {
                                name: unitFieldName,
                                required: item.required,
                                isDisabled: busy || disabled,
                                options: unitOptions,
                                value: selectedUnitOption,
                                setValue: setValue,
                                placeholder: "Months",
                                onChange: (newValue)=>{
                                    if (item.onChangeAffect) item.onChangeAffect.forEach((affect)=>{
                                        if ((affect === null || affect === void 0 ? void 0 : affect.name) && (affect === null || affect === void 0 ? void 0 : affect.calc)) {
                                            const affectedValue = affect.calc(unitFieldName, newValue, getValues);
                                            setValue(affect === null || affect === void 0 ? void 0 : affect.name, affectedValue);
                                        }
                                    });
                                },
                                onKeyDown: (e)=>doCheckForEnter(e, true)
                            })
                        })
                    ]
                });
            }
        case "remainingLeave":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _remainingLeaveDefault.default), {
                userId: getValues(item.name) || item.value
            });
        case "error":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formErrorDefault.default), {
                content: item.value,
                visible: item.display
            });
        case "displayOnly":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: typeof item.calc === "function" ? item.calc(getValues) : defaultValue
            });
        case "workPatternSpecifics":
            var _getValues;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _workPatternSpecificsMatrixDefault.default), {
                name: item.name,
                value: getValues(item.name) || defaultValue,
                setValue: setValue,
                disabled: busy || disabled,
                onKeyDown: doCheckForEnter,
                breaksPaidName: item.breaksPaidName,
                breaksPaidValue: (_getValues = getValues(item.breaksPaidName)) !== null && _getValues !== void 0 ? _getValues : item.breaksPaidDefault
            });
        case "payReview":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _payReviewMatrixDefault.default), {
                item: item,
                getValues: getValues,
                setValue: setValue,
                disabled: busy || disabled,
                onKeyDown: doCheckForEnter
            });
        case "notice":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noticeDefault.default), {
                message: item.value
            });
        case "heading":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: item.label
            });
        case "section":
        case "page":
            return item.label ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                children: item.label
            }) : null;
        case "button":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "button",
                type: "button",
                disabled: busy || disabled,
                onClick: ()=>{
                    item.action(getValues());
                },
                children: !busy ? item.label : item.labelBusy
            });
        case "buttons":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "form-input-flex form-input-flex__tight form-input-flex__tighter",
                children: item.buttons.map((button, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "button button__invert",
                        type: "button",
                        disabled: busy || disabled,
                        onClick: ()=>{
                            button.onClick(getValues());
                        },
                        children: !busy ? button.label : button.labelBusy
                    }, key))
            });
        case "file":
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                id: `sidebar-form-${id}`,
                type: "file",
                required: item.required,
                "aria-required": item.required,
                disabled: busy || disabled,
                ...register(item.name, {
                    required: {
                        value: item.required ? true : false,
                        message: `Please upload a file`
                    },
                    ...validation(item.validate || item.type)
                })
            });
        case "text":
        default:
            var _item_label5;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                id: `sidebar-form-${id}`,
                type: item.type === "password" ? item.type : "text",
                placeholder: null,
                required: item.required,
                "aria-required": item.required,
                disabled: busy || disabled,
                defaultValue: defaultValue,
                maxLength: item.maxlength,
                autoFocus: !!(autoFocus && (id === "0-0" || focus || item.autoFocus)),
                onKeyDown: doCheckForEnter,
                ...register(item.name, {
                    required: {
                        value: item.required ? true : false,
                        message: `Please enter ${item === null || item === void 0 ? void 0 : (_item_label5 = item.label) === null || _item_label5 === void 0 ? void 0 : _item_label5.toLowerCase()}`
                    },
                    ...validation(item.validate || item.type)
                })
            });
    }
};
const FocusGrabber = ({ enabled = false })=>{
    // This allows the 'press enter to advance' functionality when 'click to edit'
    // mode is enabled. It grabs the focus, so enter can be pressed to submit the form,
    // triggering the onSubmit event
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
        autoFocus: !!enabled,
        "aria-hidden": "true",
        style: {
            width: 0,
            height: 0,
            position: "absolute",
            opacity: 0,
            pointerEvents: "none"
        },
        value: enabled === null || enabled === void 0 ? void 0 : enabled.toString(),
        onChange: ()=>{}
    });
};
exports.default = FormInput;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","react-hook-form":"9V3w9","akar-icons":"b8xdj","luxon":"24mCD","./selectWrapper":"kJJH1","./radioFormInputs":"caW72","./tickbox":"aNE2q","./formError":"CPMpt","./iconPicker":"00ZlL","./remainingLeave":"81sT4","./svg":"4pImm","./colourPicker":"1KGGL","./absenceTypePicker":"i3epP","./periodOverride":"iVM6N","./notice":"bnY7j","./workPatternSpecificsMatrix":"cUp8u","./payReviewMatrix":"3oijc","../hooks/useStore":"l1Yj7","1968c7935e439b29":"6NoBQ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kJJH1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _akarIcons = require("akar-icons");
var _select = require("./select");
var _selectDefault = parcelHelpers.interopDefault(_select);
const SelectWrapper = ({ name, value, options: initOptions, required, isDisabled, creatable, autoFocus, renderTrigger, isMulti, setValue, placeholder, onEditFieldChange, onChange, onKeyDown })=>{
    value === null || value === void 0 ? true : delete value.colour;
    const [currentValue, setCurrentValue] = (0, _react.useState)(value);
    (0, _react.useEffect)(()=>{
        setCurrentValue(value);
        setValue && setValue(name, value);
    }, [
        value
    ]);
    const doChangeValue = (val)=>{
        const newValue = Array.isArray(val) ? [
            ...val
        ] : val && typeof val === "object" ? {
            ...val
        } : val !== null && val !== void 0 ? val : null;
        setCurrentValue(newValue);
        setValue && setValue(name, newValue);
        if (onEditFieldChange && !isMulti) onEditFieldChange(null, (newValue === null || newValue === void 0 ? void 0 : newValue.label) || newValue);
        if (onChange && !isMulti) onChange(newValue);
    };
    // if we're using a multi select, trigger change on blur instead
    const onBlur = isMulti && (onChange || onEditFieldChange) ? (val)=>{
        if (onEditFieldChange) onEditFieldChange(null, (val === null || val === void 0 ? void 0 : val.label) || val);
        if (onChange) onChange(val);
    } : null;
    const options = initOptions === null || initOptions === void 0 ? void 0 : initOptions.map((option)=>{
        let { label, value, colour } = option;
        if (colour) {
            const iconStyle = {
                color: colour,
                marginRight: "1rem"
            };
            label = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.CircleFill), {
                        size: 10,
                        style: iconStyle
                    }),
                    label
                ]
            });
        }
        const returnOption = {
            label,
            value
        };
        return returnOption;
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
        required: required,
        isDisabled: isDisabled,
        creatable: creatable,
        options: options,
        value: currentValue,
        autoFocus: autoFocus,
        className: "select",
        menuPlacement: "auto",
        placeholder: placeholder,
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: 60
                })
        },
        menuPortalTarget: document.body,
        isMulti: isMulti,
        onChange: doChangeValue,
        onBlur: onBlur,
        onKeyDown: onKeyDown
    }, renderTrigger);
};
exports.default = SelectWrapper;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","akar-icons":"b8xdj","./select":"585wy","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"585wy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _creatable = require("react-select/creatable");
var _creatableDefault = parcelHelpers.interopDefault(_creatable);
//when dropdown is not manually clicked then it does not scroll into view
const onMenuOpen = ()=>{
    setTimeout(()=>{
        const selectedEl = document.getElementsByClassName("select__option--is-selected")[0];
        if (selectedEl) selectedEl.parentNode.scrollTop = selectedEl.offsetTop;
    }, 1);
};
const Select = (props)=>{
    const selectRef = (0, _react.useRef)(null);
    const currentSelectRef = (props === null || props === void 0 ? void 0 : props.htmlRef) || selectRef;
    const doBlur = ()=>{
        var _currentSelectRef_current;
        if (props === null || props === void 0 ? void 0 : props.onBlur) props.onBlur(currentSelectRef === null || currentSelectRef === void 0 ? void 0 : (_currentSelectRef_current = currentSelectRef.current) === null || _currentSelectRef_current === void 0 ? void 0 : _currentSelectRef_current.getValue());
    };
    const closeMenuOnSelect = (props === null || props === void 0 ? void 0 : props.isMulti) ? false : true;
    var _props_isClearable;
    const selectProps = {
        ...props,
        closeMenuOnSelect,
        ignoreAccents: false,
        classNamePrefix: "select",
        isClearable: (_props_isClearable = props.isClearable) !== null && _props_isClearable !== void 0 ? _props_isClearable : true,
        ref: currentSelectRef,
        onMenuOpen: onMenuOpen,
        onBlur: doBlur
    };
    if (props.creatable) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _creatableDefault.default), {
        ...selectProps,
        styles: {
            ...props.styles,
            option: (provided, state)=>state.data.__isNew__ ? {
                    ...provided,
                    ...props.styles,
                    backgroundColor: "var(--colour-buttons) !important",
                    color: "var(--colour-buttons-text) !important",
                    fontWeight: "bold",
                    borderRadius: "var(--border-radius-small)",
                    cursor: "pointer"
                } : provided
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
        ...selectProps
    });
};
exports.default = Select;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","react-select":"7k7ya","react-select/creatable":"k7RZu","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7k7ya":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStateManager", ()=>(0, _useStateManager7E1E8489EsmJs.u));
parcelHelpers.export(exports, "createFilter", ()=>(0, _selectEf7C0426EsmJs.c));
parcelHelpers.export(exports, "defaultTheme", ()=>(0, _selectEf7C0426EsmJs.d));
parcelHelpers.export(exports, "mergeStyles", ()=>(0, _selectEf7C0426EsmJs.m));
parcelHelpers.export(exports, "components", ()=>(0, _index641Ee5B8EsmJs.c));
parcelHelpers.export(exports, "NonceProvider", ()=>NonceProvider);
parcelHelpers.export(exports, "default", ()=>StateManagedSelect$1);
var _useStateManager7E1E8489EsmJs = require("./useStateManager-7e1e8489.esm.js");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _selectEf7C0426EsmJs = require("./Select-ef7c0426.esm.js");
var _react1 = require("@emotion/react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _index641Ee5B8EsmJs = require("./index-641ee5b8.esm.js");
var _objectSpread2 = require("@babel/runtime/helpers/objectSpread2");
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _createClass = require("@babel/runtime/helpers/createClass");
var _inherits = require("@babel/runtime/helpers/inherits");
var _createSuper = require("@babel/runtime/helpers/createSuper");
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _memoizeOne = require("memoize-one");
var _typeof = require("@babel/runtime/helpers/typeof");
var _taggedTemplateLiteral = require("@babel/runtime/helpers/taggedTemplateLiteral");
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var StateManagedSelect = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, _useStateManager7E1E8489EsmJs.u)(props);
    return /*#__PURE__*/ _react.createElement((0, _selectEf7C0426EsmJs.S), (0, _extendsDefault.default)({
        ref: ref
    }, baseSelectProps));
});
var StateManagedSelect$1 = StateManagedSelect;
var NonceProvider = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, _react.useMemo)(function() {
        return (0, _cacheDefault.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ _react.createElement((0, _react1.CacheProvider), {
        value: emotionCache
    }, children);
};

},{"./useStateManager-7e1e8489.esm.js":"3I33q","@babel/runtime/helpers/esm/extends":"dMXQY","react":"6wC8C","./Select-ef7c0426.esm.js":"hl7m3","@emotion/react":"7QoHu","@emotion/cache":"iU54n","./index-641ee5b8.esm.js":false,"@babel/runtime/helpers/objectSpread2":"kvorf","@babel/runtime/helpers/slicedToArray":"9gUJv","@babel/runtime/helpers/objectWithoutProperties":"62gm1","@babel/runtime/helpers/classCallCheck":"cHkbO","@babel/runtime/helpers/createClass":"lI4fG","@babel/runtime/helpers/inherits":"drK9a","@babel/runtime/helpers/createSuper":"hpHBD","@babel/runtime/helpers/toConsumableArray":"lIlWW","memoize-one":"giD7z","@babel/runtime/helpers/typeof":"5VoYe","@babel/runtime/helpers/taggedTemplateLiteral":"cxYL1","@babel/runtime/helpers/defineProperty":"eEvLO","react-dom":"7k58v","@floating-ui/dom":"js5Ws","use-isomorphic-layout-effect":"ld1Ps","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3I33q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "u", ()=>useStateManager);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _react = require("react");
var _excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function useStateManager(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded);
    var _useState = (0, _react.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, _react.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, _slicedToArrayDefault.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, _react.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, _slicedToArrayDefault.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, _react.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, _react.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, _react.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, _react.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

},{"@babel/runtime/helpers/esm/objectSpread2":"3il2o","@babel/runtime/helpers/esm/slicedToArray":"f36Pa","@babel/runtime/helpers/esm/objectWithoutProperties":"hVKX3","react":"6wC8C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3il2o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectSpread2);
var _definePropertyJs = require("./defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _definePropertyJsDefault.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

},{"./defineProperty.js":"aDrSw","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"aDrSw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_defineProperty);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(e, r, t) {
    return (r = (0, _toPropertyKeyJsDefault.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

},{"./toPropertyKey.js":"4UKWv","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4UKWv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPropertyKey);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : i + "";
}

},{"./typeof.js":"3YNfM","./toPrimitive.js":"absHh","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3YNfM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_typeof);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"absHh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPrimitive);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"3YNfM","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"f36Pa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_slicedToArray);
var _arrayWithHolesJs = require("./arrayWithHoles.js");
var _arrayWithHolesJsDefault = parcelHelpers.interopDefault(_arrayWithHolesJs);
var _iterableToArrayLimitJs = require("./iterableToArrayLimit.js");
var _iterableToArrayLimitJsDefault = parcelHelpers.interopDefault(_iterableToArrayLimitJs);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
var _nonIterableRestJs = require("./nonIterableRest.js");
var _nonIterableRestJsDefault = parcelHelpers.interopDefault(_nonIterableRestJs);
function _slicedToArray(r, e) {
    return (0, _arrayWithHolesJsDefault.default)(r) || (0, _iterableToArrayLimitJsDefault.default)(r, e) || (0, _unsupportedIterableToArrayJsDefault.default)(r, e) || (0, _nonIterableRestJsDefault.default)();
}

},{"./arrayWithHoles.js":"diNRb","./iterableToArrayLimit.js":"6Gf3n","./unsupportedIterableToArray.js":"ff954","./nonIterableRest.js":"33YfX","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"diNRb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayWithHoles);
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6Gf3n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_iterableToArrayLimit);
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ff954":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_unsupportedIterableToArray);
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, _arrayLikeToArrayJsDefault.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, _arrayLikeToArrayJsDefault.default)(r, a) : void 0;
    }
}

},{"./arrayLikeToArray.js":"arI5i","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"arI5i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayLikeToArray);
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"33YfX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_nonIterableRest);
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hVKX3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutProperties);
var _objectWithoutPropertiesLooseJs = require("./objectWithoutPropertiesLoose.js");
var _objectWithoutPropertiesLooseJsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLooseJs);
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = (0, _objectWithoutPropertiesLooseJsDefault.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

},{"./objectWithoutPropertiesLoose.js":"7WHlQ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hl7m3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>Select);
parcelHelpers.export(exports, "a", ()=>defaultProps);
parcelHelpers.export(exports, "b", ()=>getOptionLabel$1);
parcelHelpers.export(exports, "c", ()=>createFilter);
parcelHelpers.export(exports, "d", ()=>defaultTheme);
parcelHelpers.export(exports, "g", ()=>getOptionValue$1);
parcelHelpers.export(exports, "m", ()=>mergeStyles);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _react = require("react");
var _index641Ee5B8EsmJs = require("./index-641ee5b8.esm.js");
var _react1 = require("@emotion/react");
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
function _EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var _ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var A11yText = function A11yText(props) {
    return (0, _react1.jsx)("span", (0, _extendsDefault.default)({
        css: _ref
    }, props));
};
var A11yText$1 = A11yText;
var defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, _react.useMemo)(function() {
        return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, _react.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, _objectSpread2Default.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, _react.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, _react.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, _react.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, _react1.jsx)((0, _react.Fragment), null, (0, _react1.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, _react1.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, _react1.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, _react1.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, _react1.jsx)((0, _react.Fragment), null, (0, _react1.jsx)(A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, _react1.jsx)(A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var LiveRegion$1 = LiveRegion;
var diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var anyDiacritic = new RegExp('[' + diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};
for(var i = 0; i < diacritics.length; i++){
    var diacritic = diacritics[i];
    for(var j = 0; j < diacritic.letters.length; j++)diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
var stripDiacritics = function stripDiacritics(str) {
    return str.replace(anyDiacritic, function(match) {
        return diacriticToBase[match];
    });
};
var memoizedStripDiacriticsForInput = (0, _memoizeOneDefault.default)(stripDiacritics);
var trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, _objectSpread2Default.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? trimString(rawInput) : rawInput;
        var candidate = trim ? trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = memoizedStripDiacriticsForInput(input);
            candidate = stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var _excluded = [
    "innerRef"
];
function DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, _index641Ee5B8EsmJs.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, _react1.jsx)("input", (0, _extendsDefault.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, _react1.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, _react.useRef)(false);
    var isTop = (0, _react.useRef)(false);
    var touchStart = (0, _react.useRef)(0);
    var scrollTarget = (0, _react.useRef)(null);
    var handleEventDelta = (0, _react.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, _react.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, _react.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, _react.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, _react.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, _index641Ee5B8EsmJs.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, _react.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, _react.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function allowTouchMove(e) {
    e.stopPropagation();
}
function preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
    capture: false,
    passive: false
};
function useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, _react.useRef)({});
    var scrollTarget = (0, _react.useRef)(null);
    var addScrollLock = (0, _react.useCallback)(function(touchScrollTarget) {
        if (!canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys(LOCK_STYLES).forEach(function(key) {
                var val = LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', preventTouchMove, listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
                touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
            }
        }
        // increment active scroll locks
        activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, _react.useCallback)(function(touchScrollTarget) {
        if (!canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        activeScrollLocks = Math.max(activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && activeScrollLocks < 1) STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && isTouchDevice()) {
            target.removeEventListener('touchmove', preventTouchMove, listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, _react.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var _ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, _react1.jsx)((0, _react.Fragment), null, lockEnabled && (0, _react1.jsx)("div", {
        onClick: blurSelectInput,
        css: _ref2$1
    }), children(targetRef));
}
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, _react1.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: _ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var RequiredInput$1 = RequiredInput;
/// <reference types="user-agent-data-types" />
function testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function isIPhone() {
    return testPlatform(/^iPhone/i);
}
function isMac() {
    return testPlatform(/^Mac/i);
}
function isIPad() {
    return testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    isMac() && navigator.maxTouchPoints > 1;
}
function isIOS() {
    return isIPhone() || isIPad();
}
function isAppleDevice() {
    return isMac() || isIOS();
}
var formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
    return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
    return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var defaultStyles = {
    clearIndicator: (0, _index641Ee5B8EsmJs.a),
    container: (0, _index641Ee5B8EsmJs.b),
    control: (0, _index641Ee5B8EsmJs.d),
    dropdownIndicator: (0, _index641Ee5B8EsmJs.e),
    group: (0, _index641Ee5B8EsmJs.g),
    groupHeading: (0, _index641Ee5B8EsmJs.f),
    indicatorsContainer: (0, _index641Ee5B8EsmJs.i),
    indicatorSeparator: (0, _index641Ee5B8EsmJs.h),
    input: (0, _index641Ee5B8EsmJs.j),
    loadingIndicator: (0, _index641Ee5B8EsmJs.l),
    loadingMessage: (0, _index641Ee5B8EsmJs.k),
    menu: (0, _index641Ee5B8EsmJs.m),
    menuList: (0, _index641Ee5B8EsmJs.n),
    menuPortal: (0, _index641Ee5B8EsmJs.o),
    multiValue: (0, _index641Ee5B8EsmJs.p),
    multiValueLabel: (0, _index641Ee5B8EsmJs.q),
    multiValueRemove: (0, _index641Ee5B8EsmJs.t),
    noOptionsMessage: (0, _index641Ee5B8EsmJs.u),
    option: (0, _index641Ee5B8EsmJs.v),
    placeholder: (0, _index641Ee5B8EsmJs.w),
    singleValue: (0, _index641Ee5B8EsmJs.x),
    valueContainer: (0, _index641Ee5B8EsmJs.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function mergeStyles(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, _objectSpread2Default.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var baseUnit = 4;
// The minimum height of the control
var controlHeight = 38;
// The amount of space between the control and menu */
var menuGutter = baseUnit * 2;
var spacing = {
    baseUnit: baseUnit,
    controlHeight: controlHeight,
    menuGutter: menuGutter
};
var defaultTheme = {
    borderRadius: borderRadius,
    colors: colors,
    spacing: spacing
};
var defaultProps = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, _index641Ee5B8EsmJs.z)(),
    captureMenuScroll: !(0, _index641Ee5B8EsmJs.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: createFilter(),
    formatGroupLabel: formatGroupLabel,
    getOptionLabel: getOptionLabel$1,
    getOptionValue: getOptionValue$1,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, _index641Ee5B8EsmJs.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = _isOptionDisabled(props, option, selectValue);
    var isSelected = _isOptionSelected(props, option, selectValue);
    var label = getOptionLabel(props, option);
    var value = getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, _index641Ee5B8EsmJs.K));
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, _toConsumableArrayDefault.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, _toConsumableArrayDefault.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function buildFocusableOptions(props, selectValue) {
    return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = getOptionValue(props, option);
    return selectValue.some(function(i) {
        return getOptionValue(props, i) === candidate;
    });
}
function _filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var instanceId = 1;
var Select = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(Select, _Component);
    var _super = (0, _createSuperDefault.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, _classCallCheckDefault.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: '',
            isAppleDevice: false
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, _index641Ee5B8EsmJs.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, _index641Ee5B8EsmJs.B)([].concat((0, _toConsumableArrayDefault.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, _index641Ee5B8EsmJs.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, _index641Ee5B8EsmJs.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, _index641Ee5B8EsmJs.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, _index641Ee5B8EsmJs.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, _index641Ee5B8EsmJs.D)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return buildFocusableOptionsWithIds(buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, _index641Ee5B8EsmJs.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, _index641Ee5B8EsmJs.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, _objectSpread2Default.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, _index641Ee5B8EsmJs.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
        _this.state.selectValue = (0, _index641Ee5B8EsmJs.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, _createClassDefault.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, _index641Ee5B8EsmJs.I)(this.menuListRef, this.focusedOptionRef);
                if (isAppleDevice()) // eslint-disable-next-line react/no-did-mount-set-state
                this.setState({
                    isAppleDevice: true
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, _index641Ee5B8EsmJs.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return defaultTheme;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme(defaultTheme);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, defaultTheme), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return _isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return _isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return _filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.state.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ _react.createElement(DummyInput, (0, _extendsDefault.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, _index641Ee5B8EsmJs.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ _react.createElement(Input, (0, _extendsDefault.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ _react.createElement(Placeholder, (0, _extendsDefault.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ _react.createElement(MultiValue, (0, _extendsDefault.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ _react.createElement(SingleValue, (0, _extendsDefault.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ _react.createElement(ClearIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ _react.createElement(LoadingIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ _react.createElement(IndicatorSeparator, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ _react.createElement(DropdownIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.state.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ _react.createElement(Option, (0, _extendsDefault.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ _react.createElement(Group, (0, _extendsDefault.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ _react.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ _react.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ _react.createElement((0, _index641Ee5B8EsmJs.M), (0, _extendsDefault.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ _react.createElement(Menu, (0, _extendsDefault.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ _react.createElement(ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ _react.createElement(MenuList, (0, _extendsDefault.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ _react.createElement(MenuPortal, (0, _extendsDefault.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ _react.createElement(RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ _react.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ _react.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ _react.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ _react.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ _react.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ _react.createElement(LiveRegion$1, (0, _extendsDefault.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.state.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ _react.createElement(SelectContainer, (0, _extendsDefault.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ _react.createElement(Control, (0, _extendsDefault.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ _react.createElement(ValueContainer, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ _react.createElement(IndicatorsContainer, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, _index641Ee5B8EsmJs.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? buildFocusableOptionsWithIds(buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, _index641Ee5B8EsmJs.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, _react.Component));
Select.defaultProps = defaultProps;

},{"@babel/runtime/helpers/esm/extends":"dMXQY","@babel/runtime/helpers/esm/objectSpread2":"3il2o","@babel/runtime/helpers/esm/classCallCheck":"huHb5","@babel/runtime/helpers/esm/createClass":"8N42c","@babel/runtime/helpers/esm/inherits":"9DBVP","@babel/runtime/helpers/esm/createSuper":"bDxpq","@babel/runtime/helpers/esm/toConsumableArray":"er2bj","react":"6wC8C","./index-641ee5b8.esm.js":"4oJfS","@emotion/react":"7QoHu","memoize-one":"giD7z","@babel/runtime/helpers/esm/objectWithoutProperties":"hVKX3","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"huHb5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_classCallCheck);
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8N42c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createClass);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, _toPropertyKeyJsDefault.default)(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

},{"./toPropertyKey.js":"4UKWv","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9DBVP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inherits);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, _setPrototypeOfJsDefault.default)(t, e);
}

},{"./setPrototypeOf.js":"6G96F","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"bDxpq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createSuper);
var _getPrototypeOfJs = require("./getPrototypeOf.js");
var _getPrototypeOfJsDefault = parcelHelpers.interopDefault(_getPrototypeOfJs);
var _isNativeReflectConstructJs = require("./isNativeReflectConstruct.js");
var _isNativeReflectConstructJsDefault = parcelHelpers.interopDefault(_isNativeReflectConstructJs);
var _possibleConstructorReturnJs = require("./possibleConstructorReturn.js");
var _possibleConstructorReturnJsDefault = parcelHelpers.interopDefault(_possibleConstructorReturnJs);
function _createSuper(t) {
    var r = (0, _isNativeReflectConstructJsDefault.default)();
    return function() {
        var e, o = (0, _getPrototypeOfJsDefault.default)(t);
        if (r) {
            var s = (0, _getPrototypeOfJsDefault.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, _possibleConstructorReturnJsDefault.default)(this, e);
    };
}

},{"./getPrototypeOf.js":"fnAGK","./isNativeReflectConstruct.js":"92Qof","./possibleConstructorReturn.js":"jzLbz","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fnAGK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_getPrototypeOf);
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"92Qof":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isNativeReflectConstruct);
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"jzLbz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_possibleConstructorReturn);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _assertThisInitializedJs = require("./assertThisInitialized.js");
var _assertThisInitializedJsDefault = parcelHelpers.interopDefault(_assertThisInitializedJs);
function _possibleConstructorReturn(t, e) {
    if (e && ("object" == (0, _typeofJsDefault.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, _assertThisInitializedJsDefault.default)(t);
}

},{"./typeof.js":"3YNfM","./assertThisInitialized.js":"bhShD","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"bhShD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertThisInitialized);
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"er2bj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_toConsumableArray);
var _arrayWithoutHolesJs = require("./arrayWithoutHoles.js");
var _arrayWithoutHolesJsDefault = parcelHelpers.interopDefault(_arrayWithoutHolesJs);
var _iterableToArrayJs = require("./iterableToArray.js");
var _iterableToArrayJsDefault = parcelHelpers.interopDefault(_iterableToArrayJs);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
var _nonIterableSpreadJs = require("./nonIterableSpread.js");
var _nonIterableSpreadJsDefault = parcelHelpers.interopDefault(_nonIterableSpreadJs);
function _toConsumableArray(r) {
    return (0, _arrayWithoutHolesJsDefault.default)(r) || (0, _iterableToArrayJsDefault.default)(r) || (0, _unsupportedIterableToArrayJsDefault.default)(r) || (0, _nonIterableSpreadJsDefault.default)();
}

},{"./arrayWithoutHoles.js":"aYsl7","./iterableToArray.js":"2FHmd","./unsupportedIterableToArray.js":"ff954","./nonIterableSpread.js":"wJY36","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"aYsl7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayWithoutHoles);
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return (0, _arrayLikeToArrayJsDefault.default)(r);
}

},{"./arrayLikeToArray.js":"arI5i","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2FHmd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_iterableToArray);
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"wJY36":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_nonIterableSpread);
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4oJfS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "A", ()=>isMobileDevice);
parcelHelpers.export(exports, "B", ()=>multiValueAsValue);
parcelHelpers.export(exports, "C", ()=>singleValueAsValue);
parcelHelpers.export(exports, "D", ()=>valueTernary);
parcelHelpers.export(exports, "E", ()=>classNames);
parcelHelpers.export(exports, "F", ()=>defaultComponents);
parcelHelpers.export(exports, "G", ()=>isDocumentElement);
parcelHelpers.export(exports, "H", ()=>cleanValue);
parcelHelpers.export(exports, "I", ()=>scrollIntoView);
parcelHelpers.export(exports, "J", ()=>noop);
parcelHelpers.export(exports, "K", ()=>notNullish);
parcelHelpers.export(exports, "L", ()=>handleInputChange);
parcelHelpers.export(exports, "M", ()=>MenuPlacer);
parcelHelpers.export(exports, "a", ()=>clearIndicatorCSS);
parcelHelpers.export(exports, "b", ()=>containerCSS);
parcelHelpers.export(exports, "c", ()=>components);
parcelHelpers.export(exports, "d", ()=>css$1);
parcelHelpers.export(exports, "e", ()=>dropdownIndicatorCSS);
parcelHelpers.export(exports, "f", ()=>groupHeadingCSS);
parcelHelpers.export(exports, "g", ()=>groupCSS);
parcelHelpers.export(exports, "h", ()=>indicatorSeparatorCSS);
parcelHelpers.export(exports, "i", ()=>indicatorsContainerCSS);
parcelHelpers.export(exports, "j", ()=>inputCSS);
parcelHelpers.export(exports, "k", ()=>loadingMessageCSS);
parcelHelpers.export(exports, "l", ()=>loadingIndicatorCSS);
parcelHelpers.export(exports, "m", ()=>menuCSS);
parcelHelpers.export(exports, "n", ()=>menuListCSS);
parcelHelpers.export(exports, "o", ()=>menuPortalCSS);
parcelHelpers.export(exports, "p", ()=>multiValueCSS);
parcelHelpers.export(exports, "q", ()=>multiValueLabelCSS);
parcelHelpers.export(exports, "r", ()=>removeProps);
parcelHelpers.export(exports, "s", ()=>supportsPassiveEvents);
parcelHelpers.export(exports, "t", ()=>multiValueRemoveCSS);
parcelHelpers.export(exports, "u", ()=>noOptionsMessageCSS);
parcelHelpers.export(exports, "v", ()=>optionCSS);
parcelHelpers.export(exports, "w", ()=>placeholderCSS);
parcelHelpers.export(exports, "x", ()=>css);
parcelHelpers.export(exports, "y", ()=>valueContainerCSS);
parcelHelpers.export(exports, "z", ()=>isTouchCapable);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _taggedTemplateLiteral = require("@babel/runtime/helpers/esm/taggedTemplateLiteral");
var _taggedTemplateLiteralDefault = parcelHelpers.interopDefault(_taggedTemplateLiteral);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react1 = require("react");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var _useIsomorphicLayoutEffectDefault = parcelHelpers.interopDefault(_useIsomorphicLayoutEffect);
var _excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function classNames(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat(applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var cleanValue = function cleanValue(value) {
    if (isArray(value)) return value.filter(Boolean);
    if ((0, _typeofDefault.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, _objectWithoutPropertiesDefault.default)(props, _excluded$4);
    return (0, _objectSpread2Default.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function normalizedHeight(el) {
    if (isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function getScrollTop(el) {
    if (isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if (isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
    var start = getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = easeOutCubic(currentTime, start, change, duration);
        scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function scrollIntoView(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var passiveOptionAccessed = false;
var options = {
    get passive () {
        return passiveOptionAccessed = true;
    }
};
// check for SSR
var w = typeof window !== 'undefined' ? window : {};
if (w.addEventListener && w.removeEventListener) {
    w.addEventListener('p', noop, options);
    w.removeEventListener('p', noop, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
    return item != null;
}
function isArray(arg) {
    return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
    return singleValue;
}
function multiValueAsValue(multiValue) {
    return multiValue;
}
var removeProps = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, _slicedToArrayDefault.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, _slicedToArrayDefault.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var _excluded$3 = [
    "children",
    "innerProps"
], _excluded2$1 = [
    "children",
    "innerProps"
];
function getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
    var scrollTop = getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var menuCSS = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, _objectSpread2Default.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, _definePropertyDefault.default)(_objectSpread2, alignToControl(placement), '100%'), (0, _definePropertyDefault.default)(_objectSpread2, "position", 'absolute'), (0, _definePropertyDefault.default)(_objectSpread2, "width", '100%'), (0, _definePropertyDefault.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var PortalPlacementContext = /*#__PURE__*/ (0, _react1.createContext)(null);
// NOTE: internal only
var MenuPlacer = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, _react1.useContext)(PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, _react1.useRef)(null);
    var _useState = (0, _react1.useState)(maxMenuHeight), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, _react1.useState)(null), _useState4 = (0, _slicedToArrayDefault.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, props), {}, {
            placement: placement || coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var Menu$1 = Menu;
// ==============================
// Menu List
// ==============================
var menuListCSS = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, _objectSpread2Default.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, _objectSpread2Default.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref6, _excluded$3);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref7, _excluded2$1);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var menuPortalCSS = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, _react1.useRef)(null);
    var cleanupRef = (0, _react1.useRef)(null);
    var _useState5 = (0, _react1.useState)(coercePlacement(menuPlacement)), _useState6 = (0, _slicedToArrayDefault.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, _react1.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, _react1.useState)(null), _useState8 = (0, _slicedToArrayDefault.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, _react1.useCallback)(function() {
        if (!controlElement) return;
        var rect = getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, _react1.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, _dom.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, _react1.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, _react.jsx)("div", (0, _extendsDefault.default)({
        ref: setMenuPortalElement
    }, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, _react.jsx)(PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, _reactDom.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var containerCSS = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var valueContainerCSS = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, _objectSpread2Default.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var indicatorsContainerCSS = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var _templateObject;
var _excluded$2 = [
    "size"
], _excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var _ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded$2);
    return (0, _react.jsx)("svg", (0, _extendsDefault.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: _ref2
    }, props));
};
var CrossIcon = function CrossIcon(props) {
    return (0, _react.jsx)(Svg, (0, _extendsDefault.default)({
        size: 20
    }, props), (0, _react.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var DownChevron = function DownChevron(props) {
    return (0, _react.jsx)(Svg, (0, _extendsDefault.default)({
        size: 20
    }, props), (0, _react.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, _react.jsx)(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, _react.jsx)(CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, _react.jsx)("span", (0, _extendsDefault.default)({}, innerProps, getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var loadingDotAnimations = (0, _react.keyframes)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralDefault.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, _objectSpread2Default.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, _react.jsx)("span", {
        css: /*#__PURE__*/ (0, _react.css)({
            animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref7, _excluded2);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, _react.jsx)(LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, _react.jsx)(LoadingDot, {
        delay: 160,
        offset: true
    }), (0, _react.jsx)(LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var css$1 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, _objectSpread2Default.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        ref: innerRef
    }, getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var Control$1 = Control;
var _excluded$1 = [
    "data"
];
var groupCSS = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, _react.jsx)(Heading, (0, _extendsDefault.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, _react.jsx)("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, _objectSpread2Default.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, _objectWithoutPropertiesDefault.default)(_cleanCommonProps, _excluded$1);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var Group$1 = Group;
var _excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var inputCSS = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, _objectSpread2Default.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, spacingStyle)
};
var inputStyle = function inputStyle(isHidden) {
    return (0, _objectSpread2Default.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, spacingStyle);
};
var Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, _objectWithoutPropertiesDefault.default)(_cleanCommonProps, _excluded);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, _react.jsx)("input", (0, _extendsDefault.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var Input$1 = Input;
var multiValueCSS = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, _objectSpread2Default.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, _objectSpread2Default.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, _react.jsx)("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        role: "button"
    }, innerProps), children || (0, _react.jsx)(CrossIcon, {
        size: 14
    }));
}
var MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, _react.jsx)(Container, {
        data: data,
        innerProps: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, _react.jsx)(Label, {
        data: data,
        innerProps: (0, _objectSpread2Default.default)({}, getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, _react.jsx)(Remove, {
        data: data,
        innerProps: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var MultiValue$1 = MultiValue;
var optionCSS = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var Option$1 = Option;
var placeholderCSS = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var Placeholder$1 = Placeholder;
var css = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var SingleValue$1 = SingleValue;
var components = {
    ClearIndicator: ClearIndicator,
    Control: Control$1,
    DropdownIndicator: DropdownIndicator,
    DownChevron: DownChevron,
    CrossIcon: CrossIcon,
    Group: Group$1,
    GroupHeading: GroupHeading,
    IndicatorsContainer: IndicatorsContainer,
    IndicatorSeparator: IndicatorSeparator,
    Input: Input$1,
    LoadingIndicator: LoadingIndicator,
    Menu: Menu$1,
    MenuList: MenuList,
    MenuPortal: MenuPortal,
    LoadingMessage: LoadingMessage,
    NoOptionsMessage: NoOptionsMessage,
    MultiValue: MultiValue$1,
    MultiValueContainer: MultiValueContainer,
    MultiValueLabel: MultiValueLabel,
    MultiValueRemove: MultiValueRemove,
    Option: Option$1,
    Placeholder: Placeholder$1,
    SelectContainer: SelectContainer,
    SingleValue: SingleValue$1,
    ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, components), props.components);
};

},{"@babel/runtime/helpers/esm/objectSpread2":"3il2o","@babel/runtime/helpers/esm/extends":"dMXQY","@emotion/react":"7QoHu","@babel/runtime/helpers/esm/slicedToArray":"f36Pa","@babel/runtime/helpers/esm/objectWithoutProperties":"hVKX3","@babel/runtime/helpers/esm/typeof":"3YNfM","@babel/runtime/helpers/esm/taggedTemplateLiteral":"7ObYc","@babel/runtime/helpers/esm/defineProperty":"aDrSw","react":"6wC8C","react-dom":"7k58v","@floating-ui/dom":"js5Ws","use-isomorphic-layout-effect":"ld1Ps","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7QoHu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheProvider", ()=>(0, _emotionElementD59E098FEsmJs.C));
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _emotionElementD59E098FEsmJs.T));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _emotionElementD59E098FEsmJs.b));
parcelHelpers.export(exports, "__unsafe_useEmotionCache", ()=>(0, _emotionElementD59E098FEsmJs._));
parcelHelpers.export(exports, "useTheme", ()=>(0, _emotionElementD59E098FEsmJs.u));
parcelHelpers.export(exports, "withEmotionCache", ()=>(0, _emotionElementD59E098FEsmJs.w));
parcelHelpers.export(exports, "withTheme", ()=>(0, _emotionElementD59E098FEsmJs.d));
parcelHelpers.export(exports, "ClassNames", ()=>ClassNames);
parcelHelpers.export(exports, "Global", ()=>Global);
parcelHelpers.export(exports, "createElement", ()=>jsx);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "jsx", ()=>jsx);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
var _emotionElementD59E098FEsmJs = require("./emotion-element-d59e098f.esm.js");
var _react = require("react");
var _utils = require("@emotion/utils");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _serialize = require("@emotion/serialize");
var _cache = require("@emotion/cache");
var _extends = require("@babel/runtime/helpers/extends");
var _weakMemoize = require("@emotion/weak-memoize");
var _emotionReactIsolatedHnrsEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var jsx = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, _emotionElementD59E098FEsmJs.h).call(props, 'css')) return _react.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, _emotionElementD59E098FEsmJs.E);
    createElementArgArray[1] = (0, _emotionElementD59E098FEsmJs.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return _react.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})(jsx || (jsx = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var Global = /* #__PURE__ */ (0, _emotionElementD59E098FEsmJs.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, _serialize.serializeStyles)([
        styles
    ], undefined, _react.useContext((0, _emotionElementD59E098FEsmJs.T)));
    if (!(0, _emotionElementD59E098FEsmJs.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ _react.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = _react.useRef();
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, _utils.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, _serialize.serializeStyles)(args);
}
function keyframes() {
    var insertable = css.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, _utils.insertStyles)(cache, serializedArr[i], false);
            if (!(0, _emotionElementD59E098FEsmJs.i) && res !== undefined) rules += res;
        }
        if (!(0, _emotionElementD59E098FEsmJs.i)) return rules;
    });
    if (!(0, _emotionElementD59E098FEsmJs.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ _react.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var ClassNames = /* #__PURE__ */ (0, _emotionElementD59E098FEsmJs.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, _emotionElementD59E098FEsmJs.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, _utils.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, _emotionElementD59E098FEsmJs.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return merge(cache.registered, css, classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: _react.useContext((0, _emotionElementD59E098FEsmJs.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

},{"./emotion-element-d59e098f.esm.js":"9Kk7q","react":"6wC8C","@emotion/utils":"1NWBp","@emotion/use-insertion-effect-with-fallbacks":"hlniG","@emotion/serialize":"50XQ5","@emotion/cache":"iU54n","@babel/runtime/helpers/extends":"jVkOb","@emotion/weak-memoize":"1tkfo","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js":"bifUP","hoist-non-react-statics":"bqi8K","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9Kk7q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "C", ()=>CacheProvider);
parcelHelpers.export(exports, "E", ()=>Emotion$1);
parcelHelpers.export(exports, "T", ()=>ThemeContext);
parcelHelpers.export(exports, "_", ()=>__unsafe_useEmotionCache);
parcelHelpers.export(exports, "a", ()=>isDevelopment);
parcelHelpers.export(exports, "b", ()=>ThemeProvider);
parcelHelpers.export(exports, "c", ()=>createEmotionProps);
parcelHelpers.export(exports, "d", ()=>withTheme);
parcelHelpers.export(exports, "h", ()=>hasOwn);
parcelHelpers.export(exports, "i", ()=>isBrowser);
parcelHelpers.export(exports, "u", ()=>useTheme);
parcelHelpers.export(exports, "w", ()=>withEmotionCache);
var _react = require("react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _emotionReactIsolatedHnrsEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js");
var _emotionReactIsolatedHnrsEsmJsDefault = parcelHelpers.interopDefault(_emotionReactIsolatedHnrsEsmJs);
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var isDevelopment = false;
var isBrowser = typeof document !== 'undefined';
var EmotionCacheContext = /* #__PURE__ */ _react.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, _cacheDefault.default)({
    key: 'css'
}) : null);
var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
    return (0, _react.useContext)(EmotionCacheContext);
};
var withEmotionCache = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, _react.useContext)(EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!isBrowser) withEmotionCache = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, _react.useContext)(EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, _cacheDefault.default)({
                key: 'css'
            });
            return /*#__PURE__*/ _react.createElement(EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var ThemeContext = /* #__PURE__ */ _react.createContext({});
var useTheme = function useTheme() {
    return _react.useContext(ThemeContext);
};
var getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, _extendsDefault.default)({}, outerTheme, theme);
};
var createCacheWithTheme = /* #__PURE__ */ (0, _weakMemoizeDefault.default)(function(outerTheme) {
    return (0, _weakMemoizeDefault.default)(function(theme) {
        return getTheme(outerTheme, theme);
    });
});
var ThemeProvider = function ThemeProvider(props) {
    var theme = _react.useContext(ThemeContext);
    if (props.theme !== theme) theme = createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ _react.createElement(ThemeContext.Provider, {
        value: theme
    }, props.children);
};
function withTheme(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ _react.forwardRef(function render(props, ref) {
        var theme = _react.useContext(ThemeContext);
        return /*#__PURE__*/ _react.createElement(Component, (0, _extendsDefault.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, _emotionReactIsolatedHnrsEsmJsDefault.default)(WithTheme, Component);
}
var hasOwn = {}.hasOwnProperty;
var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if (hasOwn.call(props, _key)) newProps[_key] = props[_key];
    newProps[typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    if (!isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ _react.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var Emotion = /* #__PURE__ */ withEmotionCache(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, _utils.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, _serialize.serializeStyles)(registeredStyles, undefined, _react.useContext(ThemeContext));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if (hasOwn.call(props, _key2) && _key2 !== 'css' && _key2 !== typePropName && !isDevelopment) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ _react.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;

},{"react":"6wC8C","@emotion/cache":"iU54n","@babel/runtime/helpers/esm/extends":"dMXQY","@emotion/weak-memoize":"1tkfo","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js":"bifUP","@emotion/utils":"1NWBp","@emotion/serialize":"50XQ5","@emotion/use-insertion-effect-with-fallbacks":"hlniG","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"iU54n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createCache);
var _sheet = require("@emotion/sheet");
var _stylis = require("stylis");
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var isBrowser = typeof document !== 'undefined';
var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, _stylis.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, _stylis.token)(character)) break;
        (0, _stylis.next)();
    }
    return (0, _stylis.slice)(begin, (0, _stylis.position));
};
var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, _stylis.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, _stylis.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += identifierWithPointTracking((0, _stylis.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, _stylis.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, _stylis.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, _stylis.from)(character);
    }
    while (character = (0, _stylis.next)());
    return parsed;
};
var getRules = function getRules(value, points) {
    return (0, _stylis.dealloc)(toRules((0, _stylis.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var fixedElements = /* #__PURE__ */ new WeakMap();
var compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function prefix(value, length) {
    switch((0, _stylis.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, _stylis.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, _stylis.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MOZ) + value + (0, _stylis.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
        // order
        case 6165:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.replace)(value, /(\w+).+(:[^]+)/, (0, _stylis.WEBKIT) + 'box-$1$2' + (0, _stylis.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-item-' + (0, _stylis.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-line-pack' + (0, _stylis.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, _stylis.WEBKIT) + 'box-' + (0, _stylis.replace)(value, '-grow', '') + (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, _stylis.WEBKIT) + (0, _stylis.replace)(value, /([^-])(transform)/g, '$1' + (0, _stylis.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, _stylis.replace)((0, _stylis.replace)((0, _stylis.replace)(value, /(zoom-|grab)/, (0, _stylis.WEBKIT) + '$1'), /(image-set)/, (0, _stylis.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, _stylis.replace)(value, /(image-set\([^]*)/, (0, _stylis.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, _stylis.replace)((0, _stylis.replace)(value, /(.+:)(flex-)?(.*)/, (0, _stylis.WEBKIT) + 'box-pack:$3' + (0, _stylis.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, _stylis.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, _stylis.replace)(value, /(.+)-inline(.+)/, (0, _stylis.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, _stylis.strlen)(value) - 1 - length > 6) switch((0, _stylis.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, _stylis.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, _stylis.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, _stylis.WEBKIT) + '$2-$3' + '$1' + (0, _stylis.MOZ) + ((0, _stylis.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, _stylis.indexof)(value, 'stretch') ? prefix((0, _stylis.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, _stylis.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, _stylis.charat)(value, (0, _stylis.strlen)(value) - 3 - (~(0, _stylis.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, _stylis.replace)(value, ':', ':' + (0, _stylis.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, _stylis.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, _stylis.WEBKIT) + ((0, _stylis.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, _stylis.WEBKIT) + '$2$3' + '$1' + (0, _stylis.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, _stylis.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
    }
    return value;
}
var prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, _stylis.DECLARATION:
                element["return"] = prefix(element.value, element.length);
                break;
            case 0, _stylis.KEYFRAMES:
                return (0, _stylis.serialize)([
                    (0, _stylis.copy)(element, {
                        value: (0, _stylis.replace)(element.value, '@', '@' + (0, _stylis.WEBKIT))
                    })
                ], callback);
            case 0, _stylis.RULESET:
                if (element.length) return (0, _stylis.combine)(element.props, function(value) {
                    switch((0, _stylis.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(read-\w+)/, ':' + (0, _stylis.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ':' + (0, _stylis.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ':' + (0, _stylis.MOZ) + '$1')
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, (0, _stylis.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var getServerStylisCache = isBrowser ? undefined : (0, _weakMemoizeDefault.default)(function() {
    return (0, _memoizeDefault.default)(function() {
        return {};
    });
});
var defaultStylisPlugins = [
    prefixer
];
var createCache = function createCache(options) {
    var key = options.key;
    if (isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if (isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        compat,
        removeLabel
    ];
    if (!getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, _stylis.stringify),
            (0, _stylis.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, _stylis.serialize)((0, _stylis.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, _stylis.stringify)
        ];
        var _serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis1 = function _stylis1(styles) {
            return (0, _stylis.serialize)((0, _stylis.compile)(styles), _serializer);
        };
        var serverStylisCache = getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis1(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

},{"@emotion/sheet":"i6lwY","stylis":"5Hauq","@emotion/weak-memoize":"1tkfo","@emotion/memoize":"2zzxT","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"i6lwY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
var isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag(createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5Hauq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHARSET", ()=>f);
parcelHelpers.export(exports, "COMMENT", ()=>n);
parcelHelpers.export(exports, "COUNTER_STYLE", ()=>w);
parcelHelpers.export(exports, "DECLARATION", ()=>s);
parcelHelpers.export(exports, "DOCUMENT", ()=>v);
parcelHelpers.export(exports, "FONT_FACE", ()=>b);
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", ()=>d);
parcelHelpers.export(exports, "IMPORT", ()=>i);
parcelHelpers.export(exports, "KEYFRAMES", ()=>h);
parcelHelpers.export(exports, "LAYER", ()=>$);
parcelHelpers.export(exports, "MEDIA", ()=>u);
parcelHelpers.export(exports, "MOZ", ()=>r);
parcelHelpers.export(exports, "MS", ()=>e);
parcelHelpers.export(exports, "NAMESPACE", ()=>p);
parcelHelpers.export(exports, "PAGE", ()=>t);
parcelHelpers.export(exports, "RULESET", ()=>c);
parcelHelpers.export(exports, "SUPPORTS", ()=>l);
parcelHelpers.export(exports, "VIEWPORT", ()=>o);
parcelHelpers.export(exports, "WEBKIT", ()=>a);
parcelHelpers.export(exports, "abs", ()=>g);
parcelHelpers.export(exports, "alloc", ()=>V);
parcelHelpers.export(exports, "append", ()=>q);
parcelHelpers.export(exports, "assign", ()=>m);
parcelHelpers.export(exports, "caret", ()=>R);
parcelHelpers.export(exports, "char", ()=>L);
parcelHelpers.export(exports, "character", ()=>H);
parcelHelpers.export(exports, "characters", ()=>I);
parcelHelpers.export(exports, "charat", ()=>O);
parcelHelpers.export(exports, "column", ()=>E);
parcelHelpers.export(exports, "combine", ()=>B);
parcelHelpers.export(exports, "comment", ()=>ue);
parcelHelpers.export(exports, "commenter", ()=>ae);
parcelHelpers.export(exports, "compile", ()=>ce);
parcelHelpers.export(exports, "copy", ()=>K);
parcelHelpers.export(exports, "dealloc", ()=>W);
parcelHelpers.export(exports, "declaration", ()=>ie);
parcelHelpers.export(exports, "delimit", ()=>X);
parcelHelpers.export(exports, "delimiter", ()=>re);
parcelHelpers.export(exports, "escaping", ()=>ee);
parcelHelpers.export(exports, "from", ()=>k);
parcelHelpers.export(exports, "hash", ()=>x);
parcelHelpers.export(exports, "identifier", ()=>ne);
parcelHelpers.export(exports, "indexof", ()=>C);
parcelHelpers.export(exports, "length", ()=>F);
parcelHelpers.export(exports, "line", ()=>D);
parcelHelpers.export(exports, "match", ()=>j);
parcelHelpers.export(exports, "middleware", ()=>ve);
parcelHelpers.export(exports, "namespace", ()=>be);
parcelHelpers.export(exports, "next", ()=>P);
parcelHelpers.export(exports, "node", ()=>J);
parcelHelpers.export(exports, "parse", ()=>se);
parcelHelpers.export(exports, "peek", ()=>Q);
parcelHelpers.export(exports, "position", ()=>G);
parcelHelpers.export(exports, "prefix", ()=>fe);
parcelHelpers.export(exports, "prefixer", ()=>he);
parcelHelpers.export(exports, "prev", ()=>N);
parcelHelpers.export(exports, "replace", ()=>z);
parcelHelpers.export(exports, "ruleset", ()=>te);
parcelHelpers.export(exports, "rulesheet", ()=>pe);
parcelHelpers.export(exports, "serialize", ()=>oe);
parcelHelpers.export(exports, "sizeof", ()=>S);
parcelHelpers.export(exports, "slice", ()=>T);
parcelHelpers.export(exports, "stringify", ()=>le);
parcelHelpers.export(exports, "strlen", ()=>M);
parcelHelpers.export(exports, "substr", ()=>A);
parcelHelpers.export(exports, "token", ()=>U);
parcelHelpers.export(exports, "tokenize", ()=>Y);
parcelHelpers.export(exports, "tokenizer", ()=>_);
parcelHelpers.export(exports, "trim", ()=>y);
parcelHelpers.export(exports, "whitespace", ()=>Z);
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var n = "comm";
var c = "rule";
var s = "decl";
var t = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var v = "@document";
var p = "@namespace";
var h = "@keyframes";
var b = "@font-face";
var w = "@counter-style";
var d = "@font-feature-values";
var $ = "@layer";
var g = Math.abs;
var k = String.fromCharCode;
var m = Object.assign;
function x(e, r) {
    return O(e, 0) ^ 45 ? (((r << 2 ^ O(e, 0)) << 2 ^ O(e, 1)) << 2 ^ O(e, 2)) << 2 ^ O(e, 3) : 0;
}
function y(e) {
    return e.trim();
}
function j(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function z(e, r, a) {
    return e.replace(r, a);
}
function C(e, r) {
    return e.indexOf(r);
}
function O(e, r) {
    return e.charCodeAt(r) | 0;
}
function A(e, r, a) {
    return e.slice(r, a);
}
function M(e) {
    return e.length;
}
function S(e) {
    return e.length;
}
function q(e, r) {
    return r.push(e), e;
}
function B(e, r) {
    return e.map(r).join("");
}
var D = 1;
var E = 1;
var F = 0;
var G = 0;
var H = 0;
var I = "";
function J(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: D,
        column: E,
        length: t,
        return: ""
    };
}
function K(e, r) {
    return m(J("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function L() {
    return H;
}
function N() {
    H = G > 0 ? O(I, --G) : 0;
    if (E--, H === 10) E = 1, D--;
    return H;
}
function P() {
    H = G < F ? O(I, G++) : 0;
    if (E++, H === 10) E = 1, D++;
    return H;
}
function Q() {
    return O(I, G);
}
function R() {
    return G;
}
function T(e, r) {
    return A(I, e, r);
}
function U(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function V(e) {
    return D = E = 1, F = M(I = e), G = 0, [];
}
function W(e) {
    return I = "", e;
}
function X(e) {
    return y(T(G - 1, re(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Y(e) {
    return W(_(V(e)));
}
function Z(e) {
    while(H = Q())if (H < 33) P();
    else break;
    return U(e) > 2 || U(H) > 3 ? "" : " ";
}
function _(e) {
    while(P())switch(U(H)){
        case 0:
            q(ne(G - 1), e);
            break;
        case 2:
            q(X(H), e);
            break;
        default:
            q(k(H), e);
    }
    return e;
}
function ee(e, r) {
    while(--r && P())if (H < 48 || H > 102 || H > 57 && H < 65 || H > 70 && H < 97) break;
    return T(e, R() + (r < 6 && Q() == 32 && P() == 32));
}
function re(e) {
    while(P())switch(H){
        case e:
            return G;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) re(H);
            break;
        case 40:
            if (e === 41) re(e);
            break;
        case 92:
            P();
            break;
    }
    return G;
}
function ae(e, r) {
    while(P())if (e + H === 57) break;
    else if (e + H === 84 && Q() === 47) break;
    return "/*" + T(r, G - 1) + "*" + k(e === 47 ? e : P());
}
function ne(e) {
    while(!U(Q()))P();
    return T(e, G);
}
function ce(e) {
    return W(se("", null, null, null, [
        ""
    ], e = V(e), 0, [
        0
    ], e));
}
function se(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = P()){
        case 40:
            if (h != 108 && O(j, l - 1) == 58) {
                if (C(j += z(X($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += X($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += Z(h);
            break;
        case 92:
            j += ee(R() - 1, 7);
            continue;
        case 47:
            switch(Q()){
                case 42:
                case 47:
                    q(ue(ae(P(), R()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = M(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = z(j, /\f/g, "");
                    if (p > 0 && M(j) - l) q(p > 32 ? ie(j + ";", n, a, l - 1) : ie(z(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    q(y = te(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) se(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && O(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                se(e, y, y, n && q(te(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                se(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + M(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && N() == 125) continue;
            }
            switch(j += k($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = (M(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if (Q() === 45) j += X(P());
                    v = Q(), o = l = M(g = j += ne(R())), $++;
                    break;
                case 45:
                    if (h === 45 && M(j) == 2) b = 0;
            }
    }
    return s;
}
function te(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = S(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = A(e, v + 1, v = g(w = u[b])), m = e; $ < h; ++$)if (m = y(w > 0 ? p[$] + " " + k : z(k, /&\f/g, p[$]))) f[d++] = m;
    return J(e, r, a, s === 0 ? c : i, f, o, l);
}
function ue(e, r, a) {
    return J(e, r, a, n, k(L()), A(e, 2, -2), 0);
}
function ie(e, r, a, n) {
    return J(e, r, a, s, A(e, 0, n), A(e, n + 1, -1), n);
}
function fe(n, c, s) {
    switch(x(n, c)){
        case 5103:
            return a + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return a + n + n;
        case 4789:
            return r + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return a + n + r + n + e + n + n;
        case 5936:
            switch(O(n, c + 11)){
                case 114:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return a + n + e + n + n;
        case 6165:
            return a + n + e + "flex-" + n + n;
        case 5187:
            return a + n + z(n, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + n;
        case 5443:
            return a + n + e + "flex-item-" + z(n, /flex-|-self/g, "") + (!j(n, /flex-|baseline/) ? e + "grid-row-" + z(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return a + n + e + "flex-line-pack" + z(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return a + n + e + z(n, "shrink", "negative") + n;
        case 5292:
            return a + n + e + z(n, "basis", "preferred-size") + n;
        case 6060:
            return a + "box-" + z(n, "-grow", "") + a + n + e + z(n, "grow", "positive") + n;
        case 4554:
            return a + z(n, /([^-])(transform)/g, "$1" + a + "$2") + n;
        case 6187:
            return z(z(z(n, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return z(n, /(image-set\([^]*)/, a + "$1" + "$`$1");
        case 4968:
            return z(z(n, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + n + n;
        case 4200:
            if (!j(n, /flex-|baseline/)) return e + "grid-column-align" + A(n, c) + n;
            break;
        case 2592:
        case 3360:
            return e + z(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, j(e.props, /grid-\w+-end/);
            })) return ~C(n + (s = s[c].value), "span") ? n : e + z(n, "-start", "") + n + e + "grid-row-span:" + (~C(s, "span") ? j(s, /\d+/) : +j(s, /\d+/) - +j(n, /\d+/)) + ";";
            return e + z(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return j(e.props, /grid-\w+-start/);
            }) ? n : e + z(z(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return z(n, /(.+)-inline(.+)/, a + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (M(n) - 1 - c > 6) switch(O(n, c + 1)){
                case 109:
                    if (O(n, c + 4) !== 45) break;
                case 102:
                    return z(n, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (O(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~C(n, "stretch") ? fe(z(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return z(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return e + a + ":" + c + i + (s ? e + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if (O(n, c + 6) === 121) return z(n, ":", ":" + a) + n;
            break;
        case 6444:
            switch(O(n, O(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return z(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + a + (O(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + n;
                case 100:
                    return z(n, ":", ":" + e) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return z(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function oe(e, r) {
    var a = "";
    var n = S(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function le(e, r, a, t) {
    switch(e.type){
        case $:
            if (e.children.length) break;
        case i:
        case s:
            return e.return = e.return || e.value;
        case n:
            return "";
        case h:
            return e.return = e.value + "{" + oe(e.children, t) + "}";
        case c:
            e.value = e.props.join(",");
    }
    return M(a = oe(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function ve(e) {
    var r = S(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function pe(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function he(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case s:
                n.return = fe(n.value, n.length, u);
                return;
            case h:
                return oe([
                    K(n, {
                        value: z(n.value, "@", "@" + a)
                    })
                ], i);
            case c:
                if (n.length) return B(n.props, function(c) {
                    switch(j(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(read-\w+)/, ":" + r + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + a + "input-$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + r + "$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, e + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function be(e) {
    switch(e.type){
        case c:
            e.props = e.props.map(function(r) {
                return B(Y(r), function(r, a, n) {
                    switch(O(r, 0)){
                        case 12:
                            return A(r, 1, M(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + A(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return S(n) > 1 ? "" : r;
                                case a = S(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"1tkfo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>weakMemoize);
var weakMemoize = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2zzxT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"bifUP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hoistNonReactStatics);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, _hoistNonReactStaticsDefault.default)(targetComponent, sourceComponent);
};

},{"hoist-non-react-statics":"bqi8K","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"bqi8K":[function(require,module,exports,__globalThis) {
'use strict';
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"fWsrJ"}],"fWsrJ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"bi8yr"}],"bi8yr":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"1NWBp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "insertStyles", ()=>insertStyles);
parcelHelpers.export(exports, "registerStyles", ()=>registerStyles);
var isBrowser = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"50XQ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", ()=>serializeStyles);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var isDevelopment = false;
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var processStyleName = /* #__PURE__ */ (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if (isProcessableValue(asString)) string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment) throw new Error(noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: cursor
    };
}

},{"@emotion/hash":"k9FwI","@emotion/unitless":"3eYs8","@emotion/memoize":"2zzxT","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"k9FwI":[function(require,module,exports,__globalThis) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>murmur2);
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3eYs8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unitlessKeys);
var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hlniG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInsertionEffectAlwaysWithSyncFallback", ()=>useInsertionEffectAlwaysWithSyncFallback);
parcelHelpers.export(exports, "useInsertionEffectWithLayoutFallback", ()=>useInsertionEffectWithLayoutFallback);
var _react = require("react");
var isBrowser = typeof document !== 'undefined';
var syncFallback = function syncFallback(create) {
    return create();
};
var useInsertionEffect = _react["useInsertionEffect"] ? _react["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser ? syncFallback : useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || _react.useLayoutEffect;

},{"react":"6wC8C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"jVkOb":[function(require,module,exports,__globalThis) {
function _extends() {
    return module.exports = _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"7ObYc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_taggedTemplateLiteral);
function _taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"js5Ws":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>(0, _dom.getOverflowAncestors));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "autoUpdate", ()=>autoUpdate);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "platform", ()=>platform);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _core = require("@floating-ui/core");
var _utils = require("@floating-ui/utils");
var _dom = require("@floating-ui/utils/dom");
function getCssDimensions(element) {
    const css = (0, _dom.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, _dom.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, _utils.round)(width) !== offsetWidth || (0, _utils.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width,
        height,
        $: shouldFallback
    };
}
function unwrapElement(element) {
    return !(0, _dom.isElement)(element) ? element.contextElement : element;
}
function getScale(element) {
    const domElement = unwrapElement(element);
    if (!(0, _dom.isHTMLElement)(domElement)) return (0, _utils.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width, height, $ } = getCssDimensions(domElement);
    let x = ($ ? (0, _utils.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, _utils.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x,
        y
    };
}
const noOffsets = /*#__PURE__*/ (0, _utils.createCoords)(0);
function getVisualOffsets(element) {
    const win = (0, _dom.getWindow)(element);
    if (!(0, _dom.isWebKit)() || !win.visualViewport) return noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, _dom.getWindow)(element)) return false;
    return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = unwrapElement(element);
    let scale = (0, _utils.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, _dom.isElement)(offsetParent)) scale = getScale(offsetParent);
        } else scale = getScale(element);
    }
    const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : (0, _utils.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, _dom.getWindow)(domElement);
        const offsetWin = offsetParent && (0, _dom.isElement)(offsetParent) ? (0, _dom.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, _dom.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, _dom.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, _dom.getWindow)(currentIFrame);
            currentIFrame = (0, _dom.getFrameElement)(currentWin);
        }
    }
    return (0, _core.rectToClientRect)({
        width,
        height,
        x,
        y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
    const leftScroll = (0, _dom.getNodeScroll)(element).scrollLeft;
    if (!rect) return getBoundingClientRect((0, _dom.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x,
        y
    };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements, rect, offsetParent, strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, _dom.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, _utils.createCoords)(1);
    const offsets = (0, _utils.createCoords)(0);
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = getBoundingClientRect(offsetParent);
            scale = getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : (0, _utils.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
    const html = (0, _dom.getDocumentElement)(element);
    const scroll = (0, _dom.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, _utils.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, _utils.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, _dom.getComputedStyle)(body).direction === 'rtl') x += (0, _utils.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width,
        height,
        x,
        y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const SCROLLBAR_MAX = 25;
function getViewportRect(element, strategy) {
    const win = (0, _dom.getWindow)(element);
    const html = (0, _dom.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, _dom.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width,
        height,
        x,
        y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
    const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, _dom.isHTMLElement)(element) ? getScale(element) : (0, _utils.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width,
        height,
        x,
        y
    };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = getDocumentRect((0, _dom.getDocumentElement)(element));
    else if ((0, _dom.isElement)(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, _core.rectToClientRect)(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, _dom.getParentNode)(element);
    if (parentNode === stopNode || !(0, _dom.isElement)(parentNode) || (0, _dom.isLastTraversableNode)(parentNode)) return false;
    return (0, _dom.getComputedStyle)(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, _dom.getOverflowAncestors)(element, [], false).filter((el)=>(0, _dom.isElement)(el) && (0, _dom.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, _dom.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, _dom.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, _dom.isElement)(currentNode) && !(0, _dom.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, _dom.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, _dom.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, _dom.isOverflowElement)(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, _dom.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
    let { element, boundary, rootBoundary, strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, _dom.isTopLayer)(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, _utils.max)(rect.top, top);
        right = (0, _utils.min)(rect.right, right);
        bottom = (0, _utils.min)(rect.bottom, bottom);
        left = (0, _utils.max)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function getDimensions(element) {
    const { width, height } = getCssDimensions(element);
    return {
        width,
        height
    };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, _utils.createCoords)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : (0, _utils.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x,
        y,
        width: rect.width,
        height: rect.height
    };
}
function isStaticPositioned(element) {
    return (0, _dom.getComputedStyle)(element).position === 'static';
}
function getTrueOffsetParent(element, polyfill) {
    if (!(0, _dom.isHTMLElement)(element) || (0, _dom.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, _dom.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
    const win = (0, _dom.getWindow)(element);
    if ((0, _dom.isTopLayer)(element)) return win;
    if (!(0, _dom.isHTMLElement)(element)) {
        let svgOffsetParent = (0, _dom.getParentNode)(element);
        while(svgOffsetParent && !(0, _dom.isLastTraversableNode)(svgOffsetParent)){
            if ((0, _dom.isElement)(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, _dom.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, _dom.isTableElement)(offsetParent) && isStaticPositioned(offsetParent))offsetParent = getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, _dom.isLastTraversableNode)(offsetParent) && isStaticPositioned(offsetParent) && !(0, _dom.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, _dom.getContainingBlock)(element) || win;
}
const getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function isRTL(element) {
    return (0, _dom.getComputedStyle)(element).direction === 'rtl';
}
const platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: (0, _dom.getDocumentElement),
    getClippingRect,
    getOffsetParent,
    getElementRects,
    getClientRects,
    getDimensions,
    getScale,
    isElement: (0, _dom.isElement),
    isRTL
};
function rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, _dom.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left, top, width, height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, _utils.floor)(top);
        const insetRight = (0, _utils.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, _utils.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, _utils.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin,
            threshold: (0, _utils.max)(0, (0, _utils.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll = true, ancestorResize = true, elementResize = typeof ResizeObserver === 'function', layoutShift = typeof IntersectionObserver === 'function', animationFrame = false } = options;
    const referenceEl = unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, _dom.getOverflowAncestors)(referenceEl) : [],
        ...floating ? (0, _dom.getOverflowAncestors)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = getBoundingClientRect(reference);
        if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const detectOverflow = (0, _core.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = (0, _core.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = (0, _core.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = (0, _core.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = (0, _core.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = (0, _core.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = (0, _core.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (0, _core.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = (0, _core.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = (0, _core.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const computePosition = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, _core.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

},{"@floating-ui/core":"elyaI","@floating-ui/utils":"8tvlQ","@floating-ui/utils/dom":"c3uLU","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"elyaI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rectToClientRect", ()=>(0, _utils.rectToClientRect));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _utils = require("@floating-ui/utils");
function computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference, floating } = _ref;
    const sideAxis = (0, _utils.getSideAxis)(placement);
    const alignmentAxis = (0, _utils.getAlignmentAxis)(placement);
    const alignLength = (0, _utils.getAxisLength)(alignmentAxis);
    const side = (0, _utils.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, _utils.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function detectOverflow(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x, y, platform, rects, elements, strategy } = state;
    const { boundary = 'clippingAncestors', rootBoundary = 'viewport', elementContext = 'floating', altBoundary = false, padding = 0 } = (0, _utils.evaluate)(options, state);
    const paddingObject = (0, _utils.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, _utils.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary,
        rootBoundary,
        strategy
    }));
    const rect = elementContext === 'floating' ? {
        x,
        y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, _utils.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements,
        rect,
        offsetParent,
        strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const computePosition = async (reference, floating, config)=>{
    const { placement = 'bottom', strategy = 'absolute', middleware = [], platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference,
        floating,
        strategy
    });
    let { x, y } = computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name, fn } = currentMiddleware;
        const { x: nextX, y: nextY, data, reset } = await fn({
            x,
            y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy,
            middlewareData,
            rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference,
                floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference,
                    floating,
                    strategy
                }) : reset.rects;
                ({ x, y } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x,
        y,
        placement: statefulPlacement,
        strategy,
        middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (options)=>({
        name: 'arrow',
        options,
        async fn (state) {
            const { x, y, placement, rects, platform, elements, middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element, padding = 0 } = (0, _utils.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            const coords = {
                x,
                y
            };
            const axis = (0, _utils.getAlignmentAxis)(placement);
            const length = (0, _utils.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, _utils.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, _utils.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, _utils.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, _utils.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, _utils.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, _utils.getAlignment)(placement) === alignment || (autoAlignment ? (0, _utils.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects, middlewareData, placement, platform, elements } = state;
            const { crossAxis = false, alignment, allowedPlacements = (0, _utils.placements), autoAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, _utils.placements) ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, _utils.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, _utils.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, _utils.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, _utils.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement, middlewareData, rects, initialPlacement, platform, elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy = 'bestFit', fallbackAxisSideDirection = 'none', flipAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, _utils.getSide)(placement);
            const initialSideAxis = (0, _utils.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, _utils.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, _utils.getOppositePlacement)(initialPlacement)
            ] : (0, _utils.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, _utils.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, _utils.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement,
                    overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, _utils.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, _utils.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, _utils.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function isAnySideFullyClipped(overflow) {
    return (0, _utils.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options,
        async fn (state) {
            const { rects, platform } = state;
            const { strategy = 'referenceHidden', ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function getBoundingRect(rects) {
    const minX = (0, _utils.min)(...rects.map((rect)=>rect.left));
    const minY = (0, _utils.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, _utils.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, _utils.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, _utils.rectToClientRect)(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options,
        async fn (state) {
            const { placement, elements, rects, platform, strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding = 2, x, y } = (0, _utils.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = getRectsByLine(nativeClientRects);
            const fallback = (0, _utils.rectToClientRect)(getBoundingRect(nativeClientRects));
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, _utils.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, _utils.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top,
                            bottom,
                            left,
                            right,
                            width,
                            height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, _utils.getSide)(placement) === 'left';
                    const maxRight = (0, _utils.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, _utils.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top,
                        bottom,
                        left,
                        right,
                        width,
                        height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect
                },
                floating: elements.floating,
                strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function convertValueToCoords(state, options) {
    const { placement, platform, elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, _utils.getSide)(placement);
    const alignment = (0, _utils.getAlignment)(placement);
    const isVertical = (0, _utils.getSideAxis)(placement) === 'y';
    const mainAxisMulti = originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, _utils.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis, crossAxis, alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x, y, placement, middlewareData } = state;
            const diffCoords = await convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options,
        async fn (state) {
            const { x, y, placement, platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter = {
                fn: (_ref)=>{
                    let { x, y } = _ref;
                    return {
                        x,
                        y
                    };
                }
            }, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, _utils.getSideAxis)((0, _utils.getSide)(placement));
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, _utils.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, _utils.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = function(options) {
    if (options === void 0) options = {};
    return {
        options,
        fn (state) {
            const { x, y, placement, rects, middlewareData } = state;
            const { offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const crossAxis = (0, _utils.getSideAxis)(placement);
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, _utils.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = originSides.has((0, _utils.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement, rects, platform, elements } = state;
            const { apply = ()=>{}, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, _utils.getSide)(placement);
            const alignment = (0, _utils.getAlignment)(placement);
            const isYAxis = (0, _utils.getSideAxis)(placement) === 'y';
            const { width, height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, _utils.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, _utils.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, _utils.max)(overflow.left, 0);
                const xMax = (0, _utils.max)(overflow.right, 0);
                const yMin = (0, _utils.max)(overflow.top, 0);
                const yMax = (0, _utils.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, _utils.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, _utils.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth,
                availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

},{"@floating-ui/utils":"8tvlQ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8tvlQ":[function(require,module,exports,__globalThis) {
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignments", ()=>alignments);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "createCoords", ()=>createCoords);
parcelHelpers.export(exports, "evaluate", ()=>evaluate);
parcelHelpers.export(exports, "expandPaddingObject", ()=>expandPaddingObject);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "getAlignment", ()=>getAlignment);
parcelHelpers.export(exports, "getAlignmentAxis", ()=>getAlignmentAxis);
parcelHelpers.export(exports, "getAlignmentSides", ()=>getAlignmentSides);
parcelHelpers.export(exports, "getAxisLength", ()=>getAxisLength);
parcelHelpers.export(exports, "getExpandedPlacements", ()=>getExpandedPlacements);
parcelHelpers.export(exports, "getOppositeAlignmentPlacement", ()=>getOppositeAlignmentPlacement);
parcelHelpers.export(exports, "getOppositeAxis", ()=>getOppositeAxis);
parcelHelpers.export(exports, "getOppositeAxisPlacements", ()=>getOppositeAxisPlacements);
parcelHelpers.export(exports, "getOppositePlacement", ()=>getOppositePlacement);
parcelHelpers.export(exports, "getPaddingObject", ()=>getPaddingObject);
parcelHelpers.export(exports, "getSide", ()=>getSide);
parcelHelpers.export(exports, "getSideAxis", ()=>getSideAxis);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "rectToClientRect", ()=>rectToClientRect);
parcelHelpers.export(exports, "round", ()=>round);
parcelHelpers.export(exports, "sides", ()=>sides);
const sides = [
    'top',
    'right',
    'bottom',
    'left'
];
const alignments = [
    'start',
    'end'
];
const placements = /*#__PURE__*/ sides.reduce((acc, side)=>acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v)=>({
        x: v,
        y: v
    });
const oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function clamp(start, value, end) {
    return max(start, min(value, end));
}
function evaluate(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
    return placement.split('-')[0];
}
function getAlignment(placement) {
    return placement.split('-')[1];
}
function getOppositeAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
    return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = getAlignment(placement);
    const alignmentAxis = getAlignmentAxis(placement);
    const length = getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        getOppositePlacement(mainAlignmentSide)
    ];
}
function getExpandedPlacements(placement) {
    const oppositePlacement = getOppositePlacement(placement);
    return [
        getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function getOppositeAlignmentPlacement(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const lrPlacement = [
    'left',
    'right'
];
const rlPlacement = [
    'right',
    'left'
];
const tbPlacement = [
    'top',
    'bottom'
];
const btPlacement = [
    'bottom',
    'top'
];
function getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rlPlacement : lrPlacement;
            return isStart ? lrPlacement : rlPlacement;
        case 'left':
        case 'right':
            return isStart ? tbPlacement : btPlacement;
        default:
            return [];
    }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = getAlignment(placement);
    let list = getSideList(getSide(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
    return list;
}
function getOppositePlacement(placement) {
    const side = getSide(placement);
    return oppositeSideMap[side] + placement.slice(side.length);
}
function expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function getPaddingObject(padding) {
    return typeof padding !== 'number' ? expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function rectToClientRect(rect) {
    const { x, y, width, height } = rect;
    return {
        width,
        height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x,
        y
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"c3uLU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComputedStyle", ()=>getComputedStyle);
parcelHelpers.export(exports, "getContainingBlock", ()=>getContainingBlock);
parcelHelpers.export(exports, "getDocumentElement", ()=>getDocumentElement);
parcelHelpers.export(exports, "getFrameElement", ()=>getFrameElement);
parcelHelpers.export(exports, "getNearestOverflowAncestor", ()=>getNearestOverflowAncestor);
parcelHelpers.export(exports, "getNodeName", ()=>getNodeName);
parcelHelpers.export(exports, "getNodeScroll", ()=>getNodeScroll);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>getOverflowAncestors);
parcelHelpers.export(exports, "getParentNode", ()=>getParentNode);
parcelHelpers.export(exports, "getWindow", ()=>getWindow);
parcelHelpers.export(exports, "isContainingBlock", ()=>isContainingBlock);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isLastTraversableNode", ()=>isLastTraversableNode);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isOverflowElement", ()=>isOverflowElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
parcelHelpers.export(exports, "isTableElement", ()=>isTableElement);
parcelHelpers.export(exports, "isTopLayer", ()=>isTopLayer);
parcelHelpers.export(exports, "isWebKit", ()=>isWebKit);
function hasWindow() {
    return typeof window !== 'undefined';
}
function getNodeName(node) {
    if (isNode(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
    var _ref;
    return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
    if (!hasWindow()) return false;
    return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
    if (!hasWindow()) return false;
    return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
    if (!hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
    if (!hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
    const { overflow, overflowX, overflowY, display } = getComputedStyle(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function isTableElement(element) {
    return /^(table|td|th)$/.test(getNodeName(element));
}
function isTopLayer(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const containRe = /paint|layout|strict|content/;
const isNotNone = (value)=>!!value && value !== 'none';
let isWebKitValue;
function isContainingBlock(elementOrCss) {
    const css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return isNotNone(css.transform) || isNotNone(css.translate) || isNotNone(css.scale) || isNotNone(css.rotate) || isNotNone(css.perspective) || !isWebKit() && (isNotNone(css.backdropFilter) || isNotNone(css.filter)) || willChangeRe.test(css.willChange || '') || containRe.test(css.contain || '');
}
function getContainingBlock(element) {
    let currentNode = getParentNode(element);
    while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
        if (isContainingBlock(currentNode)) return currentNode;
        else if (isTopLayer(currentNode)) return null;
        currentNode = getParentNode(currentNode);
    }
    return null;
}
function isWebKit() {
    if (isWebKitValue == null) isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return isWebKitValue;
}
function isLastTraversableNode(node) {
    return /^(html|body|#document)$/.test(getNodeName(node));
}
function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
    if (isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function getParentNode(node) {
    if (getNodeName(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node);
    return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
    const parentNode = getParentNode(node);
    if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
    return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = getWindow(scrollableAncestor);
    if (isBody) {
        const frameElement = getFrameElement(win);
        return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
    } else return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ld1Ps":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>index);
var _react = require("react");
var index = (0, _react.useLayoutEffect);

},{"react":"6wC8C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"giD7z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoizeOne);
var safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function isEqual(first, second) {
    if (first === second) return true;
    if (safeIsNaN(first) && safeIsNaN(second)) return true;
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kvorf":[function(require,module,exports,__globalThis) {
var defineProperty = require("818faec3224b1d63");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"818faec3224b1d63":"eEvLO"}],"eEvLO":[function(require,module,exports,__globalThis) {
var toPropertyKey = require("29ac19868e7f119");
function _defineProperty(e, r, t) {
    return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"29ac19868e7f119":"a6HZe"}],"a6HZe":[function(require,module,exports,__globalThis) {
var _typeof = require("a14bd529aa4ac1cd")["default"];
var toPrimitive = require("2713647ce51d8c75");
function toPropertyKey(t) {
    var i = toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a14bd529aa4ac1cd":"5VoYe","2713647ce51d8c75":"dYzuS"}],"5VoYe":[function(require,module,exports,__globalThis) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"dYzuS":[function(require,module,exports,__globalThis) {
var _typeof = require("e0211298897b2d31")["default"];
function toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"e0211298897b2d31":"5VoYe"}],"9gUJv":[function(require,module,exports,__globalThis) {
var arrayWithHoles = require("a3af206dbd14b1b5");
var iterableToArrayLimit = require("c109e0e3b1a7ef05");
var unsupportedIterableToArray = require("6782568c4383bd49");
var nonIterableRest = require("1e06d43f4bd6e532");
function _slicedToArray(r, e) {
    return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a3af206dbd14b1b5":"jSkeA","c109e0e3b1a7ef05":"cnZ4o","6782568c4383bd49":"kKUDI","1e06d43f4bd6e532":"gyWuz"}],"jSkeA":[function(require,module,exports,__globalThis) {
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"cnZ4o":[function(require,module,exports,__globalThis) {
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"kKUDI":[function(require,module,exports,__globalThis) {
var arrayLikeToArray = require("f8ccc0353f5f3746");
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
    }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f8ccc0353f5f3746":"3rRDj"}],"3rRDj":[function(require,module,exports,__globalThis) {
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"gyWuz":[function(require,module,exports,__globalThis) {
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"62gm1":[function(require,module,exports,__globalThis) {
var objectWithoutPropertiesLoose = require("424c8dc91f0a14f9");
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"424c8dc91f0a14f9":"8h5NR"}],"8h5NR":[function(require,module,exports,__globalThis) {
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"cHkbO":[function(require,module,exports,__globalThis) {
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"lI4fG":[function(require,module,exports,__globalThis) {
var toPropertyKey = require("b03a9e1e96a7e901");
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b03a9e1e96a7e901":"a6HZe"}],"drK9a":[function(require,module,exports,__globalThis) {
var setPrototypeOf = require("f41396146170672b");
function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && setPrototypeOf(t, e);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f41396146170672b":"2fkjH"}],"2fkjH":[function(require,module,exports,__globalThis) {
function _setPrototypeOf(t, e) {
    return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"hpHBD":[function(require,module,exports,__globalThis) {
var getPrototypeOf = require("b241ea01e2bf5861");
var isNativeReflectConstruct = require("35b08a444265bcf9");
var possibleConstructorReturn = require("d50bbe07b7bb3622");
function _createSuper(t) {
    var r = isNativeReflectConstruct();
    return function() {
        var e, o = getPrototypeOf(t);
        if (r) {
            var s = getPrototypeOf(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return possibleConstructorReturn(this, e);
    };
}
module.exports = _createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b241ea01e2bf5861":"3k5AT","35b08a444265bcf9":"dqF27","d50bbe07b7bb3622":"6tnWt"}],"3k5AT":[function(require,module,exports,__globalThis) {
function _getPrototypeOf(t) {
    return module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _getPrototypeOf(t);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"dqF27":[function(require,module,exports,__globalThis) {
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = _isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"6tnWt":[function(require,module,exports,__globalThis) {
var _typeof = require("52fa942c15a57b36")["default"];
var assertThisInitialized = require("ca3744a9acc8b6f9");
function _possibleConstructorReturn(t, e) {
    if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return assertThisInitialized(t);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"52fa942c15a57b36":"5VoYe","ca3744a9acc8b6f9":"cjzBA"}],"cjzBA":[function(require,module,exports,__globalThis) {
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"lIlWW":[function(require,module,exports,__globalThis) {
var arrayWithoutHoles = require("80b438c8f11ca70e");
var iterableToArray = require("4f1268a27b81f1fd");
var unsupportedIterableToArray = require("bfa7725fe5f724b");
var nonIterableSpread = require("24ae2b6222a85da6");
function _toConsumableArray(r) {
    return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"80b438c8f11ca70e":"114vh","4f1268a27b81f1fd":"gQL1c","bfa7725fe5f724b":"kKUDI","24ae2b6222a85da6":"5Fyob"}],"114vh":[function(require,module,exports,__globalThis) {
var arrayLikeToArray = require("d3a23041cb0f1512");
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return arrayLikeToArray(r);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"d3a23041cb0f1512":"3rRDj"}],"gQL1c":[function(require,module,exports,__globalThis) {
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"5Fyob":[function(require,module,exports,__globalThis) {
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"cxYL1":[function(require,module,exports,__globalThis) {
function _taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = _taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"k7RZu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCreatable", ()=>(0, _useCreatable09Aaeb9AEsmJs.u));
parcelHelpers.export(exports, "default", ()=>CreatableSelect$1);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _selectEf7C0426EsmJs = require("../../dist/Select-ef7c0426.esm.js");
var _useStateManager7E1E8489EsmJs = require("../../dist/useStateManager-7e1e8489.esm.js");
var _useCreatable09Aaeb9AEsmJs = require("../../dist/useCreatable-09aaeb9a.esm.js");
var _objectSpread2 = require("@babel/runtime/helpers/objectSpread2");
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _createClass = require("@babel/runtime/helpers/createClass");
var _inherits = require("@babel/runtime/helpers/inherits");
var _createSuper = require("@babel/runtime/helpers/createSuper");
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _index641Ee5B8EsmJs = require("../../dist/index-641ee5b8.esm.js");
var _react1 = require("@emotion/react");
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _typeof = require("@babel/runtime/helpers/typeof");
var _taggedTemplateLiteral = require("@babel/runtime/helpers/taggedTemplateLiteral");
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var _memoizeOne = require("memoize-one");
var CreatableSelect = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var creatableProps = (0, _useStateManager7E1E8489EsmJs.u)(props);
    var selectProps = (0, _useCreatable09Aaeb9AEsmJs.u)(creatableProps);
    return /*#__PURE__*/ _react.createElement((0, _selectEf7C0426EsmJs.S), (0, _extendsDefault.default)({
        ref: ref
    }, selectProps));
});
var CreatableSelect$1 = CreatableSelect;

},{"@babel/runtime/helpers/esm/extends":"dMXQY","react":"6wC8C","../../dist/Select-ef7c0426.esm.js":"hl7m3","../../dist/useStateManager-7e1e8489.esm.js":"3I33q","../../dist/useCreatable-09aaeb9a.esm.js":"lwXnR","@babel/runtime/helpers/objectSpread2":"kvorf","@babel/runtime/helpers/classCallCheck":"cHkbO","@babel/runtime/helpers/createClass":"lI4fG","@babel/runtime/helpers/inherits":"drK9a","@babel/runtime/helpers/createSuper":"hpHBD","@babel/runtime/helpers/toConsumableArray":"lIlWW","../../dist/index-641ee5b8.esm.js":"4oJfS","@emotion/react":"7QoHu","@babel/runtime/helpers/slicedToArray":"9gUJv","@babel/runtime/helpers/objectWithoutProperties":"62gm1","@babel/runtime/helpers/typeof":"5VoYe","@babel/runtime/helpers/taggedTemplateLiteral":"cxYL1","@babel/runtime/helpers/defineProperty":"eEvLO","react-dom":"7k58v","@floating-ui/dom":"js5Ws","use-isomorphic-layout-effect":"ld1Ps","memoize-one":"giD7z","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"lwXnR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "u", ()=>useCreatable);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _react = require("react");
var _index641Ee5B8EsmJs = require("./index-641ee5b8.esm.js");
var _selectEf7C0426EsmJs = require("./Select-ef7c0426.esm.js");
var _excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return "Create \"".concat(inputValue, "\"");
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function useCreatable(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? 'last' : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, _selectEf7C0426EsmJs.g) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, _selectEf7C0426EsmJs.b) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, _react.useMemo)(function() {
        return isValidNewOption(inputValue, (0, _index641Ee5B8EsmJs.H)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, _react.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption
        ].concat((0, _toConsumableArrayDefault.default)(propsOptions)) : [].concat((0, _toConsumableArrayDefault.default)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, _react.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, _index641Ee5B8EsmJs.D)(isMulti, [].concat((0, _toConsumableArrayDefault.default)((0, _index641Ee5B8EsmJs.H)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}

},{"@babel/runtime/helpers/esm/objectSpread2":"3il2o","@babel/runtime/helpers/esm/toConsumableArray":"er2bj","@babel/runtime/helpers/esm/objectWithoutProperties":"hVKX3","react":"6wC8C","./index-641ee5b8.esm.js":"4oJfS","./Select-ef7c0426.esm.js":"hl7m3","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"caW72":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _radioInput = require("./radioInput");
var _radioInputDefault = parcelHelpers.interopDefault(_radioInput);
const RadioFormInputs = ({ name, value, options, disabled, label, required, setValue, register, validation, onChange })=>{
    const [currentValue, setCurrentValue] = (0, _react.useState)(value);
    (0, _react.useEffect)(()=>{
        if (value) setCurrentValue(value);
    }, [
        value,
        name
    ]);
    const doOnChange = (e, value)=>{
        onChange && onChange(e, value);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "form-input-flex form-input-flex__tight",
        children: Array.isArray(options) && options.length > 0 && options.map((option, key)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form-input-flex-pair",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioInputDefault.default), {
                        id: `${name}-${key}`,
                        name: name,
                        value: option.value,
                        currentValue: currentValue,
                        disabled: disabled,
                        label: label,
                        required: required,
                        "aria-required": required,
                        register: register,
                        validation: validation,
                        onChange: (e)=>{
                            if (option.value) {
                                setCurrentValue(option.value);
                                setValue && setValue(name, option.value);
                                doOnChange(e, option.value);
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: `${name}-${key}`,
                        children: option.label
                    })
                ]
            }, key);
        }) || null
    });
};
exports.default = RadioFormInputs;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","./radioInput":"5Nagi","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5Nagi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
const RadioInput = ({ id, name, value, required, label, disabled, currentValue, size: initSize, register, validation, setValue, onChange })=>{
    const size = initSize ? parseInt(initSize) : 28;
    const isChecked = !!(currentValue && currentValue === value);
    const doChecked = (e)=>{
        setValue && setValue(name, value);
        onChange && onChange(e);
    };
    // ensure the hidden radio element is checked if it's supposed to be
    setTimeout(()=>{
        const el = document.getElementById(id);
        if (el) el.checked = isChecked ? true : false;
    }, 1);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
            htmlFor: id,
            className: "button-link radio",
            "data-disabled": disabled,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "radio",
                    id: id,
                    name: name,
                    value: value,
                    checked: isChecked,
                    disabled: disabled,
                    onInput: doChecked,
                    onClick: doChecked,
                    onChange: doChecked,
                    ...register(name, {
                        required: {
                            value: required ? true : false,
                            message: `Please choose an option for ${label === null || label === void 0 ? void 0 : label.toLowerCase()}`
                        },
                        ...validation("text")
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: size,
                    height: size,
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "12",
                            cy: "12",
                            r: "10"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "12",
                            cy: "12",
                            r: "5",
                            className: "radio-button",
                            fill: "currentColor"
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = RadioInput;

},{"react/jsx-runtime":"i3K7E","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"aNE2q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const Tickbox = ({ id, name, checked: initChecked, size: initSize, trigger = null, setValue, required, onChange, disabled, onKeyDown })=>{
    const [checked, setChecked] = (0, _react.useState)(initChecked);
    (0, _react.useEffect)(()=>{
        setChecked(!!initChecked);
        setValue && setValue(`${name}`, !!initChecked);
    }, [
        initChecked,
        trigger
    ]);
    (0, _react.useEffect)(()=>{
        const isChecked = checked ? true : false;
        setValue && setValue(`${name}`, !!isChecked);
    }, [
        checked
    ]);
    const size = initSize ? parseInt(initSize) : 28;
    const doChecked = (checked, e)=>{
        const isChecked = checked ? true : false;
        setChecked(isChecked);
        onChange && onChange(isChecked, e);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
            htmlFor: id,
            className: "button-link tickbox",
            "data-disabled": disabled,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "checkbox",
                    id: id,
                    name: name,
                    checked: checked,
                    onKeyDown: onKeyDown,
                    onChange: (e)=>{
                        doChecked(!checked, e);
                    },
                    disabled: disabled
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: size,
                    height: size,
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            x: "3",
                            y: "3",
                            width: "18",
                            height: "18",
                            rx: "4"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M6,13l5,4L18,7"
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = Tickbox;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"00ZlL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _icon = require("./icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _iconSelection = require("./iconSelection");
var _iconSelectionDefault = parcelHelpers.interopDefault(_iconSelection);
const IconPicker = ({ icon, iconStyle, name, setValue, onChange })=>{
    const [currentIcon, setCurrentIcon] = (0, _react.useState)(icon);
    const [showIconPicker, setShowIconPicker] = (0, _react.useState)(false);
    const iconTrigger = (0, _react.useRef)(null);
    const doHidePicker = (e)=>{
        if (!e || (iconTrigger === null || iconTrigger === void 0 ? void 0 : iconTrigger.current) && e.relatedTarget !== iconTrigger.current) setShowIconPicker(false);
    };
    const doSelectIcon = (e, icon)=>{
        setCurrentIcon(icon);
        doHidePicker();
        if (onChange) onChange(e, icon);
    };
    (0, _react.useEffect)(()=>{
        // const iconStr = JSON.stringify(currentIcon);
        setValue && setValue(`${name}`, currentIcon);
    }, [
        currentIcon
    ]);
    const blankSvg = /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: iconStyle
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "icon-picker-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                className: "button-link",
                ref: iconTrigger,
                onClick: ()=>{
                    setShowIconPicker(!showIconPicker);
                },
                children: (currentIcon === null || currentIcon === void 0 ? void 0 : currentIcon.type) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    type: currentIcon === null || currentIcon === void 0 ? void 0 : currentIcon.type,
                    src: currentIcon === null || currentIcon === void 0 ? void 0 : currentIcon.icon,
                    iconStyle: iconStyle
                }) : blankSvg
            }),
            showIconPicker && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconSelectionDefault.default), {
                onHide: doHidePicker,
                onSelect: doSelectIcon
            })
        ]
    });
};
exports.default = IconPicker;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","./icon":"8WxrN","./iconSelection":"9ZS7P","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8WxrN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _svg = require("./svg");
var _svgDefault = parcelHelpers.interopDefault(_svg);
var _akarIcons = require("akar-icons");
const Icon = ({ className = 'icon', type = 'custom', src, iconStyle, alt, size, strokeWidth })=>{
    let icon = null;
    const fillStroke = type === 'custom' ? true : false;
    const baseClassName = fillStroke === true ? 'item-icon item-icon__fill-stroke' : 'item-icon';
    switch(type){
        case 'custom':
        case 'customMenu':
            icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgDefault.default), {
                src: src,
                style: iconStyle,
                alt: alt,
                strokeWidth: strokeWidth,
                className: baseClassName + (className ? ` ${className}` : '')
            });
            break;
        case 'akar':
            const component = /*#__PURE__*/ (0, _jsxRuntime.jsx)(AkarComponent, {
                src,
                size,
                alt,
                iconStyle,
                strokeWidth
            });
            if (className && className !== 'icon') icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: baseClassName + (className ? ` ${className}` : ''),
                children: component
            });
            else icon = component;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: icon
    });
};
const AkarComponent = ({ src, size, alt, iconStyle, strokeWidth })=>{
    const Akar = _akarIcons[src];
    if (!Akar) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Akar, {
        size: size,
        alt: alt,
        strokeWidth: strokeWidth,
        style: iconStyle
    });
};
exports.default = Icon;

},{"react/jsx-runtime":"i3K7E","./svg":"4pImm","akar-icons":"b8xdj","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9ZS7P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("./icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _react = require("react");
var _useStore = require("../../components/hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
let customIcons = [
    "menu-hr",
    "menu-hs",
    "menu-td",
    "wellbeing",
    "triangles"
];
customIcons = customIcons.map((icon)=>({
        icon,
        type: "custom"
    }));
let akarIcons = [
    "Air",
    "AirplayAudio",
    "AirplayVideo",
    "Airpods",
    "Alarm",
    "AlignBottom",
    "AlignHorizontalCenter",
    "AlignLeft",
    "AlignRight",
    "AlignToBottom",
    "AlignToMiddle",
    "AlignToTop",
    "AlignTop",
    "AlignVerticalCenter",
    "AndroidFill",
    "AngularFill",
    "ArrowBack",
    "ArrowBackThick",
    "ArrowBackThickFill",
    "ArrowClockwise",
    "ArrowCounterClockwise",
    "ArrowCycle",
    "ArrowDown",
    "ArrowDownLeft",
    "ArrowDownRight",
    "ArrowDownThick",
    "ArrowForward",
    "ArrowForwardThick",
    "ArrowForwardThickFill",
    "ArrowLeft",
    "ArrowLeftThick",
    "ArrowRepeat",
    "ArrowRight",
    "ArrowRightLeft",
    "ArrowRightThick",
    "ArrowShuffle",
    "ArrowUp",
    "ArrowUpDown",
    "ArrowUpLeft",
    "ArrowUpRight",
    "ArrowUpThick",
    "Ascending",
    "Attach",
    "Backspace",
    "BackspaceFill",
    "Basket",
    "BatteryCharging",
    "BatteryEmpty",
    "BatteryFull",
    "BatteryLow",
    "BatteryMedium",
    "BehanceFill",
    "Bell",
    "Bicycle",
    "BitcoinFill",
    "Block",
    "Bluetooth",
    "Boat",
    "BookClose",
    "BookOpen",
    "BootstrapFill",
    "Box",
    "Briefcase",
    "Bug",
    "Cake",
    "Calculator",
    "Calendar",
    "Camera",
    "Cart",
    "ChatAdd",
    "ChatApprove",
    "ChatBubble",
    "ChatDots",
    "ChatEdit",
    "ChatError",
    "ChatQuestion",
    "ChatRemove",
    "Check",
    "CheckBox",
    "CheckBoxFill",
    "CheckIn",
    "Chess",
    "ChevronDown",
    "ChevronHorizontal",
    "ChevronLeft",
    "ChevronRight",
    "ChevronUp",
    "ChevronVertical",
    "Circle",
    "CircleAlert",
    "CircleAlertFill",
    "CircleCheck",
    "CircleCheckFill",
    "CircleChevronDown",
    "CircleChevronDownFill",
    "CircleChevronLeft",
    "CircleChevronLeftFill",
    "CircleChevronRight",
    "CircleChevronRightFill",
    "CircleChevronUp",
    "CircleChevronUpFill",
    "CircleFill",
    "CircleMinus",
    "CircleMinusFill",
    "CirclePlus",
    "CirclePlusFill",
    "CircleTriangleDown",
    "CircleTriangleDownFill",
    "CircleTriangleLeft",
    "CircleTriangleLeftFill",
    "CircleTriangleRight",
    "CircleTriangleRightFill",
    "CircleTriangleUp",
    "CircleTriangleUpFill",
    "CircleX",
    "CircleXFill",
    "Clipboard",
    "Clock",
    "Cloud",
    "CloudDownload",
    "CloudUpload",
    "CodepenFill",
    "Coffee",
    "Coin",
    "Command",
    "Computing",
    "Copy",
    "CreditCard",
    "Cross",
    "Crown",
    "CssFill",
    "Cursor",
    "Cut",
    "Dental",
    "Descending",
    "DesktopDevice",
    "Devices",
    "Diamond",
    "DiscordFill",
    "DjangoFill",
    "Door",
    "DotGridFill",
    "DoubleCheck",
    "DoubleSword",
    "Download",
    "Draft",
    "DragHorizontalFill",
    "DragVerticalFill",
    "DribbbleFill",
    "DropboxFill",
    "Edit",
    "Enlarge",
    "Envelope",
    "EyeClosed",
    "EyeOpen",
    "EyeSlashed",
    "FaceHappy",
    "FaceNeutral",
    "FaceSad",
    "FaceVeryHappy",
    "FaceVerySad",
    "FaceWink",
    "FacebookFill",
    "FigmaFill",
    "File",
    "Filter",
    "Fire",
    "Flag",
    "Flashlight",
    "Folder",
    "FolderAdd",
    "Frame",
    "FullScreen",
    "GameController",
    "GatsbyFill",
    "Gear",
    "Gift",
    "GithubFill",
    "Glasses",
    "Globe",
    "GoogleContainedFill",
    "GoogleFill",
    "GraphqlFill",
    "Grid",
    "Hand",
    "Hashtag",
    "Headphone",
    "Health",
    "Heart",
    "Height",
    "Heptagon",
    "HeptagonFill",
    "Hexagon",
    "HexagonFill",
    "Home",
    "HtmlFill",
    "Image",
    "Inbox",
    "Infinite",
    "Info",
    "InfoFill",
    "InstagramFill",
    "Jar",
    "JavascriptFill",
    "JqueryFill",
    "Key",
    "KeyCap",
    "LaptopDevice",
    "Leaf",
    "Lifesaver",
    "LightBulb",
    "LinkChain",
    "LinkOff",
    "LinkOn",
    "LinkOut",
    "LinkedinBoxFill",
    "LinkedinFill",
    "Location",
    "LockOff",
    "LockOn",
    "Map",
    "MediumFill",
    "Mention",
    "Microphone",
    "Miniplayer",
    "Minus",
    "MobileDevice",
    "Money",
    "Moon",
    "MoonFill",
    "MoreHorizontalFill",
    "MoreVerticalFill",
    "Music",
    "MusicAlbum",
    "MusicAlbumFill",
    "MusicNote",
    "Network",
    "Newspaper",
    "NextjsFill",
    "NodeFill",
    "NormalScreen",
    "NpmFill",
    "Octagon",
    "OctagonFill",
    "OctocatFill",
    "OpenEnvelope",
    "Oval",
    "Paper",
    "Parallelogram",
    "Pause",
    "Pencil",
    "Pentagon",
    "PentagonFill",
    "PeopleGroup",
    "PeopleMultiple",
    "Percentage",
    "Person",
    "PersonAdd",
    "PersonCheck",
    "PersonCross",
    "Phone",
    "PhpFill",
    "Pin",
    "PinterestFill",
    "Plane",
    "PlaneFill",
    "Planet",
    "Plant",
    "Play",
    "Plus",
    "PointerDownFill",
    "PointerHand",
    "PointerLeftFill",
    "PointerRightFill",
    "PointerUpFill",
    "PointingUp",
    "PostgresqlFill",
    "PythonFill",
    "Question",
    "QuestionFill",
    "Radish",
    "ReactFill",
    "RedditFill",
    "Reduce",
    "ReduxFill",
    "Ribbon",
    "RockOn",
    "Rss",
    "SassFill",
    "Schedule",
    "Scissor",
    "Search",
    "Send",
    "SettingsHorizontal",
    "SettingsVertical",
    "ShareBox",
    "Shield",
    "ShippingBoxV1",
    "ShippingBoxV2",
    "ShoppingBag",
    "SidebarLeft",
    "SidebarRight",
    "SignOut",
    "SlackFill",
    "Slice",
    "SnapchatFill",
    "SoundDown",
    "SoundOff",
    "SoundOn",
    "SoundUp",
    "SoundcloudFill",
    "Sparkles",
    "SpotifyFill",
    "Square",
    "SquareFill",
    "StackOverflowFill",
    "Star",
    "StatisticDown",
    "StatisticUp",
    "Stop",
    "StopFill",
    "Sun",
    "SunFill",
    "Sword",
    "TabletDevice",
    "Tag",
    "TelegramFill",
    "Telescope",
    "Tetragon",
    "TetragonFill",
    "TextAlignCenter",
    "TextAlignJustified",
    "TextAlignLeft",
    "TextAlignRight",
    "ThreeLineHorizontal",
    "ThreeLineVertical",
    "ThumbsDown",
    "ThumbsUp",
    "Thunder",
    "Ticket",
    "ToggleOff",
    "ToggleOffFill",
    "ToggleOn",
    "ToggleOnFill",
    "TogoCup",
    "TrashBin",
    "TrashCan",
    "Triangle",
    "TriangleAlert",
    "TriangleAlertFill",
    "TriangleDown",
    "TriangleFill",
    "TriangleLeft",
    "TriangleRight",
    "TriangleUp",
    "Trophy",
    "Truck",
    "TumblrFill",
    "TwitchFill",
    "TwitterFill",
    "TwoLineHorizontal",
    "TwoLineVertical",
    "Umbrella",
    "Utensils",
    "VapeKit",
    "VercelFill",
    "VictoryHand",
    "Video",
    "VimeoFill",
    "VkFill",
    "VrAr",
    "VscodeFill",
    "VueFill",
    "Wallet",
    "WatchDevice",
    "Water",
    "WhatsappFill",
    "Width",
    "Wifi",
    "WineGlass",
    "YarnFill",
    "YoutubeFill",
    "ZoomFill",
    "ZoomIn",
    "ZoomOut"
];
akarIcons = akarIcons.map((icon)=>({
        icon,
        type: "akar"
    }));
const IconSelection = ({ onSelect, onHide })=>{
    const isAdmin = (0, _useStoreDefault.default)((state)=>state.getIsAdmin());
    const icons = [
        ...customIcons,
        ...akarIcons
    ];
    if (!isAdmin) icons.splice(4, 1);
    const iconInput = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        var _iconInput_current;
        if (iconInput.current) (_iconInput_current = iconInput.current) === null || _iconInput_current === void 0 ? void 0 : _iconInput_current.focus();
    }, [
        iconInput
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "icon-picker",
        tabIndex: "0",
        autoFocus: true,
        ref: iconInput,
        onBlur: onHide,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "icon-picker--grid",
            children: icons.map((icon, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "icon-picker--grid-item",
                    onClick: (e)=>{
                        e.preventDefault();
                        onSelect(e, {
                            type: icon.type,
                            icon: icon.icon
                        });
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        type: icon.type,
                        src: icon.icon,
                        iconStyle: {
                            width: "32px"
                        }
                    })
                }, key))
        })
    });
};
exports.default = IconSelection;

},{"react/jsx-runtime":"i3K7E","./icon":"8WxrN","react":"6wC8C","../../components/hooks/useStore":"l1Yj7","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"81sT4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _spinner = require("./spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _useFetchUsers = require("../hooks/fetch/useFetchUsers");
var _useStore = require("../hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
const RemainingLeave = ({ userId })=>{
    var _user_absenceSummary_leave, _user_absenceSummary, _user_absenceSummary1;
    const clientRef = (0, _useStoreDefault.default)((state)=>state.clientRef);
    const { data: user, isLoading } = (0, _useFetchUsers.useFetchUser)({
        account: clientRef,
        userId
    });
    if (!userId) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "remaining-leave",
        children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}) : (user === null || user === void 0 ? void 0 : user.absenceSummary) ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                user === null || user === void 0 ? void 0 : (_user_absenceSummary = user.absenceSummary) === null || _user_absenceSummary === void 0 ? void 0 : (_user_absenceSummary_leave = _user_absenceSummary.leave) === null || _user_absenceSummary_leave === void 0 ? void 0 : _user_absenceSummary_leave.remaining,
                " ",
                user === null || user === void 0 ? void 0 : (_user_absenceSummary1 = user.absenceSummary) === null || _user_absenceSummary1 === void 0 ? void 0 : _user_absenceSummary1.absenceUnit,
                " holiday remaining"
            ]
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: "Absence details unavailable"
        })
    });
};
exports.default = RemainingLeave;

},{"react/jsx-runtime":"i3K7E","./spinner":"lRuRG","../hooks/fetch/useFetchUsers":"4DurT","../hooks/useStore":"l1Yj7","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"lRuRG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
require("2b73f95485a9aad0");
const Spinner = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "spinner lds-ellipsis",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {})
        ]
    });
};
exports.default = Spinner;

},{"react/jsx-runtime":"i3K7E","2b73f95485a9aad0":"7HG4k","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7HG4k":[function(require,module,exports,__globalThis) {
module.exports = require("35db0f68b0d07be7")(module.bundle.resolve("h0Jmt"));

},{"35db0f68b0d07be7":"efVvj"}],"4DurT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFetchHolidayGroups", ()=>useFetchHolidayGroups);
parcelHelpers.export(exports, "useFetchUsersBasic", ()=>useFetchUsersBasic);
parcelHelpers.export(exports, "useFetchMe", ()=>useFetchMe);
parcelHelpers.export(exports, "useFetchUser", ()=>useFetchUser);
parcelHelpers.export(exports, "useUpdateUser", ()=>useUpdateUser);
parcelHelpers.export(exports, "useUpdateGroup", ()=>useUpdateGroup);
parcelHelpers.export(exports, "useDeleteUser", ()=>useDeleteUser);
parcelHelpers.export(exports, "useAddUser", ()=>useAddUser);
parcelHelpers.export(exports, "useCreateUserGroup", ()=>useCreateUserGroup);
parcelHelpers.export(exports, "useDeleteUserGroup", ()=>useDeleteUserGroup);
var _reactQuery = require("react-query");
var _setValue = require("set-value");
var _setValueDefault = parcelHelpers.interopDefault(_setValue);
var _fetchJs = require("../../../utilities/fetch.js");
const transformUserProfile = (data)=>{
    let newData = {};
    // any select inputs will be passed as object, so
    // need to extract value
    const selects = [
        "details--maritalStatus",
        "details--gender",
        "employment--status",
        "employment--noticePeriodEmployee",
        "employment--noticePeriodCompany",
        "employment--salaryHourly",
        "employment--probationaryPeriodUnit",
        "employment--legalEntity",
        "employment--payInterval",
        "employment--payDateWeekly",
        "employment--contractType",
        "employment--type",
        "employment--lineManagers",
        "employment--endDetails",
        "employment--placeOfWork",
        "employment--department",
        "employment--location",
        "accessLevel",
        "groups"
    ];
    for(const property in data){
        if (property === "employment--payReview") continue;
        let dataValue = data[property];
        if (selects.indexOf(property) > -1) {
            if (Array.isArray(dataValue)) {
                dataValue = dataValue.map((item)=>{
                    return item === null || item === void 0 ? void 0 : item.value;
                }).filter((value)=>value != null);
                if (dataValue.length === 0) dataValue = null;
            } else if (dataValue === null || dataValue === void 0 ? void 0 : dataValue.value) dataValue = dataValue === null || dataValue === void 0 ? void 0 : dataValue.value;
            else dataValue = null;
        }
        if (property !== "id" && property !== "age" && property !== "lengthOfService") {
            if (property === "accessLevel" || property === "employment--salary" || property === "employment--rate" || property === "employment--newRate" || property === "employment--bonusOrAddition" || property === "employment--payDateMonthly" || property === "employment--overtimeRate1" || property === "employment--overtimeRate2" || property === "employment--overtimeRate3" || property === "employment--probationaryPeriod") {
                const blankValue = dataValue === "" || dataValue === null || dataValue === undefined;
                if (blankValue) dataValue = property === "accessLevel" ? 0.3 : null;
                else {
                    dataValue = parseFloat(dataValue);
                    if (isNaN(dataValue)) dataValue = property === "accessLevel" ? 0.3 : null;
                }
            }
            if (property === "employment--regularDays") {
                const days = [
                    false
                ];
                const regularDays = [
                    {
                        value: 1,
                        label: "Monday"
                    },
                    {
                        value: 2,
                        label: "Tuesday"
                    },
                    {
                        value: 3,
                        label: "Wednesday"
                    },
                    {
                        value: 4,
                        label: "Thursday"
                    },
                    {
                        value: 5,
                        label: "Friday"
                    },
                    {
                        value: 6,
                        label: "Saturday"
                    },
                    {
                        value: 7,
                        label: "Sunday"
                    }
                ];
                for (const day of regularDays){
                    const search = dataValue === null || dataValue === void 0 ? void 0 : dataValue.find((item)=>(item === null || item === void 0 ? void 0 : item.value) === day.value);
                    days.push(!!search);
                }
                dataValue = days;
            }
            (0, _setValueDefault.default)(newData, property.replaceAll("--", "."), dataValue);
        }
    }
    return newData;
};
const useFetchHolidayGroups = ({ account = null, callback, enabled = true })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "holidayGroups"
    });
    return (0, _reactQuery.useQuery)([
        "holidayGroups",
        account
    ], ()=>(0, _fetchJs.request)({
            url: "/user-groups",
            params: {
                holiday: 1,
                account: account
            }
        }), {
        refetchInterval: false,
        select: (data)=>{
            var _data_data;
            return data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.items;
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0 && enabled
    });
};
const useFetchUsersBasic = ({ account = null, callback, level = null, archive = false, enabled = true })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "users"
    });
    return (0, _reactQuery.useQuery)([
        "usersBasic",
        account,
        level,
        archive
    ], ()=>(0, _fetchJs.request)({
            url: "/users",
            params: {
                basic: 1,
                account: account,
                accessLevel: level
            }
        }), {
        refetchInterval: false,
        select: (data)=>{
            var _data_data_items_filter, _data_data_items, _data_data;
            return data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : (_data_data_items = _data_data.items) === null || _data_data_items === void 0 ? void 0 : (_data_data_items_filter = _data_data_items.filter((user)=>{
                return !!(!(user === null || user === void 0 ? void 0 : user.enabled) === archive);
            })) === null || _data_data_items_filter === void 0 ? void 0 : _data_data_items_filter.sort((a, b)=>a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase()));
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0 && enabled
    });
};
const useFetchMe = ({ callback })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "users"
    });
    return (0, _reactQuery.useQuery)([
        "me"
    ], ()=>{
        const isAdmin = !!(localStorage.getItem("admin") === "true");
        const loggedIn = !!(localStorage.getItem("loggedIn") === "true");
        if (isAdmin || !loggedIn) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/auth/me`
        });
    }, {
        refetchInterval: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        select: (data)=>{
            const me = data === null || data === void 0 ? void 0 : data.data;
            return me;
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useFetchUser = ({ account = null, userId = null, callback })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "users"
    });
    return (0, _reactQuery.useQuery)([
        "user",
        account,
        userId === null || userId === void 0 ? void 0 : userId.toString()
    ], ()=>{
        if (!userId) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/users/${userId}`,
            params: {
                account: account
            }
        });
    }, {
        refetchInterval: false,
        select: (data)=>data === null || data === void 0 ? void 0 : data.data,
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useUpdateUser = ({ account = null, callback, callbackError, level = null, approve = false, area = null, preventOptimistic = false })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)(async (data)=>{
        const userId = data === null || data === void 0 ? void 0 : data.id;
        if (!userId) return Promise.resolve({});
        const newData = transformUserProfile(data);
        if (approve) newData.approved = true;
        if (area) newData.updatedArea = area;
        return (0, _fetchJs.request)({
            url: `/users/${userId}`,
            method: "patch",
            params: {
                account: account
            },
            data: newData,
            json: true
        });
    }, {
        mutationKey: "users",
        onMutate: async (data)=>{
            var _queryClient_getQueryData, _data_groups_map, _data_details, _data_details1, _data_employment, _data_employment1;
            if (preventOptimistic) return;
            const userId = data === null || data === void 0 ? void 0 : data.id;
            // optimistic updates
            // update user
            await queryClient.cancelQueries([
                "user",
                account,
                userId === null || userId === void 0 ? void 0 : userId.toString()
            ]);
            const currentUser = (_queryClient_getQueryData = queryClient.getQueryData([
                "user",
                account,
                userId === null || userId === void 0 ? void 0 : userId.toString()
            ])) === null || _queryClient_getQueryData === void 0 ? void 0 : _queryClient_getQueryData.data;
            let newData = transformUserProfile(data);
            if ((data === null || data === void 0 ? void 0 : data.hasOwnProperty("groups")) && Array.isArray(data.groups)) newData.groups = (_data_groups_map = data.groups.map((item)=>item === null || item === void 0 ? void 0 : item.label)) === null || _data_groups_map === void 0 ? void 0 : _data_groups_map.join(", ");
            newData = {
                ...currentUser,
                ...newData
            };
            await queryClient.setQueryData([
                "user",
                account,
                userId === null || userId === void 0 ? void 0 : userId.toString()
            ], {
                data: newData
            });
            // update users collection
            await queryClient.cancelQueries([
                "usersBasic",
                account,
                level,
                true
            ]);
            await queryClient.cancelQueries([
                "usersBasic",
                account,
                level,
                false
            ]);
            if ((data === null || data === void 0 ? void 0 : data.hasOwnProperty("accessLevel")) || (data === null || data === void 0 ? void 0 : data.hasOwnProperty("enabled")) || (data === null || data === void 0 ? void 0 : (_data_details = data.details) === null || _data_details === void 0 ? void 0 : _data_details.hasOwnProperty("firstName")) || (data === null || data === void 0 ? void 0 : (_data_details1 = data.details) === null || _data_details1 === void 0 ? void 0 : _data_details1.hasOwnProperty("surname")) || (data === null || data === void 0 ? void 0 : (_data_employment = data.employment) === null || _data_employment === void 0 ? void 0 : _data_employment.hasOwnProperty("location")) || (data === null || data === void 0 ? void 0 : (_data_employment1 = data.employment) === null || _data_employment1 === void 0 ? void 0 : _data_employment1.hasOwnProperty("department"))) {
                var _data_details2, _data_details3, _data_employment2, _data_employment3, _data_accessLevel;
                newData = {
                    ...data
                };
                if (data === null || data === void 0 ? void 0 : (_data_details2 = data.details) === null || _data_details2 === void 0 ? void 0 : _data_details2.hasOwnProperty("firstName")) newData.fullName = `${data.details.firstName} ${data === null || data === void 0 ? void 0 : (_data_details3 = data.details) === null || _data_details3 === void 0 ? void 0 : _data_details3.surname}`;
                if (data === null || data === void 0 ? void 0 : (_data_employment2 = data.employment) === null || _data_employment2 === void 0 ? void 0 : _data_employment2.hasOwnProperty("location")) newData.location = data.employment.location;
                if (data === null || data === void 0 ? void 0 : (_data_employment3 = data.employment) === null || _data_employment3 === void 0 ? void 0 : _data_employment3.hasOwnProperty("department")) newData.department = data.employment.department;
                if (data === null || data === void 0 ? void 0 : data.hasOwnProperty("accessLevel")) newData.accessLevel = (_data_accessLevel = data.accessLevel) === null || _data_accessLevel === void 0 ? void 0 : _data_accessLevel.value;
                const includedArchive = [
                    true,
                    false
                ];
                includedArchive.forEach(async (archive)=>{
                    var _queryClient_getQueryData_data, _queryClient_getQueryData;
                    const currentUsers = (_queryClient_getQueryData = queryClient.getQueryData([
                        "usersBasic",
                        account,
                        level,
                        archive
                    ])) === null || _queryClient_getQueryData === void 0 ? void 0 : (_queryClient_getQueryData_data = _queryClient_getQueryData.data) === null || _queryClient_getQueryData_data === void 0 ? void 0 : _queryClient_getQueryData_data.items;
                    if ((currentUsers === null || currentUsers === void 0 ? void 0 : currentUsers.length) > 0) {
                        const index = currentUsers.findIndex((item)=>item.id === userId);
                        if (index > -1) {
                            currentUsers[index] = {
                                ...currentUsers[index],
                                ...newData
                            };
                            await queryClient.setQueryData([
                                "usersBasic",
                                account,
                                level,
                                archive
                            ], {
                                data: {
                                    items: currentUsers
                                }
                            });
                        }
                    }
                });
            }
            console.log("Optimistic update for user", userId);
        },
        onSettled: (returned, error, data)=>{
            // Only refetch if there was no error
            if (!error) {
                var _returned_data;
                console.log("refetch!");
                const userId = returned === null || returned === void 0 ? void 0 : (_returned_data = returned.data) === null || _returned_data === void 0 ? void 0 : _returned_data.id;
                queryClient.refetchQueries([
                    "user",
                    account,
                    userId === null || userId === void 0 ? void 0 : userId.toString()
                ]);
                // update all reminders queries
                queryClient.invalidateQueries((key)=>key[0] === "reminders");
            }
        },
        onSuccess: callback,
        onError: callbackError || ((err)=>console.error(err))
    });
};
const useUpdateGroup = ({ account = null, callback, callbackError })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)(async (data)=>{
        const submission = {
            ...data
        };
        delete submission.groupId;
        const groupId = data === null || data === void 0 ? void 0 : data.groupId;
        if (!groupId) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/user-groups/${groupId}`,
            method: "patch",
            params: {
                account: account
            },
            data: submission,
            json: true
        });
    }, {
        mutationKey: "holidayGroups",
        onMutate: async (data)=>{
            const groupId = data === null || data === void 0 ? void 0 : data.groupId;
            // optimistic update group in groups collection
            await queryClient.cancelQueries([
                "holidayGroups",
                account
            ]);
            if (groupId) {
                var _queryClient_getQueryData_data, _queryClient_getQueryData;
                const newData = {
                    ...data
                };
                delete newData.id;
                const currentGroups = (_queryClient_getQueryData = queryClient.getQueryData([
                    "holidayGroups",
                    account
                ])) === null || _queryClient_getQueryData === void 0 ? void 0 : (_queryClient_getQueryData_data = _queryClient_getQueryData.data) === null || _queryClient_getQueryData_data === void 0 ? void 0 : _queryClient_getQueryData_data.items;
                if ((currentGroups === null || currentGroups === void 0 ? void 0 : currentGroups.length) > 0) {
                    const index = currentGroups.findIndex((item)=>item.groupId === groupId);
                    if (index > -1) {
                        currentGroups[index] = {
                            ...currentGroups[index],
                            ...newData
                        };
                        await queryClient.setQueryData([
                            "holidayGroups",
                            account
                        ], {
                            data: {
                                items: currentGroups
                            }
                        });
                    }
                }
            }
        },
        onSuccess: callback,
        onError: callbackError || ((err)=>console.error(err))
    });
};
const useDeleteUser = ({ account = null, callback, level = null })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((userId)=>{
        return (0, _fetchJs.request)({
            url: `/users/${userId}`,
            params: {
                account: account
            },
            method: "delete"
        });
    }, {
        mutationKey: "users",
        onMutate: async (userId)=>{
            await queryClient.cancelQueries([
                "usersBasic",
                account,
                level,
                true
            ]);
            await queryClient.cancelQueries([
                "usersBasic",
                account,
                level,
                false
            ]);
            const includedArchive = [
                true,
                false
            ];
            for (const archive of includedArchive){
                var _currentUserData_data;
                const currentUserData = queryClient.getQueryData([
                    "usersBasic",
                    account,
                    level,
                    archive
                ]);
                const currentUsers = currentUserData === null || currentUserData === void 0 ? void 0 : (_currentUserData_data = currentUserData.data) === null || _currentUserData_data === void 0 ? void 0 : _currentUserData_data.items;
                // optimistic update data
                if ((currentUsers === null || currentUsers === void 0 ? void 0 : currentUsers.length) > 0) {
                    const updated = [
                        ...currentUsers
                    ];
                    const deleteIndex = updated === null || updated === void 0 ? void 0 : updated.findIndex((user)=>(user === null || user === void 0 ? void 0 : user.id) === userId);
                    updated.splice(deleteIndex, 1);
                    await queryClient.setQueryData([
                        "usersBasic",
                        account,
                        level,
                        archive
                    ], {
                        data: {
                            items: [
                                ...updated
                            ]
                        }
                    });
                }
            }
        },
        onSettled: (userId)=>{
            queryClient.invalidateQueries([
                "usersBasic",
                account,
                level,
                true
            ]);
            queryClient.invalidateQueries([
                "usersBasic",
                account,
                level,
                false
            ]);
        },
        onSuccess: callback
    });
};
const useAddUser = ({ account = null, callback, callbackError, level = null })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)(async (data)=>{
        const newData = transformUserProfile(data);
        return (0, _fetchJs.request)({
            url: `/users`,
            method: "post",
            params: {
                account: account
            },
            data: newData,
            json: true
        });
    }, {
        mutationKey: "users",
        onSettled: (returned, _v, data)=>{
            queryClient.invalidateQueries([
                "usersBasic",
                account,
                level,
                true
            ]);
            queryClient.invalidateQueries([
                "usersBasic",
                account,
                level,
                false
            ]);
        },
        onSuccess: callback,
        onError: callbackError
    });
};
const useCreateUserGroup = ({ account = null, callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)(async (data)=>{
        return (0, _fetchJs.request)({
            url: `/user-groups`,
            method: "post",
            params: {
                account: account
            },
            data: data,
            json: true
        });
    }, {
        mutationKey: "holidayGroups",
        onSettled: ()=>{
            queryClient.invalidateQueries([
                "holidayGroups",
                account
            ]);
        },
        onSuccess: callback
    });
};
const useDeleteUserGroup = ({ account = null, callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((groupId)=>{
        return (0, _fetchJs.request)({
            url: `/user-groups/${groupId}`,
            params: {
                account: account
            },
            method: "delete"
        });
    }, {
        mutationKey: "users",
        onMutate: async (groupId)=>{
            var _currentGroupsData_data;
            await queryClient.cancelQueries([
                "holidayGroups",
                account
            ]);
            const currentGroupsData = queryClient.getQueryData([
                "holidayGroups",
                account
            ]);
            const currentGroups = currentGroupsData === null || currentGroupsData === void 0 ? void 0 : (_currentGroupsData_data = currentGroupsData.data) === null || _currentGroupsData_data === void 0 ? void 0 : _currentGroupsData_data.items;
            // optimistic update data
            if ((currentGroups === null || currentGroups === void 0 ? void 0 : currentGroups.length) > 0) {
                const updated = [
                    ...currentGroups
                ];
                const deleteIndex = updated === null || updated === void 0 ? void 0 : updated.findIndex((group)=>(group === null || group === void 0 ? void 0 : group.groupId) === groupId);
                updated.splice(deleteIndex, 1);
                await queryClient.setQueryData([
                    "holidayGroups",
                    account
                ], {
                    data: {
                        items: [
                            ...updated
                        ]
                    }
                });
            }
        },
        onSettled: ()=>{
            queryClient.invalidateQueries([
                "holidayGroups",
                account
            ]);
        },
        onSuccess: callback
    });
};
exports.default = useFetchUsersBasic;

},{"react-query":"41hyj","set-value":"2zPgc","../../../utilities/fetch.js":"hAKRo","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2zPgc":[function(require,module,exports,__globalThis) {
/*!
 * set-value <https://github.com/jonschlinkert/set-value>
 *
 * Copyright (c) Jon Schlinkert (https://github.com/jonschlinkert).
 * Released under the MIT License.
 */ 'use strict';
const { deleteProperty } = Reflect;
const isPrimitive = require("4cba3441d797b11");
const isPlainObject = require("b7c81413652c9ce8");
const isObject = (value)=>{
    return typeof value === 'object' && value !== null || typeof value === 'function';
};
const isUnsafeKey = (key)=>{
    return key === '__proto__' || key === 'constructor' || key === 'prototype';
};
const validateKey = (key)=>{
    if (!isPrimitive(key)) throw new TypeError('Object keys must be strings or symbols');
    if (isUnsafeKey(key)) throw new Error(`Cannot set unsafe key: "${key}"`);
};
const toStringKey = (input)=>{
    return Array.isArray(input) ? input.flat().map(String).join(',') : input;
};
const createMemoKey = (input, options)=>{
    if (typeof input !== 'string' || !options) return input;
    let key = input + ';';
    if (options.arrays !== undefined) key += `arrays=${options.arrays};`;
    if (options.separator !== undefined) key += `separator=${options.separator};`;
    if (options.split !== undefined) key += `split=${options.split};`;
    if (options.merge !== undefined) key += `merge=${options.merge};`;
    if (options.preservePaths !== undefined) key += `preservePaths=${options.preservePaths};`;
    return key;
};
const memoize = (input, options, fn)=>{
    const key = toStringKey(options ? createMemoKey(input, options) : input);
    validateKey(key);
    const value = setValue.cache.get(key) || fn();
    setValue.cache.set(key, value);
    return value;
};
const splitString = (input, options = {})=>{
    const sep = options.separator || '.';
    const preserve = sep === '/' ? false : options.preservePaths;
    if (typeof input === 'string' && preserve !== false && /\//.test(input)) return [
        input
    ];
    const parts = [];
    let part = '';
    const push = (part)=>{
        let number;
        if (part.trim() !== '' && Number.isInteger(number = Number(part))) parts.push(number);
        else parts.push(part);
    };
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        if (value === '\\') {
            part += input[++i];
            continue;
        }
        if (value === sep) {
            push(part);
            part = '';
            continue;
        }
        part += value;
    }
    if (part) push(part);
    return parts;
};
const split = (input, options)=>{
    if (options && typeof options.split === 'function') return options.split(input);
    if (typeof input === 'symbol') return [
        input
    ];
    if (Array.isArray(input)) return input;
    return memoize(input, options, ()=>splitString(input, options));
};
const assignProp = (obj, prop, value, options)=>{
    validateKey(prop);
    // Delete property when "value" is undefined
    if (value === undefined) deleteProperty(obj, prop);
    else if (options && options.merge) {
        const merge = options.merge === 'function' ? options.merge : Object.assign;
        // Only merge plain objects
        if (merge && isPlainObject(obj[prop]) && isPlainObject(value)) obj[prop] = merge(obj[prop], value);
        else obj[prop] = value;
    } else obj[prop] = value;
    return obj;
};
const setValue = (target, path, value, options)=>{
    if (!path || !isObject(target)) return target;
    const keys = split(path, options);
    let obj = target;
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const next = keys[i + 1];
        validateKey(key);
        if (next === undefined) {
            assignProp(obj, key, value, options);
            break;
        }
        if (typeof next === 'number' && !Array.isArray(obj[key])) {
            obj = obj[key] = [];
            continue;
        }
        if (!isObject(obj[key])) obj[key] = {};
        obj = obj[key];
    }
    return target;
};
setValue.split = split;
setValue.cache = new Map();
setValue.clear = ()=>{
    setValue.cache = new Map();
};
module.exports = setValue;

},{"4cba3441d797b11":"5Q7l5","b7c81413652c9ce8":"fpKAC"}],"5Q7l5":[function(require,module,exports,__globalThis) {
/*!
 * is-primitive <https://github.com/jonschlinkert/is-primitive>
 *
 * Copyright (c) 2014-present, Jon Schlinkert.
 * Released under the MIT License.
 */ 'use strict';
module.exports = function isPrimitive(val) {
    if (typeof val === 'object') return val === null;
    return typeof val !== 'function';
};

},{}],"fpKAC":[function(require,module,exports,__globalThis) {
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ 'use strict';
var isObject = require("c40d935aa50b0faa");
function isObjectObject(o) {
    return isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
module.exports = function isPlainObject(o) {
    var ctor, prot;
    if (isObjectObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    prot = ctor.prototype;
    if (isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty('isPrototypeOf') === false) return false;
    // Most likely a plain Object
    return true;
};

},{"c40d935aa50b0faa":"5kFs3"}],"5kFs3":[function(require,module,exports,__globalThis) {
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ 'use strict';
module.exports = function isObject(val) {
    return val != null && typeof val === 'object' && Array.isArray(val) === false;
};

},{}],"1KGGL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactColor = require("react-color");
var _useFocusComponent = require("../hooks/useFocusComponent");
var _useFocusComponentDefault = parcelHelpers.interopDefault(_useFocusComponent);
const ColourPicker = ({ name, colour: initColour, register, setValue, disabled: initDisabled })=>{
    const { ref: focusedRef, setFocused } = (0, _useFocusComponentDefault.default)(()=>{
        setPickerVisible(false);
    });
    const [pickerVisible, setPickerVisible] = (0, _react.useState)(false);
    const [colour, setColour] = (0, _react.useState)(initColour);
    const [disabled, setDisabled] = (0, _react.useState)(initDisabled);
    // const colourPicker = useRef(null);
    const doShowPicker = ()=>{
        setPickerVisible(true);
        setFocused();
        if (!pickerVisible) focusedRef.current.focus();
    };
    const doChange = (colour, e)=>{
        const colourStr = (colour === null || colour === void 0 ? void 0 : colour.hex) ? colour.hex : colour === null || colour === void 0 ? void 0 : colour.toString();
        setColour(colourStr);
        if ((e === null || e === void 0 ? void 0 : e.type) === "click") setPickerVisible(false);
        setValue && setValue(`${name}`, colourStr);
    };
    (0, _react.useEffect)(()=>{
        doChange(initColour);
    }, [
        initColour
    ]);
    (0, _react.useEffect)(()=>{
        setDisabled(initDisabled);
    }, [
        initDisabled
    ]);
    let buttonStyle = {
        backgroundColor: colour
    };
    const pickerClass = "input-colour-picker" + (disabled ? " disabled" : "");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: pickerClass,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "input-colour-picker--swatch",
                    style: buttonStyle,
                    type: "button",
                    onClick: disabled ? null : doShowPicker
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    ref: focusedRef,
                    className: "input-colour-picker--picker",
                    id: "input-colour-picker",
                    children: pickerVisible && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactColor.BlockPicker), {
                        color: colour,
                        onChangeComplete: doChange
                    })
                }),
                register && /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    name: name,
                    type: "hidden",
                    defaultValue: colour,
                    ...register(name, {
                        required: {
                            value: false
                        }
                    })
                })
            ]
        })
    });
};
exports.default = ColourPicker;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","react-color":"7JoU2","../hooks/useFocusComponent":"eNeLi","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7JoU2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlphaPicker", ()=>(0, _alphaDefault.default));
parcelHelpers.export(exports, "BlockPicker", ()=>(0, _blockDefault.default));
parcelHelpers.export(exports, "CirclePicker", ()=>(0, _circleDefault.default));
parcelHelpers.export(exports, "ChromePicker", ()=>(0, _chromeDefault.default));
parcelHelpers.export(exports, "CompactPicker", ()=>(0, _compactDefault.default));
parcelHelpers.export(exports, "GithubPicker", ()=>(0, _githubDefault.default));
parcelHelpers.export(exports, "HuePicker", ()=>(0, _hueDefault.default));
parcelHelpers.export(exports, "MaterialPicker", ()=>(0, _materialDefault.default));
parcelHelpers.export(exports, "PhotoshopPicker", ()=>(0, _photoshopDefault.default));
parcelHelpers.export(exports, "SketchPicker", ()=>(0, _sketchDefault.default));
parcelHelpers.export(exports, "SliderPicker", ()=>(0, _sliderDefault.default));
parcelHelpers.export(exports, "SwatchesPicker", ()=>(0, _swatchesDefault.default));
parcelHelpers.export(exports, "TwitterPicker", ()=>(0, _twitterDefault.default));
parcelHelpers.export(exports, "GooglePicker", ()=>(0, _googleDefault.default));
parcelHelpers.export(exports, "CustomPicker", ()=>(0, _colorWrapDefault.default));
parcelHelpers.export(exports, "default", ()=>(0, _chromeDefault.default));
var _alpha = require("./components/alpha/Alpha");
var _alphaDefault = parcelHelpers.interopDefault(_alpha);
var _block = require("./components/block/Block");
var _blockDefault = parcelHelpers.interopDefault(_block);
var _circle = require("./components/circle/Circle");
var _circleDefault = parcelHelpers.interopDefault(_circle);
var _chrome = require("./components/chrome/Chrome");
var _chromeDefault = parcelHelpers.interopDefault(_chrome);
var _compact = require("./components/compact/Compact");
var _compactDefault = parcelHelpers.interopDefault(_compact);
var _github = require("./components/github/Github");
var _githubDefault = parcelHelpers.interopDefault(_github);
var _hue = require("./components/hue/Hue");
var _hueDefault = parcelHelpers.interopDefault(_hue);
var _material = require("./components/material/Material");
var _materialDefault = parcelHelpers.interopDefault(_material);
var _photoshop = require("./components/photoshop/Photoshop");
var _photoshopDefault = parcelHelpers.interopDefault(_photoshop);
var _sketch = require("./components/sketch/Sketch");
var _sketchDefault = parcelHelpers.interopDefault(_sketch);
var _slider = require("./components/slider/Slider");
var _sliderDefault = parcelHelpers.interopDefault(_slider);
var _swatches = require("./components/swatches/Swatches");
var _swatchesDefault = parcelHelpers.interopDefault(_swatches);
var _twitter = require("./components/twitter/Twitter");
var _twitterDefault = parcelHelpers.interopDefault(_twitter);
var _google = require("./components/google/Google");
var _googleDefault = parcelHelpers.interopDefault(_google);
var _colorWrap = require("./components/common/ColorWrap");
var _colorWrapDefault = parcelHelpers.interopDefault(_colorWrap);

},{"./components/alpha/Alpha":"cziW2","./components/block/Block":"16mK3","./components/circle/Circle":"1M8bI","./components/chrome/Chrome":"fVe7r","./components/compact/Compact":"iqS6C","./components/github/Github":"hALqU","./components/hue/Hue":"irVLb","./components/material/Material":"3lSZF","./components/photoshop/Photoshop":"5FTll","./components/sketch/Sketch":"iFUvx","./components/slider/Slider":"4E9sB","./components/swatches/Swatches":"6MLRe","./components/twitter/Twitter":"botYY","./components/google/Google":"kr9NJ","./components/common/ColorWrap":"6BSbS","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"cziW2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlphaPicker", ()=>AlphaPicker);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var _alphaPointer = require("./AlphaPointer");
var _alphaPointerDefault = parcelHelpers.interopDefault(_alphaPointer);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var AlphaPicker = function AlphaPicker(_ref) {
    var rgb = _ref.rgb, hsl = _ref.hsl, width = _ref.width, height = _ref.height, onChange = _ref.onChange, direction = _ref.direction, style = _ref.style, renderers = _ref.renderers, pointer = _ref.pointer, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                position: 'relative',
                width: width,
                height: height
            },
            alpha: {
                radius: '2px',
                style: style
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker,
        className: 'alpha-picker ' + className
    }, (0, _reactDefault.default).createElement((0, _common.Alpha), _extends({}, styles.alpha, {
        rgb: rgb,
        hsl: hsl,
        pointer: pointer,
        renderers: renderers,
        onChange: onChange,
        direction: direction
    })));
};
AlphaPicker.defaultProps = {
    width: '316px',
    height: '16px',
    direction: 'horizontal',
    pointer: (0, _alphaPointerDefault.default)
};
exports.default = (0, _common.ColorWrap)(AlphaPicker);

},{"react":"6wC8C","reactcss":"7yqRl","../common":"gx5lJ","./AlphaPointer":"dCmvO","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7yqRl":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;
var _flattenNames = require("d21bbaf20f135ed7");
var _flattenNames2 = _interopRequireDefault(_flattenNames);
var _mergeClasses = require("7ab5259b27ba03f4");
var _mergeClasses2 = _interopRequireDefault(_mergeClasses);
var _autoprefix = require("f7ab0b82c66de9f6");
var _autoprefix2 = _interopRequireDefault(_autoprefix);
var _hover2 = require("610a3f6b931726da");
var _hover3 = _interopRequireDefault(_hover2);
var _active = require("8d8d6281227b8365");
var _active2 = _interopRequireDefault(_active);
var _loop2 = require("c3bae8551a541b09");
var _loop3 = _interopRequireDefault(_loop2);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.hover = _hover3.default;
exports.handleHover = _hover3.default;
exports.handleActive = _active2.default;
exports.loop = _loop3.default;
var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
    for(var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)activations[_key - 1] = arguments[_key];
    var activeNames = (0, _flattenNames2.default)(activations);
    var merged = (0, _mergeClasses2.default)(classes, activeNames);
    return (0, _autoprefix2.default)(merged);
};
exports.default = ReactCSS;

},{"d21bbaf20f135ed7":"50JUK","7ab5259b27ba03f4":"fmyNm","f7ab0b82c66de9f6":"18Q7t","610a3f6b931726da":"8Cc6Q","8d8d6281227b8365":"diqVA","c3bae8551a541b09":"kJLEK"}],"50JUK":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.flattenNames = undefined;
var _isString2 = require("cc07907b88eac890");
var _isString3 = _interopRequireDefault(_isString2);
var _forOwn2 = require("2db844d13e15e498");
var _forOwn3 = _interopRequireDefault(_forOwn2);
var _isPlainObject2 = require("8ea197129e7ee890");
var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
var _map2 = require("8f65518dcbd71fa0");
var _map3 = _interopRequireDefault(_map2);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var flattenNames = exports.flattenNames = function flattenNames() {
    var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var names = [];
    (0, _map3.default)(things, function(thing) {
        if (Array.isArray(thing)) flattenNames(thing).map(function(name) {
            return names.push(name);
        });
        else if ((0, _isPlainObject3.default)(thing)) (0, _forOwn3.default)(thing, function(value, key) {
            value === true && names.push(key);
            names.push(key + '-' + value);
        });
        else if ((0, _isString3.default)(thing)) names.push(thing);
    });
    return names;
};
exports.default = flattenNames;

},{"cc07907b88eac890":"f3aDD","2db844d13e15e498":"8iXol","8ea197129e7ee890":"gxTEE","8f65518dcbd71fa0":"cZTmU"}],"f3aDD":[function(require,module,exports,__globalThis) {
var baseGetTag = require("b4b8a393acf14901"), isArray = require("46fdd4d2c5d7b4ab"), isObjectLike = require("36ebbb6a9d8b3fe4");
/** `Object#toString` result references. */ var stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
module.exports = isString;

},{"b4b8a393acf14901":"g69ny","46fdd4d2c5d7b4ab":"2bYH3","36ebbb6a9d8b3fe4":"5AOB5"}],"g69ny":[function(require,module,exports,__globalThis) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"A3k0h","9b2aaf31b7bdd837":"fRhng","46d5beb3375f8a28":"edSnZ"}],"A3k0h":[function(require,module,exports,__globalThis) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"4985z"}],"4985z":[function(require,module,exports,__globalThis) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;

},{"cd92e8811deaabf5":"g8stD"}],"g8stD":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"fRhng":[function(require,module,exports,__globalThis) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"A3k0h"}],"edSnZ":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"2bYH3":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"5AOB5":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = isObjectLike;

},{}],"8iXol":[function(require,module,exports,__globalThis) {
var baseForOwn = require("29fecbf008d96984"), castFunction = require("e9d5e9d48b9f93d3");
/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function forOwn(object, iteratee) {
    return object && baseForOwn(object, castFunction(iteratee));
}
module.exports = forOwn;

},{"29fecbf008d96984":"eCC1H","e9d5e9d48b9f93d3":"jsvr3"}],"eCC1H":[function(require,module,exports,__globalThis) {
var baseFor = require("c7da20818a5fe3d6"), keys = require("1fb77c53defe5720");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"c7da20818a5fe3d6":"fdKz6","1fb77c53defe5720":"4gozK"}],"fdKz6":[function(require,module,exports,__globalThis) {
var createBaseFor = require("178c767a7be60d59");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"178c767a7be60d59":"fPO89"}],"fPO89":[function(require,module,exports,__globalThis) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"4gozK":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"81yOD","e8453365fdacc8da":"cjiOn","7760b47b02971dfa":"MFtZx"}],"81yOD":[function(require,module,exports,__globalThis) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"foWYS","9cdb51ffa56f149b":"7U1h4","38cd49f1e493b3d7":"2bYH3","b379831fe1873fed":"fs7Lv","f362a34cd8321bb7":"1w8D6","c019db5297494469":"bEDrg"}],"foWYS":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"7U1h4":[function(require,module,exports,__globalThis) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
module.exports = isArguments;

},{"b56e5b7d86069686":"fzvfz","bead821d6af018b5":"5AOB5"}],"fzvfz":[function(require,module,exports,__globalThis) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"g69ny","b6cdbe52dcf709f8":"5AOB5"}],"fs7Lv":[function(require,module,exports,__globalThis) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"4985z","a1e87b138cf75d1d":"b8TdJ"}],"b8TdJ":[function(require,module,exports,__globalThis) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"1w8D6":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"bEDrg":[function(require,module,exports,__globalThis) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"lLcmi","903f50eb1c16d257":"2jWGX","fa49853a82034c30":"747Ud"}],"lLcmi":[function(require,module,exports,__globalThis) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"g69ny","f661b3a120d7a4cb":"gba14","cdd86c83797c0618":"5AOB5"}],"gba14":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"2jWGX":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"747Ud":[function(require,module,exports,__globalThis) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"g8stD"}],"cjiOn":[function(require,module,exports,__globalThis) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"6Gf4U","3ec652610d8dd5d3":"kZML7"}],"6Gf4U":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"kZML7":[function(require,module,exports,__globalThis) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"euK3Y"}],"euK3Y":[function(require,module,exports,__globalThis) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"MFtZx":[function(require,module,exports,__globalThis) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"6IPYx","f3db08d4d1110aaf":"gba14"}],"6IPYx":[function(require,module,exports,__globalThis) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"g69ny","3cba3c966459d528":"6NReb"}],"6NReb":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = isObject;

},{}],"jsvr3":[function(require,module,exports,__globalThis) {
var identity = require("c0eaa1c5ad52cc2f");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function castFunction(value) {
    return typeof value == 'function' ? value : identity;
}
module.exports = castFunction;

},{"c0eaa1c5ad52cc2f":"7OCp8"}],"7OCp8":[function(require,module,exports,__globalThis) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"gxTEE":[function(require,module,exports,__globalThis) {
var baseGetTag = require("c03dd41ed9922dd2"), getPrototype = require("2ca5b85a120835de"), isObjectLike = require("963b65e043435612");
/** `Object#toString` result references. */ var objectTag = '[object Object]';
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"c03dd41ed9922dd2":"g69ny","2ca5b85a120835de":"CmjGT","963b65e043435612":"5AOB5"}],"CmjGT":[function(require,module,exports,__globalThis) {
var overArg = require("11c2fcc01fbb2119");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"11c2fcc01fbb2119":"euK3Y"}],"cZTmU":[function(require,module,exports,__globalThis) {
var arrayMap = require("61518c8bb036dd9b"), baseIteratee = require("8bad46685c8864d"), baseMap = require("51c76ab24fdb66f9"), isArray = require("7cb4cacc4dea406c");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee) {
    var func = isArray(collection) ? arrayMap : baseMap;
    return func(collection, baseIteratee(iteratee, 3));
}
module.exports = map;

},{"61518c8bb036dd9b":"e28WC","8bad46685c8864d":"gSWjf","51c76ab24fdb66f9":"8aT0A","7cb4cacc4dea406c":"2bYH3"}],"e28WC":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"gSWjf":[function(require,module,exports,__globalThis) {
var baseMatches = require("30aeab910fab669"), baseMatchesProperty = require("4f010869f7b63154"), identity = require("28f06147d1eb9502"), isArray = require("3c56f88c4debf449"), property = require("aee920e0ef5bf111");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return identity;
    if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"30aeab910fab669":"b5P9O","4f010869f7b63154":"isNRN","28f06147d1eb9502":"7OCp8","3c56f88c4debf449":"2bYH3","aee920e0ef5bf111":"15pXc"}],"b5P9O":[function(require,module,exports,__globalThis) {
var baseIsMatch = require("e45515c903dc8f87"), getMatchData = require("89e9034a8071e297"), matchesStrictComparable = require("782598b150762386");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"e45515c903dc8f87":"1A4S6","89e9034a8071e297":"7C3fu","782598b150762386":"felLl"}],"1A4S6":[function(require,module,exports,__globalThis) {
var Stack = require("ae43062900bf7e4d"), baseIsEqual = require("9003c0cc8ac007b6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"ae43062900bf7e4d":"dymnP","9003c0cc8ac007b6":"gNP09"}],"dymnP":[function(require,module,exports,__globalThis) {
var ListCache = require("cfb30a39eead9e7e"), stackClear = require("ceda2a63c77c915"), stackDelete = require("91ee1b348d9d7172"), stackGet = require("3fe28318f65b9332"), stackHas = require("724ca4def8b84e06"), stackSet = require("e9ceacb40d9582bd");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"cfb30a39eead9e7e":"30RhW","ceda2a63c77c915":"kdn15","91ee1b348d9d7172":"6viBp","3fe28318f65b9332":"4LDFg","724ca4def8b84e06":"iuwuf","e9ceacb40d9582bd":"3B3u1"}],"30RhW":[function(require,module,exports,__globalThis) {
var listCacheClear = require("4b1a0d54aed80a7b"), listCacheDelete = require("b700cb849df2c166"), listCacheGet = require("d76dd90eead6cced"), listCacheHas = require("3d210628ba60ec8"), listCacheSet = require("76026bf2d4cfff93");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"4b1a0d54aed80a7b":"3Rc8o","b700cb849df2c166":"gzIDQ","d76dd90eead6cced":"bUufm","3d210628ba60ec8":"bT8wN","76026bf2d4cfff93":"a7w6K"}],"3Rc8o":[function(require,module,exports,__globalThis) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"gzIDQ":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("173cad7d48c35f4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"173cad7d48c35f4f":"54K3Y"}],"54K3Y":[function(require,module,exports,__globalThis) {
var eq = require("b38bfe408564f7a5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"b38bfe408564f7a5":"1uQuO"}],"1uQuO":[function(require,module,exports,__globalThis) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"bUufm":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("c0bae780ed176e2c");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"c0bae780ed176e2c":"54K3Y"}],"bT8wN":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("7ed3d4e3adbd64a4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"7ed3d4e3adbd64a4":"54K3Y"}],"a7w6K":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("5be4035c2d7ca432");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5be4035c2d7ca432":"54K3Y"}],"kdn15":[function(require,module,exports,__globalThis) {
var ListCache = require("8a0350213da984ae");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"8a0350213da984ae":"30RhW"}],"6viBp":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"4LDFg":[function(require,module,exports,__globalThis) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"iuwuf":[function(require,module,exports,__globalThis) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"3B3u1":[function(require,module,exports,__globalThis) {
var ListCache = require("4737651e99b917d2"), Map = require("1494efbafafa9552"), MapCache = require("6049e8027fe9407f");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"4737651e99b917d2":"30RhW","1494efbafafa9552":"2dsmN","6049e8027fe9407f":"gGU71"}],"2dsmN":[function(require,module,exports,__globalThis) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map');
module.exports = Map;

},{"ed0752fe9f482107":"ejqXU","29224713b8d411e6":"4985z"}],"ejqXU":[function(require,module,exports,__globalThis) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"bCGN5","16db51a0e009bd8c":"lsKEX"}],"bCGN5":[function(require,module,exports,__globalThis) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"6IPYx","cabbc2adfaeb27d9":"5nbRo","cbb5703fe1562e7f":"6NReb","388b819f47a43aa5":"bAnJz"}],"5nbRo":[function(require,module,exports,__globalThis) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"8zsEW"}],"8zsEW":[function(require,module,exports,__globalThis) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"4985z"}],"bAnJz":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = toSource;

},{}],"lsKEX":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"gGU71":[function(require,module,exports,__globalThis) {
var mapCacheClear = require("a5ffecfb6a8bdac1"), mapCacheDelete = require("d2967b0e32ccfa56"), mapCacheGet = require("ca21409ea89624c0"), mapCacheHas = require("f88fd07f8dd1f67d"), mapCacheSet = require("dbf3eae765642a3b");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"a5ffecfb6a8bdac1":"dtfzE","d2967b0e32ccfa56":"u4DGr","ca21409ea89624c0":"9muNT","f88fd07f8dd1f67d":"7GPjZ","dbf3eae765642a3b":"5AobE"}],"dtfzE":[function(require,module,exports,__globalThis) {
var Hash = require("4ae82d88051cc92b"), ListCache = require("a07dcf3fd3097a0c"), Map = require("92c01c953ef00ded");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
module.exports = mapCacheClear;

},{"4ae82d88051cc92b":"hBRjy","a07dcf3fd3097a0c":"30RhW","92c01c953ef00ded":"2dsmN"}],"hBRjy":[function(require,module,exports,__globalThis) {
var hashClear = require("f47a1723b6e2d79b"), hashDelete = require("bc25d439ccd1fb47"), hashGet = require("f096b37295a92ab0"), hashHas = require("d88173cbc6a133c8"), hashSet = require("afb9b3bae0461cbf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f47a1723b6e2d79b":"7YRYn","bc25d439ccd1fb47":"46CyE","f096b37295a92ab0":"8lCog","d88173cbc6a133c8":"eir7W","afb9b3bae0461cbf":"3SY42"}],"7YRYn":[function(require,module,exports,__globalThis) {
var nativeCreate = require("dc294230a47ca365");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"dc294230a47ca365":"7GTdg"}],"7GTdg":[function(require,module,exports,__globalThis) {
var getNative = require("12f496acdffb7cf7");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, 'create');
module.exports = nativeCreate;

},{"12f496acdffb7cf7":"ejqXU"}],"46CyE":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"8lCog":[function(require,module,exports,__globalThis) {
var nativeCreate = require("627211fa3e1596e1");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"627211fa3e1596e1":"7GTdg"}],"eir7W":[function(require,module,exports,__globalThis) {
var nativeCreate = require("52b3f0bfeddceb45");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"52b3f0bfeddceb45":"7GTdg"}],"3SY42":[function(require,module,exports,__globalThis) {
var nativeCreate = require("67b7d10f53ccd515");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"67b7d10f53ccd515":"7GTdg"}],"u4DGr":[function(require,module,exports,__globalThis) {
var getMapData = require("656d8c5510e0af84");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"656d8c5510e0af84":"9zwSl"}],"9zwSl":[function(require,module,exports,__globalThis) {
var isKeyable = require("adfdd2b4101370ed");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = getMapData;

},{"adfdd2b4101370ed":"WjLAs"}],"WjLAs":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = isKeyable;

},{}],"9muNT":[function(require,module,exports,__globalThis) {
var getMapData = require("d345cdfee2b4007d");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"d345cdfee2b4007d":"9zwSl"}],"7GPjZ":[function(require,module,exports,__globalThis) {
var getMapData = require("29ebabd55e2d6074");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"29ebabd55e2d6074":"9zwSl"}],"5AobE":[function(require,module,exports,__globalThis) {
var getMapData = require("21c5ffca56eeb737");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"21c5ffca56eeb737":"9zwSl"}],"gNP09":[function(require,module,exports,__globalThis) {
var baseIsEqualDeep = require("bd1d38ebd4028e5a"), isObjectLike = require("809bbb0c20650dbc");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"bd1d38ebd4028e5a":"iTwVO","809bbb0c20650dbc":"5AOB5"}],"iTwVO":[function(require,module,exports,__globalThis) {
var Stack = require("60c73bca87468e58"), equalArrays = require("96bc8a1825db53a5"), equalByTag = require("8bdece495e87fb69"), equalObjects = require("bb94920432a68eca"), getTag = require("45495edff98e5837"), isArray = require("18256411ae9e2858"), isBuffer = require("e5ba7abf54247fc5"), isTypedArray = require("50d786bb5c7366af");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"60c73bca87468e58":"dymnP","96bc8a1825db53a5":"gKtk1","8bdece495e87fb69":"dfkeE","bb94920432a68eca":"6Mk4q","45495edff98e5837":"i3l7I","18256411ae9e2858":"2bYH3","e5ba7abf54247fc5":"fs7Lv","50d786bb5c7366af":"bEDrg"}],"gKtk1":[function(require,module,exports,__globalThis) {
var SetCache = require("9b110ce138e67ce5"), arraySome = require("1ee20de911db0cb0"), cacheHas = require("defff3d81be91b23");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = equalArrays;

},{"9b110ce138e67ce5":"8V7yB","1ee20de911db0cb0":"e9So5","defff3d81be91b23":"25qvE"}],"8V7yB":[function(require,module,exports,__globalThis) {
var MapCache = require("10fe37252553d0bd"), setCacheAdd = require("9a831e81e9a1f98c"), setCacheHas = require("1a2b6c8a7399c39f");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"10fe37252553d0bd":"gGU71","9a831e81e9a1f98c":"kPz0Z","1a2b6c8a7399c39f":"kNgW9"}],"kPz0Z":[function(require,module,exports,__globalThis) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"kNgW9":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"e9So5":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"25qvE":[function(require,module,exports,__globalThis) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"dfkeE":[function(require,module,exports,__globalThis) {
var Symbol = require("474c1df4fc722b40"), Uint8Array = require("dbf6aa5033a0f48"), eq = require("539966708f906e61"), equalArrays = require("8142d4017f0a425f"), mapToArray = require("48cddf732eff33ba"), setToArray = require("9dc78b26c5daba20");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"474c1df4fc722b40":"A3k0h","dbf6aa5033a0f48":"3xl2A","539966708f906e61":"1uQuO","8142d4017f0a425f":"gKtk1","48cddf732eff33ba":"1m0k7","9dc78b26c5daba20":"ggO7w"}],"3xl2A":[function(require,module,exports,__globalThis) {
var root = require("f755339301d6568f");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"f755339301d6568f":"4985z"}],"1m0k7":[function(require,module,exports,__globalThis) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"ggO7w":[function(require,module,exports,__globalThis) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"6Mk4q":[function(require,module,exports,__globalThis) {
var getAllKeys = require("b911593d305cf4a2");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = equalObjects;

},{"b911593d305cf4a2":"6nMvD"}],"6nMvD":[function(require,module,exports,__globalThis) {
var baseGetAllKeys = require("c3dbe402f6996a21"), getSymbols = require("aa79b69a13f924db"), keys = require("e3ad83e53433bc8a");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"c3dbe402f6996a21":"a1CCa","aa79b69a13f924db":"3ujuB","e3ad83e53433bc8a":"4gozK"}],"a1CCa":[function(require,module,exports,__globalThis) {
var arrayPush = require("abfc70b400ed76c2"), isArray = require("148b85918856c33a");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"abfc70b400ed76c2":"1bzZi","148b85918856c33a":"2bYH3"}],"1bzZi":[function(require,module,exports,__globalThis) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"3ujuB":[function(require,module,exports,__globalThis) {
var arrayFilter = require("7fe025254f0b7e4a"), stubArray = require("6b1c62cea92cdb9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"7fe025254f0b7e4a":"jj3Mm","6b1c62cea92cdb9":"7uWeX"}],"jj3Mm":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"7uWeX":[function(require,module,exports,__globalThis) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"i3l7I":[function(require,module,exports,__globalThis) {
var DataView = require("7f038695b2fdb86e"), Map = require("28e3344aae951f13"), Promise = require("b286298be5b1d9a4"), Set = require("3ae50c158f89813"), WeakMap = require("9f458755f627d456"), baseGetTag = require("8e9160b373d7fe66"), toSource = require("b210627dd951641f");
/** `Object#toString` result references. */ var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7f038695b2fdb86e":"j5yI2","28e3344aae951f13":"2dsmN","b286298be5b1d9a4":"8JIwP","3ae50c158f89813":"kLEEL","9f458755f627d456":"9Z5gH","8e9160b373d7fe66":"g69ny","b210627dd951641f":"bAnJz"}],"j5yI2":[function(require,module,exports,__globalThis) {
var getNative = require("a6517d0448dad786"), root = require("f83c375075418382");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView');
module.exports = DataView;

},{"a6517d0448dad786":"ejqXU","f83c375075418382":"4985z"}],"8JIwP":[function(require,module,exports,__globalThis) {
var getNative = require("6940648d854355b5"), root = require("a5c6637bac681a0");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, 'Promise');
module.exports = Promise;

},{"6940648d854355b5":"ejqXU","a5c6637bac681a0":"4985z"}],"kLEEL":[function(require,module,exports,__globalThis) {
var getNative = require("56b792d64741a4ff"), root = require("ca486d41cdf819d4");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, 'Set');
module.exports = Set;

},{"56b792d64741a4ff":"ejqXU","ca486d41cdf819d4":"4985z"}],"9Z5gH":[function(require,module,exports,__globalThis) {
var getNative = require("4507415bd8810d3c"), root = require("7a9a6581834a8452");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, 'WeakMap');
module.exports = WeakMap;

},{"4507415bd8810d3c":"ejqXU","7a9a6581834a8452":"4985z"}],"7C3fu":[function(require,module,exports,__globalThis) {
var isStrictComparable = require("8ba18052e16e94fb"), keys = require("94ffded3a85af2f6");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"8ba18052e16e94fb":"hRLL6","94ffded3a85af2f6":"4gozK"}],"hRLL6":[function(require,module,exports,__globalThis) {
var isObject = require("be1941f960bbf057");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"be1941f960bbf057":"6NReb"}],"felLl":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"isNRN":[function(require,module,exports,__globalThis) {
var baseIsEqual = require("cebe22f5ca0827a7"), get = require("d5ca180f7d6f956a"), hasIn = require("3462bb3f546fa1f7"), isKey = require("f5fef07966a1c4ee"), isStrictComparable = require("2a1cd212d48516"), matchesStrictComparable = require("885e72ee7fc6d296"), toKey = require("cd65eaf4a3af29f6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"cebe22f5ca0827a7":"gNP09","d5ca180f7d6f956a":"gY0p0","3462bb3f546fa1f7":"72hLZ","f5fef07966a1c4ee":"h78Ge","2a1cd212d48516":"hRLL6","885e72ee7fc6d296":"felLl","cd65eaf4a3af29f6":"1bIP6"}],"gY0p0":[function(require,module,exports,__globalThis) {
var baseGet = require("446ba3c1be7939a3");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"446ba3c1be7939a3":"b66Bd"}],"b66Bd":[function(require,module,exports,__globalThis) {
var castPath = require("434ba191fc1dcf09"), toKey = require("c3296f04fad32769");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"434ba191fc1dcf09":"jfxns","c3296f04fad32769":"1bIP6"}],"jfxns":[function(require,module,exports,__globalThis) {
var isArray = require("26a856890198f45b"), isKey = require("e823e604d75f975b"), stringToPath = require("f5fff1c342107fbd"), toString = require("b04e8cc634273c23");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"26a856890198f45b":"2bYH3","e823e604d75f975b":"h78Ge","f5fff1c342107fbd":"4om0N","b04e8cc634273c23":"9dDin"}],"h78Ge":[function(require,module,exports,__globalThis) {
var isArray = require("1efcc081e9a448a8"), isSymbol = require("4cdff6c9e9ff5d38");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"1efcc081e9a448a8":"2bYH3","4cdff6c9e9ff5d38":"hyFLE"}],"hyFLE":[function(require,module,exports,__globalThis) {
var baseGetTag = require("6118c0d5630f51ce"), isObjectLike = require("74644060ad1a1d3c");
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"6118c0d5630f51ce":"g69ny","74644060ad1a1d3c":"5AOB5"}],"4om0N":[function(require,module,exports,__globalThis) {
var memoizeCapped = require("55f565a895f455e5");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"55f565a895f455e5":"aA3ie"}],"aA3ie":[function(require,module,exports,__globalThis) {
var memoize = require("cb456550b1f5dd0a");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"cb456550b1f5dd0a":"juhi7"}],"juhi7":[function(require,module,exports,__globalThis) {
var MapCache = require("b34b26bf235f1cdd");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"b34b26bf235f1cdd":"gGU71"}],"9dDin":[function(require,module,exports,__globalThis) {
var baseToString = require("81fca33832a744d9");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
module.exports = toString;

},{"81fca33832a744d9":"iehtJ"}],"iehtJ":[function(require,module,exports,__globalThis) {
var Symbol = require("16af83505444e42a"), arrayMap = require("8439a3a1551d0706"), isArray = require("4b12c9f502d3288a"), isSymbol = require("a0ebd327d618908a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = baseToString;

},{"16af83505444e42a":"A3k0h","8439a3a1551d0706":"e28WC","4b12c9f502d3288a":"2bYH3","a0ebd327d618908a":"hyFLE"}],"1bIP6":[function(require,module,exports,__globalThis) {
var isSymbol = require("2aed9f6fd4b7386");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = toKey;

},{"2aed9f6fd4b7386":"hyFLE"}],"72hLZ":[function(require,module,exports,__globalThis) {
var baseHasIn = require("9fbd4bb192f3f572"), hasPath = require("b0aefd36de99e579");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"9fbd4bb192f3f572":"376ET","b0aefd36de99e579":"5wQrI"}],"376ET":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"5wQrI":[function(require,module,exports,__globalThis) {
var castPath = require("bdbd2cfd212d36f7"), isArguments = require("47ffafdab3ba0d6f"), isArray = require("93ebd263ff0131c1"), isIndex = require("252ef74480e01958"), isLength = require("23c2f64e75e90a2"), toKey = require("af5ade297cb685ee");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"bdbd2cfd212d36f7":"jfxns","47ffafdab3ba0d6f":"7U1h4","93ebd263ff0131c1":"2bYH3","252ef74480e01958":"1w8D6","23c2f64e75e90a2":"gba14","af5ade297cb685ee":"1bIP6"}],"15pXc":[function(require,module,exports,__globalThis) {
var baseProperty = require("c7f2d79ee4b1c16a"), basePropertyDeep = require("abf31da39349df22"), isKey = require("a387ef4a4373de2c"), toKey = require("9315973458389ae7");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"c7f2d79ee4b1c16a":"l2ViY","abf31da39349df22":"f2QjL","a387ef4a4373de2c":"h78Ge","9315973458389ae7":"1bIP6"}],"l2ViY":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"f2QjL":[function(require,module,exports,__globalThis) {
var baseGet = require("f0f9f03bc3030d02");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"f0f9f03bc3030d02":"b66Bd"}],"8aT0A":[function(require,module,exports,__globalThis) {
var baseEach = require("488df795cf6fe570"), isArrayLike = require("2924e2db4bb5430d");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = baseMap;

},{"488df795cf6fe570":"458ha","2924e2db4bb5430d":"MFtZx"}],"458ha":[function(require,module,exports,__globalThis) {
var baseForOwn = require("ee57d32bcdc873cb"), createBaseEach = require("f1e3fc84161ef3ec");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"ee57d32bcdc873cb":"eCC1H","f1e3fc84161ef3ec":"gXHVm"}],"gXHVm":[function(require,module,exports,__globalThis) {
var isArrayLike = require("49bbd11cbf093bb1");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"49bbd11cbf093bb1":"MFtZx"}],"fmyNm":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mergeClasses = undefined;
var _forOwn2 = require("42f7fd880fbb6b28");
var _forOwn3 = _interopRequireDefault(_forOwn2);
var _cloneDeep2 = require("fe0598645aa3c32b");
var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
    var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
    activeNames.map(function(name) {
        var toMerge = classes[name];
        if (toMerge) (0, _forOwn3.default)(toMerge, function(value, key) {
            if (!styles[key]) styles[key] = {};
            styles[key] = _extends({}, styles[key], toMerge[key]);
        });
        return name;
    });
    return styles;
};
exports.default = mergeClasses;

},{"42f7fd880fbb6b28":"8iXol","fe0598645aa3c32b":"lpaxs"}],"lpaxs":[function(require,module,exports,__globalThis) {
var baseClone = require("9b38cc9a3ba32230");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
module.exports = cloneDeep;

},{"9b38cc9a3ba32230":"78ooG"}],"78ooG":[function(require,module,exports,__globalThis) {
var Stack = require("c3256a0a192955f9"), arrayEach = require("3a79976eb46af94a"), assignValue = require("bc83a05a4f99d69b"), baseAssign = require("e6b4c3e6c85df6bb"), baseAssignIn = require("f340cc553ba5643c"), cloneBuffer = require("e72e99883a50402d"), copyArray = require("dc840ead07f1054"), copySymbols = require("309288e8ee190af0"), copySymbolsIn = require("687fa30fede0b048"), getAllKeys = require("bb0ba724f98b094d"), getAllKeysIn = require("12bae1dca0e83064"), getTag = require("4c3204eaea28d680"), initCloneArray = require("fd7741200b462cdf"), initCloneByTag = require("f93a1d24ac08e076"), initCloneObject = require("630039e80f692f17"), isArray = require("f37949484ab52dae"), isBuffer = require("ac876cc65d29c86e"), isMap = require("1056c031d98783c0"), isObject = require("1800fb3122907fc2"), isSet = require("31f022f648037bd3"), keys = require("5f3267fbd9848a7d"), keysIn = require("7d3f3bdc4f2e7bb8");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (isSet(value)) value.forEach(function(subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if (isMap(value)) value.forEach(function(subValue, key) {
        result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = baseClone;

},{"c3256a0a192955f9":"dymnP","3a79976eb46af94a":"jSpSP","bc83a05a4f99d69b":"eQHG3","e6b4c3e6c85df6bb":"lMgv5","f340cc553ba5643c":"gg58v","e72e99883a50402d":"bgJ66","dc840ead07f1054":"7WOBx","309288e8ee190af0":"8uMX9","687fa30fede0b048":"e9H4c","bb0ba724f98b094d":"6nMvD","12bae1dca0e83064":"d2EQ0","4c3204eaea28d680":"i3l7I","fd7741200b462cdf":"IrH7G","f93a1d24ac08e076":"4aVfI","630039e80f692f17":"7cNNi","f37949484ab52dae":"2bYH3","ac876cc65d29c86e":"fs7Lv","1056c031d98783c0":"aoPKG","1800fb3122907fc2":"6NReb","31f022f648037bd3":"6KW3L","5f3267fbd9848a7d":"4gozK","7d3f3bdc4f2e7bb8":"5wT7m"}],"jSpSP":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = arrayEach;

},{}],"eQHG3":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("be513dd57a36b3f4"), eq = require("b62ef95b3cf1cde1");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"be513dd57a36b3f4":"2xB46","b62ef95b3cf1cde1":"1uQuO"}],"2xB46":[function(require,module,exports,__globalThis) {
var defineProperty = require("57c6267f904aee0a");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"57c6267f904aee0a":"9SyZr"}],"9SyZr":[function(require,module,exports,__globalThis) {
var getNative = require("7565accd8c33cb8b");
var defineProperty = function() {
    try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"7565accd8c33cb8b":"ejqXU"}],"lMgv5":[function(require,module,exports,__globalThis) {
var copyObject = require("c7567f70ddd05963"), keys = require("fcf23a0242ef0da9");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
module.exports = baseAssign;

},{"c7567f70ddd05963":"xMtOL","fcf23a0242ef0da9":"4gozK"}],"xMtOL":[function(require,module,exports,__globalThis) {
var assignValue = require("51e2769785cbfa78"), baseAssignValue = require("9cddf6ac1a092765");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"51e2769785cbfa78":"eQHG3","9cddf6ac1a092765":"2xB46"}],"gg58v":[function(require,module,exports,__globalThis) {
var copyObject = require("6f2a44bcb454186d"), keysIn = require("7697a1565646c93");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssignIn(object, source) {
    return object && copyObject(source, keysIn(source), object);
}
module.exports = baseAssignIn;

},{"6f2a44bcb454186d":"xMtOL","7697a1565646c93":"5wT7m"}],"5wT7m":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("635aebb56f3a408f"), baseKeysIn = require("194eb1a802636842"), isArrayLike = require("ac15afdc3ddd76cd");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"635aebb56f3a408f":"81yOD","194eb1a802636842":"fchpS","ac15afdc3ddd76cd":"MFtZx"}],"fchpS":[function(require,module,exports,__globalThis) {
var isObject = require("bd1636f5883f1002"), isPrototype = require("f7d53cd92b2b977b"), nativeKeysIn = require("c039208a16eb68bd");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"bd1636f5883f1002":"6NReb","f7d53cd92b2b977b":"6Gf4U","c039208a16eb68bd":"htY8C"}],"htY8C":[function(require,module,exports,__globalThis) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"bgJ66":[function(require,module,exports,__globalThis) {
var root = require("5d68e87b918bbcc5");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

},{"5d68e87b918bbcc5":"4985z"}],"7WOBx":[function(require,module,exports,__globalThis) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = copyArray;

},{}],"8uMX9":[function(require,module,exports,__globalThis) {
var copyObject = require("4cc37626612884ad"), getSymbols = require("39cbde2205d9399c");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
module.exports = copySymbols;

},{"4cc37626612884ad":"xMtOL","39cbde2205d9399c":"3ujuB"}],"e9H4c":[function(require,module,exports,__globalThis) {
var copyObject = require("73fd77060a6bfcff"), getSymbolsIn = require("9b660e6b0c20d303");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbolsIn(source, object) {
    return copyObject(source, getSymbolsIn(source), object);
}
module.exports = copySymbolsIn;

},{"73fd77060a6bfcff":"xMtOL","9b660e6b0c20d303":"7js9e"}],"7js9e":[function(require,module,exports,__globalThis) {
var arrayPush = require("2f7c7daf8773557"), getPrototype = require("6ccae2aa7cfa3c66"), getSymbols = require("bdb501682ee9305d"), stubArray = require("7641fe4ae6d2cc96");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while(object){
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
module.exports = getSymbolsIn;

},{"2f7c7daf8773557":"1bzZi","6ccae2aa7cfa3c66":"CmjGT","bdb501682ee9305d":"3ujuB","7641fe4ae6d2cc96":"7uWeX"}],"d2EQ0":[function(require,module,exports,__globalThis) {
var baseGetAllKeys = require("f6d6a583609f5bf6"), getSymbolsIn = require("feede5d0a2d06427"), keysIn = require("287f70f798405911");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
module.exports = getAllKeysIn;

},{"f6d6a583609f5bf6":"a1CCa","feede5d0a2d06427":"7js9e","287f70f798405911":"5wT7m"}],"IrH7G":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = initCloneArray;

},{}],"4aVfI":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("d24f0b9a34d2e38a"), cloneDataView = require("dbf04edaab2ae376"), cloneRegExp = require("763300f2dd9bdaf3"), cloneSymbol = require("c30e64d90e4b92d1"), cloneTypedArray = require("d1edd8349e9ad54d");
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return new Ctor;
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return new Ctor;
        case symbolTag:
            return cloneSymbol(object);
    }
}
module.exports = initCloneByTag;

},{"d24f0b9a34d2e38a":"4bAdD","dbf04edaab2ae376":"bdblB","763300f2dd9bdaf3":"blUvR","c30e64d90e4b92d1":"9L0NT","d1edd8349e9ad54d":"hiCj1"}],"4bAdD":[function(require,module,exports,__globalThis) {
var Uint8Array = require("c50984a96481fd62");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;

},{"c50984a96481fd62":"3xl2A"}],"bdblB":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("55b473c4a5622b5a");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = cloneDataView;

},{"55b473c4a5622b5a":"4bAdD"}],"blUvR":[function(require,module,exports,__globalThis) {
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = cloneRegExp;

},{}],"9L0NT":[function(require,module,exports,__globalThis) {
var Symbol = require("b88cf659c1f1d984");
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
module.exports = cloneSymbol;

},{"b88cf659c1f1d984":"A3k0h"}],"hiCj1":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("b3183de060e04548");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;

},{"b3183de060e04548":"4bAdD"}],"7cNNi":[function(require,module,exports,__globalThis) {
var baseCreate = require("4a25a11eb90445e8"), getPrototype = require("8c92276927b7c3e0"), isPrototype = require("e939f15d7a0f64a5");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
module.exports = initCloneObject;

},{"4a25a11eb90445e8":"4MhDd","8c92276927b7c3e0":"CmjGT","e939f15d7a0f64a5":"6Gf4U"}],"4MhDd":[function(require,module,exports,__globalThis) {
var isObject = require("2c87f13f7934e7bd");
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = baseCreate;

},{"2c87f13f7934e7bd":"6NReb"}],"aoPKG":[function(require,module,exports,__globalThis) {
var baseIsMap = require("bcb4b5290583d129"), baseUnary = require("6a7e6b1a2d9fb1d5"), nodeUtil = require("7d4f449dd306450f");
/* Node.js helper references. */ var nodeIsMap = nodeUtil && nodeUtil.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
module.exports = isMap;

},{"bcb4b5290583d129":"3rtYS","6a7e6b1a2d9fb1d5":"2jWGX","7d4f449dd306450f":"747Ud"}],"3rtYS":[function(require,module,exports,__globalThis) {
var getTag = require("f59b9932854175ea"), isObjectLike = require("88260e33e0003386");
/** `Object#toString` result references. */ var mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function baseIsMap(value) {
    return isObjectLike(value) && getTag(value) == mapTag;
}
module.exports = baseIsMap;

},{"f59b9932854175ea":"i3l7I","88260e33e0003386":"5AOB5"}],"6KW3L":[function(require,module,exports,__globalThis) {
var baseIsSet = require("efa5963001bed2f4"), baseUnary = require("3cb35dba719c68b1"), nodeUtil = require("7a3e899a332ff7be");
/* Node.js helper references. */ var nodeIsSet = nodeUtil && nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
module.exports = isSet;

},{"efa5963001bed2f4":"gPHHz","3cb35dba719c68b1":"2jWGX","7a3e899a332ff7be":"747Ud"}],"gPHHz":[function(require,module,exports,__globalThis) {
var getTag = require("3451ecb010f954cc"), isObjectLike = require("b6fc875bc5f351c9");
/** `Object#toString` result references. */ var setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function baseIsSet(value) {
    return isObjectLike(value) && getTag(value) == setTag;
}
module.exports = baseIsSet;

},{"3451ecb010f954cc":"i3l7I","b6fc875bc5f351c9":"5AOB5"}],"18Q7t":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.autoprefix = undefined;
var _forOwn2 = require("6b2ab06ed0e74650");
var _forOwn3 = _interopRequireDefault(_forOwn2);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var transforms = {
    borderRadius: function borderRadius(value) {
        return {
            msBorderRadius: value,
            MozBorderRadius: value,
            OBorderRadius: value,
            WebkitBorderRadius: value,
            borderRadius: value
        };
    },
    boxShadow: function boxShadow(value) {
        return {
            msBoxShadow: value,
            MozBoxShadow: value,
            OBoxShadow: value,
            WebkitBoxShadow: value,
            boxShadow: value
        };
    },
    userSelect: function userSelect(value) {
        return {
            WebkitTouchCallout: value,
            KhtmlUserSelect: value,
            MozUserSelect: value,
            msUserSelect: value,
            WebkitUserSelect: value,
            userSelect: value
        };
    },
    flex: function flex(value) {
        return {
            WebkitBoxFlex: value,
            MozBoxFlex: value,
            WebkitFlex: value,
            msFlex: value,
            flex: value
        };
    },
    flexBasis: function flexBasis(value) {
        return {
            WebkitFlexBasis: value,
            flexBasis: value
        };
    },
    justifyContent: function justifyContent(value) {
        return {
            WebkitJustifyContent: value,
            justifyContent: value
        };
    },
    transition: function transition(value) {
        return {
            msTransition: value,
            MozTransition: value,
            OTransition: value,
            WebkitTransition: value,
            transition: value
        };
    },
    transform: function transform(value) {
        return {
            msTransform: value,
            MozTransform: value,
            OTransform: value,
            WebkitTransform: value,
            transform: value
        };
    },
    absolute: function absolute(value) {
        var direction = value && value.split(' ');
        return {
            position: 'absolute',
            top: direction && direction[0],
            right: direction && direction[1],
            bottom: direction && direction[2],
            left: direction && direction[3]
        };
    },
    extend: function extend(name, otherElementStyles) {
        var otherStyle = otherElementStyles[name];
        if (otherStyle) return otherStyle;
        return {
            'extend': name
        };
    }
};
var autoprefix = exports.autoprefix = function autoprefix(elements) {
    var prefixed = {};
    (0, _forOwn3.default)(elements, function(styles, element) {
        var expanded = {};
        (0, _forOwn3.default)(styles, function(value, key) {
            var transform = transforms[key];
            if (transform) expanded = _extends({}, expanded, transform(value));
            else expanded[key] = value;
        });
        prefixed[element] = expanded;
    });
    return prefixed;
};
exports.default = autoprefix;

},{"6b2ab06ed0e74650":"8iXol"}],"8Cc6Q":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hover = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("a618bb79e13970dd");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var hover = exports.hover = function hover(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        _inherits(Hover, _React$Component);
        function Hover() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Hover);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                hover: false
            }, _this.handleMouseOver = function() {
                return _this.setState({
                    hover: true
                });
            }, _this.handleMouseOut = function() {
                return _this.setState({
                    hover: false
                });
            }, _this.render = function() {
                return _react2.default.createElement(Span, {
                    onMouseOver: _this.handleMouseOver,
                    onMouseOut: _this.handleMouseOut
                }, _react2.default.createElement(Component, _extends({}, _this.props, _this.state)));
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        return Hover;
    }(_react2.default.Component);
};
exports.default = hover;

},{"a618bb79e13970dd":"6wC8C"}],"diqVA":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.active = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("91e1b91cd0b21ba2");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var active = exports.active = function active(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        _inherits(Active, _React$Component);
        function Active() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Active);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                active: false
            }, _this.handleMouseDown = function() {
                return _this.setState({
                    active: true
                });
            }, _this.handleMouseUp = function() {
                return _this.setState({
                    active: false
                });
            }, _this.render = function() {
                return _react2.default.createElement(Span, {
                    onMouseDown: _this.handleMouseDown,
                    onMouseUp: _this.handleMouseUp
                }, _react2.default.createElement(Component, _extends({}, _this.props, _this.state)));
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        return Active;
    }(_react2.default.Component);
};
exports.default = active;

},{"91e1b91cd0b21ba2":"6wC8C"}],"kJLEK":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var loopable = function loopable(i, length) {
    var props = {};
    var setProp = function setProp(name) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        props[name] = value;
    };
    i === 0 && setProp('first-child');
    i === length - 1 && setProp('last-child');
    (i === 0 || i % 2 === 0) && setProp('even');
    Math.abs(i % 2) === 1 && setProp('odd');
    setProp('nth-child', i);
    return props;
};
exports.default = loopable;

},{}],"gx5lJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alpha", ()=>(0, _alphaDefault.default));
parcelHelpers.export(exports, "Checkboard", ()=>(0, _checkboardDefault.default));
parcelHelpers.export(exports, "EditableInput", ()=>(0, _editableInputDefault.default));
parcelHelpers.export(exports, "Hue", ()=>(0, _hueDefault.default));
parcelHelpers.export(exports, "Raised", ()=>(0, _raisedDefault.default));
parcelHelpers.export(exports, "Saturation", ()=>(0, _saturationDefault.default));
parcelHelpers.export(exports, "ColorWrap", ()=>(0, _colorWrapDefault.default));
parcelHelpers.export(exports, "Swatch", ()=>(0, _swatchDefault.default));
var _alpha = require("./Alpha");
var _alphaDefault = parcelHelpers.interopDefault(_alpha);
var _checkboard = require("./Checkboard");
var _checkboardDefault = parcelHelpers.interopDefault(_checkboard);
var _editableInput = require("./EditableInput");
var _editableInputDefault = parcelHelpers.interopDefault(_editableInput);
var _hue = require("./Hue");
var _hueDefault = parcelHelpers.interopDefault(_hue);
var _raised = require("./Raised");
var _raisedDefault = parcelHelpers.interopDefault(_raised);
var _saturation = require("./Saturation");
var _saturationDefault = parcelHelpers.interopDefault(_saturation);
var _colorWrap = require("./ColorWrap");
var _colorWrapDefault = parcelHelpers.interopDefault(_colorWrap);
var _swatch = require("./Swatch");
var _swatchDefault = parcelHelpers.interopDefault(_swatch);

},{"./Alpha":"l4MGX","./Checkboard":"2JG2I","./EditableInput":"fnll7","./Hue":"ea84j","./Raised":"gcstR","./Saturation":"7BT44","./ColorWrap":"6BSbS","./Swatch":"jdR52","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"l4MGX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alpha", ()=>Alpha);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _alpha = require("../../helpers/alpha");
var _checkboard = require("./Checkboard");
var _checkboardDefault = parcelHelpers.interopDefault(_checkboard);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Alpha = function(_ref) {
    _inherits(Alpha, _ref);
    function Alpha() {
        var _ref2;
        var _temp, _this, _ret;
        _classCallCheck(this, Alpha);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = _alpha.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleChange);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(Alpha, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var rgb = this.props.rgb;
                var styles = (0, _reactcssDefault.default)({
                    'default': {
                        alpha: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        checkboard: {
                            absolute: '0px 0px 0px 0px',
                            overflow: 'hidden',
                            borderRadius: this.props.radius
                        },
                        gradient: {
                            absolute: '0px 0px 0px 0px',
                            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        container: {
                            position: 'relative',
                            height: '100%',
                            margin: '0 3px'
                        },
                        pointer: {
                            position: 'absolute',
                            left: rgb.a * 100 + '%'
                        },
                        slider: {
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            marginTop: '1px',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        gradient: {
                            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
                        },
                        pointer: {
                            left: 0,
                            top: rgb.a * 100 + '%'
                        }
                    },
                    'overwrite': _extends({}, this.props.style)
                }, {
                    vertical: this.props.direction === 'vertical',
                    overwrite: true
                });
                return (0, _reactDefault.default).createElement('div', {
                    style: styles.alpha
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.checkboard
                }, (0, _reactDefault.default).createElement((0, _checkboardDefault.default), {
                    renderers: this.props.renderers
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.gradient
                }), (0, _reactDefault.default).createElement('div', {
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, _reactDefault.default).createElement(this.props.pointer, this.props) : (0, _reactDefault.default).createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Alpha;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = Alpha;

},{"react":"6wC8C","reactcss":"7yqRl","../../helpers/alpha":"9A1K9","./Checkboard":"2JG2I","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9A1K9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateChange", ()=>calculateChange);
var calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var a = void 0;
        if (top < 0) a = 0;
        else if (top > containerHeight) a = 1;
        else a = Math.round(top * 100 / containerHeight) / 100;
        if (hsl.a !== a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: a,
            source: 'rgb'
        };
    } else {
        var _a = void 0;
        if (left < 0) _a = 0;
        else if (left > containerWidth) _a = 1;
        else _a = Math.round(left * 100 / containerWidth) / 100;
        if (initialA !== _a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: _a,
            source: 'rgb'
        };
    }
    return null;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2JG2I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkboard", ()=>Checkboard);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _checkboard = require("../../helpers/checkboard");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var Checkboard = function Checkboard(_ref) {
    var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow, children = _ref.children;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            grid: {
                borderRadius: borderRadius,
                boxShadow: boxShadow,
                absolute: '0px 0px 0px 0px',
                background: 'url(' + _checkboard.get(white, grey, size, renderers.canvas) + ') center left'
            }
        }
    });
    return (0, _react.isValidElement)(children) ? (0, _reactDefault.default).cloneElement(children, _extends({}, children.props, {
        style: _extends({}, children.props.style, styles.grid)
    })) : (0, _reactDefault.default).createElement('div', {
        style: styles.grid
    });
};
Checkboard.defaultProps = {
    size: 8,
    white: 'transparent',
    grey: 'rgba(0,0,0,.08)',
    renderers: {}
};
exports.default = Checkboard;

},{"react":"6wC8C","reactcss":"7yqRl","../../helpers/checkboard":"dQ6tK","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"dQ6tK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
parcelHelpers.export(exports, "get", ()=>get);
var checkboardCache = {};
var render = function render(c1, c2, size, serverCanvas) {
    if (typeof document === 'undefined' && !serverCanvas) return null;
    var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
    canvas.width = size * 2;
    canvas.height = size * 2;
    var ctx = canvas.getContext('2d');
    if (!ctx) return null;
     // If no context can be found, return early.
    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
};
var get = function get(c1, c2, size, serverCanvas) {
    var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
    if (checkboardCache[key]) return checkboardCache[key];
    var checkboard = render(c1, c2, size, serverCanvas);
    checkboardCache[key] = checkboard;
    return checkboard;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fnll7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditableInput", ()=>EditableInput);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var DEFAULT_ARROW_OFFSET = 1;
var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [
    UP_KEY_CODE,
    DOWN_KEY_CODE
];
var isValidKeyCode = function isValidKeyCode(keyCode) {
    return VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var getNumberValue = function getNumberValue(value) {
    return Number(String(value).replace(/%/g, ''));
};
var idCounter = 1;
var EditableInput = function(_ref) {
    _inherits(EditableInput, _ref);
    function EditableInput(props) {
        _classCallCheck(this, EditableInput);
        var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
        _this.handleBlur = function() {
            if (_this.state.blurValue) _this.setState({
                value: _this.state.blurValue,
                blurValue: null
            });
        };
        _this.handleChange = function(e) {
            _this.setUpdatedValue(e.target.value, e);
        };
        _this.handleKeyDown = function(e) {
            // In case `e.target.value` is a percentage remove the `%` character
            // and update accordingly with a percentage
            // https://github.com/casesandberg/react-color/issues/383
            var value = getNumberValue(e.target.value);
            if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
                var offset = _this.getArrowOffset();
                var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;
                _this.setUpdatedValue(updatedValue, e);
            }
        };
        _this.handleDrag = function(e) {
            if (_this.props.dragLabel) {
                var newValue = Math.round(_this.props.value + e.movementX);
                if (newValue >= 0 && newValue <= _this.props.dragMax) _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
            }
        };
        _this.handleMouseDown = function(e) {
            if (_this.props.dragLabel) {
                e.preventDefault();
                _this.handleDrag(e);
                window.addEventListener('mousemove', _this.handleDrag);
                window.addEventListener('mouseup', _this.handleMouseUp);
            }
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.unbindEventListeners = function() {
            window.removeEventListener('mousemove', _this.handleDrag);
            window.removeEventListener('mouseup', _this.handleMouseUp);
        };
        _this.state = {
            value: String(props.value).toUpperCase(),
            blurValue: String(props.value).toUpperCase()
        };
        _this.inputId = 'rc-editable-input-' + idCounter++;
        return _this;
    }
    _createClass(EditableInput, [
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
                    if (this.input === document.activeElement) this.setState({
                        blurValue: String(this.props.value).toUpperCase()
                    });
                    else this.setState({
                        value: String(this.props.value).toUpperCase(),
                        blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
                    });
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'getValueObjectWithLabel',
            value: function getValueObjectWithLabel(value) {
                return _defineProperty({}, this.props.label, value);
            }
        },
        {
            key: 'getArrowOffset',
            value: function getArrowOffset() {
                return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
            }
        },
        {
            key: 'setUpdatedValue',
            value: function setUpdatedValue(value, e) {
                var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
                this.props.onChange && this.props.onChange(onChangeValue, e);
                this.setState({
                    value: value
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var styles = (0, _reactcssDefault.default)({
                    'default': {
                        wrap: {
                            position: 'relative'
                        }
                    },
                    'user-override': {
                        wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
                        input: this.props.style && this.props.style.input ? this.props.style.input : {},
                        label: this.props.style && this.props.style.label ? this.props.style.label : {}
                    },
                    'dragLabel-true': {
                        label: {
                            cursor: 'ew-resize'
                        }
                    }
                }, {
                    'user-override': true
                }, this.props);
                return (0, _reactDefault.default).createElement('div', {
                    style: styles.wrap
                }, (0, _reactDefault.default).createElement('input', {
                    id: this.inputId,
                    style: styles.input,
                    ref: function ref(input) {
                        return _this2.input = input;
                    },
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    placeholder: this.props.placeholder,
                    spellCheck: 'false'
                }), this.props.label && !this.props.hideLabel ? (0, _reactDefault.default).createElement('label', {
                    htmlFor: this.inputId,
                    style: styles.label,
                    onMouseDown: this.handleMouseDown
                }, this.props.label) : null);
            }
        }
    ]);
    return EditableInput;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = EditableInput;

},{"react":"6wC8C","reactcss":"7yqRl","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ea84j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hue", ()=>Hue);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _hue = require("../../helpers/hue");
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Hue = function(_ref) {
    _inherits(Hue, _ref);
    function Hue() {
        var _ref2;
        var _temp, _this, _ret;
        _classCallCheck(this, Hue);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = _hue.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
            change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener('mousemove', _this.handleChange);
            window.addEventListener('mouseup', _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(Hue, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                window.removeEventListener('mousemove', this.handleChange);
                window.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _props$direction = this.props.direction, direction = _props$direction === undefined ? 'horizontal' : _props$direction;
                var styles = (0, _reactcssDefault.default)({
                    'default': {
                        hue: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius,
                            boxShadow: this.props.shadow
                        },
                        container: {
                            padding: '0 2px',
                            position: 'relative',
                            height: '100%',
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            left: this.props.hsl.h * 100 / 360 + '%'
                        },
                        slider: {
                            marginTop: '1px',
                            width: '4px',
                            borderRadius: '1px',
                            height: '8px',
                            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
                            background: '#fff',
                            transform: 'translateX(-2px)'
                        }
                    },
                    'vertical': {
                        pointer: {
                            left: '0px',
                            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
                        }
                    }
                }, {
                    vertical: direction === 'vertical'
                });
                return (0, _reactDefault.default).createElement('div', {
                    style: styles.hue
                }, (0, _reactDefault.default).createElement('div', {
                    className: 'hue-' + direction,
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, _reactDefault.default).createElement('style', null, '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '), (0, _reactDefault.default).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, _reactDefault.default).createElement(this.props.pointer, this.props) : (0, _reactDefault.default).createElement('div', {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Hue;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = Hue;

},{"react":"6wC8C","reactcss":"7yqRl","../../helpers/hue":"kPUqp","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kPUqp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateChange", ()=>calculateChange);
var calculateChange = function calculateChange(e, direction, hsl, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === 'vertical') {
        var h = void 0;
        if (top < 0) h = 359;
        else if (top > containerHeight) h = 0;
        else {
            var percent = -(top * 100 / containerHeight) + 100;
            h = 360 * percent / 100;
        }
        if (hsl.h !== h) return {
            h: h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    } else {
        var _h = void 0;
        if (left < 0) _h = 0;
        else if (left > containerWidth) _h = 359;
        else {
            var _percent = left * 100 / containerWidth;
            _h = 360 * _percent / 100;
        }
        if (hsl.h !== _h) return {
            h: _h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: 'hsl'
        };
    }
    return null;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"gcstR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Raised", ()=>Raised);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var Raised = function Raised(_ref) {
    var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            wrap: {
                position: 'relative',
                display: 'inline-block'
            },
            content: {
                position: 'relative'
            },
            bg: {
                absolute: '0px 0px 0px 0px',
                boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
                borderRadius: radius,
                background: background
            }
        },
        'zDepth-0': {
            bg: {
                boxShadow: 'none'
            }
        },
        'zDepth-1': {
            bg: {
                boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
            }
        },
        'zDepth-2': {
            bg: {
                boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
            }
        },
        'zDepth-3': {
            bg: {
                boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
            }
        },
        'zDepth-4': {
            bg: {
                boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
            }
        },
        'zDepth-5': {
            bg: {
                boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
            }
        },
        'square': {
            bg: {
                borderRadius: '0'
            }
        },
        'circle': {
            bg: {
                borderRadius: '50%'
            }
        }
    }, passedStyles), {
        'zDepth-1': zDepth === 1
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.wrap
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.bg
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.content
    }, children));
};
Raised.propTypes = {
    background: (0, _propTypesDefault.default).string,
    zDepth: (0, _propTypesDefault.default).oneOf([
        0,
        1,
        2,
        3,
        4,
        5
    ]),
    radius: (0, _propTypesDefault.default).number,
    styles: (0, _propTypesDefault.default).object
};
Raised.defaultProps = {
    background: '#fff',
    zDepth: 1,
    radius: 2,
    styles: {}
};
exports.default = Raised;

},{"react":"6wC8C","prop-types":"6YTRF","reactcss":"7yqRl","lodash-es/merge":"4s9GK","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4s9GK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseMergeJs = require("./_baseMerge.js");
var _baseMergeJsDefault = parcelHelpers.interopDefault(_baseMergeJs);
var _createAssignerJs = require("./_createAssigner.js");
var _createAssignerJsDefault = parcelHelpers.interopDefault(_createAssignerJs);
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = (0, _createAssignerJsDefault.default)(function(object, source, srcIndex) {
    (0, _baseMergeJsDefault.default)(object, source, srcIndex);
});
exports.default = merge;

},{"./_baseMerge.js":"bionH","./_createAssigner.js":"1kqQ2","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"bionH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stackJs = require("./_Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _assignMergeValueJs = require("./_assignMergeValue.js");
var _assignMergeValueJsDefault = parcelHelpers.interopDefault(_assignMergeValueJs);
var _baseForJs = require("./_baseFor.js");
var _baseForJsDefault = parcelHelpers.interopDefault(_baseForJs);
var _baseMergeDeepJs = require("./_baseMergeDeep.js");
var _baseMergeDeepJsDefault = parcelHelpers.interopDefault(_baseMergeDeepJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
var _safeGetJs = require("./_safeGet.js");
var _safeGetJsDefault = parcelHelpers.interopDefault(_safeGetJs);
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, _baseForJsDefault.default)(source, function(srcValue, key) {
        stack || (stack = new (0, _stackJsDefault.default));
        if ((0, _isObjectJsDefault.default)(srcValue)) (0, _baseMergeDeepJsDefault.default)(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, _safeGetJsDefault.default)(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, _assignMergeValueJsDefault.default)(object, key, newValue);
        }
    }, (0, _keysInJsDefault.default));
}
exports.default = baseMerge;

},{"./_Stack.js":"ewgF6","./_assignMergeValue.js":"2St1s","./_baseFor.js":"aq01c","./_baseMergeDeep.js":"bDNhP","./isObject.js":"3FPXi","./keysIn.js":"36tp6","./_safeGet.js":"5CWGP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ewgF6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _stackClearJs = require("./_stackClear.js");
var _stackClearJsDefault = parcelHelpers.interopDefault(_stackClearJs);
var _stackDeleteJs = require("./_stackDelete.js");
var _stackDeleteJsDefault = parcelHelpers.interopDefault(_stackDeleteJs);
var _stackGetJs = require("./_stackGet.js");
var _stackGetJsDefault = parcelHelpers.interopDefault(_stackGetJs);
var _stackHasJs = require("./_stackHas.js");
var _stackHasJsDefault = parcelHelpers.interopDefault(_stackHasJs);
var _stackSetJs = require("./_stackSet.js");
var _stackSetJsDefault = parcelHelpers.interopDefault(_stackSetJs);
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new (0, _listCacheJsDefault.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = (0, _stackClearJsDefault.default);
Stack.prototype['delete'] = (0, _stackDeleteJsDefault.default);
Stack.prototype.get = (0, _stackGetJsDefault.default);
Stack.prototype.has = (0, _stackHasJsDefault.default);
Stack.prototype.set = (0, _stackSetJsDefault.default);
exports.default = Stack;

},{"./_ListCache.js":"czb5B","./_stackClear.js":"abGu2","./_stackDelete.js":"5WHAw","./_stackGet.js":"j1JZB","./_stackHas.js":"hzSmq","./_stackSet.js":"1MPge","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"czb5B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheClearJs = require("./_listCacheClear.js");
var _listCacheClearJsDefault = parcelHelpers.interopDefault(_listCacheClearJs);
var _listCacheDeleteJs = require("./_listCacheDelete.js");
var _listCacheDeleteJsDefault = parcelHelpers.interopDefault(_listCacheDeleteJs);
var _listCacheGetJs = require("./_listCacheGet.js");
var _listCacheGetJsDefault = parcelHelpers.interopDefault(_listCacheGetJs);
var _listCacheHasJs = require("./_listCacheHas.js");
var _listCacheHasJsDefault = parcelHelpers.interopDefault(_listCacheHasJs);
var _listCacheSetJs = require("./_listCacheSet.js");
var _listCacheSetJsDefault = parcelHelpers.interopDefault(_listCacheSetJs);
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = (0, _listCacheClearJsDefault.default);
ListCache.prototype['delete'] = (0, _listCacheDeleteJsDefault.default);
ListCache.prototype.get = (0, _listCacheGetJsDefault.default);
ListCache.prototype.has = (0, _listCacheHasJsDefault.default);
ListCache.prototype.set = (0, _listCacheSetJsDefault.default);
exports.default = ListCache;

},{"./_listCacheClear.js":"7o6By","./_listCacheDelete.js":"jIemm","./_listCacheGet.js":"9s7BX","./_listCacheHas.js":"2KLea","./_listCacheSet.js":"8pQkr","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7o6By":[function(require,module,exports,__globalThis) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
exports.default = listCacheClear;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"jIemm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
exports.default = listCacheDelete;

},{"./_assocIndexOf.js":"afsca","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"afsca":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, _eqJsDefault.default)(array[length][0], key)) return length;
    }
    return -1;
}
exports.default = assocIndexOf;

},{"./eq.js":"5kiZ7","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5kiZ7":[function(require,module,exports,__globalThis) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function eq(value, other) {
    return value === other || value !== value && other !== other;
}
exports.default = eq;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9s7BX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
exports.default = listCacheGet;

},{"./_assocIndexOf.js":"afsca","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2KLea":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return (0, _assocIndexOfJsDefault.default)(this.__data__, key) > -1;
}
exports.default = listCacheHas;

},{"./_assocIndexOf.js":"afsca","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8pQkr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assocIndexOfJs = require("./_assocIndexOf.js");
var _assocIndexOfJsDefault = parcelHelpers.interopDefault(_assocIndexOfJs);
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = (0, _assocIndexOfJsDefault.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
exports.default = listCacheSet;

},{"./_assocIndexOf.js":"afsca","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"abGu2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new (0, _listCacheJsDefault.default);
    this.size = 0;
}
exports.default = stackClear;

},{"./_ListCache.js":"czb5B","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5WHAw":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
exports.default = stackDelete;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"j1JZB":[function(require,module,exports,__globalThis) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackGet(key) {
    return this.__data__.get(key);
}
exports.default = stackGet;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hzSmq":[function(require,module,exports,__globalThis) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stackHas(key) {
    return this.__data__.has(key);
}
exports.default = stackHas;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"1MPge":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, _listCacheJsDefault.default)) {
        var pairs = data.__data__;
        if (!(0, _mapJsDefault.default) || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, _mapCacheJsDefault.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
exports.default = stackSet;

},{"./_ListCache.js":"czb5B","./_Map.js":"fNX1n","./_MapCache.js":"3OQXh","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fNX1n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Map = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'Map');
exports.default = Map;

},{"./_getNative.js":"hOQOA","./_root.js":"lCXwP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hOQOA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsNativeJs = require("./_baseIsNative.js");
var _baseIsNativeJsDefault = parcelHelpers.interopDefault(_baseIsNativeJs);
var _getValueJs = require("./_getValue.js");
var _getValueJsDefault = parcelHelpers.interopDefault(_getValueJs);
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = (0, _getValueJsDefault.default)(object, key);
    return (0, _baseIsNativeJsDefault.default)(value) ? value : undefined;
}
exports.default = getNative;

},{"./_baseIsNative.js":"183lW","./_getValue.js":"4811a","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"183lW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isMaskedJs = require("./_isMasked.js");
var _isMaskedJsDefault = parcelHelpers.interopDefault(_isMaskedJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _toSourceJs = require("./_toSource.js");
var _toSourceJsDefault = parcelHelpers.interopDefault(_toSourceJs);
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!(0, _isObjectJsDefault.default)(value) || (0, _isMaskedJsDefault.default)(value)) return false;
    var pattern = (0, _isFunctionJsDefault.default)(value) ? reIsNative : reIsHostCtor;
    return pattern.test((0, _toSourceJsDefault.default)(value));
}
exports.default = baseIsNative;

},{"./isFunction.js":"6DClC","./_isMasked.js":"hlk6n","./isObject.js":"3FPXi","./_toSource.js":"iLvxz","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6DClC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!(0, _isObjectJsDefault.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, _baseGetTagJsDefault.default)(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
exports.default = isFunction;

},{"./_baseGetTag.js":"7xCXT","./isObject.js":"3FPXi","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7xCXT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _getRawTagJs = require("./_getRawTag.js");
var _getRawTagJsDefault = parcelHelpers.interopDefault(_getRawTagJs);
var _objectToStringJs = require("./_objectToString.js");
var _objectToStringJsDefault = parcelHelpers.interopDefault(_objectToStringJs);
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? (0, _getRawTagJsDefault.default)(value) : (0, _objectToStringJsDefault.default)(value);
}
exports.default = baseGetTag;

},{"./_Symbol.js":"j1NQF","./_getRawTag.js":"i6yIy","./_objectToString.js":"7VbeY","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"j1NQF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Built-in value references. */ var Symbol = (0, _rootJsDefault.default).Symbol;
exports.default = Symbol;

},{"./_root.js":"lCXwP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"lCXwP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _freeGlobalJs = require("./_freeGlobal.js");
var _freeGlobalJsDefault = parcelHelpers.interopDefault(_freeGlobalJs);
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = (0, _freeGlobalJsDefault.default) || freeSelf || Function('return this')();
exports.default = root;

},{"./_freeGlobal.js":"2Mp77","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2Mp77":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var global = arguments[3];
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
exports.default = freeGlobal;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"i6yIy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
exports.default = getRawTag;

},{"./_Symbol.js":"j1NQF","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7VbeY":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
exports.default = objectToString;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3FPXi":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
exports.default = isObject;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hlk6n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _coreJsDataJs = require("./_coreJsData.js");
var _coreJsDataJsDefault = parcelHelpers.interopDefault(_coreJsDataJs);
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, _coreJsDataJsDefault.default) && (0, _coreJsDataJsDefault.default).keys && (0, _coreJsDataJsDefault.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
exports.default = isMasked;

},{"./_coreJsData.js":"4sOhp","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4sOhp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Used to detect overreaching core-js shims. */ var coreJsData = (0, _rootJsDefault.default)['__core-js_shared__'];
exports.default = coreJsData;

},{"./_root.js":"lCXwP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"iLvxz":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
exports.default = toSource;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4811a":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function getValue(object, key) {
    return object == null ? undefined : object[key];
}
exports.default = getValue;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3OQXh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheClearJs = require("./_mapCacheClear.js");
var _mapCacheClearJsDefault = parcelHelpers.interopDefault(_mapCacheClearJs);
var _mapCacheDeleteJs = require("./_mapCacheDelete.js");
var _mapCacheDeleteJsDefault = parcelHelpers.interopDefault(_mapCacheDeleteJs);
var _mapCacheGetJs = require("./_mapCacheGet.js");
var _mapCacheGetJsDefault = parcelHelpers.interopDefault(_mapCacheGetJs);
var _mapCacheHasJs = require("./_mapCacheHas.js");
var _mapCacheHasJsDefault = parcelHelpers.interopDefault(_mapCacheHasJs);
var _mapCacheSetJs = require("./_mapCacheSet.js");
var _mapCacheSetJsDefault = parcelHelpers.interopDefault(_mapCacheSetJs);
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = (0, _mapCacheClearJsDefault.default);
MapCache.prototype['delete'] = (0, _mapCacheDeleteJsDefault.default);
MapCache.prototype.get = (0, _mapCacheGetJsDefault.default);
MapCache.prototype.has = (0, _mapCacheHasJsDefault.default);
MapCache.prototype.set = (0, _mapCacheSetJsDefault.default);
exports.default = MapCache;

},{"./_mapCacheClear.js":"exwhm","./_mapCacheDelete.js":"aRmiF","./_mapCacheGet.js":"kJvo8","./_mapCacheHas.js":"7KOUj","./_mapCacheSet.js":"gIujw","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"exwhm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hashJs = require("./_Hash.js");
var _hashJsDefault = parcelHelpers.interopDefault(_hashJs);
var _listCacheJs = require("./_ListCache.js");
var _listCacheJsDefault = parcelHelpers.interopDefault(_listCacheJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, _hashJsDefault.default),
        'map': new ((0, _mapJsDefault.default) || (0, _listCacheJsDefault.default)),
        'string': new (0, _hashJsDefault.default)
    };
}
exports.default = mapCacheClear;

},{"./_Hash.js":"iOZ7R","./_ListCache.js":"czb5B","./_Map.js":"fNX1n","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"iOZ7R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hashClearJs = require("./_hashClear.js");
var _hashClearJsDefault = parcelHelpers.interopDefault(_hashClearJs);
var _hashDeleteJs = require("./_hashDelete.js");
var _hashDeleteJsDefault = parcelHelpers.interopDefault(_hashDeleteJs);
var _hashGetJs = require("./_hashGet.js");
var _hashGetJsDefault = parcelHelpers.interopDefault(_hashGetJs);
var _hashHasJs = require("./_hashHas.js");
var _hashHasJsDefault = parcelHelpers.interopDefault(_hashHasJs);
var _hashSetJs = require("./_hashSet.js");
var _hashSetJsDefault = parcelHelpers.interopDefault(_hashSetJs);
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = (0, _hashClearJsDefault.default);
Hash.prototype['delete'] = (0, _hashDeleteJsDefault.default);
Hash.prototype.get = (0, _hashGetJsDefault.default);
Hash.prototype.has = (0, _hashHasJsDefault.default);
Hash.prototype.set = (0, _hashSetJsDefault.default);
exports.default = Hash;

},{"./_hashClear.js":"eyQkL","./_hashDelete.js":"6YFUs","./_hashGet.js":"lvRXF","./_hashHas.js":"gQnto","./_hashSet.js":"lPp6I","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"eyQkL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = (0, _nativeCreateJsDefault.default) ? (0, _nativeCreateJsDefault.default)(null) : {};
    this.size = 0;
}
exports.default = hashClear;

},{"./_nativeCreate.js":"lSogq","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"lSogq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
/* Built-in method references that are verified to be native. */ var nativeCreate = (0, _getNativeJsDefault.default)(Object, 'create');
exports.default = nativeCreate;

},{"./_getNative.js":"hOQOA","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6YFUs":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
exports.default = hashDelete;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"lvRXF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (0, _nativeCreateJsDefault.default) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
exports.default = hashGet;

},{"./_nativeCreate.js":"lSogq","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"gQnto":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return (0, _nativeCreateJsDefault.default) ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
exports.default = hashHas;

},{"./_nativeCreate.js":"lSogq","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"lPp6I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeCreateJs = require("./_nativeCreate.js");
var _nativeCreateJsDefault = parcelHelpers.interopDefault(_nativeCreateJs);
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, _nativeCreateJsDefault.default) && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
exports.default = hashSet;

},{"./_nativeCreate.js":"lSogq","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"aRmiF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = (0, _getMapDataJsDefault.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
exports.default = mapCacheDelete;

},{"./_getMapData.js":"bFQBa","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"bFQBa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isKeyableJs = require("./_isKeyable.js");
var _isKeyableJsDefault = parcelHelpers.interopDefault(_isKeyableJs);
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return (0, _isKeyableJsDefault.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
exports.default = getMapData;

},{"./_isKeyable.js":"3dM2f","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3dM2f":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
exports.default = isKeyable;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kJvo8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return (0, _getMapDataJsDefault.default)(this, key).get(key);
}
exports.default = mapCacheGet;

},{"./_getMapData.js":"bFQBa","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7KOUj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return (0, _getMapDataJsDefault.default)(this, key).has(key);
}
exports.default = mapCacheHas;

},{"./_getMapData.js":"bFQBa","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"gIujw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getMapDataJs = require("./_getMapData.js");
var _getMapDataJsDefault = parcelHelpers.interopDefault(_getMapDataJs);
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = (0, _getMapDataJsDefault.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
exports.default = mapCacheSet;

},{"./_getMapData.js":"bFQBa","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2St1s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, _eqJsDefault.default)(object[key], value) || value === undefined && !(key in object)) (0, _baseAssignValueJsDefault.default)(object, key, value);
}
exports.default = assignMergeValue;

},{"./_baseAssignValue.js":"l4dYx","./eq.js":"5kiZ7","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"l4dYx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _definePropertyJs = require("./_defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, _definePropertyJsDefault.default)) (0, _definePropertyJsDefault.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
exports.default = baseAssignValue;

},{"./_defineProperty.js":"gZW0H","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"gZW0H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var defineProperty = function() {
    try {
        var func = (0, _getNativeJsDefault.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
exports.default = defineProperty;

},{"./_getNative.js":"hOQOA","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"aq01c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createBaseForJs = require("./_createBaseFor.js");
var _createBaseForJsDefault = parcelHelpers.interopDefault(_createBaseForJs);
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = (0, _createBaseForJsDefault.default)();
exports.default = baseFor;

},{"./_createBaseFor.js":"auZKc","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"auZKc":[function(require,module,exports,__globalThis) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
exports.default = createBaseFor;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"bDNhP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assignMergeValueJs = require("./_assignMergeValue.js");
var _assignMergeValueJsDefault = parcelHelpers.interopDefault(_assignMergeValueJs);
var _cloneBufferJs = require("./_cloneBuffer.js");
var _cloneBufferJsDefault = parcelHelpers.interopDefault(_cloneBufferJs);
var _cloneTypedArrayJs = require("./_cloneTypedArray.js");
var _cloneTypedArrayJsDefault = parcelHelpers.interopDefault(_cloneTypedArrayJs);
var _copyArrayJs = require("./_copyArray.js");
var _copyArrayJsDefault = parcelHelpers.interopDefault(_copyArrayJs);
var _initCloneObjectJs = require("./_initCloneObject.js");
var _initCloneObjectJsDefault = parcelHelpers.interopDefault(_initCloneObjectJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isArrayLikeObjectJs = require("./isArrayLikeObject.js");
var _isArrayLikeObjectJsDefault = parcelHelpers.interopDefault(_isArrayLikeObjectJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isPlainObjectJs = require("./isPlainObject.js");
var _isPlainObjectJsDefault = parcelHelpers.interopDefault(_isPlainObjectJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
var _safeGetJs = require("./_safeGet.js");
var _safeGetJsDefault = parcelHelpers.interopDefault(_safeGetJs);
var _toPlainObjectJs = require("./toPlainObject.js");
var _toPlainObjectJsDefault = parcelHelpers.interopDefault(_toPlainObjectJs);
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, _safeGetJsDefault.default)(object, key), srcValue = (0, _safeGetJsDefault.default)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, _assignMergeValueJsDefault.default)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, _isArrayJsDefault.default)(srcValue), isBuff = !isArr && (0, _isBufferJsDefault.default)(srcValue), isTyped = !isArr && !isBuff && (0, _isTypedArrayJsDefault.default)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, _isArrayJsDefault.default)(objValue)) newValue = objValue;
            else if ((0, _isArrayLikeObjectJsDefault.default)(objValue)) newValue = (0, _copyArrayJsDefault.default)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, _cloneBufferJsDefault.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, _cloneTypedArrayJsDefault.default)(srcValue, true);
            } else newValue = [];
        } else if ((0, _isPlainObjectJsDefault.default)(srcValue) || (0, _isArgumentsJsDefault.default)(srcValue)) {
            newValue = objValue;
            if ((0, _isArgumentsJsDefault.default)(objValue)) newValue = (0, _toPlainObjectJsDefault.default)(objValue);
            else if (!(0, _isObjectJsDefault.default)(objValue) || (0, _isFunctionJsDefault.default)(objValue)) newValue = (0, _initCloneObjectJsDefault.default)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    (0, _assignMergeValueJsDefault.default)(object, key, newValue);
}
exports.default = baseMergeDeep;

},{"./_assignMergeValue.js":"2St1s","./_cloneBuffer.js":"4WF5i","./_cloneTypedArray.js":"hCeaN","./_copyArray.js":"64gGt","./_initCloneObject.js":"kLpnM","./isArguments.js":"1sQzR","./isArray.js":"cFsjQ","./isArrayLikeObject.js":"6f1O8","./isBuffer.js":"aZLZf","./isFunction.js":"6DClC","./isObject.js":"3FPXi","./isPlainObject.js":"jrCSV","./isTypedArray.js":"hjfPZ","./_safeGet.js":"5CWGP","./toPlainObject.js":"62WLl","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4WF5i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, _rootJsDefault.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
exports.default = cloneBuffer;

},{"./_root.js":"lCXwP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hCeaN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneArrayBufferJs = require("./_cloneArrayBuffer.js");
var _cloneArrayBufferJsDefault = parcelHelpers.interopDefault(_cloneArrayBufferJs);
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, _cloneArrayBufferJsDefault.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
exports.default = cloneTypedArray;

},{"./_cloneArrayBuffer.js":"3PbK5","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3PbK5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _uint8ArrayJs = require("./_Uint8Array.js");
var _uint8ArrayJsDefault = parcelHelpers.interopDefault(_uint8ArrayJs);
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, _uint8ArrayJsDefault.default)(result).set(new (0, _uint8ArrayJsDefault.default)(arrayBuffer));
    return result;
}
exports.default = cloneArrayBuffer;

},{"./_Uint8Array.js":"8BRp2","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8BRp2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Built-in value references. */ var Uint8Array = (0, _rootJsDefault.default).Uint8Array;
exports.default = Uint8Array;

},{"./_root.js":"lCXwP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"64gGt":[function(require,module,exports,__globalThis) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
exports.default = copyArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kLpnM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseCreateJs = require("./_baseCreate.js");
var _baseCreateJsDefault = parcelHelpers.interopDefault(_baseCreateJs);
var _getPrototypeJs = require("./_getPrototype.js");
var _getPrototypeJsDefault = parcelHelpers.interopDefault(_getPrototypeJs);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, _isPrototypeJsDefault.default)(object) ? (0, _baseCreateJsDefault.default)((0, _getPrototypeJsDefault.default)(object)) : {};
}
exports.default = initCloneObject;

},{"./_baseCreate.js":"b7u9C","./_getPrototype.js":"1AAYb","./_isPrototype.js":"46tIR","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"b7u9C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, _isObjectJsDefault.default)(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
exports.default = baseCreate;

},{"./isObject.js":"3FPXi","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"1AAYb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overArgJs = require("./_overArg.js");
var _overArgJsDefault = parcelHelpers.interopDefault(_overArgJs);
/** Built-in value references. */ var getPrototype = (0, _overArgJsDefault.default)(Object.getPrototypeOf, Object);
exports.default = getPrototype;

},{"./_overArg.js":"7tDRB","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7tDRB":[function(require,module,exports,__globalThis) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
exports.default = overArg;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"46tIR":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
exports.default = isPrototype;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"1sQzR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsArgumentsJs = require("./_baseIsArguments.js");
var _baseIsArgumentsJsDefault = parcelHelpers.interopDefault(_baseIsArgumentsJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = (0, _baseIsArgumentsJsDefault.default)(function() {
    return arguments;
}()) ? (0, _baseIsArgumentsJsDefault.default) : function(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
exports.default = isArguments;

},{"./_baseIsArguments.js":"2uZoI","./isObjectLike.js":"2a8tS","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2uZoI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _baseGetTagJsDefault.default)(value) == argsTag;
}
exports.default = baseIsArguments;

},{"./_baseGetTag.js":"7xCXT","./isObjectLike.js":"2a8tS","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2a8tS":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
exports.default = isObjectLike;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"cFsjQ":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isArray = Array.isArray;
exports.default = isArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6f1O8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _isArrayLikeJsDefault.default)(value);
}
exports.default = isArrayLikeObject;

},{"./isArrayLike.js":"2V1MI","./isObjectLike.js":"2a8tS","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2V1MI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isFunctionJs = require("./isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && (0, _isLengthJsDefault.default)(value.length) && !(0, _isFunctionJsDefault.default)(value);
}
exports.default = isArrayLike;

},{"./isFunction.js":"6DClC","./isLength.js":"lxY52","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"lxY52":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
exports.default = isLength;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"aZLZf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
var _stubFalseJs = require("./stubFalse.js");
var _stubFalseJsDefault = parcelHelpers.interopDefault(_stubFalseJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, _rootJsDefault.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, _stubFalseJsDefault.default);
exports.default = isBuffer;

},{"./_root.js":"lCXwP","./stubFalse.js":"bX5hh","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"bX5hh":[function(require,module,exports,__globalThis) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stubFalse() {
    return false;
}
exports.default = stubFalse;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"jrCSV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _getPrototypeJs = require("./_getPrototype.js");
var _getPrototypeJsDefault = parcelHelpers.interopDefault(_getPrototypeJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var objectTag = '[object Object]';
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!(0, _isObjectLikeJsDefault.default)(value) || (0, _baseGetTagJsDefault.default)(value) != objectTag) return false;
    var proto = (0, _getPrototypeJsDefault.default)(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
exports.default = isPlainObject;

},{"./_baseGetTag.js":"7xCXT","./_getPrototype.js":"1AAYb","./isObjectLike.js":"2a8tS","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hjfPZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsTypedArrayJs = require("./_baseIsTypedArray.js");
var _baseIsTypedArrayJsDefault = parcelHelpers.interopDefault(_baseIsTypedArrayJs);
var _baseUnaryJs = require("./_baseUnary.js");
var _baseUnaryJsDefault = parcelHelpers.interopDefault(_baseUnaryJs);
var _nodeUtilJs = require("./_nodeUtil.js");
var _nodeUtilJsDefault = parcelHelpers.interopDefault(_nodeUtilJs);
/* Node.js helper references. */ var nodeIsTypedArray = (0, _nodeUtilJsDefault.default) && (0, _nodeUtilJsDefault.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? (0, _baseUnaryJsDefault.default)(nodeIsTypedArray) : (0, _baseIsTypedArrayJsDefault.default);
exports.default = isTypedArray;

},{"./_baseIsTypedArray.js":"lgkEJ","./_baseUnary.js":"1sAJX","./_nodeUtil.js":"329Wy","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"lgkEJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return (0, _isObjectLikeJsDefault.default)(value) && (0, _isLengthJsDefault.default)(value.length) && !!typedArrayTags[(0, _baseGetTagJsDefault.default)(value)];
}
exports.default = baseIsTypedArray;

},{"./_baseGetTag.js":"7xCXT","./isLength.js":"lxY52","./isObjectLike.js":"2a8tS","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"1sAJX":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
exports.default = baseUnary;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"329Wy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _freeGlobalJs = require("./_freeGlobal.js");
var _freeGlobalJsDefault = parcelHelpers.interopDefault(_freeGlobalJs);
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, _freeGlobalJsDefault.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
exports.default = nodeUtil;

},{"./_freeGlobal.js":"2Mp77","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5CWGP":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
exports.default = safeGet;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"62WLl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _copyObjectJs = require("./_copyObject.js");
var _copyObjectJsDefault = parcelHelpers.interopDefault(_copyObjectJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return (0, _copyObjectJsDefault.default)(value, (0, _keysInJsDefault.default)(value));
}
exports.default = toPlainObject;

},{"./_copyObject.js":"det16","./keysIn.js":"36tp6","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"det16":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _assignValueJs = require("./_assignValue.js");
var _assignValueJsDefault = parcelHelpers.interopDefault(_assignValueJs);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, _baseAssignValueJsDefault.default)(object, key, newValue);
        else (0, _assignValueJsDefault.default)(object, key, newValue);
    }
    return object;
}
exports.default = copyObject;

},{"./_assignValue.js":"4v2T7","./_baseAssignValue.js":"l4dYx","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4v2T7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseAssignValueJs = require("./_baseAssignValue.js");
var _baseAssignValueJsDefault = parcelHelpers.interopDefault(_baseAssignValueJs);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && (0, _eqJsDefault.default)(objValue, value)) || value === undefined && !(key in object)) (0, _baseAssignValueJsDefault.default)(object, key, value);
}
exports.default = assignValue;

},{"./_baseAssignValue.js":"l4dYx","./eq.js":"5kiZ7","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"36tp6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayLikeKeysJs = require("./_arrayLikeKeys.js");
var _arrayLikeKeysJsDefault = parcelHelpers.interopDefault(_arrayLikeKeysJs);
var _baseKeysInJs = require("./_baseKeysIn.js");
var _baseKeysInJsDefault = parcelHelpers.interopDefault(_baseKeysInJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return (0, _isArrayLikeJsDefault.default)(object) ? (0, _arrayLikeKeysJsDefault.default)(object, true) : (0, _baseKeysInJsDefault.default)(object);
}
exports.default = keysIn;

},{"./_arrayLikeKeys.js":"1wq18","./_baseKeysIn.js":"6MYTH","./isArrayLike.js":"2V1MI","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"1wq18":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseTimesJs = require("./_baseTimes.js");
var _baseTimesJsDefault = parcelHelpers.interopDefault(_baseTimesJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isIndexJs = require("./_isIndex.js");
var _isIndexJsDefault = parcelHelpers.interopDefault(_isIndexJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = (0, _isArrayJsDefault.default)(value), isArg = !isArr && (0, _isArgumentsJsDefault.default)(value), isBuff = !isArr && !isArg && (0, _isBufferJsDefault.default)(value), isType = !isArr && !isArg && !isBuff && (0, _isTypedArrayJsDefault.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, _baseTimesJsDefault.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, _isIndexJsDefault.default)(key, length)))) result.push(key);
    return result;
}
exports.default = arrayLikeKeys;

},{"./_baseTimes.js":"sUxuP","./isArguments.js":"1sQzR","./isArray.js":"cFsjQ","./isBuffer.js":"aZLZf","./_isIndex.js":"ck6BC","./isTypedArray.js":"hjfPZ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"sUxuP":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
exports.default = baseTimes;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ck6BC":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
exports.default = isIndex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6MYTH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
var _nativeKeysInJs = require("./_nativeKeysIn.js");
var _nativeKeysInJsDefault = parcelHelpers.interopDefault(_nativeKeysInJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!(0, _isObjectJsDefault.default)(object)) return (0, _nativeKeysInJsDefault.default)(object);
    var isProto = (0, _isPrototypeJsDefault.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
exports.default = baseKeysIn;

},{"./isObject.js":"3FPXi","./_isPrototype.js":"46tIR","./_nativeKeysIn.js":"du5OK","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"du5OK":[function(require,module,exports,__globalThis) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
exports.default = nativeKeysIn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"1kqQ2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseRestJs = require("./_baseRest.js");
var _baseRestJsDefault = parcelHelpers.interopDefault(_baseRestJs);
var _isIterateeCallJs = require("./_isIterateeCall.js");
var _isIterateeCallJsDefault = parcelHelpers.interopDefault(_isIterateeCallJs);
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return (0, _baseRestJsDefault.default)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && (0, _isIterateeCallJsDefault.default)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
exports.default = createAssigner;

},{"./_baseRest.js":"3ligi","./_isIterateeCall.js":"bB6O2","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3ligi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _overRestJs = require("./_overRest.js");
var _overRestJsDefault = parcelHelpers.interopDefault(_overRestJs);
var _setToStringJs = require("./_setToString.js");
var _setToStringJsDefault = parcelHelpers.interopDefault(_setToStringJs);
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return (0, _setToStringJsDefault.default)((0, _overRestJsDefault.default)(func, start, (0, _identityJsDefault.default)), func + '');
}
exports.default = baseRest;

},{"./identity.js":"arr0C","./_overRest.js":"6PVjN","./_setToString.js":"4rblg","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"arr0C":[function(require,module,exports,__globalThis) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function identity(value) {
    return value;
}
exports.default = identity;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6PVjN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _applyJs = require("./_apply.js");
var _applyJsDefault = parcelHelpers.interopDefault(_applyJs);
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, _applyJsDefault.default)(func, this, otherArgs);
    };
}
exports.default = overRest;

},{"./_apply.js":"37co2","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"37co2":[function(require,module,exports,__globalThis) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
exports.default = apply;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4rblg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseSetToStringJs = require("./_baseSetToString.js");
var _baseSetToStringJsDefault = parcelHelpers.interopDefault(_baseSetToStringJs);
var _shortOutJs = require("./_shortOut.js");
var _shortOutJsDefault = parcelHelpers.interopDefault(_shortOutJs);
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = (0, _shortOutJsDefault.default)((0, _baseSetToStringJsDefault.default));
exports.default = setToString;

},{"./_baseSetToString.js":"5ztKv","./_shortOut.js":"9UwIi","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5ztKv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _definePropertyJs = require("./_defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !(0, _definePropertyJsDefault.default) ? (0, _identityJsDefault.default) : function(func, string) {
    return (0, _definePropertyJsDefault.default)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, _constantJsDefault.default)(string),
        'writable': true
    });
};
exports.default = baseSetToString;

},{"./constant.js":"5PcyJ","./_defineProperty.js":"gZW0H","./identity.js":"arr0C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5PcyJ":[function(require,module,exports,__globalThis) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function constant(value) {
    return function() {
        return value;
    };
}
exports.default = constant;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9UwIi":[function(require,module,exports,__globalThis) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
exports.default = shortOut;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"bB6O2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _isIndexJs = require("./_isIndex.js");
var _isIndexJsDefault = parcelHelpers.interopDefault(_isIndexJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!(0, _isObjectJsDefault.default)(object)) return false;
    var type = typeof index;
    if (type == 'number' ? (0, _isArrayLikeJsDefault.default)(object) && (0, _isIndexJsDefault.default)(index, object.length) : type == 'string' && index in object) return (0, _eqJsDefault.default)(object[index], value);
    return false;
}
exports.default = isIterateeCall;

},{"./eq.js":"5kiZ7","./isArrayLike.js":"2V1MI","./_isIndex.js":"ck6BC","./isObject.js":"3FPXi","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7BT44":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Saturation", ()=>Saturation);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _throttle = require("lodash-es/throttle");
var _throttleDefault = parcelHelpers.interopDefault(_throttle);
var _saturation = require("../../helpers/saturation");
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Saturation = function(_ref) {
    _inherits(Saturation, _ref);
    function Saturation(props) {
        _classCallCheck(this, Saturation);
        var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
        _this.handleChange = function(e) {
            typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, _saturation.calculateChange(e, _this.props.hsl, _this.container), e);
        };
        _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            var renderWindow = _this.getContainerRenderWindow();
            renderWindow.addEventListener('mousemove', _this.handleChange);
            renderWindow.addEventListener('mouseup', _this.handleMouseUp);
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.throttle = (0, _throttleDefault.default)(function(fn, data, e) {
            fn(data, e);
        }, 50);
        return _this;
    }
    _createClass(Saturation, [
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.throttle.cancel();
                this.unbindEventListeners();
            }
        },
        {
            key: 'getContainerRenderWindow',
            value: function getContainerRenderWindow() {
                var container = this.container;
                var renderWindow = window;
                while(!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow)renderWindow = renderWindow.parent;
                return renderWindow;
            }
        },
        {
            key: 'unbindEventListeners',
            value: function unbindEventListeners() {
                var renderWindow = this.getContainerRenderWindow();
                renderWindow.removeEventListener('mousemove', this.handleChange);
                renderWindow.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _ref2 = this.props.style || {}, color = _ref2.color, white = _ref2.white, black = _ref2.black, pointer = _ref2.pointer, circle = _ref2.circle;
                var styles = (0, _reactcssDefault.default)({
                    'default': {
                        color: {
                            absolute: '0px 0px 0px 0px',
                            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
                            borderRadius: this.props.radius
                        },
                        white: {
                            absolute: '0px 0px 0px 0px',
                            borderRadius: this.props.radius
                        },
                        black: {
                            absolute: '0px 0px 0px 0px',
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: 'absolute',
                            top: -(this.props.hsv.v * 100) + 100 + '%',
                            left: this.props.hsv.s * 100 + '%',
                            cursor: 'default'
                        },
                        circle: {
                            width: '4px',
                            height: '4px',
                            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
                            borderRadius: '50%',
                            cursor: 'hand',
                            transform: 'translate(-2px, -2px)'
                        }
                    },
                    'custom': {
                        color: color,
                        white: white,
                        black: black,
                        pointer: pointer,
                        circle: circle
                    }
                }, {
                    'custom': !!this.props.style
                });
                return (0, _reactDefault.default).createElement('div', {
                    style: styles.color,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, _reactDefault.default).createElement('style', null, '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '), (0, _reactDefault.default).createElement('div', {
                    style: styles.white,
                    className: 'saturation-white'
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.black,
                    className: 'saturation-black'
                }), (0, _reactDefault.default).createElement('div', {
                    style: styles.pointer
                }, this.props.pointer ? (0, _reactDefault.default).createElement(this.props.pointer, this.props) : (0, _reactDefault.default).createElement('div', {
                    style: styles.circle
                }))));
            }
        }
    ]);
    return Saturation;
}((0, _react.PureComponent) || (0, _react.Component));
exports.default = Saturation;

},{"react":"6wC8C","reactcss":"7yqRl","lodash-es/throttle":"ie5G5","../../helpers/saturation":"2hYxM","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ie5G5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _debounceJs = require("./debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    if ((0, _isObjectJsDefault.default)(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return (0, _debounceJsDefault.default)(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
exports.default = throttle;

},{"./debounce.js":"7bDc4","./isObject.js":"3FPXi","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7bDc4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _nowJs = require("./now.js");
var _nowJsDefault = parcelHelpers.interopDefault(_nowJs);
var _toNumberJs = require("./toNumber.js");
var _toNumberJsDefault = parcelHelpers.interopDefault(_toNumberJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    wait = (0, _toNumberJsDefault.default)(wait) || 0;
    if ((0, _isObjectJsDefault.default)(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax((0, _toNumberJsDefault.default)(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, _nowJsDefault.default)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, _nowJsDefault.default)());
    }
    function debounced() {
        var time = (0, _nowJsDefault.default)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
exports.default = debounce;

},{"./isObject.js":"3FPXi","./now.js":"geThZ","./toNumber.js":"iilu2","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"geThZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
    return (0, _rootJsDefault.default).Date.now();
};
exports.default = now;

},{"./_root.js":"lCXwP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"iilu2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseTrimJs = require("./_baseTrim.js");
var _baseTrimJsDefault = parcelHelpers.interopDefault(_baseTrimJs);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == 'number') return value;
    if ((0, _isSymbolJsDefault.default)(value)) return NAN;
    if ((0, _isObjectJsDefault.default)(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = (0, _isObjectJsDefault.default)(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = (0, _baseTrimJsDefault.default)(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
exports.default = toNumber;

},{"./_baseTrim.js":"1BgHt","./isObject.js":"3FPXi","./isSymbol.js":"9Ecuc","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"1BgHt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _trimmedEndIndexJs = require("./_trimmedEndIndex.js");
var _trimmedEndIndexJsDefault = parcelHelpers.interopDefault(_trimmedEndIndexJs);
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, (0, _trimmedEndIndexJsDefault.default)(string) + 1).replace(reTrimStart, '') : string;
}
exports.default = baseTrim;

},{"./_trimmedEndIndex.js":"ienzv","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ienzv":[function(require,module,exports,__globalThis) {
/** Used to match a single whitespace character. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
exports.default = trimmedEndIndex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9Ecuc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || (0, _isObjectLikeJsDefault.default)(value) && (0, _baseGetTagJsDefault.default)(value) == symbolTag;
}
exports.default = isSymbol;

},{"./_baseGetTag.js":"7xCXT","./isObjectLike.js":"2a8tS","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2hYxM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateChange", ()=>calculateChange);
var calculateChange = function calculateChange(e, hsl, container) {
    var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
    var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (left < 0) left = 0;
    else if (left > containerWidth) left = containerWidth;
    if (top < 0) top = 0;
    else if (top > containerHeight) top = containerHeight;
    var saturation = left / containerWidth;
    var bright = 1 - top / containerHeight;
    return {
        h: hsl.h,
        s: saturation,
        v: bright,
        a: hsl.a,
        source: 'hsv'
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6BSbS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorWrap", ()=>ColorWrap);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _debounce = require("lodash-es/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _color = require("../../helpers/color");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ColorWrap = function ColorWrap(Picker) {
    var ColorPicker = function(_ref) {
        _inherits(ColorPicker, _ref);
        function ColorPicker(props) {
            _classCallCheck(this, ColorPicker);
            var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
            _this.handleChange = function(data, event) {
                var isValidColor = _color.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = _color.toState(data, data.h || _this.state.oldHue);
                    _this.setState(colors);
                    _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
                    _this.props.onChange && _this.props.onChange(colors, event);
                }
            };
            _this.handleSwatchHover = function(data, event) {
                var isValidColor = _color.simpleCheckForValidColor(data);
                if (isValidColor) {
                    var colors = _color.toState(data, data.h || _this.state.oldHue);
                    _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
                }
            };
            _this.state = _extends({}, _color.toState(props.color, 0));
            _this.debounce = (0, _debounceDefault.default)(function(fn, data, event) {
                fn(data, event);
            }, 100);
            return _this;
        }
        _createClass(ColorPicker, [
            {
                key: 'render',
                value: function render() {
                    var optionalEvents = {};
                    if (this.props.onSwatchHover) optionalEvents.onSwatchHover = this.handleSwatchHover;
                    return (0, _reactDefault.default).createElement(Picker, _extends({}, this.props, this.state, {
                        onChange: this.handleChange
                    }, optionalEvents));
                }
            }
        ], [
            {
                key: 'getDerivedStateFromProps',
                value: function getDerivedStateFromProps(nextProps, state) {
                    return _extends({}, _color.toState(nextProps.color, state.oldHue));
                }
            }
        ]);
        return ColorPicker;
    }((0, _react.PureComponent) || (0, _react.Component));
    ColorPicker.propTypes = _extends({}, Picker.propTypes);
    ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
        color: {
            h: 250,
            s: 0.50,
            l: 0.20,
            a: 1
        }
    });
    return ColorPicker;
};
exports.default = ColorWrap;

},{"react":"6wC8C","lodash-es/debounce":"7bDc4","../../helpers/color":"dHnAt","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"dHnAt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "simpleCheckForValidColor", ()=>simpleCheckForValidColor);
parcelHelpers.export(exports, "toState", ()=>toState);
parcelHelpers.export(exports, "isValidHex", ()=>isValidHex);
parcelHelpers.export(exports, "getContrastingColor", ()=>getContrastingColor);
parcelHelpers.export(exports, "red", ()=>red);
parcelHelpers.export(exports, "isvalidColorString", ()=>isvalidColorString);
var _each = require("lodash-es/each");
var _eachDefault = parcelHelpers.interopDefault(_each);
var _tinycolor2 = require("tinycolor2");
var _tinycolor2Default = parcelHelpers.interopDefault(_tinycolor2);
var simpleCheckForValidColor = function simpleCheckForValidColor(data) {
    var keysToCheck = [
        'r',
        'g',
        'b',
        'a',
        'h',
        's',
        'l',
        'v'
    ];
    var checked = 0;
    var passed = 0;
    (0, _eachDefault.default)(keysToCheck, function(letter) {
        if (data[letter]) {
            checked += 1;
            if (!isNaN(data[letter])) passed += 1;
            if (letter === 's' || letter === 'l') {
                var percentPatt = /^\d+%$/;
                if (percentPatt.test(data[letter])) passed += 1;
            }
        }
    });
    return checked === passed ? data : false;
};
var toState = function toState(data, oldHue) {
    var color = data.hex ? (0, _tinycolor2Default.default)(data.hex) : (0, _tinycolor2Default.default)(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
        hsl.h = oldHue || 0;
        hsv.h = oldHue || 0;
    }
    var transparent = hex === '000000' && rgb.a === 0;
    return {
        hsl: hsl,
        hex: transparent ? 'transparent' : '#' + hex,
        rgb: rgb,
        hsv: hsv,
        oldHue: data.h || oldHue || hsl.h,
        source: data.source
    };
};
var isValidHex = function isValidHex(hex) {
    if (hex === 'transparent') return true;
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === '#' ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, _tinycolor2Default.default)(hex).isValid();
};
var getContrastingColor = function getContrastingColor(data) {
    if (!data) return '#fff';
    var col = toState(data);
    if (col.hex === 'transparent') return 'rgba(0,0,0,0.4)';
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? '#000' : '#fff';
};
var red = {
    hsl: {
        a: 1,
        h: 0,
        l: 0.5,
        s: 1
    },
    hex: '#ff0000',
    rgb: {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    },
    hsv: {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    }
};
var isvalidColorString = function isvalidColorString(string, type) {
    var stringWithoutDegree = string.replace("\xb0", '');
    return (0, _tinycolor2Default.default)(type + ' (' + stringWithoutDegree + ')')._ok;
};

},{"lodash-es/each":"lqE81","tinycolor2":"7cL88","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"lqE81":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _forEachJsDefault.default));
var _forEachJs = require("./forEach.js");
var _forEachJsDefault = parcelHelpers.interopDefault(_forEachJs);

},{"./forEach.js":"ftOEg","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ftOEg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayEachJs = require("./_arrayEach.js");
var _arrayEachJsDefault = parcelHelpers.interopDefault(_arrayEachJs);
var _baseEachJs = require("./_baseEach.js");
var _baseEachJsDefault = parcelHelpers.interopDefault(_baseEachJs);
var _castFunctionJs = require("./_castFunction.js");
var _castFunctionJsDefault = parcelHelpers.interopDefault(_castFunctionJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function forEach(collection, iteratee) {
    var func = (0, _isArrayJsDefault.default)(collection) ? (0, _arrayEachJsDefault.default) : (0, _baseEachJsDefault.default);
    return func(collection, (0, _castFunctionJsDefault.default)(iteratee));
}
exports.default = forEach;

},{"./_arrayEach.js":"gfdSn","./_baseEach.js":"1rj7a","./_castFunction.js":"dkP2E","./isArray.js":"cFsjQ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"gfdSn":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
exports.default = arrayEach;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"1rj7a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseForOwnJs = require("./_baseForOwn.js");
var _baseForOwnJsDefault = parcelHelpers.interopDefault(_baseForOwnJs);
var _createBaseEachJs = require("./_createBaseEach.js");
var _createBaseEachJsDefault = parcelHelpers.interopDefault(_createBaseEachJs);
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = (0, _createBaseEachJsDefault.default)((0, _baseForOwnJsDefault.default));
exports.default = baseEach;

},{"./_baseForOwn.js":"ffMoA","./_createBaseEach.js":"aeq1n","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ffMoA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseForJs = require("./_baseFor.js");
var _baseForJsDefault = parcelHelpers.interopDefault(_baseForJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && (0, _baseForJsDefault.default)(object, iteratee, (0, _keysJsDefault.default));
}
exports.default = baseForOwn;

},{"./_baseFor.js":"aq01c","./keys.js":"clTjo","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"clTjo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayLikeKeysJs = require("./_arrayLikeKeys.js");
var _arrayLikeKeysJsDefault = parcelHelpers.interopDefault(_arrayLikeKeysJs);
var _baseKeysJs = require("./_baseKeys.js");
var _baseKeysJsDefault = parcelHelpers.interopDefault(_baseKeysJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return (0, _isArrayLikeJsDefault.default)(object) ? (0, _arrayLikeKeysJsDefault.default)(object) : (0, _baseKeysJsDefault.default)(object);
}
exports.default = keys;

},{"./_arrayLikeKeys.js":"1wq18","./_baseKeys.js":"i1naC","./isArrayLike.js":"2V1MI","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"i1naC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isPrototypeJs = require("./_isPrototype.js");
var _isPrototypeJsDefault = parcelHelpers.interopDefault(_isPrototypeJs);
var _nativeKeysJs = require("./_nativeKeys.js");
var _nativeKeysJsDefault = parcelHelpers.interopDefault(_nativeKeysJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!(0, _isPrototypeJsDefault.default)(object)) return (0, _nativeKeysJsDefault.default)(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
exports.default = baseKeys;

},{"./_isPrototype.js":"46tIR","./_nativeKeys.js":"dqisL","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"dqisL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overArgJs = require("./_overArg.js");
var _overArgJsDefault = parcelHelpers.interopDefault(_overArgJs);
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = (0, _overArgJsDefault.default)(Object.keys, Object);
exports.default = nativeKeys;

},{"./_overArg.js":"7tDRB","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"aeq1n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, _isArrayLikeJsDefault.default)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
exports.default = createBaseEach;

},{"./isArrayLike.js":"2V1MI","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"dkP2E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function castFunction(value) {
    return typeof value == 'function' ? value : (0, _identityJsDefault.default);
}
exports.default = castFunction;

},{"./identity.js":"arr0C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7cL88":[function(require,module,exports,__globalThis) {
// This file is autogenerated. It's used to publish CJS to npm.
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License
    var trimLeft = /^\s+/;
    var trimRight = /\s+$/;
    function tinycolor(color, opts) {
        color = color ? color : "";
        opts = opts || {};
        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) return color;
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) return new tinycolor(color, opts);
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) this._r = Math.round(this._r);
        if (this._g < 1) this._g = Math.round(this._g);
        if (this._b < 1) this._b = Math.round(this._b);
        this._ok = rgb.ok;
    }
    tinycolor.prototype = {
        isDark: function isDark() {
            return this.getBrightness() < 128;
        },
        isLight: function isLight() {
            return !this.isDark();
        },
        isValid: function isValid() {
            return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
            return this._originalInput;
        },
        getFormat: function getFormat() {
            return this._format;
        },
        getAlpha: function getAlpha() {
            return this._a;
        },
        getBrightness: function getBrightness() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function getLuminance() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) R = RsRGB / 12.92;
            else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
            if (GsRGB <= 0.03928) G = GsRGB / 12.92;
            else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
            if (BsRGB <= 0.03928) B = BsRGB / 12.92;
            else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function setAlpha(value) {
            this._a = boundAlpha(value);
            this._roundA = Math.round(100 * this._a) / 100;
            return this;
        },
        toHsv: function toHsv() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return {
                h: hsv.h * 360,
                s: hsv.s,
                v: hsv.v,
                a: this._a
            };
        },
        toHsvString: function toHsvString() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return {
                h: hsl.h * 360,
                s: hsl.s,
                l: hsl.l,
                a: this._a
            };
        },
        toHslString: function toHslString() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function toHex(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function toHexString(allow3Char) {
            return "#" + this.toHex(allow3Char);
        },
        toHex8: function toHex8(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function toHex8String(allow4Char) {
            return "#" + this.toHex8(allow4Char);
        },
        toRgb: function toRgb() {
            return {
                r: Math.round(this._r),
                g: Math.round(this._g),
                b: Math.round(this._b),
                a: this._a
            };
        },
        toRgbString: function toRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
            return {
                r: Math.round(bound01(this._r, 255) * 100) + "%",
                g: Math.round(bound01(this._g, 255) * 100) + "%",
                b: Math.round(bound01(this._b, 255) * 100) + "%",
                a: this._a
            };
        },
        toPercentageRgbString: function toPercentageRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
            if (this._a === 0) return "transparent";
            if (this._a < 1) return false;
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function toFilter(secondColor) {
            var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function toString(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) return this.toName();
                return this.toRgbString();
            }
            if (format === "rgb") formattedString = this.toRgbString();
            if (format === "prgb") formattedString = this.toPercentageRgbString();
            if (format === "hex" || format === "hex6") formattedString = this.toHexString();
            if (format === "hex3") formattedString = this.toHexString(true);
            if (format === "hex4") formattedString = this.toHex8String(true);
            if (format === "hex8") formattedString = this.toHex8String();
            if (format === "name") formattedString = this.toName();
            if (format === "hsl") formattedString = this.toHslString();
            if (format === "hsv") formattedString = this.toHsvString();
            return formattedString || this.toHexString();
        },
        clone: function clone() {
            return tinycolor(this.toString());
        },
        _applyModification: function _applyModification(fn, args) {
            var color = fn.apply(null, [
                this
            ].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function lighten() {
            return this._applyModification(_lighten, arguments);
        },
        brighten: function brighten() {
            return this._applyModification(_brighten, arguments);
        },
        darken: function darken() {
            return this._applyModification(_darken, arguments);
        },
        desaturate: function desaturate() {
            return this._applyModification(_desaturate, arguments);
        },
        saturate: function saturate() {
            return this._applyModification(_saturate, arguments);
        },
        greyscale: function greyscale() {
            return this._applyModification(_greyscale, arguments);
        },
        spin: function spin() {
            return this._applyModification(_spin, arguments);
        },
        _applyCombination: function _applyCombination(fn, args) {
            return fn.apply(null, [
                this
            ].concat([].slice.call(args)));
        },
        analogous: function analogous() {
            return this._applyCombination(_analogous, arguments);
        },
        complement: function complement() {
            return this._applyCombination(_complement, arguments);
        },
        monochromatic: function monochromatic() {
            return this._applyCombination(_monochromatic, arguments);
        },
        splitcomplement: function splitcomplement() {
            return this._applyCombination(_splitcomplement, arguments);
        },
        // Disabled until https://github.com/bgrins/TinyColor/issues/254
        // polyad: function (number) {
        //   return this._applyCombination(polyad, [number]);
        // },
        triad: function triad() {
            return this._applyCombination(polyad, [
                3
            ]);
        },
        tetrad: function tetrad() {
            return this._applyCombination(polyad, [
                4
            ]);
        }
    };
    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (_typeof(color) == "object") {
            var newColor = {};
            for(var i in color)if (color.hasOwnProperty(i)) {
                if (i === "a") newColor[i] = color[i];
                else newColor[i] = convertToPercentage(color[i]);
            }
            color = newColor;
        }
        return tinycolor(color, opts);
    };
    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
        var rgb = {
            r: 0,
            g: 0,
            b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;
        if (typeof color == "string") color = stringInputToObject(color);
        if (_typeof(color) == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }
            if (color.hasOwnProperty("a")) a = color.a;
        }
        a = boundAlpha(a);
        return {
            ok: ok,
            format: color.format || format,
            r: Math.min(255, Math.max(rgb.r, 0)),
            g: Math.min(255, Math.max(rgb.g, 0)),
            b: Math.min(255, Math.max(rgb.b, 0)),
            a: a
        };
    }
    // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }
    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) h = s = 0; // achromatic
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) h = 0; // achromatic
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    }
    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod], g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod], b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];
        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        return hex.join("");
    }
    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        return hex.join("");
    }
    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: Math.random(),
            g: Math.random(),
            b: Math.random()
        });
    };
    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
    function _desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _greyscale(color) {
        return tinycolor(color).desaturate(100);
    }
    function _lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    function _brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor(color).toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return tinycolor(rgb);
    }
    function _darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function _spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }
    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
    function _complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }
    function polyad(color, number) {
        if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
        var hsl = tinycolor(color).toHsl();
        var result = [
            tinycolor(color)
        ];
        var step = 360 / number;
        for(var i = 1; i < number; i++)result.push(tinycolor({
            h: (hsl.h + i * step) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    }
    function _splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function _analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [
            tinycolor(color)
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }
    function _monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while(results--){
            ret.push(tinycolor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return ret;
    }
    // Utility Functions
    // ---------------------
    tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
    };
    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };
    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch(wcag2Parms.level + wcag2Parms.size){
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;
    };
    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for(var i = 0; i < colorList.length; i++){
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
            level: level,
            size: size
        }) || !includeFallbackColors) return bestColor;
        else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, [
                "#fff",
                "#000"
            ], args);
        }
    };
    // Big List of Colors
    // ------------------
    // <https://www.w3.org/TR/css-color-4/#named-colors>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };
    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);
    // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = {};
        for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
        return flipped;
    }
    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) a = 1;
        return a;
    }
    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) n = "100%";
        var processPercent = isPercentage(n);
        n = Math.min(max, Math.max(0, parseFloat(n)));
        // Automatically convert percentage into number
        if (processPercent) n = parseInt(n * max, 10) / 100;
        // Handle floating point rounding errors
        if (Math.abs(n - max) < 0.000001) return 1;
        // Convert into [0, 1] range if it isn't already
        return n % max / parseFloat(max);
    }
    // Force a number between 0 and 1
    function clamp01(val) {
        return Math.min(1, Math.max(0, val));
    }
    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }
    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
    }
    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf("%") != -1;
    }
    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? "0" + c : "" + c;
    }
    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) n = n * 100 + "%";
        return n;
    }
    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
    }
    var matchers = function() {
        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    }();
    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }
    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
        color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        } else if (color == "transparent") return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if (match = matchers.rgb.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3]
        };
        if (match = matchers.rgba.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3],
            a: match[4]
        };
        if (match = matchers.hsl.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3]
        };
        if (match = matchers.hsla.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3],
            a: match[4]
        };
        if (match = matchers.hsv.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3]
        };
        if (match = matchers.hsva.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3],
            a: match[4]
        };
        if (match = matchers.hex8.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex6.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
        if (match = matchers.hex4.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            a: convertHexToDecimal(match[4] + "" + match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex3.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            format: named ? "name" : "hex"
        };
        return false;
    }
    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {
            level: "AA",
            size: "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") level = "AA";
        if (size !== "small" && size !== "large") size = "small";
        return {
            level: level,
            size: size
        };
    }
    return tinycolor;
});

},{}],"jdR52":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Swatch", ()=>Swatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _interaction = require("../../helpers/interaction");
var _checkboard = require("./Checkboard");
var _checkboardDefault = parcelHelpers.interopDefault(_checkboard);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var ENTER = 13;
var Swatch = function Swatch(_ref) {
    var color = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title = _ref$title === undefined ? color : _ref$title, children = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
    var transparent = color === 'transparent';
    var styles = (0, _reactcssDefault.default)({
        default: {
            swatch: _extends({
                background: color,
                height: '100%',
                width: '100%',
                cursor: 'pointer',
                position: 'relative',
                outline: 'none'
            }, style, focus ? focusStyle : {})
        }
    });
    var handleClick = function handleClick(e) {
        return onClick(color, e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        return e.keyCode === ENTER && onClick(color, e);
    };
    var handleHover = function handleHover(e) {
        return onHover(color, e);
    };
    var optionalEvents = {};
    if (onHover) optionalEvents.onMouseOver = handleHover;
    return (0, _reactDefault.default).createElement('div', _extends({
        style: styles.swatch,
        onClick: handleClick,
        title: title,
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, optionalEvents), children, transparent && (0, _reactDefault.default).createElement((0, _checkboardDefault.default), {
        borderRadius: styles.swatch.borderRadius,
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    }));
};
exports.default = (0, _interaction.handleFocus)(Swatch);

},{"react":"6wC8C","reactcss":"7yqRl","../../helpers/interaction":"dHcIX","./Checkboard":"2JG2I","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"dHcIX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleFocus", ()=>handleFocus);
/* eslint-disable no-invalid-this */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var handleFocus = function handleFocus(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
    return function(_React$Component) {
        _inherits(Focus, _React$Component);
        function Focus() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Focus);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                focus: false
            }, _this.handleFocus = function() {
                return _this.setState({
                    focus: true
                });
            }, _this.handleBlur = function() {
                return _this.setState({
                    focus: false
                });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(Focus, [
            {
                key: 'render',
                value: function render() {
                    return (0, _reactDefault.default).createElement(Span, {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur
                    }, (0, _reactDefault.default).createElement(Component, _extends({}, this.props, this.state)));
                }
            }
        ]);
        return Focus;
    }((0, _reactDefault.default).Component);
};

},{"react":"6wC8C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"dCmvO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlphaPointer", ()=>AlphaPointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var AlphaPointer = function AlphaPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '18px',
                height: '18px',
                borderRadius: '50%',
                transform: 'translate(-9px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        },
        'vertical': {
            picker: {
                transform: 'translate(-3px, -9px)'
            }
        }
    }, {
        vertical: direction === 'vertical'
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
exports.default = AlphaPointer;

},{"react":"6wC8C","reactcss":"7yqRl","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"16mK3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Block", ()=>Block);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var _blockSwatches = require("./BlockSwatches");
var _blockSwatchesDefault = parcelHelpers.interopDefault(_blockSwatches);
var Block = function Block(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var transparent = hex === 'transparent';
    var handleChange = function handleChange(hexCode, e) {
        _color.isValidHex(hexCode) && onChange({
            hex: hexCode,
            source: 'hex'
        }, e);
    };
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                boxShadow: '0 1px rgba(0,0,0,.1)',
                borderRadius: '6px',
                position: 'relative'
            },
            head: {
                height: '110px',
                background: hex,
                borderRadius: '6px 6px 0 0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative'
            },
            body: {
                padding: '10px'
            },
            label: {
                fontSize: '18px',
                color: _color.getContrastingColor(hex),
                position: 'relative'
            },
            triangle: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 10px 10px 10px',
                borderColor: 'transparent transparent ' + hex + ' transparent',
                position: 'absolute',
                top: '-10px',
                left: '50%',
                marginLeft: '-10px'
            },
            input: {
                width: '100%',
                fontSize: '12px',
                color: '#666',
                border: '0px',
                outline: 'none',
                height: '22px',
                boxShadow: 'inset 0 0 0 1px #ddd',
                borderRadius: '4px',
                padding: '0 7px',
                boxSizing: 'border-box'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide'
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.card,
        className: 'block-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.triangle
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.head
    }, transparent && (0, _reactDefault.default).createElement((0, _common.Checkboard), {
        borderRadius: '6px 6px 0 0'
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.label
    }, hex)), (0, _reactDefault.default).createElement('div', {
        style: styles.body
    }, (0, _reactDefault.default).createElement((0, _blockSwatchesDefault.default), {
        colors: colors,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input
        },
        value: hex,
        onChange: handleChange
    })));
};
Block.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    triangle: (0, _propTypesDefault.default).oneOf([
        'top',
        'hide'
    ]),
    styles: (0, _propTypesDefault.default).object
};
Block.defaultProps = {
    width: 170,
    colors: [
        '#D9E3F0',
        '#F47373',
        '#697689',
        '#37D67A',
        '#2CCCE4',
        '#555555',
        '#dce775',
        '#ff8a65',
        '#ba68c8'
    ],
    triangle: 'top',
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Block);

},{"react":"6wC8C","prop-types":"6YTRF","reactcss":"7yqRl","lodash-es/merge":"4s9GK","../../helpers/color":"dHnAt","../common":"gx5lJ","./BlockSwatches":"3kEQH","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3kEQH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlockSwatches", ()=>BlockSwatches);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _common = require("../common");
var BlockSwatches = function BlockSwatches(_ref) {
    var colors = _ref.colors, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            swatches: {
                marginRight: '-10px'
            },
            swatch: {
                width: '22px',
                height: '22px',
                float: 'left',
                marginRight: '10px',
                marginBottom: '10px',
                borderRadius: '4px'
            },
            clear: {
                clear: 'both'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.swatches
    }, (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _common.Swatch), {
            key: c,
            color: c,
            style: styles.swatch,
            onClick: onClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: '0 0 4px ' + c
            }
        });
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.clear
    }));
};
exports.default = BlockSwatches;

},{"react":"6wC8C","reactcss":"7yqRl","lodash-es/map":"d8f0z","../common":"gx5lJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"d8f0z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayMapJs = require("./_arrayMap.js");
var _arrayMapJsDefault = parcelHelpers.interopDefault(_arrayMapJs);
var _baseIterateeJs = require("./_baseIteratee.js");
var _baseIterateeJsDefault = parcelHelpers.interopDefault(_baseIterateeJs);
var _baseMapJs = require("./_baseMap.js");
var _baseMapJsDefault = parcelHelpers.interopDefault(_baseMapJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function map(collection, iteratee) {
    var func = (0, _isArrayJsDefault.default)(collection) ? (0, _arrayMapJsDefault.default) : (0, _baseMapJsDefault.default);
    return func(collection, (0, _baseIterateeJsDefault.default)(iteratee, 3));
}
exports.default = map;

},{"./_arrayMap.js":"fmP6u","./_baseIteratee.js":"jdm88","./_baseMap.js":"3HK9l","./isArray.js":"cFsjQ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fmP6u":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
exports.default = arrayMap;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"jdm88":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseMatchesJs = require("./_baseMatches.js");
var _baseMatchesJsDefault = parcelHelpers.interopDefault(_baseMatchesJs);
var _baseMatchesPropertyJs = require("./_baseMatchesProperty.js");
var _baseMatchesPropertyJsDefault = parcelHelpers.interopDefault(_baseMatchesPropertyJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _propertyJs = require("./property.js");
var _propertyJsDefault = parcelHelpers.interopDefault(_propertyJs);
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return 0, _identityJsDefault.default;
    if (typeof value == 'object') return (0, _isArrayJsDefault.default)(value) ? (0, _baseMatchesPropertyJsDefault.default)(value[0], value[1]) : (0, _baseMatchesJsDefault.default)(value);
    return (0, _propertyJsDefault.default)(value);
}
exports.default = baseIteratee;

},{"./_baseMatches.js":"chsSt","./_baseMatchesProperty.js":"ewFUV","./identity.js":"arr0C","./isArray.js":"cFsjQ","./property.js":"s3hj3","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"chsSt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsMatchJs = require("./_baseIsMatch.js");
var _baseIsMatchJsDefault = parcelHelpers.interopDefault(_baseIsMatchJs);
var _getMatchDataJs = require("./_getMatchData.js");
var _getMatchDataJsDefault = parcelHelpers.interopDefault(_getMatchDataJs);
var _matchesStrictComparableJs = require("./_matchesStrictComparable.js");
var _matchesStrictComparableJsDefault = parcelHelpers.interopDefault(_matchesStrictComparableJs);
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = (0, _getMatchDataJsDefault.default)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, _matchesStrictComparableJsDefault.default)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, _baseIsMatchJsDefault.default)(object, source, matchData);
    };
}
exports.default = baseMatches;

},{"./_baseIsMatch.js":"iksFd","./_getMatchData.js":"fPKl1","./_matchesStrictComparable.js":"3XPi4","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"iksFd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stackJs = require("./_Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _baseIsEqualJs = require("./_baseIsEqual.js");
var _baseIsEqualJsDefault = parcelHelpers.interopDefault(_baseIsEqualJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, _stackJsDefault.default);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, _baseIsEqualJsDefault.default)(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
exports.default = baseIsMatch;

},{"./_Stack.js":"ewgF6","./_baseIsEqual.js":"bgKjw","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"bgKjw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsEqualDeepJs = require("./_baseIsEqualDeep.js");
var _baseIsEqualDeepJsDefault = parcelHelpers.interopDefault(_baseIsEqualDeepJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, _isObjectLikeJsDefault.default)(value) && !(0, _isObjectLikeJsDefault.default)(other)) return value !== value && other !== other;
    return (0, _baseIsEqualDeepJsDefault.default)(value, other, bitmask, customizer, baseIsEqual, stack);
}
exports.default = baseIsEqual;

},{"./_baseIsEqualDeep.js":"99DWS","./isObjectLike.js":"2a8tS","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"99DWS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _stackJs = require("./_Stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _equalArraysJs = require("./_equalArrays.js");
var _equalArraysJsDefault = parcelHelpers.interopDefault(_equalArraysJs);
var _equalByTagJs = require("./_equalByTag.js");
var _equalByTagJsDefault = parcelHelpers.interopDefault(_equalByTagJs);
var _equalObjectsJs = require("./_equalObjects.js");
var _equalObjectsJsDefault = parcelHelpers.interopDefault(_equalObjectsJs);
var _getTagJs = require("./_getTag.js");
var _getTagJsDefault = parcelHelpers.interopDefault(_getTagJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isBufferJs = require("./isBuffer.js");
var _isBufferJsDefault = parcelHelpers.interopDefault(_isBufferJs);
var _isTypedArrayJs = require("./isTypedArray.js");
var _isTypedArrayJsDefault = parcelHelpers.interopDefault(_isTypedArrayJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, _isArrayJsDefault.default)(object), othIsArr = (0, _isArrayJsDefault.default)(other), objTag = objIsArr ? arrayTag : (0, _getTagJsDefault.default)(object), othTag = othIsArr ? arrayTag : (0, _getTagJsDefault.default)(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, _isBufferJsDefault.default)(object)) {
        if (!(0, _isBufferJsDefault.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, _stackJsDefault.default));
        return objIsArr || (0, _isTypedArrayJsDefault.default)(object) ? (0, _equalArraysJsDefault.default)(object, other, bitmask, customizer, equalFunc, stack) : (0, _equalByTagJsDefault.default)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, _stackJsDefault.default));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, _stackJsDefault.default));
    return (0, _equalObjectsJsDefault.default)(object, other, bitmask, customizer, equalFunc, stack);
}
exports.default = baseIsEqualDeep;

},{"./_Stack.js":"ewgF6","./_equalArrays.js":"4BNa8","./_equalByTag.js":"fNOdq","./_equalObjects.js":"5GabD","./_getTag.js":"hqOna","./isArray.js":"cFsjQ","./isBuffer.js":"aZLZf","./isTypedArray.js":"hjfPZ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4BNa8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setCacheJs = require("./_SetCache.js");
var _setCacheJsDefault = parcelHelpers.interopDefault(_setCacheJs);
var _arraySomeJs = require("./_arraySome.js");
var _arraySomeJsDefault = parcelHelpers.interopDefault(_arraySomeJs);
var _cacheHasJs = require("./_cacheHas.js");
var _cacheHasJsDefault = parcelHelpers.interopDefault(_cacheHasJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new (0, _setCacheJsDefault.default) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, _arraySomeJsDefault.default)(other, function(othValue, othIndex) {
                if (!(0, _cacheHasJsDefault.default)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
exports.default = equalArrays;

},{"./_SetCache.js":"6qBPC","./_arraySome.js":"bXyGc","./_cacheHas.js":"4IDCj","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6qBPC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
var _setCacheAddJs = require("./_setCacheAdd.js");
var _setCacheAddJsDefault = parcelHelpers.interopDefault(_setCacheAddJs);
var _setCacheHasJs = require("./_setCacheHas.js");
var _setCacheHasJsDefault = parcelHelpers.interopDefault(_setCacheHasJs);
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, _mapCacheJsDefault.default);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = (0, _setCacheAddJsDefault.default);
SetCache.prototype.has = (0, _setCacheHasJsDefault.default);
exports.default = SetCache;

},{"./_MapCache.js":"3OQXh","./_setCacheAdd.js":"8ndZT","./_setCacheHas.js":"12mtp","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8ndZT":[function(require,module,exports,__globalThis) {
/** Used to stand-in for `undefined` hash values. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
exports.default = setCacheAdd;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"12mtp":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function setCacheHas(value) {
    return this.__data__.has(value);
}
exports.default = setCacheHas;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"bXyGc":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
exports.default = arraySome;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4IDCj":[function(require,module,exports,__globalThis) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function cacheHas(cache, key) {
    return cache.has(key);
}
exports.default = cacheHas;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fNOdq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _uint8ArrayJs = require("./_Uint8Array.js");
var _uint8ArrayJsDefault = parcelHelpers.interopDefault(_uint8ArrayJs);
var _eqJs = require("./eq.js");
var _eqJsDefault = parcelHelpers.interopDefault(_eqJs);
var _equalArraysJs = require("./_equalArrays.js");
var _equalArraysJsDefault = parcelHelpers.interopDefault(_equalArraysJs);
var _mapToArrayJs = require("./_mapToArray.js");
var _mapToArrayJsDefault = parcelHelpers.interopDefault(_mapToArrayJs);
var _setToArrayJs = require("./_setToArray.js");
var _setToArrayJsDefault = parcelHelpers.interopDefault(_setToArrayJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var symbolProto = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, _uint8ArrayJsDefault.default)(object), new (0, _uint8ArrayJsDefault.default)(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, _eqJsDefault.default)(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = (0, _mapToArrayJsDefault.default);
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, _setToArrayJsDefault.default));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, _equalArraysJsDefault.default)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
exports.default = equalByTag;

},{"./_Symbol.js":"j1NQF","./_Uint8Array.js":"8BRp2","./eq.js":"5kiZ7","./_equalArrays.js":"4BNa8","./_mapToArray.js":"gUz0W","./_setToArray.js":"7IadW","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"gUz0W":[function(require,module,exports,__globalThis) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
exports.default = mapToArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7IadW":[function(require,module,exports,__globalThis) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
exports.default = setToArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5GabD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getAllKeysJs = require("./_getAllKeys.js");
var _getAllKeysJsDefault = parcelHelpers.interopDefault(_getAllKeysJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = (0, _getAllKeysJsDefault.default)(object), objLength = objProps.length, othProps = (0, _getAllKeysJsDefault.default)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
exports.default = equalObjects;

},{"./_getAllKeys.js":"1xsCM","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"1xsCM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetAllKeysJs = require("./_baseGetAllKeys.js");
var _baseGetAllKeysJsDefault = parcelHelpers.interopDefault(_baseGetAllKeysJs);
var _getSymbolsJs = require("./_getSymbols.js");
var _getSymbolsJsDefault = parcelHelpers.interopDefault(_getSymbolsJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return (0, _baseGetAllKeysJsDefault.default)(object, (0, _keysJsDefault.default), (0, _getSymbolsJsDefault.default));
}
exports.default = getAllKeys;

},{"./_baseGetAllKeys.js":"kcpEW","./_getSymbols.js":"9EB21","./keys.js":"clTjo","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kcpEW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayPushJs = require("./_arrayPush.js");
var _arrayPushJsDefault = parcelHelpers.interopDefault(_arrayPushJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, _isArrayJsDefault.default)(object) ? result : (0, _arrayPushJsDefault.default)(result, symbolsFunc(object));
}
exports.default = baseGetAllKeys;

},{"./_arrayPush.js":"8pjhE","./isArray.js":"cFsjQ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8pjhE":[function(require,module,exports,__globalThis) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
exports.default = arrayPush;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9EB21":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arrayFilterJs = require("./_arrayFilter.js");
var _arrayFilterJsDefault = parcelHelpers.interopDefault(_arrayFilterJs);
var _stubArrayJs = require("./stubArray.js");
var _stubArrayJsDefault = parcelHelpers.interopDefault(_stubArrayJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? (0, _stubArrayJsDefault.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, _arrayFilterJsDefault.default)(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
exports.default = getSymbols;

},{"./_arrayFilter.js":"gxGHO","./stubArray.js":"48uul","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"gxGHO":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
exports.default = arrayFilter;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"48uul":[function(require,module,exports,__globalThis) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stubArray() {
    return [];
}
exports.default = stubArray;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hqOna":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataViewJs = require("./_DataView.js");
var _dataViewJsDefault = parcelHelpers.interopDefault(_dataViewJs);
var _mapJs = require("./_Map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _promiseJs = require("./_Promise.js");
var _promiseJsDefault = parcelHelpers.interopDefault(_promiseJs);
var _setJs = require("./_Set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
var _weakMapJs = require("./_WeakMap.js");
var _weakMapJsDefault = parcelHelpers.interopDefault(_weakMapJs);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _toSourceJs = require("./_toSource.js");
var _toSourceJsDefault = parcelHelpers.interopDefault(_toSourceJs);
/** `Object#toString` result references. */ var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = (0, _toSourceJsDefault.default)((0, _dataViewJsDefault.default)), mapCtorString = (0, _toSourceJsDefault.default)((0, _mapJsDefault.default)), promiseCtorString = (0, _toSourceJsDefault.default)((0, _promiseJsDefault.default)), setCtorString = (0, _toSourceJsDefault.default)((0, _setJsDefault.default)), weakMapCtorString = (0, _toSourceJsDefault.default)((0, _weakMapJsDefault.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = (0, _baseGetTagJsDefault.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, _dataViewJsDefault.default) && getTag(new (0, _dataViewJsDefault.default)(new ArrayBuffer(1))) != dataViewTag || (0, _mapJsDefault.default) && getTag(new (0, _mapJsDefault.default)) != mapTag || (0, _promiseJsDefault.default) && getTag((0, _promiseJsDefault.default).resolve()) != promiseTag || (0, _setJsDefault.default) && getTag(new (0, _setJsDefault.default)) != setTag || (0, _weakMapJsDefault.default) && getTag(new (0, _weakMapJsDefault.default)) != weakMapTag) getTag = function(value) {
    var result = (0, _baseGetTagJsDefault.default)(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, _toSourceJsDefault.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
exports.default = getTag;

},{"./_DataView.js":"415Rv","./_Map.js":"fNX1n","./_Promise.js":"GdBmr","./_Set.js":"eddDj","./_WeakMap.js":"d8aXK","./_baseGetTag.js":"7xCXT","./_toSource.js":"iLvxz","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"415Rv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var DataView = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'DataView');
exports.default = DataView;

},{"./_getNative.js":"hOQOA","./_root.js":"lCXwP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"GdBmr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Promise = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'Promise');
exports.default = Promise;

},{"./_getNative.js":"hOQOA","./_root.js":"lCXwP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"eddDj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var Set = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'Set');
exports.default = Set;

},{"./_getNative.js":"hOQOA","./_root.js":"lCXwP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"d8aXK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNativeJs = require("./_getNative.js");
var _getNativeJsDefault = parcelHelpers.interopDefault(_getNativeJs);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/* Built-in method references that are verified to be native. */ var WeakMap = (0, _getNativeJsDefault.default)((0, _rootJsDefault.default), 'WeakMap');
exports.default = WeakMap;

},{"./_getNative.js":"hOQOA","./_root.js":"lCXwP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fPKl1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isStrictComparableJs = require("./_isStrictComparable.js");
var _isStrictComparableJsDefault = parcelHelpers.interopDefault(_isStrictComparableJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = (0, _keysJsDefault.default)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, _isStrictComparableJsDefault.default)(value)
        ];
    }
    return result;
}
exports.default = getMatchData;

},{"./_isStrictComparable.js":"8RVGs","./keys.js":"clTjo","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8RVGs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isObjectJs = require("./isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !(0, _isObjectJsDefault.default)(value);
}
exports.default = isStrictComparable;

},{"./isObject.js":"3FPXi","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3XPi4":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
exports.default = matchesStrictComparable;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ewFUV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseIsEqualJs = require("./_baseIsEqual.js");
var _baseIsEqualJsDefault = parcelHelpers.interopDefault(_baseIsEqualJs);
var _getJs = require("./get.js");
var _getJsDefault = parcelHelpers.interopDefault(_getJs);
var _hasInJs = require("./hasIn.js");
var _hasInJsDefault = parcelHelpers.interopDefault(_hasInJs);
var _isKeyJs = require("./_isKey.js");
var _isKeyJsDefault = parcelHelpers.interopDefault(_isKeyJs);
var _isStrictComparableJs = require("./_isStrictComparable.js");
var _isStrictComparableJsDefault = parcelHelpers.interopDefault(_isStrictComparableJs);
var _matchesStrictComparableJs = require("./_matchesStrictComparable.js");
var _matchesStrictComparableJsDefault = parcelHelpers.interopDefault(_matchesStrictComparableJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if ((0, _isKeyJsDefault.default)(path) && (0, _isStrictComparableJsDefault.default)(srcValue)) return (0, _matchesStrictComparableJsDefault.default)((0, _toKeyJsDefault.default)(path), srcValue);
    return function(object) {
        var objValue = (0, _getJsDefault.default)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, _hasInJsDefault.default)(object, path) : (0, _baseIsEqualJsDefault.default)(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
exports.default = baseMatchesProperty;

},{"./_baseIsEqual.js":"bgKjw","./get.js":"pAt1M","./hasIn.js":"ilrPP","./_isKey.js":"keVwb","./_isStrictComparable.js":"8RVGs","./_matchesStrictComparable.js":"3XPi4","./_toKey.js":"fj9ZJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"pAt1M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetJs = require("./_baseGet.js");
var _baseGetJsDefault = parcelHelpers.interopDefault(_baseGetJs);
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, _baseGetJsDefault.default)(object, path);
    return result === undefined ? defaultValue : result;
}
exports.default = get;

},{"./_baseGet.js":"dGfUx","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"dGfUx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _castPathJs = require("./_castPath.js");
var _castPathJsDefault = parcelHelpers.interopDefault(_castPathJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = (0, _castPathJsDefault.default)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, _toKeyJsDefault.default)(path[index++])];
    return index && index == length ? object : undefined;
}
exports.default = baseGet;

},{"./_castPath.js":"8pZwZ","./_toKey.js":"fj9ZJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8pZwZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isKeyJs = require("./_isKey.js");
var _isKeyJsDefault = parcelHelpers.interopDefault(_isKeyJs);
var _stringToPathJs = require("./_stringToPath.js");
var _stringToPathJsDefault = parcelHelpers.interopDefault(_stringToPathJs);
var _toStringJs = require("./toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if ((0, _isArrayJsDefault.default)(value)) return value;
    return (0, _isKeyJsDefault.default)(value, object) ? [
        value
    ] : (0, _stringToPathJsDefault.default)((0, _toStringJsDefault.default)(value));
}
exports.default = castPath;

},{"./isArray.js":"cFsjQ","./_isKey.js":"keVwb","./_stringToPath.js":"8djdl","./toString.js":"1PdmN","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"keVwb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if ((0, _isArrayJsDefault.default)(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || (0, _isSymbolJsDefault.default)(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
exports.default = isKey;

},{"./isArray.js":"cFsjQ","./isSymbol.js":"9Ecuc","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8djdl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoizeCappedJs = require("./_memoizeCapped.js");
var _memoizeCappedJsDefault = parcelHelpers.interopDefault(_memoizeCappedJs);
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = (0, _memoizeCappedJsDefault.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
exports.default = stringToPath;

},{"./_memoizeCapped.js":"5HufL","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5HufL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoizeJs = require("./memoize.js");
var _memoizeJsDefault = parcelHelpers.interopDefault(_memoizeJs);
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = (0, _memoizeJsDefault.default)(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
exports.default = memoizeCapped;

},{"./memoize.js":"4ualt","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4ualt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapCacheJs = require("./_MapCache.js");
var _mapCacheJsDefault = parcelHelpers.interopDefault(_mapCacheJs);
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || (0, _mapCacheJsDefault.default));
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = (0, _mapCacheJsDefault.default);
exports.default = memoize;

},{"./_MapCache.js":"3OQXh","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"1PdmN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseToStringJs = require("./_baseToString.js");
var _baseToStringJsDefault = parcelHelpers.interopDefault(_baseToStringJs);
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : (0, _baseToStringJsDefault.default)(value);
}
exports.default = toString;

},{"./_baseToString.js":"dwUcZ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"dwUcZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _arrayMapJs = require("./_arrayMap.js");
var _arrayMapJsDefault = parcelHelpers.interopDefault(_arrayMapJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, _isArrayJsDefault.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, _arrayMapJsDefault.default)(value, baseToString) + '';
    if ((0, _isSymbolJsDefault.default)(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
exports.default = baseToString;

},{"./_Symbol.js":"j1NQF","./_arrayMap.js":"fmP6u","./isArray.js":"cFsjQ","./isSymbol.js":"9Ecuc","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fj9ZJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isSymbolJs = require("./isSymbol.js");
var _isSymbolJsDefault = parcelHelpers.interopDefault(_isSymbolJs);
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || (0, _isSymbolJsDefault.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
exports.default = toKey;

},{"./isSymbol.js":"9Ecuc","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ilrPP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseHasInJs = require("./_baseHasIn.js");
var _baseHasInJsDefault = parcelHelpers.interopDefault(_baseHasInJs);
var _hasPathJs = require("./_hasPath.js");
var _hasPathJsDefault = parcelHelpers.interopDefault(_hasPathJs);
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && (0, _hasPathJsDefault.default)(object, path, (0, _baseHasInJsDefault.default));
}
exports.default = hasIn;

},{"./_baseHasIn.js":"g6Ud8","./_hasPath.js":"eJmiZ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"g6Ud8":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
exports.default = baseHasIn;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"eJmiZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _castPathJs = require("./_castPath.js");
var _castPathJsDefault = parcelHelpers.interopDefault(_castPathJs);
var _isArgumentsJs = require("./isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isIndexJs = require("./_isIndex.js");
var _isIndexJsDefault = parcelHelpers.interopDefault(_isIndexJs);
var _isLengthJs = require("./isLength.js");
var _isLengthJsDefault = parcelHelpers.interopDefault(_isLengthJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = (0, _castPathJsDefault.default)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, _toKeyJsDefault.default)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, _isLengthJsDefault.default)(length) && (0, _isIndexJsDefault.default)(key, length) && ((0, _isArrayJsDefault.default)(object) || (0, _isArgumentsJsDefault.default)(object));
}
exports.default = hasPath;

},{"./_castPath.js":"8pZwZ","./isArguments.js":"1sQzR","./isArray.js":"cFsjQ","./_isIndex.js":"ck6BC","./isLength.js":"lxY52","./_toKey.js":"fj9ZJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"s3hj3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _basePropertyJs = require("./_baseProperty.js");
var _basePropertyJsDefault = parcelHelpers.interopDefault(_basePropertyJs);
var _basePropertyDeepJs = require("./_basePropertyDeep.js");
var _basePropertyDeepJsDefault = parcelHelpers.interopDefault(_basePropertyDeepJs);
var _isKeyJs = require("./_isKey.js");
var _isKeyJsDefault = parcelHelpers.interopDefault(_isKeyJs);
var _toKeyJs = require("./_toKey.js");
var _toKeyJsDefault = parcelHelpers.interopDefault(_toKeyJs);
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return (0, _isKeyJsDefault.default)(path) ? (0, _basePropertyJsDefault.default)((0, _toKeyJsDefault.default)(path)) : (0, _basePropertyDeepJsDefault.default)(path);
}
exports.default = property;

},{"./_baseProperty.js":"f9hCe","./_basePropertyDeep.js":"iSgEY","./_isKey.js":"keVwb","./_toKey.js":"fj9ZJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"f9hCe":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
exports.default = baseProperty;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"iSgEY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetJs = require("./_baseGet.js");
var _baseGetJsDefault = parcelHelpers.interopDefault(_baseGetJs);
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return (0, _baseGetJsDefault.default)(object, path);
    };
}
exports.default = basePropertyDeep;

},{"./_baseGet.js":"dGfUx","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3HK9l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseEachJs = require("./_baseEach.js");
var _baseEachJsDefault = parcelHelpers.interopDefault(_baseEachJs);
var _isArrayLikeJs = require("./isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = (0, _isArrayLikeJsDefault.default)(collection) ? Array(collection.length) : [];
    (0, _baseEachJsDefault.default)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
exports.default = baseMap;

},{"./_baseEach.js":"1rj7a","./isArrayLike.js":"2V1MI","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"1M8bI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Circle", ()=>Circle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _materialColors = require("material-colors");
var _common = require("../common");
var _circleSwatch = require("./CircleSwatch");
var _circleSwatchDefault = parcelHelpers.interopDefault(_circleSwatch);
var Circle = function Circle(_ref) {
    var width = _ref.width, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, circleSize = _ref.circleSize, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, circleSpacing = _ref.circleSpacing, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            card: {
                width: width,
                display: 'flex',
                flexWrap: 'wrap',
                marginRight: -circleSpacing,
                marginBottom: -circleSpacing
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(hexCode, e) {
        return onChange({
            hex: hexCode,
            source: 'hex'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.card,
        className: 'circle-picker ' + className
    }, (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _circleSwatchDefault.default), {
            key: c,
            color: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover,
            active: hex === c.toLowerCase(),
            circleSize: circleSize,
            circleSpacing: circleSpacing
        });
    }));
};
Circle.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    circleSize: (0, _propTypesDefault.default).number,
    circleSpacing: (0, _propTypesDefault.default).number,
    styles: (0, _propTypesDefault.default).object
};
Circle.defaultProps = {
    width: 252,
    circleSize: 28,
    circleSpacing: 14,
    colors: [
        _materialColors.red['500'],
        _materialColors.pink['500'],
        _materialColors.purple['500'],
        _materialColors.deepPurple['500'],
        _materialColors.indigo['500'],
        _materialColors.blue['500'],
        _materialColors.lightBlue['500'],
        _materialColors.cyan['500'],
        _materialColors.teal['500'],
        _materialColors.green['500'],
        _materialColors.lightGreen['500'],
        _materialColors.lime['500'],
        _materialColors.yellow['500'],
        _materialColors.amber['500'],
        _materialColors.orange['500'],
        _materialColors.deepOrange['500'],
        _materialColors.brown['500'],
        _materialColors.blueGrey['500']
    ],
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Circle);

},{"react":"6wC8C","prop-types":"6YTRF","reactcss":"7yqRl","lodash-es/map":"d8f0z","lodash-es/merge":"4s9GK","material-colors":"8RjDx","../common":"gx5lJ","./CircleSwatch":"6boI0","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8RjDx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "red", ()=>red);
parcelHelpers.export(exports, "pink", ()=>pink);
parcelHelpers.export(exports, "purple", ()=>purple);
parcelHelpers.export(exports, "deepPurple", ()=>deepPurple);
parcelHelpers.export(exports, "indigo", ()=>indigo);
parcelHelpers.export(exports, "blue", ()=>blue);
parcelHelpers.export(exports, "lightBlue", ()=>lightBlue);
parcelHelpers.export(exports, "cyan", ()=>cyan);
parcelHelpers.export(exports, "teal", ()=>teal);
parcelHelpers.export(exports, "green", ()=>green);
parcelHelpers.export(exports, "lightGreen", ()=>lightGreen);
parcelHelpers.export(exports, "lime", ()=>lime);
parcelHelpers.export(exports, "yellow", ()=>yellow);
parcelHelpers.export(exports, "amber", ()=>amber);
parcelHelpers.export(exports, "orange", ()=>orange);
parcelHelpers.export(exports, "deepOrange", ()=>deepOrange);
parcelHelpers.export(exports, "brown", ()=>brown);
parcelHelpers.export(exports, "grey", ()=>grey);
parcelHelpers.export(exports, "blueGrey", ()=>blueGrey);
parcelHelpers.export(exports, "darkText", ()=>darkText);
parcelHelpers.export(exports, "lightText", ()=>lightText);
parcelHelpers.export(exports, "darkIcons", ()=>darkIcons);
parcelHelpers.export(exports, "lightIcons", ()=>lightIcons);
parcelHelpers.export(exports, "white", ()=>white);
parcelHelpers.export(exports, "black", ()=>black);
var red = {
    "50": "#ffebee",
    "100": "#ffcdd2",
    "200": "#ef9a9a",
    "300": "#e57373",
    "400": "#ef5350",
    "500": "#f44336",
    "600": "#e53935",
    "700": "#d32f2f",
    "800": "#c62828",
    "900": "#b71c1c",
    "a100": "#ff8a80",
    "a200": "#ff5252",
    "a400": "#ff1744",
    "a700": "#d50000"
};
var pink = {
    "50": "#fce4ec",
    "100": "#f8bbd0",
    "200": "#f48fb1",
    "300": "#f06292",
    "400": "#ec407a",
    "500": "#e91e63",
    "600": "#d81b60",
    "700": "#c2185b",
    "800": "#ad1457",
    "900": "#880e4f",
    "a100": "#ff80ab",
    "a200": "#ff4081",
    "a400": "#f50057",
    "a700": "#c51162"
};
var purple = {
    "50": "#f3e5f5",
    "100": "#e1bee7",
    "200": "#ce93d8",
    "300": "#ba68c8",
    "400": "#ab47bc",
    "500": "#9c27b0",
    "600": "#8e24aa",
    "700": "#7b1fa2",
    "800": "#6a1b9a",
    "900": "#4a148c",
    "a100": "#ea80fc",
    "a200": "#e040fb",
    "a400": "#d500f9",
    "a700": "#aa00ff"
};
var deepPurple = {
    "50": "#ede7f6",
    "100": "#d1c4e9",
    "200": "#b39ddb",
    "300": "#9575cd",
    "400": "#7e57c2",
    "500": "#673ab7",
    "600": "#5e35b1",
    "700": "#512da8",
    "800": "#4527a0",
    "900": "#311b92",
    "a100": "#b388ff",
    "a200": "#7c4dff",
    "a400": "#651fff",
    "a700": "#6200ea"
};
var indigo = {
    "50": "#e8eaf6",
    "100": "#c5cae9",
    "200": "#9fa8da",
    "300": "#7986cb",
    "400": "#5c6bc0",
    "500": "#3f51b5",
    "600": "#3949ab",
    "700": "#303f9f",
    "800": "#283593",
    "900": "#1a237e",
    "a100": "#8c9eff",
    "a200": "#536dfe",
    "a400": "#3d5afe",
    "a700": "#304ffe"
};
var blue = {
    "50": "#e3f2fd",
    "100": "#bbdefb",
    "200": "#90caf9",
    "300": "#64b5f6",
    "400": "#42a5f5",
    "500": "#2196f3",
    "600": "#1e88e5",
    "700": "#1976d2",
    "800": "#1565c0",
    "900": "#0d47a1",
    "a100": "#82b1ff",
    "a200": "#448aff",
    "a400": "#2979ff",
    "a700": "#2962ff"
};
var lightBlue = {
    "50": "#e1f5fe",
    "100": "#b3e5fc",
    "200": "#81d4fa",
    "300": "#4fc3f7",
    "400": "#29b6f6",
    "500": "#03a9f4",
    "600": "#039be5",
    "700": "#0288d1",
    "800": "#0277bd",
    "900": "#01579b",
    "a100": "#80d8ff",
    "a200": "#40c4ff",
    "a400": "#00b0ff",
    "a700": "#0091ea"
};
var cyan = {
    "50": "#e0f7fa",
    "100": "#b2ebf2",
    "200": "#80deea",
    "300": "#4dd0e1",
    "400": "#26c6da",
    "500": "#00bcd4",
    "600": "#00acc1",
    "700": "#0097a7",
    "800": "#00838f",
    "900": "#006064",
    "a100": "#84ffff",
    "a200": "#18ffff",
    "a400": "#00e5ff",
    "a700": "#00b8d4"
};
var teal = {
    "50": "#e0f2f1",
    "100": "#b2dfdb",
    "200": "#80cbc4",
    "300": "#4db6ac",
    "400": "#26a69a",
    "500": "#009688",
    "600": "#00897b",
    "700": "#00796b",
    "800": "#00695c",
    "900": "#004d40",
    "a100": "#a7ffeb",
    "a200": "#64ffda",
    "a400": "#1de9b6",
    "a700": "#00bfa5"
};
var green = {
    "50": "#e8f5e9",
    "100": "#c8e6c9",
    "200": "#a5d6a7",
    "300": "#81c784",
    "400": "#66bb6a",
    "500": "#4caf50",
    "600": "#43a047",
    "700": "#388e3c",
    "800": "#2e7d32",
    "900": "#1b5e20",
    "a100": "#b9f6ca",
    "a200": "#69f0ae",
    "a400": "#00e676",
    "a700": "#00c853"
};
var lightGreen = {
    "50": "#f1f8e9",
    "100": "#dcedc8",
    "200": "#c5e1a5",
    "300": "#aed581",
    "400": "#9ccc65",
    "500": "#8bc34a",
    "600": "#7cb342",
    "700": "#689f38",
    "800": "#558b2f",
    "900": "#33691e",
    "a100": "#ccff90",
    "a200": "#b2ff59",
    "a400": "#76ff03",
    "a700": "#64dd17"
};
var lime = {
    "50": "#f9fbe7",
    "100": "#f0f4c3",
    "200": "#e6ee9c",
    "300": "#dce775",
    "400": "#d4e157",
    "500": "#cddc39",
    "600": "#c0ca33",
    "700": "#afb42b",
    "800": "#9e9d24",
    "900": "#827717",
    "a100": "#f4ff81",
    "a200": "#eeff41",
    "a400": "#c6ff00",
    "a700": "#aeea00"
};
var yellow = {
    "50": "#fffde7",
    "100": "#fff9c4",
    "200": "#fff59d",
    "300": "#fff176",
    "400": "#ffee58",
    "500": "#ffeb3b",
    "600": "#fdd835",
    "700": "#fbc02d",
    "800": "#f9a825",
    "900": "#f57f17",
    "a100": "#ffff8d",
    "a200": "#ffff00",
    "a400": "#ffea00",
    "a700": "#ffd600"
};
var amber = {
    "50": "#fff8e1",
    "100": "#ffecb3",
    "200": "#ffe082",
    "300": "#ffd54f",
    "400": "#ffca28",
    "500": "#ffc107",
    "600": "#ffb300",
    "700": "#ffa000",
    "800": "#ff8f00",
    "900": "#ff6f00",
    "a100": "#ffe57f",
    "a200": "#ffd740",
    "a400": "#ffc400",
    "a700": "#ffab00"
};
var orange = {
    "50": "#fff3e0",
    "100": "#ffe0b2",
    "200": "#ffcc80",
    "300": "#ffb74d",
    "400": "#ffa726",
    "500": "#ff9800",
    "600": "#fb8c00",
    "700": "#f57c00",
    "800": "#ef6c00",
    "900": "#e65100",
    "a100": "#ffd180",
    "a200": "#ffab40",
    "a400": "#ff9100",
    "a700": "#ff6d00"
};
var deepOrange = {
    "50": "#fbe9e7",
    "100": "#ffccbc",
    "200": "#ffab91",
    "300": "#ff8a65",
    "400": "#ff7043",
    "500": "#ff5722",
    "600": "#f4511e",
    "700": "#e64a19",
    "800": "#d84315",
    "900": "#bf360c",
    "a100": "#ff9e80",
    "a200": "#ff6e40",
    "a400": "#ff3d00",
    "a700": "#dd2c00"
};
var brown = {
    "50": "#efebe9",
    "100": "#d7ccc8",
    "200": "#bcaaa4",
    "300": "#a1887f",
    "400": "#8d6e63",
    "500": "#795548",
    "600": "#6d4c41",
    "700": "#5d4037",
    "800": "#4e342e",
    "900": "#3e2723"
};
var grey = {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#212121"
};
var blueGrey = {
    "50": "#eceff1",
    "100": "#cfd8dc",
    "200": "#b0bec5",
    "300": "#90a4ae",
    "400": "#78909c",
    "500": "#607d8b",
    "600": "#546e7a",
    "700": "#455a64",
    "800": "#37474f",
    "900": "#263238"
};
var darkText = {
    "primary": "rgba(0, 0, 0, 0.87)",
    "secondary": "rgba(0, 0, 0, 0.54)",
    "disabled": "rgba(0, 0, 0, 0.38)",
    "dividers": "rgba(0, 0, 0, 0.12)"
};
var lightText = {
    "primary": "rgba(255, 255, 255, 1)",
    "secondary": "rgba(255, 255, 255, 0.7)",
    "disabled": "rgba(255, 255, 255, 0.5)",
    "dividers": "rgba(255, 255, 255, 0.12)"
};
var darkIcons = {
    "active": "rgba(0, 0, 0, 0.54)",
    "inactive": "rgba(0, 0, 0, 0.38)"
};
var lightIcons = {
    "active": "rgba(255, 255, 255, 1)",
    "inactive": "rgba(255, 255, 255, 0.5)"
};
var white = "#ffffff";
var black = "#000000";
exports.default = {
    red: red,
    pink: pink,
    purple: purple,
    deepPurple: deepPurple,
    indigo: indigo,
    blue: blue,
    lightBlue: lightBlue,
    cyan: cyan,
    teal: teal,
    green: green,
    lightGreen: lightGreen,
    lime: lime,
    yellow: yellow,
    amber: amber,
    orange: orange,
    deepOrange: deepOrange,
    brown: brown,
    grey: grey,
    blueGrey: blueGrey,
    darkText: darkText,
    lightText: lightText,
    darkIcons: darkIcons,
    lightIcons: lightIcons,
    white: white,
    black: black
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6boI0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CircleSwatch", ()=>CircleSwatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var CircleSwatch = function CircleSwatch(_ref) {
    var color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, hover = _ref.hover, active = _ref.active, circleSize = _ref.circleSize, circleSpacing = _ref.circleSpacing;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            swatch: {
                width: circleSize,
                height: circleSize,
                marginRight: circleSpacing,
                marginBottom: circleSpacing,
                transform: 'scale(1)',
                transition: '100ms transform ease'
            },
            Swatch: {
                borderRadius: '50%',
                background: 'transparent',
                boxShadow: 'inset 0 0 0 ' + (circleSize / 2 + 1) + 'px ' + color,
                transition: '100ms box-shadow ease'
            }
        },
        'hover': {
            swatch: {
                transform: 'scale(1.2)'
            }
        },
        'active': {
            Swatch: {
                boxShadow: 'inset 0 0 0 3px ' + color
            }
        }
    }, {
        hover: hover,
        active: active
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _common.Swatch), {
        style: styles.Swatch,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color
        }
    }));
};
CircleSwatch.defaultProps = {
    circleSize: 28,
    circleSpacing: 14
};
exports.default = (0, _reactcss.handleHover)(CircleSwatch);

},{"react":"6wC8C","reactcss":"7yqRl","../common":"gx5lJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fVe7r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Chrome", ()=>Chrome);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _chromeFields = require("./ChromeFields");
var _chromeFieldsDefault = parcelHelpers.interopDefault(_chromeFields);
var _chromePointer = require("./ChromePointer");
var _chromePointerDefault = parcelHelpers.interopDefault(_chromePointer);
var _chromePointerCircle = require("./ChromePointerCircle");
var _chromePointerCircleDefault = parcelHelpers.interopDefault(_chromePointerCircle);
var Chrome = function Chrome(_ref) {
    var width = _ref.width, onChange = _ref.onChange, disableAlpha = _ref.disableAlpha, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className, defaultView = _ref.defaultView;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            picker: {
                width: width,
                background: '#fff',
                borderRadius: '2px',
                boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
                boxSizing: 'initial',
                fontFamily: 'Menlo'
            },
            saturation: {
                width: '100%',
                paddingBottom: '55%',
                position: 'relative',
                borderRadius: '2px 2px 0 0',
                overflow: 'hidden'
            },
            Saturation: {
                radius: '2px 2px 0 0'
            },
            body: {
                padding: '16px 16px 12px'
            },
            controls: {
                display: 'flex'
            },
            color: {
                width: '32px'
            },
            swatch: {
                marginTop: '6px',
                width: '16px',
                height: '16px',
                borderRadius: '8px',
                position: 'relative',
                overflow: 'hidden'
            },
            active: {
                absolute: '0px 0px 0px 0px',
                borderRadius: '8px',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
                background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
                zIndex: '2'
            },
            toggles: {
                flex: '1'
            },
            hue: {
                height: '10px',
                position: 'relative',
                marginBottom: '8px'
            },
            Hue: {
                radius: '2px'
            },
            alpha: {
                height: '10px',
                position: 'relative'
            },
            Alpha: {
                radius: '2px'
            }
        },
        'disableAlpha': {
            color: {
                width: '22px'
            },
            alpha: {
                display: 'none'
            },
            hue: {
                marginBottom: '0px'
            },
            swatch: {
                width: '10px',
                height: '10px',
                marginTop: '0px'
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker,
        className: 'chrome-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.saturation
    }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: (0, _chromePointerCircleDefault.default),
        onChange: onChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.body
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.color
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.active
    }), (0, _reactDefault.default).createElement((0, _common.Checkboard), {
        renderers: renderers
    }))), (0, _reactDefault.default).createElement('div', {
        style: styles.toggles
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        pointer: (0, _chromePointerDefault.default),
        onChange: onChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.alpha
    }, (0, _reactDefault.default).createElement((0, _common.Alpha), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        pointer: (0, _chromePointerDefault.default),
        renderers: renderers,
        onChange: onChange
    })))), (0, _reactDefault.default).createElement((0, _chromeFieldsDefault.default), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
    })));
};
Chrome.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    disableAlpha: (0, _propTypesDefault.default).bool,
    styles: (0, _propTypesDefault.default).object,
    defaultView: (0, _propTypesDefault.default).oneOf([
        "hex",
        "rgb",
        "hsl"
    ])
};
Chrome.defaultProps = {
    width: 225,
    disableAlpha: false,
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Chrome);

},{"react":"6wC8C","prop-types":"6YTRF","reactcss":"7yqRl","lodash-es/merge":"4s9GK","../common":"gx5lJ","./ChromeFields":"h3N4i","./ChromePointer":"9bqR2","./ChromePointerCircle":"gpyjV","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"h3N4i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChromeFields", ()=>ChromeFields);
/* eslint-disable react/no-did-mount-set-state, no-param-reassign */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _isUndefined = require("lodash-es/isUndefined");
var _isUndefinedDefault = parcelHelpers.interopDefault(_isUndefined);
var _common = require("../common");
var _unfoldMoreHorizontalIcon = require("@icons/material/UnfoldMoreHorizontalIcon");
var _unfoldMoreHorizontalIconDefault = parcelHelpers.interopDefault(_unfoldMoreHorizontalIcon);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ChromeFields = function(_React$Component) {
    _inherits(ChromeFields, _React$Component);
    function ChromeFields(props) {
        _classCallCheck(this, ChromeFields);
        var _this = _possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));
        _this.toggleViews = function() {
            if (_this.state.view === 'hex') _this.setState({
                view: 'rgb'
            });
            else if (_this.state.view === 'rgb') _this.setState({
                view: 'hsl'
            });
            else if (_this.state.view === 'hsl') {
                if (_this.props.hsl.a === 1) _this.setState({
                    view: 'hex'
                });
                else _this.setState({
                    view: 'rgb'
                });
            }
        };
        _this.handleChange = function(data, e) {
            if (data.hex) _color.isValidHex(data.hex) && _this.props.onChange({
                hex: data.hex,
                source: 'hex'
            }, e);
            else if (data.r || data.g || data.b) _this.props.onChange({
                r: data.r || _this.props.rgb.r,
                g: data.g || _this.props.rgb.g,
                b: data.b || _this.props.rgb.b,
                source: 'rgb'
            }, e);
            else if (data.a) {
                if (data.a < 0) data.a = 0;
                else if (data.a > 1) data.a = 1;
                _this.props.onChange({
                    h: _this.props.hsl.h,
                    s: _this.props.hsl.s,
                    l: _this.props.hsl.l,
                    a: Math.round(data.a * 100) / 100,
                    source: 'rgb'
                }, e);
            } else if (data.h || data.s || data.l) {
                // Remove any occurances of '%'.
                if (typeof data.s === 'string' && data.s.includes('%')) data.s = data.s.replace('%', '');
                if (typeof data.l === 'string' && data.l.includes('%')) data.l = data.l.replace('%', '');
                // We store HSL as a unit interval so we need to override the 1 input to 0.01
                if (data.s == 1) data.s = 0.01;
                else if (data.l == 1) data.l = 0.01;
                _this.props.onChange({
                    h: data.h || _this.props.hsl.h,
                    s: Number(!(0, _isUndefinedDefault.default)(data.s) ? data.s : _this.props.hsl.s),
                    l: Number(!(0, _isUndefinedDefault.default)(data.l) ? data.l : _this.props.hsl.l),
                    source: 'hsl'
                }, e);
            }
        };
        _this.showHighlight = function(e) {
            e.currentTarget.style.background = '#eee';
        };
        _this.hideHighlight = function(e) {
            e.currentTarget.style.background = 'transparent';
        };
        if (props.hsl.a !== 1 && props.view === "hex") _this.state = {
            view: "rgb"
        };
        else _this.state = {
            view: props.view
        };
        return _this;
    }
    _createClass(ChromeFields, [
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var styles = (0, _reactcssDefault.default)({
                    'default': {
                        wrap: {
                            paddingTop: '16px',
                            display: 'flex'
                        },
                        fields: {
                            flex: '1',
                            display: 'flex',
                            marginLeft: '-6px'
                        },
                        field: {
                            paddingLeft: '6px',
                            width: '100%'
                        },
                        alpha: {
                            paddingLeft: '6px',
                            width: '100%'
                        },
                        toggle: {
                            width: '32px',
                            textAlign: 'right',
                            position: 'relative'
                        },
                        icon: {
                            marginRight: '-4px',
                            marginTop: '12px',
                            cursor: 'pointer',
                            position: 'relative'
                        },
                        iconHighlight: {
                            position: 'absolute',
                            width: '24px',
                            height: '28px',
                            background: '#eee',
                            borderRadius: '4px',
                            top: '10px',
                            left: '12px',
                            display: 'none'
                        },
                        input: {
                            fontSize: '11px',
                            color: '#333',
                            width: '100%',
                            borderRadius: '2px',
                            border: 'none',
                            boxShadow: 'inset 0 0 0 1px #dadada',
                            height: '21px',
                            textAlign: 'center'
                        },
                        label: {
                            textTransform: 'uppercase',
                            fontSize: '11px',
                            lineHeight: '11px',
                            color: '#969696',
                            textAlign: 'center',
                            display: 'block',
                            marginTop: '12px'
                        },
                        svg: {
                            fill: '#333',
                            width: '24px',
                            height: '24px',
                            border: '1px transparent solid',
                            borderRadius: '5px'
                        }
                    },
                    'disableAlpha': {
                        alpha: {
                            display: 'none'
                        }
                    }
                }, this.props, this.state);
                var fields = void 0;
                if (this.state.view === 'hex') fields = (0, _reactDefault.default).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'hex',
                    value: this.props.hex,
                    onChange: this.handleChange
                })));
                else if (this.state.view === 'rgb') fields = (0, _reactDefault.default).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'r',
                    value: this.props.rgb.r,
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'g',
                    value: this.props.rgb.g,
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'b',
                    value: this.props.rgb.b,
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.alpha
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'a',
                    value: this.props.rgb.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                else if (this.state.view === 'hsl') fields = (0, _reactDefault.default).createElement('div', {
                    style: styles.fields,
                    className: 'flexbox-fix'
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'h',
                    value: Math.round(this.props.hsl.h),
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 's',
                    value: Math.round(this.props.hsl.s * 100) + '%',
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.field
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'l',
                    value: Math.round(this.props.hsl.l * 100) + '%',
                    onChange: this.handleChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.alpha
                }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: 'a',
                    value: this.props.hsl.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                return (0, _reactDefault.default).createElement('div', {
                    style: styles.wrap,
                    className: 'flexbox-fix'
                }, fields, (0, _reactDefault.default).createElement('div', {
                    style: styles.toggle
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.icon,
                    onClick: this.toggleViews,
                    ref: function ref(icon) {
                        return _this2.icon = icon;
                    }
                }, (0, _reactDefault.default).createElement((0, _unfoldMoreHorizontalIconDefault.default), {
                    style: styles.svg,
                    onMouseOver: this.showHighlight,
                    onMouseEnter: this.showHighlight,
                    onMouseOut: this.hideHighlight
                }))));
            }
        }
    ], [
        {
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(nextProps, state) {
                if (nextProps.hsl.a !== 1 && state.view === 'hex') return {
                    view: 'rgb'
                };
                return null;
            }
        }
    ]);
    return ChromeFields;
}((0, _reactDefault.default).Component);
ChromeFields.defaultProps = {
    view: "hex"
};
exports.default = ChromeFields;

},{"react":"6wC8C","reactcss":"7yqRl","../../helpers/color":"dHnAt","lodash-es/isUndefined":"gCOA1","../common":"gx5lJ","@icons/material/UnfoldMoreHorizontalIcon":"j9vY7","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"gCOA1":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isUndefined(value) {
    return value === undefined;
}
exports.default = isUndefined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"j9vY7":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("cab3160a8154bde");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var DEFAULT_SIZE = 24;
exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? 'currentColor' : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = _objectWithoutProperties(_ref, [
        'fill',
        'width',
        'height',
        'style'
    ]);
    return _react2.default.createElement('svg', _extends({
        viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
        style: _extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), _react2.default.createElement('path', {
        d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z'
    }));
};

},{"cab3160a8154bde":"6wC8C"}],"9bqR2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChromePointer", ()=>ChromePointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var ChromePointer = function ChromePointer() {
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                transform: 'translate(-6px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
exports.default = ChromePointer;

},{"react":"6wC8C","reactcss":"7yqRl","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"gpyjV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChromePointerCircle", ()=>ChromePointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var ChromePointerCircle = function ChromePointerCircle() {
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                boxShadow: 'inset 0 0 0 1px #fff',
                transform: 'translate(-6px, -6px)'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
exports.default = ChromePointerCircle;

},{"react":"6wC8C","reactcss":"7yqRl","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"iqS6C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Compact", ()=>Compact);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var _compactColor = require("./CompactColor");
var _compactColorDefault = parcelHelpers.interopDefault(_compactColor);
var _compactFields = require("./CompactFields");
var _compactFieldsDefault = parcelHelpers.interopDefault(_compactFields);
var Compact = function Compact(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            Compact: {
                background: '#f6f6f6',
                radius: '4px'
            },
            compact: {
                paddingTop: '5px',
                paddingLeft: '5px',
                boxSizing: 'initial',
                width: '240px'
            },
            clear: {
                clear: 'both'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else onChange(data, e);
    };
    return (0, _reactDefault.default).createElement((0, _common.Raised), {
        style: styles.Compact,
        styles: passedStyles
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.compact,
        className: 'compact-picker ' + className
    }, (0, _reactDefault.default).createElement('div', null, (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _compactColorDefault.default), {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.clear
    })), (0, _reactDefault.default).createElement((0, _compactFieldsDefault.default), {
        hex: hex,
        rgb: rgb,
        onChange: handleChange
    })));
};
Compact.propTypes = {
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    styles: (0, _propTypesDefault.default).object
};
Compact.defaultProps = {
    colors: [
        '#4D4D4D',
        '#999999',
        '#FFFFFF',
        '#F44E3B',
        '#FE9200',
        '#FCDC00',
        '#DBDF00',
        '#A4DD00',
        '#68CCCA',
        '#73D8FF',
        '#AEA1FF',
        '#FDA1FF',
        '#333333',
        '#808080',
        '#cccccc',
        '#D33115',
        '#E27300',
        '#FCC400',
        '#B0BC00',
        '#68BC00',
        '#16A5A5',
        '#009CE0',
        '#7B64FF',
        '#FA28FF',
        '#000000',
        '#666666',
        '#B3B3B3',
        '#9F0500',
        '#C45100',
        '#FB9E00',
        '#808900',
        '#194D33',
        '#0C797D',
        '#0062B1',
        '#653294',
        '#AB149E'
    ],
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Compact);

},{"react":"6wC8C","prop-types":"6YTRF","reactcss":"7yqRl","lodash-es/map":"d8f0z","lodash-es/merge":"4s9GK","../../helpers/color":"dHnAt","../common":"gx5lJ","./CompactColor":"76GFc","./CompactFields":"6800m","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"76GFc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompactColor", ()=>CompactColor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var CompactColor = function CompactColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            color: {
                background: color,
                width: '15px',
                height: '15px',
                float: 'left',
                marginRight: '5px',
                marginBottom: '5px',
                position: 'relative',
                cursor: 'pointer'
            },
            dot: {
                absolute: '5px 5px 5px 5px',
                background: _color.getContrastingColor(color),
                borderRadius: '50%',
                opacity: '0'
            }
        },
        'active': {
            dot: {
                opacity: '1'
            }
        },
        'color-#FFFFFF': {
            color: {
                boxShadow: 'inset 0 0 0 1px #ddd'
            },
            dot: {
                background: '#000'
            }
        },
        'transparent': {
            dot: {
                background: '#000'
            }
        }
    }, {
        active: active,
        'color-#FFFFFF': color === '#FFFFFF',
        'transparent': color === 'transparent'
    });
    return (0, _reactDefault.default).createElement((0, _common.Swatch), {
        style: styles.color,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: '0 0 4px ' + color
        }
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.dot
    }));
};
exports.default = CompactColor;

},{"react":"6wC8C","reactcss":"7yqRl","../../helpers/color":"dHnAt","../common":"gx5lJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6800m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompactFields", ()=>CompactFields);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var CompactFields = function CompactFields(_ref) {
    var hex = _ref.hex, rgb = _ref.rgb, onChange = _ref.onChange;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            fields: {
                display: 'flex',
                paddingBottom: '6px',
                paddingRight: '5px',
                position: 'relative'
            },
            active: {
                position: 'absolute',
                top: '6px',
                left: '5px',
                height: '9px',
                width: '9px',
                background: hex
            },
            HEXwrap: {
                flex: '6',
                position: 'relative'
            },
            HEXinput: {
                width: '80%',
                padding: '0px',
                paddingLeft: '20%',
                border: 'none',
                outline: 'none',
                background: 'none',
                fontSize: '12px',
                color: '#333',
                height: '16px'
            },
            HEXlabel: {
                display: 'none'
            },
            RGBwrap: {
                flex: '3',
                position: 'relative'
            },
            RGBinput: {
                width: '70%',
                padding: '0px',
                paddingLeft: '30%',
                border: 'none',
                outline: 'none',
                background: 'none',
                fontSize: '12px',
                color: '#333',
                height: '16px'
            },
            RGBlabel: {
                position: 'absolute',
                top: '3px',
                left: '0px',
                lineHeight: '16px',
                textTransform: 'uppercase',
                fontSize: '12px',
                color: '#999'
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
        else onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.fields,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.active
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    }));
};
exports.default = CompactFields;

},{"react":"6wC8C","reactcss":"7yqRl","../common":"gx5lJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hALqU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Github", ()=>Github);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _githubSwatch = require("./GithubSwatch");
var _githubSwatchDefault = parcelHelpers.interopDefault(_githubSwatch);
var Github = function Github(_ref) {
    var width = _ref.width, colors = _ref.colors, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                border: '1px solid rgba(0,0,0,0.2)',
                boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
                borderRadius: '4px',
                position: 'relative',
                padding: '5px',
                display: 'flex',
                flexWrap: 'wrap'
            },
            triangle: {
                position: 'absolute',
                border: '7px solid transparent',
                borderBottomColor: '#fff'
            },
            triangleShadow: {
                position: 'absolute',
                border: '8px solid transparent',
                borderBottomColor: 'rgba(0,0,0,0.15)'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            },
            triangleShadow: {
                display: 'none'
            }
        },
        'top-left-triangle': {
            triangle: {
                top: '-14px',
                left: '10px'
            },
            triangleShadow: {
                top: '-16px',
                left: '9px'
            }
        },
        'top-right-triangle': {
            triangle: {
                top: '-14px',
                right: '10px'
            },
            triangleShadow: {
                top: '-16px',
                right: '9px'
            }
        },
        'bottom-left-triangle': {
            triangle: {
                top: '35px',
                left: '10px',
                transform: 'rotate(180deg)'
            },
            triangleShadow: {
                top: '37px',
                left: '9px',
                transform: 'rotate(180deg)'
            }
        },
        'bottom-right-triangle': {
            triangle: {
                top: '35px',
                right: '10px',
                transform: 'rotate(180deg)'
            },
            triangleShadow: {
                top: '37px',
                right: '9px',
                transform: 'rotate(180deg)'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide',
        'top-left-triangle': triangle === 'top-left',
        'top-right-triangle': triangle === 'top-right',
        'bottom-left-triangle': triangle === 'bottom-left',
        'bottom-right-triangle': triangle === 'bottom-right'
    });
    var handleChange = function handleChange(hex, e) {
        return onChange({
            hex: hex,
            source: 'hex'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.card,
        className: 'github-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.triangleShadow
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.triangle
    }), (0, _mapDefault.default)(colors, function(c) {
        return (0, _reactDefault.default).createElement((0, _githubSwatchDefault.default), {
            color: c,
            key: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }));
};
Github.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    triangle: (0, _propTypesDefault.default).oneOf([
        'hide',
        'top-left',
        'top-right',
        'bottom-left',
        'bottom-right'
    ]),
    styles: (0, _propTypesDefault.default).object
};
Github.defaultProps = {
    width: 200,
    colors: [
        '#B80000',
        '#DB3E00',
        '#FCCB00',
        '#008B02',
        '#006B76',
        '#1273DE',
        '#004DCF',
        '#5300EB',
        '#EB9694',
        '#FAD0C3',
        '#FEF3BD',
        '#C1E1C5',
        '#BEDADC',
        '#C4DEF6',
        '#BED3F3',
        '#D4C4FB'
    ],
    triangle: 'top-left',
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Github);

},{"react":"6wC8C","prop-types":"6YTRF","reactcss":"7yqRl","lodash-es/map":"d8f0z","lodash-es/merge":"4s9GK","../common":"gx5lJ","./GithubSwatch":"kcUbD","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kcUbD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GithubSwatch", ()=>GithubSwatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var GithubSwatch = function GithubSwatch(_ref) {
    var hover = _ref.hover, color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var hoverSwatch = {
        position: 'relative',
        zIndex: '2',
        outline: '2px solid #fff',
        boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
    };
    var styles = (0, _reactcssDefault.default)({
        'default': {
            swatch: {
                width: '25px',
                height: '25px',
                fontSize: '0'
            }
        },
        'hover': {
            swatch: hoverSwatch
        }
    }, {
        hover: hover
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _common.Swatch), {
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: hoverSwatch
    }));
};
exports.default = (0, _reactcss.handleHover)(GithubSwatch);

},{"react":"6wC8C","reactcss":"7yqRl","../common":"gx5lJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"irVLb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HuePicker", ()=>HuePicker);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _huePointer = require("./HuePointer");
var _huePointerDefault = parcelHelpers.interopDefault(_huePointer);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var HuePicker = function HuePicker(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, hsl = _ref.hsl, direction = _ref.direction, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            picker: {
                position: 'relative',
                width: width,
                height: height
            },
            hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    // Overwrite to provide pure hue color
    var handleChange = function handleChange(data) {
        return onChange({
            a: 1,
            h: data.h,
            l: 0.5,
            s: 1
        });
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker,
        className: 'hue-picker ' + className
    }, (0, _reactDefault.default).createElement((0, _common.Hue), _extends({}, styles.hue, {
        hsl: hsl,
        pointer: pointer,
        onChange: handleChange,
        direction: direction
    })));
};
HuePicker.propTypes = {
    styles: (0, _propTypesDefault.default).object
};
HuePicker.defaultProps = {
    width: '316px',
    height: '16px',
    direction: 'horizontal',
    pointer: (0, _huePointerDefault.default),
    styles: {}
};
exports.default = (0, _common.ColorWrap)(HuePicker);

},{"react":"6wC8C","prop-types":"6YTRF","reactcss":"7yqRl","lodash-es/merge":"4s9GK","../common":"gx5lJ","./HuePointer":"hnB4a","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hnB4a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderPointer", ()=>SliderPointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var SliderPointer = function SliderPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '18px',
                height: '18px',
                borderRadius: '50%',
                transform: 'translate(-9px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        },
        'vertical': {
            picker: {
                transform: 'translate(-3px, -9px)'
            }
        }
    }, {
        vertical: direction === 'vertical'
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
exports.default = SliderPointer;

},{"react":"6wC8C","reactcss":"7yqRl","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3lSZF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Material", ()=>Material);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var Material = function Material(_ref) {
    var onChange = _ref.onChange, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            material: {
                width: '98px',
                height: '98px',
                padding: '16px',
                fontFamily: 'Roboto'
            },
            HEXwrap: {
                position: 'relative'
            },
            HEXinput: {
                width: '100%',
                marginTop: '12px',
                fontSize: '15px',
                color: '#333',
                padding: '0px',
                border: '0px',
                borderBottom: '2px solid ' + hex,
                outline: 'none',
                height: '30px'
            },
            HEXlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                fontSize: '11px',
                color: '#999999',
                textTransform: 'capitalize'
            },
            Hex: {
                style: {}
            },
            RGBwrap: {
                position: 'relative'
            },
            RGBinput: {
                width: '100%',
                marginTop: '12px',
                fontSize: '15px',
                color: '#333',
                padding: '0px',
                border: '0px',
                borderBottom: '1px solid #eee',
                outline: 'none',
                height: '30px'
            },
            RGBlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                fontSize: '11px',
                color: '#999999',
                textTransform: 'capitalize'
            },
            split: {
                display: 'flex',
                marginRight: '-10px',
                paddingTop: '11px'
            },
            third: {
                flex: '1',
                paddingRight: '10px'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
    };
    return (0, _reactDefault.default).createElement((0, _common.Raised), {
        styles: passedStyles
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.material,
        className: 'material-picker ' + className
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.split,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.third
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.third
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.third
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    })))));
};
exports.default = (0, _common.ColorWrap)(Material);

},{"react":"6wC8C","reactcss":"7yqRl","lodash-es/merge":"4s9GK","../../helpers/color":"dHnAt","../common":"gx5lJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5FTll":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Photoshop", ()=>Photoshop);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _photoshopFields = require("./PhotoshopFields");
var _photoshopFieldsDefault = parcelHelpers.interopDefault(_photoshopFields);
var _photoshopPointerCircle = require("./PhotoshopPointerCircle");
var _photoshopPointerCircleDefault = parcelHelpers.interopDefault(_photoshopPointerCircle);
var _photoshopPointer = require("./PhotoshopPointer");
var _photoshopPointerDefault = parcelHelpers.interopDefault(_photoshopPointer);
var _photoshopButton = require("./PhotoshopButton");
var _photoshopButtonDefault = parcelHelpers.interopDefault(_photoshopButton);
var _photoshopPreviews = require("./PhotoshopPreviews");
var _photoshopPreviewsDefault = parcelHelpers.interopDefault(_photoshopPreviews);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Photoshop = function(_React$Component) {
    _inherits(Photoshop, _React$Component);
    function Photoshop(props) {
        _classCallCheck(this, Photoshop);
        var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
        _this.state = {
            currentColor: props.hex
        };
        return _this;
    }
    _createClass(Photoshop, [
        {
            key: 'render',
            value: function render() {
                var _props = this.props, _props$styles = _props.styles, passedStyles = _props$styles === undefined ? {} : _props$styles, _props$className = _props.className, className = _props$className === undefined ? '' : _props$className;
                var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
                    'default': {
                        picker: {
                            background: '#DCDCDC',
                            borderRadius: '4px',
                            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
                            boxSizing: 'initial',
                            width: '513px'
                        },
                        head: {
                            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
                            borderBottom: '1px solid #B1B1B1',
                            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
                            height: '23px',
                            lineHeight: '24px',
                            borderRadius: '4px 4px 0 0',
                            fontSize: '13px',
                            color: '#4D4D4D',
                            textAlign: 'center'
                        },
                        body: {
                            padding: '15px 15px 0',
                            display: 'flex'
                        },
                        saturation: {
                            width: '256px',
                            height: '256px',
                            position: 'relative',
                            border: '2px solid #B3B3B3',
                            borderBottom: '2px solid #F0F0F0',
                            overflow: 'hidden'
                        },
                        hue: {
                            position: 'relative',
                            height: '256px',
                            width: '19px',
                            marginLeft: '10px',
                            border: '2px solid #B3B3B3',
                            borderBottom: '2px solid #F0F0F0'
                        },
                        controls: {
                            width: '180px',
                            marginLeft: '10px'
                        },
                        top: {
                            display: 'flex'
                        },
                        previews: {
                            width: '60px'
                        },
                        actions: {
                            flex: '1',
                            marginLeft: '20px'
                        }
                    }
                }, passedStyles));
                return (0, _reactDefault.default).createElement('div', {
                    style: styles.picker,
                    className: 'photoshop-picker ' + className
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.head
                }, this.props.header), (0, _reactDefault.default).createElement('div', {
                    style: styles.body,
                    className: 'flexbox-fix'
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.saturation
                }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
                    hsl: this.props.hsl,
                    hsv: this.props.hsv,
                    pointer: (0, _photoshopPointerCircleDefault.default),
                    onChange: this.props.onChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.hue
                }, (0, _reactDefault.default).createElement((0, _common.Hue), {
                    direction: 'vertical',
                    hsl: this.props.hsl,
                    pointer: (0, _photoshopPointerDefault.default),
                    onChange: this.props.onChange
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.controls
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.top,
                    className: 'flexbox-fix'
                }, (0, _reactDefault.default).createElement('div', {
                    style: styles.previews
                }, (0, _reactDefault.default).createElement((0, _photoshopPreviewsDefault.default), {
                    rgb: this.props.rgb,
                    currentColor: this.state.currentColor
                })), (0, _reactDefault.default).createElement('div', {
                    style: styles.actions
                }, (0, _reactDefault.default).createElement((0, _photoshopButtonDefault.default), {
                    label: 'OK',
                    onClick: this.props.onAccept,
                    active: true
                }), (0, _reactDefault.default).createElement((0, _photoshopButtonDefault.default), {
                    label: 'Cancel',
                    onClick: this.props.onCancel
                }), (0, _reactDefault.default).createElement((0, _photoshopFieldsDefault.default), {
                    onChange: this.props.onChange,
                    rgb: this.props.rgb,
                    hsv: this.props.hsv,
                    hex: this.props.hex
                }))))));
            }
        }
    ]);
    return Photoshop;
}((0, _reactDefault.default).Component);
Photoshop.propTypes = {
    header: (0, _propTypesDefault.default).string,
    styles: (0, _propTypesDefault.default).object
};
Photoshop.defaultProps = {
    header: 'Color Picker',
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Photoshop);

},{"react":"6wC8C","prop-types":"6YTRF","reactcss":"7yqRl","lodash-es/merge":"4s9GK","../common":"gx5lJ","./PhotoshopFields":"020hm","./PhotoshopPointerCircle":"1RSfo","./PhotoshopPointer":"dTc0q","./PhotoshopButton":"77Iw5","./PhotoshopPreviews":"7mCnl","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"020hm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPicker", ()=>PhotoshopPicker);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var PhotoshopPicker = function PhotoshopPicker(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsv = _ref.hsv, hex = _ref.hex;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            fields: {
                paddingTop: '5px',
                paddingBottom: '9px',
                width: '80px',
                position: 'relative'
            },
            divider: {
                height: '5px'
            },
            RGBwrap: {
                position: 'relative'
            },
            RGBinput: {
                marginLeft: '40%',
                width: '40%',
                height: '18px',
                border: '1px solid #888888',
                boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
                marginBottom: '5px',
                fontSize: '13px',
                paddingLeft: '3px',
                marginRight: '10px'
            },
            RGBlabel: {
                left: '0px',
                top: '0px',
                width: '34px',
                textTransform: 'uppercase',
                fontSize: '13px',
                height: '18px',
                lineHeight: '22px',
                position: 'absolute'
            },
            HEXwrap: {
                position: 'relative'
            },
            HEXinput: {
                marginLeft: '20%',
                width: '80%',
                height: '18px',
                border: '1px solid #888888',
                boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
                marginBottom: '6px',
                fontSize: '13px',
                paddingLeft: '3px'
            },
            HEXlabel: {
                position: 'absolute',
                top: '0px',
                left: '0px',
                width: '14px',
                textTransform: 'uppercase',
                fontSize: '13px',
                height: '18px',
                lineHeight: '22px'
            },
            fieldSymbols: {
                position: 'absolute',
                top: '5px',
                right: '-7px',
                fontSize: '13px'
            },
            symbol: {
                height: '20px',
                lineHeight: '22px',
                paddingBottom: '7px'
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data['#']) _color.isValidHex(data['#']) && onChange({
            hex: data['#'],
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: 'rgb'
        }, e);
        else if (data.h || data.s || data.v) onChange({
            h: data.h || hsv.h,
            s: data.s || hsv.s,
            v: data.v || hsv.v,
            source: 'hsv'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.fields
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'h',
        value: Math.round(hsv.h),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 's',
        value: Math.round(hsv.s * 100),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'v',
        value: Math.round(hsv.v * 100),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.divider
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.divider
    }), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: '#',
        value: hex.replace('#', ''),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.fieldSymbols
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.symbol
    }, '\xB0'), (0, _reactDefault.default).createElement('div', {
        style: styles.symbol
    }, '%'), (0, _reactDefault.default).createElement('div', {
        style: styles.symbol
    }, '%')));
};
exports.default = PhotoshopPicker;

},{"react":"6wC8C","reactcss":"7yqRl","../../helpers/color":"dHnAt","../common":"gx5lJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"1RSfo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPointerCircle", ()=>PhotoshopPointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
    var hsl = _ref.hsl;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                boxShadow: 'inset 0 0 0 1px #fff',
                transform: 'translate(-6px, -6px)'
            }
        },
        'black-outline': {
            picker: {
                boxShadow: 'inset 0 0 0 1px #000'
            }
        }
    }, {
        'black-outline': hsl.l > 0.5
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
exports.default = PhotoshopPointerCircle;

},{"react":"6wC8C","reactcss":"7yqRl","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"dTc0q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPointerCircle", ()=>PhotoshopPointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopPointerCircle = function PhotoshopPointerCircle() {
    var styles = (0, _reactcssDefault.default)({
        'default': {
            triangle: {
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '4px 0 4px 6px',
                borderColor: 'transparent transparent transparent #fff',
                position: 'absolute',
                top: '1px',
                left: '1px'
            },
            triangleBorder: {
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '5px 0 5px 8px',
                borderColor: 'transparent transparent transparent #555'
            },
            left: {
                Extend: 'triangleBorder',
                transform: 'translate(-13px, -4px)'
            },
            leftInside: {
                Extend: 'triangle',
                transform: 'translate(-8px, -5px)'
            },
            right: {
                Extend: 'triangleBorder',
                transform: 'translate(20px, -14px) rotate(180deg)'
            },
            rightInside: {
                Extend: 'triangle',
                transform: 'translate(-8px, -5px)'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.pointer
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.left
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.leftInside
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.right
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.rightInside
    })));
};
exports.default = PhotoshopPointerCircle;

},{"react":"6wC8C","reactcss":"7yqRl","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"77Iw5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopButton", ()=>PhotoshopButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopButton = function PhotoshopButton(_ref) {
    var onClick = _ref.onClick, label = _ref.label, children = _ref.children, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            button: {
                backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
                border: '1px solid #878787',
                borderRadius: '2px',
                height: '20px',
                boxShadow: '0 1px 0 0 #EAEAEA',
                fontSize: '14px',
                color: '#000',
                lineHeight: '20px',
                textAlign: 'center',
                marginBottom: '10px',
                cursor: 'pointer'
            }
        },
        'active': {
            button: {
                boxShadow: '0 0 0 1px #878787'
            }
        }
    }, {
        active: active
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.button,
        onClick: onClick
    }, label || children);
};
exports.default = PhotoshopButton;

},{"react":"6wC8C","reactcss":"7yqRl","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7mCnl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PhotoshopPreviews", ()=>PhotoshopPreviews);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var PhotoshopPreviews = function PhotoshopPreviews(_ref) {
    var rgb = _ref.rgb, currentColor = _ref.currentColor;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            swatches: {
                border: '1px solid #B3B3B3',
                borderBottom: '1px solid #F0F0F0',
                marginBottom: '2px',
                marginTop: '1px'
            },
            new: {
                height: '34px',
                background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
                boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
            },
            current: {
                height: '34px',
                background: currentColor,
                boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
            },
            label: {
                fontSize: '14px',
                color: '#000',
                textAlign: 'center'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', null, (0, _reactDefault.default).createElement('div', {
        style: styles.label
    }, 'new'), (0, _reactDefault.default).createElement('div', {
        style: styles.swatches
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.new
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.current
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.label
    }, 'current'));
};
exports.default = PhotoshopPreviews;

},{"react":"6wC8C","reactcss":"7yqRl","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"iFUvx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sketch", ()=>Sketch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _sketchFields = require("./SketchFields");
var _sketchFieldsDefault = parcelHelpers.interopDefault(_sketchFields);
var _sketchPresetColors = require("./SketchPresetColors");
var _sketchPresetColorsDefault = parcelHelpers.interopDefault(_sketchPresetColors);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var Sketch = function Sketch(_ref) {
    var width = _ref.width, rgb = _ref.rgb, hex = _ref.hex, hsv = _ref.hsv, hsl = _ref.hsl, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, disableAlpha = _ref.disableAlpha, presetColors = _ref.presetColors, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': _extends({
            picker: {
                width: width,
                padding: '10px 10px 0',
                boxSizing: 'initial',
                background: '#fff',
                borderRadius: '4px',
                boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
            },
            saturation: {
                width: '100%',
                paddingBottom: '75%',
                position: 'relative',
                overflow: 'hidden'
            },
            Saturation: {
                radius: '3px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            controls: {
                display: 'flex'
            },
            sliders: {
                padding: '4px 0',
                flex: '1'
            },
            color: {
                width: '24px',
                height: '24px',
                position: 'relative',
                marginTop: '4px',
                marginLeft: '4px',
                borderRadius: '3px'
            },
            activeColor: {
                absolute: '0px 0px 0px 0px',
                borderRadius: '2px',
                background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            hue: {
                position: 'relative',
                height: '10px',
                overflow: 'hidden'
            },
            Hue: {
                radius: '2px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            },
            alpha: {
                position: 'relative',
                height: '10px',
                marginTop: '4px',
                overflow: 'hidden'
            },
            Alpha: {
                radius: '2px',
                shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
            }
        }, passedStyles),
        'disableAlpha': {
            color: {
                height: '10px'
            },
            hue: {
                height: '10px'
            },
            alpha: {
                display: 'none'
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker,
        className: 'sketch-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.saturation
    }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.sliders
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        onChange: onChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.alpha
    }, (0, _reactDefault.default).createElement((0, _common.Alpha), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        renderers: renderers,
        onChange: onChange
    }))), (0, _reactDefault.default).createElement('div', {
        style: styles.color
    }, (0, _reactDefault.default).createElement((0, _common.Checkboard), null), (0, _reactDefault.default).createElement('div', {
        style: styles.activeColor
    }))), (0, _reactDefault.default).createElement((0, _sketchFieldsDefault.default), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        onChange: onChange,
        disableAlpha: disableAlpha
    }), (0, _reactDefault.default).createElement((0, _sketchPresetColorsDefault.default), {
        colors: presetColors,
        onClick: onChange,
        onSwatchHover: onSwatchHover
    }));
};
Sketch.propTypes = {
    disableAlpha: (0, _propTypesDefault.default).bool,
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    styles: (0, _propTypesDefault.default).object
};
Sketch.defaultProps = {
    disableAlpha: false,
    width: 200,
    styles: {},
    presetColors: [
        '#D0021B',
        '#F5A623',
        '#F8E71C',
        '#8B572A',
        '#7ED321',
        '#417505',
        '#BD10E0',
        '#9013FE',
        '#4A90E2',
        '#50E3C2',
        '#B8E986',
        '#000000',
        '#4A4A4A',
        '#9B9B9B',
        '#FFFFFF'
    ]
};
exports.default = (0, _common.ColorWrap)(Sketch);

},{"react":"6wC8C","prop-types":"6YTRF","reactcss":"7yqRl","lodash-es/merge":"4s9GK","../common":"gx5lJ","./SketchFields":"7hejH","./SketchPresetColors":"duzTh","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7hejH":[function(require,module,exports,__globalThis) {
/* eslint-disable no-param-reassign */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SketchFields", ()=>SketchFields);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var SketchFields = function SketchFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, disableAlpha = _ref.disableAlpha;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            fields: {
                display: 'flex',
                paddingTop: '4px'
            },
            single: {
                flex: '1',
                paddingLeft: '6px'
            },
            alpha: {
                flex: '1',
                paddingLeft: '6px'
            },
            double: {
                flex: '2'
            },
            input: {
                width: '80%',
                padding: '4px 10% 3px',
                border: 'none',
                boxShadow: 'inset 0 0 0 1px #ccc',
                fontSize: '11px'
            },
            label: {
                display: 'block',
                textAlign: 'center',
                fontSize: '11px',
                color: '#222',
                paddingTop: '3px',
                paddingBottom: '4px',
                textTransform: 'capitalize'
            }
        },
        'disableAlpha': {
            alpha: {
                display: 'none'
            }
        }
    }, {
        disableAlpha: disableAlpha
    });
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            a: rgb.a,
            source: 'rgb'
        }, e);
        else if (data.a) {
            if (data.a < 0) data.a = 0;
            else if (data.a > 100) data.a = 100;
            data.a /= 100;
            onChange({
                h: hsl.h,
                s: hsl.s,
                l: hsl.l,
                a: data.a,
                source: 'rgb'
            }, e);
        }
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.fields,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.double
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'hex',
        value: hex.replace('#', ''),
        onChange: handleChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'r',
        value: rgb.r,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'g',
        value: rgb.g,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'b',
        value: rgb.b,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.alpha
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'a',
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '100'
    })));
};
exports.default = SketchFields;

},{"react":"6wC8C","reactcss":"7yqRl","../../helpers/color":"dHnAt","../common":"gx5lJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"duzTh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SketchPresetColors", ()=>SketchPresetColors);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _common = require("../common");
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var SketchPresetColors = function SketchPresetColors(_ref) {
    var colors = _ref.colors, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            colors: {
                margin: '0 -10px',
                padding: '10px 0 0 10px',
                borderTop: '1px solid #eee',
                display: 'flex',
                flexWrap: 'wrap',
                position: 'relative'
            },
            swatchWrap: {
                width: '16px',
                height: '16px',
                margin: '0 10px 10px 0'
            },
            swatch: {
                borderRadius: '3px',
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
            }
        },
        'no-presets': {
            colors: {
                display: 'none'
            }
        }
    }, {
        'no-presets': !colors || !colors.length
    });
    var handleClick = function handleClick(hex, e) {
        onClick({
            hex: hex,
            source: 'hex'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.colors,
        className: 'flexbox-fix'
    }, colors.map(function(colorObjOrString) {
        var c = typeof colorObjOrString === 'string' ? {
            color: colorObjOrString
        } : colorObjOrString;
        var key = '' + c.color + (c.title || '');
        return (0, _reactDefault.default).createElement('div', {
            key: key,
            style: styles.swatchWrap
        }, (0, _reactDefault.default).createElement((0, _common.Swatch), _extends({}, c, {
            style: styles.swatch,
            onClick: handleClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
            }
        })));
    }));
};
SketchPresetColors.propTypes = {
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).shape({
            color: (0, _propTypesDefault.default).string,
            title: (0, _propTypesDefault.default).string
        })
    ])).isRequired
};
exports.default = SketchPresetColors;

},{"react":"6wC8C","prop-types":"6YTRF","reactcss":"7yqRl","../common":"gx5lJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4E9sB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Slider", ()=>Slider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _sliderSwatches = require("./SliderSwatches");
var _sliderSwatchesDefault = parcelHelpers.interopDefault(_sliderSwatches);
var _sliderPointer = require("./SliderPointer");
var _sliderPointerDefault = parcelHelpers.interopDefault(_sliderPointer);
var Slider = function Slider(_ref) {
    var hsl = _ref.hsl, onChange = _ref.onChange, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            hue: {
                height: '12px',
                position: 'relative'
            },
            Hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    return (0, _reactDefault.default).createElement('div', {
        style: styles.wrap || {},
        className: 'slider-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.swatches
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchesDefault.default), {
        hsl: hsl,
        onClick: onChange
    })));
};
Slider.propTypes = {
    styles: (0, _propTypesDefault.default).object
};
Slider.defaultProps = {
    pointer: (0, _sliderPointerDefault.default),
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Slider);

},{"react":"6wC8C","prop-types":"6YTRF","reactcss":"7yqRl","lodash-es/merge":"4s9GK","../common":"gx5lJ","./SliderSwatches":"89Sep","./SliderPointer":"AA7C9","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"89Sep":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderSwatches", ()=>SliderSwatches);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _sliderSwatch = require("./SliderSwatch");
var _sliderSwatchDefault = parcelHelpers.interopDefault(_sliderSwatch);
var SliderSwatches = function SliderSwatches(_ref) {
    var onClick = _ref.onClick, hsl = _ref.hsl;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            swatches: {
                marginTop: '20px'
            },
            swatch: {
                boxSizing: 'border-box',
                width: '20%',
                paddingRight: '1px',
                float: 'left'
            },
            clear: {
                clear: 'both'
            }
        }
    });
    // Acceptible difference in floating point equality
    var epsilon = 0.1;
    return (0, _reactDefault.default).createElement('div', {
        style: styles.swatches
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: '.80',
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: '.65',
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: '.50',
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: '.35',
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }, (0, _reactDefault.default).createElement((0, _sliderSwatchDefault.default), {
        hsl: hsl,
        offset: '.20',
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.clear
    }));
};
exports.default = SliderSwatches;

},{"react":"6wC8C","reactcss":"7yqRl","./SliderSwatch":"eKwuO","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"eKwuO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderSwatch", ()=>SliderSwatch);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var SliderSwatch = function SliderSwatch(_ref) {
    var hsl = _ref.hsl, offset = _ref.offset, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, active = _ref.active, first = _ref.first, last = _ref.last;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            swatch: {
                height: '12px',
                background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
                cursor: 'pointer'
            }
        },
        'first': {
            swatch: {
                borderRadius: '2px 0 0 2px'
            }
        },
        'last': {
            swatch: {
                borderRadius: '0 2px 2px 0'
            }
        },
        'active': {
            swatch: {
                transform: 'scaleY(1.8)',
                borderRadius: '3.6px/2px'
            }
        }
    }, {
        active: active,
        first: first,
        last: last
    });
    var handleClick = function handleClick(e) {
        return onClick({
            h: hsl.h,
            s: 0.5,
            l: offset,
            source: 'hsl'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.swatch,
        onClick: handleClick
    });
};
exports.default = SliderSwatch;

},{"react":"6wC8C","reactcss":"7yqRl","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"AA7C9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SliderPointer", ()=>SliderPointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var SliderPointer = function SliderPointer() {
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '14px',
                height: '14px',
                borderRadius: '6px',
                transform: 'translate(-7px, -1px)',
                backgroundColor: 'rgb(248, 248, 248)',
                boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
exports.default = SliderPointer;

},{"react":"6wC8C","reactcss":"7yqRl","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6MLRe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Swatches", ()=>Swatches);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _materialColors = require("material-colors");
var _common = require("../common");
var _swatchesGroup = require("./SwatchesGroup");
var _swatchesGroupDefault = parcelHelpers.interopDefault(_swatchesGroup);
var Swatches = function Swatches(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            picker: {
                width: width,
                height: height
            },
            overflow: {
                height: height,
                overflowY: 'scroll'
            },
            body: {
                padding: '16px 0 6px 16px'
            },
            clear: {
                clear: 'both'
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        return onChange({
            hex: data,
            source: 'hex'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker,
        className: 'swatches-picker ' + className
    }, (0, _reactDefault.default).createElement((0, _common.Raised), null, (0, _reactDefault.default).createElement('div', {
        style: styles.overflow
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.body
    }, (0, _mapDefault.default)(colors, function(group) {
        return (0, _reactDefault.default).createElement((0, _swatchesGroupDefault.default), {
            key: group.toString(),
            group: group,
            active: hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.clear
    })))));
};
Swatches.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    height: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)),
    styles: (0, _propTypesDefault.default).object
};
Swatches.defaultProps = {
    width: 320,
    height: 240,
    colors: [
        [
            _materialColors.red['900'],
            _materialColors.red['700'],
            _materialColors.red['500'],
            _materialColors.red['300'],
            _materialColors.red['100']
        ],
        [
            _materialColors.pink['900'],
            _materialColors.pink['700'],
            _materialColors.pink['500'],
            _materialColors.pink['300'],
            _materialColors.pink['100']
        ],
        [
            _materialColors.purple['900'],
            _materialColors.purple['700'],
            _materialColors.purple['500'],
            _materialColors.purple['300'],
            _materialColors.purple['100']
        ],
        [
            _materialColors.deepPurple['900'],
            _materialColors.deepPurple['700'],
            _materialColors.deepPurple['500'],
            _materialColors.deepPurple['300'],
            _materialColors.deepPurple['100']
        ],
        [
            _materialColors.indigo['900'],
            _materialColors.indigo['700'],
            _materialColors.indigo['500'],
            _materialColors.indigo['300'],
            _materialColors.indigo['100']
        ],
        [
            _materialColors.blue['900'],
            _materialColors.blue['700'],
            _materialColors.blue['500'],
            _materialColors.blue['300'],
            _materialColors.blue['100']
        ],
        [
            _materialColors.lightBlue['900'],
            _materialColors.lightBlue['700'],
            _materialColors.lightBlue['500'],
            _materialColors.lightBlue['300'],
            _materialColors.lightBlue['100']
        ],
        [
            _materialColors.cyan['900'],
            _materialColors.cyan['700'],
            _materialColors.cyan['500'],
            _materialColors.cyan['300'],
            _materialColors.cyan['100']
        ],
        [
            _materialColors.teal['900'],
            _materialColors.teal['700'],
            _materialColors.teal['500'],
            _materialColors.teal['300'],
            _materialColors.teal['100']
        ],
        [
            '#194D33',
            _materialColors.green['700'],
            _materialColors.green['500'],
            _materialColors.green['300'],
            _materialColors.green['100']
        ],
        [
            _materialColors.lightGreen['900'],
            _materialColors.lightGreen['700'],
            _materialColors.lightGreen['500'],
            _materialColors.lightGreen['300'],
            _materialColors.lightGreen['100']
        ],
        [
            _materialColors.lime['900'],
            _materialColors.lime['700'],
            _materialColors.lime['500'],
            _materialColors.lime['300'],
            _materialColors.lime['100']
        ],
        [
            _materialColors.yellow['900'],
            _materialColors.yellow['700'],
            _materialColors.yellow['500'],
            _materialColors.yellow['300'],
            _materialColors.yellow['100']
        ],
        [
            _materialColors.amber['900'],
            _materialColors.amber['700'],
            _materialColors.amber['500'],
            _materialColors.amber['300'],
            _materialColors.amber['100']
        ],
        [
            _materialColors.orange['900'],
            _materialColors.orange['700'],
            _materialColors.orange['500'],
            _materialColors.orange['300'],
            _materialColors.orange['100']
        ],
        [
            _materialColors.deepOrange['900'],
            _materialColors.deepOrange['700'],
            _materialColors.deepOrange['500'],
            _materialColors.deepOrange['300'],
            _materialColors.deepOrange['100']
        ],
        [
            _materialColors.brown['900'],
            _materialColors.brown['700'],
            _materialColors.brown['500'],
            _materialColors.brown['300'],
            _materialColors.brown['100']
        ],
        [
            _materialColors.blueGrey['900'],
            _materialColors.blueGrey['700'],
            _materialColors.blueGrey['500'],
            _materialColors.blueGrey['300'],
            _materialColors.blueGrey['100']
        ],
        [
            '#000000',
            '#525252',
            '#969696',
            '#D9D9D9',
            '#FFFFFF'
        ]
    ],
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Swatches);

},{"react":"6wC8C","prop-types":"6YTRF","reactcss":"7yqRl","lodash-es/map":"d8f0z","lodash-es/merge":"4s9GK","material-colors":"8RjDx","../common":"gx5lJ","./SwatchesGroup":"fZhtw","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fZhtw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwatchesGroup", ()=>SwatchesGroup);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _swatchesColor = require("./SwatchesColor");
var _swatchesColorDefault = parcelHelpers.interopDefault(_swatchesColor);
var SwatchesGroup = function SwatchesGroup(_ref) {
    var onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, group = _ref.group, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            group: {
                paddingBottom: '10px',
                width: '40px',
                float: 'left',
                marginRight: '10px'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.group
    }, (0, _mapDefault.default)(group, function(color, i) {
        return (0, _reactDefault.default).createElement((0, _swatchesColorDefault.default), {
            key: color,
            color: color,
            active: color.toLowerCase() === active,
            first: i === 0,
            last: i === group.length - 1,
            onClick: onClick,
            onSwatchHover: onSwatchHover
        });
    }));
};
exports.default = SwatchesGroup;

},{"react":"6wC8C","reactcss":"7yqRl","lodash-es/map":"d8f0z","./SwatchesColor":"hGyuC","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hGyuC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwatchesColor", ()=>SwatchesColor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var _checkIcon = require("@icons/material/CheckIcon");
var _checkIconDefault = parcelHelpers.interopDefault(_checkIcon);
var SwatchesColor = function SwatchesColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, first = _ref.first, last = _ref.last, active = _ref.active;
    var styles = (0, _reactcssDefault.default)({
        'default': {
            color: {
                width: '40px',
                height: '24px',
                cursor: 'pointer',
                background: color,
                marginBottom: '1px'
            },
            check: {
                color: _color.getContrastingColor(color),
                marginLeft: '8px',
                display: 'none'
            }
        },
        'first': {
            color: {
                overflow: 'hidden',
                borderRadius: '2px 2px 0 0'
            }
        },
        'last': {
            color: {
                overflow: 'hidden',
                borderRadius: '0 0 2px 2px'
            }
        },
        'active': {
            check: {
                display: 'block'
            }
        },
        'color-#FFFFFF': {
            color: {
                boxShadow: 'inset 0 0 0 1px #ddd'
            },
            check: {
                color: '#333'
            }
        },
        'transparent': {
            check: {
                color: '#333'
            }
        }
    }, {
        first: first,
        last: last,
        active: active,
        'color-#FFFFFF': color === '#FFFFFF',
        'transparent': color === 'transparent'
    });
    return (0, _reactDefault.default).createElement((0, _common.Swatch), {
        color: color,
        style: styles.color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: '0 0 4px ' + color
        }
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.check
    }, (0, _reactDefault.default).createElement((0, _checkIconDefault.default), null)));
};
exports.default = SwatchesColor;

},{"react":"6wC8C","reactcss":"7yqRl","../../helpers/color":"dHnAt","../common":"gx5lJ","@icons/material/CheckIcon":"iGcyv","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"iGcyv":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("b7292f2d749daff7");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var DEFAULT_SIZE = 24;
exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? 'currentColor' : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = _objectWithoutProperties(_ref, [
        'fill',
        'width',
        'height',
        'style'
    ]);
    return _react2.default.createElement('svg', _extends({
        viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
        style: _extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), _react2.default.createElement('path', {
        d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z'
    }));
};

},{"b7292f2d749daff7":"6wC8C"}],"botYY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Twitter", ()=>Twitter);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _map = require("lodash-es/map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _color = require("../../helpers/color");
var _common = require("../common");
var Twitter = function Twitter(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            card: {
                width: width,
                background: '#fff',
                border: '0 solid rgba(0,0,0,0.25)',
                boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
                borderRadius: '4px',
                position: 'relative'
            },
            body: {
                padding: '15px 9px 9px 15px'
            },
            label: {
                fontSize: '18px',
                color: '#fff'
            },
            triangle: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 9px 10px 9px',
                borderColor: 'transparent transparent #fff transparent',
                position: 'absolute'
            },
            triangleShadow: {
                width: '0px',
                height: '0px',
                borderStyle: 'solid',
                borderWidth: '0 9px 10px 9px',
                borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
                position: 'absolute'
            },
            hash: {
                background: '#F0F0F0',
                height: '30px',
                width: '30px',
                borderRadius: '4px 0 0 4px',
                float: 'left',
                color: '#98A1A4',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            },
            input: {
                width: '100px',
                fontSize: '14px',
                color: '#666',
                border: '0px',
                outline: 'none',
                height: '28px',
                boxShadow: 'inset 0 0 0 1px #F0F0F0',
                boxSizing: 'content-box',
                borderRadius: '0 4px 4px 0',
                float: 'left',
                paddingLeft: '8px'
            },
            swatch: {
                width: '30px',
                height: '30px',
                float: 'left',
                borderRadius: '4px',
                margin: '0 6px 6px 0'
            },
            clear: {
                clear: 'both'
            }
        },
        'hide-triangle': {
            triangle: {
                display: 'none'
            },
            triangleShadow: {
                display: 'none'
            }
        },
        'top-left-triangle': {
            triangle: {
                top: '-10px',
                left: '12px'
            },
            triangleShadow: {
                top: '-11px',
                left: '12px'
            }
        },
        'top-right-triangle': {
            triangle: {
                top: '-10px',
                right: '12px'
            },
            triangleShadow: {
                top: '-11px',
                right: '12px'
            }
        }
    }, passedStyles), {
        'hide-triangle': triangle === 'hide',
        'top-left-triangle': triangle === 'top-left',
        'top-right-triangle': triangle === 'top-right'
    });
    var handleChange = function handleChange(hexcode, e) {
        _color.isValidHex(hexcode) && onChange({
            hex: hexcode,
            source: 'hex'
        }, e);
    };
    return (0, _reactDefault.default).createElement('div', {
        style: styles.card,
        className: 'twitter-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.triangleShadow
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.triangle
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.body
    }, (0, _mapDefault.default)(colors, function(c, i) {
        return (0, _reactDefault.default).createElement((0, _common.Swatch), {
            key: i,
            color: c,
            hex: c,
            style: styles.swatch,
            onClick: handleChange,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: '0 0 4px ' + c
            }
        });
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.hash
    }, '#'), (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        label: null,
        style: {
            input: styles.input
        },
        value: hex.replace('#', ''),
        onChange: handleChange
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.clear
    })));
};
Twitter.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    triangle: (0, _propTypesDefault.default).oneOf([
        'hide',
        'top-left',
        'top-right'
    ]),
    colors: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    styles: (0, _propTypesDefault.default).object
};
Twitter.defaultProps = {
    width: 276,
    colors: [
        '#FF6900',
        '#FCB900',
        '#7BDCB5',
        '#00D084',
        '#8ED1FC',
        '#0693E3',
        '#ABB8C3',
        '#EB144C',
        '#F78DA7',
        '#9900EF'
    ],
    triangle: 'top-left',
    styles: {}
};
exports.default = (0, _common.ColorWrap)(Twitter);

},{"react":"6wC8C","prop-types":"6YTRF","reactcss":"7yqRl","lodash-es/map":"d8f0z","lodash-es/merge":"4s9GK","../../helpers/color":"dHnAt","../common":"gx5lJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kr9NJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Google", ()=>Google);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _merge = require("lodash-es/merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _common = require("../common");
var _googlePointerCircle = require("./GooglePointerCircle");
var _googlePointerCircleDefault = parcelHelpers.interopDefault(_googlePointerCircle);
var _googlePointer = require("./GooglePointer");
var _googlePointerDefault = parcelHelpers.interopDefault(_googlePointer);
var _googleFields = require("./GoogleFields");
var _googleFieldsDefault = parcelHelpers.interopDefault(_googleFields);
var Google = function Google(_ref) {
    var width = _ref.width, onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, header = _ref.header, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? '' : _ref$className;
    var styles = (0, _reactcssDefault.default)((0, _mergeDefault.default)({
        'default': {
            picker: {
                width: width,
                background: '#fff',
                border: '1px solid #dfe1e5',
                boxSizing: 'initial',
                display: 'flex',
                flexWrap: 'wrap',
                borderRadius: '8px 8px 0px 0px'
            },
            head: {
                height: '57px',
                width: '100%',
                paddingTop: '16px',
                paddingBottom: '16px',
                paddingLeft: '16px',
                fontSize: '20px',
                boxSizing: 'border-box',
                fontFamily: 'Roboto-Regular,HelveticaNeue,Arial,sans-serif'
            },
            saturation: {
                width: '70%',
                padding: '0px',
                position: 'relative',
                overflow: 'hidden'
            },
            swatch: {
                width: '30%',
                height: '228px',
                padding: '0px',
                background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 1)',
                position: 'relative',
                overflow: 'hidden'
            },
            body: {
                margin: 'auto',
                width: '95%'
            },
            controls: {
                display: 'flex',
                boxSizing: 'border-box',
                height: '52px',
                paddingTop: '22px'
            },
            color: {
                width: '32px'
            },
            hue: {
                height: '8px',
                position: 'relative',
                margin: '0px 16px 0px 16px',
                width: '100%'
            },
            Hue: {
                radius: '2px'
            }
        }
    }, passedStyles));
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker,
        className: 'google-picker ' + className
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.head
    }, header), (0, _reactDefault.default).createElement('div', {
        style: styles.swatch
    }), (0, _reactDefault.default).createElement('div', {
        style: styles.saturation
    }, (0, _reactDefault.default).createElement((0, _common.Saturation), {
        hsl: hsl,
        hsv: hsv,
        pointer: (0, _googlePointerCircleDefault.default),
        onChange: onChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.body
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.controls,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.hue
    }, (0, _reactDefault.default).createElement((0, _common.Hue), {
        style: styles.Hue,
        hsl: hsl,
        radius: '4px',
        pointer: (0, _googlePointerDefault.default),
        onChange: onChange
    }))), (0, _reactDefault.default).createElement((0, _googleFieldsDefault.default), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
    })));
};
Google.propTypes = {
    width: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number
    ]),
    styles: (0, _propTypesDefault.default).object,
    header: (0, _propTypesDefault.default).string
};
Google.defaultProps = {
    width: 652,
    styles: {},
    header: 'Color picker'
};
exports.default = (0, _common.ColorWrap)(Google);

},{"react":"6wC8C","prop-types":"6YTRF","reactcss":"7yqRl","lodash-es/merge":"4s9GK","../common":"gx5lJ","./GooglePointerCircle":"9W3Mo","./GooglePointer":"eTk5G","./GoogleFields":"aJfbB","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9W3Mo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GooglePointerCircle", ()=>GooglePointerCircle);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var GooglePointerCircle = function GooglePointerCircle(props) {
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '20px',
                height: '20px',
                borderRadius: '22px',
                border: '2px #fff solid',
                transform: 'translate(-12px, -13px)',
                background: 'hsl(' + Math.round(props.hsl.h) + ', ' + Math.round(props.hsl.s * 100) + '%, ' + Math.round(props.hsl.l * 100) + '%)'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
GooglePointerCircle.propTypes = {
    hsl: (0, _propTypesDefault.default).shape({
        h: (0, _propTypesDefault.default).number,
        s: (0, _propTypesDefault.default).number,
        l: (0, _propTypesDefault.default).number,
        a: (0, _propTypesDefault.default).number
    })
};
GooglePointerCircle.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
exports.default = GooglePointerCircle;

},{"react":"6wC8C","reactcss":"7yqRl","prop-types":"6YTRF","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"eTk5G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GooglePointer", ()=>GooglePointer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var GooglePointer = function GooglePointer(props) {
    var styles = (0, _reactcssDefault.default)({
        'default': {
            picker: {
                width: '20px',
                height: '20px',
                borderRadius: '22px',
                transform: 'translate(-10px, -7px)',
                background: 'hsl(' + Math.round(props.hsl.h) + ', 100%, 50%)',
                border: '2px white solid'
            }
        }
    });
    return (0, _reactDefault.default).createElement('div', {
        style: styles.picker
    });
};
GooglePointer.propTypes = {
    hsl: (0, _propTypesDefault.default).shape({
        h: (0, _propTypesDefault.default).number,
        s: (0, _propTypesDefault.default).number,
        l: (0, _propTypesDefault.default).number,
        a: (0, _propTypesDefault.default).number
    })
};
GooglePointer.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
exports.default = GooglePointer;

},{"react":"6wC8C","reactcss":"7yqRl","prop-types":"6YTRF","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"aJfbB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GoogleFields", ()=>GoogleFields);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactcss = require("reactcss");
var _reactcssDefault = parcelHelpers.interopDefault(_reactcss);
var _color = require("../../helpers/color");
var _common = require("../common");
var GoogleFields = function GoogleFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, hsv = _ref.hsv;
    var handleChange = function handleChange(data, e) {
        if (data.hex) _color.isValidHex(data.hex) && onChange({
            hex: data.hex,
            source: 'hex'
        }, e);
        else if (data.rgb) {
            var values = data.rgb.split(',');
            _color.isvalidColorString(data.rgb, 'rgb') && onChange({
                r: values[0],
                g: values[1],
                b: values[2],
                a: 1,
                source: 'rgb'
            }, e);
        } else if (data.hsv) {
            var _values = data.hsv.split(',');
            if (_color.isvalidColorString(data.hsv, 'hsv')) {
                _values[2] = _values[2].replace('%', '');
                _values[1] = _values[1].replace('%', '');
                _values[0] = _values[0].replace("\xb0", '');
                if (_values[1] == 1) _values[1] = 0.01;
                else if (_values[2] == 1) _values[2] = 0.01;
                onChange({
                    h: Number(_values[0]),
                    s: Number(_values[1]),
                    v: Number(_values[2]),
                    source: 'hsv'
                }, e);
            }
        } else if (data.hsl) {
            var _values2 = data.hsl.split(',');
            if (_color.isvalidColorString(data.hsl, 'hsl')) {
                _values2[2] = _values2[2].replace('%', '');
                _values2[1] = _values2[1].replace('%', '');
                _values2[0] = _values2[0].replace("\xb0", '');
                if (hsvValue[1] == 1) hsvValue[1] = 0.01;
                else if (hsvValue[2] == 1) hsvValue[2] = 0.01;
                onChange({
                    h: Number(_values2[0]),
                    s: Number(_values2[1]),
                    v: Number(_values2[2]),
                    source: 'hsl'
                }, e);
            }
        }
    };
    var styles = (0, _reactcssDefault.default)({
        'default': {
            wrap: {
                display: 'flex',
                height: '100px',
                marginTop: '4px'
            },
            fields: {
                width: '100%'
            },
            column: {
                paddingTop: '10px',
                display: 'flex',
                justifyContent: 'space-between'
            },
            double: {
                padding: '0px 4.4px',
                boxSizing: 'border-box'
            },
            input: {
                width: '100%',
                height: '38px',
                boxSizing: 'border-box',
                padding: '4px 10% 3px',
                textAlign: 'center',
                border: '1px solid #dadce0',
                fontSize: '11px',
                textTransform: 'lowercase',
                borderRadius: '5px',
                outline: 'none',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            input2: {
                height: '38px',
                width: '100%',
                border: '1px solid #dadce0',
                boxSizing: 'border-box',
                fontSize: '11px',
                textTransform: 'lowercase',
                borderRadius: '5px',
                outline: 'none',
                paddingLeft: '10px',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            label: {
                textAlign: 'center',
                fontSize: '12px',
                background: '#fff',
                position: 'absolute',
                textTransform: 'uppercase',
                color: '#3c4043',
                width: '35px',
                top: '-6px',
                left: '0',
                right: '0',
                marginLeft: 'auto',
                marginRight: 'auto',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            label2: {
                left: '10px',
                textAlign: 'center',
                fontSize: '12px',
                background: '#fff',
                position: 'absolute',
                textTransform: 'uppercase',
                color: '#3c4043',
                width: '32px',
                top: '-6px',
                fontFamily: 'Roboto,Arial,sans-serif'
            },
            single: {
                flexGrow: '1',
                margin: '0px 4.4px'
            }
        }
    });
    var rgbValue = rgb.r + ', ' + rgb.g + ', ' + rgb.b;
    var hslValue = Math.round(hsl.h) + '\xB0, ' + Math.round(hsl.s * 100) + '%, ' + Math.round(hsl.l * 100) + '%';
    var hsvValue = Math.round(hsv.h) + '\xB0, ' + Math.round(hsv.s * 100) + '%, ' + Math.round(hsv.v * 100) + '%';
    return (0, _reactDefault.default).createElement('div', {
        style: styles.wrap,
        className: 'flexbox-fix'
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.fields
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.double
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: 'hex',
        value: hex,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.column
    }, (0, _reactDefault.default).createElement('div', {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'rgb',
        value: rgbValue,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'hsv',
        value: hsvValue,
        onChange: handleChange
    })), (0, _reactDefault.default).createElement('div', {
        style: styles.single
    }, (0, _reactDefault.default).createElement((0, _common.EditableInput), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: 'hsl',
        value: hslValue,
        onChange: handleChange
    })))));
};
exports.default = GoogleFields;

},{"react":"6wC8C","reactcss":"7yqRl","../../helpers/color":"dHnAt","../common":"gx5lJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"eNeLi":[function(require,module,exports,__globalThis) {
// This hook manages the focus state for a component. When mounted/displayed,
// the component will be tracked as focused, and when the user clicks outside
// of the component, it will be unfocused, and trigger a callback (e.g. to hide
// it). Example would be a dropdown menu etc
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const useFocusComponent = (callback)=>{
    // Create a ref to hold the reference to the component
    const componentRef = (0, _react.useRef)(null);
    // Local state to manage the focused state of the component
    const [isFocused, setIsFocused] = (0, _react.useState)(false);
    // Callback to handle outside clicks and trigger the provided callback
    const doOutsideClick = (0, _react.useCallback)((event)=>{
        // Check if the component is focused and if the click is outside the component
        if (isFocused && componentRef.current && document.body.contains(event.target) && !componentRef.current.contains(event.target) && componentRef.current !== event.target) {
            // Trigger the provided callback on an outside click
            callback === null || callback === void 0 ? void 0 : callback();
            // Set the focused state to false when clicking outside the component
            setIsFocused(false);
        }
    }, [
        isFocused,
        callback
    ]);
    (0, _react.useEffect)(()=>{
        // Event listener for outside clicks
        const handleOutsideClick = (event)=>{
            doOutsideClick(event);
        };
        // Add event listener only when the component is focused
        if (isFocused) document.body.addEventListener("click", handleOutsideClick);
        // Cleanup: remove the event listener when the component unmounts or loses focus
        return ()=>{
            document.body.removeEventListener("click", handleOutsideClick);
        };
    }, [
        doOutsideClick,
        isFocused
    ]);
    // Function to set the focused state to true
    const setFocused = ()=>{
        setIsFocused(true);
    };
    // Return an object with the componentRef and a function to set the focused state
    return {
        ref: componentRef,
        setFocused
    };
};
exports.default = useFocusComponent;

},{"react":"6wC8C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"i3epP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _select = require("./select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _useStore = require("../hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
var _useFetchAbsenceTrackingCategories = require("../hooks/fetch/useFetchAbsenceTrackingCategories");
const AbsenceTypePicker = ({ name, value, onChange, onBlur, disabled })=>{
    const account = (0, _useStoreDefault.default)((state)=>state.clientRef);
    const { data: categories = [] } = (0, _useFetchAbsenceTrackingCategories.useFetchAbsenceTrackingCategories)({
        account
    });
    const id = (0, _react.useRef)(`absence-type-${Math.random().toString(36).slice(2)}`).current;
    const options = categories.map(({ ref, label, colour })=>({
            value: ref,
            label,
            colour
        }));
    const values = [
        {
            label: "Holiday",
            value: "holiday"
        },
        {
            label: "Sickness",
            value: "sickness"
        },
        {
            label: "Family",
            value: "family"
        },
        {
            label: "Other",
            value: "other"
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "absence-type-picker",
                children: values.map((type)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                        htmlFor: `${id}-${type.value}`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "button-link radio",
                                "data-disabled": disabled,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "radio",
                                        id: `${id}-${type.value}`,
                                        name: `${name}-${id}`,
                                        value: type.value,
                                        checked: type.value === value,
                                        disabled: disabled,
                                        onChange: ()=>onChange(type.value),
                                        onBlur: onBlur
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                        width: "28",
                                        height: "28",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        "aria-hidden": "true",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: "12",
                                                cy: "12",
                                                r: "10"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: "12",
                                                cy: "12",
                                                r: "5",
                                                className: "radio-button",
                                                fill: "currentColor"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            type.label
                        ]
                    }, type.value))
            }),
            options.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "absence-type-picker--more",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: `${id}-more`,
                        children: "More:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                        inputId: `${id}-more`,
                        className: "select",
                        options: options,
                        value: options.find((option)=>option.value === value) || null,
                        onChange: (option)=>onChange(option.value),
                        onBlur: onBlur,
                        isDisabled: disabled,
                        isClearable: false,
                        placeholder: "Choose a tracking category",
                        menuPlacement: "auto",
                        menuPortalTarget: document.body,
                        styles: {
                            menuPortal: (base)=>({
                                    ...base,
                                    zIndex: 60
                                })
                        },
                        formatOptionLabel: (option)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "absence-type-picker--option",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "absence-type-picker--dot",
                                        style: {
                                            backgroundColor: option.colour
                                        },
                                        "aria-hidden": "true"
                                    }),
                                    option.label
                                ]
                            })
                    })
                ]
            })
        ]
    });
};
exports.default = AbsenceTypePicker;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","./select":"585wy","../hooks/useStore":"l1Yj7","../hooks/fetch/useFetchAbsenceTrackingCategories":"flNki","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"flNki":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFetchAbsenceTrackingCategories", ()=>useFetchAbsenceTrackingCategories);
parcelHelpers.export(exports, "useSaveAbsenceTrackingCategory", ()=>useSaveAbsenceTrackingCategory);
parcelHelpers.export(exports, "useDeleteAbsenceTrackingCategory", ()=>useDeleteAbsenceTrackingCategory);
var _reactQuery = require("react-query");
var _fetch = require("../../../utilities/fetch");
const url = "/config/absenceTrackingCategories";
const useFetchAbsenceTrackingCategories = ({ account })=>(0, _reactQuery.useQuery)([
        "absenceTrackingCategories",
        account
    ], ()=>(0, _fetch.request)({
            url,
            params: {
                account
            }
        }), {
        select: (response)=>(response === null || response === void 0 ? void 0 : response.data) || [],
        staleTime: 300000
    });
const useSaveAbsenceTrackingCategory = ({ account })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)(({ ref, label, colour })=>(0, _fetch.request)({
            url: ref ? `${url}/${encodeURIComponent(ref)}` : url,
            method: ref ? "patch" : "post",
            params: {
                account
            },
            data: {
                label,
                colour
            }
        }), {
        onSuccess: ()=>{
            queryClient.invalidateQueries([
                "absenceTrackingCategories",
                account
            ]);
            queryClient.invalidateQueries([
                "config",
                account
            ]);
        }
    });
};
const useDeleteAbsenceTrackingCategory = ({ account })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((ref)=>(0, _fetch.request)({
            url: `${url}/${encodeURIComponent(ref)}`,
            method: "delete",
            params: {
                account
            }
        }), {
        onSuccess: ()=>{
            queryClient.invalidateQueries([
                "absenceTrackingCategories",
                account
            ]);
            queryClient.invalidateQueries([
                "config",
                account
            ]);
        }
    });
};

},{"react-query":"41hyj","../../../utilities/fetch":"hAKRo","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"iVM6N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useFetchUsers = require("../hooks/fetch/useFetchUsers");
var _useStore = require("../hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
var _radioFormInputs = require("./radioFormInputs");
var _radioFormInputsDefault = parcelHelpers.interopDefault(_radioFormInputs);
const PeriodOverride = /*#__PURE__*/ (0, _react.forwardRef)(function PeriodOverride({ id, disabled, value, onChange, onBlur }, ref) {
    var _user_employment, _user_employment1;
    const { value: period, userId, unit } = value || {};
    const clientRef = (0, _useStoreDefault.default)((state)=>state.clientRef);
    const { data: user } = (0, _useFetchUsers.useFetchUser)({
        account: clientRef,
        userId
    });
    const defaultUnit = (user === null || user === void 0 ? void 0 : (_user_employment = user.employment) === null || _user_employment === void 0 ? void 0 : _user_employment.calcDaysHours) || ((user === null || user === void 0 ? void 0 : (_user_employment1 = user.employment) === null || _user_employment1 === void 0 ? void 0 : _user_employment1.type) === "Part time" ? "hours" : "days");
    const selectedUnit = unit || defaultUnit;
    // Persist the employee's default for new and legacy absences once loaded.
    (0, _react.useEffect)(()=>{
        if (!unit && user && onChange) onChange({
            ...value,
            unit: defaultUnit
        });
    }, [
        unit,
        user,
        defaultUnit,
        value,
        onChange
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: id,
                children: "Allocate a specific period to this absence"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                ref: ref,
                id: id,
                type: "number",
                min: "0",
                step: 0.1,
                disabled: disabled,
                value: period !== null && period !== void 0 ? period : "",
                onBlur: onBlur,
                onChange: (e)=>onChange({
                        ...value,
                        value: e.target.value
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                role: "group",
                "aria-label": "Period unit",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioFormInputsDefault.default), {
                    name: `${id}-unit`,
                    label: "Period unit",
                    value: selectedUnit,
                    options: [
                        {
                            label: "Days",
                            value: "days"
                        },
                        {
                            label: "Hours",
                            value: "hours"
                        }
                    ],
                    disabled: disabled || !unit && !user,
                    register: ()=>({
                            onBlur
                        }),
                    validation: ()=>({}),
                    onChange: (_event, unit)=>onChange({
                            ...value,
                            unit
                        })
                })
            })
        ]
    });
});
exports.default = PeriodOverride;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","../hooks/fetch/useFetchUsers":"4DurT","../hooks/useStore":"l1Yj7","./radioFormInputs":"caW72","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"cUp8u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _tickbox = require("./tickbox");
var _tickboxDefault = parcelHelpers.interopDefault(_tickbox);
const days = [
    {
        key: "1",
        label: "Mon"
    },
    {
        key: "2",
        label: "Tue"
    },
    {
        key: "3",
        label: "Wed"
    },
    {
        key: "4",
        label: "Thu"
    },
    {
        key: "5",
        label: "Fri"
    },
    {
        key: "6",
        label: "Sat"
    },
    {
        key: "7",
        label: "Sun"
    }
];
const emptyDay = {
    startTime: "",
    breaksQty: null,
    finishTime: "",
    dayTotalHours: null
};
const isValidTime = (value)=>/^([01]\d|2[0-3]):([0-5]\d)$/.test(value || "");
const minutesFromTime = (value)=>{
    if (!isValidTime(value)) return null;
    const [hours, minutes] = value.split(":").map((part)=>parseInt(part, 10));
    return hours * 60 + minutes;
};
const calculateDayTotalHours = (startTime, finishTime, breaksQty, breaksPaid)=>{
    const startMinutes = minutesFromTime(startTime);
    const finishMinutes = minutesFromTime(finishTime);
    if (startMinutes === null || finishMinutes === null) return null;
    if (finishMinutes <= startMinutes) return null;
    const breakHours = !breaksPaid && typeof breaksQty === "number" ? breaksQty : 0;
    const hours = Math.max((finishMinutes - startMinutes) / 60 - breakHours, 0);
    return parseFloat(hours.toFixed(2));
};
const normaliseMatrix = (value, breaksPaid)=>{
    const source = value && typeof value === "object" ? value : {};
    const matrix = {};
    days.forEach((day)=>{
        const dayValue = source[day.key] || {};
        const startTime = dayValue.startTime || "";
        const finishTime = dayValue.finishTime || "";
        const breaksQty = dayValue.breaksQty === 0 ? 0 : dayValue.breaksQty ? parseFloat(dayValue.breaksQty) : null;
        matrix[day.key] = {
            startTime,
            breaksQty,
            finishTime,
            dayTotalHours: calculateDayTotalHours(startTime, finishTime, breaksQty, breaksPaid)
        };
    });
    return matrix;
};
const WorkPatternSpecificsMatrix = ({ name, value, setValue, disabled, onKeyDown, breaksPaidName, breaksPaidValue })=>{
    const [breaksPaid, setBreaksPaid] = (0, _react.useState)(!!breaksPaidValue);
    const initialMatrix = (0, _react.useMemo)(()=>normaliseMatrix(value, breaksPaid), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        value
    ]);
    const [matrix, setMatrix] = (0, _react.useState)(initialMatrix);
    const weeklyTotalHours = (0, _react.useMemo)(()=>{
        return Object.values(matrix).reduce((total, day)=>{
            const hours = typeof (day === null || day === void 0 ? void 0 : day.dayTotalHours) === "number" ? day.dayTotalHours : 0;
            return total + hours;
        }, 0);
    }, [
        matrix
    ]);
    (0, _react.useEffect)(()=>{
        setMatrix(initialMatrix);
        setValue(name, initialMatrix);
    }, [
        initialMatrix,
        name,
        setValue
    ]);
    (0, _react.useEffect)(()=>{
        setBreaksPaid(!!breaksPaidValue);
    }, [
        breaksPaidValue
    ]);
    (0, _react.useEffect)(()=>{
        if (breaksPaidName) setValue(breaksPaidName, breaksPaid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        breaksPaid,
        breaksPaidName
    ]);
    const updateDay = (dayKey, change)=>{
        const current = matrix[dayKey] || emptyDay;
        const nextDay = {
            ...current,
            ...change
        };
        nextDay.dayTotalHours = calculateDayTotalHours(nextDay.startTime, nextDay.finishTime, nextDay.breaksQty, breaksPaid);
        const nextMatrix = {
            ...matrix,
            [dayKey]: nextDay
        };
        setMatrix(nextMatrix);
        setValue(name, nextMatrix);
    };
    const onBreaksPaidChange = (checked)=>{
        setBreaksPaid(checked);
        const nextMatrix = {};
        Object.keys(matrix).forEach((dayKey)=>{
            const current = matrix[dayKey] || emptyDay;
            nextMatrix[dayKey] = {
                ...current,
                dayTotalHours: calculateDayTotalHours(current.startTime, current.finishTime, current.breaksQty, checked)
            };
        });
        setMatrix(nextMatrix);
        setValue(name, nextMatrix);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "work-pattern-matrix-info",
                role: "note",
                children: "Changes to these work pattern details may affect holiday calculations."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "work-pattern-matrix-breaks-paid",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tickboxDefault.default), {
                        id: `${name}-breaks-paid`,
                        name: breaksPaidName || `${name}-breaks-paid`,
                        checked: breaksPaid,
                        disabled: disabled,
                        trigger: breaksPaid,
                        onKeyDown: onKeyDown,
                        onChange: (checked)=>onBreaksPaidChange(checked)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: `${name}-breaks-paid`,
                        children: "Breaks paid (not deducted from total hours)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "work-pattern-matrix",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        children: "Day"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        children: "Start"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        children: "Breaks (hours)"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        children: "Finish"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                        children: "Total hours"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                            children: days.map((day)=>{
                                const row = matrix[day.key] || emptyDay;
                                var _row_breaksQty, _row_dayTotalHours;
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                            children: day.label
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "time",
                                                value: row.startTime || "",
                                                disabled: disabled,
                                                onKeyDown: onKeyDown,
                                                onChange: (e)=>{
                                                    updateDay(day.key, {
                                                        startTime: e.target.value || ""
                                                    });
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "number",
                                                min: "0",
                                                max: "24",
                                                step: "0.5",
                                                value: (_row_breaksQty = row.breaksQty) !== null && _row_breaksQty !== void 0 ? _row_breaksQty : "",
                                                disabled: disabled,
                                                onKeyDown: onKeyDown,
                                                onChange: (e)=>{
                                                    const parsed = parseFloat(e.target.value);
                                                    updateDay(day.key, {
                                                        breaksQty: Number.isNaN(parsed) ? null : parsed
                                                    });
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "time",
                                                value: row.finishTime || "",
                                                disabled: disabled,
                                                onKeyDown: onKeyDown,
                                                onChange: (e)=>{
                                                    updateDay(day.key, {
                                                        finishTime: e.target.value || ""
                                                    });
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: (_row_dayTotalHours = row.dayTotalHours) !== null && _row_dayTotalHours !== void 0 ? _row_dayTotalHours : "-"
                                            })
                                        })
                                    ]
                                }, day.key);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "work-pattern-matrix-total",
                children: [
                    "Total weekly hours: ",
                    weeklyTotalHours.toFixed(2)
                ]
            })
        ]
    });
};
exports.default = WorkPatternSpecificsMatrix;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","./tickbox":"aNE2q","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3oijc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const fieldConfig = [
    {
        key: "newRate",
        label: "New Rate",
        name: "employment--newRate",
        type: "number"
    },
    {
        key: "newRateEffectiveDate",
        label: "Effective Date",
        name: "employment--newRateEffectiveDate",
        type: "date"
    },
    {
        key: "bonusOrAddition",
        label: "Bonus or Addition",
        name: "employment--bonusOrAddition",
        type: "number"
    },
    {
        key: "bonusOrAdditionEffectiveDate",
        label: "Effective Date",
        name: "employment--bonusOrAdditionEffectiveDate",
        type: "date"
    }
];
const getFieldValue = (field, getValues, fallback = "")=>{
    const value = getValues === null || getValues === void 0 ? void 0 : getValues(field.name);
    const resolvedValue = value === null || typeof value === "undefined" ? field.default : value;
    if (resolvedValue === null || typeof resolvedValue === "undefined") return fallback;
    if (field.type === "date" && typeof resolvedValue === "string") return resolvedValue.substring(0, 10);
    return resolvedValue;
};
const PayReviewMatrix = ({ item, getValues, setValue, disabled, onKeyDown })=>{
    var _item_fields;
    const fields = (item === null || item === void 0 ? void 0 : (_item_fields = item.fields) === null || _item_fields === void 0 ? void 0 : _item_fields.length) ? item.fields : fieldConfig;
    const initialValueMap = (0, _react.useMemo)(()=>{
        return Object.fromEntries(fields.map((field)=>{
            var _field_default;
            return [
                field.name,
                getFieldValue(field, getValues, (_field_default = field.default) !== null && _field_default !== void 0 ? _field_default : "")
            ];
        }));
    }, [
        fields,
        getValues
    ]);
    const [valueMap, setValueMap] = (0, _react.useState)(initialValueMap);
    (0, _react.useEffect)(()=>{
        setValueMap(initialValueMap);
    }, [
        initialValueMap
    ]);
    const updateField = (fieldName, rawValue)=>{
        if (!fieldName) return;
        let nextValue = rawValue;
        if (rawValue === "") nextValue = "";
        else if (fieldName.includes("EffectiveDate")) nextValue = rawValue;
        else {
            const parsed = parseFloat(rawValue);
            nextValue = rawValue === "" || Number.isNaN(parsed) ? "" : parsed;
        }
        setValueMap((current)=>({
                ...current,
                [fieldName]: nextValue
            }));
        setValue(fieldName, nextValue);
    };
    const handleKeyDown = (e)=>{
        if (e.key === "Enter" || e.key === "Tab") {
            e.stopPropagation();
            return;
        }
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "pay-review-matrix pay-review-matrix--full-width",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "pay-review-matrix__grid",
            children: fields.map((field)=>{
                var _valueMap_field_name;
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "pay-review-matrix__cell",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            className: "pay-review-matrix__label",
                            children: field.label
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: field.type,
                            min: field.type === "number" ? "0" : undefined,
                            step: field.type === "number" ? "0.01" : undefined,
                            value: (_valueMap_field_name = valueMap[field.name]) !== null && _valueMap_field_name !== void 0 ? _valueMap_field_name : "",
                            disabled: disabled,
                            onKeyDown: handleKeyDown,
                            onChange: (e)=>updateField(field.name, e.target.value)
                        })
                    ]
                }, field.name);
            })
        })
    });
};
exports.default = PayReviewMatrix;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6NoBQ":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("6c1162c7863b91cc")(module.bundle.resolve("7K9xZ")),
    module.bundle.load("hrkRR")
]).then(()=>module.bundle.root('cgCiN'));

},{"6c1162c7863b91cc":"efVvj"}],"c6jrG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _akarIcons = require("akar-icons");
var _utilities = require("../../utilities");
var _utilitiesDefault = parcelHelpers.interopDefault(_utilities);
const EditableText = ({ value: initValue, truncate, split = 0, onSave, showEditIcon = true })=>{
    const [editing, setEditing] = (0, _react.useState)(false);
    const [value, setValue] = (0, _react.useState)(initValue);
    (0, _react.useEffect)(()=>{
        setValue(initValue);
    }, [
        initValue
    ]);
    const doToggleEditing = (editing)=>{
        setEditing = editing;
    };
    const doInputChange = (e)=>{
        setValue(e.target.value);
    };
    const doKeyPress = (e)=>{
        if (e.key === "Enter") doSaveChanges();
    };
    const doSaveChanges = ()=>{
        setEditing(false);
        onSave && onSave(value);
    };
    const truncatedValue = truncate && (0, _utilitiesDefault.default).truncateString(value, truncate, split) || value;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "editable-text",
        children: editing ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "text",
                autoFocus: true,
                defaultValue: value,
                onBlur: doSaveChanges,
                onChange: doInputChange,
                onKeyDown: doKeyPress,
                onFocus: (e)=>{
                    e.target.select();
                }
            })
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    onClick: ()=>{
                        setEditing(true);
                    },
                    children: truncatedValue
                }),
                showEditIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.Pencil), {
                    size: 16
                })
            ]
        })
    });
};
exports.default = EditableText;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","akar-icons":"b8xdj","../../utilities":"fkdv9","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fo5oH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _akarIcons = require("akar-icons");
var _confirmdialog = require("primereact/confirmdialog");
var _formItemEdit = require("./formItemEdit");
var _formItemEditDefault = parcelHelpers.interopDefault(_formItemEdit);
var _useFetchForms = require("../../hooks/fetch/useFetchForms");
var _useStore = require("../../hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
const FormEditIcons = ({ fieldId, formId, formSections: formSectionsInit, onSetSections, onBusy, onCompleted })=>{
    const [action, setAction] = (0, _react.useState)();
    const pathParts = (0, _useStoreDefault.default)((state)=>state.getPathParts());
    const account = pathParts[0];
    const formSections = Array.isArray(formSectionsInit) && [
        ...formSectionsInit
    ] || [];
    const { mutate: deleteField } = (0, _useFetchForms.useDeleteFormField)({
        account
    });
    const { mutate: editForm, isLoading: isSaving } = (0, _useFetchForms.useUpdateForm)({
        account
    });
    const { mutate: createField, isLoading: isCreating } = (0, _useFetchForms.useCreateFormField)({
        account,
        callback: doInsertCallback
    });
    const isBusy = !!(isCreating || isSaving);
    (0, _react.useEffect)(()=>{
        isBusy ? onBusy && onBusy() : onCompleted && onCompleted();
    }, [
        isBusy
    ]);
    function getField(name) {
        let foundParentObject = null;
        let foundObject = null;
        let foundIndex = -1;
        let foundParentIndex = -1;
        formSections.find((section, parentIndex)=>{
            foundIndex = section.items.findIndex((item)=>item.name === name);
            if (foundIndex !== -1) {
                foundParentObject = section;
                foundObject = section.items[foundIndex];
                foundParentIndex = parentIndex;
                return true;
            }
            return false;
        });
        return {
            parentObject: foundParentObject,
            object: foundObject,
            parentIndex: foundParentIndex,
            index: foundIndex
        };
    }
    const field = getField(fieldId);
    const doEdit = ()=>{
        setAction("edit");
    };
    const doEditUpdate = (fieldObj)=>{
        if (field) {
            field.parentObject.items.splice(field.index, 1, fieldObj);
            onSetSections([
                ...formSections
            ]);
        }
    };
    const doDelete = ()=>{
        (0, _confirmdialog.confirmDialog)({
            message: "Are you sure you wish to delete this form field?",
            accept: ()=>{
                if (field) {
                    deleteField(fieldId);
                    field.parentObject.items.splice(field.index, 1);
                    if (field.parentObject.items.length === 0) formSections.splice(field.parentIndex, 1);
                    onSetSections([
                        ...formSections
                    ]);
                }
            },
            className: "confirm-dialog",
            acceptClassName: "button",
            rejectClassName: "button button__invert"
        });
    };
    const doInsert = ()=>{
        const newField = {
            label: "New Field",
            type: "text",
            required: false
        };
        createField({
            id: formId,
            afterId: fieldId,
            ...newField
        });
    };
    function doInsertCallback(data) {
        var _data_data;
        const currentFieldIndex = Array.isArray(data === null || data === void 0 ? void 0 : data.data) && (data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.findIndex((item)=>item.fieldId === fieldId));
        if (currentFieldIndex > -1) {
            const newItem = data === null || data === void 0 ? void 0 : data.data[currentFieldIndex + 1];
            if (newItem) {
                newItem.name = newItem.fieldId;
                const newSection = {
                    items: [
                        {
                            ...newItem
                        }
                    ]
                };
                formSections.splice(field.parentIndex + 1, 1, newSection);
                onSetSections([
                    ...formSections
                ]);
            }
        }
    }
    const doMove = (direction = "up")=>{
        if (field) {
            let newIndex = direction === "up" ? field.parentIndex - 1 : field.parentIndex + 1;
            if (newIndex < 0) newIndex = formSections.length;
            else if (newIndex >= formSections.length) newIndex = 0;
            const item = formSections.splice(field.parentIndex, 1)[0];
            formSections.splice(newIndex, 0, item);
            // get array of new field positions to patch to API
            const newFieldPositions = [];
            formSections.forEach((section)=>{
                section.items.forEach((item)=>{
                    newFieldPositions.push(item.name);
                });
            });
            editForm({
                id: formId,
                fields: newFieldPositions
            });
            onSetSections([
                ...formSections
            ]);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "edit-icons",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "button button__condensed",
                        "aria-label": "Edit form field",
                        title: "Edit",
                        onClick: doEdit,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.Pencil), {
                            size: 22,
                            strokeWidth: 1
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "button button__condensed",
                        "aria-label": "Delete form field",
                        title: "Delete",
                        onClick: doDelete,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.TrashCan), {
                            size: 22,
                            strokeWidth: 1
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "button button__condensed",
                        "aria-label": "Move form field up",
                        title: "Move up",
                        onClick: ()=>{
                            doMove("up");
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.ArrowUp), {
                            size: 22,
                            strokeWidth: 1
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "button button__condensed",
                        "aria-label": "Move form field down",
                        title: "Move down",
                        onClick: ()=>{
                            doMove("down");
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.ArrowDown), {
                            size: 22,
                            strokeWidth: 1
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "button button__condensed",
                        "aria-label": "Insert a new form field after this one",
                        title: "Insert after",
                        onClick: doInsert,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.CirclePlus), {
                            size: 22,
                            strokeWidth: 1
                        })
                    })
                ]
            }),
            action && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formItemEditDefault.default), {
                id: fieldId,
                formId: formId,
                create: false,
                onClose: ()=>{
                    setAction(null);
                },
                onSave: doEditUpdate
            })
        ]
    });
};
exports.default = FormEditIcons;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","akar-icons":"b8xdj","primereact/confirmdialog":"9Gq2y","./formItemEdit":"6SWde","../../hooks/fetch/useFetchForms":"fXBsb","../../hooks/useStore":"l1Yj7","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6SWde":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _drawer = require("../../drawer");
var _drawerDefault = parcelHelpers.interopDefault(_drawer);
var _utilities = require("../../../utilities");
var _utilitiesDefault = parcelHelpers.interopDefault(_utilities);
var _fieldMappingJson = require("../../json/fieldMapping.json");
var _fieldMappingJsonDefault = parcelHelpers.interopDefault(_fieldMappingJson);
var _useFetchForms = require("../../hooks/fetch/useFetchForms");
var _useStore = require("../../hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
let fieldMappingSelect = (0, _fieldMappingJsonDefault.default).map((field)=>{
    return {
        value: field.mapToPath,
        label: field.label
    };
});
fieldMappingSelect = [
    {
        value: "",
        label: "None"
    },
    ...fieldMappingSelect
];
const getMappedField = (mapToField)=>{
    const field = fieldMappingSelect.find((field)=>{
        return field.value === mapToField;
    });
    if (!field) return null;
    return {
        value: field.value,
        label: field.label
    };
};
const FormItemEdit = ({ id, formId, create, onSave, onClose, onBusy, onCompleted })=>{
    var _form_fields, _fieldOptions_find;
    if (!id && !create) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    const pathParts = (0, _useStoreDefault.default)((state)=>state.getPathParts());
    const account = pathParts[0];
    const { data: form, isLoading } = (0, _useFetchForms.useFetchForm)({
        account,
        formId
    });
    const { mutate: saveField, isLoading: isSaving } = (0, _useFetchForms.useUpdateFormField)({
        account,
        formId,
        callback: ()=>{
            setCloseSelf(true);
        }
    });
    const [closeSelf, setCloseSelf] = (0, _react.useState)(false);
    const field = form && ((_form_fields = form.fields) === null || _form_fields === void 0 ? void 0 : _form_fields.find((f)=>f.fieldId === id));
    const doSave = (data)=>{
        var _data_mapToField, _data_type;
        data.mapToField = (_data_mapToField = data.mapToField) === null || _data_mapToField === void 0 ? void 0 : _data_mapToField.value;
        data.id = id;
        data.type = (_data_type = data.type) === null || _data_type === void 0 ? void 0 : _data_type.value;
        onSave({
            ...data,
            name: data.id
        });
        saveField(data);
    };
    const isBusy = !!(isLoading || isSaving);
    (0, _react.useEffect)(()=>{
        isBusy ? onBusy && onBusy() : onCompleted && onCompleted();
    }, [
        isBusy
    ]);
    const fieldOptions = [
        {
            value: "text",
            label: "Text"
        },
        {
            value: "textarea",
            label: "Textarea"
        },
        {
            value: "select",
            label: "Select"
        },
        {
            value: "checkbox",
            label: "Checkbox"
        },
        {
            value: "multiCheckbox",
            label: "Select many"
        },
        {
            value: "radio",
            label: "Select one"
        },
        {
            value: "date",
            label: "Date"
        },
        {
            value: "file",
            label: "File"
        },
        {
            value: "number",
            label: "Number"
        },
        {
            value: "email",
            label: "Email"
        },
        {
            value: "hidden",
            label: "Hidden"
        },
        {
            value: "section",
            label: "Section divider"
        },
        {
            value: "page",
            label: "Page divider"
        }
    ];
    const sections = [
        {
            items: [
                {
                    type: "text",
                    label: "Label",
                    name: "label",
                    required: true,
                    default: field === null || field === void 0 ? void 0 : field.label
                },
                {
                    type: "select",
                    label: "Type",
                    name: "type",
                    required: true,
                    options: fieldOptions,
                    creatable: true,
                    default: {
                        value: field === null || field === void 0 ? void 0 : field.type,
                        label: (_fieldOptions_find = fieldOptions.find((o)=>{
                            return o.value === (field === null || field === void 0 ? void 0 : field.type);
                        })) === null || _fieldOptions_find === void 0 ? void 0 : _fieldOptions_find.label
                    }
                },
                {
                    type: "select",
                    label: "Options",
                    name: "options",
                    required: false,
                    multi: true,
                    creatable: true,
                    options: (0, _utilitiesDefault.default).generateSelectOptions(field === null || field === void 0 ? void 0 : field.options),
                    value: (0, _utilitiesDefault.default).generateSelectOptions(field === null || field === void 0 ? void 0 : field.options)
                },
                {
                    type: "checkbox",
                    label: "Required",
                    name: "required",
                    default: !!(field === null || field === void 0 ? void 0 : field.required)
                },
                {
                    type: "textarea",
                    label: "Caption",
                    name: "caption",
                    default: field === null || field === void 0 ? void 0 : field.caption
                },
                {
                    type: "text",
                    label: "Balloon tip",
                    name: "balloonTip",
                    default: field === null || field === void 0 ? void 0 : field.balloonTip
                },
                {
                    name: "mapToField",
                    label: "Map to user profile",
                    type: "select",
                    value: getMappedField(field === null || field === void 0 ? void 0 : field.mapToField),
                    options: fieldMappingSelect
                }
            ]
        }
    ];
    const drawerProps = {
        heading: "Edit Field",
        component: "form",
        componentProps: {
            sections
        },
        close: closeSelf,
        busy: isBusy,
        checkForUnsavedChanges: false,
        onClose,
        onSave: doSave
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _drawerDefault.default), {
        ...drawerProps
    });
};
exports.default = FormItemEdit;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","../../drawer":"2vhKL","../../../utilities":"fkdv9","../../json/fieldMapping.json":"j0Qq1","../../hooks/fetch/useFetchForms":"fXBsb","../../hooks/useStore":"l1Yj7","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2vhKL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _confirmdialog = require("primereact/confirmdialog");
var _form = require("./common/form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _revisionsHistory = require("./common/revisionsHistory");
var _revisionsHistoryDefault = parcelHelpers.interopDefault(_revisionsHistory);
var _backButton = require("./common/backButton");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
var _submitButton = require("./common/submitButton");
var _submitButtonDefault = parcelHelpers.interopDefault(_submitButton);
var _info = require("./common/info");
var _infoDefault = parcelHelpers.interopDefault(_info);
var _notice = require("./common/notice");
var _noticeDefault = parcelHelpers.interopDefault(_notice);
var _keyValueTable = require("./common/keyValueTable");
var _keyValueTableDefault = parcelHelpers.interopDefault(_keyValueTable);
var _inbox = require("./pages/components/inbox");
var _inboxDefault = parcelHelpers.interopDefault(_inbox);
var _imageSelect = require("./common/imageSelect");
var _imageSelectDefault = parcelHelpers.interopDefault(_imageSelect);
var _absences = require("./pages/components/absences");
var _absencesDefault = parcelHelpers.interopDefault(_absences);
var _formSubmission = require("./pages/components/formSubmission");
var _formSubmissionDefault = parcelHelpers.interopDefault(_formSubmission);
var _inboxConversation = require("./pages/components/inboxConversation");
var _inboxConversationDefault = parcelHelpers.interopDefault(_inboxConversation);
var _spinner = require("./common/spinner");
var _spinnerDefault = parcelHelpers.interopDefault(_spinner);
var _closeButton = require("./common/closeButton");
var _closeButtonDefault = parcelHelpers.interopDefault(_closeButton);
var _notifications = require("./pages/components/notifications");
var _notificationsDefault = parcelHelpers.interopDefault(_notifications);
var _useStore = require("./hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
var _drawerScss = require("../../scss/components/drawer.scss");
// Intercept close navigation with prompt if unsaved changes to form
const doCheck = (callback, hasUnsavedChanges, checkForUnsavedChanges = true)=>{
    return callback();
};
const Drawer = ({ component: componentType, componentProps, actionButtons, actionButtonsHeading, heading, content, notice, hideForm, close = false, loading = false, busy: initBusy, disabled = false, saveLabel = "Save", saveLabelBusy = "Saving...", checkForUnsavedChanges = true, innerRef = null, onOpen, onClose, onSave })=>{
    const hasUnsavedChanges = (0, _useStoreDefault.default)((state)=>state.hasUnsavedChanges);
    const setHasUnsavedChanges = (0, _useStoreDefault.default)((state)=>state.setHasUnsavedChanges);
    const [drawerOverlayClass, setDrawerOverlayClass] = (0, _react.useState)("drawer-overlay");
    const [drawerClass, setDrawerClass] = (0, _react.useState)("drawer");
    const [busy, setBusy] = (0, _react.useState)(initBusy);
    const [showBackLink, setShowBackLink] = (0, _react.useState)(false);
    const [backTrigger, setBackTrigger] = (0, _react.useState)(false);
    const closeTimeoutRef = (0, _react.useRef)(null);
    const openTimeoutRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        return ()=>{
            clearTimeout(closeTimeoutRef.current);
            clearTimeout(openTimeoutRef.current);
        };
    }, []);
    (0, _react.useEffect)(()=>{
        setBusy(initBusy);
    }, [
        initBusy
    ]);
    (0, _react.useEffect)(()=>{
        // custom scrollbar on content area
        require("dd45d4c69e636115");
        setHasUnsavedChanges(false);
    }, []);
    const formSubmitCallbackRef = (0, _react.useRef)();
    let component = null;
    switch(componentType){
        case "form":
            // store callback for React hook form validation / submission
            // so we can submit form from parent
            const submitCallback = (callback)=>{
                formSubmitCallbackRef.current = callback;
            };
            component = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formDefault.default), {
                registerCallback: submitCallback,
                onSubmit: onSave,
                ...componentProps,
                busy: busy
            });
            break;
        case "info":
            component = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoDefault.default), {
                data: componentProps === null || componentProps === void 0 ? void 0 : componentProps.data
            });
            break;
        case "revisionsHistory":
            component = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _revisionsHistoryDefault.default), {
                data: componentProps === null || componentProps === void 0 ? void 0 : componentProps.data
            });
            break;
        case "dataTable":
            component = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyValueTableDefault.default), {
                data: componentProps === null || componentProps === void 0 ? void 0 : componentProps.data
            });
            break;
        case "imageSelect":
            component = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageSelectDefault.default), {
                ...componentProps
            });
            break;
        case "formSubmission":
            component = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formSubmissionDefault.default), {
                ...componentProps
            });
            break;
        case "absences":
            component = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _absencesDefault.default), {
                ...componentProps,
                innerRef: innerRef,
                heading: heading
            });
            break;
        case "inboxConversation":
            component = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inboxConversationDefault.default), {
                ...componentProps
            });
            break;
        case "inbox":
            component = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inboxDefault.default), {
                ...componentProps,
                backTrigger: backTrigger,
                onBackLink: setShowBackLink,
                onBusy: setBusy
            });
            break;
        case "systemMessages":
            component = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inboxDefault.default), {
                ...componentProps,
                isSystemMessages: true,
                onBusy: setBusy
            });
            break;
        case "notifications":
            component = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notificationsDefault.default), {
                ...componentProps,
                onBusy: setBusy
            });
            break;
    }
    const doClose = ()=>{
        doCheck(()=>{
            // drawer component has onClose prop, trigger it now
            if (componentProps === null || componentProps === void 0 ? void 0 : componentProps.onClose) componentProps.onClose();
            setHasUnsavedChanges(false);
            setDrawerOverlayClass("drawer-overlay drawer-overlay__closed");
            setDrawerClass("drawer drawer__closed");
            clearTimeout(closeTimeoutRef.current);
            if (onClose) closeTimeoutRef.current = setTimeout(onClose, 600);
        }, hasUnsavedChanges, checkForUnsavedChanges);
    };
    const doBack = ()=>{
        setShowBackLink(false);
        setBackTrigger(Math.random());
    };
    (0, _react.useEffect)(()=>{
        clearTimeout(openTimeoutRef.current);
        if (close) return doClose();
        if (onOpen) openTimeoutRef.current = setTimeout(onOpen, 500);
    }, [
        close
    ]);
    const disableSubmit = !!(hideForm || componentType != "form" || disabled);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: drawerOverlayClass
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "drawer-container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: drawerClass,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "drawer--heading",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                children: heading
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "drawer--close",
                            children: [
                                showBackLink && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                                    label: "Back to inbox",
                                    onClick: doBack
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeButtonDefault.default), {
                                    onClick: doClose
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: busy || loading ? "drawer--content drawer--content__submitting" : "drawer--content",
                            children: [
                                loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinnerDefault.default), {}),
                                !loading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        actionButtons && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "drawer-action-buttons",
                                            "data-is-disabled": busy || disabled,
                                            children: [
                                                actionButtonsHeading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "drawer-action-buttons-heading",
                                                    children: actionButtonsHeading
                                                }),
                                                actionButtons.map((actionButton, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        className: "button button__invert",
                                                        onClick: ()=>actionButton === null || actionButton === void 0 ? void 0 : actionButton.action(formSubmitCallbackRef.current),
                                                        children: actionButton === null || actionButton === void 0 ? void 0 : actionButton.label
                                                    }, key))
                                            ]
                                        }),
                                        notice && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noticeDefault.default), {
                                            message: notice
                                        }),
                                        component
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "drawer--footer-buttons",
                            children: [
                                !disableSubmit && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _submitButtonDefault.default), {
                                            label: busy ? saveLabelBusy : saveLabel,
                                            disabled: busy || loading,
                                            onSubmit: ()=>{
                                                formSubmitCallbackRef.current();
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: busy ? "button button__invert button__disabled" : "button button__invert",
                                            type: "button",
                                            disabled: busy || loading,
                                            onClick: doClose,
                                            children: "Close"
                                        })
                                    ]
                                }),
                                disableSubmit && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: busy ? "button button__invert button__disabled" : "button button__invert",
                                    type: "button",
                                    disabled: busy,
                                    onClick: doClose,
                                    children: "Close"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
exports.default = Drawer;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","primereact/confirmdialog":"9Gq2y","./common/form":"dUWg9","./common/revisionsHistory":"gnkku","./common/backButton":"9eXgB","./common/submitButton":"4bi2T","./common/info":"7gwcF","./common/notice":"bnY7j","./common/keyValueTable":"hb4HB","./pages/components/inbox":"i7JDs","./common/imageSelect":"3ufLm","./pages/components/absences":"jkhEM","./pages/components/formSubmission":"9m3Mf","./pages/components/inboxConversation":"gNK1B","./common/spinner":"lRuRG","./common/closeButton":"azTQI","./pages/components/notifications":"13VYq","./hooks/useStore":"l1Yj7","../../scss/components/drawer.scss":"kMU9z","dd45d4c69e636115":"k2xEc","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"gnkku":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _utilities = require("../../utilities");
var _utilitiesDefault = parcelHelpers.interopDefault(_utilities);
var _notice = require("./notice");
var _noticeDefault = parcelHelpers.interopDefault(_notice);
var _useFetchUsers = require("../hooks/fetch/useFetchUsers");
var _useStore = require("../hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
const RevisionHistory = ({ data })=>{
    const clientRef = (0, _useStoreDefault.default)((state)=>state.clientRef);
    const { data: users } = (0, _useFetchUsers.useFetchUsersBasic)({
        account: clientRef
    });
    if (!data || (data === null || data === void 0 ? void 0 : data.length) === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noticeDefault.default), {
            message: "No changes have been recorded for this section"
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "notice notice__invert flex flex__mb",
                children: [
                    "Key:",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "diff--added",
                        children: "Added"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "diff--removed",
                        children: "Removed"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "revisions-history",
                children: data === null || data === void 0 ? void 0 : data.map((row, i)=>{
                    var _users_find;
                    const user = row.userId ? ' - ' + ((users === null || users === void 0 ? void 0 : (_users_find = users.find((u)=>u.id === row.userId)) === null || _users_find === void 0 ? void 0 : _users_find.name) || 'Admin') : '';
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                                children: [
                                    (0, _utilitiesDefault.default).getFormattedDateTime(row.dateTime),
                                    user
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "data-table--value",
                                dangerouslySetInnerHTML: {
                                    __html: row.changes
                                }
                            }),
                            i !== data.length - 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "data-table--divide"
                            })
                        ]
                    }, i);
                })
            })
        ]
    });
};
exports.default = RevisionHistory;

},{"react/jsx-runtime":"i3K7E","../../utilities":"fkdv9","./notice":"bnY7j","../hooks/fetch/useFetchUsers":"4DurT","../hooks/useStore":"l1Yj7","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9eXgB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _svg = require("./svg");
var _svgDefault = parcelHelpers.interopDefault(_svg);
var _react = require("react");
const BackButton = ({ label, disabled: initDisabled, isForm, onClick })=>{
    const [disabled, setDisabled] = (0, _react.useState)(initDisabled);
    (0, _react.useEffect)(()=>{
        setDisabled(initDisabled);
    }, [
        initDisabled
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        disabled: disabled,
        className: !disabled ? "button button__invert button__arrow-back" : "button button__invert button__arrow-back button__disabled",
        onClick: onClick,
        type: isForm ? "form" : "button",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgDefault.default), {
                src: "arrow-right",
                className: "icon",
                label: "Back"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: label
            })
        ]
    });
};
exports.default = BackButton;

},{"react/jsx-runtime":"i3K7E","./svg":"4pImm","react":"6wC8C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7gwcF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
const Info = ({ data })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "data-table",
        children: data === null || data === void 0 ? void 0 : data.map((row)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "data-table--label",
                        children: row.label
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "data-table--value",
                        children: row.value
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                        className: "data-table--divide"
                    })
                ]
            }))
    });
};
exports.default = Info;

},{"react/jsx-runtime":"i3K7E","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hb4HB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
const KeyValueTable = ({ data })=>{
    // Check if data is an object
    if (typeof data === "object" && data !== null) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
        className: "table",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
            children: Object.keys(data).map((key)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                            children: key
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(KeyValueTable, {
                                data: data[key]
                            })
                        })
                    ]
                }, key))
        })
    });
    else // If data is not an object, simply render the value
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: data
    });
};
exports.default = KeyValueTable;

},{"react/jsx-runtime":"i3K7E","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"i7JDs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _htmlEntities = require("html-entities");
var _utilities = require("../../../utilities");
var _utilitiesDefault = parcelHelpers.interopDefault(_utilities);
var _inboxConversation = require("./inboxConversation");
var _inboxConversationDefault = parcelHelpers.interopDefault(_inboxConversation);
var _notice = require("../../common/notice");
var _noticeDefault = parcelHelpers.interopDefault(_notice);
var _useFetchMessages = require("../../hooks/fetch/useFetchMessages");
var _messagesScss = require("../../../../scss/components/messages.scss");
// Helper function to scroll to the bottom of the conversation when opened
const scrollToBottom = ()=>{
    setTimeout(()=>{
        const messages = document.querySelector(".drawer--content");
        if (messages) messages.scrollTop = messages.scrollHeight;
    }, 100);
};
const Inbox = ({ backTrigger, isSystemMessages, onBackLink, onBusy = false })=>{
    // If set, holds the userId of the conversation to load
    const [conversationUser, setConversationUser] = (0, _react.useState)(isSystemMessages ? 0 : null);
    // If the backTrigger is set, reset the conversationUser to return to inbox
    (0, _react.useEffect)(()=>{
        if (backTrigger) setConversationUser(null);
    }, [
        backTrigger
    ]);
    // Fetch data hooks
    const { data: inbox } = (0, _useFetchMessages.useFetchInbox)({});
    const { data: conversation, isLoading: isConversationLoading } = (0, _useFetchMessages.useFetchConversation)({
        userId: conversationUser
    });
    // If a conversation is loaded, render the conversation component
    (0, _react.useEffect)(()=>{
        if (conversationUser !== null) {
            scrollToBottom();
            if (onBackLink) onBackLink(true);
        }
    }, [
        conversationUser,
        isConversationLoading
    ]);
    if (conversationUser !== null) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inboxConversationDefault.default), {
        messages: conversation,
        recipient: conversationUser,
        loading: isConversationLoading,
        onBusy: onBusy
    });
    // Remove the back link if no conversation is loaded
    onBackLink(false);
    if (!inbox || (inbox === null || inbox === void 0 ? void 0 : inbox.length) === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "inbox-messages",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noticeDefault.default), {
            message: "No messages found",
            type: "info"
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "inbox-messages",
        children: inbox === null || inbox === void 0 ? void 0 : inbox.map((message, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                className: message.unread > 0 ? "button-unstyled inbox-message inbox-message__unread" : "button-unstyled inbox-message",
                onClick: ()=>setConversationUser(message.userId),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "inbox-message-name",
                        children: message.fullName
                    }),
                    message.unread > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "inbox-message-unread",
                        children: message.unread
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "inbox-message-message",
                        children: (0, _htmlEntities.decode)((0, _utilitiesDefault.default).truncateString(message.message, 500, 0, true)).replaceAll("<br />", " ")
                    })
                ]
            }, index))
    });
};
exports.default = Inbox;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","html-entities":"27yUb","../../../utilities":"fkdv9","./inboxConversation":"gNK1B","../../common/notice":"bnY7j","../../hooks/fetch/useFetchMessages":"3hiet","../../../../scss/components/messages.scss":"7a3Vi","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"27yUb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Encodes all the necessary (specified by `level`) characters in the text */ parcelHelpers.export(exports, "encode", ()=>encode);
/** Decodes a single entity */ parcelHelpers.export(exports, "decodeEntity", ()=>decodeEntity);
/** Decodes all entities in the text */ parcelHelpers.export(exports, "decode", ()=>decode);
var _namedReferencesJs = require("./named-references.js");
var _numericUnicodeMapJs = require("./numeric-unicode-map.js");
var _surrogatePairsJs = require("./surrogate-pairs.js");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var allNamedReferences = __assign(__assign({}, (0, _namedReferencesJs.namedReferences)), {
    all: (0, _namedReferencesJs.namedReferences).html5
});
var encodeRegExps = {
    specialChars: /[<>'"&]/g,
    nonAscii: /[<>'"&\u0080-\uD7FF\uE000-\uFFFF\uDC00-\uDFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]?/g,
    nonAsciiPrintable: /[<>'"&\x01-\x08\x11-\x15\x17-\x1F\x7f-\uD7FF\uE000-\uFFFF\uDC00-\uDFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]?/g,
    nonAsciiPrintableOnly: /[\x01-\x08\x11-\x15\x17-\x1F\x7f-\uD7FF\uE000-\uFFFF\uDC00-\uDFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]?/g,
    extensive: /[\x01-\x0c\x0e-\x1f\x21-\x2c\x2e-\x2f\x3a-\x40\x5b-\x60\x7b-\x7d\x7f-\uD7FF\uE000-\uFFFF\uDC00-\uDFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]?/g
};
var defaultEncodeOptions = {
    mode: 'specialChars',
    level: 'all',
    numeric: 'decimal'
};
function encode(text, _a) {
    var _b = _a === void 0 ? defaultEncodeOptions : _a, _c = _b.mode, mode = _c === void 0 ? 'specialChars' : _c, _d = _b.numeric, numeric = _d === void 0 ? 'decimal' : _d, _e = _b.level, level = _e === void 0 ? 'all' : _e;
    if (!text) return '';
    var encodeRegExp = encodeRegExps[mode];
    var references = allNamedReferences[level].characters;
    var isHex = numeric === 'hexadecimal';
    return String.prototype.replace.call(text, encodeRegExp, function(input) {
        var result = references[input];
        if (!result) {
            var code = input.length > 1 ? (0, _surrogatePairsJs.getCodePoint)(input, 0) : input.charCodeAt(0);
            result = (isHex ? '&#x' + code.toString(16) : '&#' + code) + ';';
        }
        return result;
    });
}
var defaultDecodeOptions = {
    scope: 'body',
    level: 'all'
};
var strict = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);/g;
var attribute = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+)[;=]?/g;
var baseDecodeRegExps = {
    xml: {
        strict: strict,
        attribute: attribute,
        body: (0, _namedReferencesJs.bodyRegExps).xml
    },
    html4: {
        strict: strict,
        attribute: attribute,
        body: (0, _namedReferencesJs.bodyRegExps).html4
    },
    html5: {
        strict: strict,
        attribute: attribute,
        body: (0, _namedReferencesJs.bodyRegExps).html5
    }
};
var decodeRegExps = __assign(__assign({}, baseDecodeRegExps), {
    all: baseDecodeRegExps.html5
});
var fromCharCode = String.fromCharCode;
var outOfBoundsChar = fromCharCode(65533);
var defaultDecodeEntityOptions = {
    level: 'all'
};
function getDecodedEntity(entity, references, isAttribute, isStrict) {
    var decodeResult = entity;
    var decodeEntityLastChar = entity[entity.length - 1];
    if (isAttribute && decodeEntityLastChar === '=') decodeResult = entity;
    else if (isStrict && decodeEntityLastChar !== ';') decodeResult = entity;
    else {
        var decodeResultByReference = references[entity];
        if (decodeResultByReference) decodeResult = decodeResultByReference;
        else if (entity[0] === '&' && entity[1] === '#') {
            var decodeSecondChar = entity[2];
            var decodeCode = decodeSecondChar == 'x' || decodeSecondChar == 'X' ? parseInt(entity.substr(3), 16) : parseInt(entity.substr(2));
            decodeResult = decodeCode >= 0x10ffff ? outOfBoundsChar : decodeCode > 65535 ? (0, _surrogatePairsJs.fromCodePoint)(decodeCode) : fromCharCode((0, _numericUnicodeMapJs.numericUnicodeMap)[decodeCode] || decodeCode);
        }
    }
    return decodeResult;
}
function decodeEntity(entity, _a) {
    var _b = _a === void 0 ? defaultDecodeEntityOptions : _a, _c = _b.level, level = _c === void 0 ? 'all' : _c;
    if (!entity) return '';
    return getDecodedEntity(entity, allNamedReferences[level].entities, false, false);
}
function decode(text, _a) {
    var _b = _a === void 0 ? defaultDecodeOptions : _a, _c = _b.level, level = _c === void 0 ? 'all' : _c, _d = _b.scope, scope = _d === void 0 ? level === 'xml' ? 'strict' : 'body' : _d;
    if (!text) return '';
    var decodeRegExp = decodeRegExps[level][scope];
    var references = allNamedReferences[level].entities;
    var isAttribute = scope === 'attribute';
    var isStrict = scope === 'strict';
    return text.replace(decodeRegExp, function(entity) {
        return getDecodedEntity(entity, references, isAttribute, isStrict);
    });
}

},{"./named-references.js":"69kx5","./numeric-unicode-map.js":"7vPXL","./surrogate-pairs.js":"1rrcm","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"69kx5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bodyRegExps", ()=>bodyRegExps);
parcelHelpers.export(exports, "namedReferences", ()=>namedReferences);
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// This file is autogenerated by tools/process-named-references.ts
var pairDivider = "~";
var blockDivider = "~~";
function generateNamedReferences(input, prev) {
    var entities = {};
    var characters = {};
    var blocks = input.split(blockDivider);
    var isOptionalBlock = false;
    for(var i = 0; blocks.length > i; i++){
        var entries = blocks[i].split(pairDivider);
        for(var j = 0; j < entries.length; j += 2){
            var entity = entries[j];
            var character = entries[j + 1];
            var fullEntity = '&' + entity + ';';
            entities[fullEntity] = character;
            if (isOptionalBlock) entities['&' + entity] = character;
            characters[character] = fullEntity;
        }
        isOptionalBlock = true;
    }
    return prev ? {
        entities: __assign(__assign({}, entities), prev.entities),
        characters: __assign(__assign({}, characters), prev.characters)
    } : {
        entities: entities,
        characters: characters
    };
}
var bodyRegExps = {
    xml: /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
    html4: /&notin;|&(?:nbsp|iexcl|cent|pound|curren|yen|brvbar|sect|uml|copy|ordf|laquo|not|shy|reg|macr|deg|plusmn|sup2|sup3|acute|micro|para|middot|cedil|sup1|ordm|raquo|frac14|frac12|frac34|iquest|Agrave|Aacute|Acirc|Atilde|Auml|Aring|AElig|Ccedil|Egrave|Eacute|Ecirc|Euml|Igrave|Iacute|Icirc|Iuml|ETH|Ntilde|Ograve|Oacute|Ocirc|Otilde|Ouml|times|Oslash|Ugrave|Uacute|Ucirc|Uuml|Yacute|THORN|szlig|agrave|aacute|acirc|atilde|auml|aring|aelig|ccedil|egrave|eacute|ecirc|euml|igrave|iacute|icirc|iuml|eth|ntilde|ograve|oacute|ocirc|otilde|ouml|divide|oslash|ugrave|uacute|ucirc|uuml|yacute|thorn|yuml|quot|amp|lt|gt|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
    html5: /&centerdot;|&copysr;|&divideontimes;|&gtcc;|&gtcir;|&gtdot;|&gtlPar;|&gtquest;|&gtrapprox;|&gtrarr;|&gtrdot;|&gtreqless;|&gtreqqless;|&gtrless;|&gtrsim;|&ltcc;|&ltcir;|&ltdot;|&lthree;|&ltimes;|&ltlarr;|&ltquest;|&ltrPar;|&ltri;|&ltrie;|&ltrif;|&notin;|&notinE;|&notindot;|&notinva;|&notinvb;|&notinvc;|&notni;|&notniva;|&notnivb;|&notnivc;|&parallel;|&timesb;|&timesbar;|&timesd;|&(?:AElig|AMP|Aacute|Acirc|Agrave|Aring|Atilde|Auml|COPY|Ccedil|ETH|Eacute|Ecirc|Egrave|Euml|GT|Iacute|Icirc|Igrave|Iuml|LT|Ntilde|Oacute|Ocirc|Ograve|Oslash|Otilde|Ouml|QUOT|REG|THORN|Uacute|Ucirc|Ugrave|Uuml|Yacute|aacute|acirc|acute|aelig|agrave|amp|aring|atilde|auml|brvbar|ccedil|cedil|cent|copy|curren|deg|divide|eacute|ecirc|egrave|eth|euml|frac12|frac14|frac34|gt|iacute|icirc|iexcl|igrave|iquest|iuml|laquo|lt|macr|micro|middot|nbsp|not|ntilde|oacute|ocirc|ograve|ordf|ordm|oslash|otilde|ouml|para|plusmn|pound|quot|raquo|reg|sect|shy|sup1|sup2|sup3|szlig|thorn|times|uacute|ucirc|ugrave|uml|uuml|yacute|yen|yuml|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g
};
var namedReferences = {};
namedReferences['xml'] = generateNamedReferences("lt~<~gt~>~quot~\"~apos~'~amp~&");
namedReferences['html4'] = generateNamedReferences("apos~'~OElig~\u0152~oelig~\u0153~Scaron~\u0160~scaron~\u0161~Yuml~\u0178~circ~\u02C6~tilde~\u02DC~ensp~\u2002~emsp~\u2003~thinsp~\u2009~zwnj~\u200C~zwj~\u200D~lrm~\u200E~rlm~\u200F~ndash~\u2013~mdash~\u2014~lsquo~\u2018~rsquo~\u2019~sbquo~\u201A~ldquo~\u201C~rdquo~\u201D~bdquo~\u201E~dagger~\u2020~Dagger~\u2021~permil~\u2030~lsaquo~\u2039~rsaquo~\u203A~euro~\u20AC~fnof~\u0192~Alpha~\u0391~Beta~\u0392~Gamma~\u0393~Delta~\u0394~Epsilon~\u0395~Zeta~\u0396~Eta~\u0397~Theta~\u0398~Iota~\u0399~Kappa~\u039A~Lambda~\u039B~Mu~\u039C~Nu~\u039D~Xi~\u039E~Omicron~\u039F~Pi~\u03A0~Rho~\u03A1~Sigma~\u03A3~Tau~\u03A4~Upsilon~\u03A5~Phi~\u03A6~Chi~\u03A7~Psi~\u03A8~Omega~\u03A9~alpha~\u03B1~beta~\u03B2~gamma~\u03B3~delta~\u03B4~epsilon~\u03B5~zeta~\u03B6~eta~\u03B7~theta~\u03B8~iota~\u03B9~kappa~\u03BA~lambda~\u03BB~mu~\u03BC~nu~\u03BD~xi~\u03BE~omicron~\u03BF~pi~\u03C0~rho~\u03C1~sigmaf~\u03C2~sigma~\u03C3~tau~\u03C4~upsilon~\u03C5~phi~\u03C6~chi~\u03C7~psi~\u03C8~omega~\u03C9~thetasym~\u03D1~upsih~\u03D2~piv~\u03D6~bull~\u2022~hellip~\u2026~prime~\u2032~Prime~\u2033~oline~\u203E~frasl~\u2044~weierp~\u2118~image~\u2111~real~\u211C~trade~\u2122~alefsym~\u2135~larr~\u2190~uarr~\u2191~rarr~\u2192~darr~\u2193~harr~\u2194~crarr~\u21B5~lArr~\u21D0~uArr~\u21D1~rArr~\u21D2~dArr~\u21D3~hArr~\u21D4~forall~\u2200~part~\u2202~exist~\u2203~empty~\u2205~nabla~\u2207~isin~\u2208~notin~\u2209~ni~\u220B~prod~\u220F~sum~\u2211~minus~\u2212~lowast~\u2217~radic~\u221A~prop~\u221D~infin~\u221E~ang~\u2220~and~\u2227~or~\u2228~cap~\u2229~cup~\u222A~int~\u222B~there4~\u2234~sim~\u223C~cong~\u2245~asymp~\u2248~ne~\u2260~equiv~\u2261~le~\u2264~ge~\u2265~sub~\u2282~sup~\u2283~nsub~\u2284~sube~\u2286~supe~\u2287~oplus~\u2295~otimes~\u2297~perp~\u22A5~sdot~\u22C5~lceil~\u2308~rceil~\u2309~lfloor~\u230A~rfloor~\u230B~lang~\u2329~rang~\u232A~loz~\u25CA~spades~\u2660~clubs~\u2663~hearts~\u2665~diams~\u2666~~nbsp~\xa0~iexcl~\xa1~cent~\xa2~pound~\xa3~curren~\xa4~yen~\xa5~brvbar~\xa6~sect~\xa7~uml~\xa8~copy~\xa9~ordf~\xaa~laquo~\xab~not~\xac~shy~\xad~reg~\xae~macr~\xaf~deg~\xb0~plusmn~\xb1~sup2~\xb2~sup3~\xb3~acute~\xb4~micro~\xb5~para~\xb6~middot~\xb7~cedil~\xb8~sup1~\xb9~ordm~\xba~raquo~\xbb~frac14~\xbc~frac12~\xbd~frac34~\xbe~iquest~\xbf~Agrave~\xc0~Aacute~\xc1~Acirc~\xc2~Atilde~\xc3~Auml~\xc4~Aring~\xc5~AElig~\xc6~Ccedil~\xc7~Egrave~\xc8~Eacute~\xc9~Ecirc~\xca~Euml~\xcb~Igrave~\xcc~Iacute~\xcd~Icirc~\xce~Iuml~\xcf~ETH~\xd0~Ntilde~\xd1~Ograve~\xd2~Oacute~\xd3~Ocirc~\xd4~Otilde~\xd5~Ouml~\xd6~times~\xd7~Oslash~\xd8~Ugrave~\xd9~Uacute~\xda~Ucirc~\xdb~Uuml~\xdc~Yacute~\xdd~THORN~\xde~szlig~\xdf~agrave~\xe0~aacute~\xe1~acirc~\xe2~atilde~\xe3~auml~\xe4~aring~\xe5~aelig~\xe6~ccedil~\xe7~egrave~\xe8~eacute~\xe9~ecirc~\xea~euml~\xeb~igrave~\xec~iacute~\xed~icirc~\xee~iuml~\xef~eth~\xf0~ntilde~\xf1~ograve~\xf2~oacute~\xf3~ocirc~\xf4~otilde~\xf5~ouml~\xf6~divide~\xf7~oslash~\xf8~ugrave~\xf9~uacute~\xfa~ucirc~\xfb~uuml~\xfc~yacute~\xfd~thorn~\xfe~yuml~\xff~quot~\"~amp~&~lt~<~gt~>");
namedReferences['html5'] = generateNamedReferences('Abreve~\u0102~Acy~\u0410~Afr~\uD835\uDD04~Amacr~\u0100~And~\u2A53~Aogon~\u0104~Aopf~\uD835\uDD38~ApplyFunction~\u2061~Ascr~\uD835\uDC9C~Assign~\u2254~Backslash~\u2216~Barv~\u2AE7~Barwed~\u2306~Bcy~\u0411~Because~\u2235~Bernoullis~\u212C~Bfr~\uD835\uDD05~Bopf~\uD835\uDD39~Breve~\u02D8~Bscr~\u212C~Bumpeq~\u224E~CHcy~\u0427~Cacute~\u0106~Cap~\u22D2~CapitalDifferentialD~\u2145~Cayleys~\u212D~Ccaron~\u010C~Ccirc~\u0108~Cconint~\u2230~Cdot~\u010A~Cedilla~\xb8~CenterDot~\xb7~Cfr~\u212D~CircleDot~\u2299~CircleMinus~\u2296~CirclePlus~\u2295~CircleTimes~\u2297~ClockwiseContourIntegral~\u2232~CloseCurlyDoubleQuote~\u201D~CloseCurlyQuote~\u2019~Colon~\u2237~Colone~\u2A74~Congruent~\u2261~Conint~\u222F~ContourIntegral~\u222E~Copf~\u2102~Coproduct~\u2210~CounterClockwiseContourIntegral~\u2233~Cross~\u2A2F~Cscr~\uD835\uDC9E~Cup~\u22D3~CupCap~\u224D~DD~\u2145~DDotrahd~\u2911~DJcy~\u0402~DScy~\u0405~DZcy~\u040F~Darr~\u21A1~Dashv~\u2AE4~Dcaron~\u010E~Dcy~\u0414~Del~\u2207~Dfr~\uD835\uDD07~DiacriticalAcute~\xb4~DiacriticalDot~\u02D9~DiacriticalDoubleAcute~\u02DD~DiacriticalGrave~`~DiacriticalTilde~\u02DC~Diamond~\u22C4~DifferentialD~\u2146~Dopf~\uD835\uDD3B~Dot~\xa8~DotDot~\u20DC~DotEqual~\u2250~DoubleContourIntegral~\u222F~DoubleDot~\xa8~DoubleDownArrow~\u21D3~DoubleLeftArrow~\u21D0~DoubleLeftRightArrow~\u21D4~DoubleLeftTee~\u2AE4~DoubleLongLeftArrow~\u27F8~DoubleLongLeftRightArrow~\u27FA~DoubleLongRightArrow~\u27F9~DoubleRightArrow~\u21D2~DoubleRightTee~\u22A8~DoubleUpArrow~\u21D1~DoubleUpDownArrow~\u21D5~DoubleVerticalBar~\u2225~DownArrow~\u2193~DownArrowBar~\u2913~DownArrowUpArrow~\u21F5~DownBreve~\u0311~DownLeftRightVector~\u2950~DownLeftTeeVector~\u295E~DownLeftVector~\u21BD~DownLeftVectorBar~\u2956~DownRightTeeVector~\u295F~DownRightVector~\u21C1~DownRightVectorBar~\u2957~DownTee~\u22A4~DownTeeArrow~\u21A7~Downarrow~\u21D3~Dscr~\uD835\uDC9F~Dstrok~\u0110~ENG~\u014A~Ecaron~\u011A~Ecy~\u042D~Edot~\u0116~Efr~\uD835\uDD08~Element~\u2208~Emacr~\u0112~EmptySmallSquare~\u25FB~EmptyVerySmallSquare~\u25AB~Eogon~\u0118~Eopf~\uD835\uDD3C~Equal~\u2A75~EqualTilde~\u2242~Equilibrium~\u21CC~Escr~\u2130~Esim~\u2A73~Exists~\u2203~ExponentialE~\u2147~Fcy~\u0424~Ffr~\uD835\uDD09~FilledSmallSquare~\u25FC~FilledVerySmallSquare~\u25AA~Fopf~\uD835\uDD3D~ForAll~\u2200~Fouriertrf~\u2131~Fscr~\u2131~GJcy~\u0403~Gammad~\u03DC~Gbreve~\u011E~Gcedil~\u0122~Gcirc~\u011C~Gcy~\u0413~Gdot~\u0120~Gfr~\uD835\uDD0A~Gg~\u22D9~Gopf~\uD835\uDD3E~GreaterEqual~\u2265~GreaterEqualLess~\u22DB~GreaterFullEqual~\u2267~GreaterGreater~\u2AA2~GreaterLess~\u2277~GreaterSlantEqual~\u2A7E~GreaterTilde~\u2273~Gscr~\uD835\uDCA2~Gt~\u226B~HARDcy~\u042A~Hacek~\u02C7~Hat~^~Hcirc~\u0124~Hfr~\u210C~HilbertSpace~\u210B~Hopf~\u210D~HorizontalLine~\u2500~Hscr~\u210B~Hstrok~\u0126~HumpDownHump~\u224E~HumpEqual~\u224F~IEcy~\u0415~IJlig~\u0132~IOcy~\u0401~Icy~\u0418~Idot~\u0130~Ifr~\u2111~Im~\u2111~Imacr~\u012A~ImaginaryI~\u2148~Implies~\u21D2~Int~\u222C~Integral~\u222B~Intersection~\u22C2~InvisibleComma~\u2063~InvisibleTimes~\u2062~Iogon~\u012E~Iopf~\uD835\uDD40~Iscr~\u2110~Itilde~\u0128~Iukcy~\u0406~Jcirc~\u0134~Jcy~\u0419~Jfr~\uD835\uDD0D~Jopf~\uD835\uDD41~Jscr~\uD835\uDCA5~Jsercy~\u0408~Jukcy~\u0404~KHcy~\u0425~KJcy~\u040C~Kcedil~\u0136~Kcy~\u041A~Kfr~\uD835\uDD0E~Kopf~\uD835\uDD42~Kscr~\uD835\uDCA6~LJcy~\u0409~Lacute~\u0139~Lang~\u27EA~Laplacetrf~\u2112~Larr~\u219E~Lcaron~\u013D~Lcedil~\u013B~Lcy~\u041B~LeftAngleBracket~\u27E8~LeftArrow~\u2190~LeftArrowBar~\u21E4~LeftArrowRightArrow~\u21C6~LeftCeiling~\u2308~LeftDoubleBracket~\u27E6~LeftDownTeeVector~\u2961~LeftDownVector~\u21C3~LeftDownVectorBar~\u2959~LeftFloor~\u230A~LeftRightArrow~\u2194~LeftRightVector~\u294E~LeftTee~\u22A3~LeftTeeArrow~\u21A4~LeftTeeVector~\u295A~LeftTriangle~\u22B2~LeftTriangleBar~\u29CF~LeftTriangleEqual~\u22B4~LeftUpDownVector~\u2951~LeftUpTeeVector~\u2960~LeftUpVector~\u21BF~LeftUpVectorBar~\u2958~LeftVector~\u21BC~LeftVectorBar~\u2952~Leftarrow~\u21D0~Leftrightarrow~\u21D4~LessEqualGreater~\u22DA~LessFullEqual~\u2266~LessGreater~\u2276~LessLess~\u2AA1~LessSlantEqual~\u2A7D~LessTilde~\u2272~Lfr~\uD835\uDD0F~Ll~\u22D8~Lleftarrow~\u21DA~Lmidot~\u013F~LongLeftArrow~\u27F5~LongLeftRightArrow~\u27F7~LongRightArrow~\u27F6~Longleftarrow~\u27F8~Longleftrightarrow~\u27FA~Longrightarrow~\u27F9~Lopf~\uD835\uDD43~LowerLeftArrow~\u2199~LowerRightArrow~\u2198~Lscr~\u2112~Lsh~\u21B0~Lstrok~\u0141~Lt~\u226A~Map~\u2905~Mcy~\u041C~MediumSpace~\u205F~Mellintrf~\u2133~Mfr~\uD835\uDD10~MinusPlus~\u2213~Mopf~\uD835\uDD44~Mscr~\u2133~NJcy~\u040A~Nacute~\u0143~Ncaron~\u0147~Ncedil~\u0145~Ncy~\u041D~NegativeMediumSpace~\u200B~NegativeThickSpace~\u200B~NegativeThinSpace~\u200B~NegativeVeryThinSpace~\u200B~NestedGreaterGreater~\u226B~NestedLessLess~\u226A~NewLine~\n~Nfr~\uD835\uDD11~NoBreak~\u2060~NonBreakingSpace~\xa0~Nopf~\u2115~Not~\u2AEC~NotCongruent~\u2262~NotCupCap~\u226D~NotDoubleVerticalBar~\u2226~NotElement~\u2209~NotEqual~\u2260~NotEqualTilde~\u2242\u0338~NotExists~\u2204~NotGreater~\u226F~NotGreaterEqual~\u2271~NotGreaterFullEqual~\u2267\u0338~NotGreaterGreater~\u226B\u0338~NotGreaterLess~\u2279~NotGreaterSlantEqual~\u2A7E\u0338~NotGreaterTilde~\u2275~NotHumpDownHump~\u224E\u0338~NotHumpEqual~\u224F\u0338~NotLeftTriangle~\u22EA~NotLeftTriangleBar~\u29CF\u0338~NotLeftTriangleEqual~\u22EC~NotLess~\u226E~NotLessEqual~\u2270~NotLessGreater~\u2278~NotLessLess~\u226A\u0338~NotLessSlantEqual~\u2A7D\u0338~NotLessTilde~\u2274~NotNestedGreaterGreater~\u2AA2\u0338~NotNestedLessLess~\u2AA1\u0338~NotPrecedes~\u2280~NotPrecedesEqual~\u2AAF\u0338~NotPrecedesSlantEqual~\u22E0~NotReverseElement~\u220C~NotRightTriangle~\u22EB~NotRightTriangleBar~\u29D0\u0338~NotRightTriangleEqual~\u22ED~NotSquareSubset~\u228F\u0338~NotSquareSubsetEqual~\u22E2~NotSquareSuperset~\u2290\u0338~NotSquareSupersetEqual~\u22E3~NotSubset~\u2282\u20D2~NotSubsetEqual~\u2288~NotSucceeds~\u2281~NotSucceedsEqual~\u2AB0\u0338~NotSucceedsSlantEqual~\u22E1~NotSucceedsTilde~\u227F\u0338~NotSuperset~\u2283\u20D2~NotSupersetEqual~\u2289~NotTilde~\u2241~NotTildeEqual~\u2244~NotTildeFullEqual~\u2247~NotTildeTilde~\u2249~NotVerticalBar~\u2224~Nscr~\uD835\uDCA9~Ocy~\u041E~Odblac~\u0150~Ofr~\uD835\uDD12~Omacr~\u014C~Oopf~\uD835\uDD46~OpenCurlyDoubleQuote~\u201C~OpenCurlyQuote~\u2018~Or~\u2A54~Oscr~\uD835\uDCAA~Otimes~\u2A37~OverBar~\u203E~OverBrace~\u23DE~OverBracket~\u23B4~OverParenthesis~\u23DC~PartialD~\u2202~Pcy~\u041F~Pfr~\uD835\uDD13~PlusMinus~\xb1~Poincareplane~\u210C~Popf~\u2119~Pr~\u2ABB~Precedes~\u227A~PrecedesEqual~\u2AAF~PrecedesSlantEqual~\u227C~PrecedesTilde~\u227E~Product~\u220F~Proportion~\u2237~Proportional~\u221D~Pscr~\uD835\uDCAB~Qfr~\uD835\uDD14~Qopf~\u211A~Qscr~\uD835\uDCAC~RBarr~\u2910~Racute~\u0154~Rang~\u27EB~Rarr~\u21A0~Rarrtl~\u2916~Rcaron~\u0158~Rcedil~\u0156~Rcy~\u0420~Re~\u211C~ReverseElement~\u220B~ReverseEquilibrium~\u21CB~ReverseUpEquilibrium~\u296F~Rfr~\u211C~RightAngleBracket~\u27E9~RightArrow~\u2192~RightArrowBar~\u21E5~RightArrowLeftArrow~\u21C4~RightCeiling~\u2309~RightDoubleBracket~\u27E7~RightDownTeeVector~\u295D~RightDownVector~\u21C2~RightDownVectorBar~\u2955~RightFloor~\u230B~RightTee~\u22A2~RightTeeArrow~\u21A6~RightTeeVector~\u295B~RightTriangle~\u22B3~RightTriangleBar~\u29D0~RightTriangleEqual~\u22B5~RightUpDownVector~\u294F~RightUpTeeVector~\u295C~RightUpVector~\u21BE~RightUpVectorBar~\u2954~RightVector~\u21C0~RightVectorBar~\u2953~Rightarrow~\u21D2~Ropf~\u211D~RoundImplies~\u2970~Rrightarrow~\u21DB~Rscr~\u211B~Rsh~\u21B1~RuleDelayed~\u29F4~SHCHcy~\u0429~SHcy~\u0428~SOFTcy~\u042C~Sacute~\u015A~Sc~\u2ABC~Scedil~\u015E~Scirc~\u015C~Scy~\u0421~Sfr~\uD835\uDD16~ShortDownArrow~\u2193~ShortLeftArrow~\u2190~ShortRightArrow~\u2192~ShortUpArrow~\u2191~SmallCircle~\u2218~Sopf~\uD835\uDD4A~Sqrt~\u221A~Square~\u25A1~SquareIntersection~\u2293~SquareSubset~\u228F~SquareSubsetEqual~\u2291~SquareSuperset~\u2290~SquareSupersetEqual~\u2292~SquareUnion~\u2294~Sscr~\uD835\uDCAE~Star~\u22C6~Sub~\u22D0~Subset~\u22D0~SubsetEqual~\u2286~Succeeds~\u227B~SucceedsEqual~\u2AB0~SucceedsSlantEqual~\u227D~SucceedsTilde~\u227F~SuchThat~\u220B~Sum~\u2211~Sup~\u22D1~Superset~\u2283~SupersetEqual~\u2287~Supset~\u22D1~TRADE~\u2122~TSHcy~\u040B~TScy~\u0426~Tab~	~Tcaron~\u0164~Tcedil~\u0162~Tcy~\u0422~Tfr~\uD835\uDD17~Therefore~\u2234~ThickSpace~\u205F\u200A~ThinSpace~\u2009~Tilde~\u223C~TildeEqual~\u2243~TildeFullEqual~\u2245~TildeTilde~\u2248~Topf~\uD835\uDD4B~TripleDot~\u20DB~Tscr~\uD835\uDCAF~Tstrok~\u0166~Uarr~\u219F~Uarrocir~\u2949~Ubrcy~\u040E~Ubreve~\u016C~Ucy~\u0423~Udblac~\u0170~Ufr~\uD835\uDD18~Umacr~\u016A~UnderBar~_~UnderBrace~\u23DF~UnderBracket~\u23B5~UnderParenthesis~\u23DD~Union~\u22C3~UnionPlus~\u228E~Uogon~\u0172~Uopf~\uD835\uDD4C~UpArrow~\u2191~UpArrowBar~\u2912~UpArrowDownArrow~\u21C5~UpDownArrow~\u2195~UpEquilibrium~\u296E~UpTee~\u22A5~UpTeeArrow~\u21A5~Uparrow~\u21D1~Updownarrow~\u21D5~UpperLeftArrow~\u2196~UpperRightArrow~\u2197~Upsi~\u03D2~Uring~\u016E~Uscr~\uD835\uDCB0~Utilde~\u0168~VDash~\u22AB~Vbar~\u2AEB~Vcy~\u0412~Vdash~\u22A9~Vdashl~\u2AE6~Vee~\u22C1~Verbar~\u2016~Vert~\u2016~VerticalBar~\u2223~VerticalLine~|~VerticalSeparator~\u2758~VerticalTilde~\u2240~VeryThinSpace~\u200A~Vfr~\uD835\uDD19~Vopf~\uD835\uDD4D~Vscr~\uD835\uDCB1~Vvdash~\u22AA~Wcirc~\u0174~Wedge~\u22C0~Wfr~\uD835\uDD1A~Wopf~\uD835\uDD4E~Wscr~\uD835\uDCB2~Xfr~\uD835\uDD1B~Xopf~\uD835\uDD4F~Xscr~\uD835\uDCB3~YAcy~\u042F~YIcy~\u0407~YUcy~\u042E~Ycirc~\u0176~Ycy~\u042B~Yfr~\uD835\uDD1C~Yopf~\uD835\uDD50~Yscr~\uD835\uDCB4~ZHcy~\u0416~Zacute~\u0179~Zcaron~\u017D~Zcy~\u0417~Zdot~\u017B~ZeroWidthSpace~\u200B~Zfr~\u2128~Zopf~\u2124~Zscr~\uD835\uDCB5~abreve~\u0103~ac~\u223E~acE~\u223E\u0333~acd~\u223F~acy~\u0430~af~\u2061~afr~\uD835\uDD1E~aleph~\u2135~amacr~\u0101~amalg~\u2A3F~andand~\u2A55~andd~\u2A5C~andslope~\u2A58~andv~\u2A5A~ange~\u29A4~angle~\u2220~angmsd~\u2221~angmsdaa~\u29A8~angmsdab~\u29A9~angmsdac~\u29AA~angmsdad~\u29AB~angmsdae~\u29AC~angmsdaf~\u29AD~angmsdag~\u29AE~angmsdah~\u29AF~angrt~\u221F~angrtvb~\u22BE~angrtvbd~\u299D~angsph~\u2222~angst~\xc5~angzarr~\u237C~aogon~\u0105~aopf~\uD835\uDD52~ap~\u2248~apE~\u2A70~apacir~\u2A6F~ape~\u224A~apid~\u224B~approx~\u2248~approxeq~\u224A~ascr~\uD835\uDCB6~ast~*~asympeq~\u224D~awconint~\u2233~awint~\u2A11~bNot~\u2AED~backcong~\u224C~backepsilon~\u03F6~backprime~\u2035~backsim~\u223D~backsimeq~\u22CD~barvee~\u22BD~barwed~\u2305~barwedge~\u2305~bbrk~\u23B5~bbrktbrk~\u23B6~bcong~\u224C~bcy~\u0431~becaus~\u2235~because~\u2235~bemptyv~\u29B0~bepsi~\u03F6~bernou~\u212C~beth~\u2136~between~\u226C~bfr~\uD835\uDD1F~bigcap~\u22C2~bigcirc~\u25EF~bigcup~\u22C3~bigodot~\u2A00~bigoplus~\u2A01~bigotimes~\u2A02~bigsqcup~\u2A06~bigstar~\u2605~bigtriangledown~\u25BD~bigtriangleup~\u25B3~biguplus~\u2A04~bigvee~\u22C1~bigwedge~\u22C0~bkarow~\u290D~blacklozenge~\u29EB~blacksquare~\u25AA~blacktriangle~\u25B4~blacktriangledown~\u25BE~blacktriangleleft~\u25C2~blacktriangleright~\u25B8~blank~\u2423~blk12~\u2592~blk14~\u2591~blk34~\u2593~block~\u2588~bne~=\u20E5~bnequiv~\u2261\u20E5~bnot~\u2310~bopf~\uD835\uDD53~bot~\u22A5~bottom~\u22A5~bowtie~\u22C8~boxDL~\u2557~boxDR~\u2554~boxDl~\u2556~boxDr~\u2553~boxH~\u2550~boxHD~\u2566~boxHU~\u2569~boxHd~\u2564~boxHu~\u2567~boxUL~\u255D~boxUR~\u255A~boxUl~\u255C~boxUr~\u2559~boxV~\u2551~boxVH~\u256C~boxVL~\u2563~boxVR~\u2560~boxVh~\u256B~boxVl~\u2562~boxVr~\u255F~boxbox~\u29C9~boxdL~\u2555~boxdR~\u2552~boxdl~\u2510~boxdr~\u250C~boxh~\u2500~boxhD~\u2565~boxhU~\u2568~boxhd~\u252C~boxhu~\u2534~boxminus~\u229F~boxplus~\u229E~boxtimes~\u22A0~boxuL~\u255B~boxuR~\u2558~boxul~\u2518~boxur~\u2514~boxv~\u2502~boxvH~\u256A~boxvL~\u2561~boxvR~\u255E~boxvh~\u253C~boxvl~\u2524~boxvr~\u251C~bprime~\u2035~breve~\u02D8~bscr~\uD835\uDCB7~bsemi~\u204F~bsim~\u223D~bsime~\u22CD~bsol~\\~bsolb~\u29C5~bsolhsub~\u27C8~bullet~\u2022~bump~\u224E~bumpE~\u2AAE~bumpe~\u224F~bumpeq~\u224F~cacute~\u0107~capand~\u2A44~capbrcup~\u2A49~capcap~\u2A4B~capcup~\u2A47~capdot~\u2A40~caps~\u2229\uFE00~caret~\u2041~caron~\u02C7~ccaps~\u2A4D~ccaron~\u010D~ccirc~\u0109~ccups~\u2A4C~ccupssm~\u2A50~cdot~\u010B~cemptyv~\u29B2~centerdot~\xb7~cfr~\uD835\uDD20~chcy~\u0447~check~\u2713~checkmark~\u2713~cir~\u25CB~cirE~\u29C3~circeq~\u2257~circlearrowleft~\u21BA~circlearrowright~\u21BB~circledR~\xae~circledS~\u24C8~circledast~\u229B~circledcirc~\u229A~circleddash~\u229D~cire~\u2257~cirfnint~\u2A10~cirmid~\u2AEF~cirscir~\u29C2~clubsuit~\u2663~colon~:~colone~\u2254~coloneq~\u2254~comma~,~commat~@~comp~\u2201~compfn~\u2218~complement~\u2201~complexes~\u2102~congdot~\u2A6D~conint~\u222E~copf~\uD835\uDD54~coprod~\u2210~copysr~\u2117~cross~\u2717~cscr~\uD835\uDCB8~csub~\u2ACF~csube~\u2AD1~csup~\u2AD0~csupe~\u2AD2~ctdot~\u22EF~cudarrl~\u2938~cudarrr~\u2935~cuepr~\u22DE~cuesc~\u22DF~cularr~\u21B6~cularrp~\u293D~cupbrcap~\u2A48~cupcap~\u2A46~cupcup~\u2A4A~cupdot~\u228D~cupor~\u2A45~cups~\u222A\uFE00~curarr~\u21B7~curarrm~\u293C~curlyeqprec~\u22DE~curlyeqsucc~\u22DF~curlyvee~\u22CE~curlywedge~\u22CF~curvearrowleft~\u21B6~curvearrowright~\u21B7~cuvee~\u22CE~cuwed~\u22CF~cwconint~\u2232~cwint~\u2231~cylcty~\u232D~dHar~\u2965~daleth~\u2138~dash~\u2010~dashv~\u22A3~dbkarow~\u290F~dblac~\u02DD~dcaron~\u010F~dcy~\u0434~dd~\u2146~ddagger~\u2021~ddarr~\u21CA~ddotseq~\u2A77~demptyv~\u29B1~dfisht~\u297F~dfr~\uD835\uDD21~dharl~\u21C3~dharr~\u21C2~diam~\u22C4~diamond~\u22C4~diamondsuit~\u2666~die~\xa8~digamma~\u03DD~disin~\u22F2~div~\xf7~divideontimes~\u22C7~divonx~\u22C7~djcy~\u0452~dlcorn~\u231E~dlcrop~\u230D~dollar~$~dopf~\uD835\uDD55~dot~\u02D9~doteq~\u2250~doteqdot~\u2251~dotminus~\u2238~dotplus~\u2214~dotsquare~\u22A1~doublebarwedge~\u2306~downarrow~\u2193~downdownarrows~\u21CA~downharpoonleft~\u21C3~downharpoonright~\u21C2~drbkarow~\u2910~drcorn~\u231F~drcrop~\u230C~dscr~\uD835\uDCB9~dscy~\u0455~dsol~\u29F6~dstrok~\u0111~dtdot~\u22F1~dtri~\u25BF~dtrif~\u25BE~duarr~\u21F5~duhar~\u296F~dwangle~\u29A6~dzcy~\u045F~dzigrarr~\u27FF~eDDot~\u2A77~eDot~\u2251~easter~\u2A6E~ecaron~\u011B~ecir~\u2256~ecolon~\u2255~ecy~\u044D~edot~\u0117~ee~\u2147~efDot~\u2252~efr~\uD835\uDD22~eg~\u2A9A~egs~\u2A96~egsdot~\u2A98~el~\u2A99~elinters~\u23E7~ell~\u2113~els~\u2A95~elsdot~\u2A97~emacr~\u0113~emptyset~\u2205~emptyv~\u2205~emsp13~\u2004~emsp14~\u2005~eng~\u014B~eogon~\u0119~eopf~\uD835\uDD56~epar~\u22D5~eparsl~\u29E3~eplus~\u2A71~epsi~\u03B5~epsiv~\u03F5~eqcirc~\u2256~eqcolon~\u2255~eqsim~\u2242~eqslantgtr~\u2A96~eqslantless~\u2A95~equals~=~equest~\u225F~equivDD~\u2A78~eqvparsl~\u29E5~erDot~\u2253~erarr~\u2971~escr~\u212F~esdot~\u2250~esim~\u2242~excl~!~expectation~\u2130~exponentiale~\u2147~fallingdotseq~\u2252~fcy~\u0444~female~\u2640~ffilig~\uFB03~fflig~\uFB00~ffllig~\uFB04~ffr~\uD835\uDD23~filig~\uFB01~fjlig~fj~flat~\u266D~fllig~\uFB02~fltns~\u25B1~fopf~\uD835\uDD57~fork~\u22D4~forkv~\u2AD9~fpartint~\u2A0D~frac13~\u2153~frac15~\u2155~frac16~\u2159~frac18~\u215B~frac23~\u2154~frac25~\u2156~frac35~\u2157~frac38~\u215C~frac45~\u2158~frac56~\u215A~frac58~\u215D~frac78~\u215E~frown~\u2322~fscr~\uD835\uDCBB~gE~\u2267~gEl~\u2A8C~gacute~\u01F5~gammad~\u03DD~gap~\u2A86~gbreve~\u011F~gcirc~\u011D~gcy~\u0433~gdot~\u0121~gel~\u22DB~geq~\u2265~geqq~\u2267~geqslant~\u2A7E~ges~\u2A7E~gescc~\u2AA9~gesdot~\u2A80~gesdoto~\u2A82~gesdotol~\u2A84~gesl~\u22DB\uFE00~gesles~\u2A94~gfr~\uD835\uDD24~gg~\u226B~ggg~\u22D9~gimel~\u2137~gjcy~\u0453~gl~\u2277~glE~\u2A92~gla~\u2AA5~glj~\u2AA4~gnE~\u2269~gnap~\u2A8A~gnapprox~\u2A8A~gne~\u2A88~gneq~\u2A88~gneqq~\u2269~gnsim~\u22E7~gopf~\uD835\uDD58~grave~`~gscr~\u210A~gsim~\u2273~gsime~\u2A8E~gsiml~\u2A90~gtcc~\u2AA7~gtcir~\u2A7A~gtdot~\u22D7~gtlPar~\u2995~gtquest~\u2A7C~gtrapprox~\u2A86~gtrarr~\u2978~gtrdot~\u22D7~gtreqless~\u22DB~gtreqqless~\u2A8C~gtrless~\u2277~gtrsim~\u2273~gvertneqq~\u2269\uFE00~gvnE~\u2269\uFE00~hairsp~\u200A~half~\xbd~hamilt~\u210B~hardcy~\u044A~harrcir~\u2948~harrw~\u21AD~hbar~\u210F~hcirc~\u0125~heartsuit~\u2665~hercon~\u22B9~hfr~\uD835\uDD25~hksearow~\u2925~hkswarow~\u2926~hoarr~\u21FF~homtht~\u223B~hookleftarrow~\u21A9~hookrightarrow~\u21AA~hopf~\uD835\uDD59~horbar~\u2015~hscr~\uD835\uDCBD~hslash~\u210F~hstrok~\u0127~hybull~\u2043~hyphen~\u2010~ic~\u2063~icy~\u0438~iecy~\u0435~iff~\u21D4~ifr~\uD835\uDD26~ii~\u2148~iiiint~\u2A0C~iiint~\u222D~iinfin~\u29DC~iiota~\u2129~ijlig~\u0133~imacr~\u012B~imagline~\u2110~imagpart~\u2111~imath~\u0131~imof~\u22B7~imped~\u01B5~in~\u2208~incare~\u2105~infintie~\u29DD~inodot~\u0131~intcal~\u22BA~integers~\u2124~intercal~\u22BA~intlarhk~\u2A17~intprod~\u2A3C~iocy~\u0451~iogon~\u012F~iopf~\uD835\uDD5A~iprod~\u2A3C~iscr~\uD835\uDCBE~isinE~\u22F9~isindot~\u22F5~isins~\u22F4~isinsv~\u22F3~isinv~\u2208~it~\u2062~itilde~\u0129~iukcy~\u0456~jcirc~\u0135~jcy~\u0439~jfr~\uD835\uDD27~jmath~\u0237~jopf~\uD835\uDD5B~jscr~\uD835\uDCBF~jsercy~\u0458~jukcy~\u0454~kappav~\u03F0~kcedil~\u0137~kcy~\u043A~kfr~\uD835\uDD28~kgreen~\u0138~khcy~\u0445~kjcy~\u045C~kopf~\uD835\uDD5C~kscr~\uD835\uDCC0~lAarr~\u21DA~lAtail~\u291B~lBarr~\u290E~lE~\u2266~lEg~\u2A8B~lHar~\u2962~lacute~\u013A~laemptyv~\u29B4~lagran~\u2112~langd~\u2991~langle~\u27E8~lap~\u2A85~larrb~\u21E4~larrbfs~\u291F~larrfs~\u291D~larrhk~\u21A9~larrlp~\u21AB~larrpl~\u2939~larrsim~\u2973~larrtl~\u21A2~lat~\u2AAB~latail~\u2919~late~\u2AAD~lates~\u2AAD\uFE00~lbarr~\u290C~lbbrk~\u2772~lbrace~{~lbrack~[~lbrke~\u298B~lbrksld~\u298F~lbrkslu~\u298D~lcaron~\u013E~lcedil~\u013C~lcub~{~lcy~\u043B~ldca~\u2936~ldquor~\u201E~ldrdhar~\u2967~ldrushar~\u294B~ldsh~\u21B2~leftarrow~\u2190~leftarrowtail~\u21A2~leftharpoondown~\u21BD~leftharpoonup~\u21BC~leftleftarrows~\u21C7~leftrightarrow~\u2194~leftrightarrows~\u21C6~leftrightharpoons~\u21CB~leftrightsquigarrow~\u21AD~leftthreetimes~\u22CB~leg~\u22DA~leq~\u2264~leqq~\u2266~leqslant~\u2A7D~les~\u2A7D~lescc~\u2AA8~lesdot~\u2A7F~lesdoto~\u2A81~lesdotor~\u2A83~lesg~\u22DA\uFE00~lesges~\u2A93~lessapprox~\u2A85~lessdot~\u22D6~lesseqgtr~\u22DA~lesseqqgtr~\u2A8B~lessgtr~\u2276~lesssim~\u2272~lfisht~\u297C~lfr~\uD835\uDD29~lg~\u2276~lgE~\u2A91~lhard~\u21BD~lharu~\u21BC~lharul~\u296A~lhblk~\u2584~ljcy~\u0459~ll~\u226A~llarr~\u21C7~llcorner~\u231E~llhard~\u296B~lltri~\u25FA~lmidot~\u0140~lmoust~\u23B0~lmoustache~\u23B0~lnE~\u2268~lnap~\u2A89~lnapprox~\u2A89~lne~\u2A87~lneq~\u2A87~lneqq~\u2268~lnsim~\u22E6~loang~\u27EC~loarr~\u21FD~lobrk~\u27E6~longleftarrow~\u27F5~longleftrightarrow~\u27F7~longmapsto~\u27FC~longrightarrow~\u27F6~looparrowleft~\u21AB~looparrowright~\u21AC~lopar~\u2985~lopf~\uD835\uDD5D~loplus~\u2A2D~lotimes~\u2A34~lowbar~_~lozenge~\u25CA~lozf~\u29EB~lpar~(~lparlt~\u2993~lrarr~\u21C6~lrcorner~\u231F~lrhar~\u21CB~lrhard~\u296D~lrtri~\u22BF~lscr~\uD835\uDCC1~lsh~\u21B0~lsim~\u2272~lsime~\u2A8D~lsimg~\u2A8F~lsqb~[~lsquor~\u201A~lstrok~\u0142~ltcc~\u2AA6~ltcir~\u2A79~ltdot~\u22D6~lthree~\u22CB~ltimes~\u22C9~ltlarr~\u2976~ltquest~\u2A7B~ltrPar~\u2996~ltri~\u25C3~ltrie~\u22B4~ltrif~\u25C2~lurdshar~\u294A~luruhar~\u2966~lvertneqq~\u2268\uFE00~lvnE~\u2268\uFE00~mDDot~\u223A~male~\u2642~malt~\u2720~maltese~\u2720~map~\u21A6~mapsto~\u21A6~mapstodown~\u21A7~mapstoleft~\u21A4~mapstoup~\u21A5~marker~\u25AE~mcomma~\u2A29~mcy~\u043C~measuredangle~\u2221~mfr~\uD835\uDD2A~mho~\u2127~mid~\u2223~midast~*~midcir~\u2AF0~minusb~\u229F~minusd~\u2238~minusdu~\u2A2A~mlcp~\u2ADB~mldr~\u2026~mnplus~\u2213~models~\u22A7~mopf~\uD835\uDD5E~mp~\u2213~mscr~\uD835\uDCC2~mstpos~\u223E~multimap~\u22B8~mumap~\u22B8~nGg~\u22D9\u0338~nGt~\u226B\u20D2~nGtv~\u226B\u0338~nLeftarrow~\u21CD~nLeftrightarrow~\u21CE~nLl~\u22D8\u0338~nLt~\u226A\u20D2~nLtv~\u226A\u0338~nRightarrow~\u21CF~nVDash~\u22AF~nVdash~\u22AE~nacute~\u0144~nang~\u2220\u20D2~nap~\u2249~napE~\u2A70\u0338~napid~\u224B\u0338~napos~\u0149~napprox~\u2249~natur~\u266E~natural~\u266E~naturals~\u2115~nbump~\u224E\u0338~nbumpe~\u224F\u0338~ncap~\u2A43~ncaron~\u0148~ncedil~\u0146~ncong~\u2247~ncongdot~\u2A6D\u0338~ncup~\u2A42~ncy~\u043D~neArr~\u21D7~nearhk~\u2924~nearr~\u2197~nearrow~\u2197~nedot~\u2250\u0338~nequiv~\u2262~nesear~\u2928~nesim~\u2242\u0338~nexist~\u2204~nexists~\u2204~nfr~\uD835\uDD2B~ngE~\u2267\u0338~nge~\u2271~ngeq~\u2271~ngeqq~\u2267\u0338~ngeqslant~\u2A7E\u0338~nges~\u2A7E\u0338~ngsim~\u2275~ngt~\u226F~ngtr~\u226F~nhArr~\u21CE~nharr~\u21AE~nhpar~\u2AF2~nis~\u22FC~nisd~\u22FA~niv~\u220B~njcy~\u045A~nlArr~\u21CD~nlE~\u2266\u0338~nlarr~\u219A~nldr~\u2025~nle~\u2270~nleftarrow~\u219A~nleftrightarrow~\u21AE~nleq~\u2270~nleqq~\u2266\u0338~nleqslant~\u2A7D\u0338~nles~\u2A7D\u0338~nless~\u226E~nlsim~\u2274~nlt~\u226E~nltri~\u22EA~nltrie~\u22EC~nmid~\u2224~nopf~\uD835\uDD5F~notinE~\u22F9\u0338~notindot~\u22F5\u0338~notinva~\u2209~notinvb~\u22F7~notinvc~\u22F6~notni~\u220C~notniva~\u220C~notnivb~\u22FE~notnivc~\u22FD~npar~\u2226~nparallel~\u2226~nparsl~\u2AFD\u20E5~npart~\u2202\u0338~npolint~\u2A14~npr~\u2280~nprcue~\u22E0~npre~\u2AAF\u0338~nprec~\u2280~npreceq~\u2AAF\u0338~nrArr~\u21CF~nrarr~\u219B~nrarrc~\u2933\u0338~nrarrw~\u219D\u0338~nrightarrow~\u219B~nrtri~\u22EB~nrtrie~\u22ED~nsc~\u2281~nsccue~\u22E1~nsce~\u2AB0\u0338~nscr~\uD835\uDCC3~nshortmid~\u2224~nshortparallel~\u2226~nsim~\u2241~nsime~\u2244~nsimeq~\u2244~nsmid~\u2224~nspar~\u2226~nsqsube~\u22E2~nsqsupe~\u22E3~nsubE~\u2AC5\u0338~nsube~\u2288~nsubset~\u2282\u20D2~nsubseteq~\u2288~nsubseteqq~\u2AC5\u0338~nsucc~\u2281~nsucceq~\u2AB0\u0338~nsup~\u2285~nsupE~\u2AC6\u0338~nsupe~\u2289~nsupset~\u2283\u20D2~nsupseteq~\u2289~nsupseteqq~\u2AC6\u0338~ntgl~\u2279~ntlg~\u2278~ntriangleleft~\u22EA~ntrianglelefteq~\u22EC~ntriangleright~\u22EB~ntrianglerighteq~\u22ED~num~#~numero~\u2116~numsp~\u2007~nvDash~\u22AD~nvHarr~\u2904~nvap~\u224D\u20D2~nvdash~\u22AC~nvge~\u2265\u20D2~nvgt~>\u20D2~nvinfin~\u29DE~nvlArr~\u2902~nvle~\u2264\u20D2~nvlt~<\u20D2~nvltrie~\u22B4\u20D2~nvrArr~\u2903~nvrtrie~\u22B5\u20D2~nvsim~\u223C\u20D2~nwArr~\u21D6~nwarhk~\u2923~nwarr~\u2196~nwarrow~\u2196~nwnear~\u2927~oS~\u24C8~oast~\u229B~ocir~\u229A~ocy~\u043E~odash~\u229D~odblac~\u0151~odiv~\u2A38~odot~\u2299~odsold~\u29BC~ofcir~\u29BF~ofr~\uD835\uDD2C~ogon~\u02DB~ogt~\u29C1~ohbar~\u29B5~ohm~\u03A9~oint~\u222E~olarr~\u21BA~olcir~\u29BE~olcross~\u29BB~olt~\u29C0~omacr~\u014D~omid~\u29B6~ominus~\u2296~oopf~\uD835\uDD60~opar~\u29B7~operp~\u29B9~orarr~\u21BB~ord~\u2A5D~order~\u2134~orderof~\u2134~origof~\u22B6~oror~\u2A56~orslope~\u2A57~orv~\u2A5B~oscr~\u2134~osol~\u2298~otimesas~\u2A36~ovbar~\u233D~par~\u2225~parallel~\u2225~parsim~\u2AF3~parsl~\u2AFD~pcy~\u043F~percnt~%~period~.~pertenk~\u2031~pfr~\uD835\uDD2D~phiv~\u03D5~phmmat~\u2133~phone~\u260E~pitchfork~\u22D4~planck~\u210F~planckh~\u210E~plankv~\u210F~plus~+~plusacir~\u2A23~plusb~\u229E~pluscir~\u2A22~plusdo~\u2214~plusdu~\u2A25~pluse~\u2A72~plussim~\u2A26~plustwo~\u2A27~pm~\xb1~pointint~\u2A15~popf~\uD835\uDD61~pr~\u227A~prE~\u2AB3~prap~\u2AB7~prcue~\u227C~pre~\u2AAF~prec~\u227A~precapprox~\u2AB7~preccurlyeq~\u227C~preceq~\u2AAF~precnapprox~\u2AB9~precneqq~\u2AB5~precnsim~\u22E8~precsim~\u227E~primes~\u2119~prnE~\u2AB5~prnap~\u2AB9~prnsim~\u22E8~profalar~\u232E~profline~\u2312~profsurf~\u2313~propto~\u221D~prsim~\u227E~prurel~\u22B0~pscr~\uD835\uDCC5~puncsp~\u2008~qfr~\uD835\uDD2E~qint~\u2A0C~qopf~\uD835\uDD62~qprime~\u2057~qscr~\uD835\uDCC6~quaternions~\u210D~quatint~\u2A16~quest~?~questeq~\u225F~rAarr~\u21DB~rAtail~\u291C~rBarr~\u290F~rHar~\u2964~race~\u223D\u0331~racute~\u0155~raemptyv~\u29B3~rangd~\u2992~range~\u29A5~rangle~\u27E9~rarrap~\u2975~rarrb~\u21E5~rarrbfs~\u2920~rarrc~\u2933~rarrfs~\u291E~rarrhk~\u21AA~rarrlp~\u21AC~rarrpl~\u2945~rarrsim~\u2974~rarrtl~\u21A3~rarrw~\u219D~ratail~\u291A~ratio~\u2236~rationals~\u211A~rbarr~\u290D~rbbrk~\u2773~rbrace~}~rbrack~]~rbrke~\u298C~rbrksld~\u298E~rbrkslu~\u2990~rcaron~\u0159~rcedil~\u0157~rcub~}~rcy~\u0440~rdca~\u2937~rdldhar~\u2969~rdquor~\u201D~rdsh~\u21B3~realine~\u211B~realpart~\u211C~reals~\u211D~rect~\u25AD~rfisht~\u297D~rfr~\uD835\uDD2F~rhard~\u21C1~rharu~\u21C0~rharul~\u296C~rhov~\u03F1~rightarrow~\u2192~rightarrowtail~\u21A3~rightharpoondown~\u21C1~rightharpoonup~\u21C0~rightleftarrows~\u21C4~rightleftharpoons~\u21CC~rightrightarrows~\u21C9~rightsquigarrow~\u219D~rightthreetimes~\u22CC~ring~\u02DA~risingdotseq~\u2253~rlarr~\u21C4~rlhar~\u21CC~rmoust~\u23B1~rmoustache~\u23B1~rnmid~\u2AEE~roang~\u27ED~roarr~\u21FE~robrk~\u27E7~ropar~\u2986~ropf~\uD835\uDD63~roplus~\u2A2E~rotimes~\u2A35~rpar~)~rpargt~\u2994~rppolint~\u2A12~rrarr~\u21C9~rscr~\uD835\uDCC7~rsh~\u21B1~rsqb~]~rsquor~\u2019~rthree~\u22CC~rtimes~\u22CA~rtri~\u25B9~rtrie~\u22B5~rtrif~\u25B8~rtriltri~\u29CE~ruluhar~\u2968~rx~\u211E~sacute~\u015B~sc~\u227B~scE~\u2AB4~scap~\u2AB8~sccue~\u227D~sce~\u2AB0~scedil~\u015F~scirc~\u015D~scnE~\u2AB6~scnap~\u2ABA~scnsim~\u22E9~scpolint~\u2A13~scsim~\u227F~scy~\u0441~sdotb~\u22A1~sdote~\u2A66~seArr~\u21D8~searhk~\u2925~searr~\u2198~searrow~\u2198~semi~;~seswar~\u2929~setminus~\u2216~setmn~\u2216~sext~\u2736~sfr~\uD835\uDD30~sfrown~\u2322~sharp~\u266F~shchcy~\u0449~shcy~\u0448~shortmid~\u2223~shortparallel~\u2225~sigmav~\u03C2~simdot~\u2A6A~sime~\u2243~simeq~\u2243~simg~\u2A9E~simgE~\u2AA0~siml~\u2A9D~simlE~\u2A9F~simne~\u2246~simplus~\u2A24~simrarr~\u2972~slarr~\u2190~smallsetminus~\u2216~smashp~\u2A33~smeparsl~\u29E4~smid~\u2223~smile~\u2323~smt~\u2AAA~smte~\u2AAC~smtes~\u2AAC\uFE00~softcy~\u044C~sol~/~solb~\u29C4~solbar~\u233F~sopf~\uD835\uDD64~spadesuit~\u2660~spar~\u2225~sqcap~\u2293~sqcaps~\u2293\uFE00~sqcup~\u2294~sqcups~\u2294\uFE00~sqsub~\u228F~sqsube~\u2291~sqsubset~\u228F~sqsubseteq~\u2291~sqsup~\u2290~sqsupe~\u2292~sqsupset~\u2290~sqsupseteq~\u2292~squ~\u25A1~square~\u25A1~squarf~\u25AA~squf~\u25AA~srarr~\u2192~sscr~\uD835\uDCC8~ssetmn~\u2216~ssmile~\u2323~sstarf~\u22C6~star~\u2606~starf~\u2605~straightepsilon~\u03F5~straightphi~\u03D5~strns~\xaf~subE~\u2AC5~subdot~\u2ABD~subedot~\u2AC3~submult~\u2AC1~subnE~\u2ACB~subne~\u228A~subplus~\u2ABF~subrarr~\u2979~subset~\u2282~subseteq~\u2286~subseteqq~\u2AC5~subsetneq~\u228A~subsetneqq~\u2ACB~subsim~\u2AC7~subsub~\u2AD5~subsup~\u2AD3~succ~\u227B~succapprox~\u2AB8~succcurlyeq~\u227D~succeq~\u2AB0~succnapprox~\u2ABA~succneqq~\u2AB6~succnsim~\u22E9~succsim~\u227F~sung~\u266A~supE~\u2AC6~supdot~\u2ABE~supdsub~\u2AD8~supedot~\u2AC4~suphsol~\u27C9~suphsub~\u2AD7~suplarr~\u297B~supmult~\u2AC2~supnE~\u2ACC~supne~\u228B~supplus~\u2AC0~supset~\u2283~supseteq~\u2287~supseteqq~\u2AC6~supsetneq~\u228B~supsetneqq~\u2ACC~supsim~\u2AC8~supsub~\u2AD4~supsup~\u2AD6~swArr~\u21D9~swarhk~\u2926~swarr~\u2199~swarrow~\u2199~swnwar~\u292A~target~\u2316~tbrk~\u23B4~tcaron~\u0165~tcedil~\u0163~tcy~\u0442~tdot~\u20DB~telrec~\u2315~tfr~\uD835\uDD31~therefore~\u2234~thetav~\u03D1~thickapprox~\u2248~thicksim~\u223C~thkap~\u2248~thksim~\u223C~timesb~\u22A0~timesbar~\u2A31~timesd~\u2A30~tint~\u222D~toea~\u2928~top~\u22A4~topbot~\u2336~topcir~\u2AF1~topf~\uD835\uDD65~topfork~\u2ADA~tosa~\u2929~tprime~\u2034~triangle~\u25B5~triangledown~\u25BF~triangleleft~\u25C3~trianglelefteq~\u22B4~triangleq~\u225C~triangleright~\u25B9~trianglerighteq~\u22B5~tridot~\u25EC~trie~\u225C~triminus~\u2A3A~triplus~\u2A39~trisb~\u29CD~tritime~\u2A3B~trpezium~\u23E2~tscr~\uD835\uDCC9~tscy~\u0446~tshcy~\u045B~tstrok~\u0167~twixt~\u226C~twoheadleftarrow~\u219E~twoheadrightarrow~\u21A0~uHar~\u2963~ubrcy~\u045E~ubreve~\u016D~ucy~\u0443~udarr~\u21C5~udblac~\u0171~udhar~\u296E~ufisht~\u297E~ufr~\uD835\uDD32~uharl~\u21BF~uharr~\u21BE~uhblk~\u2580~ulcorn~\u231C~ulcorner~\u231C~ulcrop~\u230F~ultri~\u25F8~umacr~\u016B~uogon~\u0173~uopf~\uD835\uDD66~uparrow~\u2191~updownarrow~\u2195~upharpoonleft~\u21BF~upharpoonright~\u21BE~uplus~\u228E~upsi~\u03C5~upuparrows~\u21C8~urcorn~\u231D~urcorner~\u231D~urcrop~\u230E~uring~\u016F~urtri~\u25F9~uscr~\uD835\uDCCA~utdot~\u22F0~utilde~\u0169~utri~\u25B5~utrif~\u25B4~uuarr~\u21C8~uwangle~\u29A7~vArr~\u21D5~vBar~\u2AE8~vBarv~\u2AE9~vDash~\u22A8~vangrt~\u299C~varepsilon~\u03F5~varkappa~\u03F0~varnothing~\u2205~varphi~\u03D5~varpi~\u03D6~varpropto~\u221D~varr~\u2195~varrho~\u03F1~varsigma~\u03C2~varsubsetneq~\u228A\uFE00~varsubsetneqq~\u2ACB\uFE00~varsupsetneq~\u228B\uFE00~varsupsetneqq~\u2ACC\uFE00~vartheta~\u03D1~vartriangleleft~\u22B2~vartriangleright~\u22B3~vcy~\u0432~vdash~\u22A2~vee~\u2228~veebar~\u22BB~veeeq~\u225A~vellip~\u22EE~verbar~|~vert~|~vfr~\uD835\uDD33~vltri~\u22B2~vnsub~\u2282\u20D2~vnsup~\u2283\u20D2~vopf~\uD835\uDD67~vprop~\u221D~vrtri~\u22B3~vscr~\uD835\uDCCB~vsubnE~\u2ACB\uFE00~vsubne~\u228A\uFE00~vsupnE~\u2ACC\uFE00~vsupne~\u228B\uFE00~vzigzag~\u299A~wcirc~\u0175~wedbar~\u2A5F~wedge~\u2227~wedgeq~\u2259~wfr~\uD835\uDD34~wopf~\uD835\uDD68~wp~\u2118~wr~\u2240~wreath~\u2240~wscr~\uD835\uDCCC~xcap~\u22C2~xcirc~\u25EF~xcup~\u22C3~xdtri~\u25BD~xfr~\uD835\uDD35~xhArr~\u27FA~xharr~\u27F7~xlArr~\u27F8~xlarr~\u27F5~xmap~\u27FC~xnis~\u22FB~xodot~\u2A00~xopf~\uD835\uDD69~xoplus~\u2A01~xotime~\u2A02~xrArr~\u27F9~xrarr~\u27F6~xscr~\uD835\uDCCD~xsqcup~\u2A06~xuplus~\u2A04~xutri~\u25B3~xvee~\u22C1~xwedge~\u22C0~yacy~\u044F~ycirc~\u0177~ycy~\u044B~yfr~\uD835\uDD36~yicy~\u0457~yopf~\uD835\uDD6A~yscr~\uD835\uDCCE~yucy~\u044E~zacute~\u017A~zcaron~\u017E~zcy~\u0437~zdot~\u017C~zeetrf~\u2128~zfr~\uD835\uDD37~zhcy~\u0436~zigrarr~\u21DD~zopf~\uD835\uDD6B~zscr~\uD835\uDCCF~~AMP~&~COPY~\xa9~GT~>~LT~<~QUOT~"~REG~\xae', namedReferences['html4']);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7vPXL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numericUnicodeMap", ()=>numericUnicodeMap);
var numericUnicodeMap = {
    0: 65533,
    128: 8364,
    130: 8218,
    131: 402,
    132: 8222,
    133: 8230,
    134: 8224,
    135: 8225,
    136: 710,
    137: 8240,
    138: 352,
    139: 8249,
    140: 338,
    142: 381,
    145: 8216,
    146: 8217,
    147: 8220,
    148: 8221,
    149: 8226,
    150: 8211,
    151: 8212,
    152: 732,
    153: 8482,
    154: 353,
    155: 8250,
    156: 339,
    158: 382,
    159: 376
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"1rrcm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromCodePoint", ()=>fromCodePoint);
parcelHelpers.export(exports, "getCodePoint", ()=>getCodePoint);
parcelHelpers.export(exports, "highSurrogateFrom", ()=>highSurrogateFrom);
parcelHelpers.export(exports, "highSurrogateTo", ()=>highSurrogateTo);
var fromCodePoint = String.fromCodePoint || function(astralCodePoint) {
    return String.fromCharCode(Math.floor((astralCodePoint - 0x10000) / 0x400) + 0xd800, (astralCodePoint - 0x10000) % 0x400 + 0xdc00);
};
var getCodePoint = String.prototype.codePointAt ? function(input, position) {
    return input.codePointAt(position);
} : function(input, position) {
    return (input.charCodeAt(position) - 0xd800) * 0x400 + input.charCodeAt(position + 1) - 0xdc00 + 0x10000;
};
var highSurrogateFrom = 0xd800;
var highSurrogateTo = 0xdbff;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"gNK1B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _htmlEntities = require("html-entities");
var _luxon = require("luxon");
var _utilities = require("../../../utilities");
var _utilitiesDefault = parcelHelpers.interopDefault(_utilities);
var _skeleton = require("../../../components/common/skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _submitButton = require("../../../components/common/submitButton");
var _submitButtonDefault = parcelHelpers.interopDefault(_submitButton);
var _notice = require("../../common/notice");
var _noticeDefault = parcelHelpers.interopDefault(_notice);
var _useFetchMessages = require("../../hooks/fetch/useFetchMessages");
var _useStore = require("../../hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
const today = (0, _luxon.DateTime).now().toFormat("dd/MM/yyyy");
const yesterday = (0, _luxon.DateTime).now().minus({
    days: 1
}).toFormat("dd/MM/yyyy");
// Helper function to take a given date, and return 'today', 'yesterday', or a formatted date
const formatDate = (dateString)=>{
    const dateObj = (0, _luxon.DateTime).fromISO(dateString);
    if (!dateObj.isValid) return null;
    const formattedDate = dateObj.toFormat("dd/MM/yyyy");
    return formattedDate === today ? "Today" : formattedDate === yesterday ? "Yesterday" : formattedDate;
};
const Conversation = ({ messages: messagesInit, recipient, loading, onBusy })=>{
    const clientRef = (0, _useStoreDefault.default)((state)=>state.clientRef);
    // holds the current value of the reply message
    const [reply, setReply] = (0, _react.useState)("");
    const { mutate: createMessage } = (0, _useFetchMessages.useCreateMessage)({
        userId: recipient,
        account: clientRef,
        callback: ()=>{
            if (onBusy) onBusy(false);
            setReply("");
        }
    });
    const { data: messages, isLoading: isConversationLoading } = (0, _useFetchMessages.useFetchConversation)({
        account: clientRef,
        userId: recipient
    });
    // Helper action functions
    const doReplyChange = (event)=>{
        setReply(event.target.value);
    };
    const doSendReply = ()=>{
        if (reply === "") return;
        if (onBusy) onBusy(true);
        createMessage({
            message: reply
        });
    };
    const conversation = messages || messagesInit;
    const hasConversation = (conversation === null || conversation === void 0 ? void 0 : conversation.length) > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                type: "messages"
            }),
            !loading && !hasConversation && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "inbox-messages",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noticeDefault.default), {
                    message: "No messages found",
                    type: "info"
                })
            }),
            !loading && hasConversation && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: recipient > 0 ? "messages-conversation" : "messages-conversation messages-conversation__admin",
                children: hasConversation && (conversation === null || conversation === void 0 ? void 0 : conversation.map((message, i)=>{
                    var _conversation_, _utils_stripTags_split, _utils_stripTags;
                    // If conversation is with system, only show sender messages
                    if (recipient === 0 && message.isMe) return null;
                    // Format date and time to display
                    const formattedDate = formatDate(message.dateTime);
                    conversation[i].formattedDate = formattedDate;
                    const formattedTime = formattedDate ? (0, _luxon.DateTime).fromISO(message.dateTime).toFormat("h:mm a") : null;
                    // Only show the date if it's different to the previous message
                    const shouldShowDate = formattedDate && formattedDate !== ((_conversation_ = conversation[i - 1]) === null || _conversation_ === void 0 ? void 0 : _conversation_.formattedDate);
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            shouldShowDate && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "messages-conversation-date",
                                children: formattedDate
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: message.isMe ? "messages-conversation-message messages-conversation-message__me" : "messages-conversation-message",
                                children: [
                                    formattedTime && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "messages-conversation-time",
                                        children: formattedTime
                                    }),
                                    message.fromUserId > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                        children: (_utils_stripTags = (0, _utilitiesDefault.default).stripTags((0, _htmlEntities.decode)(message.message), true)) === null || _utils_stripTags === void 0 ? void 0 : (_utils_stripTags_split = _utils_stripTags.split("<br />")) === null || _utils_stripTags_split === void 0 ? void 0 : _utils_stripTags_split.map((paragraph, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                                children: paragraph && paragraph !== "&nbsp;" && paragraph !== " " && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    children: paragraph
                                                }, key)
                                            }))
                                    }),
                                    message.fromUserId === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "inbox-message-message",
                                        dangerouslySetInnerHTML: true && {
                                            __html: message.message
                                        }
                                    })
                                ]
                            }, i)
                        ]
                    });
                }))
            }),
            recipient > 0 && !loading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "messages-reply",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                        className: "messages-reply-textarea",
                        value: reply,
                        autoFocus: true,
                        onChange: doReplyChange
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _submitButtonDefault.default), {
                        label: "Send",
                        onSubmit: doSendReply
                    })
                ]
            })
        ]
    });
};
exports.default = Conversation;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","html-entities":"27yUb","luxon":"24mCD","../../../utilities":"fkdv9","../../../components/common/skeleton":"fLZ02","../../../components/common/submitButton":"4bi2T","../../common/notice":"bnY7j","../../hooks/fetch/useFetchMessages":"3hiet","../../hooks/useStore":"l1Yj7","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3hiet":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFetchInbox", ()=>useFetchInbox);
parcelHelpers.export(exports, "useFetchNotifications", ()=>useFetchNotifications);
parcelHelpers.export(exports, "useMarkNotificationsRead", ()=>useMarkNotificationsRead);
parcelHelpers.export(exports, "useDeleteNotification", ()=>useDeleteNotification);
parcelHelpers.export(exports, "useFetchConversation", ()=>useFetchConversation);
parcelHelpers.export(exports, "useCreateMessage", ()=>useCreateMessage);
var _reactQuery = require("react-query");
var _fetchJs = require("../../../utilities/fetch.js");
const useFetchInbox = ({ callback })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: 'messagesInbox'
    });
    return (0, _reactQuery.useQuery)([
        'messagesInbox'
    ], ()=>{
        const isAdmin = !!(localStorage.getItem('admin') === 'true');
        if (isAdmin) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: '/messages/inbox?separateSystemMessages=true'
        });
    }, {
        refetchInterval: 10000,
        staleTime: 60000,
        select: (data)=>{
            var _data_data;
            return (data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.items) || [];
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useFetchNotifications = ({ callback })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: 'notifications'
    });
    return (0, _reactQuery.useQuery)([
        'notifications'
    ], ()=>{
        const isAdmin = !!(localStorage.getItem('admin') === 'true');
        if (isAdmin) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: '/notifications'
        });
    }, {
        refetchInterval: 10000,
        staleTime: 60000,
        select: (data)=>{
            var _data_data;
            return (data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.items) || [];
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useMarkNotificationsRead = ({ callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)(()=>{
        return (0, _fetchJs.request)({
            url: `/notifications/read`,
            method: 'post'
        });
    }, {
        mutationKey: 'notifications',
        onMutate: async (data)=>{
            await queryClient.cancelQueries([
                'notifications'
            ]);
        },
        onSettled: ()=>{
            queryClient.invalidateQueries([
                'notifications'
            ]);
        },
        onSuccess: ()=>{
            if (callback && typeof callback != 'undefined') callback();
        }
    });
};
const useDeleteNotification = ({ callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((notificationId)=>{
        return (0, _fetchJs.request)({
            url: `/notifications/${notificationId}`,
            method: 'delete'
        });
    }, {
        mutationKey: 'notifications',
        onMutate: async (notificationId)=>{
            var _currentNotifications_data_items, _currentNotifications_data;
            await queryClient.cancelQueries([
                'notifications'
            ]);
            const currentNotifications = queryClient.getQueryData([
                'notifications'
            ]);
            // optimistic update data
            if ((currentNotifications === null || currentNotifications === void 0 ? void 0 : (_currentNotifications_data = currentNotifications.data) === null || _currentNotifications_data === void 0 ? void 0 : (_currentNotifications_data_items = _currentNotifications_data.items) === null || _currentNotifications_data_items === void 0 ? void 0 : _currentNotifications_data_items.length) > 0) {
                const updated = [
                    ...currentNotifications.data.items
                ];
                const deleteIndex = updated.findIndex((notification)=>(notification === null || notification === void 0 ? void 0 : notification.notificationId) === notificationId);
                updated.splice(deleteIndex, 1);
                await queryClient.setQueryData([
                    'notifications'
                ], {
                    data: {
                        items: [
                            ...updated
                        ]
                    }
                });
            }
        },
        onSettled: ()=>{
            queryClient.invalidateQueries([
                'notifications'
            ]);
        },
        onSuccess: callback
    });
};
const useFetchConversation = ({ account = null, callback, userId })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: 'messagesInbox'
    });
    return (0, _reactQuery.useQuery)([
        'messagesConversation',
        userId
    ], ()=>{
        if (userId < 0 || userId === null || userId === undefined) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/messages/conversation/${userId}`,
            params: {
                account
            }
        });
    }, {
        refetchInterval: true,
        staleTime: 10000,
        select: (data)=>{
            var _data_data;
            return data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.items;
        },
        onSuccess: async ()=>{
            await queryClient.invalidateQueries([
                'messagesInbox'
            ]);
            if (callback) callback();
        },
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useCreateMessage = ({ account = null, userId, callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data)=>{
        if (!data) return Promise.resolve({});
        const sendData = {
            ...data
        };
        delete sendData.id;
        return (0, _fetchJs.request)({
            url: `/messages/${userId}`,
            params: {
                account
            },
            method: 'post',
            data: sendData
        });
    }, {
        mutationKey: 'messagesInbox',
        onMutate: async (data)=>{
            await queryClient.cancelQueries([
                'messagesConversation',
                userId
            ]);
        },
        onSettled: ()=>{
            queryClient.invalidateQueries([
                'messagesConversation',
                userId
            ]);
        },
        onSuccess: (data)=>{
            if (callback && typeof callback != 'undefined') callback(data);
        }
    });
};

},{"react-query":"41hyj","../../../utilities/fetch.js":"hAKRo","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7a3Vi":[function() {},{}],"3ufLm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _imageBrowse = require("./imageBrowse");
var _imageBrowseDefault = parcelHelpers.interopDefault(_imageBrowse);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _akarIcons = require("akar-icons");
var _useFetchResources = require("../hooks/fetch/useFetchResources");
const ImageSelect = ({ account, imageSlug, busy, onSelect = null })=>{
    const [allTags, setAllTags] = (0, _react.useState)(null);
    const [filterTags, setFilterTags] = (0, _react.useState)(null);
    const { data: images, isImagesPending } = (0, _useFetchResources.useFetchResources)({
        account: account
    });
    const { data: folders, isTagsPending } = (0, _useFetchResources.useFetchFolders)({
        account: account
    });
    (0, _react.useEffect)(()=>{
        let tags = [];
        if (folders) {
            folders === null || folders === void 0 ? void 0 : folders.map((tag)=>{
                if (tag.folderId && tag.description && tag.type === "images") tags.push({
                    value: tag.folderId,
                    label: tag.description
                });
            });
            setAllTags(tags);
        }
    }, [
        folders
    ]);
    const doChangeFilters = (tags)=>{
        let filterTags = [];
        tags.map((tag)=>{
            filterTags.push(tag.value);
        });
        setFilterTags(filterTags);
    };
    const skeleton = isImagesPending || isTagsPending;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                isMulti: true,
                options: allTags,
                className: "select",
                classNamePrefix: "select",
                placeholder: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "select-placeholder",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.Tag), {
                            size: "16"
                        }),
                        " Tags"
                    ]
                }),
                onChange: doChangeFilters
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            account && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _imageBrowseDefault.default), {
                type: "images",
                data: images,
                selectedImageSlug: imageSlug,
                skeleton: skeleton,
                account: account,
                allowDrop: true,
                editIcons: false,
                showFileUpload: false,
                busy: busy,
                filterTags: filterTags,
                allTags: allTags,
                onClick: onSelect,
                onUpload: null,
                onChangeTags: null,
                onTagCreate: null,
                onDownloadFile: null
            })
        ]
    });
};
exports.default = ImageSelect;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","./imageBrowse":"aEGZM","react-select":"7k7ya","akar-icons":"b8xdj","../hooks/fetch/useFetchResources":"wHeKG","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"aEGZM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDropzone = require("react-dropzone");
var _utilities = require("../../utilities");
var _utilitiesDefault = parcelHelpers.interopDefault(_utilities);
var _throbber = require("./throbber");
var _throbberDefault = parcelHelpers.interopDefault(_throbber);
var _skeleton = require("./skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _editableText = require("./editableText");
var _editableTextDefault = parcelHelpers.interopDefault(_editableText);
var _tags = require("./tags");
var _tagsDefault = parcelHelpers.interopDefault(_tags);
var _svg = require("./svg");
var _svgDefault = parcelHelpers.interopDefault(_svg);
var _akarIcons = require("akar-icons");
var _useFetchResources = require("../hooks/fetch/useFetchResources");
const ImageBrowse = ({ type = 'images', skeleton = false, data, selectedImageSlug, account, disabled = false, editIcons = false, allowDrop = false, filterTags = null, allTags = [], showFileUpload = false, busy = false, onDelete, onClick, onUpload, onUploadBrowse, onRename, onChangeTags, onTagCreate, onTagDelete, onDownloadFile })=>{
    const [previewImageSlug, setPreviewImageSlug] = (0, _react.useState)();
    const { data: previewImage, isImagePending } = (0, _useFetchResources.useFetchImage)({
        account: account,
        imageSlug: previewImageSlug
    });
    const [images, setImages] = (0, _react.useState)(data);
    const [uploadReplaceId, setUploadReplaceId] = (0, _react.useState)();
    const [browseFiles, setBrowseFiles] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        setBrowseFiles(!!showFileUpload);
        setUploadReplaceId(showFileUpload && Array.isArray(showFileUpload) && showFileUpload[0] ? showFileUpload[0] : null);
    }, [
        showFileUpload
    ]);
    (0, _react.useEffect)(()=>{
        if (data) setImages(data);
    }, [
        data
    ]);
    const imageAccept = {
        'image/png': [
            '.png'
        ],
        'image/jpeg': [
            '.jpg',
            '.jpeg'
        ],
        'image/webp': [
            '.webp'
        ],
        'image/svg+xml': [
            '.svg'
        ],
        'image/avif': [
            '.avif'
        ]
    };
    const fileAccept = {
        ...imageAccept,
        'video/mp4': [
            '.mp4'
        ],
        'video/ogg': [
            '.ogv'
        ],
        'video/webm': [
            '.webm'
        ],
        'video/3gpp': [
            '.3gp',
            '.3gpp'
        ],
        'audio/mpeg3': [
            '.mp3'
        ],
        'audio/aac': [
            '.aac'
        ],
        'audio/ogg': [
            '.ogg'
        ],
        'application/vnd.ms-excel': [
            '.xls',
            '.xlsx'
        ],
        'application/msword': [
            '.doc',
            '.docx'
        ],
        'application/vnd.ms-powerpoint': [
            '.ppt',
            '.pptx'
        ],
        'application/pdf': [
            '.pdf'
        ],
        'application/rtf': [
            '.rtf'
        ],
        'text/csv': [
            '.csv'
        ],
        'text/plain': [
            '.txt'
        ],
        'application/zip': [
            '.zip'
        ],
        'application/gzip': [
            '.gzip'
        ]
    };
    const { getRootProps, getInputProps, acceptedFiles, isFocused, isDragAccept, isDragReject } = (0, _reactDropzone.useDropzone)({
        noClick: true,
        accept: type === 'images' ? imageAccept : fileAccept,
        onDragEnter: ()=>{
            // if this is called, user is using drag/drop, so we need to clear replacement id
            setUploadReplaceId(null);
        },
        onDrop: (files)=>{
            if (onUpload && files && files.length > 0) onUpload(files, uploadReplaceId);
        },
        multiple: true
    });
    const doDelete = (e, id)=>{
        e.preventDefault();
        if (onDelete) onDelete(id);
    };
    const doRename = (id, value)=>{
        if (onRename) onRename(id, value);
    };
    const doUpload = (e, id)=>{
        e.preventDefault();
        if (onUploadBrowse) onUploadBrowse(id);
    };
    const doPreviewImage = (image)=>{
        if (!onClick) return setPreviewImageSlug(image === null || image === void 0 ? void 0 : image.slug);
        return onClick(image);
    };
    const doChangeTags = (id, tags)=>{
        const folder = tags && tags.length > 0 ? {
            folderId: tags[0].value,
            description: tags[0].label
        } : {};
        const imageIndex = images.findIndex((image)=>image.imageId === id ? true : false);
        if (imageIndex > -1) {
            const newImages = [
                ...images
            ];
            newImages[imageIndex].folder = folder;
            setImages(newImages);
        }
        onChangeTags && onChangeTags(id, tags);
    };
    (0, _react.useEffect)(()=>{
        if (browseFiles) {
            hiddenFileInput === null || hiddenFileInput === void 0 ? void 0 : hiddenFileInput.current.click();
            setBrowseFiles(false);
        }
    }, [
        browseFiles
    ]);
    const hiddenFileInput = (0, _react.useRef)(null);
    const getStyle = (image)=>{
        var _image_folder, _image_folder1;
        if (filterTags && filterTags.length > 0 && (!((_image_folder = image.folder) === null || _image_folder === void 0 ? void 0 : _image_folder.folderId) || !filterTags.includes((_image_folder1 = image.folder) === null || _image_folder1 === void 0 ? void 0 : _image_folder1.folderId))) return {
            display: 'none'
        };
        return {};
    };
    const classNameMod = (0, _react.useMemo)(()=>{
        if (isFocused) return 'file-drop-target__focused';
        if (isDragAccept) {
            accepted = true;
            return 'file-drop-target__accepted';
        }
        if (isDragReject) {
            rejected = true;
            return 'file-drop-target__rejected';
        }
    }, [
        isFocused,
        isDragAccept,
        isDragReject
    ]);
    let className = 'image-thumbs-browse file-drop-target' + (classNameMod ? ` ${classNameMod}` : '') + (disabled ? ' disabled' : '');
    if (busy) className += ' image-thumbs-browse__busy';
    if (type === 'files') className += ' image-thumbs-browse__files';
    const getSkeleton = ()=>{
        let thumbSkeleton = [];
        const numSkeletons = type === 'files' ? 50 : 24;
        for(let s = 0; s < numSkeletons; s++)thumbSkeleton.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "image-thumbs-browse--item-container",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "image-thumbs-browse--item",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                    image: true,
                    className: type === 'files' ? 'image-thumbs-browse--item-skeleton-small' : ''
                })
            })
        }, s));
        return thumbSkeleton;
    };
    const getImageClass = (image)=>{
        let className = selectedImageSlug && selectedImageSlug === (image === null || image === void 0 ? void 0 : image.slug) ? 'selected' : '';
        if (onClick) className += ' clickable';
        return className;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: className,
                "aria-label": "Drag and drop images here",
                ...getRootProps(),
                children: [
                    skeleton && getSkeleton(),
                    !skeleton && (images === null || images === void 0 ? void 0 : images.map((image, key)=>{
                        var _image_folder, _image_folder1, _image_folder2;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "image-thumbs-browse--item-container",
                            style: getStyle(image),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "image-thumbs-browse--item",
                                    children: [
                                        type === 'images' && (!image.type || image.type !== 'file') && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: `${"https://rest.yourhr.space"}/image/${account}/${image.slug}?size=medium&checksum=${image.hash}`,
                                                alt: image.alt,
                                                onClick: ()=>doPreviewImage(image),
                                                className: getImageClass(image)
                                            })
                                        }),
                                        type === 'files' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgDefault.default), {
                                                src: (0, _utilitiesDefault.default).getMimeIcon(image.mime),
                                                label: image.alt
                                            })
                                        }),
                                        image.alt && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "image-thumbs-browse--caption",
                                            children: [
                                                editIcons && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editableTextDefault.default), {
                                                    value: image.alt,
                                                    onSave: (value)=>{
                                                        doRename(image.imageId, value);
                                                    }
                                                }),
                                                !editIcons && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                                    children: image.alt
                                                })
                                            ]
                                        }),
                                        editIcons && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "image-thumbs-browse--edit-icons edit-icons",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    className: "button button__condensed",
                                                    "aria-label": "Upload replacement",
                                                    title: "Upload replacement",
                                                    onClick: (e)=>{
                                                        doUpload(e, image.imageId);
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.CloudUpload), {
                                                        size: 22,
                                                        strokeWidth: 1
                                                    })
                                                }),
                                                type === 'images' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                    className: "button button__condensed",
                                                    "aria-label": "Download",
                                                    title: "Download",
                                                    href: `${"https://rest.yourhr.space"}/image/${account}/${image.slug}?size=full&download=true`,
                                                    download: true,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.Download), {
                                                        size: 22,
                                                        strokeWidth: 1
                                                    })
                                                }),
                                                type === 'files' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    className: "button button__condensed",
                                                    "aria-label": "Download",
                                                    title: "Download",
                                                    onClick: (e)=>{
                                                        onDownloadFile(e, image.slug, image.fileName);
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.Download), {
                                                        size: 22,
                                                        strokeWidth: 1
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    className: "button button__condensed",
                                                    "aria-label": "Delete",
                                                    title: "Delete",
                                                    onClick: (e)=>{
                                                        doDelete(e, image.imageId);
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.TrashCan), {
                                                        size: 22,
                                                        strokeWidth: 1
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagsDefault.default), {
                                    className: "image-thumbs-browse--tags",
                                    tags: allTags,
                                    selectedTags: ((_image_folder = image.folder) === null || _image_folder === void 0 ? void 0 : _image_folder.folderId) && [
                                        {
                                            value: (_image_folder1 = image.folder) === null || _image_folder1 === void 0 ? void 0 : _image_folder1.folderId,
                                            label: (_image_folder2 = image.folder) === null || _image_folder2 === void 0 ? void 0 : _image_folder2.description
                                        }
                                    ] || null,
                                    canChange: editIcons,
                                    onTagCreate: onTagCreate,
                                    onTagDelete: onTagDelete,
                                    onChangeTags: (value)=>{
                                        doChangeTags(image.imageId, value);
                                    }
                                })
                            ]
                        }, key);
                    }))
                ]
            }),
            previewImageSlug && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "image-preview-container",
                onClick: ()=>setPreviewImageSlug(),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _throbberDefault.default), {}),
                    previewImage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: previewImage,
                        alt: "Enlarged image - click to close"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "file",
                style: {
                    display: 'none'
                },
                disabled: disabled,
                multiple: true,
                accept: "image/png, image/jpeg, image/webp, image/svg+xml, image/avif",
                ...getInputProps(),
                ref: hiddenFileInput
            })
        ]
    });
};
exports.default = ImageBrowse;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","react-dropzone":"he2Zd","../../utilities":"fkdv9","./throbber":"c8mQZ","./skeleton":"fLZ02","./editableText":"c6jrG","./tags":"hjClF","./svg":"4pImm","akar-icons":"b8xdj","../hooks/fetch/useFetchResources":"wHeKG","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"he2Zd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorCode", ()=>(0, _indexJs.ErrorCode));
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {import("./utils").AcceptProp} [props.accept] Set accepted file types.
 * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {boolean} autoFocus Set to true to auto focus the root element.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be an object with keys as a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) and the value an array of file extensions (optional).
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 * @param {(error: Error) => void} [props.onError]
 *
 * @returns {DropzoneState & DropzoneMethods}
 */ parcelHelpers.export(exports, "useDropzone", ()=>useDropzone);
/* eslint prefer-template: 0 */ var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _fileSelector = require("file-selector");
var _indexJs = require("./utils/index.js");
var _excluded = [
    "children"
], _excluded2 = [
    "open"
], _excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], _excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var Dropzone = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = _objectWithoutProperties(_ref, _excluded);
    var _useDropzone = useDropzone(params), open = _useDropzone.open, props = _objectWithoutProperties(_useDropzone, _excluded2);
    (0, _react.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), null, children(_objectSpread(_objectSpread({}, props), {}, {
        open: open
    })));
});
Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, _fileSelector.fromEvent),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: false,
    autoFocus: false
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {boolean} params.isDragGlobal Files are being dragged anywhere on the document
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, _propTypesDefault.default).func,
    /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */ accept: (0, _propTypesDefault.default).objectOf((0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, _propTypesDefault.default).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, _propTypesDefault.default).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, _propTypesDefault.default).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, _propTypesDefault.default).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, _propTypesDefault.default).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, _propTypesDefault.default).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, _propTypesDefault.default).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, _propTypesDefault.default).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, _propTypesDefault.default).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, _propTypesDefault.default).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, _propTypesDefault.default).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, _propTypesDefault.default).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, _propTypesDefault.default).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, _propTypesDefault.default).bool,
    /**
   * Set to true to focus the root element on render
   */ autoFocus: (0, _propTypesDefault.default).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, _propTypesDefault.default).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, _propTypesDefault.default).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, _propTypesDefault.default).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, _propTypesDefault.default).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, _propTypesDefault.default).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, _propTypesDefault.default).func,
    /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */ onError: (0, _propTypesDefault.default).func,
    /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */ validator: (0, _propTypesDefault.default).func
};
exports.default = Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {boolean} isDragGlobal Files are being dragged anywhere on the document
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ /**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */ var initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    isDragGlobal: false,
    acceptedFiles: [],
    fileRejections: []
};
function useDropzone() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, _react.useMemo)(function() {
        return (0, _indexJs.acceptPropAsAcceptAttr)(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, _react.useMemo)(function() {
        return (0, _indexJs.pickerOptionsFromAccept)(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, _react.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, _react.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop;
    }, [
        onFileDialogCancel
    ]);
    /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */ var rootRef = (0, _react.useRef)(null);
    var inputRef = (0, _react.useRef)(null);
    var _useReducer = (0, _react.useReducer)(reducer, initialState), _useReducer2 = _slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, _react.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, _indexJs.canUseFileSystemAccessAPI)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, _react.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, _react.useRef)([]);
    var globalDragTargetsRef = (0, _react.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, _react.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, _indexJs.onDocumentDragOver), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, _indexJs.onDocumentDragOver));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]); // Track global drag state for document-level drag events
    (0, _react.useEffect)(function() {
        var onDocumentDragEnter = function onDocumentDragEnter(event) {
            globalDragTargetsRef.current = [].concat(_toConsumableArray(globalDragTargetsRef.current), [
                event.target
            ]);
            if ((0, _indexJs.isEvtWithFiles)(event)) dispatch({
                isDragGlobal: true,
                type: "setDragGlobal"
            });
        };
        var onDocumentDragLeave = function onDocumentDragLeave(event) {
            // Only deactivate once we've left all children
            globalDragTargetsRef.current = globalDragTargetsRef.current.filter(function(el) {
                return el !== event.target && el !== null;
            });
            if (globalDragTargetsRef.current.length > 0) return;
            dispatch({
                isDragGlobal: false,
                type: "setDragGlobal"
            });
        };
        var onDocumentDragEnd = function onDocumentDragEnd() {
            globalDragTargetsRef.current = [];
            dispatch({
                isDragGlobal: false,
                type: "setDragGlobal"
            });
        };
        var onDocumentDropGlobal = function onDocumentDropGlobal() {
            globalDragTargetsRef.current = [];
            dispatch({
                isDragGlobal: false,
                type: "setDragGlobal"
            });
        };
        document.addEventListener("dragenter", onDocumentDragEnter, false);
        document.addEventListener("dragleave", onDocumentDragLeave, false);
        document.addEventListener("dragend", onDocumentDragEnd, false);
        document.addEventListener("drop", onDocumentDropGlobal, false);
        return function() {
            document.removeEventListener("dragenter", onDocumentDragEnter);
            document.removeEventListener("dragleave", onDocumentDragLeave);
            document.removeEventListener("dragend", onDocumentDragEnd);
            document.removeEventListener("drop", onDocumentDropGlobal);
        };
    }, [
        rootRef
    ]); // Auto focus the root when autoFocus is true
    (0, _react.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, _react.useCallback)(function(e) {
        if (onError) onError(e);
        else // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, _react.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, _indexJs.isEvtWithFiles)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, _indexJs.isPropagationStopped)(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && (0, _indexJs.allFilesAccepted)({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, _react.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, _indexJs.isEvtWithFiles)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, _react.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if ((0, _indexJs.isEvtWithFiles)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, _react.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, _indexJs.fileAccepted)(file, acceptAttr), _fileAccepted2 = _slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, _indexJs.fileMatchSize)(file, minSize, maxSize), _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, _indexJs.TOO_MANY_FILES_REJECTION)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            isDragReject: fileRejections.length > 0,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, _react.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, _indexJs.isEvtWithFiles)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, _indexJs.isPropagationStopped)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, _react.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, _indexJs.isAbort)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, _indexJs.isSecurityError)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, _react.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, _react.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, _react.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, _react.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, _indexJs.isIeOrEdge)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, _react.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = _objectWithoutProperties(_ref2, _excluded3);
            return _objectSpread(_objectSpread(_defineProperty({
                onKeyDown: composeKeyboardHandler((0, _indexJs.composeEventHandlers)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, _indexJs.composeEventHandlers)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, _indexJs.composeEventHandlers)(onBlur, onBlurCb)),
                onClick: composeHandler((0, _indexJs.composeEventHandlers)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, _indexJs.composeEventHandlers)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, _indexJs.composeEventHandlers)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, _indexJs.composeEventHandlers)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, _indexJs.composeEventHandlers)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "presentation"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, _react.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, _react.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = _objectWithoutProperties(_ref3, _excluded4);
            var inputProps = _defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    border: 0,
                    clip: "rect(0, 0, 0, 0)",
                    clipPath: "inset(50%)",
                    height: "1px",
                    margin: "0 -1px -1px 0",
                    overflow: "hidden",
                    padding: 0,
                    position: "absolute",
                    width: "1px",
                    whiteSpace: "nowrap"
                },
                onChange: composeHandler((0, _indexJs.composeEventHandlers)(onChange, onDropCb)),
                onClick: composeHandler((0, _indexJs.composeEventHandlers)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return _objectSpread(_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */ function reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return _objectSpread(_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return _objectSpread(_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return _objectSpread(_objectSpread({}, initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return _objectSpread(_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return _objectSpread(_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return _objectSpread(_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections,
                isDragReject: action.isDragReject
            });
        case "setDragGlobal":
            return _objectSpread(_objectSpread({}, state), {}, {
                isDragGlobal: action.isDragGlobal
            });
        case "reset":
            return _objectSpread({}, initialState);
        default:
            return state;
    }
}
function noop() {}

},{"react":"6wC8C","prop-types":"6YTRF","file-selector":"aqcSC","./utils/index.js":"c9xfP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"aqcSC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromEvent", ()=>(0, _fileSelector.fromEvent));
var _fileSelector = require("./file-selector");

},{"./file-selector":"3Xy9d","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3Xy9d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */ parcelHelpers.export(exports, "fromEvent", ()=>fromEvent);
var _tslib = require("tslib");
var _file = require("./file");
const FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
function fromEvent(evt) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
        if (isObject(evt) && isDataTransfer(evt.dataTransfer)) return getDataTransferFiles(evt.dataTransfer, evt.type);
        else if (isChangeEvt(evt)) return getInputFiles(evt);
        else if (Array.isArray(evt) && evt.every((item)=>'getFile' in item && typeof item.getFile === 'function')) return getFsHandleFiles(evt);
        return [];
    });
}
function isDataTransfer(value) {
    return isObject(value);
}
function isChangeEvt(value) {
    return isObject(value) && isObject(value.target);
}
function isObject(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map((file)=>(0, _file.toFileWithPath)(file));
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
        const files = yield Promise.all(handles.map((h)=>h.getFile()));
        return files.map((file)=>(0, _file.toFileWithPath)(file));
    });
}
function getDataTransferFiles(dt, type) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
        // IE11 does not support dataTransfer.items
        // See https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/items#Browser_compatibility
        if (dt.items) {
            const items = fromList(dt.items).filter((item)=>item.kind === 'file');
            // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
            // only 'dragstart' and 'drop' has access to the data (source node)
            if (type !== 'drop') return items;
            const files = yield Promise.all(items.map(toFilePromises));
            return noIgnoredFiles(flatten(files));
        }
        return noIgnoredFiles(fromList(dt.files).map((file)=>(0, _file.toFileWithPath)(file)));
    });
}
function noIgnoredFiles(files) {
    return files.filter((file)=>FILES_TO_IGNORE.indexOf(file.name) === -1);
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    if (items === null) return [];
    const files = [];
    // tslint:disable: prefer-for-of
    for(let i = 0; i < items.length; i++){
        const file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') return fromDataTransferItem(item);
    const entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return fromDirEntry(entry);
    return fromDataTransferItem(item, entry);
}
function flatten(items) {
    return items.reduce((acc, files)=>[
            ...acc,
            ...Array.isArray(files) ? flatten(files) : [
                files
            ]
        ], []);
}
function fromDataTransferItem(item, entry) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
        var _a;
        // Check if we're in a secure context; due to a bug in Chrome (as far as we know)
        // the browser crashes when calling this API (yet to be confirmed as a consistent behaviour).
        //
        // See:
        // - https://issues.chromium.org/issues/40186242
        // - https://github.com/react-dropzone/react-dropzone/issues/1397
        if (globalThis.isSecureContext && typeof item.getAsFileSystemHandle === 'function') {
            const h = yield item.getAsFileSystemHandle();
            if (h === null) throw new Error(`${item} is not a File`);
            // It seems that the handle can be `undefined` (see https://github.com/react-dropzone/file-selector/issues/120),
            // so we check if it isn't; if it is, the code path continues to the next API (`getAsFile`).
            if (h !== undefined) {
                const file = yield h.getFile();
                file.handle = h;
                return (0, _file.toFileWithPath)(file);
            }
        }
        const file = item.getAsFile();
        if (!file) throw new Error(`${item} is not a File`);
        const fwp = (0, _file.toFileWithPath)(file, (_a = entry === null || entry === void 0 ? void 0 : entry.fullPath) !== null && _a !== void 0 ? _a : undefined);
        return fwp;
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
        return entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry);
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    const reader = entry.createReader();
    return new Promise((resolve, reject)=>{
        const entries = [];
        function readEntries() {
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries((batch)=>(0, _tslib.__awaiter)(this, void 0, void 0, function*() {
                    if (!batch.length) // Done reading directory
                    try {
                        const files = yield Promise.all(entries);
                        resolve(files);
                    } catch (err) {
                        reject(err);
                    }
                    else {
                        const items = Promise.all(batch.map(fromEntry));
                        entries.push(items);
                        // Continue reading
                        readEntries();
                    }
                }), (err)=>{
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return (0, _tslib.__awaiter)(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            entry.file((file)=>{
                const fwp = (0, _file.toFileWithPath)(file, entry.fullPath);
                resolve(fwp);
            }, (err)=>{
                reject(err);
            });
        });
    });
}

},{"tslib":"7fEba","./file":"6ZxJI","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7fEba":[function(require,module,exports,__globalThis) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
parcelHelpers.export(exports, "__rewriteRelativeImportExtension", ()=>__rewriteRelativeImportExtension);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var ownKeys = function(o) {
    ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return ownKeys(o);
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __esDecorate: __esDecorate,
    __runInitializers: __runInitializers,
    __propKey: __propKey,
    __setFunctionName: __setFunctionName,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
    __rewriteRelativeImportExtension: __rewriteRelativeImportExtension
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6ZxJI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COMMON_MIME_TYPES", ()=>COMMON_MIME_TYPES);
parcelHelpers.export(exports, "toFileWithPath", ()=>toFileWithPath);
const COMMON_MIME_TYPES = new Map([
    // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
    [
        '1km',
        'application/vnd.1000minds.decision-model+xml'
    ],
    [
        '3dml',
        'text/vnd.in3d.3dml'
    ],
    [
        '3ds',
        'image/x-3ds'
    ],
    [
        '3g2',
        'video/3gpp2'
    ],
    [
        '3gp',
        'video/3gp'
    ],
    [
        '3gpp',
        'video/3gpp'
    ],
    [
        '3mf',
        'model/3mf'
    ],
    [
        '7z',
        'application/x-7z-compressed'
    ],
    [
        '7zip',
        'application/x-7z-compressed'
    ],
    [
        '123',
        'application/vnd.lotus-1-2-3'
    ],
    [
        'aab',
        'application/x-authorware-bin'
    ],
    [
        'aac',
        'audio/x-acc'
    ],
    [
        'aam',
        'application/x-authorware-map'
    ],
    [
        'aas',
        'application/x-authorware-seg'
    ],
    [
        'abw',
        'application/x-abiword'
    ],
    [
        'ac',
        'application/vnd.nokia.n-gage.ac+xml'
    ],
    [
        'ac3',
        'audio/ac3'
    ],
    [
        'acc',
        'application/vnd.americandynamics.acc'
    ],
    [
        'ace',
        'application/x-ace-compressed'
    ],
    [
        'acu',
        'application/vnd.acucobol'
    ],
    [
        'acutc',
        'application/vnd.acucorp'
    ],
    [
        'adp',
        'audio/adpcm'
    ],
    [
        'aep',
        'application/vnd.audiograph'
    ],
    [
        'afm',
        'application/x-font-type1'
    ],
    [
        'afp',
        'application/vnd.ibm.modcap'
    ],
    [
        'ahead',
        'application/vnd.ahead.space'
    ],
    [
        'ai',
        'application/pdf'
    ],
    [
        'aif',
        'audio/x-aiff'
    ],
    [
        'aifc',
        'audio/x-aiff'
    ],
    [
        'aiff',
        'audio/x-aiff'
    ],
    [
        'air',
        'application/vnd.adobe.air-application-installer-package+zip'
    ],
    [
        'ait',
        'application/vnd.dvb.ait'
    ],
    [
        'ami',
        'application/vnd.amiga.ami'
    ],
    [
        'amr',
        'audio/amr'
    ],
    [
        'apk',
        'application/vnd.android.package-archive'
    ],
    [
        'apng',
        'image/apng'
    ],
    [
        'appcache',
        'text/cache-manifest'
    ],
    [
        'application',
        'application/x-ms-application'
    ],
    [
        'apr',
        'application/vnd.lotus-approach'
    ],
    [
        'arc',
        'application/x-freearc'
    ],
    [
        'arj',
        'application/x-arj'
    ],
    [
        'asc',
        'application/pgp-signature'
    ],
    [
        'asf',
        'video/x-ms-asf'
    ],
    [
        'asm',
        'text/x-asm'
    ],
    [
        'aso',
        'application/vnd.accpac.simply.aso'
    ],
    [
        'asx',
        'video/x-ms-asf'
    ],
    [
        'atc',
        'application/vnd.acucorp'
    ],
    [
        'atom',
        'application/atom+xml'
    ],
    [
        'atomcat',
        'application/atomcat+xml'
    ],
    [
        'atomdeleted',
        'application/atomdeleted+xml'
    ],
    [
        'atomsvc',
        'application/atomsvc+xml'
    ],
    [
        'atx',
        'application/vnd.antix.game-component'
    ],
    [
        'au',
        'audio/x-au'
    ],
    [
        'avi',
        'video/x-msvideo'
    ],
    [
        'avif',
        'image/avif'
    ],
    [
        'aw',
        'application/applixware'
    ],
    [
        'azf',
        'application/vnd.airzip.filesecure.azf'
    ],
    [
        'azs',
        'application/vnd.airzip.filesecure.azs'
    ],
    [
        'azv',
        'image/vnd.airzip.accelerator.azv'
    ],
    [
        'azw',
        'application/vnd.amazon.ebook'
    ],
    [
        'b16',
        'image/vnd.pco.b16'
    ],
    [
        'bat',
        'application/x-msdownload'
    ],
    [
        'bcpio',
        'application/x-bcpio'
    ],
    [
        'bdf',
        'application/x-font-bdf'
    ],
    [
        'bdm',
        'application/vnd.syncml.dm+wbxml'
    ],
    [
        'bdoc',
        'application/x-bdoc'
    ],
    [
        'bed',
        'application/vnd.realvnc.bed'
    ],
    [
        'bh2',
        'application/vnd.fujitsu.oasysprs'
    ],
    [
        'bin',
        'application/octet-stream'
    ],
    [
        'blb',
        'application/x-blorb'
    ],
    [
        'blorb',
        'application/x-blorb'
    ],
    [
        'bmi',
        'application/vnd.bmi'
    ],
    [
        'bmml',
        'application/vnd.balsamiq.bmml+xml'
    ],
    [
        'bmp',
        'image/bmp'
    ],
    [
        'book',
        'application/vnd.framemaker'
    ],
    [
        'box',
        'application/vnd.previewsystems.box'
    ],
    [
        'boz',
        'application/x-bzip2'
    ],
    [
        'bpk',
        'application/octet-stream'
    ],
    [
        'bpmn',
        'application/octet-stream'
    ],
    [
        'bsp',
        'model/vnd.valve.source.compiled-map'
    ],
    [
        'btif',
        'image/prs.btif'
    ],
    [
        'buffer',
        'application/octet-stream'
    ],
    [
        'bz',
        'application/x-bzip'
    ],
    [
        'bz2',
        'application/x-bzip2'
    ],
    [
        'c',
        'text/x-c'
    ],
    [
        'c4d',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4f',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4g',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4p',
        'application/vnd.clonk.c4group'
    ],
    [
        'c4u',
        'application/vnd.clonk.c4group'
    ],
    [
        'c11amc',
        'application/vnd.cluetrust.cartomobile-config'
    ],
    [
        'c11amz',
        'application/vnd.cluetrust.cartomobile-config-pkg'
    ],
    [
        'cab',
        'application/vnd.ms-cab-compressed'
    ],
    [
        'caf',
        'audio/x-caf'
    ],
    [
        'cap',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'car',
        'application/vnd.curl.car'
    ],
    [
        'cat',
        'application/vnd.ms-pki.seccat'
    ],
    [
        'cb7',
        'application/x-cbr'
    ],
    [
        'cba',
        'application/x-cbr'
    ],
    [
        'cbr',
        'application/x-cbr'
    ],
    [
        'cbt',
        'application/x-cbr'
    ],
    [
        'cbz',
        'application/x-cbr'
    ],
    [
        'cc',
        'text/x-c'
    ],
    [
        'cco',
        'application/x-cocoa'
    ],
    [
        'cct',
        'application/x-director'
    ],
    [
        'ccxml',
        'application/ccxml+xml'
    ],
    [
        'cdbcmsg',
        'application/vnd.contact.cmsg'
    ],
    [
        'cda',
        'application/x-cdf'
    ],
    [
        'cdf',
        'application/x-netcdf'
    ],
    [
        'cdfx',
        'application/cdfx+xml'
    ],
    [
        'cdkey',
        'application/vnd.mediastation.cdkey'
    ],
    [
        'cdmia',
        'application/cdmi-capability'
    ],
    [
        'cdmic',
        'application/cdmi-container'
    ],
    [
        'cdmid',
        'application/cdmi-domain'
    ],
    [
        'cdmio',
        'application/cdmi-object'
    ],
    [
        'cdmiq',
        'application/cdmi-queue'
    ],
    [
        'cdr',
        'application/cdr'
    ],
    [
        'cdx',
        'chemical/x-cdx'
    ],
    [
        'cdxml',
        'application/vnd.chemdraw+xml'
    ],
    [
        'cdy',
        'application/vnd.cinderella'
    ],
    [
        'cer',
        'application/pkix-cert'
    ],
    [
        'cfs',
        'application/x-cfs-compressed'
    ],
    [
        'cgm',
        'image/cgm'
    ],
    [
        'chat',
        'application/x-chat'
    ],
    [
        'chm',
        'application/vnd.ms-htmlhelp'
    ],
    [
        'chrt',
        'application/vnd.kde.kchart'
    ],
    [
        'cif',
        'chemical/x-cif'
    ],
    [
        'cii',
        'application/vnd.anser-web-certificate-issue-initiation'
    ],
    [
        'cil',
        'application/vnd.ms-artgalry'
    ],
    [
        'cjs',
        'application/node'
    ],
    [
        'cla',
        'application/vnd.claymore'
    ],
    [
        'class',
        'application/octet-stream'
    ],
    [
        'clkk',
        'application/vnd.crick.clicker.keyboard'
    ],
    [
        'clkp',
        'application/vnd.crick.clicker.palette'
    ],
    [
        'clkt',
        'application/vnd.crick.clicker.template'
    ],
    [
        'clkw',
        'application/vnd.crick.clicker.wordbank'
    ],
    [
        'clkx',
        'application/vnd.crick.clicker'
    ],
    [
        'clp',
        'application/x-msclip'
    ],
    [
        'cmc',
        'application/vnd.cosmocaller'
    ],
    [
        'cmdf',
        'chemical/x-cmdf'
    ],
    [
        'cml',
        'chemical/x-cml'
    ],
    [
        'cmp',
        'application/vnd.yellowriver-custom-menu'
    ],
    [
        'cmx',
        'image/x-cmx'
    ],
    [
        'cod',
        'application/vnd.rim.cod'
    ],
    [
        'coffee',
        'text/coffeescript'
    ],
    [
        'com',
        'application/x-msdownload'
    ],
    [
        'conf',
        'text/plain'
    ],
    [
        'cpio',
        'application/x-cpio'
    ],
    [
        'cpp',
        'text/x-c'
    ],
    [
        'cpt',
        'application/mac-compactpro'
    ],
    [
        'crd',
        'application/x-mscardfile'
    ],
    [
        'crl',
        'application/pkix-crl'
    ],
    [
        'crt',
        'application/x-x509-ca-cert'
    ],
    [
        'crx',
        'application/x-chrome-extension'
    ],
    [
        'cryptonote',
        'application/vnd.rig.cryptonote'
    ],
    [
        'csh',
        'application/x-csh'
    ],
    [
        'csl',
        'application/vnd.citationstyles.style+xml'
    ],
    [
        'csml',
        'chemical/x-csml'
    ],
    [
        'csp',
        'application/vnd.commonspace'
    ],
    [
        'csr',
        'application/octet-stream'
    ],
    [
        'css',
        'text/css'
    ],
    [
        'cst',
        'application/x-director'
    ],
    [
        'csv',
        'text/csv'
    ],
    [
        'cu',
        'application/cu-seeme'
    ],
    [
        'curl',
        'text/vnd.curl'
    ],
    [
        'cww',
        'application/prs.cww'
    ],
    [
        'cxt',
        'application/x-director'
    ],
    [
        'cxx',
        'text/x-c'
    ],
    [
        'dae',
        'model/vnd.collada+xml'
    ],
    [
        'daf',
        'application/vnd.mobius.daf'
    ],
    [
        'dart',
        'application/vnd.dart'
    ],
    [
        'dataless',
        'application/vnd.fdsn.seed'
    ],
    [
        'davmount',
        'application/davmount+xml'
    ],
    [
        'dbf',
        'application/vnd.dbf'
    ],
    [
        'dbk',
        'application/docbook+xml'
    ],
    [
        'dcr',
        'application/x-director'
    ],
    [
        'dcurl',
        'text/vnd.curl.dcurl'
    ],
    [
        'dd2',
        'application/vnd.oma.dd2+xml'
    ],
    [
        'ddd',
        'application/vnd.fujixerox.ddd'
    ],
    [
        'ddf',
        'application/vnd.syncml.dmddf+xml'
    ],
    [
        'dds',
        'image/vnd.ms-dds'
    ],
    [
        'deb',
        'application/x-debian-package'
    ],
    [
        'def',
        'text/plain'
    ],
    [
        'deploy',
        'application/octet-stream'
    ],
    [
        'der',
        'application/x-x509-ca-cert'
    ],
    [
        'dfac',
        'application/vnd.dreamfactory'
    ],
    [
        'dgc',
        'application/x-dgc-compressed'
    ],
    [
        'dic',
        'text/x-c'
    ],
    [
        'dir',
        'application/x-director'
    ],
    [
        'dis',
        'application/vnd.mobius.dis'
    ],
    [
        'disposition-notification',
        'message/disposition-notification'
    ],
    [
        'dist',
        'application/octet-stream'
    ],
    [
        'distz',
        'application/octet-stream'
    ],
    [
        'djv',
        'image/vnd.djvu'
    ],
    [
        'djvu',
        'image/vnd.djvu'
    ],
    [
        'dll',
        'application/octet-stream'
    ],
    [
        'dmg',
        'application/x-apple-diskimage'
    ],
    [
        'dmn',
        'application/octet-stream'
    ],
    [
        'dmp',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'dms',
        'application/octet-stream'
    ],
    [
        'dna',
        'application/vnd.dna'
    ],
    [
        'doc',
        'application/msword'
    ],
    [
        'docm',
        'application/vnd.ms-word.template.macroEnabled.12'
    ],
    [
        'docx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ],
    [
        'dot',
        'application/msword'
    ],
    [
        'dotm',
        'application/vnd.ms-word.template.macroEnabled.12'
    ],
    [
        'dotx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template'
    ],
    [
        'dp',
        'application/vnd.osgi.dp'
    ],
    [
        'dpg',
        'application/vnd.dpgraph'
    ],
    [
        'dra',
        'audio/vnd.dra'
    ],
    [
        'drle',
        'image/dicom-rle'
    ],
    [
        'dsc',
        'text/prs.lines.tag'
    ],
    [
        'dssc',
        'application/dssc+der'
    ],
    [
        'dtb',
        'application/x-dtbook+xml'
    ],
    [
        'dtd',
        'application/xml-dtd'
    ],
    [
        'dts',
        'audio/vnd.dts'
    ],
    [
        'dtshd',
        'audio/vnd.dts.hd'
    ],
    [
        'dump',
        'application/octet-stream'
    ],
    [
        'dvb',
        'video/vnd.dvb.file'
    ],
    [
        'dvi',
        'application/x-dvi'
    ],
    [
        'dwd',
        'application/atsc-dwd+xml'
    ],
    [
        'dwf',
        'model/vnd.dwf'
    ],
    [
        'dwg',
        'image/vnd.dwg'
    ],
    [
        'dxf',
        'image/vnd.dxf'
    ],
    [
        'dxp',
        'application/vnd.spotfire.dxp'
    ],
    [
        'dxr',
        'application/x-director'
    ],
    [
        'ear',
        'application/java-archive'
    ],
    [
        'ecelp4800',
        'audio/vnd.nuera.ecelp4800'
    ],
    [
        'ecelp7470',
        'audio/vnd.nuera.ecelp7470'
    ],
    [
        'ecelp9600',
        'audio/vnd.nuera.ecelp9600'
    ],
    [
        'ecma',
        'application/ecmascript'
    ],
    [
        'edm',
        'application/vnd.novadigm.edm'
    ],
    [
        'edx',
        'application/vnd.novadigm.edx'
    ],
    [
        'efif',
        'application/vnd.picsel'
    ],
    [
        'ei6',
        'application/vnd.pg.osasli'
    ],
    [
        'elc',
        'application/octet-stream'
    ],
    [
        'emf',
        'image/emf'
    ],
    [
        'eml',
        'message/rfc822'
    ],
    [
        'emma',
        'application/emma+xml'
    ],
    [
        'emotionml',
        'application/emotionml+xml'
    ],
    [
        'emz',
        'application/x-msmetafile'
    ],
    [
        'eol',
        'audio/vnd.digital-winds'
    ],
    [
        'eot',
        'application/vnd.ms-fontobject'
    ],
    [
        'eps',
        'application/postscript'
    ],
    [
        'epub',
        'application/epub+zip'
    ],
    [
        'es',
        'application/ecmascript'
    ],
    [
        'es3',
        'application/vnd.eszigno3+xml'
    ],
    [
        'esa',
        'application/vnd.osgi.subsystem'
    ],
    [
        'esf',
        'application/vnd.epson.esf'
    ],
    [
        'et3',
        'application/vnd.eszigno3+xml'
    ],
    [
        'etx',
        'text/x-setext'
    ],
    [
        'eva',
        'application/x-eva'
    ],
    [
        'evy',
        'application/x-envoy'
    ],
    [
        'exe',
        'application/octet-stream'
    ],
    [
        'exi',
        'application/exi'
    ],
    [
        'exp',
        'application/express'
    ],
    [
        'exr',
        'image/aces'
    ],
    [
        'ext',
        'application/vnd.novadigm.ext'
    ],
    [
        'ez',
        'application/andrew-inset'
    ],
    [
        'ez2',
        'application/vnd.ezpix-album'
    ],
    [
        'ez3',
        'application/vnd.ezpix-package'
    ],
    [
        'f',
        'text/x-fortran'
    ],
    [
        'f4v',
        'video/mp4'
    ],
    [
        'f77',
        'text/x-fortran'
    ],
    [
        'f90',
        'text/x-fortran'
    ],
    [
        'fbs',
        'image/vnd.fastbidsheet'
    ],
    [
        'fcdt',
        'application/vnd.adobe.formscentral.fcdt'
    ],
    [
        'fcs',
        'application/vnd.isac.fcs'
    ],
    [
        'fdf',
        'application/vnd.fdf'
    ],
    [
        'fdt',
        'application/fdt+xml'
    ],
    [
        'fe_launch',
        'application/vnd.denovo.fcselayout-link'
    ],
    [
        'fg5',
        'application/vnd.fujitsu.oasysgp'
    ],
    [
        'fgd',
        'application/x-director'
    ],
    [
        'fh',
        'image/x-freehand'
    ],
    [
        'fh4',
        'image/x-freehand'
    ],
    [
        'fh5',
        'image/x-freehand'
    ],
    [
        'fh7',
        'image/x-freehand'
    ],
    [
        'fhc',
        'image/x-freehand'
    ],
    [
        'fig',
        'application/x-xfig'
    ],
    [
        'fits',
        'image/fits'
    ],
    [
        'flac',
        'audio/x-flac'
    ],
    [
        'fli',
        'video/x-fli'
    ],
    [
        'flo',
        'application/vnd.micrografx.flo'
    ],
    [
        'flv',
        'video/x-flv'
    ],
    [
        'flw',
        'application/vnd.kde.kivio'
    ],
    [
        'flx',
        'text/vnd.fmi.flexstor'
    ],
    [
        'fly',
        'text/vnd.fly'
    ],
    [
        'fm',
        'application/vnd.framemaker'
    ],
    [
        'fnc',
        'application/vnd.frogans.fnc'
    ],
    [
        'fo',
        'application/vnd.software602.filler.form+xml'
    ],
    [
        'for',
        'text/x-fortran'
    ],
    [
        'fpx',
        'image/vnd.fpx'
    ],
    [
        'frame',
        'application/vnd.framemaker'
    ],
    [
        'fsc',
        'application/vnd.fsc.weblaunch'
    ],
    [
        'fst',
        'image/vnd.fst'
    ],
    [
        'ftc',
        'application/vnd.fluxtime.clip'
    ],
    [
        'fti',
        'application/vnd.anser-web-funds-transfer-initiation'
    ],
    [
        'fvt',
        'video/vnd.fvt'
    ],
    [
        'fxp',
        'application/vnd.adobe.fxp'
    ],
    [
        'fxpl',
        'application/vnd.adobe.fxp'
    ],
    [
        'fzs',
        'application/vnd.fuzzysheet'
    ],
    [
        'g2w',
        'application/vnd.geoplan'
    ],
    [
        'g3',
        'image/g3fax'
    ],
    [
        'g3w',
        'application/vnd.geospace'
    ],
    [
        'gac',
        'application/vnd.groove-account'
    ],
    [
        'gam',
        'application/x-tads'
    ],
    [
        'gbr',
        'application/rpki-ghostbusters'
    ],
    [
        'gca',
        'application/x-gca-compressed'
    ],
    [
        'gdl',
        'model/vnd.gdl'
    ],
    [
        'gdoc',
        'application/vnd.google-apps.document'
    ],
    [
        'geo',
        'application/vnd.dynageo'
    ],
    [
        'geojson',
        'application/geo+json'
    ],
    [
        'gex',
        'application/vnd.geometry-explorer'
    ],
    [
        'ggb',
        'application/vnd.geogebra.file'
    ],
    [
        'ggt',
        'application/vnd.geogebra.tool'
    ],
    [
        'ghf',
        'application/vnd.groove-help'
    ],
    [
        'gif',
        'image/gif'
    ],
    [
        'gim',
        'application/vnd.groove-identity-message'
    ],
    [
        'glb',
        'model/gltf-binary'
    ],
    [
        'gltf',
        'model/gltf+json'
    ],
    [
        'gml',
        'application/gml+xml'
    ],
    [
        'gmx',
        'application/vnd.gmx'
    ],
    [
        'gnumeric',
        'application/x-gnumeric'
    ],
    [
        'gpg',
        'application/gpg-keys'
    ],
    [
        'gph',
        'application/vnd.flographit'
    ],
    [
        'gpx',
        'application/gpx+xml'
    ],
    [
        'gqf',
        'application/vnd.grafeq'
    ],
    [
        'gqs',
        'application/vnd.grafeq'
    ],
    [
        'gram',
        'application/srgs'
    ],
    [
        'gramps',
        'application/x-gramps-xml'
    ],
    [
        'gre',
        'application/vnd.geometry-explorer'
    ],
    [
        'grv',
        'application/vnd.groove-injector'
    ],
    [
        'grxml',
        'application/srgs+xml'
    ],
    [
        'gsf',
        'application/x-font-ghostscript'
    ],
    [
        'gsheet',
        'application/vnd.google-apps.spreadsheet'
    ],
    [
        'gslides',
        'application/vnd.google-apps.presentation'
    ],
    [
        'gtar',
        'application/x-gtar'
    ],
    [
        'gtm',
        'application/vnd.groove-tool-message'
    ],
    [
        'gtw',
        'model/vnd.gtw'
    ],
    [
        'gv',
        'text/vnd.graphviz'
    ],
    [
        'gxf',
        'application/gxf'
    ],
    [
        'gxt',
        'application/vnd.geonext'
    ],
    [
        'gz',
        'application/gzip'
    ],
    [
        'gzip',
        'application/gzip'
    ],
    [
        'h',
        'text/x-c'
    ],
    [
        'h261',
        'video/h261'
    ],
    [
        'h263',
        'video/h263'
    ],
    [
        'h264',
        'video/h264'
    ],
    [
        'hal',
        'application/vnd.hal+xml'
    ],
    [
        'hbci',
        'application/vnd.hbci'
    ],
    [
        'hbs',
        'text/x-handlebars-template'
    ],
    [
        'hdd',
        'application/x-virtualbox-hdd'
    ],
    [
        'hdf',
        'application/x-hdf'
    ],
    [
        'heic',
        'image/heic'
    ],
    [
        'heics',
        'image/heic-sequence'
    ],
    [
        'heif',
        'image/heif'
    ],
    [
        'heifs',
        'image/heif-sequence'
    ],
    [
        'hej2',
        'image/hej2k'
    ],
    [
        'held',
        'application/atsc-held+xml'
    ],
    [
        'hh',
        'text/x-c'
    ],
    [
        'hjson',
        'application/hjson'
    ],
    [
        'hlp',
        'application/winhlp'
    ],
    [
        'hpgl',
        'application/vnd.hp-hpgl'
    ],
    [
        'hpid',
        'application/vnd.hp-hpid'
    ],
    [
        'hps',
        'application/vnd.hp-hps'
    ],
    [
        'hqx',
        'application/mac-binhex40'
    ],
    [
        'hsj2',
        'image/hsj2'
    ],
    [
        'htc',
        'text/x-component'
    ],
    [
        'htke',
        'application/vnd.kenameaapp'
    ],
    [
        'htm',
        'text/html'
    ],
    [
        'html',
        'text/html'
    ],
    [
        'hvd',
        'application/vnd.yamaha.hv-dic'
    ],
    [
        'hvp',
        'application/vnd.yamaha.hv-voice'
    ],
    [
        'hvs',
        'application/vnd.yamaha.hv-script'
    ],
    [
        'i2g',
        'application/vnd.intergeo'
    ],
    [
        'icc',
        'application/vnd.iccprofile'
    ],
    [
        'ice',
        'x-conference/x-cooltalk'
    ],
    [
        'icm',
        'application/vnd.iccprofile'
    ],
    [
        'ico',
        'image/x-icon'
    ],
    [
        'ics',
        'text/calendar'
    ],
    [
        'ief',
        'image/ief'
    ],
    [
        'ifb',
        'text/calendar'
    ],
    [
        'ifm',
        'application/vnd.shana.informed.formdata'
    ],
    [
        'iges',
        'model/iges'
    ],
    [
        'igl',
        'application/vnd.igloader'
    ],
    [
        'igm',
        'application/vnd.insors.igm'
    ],
    [
        'igs',
        'model/iges'
    ],
    [
        'igx',
        'application/vnd.micrografx.igx'
    ],
    [
        'iif',
        'application/vnd.shana.informed.interchange'
    ],
    [
        'img',
        'application/octet-stream'
    ],
    [
        'imp',
        'application/vnd.accpac.simply.imp'
    ],
    [
        'ims',
        'application/vnd.ms-ims'
    ],
    [
        'in',
        'text/plain'
    ],
    [
        'ini',
        'text/plain'
    ],
    [
        'ink',
        'application/inkml+xml'
    ],
    [
        'inkml',
        'application/inkml+xml'
    ],
    [
        'install',
        'application/x-install-instructions'
    ],
    [
        'iota',
        'application/vnd.astraea-software.iota'
    ],
    [
        'ipfix',
        'application/ipfix'
    ],
    [
        'ipk',
        'application/vnd.shana.informed.package'
    ],
    [
        'irm',
        'application/vnd.ibm.rights-management'
    ],
    [
        'irp',
        'application/vnd.irepository.package+xml'
    ],
    [
        'iso',
        'application/x-iso9660-image'
    ],
    [
        'itp',
        'application/vnd.shana.informed.formtemplate'
    ],
    [
        'its',
        'application/its+xml'
    ],
    [
        'ivp',
        'application/vnd.immervision-ivp'
    ],
    [
        'ivu',
        'application/vnd.immervision-ivu'
    ],
    [
        'jad',
        'text/vnd.sun.j2me.app-descriptor'
    ],
    [
        'jade',
        'text/jade'
    ],
    [
        'jam',
        'application/vnd.jam'
    ],
    [
        'jar',
        'application/java-archive'
    ],
    [
        'jardiff',
        'application/x-java-archive-diff'
    ],
    [
        'java',
        'text/x-java-source'
    ],
    [
        'jhc',
        'image/jphc'
    ],
    [
        'jisp',
        'application/vnd.jisp'
    ],
    [
        'jls',
        'image/jls'
    ],
    [
        'jlt',
        'application/vnd.hp-jlyt'
    ],
    [
        'jng',
        'image/x-jng'
    ],
    [
        'jnlp',
        'application/x-java-jnlp-file'
    ],
    [
        'joda',
        'application/vnd.joost.joda-archive'
    ],
    [
        'jp2',
        'image/jp2'
    ],
    [
        'jpe',
        'image/jpeg'
    ],
    [
        'jpeg',
        'image/jpeg'
    ],
    [
        'jpf',
        'image/jpx'
    ],
    [
        'jpg',
        'image/jpeg'
    ],
    [
        'jpg2',
        'image/jp2'
    ],
    [
        'jpgm',
        'video/jpm'
    ],
    [
        'jpgv',
        'video/jpeg'
    ],
    [
        'jph',
        'image/jph'
    ],
    [
        'jpm',
        'video/jpm'
    ],
    [
        'jpx',
        'image/jpx'
    ],
    [
        'js',
        'application/javascript'
    ],
    [
        'json',
        'application/json'
    ],
    [
        'json5',
        'application/json5'
    ],
    [
        'jsonld',
        'application/ld+json'
    ],
    // https://jsonlines.org/
    [
        'jsonl',
        'application/jsonl'
    ],
    [
        'jsonml',
        'application/jsonml+json'
    ],
    [
        'jsx',
        'text/jsx'
    ],
    [
        'jxr',
        'image/jxr'
    ],
    [
        'jxra',
        'image/jxra'
    ],
    [
        'jxrs',
        'image/jxrs'
    ],
    [
        'jxs',
        'image/jxs'
    ],
    [
        'jxsc',
        'image/jxsc'
    ],
    [
        'jxsi',
        'image/jxsi'
    ],
    [
        'jxss',
        'image/jxss'
    ],
    [
        'kar',
        'audio/midi'
    ],
    [
        'karbon',
        'application/vnd.kde.karbon'
    ],
    [
        'kdb',
        'application/octet-stream'
    ],
    [
        'kdbx',
        'application/x-keepass2'
    ],
    [
        'key',
        'application/x-iwork-keynote-sffkey'
    ],
    [
        'kfo',
        'application/vnd.kde.kformula'
    ],
    [
        'kia',
        'application/vnd.kidspiration'
    ],
    [
        'kml',
        'application/vnd.google-earth.kml+xml'
    ],
    [
        'kmz',
        'application/vnd.google-earth.kmz'
    ],
    [
        'kne',
        'application/vnd.kinar'
    ],
    [
        'knp',
        'application/vnd.kinar'
    ],
    [
        'kon',
        'application/vnd.kde.kontour'
    ],
    [
        'kpr',
        'application/vnd.kde.kpresenter'
    ],
    [
        'kpt',
        'application/vnd.kde.kpresenter'
    ],
    [
        'kpxx',
        'application/vnd.ds-keypoint'
    ],
    [
        'ksp',
        'application/vnd.kde.kspread'
    ],
    [
        'ktr',
        'application/vnd.kahootz'
    ],
    [
        'ktx',
        'image/ktx'
    ],
    [
        'ktx2',
        'image/ktx2'
    ],
    [
        'ktz',
        'application/vnd.kahootz'
    ],
    [
        'kwd',
        'application/vnd.kde.kword'
    ],
    [
        'kwt',
        'application/vnd.kde.kword'
    ],
    [
        'lasxml',
        'application/vnd.las.las+xml'
    ],
    [
        'latex',
        'application/x-latex'
    ],
    [
        'lbd',
        'application/vnd.llamagraphics.life-balance.desktop'
    ],
    [
        'lbe',
        'application/vnd.llamagraphics.life-balance.exchange+xml'
    ],
    [
        'les',
        'application/vnd.hhe.lesson-player'
    ],
    [
        'less',
        'text/less'
    ],
    [
        'lgr',
        'application/lgr+xml'
    ],
    [
        'lha',
        'application/octet-stream'
    ],
    [
        'link66',
        'application/vnd.route66.link66+xml'
    ],
    [
        'list',
        'text/plain'
    ],
    [
        'list3820',
        'application/vnd.ibm.modcap'
    ],
    [
        'listafp',
        'application/vnd.ibm.modcap'
    ],
    [
        'litcoffee',
        'text/coffeescript'
    ],
    [
        'lnk',
        'application/x-ms-shortcut'
    ],
    [
        'log',
        'text/plain'
    ],
    [
        'lostxml',
        'application/lost+xml'
    ],
    [
        'lrf',
        'application/octet-stream'
    ],
    [
        'lrm',
        'application/vnd.ms-lrm'
    ],
    [
        'ltf',
        'application/vnd.frogans.ltf'
    ],
    [
        'lua',
        'text/x-lua'
    ],
    [
        'luac',
        'application/x-lua-bytecode'
    ],
    [
        'lvp',
        'audio/vnd.lucent.voice'
    ],
    [
        'lwp',
        'application/vnd.lotus-wordpro'
    ],
    [
        'lzh',
        'application/octet-stream'
    ],
    [
        'm1v',
        'video/mpeg'
    ],
    [
        'm2a',
        'audio/mpeg'
    ],
    [
        'm2v',
        'video/mpeg'
    ],
    [
        'm3a',
        'audio/mpeg'
    ],
    [
        'm3u',
        'text/plain'
    ],
    [
        'm3u8',
        'application/vnd.apple.mpegurl'
    ],
    [
        'm4a',
        'audio/x-m4a'
    ],
    [
        'm4p',
        'application/mp4'
    ],
    [
        'm4s',
        'video/iso.segment'
    ],
    [
        'm4u',
        'application/vnd.mpegurl'
    ],
    [
        'm4v',
        'video/x-m4v'
    ],
    [
        'm13',
        'application/x-msmediaview'
    ],
    [
        'm14',
        'application/x-msmediaview'
    ],
    [
        'm21',
        'application/mp21'
    ],
    [
        'ma',
        'application/mathematica'
    ],
    [
        'mads',
        'application/mads+xml'
    ],
    [
        'maei',
        'application/mmt-aei+xml'
    ],
    [
        'mag',
        'application/vnd.ecowin.chart'
    ],
    [
        'maker',
        'application/vnd.framemaker'
    ],
    [
        'man',
        'text/troff'
    ],
    [
        'manifest',
        'text/cache-manifest'
    ],
    [
        'map',
        'application/json'
    ],
    [
        'mar',
        'application/octet-stream'
    ],
    [
        'markdown',
        'text/markdown'
    ],
    [
        'mathml',
        'application/mathml+xml'
    ],
    [
        'mb',
        'application/mathematica'
    ],
    [
        'mbk',
        'application/vnd.mobius.mbk'
    ],
    [
        'mbox',
        'application/mbox'
    ],
    [
        'mc1',
        'application/vnd.medcalcdata'
    ],
    [
        'mcd',
        'application/vnd.mcd'
    ],
    [
        'mcurl',
        'text/vnd.curl.mcurl'
    ],
    [
        'md',
        'text/markdown'
    ],
    [
        'mdb',
        'application/x-msaccess'
    ],
    [
        'mdi',
        'image/vnd.ms-modi'
    ],
    [
        'mdx',
        'text/mdx'
    ],
    [
        'me',
        'text/troff'
    ],
    [
        'mesh',
        'model/mesh'
    ],
    [
        'meta4',
        'application/metalink4+xml'
    ],
    [
        'metalink',
        'application/metalink+xml'
    ],
    [
        'mets',
        'application/mets+xml'
    ],
    [
        'mfm',
        'application/vnd.mfmp'
    ],
    [
        'mft',
        'application/rpki-manifest'
    ],
    [
        'mgp',
        'application/vnd.osgeo.mapguide.package'
    ],
    [
        'mgz',
        'application/vnd.proteus.magazine'
    ],
    [
        'mid',
        'audio/midi'
    ],
    [
        'midi',
        'audio/midi'
    ],
    [
        'mie',
        'application/x-mie'
    ],
    [
        'mif',
        'application/vnd.mif'
    ],
    [
        'mime',
        'message/rfc822'
    ],
    [
        'mj2',
        'video/mj2'
    ],
    [
        'mjp2',
        'video/mj2'
    ],
    [
        'mjs',
        'application/javascript'
    ],
    [
        'mk3d',
        'video/x-matroska'
    ],
    [
        'mka',
        'audio/x-matroska'
    ],
    [
        'mkd',
        'text/x-markdown'
    ],
    [
        'mks',
        'video/x-matroska'
    ],
    [
        'mkv',
        'video/x-matroska'
    ],
    [
        'mlp',
        'application/vnd.dolby.mlp'
    ],
    [
        'mmd',
        'application/vnd.chipnuts.karaoke-mmd'
    ],
    [
        'mmf',
        'application/vnd.smaf'
    ],
    [
        'mml',
        'text/mathml'
    ],
    [
        'mmr',
        'image/vnd.fujixerox.edmics-mmr'
    ],
    [
        'mng',
        'video/x-mng'
    ],
    [
        'mny',
        'application/x-msmoney'
    ],
    [
        'mobi',
        'application/x-mobipocket-ebook'
    ],
    [
        'mods',
        'application/mods+xml'
    ],
    [
        'mov',
        'video/quicktime'
    ],
    [
        'movie',
        'video/x-sgi-movie'
    ],
    [
        'mp2',
        'audio/mpeg'
    ],
    [
        'mp2a',
        'audio/mpeg'
    ],
    [
        'mp3',
        'audio/mpeg'
    ],
    [
        'mp4',
        'video/mp4'
    ],
    [
        'mp4a',
        'audio/mp4'
    ],
    [
        'mp4s',
        'application/mp4'
    ],
    [
        'mp4v',
        'video/mp4'
    ],
    [
        'mp21',
        'application/mp21'
    ],
    [
        'mpc',
        'application/vnd.mophun.certificate'
    ],
    [
        'mpd',
        'application/dash+xml'
    ],
    [
        'mpe',
        'video/mpeg'
    ],
    [
        'mpeg',
        'video/mpeg'
    ],
    [
        'mpg',
        'video/mpeg'
    ],
    [
        'mpg4',
        'video/mp4'
    ],
    [
        'mpga',
        'audio/mpeg'
    ],
    [
        'mpkg',
        'application/vnd.apple.installer+xml'
    ],
    [
        'mpm',
        'application/vnd.blueice.multipass'
    ],
    [
        'mpn',
        'application/vnd.mophun.application'
    ],
    [
        'mpp',
        'application/vnd.ms-project'
    ],
    [
        'mpt',
        'application/vnd.ms-project'
    ],
    [
        'mpy',
        'application/vnd.ibm.minipay'
    ],
    [
        'mqy',
        'application/vnd.mobius.mqy'
    ],
    [
        'mrc',
        'application/marc'
    ],
    [
        'mrcx',
        'application/marcxml+xml'
    ],
    [
        'ms',
        'text/troff'
    ],
    [
        'mscml',
        'application/mediaservercontrol+xml'
    ],
    [
        'mseed',
        'application/vnd.fdsn.mseed'
    ],
    [
        'mseq',
        'application/vnd.mseq'
    ],
    [
        'msf',
        'application/vnd.epson.msf'
    ],
    [
        'msg',
        'application/vnd.ms-outlook'
    ],
    [
        'msh',
        'model/mesh'
    ],
    [
        'msi',
        'application/x-msdownload'
    ],
    [
        'msl',
        'application/vnd.mobius.msl'
    ],
    [
        'msm',
        'application/octet-stream'
    ],
    [
        'msp',
        'application/octet-stream'
    ],
    [
        'msty',
        'application/vnd.muvee.style'
    ],
    [
        'mtl',
        'model/mtl'
    ],
    [
        'mts',
        'model/vnd.mts'
    ],
    [
        'mus',
        'application/vnd.musician'
    ],
    [
        'musd',
        'application/mmt-usd+xml'
    ],
    [
        'musicxml',
        'application/vnd.recordare.musicxml+xml'
    ],
    [
        'mvb',
        'application/x-msmediaview'
    ],
    [
        'mvt',
        'application/vnd.mapbox-vector-tile'
    ],
    [
        'mwf',
        'application/vnd.mfer'
    ],
    [
        'mxf',
        'application/mxf'
    ],
    [
        'mxl',
        'application/vnd.recordare.musicxml'
    ],
    [
        'mxmf',
        'audio/mobile-xmf'
    ],
    [
        'mxml',
        'application/xv+xml'
    ],
    [
        'mxs',
        'application/vnd.triscape.mxs'
    ],
    [
        'mxu',
        'video/vnd.mpegurl'
    ],
    [
        'n-gage',
        'application/vnd.nokia.n-gage.symbian.install'
    ],
    [
        'n3',
        'text/n3'
    ],
    [
        'nb',
        'application/mathematica'
    ],
    [
        'nbp',
        'application/vnd.wolfram.player'
    ],
    [
        'nc',
        'application/x-netcdf'
    ],
    [
        'ncx',
        'application/x-dtbncx+xml'
    ],
    [
        'nfo',
        'text/x-nfo'
    ],
    [
        'ngdat',
        'application/vnd.nokia.n-gage.data'
    ],
    [
        'nitf',
        'application/vnd.nitf'
    ],
    [
        'nlu',
        'application/vnd.neurolanguage.nlu'
    ],
    [
        'nml',
        'application/vnd.enliven'
    ],
    [
        'nnd',
        'application/vnd.noblenet-directory'
    ],
    [
        'nns',
        'application/vnd.noblenet-sealer'
    ],
    [
        'nnw',
        'application/vnd.noblenet-web'
    ],
    [
        'npx',
        'image/vnd.net-fpx'
    ],
    [
        'nq',
        'application/n-quads'
    ],
    [
        'nsc',
        'application/x-conference'
    ],
    [
        'nsf',
        'application/vnd.lotus-notes'
    ],
    [
        'nt',
        'application/n-triples'
    ],
    [
        'ntf',
        'application/vnd.nitf'
    ],
    [
        'numbers',
        'application/x-iwork-numbers-sffnumbers'
    ],
    [
        'nzb',
        'application/x-nzb'
    ],
    [
        'oa2',
        'application/vnd.fujitsu.oasys2'
    ],
    [
        'oa3',
        'application/vnd.fujitsu.oasys3'
    ],
    [
        'oas',
        'application/vnd.fujitsu.oasys'
    ],
    [
        'obd',
        'application/x-msbinder'
    ],
    [
        'obgx',
        'application/vnd.openblox.game+xml'
    ],
    [
        'obj',
        'model/obj'
    ],
    [
        'oda',
        'application/oda'
    ],
    [
        'odb',
        'application/vnd.oasis.opendocument.database'
    ],
    [
        'odc',
        'application/vnd.oasis.opendocument.chart'
    ],
    [
        'odf',
        'application/vnd.oasis.opendocument.formula'
    ],
    [
        'odft',
        'application/vnd.oasis.opendocument.formula-template'
    ],
    [
        'odg',
        'application/vnd.oasis.opendocument.graphics'
    ],
    [
        'odi',
        'application/vnd.oasis.opendocument.image'
    ],
    [
        'odm',
        'application/vnd.oasis.opendocument.text-master'
    ],
    [
        'odp',
        'application/vnd.oasis.opendocument.presentation'
    ],
    [
        'ods',
        'application/vnd.oasis.opendocument.spreadsheet'
    ],
    [
        'odt',
        'application/vnd.oasis.opendocument.text'
    ],
    [
        'oga',
        'audio/ogg'
    ],
    [
        'ogex',
        'model/vnd.opengex'
    ],
    [
        'ogg',
        'audio/ogg'
    ],
    [
        'ogv',
        'video/ogg'
    ],
    [
        'ogx',
        'application/ogg'
    ],
    [
        'omdoc',
        'application/omdoc+xml'
    ],
    [
        'onepkg',
        'application/onenote'
    ],
    [
        'onetmp',
        'application/onenote'
    ],
    [
        'onetoc',
        'application/onenote'
    ],
    [
        'onetoc2',
        'application/onenote'
    ],
    [
        'opf',
        'application/oebps-package+xml'
    ],
    [
        'opml',
        'text/x-opml'
    ],
    [
        'oprc',
        'application/vnd.palm'
    ],
    [
        'opus',
        'audio/ogg'
    ],
    [
        'org',
        'text/x-org'
    ],
    [
        'osf',
        'application/vnd.yamaha.openscoreformat'
    ],
    [
        'osfpvg',
        'application/vnd.yamaha.openscoreformat.osfpvg+xml'
    ],
    [
        'osm',
        'application/vnd.openstreetmap.data+xml'
    ],
    [
        'otc',
        'application/vnd.oasis.opendocument.chart-template'
    ],
    [
        'otf',
        'font/otf'
    ],
    [
        'otg',
        'application/vnd.oasis.opendocument.graphics-template'
    ],
    [
        'oth',
        'application/vnd.oasis.opendocument.text-web'
    ],
    [
        'oti',
        'application/vnd.oasis.opendocument.image-template'
    ],
    [
        'otp',
        'application/vnd.oasis.opendocument.presentation-template'
    ],
    [
        'ots',
        'application/vnd.oasis.opendocument.spreadsheet-template'
    ],
    [
        'ott',
        'application/vnd.oasis.opendocument.text-template'
    ],
    [
        'ova',
        'application/x-virtualbox-ova'
    ],
    [
        'ovf',
        'application/x-virtualbox-ovf'
    ],
    [
        'owl',
        'application/rdf+xml'
    ],
    [
        'oxps',
        'application/oxps'
    ],
    [
        'oxt',
        'application/vnd.openofficeorg.extension'
    ],
    [
        'p',
        'text/x-pascal'
    ],
    [
        'p7a',
        'application/x-pkcs7-signature'
    ],
    [
        'p7b',
        'application/x-pkcs7-certificates'
    ],
    [
        'p7c',
        'application/pkcs7-mime'
    ],
    [
        'p7m',
        'application/pkcs7-mime'
    ],
    [
        'p7r',
        'application/x-pkcs7-certreqresp'
    ],
    [
        'p7s',
        'application/pkcs7-signature'
    ],
    [
        'p8',
        'application/pkcs8'
    ],
    [
        'p10',
        'application/x-pkcs10'
    ],
    [
        'p12',
        'application/x-pkcs12'
    ],
    [
        'pac',
        'application/x-ns-proxy-autoconfig'
    ],
    [
        'pages',
        'application/x-iwork-pages-sffpages'
    ],
    [
        'pas',
        'text/x-pascal'
    ],
    [
        'paw',
        'application/vnd.pawaafile'
    ],
    [
        'pbd',
        'application/vnd.powerbuilder6'
    ],
    [
        'pbm',
        'image/x-portable-bitmap'
    ],
    [
        'pcap',
        'application/vnd.tcpdump.pcap'
    ],
    [
        'pcf',
        'application/x-font-pcf'
    ],
    [
        'pcl',
        'application/vnd.hp-pcl'
    ],
    [
        'pclxl',
        'application/vnd.hp-pclxl'
    ],
    [
        'pct',
        'image/x-pict'
    ],
    [
        'pcurl',
        'application/vnd.curl.pcurl'
    ],
    [
        'pcx',
        'image/x-pcx'
    ],
    [
        'pdb',
        'application/x-pilot'
    ],
    [
        'pde',
        'text/x-processing'
    ],
    [
        'pdf',
        'application/pdf'
    ],
    [
        'pem',
        'application/x-x509-user-cert'
    ],
    [
        'pfa',
        'application/x-font-type1'
    ],
    [
        'pfb',
        'application/x-font-type1'
    ],
    [
        'pfm',
        'application/x-font-type1'
    ],
    [
        'pfr',
        'application/font-tdpfr'
    ],
    [
        'pfx',
        'application/x-pkcs12'
    ],
    [
        'pgm',
        'image/x-portable-graymap'
    ],
    [
        'pgn',
        'application/x-chess-pgn'
    ],
    [
        'pgp',
        'application/pgp'
    ],
    [
        'php',
        'application/x-httpd-php'
    ],
    [
        'php3',
        'application/x-httpd-php'
    ],
    [
        'php4',
        'application/x-httpd-php'
    ],
    [
        'phps',
        'application/x-httpd-php-source'
    ],
    [
        'phtml',
        'application/x-httpd-php'
    ],
    [
        'pic',
        'image/x-pict'
    ],
    [
        'pkg',
        'application/octet-stream'
    ],
    [
        'pki',
        'application/pkixcmp'
    ],
    [
        'pkipath',
        'application/pkix-pkipath'
    ],
    [
        'pkpass',
        'application/vnd.apple.pkpass'
    ],
    [
        'pl',
        'application/x-perl'
    ],
    [
        'plb',
        'application/vnd.3gpp.pic-bw-large'
    ],
    [
        'plc',
        'application/vnd.mobius.plc'
    ],
    [
        'plf',
        'application/vnd.pocketlearn'
    ],
    [
        'pls',
        'application/pls+xml'
    ],
    [
        'pm',
        'application/x-perl'
    ],
    [
        'pml',
        'application/vnd.ctc-posml'
    ],
    [
        'png',
        'image/png'
    ],
    [
        'pnm',
        'image/x-portable-anymap'
    ],
    [
        'portpkg',
        'application/vnd.macports.portpkg'
    ],
    [
        'pot',
        'application/vnd.ms-powerpoint'
    ],
    [
        'potm',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12'
    ],
    [
        'potx',
        'application/vnd.openxmlformats-officedocument.presentationml.template'
    ],
    [
        'ppa',
        'application/vnd.ms-powerpoint'
    ],
    [
        'ppam',
        'application/vnd.ms-powerpoint.addin.macroEnabled.12'
    ],
    [
        'ppd',
        'application/vnd.cups-ppd'
    ],
    [
        'ppm',
        'image/x-portable-pixmap'
    ],
    [
        'pps',
        'application/vnd.ms-powerpoint'
    ],
    [
        'ppsm',
        'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
    ],
    [
        'ppsx',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow'
    ],
    [
        'ppt',
        'application/powerpoint'
    ],
    [
        'pptm',
        'application/vnd.ms-powerpoint.presentation.macroEnabled.12'
    ],
    [
        'pptx',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ],
    [
        'pqa',
        'application/vnd.palm'
    ],
    [
        'prc',
        'application/x-pilot'
    ],
    [
        'pre',
        'application/vnd.lotus-freelance'
    ],
    [
        'prf',
        'application/pics-rules'
    ],
    [
        'provx',
        'application/provenance+xml'
    ],
    [
        'ps',
        'application/postscript'
    ],
    [
        'psb',
        'application/vnd.3gpp.pic-bw-small'
    ],
    [
        'psd',
        'application/x-photoshop'
    ],
    [
        'psf',
        'application/x-font-linux-psf'
    ],
    [
        'pskcxml',
        'application/pskc+xml'
    ],
    [
        'pti',
        'image/prs.pti'
    ],
    [
        'ptid',
        'application/vnd.pvi.ptid1'
    ],
    [
        'pub',
        'application/x-mspublisher'
    ],
    [
        'pvb',
        'application/vnd.3gpp.pic-bw-var'
    ],
    [
        'pwn',
        'application/vnd.3m.post-it-notes'
    ],
    [
        'pya',
        'audio/vnd.ms-playready.media.pya'
    ],
    [
        'pyv',
        'video/vnd.ms-playready.media.pyv'
    ],
    [
        'qam',
        'application/vnd.epson.quickanime'
    ],
    [
        'qbo',
        'application/vnd.intu.qbo'
    ],
    [
        'qfx',
        'application/vnd.intu.qfx'
    ],
    [
        'qps',
        'application/vnd.publishare-delta-tree'
    ],
    [
        'qt',
        'video/quicktime'
    ],
    [
        'qwd',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qwt',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxb',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxd',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxl',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'qxt',
        'application/vnd.quark.quarkxpress'
    ],
    [
        'ra',
        'audio/x-realaudio'
    ],
    [
        'ram',
        'audio/x-pn-realaudio'
    ],
    [
        'raml',
        'application/raml+yaml'
    ],
    [
        'rapd',
        'application/route-apd+xml'
    ],
    [
        'rar',
        'application/x-rar'
    ],
    [
        'ras',
        'image/x-cmu-raster'
    ],
    [
        'rcprofile',
        'application/vnd.ipunplugged.rcprofile'
    ],
    [
        'rdf',
        'application/rdf+xml'
    ],
    [
        'rdz',
        'application/vnd.data-vision.rdz'
    ],
    [
        'relo',
        'application/p2p-overlay+xml'
    ],
    [
        'rep',
        'application/vnd.businessobjects'
    ],
    [
        'res',
        'application/x-dtbresource+xml'
    ],
    [
        'rgb',
        'image/x-rgb'
    ],
    [
        'rif',
        'application/reginfo+xml'
    ],
    [
        'rip',
        'audio/vnd.rip'
    ],
    [
        'ris',
        'application/x-research-info-systems'
    ],
    [
        'rl',
        'application/resource-lists+xml'
    ],
    [
        'rlc',
        'image/vnd.fujixerox.edmics-rlc'
    ],
    [
        'rld',
        'application/resource-lists-diff+xml'
    ],
    [
        'rm',
        'audio/x-pn-realaudio'
    ],
    [
        'rmi',
        'audio/midi'
    ],
    [
        'rmp',
        'audio/x-pn-realaudio-plugin'
    ],
    [
        'rms',
        'application/vnd.jcp.javame.midlet-rms'
    ],
    [
        'rmvb',
        'application/vnd.rn-realmedia-vbr'
    ],
    [
        'rnc',
        'application/relax-ng-compact-syntax'
    ],
    [
        'rng',
        'application/xml'
    ],
    [
        'roa',
        'application/rpki-roa'
    ],
    [
        'roff',
        'text/troff'
    ],
    [
        'rp9',
        'application/vnd.cloanto.rp9'
    ],
    [
        'rpm',
        'audio/x-pn-realaudio-plugin'
    ],
    [
        'rpss',
        'application/vnd.nokia.radio-presets'
    ],
    [
        'rpst',
        'application/vnd.nokia.radio-preset'
    ],
    [
        'rq',
        'application/sparql-query'
    ],
    [
        'rs',
        'application/rls-services+xml'
    ],
    [
        'rsa',
        'application/x-pkcs7'
    ],
    [
        'rsat',
        'application/atsc-rsat+xml'
    ],
    [
        'rsd',
        'application/rsd+xml'
    ],
    [
        'rsheet',
        'application/urc-ressheet+xml'
    ],
    [
        'rss',
        'application/rss+xml'
    ],
    [
        'rtf',
        'text/rtf'
    ],
    [
        'rtx',
        'text/richtext'
    ],
    [
        'run',
        'application/x-makeself'
    ],
    [
        'rusd',
        'application/route-usd+xml'
    ],
    [
        'rv',
        'video/vnd.rn-realvideo'
    ],
    [
        's',
        'text/x-asm'
    ],
    [
        's3m',
        'audio/s3m'
    ],
    [
        'saf',
        'application/vnd.yamaha.smaf-audio'
    ],
    [
        'sass',
        'text/x-sass'
    ],
    [
        'sbml',
        'application/sbml+xml'
    ],
    [
        'sc',
        'application/vnd.ibm.secure-container'
    ],
    [
        'scd',
        'application/x-msschedule'
    ],
    [
        'scm',
        'application/vnd.lotus-screencam'
    ],
    [
        'scq',
        'application/scvp-cv-request'
    ],
    [
        'scs',
        'application/scvp-cv-response'
    ],
    [
        'scss',
        'text/x-scss'
    ],
    [
        'scurl',
        'text/vnd.curl.scurl'
    ],
    [
        'sda',
        'application/vnd.stardivision.draw'
    ],
    [
        'sdc',
        'application/vnd.stardivision.calc'
    ],
    [
        'sdd',
        'application/vnd.stardivision.impress'
    ],
    [
        'sdkd',
        'application/vnd.solent.sdkm+xml'
    ],
    [
        'sdkm',
        'application/vnd.solent.sdkm+xml'
    ],
    [
        'sdp',
        'application/sdp'
    ],
    [
        'sdw',
        'application/vnd.stardivision.writer'
    ],
    [
        'sea',
        'application/octet-stream'
    ],
    [
        'see',
        'application/vnd.seemail'
    ],
    [
        'seed',
        'application/vnd.fdsn.seed'
    ],
    [
        'sema',
        'application/vnd.sema'
    ],
    [
        'semd',
        'application/vnd.semd'
    ],
    [
        'semf',
        'application/vnd.semf'
    ],
    [
        'senmlx',
        'application/senml+xml'
    ],
    [
        'sensmlx',
        'application/sensml+xml'
    ],
    [
        'ser',
        'application/java-serialized-object'
    ],
    [
        'setpay',
        'application/set-payment-initiation'
    ],
    [
        'setreg',
        'application/set-registration-initiation'
    ],
    [
        'sfd-hdstx',
        'application/vnd.hydrostatix.sof-data'
    ],
    [
        'sfs',
        'application/vnd.spotfire.sfs'
    ],
    [
        'sfv',
        'text/x-sfv'
    ],
    [
        'sgi',
        'image/sgi'
    ],
    [
        'sgl',
        'application/vnd.stardivision.writer-global'
    ],
    [
        'sgm',
        'text/sgml'
    ],
    [
        'sgml',
        'text/sgml'
    ],
    [
        'sh',
        'application/x-sh'
    ],
    [
        'shar',
        'application/x-shar'
    ],
    [
        'shex',
        'text/shex'
    ],
    [
        'shf',
        'application/shf+xml'
    ],
    [
        'shtml',
        'text/html'
    ],
    [
        'sid',
        'image/x-mrsid-image'
    ],
    [
        'sieve',
        'application/sieve'
    ],
    [
        'sig',
        'application/pgp-signature'
    ],
    [
        'sil',
        'audio/silk'
    ],
    [
        'silo',
        'model/mesh'
    ],
    [
        'sis',
        'application/vnd.symbian.install'
    ],
    [
        'sisx',
        'application/vnd.symbian.install'
    ],
    [
        'sit',
        'application/x-stuffit'
    ],
    [
        'sitx',
        'application/x-stuffitx'
    ],
    [
        'siv',
        'application/sieve'
    ],
    [
        'skd',
        'application/vnd.koan'
    ],
    [
        'skm',
        'application/vnd.koan'
    ],
    [
        'skp',
        'application/vnd.koan'
    ],
    [
        'skt',
        'application/vnd.koan'
    ],
    [
        'sldm',
        'application/vnd.ms-powerpoint.slide.macroenabled.12'
    ],
    [
        'sldx',
        'application/vnd.openxmlformats-officedocument.presentationml.slide'
    ],
    [
        'slim',
        'text/slim'
    ],
    [
        'slm',
        'text/slim'
    ],
    [
        'sls',
        'application/route-s-tsid+xml'
    ],
    [
        'slt',
        'application/vnd.epson.salt'
    ],
    [
        'sm',
        'application/vnd.stepmania.stepchart'
    ],
    [
        'smf',
        'application/vnd.stardivision.math'
    ],
    [
        'smi',
        'application/smil'
    ],
    [
        'smil',
        'application/smil'
    ],
    [
        'smv',
        'video/x-smv'
    ],
    [
        'smzip',
        'application/vnd.stepmania.package'
    ],
    [
        'snd',
        'audio/basic'
    ],
    [
        'snf',
        'application/x-font-snf'
    ],
    [
        'so',
        'application/octet-stream'
    ],
    [
        'spc',
        'application/x-pkcs7-certificates'
    ],
    [
        'spdx',
        'text/spdx'
    ],
    [
        'spf',
        'application/vnd.yamaha.smaf-phrase'
    ],
    [
        'spl',
        'application/x-futuresplash'
    ],
    [
        'spot',
        'text/vnd.in3d.spot'
    ],
    [
        'spp',
        'application/scvp-vp-response'
    ],
    [
        'spq',
        'application/scvp-vp-request'
    ],
    [
        'spx',
        'audio/ogg'
    ],
    [
        'sql',
        'application/x-sql'
    ],
    [
        'src',
        'application/x-wais-source'
    ],
    [
        'srt',
        'application/x-subrip'
    ],
    [
        'sru',
        'application/sru+xml'
    ],
    [
        'srx',
        'application/sparql-results+xml'
    ],
    [
        'ssdl',
        'application/ssdl+xml'
    ],
    [
        'sse',
        'application/vnd.kodak-descriptor'
    ],
    [
        'ssf',
        'application/vnd.epson.ssf'
    ],
    [
        'ssml',
        'application/ssml+xml'
    ],
    [
        'sst',
        'application/octet-stream'
    ],
    [
        'st',
        'application/vnd.sailingtracker.track'
    ],
    [
        'stc',
        'application/vnd.sun.xml.calc.template'
    ],
    [
        'std',
        'application/vnd.sun.xml.draw.template'
    ],
    [
        'stf',
        'application/vnd.wt.stf'
    ],
    [
        'sti',
        'application/vnd.sun.xml.impress.template'
    ],
    [
        'stk',
        'application/hyperstudio'
    ],
    [
        'stl',
        'model/stl'
    ],
    [
        'stpx',
        'model/step+xml'
    ],
    [
        'stpxz',
        'model/step-xml+zip'
    ],
    [
        'stpz',
        'model/step+zip'
    ],
    [
        'str',
        'application/vnd.pg.format'
    ],
    [
        'stw',
        'application/vnd.sun.xml.writer.template'
    ],
    [
        'styl',
        'text/stylus'
    ],
    [
        'stylus',
        'text/stylus'
    ],
    [
        'sub',
        'text/vnd.dvb.subtitle'
    ],
    [
        'sus',
        'application/vnd.sus-calendar'
    ],
    [
        'susp',
        'application/vnd.sus-calendar'
    ],
    [
        'sv4cpio',
        'application/x-sv4cpio'
    ],
    [
        'sv4crc',
        'application/x-sv4crc'
    ],
    [
        'svc',
        'application/vnd.dvb.service'
    ],
    [
        'svd',
        'application/vnd.svd'
    ],
    [
        'svg',
        'image/svg+xml'
    ],
    [
        'svgz',
        'image/svg+xml'
    ],
    [
        'swa',
        'application/x-director'
    ],
    [
        'swf',
        'application/x-shockwave-flash'
    ],
    [
        'swi',
        'application/vnd.aristanetworks.swi'
    ],
    [
        'swidtag',
        'application/swid+xml'
    ],
    [
        'sxc',
        'application/vnd.sun.xml.calc'
    ],
    [
        'sxd',
        'application/vnd.sun.xml.draw'
    ],
    [
        'sxg',
        'application/vnd.sun.xml.writer.global'
    ],
    [
        'sxi',
        'application/vnd.sun.xml.impress'
    ],
    [
        'sxm',
        'application/vnd.sun.xml.math'
    ],
    [
        'sxw',
        'application/vnd.sun.xml.writer'
    ],
    [
        't',
        'text/troff'
    ],
    [
        't3',
        'application/x-t3vm-image'
    ],
    [
        't38',
        'image/t38'
    ],
    [
        'taglet',
        'application/vnd.mynfc'
    ],
    [
        'tao',
        'application/vnd.tao.intent-module-archive'
    ],
    [
        'tap',
        'image/vnd.tencent.tap'
    ],
    [
        'tar',
        'application/x-tar'
    ],
    [
        'tcap',
        'application/vnd.3gpp2.tcap'
    ],
    [
        'tcl',
        'application/x-tcl'
    ],
    [
        'td',
        'application/urc-targetdesc+xml'
    ],
    [
        'teacher',
        'application/vnd.smart.teacher'
    ],
    [
        'tei',
        'application/tei+xml'
    ],
    [
        'teicorpus',
        'application/tei+xml'
    ],
    [
        'tex',
        'application/x-tex'
    ],
    [
        'texi',
        'application/x-texinfo'
    ],
    [
        'texinfo',
        'application/x-texinfo'
    ],
    [
        'text',
        'text/plain'
    ],
    [
        'tfi',
        'application/thraud+xml'
    ],
    [
        'tfm',
        'application/x-tex-tfm'
    ],
    [
        'tfx',
        'image/tiff-fx'
    ],
    [
        'tga',
        'image/x-tga'
    ],
    [
        'tgz',
        'application/x-tar'
    ],
    [
        'thmx',
        'application/vnd.ms-officetheme'
    ],
    [
        'tif',
        'image/tiff'
    ],
    [
        'tiff',
        'image/tiff'
    ],
    [
        'tk',
        'application/x-tcl'
    ],
    [
        'tmo',
        'application/vnd.tmobile-livetv'
    ],
    [
        'toml',
        'application/toml'
    ],
    [
        'torrent',
        'application/x-bittorrent'
    ],
    [
        'tpl',
        'application/vnd.groove-tool-template'
    ],
    [
        'tpt',
        'application/vnd.trid.tpt'
    ],
    [
        'tr',
        'text/troff'
    ],
    [
        'tra',
        'application/vnd.trueapp'
    ],
    [
        'trig',
        'application/trig'
    ],
    [
        'trm',
        'application/x-msterminal'
    ],
    [
        'ts',
        'video/mp2t'
    ],
    [
        'tsd',
        'application/timestamped-data'
    ],
    [
        'tsv',
        'text/tab-separated-values'
    ],
    [
        'ttc',
        'font/collection'
    ],
    [
        'ttf',
        'font/ttf'
    ],
    [
        'ttl',
        'text/turtle'
    ],
    [
        'ttml',
        'application/ttml+xml'
    ],
    [
        'twd',
        'application/vnd.simtech-mindmapper'
    ],
    [
        'twds',
        'application/vnd.simtech-mindmapper'
    ],
    [
        'txd',
        'application/vnd.genomatix.tuxedo'
    ],
    [
        'txf',
        'application/vnd.mobius.txf'
    ],
    [
        'txt',
        'text/plain'
    ],
    [
        'u8dsn',
        'message/global-delivery-status'
    ],
    [
        'u8hdr',
        'message/global-headers'
    ],
    [
        'u8mdn',
        'message/global-disposition-notification'
    ],
    [
        'u8msg',
        'message/global'
    ],
    [
        'u32',
        'application/x-authorware-bin'
    ],
    [
        'ubj',
        'application/ubjson'
    ],
    [
        'udeb',
        'application/x-debian-package'
    ],
    [
        'ufd',
        'application/vnd.ufdl'
    ],
    [
        'ufdl',
        'application/vnd.ufdl'
    ],
    [
        'ulx',
        'application/x-glulx'
    ],
    [
        'umj',
        'application/vnd.umajin'
    ],
    [
        'unityweb',
        'application/vnd.unity'
    ],
    [
        'uoml',
        'application/vnd.uoml+xml'
    ],
    [
        'uri',
        'text/uri-list'
    ],
    [
        'uris',
        'text/uri-list'
    ],
    [
        'urls',
        'text/uri-list'
    ],
    [
        'usdz',
        'model/vnd.usdz+zip'
    ],
    [
        'ustar',
        'application/x-ustar'
    ],
    [
        'utz',
        'application/vnd.uiq.theme'
    ],
    [
        'uu',
        'text/x-uuencode'
    ],
    [
        'uva',
        'audio/vnd.dece.audio'
    ],
    [
        'uvd',
        'application/vnd.dece.data'
    ],
    [
        'uvf',
        'application/vnd.dece.data'
    ],
    [
        'uvg',
        'image/vnd.dece.graphic'
    ],
    [
        'uvh',
        'video/vnd.dece.hd'
    ],
    [
        'uvi',
        'image/vnd.dece.graphic'
    ],
    [
        'uvm',
        'video/vnd.dece.mobile'
    ],
    [
        'uvp',
        'video/vnd.dece.pd'
    ],
    [
        'uvs',
        'video/vnd.dece.sd'
    ],
    [
        'uvt',
        'application/vnd.dece.ttml+xml'
    ],
    [
        'uvu',
        'video/vnd.uvvu.mp4'
    ],
    [
        'uvv',
        'video/vnd.dece.video'
    ],
    [
        'uvva',
        'audio/vnd.dece.audio'
    ],
    [
        'uvvd',
        'application/vnd.dece.data'
    ],
    [
        'uvvf',
        'application/vnd.dece.data'
    ],
    [
        'uvvg',
        'image/vnd.dece.graphic'
    ],
    [
        'uvvh',
        'video/vnd.dece.hd'
    ],
    [
        'uvvi',
        'image/vnd.dece.graphic'
    ],
    [
        'uvvm',
        'video/vnd.dece.mobile'
    ],
    [
        'uvvp',
        'video/vnd.dece.pd'
    ],
    [
        'uvvs',
        'video/vnd.dece.sd'
    ],
    [
        'uvvt',
        'application/vnd.dece.ttml+xml'
    ],
    [
        'uvvu',
        'video/vnd.uvvu.mp4'
    ],
    [
        'uvvv',
        'video/vnd.dece.video'
    ],
    [
        'uvvx',
        'application/vnd.dece.unspecified'
    ],
    [
        'uvvz',
        'application/vnd.dece.zip'
    ],
    [
        'uvx',
        'application/vnd.dece.unspecified'
    ],
    [
        'uvz',
        'application/vnd.dece.zip'
    ],
    [
        'vbox',
        'application/x-virtualbox-vbox'
    ],
    [
        'vbox-extpack',
        'application/x-virtualbox-vbox-extpack'
    ],
    [
        'vcard',
        'text/vcard'
    ],
    [
        'vcd',
        'application/x-cdlink'
    ],
    [
        'vcf',
        'text/x-vcard'
    ],
    [
        'vcg',
        'application/vnd.groove-vcard'
    ],
    [
        'vcs',
        'text/x-vcalendar'
    ],
    [
        'vcx',
        'application/vnd.vcx'
    ],
    [
        'vdi',
        'application/x-virtualbox-vdi'
    ],
    [
        'vds',
        'model/vnd.sap.vds'
    ],
    [
        'vhd',
        'application/x-virtualbox-vhd'
    ],
    [
        'vis',
        'application/vnd.visionary'
    ],
    [
        'viv',
        'video/vnd.vivo'
    ],
    [
        'vlc',
        'application/videolan'
    ],
    [
        'vmdk',
        'application/x-virtualbox-vmdk'
    ],
    [
        'vob',
        'video/x-ms-vob'
    ],
    [
        'vor',
        'application/vnd.stardivision.writer'
    ],
    [
        'vox',
        'application/x-authorware-bin'
    ],
    [
        'vrml',
        'model/vrml'
    ],
    [
        'vsd',
        'application/vnd.visio'
    ],
    [
        'vsf',
        'application/vnd.vsf'
    ],
    [
        'vss',
        'application/vnd.visio'
    ],
    [
        'vst',
        'application/vnd.visio'
    ],
    [
        'vsw',
        'application/vnd.visio'
    ],
    [
        'vtf',
        'image/vnd.valve.source.texture'
    ],
    [
        'vtt',
        'text/vtt'
    ],
    [
        'vtu',
        'model/vnd.vtu'
    ],
    [
        'vxml',
        'application/voicexml+xml'
    ],
    [
        'w3d',
        'application/x-director'
    ],
    [
        'wad',
        'application/x-doom'
    ],
    [
        'wadl',
        'application/vnd.sun.wadl+xml'
    ],
    [
        'war',
        'application/java-archive'
    ],
    [
        'wasm',
        'application/wasm'
    ],
    [
        'wav',
        'audio/x-wav'
    ],
    [
        'wax',
        'audio/x-ms-wax'
    ],
    [
        'wbmp',
        'image/vnd.wap.wbmp'
    ],
    [
        'wbs',
        'application/vnd.criticaltools.wbs+xml'
    ],
    [
        'wbxml',
        'application/wbxml'
    ],
    [
        'wcm',
        'application/vnd.ms-works'
    ],
    [
        'wdb',
        'application/vnd.ms-works'
    ],
    [
        'wdp',
        'image/vnd.ms-photo'
    ],
    [
        'weba',
        'audio/webm'
    ],
    [
        'webapp',
        'application/x-web-app-manifest+json'
    ],
    [
        'webm',
        'video/webm'
    ],
    [
        'webmanifest',
        'application/manifest+json'
    ],
    [
        'webp',
        'image/webp'
    ],
    [
        'wg',
        'application/vnd.pmi.widget'
    ],
    [
        'wgt',
        'application/widget'
    ],
    [
        'wks',
        'application/vnd.ms-works'
    ],
    [
        'wm',
        'video/x-ms-wm'
    ],
    [
        'wma',
        'audio/x-ms-wma'
    ],
    [
        'wmd',
        'application/x-ms-wmd'
    ],
    [
        'wmf',
        'image/wmf'
    ],
    [
        'wml',
        'text/vnd.wap.wml'
    ],
    [
        'wmlc',
        'application/wmlc'
    ],
    [
        'wmls',
        'text/vnd.wap.wmlscript'
    ],
    [
        'wmlsc',
        'application/vnd.wap.wmlscriptc'
    ],
    [
        'wmv',
        'video/x-ms-wmv'
    ],
    [
        'wmx',
        'video/x-ms-wmx'
    ],
    [
        'wmz',
        'application/x-msmetafile'
    ],
    [
        'woff',
        'font/woff'
    ],
    [
        'woff2',
        'font/woff2'
    ],
    [
        'word',
        'application/msword'
    ],
    [
        'wpd',
        'application/vnd.wordperfect'
    ],
    [
        'wpl',
        'application/vnd.ms-wpl'
    ],
    [
        'wps',
        'application/vnd.ms-works'
    ],
    [
        'wqd',
        'application/vnd.wqd'
    ],
    [
        'wri',
        'application/x-mswrite'
    ],
    [
        'wrl',
        'model/vrml'
    ],
    [
        'wsc',
        'message/vnd.wfa.wsc'
    ],
    [
        'wsdl',
        'application/wsdl+xml'
    ],
    [
        'wspolicy',
        'application/wspolicy+xml'
    ],
    [
        'wtb',
        'application/vnd.webturbo'
    ],
    [
        'wvx',
        'video/x-ms-wvx'
    ],
    [
        'x3d',
        'model/x3d+xml'
    ],
    [
        'x3db',
        'model/x3d+fastinfoset'
    ],
    [
        'x3dbz',
        'model/x3d+binary'
    ],
    [
        'x3dv',
        'model/x3d-vrml'
    ],
    [
        'x3dvz',
        'model/x3d+vrml'
    ],
    [
        'x3dz',
        'model/x3d+xml'
    ],
    [
        'x32',
        'application/x-authorware-bin'
    ],
    [
        'x_b',
        'model/vnd.parasolid.transmit.binary'
    ],
    [
        'x_t',
        'model/vnd.parasolid.transmit.text'
    ],
    [
        'xaml',
        'application/xaml+xml'
    ],
    [
        'xap',
        'application/x-silverlight-app'
    ],
    [
        'xar',
        'application/vnd.xara'
    ],
    [
        'xav',
        'application/xcap-att+xml'
    ],
    [
        'xbap',
        'application/x-ms-xbap'
    ],
    [
        'xbd',
        'application/vnd.fujixerox.docuworks.binder'
    ],
    [
        'xbm',
        'image/x-xbitmap'
    ],
    [
        'xca',
        'application/xcap-caps+xml'
    ],
    [
        'xcs',
        'application/calendar+xml'
    ],
    [
        'xdf',
        'application/xcap-diff+xml'
    ],
    [
        'xdm',
        'application/vnd.syncml.dm+xml'
    ],
    [
        'xdp',
        'application/vnd.adobe.xdp+xml'
    ],
    [
        'xdssc',
        'application/dssc+xml'
    ],
    [
        'xdw',
        'application/vnd.fujixerox.docuworks'
    ],
    [
        'xel',
        'application/xcap-el+xml'
    ],
    [
        'xenc',
        'application/xenc+xml'
    ],
    [
        'xer',
        'application/patch-ops-error+xml'
    ],
    [
        'xfdf',
        'application/vnd.adobe.xfdf'
    ],
    [
        'xfdl',
        'application/vnd.xfdl'
    ],
    [
        'xht',
        'application/xhtml+xml'
    ],
    [
        'xhtml',
        'application/xhtml+xml'
    ],
    [
        'xhvml',
        'application/xv+xml'
    ],
    [
        'xif',
        'image/vnd.xiff'
    ],
    [
        'xl',
        'application/excel'
    ],
    [
        'xla',
        'application/vnd.ms-excel'
    ],
    [
        'xlam',
        'application/vnd.ms-excel.addin.macroEnabled.12'
    ],
    [
        'xlc',
        'application/vnd.ms-excel'
    ],
    [
        'xlf',
        'application/xliff+xml'
    ],
    [
        'xlm',
        'application/vnd.ms-excel'
    ],
    [
        'xls',
        'application/vnd.ms-excel'
    ],
    [
        'xlsb',
        'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
    ],
    [
        'xlsm',
        'application/vnd.ms-excel.sheet.macroEnabled.12'
    ],
    [
        'xlsx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ],
    [
        'xlt',
        'application/vnd.ms-excel'
    ],
    [
        'xltm',
        'application/vnd.ms-excel.template.macroEnabled.12'
    ],
    [
        'xltx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template'
    ],
    [
        'xlw',
        'application/vnd.ms-excel'
    ],
    [
        'xm',
        'audio/xm'
    ],
    [
        'xml',
        'application/xml'
    ],
    [
        'xns',
        'application/xcap-ns+xml'
    ],
    [
        'xo',
        'application/vnd.olpc-sugar'
    ],
    [
        'xop',
        'application/xop+xml'
    ],
    [
        'xpi',
        'application/x-xpinstall'
    ],
    [
        'xpl',
        'application/xproc+xml'
    ],
    [
        'xpm',
        'image/x-xpixmap'
    ],
    [
        'xpr',
        'application/vnd.is-xpr'
    ],
    [
        'xps',
        'application/vnd.ms-xpsdocument'
    ],
    [
        'xpw',
        'application/vnd.intercon.formnet'
    ],
    [
        'xpx',
        'application/vnd.intercon.formnet'
    ],
    [
        'xsd',
        'application/xml'
    ],
    [
        'xsl',
        'application/xml'
    ],
    [
        'xslt',
        'application/xslt+xml'
    ],
    [
        'xsm',
        'application/vnd.syncml+xml'
    ],
    [
        'xspf',
        'application/xspf+xml'
    ],
    [
        'xul',
        'application/vnd.mozilla.xul+xml'
    ],
    [
        'xvm',
        'application/xv+xml'
    ],
    [
        'xvml',
        'application/xv+xml'
    ],
    [
        'xwd',
        'image/x-xwindowdump'
    ],
    [
        'xyz',
        'chemical/x-xyz'
    ],
    [
        'xz',
        'application/x-xz'
    ],
    [
        'yaml',
        'text/yaml'
    ],
    [
        'yang',
        'application/yang'
    ],
    [
        'yin',
        'application/yin+xml'
    ],
    [
        'yml',
        'text/yaml'
    ],
    [
        'ymp',
        'text/x-suse-ymp'
    ],
    [
        'z',
        'application/x-compress'
    ],
    [
        'z1',
        'application/x-zmachine'
    ],
    [
        'z2',
        'application/x-zmachine'
    ],
    [
        'z3',
        'application/x-zmachine'
    ],
    [
        'z4',
        'application/x-zmachine'
    ],
    [
        'z5',
        'application/x-zmachine'
    ],
    [
        'z6',
        'application/x-zmachine'
    ],
    [
        'z7',
        'application/x-zmachine'
    ],
    [
        'z8',
        'application/x-zmachine'
    ],
    [
        'zaz',
        'application/vnd.zzazz.deck+xml'
    ],
    [
        'zip',
        'application/zip'
    ],
    [
        'zir',
        'application/vnd.zul'
    ],
    [
        'zirz',
        'application/vnd.zul'
    ],
    [
        'zmm',
        'application/vnd.handheld-entertainment+xml'
    ],
    [
        'zsh',
        'text/x-scriptzsh'
    ]
]);
function toFileWithPath(file, path, h) {
    const f = withMimeType(file);
    const { webkitRelativePath } = file;
    const p = typeof path === 'string' ? path : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0 ? webkitRelativePath : `./${file.name}`;
    if (typeof f.path !== 'string') setObjProp(f, 'path', p);
    if (h !== undefined) Object.defineProperty(f, 'handle', {
        value: h,
        writable: false,
        configurable: false,
        enumerable: true
    });
    // Always populate a relative path so that even electron apps have access to a relativePath value
    setObjProp(f, 'relativePath', p);
    return f;
}
function withMimeType(file) {
    const { name } = file;
    const hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        const ext = name.split('.').pop().toLowerCase();
        const type = COMMON_MIME_TYPES.get(ext);
        if (type) Object.defineProperty(file, 'type', {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}
function setObjProp(f, key, value) {
    Object.defineProperty(f, key, {
        value,
        writable: false,
        configurable: false,
        enumerable: true
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"c9xfP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FILE_INVALID_TYPE", ()=>FILE_INVALID_TYPE);
parcelHelpers.export(exports, "FILE_TOO_LARGE", ()=>FILE_TOO_LARGE);
parcelHelpers.export(exports, "FILE_TOO_SMALL", ()=>FILE_TOO_SMALL);
parcelHelpers.export(exports, "TOO_MANY_FILES", ()=>TOO_MANY_FILES);
parcelHelpers.export(exports, "ErrorCode", ()=>ErrorCode);
parcelHelpers.export(exports, "getInvalidTypeRejectionErr", ()=>getInvalidTypeRejectionErr);
parcelHelpers.export(exports, "getTooLargeRejectionErr", ()=>getTooLargeRejectionErr);
parcelHelpers.export(exports, "getTooSmallRejectionErr", ()=>getTooSmallRejectionErr);
parcelHelpers.export(exports, "TOO_MANY_FILES_REJECTION", ()=>TOO_MANY_FILES_REJECTION);
/**
 * Check if the given file is a DataTransferItem with an empty type.
 *
 * During drag events, browsers may return DataTransferItem objects instead of File objects.
 * Some browsers (e.g., Chrome) return an empty MIME type for certain file types (like .md files)
 * on DataTransferItem during drag events, even though the type is correctly set during drop.
 *
 * This function detects such cases by checking for:
 * 1. Empty type string
 * 2. Presence of getAsFile method (indicates it's a DataTransferItem, not a File)
 *
 * We accept these during drag to provide proper UI feedback, while maintaining
 * strict validation during drop when real File objects are available.
 *
 * @param {File | DataTransferItem} file
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isDataTransferItemWithEmptyType", ()=>isDataTransferItemWithEmptyType);
/**
 * Check if file is accepted.
 *
 * Firefox versions prior to 53 return a bogus MIME type for every file drag,
 * so dragovers with that MIME type will always be accepted.
 *
 * Chrome/other browsers may return an empty MIME type for files during drag events,
 * so we accept those as well (we'll validate properly on drop).
 *
 * @param {File} file
 * @param {string} accept
 * @returns
 */ parcelHelpers.export(exports, "fileAccepted", ()=>fileAccepted);
parcelHelpers.export(exports, "fileMatchSize", ()=>fileMatchSize);
/**
 *
 * @param {object} options
 * @param {File[]} options.files
 * @param {string} [options.accept]
 * @param {number} [options.minSize]
 * @param {number} [options.maxSize]
 * @param {boolean} [options.multiple]
 * @param {number} [options.maxFiles]
 * @param {(f: File) => FileError|FileError[]|null} [options.validator]
 * @returns
 */ parcelHelpers.export(exports, "allFilesAccepted", ()=>allFilesAccepted) // React's synthetic events has event.isPropagationStopped,
;
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble
parcelHelpers.export(exports, "isPropagationStopped", ()=>isPropagationStopped);
parcelHelpers.export(exports, "isEvtWithFiles", ()=>isEvtWithFiles);
parcelHelpers.export(exports, "isKindFile", ()=>isKindFile) // allow the entire document to be a drag target
;
parcelHelpers.export(exports, "onDocumentDragOver", ()=>onDocumentDragOver);
parcelHelpers.export(exports, "isIeOrEdge", ()=>isIeOrEdge);
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */ parcelHelpers.export(exports, "composeEventHandlers", ()=>composeEventHandlers);
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */ parcelHelpers.export(exports, "canUseFileSystemAccessAPI", ()=>canUseFileSystemAccessAPI);
/**
 * Convert the `{accept}` dropzone prop to the
 * `{types}` option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 *
 * @param {AcceptProp} accept
 * @returns {{accept: string[]}[]}
 */ parcelHelpers.export(exports, "pickerOptionsFromAccept", ()=>pickerOptionsFromAccept);
/**
 * Convert the `{accept}` dropzone prop to an array of MIME types/extensions.
 * @param {AcceptProp} accept
 * @returns {string}
 */ parcelHelpers.export(exports, "acceptPropAsAcceptAttr", ()=>acceptPropAsAcceptAttr);
/**
 * Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is an abort exception.
 */ parcelHelpers.export(exports, "isAbort", ()=>isAbort);
/**
 * Check if v is a security error.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is a security error.
 */ parcelHelpers.export(exports, "isSecurityError", ()=>isSecurityError);
/**
 * Check if v is a MIME type string.
 *
 * See accepted format: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers.
 *
 * @param {string} v
 */ parcelHelpers.export(exports, "isMIMEType", ()=>isMIMEType);
/**
 * Check if v is a file extension.
 * @param {string} v
 */ parcelHelpers.export(exports, "isExt", ()=>isExt) /**
 * @typedef {Object.<string, string[]>} AcceptProp
 */  /**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */  /**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */ ;
var _attrAccept = require("attr-accept");
var _attrAcceptDefault = parcelHelpers.interopDefault(_attrAccept);
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var accepts = typeof (0, _attrAcceptDefault.default) === "function" ? (0, _attrAcceptDefault.default) : (0, _attrAcceptDefault.default).default; // Error codes
var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";
var ErrorCode = {
    FileInvalidType: FILE_INVALID_TYPE,
    FileTooLarge: FILE_TOO_LARGE,
    FileTooSmall: FILE_TOO_SMALL,
    TooManyFiles: TOO_MANY_FILES
};
var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr() {
    var accept = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var acceptArr = accept.split(",");
    var msg = acceptArr.length > 1 ? "one of ".concat(acceptArr.join(", ")) : acceptArr[0];
    return {
        code: FILE_INVALID_TYPE,
        message: "File type must be ".concat(msg)
    };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
    return {
        code: FILE_TOO_LARGE,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
    return {
        code: FILE_TOO_SMALL,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var TOO_MANY_FILES_REJECTION = {
    code: TOO_MANY_FILES,
    message: "Too many files"
};
function isDataTransferItemWithEmptyType(file) {
    return file.type === "" && typeof file.getAsFile === "function";
}
function fileAccepted(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || accepts(file, accept) || isDataTransferItemWithEmptyType(file);
    return [
        isAcceptable,
        isAcceptable ? null : getInvalidTypeRejectionErr(accept)
    ];
}
function fileMatchSize(file, minSize, maxSize) {
    if (isDefined(file.size)) {
        if (isDefined(minSize) && isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                getTooLargeRejectionErr(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                getTooSmallRejectionErr(minSize)
            ];
        } else if (isDefined(minSize) && file.size < minSize) return [
            false,
            getTooSmallRejectionErr(minSize)
        ];
        else if (isDefined(maxSize) && file.size > maxSize) return [
            false,
            getTooLargeRejectionErr(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function isDefined(value) {
    return value !== undefined && value !== null;
}
function allFilesAccepted(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = fileAccepted(file, accept), _fileAccepted2 = _slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = fileMatchSize(file, minSize, maxSize), _fileMatchSize2 = _slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
}
function isPropagationStopped(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function isEvtWithFiles(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function isKindFile(item) {
    return _typeof(item) === "object" && item !== null && item.kind === "file";
}
function onDocumentDragOver(event) {
    event.preventDefault();
}
function isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function isIeOrEdge() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return isIe(userAgent) || isEdge(userAgent);
}
function composeEventHandlers() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!isPropagationStopped(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return isPropagationStopped(event);
        });
    };
}
function canUseFileSystemAccessAPI() {
    return "showOpenFilePicker" in window;
}
function pickerOptionsFromAccept(accept) {
    if (isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!isMIMEType(mimeType)) {
                console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every(isExt)) {
                console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = _slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return _objectSpread(_objectSpread({}, agg), {}, _defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                // description is required due to https://crbug.com/1264708
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function acceptPropAsAcceptAttr(accept) {
    if (isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = _slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat(_toConsumableArray(a), [
            mimeType
        ], _toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function(v) {
        return isMIMEType(v) || isExt(v);
    }).join(",");
    return undefined;
}
function isAbort(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function isSecurityError(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function isMIMEType(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || v === "application/*" || /\w+\/[-+.\w]+/g.test(v);
}
function isExt(v) {
    return /^.*\.[\w]+$/.test(v);
}

},{"attr-accept":"a6rGJ","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"a6rGJ":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
        if (acceptedFilesArray.length === 0) return true;
        var fileName = file.name || '';
        var mimeType = (file.type || '').toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, '');
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === '.') return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith('/*')) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, '');
            return mimeType === validType;
        });
    }
    return true;
};

},{}],"hjClF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _akarIcons = require("akar-icons");
var _confirmdialog = require("primereact/confirmdialog");
var _tagsScss = require("../../../scss/components/tags.scss");
const Tags = ({ className, tags: tagsInit, selectedTags: selectedTagsInit, multiple = false, canChange = true, onChangeTags = null, onTagCreate = null, onTagDelete = null })=>{
    const [showingTagSelection, setShowingTagSelection] = (0, _react.useState)(false);
    const [selectedTags, setSelectedTags] = (0, _react.useState)(selectedTagsInit);
    (0, _react.useEffect)(()=>{
        // if (selectedTagsInit) {
        setSelectedTags(selectedTagsInit);
    // }
    }, [
        selectedTagsInit
    ]);
    const [tags, setTags] = (0, _react.useState)(tagsInit);
    const [busy, setBusy] = (0, _react.useState)(false);
    const tagSelect = (0, _react.useRef)(null);
    const tagTrigger = (0, _react.useRef)(null);
    const tagInput = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        var _tagSelect_current;
        if (tagSelect && showingTagSelection) (_tagSelect_current = tagSelect.current) === null || _tagSelect_current === void 0 ? void 0 : _tagSelect_current.focus();
    }, [
        showingTagSelection
    ]);
    (0, _react.useEffect)(()=>{
        if (tagsInit) {
            var _tagSelect_current;
            setTags(tagsInit);
            setBusy(false);
            if (tagInput.current) tagInput.current.value = "";
            showingTagSelection && ((_tagSelect_current = tagSelect.current) === null || _tagSelect_current === void 0 ? void 0 : _tagSelect_current.focus());
        }
    }, [
        tagsInit
    ]);
    const selectedIds = [];
    selectedTags && selectedTags.map((tag, key)=>{
        selectedIds.push(tag.value);
    });
    const doToggleTag = (label, value)=>{
        let newSelectedTags = selectedTags ? [
            ...selectedTags
        ] : [];
        const existingTag = newSelectedTags.findIndex((tag)=>tag.value === value);
        if (existingTag > -1) {
            newSelectedTags.splice(existingTag, 1);
            onChangeTags && onChangeTags(newSelectedTags);
            return setSelectedTags(newSelectedTags);
        }
        // only allow one to be selected
        if (!multiple) newSelectedTags = [
            {
                value: value,
                label: label
            }
        ];
        else newSelectedTags.push({
            value: value,
            label: label
        });
        onChangeTags && onChangeTags(newSelectedTags);
        setSelectedTags(newSelectedTags);
    };
    const doDeleteTagConfirm = (value)=>{
        (0, _confirmdialog.confirmDialog)({
            message: "Are you sure you want to delete this tag?",
            accept: ()=>doDeleteTag(value),
            className: "confirm-dialog",
            acceptClassName: "button",
            rejectClassName: "button button__invert"
        });
    };
    const doDeleteTag = (value)=>{
        if (!tags) return;
        let newTags = [
            ...tags
        ];
        let newSelectedTags = selectedTags ? [
            ...selectedTags
        ] : [];
        const selectedTag = newTags.findIndex((tag)=>tag.value === value);
        const existingTag = newSelectedTags.findIndex((tag)=>tag.value === value);
        if (selectedTag > -1) {
            newTags.splice(selectedTag, 1);
            setTags(newTags);
            if (existingTag > -1) {
                newSelectedTags.splice(existingTag, 1);
                onChangeTags && onChangeTags(newSelectedTags);
                setSelectedTags(newSelectedTags);
            }
            onTagDelete && onTagDelete(value);
        }
    };
    const doCreateTag = (e)=>{
        if (e.key === "Enter") {
            var _tagInput_current;
            if (tagInput === null || tagInput === void 0 ? void 0 : (_tagInput_current = tagInput.current) === null || _tagInput_current === void 0 ? void 0 : _tagInput_current.value) {
                var _tagInput_current1;
                setBusy(true);
                onTagCreate(tagInput === null || tagInput === void 0 ? void 0 : (_tagInput_current1 = tagInput.current) === null || _tagInput_current1 === void 0 ? void 0 : _tagInput_current1.value);
                if (tagInput.current) tagInput.current.value = "Adding tag...";
            }
            e.preventDefault();
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "tags" + (className ? ` ${className}` : "") + (showingTagSelection ? " tags__active" : "") + (!canChange ? " tags__passive" : ""),
        ref: tagTrigger,
        tabIndex: "0",
        onClick: (e)=>{
            var _e_target;
            if (!canChange) return;
            if (((_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.className) === "tags--tag-input") return e.preventDefault();
            setShowingTagSelection(!showingTagSelection);
        },
        children: [
            selectedTags && selectedTags.map((tag, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "tags--tag",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.Tag), {
                            size: 16,
                            strokeWidth: 1
                        }),
                        " ",
                        tag.label
                    ]
                }, key)),
            (!selectedTags || selectedTags.length === 0) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "tags--tag",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.Tag), {
                    size: 16,
                    strokeWidth: 1
                })
            }),
            showingTagSelection && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "tags--tag-selection" + (busy ? " tags--tag-selection__busy" : ""),
                tabIndex: "0",
                autoFocus: true,
                ref: tagSelect,
                onBlur: (e)=>{
                    var _e_relatedTarget_classList, _e_relatedTarget, _e_relatedTarget1, _e_relatedTarget2, _e_relatedTarget3;
                    if ((tagTrigger === null || tagTrigger === void 0 ? void 0 : tagTrigger.current) && e.relatedTarget !== tagTrigger.current && !((_e_relatedTarget = e.relatedTarget) === null || _e_relatedTarget === void 0 ? void 0 : (_e_relatedTarget_classList = _e_relatedTarget.classList) === null || _e_relatedTarget_classList === void 0 ? void 0 : _e_relatedTarget_classList.contains("tags--tag")) && ((_e_relatedTarget1 = e.relatedTarget) === null || _e_relatedTarget1 === void 0 ? void 0 : _e_relatedTarget1.className) !== "tags--tag-input" && ((_e_relatedTarget2 = e.relatedTarget) === null || _e_relatedTarget2 === void 0 ? void 0 : _e_relatedTarget2.className) !== "tags--tag-delete" && !((_e_relatedTarget3 = e.relatedTarget) === null || _e_relatedTarget3 === void 0 ? void 0 : _e_relatedTarget3.closest(`.tags--tag`))) setShowingTagSelection(false);
                },
                children: [
                    tags === null || tags === void 0 ? void 0 : tags.map((tag, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "tags--tag" + (selectedIds.includes(tag.value) ? " tags--tag__selected" : ""),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "tags--tag-button",
                                    "aria-label": `Select tag: '${tag.label}'`,
                                    onClick: ()=>{
                                        doToggleTag(tag.label, tag.value);
                                    },
                                    children: tag.label
                                }, key),
                                onTagDelete && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "tags--tag-delete",
                                    onClick: ()=>doDeleteTagConfirm(tag.value),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.Cross), {
                                        size: 12,
                                        strokeWidth: 1
                                    })
                                })
                            ]
                        }, key)),
                    onTagCreate && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "text",
                            placeholder: "Create tag",
                            ref: tagInput,
                            className: "tags--tag-input",
                            disabled: busy,
                            onKeyDown: doCreateTag
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = Tags;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","akar-icons":"b8xdj","primereact/confirmdialog":"9Gq2y","../../../scss/components/tags.scss":"97zxi","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"97zxi":[function() {},{}],"wHeKG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFetchResources", ()=>useFetchResources);
parcelHelpers.export(exports, "useUpdateImage", ()=>useUpdateImage);
parcelHelpers.export(exports, "useUploadImage", ()=>useUploadImage);
parcelHelpers.export(exports, "useFetchImage", ()=>useFetchImage);
parcelHelpers.export(exports, "useFetchFolders", ()=>useFetchFolders);
parcelHelpers.export(exports, "useCreateFolder", ()=>useCreateFolder);
parcelHelpers.export(exports, "useDeleteFolder", ()=>useDeleteFolder);
parcelHelpers.export(exports, "useDeleteImage", ()=>useDeleteImage);
var _reactQuery = require("react-query");
var _fetchJs = require("../../../utilities/fetch.js");
const useFetchResources = ({ type = 'images', account = null, refetch = true, callback })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: 'resources'
    });
    return (0, _reactQuery.useQuery)([
        'resources',
        type,
        account
    ], ()=>(0, _fetchJs.request)({
            url: `/resources/${type}`,
            params: {
                account: account
            }
        }), {
        refetchInterval: refetch === false ? false : 30000,
        refetchOnMount: refetch === false ? false : true,
        refetchOnWindowFocus: refetch === false ? false : true,
        select: (data)=>{
            var _data_data_items, _data_data, _data_data1;
            if (type === 'files') return data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : (_data_data_items = _data_data.items) === null || _data_data_items === void 0 ? void 0 : _data_data_items.map((file)=>{
                return {
                    type: 'file',
                    alt: file.description,
                    slug: file.slug,
                    imageId: file.fileId,
                    folder: file.folder,
                    fileName: file.fileName,
                    mime: file.mime
                };
            });
            return data === null || data === void 0 ? void 0 : (_data_data1 = data.data) === null || _data_data1 === void 0 ? void 0 : _data_data1.items;
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useUpdateImage = ({ account = null, type = 'images', callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data)=>{
        const resourceId = data === null || data === void 0 ? void 0 : data.id;
        const sendData = {
            ...data
        };
        delete sendData.id;
        return (0, _fetchJs.request)({
            url: `/resources/${type}/${resourceId}`,
            method: 'patch',
            params: {
                account: account
            },
            data: sendData,
            json: true
        });
    }, {
        mutationKey: 'resources',
        onMutate: async (data)=>{
            var _queryClient_getQueryData_data, _queryClient_getQueryData;
            await queryClient.cancelQueries([
                'resources',
                type,
                account
            ]);
            const resourceId = data === null || data === void 0 ? void 0 : data.id;
            const sendData = {
                ...data
            };
            // optimistic update data
            const currentResources = (_queryClient_getQueryData = queryClient.getQueryData([
                'resources',
                type,
                account
            ])) === null || _queryClient_getQueryData === void 0 ? void 0 : (_queryClient_getQueryData_data = _queryClient_getQueryData.data) === null || _queryClient_getQueryData_data === void 0 ? void 0 : _queryClient_getQueryData_data.items;
            const resourceIndex = currentResources.findIndex((resource)=>{
                return !!(resource.imageId === resourceId || resource.fileId === resourceId);
            });
            if (resourceIndex >= 0) {
                const update = [
                    ...currentResources
                ];
                update[resourceIndex] = {
                    ...update[resourceIndex],
                    ...sendData
                };
                await queryClient.setQueryData([
                    'resources',
                    type,
                    account
                ], {
                    data: {
                        ...update
                    }
                });
            }
            queryClient.invalidateQueries([
                'resources',
                type,
                account
            ]);
            if (callback && typeof callback != 'undefined') callback(data);
        },
        onSettled: async ()=>{
            queryClient.invalidateQueries([
                'resources',
                type,
                account
            ]);
        }
    });
};
const useUploadImage = ({ account = null, type = 'images', callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data)=>{
        return (0, _fetchJs.request)({
            url: `/resources/${type}`,
            method: 'post',
            params: {
                account: account
            },
            data: data,
            json: true,
            headers: {
                'Content-Type': 'multipart/formdata'
            }
        });
    }, {
        mutationKey: 'resources',
        onSuccess: async (data)=>{
            var _queryClient_getQueryData_data, _queryClient_getQueryData;
            await queryClient.cancelQueries([
                'resources',
                type,
                account
            ]);
            // update data
            const currentResources = (_queryClient_getQueryData = queryClient.getQueryData([
                'resources',
                type,
                account
            ])) === null || _queryClient_getQueryData === void 0 ? void 0 : (_queryClient_getQueryData_data = _queryClient_getQueryData.data) === null || _queryClient_getQueryData_data === void 0 ? void 0 : _queryClient_getQueryData_data.items;
            currentResources.push(data);
            await queryClient.setQueryData([
                'resources',
                type,
                account
            ], {
                data: {
                    ...currentResources
                }
            });
            queryClient.invalidateQueries([
                'resources',
                type,
                account
            ]);
            if (callback && typeof callback != 'undefined') callback(data);
        },
        onSettled: async ()=>{
            queryClient.invalidateQueries([
                'resources',
                type,
                account
            ]);
        }
    });
};
const useFetchImage = ({ account = null, callback, size = 'large', imageSlug = null })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: 'resources'
    });
    return (0, _reactQuery.useQuery)([
        'imagePreview',
        account,
        imageSlug
    ], ()=>{
        if (!imageSlug) return;
        return (0, _fetchJs.request)({
            url: `/image/${account}/${imageSlug}?size=${size}`,
            responseType: 'blob'
        });
    }, {
        refetchInterval: false,
        select: (response)=>{
            // convert raw blob data to a URL that can be used by img.src
            const urlCreator = window.URL || window.webkitURL;
            return urlCreator.createObjectURL(response.data);
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useFetchFolders = ({ type = 'images', account = null, refetch = true, callback })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: 'resourcesFolders'
    });
    return (0, _reactQuery.useQuery)([
        'resourceFolders',
        type,
        account
    ], ()=>(0, _fetchJs.request)({
            url: `/resources/folders/${type}`,
            params: {
                account: account
            }
        }), {
        refetchInterval: refetch === false ? false : 30000,
        refetchOnMount: refetch === false ? false : true,
        refetchOnWindowFocus: refetch === false ? false : true,
        select: (data)=>{
            var _data_data;
            return data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.items;
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useCreateFolder = ({ account = null, type = 'images', callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((description)=>{
        return (0, _fetchJs.request)({
            url: `/resources/folders/${type}`,
            method: 'post',
            params: {
                account: account
            },
            data: {
                description: description
            },
            json: true
        });
    }, {
        mutationKey: 'resources',
        onSuccess: async (data)=>{
            var _queryClient_getQueryData_data, _queryClient_getQueryData;
            // update data
            const currentFolders = (_queryClient_getQueryData = queryClient.getQueryData([
                'resourceFolders',
                type,
                account
            ])) === null || _queryClient_getQueryData === void 0 ? void 0 : (_queryClient_getQueryData_data = _queryClient_getQueryData.data) === null || _queryClient_getQueryData_data === void 0 ? void 0 : _queryClient_getQueryData_data.items;
            currentFolders.push(data === null || data === void 0 ? void 0 : data.data);
            await queryClient.setQueryData([
                'resourceFolders',
                type,
                account
            ], {
                data: {
                    items: [
                        ...currentFolders
                    ]
                }
            });
            queryClient.invalidateQueries([
                'resourceFolders',
                type,
                account
            ]);
            if (callback && typeof callback != 'undefined') callback(data === null || data === void 0 ? void 0 : data.data);
        }
    });
};
const useDeleteFolder = ({ account = null, type = 'images', callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((id)=>{
        return (0, _fetchJs.request)({
            url: `/resources/folders/${id}`,
            method: 'delete',
            params: {
                account: account
            },
            json: true
        });
    }, {
        mutationKey: 'resources',
        onMutate: async (id)=>{
            var _queryClient_getQueryData_data, _queryClient_getQueryData;
            // optimistically update data
            const currentFolders = (_queryClient_getQueryData = queryClient.getQueryData([
                'resourceFolders',
                type,
                account
            ])) === null || _queryClient_getQueryData === void 0 ? void 0 : (_queryClient_getQueryData_data = _queryClient_getQueryData.data) === null || _queryClient_getQueryData_data === void 0 ? void 0 : _queryClient_getQueryData_data.items;
            const deleteIndex = currentFolders.findIndex((folder)=>(folder === null || folder === void 0 ? void 0 : folder.folderId) === id);
            currentFolders.splice(deleteIndex, 1);
            await queryClient.setQueryData([
                'resourceFolders',
                type,
                account
            ], {
                data: {
                    items: [
                        ...currentFolders
                    ]
                }
            });
        },
        onSettled: async (data)=>{
            queryClient.invalidateQueries([
                'resourceFolders',
                type,
                account
            ]);
            if (callback && typeof callback != 'undefined') callback(data === null || data === void 0 ? void 0 : data.data);
        }
    });
};
const useDeleteImage = ({ account = null, type = 'image', callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((resourceId)=>{
        return (0, _fetchJs.request)({
            url: `/resources/${type}/${resourceId}`,
            method: 'delete',
            params: {
                account: account
            }
        });
    }, {
        mutationKey: 'resources',
        onMutate: async (resourceId)=>{
            var _queryClient_getQueryData_data, _queryClient_getQueryData;
            await queryClient.cancelQueries([
                'resources',
                type,
                account
            ]);
            const currentResources = (_queryClient_getQueryData = queryClient.getQueryData([
                'resources',
                type,
                account
            ])) === null || _queryClient_getQueryData === void 0 ? void 0 : (_queryClient_getQueryData_data = _queryClient_getQueryData.data) === null || _queryClient_getQueryData_data === void 0 ? void 0 : _queryClient_getQueryData_data.items;
            // optimistic update data
            if ((currentResources === null || currentResources === void 0 ? void 0 : currentResources.length) > 0) {
                const deleteIndex = currentResources.findIndex((resource)=>(resource === null || resource === void 0 ? void 0 : resource.imageId) === resourceId);
                currentResources.splice(deleteIndex, 1);
                await queryClient.setQueryData([
                    'resources',
                    type,
                    account
                ], {
                    data: {
                        items: [
                            ...currentResources
                        ]
                    }
                });
                queryClient.invalidateQueries([
                    'resources',
                    type,
                    account
                ]);
            }
        },
        onSettled: ()=>{
            queryClient.invalidateQueries([
                'resources',
                type,
                account
            ]);
        },
        onSuccess: callback
    });
};
exports.default = useFetchResources;

},{"react-query":"41hyj","../../../utilities/fetch.js":"hAKRo","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"jkhEM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _useFetchAbsence = require("../../hooks/fetch/useFetchAbsence");
var _useStore = require("../../hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
var _luxon = require("luxon");
var _absenceListScss = require("../../../../scss/components/absenceList.scss");
const Absences = ({ userId, innerRef = null, heading = null })=>{
    var _userAbsences_items;
    const clientRef = (0, _useStoreDefault.default)((state)=>state.clientRef);
    const { data: userAbsences, isLoading: isAbsenceLoading } = (0, _useFetchAbsence.useFetchUserAbsences)({
        account: clientRef,
        userId: userId
    });
    const stripZeros = (value)=>{
        return value === null || value === void 0 ? void 0 : value.toString().replace(/\.0{1,2}\b/, "");
    };
    const addLinebreak = (text)=>{
        const firstWord = text === null || text === void 0 ? void 0 : text.split(" ")[0];
        const restOfText = text === null || text === void 0 ? void 0 : text.split(" ").slice(1).join(" ");
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: stripZeros(firstWord)
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    children: restOfText
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "absences-list-container",
        ref: innerRef,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                className: "print-only",
                children: heading
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "absences-list",
                ref: innerRef,
                children: userAbsences === null || userAbsences === void 0 ? void 0 : (_userAbsences_items = userAbsences.items) === null || _userAbsences_items === void 0 ? void 0 : _userAbsences_items.map((absence, index)=>{
                    var _DateTime_fromISO, _DateTime_fromISO1;
                    const startDate = (_DateTime_fromISO = (0, _luxon.DateTime).fromISO(absence.start)) === null || _DateTime_fromISO === void 0 ? void 0 : _DateTime_fromISO.toFormat("dd/MM/yyyy");
                    const endDate = (_DateTime_fromISO1 = (0, _luxon.DateTime).fromISO(absence.end)) === null || _DateTime_fromISO1 === void 0 ? void 0 : _DateTime_fromISO1.toFormat("dd/MM/yyyy");
                    const date = startDate === endDate ? startDate : `${startDate} - ${endDate}`;
                    const description = (absence === null || absence === void 0 ? void 0 : absence.type) === "bankHoliday" ? absence === null || absence === void 0 ? void 0 : absence.description : absence.typeFormatted || absence.description;
                    let amount = absence === null || absence === void 0 ? void 0 : absence.annualLeaveConsumed;
                    if (absence.type === "sickness" || absence.type === "family" || absence.type === "other") amount = absence === null || absence === void 0 ? void 0 : absence.elapsed;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "absences-list--absence",
                        "data-type": absence.type,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "absences-list--absence--elapsed",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "absence-elapsed-circle",
                                    children: addLinebreak(amount)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "absences-list--absence--date",
                                children: date
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "absences-list--absence--description",
                                children: description
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
exports.default = Absences;

},{"react/jsx-runtime":"i3K7E","../../hooks/fetch/useFetchAbsence":"ljgNf","../../hooks/useStore":"l1Yj7","luxon":"24mCD","../../../../scss/components/absenceList.scss":"lzYnK","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ljgNf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFetchAbsences", ()=>useFetchAbsences);
parcelHelpers.export(exports, "useFetchAbsence", ()=>useFetchAbsence);
parcelHelpers.export(exports, "useFetchUserAbsences", ()=>useFetchUserAbsences);
parcelHelpers.export(exports, "useUpdateAbsence", ()=>useUpdateAbsence);
parcelHelpers.export(exports, "useCreateAbsence", ()=>useCreateAbsence);
parcelHelpers.export(exports, "useDeleteAbsence", ()=>useDeleteAbsence);
var _reactQuery = require("react-query");
var _fetchJs = require("../../../utilities/fetch.js");
const useFetchAbsences = (options = {})=>{
    const { account = null, start = null, end = null, callback } = options;
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: 'absence'
    });
    return (0, _reactQuery.useQuery)([
        'absences',
        account,
        start,
        end
    ], ()=>(0, _fetchJs.request)({
            url: '/holidays',
            params: {
                start: start,
                end: end,
                account: account
            }
        }), {
        refetchInterval: false,
        staleTime: 300000,
        select: (data)=>{
            var _data_data;
            return data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.items;
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useFetchAbsence = (options = {})=>{
    const { account = null, absenceId = null, callback, callbackSettled } = options;
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: 'absence'
    });
    return (0, _reactQuery.useQuery)([
        'absence',
        account,
        absenceId
    ], ()=>{
        if (!absenceId) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/holidays/${absenceId}`,
            params: {
                account: account
            }
        });
    }, {
        refetchInterval: false,
        staleTime: 300000,
        select: (data)=>data === null || data === void 0 ? void 0 : data.data,
        onSuccess: callback,
        onSettled: callbackSettled,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useFetchUserAbsences = (options = {})=>{
    const { account = null, userId = null, year = null, callback } = options;
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: 'absence'
    });
    return (0, _reactQuery.useQuery)([
        'userAbsence',
        userId,
        account
    ], ()=>{
        if (!userId) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/users/absences/${userId}`,
            params: {
                account: account,
                year: year
            }
        });
    }, {
        refetchInterval: false,
        select: (data)=>data === null || data === void 0 ? void 0 : data.data,
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useUpdateAbsence = (options = {})=>{
    const { account = null, start = null, end = null, callback, callbackSettled } = options;
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data)=>{
        const absenceId = data === null || data === void 0 ? void 0 : data.holidayId;
        if (!absenceId) return Promise.resolve({});
        if (absenceId) {
            const sendData = {
                ...data
            };
            delete sendData.holidayId;
            return (0, _fetchJs.request)({
                url: `/holidays/${absenceId}`,
                params: {
                    account: account
                },
                method: 'patch',
                data: sendData,
                json: true
            });
        }
    }, {
        mutationKey: 'absence',
        onMutate: async (data)=>{
            var _queryClient_getQueryData;
            await queryClient.cancelQueries([
                'absences',
                account,
                start,
                end
            ]);
            // optimistic update data
            const absenceId = data === null || data === void 0 ? void 0 : data.holidayId;
            const newData = {
                ...data
            };
            if (absenceId && data) {
                // update absences collection
                const currentAbsences = queryClient.getQueryData([
                    'absences',
                    account,
                    start,
                    end
                ]);
                const updatedAbsences = [
                    ...currentAbsences.data.items
                ];
                const replaceIndex = updatedAbsences.findIndex((absence)=>{
                    return !!(absence.holidayId === absenceId);
                });
                if (replaceIndex >= 0) updatedAbsences[replaceIndex] = {
                    ...updatedAbsences[replaceIndex],
                    ...newData
                };
                await queryClient.setQueryData([
                    'absences',
                    account,
                    start,
                    end
                ], {
                    data: {
                        items: [
                            ...updatedAbsences
                        ]
                    }
                });
            }
            if (callback && typeof callback != 'undefined') callback(data);
            // update absence
            const currentAbsence = (_queryClient_getQueryData = queryClient.getQueryData([
                'absence',
                account,
                absenceId
            ])) === null || _queryClient_getQueryData === void 0 ? void 0 : _queryClient_getQueryData.data;
            await queryClient.setQueryData([
                'absence',
                account,
                absenceId
            ], {
                data: {
                    ...currentAbsence,
                    ...newData
                }
            });
            queryClient.invalidateQueries([
                'absences',
                account,
                start,
                end
            ]);
            queryClient.invalidateQueries([
                'absence',
                account,
                absenceId
            ]);
        },
        onSettled: (data)=>{
            const absenceId = data === null || data === void 0 ? void 0 : data.holidayId;
            queryClient.invalidateQueries([
                'absences',
                account,
                start,
                end
            ]);
            queryClient.invalidateQueries([
                'absence',
                account,
                absenceId
            ]);
            queryClient.invalidateQueries([
                'notifications'
            ]);
            callbackSettled && callbackSettled(data === null || data === void 0 ? void 0 : data.data);
        }
    });
};
const useCreateAbsence = (options = {})=>{
    const { account = null, start = null, end = null, callback } = options;
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data)=>{
        const sendData = {
            ...data
        };
        return (0, _fetchJs.request)({
            url: `/holidays`,
            method: 'post',
            params: {
                account: account
            },
            data: sendData
        });
    }, {
        mutationKey: 'absence',
        onMutate: async (data)=>{
            await queryClient.cancelQueries([
                'absences',
                account,
                start,
                end
            ]);
        },
        onSettled: ()=>{
            queryClient.invalidateQueries([
                'absences',
                account,
                start,
                end
            ]);
            queryClient.invalidateQueries([
                'notifications'
            ]);
        },
        onSuccess: callback
    });
};
const useDeleteAbsence = ({ account, start = null, end = null, callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((id)=>{
        return (0, _fetchJs.request)({
            url: `/holidays/${id}`,
            params: {
                account: account
            },
            method: 'delete'
        });
    }, {
        mutationKey: [
            'absence'
        ],
        onMutate: async (id)=>{
            var _currentAbsenceData_data_items, _currentAbsenceData_data;
            await queryClient.cancelQueries([
                'absences',
                account,
                start,
                end
            ]);
            const currentAbsenceData = queryClient.getQueryData([
                'absences',
                account,
                start,
                end
            ]);
            // optimistic update data
            if ((currentAbsenceData === null || currentAbsenceData === void 0 ? void 0 : (_currentAbsenceData_data = currentAbsenceData.data) === null || _currentAbsenceData_data === void 0 ? void 0 : (_currentAbsenceData_data_items = _currentAbsenceData_data.items) === null || _currentAbsenceData_data_items === void 0 ? void 0 : _currentAbsenceData_data_items.length) > 0) {
                const updated = [
                    ...currentAbsenceData.data.items
                ];
                const deleteIndex = updated.findIndex((absence)=>(absence === null || absence === void 0 ? void 0 : absence.holidayId) === id);
                updated.splice(deleteIndex, 1);
                await queryClient.setQueryData([
                    'absences',
                    account,
                    start,
                    end
                ], {
                    data: {
                        items: [
                            ...updated
                        ]
                    }
                });
            }
        },
        onSettled: ()=>{
            queryClient.invalidateQueries([
                'absences',
                account,
                start,
                end
            ]);
        },
        onSuccess: callback
    });
};
exports.default = useFetchAbsences;

},{"react-query":"41hyj","../../../utilities/fetch.js":"hAKRo","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"lzYnK":[function() {},{}],"9m3Mf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utilities = require("../../../utilities");
var _utilitiesDefault = parcelHelpers.interopDefault(_utilities);
var _capacitor = require("../../../utilities/capacitor");
var _useStore = require("../../hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
var _formSubmissionScss = require("../../../../scss/components/formSubmission.scss");
const Submission = ({ submissionId, submission })=>{
    const clientRef = (0, _useStoreDefault.default)((state)=>state.clientRef);
    const authToken = (0, _useStoreDefault.default)((state)=>state.authToken);
    const printComponent = (0, _react.useRef)();
    const getField = (field)=>{
        switch(field.type){
            case "date":
                return (0, _utilitiesDefault.default).getFormattedDate(field.value);
            case "file":
                var _field_value_;
                const fileName = (field === null || field === void 0 ? void 0 : field.value) && (field === null || field === void 0 ? void 0 : (_field_value_ = field.value[0]) === null || _field_value_ === void 0 ? void 0 : _field_value_.fileName) || null;
                if (!fileName) return "No file uploaded";
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "button-link",
                    type: "button",
                    onClick: ()=>doDownloadFile(field.value[0]),
                    children: fileName
                });
            default:
                return field.value;
        }
    };
    (0, _react.useEffect)(()=>{
        document.body.classList.add("print-mode");
    }, []);
    const doDownloadFile = (file)=>{
        if (!file) return;
        const fileName = file === null || file === void 0 ? void 0 : file.fileName;
        const endpoint = file === null || file === void 0 ? void 0 : file.endpoint;
        fetch(`${"https://rest.yourhr.space"}${endpoint}?account=${clientRef}`, {
            method: "GET",
            headers: {
                "x-auth-token": authToken,
                ...(0, _capacitor.getCapacitorHeaders)()
            }
        }).then(async (res)=>{
            return res.blob();
        }).then((blob)=>{
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.setAttribute("target", "_blank");
            a.setAttribute("download", fileName);
            a.href = url;
            document.body.appendChild(a);
            a.click();
            a.remove();
        }).catch((err)=>{
            console.error(err);
        });
    };
    const doPrint = ()=>{
        var _printComponent_current, _document_getElementById;
        const printEl = (_printComponent_current = printComponent.current) === null || _printComponent_current === void 0 ? void 0 : _printComponent_current.cloneNode(true);
        (_document_getElementById = document.getElementById("print-container")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.replaceChildren(printEl);
        window.print();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "button",
                onClick: doPrint,
                children: "Print"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("table", {
                className: "table table__2-col-split",
                ref: printComponent,
                style: {
                    "margin-top": "var(--padding)"
                },
                children: (submission === null || submission === void 0 ? void 0 : submission.length) > 0 && (submission === null || submission === void 0 ? void 0 : submission.map((field)=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                children: field.label
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                children: getField(field)
                            })
                        ]
                    }, field.fieldId);
                }))
            })
        ]
    });
};
exports.default = Submission;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","../../../utilities":"fkdv9","../../../utilities/capacitor":"lTR78","../../hooks/useStore":"l1Yj7","../../../../scss/components/formSubmission.scss":"58JL1","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"58JL1":[function() {},{}],"azTQI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _svg = require("./svg");
var _svgDefault = parcelHelpers.interopDefault(_svg);
require("79a480bd39501d54");
const CloseButton = ({ className, onClick })=>{
    const buttonClass = "close-button" + (className ? " " + className : "");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        className: buttonClass,
        "aria-label": "Close",
        type: "button",
        onClick: onClick,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgDefault.default), {
            src: "close",
            className: "icon",
            label: "Close"
        })
    });
};
exports.default = CloseButton;

},{"react/jsx-runtime":"i3K7E","79a480bd39501d54":"2uX7v","./svg":"4pImm","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2uX7v":[function(require,module,exports,__globalThis) {
module.exports = require("1fa1dba9ab66523e")(module.bundle.resolve("80v8O"));

},{"1fa1dba9ab66523e":"efVvj"}],"13VYq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _htmlEntities = require("html-entities");
var _akarIcons = require("akar-icons");
var _useFetchMessages = require("../../hooks/fetch/useFetchMessages");
var _messagesScss = require("../../../../scss/components/messages.scss");
const parseNotification = (content)=>{
    const decoded = (0, _htmlEntities.decode)(content);
    // convert URLs to links
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return decoded === null || decoded === void 0 ? void 0 : decoded.replace(urlRegex, (url)=>{
        // if the URL contains '#'
        let linkText = url;
        if (url.includes("#")) linkText = "Go to absence";
        return `<a href="${url}">${linkText}</a>`;
    });
};
const Notifications = ({})=>{
    // Fetch data hooks
    const { data: notifications } = (0, _useFetchMessages.useFetchNotifications)({});
    const { mutate: doDelete } = (0, _useFetchMessages.useDeleteNotification)({});
    if ((notifications === null || notifications === void 0 ? void 0 : notifications.length) === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "inbox-messages",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "inbox-message-message",
            children: "You have no notifications"
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "inbox-messages",
        children: notifications === null || notifications === void 0 ? void 0 : notifications.map((notification, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: notification.unread > 0 ? "inbox-message inbox-message__unread" : "inbox-message",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: notification.unread > 0 ? "inbox-message-message inbox-message-message__unread" : "inbox-message-message",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            dangerouslySetInnerHTML: true && {
                                __html: parseNotification(notification.content)
                            }
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: ()=>{
                                doDelete(notification.notificationId);
                            },
                            className: "button button__transparent inbox-message-message--delete",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.Cross), {
                                size: 16
                            })
                        })
                    ]
                })
            }, i))
    });
};
exports.default = Notifications;

},{"react/jsx-runtime":"i3K7E","html-entities":"27yUb","akar-icons":"b8xdj","../../hooks/fetch/useFetchMessages":"3hiet","../../../../scss/components/messages.scss":"7a3Vi","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"7a3Vi":[function() {},{}],"kMU9z":[function() {},{}],"k2xEc":[function(require,module,exports,__globalThis) {
/**
 * SimpleBar.js - v5.3.9
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _esObjectToStringJs = require("core-js/modules/es.object.to-string.js");
var _webDomCollectionsForEachJs = require("core-js/modules/web.dom-collections.for-each.js");
var _canUseDom = require("can-use-dom");
var _canUseDomDefault = parcelHelpers.interopDefault(_canUseDom);
var _esParseIntJs = require("core-js/modules/es.parse-int.js");
var _esObjectAssignJs = require("core-js/modules/es.object.assign.js");
var _esArrayFilterJs = require("core-js/modules/es.array.filter.js");
var _esArrayIteratorJs = require("core-js/modules/es.array.iterator.js");
var _esStringIteratorJs = require("core-js/modules/es.string.iterator.js");
var _esWeakMapJs = require("core-js/modules/es.weak-map.js");
var _webDomCollectionsIteratorJs = require("core-js/modules/web.dom-collections.iterator.js");
var _lodashThrottle = require("lodash.throttle");
var _lodashThrottleDefault = parcelHelpers.interopDefault(_lodashThrottle);
var _lodashDebounce = require("lodash.debounce");
var _lodashDebounceDefault = parcelHelpers.interopDefault(_lodashDebounce);
var _lodashMemoize = require("lodash.memoize");
var _lodashMemoizeDefault = parcelHelpers.interopDefault(_lodashMemoize);
var _resizeObserver = require("@juggle/resize-observer");
var _esArrayReduceJs = require("core-js/modules/es.array.reduce.js");
var _esRegexpExecJs = require("core-js/modules/es.regexp.exec.js");
var _esStringMatchJs = require("core-js/modules/es.string.match.js");
var _esFunctionNameJs = require("core-js/modules/es.function.name.js");
var _esStringReplaceJs = require("core-js/modules/es.string.replace.js");
// Helper function to retrieve options from element attributes
var getOptions = function getOptions(obj) {
    var options = Array.prototype.reduce.call(obj, function(acc, attribute) {
        var option = attribute.name.match(/data-simplebar-(.+)/);
        if (option) {
            var key = option[1].replace(/\W+(.)/g, function(x, chr) {
                return chr.toUpperCase();
            });
            switch(attribute.value){
                case 'true':
                    acc[key] = true;
                    break;
                case 'false':
                    acc[key] = false;
                    break;
                case undefined:
                    acc[key] = true;
                    break;
                default:
                    acc[key] = attribute.value;
            }
        }
        return acc;
    }, {});
    return options;
};
function getElementWindow(element) {
    if (!element || !element.ownerDocument || !element.ownerDocument.defaultView) return window;
    return element.ownerDocument.defaultView;
}
function getElementDocument(element) {
    if (!element || !element.ownerDocument) return document;
    return element.ownerDocument;
}
var cachedScrollbarWidth = null;
var cachedDevicePixelRatio = null;
if (0, _canUseDomDefault.default) window.addEventListener('resize', function() {
    if (cachedDevicePixelRatio !== window.devicePixelRatio) {
        cachedDevicePixelRatio = window.devicePixelRatio;
        cachedScrollbarWidth = null;
    }
});
function scrollbarWidth(el) {
    if (cachedScrollbarWidth === null) {
        var document1 = getElementDocument(el);
        if (typeof document1 === 'undefined') {
            cachedScrollbarWidth = 0;
            return cachedScrollbarWidth;
        }
        var body = document1.body;
        var box = document1.createElement('div');
        box.classList.add('simplebar-hide-scrollbar');
        body.appendChild(box);
        var width = box.getBoundingClientRect().right;
        body.removeChild(box);
        cachedScrollbarWidth = width;
    }
    return cachedScrollbarWidth;
}
var SimpleBar = /*#__PURE__*/ function() {
    function SimpleBar(element, options) {
        var _this = this;
        this.onScroll = function() {
            var elWindow = getElementWindow(_this.el);
            if (!_this.scrollXTicking) {
                elWindow.requestAnimationFrame(_this.scrollX);
                _this.scrollXTicking = true;
            }
            if (!_this.scrollYTicking) {
                elWindow.requestAnimationFrame(_this.scrollY);
                _this.scrollYTicking = true;
            }
        };
        this.scrollX = function() {
            if (_this.axis.x.isOverflowing) {
                _this.showScrollbar('x');
                _this.positionScrollbar('x');
            }
            _this.scrollXTicking = false;
        };
        this.scrollY = function() {
            if (_this.axis.y.isOverflowing) {
                _this.showScrollbar('y');
                _this.positionScrollbar('y');
            }
            _this.scrollYTicking = false;
        };
        this.onMouseEnter = function() {
            _this.showScrollbar('x');
            _this.showScrollbar('y');
        };
        this.onMouseMove = function(e) {
            _this.mouseX = e.clientX;
            _this.mouseY = e.clientY;
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseMoveForAxis('x');
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseMoveForAxis('y');
        };
        this.onMouseLeave = function() {
            _this.onMouseMove.cancel();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseLeaveForAxis('x');
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseLeaveForAxis('y');
            _this.mouseX = -1;
            _this.mouseY = -1;
        };
        this.onWindowResize = function() {
            // Recalculate scrollbarWidth in case it's a zoom
            _this.scrollbarWidth = _this.getScrollbarWidth();
            _this.hideNativeScrollbar();
        };
        this.hideScrollbars = function() {
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (!_this.isWithinBounds(_this.axis.y.track.rect)) {
                _this.axis.y.scrollbar.el.classList.remove(_this.classNames.visible);
                _this.axis.y.isVisible = false;
            }
            if (!_this.isWithinBounds(_this.axis.x.track.rect)) {
                _this.axis.x.scrollbar.el.classList.remove(_this.classNames.visible);
                _this.axis.x.isVisible = false;
            }
        };
        this.onPointerEvent = function(e) {
            var isWithinTrackXBounds, isWithinTrackYBounds;
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) isWithinTrackXBounds = _this.isWithinBounds(_this.axis.x.track.rect);
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) isWithinTrackYBounds = _this.isWithinBounds(_this.axis.y.track.rect);
             // If any pointer event is called on the scrollbar
            if (isWithinTrackXBounds || isWithinTrackYBounds) {
                // Preventing the event's default action stops text being
                // selectable during the drag.
                e.preventDefault(); // Prevent event leaking
                e.stopPropagation();
                if (e.type === 'mousedown') {
                    if (isWithinTrackXBounds) {
                        _this.axis.x.scrollbar.rect = _this.axis.x.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.x.scrollbar.rect)) _this.onDragStart(e, 'x');
                        else _this.onTrackClick(e, 'x');
                    }
                    if (isWithinTrackYBounds) {
                        _this.axis.y.scrollbar.rect = _this.axis.y.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.y.scrollbar.rect)) _this.onDragStart(e, 'y');
                        else _this.onTrackClick(e, 'y');
                    }
                }
            }
        };
        this.drag = function(e) {
            var eventOffset;
            var track = _this.axis[_this.draggedAxis].track;
            var trackSize = track.rect[_this.axis[_this.draggedAxis].sizeAttr];
            var scrollbar = _this.axis[_this.draggedAxis].scrollbar;
            var contentSize = _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollSizeAttr];
            var hostSize = parseInt(_this.elStyles[_this.axis[_this.draggedAxis].sizeAttr], 10);
            e.preventDefault();
            e.stopPropagation();
            if (_this.draggedAxis === 'y') eventOffset = e.pageY;
            else eventOffset = e.pageX;
             // Calculate how far the user's mouse is from the top/left of the scrollbar (minus the dragOffset).
            var dragPos = eventOffset - track.rect[_this.axis[_this.draggedAxis].offsetAttr] - _this.axis[_this.draggedAxis].dragOffset; // Convert the mouse position into a percentage of the scrollbar height/width.
            var dragPerc = dragPos / (trackSize - scrollbar.size); // Scroll the content by the same percentage.
            var scrollPos = dragPerc * (contentSize - hostSize); // Fix browsers inconsistency on RTL
            if (_this.draggedAxis === 'x') {
                scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? scrollPos - (trackSize + scrollbar.size) : scrollPos;
                scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollPos : scrollPos;
            }
            _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollOffsetAttr] = scrollPos;
        };
        this.onEndDrag = function(e) {
            var elDocument = getElementDocument(_this.el);
            var elWindow = getElementWindow(_this.el);
            e.preventDefault();
            e.stopPropagation();
            _this.el.classList.remove(_this.classNames.dragging);
            elDocument.removeEventListener('mousemove', _this.drag, true);
            elDocument.removeEventListener('mouseup', _this.onEndDrag, true);
            _this.removePreventClickId = elWindow.setTimeout(function() {
                // Remove these asynchronously so we still suppress click events
                // generated simultaneously with mouseup.
                elDocument.removeEventListener('click', _this.preventClick, true);
                elDocument.removeEventListener('dblclick', _this.preventClick, true);
                _this.removePreventClickId = null;
            });
        };
        this.preventClick = function(e) {
            e.preventDefault();
            e.stopPropagation();
        };
        this.el = element;
        this.minScrollbarWidth = 20;
        this.options = Object.assign({}, SimpleBar.defaultOptions, options);
        this.classNames = Object.assign({}, SimpleBar.defaultOptions.classNames, this.options.classNames);
        this.axis = {
            x: {
                scrollOffsetAttr: 'scrollLeft',
                sizeAttr: 'width',
                scrollSizeAttr: 'scrollWidth',
                offsetSizeAttr: 'offsetWidth',
                offsetAttr: 'left',
                overflowAttr: 'overflowX',
                dragOffset: 0,
                isOverflowing: true,
                isVisible: false,
                forceVisible: false,
                track: {},
                scrollbar: {}
            },
            y: {
                scrollOffsetAttr: 'scrollTop',
                sizeAttr: 'height',
                scrollSizeAttr: 'scrollHeight',
                offsetSizeAttr: 'offsetHeight',
                offsetAttr: 'top',
                overflowAttr: 'overflowY',
                dragOffset: 0,
                isOverflowing: true,
                isVisible: false,
                forceVisible: false,
                track: {},
                scrollbar: {}
            }
        };
        this.removePreventClickId = null; // Don't re-instantiate over an existing one
        if (SimpleBar.instances.has(this.el)) return;
        this.recalculate = (0, _lodashThrottleDefault.default)(this.recalculate.bind(this), 64);
        this.onMouseMove = (0, _lodashThrottleDefault.default)(this.onMouseMove.bind(this), 64);
        this.hideScrollbars = (0, _lodashDebounceDefault.default)(this.hideScrollbars.bind(this), this.options.timeout);
        this.onWindowResize = (0, _lodashDebounceDefault.default)(this.onWindowResize.bind(this), 64, {
            leading: true
        });
        SimpleBar.getRtlHelpers = (0, _lodashMemoizeDefault.default)(SimpleBar.getRtlHelpers);
        this.init();
    }
    /**
   * Static properties
   */ /**
   * Helper to fix browsers inconsistency on RTL:
   *  - Firefox inverts the scrollbar initial position
   *  - IE11 inverts both scrollbar position and scrolling offset
   * Directly inspired by @KingSora's OverlayScrollbars https://github.com/KingSora/OverlayScrollbars/blob/master/js/OverlayScrollbars.js#L1634
   */ SimpleBar.getRtlHelpers = function getRtlHelpers() {
        var dummyDiv = document.createElement('div');
        dummyDiv.innerHTML = '<div class="hs-dummy-scrollbar-size"><div style="height: 200%; width: 200%; margin: 10px 0;"></div></div>';
        var scrollbarDummyEl = dummyDiv.firstElementChild;
        document.body.appendChild(scrollbarDummyEl);
        var dummyContainerChild = scrollbarDummyEl.firstElementChild;
        scrollbarDummyEl.scrollLeft = 0;
        var dummyContainerOffset = SimpleBar.getOffset(scrollbarDummyEl);
        var dummyContainerChildOffset = SimpleBar.getOffset(dummyContainerChild);
        scrollbarDummyEl.scrollLeft = 999;
        var dummyContainerScrollOffsetAfterScroll = SimpleBar.getOffset(dummyContainerChild);
        return {
            // determines if the scrolling is responding with negative values
            isRtlScrollingInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left && dummyContainerChildOffset.left - dummyContainerScrollOffsetAfterScroll.left !== 0,
            // determines if the origin scrollbar position is inverted or not (positioned on left or right)
            isRtlScrollbarInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left
        };
    };
    SimpleBar.getOffset = function getOffset(el) {
        var rect = el.getBoundingClientRect();
        var elDocument = getElementDocument(el);
        var elWindow = getElementWindow(el);
        return {
            top: rect.top + (elWindow.pageYOffset || elDocument.documentElement.scrollTop),
            left: rect.left + (elWindow.pageXOffset || elDocument.documentElement.scrollLeft)
        };
    };
    var _proto = SimpleBar.prototype;
    _proto.init = function init() {
        // Save a reference to the instance, so we know this DOM node has already been instancied
        SimpleBar.instances.set(this.el, this); // We stop here on server-side
        if (0, _canUseDomDefault.default) {
            this.initDOM();
            this.setAccessibilityAttributes();
            this.scrollbarWidth = this.getScrollbarWidth();
            this.recalculate();
            this.initListeners();
        }
    };
    _proto.initDOM = function initDOM() {
        var _this2 = this;
        // make sure this element doesn't have the elements yet
        if (Array.prototype.filter.call(this.el.children, function(child) {
            return child.classList.contains(_this2.classNames.wrapper);
        }).length) {
            // assume that element has his DOM already initiated
            this.wrapperEl = this.el.querySelector("." + this.classNames.wrapper);
            this.contentWrapperEl = this.options.scrollableNode || this.el.querySelector("." + this.classNames.contentWrapper);
            this.contentEl = this.options.contentNode || this.el.querySelector("." + this.classNames.contentEl);
            this.offsetEl = this.el.querySelector("." + this.classNames.offset);
            this.maskEl = this.el.querySelector("." + this.classNames.mask);
            this.placeholderEl = this.findChild(this.wrapperEl, "." + this.classNames.placeholder);
            this.heightAutoObserverWrapperEl = this.el.querySelector("." + this.classNames.heightAutoObserverWrapperEl);
            this.heightAutoObserverEl = this.el.querySelector("." + this.classNames.heightAutoObserverEl);
            this.axis.x.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.horizontal);
            this.axis.y.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.vertical);
        } else {
            // Prepare DOM
            this.wrapperEl = document.createElement('div');
            this.contentWrapperEl = document.createElement('div');
            this.offsetEl = document.createElement('div');
            this.maskEl = document.createElement('div');
            this.contentEl = document.createElement('div');
            this.placeholderEl = document.createElement('div');
            this.heightAutoObserverWrapperEl = document.createElement('div');
            this.heightAutoObserverEl = document.createElement('div');
            this.wrapperEl.classList.add(this.classNames.wrapper);
            this.contentWrapperEl.classList.add(this.classNames.contentWrapper);
            this.offsetEl.classList.add(this.classNames.offset);
            this.maskEl.classList.add(this.classNames.mask);
            this.contentEl.classList.add(this.classNames.contentEl);
            this.placeholderEl.classList.add(this.classNames.placeholder);
            this.heightAutoObserverWrapperEl.classList.add(this.classNames.heightAutoObserverWrapperEl);
            this.heightAutoObserverEl.classList.add(this.classNames.heightAutoObserverEl);
            while(this.el.firstChild)this.contentEl.appendChild(this.el.firstChild);
            this.contentWrapperEl.appendChild(this.contentEl);
            this.offsetEl.appendChild(this.contentWrapperEl);
            this.maskEl.appendChild(this.offsetEl);
            this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl);
            this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl);
            this.wrapperEl.appendChild(this.maskEl);
            this.wrapperEl.appendChild(this.placeholderEl);
            this.el.appendChild(this.wrapperEl);
        }
        if (!this.axis.x.track.el || !this.axis.y.track.el) {
            var track = document.createElement('div');
            var scrollbar = document.createElement('div');
            track.classList.add(this.classNames.track);
            scrollbar.classList.add(this.classNames.scrollbar);
            track.appendChild(scrollbar);
            this.axis.x.track.el = track.cloneNode(true);
            this.axis.x.track.el.classList.add(this.classNames.horizontal);
            this.axis.y.track.el = track.cloneNode(true);
            this.axis.y.track.el.classList.add(this.classNames.vertical);
            this.el.appendChild(this.axis.x.track.el);
            this.el.appendChild(this.axis.y.track.el);
        }
        this.axis.x.scrollbar.el = this.axis.x.track.el.querySelector("." + this.classNames.scrollbar);
        this.axis.y.scrollbar.el = this.axis.y.track.el.querySelector("." + this.classNames.scrollbar);
        if (!this.options.autoHide) {
            this.axis.x.scrollbar.el.classList.add(this.classNames.visible);
            this.axis.y.scrollbar.el.classList.add(this.classNames.visible);
        }
        this.el.setAttribute('data-simplebar', 'init');
    };
    _proto.setAccessibilityAttributes = function setAccessibilityAttributes() {
        var ariaLabel = this.options.ariaLabel || 'scrollable content';
        this.contentWrapperEl.setAttribute('tabindex', '0');
        this.contentWrapperEl.setAttribute('role', 'region');
        this.contentWrapperEl.setAttribute('aria-label', ariaLabel);
    };
    _proto.initListeners = function initListeners() {
        var _this3 = this;
        var elWindow = getElementWindow(this.el); // Event listeners
        if (this.options.autoHide) this.el.addEventListener('mouseenter', this.onMouseEnter);
        [
            'mousedown',
            'click',
            'dblclick'
        ].forEach(function(e) {
            _this3.el.addEventListener(e, _this3.onPointerEvent, true);
        });
        [
            'touchstart',
            'touchend',
            'touchmove'
        ].forEach(function(e) {
            _this3.el.addEventListener(e, _this3.onPointerEvent, {
                capture: true,
                passive: true
            });
        });
        this.el.addEventListener('mousemove', this.onMouseMove);
        this.el.addEventListener('mouseleave', this.onMouseLeave);
        this.contentWrapperEl.addEventListener('scroll', this.onScroll); // Browser zoom triggers a window resize
        elWindow.addEventListener('resize', this.onWindowResize); // Hack for https://github.com/WICG/ResizeObserver/issues/38
        var resizeObserverStarted = false;
        var resizeAnimationFrameId = null;
        var resizeObserver = elWindow.ResizeObserver || (0, _resizeObserver.ResizeObserver);
        this.resizeObserver = new resizeObserver(function() {
            if (!resizeObserverStarted || resizeAnimationFrameId !== null) return;
            resizeAnimationFrameId = elWindow.requestAnimationFrame(function() {
                _this3.recalculate();
                resizeAnimationFrameId = null;
            });
        });
        this.resizeObserver.observe(this.el);
        this.resizeObserver.observe(this.contentEl);
        elWindow.requestAnimationFrame(function() {
            resizeObserverStarted = true;
        }); // This is required to detect horizontal scroll. Vertical scroll only needs the resizeObserver.
        this.mutationObserver = new elWindow.MutationObserver(this.recalculate);
        this.mutationObserver.observe(this.contentEl, {
            childList: true,
            subtree: true,
            characterData: true
        });
    };
    _proto.recalculate = function recalculate() {
        var elWindow = getElementWindow(this.el);
        this.elStyles = elWindow.getComputedStyle(this.el);
        this.isRtl = this.elStyles.direction === 'rtl';
        var isHeightAuto = this.heightAutoObserverEl.offsetHeight <= 1;
        var isWidthAuto = this.heightAutoObserverEl.offsetWidth <= 1;
        var contentElOffsetWidth = this.contentEl.offsetWidth;
        var contentWrapperElOffsetWidth = this.contentWrapperEl.offsetWidth;
        var elOverflowX = this.elStyles.overflowX;
        var elOverflowY = this.elStyles.overflowY;
        this.contentEl.style.padding = this.elStyles.paddingTop + " " + this.elStyles.paddingRight + " " + this.elStyles.paddingBottom + " " + this.elStyles.paddingLeft;
        this.wrapperEl.style.margin = "-" + this.elStyles.paddingTop + " -" + this.elStyles.paddingRight + " -" + this.elStyles.paddingBottom + " -" + this.elStyles.paddingLeft;
        var contentElScrollHeight = this.contentEl.scrollHeight;
        var contentElScrollWidth = this.contentEl.scrollWidth;
        this.contentWrapperEl.style.height = isHeightAuto ? 'auto' : '100%'; // Determine placeholder size
        this.placeholderEl.style.width = isWidthAuto ? contentElOffsetWidth + "px" : 'auto';
        this.placeholderEl.style.height = contentElScrollHeight + "px";
        var contentWrapperElOffsetHeight = this.contentWrapperEl.offsetHeight;
        this.axis.x.isOverflowing = contentElScrollWidth > contentElOffsetWidth;
        this.axis.y.isOverflowing = contentElScrollHeight > contentWrapperElOffsetHeight; // Set isOverflowing to false if user explicitely set hidden overflow
        this.axis.x.isOverflowing = elOverflowX === 'hidden' ? false : this.axis.x.isOverflowing;
        this.axis.y.isOverflowing = elOverflowY === 'hidden' ? false : this.axis.y.isOverflowing;
        this.axis.x.forceVisible = this.options.forceVisible === 'x' || this.options.forceVisible === true;
        this.axis.y.forceVisible = this.options.forceVisible === 'y' || this.options.forceVisible === true;
        this.hideNativeScrollbar(); // Set isOverflowing to false if scrollbar is not necessary (content is shorter than offset)
        var offsetForXScrollbar = this.axis.x.isOverflowing ? this.scrollbarWidth : 0;
        var offsetForYScrollbar = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
        this.axis.x.isOverflowing = this.axis.x.isOverflowing && contentElScrollWidth > contentWrapperElOffsetWidth - offsetForYScrollbar;
        this.axis.y.isOverflowing = this.axis.y.isOverflowing && contentElScrollHeight > contentWrapperElOffsetHeight - offsetForXScrollbar;
        this.axis.x.scrollbar.size = this.getScrollbarSize('x');
        this.axis.y.scrollbar.size = this.getScrollbarSize('y');
        this.axis.x.scrollbar.el.style.width = this.axis.x.scrollbar.size + "px";
        this.axis.y.scrollbar.el.style.height = this.axis.y.scrollbar.size + "px";
        this.positionScrollbar('x');
        this.positionScrollbar('y');
        this.toggleTrackVisibility('x');
        this.toggleTrackVisibility('y');
    };
    _proto.getScrollbarSize = function getScrollbarSize(axis) {
        if (axis === void 0) axis = 'y';
        if (!this.axis[axis].isOverflowing) return 0;
        var contentSize = this.contentEl[this.axis[axis].scrollSizeAttr];
        var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
        var scrollbarSize;
        var scrollbarRatio = trackSize / contentSize; // Calculate new height/position of drag handle.
        scrollbarSize = Math.max(~~(scrollbarRatio * trackSize), this.options.scrollbarMinSize);
        if (this.options.scrollbarMaxSize) scrollbarSize = Math.min(scrollbarSize, this.options.scrollbarMaxSize);
        return scrollbarSize;
    };
    _proto.positionScrollbar = function positionScrollbar(axis) {
        if (axis === void 0) axis = 'y';
        if (!this.axis[axis].isOverflowing) return;
        var contentSize = this.contentWrapperEl[this.axis[axis].scrollSizeAttr];
        var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrollbar = this.axis[axis].scrollbar;
        var scrollOffset = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        scrollOffset = axis === 'x' && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollOffset : scrollOffset;
        var scrollPourcent = scrollOffset / (contentSize - hostSize);
        var handleOffset = ~~((trackSize - scrollbar.size) * scrollPourcent);
        handleOffset = axis === 'x' && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? handleOffset + (trackSize - scrollbar.size) : handleOffset;
        scrollbar.el.style.transform = axis === 'x' ? "translate3d(" + handleOffset + "px, 0, 0)" : "translate3d(0, " + handleOffset + "px, 0)";
    };
    _proto.toggleTrackVisibility = function toggleTrackVisibility(axis) {
        if (axis === void 0) axis = 'y';
        var track = this.axis[axis].track.el;
        var scrollbar = this.axis[axis].scrollbar.el;
        if (this.axis[axis].isOverflowing || this.axis[axis].forceVisible) {
            track.style.visibility = 'visible';
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = 'scroll';
        } else {
            track.style.visibility = 'hidden';
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = 'hidden';
        } // Even if forceVisible is enabled, scrollbar itself should be hidden
        if (this.axis[axis].isOverflowing) scrollbar.style.display = 'block';
        else scrollbar.style.display = 'none';
    };
    _proto.hideNativeScrollbar = function hideNativeScrollbar() {
        this.offsetEl.style[this.isRtl ? 'left' : 'right'] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
        this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
    };
    _proto.onMouseMoveForAxis = function onMouseMoveForAxis(axis) {
        if (axis === void 0) axis = 'y';
        this.axis[axis].track.rect = this.axis[axis].track.el.getBoundingClientRect();
        this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
        var isWithinScrollbarBoundsX = this.isWithinBounds(this.axis[axis].scrollbar.rect);
        if (isWithinScrollbarBoundsX) this.axis[axis].scrollbar.el.classList.add(this.classNames.hover);
        else this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
        if (this.isWithinBounds(this.axis[axis].track.rect)) {
            this.showScrollbar(axis);
            this.axis[axis].track.el.classList.add(this.classNames.hover);
        } else this.axis[axis].track.el.classList.remove(this.classNames.hover);
    };
    _proto.onMouseLeaveForAxis = function onMouseLeaveForAxis(axis) {
        if (axis === void 0) axis = 'y';
        this.axis[axis].track.el.classList.remove(this.classNames.hover);
        this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
    };
    /**
   * Show scrollbar
   */ _proto.showScrollbar = function showScrollbar(axis) {
        if (axis === void 0) axis = 'y';
        var scrollbar = this.axis[axis].scrollbar.el;
        if (!this.axis[axis].isVisible) {
            scrollbar.classList.add(this.classNames.visible);
            this.axis[axis].isVisible = true;
        }
        if (this.options.autoHide) this.hideScrollbars();
    };
    /**
   * on scrollbar handle drag movement starts
   */ _proto.onDragStart = function onDragStart(e, axis) {
        if (axis === void 0) axis = 'y';
        var elDocument = getElementDocument(this.el);
        var elWindow = getElementWindow(this.el);
        var scrollbar = this.axis[axis].scrollbar; // Measure how far the user's mouse is from the top of the scrollbar drag handle.
        var eventOffset = axis === 'y' ? e.pageY : e.pageX;
        this.axis[axis].dragOffset = eventOffset - scrollbar.rect[this.axis[axis].offsetAttr];
        this.draggedAxis = axis;
        this.el.classList.add(this.classNames.dragging);
        elDocument.addEventListener('mousemove', this.drag, true);
        elDocument.addEventListener('mouseup', this.onEndDrag, true);
        if (this.removePreventClickId === null) {
            elDocument.addEventListener('click', this.preventClick, true);
            elDocument.addEventListener('dblclick', this.preventClick, true);
        } else {
            elWindow.clearTimeout(this.removePreventClickId);
            this.removePreventClickId = null;
        }
    };
    _proto.onTrackClick = function onTrackClick(e, axis) {
        var _this4 = this;
        if (axis === void 0) axis = 'y';
        if (!this.options.clickOnTrack) return;
        var elWindow = getElementWindow(this.el);
        this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
        var scrollbar = this.axis[axis].scrollbar;
        var scrollbarOffset = scrollbar.rect[this.axis[axis].offsetAttr];
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrolled = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        var t = axis === 'y' ? this.mouseY - scrollbarOffset : this.mouseX - scrollbarOffset;
        var dir = t < 0 ? -1 : 1;
        var scrollSize = dir === -1 ? scrolled - hostSize : scrolled + hostSize;
        var scrollTo = function scrollTo() {
            if (dir === -1) {
                if (scrolled > scrollSize) {
                    var _this4$contentWrapper;
                    scrolled -= _this4.options.clickOnTrackSpeed;
                    _this4.contentWrapperEl.scrollTo((_this4$contentWrapper = {}, _this4$contentWrapper[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper));
                    elWindow.requestAnimationFrame(scrollTo);
                }
            } else if (scrolled < scrollSize) {
                var _this4$contentWrapper2;
                scrolled += _this4.options.clickOnTrackSpeed;
                _this4.contentWrapperEl.scrollTo((_this4$contentWrapper2 = {}, _this4$contentWrapper2[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper2));
                elWindow.requestAnimationFrame(scrollTo);
            }
        };
        scrollTo();
    };
    _proto.getContentElement = function getContentElement() {
        return this.contentEl;
    };
    _proto.getScrollElement = function getScrollElement() {
        return this.contentWrapperEl;
    };
    _proto.getScrollbarWidth = function getScrollbarWidth() {
        // Try/catch for FF 56 throwing on undefined computedStyles
        try {
            // Detect browsers supporting CSS scrollbar styling and do not calculate
            if (getComputedStyle(this.contentWrapperEl, '::-webkit-scrollbar').display === 'none' || 'scrollbarWidth' in document.documentElement.style || '-ms-overflow-style' in document.documentElement.style) return 0;
            else return scrollbarWidth(this.el);
        } catch (e) {
            return scrollbarWidth(this.el);
        }
    };
    _proto.removeListeners = function removeListeners() {
        var _this5 = this;
        var elWindow = getElementWindow(this.el); // Event listeners
        if (this.options.autoHide) this.el.removeEventListener('mouseenter', this.onMouseEnter);
        [
            'mousedown',
            'click',
            'dblclick'
        ].forEach(function(e) {
            _this5.el.removeEventListener(e, _this5.onPointerEvent, true);
        });
        [
            'touchstart',
            'touchend',
            'touchmove'
        ].forEach(function(e) {
            _this5.el.removeEventListener(e, _this5.onPointerEvent, {
                capture: true,
                passive: true
            });
        });
        this.el.removeEventListener('mousemove', this.onMouseMove);
        this.el.removeEventListener('mouseleave', this.onMouseLeave);
        if (this.contentWrapperEl) this.contentWrapperEl.removeEventListener('scroll', this.onScroll);
        elWindow.removeEventListener('resize', this.onWindowResize);
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
         // Cancel all debounced functions
        this.recalculate.cancel();
        this.onMouseMove.cancel();
        this.hideScrollbars.cancel();
        this.onWindowResize.cancel();
    };
    _proto.unMount = function unMount() {
        this.removeListeners();
        SimpleBar.instances.delete(this.el);
    };
    _proto.isWithinBounds = function isWithinBounds(bbox) {
        return this.mouseX >= bbox.left && this.mouseX <= bbox.left + bbox.width && this.mouseY >= bbox.top && this.mouseY <= bbox.top + bbox.height;
    };
    _proto.findChild = function findChild(el, query) {
        var matches = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
        return Array.prototype.filter.call(el.children, function(child) {
            return matches.call(child, query);
        })[0];
    };
    return SimpleBar;
}();
SimpleBar.defaultOptions = {
    autoHide: true,
    forceVisible: false,
    clickOnTrack: true,
    clickOnTrackSpeed: 40,
    classNames: {
        contentEl: 'simplebar-content',
        contentWrapper: 'simplebar-content-wrapper',
        offset: 'simplebar-offset',
        mask: 'simplebar-mask',
        wrapper: 'simplebar-wrapper',
        placeholder: 'simplebar-placeholder',
        scrollbar: 'simplebar-scrollbar',
        track: 'simplebar-track',
        heightAutoObserverWrapperEl: 'simplebar-height-auto-observer-wrapper',
        heightAutoObserverEl: 'simplebar-height-auto-observer',
        visible: 'simplebar-visible',
        horizontal: 'simplebar-horizontal',
        vertical: 'simplebar-vertical',
        hover: 'simplebar-hover',
        dragging: 'simplebar-dragging'
    },
    scrollbarMinSize: 25,
    scrollbarMaxSize: 0,
    timeout: 1000
};
SimpleBar.instances = new WeakMap();
SimpleBar.initDOMLoadedElements = function() {
    document.removeEventListener('DOMContentLoaded', this.initDOMLoadedElements);
    window.removeEventListener('load', this.initDOMLoadedElements);
    Array.prototype.forEach.call(document.querySelectorAll('[data-simplebar]'), function(el) {
        if (el.getAttribute('data-simplebar') !== 'init' && !SimpleBar.instances.has(el)) new SimpleBar(el, getOptions(el.attributes));
    });
};
SimpleBar.removeObserver = function() {
    this.globalObserver.disconnect();
};
SimpleBar.initHtmlApi = function() {
    this.initDOMLoadedElements = this.initDOMLoadedElements.bind(this); // MutationObserver is IE11+
    if (typeof MutationObserver !== 'undefined') {
        // Mutation observer to observe dynamically added elements
        this.globalObserver = new MutationObserver(SimpleBar.handleMutations);
        this.globalObserver.observe(document, {
            childList: true,
            subtree: true
        });
    } // Taken from jQuery `ready` function
    // Instantiate elements already present on the page
    if (document.readyState === 'complete' || document.readyState !== 'loading' && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay init
    window.setTimeout(this.initDOMLoadedElements);
    else {
        document.addEventListener('DOMContentLoaded', this.initDOMLoadedElements);
        window.addEventListener('load', this.initDOMLoadedElements);
    }
};
SimpleBar.handleMutations = function(mutations) {
    mutations.forEach(function(mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function(addedNode) {
            if (addedNode.nodeType === 1) {
                if (addedNode.hasAttribute('data-simplebar')) !SimpleBar.instances.has(addedNode) && document.documentElement.contains(addedNode) && new SimpleBar(addedNode, getOptions(addedNode.attributes));
                else Array.prototype.forEach.call(addedNode.querySelectorAll('[data-simplebar]'), function(el) {
                    if (el.getAttribute('data-simplebar') !== 'init' && !SimpleBar.instances.has(el) && document.documentElement.contains(el)) new SimpleBar(el, getOptions(el.attributes));
                });
            }
        });
        Array.prototype.forEach.call(mutation.removedNodes, function(removedNode) {
            if (removedNode.nodeType === 1) {
                if (removedNode.getAttribute('data-simplebar') === 'init') SimpleBar.instances.has(removedNode) && !document.documentElement.contains(removedNode) && SimpleBar.instances.get(removedNode).unMount();
                else Array.prototype.forEach.call(removedNode.querySelectorAll('[data-simplebar="init"]'), function(el) {
                    SimpleBar.instances.has(el) && !document.documentElement.contains(el) && SimpleBar.instances.get(el).unMount();
                });
            }
        });
    });
};
SimpleBar.getOptions = getOptions;
/**
 * HTML API
 * Called only in a browser env.
 */ if (0, _canUseDomDefault.default) SimpleBar.initHtmlApi();
exports.default = SimpleBar;

},{"core-js/modules/es.object.to-string.js":"eeozG","core-js/modules/web.dom-collections.for-each.js":"33JtO","can-use-dom":"hIiRP","core-js/modules/es.parse-int.js":"esPRw","core-js/modules/es.object.assign.js":"cvOlS","core-js/modules/es.array.filter.js":"1cjIl","core-js/modules/es.array.iterator.js":"iTs2y","core-js/modules/es.string.iterator.js":"9ej1J","core-js/modules/es.weak-map.js":"aSJVT","core-js/modules/web.dom-collections.iterator.js":"cZvdG","lodash.throttle":"39XSF","lodash.debounce":"fxZki","lodash.memoize":"1qNIh","@juggle/resize-observer":"3Ebqt","core-js/modules/es.array.reduce.js":"6Jl3s","core-js/modules/es.regexp.exec.js":"4ceMt","core-js/modules/es.string.match.js":"lfU7s","core-js/modules/es.function.name.js":"hBP0j","core-js/modules/es.string.replace.js":"5boEp","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"eeozG":[function(require,module,exports,__globalThis) {
'use strict';
var TO_STRING_TAG_SUPPORT = require("2f5378debd330ed5");
var defineBuiltIn = require("5e0718aecf12f1e8");
var toString = require("6b32f4accffdcba8");
// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) defineBuiltIn(Object.prototype, 'toString', toString, {
    unsafe: true
});

},{"2f5378debd330ed5":"2PiAP","5e0718aecf12f1e8":"baZWN","6b32f4accffdcba8":"7Fmda"}],"2PiAP":[function(require,module,exports,__globalThis) {
'use strict';
var wellKnownSymbol = require("6306cd4835715127");
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};
// eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
test[TO_STRING_TAG] = 'z';
module.exports = String(test) === '[object z]';

},{"6306cd4835715127":"iPmWx"}],"iPmWx":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("ad5ef4474219c101");
var shared = require("6a2cda01df6b4c79");
var hasOwn = require("dccc28ffa5beeb54");
var uid = require("48d6af1225853d44");
var NATIVE_SYMBOL = require("9f762329148684");
var USE_SYMBOL_AS_UID = require("1ce268781e409df2");
var Symbol = globalThis.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;
module.exports = function(name) {
    if (!hasOwn(WellKnownSymbolsStore, name)) WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name) ? Symbol[name] : createWellKnownSymbol('Symbol.' + name);
    return WellKnownSymbolsStore[name];
};

},{"ad5ef4474219c101":"f9rMX","6a2cda01df6b4c79":"wnsd5","dccc28ffa5beeb54":"23l8D","48d6af1225853d44":"7KkeL","9f762329148684":"5H0Pm","1ce268781e409df2":"8Eb9Y"}],"f9rMX":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
var check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = // eslint-disable-next-line es/no-global-this -- safe
check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
check(typeof self == 'object' && self) || check(typeof global == 'object' && global) || check(typeof this == 'object' && this) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();

},{}],"wnsd5":[function(require,module,exports,__globalThis) {
'use strict';
var store = require("84eeed9891aafe14");
module.exports = function(key, value) {
    return store[key] || (store[key] = value || {});
};

},{"84eeed9891aafe14":"2nMB9"}],"2nMB9":[function(require,module,exports,__globalThis) {
'use strict';
var IS_PURE = require("7b43004672b1879f");
var globalThis = require("bc8329e77dc2c1cc");
var defineGlobalProperty = require("dfb72a1d809f7b02");
var SHARED = '__core-js_shared__';
var store = module.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});
(store.versions || (store.versions = [])).push({
    version: '3.49.0',
    mode: IS_PURE ? 'pure' : 'global',
    copyright: "\xa9 2013\u20132025 Denis Pushkarev (zloirock.ru), 2025\u20132026 CoreJS Company (core-js.io). All rights reserved.",
    license: 'https://github.com/zloirock/core-js/blob/v3.49.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});

},{"7b43004672b1879f":"ewUJV","bc8329e77dc2c1cc":"f9rMX","dfb72a1d809f7b02":"6PYLS"}],"ewUJV":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = false;

},{}],"6PYLS":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("2d1c29655635b9ea");
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
module.exports = function(key, value) {
    try {
        defineProperty(globalThis, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        globalThis[key] = value;
    }
    return value;
};

},{"2d1c29655635b9ea":"f9rMX"}],"23l8D":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("f5dcaa60a713971f");
var toObject = require("ab17c4f45fcf0841");
var hasOwnProperty = uncurryThis({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
    return hasOwnProperty(toObject(it), key);
};

},{"f5dcaa60a713971f":"2eIWS","ab17c4f45fcf0841":"4wIgP"}],"2eIWS":[function(require,module,exports,__globalThis) {
'use strict';
var NATIVE_BIND = require("829dd7a4e960cf9e");
var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);
module.exports = NATIVE_BIND ? uncurryThisWithBind : function(fn) {
    return function() {
        return call.apply(fn, arguments);
    };
};

},{"829dd7a4e960cf9e":"5YUIB"}],"5YUIB":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("2642aa7619056f20");
module.exports = !fails(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});

},{"2642aa7619056f20":"5EMIZ"}],"5EMIZ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};

},{}],"4wIgP":[function(require,module,exports,__globalThis) {
'use strict';
var requireObjectCoercible = require("f45a7b5dcdc4a410");
var $Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function(argument) {
    return $Object(requireObjectCoercible(argument));
};

},{"f45a7b5dcdc4a410":"eSVZv"}],"eSVZv":[function(require,module,exports,__globalThis) {
'use strict';
var isNullOrUndefined = require("74607922ed30019f");
var $TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function(it) {
    if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
    return it;
};

},{"74607922ed30019f":"6MFHG"}],"6MFHG":[function(require,module,exports,__globalThis) {
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function(it) {
    return it === null || it === undefined;
};

},{}],"7KkeL":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("5da0fe4507da20a3");
var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.1.toString);
module.exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};

},{"5da0fe4507da20a3":"2eIWS"}],"5H0Pm":[function(require,module,exports,__globalThis) {
'use strict';
/* eslint-disable es/no-symbol -- required for testing */ var V8_VERSION = require("53b951dfb9de4d22");
var fails = require("b37df495bcdc1d99");
var globalThis = require("e5929e9affd2affc");
var $String = globalThis.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

},{"53b951dfb9de4d22":"42zsN","b37df495bcdc1d99":"5EMIZ","e5929e9affd2affc":"f9rMX"}],"42zsN":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("d049c1c2aa0eee5b");
var userAgent = require("4eb5796bbafe334d");
var process = globalThis.process;
var Deno = globalThis.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
    match = v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
    match = userAgent.match(/Edge\/(\d+)/);
    if (!match || match[1] >= 74) {
        match = userAgent.match(/Chrome\/(\d+)/);
        if (match) version = +match[1];
    }
}
module.exports = version;

},{"d049c1c2aa0eee5b":"f9rMX","4eb5796bbafe334d":"eC1k9"}],"eC1k9":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("888bcb4c75dc4ad");
var navigator = globalThis.navigator;
var userAgent = navigator && navigator.userAgent;
module.exports = userAgent ? String(userAgent) : '';

},{"888bcb4c75dc4ad":"f9rMX"}],"8Eb9Y":[function(require,module,exports,__globalThis) {
'use strict';
/* eslint-disable es/no-symbol -- required for testing */ var NATIVE_SYMBOL = require("da4a972af0214ea0");
module.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == 'symbol';

},{"da4a972af0214ea0":"5H0Pm"}],"baZWN":[function(require,module,exports,__globalThis) {
'use strict';
var isCallable = require("99ee13632b3fa68");
var definePropertyModule = require("9ebb3e3004fccc0a");
var makeBuiltIn = require("f10cc812a3094053");
var defineGlobalProperty = require("d354802d852d9c2b");
module.exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if (isCallable(value)) makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else defineGlobalProperty(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else definePropertyModule.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};

},{"99ee13632b3fa68":"5VYzL","9ebb3e3004fccc0a":"3CoVw","f10cc812a3094053":"egX5P","d354802d852d9c2b":"6PYLS"}],"5VYzL":[function(require,module,exports,__globalThis) {
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof documentAll == 'undefined' && documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === documentAll;
} : function(argument) {
    return typeof argument == 'function';
};

},{}],"3CoVw":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("ca50eb9163928400");
var IE8_DOM_DEFINE = require("d482f9e5478795e8");
var V8_PROTOTYPE_DEFINE_BUG = require("b6ad7537efb06f4b");
var anObject = require("16365a73399e7fe7");
var toPropertyKey = require("fab1d366c47796d9");
var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPropertyKey(P);
    anObject(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
        var current = $getOwnPropertyDescriptor(O, P);
        if (current && current[WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
                enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                writable: false
            };
        }
    }
    return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPropertyKey(P);
    anObject(Attributes);
    if (IE8_DOM_DEFINE) try {
        return $defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

},{"ca50eb9163928400":"6VYiA","d482f9e5478795e8":"k7aMK","b6ad7537efb06f4b":"gMbWP","16365a73399e7fe7":"BZXPW","fab1d366c47796d9":"5rqp9"}],"6VYiA":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("735b783268fd06c0");
// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});

},{"735b783268fd06c0":"5EMIZ"}],"k7aMK":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("9b4278b13c076bf");
var fails = require("8aee5d88a5f9b6b5");
var createElement = require("1db4d60148afcf21");
// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(createElement('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});

},{"9b4278b13c076bf":"6VYiA","8aee5d88a5f9b6b5":"5EMIZ","1db4d60148afcf21":"7v5iJ"}],"7v5iJ":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("845bcece0e6d354");
var isObject = require("824df78b2e007250");
var document = globalThis.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);
module.exports = function(it) {
    return EXISTS ? document.createElement(it) : {};
};

},{"845bcece0e6d354":"f9rMX","824df78b2e007250":"9mXeP"}],"9mXeP":[function(require,module,exports,__globalThis) {
'use strict';
var isCallable = require("f87cee1cb79cbcca");
module.exports = function(it) {
    return typeof it == 'object' ? it !== null : isCallable(it);
};

},{"f87cee1cb79cbcca":"5VYzL"}],"gMbWP":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("b22a5a2de93e3ad2");
var fails = require("249a5b857c2dfccd");
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});

},{"b22a5a2de93e3ad2":"6VYiA","249a5b857c2dfccd":"5EMIZ"}],"BZXPW":[function(require,module,exports,__globalThis) {
'use strict';
var isObject = require("2b6c6258a0a6082f");
var $String = String;
var $TypeError = TypeError;
// `Assert: Type(argument) is Object`
module.exports = function(argument) {
    if (isObject(argument)) return argument;
    throw new $TypeError($String(argument) + ' is not an object');
};

},{"2b6c6258a0a6082f":"9mXeP"}],"5rqp9":[function(require,module,exports,__globalThis) {
'use strict';
var toPrimitive = require("53a3a67ac381c4e8");
var isSymbol = require("b992ca9cdcf7937b");
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function(argument) {
    var key = toPrimitive(argument, 'string');
    return isSymbol(key) ? key : key + '';
};

},{"53a3a67ac381c4e8":"eYKW3","b992ca9cdcf7937b":"g5NMF"}],"eYKW3":[function(require,module,exports,__globalThis) {
'use strict';
var call = require("70235907dc93b4b0");
var isObject = require("46fb53dace408c8e");
var isSymbol = require("677bdc4d74d2f983");
var getMethod = require("80395bcde336a28b");
var ordinaryToPrimitive = require("49552a7324952190");
var wellKnownSymbol = require("aea01c71276624bf");
var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function(input, pref) {
    if (!isObject(input) || isSymbol(input)) return input;
    var exoticToPrim = getMethod(input, TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = call(exoticToPrim, input, pref);
        if (!isObject(result) || isSymbol(result)) return result;
        throw new $TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return ordinaryToPrimitive(input, pref);
};

},{"70235907dc93b4b0":"2uUEG","46fb53dace408c8e":"9mXeP","677bdc4d74d2f983":"g5NMF","80395bcde336a28b":"2Kir9","49552a7324952190":"lmVHC","aea01c71276624bf":"iPmWx"}],"2uUEG":[function(require,module,exports,__globalThis) {
'use strict';
var NATIVE_BIND = require("44e025d030d66023");
var call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
module.exports = NATIVE_BIND ? call.bind(call) : function() {
    return call.apply(call, arguments);
};

},{"44e025d030d66023":"5YUIB"}],"g5NMF":[function(require,module,exports,__globalThis) {
'use strict';
var getBuiltIn = require("6b6c481cdfb7df35");
var isCallable = require("2af44fcbdbf14c83");
var isPrototypeOf = require("76e903e830c40e7c");
var USE_SYMBOL_AS_UID = require("7e2fe930b3598e22");
var $Object = Object;
module.exports = USE_SYMBOL_AS_UID ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = getBuiltIn('Symbol');
    return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};

},{"6b6c481cdfb7df35":"6vKyV","2af44fcbdbf14c83":"5VYzL","76e903e830c40e7c":"dduyg","7e2fe930b3598e22":"8Eb9Y"}],"6vKyV":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("e057fc33d60763c1");
var isCallable = require("f1d62079325906cb");
var aFunction = function(argument) {
    return isCallable(argument) ? argument : undefined;
};
module.exports = function(namespace, method) {
    return arguments.length < 2 ? aFunction(globalThis[namespace]) : globalThis[namespace] && globalThis[namespace][method];
};

},{"e057fc33d60763c1":"f9rMX","f1d62079325906cb":"5VYzL"}],"dduyg":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("83f14842ef67e16a");
module.exports = uncurryThis({}.isPrototypeOf);

},{"83f14842ef67e16a":"2eIWS"}],"2Kir9":[function(require,module,exports,__globalThis) {
'use strict';
var aCallable = require("bbfed17b24e215f4");
var isNullOrUndefined = require("492a86e2970f6a26");
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function(V, P) {
    var func = V[P];
    return isNullOrUndefined(func) ? undefined : aCallable(func);
};

},{"bbfed17b24e215f4":"gx4Kw","492a86e2970f6a26":"6MFHG"}],"gx4Kw":[function(require,module,exports,__globalThis) {
'use strict';
var isCallable = require("4094667126ecac05");
var tryToString = require("fce2a7573db493fa");
var $TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
module.exports = function(argument) {
    if (isCallable(argument)) return argument;
    throw new $TypeError(tryToString(argument) + ' is not a function');
};

},{"4094667126ecac05":"5VYzL","fce2a7573db493fa":"konra"}],"konra":[function(require,module,exports,__globalThis) {
'use strict';
var $String = String;
module.exports = function(argument) {
    try {
        return $String(argument);
    } catch (error) {
        return 'Object';
    }
};

},{}],"lmVHC":[function(require,module,exports,__globalThis) {
'use strict';
var call = require("abe9ca006f56626e");
var isCallable = require("c96b3a89fec6248a");
var isObject = require("551615fda0214f1b");
var $TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
    if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
    if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
    throw new $TypeError("Can't convert object to primitive value");
};

},{"abe9ca006f56626e":"2uUEG","c96b3a89fec6248a":"5VYzL","551615fda0214f1b":"9mXeP"}],"egX5P":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("ca84677f1ebd1804");
var fails = require("13360f2842eba261");
var isCallable = require("103e488c0928755a");
var hasOwn = require("cbf9b0e0779cc368");
var DESCRIPTORS = require("3f2eb7efeae2f72b");
var CONFIGURABLE_FUNCTION_NAME = require("548b10f284264c72").CONFIGURABLE;
var inspectSource = require("358f00f3103bd55b");
var InternalStateModule = require("9b2ce14119fd2412");
var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);
var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function() {
    return defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var TEMPLATE = String(String).split('String');
var makeBuiltIn = module.exports = function(value, name, options) {
    if (stringSlice($String(name), 0, 7) === 'Symbol(') name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!hasOwn(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if (DESCRIPTORS) defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && hasOwn(options, 'constructor') && options.constructor) {
            if (DESCRIPTORS) defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = enforceInternalState(value);
    if (!hasOwn(state, 'source')) state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
    return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');

},{"ca84677f1ebd1804":"2eIWS","13360f2842eba261":"5EMIZ","103e488c0928755a":"5VYzL","cbf9b0e0779cc368":"23l8D","3f2eb7efeae2f72b":"6VYiA","548b10f284264c72":"iqmDO","358f00f3103bd55b":"t33IC","9b2ce14119fd2412":"7SPub"}],"iqmDO":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("8ad2bacb0e20b95c");
var hasOwn = require("4eabfd8f83afc9d5");
var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() {}).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable);
module.exports = {
    EXISTS: EXISTS,
    PROPER: PROPER,
    CONFIGURABLE: CONFIGURABLE
};

},{"8ad2bacb0e20b95c":"6VYiA","4eabfd8f83afc9d5":"23l8D"}],"t33IC":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("26e26db98367212e");
var isCallable = require("40ed9a4f6ae66648");
var store = require("485d48d6f4c6739e");
var functionToString = uncurryThis(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) store.inspectSource = function(it) {
    return functionToString(it);
};
module.exports = store.inspectSource;

},{"26e26db98367212e":"2eIWS","40ed9a4f6ae66648":"5VYzL","485d48d6f4c6739e":"2nMB9"}],"7SPub":[function(require,module,exports,__globalThis) {
'use strict';
var NATIVE_WEAK_MAP = require("d3f0c9f3327b2fd6");
var globalThis = require("28c3574d0c39fe7e");
var isObject = require("f82e6cc0ac249fa5");
var createNonEnumerableProperty = require("c0ae163eea4ef97");
var hasOwn = require("6dea7358344877bb");
var shared = require("3e035a1241da2f0");
var sharedKey = require("88d6ccc27e779e5a");
var hiddenKeys = require("d40b9b3abdbb956e");
var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = globalThis.TypeError;
var WeakMap = globalThis.WeakMap;
var set, get, has;
var enforce = function(it) {
    return has(it) ? get(it) : set(it, {});
};
var getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!isObject(it) || (state = get(it)).type !== TYPE) throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if (NATIVE_WEAK_MAP || shared.state) {
    var store = shared.state || (shared.state = new WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ store.get = store.get;
    store.has = store.has;
    store.set = store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ set = function(it, metadata) {
        if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        store.set(it, metadata);
        return metadata;
    };
    get = function(it) {
        return store.get(it) || {};
    };
    has = function(it) {
        return store.has(it);
    };
} else {
    var STATE = sharedKey('state');
    hiddenKeys[STATE] = true;
    set = function(it, metadata) {
        if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        createNonEnumerableProperty(it, STATE, metadata);
        return metadata;
    };
    get = function(it) {
        return hasOwn(it, STATE) ? it[STATE] : {};
    };
    has = function(it) {
        return hasOwn(it, STATE);
    };
}
module.exports = {
    set: set,
    get: get,
    has: has,
    enforce: enforce,
    getterFor: getterFor
};

},{"d3f0c9f3327b2fd6":"dhJro","28c3574d0c39fe7e":"f9rMX","f82e6cc0ac249fa5":"9mXeP","c0ae163eea4ef97":"dsQvz","6dea7358344877bb":"23l8D","3e035a1241da2f0":"2nMB9","88d6ccc27e779e5a":"eJkH1","d40b9b3abdbb956e":"g2juy"}],"dhJro":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("8b1a8c1dbfd18eb5");
var isCallable = require("aa77fff8d5ef0565");
var WeakMap = globalThis.WeakMap;
module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));

},{"8b1a8c1dbfd18eb5":"f9rMX","aa77fff8d5ef0565":"5VYzL"}],"dsQvz":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("a8753383ef98ee18");
var definePropertyModule = require("189ab650b8f71085");
var createPropertyDescriptor = require("1168c8162aa30435");
module.exports = DESCRIPTORS ? function(object, key, value) {
    return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

},{"a8753383ef98ee18":"6VYiA","189ab650b8f71085":"3CoVw","1168c8162aa30435":"jKXht"}],"jKXht":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

},{}],"eJkH1":[function(require,module,exports,__globalThis) {
'use strict';
var shared = require("dbc8182adeb8c92f");
var uid = require("90b4ffb58508a6e5");
var keys = shared('keys');
module.exports = function(key) {
    return keys[key] || (keys[key] = uid(key));
};

},{"dbc8182adeb8c92f":"wnsd5","90b4ffb58508a6e5":"7KkeL"}],"g2juy":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = {};

},{}],"7Fmda":[function(require,module,exports,__globalThis) {
'use strict';
var TO_STRING_TAG_SUPPORT = require("312e54676af41375");
var classof = require("2dbce13c946fe9d0");
// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? ({}).toString : function toString() {
    return '[object ' + classof(this) + ']';
};

},{"312e54676af41375":"2PiAP","2dbce13c946fe9d0":"dhWw4"}],"dhWw4":[function(require,module,exports,__globalThis) {
'use strict';
var TO_STRING_TAG_SUPPORT = require("397e535b3976d304");
var isCallable = require("eebd8012c2d2c3ae");
var classofRaw = require("8da113eeaf06c4ba");
var wellKnownSymbol = require("df252844008f634");
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

},{"397e535b3976d304":"2PiAP","eebd8012c2d2c3ae":"5VYzL","8da113eeaf06c4ba":"60dWh","df252844008f634":"iPmWx"}],"60dWh":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("1c71c3f6daac476c");
var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);
module.exports = function(it) {
    return stringSlice(toString(it), 8, -1);
};

},{"1c71c3f6daac476c":"2eIWS"}],"33JtO":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("f2983879ab6ef4f");
var DOMIterables = require("74a037ab8118876");
var DOMTokenListPrototype = require("a3359ffcd052df79");
var forEach = require("9e6862fbf1bc54d2");
var createNonEnumerableProperty = require("833a1c6e8a10b1ff");
var handlePrototype = function(CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
        createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
    } catch (error) {
        CollectionPrototype.forEach = forEach;
    }
};
for(var COLLECTION_NAME in DOMIterables)if (DOMIterables[COLLECTION_NAME]) handlePrototype(globalThis[COLLECTION_NAME] && globalThis[COLLECTION_NAME].prototype);
handlePrototype(DOMTokenListPrototype);

},{"f2983879ab6ef4f":"f9rMX","74a037ab8118876":"cLOuj","a3359ffcd052df79":"aTda8","9e6862fbf1bc54d2":"eQMa4","833a1c6e8a10b1ff":"dsQvz"}],"cLOuj":[function(require,module,exports,__globalThis) {
'use strict';
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};

},{}],"aTda8":[function(require,module,exports,__globalThis) {
'use strict';
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = require("a6fc44eba1875331");
var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;
module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;

},{"a6fc44eba1875331":"7v5iJ"}],"eQMa4":[function(require,module,exports,__globalThis) {
'use strict';
var $forEach = require("1a0535b754110eb5").forEach;
var arrayMethodIsStrict = require("df61bc1b7a92de0f");
var STRICT_METHOD = arrayMethodIsStrict('forEach');
// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
    return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

},{"1a0535b754110eb5":"2Wpao","df61bc1b7a92de0f":"79K9I"}],"2Wpao":[function(require,module,exports,__globalThis) {
'use strict';
var bind = require("13e0747865316a42");
var IndexedObject = require("57aaeabd9d30911");
var toObject = require("3acffc809f3b03fb");
var lengthOfArrayLike = require("1fc4c4e55871562c");
var arraySpeciesCreate = require("76c922b575fbf7bd");
var createProperty = require("b1d8afcee549f73d");
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that) {
        var O = toObject($this);
        var self = IndexedObject(O);
        var length = lengthOfArrayLike(self);
        var boundFunction = bind(callbackfn, that);
        var index = 0;
        var resIndex = 0;
        var target = IS_MAP ? arraySpeciesCreate($this, length) : IS_FILTER || IS_FILTER_REJECT ? arraySpeciesCreate($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) createProperty(target, index, result); // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        createProperty(target, resIndex++, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        createProperty(target, resIndex++, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
module.exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: createMethod(7)
};

},{"13e0747865316a42":"cjIPc","57aaeabd9d30911":"fSmQq","3acffc809f3b03fb":"4wIgP","1fc4c4e55871562c":"1iqfp","76c922b575fbf7bd":"7Lcjj","b1d8afcee549f73d":"8kdml"}],"cjIPc":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("92f6f475baa85665");
var aCallable = require("547ee4f9dab0cc76");
var NATIVE_BIND = require("5acd31cba656d393");
var bind = uncurryThis(uncurryThis.bind);
// optional / simple context binding
module.exports = function(fn, that) {
    aCallable(fn);
    return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};

},{"92f6f475baa85665":"bIvNd","547ee4f9dab0cc76":"gx4Kw","5acd31cba656d393":"5YUIB"}],"bIvNd":[function(require,module,exports,__globalThis) {
'use strict';
var classofRaw = require("8e77093015e1e67f");
var uncurryThis = require("9daa4dbbca634c9e");
module.exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};

},{"8e77093015e1e67f":"60dWh","9daa4dbbca634c9e":"2eIWS"}],"fSmQq":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("7ba7e65983d7b662");
var fails = require("df551e12a7c872dd");
var classof = require("1d34ea813cebff9c");
var $Object = Object;
var split = uncurryThis(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;

},{"7ba7e65983d7b662":"2eIWS","df551e12a7c872dd":"5EMIZ","1d34ea813cebff9c":"60dWh"}],"1iqfp":[function(require,module,exports,__globalThis) {
'use strict';
var toLength = require("23d9716c54a2ab90");
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function(obj) {
    return toLength(obj.length);
};

},{"23d9716c54a2ab90":"hhykm"}],"hhykm":[function(require,module,exports,__globalThis) {
'use strict';
var toIntegerOrInfinity = require("c48d3a8b8ac52b0b");
var min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function(argument) {
    var len = toIntegerOrInfinity(argument);
    return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

},{"c48d3a8b8ac52b0b":"03zUT"}],"03zUT":[function(require,module,exports,__globalThis) {
'use strict';
var trunc = require("3403cba02b5f61d8");
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : trunc(number);
};

},{"3403cba02b5f61d8":"ggGaP"}],"ggGaP":[function(require,module,exports,__globalThis) {
'use strict';
var ceil = Math.ceil;
var floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? floor : ceil)(n);
};

},{}],"7Lcjj":[function(require,module,exports,__globalThis) {
'use strict';
var arraySpeciesConstructor = require("4580767bbbe40f0b");
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray, length) {
    return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

},{"4580767bbbe40f0b":"gYnR3"}],"gYnR3":[function(require,module,exports,__globalThis) {
'use strict';
var isArray = require("a9e5b9af57e551f6");
var isConstructor = require("2b4d84c184e08f4f");
var isObject = require("f4bec83e8d6008c9");
var wellKnownSymbol = require("4a13cf47b259a825");
var SPECIES = wellKnownSymbol('species');
var $Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function(originalArray) {
    var C;
    if (isArray(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
        else if (isObject(C)) {
            C = C[SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $Array : C;
};

},{"a9e5b9af57e551f6":"jO10N","2b4d84c184e08f4f":"20Y9e","f4bec83e8d6008c9":"9mXeP","4a13cf47b259a825":"iPmWx"}],"jO10N":[function(require,module,exports,__globalThis) {
'use strict';
var classof = require("ccb261b2d73a4fca");
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
    return classof(argument) === 'Array';
};

},{"ccb261b2d73a4fca":"60dWh"}],"20Y9e":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("3b3e7fa8cfe4b3ac");
var fails = require("84df2127d2d40501");
var isCallable = require("ae35eceee587c4bc");
var classof = require("7bd40df22601ee7e");
var getBuiltIn = require("271ff92378cbc486");
var inspectSource = require("74840ba4357c1c30");
var noop = function() {};
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);
var isConstructorModern = function isConstructor(argument) {
    if (!isCallable(argument)) return false;
    try {
        construct(noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var isConstructorLegacy = function isConstructor(argument) {
    if (!isCallable(argument)) return false;
    switch(classof(argument)){
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
    } catch (error) {
        return true;
    }
};
isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function() {
    var called;
    return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
        called = true;
    }) || called;
}) ? isConstructorLegacy : isConstructorModern;

},{"3b3e7fa8cfe4b3ac":"2eIWS","84df2127d2d40501":"5EMIZ","ae35eceee587c4bc":"5VYzL","7bd40df22601ee7e":"dhWw4","271ff92378cbc486":"6vKyV","74840ba4357c1c30":"t33IC"}],"8kdml":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("667a2d5a858194a6");
var definePropertyModule = require("2daa2f41b7310fd4");
var createPropertyDescriptor = require("7bb9efd811e3f83f");
module.exports = function(object, key, value) {
    if (DESCRIPTORS) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
    else object[key] = value;
};

},{"667a2d5a858194a6":"6VYiA","2daa2f41b7310fd4":"3CoVw","7bb9efd811e3f83f":"jKXht"}],"79K9I":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("77f0d106558781f");
module.exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && fails(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};

},{"77f0d106558781f":"5EMIZ"}],"hIiRP":[function(require,module,exports,__globalThis) {
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = canUseDOM;

},{}],"esPRw":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("3ca2a8550b205bbe");
var $parseInt = require("f57aad6998179c26");
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$({
    global: true,
    forced: parseInt !== $parseInt
}, {
    parseInt: $parseInt
});

},{"3ca2a8550b205bbe":"kc6W7","f57aad6998179c26":"aEMkj"}],"kc6W7":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("23dea28abc8414d1");
var getOwnPropertyDescriptor = require("2ec751f39e500b85").f;
var createNonEnumerableProperty = require("b4567636b28a3b3a");
var defineBuiltIn = require("50460aa43dd4048a");
var defineGlobalProperty = require("581238c99f8c2c30");
var copyConstructorProperties = require("566a383894c688bc");
var isForced = require("f0e2e697f04e8ad9");
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ module.exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = globalThis;
    else if (STATIC) target = globalThis[TARGET] || defineGlobalProperty(TARGET, {});
    else target = globalThis[TARGET] && globalThis[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(sourceProperty, 'sham', true);
        defineBuiltIn(target, key, sourceProperty, options);
    }
};

},{"23dea28abc8414d1":"f9rMX","2ec751f39e500b85":"cwlLN","b4567636b28a3b3a":"dsQvz","50460aa43dd4048a":"baZWN","581238c99f8c2c30":"6PYLS","566a383894c688bc":"gTEz3","f0e2e697f04e8ad9":"iGQvM"}],"cwlLN":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("c04e6fb248689dba");
var call = require("553ec943aa2a4554");
var propertyIsEnumerableModule = require("bbc5e69071aa2fbd");
var createPropertyDescriptor = require("1d2ffbfd99e01f41");
var toIndexedObject = require("c4ea69a78a643d87");
var toPropertyKey = require("8ab18ff766aa2ab9");
var hasOwn = require("3761c5d34b7aa48f");
var IE8_DOM_DEFINE = require("c4dfcc26308f1b4a");
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = toIndexedObject(O);
    P = toPropertyKey(P);
    if (IE8_DOM_DEFINE) try {
        return $getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};

},{"c04e6fb248689dba":"6VYiA","553ec943aa2a4554":"2uUEG","bbc5e69071aa2fbd":"9xvNr","1d2ffbfd99e01f41":"jKXht","c4ea69a78a643d87":"hOZCp","8ab18ff766aa2ab9":"5rqp9","3761c5d34b7aa48f":"23l8D","c4dfcc26308f1b4a":"k7aMK"}],"9xvNr":[function(require,module,exports,__globalThis) {
'use strict';
var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

},{}],"hOZCp":[function(require,module,exports,__globalThis) {
'use strict';
// toObject with fallback for non-array-like ES3 strings
var IndexedObject = require("9d8f8f50ac9468eb");
var requireObjectCoercible = require("f7224aed72953ac4");
module.exports = function(it) {
    return IndexedObject(requireObjectCoercible(it));
};

},{"9d8f8f50ac9468eb":"fSmQq","f7224aed72953ac4":"eSVZv"}],"gTEz3":[function(require,module,exports,__globalThis) {
'use strict';
var hasOwn = require("d91d786cc71453ce");
var ownKeys = require("88cb809f98beddc6");
var getOwnPropertyDescriptorModule = require("10ea642aad5f7c21");
var definePropertyModule = require("39ff598ce822187e");
module.exports = function(target, source, exceptions) {
    var keys = ownKeys(source);
    var defineProperty = definePropertyModule.f;
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};

},{"d91d786cc71453ce":"23l8D","88cb809f98beddc6":"2EF05","10ea642aad5f7c21":"cwlLN","39ff598ce822187e":"3CoVw"}],"2EF05":[function(require,module,exports,__globalThis) {
'use strict';
var getBuiltIn = require("3cc1e4329d869e34");
var uncurryThis = require("2b8e77cbdbe3db7a");
var getOwnPropertyNamesModule = require("d703bcb62fcda216");
var getOwnPropertySymbolsModule = require("157674bad2772c6d");
var anObject = require("a09e060b9cae3c6c");
var concat = uncurryThis([].concat);
// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = getOwnPropertyNamesModule.f(anObject(it));
    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

},{"3cc1e4329d869e34":"6vKyV","2b8e77cbdbe3db7a":"2eIWS","d703bcb62fcda216":"eeq2u","157674bad2772c6d":"gMnps","a09e060b9cae3c6c":"BZXPW"}],"eeq2u":[function(require,module,exports,__globalThis) {
'use strict';
var internalObjectKeys = require("6d8591e17a49376c");
var enumBugKeys = require("2c933f93dd98f385");
var hiddenKeys = enumBugKeys.concat('length', 'prototype');
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return internalObjectKeys(O, hiddenKeys);
};

},{"6d8591e17a49376c":"2kRxv","2c933f93dd98f385":"428gw"}],"2kRxv":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("363ee0e6bb4f46a7");
var hasOwn = require("3183fe0b0bf6f6ac");
var toIndexedObject = require("28192ac12e934672");
var indexOf = require("a5f9c5d8e993ccd6").indexOf;
var hiddenKeys = require("57775908f1581bc6");
var push = uncurryThis([].push);
module.exports = function(object, names) {
    var O = toIndexedObject(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if (hasOwn(O, key = names[i++])) ~indexOf(result, key) || push(result, key);
    return result;
};

},{"363ee0e6bb4f46a7":"2eIWS","3183fe0b0bf6f6ac":"23l8D","28192ac12e934672":"hOZCp","a5f9c5d8e993ccd6":"4rZ9c","57775908f1581bc6":"g2juy"}],"4rZ9c":[function(require,module,exports,__globalThis) {
'use strict';
var toIndexedObject = require("d5dcbcd68ac5acd0");
var toAbsoluteIndex = require("212b13aecfa48226");
var lengthOfArrayLike = require("e5a8b3e1da4c5637");
// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = toIndexedObject($this);
        var length = lengthOfArrayLike(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
module.exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: createMethod(false)
};

},{"d5dcbcd68ac5acd0":"hOZCp","212b13aecfa48226":"iChuk","e5a8b3e1da4c5637":"1iqfp"}],"iChuk":[function(require,module,exports,__globalThis) {
'use strict';
var toIntegerOrInfinity = require("72fe0a53ad43912c");
var max = Math.max;
var min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function(index, length) {
    var integer = toIntegerOrInfinity(index);
    return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

},{"72fe0a53ad43912c":"03zUT"}],"428gw":[function(require,module,exports,__globalThis) {
'use strict';
// IE8- don't enum bug keys
module.exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];

},{}],"gMnps":[function(require,module,exports,__globalThis) {
'use strict';
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;

},{}],"iGQvM":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("10299561ea0c7870");
var isCallable = require("8b1ecdaf59f07210");
var replacement = /#|\.prototype\./;
var isForced = function(feature, detection) {
    var value = data[normalize(feature)];
    return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
};
var normalize = isForced.normalize = function(string) {
    return String(string).replace(replacement, '.').toLowerCase();
};
var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';
module.exports = isForced;

},{"10299561ea0c7870":"5EMIZ","8b1ecdaf59f07210":"5VYzL"}],"aEMkj":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("272fde501e24d305");
var fails = require("48c528ae508d02e");
var uncurryThis = require("7e7198f2f1540a47");
var toString = require("dd517d0a64474028");
var trim = require("b0ec8b6ceac29d85").trim;
var whitespaces = require("5252068313c033be");
var $parseInt = globalThis.parseInt;
var Symbol = globalThis.Symbol;
var ITERATOR = Symbol && Symbol.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis(hex.exec);
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22 || ITERATOR && !fails(function() {
    $parseInt(Object(ITERATOR));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
    var S = trim(toString(string));
    return $parseInt(S, radix >>> 0 || (exec(hex, S) ? 16 : 10));
} : $parseInt;

},{"272fde501e24d305":"f9rMX","48c528ae508d02e":"5EMIZ","7e7198f2f1540a47":"2eIWS","dd517d0a64474028":"5KK1q","b0ec8b6ceac29d85":"4RZUn","5252068313c033be":"fbTKU"}],"5KK1q":[function(require,module,exports,__globalThis) {
'use strict';
var classof = require("3e4265f3f6994add");
var $String = String;
module.exports = function(argument) {
    if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
    return $String(argument);
};

},{"3e4265f3f6994add":"dhWw4"}],"4RZUn":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("17f5a3ff1a1c6ce6");
var requireObjectCoercible = require("56083d5e0450dab9");
var toString = require("3c5616504c7d56e9");
var whitespaces = require("eacd32ca91d3c555");
var replace = uncurryThis(''.replace);
var ltrim = RegExp('^[' + whitespaces + ']+');
var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function(TYPE) {
    return function($this) {
        var string = toString(requireObjectCoercible($this));
        if (TYPE & 1) string = replace(string, ltrim, '');
        if (TYPE & 2) string = replace(string, rtrim, '$1');
        return string;
    };
};
module.exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: createMethod(3)
};

},{"17f5a3ff1a1c6ce6":"2eIWS","56083d5e0450dab9":"eSVZv","3c5616504c7d56e9":"5KK1q","eacd32ca91d3c555":"fbTKU"}],"fbTKU":[function(require,module,exports,__globalThis) {
'use strict';
// a string of all valid unicode whitespaces
module.exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";

},{}],"cvOlS":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("9e39c36176ea9027");
var assign = require("eca15ea3e03a62cf");
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({
    target: 'Object',
    stat: true,
    arity: 2,
    forced: Object.assign !== assign
}, {
    assign: assign
});

},{"9e39c36176ea9027":"kc6W7","eca15ea3e03a62cf":"jUfFN"}],"jUfFN":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("6bef1f1b71c0d15f");
var uncurryThis = require("d01fdbe6acf1dc69");
var call = require("152344c6f1cc0727");
var fails = require("e500b6660dae4ed2");
var objectKeys = require("a51f09aa538cbbc9");
var getOwnPropertySymbolsModule = require("1e00e3b82b1b3cb6");
var propertyIsEnumerableModule = require("df8aa13044dccc97");
var toObject = require("fb90ba2f91e5c029");
var IndexedObject = require("33842bab271c4900");
// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function() {
    // should have correct order of operations (Edge bug)
    if (DESCRIPTORS && $assign({
        b: 1
    }, $assign(defineProperty({}, 'a', {
        enumerable: true,
        get: function() {
            defineProperty(this, 'b', {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol('assign detection');
    var alphabet = 'abcdefghijklmnopqrst';
    A[symbol] = 7;
    // eslint-disable-next-line es/no-array-prototype-foreach -- safe
    alphabet.split('').forEach(function(chr) {
        B[chr] = chr;
    });
    return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) {
    var T = toObject(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    var propertyIsEnumerable = propertyIsEnumerableModule.f;
    while(argumentsLength > index){
        var S = IndexedObject(arguments[index++]);
        var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $assign;

},{"6bef1f1b71c0d15f":"6VYiA","d01fdbe6acf1dc69":"2eIWS","152344c6f1cc0727":"2uUEG","e500b6660dae4ed2":"5EMIZ","a51f09aa538cbbc9":"jgJsv","1e00e3b82b1b3cb6":"gMnps","df8aa13044dccc97":"9xvNr","fb90ba2f91e5c029":"4wIgP","33842bab271c4900":"fSmQq"}],"jgJsv":[function(require,module,exports,__globalThis) {
'use strict';
var internalObjectKeys = require("fb982c683f43ec98");
var enumBugKeys = require("7cabc30df1982d48");
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
    return internalObjectKeys(O, enumBugKeys);
};

},{"fb982c683f43ec98":"2kRxv","7cabc30df1982d48":"428gw"}],"1cjIl":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("a465bc55e057d26f");
var $filter = require("fa9926c68c33923f").filter;
var arrayMethodHasSpeciesSupport = require("9232c94be2f9c639");
var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({
    target: 'Array',
    proto: true,
    forced: !HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});

},{"a465bc55e057d26f":"kc6W7","fa9926c68c33923f":"2Wpao","9232c94be2f9c639":"e7ARc"}],"e7ARc":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("bbe4de7ca7a1c6be");
var wellKnownSymbol = require("6cb3e4ca309911dc");
var V8_VERSION = require("4d1dd9e6baf7a81f");
var SPECIES = wellKnownSymbol('species');
module.exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return V8_VERSION >= 51 || !fails(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};

},{"bbe4de7ca7a1c6be":"5EMIZ","6cb3e4ca309911dc":"iPmWx","4d1dd9e6baf7a81f":"42zsN"}],"iTs2y":[function(require,module,exports,__globalThis) {
'use strict';
var toIndexedObject = require("c8e067881939a0cb");
var addToUnscopables = require("275b8f0cb65b77aa");
var Iterators = require("21f4d3653c90f049");
var InternalStateModule = require("85efa8d5848315f6");
var defineProperty = require("94a17682acfdceb4").f;
var defineIterator = require("bb30bdef31147b17");
var createIterResultObject = require("d8384af5151f994c");
var IS_PURE = require("fdcc207797f592fe");
var DESCRIPTORS = require("11e42ff2bbda8d0a");
var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function(iterated, kind) {
    setInternalState(this, {
        type: ARRAY_ITERATOR,
        target: toIndexedObject(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return createIterResultObject(undefined, true);
    }
    switch(state.kind){
        case 'keys':
            return createIterResultObject(index, false);
        case 'values':
            return createIterResultObject(target[index], false);
    }
    return createIterResultObject([
        index,
        target[index]
    ], false);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');
// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
    defineProperty(values, 'name', {
        value: 'values'
    });
} catch (error) {}

},{"c8e067881939a0cb":"hOZCp","275b8f0cb65b77aa":"kivs3","21f4d3653c90f049":"lbB4u","85efa8d5848315f6":"7SPub","94a17682acfdceb4":"3CoVw","bb30bdef31147b17":"cKeOa","d8384af5151f994c":"iVmDD","fdcc207797f592fe":"ewUJV","11e42ff2bbda8d0a":"6VYiA"}],"kivs3":[function(require,module,exports,__globalThis) {
'use strict';
var wellKnownSymbol = require("d4032cdcc50314e7");
var create = require("3ca2a6909ac2dcef");
var defineProperty = require("545ab457bf71d338").f;
var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
});
// add a key to Array.prototype[@@unscopables]
module.exports = function(key) {
    ArrayPrototype[UNSCOPABLES][key] = true;
};

},{"d4032cdcc50314e7":"iPmWx","3ca2a6909ac2dcef":"dEwVH","545ab457bf71d338":"3CoVw"}],"dEwVH":[function(require,module,exports,__globalThis) {
'use strict';
/* global ActiveXObject -- old IE, WSH */ var anObject = require("3bbe31d8f504111f");
var definePropertiesModule = require("a9712f03fc468b49");
var enumBugKeys = require("d9e0c389f84efa79");
var hiddenKeys = require("8a43b6a211717cde");
var html = require("78d31e3a50d79c6e");
var documentCreateElement = require("e29f7e32a0583f3");
var sharedKey = require("a6edaba97f293fc9");
var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');
var EmptyConstructor = function() {};
var scriptTag = function(content) {
    return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write(scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    // eslint-disable-next-line no-useless-assignment -- avoid memory leak
    activeXDocument = null;
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = documentCreateElement('iframe');
    var JS = 'java' + SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function() {
    try {
        activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
     : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
    var length = enumBugKeys.length;
    while(length--)delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
    return NullProtoObject();
};
hiddenKeys[IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        EmptyConstructor[PROTOTYPE] = anObject(O);
        result = new EmptyConstructor();
        EmptyConstructor[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO] = O;
    } else result = NullProtoObject();
    return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

},{"3bbe31d8f504111f":"BZXPW","a9712f03fc468b49":"dzh3g","d9e0c389f84efa79":"428gw","8a43b6a211717cde":"g2juy","78d31e3a50d79c6e":"lfyqS","e29f7e32a0583f3":"7v5iJ","a6edaba97f293fc9":"eJkH1"}],"dzh3g":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("aa39c539d0a1ec3f");
var V8_PROTOTYPE_DEFINE_BUG = require("2e9118dcee7eb93e");
var definePropertyModule = require("d88f5f00164c2da2");
var anObject = require("12ac356c5e06e57d");
var toIndexedObject = require("3cbdc44082c2f8b8");
var objectKeys = require("634da70e74fce29b");
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject(O);
    var props = toIndexedObject(Properties);
    var keys = objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)definePropertyModule.f(O, key = keys[index++], props[key]);
    return O;
};

},{"aa39c539d0a1ec3f":"6VYiA","2e9118dcee7eb93e":"gMbWP","d88f5f00164c2da2":"3CoVw","12ac356c5e06e57d":"BZXPW","3cbdc44082c2f8b8":"hOZCp","634da70e74fce29b":"jgJsv"}],"lfyqS":[function(require,module,exports,__globalThis) {
'use strict';
var getBuiltIn = require("14cb391fa4a0dda8");
module.exports = getBuiltIn('document', 'documentElement');

},{"14cb391fa4a0dda8":"6vKyV"}],"lbB4u":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = {};

},{}],"cKeOa":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("923c1bf4a39ae90c");
var call = require("46a3f73465955199");
var IS_PURE = require("c1577e63189cf935");
var FunctionName = require("dc625e1bb584faf6");
var isCallable = require("d55d91c410baca17");
var createIteratorConstructor = require("3e4ae607dbb6e78b");
var getPrototypeOf = require("48ca4ae1d4998232");
var setPrototypeOf = require("1263258b63630933");
var setToStringTag = require("9b61caf69f87dfde");
var createNonEnumerableProperty = require("7f30a3ab1bf5e1c1");
var defineBuiltIn = require("c027b4da648348d3");
var wellKnownSymbol = require("d4ad91965213ee1");
var Iterators = require("b616a206eb405268");
var IteratorsCore = require("4f9ec7e9f5d20965");
var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';
var returnThis = function() {
    return this;
};
module.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
                if (setPrototypeOf) setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
                else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
            }
            // Set @@toStringTag to native iterators
            setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
        if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return call(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod(VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
            entries: getIterationMethod(ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
        } else $({
            target: NAME,
            proto: true,
            forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    Iterators[NAME] = defaultIterator;
    return methods;
};

},{"923c1bf4a39ae90c":"kc6W7","46a3f73465955199":"2uUEG","c1577e63189cf935":"ewUJV","dc625e1bb584faf6":"iqmDO","d55d91c410baca17":"5VYzL","3e4ae607dbb6e78b":"3Jqzg","48ca4ae1d4998232":"jnRJs","1263258b63630933":"aYEPL","9b61caf69f87dfde":"ktjuM","7f30a3ab1bf5e1c1":"dsQvz","c027b4da648348d3":"baZWN","d4ad91965213ee1":"iPmWx","b616a206eb405268":"lbB4u","4f9ec7e9f5d20965":"dVhMO"}],"3Jqzg":[function(require,module,exports,__globalThis) {
'use strict';
var IteratorPrototype = require("6d3197d79123a33d").IteratorPrototype;
var create = require("f19338a88747fb05");
var createPropertyDescriptor = require("cc176dfbf6ea0553");
var setToStringTag = require("bc433e6ab6880430");
var Iterators = require("2f833e0e1738e7e0");
var returnThis = function() {
    return this;
};
module.exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = create(IteratorPrototype, {
        next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next)
    });
    setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
    Iterators[TO_STRING_TAG] = returnThis;
    return IteratorConstructor;
};

},{"6d3197d79123a33d":"dVhMO","f19338a88747fb05":"dEwVH","cc176dfbf6ea0553":"jKXht","bc433e6ab6880430":"ktjuM","2f833e0e1738e7e0":"lbB4u"}],"dVhMO":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("cdb9dcd93b52b3fc");
var isCallable = require("db955145706fc55a");
var isObject = require("83e5df3d56e8834f");
var create = require("45d6f1a3c372cdf6");
var getPrototypeOf = require("a97459767d74fdc3");
var defineBuiltIn = require("3bdf78f362001d7c");
var wellKnownSymbol = require("d3901e60df7842c9");
var IS_PURE = require("e736fd193ddc96e5");
var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
    else {
        PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
        if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
    }
}
var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function() {
    var test = {};
    // FF44- legacy iterators case
    return IteratorPrototype[ITERATOR].call(test) !== test;
});
if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) defineBuiltIn(IteratorPrototype, ITERATOR, function() {
    return this;
});
module.exports = {
    IteratorPrototype: IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

},{"cdb9dcd93b52b3fc":"5EMIZ","db955145706fc55a":"5VYzL","83e5df3d56e8834f":"9mXeP","45d6f1a3c372cdf6":"dEwVH","a97459767d74fdc3":"jnRJs","3bdf78f362001d7c":"baZWN","d3901e60df7842c9":"iPmWx","e736fd193ddc96e5":"ewUJV"}],"jnRJs":[function(require,module,exports,__globalThis) {
'use strict';
var hasOwn = require("da54a59ea207dd");
var isCallable = require("71ab2a7bcc8c8fc8");
var toObject = require("7a3afd2bb40b0292");
var sharedKey = require("296d7a2db8e23969");
var CORRECT_PROTOTYPE_GETTER = require("58de29d5e883862f");
var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function(O) {
    var object = toObject(O);
    if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
    var constructor = object.constructor;
    if (isCallable(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $Object ? ObjectPrototype : null;
};

},{"da54a59ea207dd":"23l8D","71ab2a7bcc8c8fc8":"5VYzL","7a3afd2bb40b0292":"4wIgP","296d7a2db8e23969":"eJkH1","58de29d5e883862f":"iWz4w"}],"iWz4w":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("85ffc28af2e8afc1");
module.exports = !fails(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});

},{"85ffc28af2e8afc1":"5EMIZ"}],"ktjuM":[function(require,module,exports,__globalThis) {
'use strict';
var defineProperty = require("93a3d85da48077c").f;
var hasOwn = require("2ebf7179e87d878f");
var wellKnownSymbol = require("5b1eb5d1639e9eb7");
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
module.exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !hasOwn(target, TO_STRING_TAG)) defineProperty(target, TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};

},{"93a3d85da48077c":"3CoVw","2ebf7179e87d878f":"23l8D","5b1eb5d1639e9eb7":"iPmWx"}],"aYEPL":[function(require,module,exports,__globalThis) {
'use strict';
/* eslint-disable no-proto -- safe */ var uncurryThisAccessor = require("995a94425a563d6");
var isObject = require("caa27fe2635f1f44");
var requireObjectCoercible = require("a751660a0fcdf70");
var aPossiblePrototype = require("6e2c833ee2a62cf6");
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        requireObjectCoercible(O);
        aPossiblePrototype(proto);
        if (!isObject(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);

},{"995a94425a563d6":"d83Oe","caa27fe2635f1f44":"9mXeP","a751660a0fcdf70":"eSVZv","6e2c833ee2a62cf6":"eq8GK"}],"d83Oe":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("27a2d181325e1926");
var aCallable = require("36b26076b1e2fac1");
module.exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};

},{"27a2d181325e1926":"2eIWS","36b26076b1e2fac1":"gx4Kw"}],"eq8GK":[function(require,module,exports,__globalThis) {
'use strict';
var isPossiblePrototype = require("fcc5bbb526d602c6");
var $String = String;
var $TypeError = TypeError;
module.exports = function(argument) {
    if (isPossiblePrototype(argument)) return argument;
    throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};

},{"fcc5bbb526d602c6":"5IEWl"}],"5IEWl":[function(require,module,exports,__globalThis) {
'use strict';
var isObject = require("a504c97d35bacd6c");
module.exports = function(argument) {
    return isObject(argument) || argument === null;
};

},{"a504c97d35bacd6c":"9mXeP"}],"iVmDD":[function(require,module,exports,__globalThis) {
'use strict';
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};

},{}],"9ej1J":[function(require,module,exports,__globalThis) {
'use strict';
var charAt = require("e8b36e9e8f60deb1").charAt;
var toString = require("99724183e9ac759e");
var InternalStateModule = require("75c45c226da41a58");
var defineIterator = require("5bce8e62b9ff7984");
var createIterResultObject = require("cab4a14c8e102263");
var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function(iterated) {
    setInternalState(this, {
        type: STRING_ITERATOR,
        string: toString(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return createIterResultObject(undefined, true);
    point = charAt(string, index);
    state.index += point.length;
    return createIterResultObject(point, false);
});

},{"e8b36e9e8f60deb1":"44Ku7","99724183e9ac759e":"5KK1q","75c45c226da41a58":"7SPub","5bce8e62b9ff7984":"cKeOa","cab4a14c8e102263":"iVmDD"}],"44Ku7":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("8b9beff9818f042");
var toIntegerOrInfinity = require("d3e375e7697978fb");
var toString = require("545a72c28133c459");
var requireObjectCoercible = require("5bafa9e5b372669c");
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);
var createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = toString(requireObjectCoercible($this));
        var position = toIntegerOrInfinity(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
        first = charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt(S, position) : first : CONVERT_TO_STRING ? stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
module.exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: createMethod(true)
};

},{"8b9beff9818f042":"2eIWS","d3e375e7697978fb":"03zUT","545a72c28133c459":"5KK1q","5bafa9e5b372669c":"eSVZv"}],"aSJVT":[function(require,module,exports,__globalThis) {
'use strict';
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require("a8c1e25017437d");

},{"a8c1e25017437d":"doJEp"}],"doJEp":[function(require,module,exports,__globalThis) {
'use strict';
var FREEZING = require("4e60997043599c68");
var globalThis = require("5341adea83e89c0c");
var uncurryThis = require("182f989a492de7c6");
var defineBuiltIns = require("b41734fbe20d8ad4");
var InternalMetadataModule = require("78ba01528267d962");
var collection = require("32fff688dc79e50c");
var collectionWeak = require("b362d8e7ff41644e");
var isObject = require("40b9e3e73f50872d");
var enforceInternalState = require("e46a6ca6b98d61d0").enforce;
var fails = require("878a9525b93f8113");
var NATIVE_WEAK_MAP = require("2163c9ee83b27dfc");
var $Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = $Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var isFrozen = $Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var isSealed = $Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var freeze = $Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var seal = $Object.seal;
var IS_IE11 = !globalThis.ActiveXObject && 'ActiveXObject' in globalThis;
var InternalWeakMap;
var wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = collection('WeakMap', wrapper, collectionWeak);
var WeakMapPrototype = $WeakMap.prototype;
var nativeSet = uncurryThis(WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var hasMSEdgeFreezingBug = function() {
    return FREEZING && fails(function() {
        var frozenArray = freeze([]);
        nativeSet(new $WeakMap(), frozenArray, 1);
        return !isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP) {
    if (IS_IE11) {
        InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
        InternalMetadataModule.enable();
        var nativeDelete = uncurryThis(WeakMapPrototype['delete']);
        var nativeHas = uncurryThis(WeakMapPrototype.has);
        var nativeGet = uncurryThis(WeakMapPrototype.get);
        defineBuiltIns(WeakMapPrototype, {
            'delete': function(key) {
                if (isObject(key) && !isExtensible(key)) {
                    var state = enforceInternalState(this);
                    if (!state.frozen) state.frozen = new InternalWeakMap();
                    return nativeDelete(this, key) || state.frozen['delete'](key);
                }
                return nativeDelete(this, key);
            },
            has: function has(key) {
                if (isObject(key) && !isExtensible(key)) {
                    var state = enforceInternalState(this);
                    if (!state.frozen) state.frozen = new InternalWeakMap();
                    return nativeHas(this, key) || state.frozen.has(key);
                }
                return nativeHas(this, key);
            },
            get: function get(key) {
                if (isObject(key) && !isExtensible(key)) {
                    var state = enforceInternalState(this);
                    if (!state.frozen) state.frozen = new InternalWeakMap();
                    return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
                }
                return nativeGet(this, key);
            },
            set: function set(key, value) {
                if (isObject(key) && !isExtensible(key)) {
                    var state = enforceInternalState(this);
                    if (!state.frozen) state.frozen = new InternalWeakMap();
                    nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
                } else nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if (hasMSEdgeFreezingBug()) defineBuiltIns(WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if (isArray(key)) {
                if (isFrozen(key)) arrayIntegrityLevel = freeze;
                else if (isSealed(key)) arrayIntegrityLevel = seal;
            }
            nativeSet(this, key, value);
            if (arrayIntegrityLevel) arrayIntegrityLevel(key);
            return this;
        }
    });
}

},{"4e60997043599c68":"ha0Wo","5341adea83e89c0c":"f9rMX","182f989a492de7c6":"2eIWS","b41734fbe20d8ad4":"SD772","78ba01528267d962":"39BQW","32fff688dc79e50c":"9l7Il","b362d8e7ff41644e":"is1FE","40b9e3e73f50872d":"9mXeP","e46a6ca6b98d61d0":"7SPub","878a9525b93f8113":"5EMIZ","2163c9ee83b27dfc":"dhJro"}],"ha0Wo":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("388690d33020cebb");
module.exports = !fails(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});

},{"388690d33020cebb":"5EMIZ"}],"SD772":[function(require,module,exports,__globalThis) {
'use strict';
var defineBuiltIn = require("e34e683e23dcb4bb");
module.exports = function(target, src, options) {
    for(var key in src)defineBuiltIn(target, key, src[key], options);
    return target;
};

},{"e34e683e23dcb4bb":"baZWN"}],"39BQW":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("3242fc68c548334b");
var uncurryThis = require("d7dc323978454584");
var hiddenKeys = require("33c7a5cefcfa8a48");
var isObject = require("949cc173e657f4a8");
var hasOwn = require("e6764a7848fbe604");
var defineProperty = require("77d05ce7ff38a94f").f;
var getOwnPropertyNamesModule = require("491415e519a00a7c");
var getOwnPropertyNamesExternalModule = require("1a3edc3a1e92ccaf");
var isExtensible = require("1f8f4e666c381f6");
var uid = require("2f09fd9212a3372e");
var FREEZING = require("858ced62f45384ee");
var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;
var setMetadata = function(it) {
    defineProperty(it, METADATA, {
        value: {
            objectID: 'O' + id++,
            weakData: {} // weak collections IDs
        }
    });
};
var fastKey = function(it, create) {
    // return a primitive with prefix
    if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!hasOwn(it, METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        setMetadata(it);
    // return object ID
    }
    return it[METADATA].objectID;
};
var getWeakData = function(it, create) {
    if (!hasOwn(it, METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[METADATA].weakData;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it) {
    if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
    return it;
};
var enable = function() {
    meta.enable = function() {};
    REQUIRED = true;
    var getOwnPropertyNames = getOwnPropertyNamesModule.f;
    var splice = uncurryThis([].splice);
    var test = {};
    // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
    test[METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        getOwnPropertyNamesModule.f = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $({
            target: 'Object',
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
        });
    }
};
var meta = module.exports = {
    enable: enable,
    fastKey: fastKey,
    getWeakData: getWeakData,
    onFreeze: onFreeze
};
hiddenKeys[METADATA] = true;

},{"3242fc68c548334b":"kc6W7","d7dc323978454584":"2eIWS","33c7a5cefcfa8a48":"g2juy","949cc173e657f4a8":"9mXeP","e6764a7848fbe604":"23l8D","77d05ce7ff38a94f":"3CoVw","491415e519a00a7c":"eeq2u","1a3edc3a1e92ccaf":"9XdR2","1f8f4e666c381f6":"6bmBi","2f09fd9212a3372e":"7KkeL","858ced62f45384ee":"ha0Wo"}],"9XdR2":[function(require,module,exports,__globalThis) {
'use strict';
/* eslint-disable es/no-object-getownpropertynames -- safe */ var classof = require("279dbc8649868a7a");
var toIndexedObject = require("430d7ab8977dd85e");
var $getOwnPropertyNames = require("a5a6278a4291e239").f;
var arraySlice = require("a0e199be640bf61f");
var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var getWindowNames = function(it) {
    try {
        return $getOwnPropertyNames(it);
    } catch (error) {
        return arraySlice(windowNames);
    }
};
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
    return windowNames && classof(it) === 'Window' ? getWindowNames(it) : $getOwnPropertyNames(toIndexedObject(it));
};

},{"279dbc8649868a7a":"60dWh","430d7ab8977dd85e":"hOZCp","a5a6278a4291e239":"eeq2u","a0e199be640bf61f":"evWJw"}],"evWJw":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("5250b5c9324ccbe");
module.exports = uncurryThis([].slice);

},{"5250b5c9324ccbe":"2eIWS"}],"6bmBi":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("de1e0227a248bfd3");
var isObject = require("68a5b2cef468256c");
var classof = require("cb8542af391c6b0e");
var ARRAY_BUFFER_NON_EXTENSIBLE = require("79d81d484af31adc");
// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function() {
    $isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE ? function isExtensible(it) {
    if (!isObject(it)) return false;
    if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === 'ArrayBuffer') return false;
    return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;

},{"de1e0227a248bfd3":"5EMIZ","68a5b2cef468256c":"9mXeP","cb8542af391c6b0e":"60dWh","79d81d484af31adc":"iWuoO"}],"iWuoO":[function(require,module,exports,__globalThis) {
'use strict';
// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails = require("5bca09ebe0e39932");
module.exports = fails(function() {
    if (typeof ArrayBuffer == 'function') {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', {
            value: 8
        });
    }
});

},{"5bca09ebe0e39932":"5EMIZ"}],"9l7Il":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("7f7d2ffaf036b70c");
var globalThis = require("23fed902470e3d4c");
var uncurryThis = require("58d7b96f0152237");
var isForced = require("30876c2e1f5df872");
var defineBuiltIn = require("b827fda460342f0d");
var InternalMetadataModule = require("6163d338080ca134");
var iterate = require("f05c3889843e7603");
var anInstance = require("38cbb680894f59a3");
var isCallable = require("799d274b4fe226e7");
var isNullOrUndefined = require("36192c2af1f673a1");
var isObject = require("9e3db26fb26723ec");
var fails = require("f5cb548db0e3391e");
var checkCorrectnessOfIteration = require("80e8f5144d6954d9");
var setToStringTag = require("4fbd135f98af11c4");
var inheritIfRequired = require("585a6aeda8432eb3");
module.exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
    var ADDER = IS_MAP ? 'set' : 'add';
    var NativeConstructor = globalThis[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function(KEY) {
        var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
        defineBuiltIn(NativePrototype, KEY, KEY === 'add' ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY === 'delete' ? function(key) {
            return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === 'get' ? function get(key) {
            return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === 'has' ? function has(key) {
            return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = isForced(CONSTRUCTOR_NAME, !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        InternalMetadataModule.enable();
    } else if (isForced(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = fails(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && fails(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                anInstance(dummy, NativePrototype);
                var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
                if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod('delete');
            fixMethod('has');
            IS_MAP && fixMethod('get');
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $({
        global: true,
        constructor: true,
        forced: Constructor !== NativeConstructor
    }, exported);
    setToStringTag(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};

},{"7f7d2ffaf036b70c":"kc6W7","23fed902470e3d4c":"f9rMX","58d7b96f0152237":"2eIWS","30876c2e1f5df872":"iGQvM","b827fda460342f0d":"baZWN","6163d338080ca134":"39BQW","f05c3889843e7603":"gEv5v","38cbb680894f59a3":"6GhkP","799d274b4fe226e7":"5VYzL","36192c2af1f673a1":"6MFHG","9e3db26fb26723ec":"9mXeP","f5cb548db0e3391e":"5EMIZ","80e8f5144d6954d9":"5s74I","4fbd135f98af11c4":"ktjuM","585a6aeda8432eb3":"35HNx"}],"gEv5v":[function(require,module,exports,__globalThis) {
'use strict';
var bind = require("2f267ed50e670495");
var call = require("c0af58bb1ef1cc62");
var anObject = require("7fa6542c03ca9239");
var tryToString = require("fa596d1a4c07b72a");
var isArrayIteratorMethod = require("fd753cc641a6f10a");
var lengthOfArrayLike = require("2a15dee148d3db96");
var isPrototypeOf = require("417f9a13deeb58a6");
var getIterator = require("43af53be1b24dae5");
var getIteratorMethod = require("bf7ad32b21aed0b4");
var iteratorClose = require("5241389e1d6eeb73");
var $TypeError = TypeError;
var Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var ResultPrototype = Result.prototype;
module.exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = bind(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        var $iterator = iterator;
        iterator = undefined;
        if ($iterator) iteratorClose($iterator, 'normal');
        return new Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            anObject(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = getIteratorMethod(iterable);
        if (!iterFn) throw new $TypeError(tryToString(iterable) + ' is not iterable');
        // optimisation for array iterators
        if (isArrayIteratorMethod(iterFn)) {
            for(index = 0, length = lengthOfArrayLike(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && isPrototypeOf(ResultPrototype, result)) return result;
            }
            return new Result(false);
        }
        iterator = getIterator(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = call(next, iterator)).done){
        // `IteratorValue` errors should propagate without closing the iterator
        var value = step.value;
        try {
            result = callFn(value);
        } catch (error) {
            if (iterator) iteratorClose(iterator, 'throw', error);
            else throw error;
        }
        if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
    }
    return new Result(false);
};

},{"2f267ed50e670495":"cjIPc","c0af58bb1ef1cc62":"2uUEG","7fa6542c03ca9239":"BZXPW","fa596d1a4c07b72a":"konra","fd753cc641a6f10a":"eiAIW","2a15dee148d3db96":"1iqfp","417f9a13deeb58a6":"dduyg","43af53be1b24dae5":"kebD6","bf7ad32b21aed0b4":"9QRt3","5241389e1d6eeb73":"fyPk9"}],"eiAIW":[function(require,module,exports,__globalThis) {
'use strict';
var wellKnownSymbol = require("85b004b6ab4bc5da");
var Iterators = require("6de391ad2976ca02");
var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;
// check on default Array iterator
module.exports = function(it) {
    return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};

},{"85b004b6ab4bc5da":"iPmWx","6de391ad2976ca02":"lbB4u"}],"kebD6":[function(require,module,exports,__globalThis) {
'use strict';
var call = require("132ebf774107ae29");
var aCallable = require("e248489b4825ceb7");
var anObject = require("18a343d2ef625577");
var tryToString = require("7e576a1564cef99e");
var getIteratorMethod = require("4a7b0311be0471b2");
var $TypeError = TypeError;
module.exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
    if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
    throw new $TypeError(tryToString(argument) + ' is not iterable');
};

},{"132ebf774107ae29":"2uUEG","e248489b4825ceb7":"gx4Kw","18a343d2ef625577":"BZXPW","7e576a1564cef99e":"konra","4a7b0311be0471b2":"9QRt3"}],"9QRt3":[function(require,module,exports,__globalThis) {
'use strict';
var classof = require("32d61dafd81dde78");
var getMethod = require("84e24a6ac7559d3a");
var isNullOrUndefined = require("f0707282c0d93eeb");
var Iterators = require("1c181d5c49efd5d1");
var wellKnownSymbol = require("d10d0e0ae49498c5");
var ITERATOR = wellKnownSymbol('iterator');
module.exports = function(it) {
    if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR) || getMethod(it, '@@iterator') || Iterators[classof(it)];
};

},{"32d61dafd81dde78":"dhWw4","84e24a6ac7559d3a":"2Kir9","f0707282c0d93eeb":"6MFHG","1c181d5c49efd5d1":"lbB4u","d10d0e0ae49498c5":"iPmWx"}],"fyPk9":[function(require,module,exports,__globalThis) {
'use strict';
var call = require("a4a3a7d4a45c4219");
var anObject = require("feb876e7da2df7bd");
var getMethod = require("2e660cdfabd9c61f");
module.exports = function(iterator, kind, value) {
    var innerResult, innerError;
    anObject(iterator);
    try {
        innerResult = getMethod(iterator, 'return');
        if (!innerResult) {
            if (kind === 'throw') throw value;
            return value;
        }
        innerResult = call(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    anObject(innerResult);
    return value;
};

},{"a4a3a7d4a45c4219":"2uUEG","feb876e7da2df7bd":"BZXPW","2e660cdfabd9c61f":"2Kir9"}],"6GhkP":[function(require,module,exports,__globalThis) {
'use strict';
var isPrototypeOf = require("55f8840091c5bf21");
var $TypeError = TypeError;
module.exports = function(it, Prototype) {
    if (isPrototypeOf(Prototype, it)) return it;
    throw new $TypeError('Incorrect invocation');
};

},{"55f8840091c5bf21":"dduyg"}],"5s74I":[function(require,module,exports,__globalThis) {
'use strict';
var wellKnownSymbol = require("a5154de5c7fcf21e");
var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;
try {
    var called = 0;
    var iteratorWithReturn = {
        next: function() {
            return {
                done: !!called++
            };
        },
        'return': function() {
            SAFE_CLOSING = true;
        }
    };
    // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
    iteratorWithReturn[ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from(iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
module.exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
        object[ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};

},{"a5154de5c7fcf21e":"iPmWx"}],"35HNx":[function(require,module,exports,__globalThis) {
'use strict';
var isCallable = require("9f474ed504af79a9");
var isObject = require("bd2a6951ff768696");
var setPrototypeOf = require("972057e738a2788f");
// makes subclassing work correct for wrapped built-ins
module.exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    setPrototypeOf && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) setPrototypeOf($this, NewTargetPrototype);
    return $this;
};

},{"9f474ed504af79a9":"5VYzL","bd2a6951ff768696":"9mXeP","972057e738a2788f":"aYEPL"}],"is1FE":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("1805cb6220d706e7");
var defineBuiltIns = require("5263c73c3566f1ef");
var getWeakData = require("9764e89aab31dc9a").getWeakData;
var anInstance = require("e632c1106cb00cea");
var anObject = require("602fe1299f06e16c");
var isNullOrUndefined = require("bfb5a8bfdc9265b1");
var isObject = require("211f42379f0813a");
var iterate = require("830bf4bd7bf8261c");
var ArrayIterationModule = require("ffaf20b85e78d82f");
var hasOwn = require("cef0026b9b05e2");
var InternalStateModule = require("96b7fea7b9fcfa28");
var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var splice = uncurryThis([].splice);
var id = 0;
// fallback for uncaught frozen keys
var uncaughtFrozenStore = function(state) {
    return state.frozen || (state.frozen = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function() {
    this.entries = [];
};
var findUncaughtFrozen = function(store, key) {
    return find(store.entries, function(it) {
        return it[0] === key;
    });
};
UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    'delete': function(key) {
        var index = findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) splice(this.entries, index, 1);
        return !!~index;
    }
};
module.exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            anInstance(that, Prototype);
            setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: id++,
                frozen: null
            });
            if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = getWeakData(anObject(key), true);
            if (data === true) uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        defineBuiltIns(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            'delete': function(key) {
                var state = getInternalState(this);
                if (!isObject(key)) return false;
                var data = getWeakData(key);
                if (data === true) return uncaughtFrozenStore(state)['delete'](key);
                return data && hasOwn(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!isObject(key)) return false;
                var data = getWeakData(key);
                if (data === true) return uncaughtFrozenStore(state).has(key);
                return data && hasOwn(data, state.id);
            }
        });
        defineBuiltIns(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if (isObject(key)) {
                    var data = getWeakData(key);
                    if (data === true) return uncaughtFrozenStore(state).get(key);
                    if (data) return data[state.id];
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};

},{"1805cb6220d706e7":"2eIWS","5263c73c3566f1ef":"SD772","9764e89aab31dc9a":"39BQW","e632c1106cb00cea":"6GhkP","602fe1299f06e16c":"BZXPW","bfb5a8bfdc9265b1":"6MFHG","211f42379f0813a":"9mXeP","830bf4bd7bf8261c":"gEv5v","ffaf20b85e78d82f":"2Wpao","cef0026b9b05e2":"23l8D","96b7fea7b9fcfa28":"7SPub"}],"cZvdG":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("c051336c9ece485c");
var DOMIterables = require("b1dd6223fec045b2");
var DOMTokenListPrototype = require("2927608065790e8a");
var ArrayIteratorMethods = require("107ef5eaf95c92b0");
var createNonEnumerableProperty = require("2f02b421bbdb9eb4");
var setToStringTag = require("46e3db6eb678f758");
var wellKnownSymbol = require("6a4d2091548e6557");
var ITERATOR = wellKnownSymbol('iterator');
var ArrayValues = ArrayIteratorMethods.values;
var handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
            createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
        } catch (error) {
            CollectionPrototype[ITERATOR] = ArrayValues;
        }
        setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
        if (DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in ArrayIteratorMethods){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
                createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
            }
        }
    }
};
for(var COLLECTION_NAME in DOMIterables)handlePrototype(globalThis[COLLECTION_NAME] && globalThis[COLLECTION_NAME].prototype, COLLECTION_NAME);
handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

},{"c051336c9ece485c":"f9rMX","b1dd6223fec045b2":"cLOuj","2927608065790e8a":"aTda8","107ef5eaf95c92b0":"iTs2y","2f02b421bbdb9eb4":"dsQvz","46e3db6eb678f758":"ktjuM","6a4d2091548e6557":"iPmWx"}],"39XSF":[function(require,module,exports,__globalThis) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var global = arguments[3];
var FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
    return root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(now());
    }
    function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == 'number') return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace(reTrim, '');
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = throttle;

},{}],"fxZki":[function(require,module,exports,__globalThis) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var global = arguments[3];
var FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
    return root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(now());
    }
    function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == 'number') return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace(reTrim, '');
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = debounce;

},{}],"1qNIh":[function(require,module,exports,__globalThis) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var global = arguments[3];
var FUNC_ERROR_TEXT = 'Expected a function';
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** `Object#toString` result references. */ var funcTag = '[object Function]', genTag = '[object GeneratorFunction]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var splice = arrayProto.splice;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map'), nativeCreate = getNative(Object, 'create');
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
module.exports = memoize;

},{}],"3Ebqt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserver", ()=>(0, _resizeObserver.ResizeObserver));
parcelHelpers.export(exports, "ResizeObserverEntry", ()=>(0, _resizeObserverEntry.ResizeObserverEntry));
parcelHelpers.export(exports, "ResizeObserverSize", ()=>(0, _resizeObserverSize.ResizeObserverSize));
var _resizeObserver = require("../ResizeObserver");
var _resizeObserverEntry = require("../ResizeObserverEntry");
var _resizeObserverSize = require("../ResizeObserverSize");

},{"../ResizeObserver":"8yk8h","../ResizeObserverEntry":"3BwCT","../ResizeObserverSize":"fLNnm","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8yk8h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserver", ()=>ResizeObserver);
var _resizeObserverController = require("./ResizeObserverController");
var _element = require("./utils/element");
var ResizeObserver = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== 'function') throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, _resizeObserverController.ResizeObserverController).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, _element.isElement)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, _resizeObserverController.ResizeObserverController).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, _element.isElement)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, _resizeObserverController.ResizeObserverController).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, _resizeObserverController.ResizeObserverController).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return 'function ResizeObserver () { [polyfill code] }';
    };
    return ResizeObserver;
}();

},{"./ResizeObserverController":"ab55r","./utils/element":"2vgKP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ab55r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserverController", ()=>ResizeObserverController);
var _scheduler = require("./utils/scheduler");
var _resizeObservation = require("./ResizeObservation");
var _resizeObserverDetail = require("./ResizeObserverDetail");
var _resizeObservers = require("./utils/resizeObservers");
var observerMap = new WeakMap();
var getObservationIndex = function(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var ResizeObserverController = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, _resizeObserverDetail.ResizeObserverDetail)(resizeObserver, callback);
        observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if (getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, _resizeObservers.resizeObservers).push(detail);
            detail.observationTargets.push(new (0, _resizeObservation.ResizeObservation)(target, options && options.box));
            (0, _scheduler.updateCount)(1);
            (0, _scheduler.scheduler).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = observerMap.get(resizeObserver);
        var index = getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, _resizeObservers.resizeObservers).splice((0, _resizeObservers.resizeObservers).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, _scheduler.updateCount)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();

},{"./utils/scheduler":"ebdja","./ResizeObservation":"9ySVb","./ResizeObserverDetail":"f34MD","./utils/resizeObservers":"eejb5","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ebdja":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduler", ()=>scheduler);
parcelHelpers.export(exports, "updateCount", ()=>updateCount);
var _process = require("./process");
var _global = require("./global");
var _queueResizeObserver = require("./queueResizeObserver");
var watching = 0;
var isWatching = function() {
    return !!watching;
};
var CATCH_PERIOD = 250;
var observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var time = function(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var scheduled = false;
var Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = CATCH_PERIOD;
        if (scheduled) return;
        scheduled = true;
        var until = time(timeout);
        (0, _queueResizeObserver.queueResizeObserver)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, _process.process)();
            } finally{
                scheduled = false;
                timeout = until - time();
                if (!isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function() {
            return _this.observer && _this.observer.observe(document.body, observerConfig);
        };
        document.body ? cb() : (0, _global.global).addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            events.forEach(function(name) {
                return (0, _global.global).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            events.forEach(function(name) {
                return (0, _global.global).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var scheduler = new Scheduler();
var updateCount = function(n) {
    !watching && n > 0 && scheduler.start();
    watching += n;
    !watching && scheduler.stop();
};

},{"./process":"9S6C7","./global":"6Qnsc","./queueResizeObserver":"kIiss","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9S6C7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "process", ()=>process);
var _hasActiveObservations = require("../algorithms/hasActiveObservations");
var _hasSkippedObservations = require("../algorithms/hasSkippedObservations");
var _deliverResizeLoopError = require("../algorithms/deliverResizeLoopError");
var _broadcastActiveObservations = require("../algorithms/broadcastActiveObservations");
var _gatherActiveObservationsAtDepth = require("../algorithms/gatherActiveObservationsAtDepth");
var process = function() {
    var depth = 0;
    (0, _gatherActiveObservationsAtDepth.gatherActiveObservationsAtDepth)(depth);
    while((0, _hasActiveObservations.hasActiveObservations)()){
        depth = (0, _broadcastActiveObservations.broadcastActiveObservations)();
        (0, _gatherActiveObservationsAtDepth.gatherActiveObservationsAtDepth)(depth);
    }
    if ((0, _hasSkippedObservations.hasSkippedObservations)()) (0, _deliverResizeLoopError.deliverResizeLoopError)();
    return depth > 0;
};

},{"../algorithms/hasActiveObservations":"eegA2","../algorithms/hasSkippedObservations":"93UDo","../algorithms/deliverResizeLoopError":"fVzL1","../algorithms/broadcastActiveObservations":"hxe4G","../algorithms/gatherActiveObservationsAtDepth":"4MKio","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"eegA2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasActiveObservations", ()=>hasActiveObservations);
var _resizeObservers = require("../utils/resizeObservers");
var hasActiveObservations = function() {
    return (0, _resizeObservers.resizeObservers).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};

},{"../utils/resizeObservers":"eejb5","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"eejb5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resizeObservers", ()=>resizeObservers);
var resizeObservers = [];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"93UDo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasSkippedObservations", ()=>hasSkippedObservations);
var _resizeObservers = require("../utils/resizeObservers");
var hasSkippedObservations = function() {
    return (0, _resizeObservers.resizeObservers).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};

},{"../utils/resizeObservers":"eejb5","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fVzL1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deliverResizeLoopError", ()=>deliverResizeLoopError);
var msg = 'ResizeObserver loop completed with undelivered notifications.';
var deliverResizeLoopError = function() {
    var event;
    if (typeof ErrorEvent === 'function') event = new ErrorEvent('error', {
        message: msg
    });
    else {
        event = document.createEvent('Event');
        event.initEvent('error', false, false);
        event.message = msg;
    }
    window.dispatchEvent(event);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hxe4G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "broadcastActiveObservations", ()=>broadcastActiveObservations);
var _resizeObservers = require("../utils/resizeObservers");
var _resizeObserverEntry = require("../ResizeObserverEntry");
var _calculateDepthForNode = require("./calculateDepthForNode");
var _calculateBoxSize = require("./calculateBoxSize");
var broadcastActiveObservations = function() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, _resizeObservers.resizeObservers).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, _resizeObserverEntry.ResizeObserverEntry)(ot.target);
            var targetDepth = (0, _calculateDepthForNode.calculateDepthForNode)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, _calculateBoxSize.calculateBoxSize)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};

},{"../utils/resizeObservers":"eejb5","../ResizeObserverEntry":"3BwCT","./calculateDepthForNode":"9YpxS","./calculateBoxSize":"1lEsn","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"3BwCT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserverEntry", ()=>ResizeObserverEntry);
var _calculateBoxSize = require("./algorithms/calculateBoxSize");
var _freeze = require("./utils/freeze");
var ResizeObserverEntry = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, _calculateBoxSize.calculateBoxSizes)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, _freeze.freeze)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, _freeze.freeze)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, _freeze.freeze)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();

},{"./algorithms/calculateBoxSize":"1lEsn","./utils/freeze":"8Xk3z","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"1lEsn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateBoxSize", ()=>calculateBoxSize);
parcelHelpers.export(exports, "calculateBoxSizes", ()=>calculateBoxSizes);
var _resizeObserverBoxOptions = require("../ResizeObserverBoxOptions");
var _resizeObserverSize = require("../ResizeObserverSize");
var _domrectReadOnly = require("../DOMRectReadOnly");
var _element = require("../utils/element");
var _freeze = require("../utils/freeze");
var _global = require("../utils/global");
var cache = new WeakMap();
var scrollRegexp = /auto|scroll/;
var verticalRegexp = /^tb|vertical/;
var IE = /msie|trident/i.test((0, _global.global).navigator && (0, _global.global).navigator.userAgent);
var parseDimension = function(pixel) {
    return parseFloat(pixel || '0');
};
var size = function(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, _resizeObserverSize.ResizeObserverSize)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var zeroBoxes = (0, _freeze.freeze)({
    devicePixelContentBoxSize: size(),
    borderBoxSize: size(),
    contentBoxSize: size(),
    contentRect: new (0, _domrectReadOnly.DOMRectReadOnly)(0, 0, 0, 0)
});
var calculateBoxSizes = function(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if (cache.has(target) && !forceRecalculation) return cache.get(target);
    if ((0, _element.isHidden)(target)) {
        cache.set(target, zeroBoxes);
        return zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, _element.isSVG)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !IE && cs.boxSizing === 'border-box';
    var switchSizes = verticalRegexp.test(cs.writingMode || '');
    var canScrollVertically = !svg && scrollRegexp.test(cs.overflowY || '');
    var canScrollHorizontally = !svg && scrollRegexp.test(cs.overflowX || '');
    var paddingTop = svg ? 0 : parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, _freeze.freeze)({
        devicePixelContentBoxSize: size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, _domrectReadOnly.DOMRectReadOnly)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    cache.set(target, boxes);
    return boxes;
};
var calculateBoxSize = function(target, observedBox, forceRecalculation) {
    var _a = calculateBoxSizes(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, _resizeObserverBoxOptions.ResizeObserverBoxOptions).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, _resizeObserverBoxOptions.ResizeObserverBoxOptions).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};

},{"../ResizeObserverBoxOptions":"5ezv1","../ResizeObserverSize":"fLNnm","../DOMRectReadOnly":"cCzGC","../utils/element":"2vgKP","../utils/freeze":"8Xk3z","../utils/global":"6Qnsc","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5ezv1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserverBoxOptions", ()=>ResizeObserverBoxOptions);
var ResizeObserverBoxOptions;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})(ResizeObserverBoxOptions || (ResizeObserverBoxOptions = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fLNnm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserverSize", ()=>ResizeObserverSize);
var _freeze = require("./utils/freeze");
var ResizeObserverSize = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, _freeze.freeze)(this);
    }
    return ResizeObserverSize;
}();

},{"./utils/freeze":"8Xk3z","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"8Xk3z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "freeze", ()=>freeze);
var freeze = function(obj) {
    return Object.freeze(obj);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"cCzGC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DOMRectReadOnly", ()=>DOMRectReadOnly);
var _freeze = require("./utils/freeze");
var DOMRectReadOnly = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, _freeze.freeze)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();

},{"./utils/freeze":"8Xk3z","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2vgKP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSVG", ()=>isSVG);
parcelHelpers.export(exports, "isHidden", ()=>isHidden);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isReplacedElement", ()=>isReplacedElement);
var isSVG = function(target) {
    return target instanceof SVGElement && 'getBBox' in target;
};
var isHidden = function(target) {
    if (isSVG(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var isElement = function(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var isReplacedElement = function(target) {
    switch(target.tagName){
        case 'INPUT':
            if (target.type !== 'image') break;
        case 'VIDEO':
        case 'AUDIO':
        case 'EMBED':
        case 'OBJECT':
        case 'CANVAS':
        case 'IFRAME':
        case 'IMG':
            return true;
    }
    return false;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6Qnsc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "global", ()=>global);
var global = typeof window !== 'undefined' ? window : {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9YpxS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateDepthForNode", ()=>calculateDepthForNode);
var _element = require("../utils/element");
var calculateDepthForNode = function(node) {
    if ((0, _element.isHidden)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};

},{"../utils/element":"2vgKP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"4MKio":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gatherActiveObservationsAtDepth", ()=>gatherActiveObservationsAtDepth);
var _resizeObservers = require("../utils/resizeObservers");
var _calculateDepthForNode = require("./calculateDepthForNode");
var gatherActiveObservationsAtDepth = function(depth) {
    (0, _resizeObservers.resizeObservers).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, _calculateDepthForNode.calculateDepthForNode)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};

},{"../utils/resizeObservers":"eejb5","./calculateDepthForNode":"9YpxS","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kIiss":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queueResizeObserver", ()=>queueResizeObserver);
var _queueMicroTask = require("./queueMicroTask");
var queueResizeObserver = function(cb) {
    (0, _queueMicroTask.queueMicroTask)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};

},{"./queueMicroTask":"6qKex","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6qKex":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queueMicroTask", ()=>queueMicroTask);
var trigger;
var callbacks = [];
var notify = function() {
    return callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var queueMicroTask = function(callback) {
    if (!trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode('');
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return notify();
        }).observe(el_1, config);
        trigger = function() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    callbacks.push(callback);
    trigger();
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9ySVb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObservation", ()=>ResizeObservation);
var _resizeObserverBoxOptions = require("./ResizeObserverBoxOptions");
var _calculateBoxSize = require("./algorithms/calculateBoxSize");
var _element = require("./utils/element");
var skipNotifyOnElement = function(target) {
    return !(0, _element.isSVG)(target) && !(0, _element.isReplacedElement)(target) && getComputedStyle(target).display === 'inline';
};
var ResizeObservation = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, _resizeObserverBoxOptions.ResizeObserverBoxOptions).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, _calculateBoxSize.calculateBoxSize)(this.target, this.observedBox, true);
        if (skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();

},{"./ResizeObserverBoxOptions":"5ezv1","./algorithms/calculateBoxSize":"1lEsn","./utils/element":"2vgKP","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"f34MD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizeObserverDetail", ()=>ResizeObserverDetail);
var ResizeObserverDetail = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"6Jl3s":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("aa6d80bc3b697f48");
var $reduce = require("1ee240c0462acdf8").left;
var arrayMethodIsStrict = require("161424d627b72094");
var CHROME_VERSION = require("bc7f601de74ac73e");
var IS_NODE = require("fbcc11805e216a7d");
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduce');
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({
    target: 'Array',
    proto: true,
    forced: FORCED
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});

},{"aa6d80bc3b697f48":"kc6W7","1ee240c0462acdf8":"gMJdx","161424d627b72094":"79K9I","bc7f601de74ac73e":"42zsN","fbcc11805e216a7d":"65woV"}],"gMJdx":[function(require,module,exports,__globalThis) {
'use strict';
var aCallable = require("93e7a99f8d3bc817");
var toObject = require("915d05570b61a3c9");
var IndexedObject = require("da310552be96f5db");
var lengthOfArrayLike = require("f4209260f2003c23");
var $TypeError = TypeError;
var REDUCE_EMPTY = 'Reduce of empty array with no initial value';
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        var O = toObject(that);
        var self = IndexedObject(O);
        var length = lengthOfArrayLike(O);
        aCallable(callbackfn);
        if (length === 0 && argumentsLength < 2) throw new $TypeError(REDUCE_EMPTY);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw new $TypeError(REDUCE_EMPTY);
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
module.exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: createMethod(true)
};

},{"93e7a99f8d3bc817":"gx4Kw","915d05570b61a3c9":"4wIgP","da310552be96f5db":"fSmQq","f4209260f2003c23":"1iqfp"}],"65woV":[function(require,module,exports,__globalThis) {
'use strict';
var ENVIRONMENT = require("5fac34e3c4c0e043");
module.exports = ENVIRONMENT === 'NODE';

},{"5fac34e3c4c0e043":"88wXt"}],"88wXt":[function(require,module,exports,__globalThis) {
'use strict';
/* global Bun, Deno -- detection */ var globalThis = require("7dc361f46ecde901");
var userAgent = require("9f6e24ecbba66a9e");
var classof = require("a008a59fdc341842");
var userAgentStartsWith = function(string) {
    return userAgent.slice(0, string.length) === string;
};
module.exports = function() {
    if (userAgentStartsWith('Bun/')) return 'BUN';
    if (userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
    if (userAgentStartsWith('Deno/')) return 'DENO';
    if (userAgentStartsWith('Node.js/')) return 'NODE';
    if (globalThis.Bun && typeof Bun.version == 'string') return 'BUN';
    if (globalThis.Deno && typeof Deno.version == 'object') return 'DENO';
    if (classof(globalThis.process) === 'process') return 'NODE';
    if (globalThis.window && globalThis.document) return 'BROWSER';
    return 'REST';
}();

},{"7dc361f46ecde901":"f9rMX","9f6e24ecbba66a9e":"eC1k9","a008a59fdc341842":"60dWh"}],"4ceMt":[function(require,module,exports,__globalThis) {
'use strict';
var $ = require("72ba4de9841213e");
var exec = require("d4ebaff1663cc5b9");
// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({
    target: 'RegExp',
    proto: true,
    forced: /./.exec !== exec
}, {
    exec: exec
});

},{"72ba4de9841213e":"kc6W7","d4ebaff1663cc5b9":"iov06"}],"iov06":[function(require,module,exports,__globalThis) {
'use strict';
/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */ /* eslint-disable regexp/no-useless-quantifier -- testing */ var call = require("698f504b4733b02d");
var uncurryThis = require("6d0d2df39383a10b");
var toString = require("382af5492ddc18e6");
var regexpFlags = require("96e0244464229d3");
var stickyHelpers = require("3bd1d72d4987e0ff");
var shared = require("12c3e6e355312395");
var create = require("38d060dff8e4ab54");
var getInternalState = require("aec1e11e2cd92d19").get;
var UNSUPPORTED_DOT_ALL = require("7d9db6b4177b833a");
var UNSUPPORTED_NCG = require("b26a8ca5152d0a8d");
var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
var UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    call(nativeExec, re1, 'a');
    call(nativeExec, re2, 'a');
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;
var setGroups = function(re, groups) {
    var object = re.groups = create(null);
    for(var i = 0; i < groups.length; i++){
        var group = groups[i];
        object[group[0]] = re[group[1]];
    }
};
if (PATCH) patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = call(patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        if (result && state.groups) setGroups(result, state.groups);
        return result;
    }
    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = replace(flags, 'y', '');
        if (indexOf(flags, 'g') === -1) flags += 'g';
        strCopy = stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        var prevChar = re.lastIndex > 0 && charAt(str, re.lastIndex - 1);
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && prevChar !== '\n' && prevChar !== '\r' && prevChar !== '\u2028' && prevChar !== '\u2029')) {
            source = '(?: (?:' + source + '))';
            strCopy = ' ' + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp('^(?:' + source + ')', flags);
    }
    if (NPCG_INCLUDED) reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    var match = call(nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = str;
            match[0] = stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if (NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
    call(nativeReplace, match[0], reCopy, function() {
        for(var i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) setGroups(match, groups);
    return match;
};
module.exports = patchedExec;

},{"698f504b4733b02d":"2uUEG","6d0d2df39383a10b":"2eIWS","382af5492ddc18e6":"5KK1q","96e0244464229d3":"jw7Yw","3bd1d72d4987e0ff":"lvn2w","12c3e6e355312395":"wnsd5","38d060dff8e4ab54":"dEwVH","aec1e11e2cd92d19":"7SPub","7d9db6b4177b833a":"1EX8r","b26a8ca5152d0a8d":"4kJ4R"}],"jw7Yw":[function(require,module,exports,__globalThis) {
'use strict';
var anObject = require("136abace0aec2b5c");
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function() {
    var that = anObject(this);
    var result = '';
    if (that.hasIndices) result += 'd';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.dotAll) result += 's';
    if (that.unicode) result += 'u';
    if (that.unicodeSets) result += 'v';
    if (that.sticky) result += 'y';
    return result;
};

},{"136abace0aec2b5c":"BZXPW"}],"lvn2w":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("797bef35e651cb5e");
var globalThis = require("d87f6288614c07bc");
// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = globalThis.RegExp;
var UNSUPPORTED_Y = fails(function() {
    var re = $RegExp('a', 'y');
    re.lastIndex = 2;
    return re.exec('abcd') !== null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function() {
    return !$RegExp('a', 'y').sticky;
});
var BROKEN_CARET = UNSUPPORTED_Y || fails(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $RegExp('^r', 'gy');
    re.lastIndex = 2;
    return re.exec('str') !== null;
});
module.exports = {
    BROKEN_CARET: BROKEN_CARET,
    MISSED_STICKY: MISSED_STICKY,
    UNSUPPORTED_Y: UNSUPPORTED_Y
};

},{"797bef35e651cb5e":"5EMIZ","d87f6288614c07bc":"f9rMX"}],"1EX8r":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("e4784e58ea762065");
var globalThis = require("ea51a856230c58ac");
// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = globalThis.RegExp;
module.exports = fails(function() {
    var re = $RegExp('.', 's');
    return !(re.dotAll && re.test('\n') && re.flags === 's');
});

},{"e4784e58ea762065":"5EMIZ","ea51a856230c58ac":"f9rMX"}],"4kJ4R":[function(require,module,exports,__globalThis) {
'use strict';
var fails = require("b9b1a0fbdd999ded");
var globalThis = require("f47a97b0c4cfeafc");
// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = globalThis.RegExp;
module.exports = fails(function() {
    var re = $RegExp('(?<a>b)', 'g');
    return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
});

},{"b9b1a0fbdd999ded":"5EMIZ","f47a97b0c4cfeafc":"f9rMX"}],"lfU7s":[function(require,module,exports,__globalThis) {
'use strict';
var call = require("1a72ba86dc4099cd");
var uncurryThis = require("600d78d4a838dc5");
var fixRegExpWellKnownSymbolLogic = require("3e8300c8dcd37861");
var anObject = require("4e367ba2e602279b");
var isObject = require("cde57a6a8e06b210");
var toLength = require("3ad5c9f9719d1735");
var toString = require("a1912f278569b4e6");
var requireObjectCoercible = require("d83ac9e10edfa0ef");
var getMethod = require("4fa13f5559b9cbba");
var advanceStringIndex = require("357167b0f8a6ba45");
var getRegExpFlags = require("3922ca715397933e");
var regExpExec = require("3b40f00a568e6a6b");
var stringIndexOf = uncurryThis(''.indexOf);
// @@match logic
fixRegExpWellKnownSymbolLogic('match', function(MATCH, nativeMatch, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.es/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = requireObjectCoercible(this);
            var matcher = isObject(regexp) ? getMethod(regexp, MATCH) : undefined;
            return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
        function(string) {
            var rx = anObject(this);
            var S = toString(string);
            var res = maybeCallNative(nativeMatch, rx, S);
            if (res.done) return res.value;
            var flags = toString(getRegExpFlags(rx));
            if (!~stringIndexOf(flags, 'g')) return regExpExec(rx, S);
            var fullUnicode = !!~stringIndexOf(flags, 'u') || !!~stringIndexOf(flags, 'v');
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = regExpExec(rx, S)) !== null){
                var matchStr = toString(result[0]);
                A[n] = matchStr;
                if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});

},{"1a72ba86dc4099cd":"2uUEG","600d78d4a838dc5":"2eIWS","3e8300c8dcd37861":"iX6b8","4e367ba2e602279b":"BZXPW","cde57a6a8e06b210":"9mXeP","3ad5c9f9719d1735":"hhykm","a1912f278569b4e6":"5KK1q","d83ac9e10edfa0ef":"eSVZv","4fa13f5559b9cbba":"2Kir9","357167b0f8a6ba45":"1o7QW","3922ca715397933e":"66ngE","3b40f00a568e6a6b":"99rVu"}],"iX6b8":[function(require,module,exports,__globalThis) {
'use strict';
// TODO: Remove from `core-js@4` since it's moved to entry points
require("a7057ee05361671");
var call = require("771b9a32e3d08596");
var defineBuiltIn = require("5a9ef6cc43262548");
var regexpExec = require("b286e3fd8e91d745");
var fails = require("f56adef42dd3c42");
var wellKnownSymbol = require("39c5bea895574e43");
var createNonEnumerableProperty = require("1c6881441295e4f4");
var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;
module.exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = wellKnownSymbol(KEY);
    var DELEGATES_TO_SYMBOL = !fails(function() {
        // String methods call symbol-named RegExp methods
        var O = {};
        // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
        O[SYMBOL] = function() {
            return 7;
        };
        return ''[KEY](O) !== 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === 'split') {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            var constructor = {};
            // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
            constructor[SPECIES] = function() {
                return re;
            };
            re = {
                constructor: constructor,
                flags: ''
            };
            // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]('');
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var nativeRegExpMethod = /./[SYMBOL];
        var methods = exec(SYMBOL, ''[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var $exec = regexp.exec;
            if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: call(nativeRegExpMethod, regexp, str, arg2)
                };
                return {
                    done: true,
                    value: call(nativeMethod, str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        defineBuiltIn(String.prototype, KEY, methods[0]);
        defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

},{"a7057ee05361671":"4ceMt","771b9a32e3d08596":"2uUEG","5a9ef6cc43262548":"baZWN","b286e3fd8e91d745":"iov06","f56adef42dd3c42":"5EMIZ","39c5bea895574e43":"iPmWx","1c6881441295e4f4":"dsQvz"}],"1o7QW":[function(require,module,exports,__globalThis) {
'use strict';
var charAt = require("7830b1b106fe9c2f").charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function(S, index, unicode) {
    return index + (unicode ? charAt(S, index).length || 1 : 1);
};

},{"7830b1b106fe9c2f":"44Ku7"}],"66ngE":[function(require,module,exports,__globalThis) {
'use strict';
var call = require("fd54476372f3a204");
var hasOwn = require("a12d2126c329f45");
var isPrototypeOf = require("815509f48e0b1e36");
var regExpFlagsDetection = require("586a9e5bee9cf7ef");
var regExpFlagsGetterImplementation = require("37fba4854c4ab846");
var RegExpPrototype = RegExp.prototype;
module.exports = regExpFlagsDetection.correct ? function(it) {
    return it.flags;
} : function(it) {
    return !regExpFlagsDetection.correct && isPrototypeOf(RegExpPrototype, it) && !hasOwn(it, 'flags') ? call(regExpFlagsGetterImplementation, it) : it.flags;
};

},{"fd54476372f3a204":"2uUEG","a12d2126c329f45":"23l8D","815509f48e0b1e36":"dduyg","586a9e5bee9cf7ef":"hBf6D","37fba4854c4ab846":"jw7Yw"}],"hBf6D":[function(require,module,exports,__globalThis) {
'use strict';
var globalThis = require("e604b58e4400a5a9");
var fails = require("c7e788cbac482e2");
// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var RegExp = globalThis.RegExp;
var FLAGS_GETTER_IS_CORRECT = !fails(function() {
    var INDICES_SUPPORT = true;
    try {
        RegExp('.', 'd');
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = '';
    var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';
    var addGetter = function(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: 's',
        global: 'g',
        ignoreCase: 'i',
        multiline: 'm',
        sticky: 'y'
    };
    if (INDICES_SUPPORT) pairs.hasIndices = 'd';
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor(RegExp.prototype, 'flags').get.call(O);
    return result !== expected || calls !== expected;
});
module.exports = {
    correct: FLAGS_GETTER_IS_CORRECT
};

},{"e604b58e4400a5a9":"f9rMX","c7e788cbac482e2":"5EMIZ"}],"99rVu":[function(require,module,exports,__globalThis) {
'use strict';
var call = require("fe012fd0e62b041c");
var anObject = require("953f0ef3a583db2e");
var isCallable = require("7b1bebb22aa6d09f");
var classof = require("41458309d054e6d9");
var regexpExec = require("2da13aa8500d5870");
var $TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function(R, S) {
    var exec = R.exec;
    if (isCallable(exec)) {
        var result = call(exec, R, S);
        if (result !== null) anObject(result);
        return result;
    }
    if (classof(R) === 'RegExp') return call(regexpExec, R, S);
    throw new $TypeError('RegExp#exec called on incompatible receiver');
};

},{"fe012fd0e62b041c":"2uUEG","953f0ef3a583db2e":"BZXPW","7b1bebb22aa6d09f":"5VYzL","41458309d054e6d9":"60dWh","2da13aa8500d5870":"iov06"}],"hBP0j":[function(require,module,exports,__globalThis) {
'use strict';
var DESCRIPTORS = require("b7ae6c9060bb031e");
var FUNCTION_NAME_EXISTS = require("dbb3f5c37b15a691").EXISTS;
var uncurryThis = require("ba7e18d66fc2fe0e");
var defineBuiltInAccessor = require("c4fdf1e400153454");
var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';
// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) defineBuiltInAccessor(FunctionPrototype, NAME, {
    configurable: true,
    get: function() {
        try {
            return regExpExec(nameRE, functionToString(this))[1];
        } catch (error) {
            return '';
        }
    }
});

},{"b7ae6c9060bb031e":"6VYiA","dbb3f5c37b15a691":"iqmDO","ba7e18d66fc2fe0e":"2eIWS","c4fdf1e400153454":"dQ1dy"}],"dQ1dy":[function(require,module,exports,__globalThis) {
'use strict';
var makeBuiltIn = require("5bd1cd8472955124");
var defineProperty = require("1413185c6323bbbc");
module.exports = function(target, name, descriptor) {
    if (descriptor.get) makeBuiltIn(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) makeBuiltIn(descriptor.set, name, {
        setter: true
    });
    return defineProperty.f(target, name, descriptor);
};

},{"5bd1cd8472955124":"egX5P","1413185c6323bbbc":"3CoVw"}],"5boEp":[function(require,module,exports,__globalThis) {
'use strict';
var apply = require("f8fd16f994f85406");
var call = require("b5234e1018cb2916");
var uncurryThis = require("c3560c75b4ad1ef2");
var fixRegExpWellKnownSymbolLogic = require("c4a2369a79c5aaa2");
var fails = require("daa534dec0372986");
var anObject = require("317f495e148be81e");
var isCallable = require("36464dd17d2a7224");
var isObject = require("bdde82227ff40558");
var toIntegerOrInfinity = require("3847a5ff118f8ebb");
var toLength = require("effd88adfbb6b4bc");
var toString = require("953b724c90cd8db6");
var requireObjectCoercible = require("154963922e7c9354");
var advanceStringIndex = require("90f011aa61b831b4");
var getMethod = require("af552ab4c89e35be");
var getSubstitution = require("3726cfd8dc51c82c");
var getRegExpFlags = require("bfd28e5f1d657a68");
var regExpExec = require("6de55154ce28598");
var wellKnownSymbol = require("4b6a0c7e75a1080a");
var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);
var maybeToString = function(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return 'a'.replace(/./, '$0') === '$0';
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[REPLACE]) return /./[REPLACE]('a', '$0') === '';
    return false;
}();
var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: '7'
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return ''.replace(re, '$<a>') !== '7';
});
// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = requireObjectCoercible(this);
            var replacer = isObject(searchValue) ? getMethod(searchValue, REPLACE) : undefined;
            return replacer ? call(replacer, searchValue, O, replaceValue) : call(nativeReplace, toString(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = anObject(this);
            var S = toString(string);
            var functionalReplace = isCallable(replaceValue);
            if (!functionalReplace) replaceValue = toString(replaceValue);
            var flags = toString(getRegExpFlags(rx));
            if (typeof replaceValue == 'string' && !~stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) && !~stringIndexOf(replaceValue, '$<') && !~stringIndexOf(flags, 'y')) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var global = !!~stringIndexOf(flags, 'g');
            var fullUnicode;
            if (global) {
                fullUnicode = !!~stringIndexOf(flags, 'u') || !!~stringIndexOf(flags, 'v');
                rx.lastIndex = 0;
            }
            var results = [];
            var result;
            while(true){
                result = regExpExec(rx, S);
                if (result === null) break;
                push(results, result);
                if (!global) break;
                var matchStr = toString(result[0]);
                if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = '';
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = toString(result[0]);
                var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
                var captures = [];
                var replacement;
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)push(captures, maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
                    replacement = toString(apply(replaceValue, undefined, replacerArgs));
                } else replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + stringSlice(S, nextSourcePosition);
        }
    ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

},{"f8fd16f994f85406":"hI1sY","b5234e1018cb2916":"2uUEG","c3560c75b4ad1ef2":"2eIWS","c4a2369a79c5aaa2":"iX6b8","daa534dec0372986":"5EMIZ","317f495e148be81e":"BZXPW","36464dd17d2a7224":"5VYzL","bdde82227ff40558":"9mXeP","3847a5ff118f8ebb":"03zUT","effd88adfbb6b4bc":"hhykm","953b724c90cd8db6":"5KK1q","154963922e7c9354":"eSVZv","90f011aa61b831b4":"1o7QW","af552ab4c89e35be":"2Kir9","3726cfd8dc51c82c":"l3Q2S","bfd28e5f1d657a68":"66ngE","6de55154ce28598":"99rVu","4b6a0c7e75a1080a":"iPmWx"}],"hI1sY":[function(require,module,exports,__globalThis) {
'use strict';
var NATIVE_BIND = require("d07466971ded2aca");
var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function() {
    return call.apply(apply, arguments);
});

},{"d07466971ded2aca":"5YUIB"}],"l3Q2S":[function(require,module,exports,__globalThis) {
'use strict';
var uncurryThis = require("3cf51fea5d34c201");
var toObject = require("999f669befd62c27");
var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = toObject(namedCaptures);
        symbols = SUBSTITUTION_SYMBOLS;
    }
    return replace(replacement, symbols, function(match, ch) {
        var capture;
        switch(charAt(ch, 0)){
            case '$':
                return '$';
            case '&':
                return matched;
            case '`':
                return stringSlice(str, 0, position);
            case "'":
                return stringSlice(str, tailPos);
            case '<':
                capture = namedCaptures[stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? '' : capture;
    });
};

},{"3cf51fea5d34c201":"2eIWS","999f669befd62c27":"4wIgP"}],"j0Qq1":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("[{\"key\":\"name\",\"label\":\"Full name\",\"mapToPath\":\"name\",\"category\":\"Personal\"},{\"key\":\"firstname\",\"label\":\"First name\",\"mapToPath\":\"details.firstName\",\"category\":\"Personal\"},{\"key\":\"middle_name\",\"label\":\"Middle name\",\"mapToPath\":\"details.middleName\",\"category\":\"Personal\"},{\"key\":\"surname\",\"label\":\"Surname\",\"mapToPath\":\"details.surname\",\"category\":\"Personal\"},{\"key\":\"address\",\"label\":\"Address\",\"mapToPath\":\"details.address\",\"category\":\"Personal\"},{\"key\":\"address_2\",\"label\":\"Address 2\",\"mapToPath\":\"details.address2\",\"category\":\"Personal\"},{\"key\":\"address_3\",\"label\":\"Address 3\",\"mapToPath\":\"details.address3\",\"category\":\"Personal\"},{\"key\":\"address_4\",\"label\":\"Address 4\",\"mapToPath\":\"details.address4\",\"category\":\"Personal\"},{\"key\":\"town\",\"label\":\"Town\",\"mapToPath\":\"details.town\",\"category\":\"Personal\"},{\"key\":\"county\",\"label\":\"County\",\"mapToPath\":\"details.county\",\"category\":\"Personal\"},{\"key\":\"postcode\",\"label\":\"Postcode\",\"mapToPath\":\"details.postcode\",\"category\":\"Personal\"},{\"key\":\"salutation\",\"label\":\"Salutation\",\"mapToPath\":\"details.salutation\",\"category\":\"Personal\"},{\"key\":\"known_as\",\"label\":\"Known as\",\"mapToPath\":\"details.knownAs\",\"category\":\"Personal\"},{\"key\":\"dob\",\"label\":\"Date of birth\",\"mapToPath\":\"details.dob\",\"category\":\"Personal\"},{\"key\":\"ni_number\",\"label\":\"NI number\",\"mapToPath\":\"employment.niNumber\",\"category\":\"Employment\"},{\"key\":\"marital_status\",\"label\":\"Marital status\",\"mapToPath\":\"details.maritalStatus\",\"category\":\"Employment\"},{\"key\":\"relationships\",\"label\":\"Relationships at work\",\"mapToPath\":\"details.relationships\",\"category\":\"Employment\"},{\"key\":\"gender\",\"label\":\"Gender\",\"mapToPath\":\"details.gender\",\"category\":\"Personal\"},{\"key\":\"email\",\"label\":\"Email address\",\"mapToPath\":\"details.email\",\"category\":\"Personal\"},{\"key\":\"additional_email\",\"label\":\"Additional email address\",\"mapToPath\":\"details.additionalEmail\",\"category\":\"Personal\"},{\"key\":\"website\",\"label\":\"Website\",\"mapToPath\":\"details.website\",\"category\":\"Personal\"},{\"key\":\"tel\",\"label\":\"Telephone number\",\"mapToPath\":\"details.tel\",\"category\":\"Personal\"},{\"key\":\"mobile\",\"label\":\"Telephone number (mobile)\",\"mapToPath\":\"details.telMobilePersonal\",\"category\":\"Personal\"},{\"key\":\"bank\",\"label\":\"Bank - bank name\",\"mapToPath\":\"bank.bank\",\"category\":\"Bank details\"},{\"key\":\"account_name\",\"label\":\"Bank - account name\",\"mapToPath\":\"bank.name\",\"category\":\"Bank details\"},{\"key\":\"account_no\",\"label\":\"Bank - account number\",\"mapToPath\":\"bank.acNo\",\"category\":\"Bank details\"},{\"key\":\"sort_code\",\"label\":\"Bank - sort code\",\"mapToPath\":\"bank.sortCode\",\"category\":\"Bank details\"},{\"key\":\"bank_ref\",\"label\":\"Bank - reference\",\"mapToPath\":\"bank.ref\",\"category\":\"Bank details\"},{\"key\":\"employment_status\",\"label\":\"Employment status\",\"mapToPath\":\"employment.status\",\"category\":\"Employment\"},{\"key\":\"employment_type\",\"label\":\"Employment type\",\"mapToPath\":\"employment.type\",\"category\":\"Employment\"},{\"key\":\"department\",\"label\":\"Department\",\"mapToPath\":\"employment.department\",\"category\":\"Employment\"},{\"key\":\"job_title\",\"label\":\"Job title\",\"mapToPath\":\"employment.jobTitle\",\"category\":\"Employment\"},{\"key\":\"notice_period_employee\",\"label\":\"Notice period (employee)\",\"mapToPath\":\"employment.noticePeriodEmployee\",\"category\":\"Employment\"},{\"key\":\"notice_period_company\",\"label\":\"Notice period (company)\",\"mapToPath\":\"employment.noticePeriodCompany\",\"category\":\"Employment\"},{\"key\":\"notice_probationary_employee\",\"label\":\"Notice period (probationary - employee)\",\"mapToPath\":\"employment.noticeProbationaryEmployee\",\"category\":\"Employment\"},{\"key\":\"notice_probationary_company\",\"label\":\"Notice period (probationary - company)\",\"mapToPath\":\"employment.noticeProbationaryCompany\",\"category\":\"Employment\"},{\"key\":\"probationary_period_ends\",\"label\":\"Probationary Period Ends\",\"mapToPath\":\"employment.probationaryPeriodEnds\",\"category\":\"Employment\"},{\"key\":\"salary_hourly\",\"label\":\"Salary / Hourly\",\"mapToPath\":\"employment.salaryHourly\",\"category\":\"Employment\"},{\"key\":\"salary\",\"label\":\"Salary\",\"mapToPath\":\"employment.salary\",\"category\":\"Employment\"},{\"key\":\"rate\",\"label\":\"Rate\",\"mapToPath\":\"employment.rate\",\"category\":\"Employment\"},{\"key\":\"start_date\",\"label\":\"Start date\",\"mapToPath\":\"employment.began\",\"category\":\"Employment\"},{\"key\":\"date_of_continuous_employment\",\"label\":\"Date of continuous employment\",\"mapToPath\":\"employment.dateOfContinuousEmployment\",\"category\":\"Employment\"},{\"key\":\"end_date\",\"label\":\"End date\",\"mapToPath\":\"employment.end\",\"category\":\"Employment\"},{\"key\":\"end_reason\",\"label\":\"Employment end - reason\",\"mapToPath\":\"employment.endReason\",\"category\":\"Employment\"},{\"key\":\"end_details\",\"label\":\"Employment end - details\",\"mapToPath\":\"employment.endDetails\",\"category\":\"Employment\"},{\"key\":\"end_notes\",\"label\":\"Employment end - notes\",\"mapToPath\":\"employment.endNotes\",\"category\":\"Employment\"},{\"key\":\"place_of_work\",\"label\":\"Place of work\",\"mapToPath\":\"employment.placeOfWork\",\"category\":\"Employment\"},{\"key\":\"work_pattern\",\"label\":\"Work pattern\",\"mapToPath\":\"employment.regularDays\",\"category\":\"Employment\"},{\"key\":\"work_pattern_details\",\"label\":\"Work pattern notes\",\"mapToPath\":\"employment.workPatternDetails\",\"category\":\"Employment\"},{\"key\":\"work_pattern_specifics\",\"label\":\"Work pattern details\",\"mapToPath\":\"employment.workPatternSpecifics\",\"category\":\"Employment\"},{\"key\":\"hours_per_week\",\"label\":\"Hours per week\",\"mapToPath\":\"employment.hoursPerWeek\",\"category\":\"Employment\"},{\"key\":\"emergency_name\",\"label\":\"Emergency contact name\",\"mapToPath\":\"emergencyContacts.emergencyName\",\"category\":\"Emergency contacts\"},{\"key\":\"emergency_relationship\",\"label\":\"Emergenct contact relationship\",\"mapToPath\":\"emergencyContacts.emergencyRelationship\",\"category\":\"Emergency contacts\"},{\"key\":\"emergency_contact_number\",\"label\":\"Emergency contact number\",\"mapToPath\":\"emergencyContacts.emergencyTel\",\"category\":\"Emergency contacts\"},{\"key\":\"emergency_contact_number_alt\",\"label\":\"Emergency contact number (alternative)\",\"mapToPath\":\"emergencyContacts.emergencyTelAlt\",\"category\":\"Emergency contacts\"},{\"key\":\"emergency_email\",\"label\":\"Emergency contact email\",\"mapToPath\":\"emergencyContacts.emergencyEmail\",\"category\":\"Emergency contacts\"},{\"key\":\"emergency_address\",\"label\":\"Emergency contact address\",\"mapToPath\":\"emergencyContacts.emergencyAddress\",\"category\":\"Emergency contacts\"},{\"key\":\"emergency_address_2\",\"label\":\"Emergency contact address line 2\",\"mapToPath\":\"emergencyContacts.emergencyAddress2\",\"category\":\"Emergency contacts\"},{\"key\":\"emergency_postcode\",\"label\":\"Emergency contact address postcode\",\"mapToPath\":\"emergencyContacts.emergencyPostcode\",\"category\":\"Emergency contacts\"},{\"key\":\"emergency_name-2\",\"label\":\"Emergency contact 2 name\",\"mapToPath\":\"emergencyContacts.emergency2Name\",\"category\":\"Emergency contacts\"},{\"key\":\"emergency_relationship-2\",\"label\":\"Emergenct contact 2 relationship\",\"mapToPath\":\"emergencyContacts.emergency2Relationship\",\"category\":\"Emergency contacts\"},{\"key\":\"emergency_contact_number-2\",\"label\":\"Emergency contact 2 number\",\"mapToPath\":\"emergencyContacts.emergency2Tel\",\"category\":\"Emergency contacts\"},{\"key\":\"emergency_contact_number_alt-2\",\"label\":\"Emergency contact 2 number (alternative)\",\"mapToPath\":\"emergencyContacts.emergency2TelAlt\",\"category\":\"Emergency contacts\"},{\"key\":\"emergency_email-2\",\"label\":\"Emergency contact 2 email\",\"mapToPath\":\"emergencyContacts.emergency2Email\",\"category\":\"Emergency contacts\"},{\"key\":\"emergency_address-2\",\"label\":\"Emergency contact 2 address\",\"mapToPath\":\"emergencyContacts.emergency2Address\",\"category\":\"Emergency contacts\"},{\"key\":\"emergency_address_2-2\",\"label\":\"Emergency contact 2 address line 2\",\"mapToPath\":\"emergencyContacts.emergency2Address2\",\"category\":\"Emergency contacts\"},{\"key\":\"emergency_postcode-2\",\"label\":\"Emergency contact 2 address postcode\",\"mapToPath\":\"emergencyContacts.emergency2Postcode\",\"category\":\"Emergency contacts\"}]");

},{}],"fXBsb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFetchForms", ()=>useFetchForms);
parcelHelpers.export(exports, "useFetchSubmissions", ()=>useFetchSubmissions);
parcelHelpers.export(exports, "useFetchUserSubmissions", ()=>useFetchUserSubmissions);
parcelHelpers.export(exports, "useFetchSubmission", ()=>useFetchSubmission);
parcelHelpers.export(exports, "useFetchForm", ()=>useFetchForm);
parcelHelpers.export(exports, "useFetchFormFields", ()=>useFetchFormFields);
parcelHelpers.export(exports, "useFetchFormField", ()=>useFetchFormField);
parcelHelpers.export(exports, "useCreateForm", ()=>useCreateForm);
parcelHelpers.export(exports, "useDuplicateForm", ()=>useDuplicateForm);
parcelHelpers.export(exports, "useDeleteForm", ()=>useDeleteForm);
parcelHelpers.export(exports, "useUpdateForm", ()=>useUpdateForm);
parcelHelpers.export(exports, "useUpdateFormField", ()=>useUpdateFormField);
parcelHelpers.export(exports, "useCreateFormField", ()=>useCreateFormField);
parcelHelpers.export(exports, "useCreateSubmission", ()=>useCreateSubmission);
parcelHelpers.export(exports, "useUpdateSubmission", ()=>useUpdateSubmission);
parcelHelpers.export(exports, "useDeleteFormField", ()=>useDeleteFormField);
var _reactQuery = require("react-query");
var _fetchJs = require("../../../utilities/fetch.js");
var _useStoreJsx = require("../useStore.jsx");
var _useStoreJsxDefault = parcelHelpers.interopDefault(_useStoreJsx);
const transformSubmissionData = (data, formFields)=>{
    const formData = new FormData();
    for (const [key, field] of Object.entries(data))if (key !== "id") {
        // get form field
        const formField = formFields === null || formFields === void 0 ? void 0 : formFields.find((f)=>f.fieldId === key);
        if (field instanceof FileList) // Handle file uploads separately
        Array.from(field).forEach((file, index)=>{
            formData.append(`${key}_${index}`, file);
        });
        else if ((formField === null || formField === void 0 ? void 0 : formField.type) === "multiCheckbox") {
            let value = "";
            field.forEach((item, index)=>{
                value += item.label + ", ";
            });
            value = value.slice(0, -2);
            formData.append(key, value);
        } else formData.append(key, (field === null || field === void 0 ? void 0 : field.value) || field);
    }
    return formData;
};
const useFetchForms = ({ account = null, callback, refetch = true })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "forms"
    });
    const clientRef = (0, _useStoreJsxDefault.default).getState().clientRef;
    const setLoggedIn = (0, _useStoreJsxDefault.default).getState().setLoggedIn;
    return (0, _reactQuery.useQuery)([
        "forms",
        account
    ], ()=>{
        if (account === false) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: "/forms",
            params: {
                account: account
            }
        });
    }, {
        refetchInterval: refetch === false ? false : 30000,
        refetchOnMount: refetch === false ? false : true,
        refetchOnWindowFocus: refetch === false ? false : true,
        select: (data)=>{
            var _data_data, _data_data1;
            if ((data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.account) && clientRef && data.data.account !== clientRef && clientRef !== "admin" && clientRef !== "app") {
                console.warn(`Account mismatch for forms: fetched account "${data.data.account}" does not match client "${clientRef}"`);
                setLoggedIn(false);
            }
            return data === null || data === void 0 ? void 0 : (_data_data1 = data.data) === null || _data_data1 === void 0 ? void 0 : _data_data1.items;
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useFetchSubmissions = ({ account = null, formId, callback })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "submissions"
    });
    return (0, _reactQuery.useQuery)([
        "submissions",
        formId,
        account
    ], ()=>{
        if (!formId || account === false) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/submissions/${formId}`,
            params: {
                account: account
            }
        });
    }, {
        refetchInterval: 30000,
        select: (data)=>{
            var _data_data;
            return data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.items;
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useFetchUserSubmissions = ({ account = null, userId, callback })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "submissions"
    });
    return (0, _reactQuery.useQuery)([
        "submissions",
        userId,
        account
    ], ()=>{
        if (!userId) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/submissions/user/${userId}`,
            params: {
                account: account
            }
        });
    }, {
        refetchInterval: 30000,
        select: (data)=>{
            var _data_data;
            return data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.items;
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useFetchSubmission = ({ account = null, submissionId, callback })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "submissions"
    });
    return (0, _reactQuery.useQuery)([
        "submission",
        submissionId,
        account
    ], ()=>{
        if (!submissionId) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/submission/${submissionId}`,
            params: {
                account: account
            }
        });
    }, {
        refetchInterval: 30000,
        select: (data)=>data === null || data === void 0 ? void 0 : data.data,
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useFetchForm = ({ account = null, formId, callback })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "forms"
    });
    return (0, _reactQuery.useQuery)([
        "form",
        account,
        formId
    ], ()=>{
        if (!formId) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/forms/${formId}`,
            params: {
                account: account
            }
        });
    }, {
        refetchInterval: false,
        select: (data)=>data === null || data === void 0 ? void 0 : data.data,
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useFetchFormFields = ({ account = null, callback })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "formFields"
    });
    return (0, _reactQuery.useQuery)([
        "formFields",
        account
    ], ()=>{
        return (0, _fetchJs.request)({
            url: `/form-fields`,
            params: {
                account: account
            }
        });
    }, {
        refetchInterval: false,
        select: (data)=>{
            var _data_data;
            return data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.items;
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useFetchFormField = ({ account = null, callback, fieldId = null })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "formFields"
    });
    return (0, _reactQuery.useQuery)([
        "formField",
        fieldId,
        account
    ], ()=>{
        if (!fieldId) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/form-fields/${fieldId}`,
            params: {
                account: account
            }
        });
    }, {
        refetchInterval: false,
        select: (data)=>data === null || data === void 0 ? void 0 : data.data,
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useCreateForm = ({ account = null, callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data)=>{
        return (0, _fetchJs.request)({
            url: `/forms`,
            method: "post",
            data: data,
            params: {
                account: account
            }
        });
    }, {
        mutationKey: "forms",
        onMutate: async (data)=>{
            await queryClient.cancelQueries([
                "forms",
                account
            ]);
        },
        onSettled: (data)=>{
            queryClient.invalidateQueries([
                "forms",
                account
            ]);
        },
        onSuccess: callback
    });
};
const useDuplicateForm = ({ account = null, callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((id)=>{
        return (0, _fetchJs.request)({
            url: `/forms/duplicate/${id}`,
            method: "get",
            params: {
                account: account
            }
        });
    }, {
        mutationKey: "forms",
        onMutate: async (data)=>{
            await queryClient.cancelQueries([
                "forms",
                account
            ]);
        },
        onSettled: (data)=>{
            queryClient.invalidateQueries([
                "forms",
                account
            ]);
        },
        onSuccess: callback
    });
};
const useDeleteForm = ({ account = null, callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((formId)=>{
        return (0, _fetchJs.request)({
            url: `/forms/${formId}`,
            method: "delete",
            params: {
                account: account
            }
        });
    }, {
        mutationKey: "forms",
        onMutate: async (formId)=>{
            var _queryClient_getQueryData_data, _queryClient_getQueryData;
            await queryClient.cancelQueries([
                "forms",
                account
            ]);
            const currentForms = (_queryClient_getQueryData = queryClient.getQueryData([
                "forms",
                account
            ])) === null || _queryClient_getQueryData === void 0 ? void 0 : (_queryClient_getQueryData_data = _queryClient_getQueryData.data) === null || _queryClient_getQueryData_data === void 0 ? void 0 : _queryClient_getQueryData_data.items;
            // optimistic update data
            if ((currentForms === null || currentForms === void 0 ? void 0 : currentForms.length) > 0) {
                const deleteIndex = currentForms.findIndex((form)=>(form === null || form === void 0 ? void 0 : form.formId) === formId);
                currentForms.splice(deleteIndex, 1);
                await queryClient.setQueryData([
                    "forms",
                    account
                ], {
                    data: {
                        items: [
                            ...currentForms
                        ]
                    }
                });
                queryClient.invalidateQueries([
                    "forms",
                    account
                ]);
            }
        },
        onSettled: ()=>{
            queryClient.invalidateQueries([
                "forms",
                account
            ]);
        },
        onSuccess: callback
    });
};
const useUpdateForm = ({ account = null, callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data)=>{
        const formId = data === null || data === void 0 ? void 0 : data.id;
        if (!formId) return Promise.resolve({});
        const submitData = {
            ...data
        };
        delete submitData.id;
        return (0, _fetchJs.request)({
            url: `/forms/${formId}`,
            method: "patch",
            data: submitData,
            params: {
                account: account
            }
        });
    }, {
        mutationKey: "forms",
        onMutate: async (data)=>{
            const formId = data === null || data === void 0 ? void 0 : data.id;
            await queryClient.cancelQueries([
                "form",
                account,
                formId
            ]);
            await queryClient.cancelQueries([
                "forms",
                account
            ]);
        },
        onSettled: (data)=>{
            var _data_data;
            const formId = data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.formId;
            queryClient.invalidateQueries([
                "form",
                account,
                formId
            ]);
            queryClient.refetchQueries([
                "form",
                account,
                formId
            ]);
            queryClient.invalidateQueries([
                "forms",
                account
            ]);
        },
        onSuccess: callback
    });
};
const useUpdateFormField = ({ account = null, callback, formId = null })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data)=>{
        const fieldId = data === null || data === void 0 ? void 0 : data.id;
        if (!fieldId) return Promise.resolve({});
        delete data.id;
        if (data.options) {
            if (!Array.isArray(data.options)) data.options = null;
            else data.options = data.options.map((option)=>{
                var _option_value;
                return (_option_value = option.value) === null || _option_value === void 0 ? void 0 : _option_value.toString();
            });
        }
        return (0, _fetchJs.request)({
            url: `/form-fields/${fieldId}`,
            method: "patch",
            data: data,
            params: {
                account: account
            }
        });
    }, {
        mutationKey: "forms",
        onMutate: async ()=>{
            await queryClient.cancelQueries([
                "form",
                account,
                formId
            ]);
        },
        onSettled: ()=>{
            queryClient.invalidateQueries([
                "form",
                account,
                formId
            ]);
        },
        onSuccess: callback
    });
};
const useCreateFormField = ({ account = null, callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data)=>{
        const formId = data === null || data === void 0 ? void 0 : data.id;
        if (!formId) return Promise.resolve({});
        delete data.id;
        return (0, _fetchJs.request)({
            url: `/forms/${formId}`,
            method: "post",
            data: data,
            params: {
                account: account
            }
        });
    }, {
        mutationKey: "forms",
        onMutate: async (data)=>{
            const formId = data === null || data === void 0 ? void 0 : data.id;
            await queryClient.cancelQueries([
                "form",
                account,
                formId
            ]);
        },
        onSettled: (data)=>{
            const formId = data === null || data === void 0 ? void 0 : data.id;
            queryClient.invalidateQueries([
                "form",
                account,
                formId
            ]);
        },
        onSuccess: callback
    });
};
const useCreateSubmission = ({ account = null, callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data = {}, formFields = [])=>{
        const formId = data === null || data === void 0 ? void 0 : data.id;
        if (!formId) return Promise.resolve({});
        delete data.id;
        data = transformSubmissionData(data, formFields);
        return (0, _fetchJs.request)({
            url: `/submissions/${formId}`,
            method: "post",
            data: data,
            params: {
                account: account
            }
        });
    }, {
        mutationKey: [
            "submissions"
        ],
        onMutate: async (data)=>{
            const userId = data === null || data === void 0 ? void 0 : data.userId;
            await queryClient.cancelQueries([
                "submissions",
                userId,
                account
            ]);
        },
        onSettled: (data)=>{
            const userId = data === null || data === void 0 ? void 0 : data.userId;
            queryClient.invalidateQueries([
                "submissions",
                userId,
                account
            ]);
        },
        onSuccess: callback
    });
};
const useUpdateSubmission = ({ account = null, callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data = {}, formFields = [])=>{
        const submissionId = data === null || data === void 0 ? void 0 : data.id;
        if (!submissionId) return Promise.resolve({});
        delete data.id;
        data = transformSubmissionData(data, formFields);
        return (0, _fetchJs.request)({
            url: `/submissions/${submissionId}`,
            method: "patch",
            data: data,
            params: {
                account: account
            }
        });
    }, {
        mutationKey: [
            "submissions"
        ],
        onMutate: async (data)=>{
            const userId = data === null || data === void 0 ? void 0 : data.userId;
            await queryClient.cancelQueries([
                "submissions",
                userId,
                account
            ]);
        },
        onSettled: (data)=>{
            const userId = data === null || data === void 0 ? void 0 : data.userId;
            queryClient.invalidateQueries([
                "submissions",
                userId,
                account
            ]);
        },
        onSuccess: callback
    });
};
const useDeleteFormField = ({ account = null, callback, formId })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((fieldId)=>{
        return (0, _fetchJs.request)({
            url: `/form-fields/${fieldId}`,
            method: "delete",
            params: {
                account: account
            }
        });
    }, {
        mutationKey: "forms",
        onMutate: async (fieldId)=>{
            var _queryClient_getQueryData_data, _queryClient_getQueryData;
            await queryClient.cancelQueries([
                "form",
                account,
                formId
            ]);
            const currentFormItems = (_queryClient_getQueryData = queryClient.getQueryData([
                "form",
                account,
                formId
            ])) === null || _queryClient_getQueryData === void 0 ? void 0 : (_queryClient_getQueryData_data = _queryClient_getQueryData.data) === null || _queryClient_getQueryData_data === void 0 ? void 0 : _queryClient_getQueryData_data.fields;
            // optimistic update data
            if ((currentFormItems === null || currentFormItems === void 0 ? void 0 : currentFormItems.length) > 0) {
                const deleteIndex = currentFormItems.findIndex((field)=>(field === null || field === void 0 ? void 0 : field.fieldId) === fieldId);
                currentFormItems.splice(deleteIndex, 1);
                await queryClient.setQueryData([
                    "form",
                    account,
                    formId
                ], {
                    data: {
                        fields: [
                            ...currentFormItems
                        ]
                    }
                });
                queryClient.invalidateQueries([
                    "form",
                    account,
                    formId
                ]);
            }
        },
        onSettled: ()=>{
            queryClient.invalidateQueries([
                "form",
                account,
                formId
            ]);
        },
        onSuccess: callback
    });
};
exports.default = useFetchForms;

},{"react-query":"41hyj","../../../utilities/fetch.js":"hAKRo","../useStore.jsx":"l1Yj7","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"cl66D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const useInterval = (callback, delay)=>{
    const savedCallback = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, _react.useEffect)(()=>{
        const tick = ()=>{
            savedCallback.current();
        };
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
    }, [
        delay
    ]);
};
exports.default = useInterval;

},{"react":"6wC8C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"kmXGR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _submitButton = require("./submitButton");
var _submitButtonDefault = parcelHelpers.interopDefault(_submitButton);
var _useStore = require("../hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
require("856095e8ca27f69e");
const ContractSign = ({ disabled, onSubmit })=>{
    const currentUser = (0, _useStoreDefault.default)((state)=>state.currentUser);
    const [typedName, setTypedName] = (0, _react.useState)("");
    const doSignContract = ()=>{
        if (typedName.trim().toLowerCase() === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.name.toLowerCase())) onSubmit && onSubmit();
        else // Display an error message or handle it as you prefer
        console.error("Please enter your full name.");
    };
    const handleNameChange = (event)=>{
        setTypedName(event.target.value);
    };
    const isSubmitDisabled = disabled || !typedName.trim() || typedName.trim().toLowerCase() !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.name.toLowerCase());
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "contract-sign-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: "name",
                children: "Please enter your name in full and click the button below to sign this document"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                id: "name",
                type: "text",
                placeholder: `Type '${currentUser === null || currentUser === void 0 ? void 0 : currentUser.name}'`,
                value: typedName,
                "aria-label": "Type your name in full",
                onChange: handleNameChange
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _submitButtonDefault.default), {
                label: "Sign document",
                disabled: isSubmitDisabled,
                "aria-label": "Sign document",
                onSubmit: doSignContract
            })
        ]
    });
};
exports.default = ContractSign;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","./submitButton":"4bi2T","856095e8ca27f69e":"aYo5H","../hooks/useStore":"l1Yj7","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"aYo5H":[function(require,module,exports,__globalThis) {
module.exports = require("8f6090a9ec96022e")(module.bundle.resolve("hMhSG"));

},{"8f6090a9ec96022e":"efVvj"}],"hL6QE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _svg = require("./svg");
var _svgDefault = parcelHelpers.interopDefault(_svg);
var _utilities = require("../../utilities");
var _utilitiesDefault = parcelHelpers.interopDefault(_utilities);
var _capacitor = require("../../utilities/capacitor");
var _useFetchResources = require("../hooks/fetch/useFetchResources");
var _useStore = require("../hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
var _fileLibraryLinksScss = require("../../../scss/components/fileLibraryLinks.scss");
const FileLibraryLinks = ({ id, allowDownload = true })=>{
    const authToken = (0, _useStoreDefault.default)((state)=>state.authToken);
    const clientRef = (0, _useStoreDefault.default)((state)=>state.getClientRef());
    const { data: files, isLoading } = (0, _useFetchResources.useFetchResources)({
        type: "files",
        account: clientRef,
        refetch: allowDownload
    });
    const filteredFiles = files === null || files === void 0 ? void 0 : files.filter((file)=>{
        var _file_folder;
        return ((_file_folder = file.folder) === null || _file_folder === void 0 ? void 0 : _file_folder.folderId) === id;
    });
    const doDownload = (file)=>{
        if (!allowDownload) return;
        fetch(`${"https://rest.yourhr.space"}/file/${file === null || file === void 0 ? void 0 : file.slug}?account=${clientRef}`, {
            method: "GET",
            headers: {
                "x-auth-token": authToken,
                ...(0, _capacitor.getCapacitorHeaders)()
            }
        }).then(async (res)=>{
            return res.blob();
        }).then((blob)=>{
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.setAttribute("target", "_blank");
            a.setAttribute("download", file === null || file === void 0 ? void 0 : file.fileName);
            a.href = url;
            document.body.appendChild(a);
            a.click();
            a.remove();
        }).catch((err)=>{
            console.error(err);
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "file-library-links",
        children: filteredFiles === null || filteredFiles === void 0 ? void 0 : filteredFiles.map((file)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                type: "button",
                "data-can-download": allowDownload,
                "aria-label": "Download file",
                onClick: ()=>{
                    doDownload(file);
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgDefault.default), {
                        src: (0, _utilitiesDefault.default).getMimeIcon(file.mime),
                        label: file.description
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        children: file.fileName
                    })
                ]
            });
        })
    });
};
exports.default = FileLibraryLinks;

},{"react/jsx-runtime":"i3K7E","./svg":"4pImm","../../utilities":"fkdv9","../../utilities/capacitor":"lTR78","../hooks/fetch/useFetchResources":"wHeKG","../hooks/useStore":"l1Yj7","../../../scss/components/fileLibraryLinks.scss":"1RLsj","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"1RLsj":[function() {},{}],"g1aeh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _videoScss = require("../../../scss/components/video.scss");
var _react = require("react");
var _utilitiesJs = require("../../utilities.js");
var _utilitiesJsDefault = parcelHelpers.interopDefault(_utilitiesJs);
const YouTubeEmbed = /*#__PURE__*/ (0, _react.memo)(({ url, thumbnail, autoplay })=>{
    if (!url) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    const id = (0, _utilitiesJsDefault.default).extractYoutubeId(url);
    if (thumbnail) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
        className: "video-embed",
        src: `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`
    });
    const autoplayQs = autoplay ? "&autoplay=1" : "";
    const ytUrl = `https://www.youtube.com/embed/${id}?rel=0${autoplayQs}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
        className: "video-embed",
        src: ytUrl,
        title: "YouTube video player",
        frameborder: "0",
        allow: "autoplay; fullscreen; encrypted-media"
    });
});
exports.default = YouTubeEmbed;

},{"react/jsx-runtime":"i3K7E","../../../scss/components/video.scss":"fAOrA","react":"6wC8C","../../utilities.js":"fkdv9","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fAOrA":[function() {},{}],"vk65v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDropzone = require("react-dropzone");
var _core = require("@dnd-kit/core");
var _utilities = require("@dnd-kit/utilities");
var _userFileLibraryScss = require("../../../../scss/components/userFileLibrary.scss");
var _akarIcons = require("akar-icons");
var _dialog = require("primereact/dialog");
var _confirmdialog = require("primereact/confirmdialog");
var _svg = require("../../common/svg");
var _svgDefault = parcelHelpers.interopDefault(_svg);
var _icon = require("../../common/icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _skeleton = require("../../common/skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _editableText = require("../../common/editableText");
var _editableTextDefault = parcelHelpers.interopDefault(_editableText);
var _utilities1 = require("../../../utilities");
var _utilitiesDefault = parcelHelpers.interopDefault(_utilities1);
var _useFetchUserFiles = require("../../hooks/fetch/useFetchUserFiles");
var _useFetchUsers = require("../../hooks/fetch/useFetchUsers");
var _useStore = require("../../hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
var _capacitor = require("../../../utilities/capacitor");
const imageAccept = {
    "image/png": [
        ".png"
    ],
    "image/jpeg": [
        ".jpg",
        ".jpeg"
    ],
    "image/webp": [
        ".webp"
    ],
    "image/svg+xml": [
        ".svg"
    ],
    "image/avif": [
        ".avif"
    ]
};
const fileAccept = {
    ...imageAccept,
    "video/mp4": [
        ".mp4"
    ],
    "video/ogg": [
        ".ogv"
    ],
    "video/webm": [
        ".webm"
    ],
    "video/3gpp": [
        ".3gp",
        ".3gpp"
    ],
    "audio/mpeg3": [
        ".mp3"
    ],
    "audio/aac": [
        ".aac"
    ],
    "audio/ogg": [
        ".ogg"
    ],
    "application/vnd.ms-excel": [
        ".xls",
        ".xlsx"
    ],
    "application/msword": [
        ".doc",
        ".docx"
    ],
    "application/vnd.ms-powerpoint": [
        ".ppt",
        ".pptx"
    ],
    "application/pdf": [
        ".pdf"
    ],
    "application/rtf": [
        ".rtf"
    ],
    "text/csv": [
        ".csv"
    ],
    "text/plain": [
        ".txt"
    ],
    "application/zip": [
        ".zip"
    ],
    "application/gzip": [
        ".gzip"
    ],
    "message/rfc822": [
        ".eml"
    ],
    "application/vnd.ms-outlook": [
        ".msg"
    ]
};
const UserFileLibrary = ({ user: initUser, slug, readOnly = false, hasFolders = true, hasWelcomeText = false, title = null, helpText = null })=>{
    var _library_settingsUser, _library_settingsAdmin, _library_settingsUser1, _library_settingsAdmin1, _library_settingsUser2, _library_settingsAdmin2, _library_settingsUser3, _library_settingsAdmin3, _library_settingsUser4, _library_settingsAdmin4;
    const user = initUser || {
        id: "0"
    };
    const clientRef = (0, _useStoreDefault.default)((state)=>state.clientRef);
    const isAdmin = (0, _useStoreDefault.default)((state)=>state.getIsAdmin());
    const currentUser = (0, _useStoreDefault.default)((state)=>state.currentUser);
    const { isPayroll } = currentUser;
    const [isBusy, setIsBusy] = (0, _react.useState)(false);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [isDragging, setIsDragging] = (0, _react.useState)(false);
    const [droppedId, setDroppedId] = (0, _react.useState)(null);
    const [isDraggingOverFolder, setIsDraggingOverFolder] = (0, _react.useState)(null);
    const [path, setPath] = (0, _react.useState)("");
    const fileInputRef = (0, _react.useRef)(null);
    const sensors = (0, _core.useSensors)((0, _core.useSensor)((0, _core.PointerSensor), {
        activationConstraint: {
            distance: 6
        }
    }));
    // Reset path to when user changes
    (0, _react.useEffect)(()=>{
        setPath("");
    }, [
        user === null || user === void 0 ? void 0 : user.id,
        slug
    ]);
    const { data: me, isLoading: isMeLoading } = (0, _useFetchUsers.useFetchMe)({});
    const { data: libraries, isLoading: isLoadingLibraries } = (0, _useFetchUserFiles.useFetchFileLibraries)({
        account: clientRef,
        userId: user === null || user === void 0 ? void 0 : user.id
    });
    const { mutate: updateFile } = (0, _useFetchUserFiles.useUpdateFile)({
        account: clientRef,
        userId: user === null || user === void 0 ? void 0 : user.id,
        callback: ()=>{
            refetchFiles();
        }
    });
    (0, _react.useEffect)(()=>{
        setIsLoading(!!(isMeLoading || isLoadingLibraries));
    }, [
        isMeLoading,
        isLoadingLibraries
    ]);
    // Need to check if user is line manager of current user
    // for now just use isAdmin or accessLevel
    const isManager = isAdmin || slug === "payroll" && isPayroll || (me === null || me === void 0 ? void 0 : me.accessLevel) >= 2;
    // Is current user the same as the user being viewed?
    const isMe = me && user && (user === null || user === void 0 ? void 0 : user.id) === (me === null || me === void 0 ? void 0 : me.id);
    const library = libraries === null || libraries === void 0 ? void 0 : libraries.find((library)=>library.slug === slug);
    const { mutate: uploadFiles } = (0, _useFetchUserFiles.useAddUserFiles)({
        account: clientRef,
        userId: user === null || user === void 0 ? void 0 : user.id,
        libraryId: library === null || library === void 0 ? void 0 : library.id,
        path,
        callback: ()=>{
            setIsBusy(false);
        }
    });
    const { refetch: refetchFiles } = (0, _useFetchUserFiles.useFetchFileLibrary)({
        account: clientRef,
        libraryId: library === null || library === void 0 ? void 0 : library.id,
        userId: user === null || user === void 0 ? void 0 : user.id,
        callback: ()=>{
            setIsBusy(false);
            setDroppedId(null);
        }
    });
    const { getRootProps, getInputProps } = (0, _reactDropzone.useDropzone)({
        noClick: true,
        accept: fileAccept,
        onDrop: (files)=>{
            if (doUploadFiles && files && files.length > 0) doUploadFiles(files);
        },
        multiple: true
    });
    const dropTargetProps = getRootProps();
    const fileInputProps = getInputProps();
    const doUploadFiles = async (files)=>{
        setIsBusy(true);
        const thisFormData = new FormData();
        for(let i = 0; i < files.length; i++)thisFormData.append("upload", files[i]);
        thisFormData.append("folder", path);
        uploadFiles(thisFormData);
    };
    const doDragFileEnd = (e)=>{
        var _e_active_id, _e_active, _e_over_id, _e_over;
        const id = e === null || e === void 0 ? void 0 : (_e_active = e.active) === null || _e_active === void 0 ? void 0 : (_e_active_id = _e_active.id) === null || _e_active_id === void 0 ? void 0 : _e_active_id.substring(4);
        const overId = e === null || e === void 0 ? void 0 : (_e_over = e.over) === null || _e_over === void 0 ? void 0 : (_e_over_id = _e_over.id) === null || _e_over_id === void 0 ? void 0 : _e_over_id.substring(4);
        setIsDragging(false);
        setIsDraggingOverFolder(null);
        if (overId) {
            setDroppedId(id);
            setIsBusy(true);
            updateFile({
                id,
                path: overId
            });
        }
    };
    const doDragOver = (e)=>{
        var _e_over;
        const overId = e === null || e === void 0 ? void 0 : (_e_over = e.over) === null || _e_over === void 0 ? void 0 : _e_over.id;
        if (overId) return setIsDraggingOverFolder(overId === null || overId === void 0 ? void 0 : overId.substring(4));
        setIsDraggingOverFolder(null);
    };
    const settings = {
        access: isMe && (library === null || library === void 0 ? void 0 : (_library_settingsUser = library.settingsUser) === null || _library_settingsUser === void 0 ? void 0 : _library_settingsUser.access) || isManager && (library === null || library === void 0 ? void 0 : (_library_settingsAdmin = library.settingsAdmin) === null || _library_settingsAdmin === void 0 ? void 0 : _library_settingsAdmin.access),
        upload: isMe && (library === null || library === void 0 ? void 0 : (_library_settingsUser1 = library.settingsUser) === null || _library_settingsUser1 === void 0 ? void 0 : _library_settingsUser1.upload) || isManager && (library === null || library === void 0 ? void 0 : (_library_settingsAdmin1 = library.settingsAdmin) === null || _library_settingsAdmin1 === void 0 ? void 0 : _library_settingsAdmin1.upload),
        download: isMe && (library === null || library === void 0 ? void 0 : (_library_settingsUser2 = library.settingsUser) === null || _library_settingsUser2 === void 0 ? void 0 : _library_settingsUser2.download) || isManager && (library === null || library === void 0 ? void 0 : (_library_settingsAdmin2 = library.settingsAdmin) === null || _library_settingsAdmin2 === void 0 ? void 0 : _library_settingsAdmin2.download),
        edit: isMe && (library === null || library === void 0 ? void 0 : (_library_settingsUser3 = library.settingsUser) === null || _library_settingsUser3 === void 0 ? void 0 : _library_settingsUser3.edit) || isManager && (library === null || library === void 0 ? void 0 : (_library_settingsAdmin3 = library.settingsAdmin) === null || _library_settingsAdmin3 === void 0 ? void 0 : _library_settingsAdmin3.edit),
        delete: isMe && (library === null || library === void 0 ? void 0 : (_library_settingsUser4 = library.settingsUser) === null || _library_settingsUser4 === void 0 ? void 0 : _library_settingsUser4.delete) || isManager && (library === null || library === void 0 ? void 0 : (_library_settingsAdmin4 = library.settingsAdmin) === null || _library_settingsAdmin4 === void 0 ? void 0 : _library_settingsAdmin4.delete)
    };
    if (!(library === null || library === void 0 ? void 0 : library.global) && settings.access === false) return null;
    const libraryClass = !isBusy ? "user-file-library" : "user-file-library user-file-library__busy";
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: libraryClass,
        children: [
            title && /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: title
            }),
            helpText && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: helpText
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(UserFileLibraryToolbar, {
                library: library,
                userId: user === null || user === void 0 ? void 0 : user.id,
                path: path,
                readOnly: readOnly,
                hasFolders: hasFolders,
                fileInputProps: fileInputProps,
                fileInputRef: fileInputRef,
                onIsBusy: setIsBusy
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.DndContext), {
                sensors: sensors,
                onDragEnd: doDragFileEnd,
                onDragStart: ()=>{
                    setIsDragging(true);
                },
                onDragCancel: ()=>{
                    setIsDragging(false);
                },
                onDragOver: doDragOver,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(UserFileLibraryFilesFolders, {
                    userId: user === null || user === void 0 ? void 0 : user.id,
                    libraryId: library === null || library === void 0 ? void 0 : library.id,
                    path: path,
                    readOnly: readOnly,
                    dropTargetProps: dropTargetProps,
                    isLoading: isLoading,
                    isDragging: isDragging,
                    isDraggingOverFolder: isDraggingOverFolder,
                    droppedId: droppedId,
                    fileInputRef: fileInputRef,
                    hasFolders: hasFolders,
                    hasWelcomeText: hasWelcomeText,
                    onChangeFolder: setPath,
                    onIsBusy: setIsBusy
                })
            })
        ]
    });
};
const UserFileLibraryToolbar = ({ library, userId, path, readOnly, hasFolders, fileInputProps, fileInputRef })=>{
    var _path_split, _fileAccept_keys;
    const clientRef = (0, _useStoreDefault.default)((state)=>state.clientRef);
    const [showFolderPrompt, setShowFolderPrompt] = (0, _react.useState)(false);
    const { mutate: uploadFiles, isLoading: isUploading } = (0, _useFetchUserFiles.useAddUserFiles)({
        account: clientRef,
        userId,
        libraryId: library === null || library === void 0 ? void 0 : library.id,
        path,
        callback: ()=>{
            setShowFolderPrompt(false);
        }
    });
    const folderNameInput = (0, _react.useRef)(null);
    const pathParts = path === null || path === void 0 ? void 0 : (_path_split = path.split("/")) === null || _path_split === void 0 ? void 0 : _path_split.filter((part)=>part !== "");
    const doCreateFolder = ()=>{
        var _folderNameInput_current;
        const folderName = folderNameInput === null || folderNameInput === void 0 ? void 0 : (_folderNameInput_current = folderNameInput.current) === null || _folderNameInput_current === void 0 ? void 0 : _folderNameInput_current.value;
        if (folderName) {
            const thisFormData = new FormData();
            thisFormData.append("folder", path + folderName);
            uploadFiles(thisFormData);
        }
    };
    const doShowFileUpload = ()=>{
        var _fileInputRef_current;
        fileInputRef === null || fileInputRef === void 0 ? void 0 : (_fileInputRef_current = fileInputRef.current) === null || _fileInputRef_current === void 0 ? void 0 : _fileInputRef_current.click();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "user-file-library-toolbar",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "user-file-library-toolbar--path",
                        children: (pathParts === null || pathParts === void 0 ? void 0 : pathParts.length) > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "user-file-library-toolbar--path--item",
                                children: pathParts.map((part)=>{
                                    return part + " / ";
                                })
                            })
                        })
                    }),
                    !readOnly && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            hasFolders && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "button button__toolbar",
                                title: "Create folder",
                                "aria-label": "Create folder",
                                onClick: ()=>{
                                    setShowFolderPrompt(true);
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.FolderAdd), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "button button__toolbar",
                                title: "Upload files",
                                "aria-label": "Upload files",
                                onClick: doShowFileUpload,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.CloudUpload), {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialog.Dialog), {
                header: "Header",
                visible: showFolderPrompt,
                closable: true,
                dismissableMask: true,
                className: "confirm-dialog",
                footer: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: ()=>{
                                setShowFolderPrompt(false);
                            },
                            "aria-label": "Cancel",
                            className: "p-button p-component p-confirm-dialog-reject button button__invert",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "p-button-label p-c",
                                children: "Cancel"
                            })
                        }),
                        isUploading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            disabled: true,
                            "aria-label": "Create folder (saving)",
                            className: "p-button p-component p-confirm-dialog-accept button",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "p-button-label p-c",
                                children: "Creating folder..."
                            })
                        }),
                        !isUploading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            onClick: doCreateFolder,
                            "aria-label": "OK",
                            className: "p-button p-component p-confirm-dialog-accept button",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "p-button-label p-c",
                                children: "OK"
                            })
                        })
                    ]
                }),
                onHide: ()=>{
                    setShowFolderPrompt(false);
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "dialog-input-youtube",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                children: "Create a folder"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "confirm-inputs",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                ref: folderNameInput,
                                autoFocus: true,
                                type: "text",
                                placeholder: "Folder name",
                                "aria-label": "Folder name",
                                onKeyUp: (e)=>e.key === "Enter" && doCreateFolder()
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "file",
                style: {
                    display: "none"
                },
                // disabled={disabled}
                multiple: true,
                accept: fileAccept === null || fileAccept === void 0 ? void 0 : (_fileAccept_keys = fileAccept.keys) === null || _fileAccept_keys === void 0 ? void 0 : _fileAccept_keys.join(","),
                ...fileInputProps,
                ref: fileInputRef
            })
        ]
    });
};
const UserFileLibraryFilesFolders = ({ libraryId, userId, path = null, dropTargetProps, readOnly, isLoading, isDragging, isDraggingOverFolder, droppedId, hasWelcomeText, hasFolders, fileInputRef, onChangeFolder })=>{
    var _path_split, _library_files;
    const clientRef = (0, _useStoreDefault.default)((state)=>state.clientRef);
    const fetchProps = {
        account: clientRef,
        libraryId,
        userId
    };
    const { data: library, isLoading: isLibraryLoading, refetch: refetchFiles } = (0, _useFetchUserFiles.useFetchFileLibrary)(fetchProps);
    (0, _react.useEffect)(()=>{
        refetchFiles();
    }, [
        clientRef,
        libraryId,
        userId,
        path
    ]);
    const pathParts = path === null || path === void 0 ? void 0 : (_path_split = path.split("/")) === null || _path_split === void 0 ? void 0 : _path_split.filter((part)=>part !== "");
    const files = library === null || library === void 0 ? void 0 : (_library_files = library.files) === null || _library_files === void 0 ? void 0 : _library_files.filter((file)=>{
        if (!path || Array.isArray(pathParts) && pathParts.length === 0) return !!(!file.path || file.path === "/");
        return file.path === path;
    });
    const folders = library === null || library === void 0 ? void 0 : library.folders;
    const foldersRoot = path && path !== "/" && (0, _utilitiesDefault.default).findNested(folders, "path", path) || {
        folders
    };
    const parentPath = (foldersRoot === null || foldersRoot === void 0 ? void 0 : foldersRoot.parentPath) || "";
    const subFolders = (foldersRoot === null || foldersRoot === void 0 ? void 0 : foldersRoot.folders) && [
        ...foldersRoot === null || foldersRoot === void 0 ? void 0 : foldersRoot.folders
    ] || [];
    // If we're in a subfolder, add a back button folder
    if (foldersRoot === null || foldersRoot === void 0 ? void 0 : foldersRoot.path) subFolders.unshift({
        name: "Back",
        type: "back",
        path: parentPath || "/"
    });
    const doShowFileUpload = ()=>{
        var _fileInputRef_current;
        fileInputRef === null || fileInputRef === void 0 ? void 0 : (_fileInputRef_current = fileInputRef.current) === null || _fileInputRef_current === void 0 ? void 0 : _fileInputRef_current.click();
    };
    const skeleton = !!(isLoading || isLibraryLoading);
    if (skeleton) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
        type: "files-thumbs"
    });
    if ((!subFolders || (subFolders === null || subFolders === void 0 ? void 0 : subFolders.length) === 0) && (!files || (files === null || files === void 0 ? void 0 : files.length) === 0) && hasWelcomeText) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "user-file-library-message",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
            className: "user-file-library-file-message-button",
            onClick: doShowFileUpload,
            children: "Click to upload files to this page"
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ...dropTargetProps,
        children: [
            (subFolders === null || subFolders === void 0 ? void 0 : subFolders.length) > 0 && hasFolders && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "user-file-library-files user-file-library-files__folders",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: subFolders === null || subFolders === void 0 ? void 0 : subFolders.map((folder, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(FolderButton, {
                            folder: folder,
                            libraryId: libraryId,
                            userId: userId,
                            readonly: readOnly,
                            isDropActive: isDraggingOverFolder === (folder === null || folder === void 0 ? void 0 : folder.path),
                            onChangeFolder: onChangeFolder
                        }, i))
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(UserFileLibraryFiles, {
                files: files,
                libraryId: libraryId,
                userId: userId,
                readOnly: readOnly,
                droppedId: droppedId,
                isDragging: isDragging
            })
        ]
    });
};
const FolderButton = ({ folder, readOnly, libraryId, userId, isDropActive, onChangeFolder })=>{
    const clientRef = (0, _useStoreDefault.default)((state)=>state.clientRef);
    const fetchProps = {
        account: clientRef,
        libraryId,
        userId
    };
    const { mutate: deleteFolder } = (0, _useFetchUserFiles.useDeleteFolder)(fetchProps);
    const { mutate: renameFolder } = (0, _useFetchUserFiles.useRenameFolder)(fetchProps);
    const { setNodeRef } = (0, _core.useDroppable)({
        id: `DROP${folder === null || folder === void 0 ? void 0 : folder.path}`
    });
    const doRenameFolder = (folder, newFolder)=>{
        renameFolder({
            folder,
            newFolder
        });
    };
    const doDeleteFolder = (folder)=>{
        (0, _confirmdialog.confirmDialog)({
            message: "Are you sure you want to delete this folder, and all its contents?",
            accept: ()=>{
                deleteFolder({
                    folder
                });
            },
            className: "confirm-dialog",
            acceptClassName: "button",
            rejectClassName: "button button__invert"
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "user-file-library-files--item",
        "data-folder": folder === null || folder === void 0 ? void 0 : folder.path,
        "data-is-drop-active": isDropActive,
        ref: setNodeRef,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                className: "button button__transparent user-file-library-files--item-icon--folder",
                onClick: ()=>{
                    onChangeFolder(folder === null || folder === void 0 ? void 0 : folder.path);
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        type: "akar",
                        src: "Folder",
                        label: folder === null || folder === void 0 ? void 0 : folder.name,
                        className: "user-file-library-files--item-icon"
                    }),
                    (folder === null || folder === void 0 ? void 0 : folder.type) === "back" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        type: "akar",
                        src: "ArrowBack",
                        label: folder === null || folder === void 0 ? void 0 : folder.name,
                        className: "user-file-library-files--item-icon-overlay"
                    })
                ]
            }),
            (folder === null || folder === void 0 ? void 0 : folder.type) !== "back" && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: readOnly ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: folder === null || folder === void 0 ? void 0 : folder.name
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "user-file-library-files--item--caption",
                            children: isDropActive ? folder === null || folder === void 0 ? void 0 : folder.name : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editableTextDefault.default), {
                                value: folder === null || folder === void 0 ? void 0 : folder.name,
                                truncate: 100,
                                split: 15,
                                onSave: (value)=>{
                                    doRenameFolder(folder.path, value);
                                }
                            })
                        }),
                        !isDropActive && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "user-file-library-files--edit-icons edit-icons edit-icons--hoverable",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "button button__condensed",
                                "aria-label": "Delete folder",
                                title: "Delete folder",
                                onClick: ()=>{
                                    doDeleteFolder(folder.path);
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.TrashCan), {
                                    size: 22,
                                    strokeWidth: 1
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const UserFileLibraryFiles = ({ files, libraryId, userId, readOnly, droppedId, isDragging })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "user-file-library-files",
        children: files === null || files === void 0 ? void 0 : files.map((file, i)=>droppedId != (file === null || file === void 0 ? void 0 : file.id) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(File, {
                file: file,
                libraryId: libraryId,
                userId: userId,
                readOnly: readOnly,
                isDragging: isDragging
            }, i))
    });
};
const File = ({ file, libraryId, userId, readOnly, isDragging })=>{
    const id = `DRAG${file === null || file === void 0 ? void 0 : file.id}`;
    let { attributes, listeners, setNodeRef, transform } = (0, _core.useDraggable)({
        id
    });
    const clientRef = (0, _useStoreDefault.default)((state)=>state.clientRef);
    const authToken = (0, _useStoreDefault.default)((state)=>state.authToken);
    const currentUser = (0, _useStoreDefault.default)((state)=>state.currentUser);
    const isAdmin = (0, _useStoreDefault.default)((state)=>state.getIsAdmin());
    const fetchProps = {
        account: clientRef,
        libraryId,
        userId
    };
    const { mutate: deleteFile } = (0, _useFetchUserFiles.useDeleteFile)(fetchProps);
    const { mutate: updateFile } = (0, _useFetchUserFiles.useUpdateFile)(fetchProps);
    const doRenameFile = (fileId, value)=>{
        updateFile({
            id: fileId,
            description: value
        });
    };
    const doDownloadFile = (e, fileId, fileName)=>{
        e.preventDefault();
        fetch(`${"https://rest.yourhr.space"}/file-libraries/${fileId}?account=${clientRef}`, {
            method: "GET",
            headers: {
                "x-auth-token": authToken,
                ...(0, _capacitor.getCapacitorHeaders)()
            }
        }).then(async (res)=>{
            return res.blob();
        }).then((blob)=>{
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.setAttribute("target", "_blank");
            a.setAttribute("download", fileName);
            a.href = url;
            document.body.appendChild(a);
            a.click();
            a.remove();
        }).catch((err)=>{
            console.error(err);
        });
    };
    const doDeleteFile = (fileId)=>{
        (0, _confirmdialog.confirmDialog)({
            message: "Are you sure you want to delete this file?",
            accept: ()=>{
                deleteFile(fileId);
            },
            className: "confirm-dialog",
            acceptClassName: "button",
            rejectClassName: "button button__invert"
        });
    };
    const style = {
        // Outputs `translate3d(x, y, 0)`
        transform: (0, _utilities.CSS).Translate.toString(transform)
    };
    if (!(currentUser === null || currentUser === void 0 ? void 0 : currentUser.isHR) && !isAdmin) {
        listeners = {};
        attributes = {};
    }
    const dragListeners = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.isHR) || isAdmin ? listeners : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "user-file-library-files--item",
        ref: setNodeRef,
        "data-id": file === null || file === void 0 ? void 0 : file.id,
        style: style,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "button-unstyled user-file-library-files--item-icon",
                ...dragListeners,
                ...attributes,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgDefault.default), {
                    src: (0, _utilitiesDefault.default).getMimeIcon(file === null || file === void 0 ? void 0 : file.mime),
                    label: file === null || file === void 0 ? void 0 : file.description,
                    className: "user-file-library-files--item-icon--svg"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "user-file-library-files--item--caption",
                ...dragListeners,
                children: readOnly ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: file === null || file === void 0 ? void 0 : file.description
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editableTextDefault.default), {
                    value: file === null || file === void 0 ? void 0 : file.description,
                    truncate: 100,
                    split: 15,
                    showEditIcon: !isDragging,
                    onSave: (value)=>{
                        doRenameFile(file.id, value);
                    }
                })
            }),
            !isDragging && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "user-file-library-files--edit-icons edit-icons edit-icons--hoverable",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "button button__condensed",
                        "aria-label": "Download file",
                        title: "Download file",
                        onClick: (e)=>{
                            doDownloadFile(e, file.id, file.fileName);
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.Download), {
                            size: 22,
                            strokeWidth: 1
                        })
                    }),
                    !readOnly && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "button button__condensed",
                        "aria-label": "Delete file",
                        title: "Delete file",
                        onClick: ()=>{
                            doDeleteFile(file.id);
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _akarIcons.TrashCan), {
                            size: 22,
                            strokeWidth: 1
                        })
                    })
                ]
            })
        ]
    }, file === null || file === void 0 ? void 0 : file.id);
};
exports.default = UserFileLibrary;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","react-dropzone":"he2Zd","@dnd-kit/core":"e8EXa","@dnd-kit/utilities":"2jCCE","../../../../scss/components/userFileLibrary.scss":"cQGZ7","akar-icons":"b8xdj","primereact/dialog":"8MQX5","primereact/confirmdialog":"9Gq2y","../../common/svg":"4pImm","../../common/icon":"8WxrN","../../common/skeleton":"fLZ02","../../common/editableText":"c6jrG","../../../utilities":"fkdv9","../../hooks/fetch/useFetchUserFiles":"kyRIK","../../hooks/fetch/useFetchUsers":"4DurT","../../hooks/useStore":"l1Yj7","../../../utilities/capacitor":"lTR78","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"e8EXa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AutoScrollActivator", ()=>AutoScrollActivator);
parcelHelpers.export(exports, "DndContext", ()=>DndContext);
parcelHelpers.export(exports, "DragOverlay", ()=>DragOverlay);
parcelHelpers.export(exports, "KeyboardCode", ()=>KeyboardCode);
parcelHelpers.export(exports, "KeyboardSensor", ()=>KeyboardSensor);
parcelHelpers.export(exports, "MeasuringFrequency", ()=>MeasuringFrequency);
parcelHelpers.export(exports, "MeasuringStrategy", ()=>MeasuringStrategy);
parcelHelpers.export(exports, "MouseSensor", ()=>MouseSensor);
parcelHelpers.export(exports, "PointerSensor", ()=>PointerSensor);
parcelHelpers.export(exports, "TouchSensor", ()=>TouchSensor);
parcelHelpers.export(exports, "TraversalOrder", ()=>TraversalOrder);
parcelHelpers.export(exports, "applyModifiers", ()=>applyModifiers);
parcelHelpers.export(exports, "closestCenter", ()=>closestCenter);
parcelHelpers.export(exports, "closestCorners", ()=>closestCorners);
parcelHelpers.export(exports, "defaultAnnouncements", ()=>defaultAnnouncements);
parcelHelpers.export(exports, "defaultCoordinates", ()=>defaultCoordinates);
parcelHelpers.export(exports, "defaultDropAnimation", ()=>defaultDropAnimationConfiguration);
parcelHelpers.export(exports, "defaultDropAnimationSideEffects", ()=>defaultDropAnimationSideEffects);
parcelHelpers.export(exports, "defaultKeyboardCoordinateGetter", ()=>defaultKeyboardCoordinateGetter);
parcelHelpers.export(exports, "defaultScreenReaderInstructions", ()=>defaultScreenReaderInstructions);
parcelHelpers.export(exports, "getClientRect", ()=>getClientRect);
parcelHelpers.export(exports, "getFirstCollision", ()=>getFirstCollision);
parcelHelpers.export(exports, "getScrollableAncestors", ()=>getScrollableAncestors);
parcelHelpers.export(exports, "pointerWithin", ()=>pointerWithin);
parcelHelpers.export(exports, "rectIntersection", ()=>rectIntersection);
parcelHelpers.export(exports, "useDndContext", ()=>useDndContext);
parcelHelpers.export(exports, "useDndMonitor", ()=>useDndMonitor);
parcelHelpers.export(exports, "useDraggable", ()=>useDraggable);
parcelHelpers.export(exports, "useDroppable", ()=>useDroppable);
parcelHelpers.export(exports, "useSensor", ()=>useSensor);
parcelHelpers.export(exports, "useSensors", ()=>useSensors);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _utilities = require("@dnd-kit/utilities");
var _accessibility = require("@dnd-kit/accessibility");
const DndMonitorContext = /*#__PURE__*/ (0, _react.createContext)(null);
function useDndMonitor(listener) {
    const registerListener = (0, _react.useContext)(DndMonitorContext);
    (0, _react.useEffect)(()=>{
        if (!registerListener) throw new Error('useDndMonitor must be used within a children of <DndContext>');
        const unsubscribe = registerListener(listener);
        return unsubscribe;
    }, [
        listener,
        registerListener
    ]);
}
function useDndMonitorProvider() {
    const [listeners] = (0, _react.useState)(()=>new Set());
    const registerListener = (0, _react.useCallback)((listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    }, [
        listeners
    ]);
    const dispatch = (0, _react.useCallback)((_ref)=>{
        let { type, event } = _ref;
        listeners.forEach((listener)=>{
            var _listener$type;
            return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
        });
    }, [
        listeners
    ]);
    return [
        dispatch,
        registerListener
    ];
}
const defaultScreenReaderInstructions = {
    draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const defaultAnnouncements = {
    onDragStart (_ref) {
        let { active } = _ref;
        return "Picked up draggable item " + active.id + ".";
    },
    onDragOver (_ref2) {
        let { active, over } = _ref2;
        if (over) return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
        return "Draggable item " + active.id + " is no longer over a droppable area.";
    },
    onDragEnd (_ref3) {
        let { active, over } = _ref3;
        if (over) return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
        return "Draggable item " + active.id + " was dropped.";
    },
    onDragCancel (_ref4) {
        let { active } = _ref4;
        return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
    }
};
function Accessibility(_ref) {
    let { announcements = defaultAnnouncements, container, hiddenTextDescribedById, screenReaderInstructions = defaultScreenReaderInstructions } = _ref;
    const { announce, announcement } = (0, _accessibility.useAnnouncement)();
    const liveRegionId = (0, _utilities.useUniqueId)("DndLiveRegion");
    const [mounted, setMounted] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        setMounted(true);
    }, []);
    useDndMonitor((0, _react.useMemo)(()=>({
            onDragStart (_ref2) {
                let { active } = _ref2;
                announce(announcements.onDragStart({
                    active
                }));
            },
            onDragMove (_ref3) {
                let { active, over } = _ref3;
                if (announcements.onDragMove) announce(announcements.onDragMove({
                    active,
                    over
                }));
            },
            onDragOver (_ref4) {
                let { active, over } = _ref4;
                announce(announcements.onDragOver({
                    active,
                    over
                }));
            },
            onDragEnd (_ref5) {
                let { active, over } = _ref5;
                announce(announcements.onDragEnd({
                    active,
                    over
                }));
            },
            onDragCancel (_ref6) {
                let { active, over } = _ref6;
                announce(announcements.onDragCancel({
                    active,
                    over
                }));
            }
        }), [
        announce,
        announcements
    ]));
    if (!mounted) return null;
    const markup = (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement((0, _accessibility.HiddenText), {
        id: hiddenTextDescribedById,
        value: screenReaderInstructions.draggable
    }), (0, _reactDefault.default).createElement((0, _accessibility.LiveRegion), {
        id: liveRegionId,
        announcement: announcement
    }));
    return container ? (0, _reactDom.createPortal)(markup, container) : markup;
}
var Action;
(function(Action) {
    Action["DragStart"] = "dragStart";
    Action["DragMove"] = "dragMove";
    Action["DragEnd"] = "dragEnd";
    Action["DragCancel"] = "dragCancel";
    Action["DragOver"] = "dragOver";
    Action["RegisterDroppable"] = "registerDroppable";
    Action["SetDroppableDisabled"] = "setDroppableDisabled";
    Action["UnregisterDroppable"] = "unregisterDroppable";
})(Action || (Action = {}));
function noop() {}
function useSensor(sensor, options) {
    return (0, _react.useMemo)(()=>({
            sensor,
            options: options != null ? options : {}
        }), [
        sensor,
        options
    ]);
}
function useSensors() {
    for(var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++)sensors[_key] = arguments[_key];
    return (0, _react.useMemo)(()=>[
            ...sensors
        ].filter((sensor)=>sensor != null), [
        ...sensors
    ]);
}
const defaultCoordinates = /*#__PURE__*/ Object.freeze({
    x: 0,
    y: 0
});
/**
 * Returns the distance between two points
 */ function distanceBetween(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function getRelativeTransformOrigin(event, rect) {
    const eventCoordinates = (0, _utilities.getEventCoordinates)(event);
    if (!eventCoordinates) return '0 0';
    const transformOrigin = {
        x: (eventCoordinates.x - rect.left) / rect.width * 100,
        y: (eventCoordinates.y - rect.top) / rect.height * 100
    };
    return transformOrigin.x + "% " + transformOrigin.y + "%";
}
/**
 * Sort collisions from smallest to greatest value
 */ function sortCollisionsAsc(_ref, _ref2) {
    let { data: { value: a } } = _ref;
    let { data: { value: b } } = _ref2;
    return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */ function sortCollisionsDesc(_ref3, _ref4) {
    let { data: { value: a } } = _ref3;
    let { data: { value: b } } = _ref4;
    return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */ function cornersOfRectangle(_ref5) {
    let { left, top, height, width } = _ref5;
    return [
        {
            x: left,
            y: top
        },
        {
            x: left + width,
            y: top
        },
        {
            x: left,
            y: top + height
        },
        {
            x: left + width,
            y: top + height
        }
    ];
}
function getFirstCollision(collisions, property) {
    if (!collisions || collisions.length === 0) return null;
    const [firstCollision] = collisions;
    return property ? firstCollision[property] : firstCollision;
}
/**
 * Returns the coordinates of the center of a given ClientRect
 */ function centerOfRectangle(rect, left, top) {
    if (left === void 0) left = rect.left;
    if (top === void 0) top = rect.top;
    return {
        x: left + rect.width * 0.5,
        y: top + rect.height * 0.5
    };
}
/**
 * Returns the closest rectangles from an array of rectangles to the center of a given
 * rectangle.
 */ const closestCenter = (_ref)=>{
    let { collisionRect, droppableRects, droppableContainers } = _ref;
    const centerRect = centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const distBetween = distanceBetween(centerOfRectangle(rect), centerRect);
            collisions.push({
                id,
                data: {
                    droppableContainer,
                    value: distBetween
                }
            });
        }
    }
    return collisions.sort(sortCollisionsAsc);
};
/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */ const closestCorners = (_ref)=>{
    let { collisionRect, droppableRects, droppableContainers } = _ref;
    const corners = cornersOfRectangle(collisionRect);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const rectCorners = cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner, index)=>{
                return accumulator + distanceBetween(rectCorners[index], corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id,
                data: {
                    droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort(sortCollisionsAsc);
};
/**
 * Returns the intersecting rectangle area between two rectangles
 */ function getIntersectionRatio(entry, target) {
    const top = Math.max(target.top, entry.top);
    const left = Math.max(target.left, entry.left);
    const right = Math.min(target.left + target.width, entry.left + entry.width);
    const bottom = Math.min(target.top + target.height, entry.top + entry.height);
    const width = right - left;
    const height = bottom - top;
    if (left < right && top < bottom) {
        const targetArea = target.width * target.height;
        const entryArea = entry.width * entry.height;
        const intersectionArea = width * height;
        const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
        return Number(intersectionRatio.toFixed(4));
    } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)
    return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */ const rectIntersection = (_ref)=>{
    let { collisionRect, droppableRects, droppableContainers } = _ref;
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const intersectionRatio = getIntersectionRatio(rect, collisionRect);
            if (intersectionRatio > 0) collisions.push({
                id,
                data: {
                    droppableContainer,
                    value: intersectionRatio
                }
            });
        }
    }
    return collisions.sort(sortCollisionsDesc);
};
/**
 * Check if a given point is contained within a bounding rectangle
 */ function isPointWithinRect(point, rect) {
    const { top, left, bottom, right } = rect;
    return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
}
/**
 * Returns the rectangles that the pointer is hovering over
 */ const pointerWithin = (_ref)=>{
    let { droppableContainers, droppableRects, pointerCoordinates } = _ref;
    if (!pointerCoordinates) return [];
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect && isPointWithinRect(pointerCoordinates, rect)) {
            /* There may be more than a single rectangle intersecting
       * with the pointer coordinates. In order to sort the
       * colliding rectangles, we measure the distance between
       * the pointer and the corners of the intersecting rectangle
       */ const corners = cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner)=>{
                return accumulator + distanceBetween(pointerCoordinates, corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id,
                data: {
                    droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort(sortCollisionsAsc);
};
function adjustScale(transform, rect1, rect2) {
    return {
        ...transform,
        scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
        scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
    };
}
function getRectDelta(rect1, rect2) {
    return rect1 && rect2 ? {
        x: rect1.left - rect2.left,
        y: rect1.top - rect2.top
    } : defaultCoordinates;
}
function createRectAdjustmentFn(modifier) {
    return function adjustClientRect(rect) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((acc, adjustment)=>({
                ...acc,
                top: acc.top + modifier * adjustment.y,
                bottom: acc.bottom + modifier * adjustment.y,
                left: acc.left + modifier * adjustment.x,
                right: acc.right + modifier * adjustment.x
            }), {
            ...rect
        });
    };
}
const getAdjustedRect = /*#__PURE__*/ createRectAdjustmentFn(1);
function parseTransform(transform) {
    if (transform.startsWith('matrix3d(')) {
        const transformArray = transform.slice(9, -1).split(/, /);
        return {
            x: +transformArray[12],
            y: +transformArray[13],
            scaleX: +transformArray[0],
            scaleY: +transformArray[5]
        };
    } else if (transform.startsWith('matrix(')) {
        const transformArray = transform.slice(7, -1).split(/, /);
        return {
            x: +transformArray[4],
            y: +transformArray[5],
            scaleX: +transformArray[0],
            scaleY: +transformArray[3]
        };
    }
    return null;
}
function inverseTransform(rect, transform, transformOrigin) {
    const parsedTransform = parseTransform(transform);
    if (!parsedTransform) return rect;
    const { scaleX, scaleY, x: translateX, y: translateY } = parsedTransform;
    const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
    const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(' ') + 1));
    const w = scaleX ? rect.width / scaleX : rect.width;
    const h = scaleY ? rect.height / scaleY : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
const defaultOptions = {
    ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */ function getClientRect(element, options) {
    if (options === void 0) options = defaultOptions;
    let rect = element.getBoundingClientRect();
    if (options.ignoreTransform) {
        const { transform, transformOrigin } = (0, _utilities.getWindow)(element).getComputedStyle(element);
        if (transform) rect = inverseTransform(rect, transform, transformOrigin);
    }
    const { top, left, width, height, bottom, right } = rect;
    return {
        top,
        left,
        width,
        height,
        bottom,
        right
    };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */ function getTransformAgnosticClientRect(element) {
    return getClientRect(element, {
        ignoreTransform: true
    });
}
function getWindowClientRect(element) {
    const width = element.innerWidth;
    const height = element.innerHeight;
    return {
        top: 0,
        left: 0,
        right: width,
        bottom: height,
        width,
        height
    };
}
function isFixed(node, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, _utilities.getWindow)(node).getComputedStyle(node);
    return computedStyle.position === 'fixed';
}
function isScrollable(element, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, _utilities.getWindow)(element).getComputedStyle(element);
    const overflowRegex = /(auto|scroll|overlay)/;
    const properties = [
        'overflow',
        'overflowX',
        'overflowY'
    ];
    return properties.some((property)=>{
        const value = computedStyle[property];
        return typeof value === 'string' ? overflowRegex.test(value) : false;
    });
}
function getScrollableAncestors(element, limit) {
    const scrollParents = [];
    function findScrollableAncestors(node) {
        if (limit != null && scrollParents.length >= limit) return scrollParents;
        if (!node) return scrollParents;
        if ((0, _utilities.isDocument)(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
            scrollParents.push(node.scrollingElement);
            return scrollParents;
        }
        if (!(0, _utilities.isHTMLElement)(node) || (0, _utilities.isSVGElement)(node)) return scrollParents;
        if (scrollParents.includes(node)) return scrollParents;
        const computedStyle = (0, _utilities.getWindow)(element).getComputedStyle(node);
        if (node !== element) {
            if (isScrollable(node, computedStyle)) scrollParents.push(node);
        }
        if (isFixed(node, computedStyle)) return scrollParents;
        return findScrollableAncestors(node.parentNode);
    }
    if (!element) return scrollParents;
    return findScrollableAncestors(element);
}
function getFirstScrollableAncestor(node) {
    const [firstScrollableAncestor] = getScrollableAncestors(node, 1);
    return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function getScrollableElement(element) {
    if (!(0, _utilities.canUseDOM) || !element) return null;
    if ((0, _utilities.isWindow)(element)) return element;
    if (!(0, _utilities.isNode)(element)) return null;
    if ((0, _utilities.isDocument)(element) || element === (0, _utilities.getOwnerDocument)(element).scrollingElement) return window;
    if ((0, _utilities.isHTMLElement)(element)) return element;
    return null;
}
function getScrollXCoordinate(element) {
    if ((0, _utilities.isWindow)(element)) return element.scrollX;
    return element.scrollLeft;
}
function getScrollYCoordinate(element) {
    if ((0, _utilities.isWindow)(element)) return element.scrollY;
    return element.scrollTop;
}
function getScrollCoordinates(element) {
    return {
        x: getScrollXCoordinate(element),
        y: getScrollYCoordinate(element)
    };
}
var Direction;
(function(Direction) {
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Backward"] = -1] = "Backward";
})(Direction || (Direction = {}));
function isDocumentScrollingElement(element) {
    if (!(0, _utilities.canUseDOM) || !element) return false;
    return element === document.scrollingElement;
}
function getScrollPosition(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const dimensions = isDocumentScrollingElement(scrollingContainer) ? {
        height: window.innerHeight,
        width: window.innerWidth
    } : {
        height: scrollingContainer.clientHeight,
        width: scrollingContainer.clientWidth
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - dimensions.width,
        y: scrollingContainer.scrollHeight - dimensions.height
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop,
        isLeft,
        isBottom,
        isRight,
        maxScroll,
        minScroll
    };
}
const defaultThreshold = {
    x: 0.2,
    y: 0.2
};
function getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
    let { top, left, right, bottom } = _ref;
    if (acceleration === void 0) acceleration = 10;
    if (thresholdPercentage === void 0) thresholdPercentage = defaultThreshold;
    const { isTop, isBottom, isLeft, isRight } = getScrollPosition(scrollContainer);
    const direction = {
        x: 0,
        y: 0
    };
    const speed = {
        x: 0,
        y: 0
    };
    const threshold = {
        height: scrollContainerRect.height * thresholdPercentage.y,
        width: scrollContainerRect.width * thresholdPercentage.x
    };
    if (!isTop && top <= scrollContainerRect.top + threshold.height) {
        // Scroll Up
        direction.y = Direction.Backward;
        speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
    } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
        // Scroll Down
        direction.y = Direction.Forward;
        speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
    }
    if (!isRight && right >= scrollContainerRect.right - threshold.width) {
        // Scroll Right
        direction.x = Direction.Forward;
        speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
    } else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
        // Scroll Left
        direction.x = Direction.Backward;
        speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
    }
    return {
        direction,
        speed
    };
}
function getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        const { innerWidth, innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top, left, right, bottom } = element.getBoundingClientRect();
    return {
        top,
        left,
        right,
        bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function getScrollOffsets(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return (0, _utilities.add)(acc, getScrollCoordinates(node));
    }, defaultCoordinates);
}
function getScrollXOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + getScrollXCoordinate(node);
    }, 0);
}
function getScrollYOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + getScrollYCoordinate(node);
    }, 0);
}
function scrollIntoViewIfNeeded(element, measure) {
    if (measure === void 0) measure = getClientRect;
    if (!element) return;
    const { top, left, bottom, right } = measure(element);
    const firstScrollableAncestor = getFirstScrollableAncestor(element);
    if (!firstScrollableAncestor) return;
    if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) element.scrollIntoView({
        block: 'center',
        inline: 'center'
    });
}
const properties = [
    [
        'x',
        [
            'left',
            'right'
        ],
        getScrollXOffset
    ],
    [
        'y',
        [
            'top',
            'bottom'
        ],
        getScrollYOffset
    ]
];
class Rect {
    constructor(rect, element){
        this.rect = void 0;
        this.width = void 0;
        this.height = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.right = void 0;
        this.left = void 0;
        const scrollableAncestors = getScrollableAncestors(element);
        const scrollOffsets = getScrollOffsets(scrollableAncestors);
        this.rect = {
            ...rect
        };
        this.width = rect.width;
        this.height = rect.height;
        for (const [axis, keys, getScrollOffset] of properties)for (const key of keys)Object.defineProperty(this, key, {
            get: ()=>{
                const currentOffsets = getScrollOffset(scrollableAncestors);
                const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
                return this.rect[key] + scrollOffsetsDeltla;
            },
            enumerable: true
        });
        Object.defineProperty(this, 'rect', {
            enumerable: false
        });
    }
}
class Listeners {
    constructor(target){
        this.target = void 0;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _this$target;
                return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
            });
        };
        this.target = target;
    }
    add(eventName, handler, options) {
        var _this$target2;
        (_this$target2 = this.target) == null || _this$target2.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
}
function getEventListenerTarget(target) {
    // If the `event.target` element is removed from the document events will still be targeted
    // at it, and hence won't always bubble up to the window or document anymore.
    // If there is any risk of an element being removed while it is being dragged,
    // the best practice is to attach the event listeners directly to the target.
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
    const { EventTarget } = (0, _utilities.getWindow)(target);
    return target instanceof EventTarget ? target : (0, _utilities.getOwnerDocument)(target);
}
function hasExceededDistance(delta, measurement) {
    const dx = Math.abs(delta.x);
    const dy = Math.abs(delta.y);
    if (typeof measurement === 'number') return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
    if ('x' in measurement && 'y' in measurement) return dx > measurement.x && dy > measurement.y;
    if ('x' in measurement) return dx > measurement.x;
    if ('y' in measurement) return dy > measurement.y;
    return false;
}
var EventName;
(function(EventName) {
    EventName["Click"] = "click";
    EventName["DragStart"] = "dragstart";
    EventName["Keydown"] = "keydown";
    EventName["ContextMenu"] = "contextmenu";
    EventName["Resize"] = "resize";
    EventName["SelectionChange"] = "selectionchange";
    EventName["VisibilityChange"] = "visibilitychange";
})(EventName || (EventName = {}));
function preventDefault(event) {
    event.preventDefault();
}
function stopPropagation(event) {
    event.stopPropagation();
}
var KeyboardCode;
(function(KeyboardCode) {
    KeyboardCode["Space"] = "Space";
    KeyboardCode["Down"] = "ArrowDown";
    KeyboardCode["Right"] = "ArrowRight";
    KeyboardCode["Left"] = "ArrowLeft";
    KeyboardCode["Up"] = "ArrowUp";
    KeyboardCode["Esc"] = "Escape";
    KeyboardCode["Enter"] = "Enter";
    KeyboardCode["Tab"] = "Tab";
})(KeyboardCode || (KeyboardCode = {}));
const defaultKeyboardCodes = {
    start: [
        KeyboardCode.Space,
        KeyboardCode.Enter
    ],
    cancel: [
        KeyboardCode.Esc
    ],
    end: [
        KeyboardCode.Space,
        KeyboardCode.Enter,
        KeyboardCode.Tab
    ]
};
const defaultKeyboardCoordinateGetter = (event, _ref)=>{
    let { currentCoordinates } = _ref;
    switch(event.code){
        case KeyboardCode.Right:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x + 25
            };
        case KeyboardCode.Left:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x - 25
            };
        case KeyboardCode.Down:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y + 25
            };
        case KeyboardCode.Up:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y - 25
            };
    }
    return undefined;
};
class KeyboardSensor {
    constructor(props){
        this.props = void 0;
        this.autoScrollEnabled = false;
        this.referenceCoordinates = void 0;
        this.listeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        const { event: { target } } = props;
        this.props = props;
        this.listeners = new Listeners((0, _utilities.getOwnerDocument)(target));
        this.windowListeners = new Listeners((0, _utilities.getWindow)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
    attach() {
        this.handleStart();
        this.windowListeners.add(EventName.Resize, this.handleCancel);
        this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
        setTimeout(()=>this.listeners.add(EventName.Keydown, this.handleKeyDown));
    }
    handleStart() {
        const { activeNode, onStart } = this.props;
        const node = activeNode.node.current;
        if (node) scrollIntoViewIfNeeded(node);
        onStart(defaultCoordinates);
    }
    handleKeyDown(event) {
        if ((0, _utilities.isKeyboardEvent)(event)) {
            const { active, context, options } = this.props;
            const { keyboardCodes = defaultKeyboardCodes, coordinateGetter = defaultKeyboardCoordinateGetter, scrollBehavior = 'smooth' } = options;
            const { code } = event;
            if (keyboardCodes.end.includes(code)) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.includes(code)) {
                this.handleCancel(event);
                return;
            }
            const { collisionRect } = context.current;
            const currentCoordinates = collisionRect ? {
                x: collisionRect.left,
                y: collisionRect.top
            } : defaultCoordinates;
            if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
            const newCoordinates = coordinateGetter(event, {
                active,
                context: context.current,
                currentCoordinates
            });
            if (newCoordinates) {
                const coordinatesDelta = (0, _utilities.subtract)(newCoordinates, currentCoordinates);
                const scrollDelta = {
                    x: 0,
                    y: 0
                };
                const { scrollableAncestors } = context.current;
                for (const scrollContainer of scrollableAncestors){
                    const direction = event.code;
                    const { isTop, isRight, isLeft, isBottom, maxScroll, minScroll } = getScrollPosition(scrollContainer);
                    const scrollElementRect = getScrollElementRect(scrollContainer);
                    const clampedCoordinates = {
                        x: Math.min(direction === KeyboardCode.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === KeyboardCode.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
                        y: Math.min(direction === KeyboardCode.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === KeyboardCode.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
                    };
                    const canScrollX = direction === KeyboardCode.Right && !isRight || direction === KeyboardCode.Left && !isLeft;
                    const canScrollY = direction === KeyboardCode.Down && !isBottom || direction === KeyboardCode.Up && !isTop;
                    if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                        const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
                        const canScrollToNewCoordinates = direction === KeyboardCode.Right && newScrollCoordinates <= maxScroll.x || direction === KeyboardCode.Left && newScrollCoordinates >= minScroll.x;
                        if (canScrollToNewCoordinates && !coordinatesDelta.y) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                left: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
                        else scrollDelta.x = direction === KeyboardCode.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
                        if (scrollDelta.x) scrollContainer.scrollBy({
                            left: -scrollDelta.x,
                            behavior: scrollBehavior
                        });
                        break;
                    } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                        const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
                        const canScrollToNewCoordinates = direction === KeyboardCode.Down && newScrollCoordinates <= maxScroll.y || direction === KeyboardCode.Up && newScrollCoordinates >= minScroll.y;
                        if (canScrollToNewCoordinates && !coordinatesDelta.x) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                top: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
                        else scrollDelta.y = direction === KeyboardCode.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
                        if (scrollDelta.y) scrollContainer.scrollBy({
                            top: -scrollDelta.y,
                            behavior: scrollBehavior
                        });
                        break;
                    }
                }
                this.handleMove(event, (0, _utilities.add)((0, _utilities.subtract)(newCoordinates, this.referenceCoordinates), scrollDelta));
            }
        }
    }
    handleMove(event, coordinates) {
        const { onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
    }
    handleEnd(event) {
        const { onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel } = this.props;
        event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
}
KeyboardSensor.activators = [
    {
        eventName: 'onKeyDown',
        handler: (event, _ref, _ref2)=>{
            let { keyboardCodes = defaultKeyboardCodes, onActivation } = _ref;
            let { active } = _ref2;
            const { code } = event.nativeEvent;
            if (keyboardCodes.start.includes(code)) {
                const activator = active.activatorNode.current;
                if (activator && event.target !== activator) return false;
                event.preventDefault();
                onActivation == null || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    }
];
function isDistanceConstraint(constraint) {
    return Boolean(constraint && 'distance' in constraint);
}
function isDelayConstraint(constraint) {
    return Boolean(constraint && 'delay' in constraint);
}
class AbstractPointerSensor {
    constructor(props, events, listenerTarget){
        var _getEventCoordinates;
        if (listenerTarget === void 0) listenerTarget = getEventListenerTarget(props.event.target);
        this.props = void 0;
        this.events = void 0;
        this.autoScrollEnabled = true;
        this.document = void 0;
        this.activated = false;
        this.initialCoordinates = void 0;
        this.timeoutId = null;
        this.listeners = void 0;
        this.documentListeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        this.events = events;
        const { event } = props;
        const { target } = event;
        this.props = props;
        this.events = events;
        this.document = (0, _utilities.getOwnerDocument)(target);
        this.documentListeners = new Listeners(this.document);
        this.listeners = new Listeners(listenerTarget);
        this.windowListeners = new Listeners((0, _utilities.getWindow)(target));
        this.initialCoordinates = (_getEventCoordinates = (0, _utilities.getEventCoordinates)(event)) != null ? _getEventCoordinates : defaultCoordinates;
        this.handleStart = this.handleStart.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.removeTextSelection = this.removeTextSelection.bind(this);
        this.attach();
    }
    attach() {
        const { events, props: { options: { activationConstraint, bypassActivationConstraint } } } = this;
        this.listeners.add(events.move.name, this.handleMove, {
            passive: false
        });
        this.listeners.add(events.end.name, this.handleEnd);
        if (events.cancel) this.listeners.add(events.cancel.name, this.handleCancel);
        this.windowListeners.add(EventName.Resize, this.handleCancel);
        this.windowListeners.add(EventName.DragStart, preventDefault);
        this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
        this.windowListeners.add(EventName.ContextMenu, preventDefault);
        this.documentListeners.add(EventName.Keydown, this.handleKeydown);
        if (activationConstraint) {
            if (bypassActivationConstraint != null && bypassActivationConstraint({
                event: this.props.event,
                activeNode: this.props.activeNode,
                options: this.props.options
            })) return this.handleStart();
            if (isDelayConstraint(activationConstraint)) {
                this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
                this.handlePending(activationConstraint);
                return;
            }
            if (isDistanceConstraint(activationConstraint)) {
                this.handlePending(activationConstraint);
                return;
            }
        }
        this.handleStart();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
        // This is necessary because we listen for `click` and `selection` events on the document
        setTimeout(this.documentListeners.removeAll, 50);
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    handlePending(constraint, offset) {
        const { active, onPending } = this.props;
        onPending(active, constraint, this.initialCoordinates, offset);
    }
    handleStart() {
        const { initialCoordinates } = this;
        const { onStart } = this.props;
        if (initialCoordinates) {
            this.activated = true; // Stop propagation of click events once activation constraints are met
            this.documentListeners.add(EventName.Click, stopPropagation, {
                capture: true
            }); // Remove any text selection from the document
            this.removeTextSelection(); // Prevent further text selection while dragging
            this.documentListeners.add(EventName.SelectionChange, this.removeTextSelection);
            onStart(initialCoordinates);
        }
    }
    handleMove(event) {
        var _getEventCoordinates2;
        const { activated, initialCoordinates, props } = this;
        const { onMove, options: { activationConstraint } } = props;
        if (!initialCoordinates) return;
        const coordinates = (_getEventCoordinates2 = (0, _utilities.getEventCoordinates)(event)) != null ? _getEventCoordinates2 : defaultCoordinates;
        const delta = (0, _utilities.subtract)(initialCoordinates, coordinates); // Constraint validation
        if (!activated && activationConstraint) {
            if (isDistanceConstraint(activationConstraint)) {
                if (activationConstraint.tolerance != null && hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                if (hasExceededDistance(delta, activationConstraint.distance)) return this.handleStart();
            }
            if (isDelayConstraint(activationConstraint)) {
                if (hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
            }
            this.handlePending(activationConstraint, delta);
            return;
        }
        if (event.cancelable) event.preventDefault();
        onMove(coordinates);
    }
    handleEnd() {
        const { onAbort, onEnd } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onEnd();
    }
    handleCancel() {
        const { onAbort, onCancel } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onCancel();
    }
    handleKeydown(event) {
        if (event.code === KeyboardCode.Esc) this.handleCancel();
    }
    removeTextSelection() {
        var _this$document$getSel;
        (_this$document$getSel = this.document.getSelection()) == null || _this$document$getSel.removeAllRanges();
    }
}
const events = {
    cancel: {
        name: 'pointercancel'
    },
    move: {
        name: 'pointermove'
    },
    end: {
        name: 'pointerup'
    }
};
class PointerSensor extends AbstractPointerSensor {
    constructor(props){
        const { event } = props; // Pointer events stop firing if the target is unmounted while dragging
        // Therefore we attach listeners to the owner document instead
        const listenerTarget = (0, _utilities.getOwnerDocument)(event.target);
        super(props, events, listenerTarget);
    }
}
PointerSensor.activators = [
    {
        eventName: 'onPointerDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation } = _ref2;
            if (!event.isPrimary || event.button !== 0) return false;
            onActivation == null || onActivation({
                event
            });
            return true;
        }
    }
];
const events$1 = {
    move: {
        name: 'mousemove'
    },
    end: {
        name: 'mouseup'
    }
};
var MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})(MouseButton || (MouseButton = {}));
class MouseSensor extends AbstractPointerSensor {
    constructor(props){
        super(props, events$1, (0, _utilities.getOwnerDocument)(props.event.target));
    }
}
MouseSensor.activators = [
    {
        eventName: 'onMouseDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation } = _ref2;
            if (event.button === MouseButton.RightClick) return false;
            onActivation == null || onActivation({
                event
            });
            return true;
        }
    }
];
const events$2 = {
    cancel: {
        name: 'touchcancel'
    },
    move: {
        name: 'touchmove'
    },
    end: {
        name: 'touchend'
    }
};
class TouchSensor extends AbstractPointerSensor {
    constructor(props){
        super(props, events$2);
    }
    static setup() {
        // Adding a non-capture and non-passive `touchmove` listener in order
        // to force `event.preventDefault()` calls to work in dynamically added
        // touchmove event handlers. This is required for iOS Safari.
        window.addEventListener(events$2.move.name, noop, {
            capture: false,
            passive: false
        });
        return function teardown() {
            window.removeEventListener(events$2.move.name, noop);
        }; // We create a new handler because the teardown function of another sensor
        // could remove our event listener if we use a referentially equal listener.
        function noop() {}
    }
}
TouchSensor.activators = [
    {
        eventName: 'onTouchStart',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation } = _ref2;
            const { touches } = event;
            if (touches.length > 1) return false;
            onActivation == null || onActivation({
                event
            });
            return true;
        }
    }
];
var AutoScrollActivator;
(function(AutoScrollActivator) {
    AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
    AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})(AutoScrollActivator || (AutoScrollActivator = {}));
var TraversalOrder;
(function(TraversalOrder) {
    TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
    TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})(TraversalOrder || (TraversalOrder = {}));
function useAutoScroller(_ref) {
    let { acceleration, activator = AutoScrollActivator.Pointer, canScroll, draggingRect, enabled, interval = 5, order = TraversalOrder.TreeOrder, pointerCoordinates, scrollableAncestors, scrollableAncestorRects, delta, threshold } = _ref;
    const scrollIntent = useScrollIntent({
        delta,
        disabled: !enabled
    });
    const [setAutoScrollInterval, clearAutoScrollInterval] = (0, _utilities.useInterval)();
    const scrollSpeed = (0, _react.useRef)({
        x: 0,
        y: 0
    });
    const scrollDirection = (0, _react.useRef)({
        x: 0,
        y: 0
    });
    const rect = (0, _react.useMemo)(()=>{
        switch(activator){
            case AutoScrollActivator.Pointer:
                return pointerCoordinates ? {
                    top: pointerCoordinates.y,
                    bottom: pointerCoordinates.y,
                    left: pointerCoordinates.x,
                    right: pointerCoordinates.x
                } : null;
            case AutoScrollActivator.DraggableRect:
                return draggingRect;
        }
    }, [
        activator,
        draggingRect,
        pointerCoordinates
    ]);
    const scrollContainerRef = (0, _react.useRef)(null);
    const autoScroll = (0, _react.useCallback)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
        const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
        scrollContainer.scrollBy(scrollLeft, scrollTop);
    }, []);
    const sortedScrollableAncestors = (0, _react.useMemo)(()=>order === TraversalOrder.TreeOrder ? [
            ...scrollableAncestors
        ].reverse() : scrollableAncestors, [
        order,
        scrollableAncestors
    ]);
    (0, _react.useEffect)(()=>{
        if (!enabled || !scrollableAncestors.length || !rect) {
            clearAutoScrollInterval();
            return;
        }
        for (const scrollContainer of sortedScrollableAncestors){
            if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) continue;
            const index = scrollableAncestors.indexOf(scrollContainer);
            const scrollContainerRect = scrollableAncestorRects[index];
            if (!scrollContainerRect) continue;
            const { direction, speed } = getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
            for (const axis of [
                'x',
                'y'
            ])if (!scrollIntent[axis][direction[axis]]) {
                speed[axis] = 0;
                direction[axis] = 0;
            }
            if (speed.x > 0 || speed.y > 0) {
                clearAutoScrollInterval();
                scrollContainerRef.current = scrollContainer;
                setAutoScrollInterval(autoScroll, interval);
                scrollSpeed.current = speed;
                scrollDirection.current = direction;
                return;
            }
        }
        scrollSpeed.current = {
            x: 0,
            y: 0
        };
        scrollDirection.current = {
            x: 0,
            y: 0
        };
        clearAutoScrollInterval();
    }, [
        acceleration,
        autoScroll,
        canScroll,
        clearAutoScrollInterval,
        enabled,
        interval,
        JSON.stringify(rect),
        JSON.stringify(scrollIntent),
        setAutoScrollInterval,
        scrollableAncestors,
        sortedScrollableAncestors,
        scrollableAncestorRects,
        JSON.stringify(threshold)
    ]);
}
const defaultScrollIntent = {
    x: {
        [Direction.Backward]: false,
        [Direction.Forward]: false
    },
    y: {
        [Direction.Backward]: false,
        [Direction.Forward]: false
    }
};
function useScrollIntent(_ref2) {
    let { delta, disabled } = _ref2;
    const previousDelta = (0, _utilities.usePrevious)(delta);
    return (0, _utilities.useLazyMemo)((previousIntent)=>{
        if (disabled || !previousDelta || !previousIntent) // Reset scroll intent tracking when auto-scrolling is disabled
        return defaultScrollIntent;
        const direction = {
            x: Math.sign(delta.x - previousDelta.x),
            y: Math.sign(delta.y - previousDelta.y)
        }; // Keep track of the user intent to scroll in each direction for both axis
        return {
            x: {
                [Direction.Backward]: previousIntent.x[Direction.Backward] || direction.x === -1,
                [Direction.Forward]: previousIntent.x[Direction.Forward] || direction.x === 1
            },
            y: {
                [Direction.Backward]: previousIntent.y[Direction.Backward] || direction.y === -1,
                [Direction.Forward]: previousIntent.y[Direction.Forward] || direction.y === 1
            }
        };
    }, [
        disabled,
        delta,
        previousDelta
    ]);
}
function useCachedNode(draggableNodes, id) {
    const draggableNode = id != null ? draggableNodes.get(id) : undefined;
    const node = draggableNode ? draggableNode.node.current : null;
    return (0, _utilities.useLazyMemo)((cachedNode)=>{
        var _ref;
        if (id == null) return null;
         // In some cases, the draggable node can unmount while dragging
        // This is the case for virtualized lists. In those situations,
        // we fall back to the last known value for that node.
        return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
    }, [
        node,
        id
    ]);
}
function useCombineActivators(sensors, getSyntheticHandler) {
    return (0, _react.useMemo)(()=>sensors.reduce((accumulator, sensor)=>{
            const { sensor: Sensor } = sensor;
            const sensorActivators = Sensor.activators.map((activator)=>({
                    eventName: activator.eventName,
                    handler: getSyntheticHandler(activator.handler, sensor)
                }));
            return [
                ...accumulator,
                ...sensorActivators
            ];
        }, []), [
        sensors,
        getSyntheticHandler
    ]);
}
var MeasuringStrategy;
(function(MeasuringStrategy) {
    MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
    MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
    MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})(MeasuringStrategy || (MeasuringStrategy = {}));
var MeasuringFrequency;
(function(MeasuringFrequency) {
    MeasuringFrequency["Optimized"] = "optimized";
})(MeasuringFrequency || (MeasuringFrequency = {}));
const defaultValue = /*#__PURE__*/ new Map();
function useDroppableMeasuring(containers, _ref) {
    let { dragging, dependencies, config } = _ref;
    const [queue, setQueue] = (0, _react.useState)(null);
    const { frequency, measure, strategy } = config;
    const containersRef = (0, _react.useRef)(containers);
    const disabled = isDisabled();
    const disabledRef = (0, _utilities.useLatestValue)(disabled);
    const measureDroppableContainers = (0, _react.useCallback)(function(ids) {
        if (ids === void 0) ids = [];
        if (disabledRef.current) return;
        setQueue((value)=>{
            if (value === null) return ids;
            return value.concat(ids.filter((id)=>!value.includes(id)));
        });
    }, [
        disabledRef
    ]);
    const timeoutId = (0, _react.useRef)(null);
    const droppableRects = (0, _utilities.useLazyMemo)((previousValue)=>{
        if (disabled && !dragging) return defaultValue;
        if (!previousValue || previousValue === defaultValue || containersRef.current !== containers || queue != null) {
            const map = new Map();
            for (let container of containers){
                if (!container) continue;
                if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
                    // This container does not need to be re-measured
                    map.set(container.id, container.rect.current);
                    continue;
                }
                const node = container.node.current;
                const rect = node ? new Rect(measure(node), node) : null;
                container.rect.current = rect;
                if (rect) map.set(container.id, rect);
            }
            return map;
        }
        return previousValue;
    }, [
        containers,
        queue,
        dragging,
        disabled,
        measure
    ]);
    (0, _react.useEffect)(()=>{
        containersRef.current = containers;
    }, [
        containers
    ]);
    (0, _react.useEffect)(()=>{
        if (disabled) return;
        measureDroppableContainers();
    }, [
        dragging,
        disabled
    ]);
    (0, _react.useEffect)(()=>{
        if (queue && queue.length > 0) setQueue(null);
    }, [
        JSON.stringify(queue)
    ]);
    (0, _react.useEffect)(()=>{
        if (disabled || typeof frequency !== 'number' || timeoutId.current !== null) return;
        timeoutId.current = setTimeout(()=>{
            measureDroppableContainers();
            timeoutId.current = null;
        }, frequency);
    }, [
        frequency,
        disabled,
        measureDroppableContainers,
        ...dependencies
    ]);
    return {
        droppableRects,
        measureDroppableContainers,
        measuringScheduled: queue != null
    };
    function isDisabled() {
        switch(strategy){
            case MeasuringStrategy.Always:
                return false;
            case MeasuringStrategy.BeforeDragging:
                return dragging;
            default:
                return !dragging;
        }
    }
}
function useInitialValue(value, computeFn) {
    return (0, _utilities.useLazyMemo)((previousValue)=>{
        if (!value) return null;
        if (previousValue) return previousValue;
        return typeof computeFn === 'function' ? computeFn(value) : value;
    }, [
        computeFn,
        value
    ]);
}
function useInitialRect(node, measure) {
    return useInitialValue(node, measure);
}
/**
 * Returns a new MutationObserver instance.
 * If `MutationObserver` is undefined in the execution environment, returns `undefined`.
 */ function useMutationObserver(_ref) {
    let { callback, disabled } = _ref;
    const handleMutations = (0, _utilities.useEvent)(callback);
    const mutationObserver = (0, _react.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.MutationObserver === 'undefined') return undefined;
        const { MutationObserver } = window;
        return new MutationObserver(handleMutations);
    }, [
        handleMutations,
        disabled
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }, [
        mutationObserver
    ]);
    return mutationObserver;
}
/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */ function useResizeObserver(_ref) {
    let { callback, disabled } = _ref;
    const handleResize = (0, _utilities.useEvent)(callback);
    const resizeObserver = (0, _react.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.ResizeObserver === 'undefined') return undefined;
        const { ResizeObserver } = window;
        return new ResizeObserver(handleResize);
    }, [
        disabled
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>resizeObserver == null ? void 0 : resizeObserver.disconnect();
    }, [
        resizeObserver
    ]);
    return resizeObserver;
}
function defaultMeasure(element) {
    return new Rect(getClientRect(element), element);
}
function useRect(element, measure, fallbackRect) {
    if (measure === void 0) measure = defaultMeasure;
    const [rect, setRect] = (0, _react.useState)(null);
    function measureRect() {
        setRect((currentRect)=>{
            if (!element) return null;
            if (element.isConnected === false) {
                var _ref;
                // Fall back to last rect we measured if the element is
                // no longer connected to the DOM.
                return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
            }
            const newRect = measure(element);
            if (JSON.stringify(currentRect) === JSON.stringify(newRect)) return currentRect;
            return newRect;
        });
    }
    const mutationObserver = useMutationObserver({
        callback (records) {
            if (!element) return;
            for (const record of records){
                const { type, target } = record;
                if (type === 'childList' && target instanceof HTMLElement && target.contains(element)) {
                    measureRect();
                    break;
                }
            }
        }
    });
    const resizeObserver = useResizeObserver({
        callback: measureRect
    });
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        measureRect();
        if (element) {
            resizeObserver == null || resizeObserver.observe(element);
            mutationObserver == null || mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else {
            resizeObserver == null || resizeObserver.disconnect();
            mutationObserver == null || mutationObserver.disconnect();
        }
    }, [
        element
    ]);
    return rect;
}
function useRectDelta(rect) {
    const initialRect = useInitialValue(rect);
    return getRectDelta(rect, initialRect);
}
const defaultValue$1 = [];
function useScrollableAncestors(node) {
    const previousNode = (0, _react.useRef)(node);
    const ancestors = (0, _utilities.useLazyMemo)((previousValue)=>{
        if (!node) return defaultValue$1;
        if (previousValue && previousValue !== defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) return previousValue;
        return getScrollableAncestors(node);
    }, [
        node
    ]);
    (0, _react.useEffect)(()=>{
        previousNode.current = node;
    }, [
        node
    ]);
    return ancestors;
}
function useScrollOffsets(elements) {
    const [scrollCoordinates, setScrollCoordinates] = (0, _react.useState)(null);
    const prevElements = (0, _react.useRef)(elements); // To-do: Throttle the handleScroll callback
    const handleScroll = (0, _react.useCallback)((event)=>{
        const scrollingElement = getScrollableElement(event.target);
        if (!scrollingElement) return;
        setScrollCoordinates((scrollCoordinates)=>{
            if (!scrollCoordinates) return null;
            scrollCoordinates.set(scrollingElement, getScrollCoordinates(scrollingElement));
            return new Map(scrollCoordinates);
        });
    }, []);
    (0, _react.useEffect)(()=>{
        const previousElements = prevElements.current;
        if (elements !== previousElements) {
            cleanup(previousElements);
            const entries = elements.map((element)=>{
                const scrollableElement = getScrollableElement(element);
                if (scrollableElement) {
                    scrollableElement.addEventListener('scroll', handleScroll, {
                        passive: true
                    });
                    return [
                        scrollableElement,
                        getScrollCoordinates(scrollableElement)
                    ];
                }
                return null;
            }).filter((entry)=>entry != null);
            setScrollCoordinates(entries.length ? new Map(entries) : null);
            prevElements.current = elements;
        }
        return ()=>{
            cleanup(elements);
            cleanup(previousElements);
        };
        function cleanup(elements) {
            elements.forEach((element)=>{
                const scrollableElement = getScrollableElement(element);
                scrollableElement == null || scrollableElement.removeEventListener('scroll', handleScroll);
            });
        }
    }, [
        handleScroll,
        elements
    ]);
    return (0, _react.useMemo)(()=>{
        if (elements.length) return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates)=>(0, _utilities.add)(acc, coordinates), defaultCoordinates) : getScrollOffsets(elements);
        return defaultCoordinates;
    }, [
        elements,
        scrollCoordinates
    ]);
}
function useScrollOffsetsDelta(scrollOffsets, dependencies) {
    if (dependencies === void 0) dependencies = [];
    const initialScrollOffsets = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        initialScrollOffsets.current = null;
    }, dependencies);
    (0, _react.useEffect)(()=>{
        const hasScrollOffsets = scrollOffsets !== defaultCoordinates;
        if (hasScrollOffsets && !initialScrollOffsets.current) initialScrollOffsets.current = scrollOffsets;
        if (!hasScrollOffsets && initialScrollOffsets.current) initialScrollOffsets.current = null;
    }, [
        scrollOffsets
    ]);
    return initialScrollOffsets.current ? (0, _utilities.subtract)(scrollOffsets, initialScrollOffsets.current) : defaultCoordinates;
}
function useSensorSetup(sensors) {
    (0, _react.useEffect)(()=>{
        if (!(0, _utilities.canUseDOM)) return;
        const teardownFns = sensors.map((_ref)=>{
            let { sensor } = _ref;
            return sensor.setup == null ? void 0 : sensor.setup();
        });
        return ()=>{
            for (const teardown of teardownFns)teardown == null || teardown();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2)=>{
        let { sensor } = _ref2;
        return sensor;
    }));
}
function useSyntheticListeners(listeners, id) {
    return (0, _react.useMemo)(()=>{
        return listeners.reduce((acc, _ref)=>{
            let { eventName, handler } = _ref;
            acc[eventName] = (event)=>{
                handler(event, id);
            };
            return acc;
        }, {});
    }, [
        listeners,
        id
    ]);
}
function useWindowRect(element) {
    return (0, _react.useMemo)(()=>element ? getWindowClientRect(element) : null, [
        element
    ]);
}
const defaultValue$2 = [];
function useRects(elements, measure) {
    if (measure === void 0) measure = getClientRect;
    const [firstElement] = elements;
    const windowRect = useWindowRect(firstElement ? (0, _utilities.getWindow)(firstElement) : null);
    const [rects, setRects] = (0, _react.useState)(defaultValue$2);
    function measureRects() {
        setRects(()=>{
            if (!elements.length) return defaultValue$2;
            return elements.map((element)=>isDocumentScrollingElement(element) ? windowRect : new Rect(measure(element), element));
        });
    }
    const resizeObserver = useResizeObserver({
        callback: measureRects
    });
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        resizeObserver == null || resizeObserver.disconnect();
        measureRects();
        elements.forEach((element)=>resizeObserver == null ? void 0 : resizeObserver.observe(element));
    }, [
        elements
    ]);
    return rects;
}
function getMeasurableNode(node) {
    if (!node) return null;
    if (node.children.length > 1) return node;
    const firstChild = node.children[0];
    return (0, _utilities.isHTMLElement)(firstChild) ? firstChild : node;
}
function useDragOverlayMeasuring(_ref) {
    let { measure } = _ref;
    const [rect, setRect] = (0, _react.useState)(null);
    const handleResize = (0, _react.useCallback)((entries)=>{
        for (const { target } of entries)if ((0, _utilities.isHTMLElement)(target)) {
            setRect((rect)=>{
                const newRect = measure(target);
                return rect ? {
                    ...rect,
                    width: newRect.width,
                    height: newRect.height
                } : newRect;
            });
            break;
        }
    }, [
        measure
    ]);
    const resizeObserver = useResizeObserver({
        callback: handleResize
    });
    const handleNodeChange = (0, _react.useCallback)((element)=>{
        const node = getMeasurableNode(element);
        resizeObserver == null || resizeObserver.disconnect();
        if (node) resizeObserver == null || resizeObserver.observe(node);
        setRect(node ? measure(node) : null);
    }, [
        measure,
        resizeObserver
    ]);
    const [nodeRef, setRef] = (0, _utilities.useNodeRef)(handleNodeChange);
    return (0, _react.useMemo)(()=>({
            nodeRef,
            rect,
            setRef
        }), [
        rect,
        nodeRef,
        setRef
    ]);
}
const defaultSensors = [
    {
        sensor: PointerSensor,
        options: {}
    },
    {
        sensor: KeyboardSensor,
        options: {}
    }
];
const defaultData = {
    current: {}
};
const defaultMeasuringConfiguration = {
    draggable: {
        measure: getTransformAgnosticClientRect
    },
    droppable: {
        measure: getTransformAgnosticClientRect,
        strategy: MeasuringStrategy.WhileDragging,
        frequency: MeasuringFrequency.Optimized
    },
    dragOverlay: {
        measure: getClientRect
    }
};
class DroppableContainersMap extends Map {
    get(id) {
        var _super$get;
        return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
    }
    toArray() {
        return Array.from(this.values());
    }
    getEnabled() {
        return this.toArray().filter((_ref)=>{
            let { disabled } = _ref;
            return !disabled;
        });
    }
    getNodeFor(id) {
        var _this$get$node$curren, _this$get;
        return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
    }
}
const defaultPublicContext = {
    activatorEvent: null,
    active: null,
    activeNode: null,
    activeNodeRect: null,
    collisions: null,
    containerNodeRect: null,
    draggableNodes: /*#__PURE__*/ new Map(),
    droppableRects: /*#__PURE__*/ new Map(),
    droppableContainers: /*#__PURE__*/ new DroppableContainersMap(),
    over: null,
    dragOverlay: {
        nodeRef: {
            current: null
        },
        rect: null,
        setRef: noop
    },
    scrollableAncestors: [],
    scrollableAncestorRects: [],
    measuringConfiguration: defaultMeasuringConfiguration,
    measureDroppableContainers: noop,
    windowRect: null,
    measuringScheduled: false
};
const defaultInternalContext = {
    activatorEvent: null,
    activators: [],
    active: null,
    activeNodeRect: null,
    ariaDescribedById: {
        draggable: ''
    },
    dispatch: noop,
    draggableNodes: /*#__PURE__*/ new Map(),
    over: null,
    measureDroppableContainers: noop
};
const InternalContext = /*#__PURE__*/ (0, _react.createContext)(defaultInternalContext);
const PublicContext = /*#__PURE__*/ (0, _react.createContext)(defaultPublicContext);
function getInitialState() {
    return {
        draggable: {
            active: null,
            initialCoordinates: {
                x: 0,
                y: 0
            },
            nodes: new Map(),
            translate: {
                x: 0,
                y: 0
            }
        },
        droppable: {
            containers: new DroppableContainersMap()
        }
    };
}
function reducer(state, action) {
    switch(action.type){
        case Action.DragStart:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    initialCoordinates: action.initialCoordinates,
                    active: action.active
                }
            };
        case Action.DragMove:
            if (state.draggable.active == null) return state;
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    translate: {
                        x: action.coordinates.x - state.draggable.initialCoordinates.x,
                        y: action.coordinates.y - state.draggable.initialCoordinates.y
                    }
                }
            };
        case Action.DragEnd:
        case Action.DragCancel:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    active: null,
                    initialCoordinates: {
                        x: 0,
                        y: 0
                    },
                    translate: {
                        x: 0,
                        y: 0
                    }
                }
            };
        case Action.RegisterDroppable:
            {
                const { element } = action;
                const { id } = element;
                const containers = new DroppableContainersMap(state.droppable.containers);
                containers.set(id, element);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers
                    }
                };
            }
        case Action.SetDroppableDisabled:
            {
                const { id, key, disabled } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new DroppableContainersMap(state.droppable.containers);
                containers.set(id, {
                    ...element,
                    disabled
                });
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers
                    }
                };
            }
        case Action.UnregisterDroppable:
            {
                const { id, key } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new DroppableContainersMap(state.droppable.containers);
                containers.delete(id);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers
                    }
                };
            }
        default:
            return state;
    }
}
function RestoreFocus(_ref) {
    let { disabled } = _ref;
    const { active, activatorEvent, draggableNodes } = (0, _react.useContext)(InternalContext);
    const previousActivatorEvent = (0, _utilities.usePrevious)(activatorEvent);
    const previousActiveId = (0, _utilities.usePrevious)(active == null ? void 0 : active.id); // Restore keyboard focus on the activator node
    (0, _react.useEffect)(()=>{
        if (disabled) return;
        if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
            if (!(0, _utilities.isKeyboardEvent)(previousActivatorEvent)) return;
            if (document.activeElement === previousActivatorEvent.target) // No need to restore focus
            return;
            const draggableNode = draggableNodes.get(previousActiveId);
            if (!draggableNode) return;
            const { activatorNode, node } = draggableNode;
            if (!activatorNode.current && !node.current) return;
            requestAnimationFrame(()=>{
                for (const element of [
                    activatorNode.current,
                    node.current
                ]){
                    if (!element) continue;
                    const focusableNode = (0, _utilities.findFirstFocusableNode)(element);
                    if (focusableNode) {
                        focusableNode.focus();
                        break;
                    }
                }
            });
        }
    }, [
        activatorEvent,
        disabled,
        draggableNodes,
        previousActiveId,
        previousActivatorEvent
    ]);
    return null;
}
function applyModifiers(modifiers, _ref) {
    let { transform, ...args } = _ref;
    return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier)=>{
        return modifier({
            transform: accumulator,
            ...args
        });
    }, transform) : transform;
}
function useMeasuringConfiguration(config) {
    return (0, _react.useMemo)(()=>({
            draggable: {
                ...defaultMeasuringConfiguration.draggable,
                ...config == null ? void 0 : config.draggable
            },
            droppable: {
                ...defaultMeasuringConfiguration.droppable,
                ...config == null ? void 0 : config.droppable
            },
            dragOverlay: {
                ...defaultMeasuringConfiguration.dragOverlay,
                ...config == null ? void 0 : config.dragOverlay
            }
        }), [
        config == null ? void 0 : config.draggable,
        config == null ? void 0 : config.droppable,
        config == null ? void 0 : config.dragOverlay
    ]);
}
function useLayoutShiftScrollCompensation(_ref) {
    let { activeNode, measure, initialRect, config = true } = _ref;
    const initialized = (0, _react.useRef)(false);
    const { x, y } = typeof config === 'boolean' ? {
        x: config,
        y: config
    } : config;
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        const disabled = !x && !y;
        if (disabled || !activeNode) {
            initialized.current = false;
            return;
        }
        if (initialized.current || !initialRect) // Return early if layout shift scroll compensation was already attempted
        // or if there is no initialRect to compare to.
        return;
         // Get the most up to date node ref for the active draggable
        const node = activeNode == null ? void 0 : activeNode.node.current;
        if (!node || node.isConnected === false) // Return early if there is no attached node ref or if the node is
        // disconnected from the document.
        return;
        const rect = measure(node);
        const rectDelta = getRectDelta(rect, initialRect);
        if (!x) rectDelta.x = 0;
        if (!y) rectDelta.y = 0;
         // Only perform layout shift scroll compensation once
        initialized.current = true;
        if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
            const firstScrollableAncestor = getFirstScrollableAncestor(node);
            if (firstScrollableAncestor) firstScrollableAncestor.scrollBy({
                top: rectDelta.y,
                left: rectDelta.x
            });
        }
    }, [
        activeNode,
        x,
        y,
        initialRect,
        measure
    ]);
}
const ActiveDraggableContext = /*#__PURE__*/ (0, _react.createContext)({
    ...defaultCoordinates,
    scaleX: 1,
    scaleY: 1
});
var Status;
(function(Status) {
    Status[Status["Uninitialized"] = 0] = "Uninitialized";
    Status[Status["Initializing"] = 1] = "Initializing";
    Status[Status["Initialized"] = 2] = "Initialized";
})(Status || (Status = {}));
const DndContext = /*#__PURE__*/ (0, _react.memo)(function DndContext(_ref) {
    var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
    let { id, accessibility, autoScroll = true, children, sensors = defaultSensors, collisionDetection = rectIntersection, measuring, modifiers, ...props } = _ref;
    const store = (0, _react.useReducer)(reducer, undefined, getInitialState);
    const [state, dispatch] = store;
    const [dispatchMonitorEvent, registerMonitorListener] = useDndMonitorProvider();
    const [status, setStatus] = (0, _react.useState)(Status.Uninitialized);
    const isInitialized = status === Status.Initialized;
    const { draggable: { active: activeId, nodes: draggableNodes, translate }, droppable: { containers: droppableContainers } } = state;
    const node = activeId != null ? draggableNodes.get(activeId) : null;
    const activeRects = (0, _react.useRef)({
        initial: null,
        translated: null
    });
    const active = (0, _react.useMemo)(()=>{
        var _node$data;
        return activeId != null ? {
            id: activeId,
            // It's possible for the active node to unmount while dragging
            data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : defaultData,
            rect: activeRects
        } : null;
    }, [
        activeId,
        node
    ]);
    const activeRef = (0, _react.useRef)(null);
    const [activeSensor, setActiveSensor] = (0, _react.useState)(null);
    const [activatorEvent, setActivatorEvent] = (0, _react.useState)(null);
    const latestProps = (0, _utilities.useLatestValue)(props, Object.values(props));
    const draggableDescribedById = (0, _utilities.useUniqueId)("DndDescribedBy", id);
    const enabledDroppableContainers = (0, _react.useMemo)(()=>droppableContainers.getEnabled(), [
        droppableContainers
    ]);
    const measuringConfiguration = useMeasuringConfiguration(measuring);
    const { droppableRects, measureDroppableContainers, measuringScheduled } = useDroppableMeasuring(enabledDroppableContainers, {
        dragging: isInitialized,
        dependencies: [
            translate.x,
            translate.y
        ],
        config: measuringConfiguration.droppable
    });
    const activeNode = useCachedNode(draggableNodes, activeId);
    const activationCoordinates = (0, _react.useMemo)(()=>activatorEvent ? (0, _utilities.getEventCoordinates)(activatorEvent) : null, [
        activatorEvent
    ]);
    const autoScrollOptions = getAutoScrollerOptions();
    const initialActiveNodeRect = useInitialRect(activeNode, measuringConfiguration.draggable.measure);
    useLayoutShiftScrollCompensation({
        activeNode: activeId != null ? draggableNodes.get(activeId) : null,
        config: autoScrollOptions.layoutShiftCompensation,
        initialRect: initialActiveNodeRect,
        measure: measuringConfiguration.draggable.measure
    });
    const activeNodeRect = useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
    const containerNodeRect = useRect(activeNode ? activeNode.parentElement : null);
    const sensorContext = (0, _react.useRef)({
        activatorEvent: null,
        active: null,
        activeNode,
        collisionRect: null,
        collisions: null,
        droppableRects,
        draggableNodes,
        draggingNode: null,
        draggingNodeRect: null,
        droppableContainers,
        over: null,
        scrollableAncestors: [],
        scrollAdjustedTranslate: null
    });
    const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
    const dragOverlay = useDragOverlayMeasuring({
        measure: measuringConfiguration.dragOverlay.measure
    }); // Use the rect of the drag overlay if it is mounted
    const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
    const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
    const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect); // The delta between the previous and new position of the draggable node
    // is only relevant when there is no drag overlay
    const nodeRectDelta = useRectDelta(usesDragOverlay ? null : activeNodeRect); // Get the window rect of the dragging node
    const windowRect = useWindowRect(draggingNode ? (0, _utilities.getWindow)(draggingNode) : null); // Get scrollable ancestors of the dragging node
    const scrollableAncestors = useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
    const scrollableAncestorRects = useRects(scrollableAncestors); // Apply modifiers
    const modifiedTranslate = applyModifiers(modifiers, {
        transform: {
            x: translate.x - nodeRectDelta.x,
            y: translate.y - nodeRectDelta.y,
            scaleX: 1,
            scaleY: 1
        },
        activatorEvent,
        active,
        activeNodeRect,
        containerNodeRect,
        draggingNodeRect,
        over: sensorContext.current.over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors,
        scrollableAncestorRects,
        windowRect
    });
    const pointerCoordinates = activationCoordinates ? (0, _utilities.add)(activationCoordinates, translate) : null;
    const scrollOffsets = useScrollOffsets(scrollableAncestors); // Represents the scroll delta since dragging was initiated
    const scrollAdjustment = useScrollOffsetsDelta(scrollOffsets); // Represents the scroll delta since the last time the active node rect was measured
    const activeNodeScrollDelta = useScrollOffsetsDelta(scrollOffsets, [
        activeNodeRect
    ]);
    const scrollAdjustedTranslate = (0, _utilities.add)(modifiedTranslate, scrollAdjustment);
    const collisionRect = draggingNodeRect ? getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
    const collisions = active && collisionRect ? collisionDetection({
        active,
        collisionRect,
        droppableRects,
        droppableContainers: enabledDroppableContainers,
        pointerCoordinates
    }) : null;
    const overId = getFirstCollision(collisions, 'id');
    const [over, setOver] = (0, _react.useState)(null); // When there is no drag overlay used, we need to account for the
    // window scroll delta
    const appliedTranslate = usesDragOverlay ? modifiedTranslate : (0, _utilities.add)(modifiedTranslate, activeNodeScrollDelta);
    const transform = adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
    const activeSensorRef = (0, _react.useRef)(null);
    const instantiateSensor = (0, _react.useCallback)((event, _ref2)=>{
        let { sensor: Sensor, options } = _ref2;
        if (activeRef.current == null) return;
        const activeNode = draggableNodes.get(activeRef.current);
        if (!activeNode) return;
        const activatorEvent = event.nativeEvent;
        const sensorInstance = new Sensor({
            active: activeRef.current,
            activeNode,
            event: activatorEvent,
            options,
            // Sensors need to be instantiated with refs for arguments that change over time
            // otherwise they are frozen in time with the stale arguments
            context: sensorContext,
            onAbort (id) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragAbort } = latestProps.current;
                const event = {
                    id
                };
                onDragAbort == null || onDragAbort(event);
                dispatchMonitorEvent({
                    type: 'onDragAbort',
                    event
                });
            },
            onPending (id, constraint, initialCoordinates, offset) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragPending } = latestProps.current;
                const event = {
                    id,
                    constraint,
                    initialCoordinates,
                    offset
                };
                onDragPending == null || onDragPending(event);
                dispatchMonitorEvent({
                    type: 'onDragPending',
                    event
                });
            },
            onStart (initialCoordinates) {
                const id = activeRef.current;
                if (id == null) return;
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragStart } = latestProps.current;
                const event = {
                    activatorEvent,
                    active: {
                        id,
                        data: draggableNode.data,
                        rect: activeRects
                    }
                };
                (0, _reactDom.unstable_batchedUpdates)(()=>{
                    onDragStart == null || onDragStart(event);
                    setStatus(Status.Initializing);
                    dispatch({
                        type: Action.DragStart,
                        initialCoordinates,
                        active: id
                    });
                    dispatchMonitorEvent({
                        type: 'onDragStart',
                        event
                    });
                    setActiveSensor(activeSensorRef.current);
                    setActivatorEvent(activatorEvent);
                });
            },
            onMove (coordinates) {
                dispatch({
                    type: Action.DragMove,
                    coordinates
                });
            },
            onEnd: createHandler(Action.DragEnd),
            onCancel: createHandler(Action.DragCancel)
        });
        activeSensorRef.current = sensorInstance;
        function createHandler(type) {
            return async function handler() {
                const { active, collisions, over, scrollAdjustedTranslate } = sensorContext.current;
                let event = null;
                if (active && scrollAdjustedTranslate) {
                    const { cancelDrop } = latestProps.current;
                    event = {
                        activatorEvent,
                        active: active,
                        collisions,
                        delta: scrollAdjustedTranslate,
                        over
                    };
                    if (type === Action.DragEnd && typeof cancelDrop === 'function') {
                        const shouldCancel = await Promise.resolve(cancelDrop(event));
                        if (shouldCancel) type = Action.DragCancel;
                    }
                }
                activeRef.current = null;
                (0, _reactDom.unstable_batchedUpdates)(()=>{
                    dispatch({
                        type
                    });
                    setStatus(Status.Uninitialized);
                    setOver(null);
                    setActiveSensor(null);
                    setActivatorEvent(null);
                    activeSensorRef.current = null;
                    const eventName = type === Action.DragEnd ? 'onDragEnd' : 'onDragCancel';
                    if (event) {
                        const handler = latestProps.current[eventName];
                        handler == null || handler(event);
                        dispatchMonitorEvent({
                            type: eventName,
                            event
                        });
                    }
                });
            };
        }
    }, [
        draggableNodes
    ]);
    const bindActivatorToSensorInstantiator = (0, _react.useCallback)((handler, sensor)=>{
        return (event, active)=>{
            const nativeEvent = event.nativeEvent;
            const activeDraggableNode = draggableNodes.get(active);
            if (activeRef.current !== null || // No active draggable
            !activeDraggableNode || // Event has already been captured
            nativeEvent.dndKit || nativeEvent.defaultPrevented) return;
            const activationContext = {
                active: activeDraggableNode
            };
            const shouldActivate = handler(event, sensor.options, activationContext);
            if (shouldActivate === true) {
                nativeEvent.dndKit = {
                    capturedBy: sensor.sensor
                };
                activeRef.current = active;
                instantiateSensor(event, sensor);
            }
        };
    }, [
        draggableNodes,
        instantiateSensor
    ]);
    const activators = useCombineActivators(sensors, bindActivatorToSensorInstantiator);
    useSensorSetup(sensors);
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        if (activeNodeRect && status === Status.Initializing) setStatus(Status.Initialized);
    }, [
        activeNodeRect,
        status
    ]);
    (0, _react.useEffect)(()=>{
        const { onDragMove } = latestProps.current;
        const { active, activatorEvent, collisions, over } = sensorContext.current;
        if (!active || !activatorEvent) return;
        const event = {
            active,
            activatorEvent,
            collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over
        };
        (0, _reactDom.unstable_batchedUpdates)(()=>{
            onDragMove == null || onDragMove(event);
            dispatchMonitorEvent({
                type: 'onDragMove',
                event
            });
        });
    }, [
        scrollAdjustedTranslate.x,
        scrollAdjustedTranslate.y
    ]);
    (0, _react.useEffect)(()=>{
        const { active, activatorEvent, collisions, droppableContainers, scrollAdjustedTranslate } = sensorContext.current;
        if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) return;
        const { onDragOver } = latestProps.current;
        const overContainer = droppableContainers.get(overId);
        const over = overContainer && overContainer.rect.current ? {
            id: overContainer.id,
            rect: overContainer.rect.current,
            data: overContainer.data,
            disabled: overContainer.disabled
        } : null;
        const event = {
            active,
            activatorEvent,
            collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over
        };
        (0, _reactDom.unstable_batchedUpdates)(()=>{
            setOver(over);
            onDragOver == null || onDragOver(event);
            dispatchMonitorEvent({
                type: 'onDragOver',
                event
            });
        });
    }, [
        overId
    ]);
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        sensorContext.current = {
            activatorEvent,
            active,
            activeNode,
            collisionRect,
            collisions,
            droppableRects,
            draggableNodes,
            draggingNode,
            draggingNodeRect,
            droppableContainers,
            over,
            scrollableAncestors,
            scrollAdjustedTranslate
        };
        activeRects.current = {
            initial: draggingNodeRect,
            translated: collisionRect
        };
    }, [
        active,
        activeNode,
        collisions,
        collisionRect,
        draggableNodes,
        draggingNode,
        draggingNodeRect,
        droppableRects,
        droppableContainers,
        over,
        scrollableAncestors,
        scrollAdjustedTranslate
    ]);
    useAutoScroller({
        ...autoScrollOptions,
        delta: translate,
        draggingRect: collisionRect,
        pointerCoordinates,
        scrollableAncestors,
        scrollableAncestorRects
    });
    const publicContext = (0, _react.useMemo)(()=>{
        const context = {
            active,
            activeNode,
            activeNodeRect,
            activatorEvent,
            collisions,
            containerNodeRect,
            dragOverlay,
            draggableNodes,
            droppableContainers,
            droppableRects,
            over,
            measureDroppableContainers,
            scrollableAncestors,
            scrollableAncestorRects,
            measuringConfiguration,
            measuringScheduled,
            windowRect
        };
        return context;
    }, [
        active,
        activeNode,
        activeNodeRect,
        activatorEvent,
        collisions,
        containerNodeRect,
        dragOverlay,
        draggableNodes,
        droppableContainers,
        droppableRects,
        over,
        measureDroppableContainers,
        scrollableAncestors,
        scrollableAncestorRects,
        measuringConfiguration,
        measuringScheduled,
        windowRect
    ]);
    const internalContext = (0, _react.useMemo)(()=>{
        const context = {
            activatorEvent,
            activators,
            active,
            activeNodeRect,
            ariaDescribedById: {
                draggable: draggableDescribedById
            },
            dispatch,
            draggableNodes,
            over,
            measureDroppableContainers
        };
        return context;
    }, [
        activatorEvent,
        activators,
        active,
        activeNodeRect,
        dispatch,
        draggableDescribedById,
        draggableNodes,
        over,
        measureDroppableContainers
    ]);
    return (0, _reactDefault.default).createElement(DndMonitorContext.Provider, {
        value: registerMonitorListener
    }, (0, _reactDefault.default).createElement(InternalContext.Provider, {
        value: internalContext
    }, (0, _reactDefault.default).createElement(PublicContext.Provider, {
        value: publicContext
    }, (0, _reactDefault.default).createElement(ActiveDraggableContext.Provider, {
        value: transform
    }, children)), (0, _reactDefault.default).createElement(RestoreFocus, {
        disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
    })), (0, _reactDefault.default).createElement(Accessibility, {
        ...accessibility,
        hiddenTextDescribedById: draggableDescribedById
    }));
    function getAutoScrollerOptions() {
        const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
        const autoScrollGloballyDisabled = typeof autoScroll === 'object' ? autoScroll.enabled === false : autoScroll === false;
        const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
        if (typeof autoScroll === 'object') return {
            ...autoScroll,
            enabled
        };
        return {
            enabled
        };
    }
});
const NullContext = /*#__PURE__*/ (0, _react.createContext)(null);
const defaultRole = 'button';
const ID_PREFIX = 'Draggable';
function useDraggable(_ref) {
    let { id, data, disabled = false, attributes } = _ref;
    const key = (0, _utilities.useUniqueId)(ID_PREFIX);
    const { activators, activatorEvent, active, activeNodeRect, ariaDescribedById, draggableNodes, over } = (0, _react.useContext)(InternalContext);
    const { role = defaultRole, roleDescription = 'draggable', tabIndex = 0 } = attributes != null ? attributes : {};
    const isDragging = (active == null ? void 0 : active.id) === id;
    const transform = (0, _react.useContext)(isDragging ? ActiveDraggableContext : NullContext);
    const [node, setNodeRef] = (0, _utilities.useNodeRef)();
    const [activatorNode, setActivatorNodeRef] = (0, _utilities.useNodeRef)();
    const listeners = useSyntheticListeners(activators, id);
    const dataRef = (0, _utilities.useLatestValue)(data);
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        draggableNodes.set(id, {
            id,
            key,
            node,
            activatorNode,
            data: dataRef
        });
        return ()=>{
            const node = draggableNodes.get(id);
            if (node && node.key === key) draggableNodes.delete(id);
        };
    }, [
        draggableNodes,
        id
    ]);
    const memoizedAttributes = (0, _react.useMemo)(()=>({
            role,
            tabIndex,
            'aria-disabled': disabled,
            'aria-pressed': isDragging && role === defaultRole ? true : undefined,
            'aria-roledescription': roleDescription,
            'aria-describedby': ariaDescribedById.draggable
        }), [
        disabled,
        role,
        tabIndex,
        isDragging,
        roleDescription,
        ariaDescribedById.draggable
    ]);
    return {
        active,
        activatorEvent,
        activeNodeRect,
        attributes: memoizedAttributes,
        isDragging,
        listeners: disabled ? undefined : listeners,
        node,
        over,
        setNodeRef,
        setActivatorNodeRef,
        transform
    };
}
function useDndContext() {
    return (0, _react.useContext)(PublicContext);
}
const ID_PREFIX$1 = 'Droppable';
const defaultResizeObserverConfig = {
    timeout: 25
};
function useDroppable(_ref) {
    let { data, disabled = false, id, resizeObserverConfig } = _ref;
    const key = (0, _utilities.useUniqueId)(ID_PREFIX$1);
    const { active, dispatch, over, measureDroppableContainers } = (0, _react.useContext)(InternalContext);
    const previous = (0, _react.useRef)({
        disabled
    });
    const resizeObserverConnected = (0, _react.useRef)(false);
    const rect = (0, _react.useRef)(null);
    const callbackId = (0, _react.useRef)(null);
    const { disabled: resizeObserverDisabled, updateMeasurementsFor, timeout: resizeObserverTimeout } = {
        ...defaultResizeObserverConfig,
        ...resizeObserverConfig
    };
    const ids = (0, _utilities.useLatestValue)(updateMeasurementsFor != null ? updateMeasurementsFor : id);
    const handleResize = (0, _react.useCallback)(()=>{
        if (!resizeObserverConnected.current) {
            // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
            // assuming the element is rendered and displayed.
            resizeObserverConnected.current = true;
            return;
        }
        if (callbackId.current != null) clearTimeout(callbackId.current);
        callbackId.current = setTimeout(()=>{
            measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [
                ids.current
            ]);
            callbackId.current = null;
        }, resizeObserverTimeout);
    }, [
        resizeObserverTimeout
    ]);
    const resizeObserver = useResizeObserver({
        callback: handleResize,
        disabled: resizeObserverDisabled || !active
    });
    const handleNodeChange = (0, _react.useCallback)((newElement, previousElement)=>{
        if (!resizeObserver) return;
        if (previousElement) {
            resizeObserver.unobserve(previousElement);
            resizeObserverConnected.current = false;
        }
        if (newElement) resizeObserver.observe(newElement);
    }, [
        resizeObserver
    ]);
    const [nodeRef, setNodeRef] = (0, _utilities.useNodeRef)(handleNodeChange);
    const dataRef = (0, _utilities.useLatestValue)(data);
    (0, _react.useEffect)(()=>{
        if (!resizeObserver || !nodeRef.current) return;
        resizeObserver.disconnect();
        resizeObserverConnected.current = false;
        resizeObserver.observe(nodeRef.current);
    }, [
        nodeRef,
        resizeObserver
    ]);
    (0, _react.useEffect)(()=>{
        dispatch({
            type: Action.RegisterDroppable,
            element: {
                id,
                key,
                disabled,
                node: nodeRef,
                rect,
                data: dataRef
            }
        });
        return ()=>dispatch({
                type: Action.UnregisterDroppable,
                key,
                id
            });
    }, [
        id
    ]);
    (0, _react.useEffect)(()=>{
        if (disabled !== previous.current.disabled) {
            dispatch({
                type: Action.SetDroppableDisabled,
                id,
                key,
                disabled
            });
            previous.current.disabled = disabled;
        }
    }, [
        id,
        key,
        disabled,
        dispatch
    ]);
    return {
        active,
        rect,
        isOver: (over == null ? void 0 : over.id) === id,
        node: nodeRef,
        over,
        setNodeRef
    };
}
function AnimationManager(_ref) {
    let { animation, children } = _ref;
    const [clonedChildren, setClonedChildren] = (0, _react.useState)(null);
    const [element, setElement] = (0, _react.useState)(null);
    const previousChildren = (0, _utilities.usePrevious)(children);
    if (!children && !clonedChildren && previousChildren) setClonedChildren(previousChildren);
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        if (!element) return;
        const key = clonedChildren == null ? void 0 : clonedChildren.key;
        const id = clonedChildren == null ? void 0 : clonedChildren.props.id;
        if (key == null || id == null) {
            setClonedChildren(null);
            return;
        }
        Promise.resolve(animation(id, element)).then(()=>{
            setClonedChildren(null);
        });
    }, [
        animation,
        clonedChildren,
        element
    ]);
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children, clonedChildren ? (0, _react.cloneElement)(clonedChildren, {
        ref: setElement
    }) : null);
}
const defaultTransform = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1
};
function NullifiedContextProvider(_ref) {
    let { children } = _ref;
    return (0, _reactDefault.default).createElement(InternalContext.Provider, {
        value: defaultInternalContext
    }, (0, _reactDefault.default).createElement(ActiveDraggableContext.Provider, {
        value: defaultTransform
    }, children));
}
const baseStyles = {
    position: 'fixed',
    touchAction: 'none'
};
const defaultTransition = (activatorEvent)=>{
    const isKeyboardActivator = (0, _utilities.isKeyboardEvent)(activatorEvent);
    return isKeyboardActivator ? 'transform 250ms ease' : undefined;
};
const PositionedOverlay = /*#__PURE__*/ (0, _react.forwardRef)((_ref, ref)=>{
    let { as, activatorEvent, adjustScale, children, className, rect, style, transform, transition = defaultTransition } = _ref;
    if (!rect) return null;
    const scaleAdjustedTransform = adjustScale ? transform : {
        ...transform,
        scaleX: 1,
        scaleY: 1
    };
    const styles = {
        ...baseStyles,
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        transform: (0, _utilities.CSS).Transform.toString(scaleAdjustedTransform),
        transformOrigin: adjustScale && activatorEvent ? getRelativeTransformOrigin(activatorEvent, rect) : undefined,
        transition: typeof transition === 'function' ? transition(activatorEvent) : transition,
        ...style
    };
    return (0, _reactDefault.default).createElement(as, {
        className,
        style: styles,
        ref
    }, children);
});
const defaultDropAnimationSideEffects = (options)=>(_ref)=>{
        let { active, dragOverlay } = _ref;
        const originalStyles = {};
        const { styles, className } = options;
        if (styles != null && styles.active) for (const [key, value] of Object.entries(styles.active)){
            if (value === undefined) continue;
            originalStyles[key] = active.node.style.getPropertyValue(key);
            active.node.style.setProperty(key, value);
        }
        if (styles != null && styles.dragOverlay) for (const [key, value] of Object.entries(styles.dragOverlay)){
            if (value === undefined) continue;
            dragOverlay.node.style.setProperty(key, value);
        }
        if (className != null && className.active) active.node.classList.add(className.active);
        if (className != null && className.dragOverlay) dragOverlay.node.classList.add(className.dragOverlay);
        return function cleanup() {
            for (const [key, value] of Object.entries(originalStyles))active.node.style.setProperty(key, value);
            if (className != null && className.active) active.node.classList.remove(className.active);
        };
    };
const defaultKeyframeResolver = (_ref2)=>{
    let { transform: { initial, final } } = _ref2;
    return [
        {
            transform: (0, _utilities.CSS).Transform.toString(initial)
        },
        {
            transform: (0, _utilities.CSS).Transform.toString(final)
        }
    ];
};
const defaultDropAnimationConfiguration = {
    duration: 250,
    easing: 'ease',
    keyframes: defaultKeyframeResolver,
    sideEffects: /*#__PURE__*/ defaultDropAnimationSideEffects({
        styles: {
            active: {
                opacity: '0'
            }
        }
    })
};
function useDropAnimation(_ref3) {
    let { config, draggableNodes, droppableContainers, measuringConfiguration } = _ref3;
    return (0, _utilities.useEvent)((id, node)=>{
        if (config === null) return;
        const activeDraggable = draggableNodes.get(id);
        if (!activeDraggable) return;
        const activeNode = activeDraggable.node.current;
        if (!activeNode) return;
        const measurableNode = getMeasurableNode(node);
        if (!measurableNode) return;
        const { transform } = (0, _utilities.getWindow)(node).getComputedStyle(node);
        const parsedTransform = parseTransform(transform);
        if (!parsedTransform) return;
        const animation = typeof config === 'function' ? config : createDefaultDropAnimation(config);
        scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
        return animation({
            active: {
                id,
                data: activeDraggable.data,
                node: activeNode,
                rect: measuringConfiguration.draggable.measure(activeNode)
            },
            draggableNodes,
            dragOverlay: {
                node,
                rect: measuringConfiguration.dragOverlay.measure(measurableNode)
            },
            droppableContainers,
            measuringConfiguration,
            transform: parsedTransform
        });
    });
}
function createDefaultDropAnimation(options) {
    const { duration, easing, sideEffects, keyframes } = {
        ...defaultDropAnimationConfiguration,
        ...options
    };
    return (_ref4)=>{
        let { active, dragOverlay, transform, ...rest } = _ref4;
        if (!duration) // Do not animate if animation duration is zero.
        return;
        const delta = {
            x: dragOverlay.rect.left - active.rect.left,
            y: dragOverlay.rect.top - active.rect.top
        };
        const scale = {
            scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
            scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
        };
        const finalTransform = {
            x: transform.x - delta.x,
            y: transform.y - delta.y,
            ...scale
        };
        const animationKeyframes = keyframes({
            ...rest,
            active,
            dragOverlay,
            transform: {
                initial: transform,
                final: finalTransform
            }
        });
        const [firstKeyframe] = animationKeyframes;
        const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];
        if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) // The start and end keyframes are the same, infer that there is no animation needed.
        return;
        const cleanup = sideEffects == null ? void 0 : sideEffects({
            active,
            dragOverlay,
            ...rest
        });
        const animation = dragOverlay.node.animate(animationKeyframes, {
            duration,
            easing,
            fill: 'forwards'
        });
        return new Promise((resolve)=>{
            animation.onfinish = ()=>{
                cleanup == null || cleanup();
                resolve();
            };
        });
    };
}
let key = 0;
function useKey(id) {
    return (0, _react.useMemo)(()=>{
        if (id == null) return;
        key++;
        return key;
    }, [
        id
    ]);
}
const DragOverlay = /*#__PURE__*/ (0, _reactDefault.default).memo((_ref)=>{
    let { adjustScale = false, children, dropAnimation: dropAnimationConfig, style, transition, modifiers, wrapperElement = 'div', className, zIndex = 999 } = _ref;
    const { activatorEvent, active, activeNodeRect, containerNodeRect, draggableNodes, droppableContainers, dragOverlay, over, measuringConfiguration, scrollableAncestors, scrollableAncestorRects, windowRect } = useDndContext();
    const transform = (0, _react.useContext)(ActiveDraggableContext);
    const key = useKey(active == null ? void 0 : active.id);
    const modifiedTransform = applyModifiers(modifiers, {
        activatorEvent,
        active,
        activeNodeRect,
        containerNodeRect,
        draggingNodeRect: dragOverlay.rect,
        over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors,
        scrollableAncestorRects,
        transform,
        windowRect
    });
    const initialRect = useInitialValue(activeNodeRect);
    const dropAnimation = useDropAnimation({
        config: dropAnimationConfig,
        draggableNodes,
        droppableContainers,
        measuringConfiguration
    }); // We need to wait for the active node to be measured before connecting the drag overlay ref
    // otherwise collisions can be computed against a mispositioned drag overlay
    const ref = initialRect ? dragOverlay.setRef : undefined;
    return (0, _reactDefault.default).createElement(NullifiedContextProvider, null, (0, _reactDefault.default).createElement(AnimationManager, {
        animation: dropAnimation
    }, active && key ? (0, _reactDefault.default).createElement(PositionedOverlay, {
        key: key,
        id: active.id,
        ref: ref,
        as: wrapperElement,
        activatorEvent: activatorEvent,
        adjustScale: adjustScale,
        className: className,
        transition: transition,
        rect: initialRect,
        style: {
            zIndex,
            ...style
        },
        transform: modifiedTransform
    }, children) : null));
});

},{"react":"6wC8C","react-dom":"7k58v","@dnd-kit/utilities":"2jCCE","@dnd-kit/accessibility":"fALPo","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"2jCCE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSS", ()=>CSS);
parcelHelpers.export(exports, "add", ()=>add);
parcelHelpers.export(exports, "canUseDOM", ()=>canUseDOM);
parcelHelpers.export(exports, "findFirstFocusableNode", ()=>findFirstFocusableNode);
parcelHelpers.export(exports, "getEventCoordinates", ()=>getEventCoordinates);
parcelHelpers.export(exports, "getOwnerDocument", ()=>getOwnerDocument);
parcelHelpers.export(exports, "getWindow", ()=>getWindow);
parcelHelpers.export(exports, "hasViewportRelativeCoordinates", ()=>hasViewportRelativeCoordinates);
parcelHelpers.export(exports, "isDocument", ()=>isDocument);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isKeyboardEvent", ()=>isKeyboardEvent);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isSVGElement", ()=>isSVGElement);
parcelHelpers.export(exports, "isTouchEvent", ()=>isTouchEvent);
parcelHelpers.export(exports, "isWindow", ()=>isWindow);
parcelHelpers.export(exports, "subtract", ()=>subtract);
parcelHelpers.export(exports, "useCombinedRefs", ()=>useCombinedRefs);
parcelHelpers.export(exports, "useEvent", ()=>useEvent);
parcelHelpers.export(exports, "useInterval", ()=>useInterval);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
parcelHelpers.export(exports, "useLatestValue", ()=>useLatestValue);
parcelHelpers.export(exports, "useLazyMemo", ()=>useLazyMemo);
parcelHelpers.export(exports, "useNodeRef", ()=>useNodeRef);
parcelHelpers.export(exports, "usePrevious", ()=>usePrevious);
parcelHelpers.export(exports, "useUniqueId", ()=>useUniqueId);
var _react = require("react");
function useCombinedRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (0, _react.useMemo)(()=>(node)=>{
            refs.forEach((ref)=>ref(node));
        }, refs);
}
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const canUseDOM = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
function isWindow(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === '[object Window]' || // In Electron context the Window object serializes to [object global]
    elementString === '[object global]';
}
function isNode(node) {
    return 'nodeType' in node;
}
function getWindow(target) {
    var _target$ownerDocument, _target$ownerDocument2;
    if (!target) return window;
    if (isWindow(target)) return target;
    if (!isNode(target)) return window;
    return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function isDocument(node) {
    const { Document } = getWindow(node);
    return node instanceof Document;
}
function isHTMLElement(node) {
    if (isWindow(node)) return false;
    return node instanceof getWindow(node).HTMLElement;
}
function isSVGElement(node) {
    return node instanceof getWindow(node).SVGElement;
}
function getOwnerDocument(target) {
    if (!target) return document;
    if (isWindow(target)) return target.document;
    if (!isNode(target)) return document;
    if (isDocument(target)) return target;
    if (isHTMLElement(target) || isSVGElement(target)) return target.ownerDocument;
    return document;
}
/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */ const useIsomorphicLayoutEffect = canUseDOM ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
function useEvent(handler) {
    const handlerRef = (0, _react.useRef)(handler);
    useIsomorphicLayoutEffect(()=>{
        handlerRef.current = handler;
    });
    return (0, _react.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return handlerRef.current == null ? void 0 : handlerRef.current(...args);
    }, []);
}
function useInterval() {
    const intervalRef = (0, _react.useRef)(null);
    const set = (0, _react.useCallback)((listener, duration)=>{
        intervalRef.current = setInterval(listener, duration);
    }, []);
    const clear = (0, _react.useCallback)(()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    return [
        set,
        clear
    ];
}
function useLatestValue(value, dependencies) {
    if (dependencies === void 0) dependencies = [
        value
    ];
    const valueRef = (0, _react.useRef)(value);
    useIsomorphicLayoutEffect(()=>{
        if (valueRef.current !== value) valueRef.current = value;
    }, dependencies);
    return valueRef;
}
function useLazyMemo(callback, dependencies) {
    const valueRef = (0, _react.useRef)();
    return (0, _react.useMemo)(()=>{
        const newValue = callback(valueRef.current);
        valueRef.current = newValue;
        return newValue;
    }, [
        ...dependencies
    ]);
}
function useNodeRef(onChange) {
    const onChangeHandler = useEvent(onChange);
    const node = (0, _react.useRef)(null);
    const setNodeRef = (0, _react.useCallback)((element)=>{
        if (element !== node.current) onChangeHandler == null || onChangeHandler(element, node.current);
        node.current = element;
    }, []);
    return [
        node,
        setNodeRef
    ];
}
function usePrevious(value) {
    const ref = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
let ids = {};
function useUniqueId(prefix, value) {
    return (0, _react.useMemo)(()=>{
        if (value) return value;
        const id = ids[prefix] == null ? 0 : ids[prefix] + 1;
        ids[prefix] = id;
        return prefix + "-" + id;
    }, [
        prefix,
        value
    ]);
}
function createAdjustmentFn(modifier) {
    return function(object) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((accumulator, adjustment)=>{
            const entries = Object.entries(adjustment);
            for (const [key, valueAdjustment] of entries){
                const value = accumulator[key];
                if (value != null) accumulator[key] = value + modifier * valueAdjustment;
            }
            return accumulator;
        }, {
            ...object
        });
    };
}
const add = /*#__PURE__*/ createAdjustmentFn(1);
const subtract = /*#__PURE__*/ createAdjustmentFn(-1);
function hasViewportRelativeCoordinates(event) {
    return 'clientX' in event && 'clientY' in event;
}
function isKeyboardEvent(event) {
    if (!event) return false;
    const { KeyboardEvent } = getWindow(event.target);
    return KeyboardEvent && event instanceof KeyboardEvent;
}
function isTouchEvent(event) {
    if (!event) return false;
    const { TouchEvent } = getWindow(event.target);
    return TouchEvent && event instanceof TouchEvent;
}
/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */ function getEventCoordinates(event) {
    if (isTouchEvent(event)) {
        if (event.touches && event.touches.length) {
            const { clientX: x, clientY: y } = event.touches[0];
            return {
                x,
                y
            };
        } else if (event.changedTouches && event.changedTouches.length) {
            const { clientX: x, clientY: y } = event.changedTouches[0];
            return {
                x,
                y
            };
        }
    }
    if (hasViewportRelativeCoordinates(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    return null;
}
const CSS = /*#__PURE__*/ Object.freeze({
    Translate: {
        toString (transform) {
            if (!transform) return;
            const { x, y } = transform;
            return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
        }
    },
    Scale: {
        toString (transform) {
            if (!transform) return;
            const { scaleX, scaleY } = transform;
            return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }
    },
    Transform: {
        toString (transform) {
            if (!transform) return;
            return [
                CSS.Translate.toString(transform),
                CSS.Scale.toString(transform)
            ].join(' ');
        }
    },
    Transition: {
        toString (_ref) {
            let { property, duration, easing } = _ref;
            return property + " " + duration + "ms " + easing;
        }
    }
});
const SELECTOR = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]';
function findFirstFocusableNode(element) {
    if (element.matches(SELECTOR)) return element;
    return element.querySelector(SELECTOR);
}

},{"react":"6wC8C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"fALPo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HiddenText", ()=>HiddenText);
parcelHelpers.export(exports, "LiveRegion", ()=>LiveRegion);
parcelHelpers.export(exports, "useAnnouncement", ()=>useAnnouncement);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const hiddenStyles = {
    display: 'none'
};
function HiddenText(_ref) {
    let { id, value } = _ref;
    return (0, _reactDefault.default).createElement("div", {
        id: id,
        style: hiddenStyles
    }, value);
}
function LiveRegion(_ref) {
    let { id, announcement, ariaLiveType = "assertive" } = _ref;
    // Hide element visually but keep it readable by screen readers
    const visuallyHidden = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: 1,
        height: 1,
        margin: -1,
        border: 0,
        padding: 0,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(100%)',
        whiteSpace: 'nowrap'
    };
    return (0, _reactDefault.default).createElement("div", {
        id: id,
        style: visuallyHidden,
        role: "status",
        "aria-live": ariaLiveType,
        "aria-atomic": true
    }, announcement);
}
function useAnnouncement() {
    const [announcement, setAnnouncement] = (0, _react.useState)('');
    const announce = (0, _react.useCallback)((value)=>{
        if (value != null) setAnnouncement(value);
    }, []);
    return {
        announce,
        announcement
    };
}

},{"react":"6wC8C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"cQGZ7":[function() {},{}],"kyRIK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFetchFileLibraries", ()=>useFetchFileLibraries);
parcelHelpers.export(exports, "useFetchFileLibrary", ()=>useFetchFileLibrary);
parcelHelpers.export(exports, "useAddUserFiles", ()=>useAddUserFiles);
parcelHelpers.export(exports, "useDeleteFile", ()=>useDeleteFile);
parcelHelpers.export(exports, "useUpdateFile", ()=>useUpdateFile);
parcelHelpers.export(exports, "useRenameFolder", ()=>useRenameFolder);
parcelHelpers.export(exports, "useDeleteFolder", ()=>useDeleteFolder);
var _reactQuery = require("react-query");
var _fetchJs = require("../../../utilities/fetch.js");
const useFetchFileLibraries = ({ account = null, callback })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: 'userFileLibraries'
    });
    return (0, _reactQuery.useQuery)([
        'userFileLibraries',
        account
    ], ()=>(0, _fetchJs.request)({
            url: '/file-libraries',
            params: {
                account: account
            }
        }), {
        refetchInterval: false,
        staleTime: 300000,
        select: (data)=>{
            var _data_data;
            return data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.items;
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useFetchFileLibrary = ({ account = null, userId, libraryId, callback })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: 'userFileLibraries'
    });
    return (0, _reactQuery.useQuery)([
        'userFileLibrary',
        account,
        userId,
        libraryId
    ], ()=>{
        if (!userId || !libraryId) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/file-libraries/${userId}/${libraryId}`,
            params: {
                account: account
            }
        });
    }, {
        refetchInterval: false,
        refetchOnMount: true,
        refetchOnWindowFocus: true,
        staleTime: 300000,
        select: (data)=>data === null || data === void 0 ? void 0 : data.data,
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useAddUserFiles = ({ account = null, callback, userId = null, libraryId = null })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data)=>{
        for (const pair of data.entries()){
            const [key, value] = pair;
        }
        if (!userId || !libraryId) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/file-libraries/${userId}/${libraryId}`,
            method: 'post',
            params: {
                account
            },
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }, {
        mutationKey: 'userFileLibraries',
        onSuccess: async (data)=>{
            await queryClient.cancelQueries([
                'userFileLibrary',
                account,
                userId,
                libraryId
            ]);
            queryClient.invalidateQueries([
                'userFileLibrary',
                account,
                userId,
                libraryId
            ]);
            if (callback && typeof callback != 'undefined') callback(data);
        },
        onSettled: async ()=>{
            queryClient.invalidateQueries([
                'userFileLibrary',
                account,
                userId,
                libraryId
            ]);
        }
    });
};
const useDeleteFile = ({ account = null, callback, userId = null, libraryId = null })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((fileId)=>{
        if (!fileId) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/file-libraries/${fileId}`,
            method: 'delete',
            params: {
                account: account
            }
        });
    }, {
        mutationKey: 'userFileLibraries',
        onMutate: async (fileId)=>{
            var _queryClient_getQueryData;
            await queryClient.cancelQueries([
                'userFileLibrary',
                account,
                userId,
                libraryId
            ]);
            const currentLibrary = (_queryClient_getQueryData = queryClient.getQueryData([
                'userFileLibrary',
                account,
                userId,
                libraryId
            ])) === null || _queryClient_getQueryData === void 0 ? void 0 : _queryClient_getQueryData.data;
            // optimistic update data
            if (currentLibrary) {
                const files = currentLibrary === null || currentLibrary === void 0 ? void 0 : currentLibrary.files;
                const deleteIndex = files === null || files === void 0 ? void 0 : files.findIndex((file)=>(file === null || file === void 0 ? void 0 : file.id) === fileId);
                files.splice(deleteIndex, 1);
                await queryClient.setQueryData([
                    'userFileLibrary',
                    account,
                    userId,
                    libraryId
                ], {
                    data: {
                        ...currentLibrary,
                        files: [
                            ...files
                        ]
                    }
                });
                queryClient.invalidateQueries([
                    'userFileLibrary',
                    account,
                    userId,
                    libraryId
                ]);
            }
        },
        onSettled: ()=>{
            queryClient.invalidateQueries([
                'userFileLibrary',
                account,
                userId,
                libraryId
            ]);
        },
        onSuccess: (data)=>{
            if (callback && typeof callback != 'undefined') callback(data);
        }
    });
};
const useUpdateFile = ({ account = null, callback, userId = null, libraryId = null })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data)=>{
        const fileId = data.id;
        if (!fileId) return Promise.resolve({});
        delete data.id;
        return (0, _fetchJs.request)({
            url: `/file-libraries/${fileId}`,
            method: 'patch',
            data,
            params: {
                account: account
            }
        });
    }, {
        mutationKey: 'userFileLibraries',
        onMutate: async (data)=>{
            var _queryClient_getQueryData;
            const fileId = data.id;
            await queryClient.cancelQueries([
                'userFileLibrary',
                account,
                userId,
                libraryId
            ]);
            const currentLibrary = (_queryClient_getQueryData = queryClient.getQueryData([
                'userFileLibrary',
                account,
                userId,
                libraryId
            ])) === null || _queryClient_getQueryData === void 0 ? void 0 : _queryClient_getQueryData.data;
            // optimistic update data
            if (currentLibrary) {
                const files = (currentLibrary === null || currentLibrary === void 0 ? void 0 : currentLibrary.files) && [
                    ...currentLibrary === null || currentLibrary === void 0 ? void 0 : currentLibrary.files
                ];
                const fileIndex = files === null || files === void 0 ? void 0 : files.findIndex((file)=>(file === null || file === void 0 ? void 0 : file.id) === fileId);
                files[fileIndex] = {
                    ...files[fileIndex],
                    ...data
                };
                await queryClient.setQueryData([
                    'userFileLibrary',
                    account,
                    userId,
                    libraryId
                ], {
                    data: {
                        ...currentLibrary,
                        files: [
                            ...files
                        ]
                    }
                });
                queryClient.invalidateQueries([
                    'userFileLibrary',
                    account,
                    userId,
                    libraryId
                ]);
            }
        },
        onSettled: ()=>{
            queryClient.invalidateQueries([
                'userFileLibrary',
                account,
                userId,
                libraryId
            ]);
        },
        onSuccess: (data)=>{
            if (callback && typeof callback != 'undefined') callback(data);
        }
    });
};
const useRenameFolder = ({ account = null, callback, userId = null, libraryId = null })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data)=>{
        if (!data.folder || !data.newFolder || !userId || !libraryId) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/file-libraries/${userId}/${libraryId}`,
            method: 'patch',
            data,
            params: {
                account: account
            }
        });
    }, {
        mutationKey: 'userFileLibraries',
        onMutate: async (data)=>{
            var _queryClient_getQueryData;
            await queryClient.cancelQueries([
                'userFileLibrary',
                account,
                userId,
                libraryId
            ]);
            const currentLibrary = (_queryClient_getQueryData = queryClient.getQueryData([
                'userFileLibrary',
                account,
                userId,
                libraryId
            ])) === null || _queryClient_getQueryData === void 0 ? void 0 : _queryClient_getQueryData.data;
            // optimistic update data
            if (currentLibrary) {
                let files = (currentLibrary === null || currentLibrary === void 0 ? void 0 : currentLibrary.files) && [
                    ...currentLibrary === null || currentLibrary === void 0 ? void 0 : currentLibrary.files
                ];
                files = files === null || files === void 0 ? void 0 : files.map((file)=>{
                    if ((file === null || file === void 0 ? void 0 : file.path) === data.folder) file.path = data.newFolder;
                    return file;
                });
                await queryClient.setQueryData([
                    'userFileLibrary',
                    account,
                    userId,
                    libraryId
                ], {
                    data: {
                        ...currentLibrary,
                        files
                    }
                });
                queryClient.invalidateQueries([
                    'userFileLibrary',
                    account,
                    userId,
                    libraryId
                ]);
            }
        },
        onSettled: ()=>{
            queryClient.invalidateQueries([
                'userFileLibrary',
                account,
                userId,
                libraryId
            ]);
        },
        onSuccess: (data)=>{
            if (callback && typeof callback != 'undefined') callback(data);
        }
    });
};
const useDeleteFolder = ({ account = null, callback, userId = null, libraryId = null })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data)=>{
        if (!data.folder || !userId || !libraryId) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/file-libraries/${userId}/${libraryId}`,
            method: 'delete',
            data,
            params: {
                account: account
            }
        });
    }, {
        mutationKey: 'userFileLibraries',
        onMutate: async (data)=>{
            var _queryClient_getQueryData;
            await queryClient.cancelQueries([
                'userFileLibrary',
                account,
                userId,
                libraryId
            ]);
            const currentLibrary = (_queryClient_getQueryData = queryClient.getQueryData([
                'userFileLibrary',
                account,
                userId,
                libraryId
            ])) === null || _queryClient_getQueryData === void 0 ? void 0 : _queryClient_getQueryData.data;
            // optimistic update data
            if (currentLibrary) {
                let files = (currentLibrary === null || currentLibrary === void 0 ? void 0 : currentLibrary.files) && [
                    ...currentLibrary === null || currentLibrary === void 0 ? void 0 : currentLibrary.files
                ];
                files = files === null || files === void 0 ? void 0 : files.filter((file)=>{
                    return (file === null || file === void 0 ? void 0 : file.path) !== data.folder;
                });
                await queryClient.setQueryData([
                    'userFileLibrary',
                    account,
                    userId,
                    libraryId
                ], {
                    data: {
                        ...currentLibrary,
                        files
                    }
                });
                queryClient.invalidateQueries([
                    'userFileLibrary',
                    account,
                    userId,
                    libraryId
                ]);
            }
        },
        onSettled: ()=>{
            queryClient.invalidateQueries([
                'userFileLibrary',
                account,
                userId,
                libraryId
            ]);
        },
        onSuccess: (data)=>{
            if (callback && typeof callback != 'undefined') callback(data);
        }
    });
};

},{"react-query":"41hyj","../../../utilities/fetch.js":"hAKRo","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"iHhLW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _svg = require("./common/svg");
var _svgDefault = parcelHelpers.interopDefault(_svg);
var _fetchJs = require("../utilities/fetch.js");
var _useStore = require("./hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
const MainPagePDFButton = ()=>{
    const [loading, setLoading] = (0, _react.useState)(false);
    const pathParts = (0, _useStoreDefault.default)((state)=>state.getPathParts());
    const pageName = pathParts[pathParts.length - 1];
    const pdfURL = `/articles/pdf/${pageName}`;
    const doGetPDF = ()=>{
        setLoading(true);
        (0, _fetchJs.request)({
            url: pdfURL,
            params: {
                download: 1,
                format: "pdf"
            },
            responseType: "blob"
        }).then((response)=>{
            setLoading(false);
            const url = window.URL.createObjectURL(new Blob([
                response.data
            ]));
            const filename = `${pageName}.pdf`;
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        className: "button main-content--download-btn",
        "aria-label": "Download article as PDF",
        title: "Download as PDF",
        onClick: doGetPDF,
        disabled: loading,
        children: [
            loading ? "Fetching PDF..." : "Download Printable PDF",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgDefault.default), {
                src: "download",
                label: "Download",
                className: "icon",
                width: "1rem",
                height: "1rem"
            })
        ]
    });
};
exports.default = MainPagePDFButton;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","./common/svg":"4pImm","../utilities/fetch.js":"hAKRo","./hooks/useStore":"l1Yj7","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"b4Ak7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _luxon = require("luxon");
var _utilities = require("../../utilities");
var _utilitiesDefault = parcelHelpers.interopDefault(_utilities);
var _fieldMappingJson = require("../json/fieldMapping.json");
var _fieldMappingJsonDefault = parcelHelpers.interopDefault(_fieldMappingJson);
var _useFetchPages = require("./fetch/useFetchPages");
var _useFetchUsers = require("./fetch/useFetchUsers");
var _useStore = require("./useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
// Custom hook for parsing content with substitutions
const useParseContent = (content, userId = null)=>{
    const clientRef = (0, _useStoreDefault.default)((state)=>state.clientRef);
    const { data: substitutions } = (0, _useFetchPages.useFetchSubstitutions)({});
    const { data: user, isLoading: isUserLoading } = (0, _useFetchUsers.useFetchUser)({
        account: clientRef,
        userId
    });
    const currentUser = (0, _useStoreDefault.default)((state)=>state.currentUser);
    const profile = userId ? user : currentUser;
    // Object to store user-specific substitutions
    const userSubstitutions = {};
    (0, _fieldMappingJsonDefault.default).forEach((mapping)=>{
        var _profile_details, _profile_details1, _profile_details2, _profile_details3, _profile_details4, _profile_details5, _profile_details6;
        // Extract the nested property value from current user
        let userPropertyValue = (0, _utilitiesDefault.default).getNested(profile, mapping.mapToPath);
        // Format any date values
        if (mapping.key.endsWith("date")) {
            const date = (0, _luxon.DateTime).fromISO(userPropertyValue);
            userPropertyValue = date === null || date === void 0 ? void 0 : date.toFormat("dd/MM/yyyy");
        }
        // Combine multiple address details into a single string
        if (mapping.key === "address") userPropertyValue = [
            profile === null || profile === void 0 ? void 0 : (_profile_details = profile.details) === null || _profile_details === void 0 ? void 0 : _profile_details.address,
            profile === null || profile === void 0 ? void 0 : (_profile_details1 = profile.details) === null || _profile_details1 === void 0 ? void 0 : _profile_details1.address2,
            profile === null || profile === void 0 ? void 0 : (_profile_details2 = profile.details) === null || _profile_details2 === void 0 ? void 0 : _profile_details2.address3,
            profile === null || profile === void 0 ? void 0 : (_profile_details3 = profile.details) === null || _profile_details3 === void 0 ? void 0 : _profile_details3.address4,
            profile === null || profile === void 0 ? void 0 : (_profile_details4 = profile.details) === null || _profile_details4 === void 0 ? void 0 : _profile_details4.town,
            profile === null || profile === void 0 ? void 0 : (_profile_details5 = profile.details) === null || _profile_details5 === void 0 ? void 0 : _profile_details5.county,
            profile === null || profile === void 0 ? void 0 : (_profile_details6 = profile.details) === null || _profile_details6 === void 0 ? void 0 : _profile_details6.postcode
        ].filter(Boolean).join(", ");
        // Store the substituted value in the userSubstitutions object
        userSubstitutions[mapping.key] = userPropertyValue;
    });
    // Combine global substitutions with user-specific substitutions
    const shortcuts = {
        ...substitutions,
        ...userSubstitutions
    };
    // Check if the content is an array and apply substitutions to each item
    if (Array.isArray(content)) return content === null || content === void 0 ? void 0 : content.map((item)=>{
        if (typeof item === "string") return (0, _utilitiesDefault.default).parseShortcuts(item, shortcuts);
        return {
            ...item,
            content: (0, _utilitiesDefault.default).parseShortcuts(item === null || item === void 0 ? void 0 : item.content, shortcuts)
        };
    });
    // Apply substitutions to a string
    return (0, _utilitiesDefault.default).parseShortcuts(content, shortcuts);
};
exports.default = useParseContent;

},{"luxon":"24mCD","../../utilities":"fkdv9","../json/fieldMapping.json":"j0Qq1","./fetch/useFetchPages":"gzbN3","./fetch/useFetchUsers":"4DurT","./useStore":"l1Yj7","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"gzbN3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFetchPages", ()=>useFetchPages);
parcelHelpers.export(exports, "useFetchPagesSearch", ()=>useFetchPagesSearch);
parcelHelpers.export(exports, "useFetchSubstitutions", ()=>useFetchSubstitutions);
parcelHelpers.export(exports, "useFetchContentSummary", ()=>useFetchContentSummary);
parcelHelpers.export(exports, "useFetchContentRevisions", ()=>useFetchContentRevisions);
parcelHelpers.export(exports, "useFetchArticle", ()=>useFetchArticle);
parcelHelpers.export(exports, "useFetchNoAuthArticle", ()=>useFetchNoAuthArticle);
parcelHelpers.export(exports, "useCreatePage", ()=>useCreatePage);
parcelHelpers.export(exports, "useEditPage", ()=>useEditPage);
parcelHelpers.export(exports, "useCreateSection", ()=>useCreateSection);
parcelHelpers.export(exports, "useEditSection", ()=>useEditSection);
parcelHelpers.export(exports, "useDeleteArticle", ()=>useDeleteArticle);
parcelHelpers.export(exports, "useDeleteSection", ()=>useDeleteSection);
var _reactQuery = require("react-query");
var _fetchJs = require("../../../utilities/fetch.js");
var _useStoreJsx = require("../useStore.jsx");
var _useStoreJsxDefault = parcelHelpers.interopDefault(_useStoreJsx);
const pagesTransform = (data1)=>{
    var _data_data;
    if (data1 === null || data1 === void 0 ? void 0 : (_data_data = data1.data) === null || _data_data === void 0 ? void 0 : _data_data.items) return data1.data.items.filter((page)=>{
        return !!(page.description != "");
    }).map((page)=>{
        const output = {
            id: page.id,
            label: page.description,
            slug: page.slug,
            enabled: !page.underConstruction,
            clientCanEdit: !!page.clientCanEdit,
            type: page.pageType,
            catId: page.catId,
            assignedContractUsers: page.assignedContractUsers,
            contentType: page.contentType,
            access: page.access,
            isContract: page.isContract
        };
        if (page.content) output.content = page.content;
        return output;
    });
    return null;
};
const useFetchPages = ({ account = null, callback, refetch = true })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "pages"
    });
    const clientRef = (0, _useStoreJsxDefault.default).getState().clientRef;
    const setLoggedIn = (0, _useStoreJsxDefault.default).getState().setLoggedIn;
    return (0, _reactQuery.useQuery)([
        "pagesBasic",
        account
    ], ()=>{
        if (account === false) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: "/pages",
            params: {
                account: account
            }
        });
    }, {
        refetchInterval: refetch === false ? false : 30000,
        refetchOnMount: refetch === false ? false : true,
        refetchOnWindowFocus: refetch === false ? false : true,
        select: (data1)=>{
            var _data_data;
            if ((data1 === null || data1 === void 0 ? void 0 : (_data_data = data1.data) === null || _data_data === void 0 ? void 0 : _data_data.account) && clientRef && data1.data.account !== clientRef && clientRef !== "admin" && clientRef !== "app") {
                console.warn(`Account mismatch for pages: fetched account "${data1.data.account}" does not match client "${clientRef}"`);
                setLoggedIn(false);
            }
            return pagesTransform(data1);
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useFetchPagesSearch = ({ account = null, callback, searchTerms })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "pages"
    });
    return (0, _reactQuery.useQuery)([
        "pagesSearch",
        account,
        searchTerms
    ], ()=>(0, _fetchJs.request)({
            url: `/articles/search/${encodeURIComponent(searchTerms || "")}`,
            params: {
                account: account
            }
        }), {
        refetchInterval: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false,
        select: (data1)=>{
            var _data_data;
            return data1 === null || data1 === void 0 ? void 0 : (_data_data = data1.data) === null || _data_data === void 0 ? void 0 : _data_data.items;
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useFetchSubstitutions = ({ account = null, callback })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "substitutions"
    });
    return (0, _reactQuery.useQuery)([
        "substitutions",
        account
    ], ()=>(0, _fetchJs.request)({
            url: "/substitutions",
            params: {
                account: account
            }
        }), {
        refetchInterval: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        enabled: isMutating === 0,
        select: (data1)=>{
            return data1 === null || data1 === void 0 ? void 0 : data1.data;
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        }
    });
};
const useFetchContentSummary = ({ account = null, slug, callback })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "pages"
    });
    return (0, _reactQuery.useQuery)([
        "content-summary",
        slug,
        account
    ], ()=>{
        if (!slug) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/content-summary/${slug}`,
            params: {
                account: account
            }
        });
    }, {
        refetchInterval: 30000,
        select: (data1)=>{
            var _data_data;
            return data1 === null || data1 === void 0 ? void 0 : (_data_data = data1.data) === null || _data_data === void 0 ? void 0 : _data_data.items;
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useFetchContentRevisions = ({ account = null, contentId, callback })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "revisions"
    });
    return (0, _reactQuery.useQuery)([
        "revisions",
        contentId,
        account
    ], ()=>{
        console.log(contentId);
        if (!contentId) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/content-sections/${contentId}/history`,
            params: {
                account: account
            }
        });
    }, {
        refetchInterval: 30000,
        select: (data1)=>{
            var _data_data;
            return data1 === null || data1 === void 0 ? void 0 : (_data_data = data1.data) === null || _data_data === void 0 ? void 0 : _data_data.items;
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        enabled: isMutating === 0
    });
};
const useFetchArticle = ({ refetch = true, account = null, slug, callback })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "pages"
    });
    return (0, _reactQuery.useQuery)([
        "article",
        slug,
        account
    ], ()=>{
        if (!slug) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/articles/${slug}`,
            noToaster: true,
            params: {
                account: account
            }
        });
    }, {
        refetchInterval: refetch === false ? false : 30000,
        refetchOnMount: refetch === false ? false : true,
        refetchOnWindowFocus: refetch === false ? false : true,
        select: (data1)=>{
            return data1.data;
        },
        onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        retry: false,
        enabled: isMutating === 0
    });
};
const useFetchNoAuthArticle = ({ refetch = false, account = null, slug, callback })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "pages"
    });
    return (0, _reactQuery.useQuery)([
        "articleNoAuth",
        slug,
        account
    ], ()=>{
        if (!slug) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/articles/noauth/${slug}`,
            noToaster: true,
            params: {
                account: account
            }
        });
    }, {
        refetchInterval: refetch === false ? false : 30000,
        refetchOnMount: refetch === false ? false : true,
        refetchOnWindowFocus: refetch === false ? false : true,
        select: (data1)=>{
            return data1.data;
        },
        // onSuccess: callback,
        onError: (err)=>{
            console.error(err);
        },
        retry: false,
        enabled: isMutating === 0
    });
};
const useCreatePage = ({ account = null, callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data1)=>{
        if (!(data1 === null || data1 === void 0 ? void 0 : data1.description)) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: "/articles",
            method: "post",
            params: {
                account
            },
            data: data1,
            json: true
        });
    }, {
        mutationKey: "pages",
        onMutate: async ()=>{
            await queryClient.cancelQueries([
                "pagesBasic",
                account
            ]);
        },
        onSuccess: (data1)=>{
            queryClient.invalidateQueries([
                "pagesBasic",
                account
            ]);
            if (callback && typeof callback != "undefined") callback(data1 === null || data1 === void 0 ? void 0 : data1.data);
        }
    });
};
const useEditPage = ({ account = null, callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data1)=>{
        const pageId = data1 === null || data1 === void 0 ? void 0 : data1.id;
        const sendData = {
            ...data1
        };
        // we can't update the content with this endpoint,
        // but we can send an array of section IDs (i.e. for re-ordering)
        if (sendData.content) {
            const content = sendData.content.map((section)=>{
                return {
                    contentId: section.contentId
                };
            });
            sendData.contentPositions = content;
        }
        delete sendData.id;
        delete sendData.content;
        delete sendData.articleSlug;
        return (0, _fetchJs.request)({
            url: `/articles/${pageId}`,
            method: "patch",
            params: {
                account: account
            },
            data: sendData,
            json: true
        });
    }, {
        mutationKey: "pages",
        onMutate: async (data1)=>{
            var _queryClient_getQueryData_data, _queryClient_getQueryData, _queryClient_getQueryData1;
            await queryClient.cancelQueries([
                "pagesBasic",
                account
            ]);
            await queryClient.cancelQueries([
                "article",
                data1 === null || data1 === void 0 ? void 0 : data1.articleSlug,
                account
            ]);
            const pageId = data1.id;
            const sendData = {
                ...data1,
                enabled: !data1.underConstruction
            };
            delete sendData.id;
            // optimistic update pages data
            const currentPages = (_queryClient_getQueryData = queryClient.getQueryData([
                "pagesBasic",
                account
            ])) === null || _queryClient_getQueryData === void 0 ? void 0 : (_queryClient_getQueryData_data = _queryClient_getQueryData.data) === null || _queryClient_getQueryData_data === void 0 ? void 0 : _queryClient_getQueryData_data.items;
            if (currentPages) {
                const pageIndex = currentPages.findIndex((page)=>page.id === pageId);
                if (pageIndex >= 0) {
                    const currentPage = {
                        ...currentPages[pageIndex],
                        ...sendData
                    };
                    currentPages[pageIndex] = currentPage;
                    await queryClient.setQueryData([
                        "pagesBasic",
                        account
                    ], {
                        data: {
                            items: [
                                ...currentPages
                            ]
                        }
                    });
                }
            }
            // optimistic update article
            const currentArticle = (_queryClient_getQueryData1 = queryClient.getQueryData([
                "article",
                data1 === null || data1 === void 0 ? void 0 : data1.articleSlug,
                account
            ])) === null || _queryClient_getQueryData1 === void 0 ? void 0 : _queryClient_getQueryData1.data;
            if (currentArticle) {
                const updatedArticle = {
                    ...currentArticle,
                    ...data1
                };
                await queryClient.setQueryData([
                    "article",
                    data1 === null || data1 === void 0 ? void 0 : data1.articleSlug,
                    account
                ], {
                    data: {
                        ...updatedArticle
                    }
                });
                // 'sleep' 10s, allow move animation to complete
                await new Promise((r)=>setTimeout(r, 500));
                updatedArticle.content = updatedArticle.content.map((section)=>{
                    delete section.moved;
                    return section;
                });
                // 'moved' property was used to add css class.
                // now update with the property removed
                await queryClient.setQueryData([
                    "article",
                    data1 === null || data1 === void 0 ? void 0 : data1.articleSlug,
                    account
                ], {
                    data: {
                        ...updatedArticle
                    }
                });
            }
        },
        onSettled: async (_d, _u, data1)=>{
            queryClient.invalidateQueries([
                "article",
                data1 === null || data1 === void 0 ? void 0 : data1.articleSlug,
                account
            ]);
            queryClient.invalidateQueries([
                "pagesBasic",
                account
            ]);
            if (callback && typeof callback != "undefined") callback(data1);
        }
    });
};
const useCreateSection = ({ account = null, articleSlug, callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data1)=>{
        if (!data1.contentType) data1.contentType = "content";
        return (0, _fetchJs.request)({
            url: `/articles/${articleSlug}`,
            method: "post",
            params: {
                account
            },
            data: data1,
            json: true
        });
    }, {
        mutationKey: "pages",
        onMutate: (params)=>{
        // contentType = params.type,
        // contentTypeId = params.id
        },
        onSuccess: async (data1)=>{
            var _queryClient_getQueryData;
            // update data
            const currentArticle = (_queryClient_getQueryData = queryClient.getQueryData([
                "article",
                articleSlug,
                account
            ])) === null || _queryClient_getQueryData === void 0 ? void 0 : _queryClient_getQueryData.data;
            const currentContent = currentArticle === null || currentArticle === void 0 ? void 0 : currentArticle.content;
            currentContent.push(data1 === null || data1 === void 0 ? void 0 : data1.data);
            currentArticle.content = currentContent;
            await queryClient.setQueryData([
                "article",
                articleSlug,
                account
            ], {
                data: {
                    ...currentArticle
                }
            });
            if (callback && typeof callback != "undefined") callback(data1 === null || data1 === void 0 ? void 0 : data1.data);
        }
    });
};
const useEditSection = ({ account = null, callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data1)=>{
        const sectionId = data1 === null || data1 === void 0 ? void 0 : data1.id;
        const sendData = {
            ...data1
        };
        delete sendData.id;
        delete sendData.articleSlug;
        return (0, _fetchJs.request)({
            url: `/content-sections/${sectionId}`,
            method: "patch",
            params: {
                account: account
            },
            data: sendData,
            json: true
        });
    }, {
        mutationKey: "pages",
        onMutate: async (data1)=>{
            var _queryClient_getQueryData;
            const sectionId = data1.id;
            const articleSlug = data1.articleSlug;
            await queryClient.cancelQueries([
                "article",
                articleSlug,
                account
            ]);
            const sendData = {
                ...data1
            };
            delete sendData.id;
            delete sendData.articleSlug;
            // optimistic update data
            const currentArticle = (_queryClient_getQueryData = queryClient.getQueryData([
                "article",
                articleSlug,
                account
            ])) === null || _queryClient_getQueryData === void 0 ? void 0 : _queryClient_getQueryData.data;
            const currentContent = [
                ...currentArticle === null || currentArticle === void 0 ? void 0 : currentArticle.content
            ];
            const sectionIndex = currentContent.findIndex((section)=>section.contentId === sectionId);
            if (sectionIndex >= 0) {
                var _sendData_image;
                const currentSection = {
                    ...currentContent[sectionIndex],
                    ...sendData
                };
                const update = {
                    ...currentArticle
                };
                // if we've changed the image, use property to render
                // skeleton until we've fetched the full image data
                if ((_sendData_image = sendData.image) === null || _sendData_image === void 0 ? void 0 : _sendData_image.imageId) currentSection.image = {
                    ...sendData.image,
                    skeleton: true
                };
                update.content[sectionIndex] = currentSection;
                await queryClient.setQueryData([
                    "article",
                    articleSlug,
                    account
                ], {
                    data: {
                        ...update
                    }
                });
            }
            queryClient.invalidateQueries([
                "article",
                articleSlug,
                account
            ]);
            if (callback && typeof callback != "undefined") callback(data1);
        },
        onSettled: async (_d, _u, data1)=>{
            queryClient.invalidateQueries([
                "article",
                data1 === null || data1 === void 0 ? void 0 : data1.articleSlug,
                account
            ]);
        }
    });
};
const useDeleteArticle = ({ account = null, callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((pageId)=>{
        return (0, _fetchJs.request)({
            url: `/articles/${pageId}`,
            method: "delete",
            params: {
                account: account
            }
        });
    }, {
        mutationKey: "pages",
        onMutate: async (pageId)=>{
            var _queryClient_getQueryData_data, _queryClient_getQueryData;
            await queryClient.cancelQueries([
                "pagesBasic",
                account
            ]);
            const currentPages = (_queryClient_getQueryData = queryClient.getQueryData([
                "pagesBasic",
                account
            ])) === null || _queryClient_getQueryData === void 0 ? void 0 : (_queryClient_getQueryData_data = _queryClient_getQueryData.data) === null || _queryClient_getQueryData_data === void 0 ? void 0 : _queryClient_getQueryData_data.items;
            // optimistic update data
            if ((currentPages === null || currentPages === void 0 ? void 0 : currentPages.length) > 0) {
                const deleteIndex = currentPages.findIndex((page)=>(page === null || page === void 0 ? void 0 : page.id) === pageId);
                currentPages.splice(deleteIndex, 1);
                await queryClient.setQueryData([
                    "pagesBasic",
                    account
                ], {
                    data: {
                        items: [
                            ...currentPages
                        ]
                    }
                });
                queryClient.invalidateQueries([
                    "pagesBasic",
                    account
                ]);
            }
        },
        onSettled: ()=>{
            queryClient.invalidateQueries([
                "pagesBasic",
                account
            ]);
        },
        onSuccess: callback
    });
};
const useDeleteSection = ({ account = null, callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)(({ id: sectionId })=>{
        return (0, _fetchJs.request)({
            url: `/content-sections/${sectionId}`,
            method: "delete",
            params: {
                account: account
            },
            json: true
        });
    }, {
        mutationKey: "pages",
        onMutate: async ({ id: sectionId, articleSlug })=>{
            var _queryClient_getQueryData;
            await queryClient.cancelQueries([
                "article",
                articleSlug,
                account
            ]);
            // optimistic update data
            const currentArticle = (_queryClient_getQueryData = queryClient.getQueryData([
                "article",
                articleSlug,
                account
            ])) === null || _queryClient_getQueryData === void 0 ? void 0 : _queryClient_getQueryData.data;
            const currentContent = currentArticle === null || currentArticle === void 0 ? void 0 : currentArticle.content;
            const sectionIndex = currentContent.findIndex((section)=>section.contentId === sectionId);
            if (sectionIndex >= 0) {
                currentContent.splice(sectionIndex, 1);
                currentArticle.content = currentContent;
                await queryClient.setQueryData([
                    "article",
                    articleSlug,
                    account
                ], {
                    data: {
                        ...currentArticle
                    }
                });
            }
            queryClient.invalidateQueries([
                "article",
                articleSlug,
                account
            ]);
            if (callback && typeof callback != "undefined") callback(data);
        },
        onSettled: async (_d, _u, data1)=>{
            queryClient.invalidateQueries([
                "article",
                data1 === null || data1 === void 0 ? void 0 : data1.articleSlug,
                account
            ]);
        }
    });
};
exports.default = useFetchPages;

},{"react-query":"41hyj","../../../utilities/fetch.js":"hAKRo","../useStore.jsx":"l1Yj7","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"ljrwG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _svg = require("./svg");
var _svgDefault = parcelHelpers.interopDefault(_svg);
require("dde64e2fefbe9781");
const PrintButton = ({ className, onClick })=>{
    const buttonClass = "print-button" + (className ? " " + className : "");
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        className: buttonClass,
        "aria-label": "Print",
        type: "button",
        onClick: onClick,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgDefault.default), {
            src: "printer",
            className: "icon",
            label: "Print"
        })
    });
};
exports.default = PrintButton;

},{"react/jsx-runtime":"i3K7E","dde64e2fefbe9781":"5mgb0","./svg":"4pImm","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"5mgb0":[function(require,module,exports,__globalThis) {
module.exports = require("7142654e7e26768")(module.bundle.resolve("dDLTL"));

},{"7142654e7e26768":"efVvj"}],"5QfYy":[function() {},{}],"e8Uk6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFetchAccounts", ()=>useFetchAccounts);
parcelHelpers.export(exports, "useFetchAccount", ()=>useFetchAccount);
parcelHelpers.export(exports, "useEditAccount", ()=>useEditAccount);
parcelHelpers.export(exports, "useCreateAccount", ()=>useCreateAccount);
parcelHelpers.export(exports, "useDeleteAccount", ()=>useDeleteAccount);
parcelHelpers.export(exports, "useAddAccount", ()=>useAddAccount);
var _reactQuery = require("react-query");
var _fetchJs = require("../../../utilities/fetch.js");
const useFetchAccounts = ({ callback, enabled = true })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "adminAccounts"
    });
    return (0, _reactQuery.useQuery)("adminAccounts", ()=>{
        return (0, _fetchJs.request)({
            url: "/admin/accounts"
        });
    }, {
        refetchInterval: false,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        select: (data)=>{
            var _data_data;
            return data === null || data === void 0 ? void 0 : (_data_data = data.data) === null || _data_data === void 0 ? void 0 : _data_data.sort((a, b)=>{
                var _b_description, _a_description;
                return (_a_description = a.description) === null || _a_description === void 0 ? void 0 : _a_description.toLowerCase().localeCompare((_b_description = b.description) === null || _b_description === void 0 ? void 0 : _b_description.toLowerCase());
            });
        },
        initialData: ()=>{
            if (localStorage.getItem("accounts")) return {
                data: JSON.parse(localStorage.getItem("accounts"))
            };
        },
        onSuccess: (data)=>{
            localStorage.setItem("accounts", JSON.stringify(data));
            if (callback && typeof callback != "undefined") callback(data);
        },
        enabled: isMutating === 0 && enabled
    });
};
const useFetchAccount = ({ account = null, callback, retry = true })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "adminAccounts"
    });
    return (0, _reactQuery.useQuery)([
        "account",
        account
    ], ()=>{
        if (!account || account === "app") return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/account/${account}`
        });
    }, {
        refetchInterval: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: retry,
        select: (data)=>{
            return data === null || data === void 0 ? void 0 : data.data;
        },
        onSuccess: (data)=>{
            if (callback && typeof callback != "undefined") callback(data);
        },
        enabled: isMutating === 0
    });
};
const useEditAccount = ({ account = null, callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data)=>{
        let thisAccount = account || (data === null || data === void 0 ? void 0 : data.account);
        data.account = data.clientRef;
        delete data.clientRef;
        return (0, _fetchJs.request)({
            url: `/admin/accounts/${thisAccount}`,
            method: "patch",
            data: data,
            json: true
        });
    }, {
        mutationKey: "adminAccounts",
        onMutate: async (data)=>{
            var _queryClient_getQueryData, _queryClient_getQueryData1;
            let thisAccount = account || (data === null || data === void 0 ? void 0 : data.account);
            await queryClient.cancelQueries([
                "account",
                thisAccount
            ]);
            // optimistic update data
            const currentData = (_queryClient_getQueryData = queryClient.getQueryData([
                "account",
                thisAccount
            ])) === null || _queryClient_getQueryData === void 0 ? void 0 : _queryClient_getQueryData.data;
            if (currentData === null || currentData === void 0 ? void 0 : currentData.settings) {
                var _currentData_settings, _data_settings;
                const dbTabs = (currentData === null || currentData === void 0 ? void 0 : (_currentData_settings = currentData.settings) === null || _currentData_settings === void 0 ? void 0 : _currentData_settings.dbTabs) || {};
                data.settings.dbTabs = {
                    ...dbTabs,
                    ...data === null || data === void 0 ? void 0 : (_data_settings = data.settings) === null || _data_settings === void 0 ? void 0 : _data_settings.dbTabs
                };
            }
            await queryClient.setQueryData([
                "account",
                thisAccount
            ], {
                data: {
                    ...currentData,
                    ...data
                }
            });
            queryClient.invalidateQueries([
                "account",
                thisAccount
            ]);
            // update 'accounts' array
            await queryClient.cancelQueries("adminAccounts");
            const updated = (_queryClient_getQueryData1 = queryClient.getQueryData("adminAccounts")) === null || _queryClient_getQueryData1 === void 0 ? void 0 : _queryClient_getQueryData1.data;
            const changedAccountIndex = updated === null || updated === void 0 ? void 0 : updated.findIndex((account)=>account.account === thisAccount);
            if (changedAccountIndex >= 0) {
                updated[changedAccountIndex] = {
                    ...updated[changedAccountIndex],
                    ...data
                };
                await queryClient.setQueryData("adminAccounts", {
                    data: [
                        ...updated
                    ]
                });
            }
            queryClient.invalidateQueries("adminAccounts");
        },
        onSettled: (data)=>{
            if (callback && typeof callback != "undefined") callback(data);
        }
    });
};
const useCreateAccount = ({ callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data)=>{
        return (0, _fetchJs.request)({
            url: `/admin/accounts`,
            method: "post",
            data: data,
            json: true
        });
    }, {
        mutationKey: "adminAccounts",
        onMutate: async (_d, _u, data)=>{
            var _queryClient_getQueryData;
            // update 'accounts' array
            await queryClient.cancelQueries("adminAccounts");
            const updated = (_queryClient_getQueryData = queryClient.getQueryData("adminAccounts")) === null || _queryClient_getQueryData === void 0 ? void 0 : _queryClient_getQueryData.data;
            updated.push({
                ...data
            });
            await queryClient.setQueryData("adminAccounts", {
                data: [
                    ...updated
                ]
            });
            queryClient.invalidateQueries("adminAccounts");
        },
        onSettled: (data)=>{
            if (callback && typeof callback != "undefined") callback(data);
        }
    });
};
const useDeleteAccount = ({ callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((accountName)=>{
        return (0, _fetchJs.request)({
            url: `/admin/accounts/${accountName}`,
            method: "delete"
        });
    }, {
        mutationKey: "adminAccounts",
        onMutate: async (accountName)=>{
            var _currentAccounts_data;
            await queryClient.cancelQueries("account");
            const currentAccounts = queryClient.getQueryData("adminAccounts");
            // optimistic update data
            if ((currentAccounts === null || currentAccounts === void 0 ? void 0 : (_currentAccounts_data = currentAccounts.data) === null || _currentAccounts_data === void 0 ? void 0 : _currentAccounts_data.length) > 0) {
                const updated = [
                    ...currentAccounts.data
                ];
                const deleteIndex = updated.findIndex((account)=>(account === null || account === void 0 ? void 0 : account.account) === accountName);
                updated.splice(deleteIndex, 1);
                await queryClient.setQueryData("adminAccounts", {
                    data: [
                        ...updated
                    ]
                });
            }
        },
        onSettled: ()=>{
            queryClient.invalidateQueries("adminAccounts");
        },
        onSuccess: callback
    });
};
const useAddAccount = ()=>{};
exports.default = useFetchAccounts;

},{"react-query":"41hyj","../../../utilities/fetch.js":"hAKRo","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"9sPBO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFetchAdminConfig", ()=>useFetchAdminConfig);
parcelHelpers.export(exports, "useUpdateAdminConfig", ()=>useUpdateAdminConfig);
var _reactQuery = require("react-query");
var _fetchJs = require("../../../utilities/fetch.js");
const useFetchAdminConfig = ({ callback })=>{
    const isMutating = (0, _reactQuery.useIsMutating)({
        mutationKey: "adminConfig"
    });
    return (0, _reactQuery.useQuery)("adminConfig", ()=>{
        return (0, _fetchJs.request)({
            url: "/admin/config"
        });
    }, {
        refetchInterval: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        select: (data)=>{
            return data === null || data === void 0 ? void 0 : data.data;
        },
        onSuccess: (data)=>{
            if (callback && typeof callback != "undefined") callback(data);
        },
        enabled: isMutating === 0
    });
};
const useUpdateAdminConfig = ({ callback })=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)((data)=>{
        if (!data) return Promise.resolve({});
        return (0, _fetchJs.request)({
            url: `/admin/config`,
            method: "patch",
            data: data,
            json: true
        });
    }, {
        mutationKey: "adminConfig",
        onMutate: async (data)=>{
            var _queryClient_getQueryData;
            await queryClient.cancelQueries("adminConfig");
            // optimistic update data
            const currentConfig = (_queryClient_getQueryData = queryClient.getQueryData("adminConfig")) === null || _queryClient_getQueryData === void 0 ? void 0 : _queryClient_getQueryData.data;
            await queryClient.setQueryData("adminConfig", {
                data: {
                    ...currentConfig,
                    ...data
                }
            });
            queryClient.invalidateQueries("adminConfig");
            if (callback && typeof callback != "undefined") callback(data);
        },
        onSettled: async ()=>{
            queryClient.invalidateQueries("adminConfig");
        }
    });
};

},{"react-query":"41hyj","../../../utilities/fetch.js":"hAKRo","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"38bNK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactHotToast = require("react-hot-toast");
var _reactHotToastDefault = parcelHelpers.interopDefault(_reactHotToast);
var _throbber = require("./common/throbber");
var _throbberDefault = parcelHelpers.interopDefault(_throbber);
var _fetchJs = require("../utilities/fetch.js");
var _useStore = require("./hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
var _tokenLoginScss = require("../../scss/components/tokenLogin.scss");
const TokenLogin = ({ token, onLogin })=>{
    const subdomain = (0, _useStoreDefault.default)((state)=>state.subdomain);
    const pathAccount = subdomain || 'master';
    const doLogin = async ()=>{
        const tokenDecoded = JSON.parse(atob(token));
        if ((tokenDecoded === null || tokenDecoded === void 0 ? void 0 : tokenDecoded.username) && (tokenDecoded === null || tokenDecoded === void 0 ? void 0 : tokenDecoded.token)) try {
            const login = await (0, _fetchJs.request)({
                url: `/auth/${pathAccount}`,
                method: 'POST',
                data: {
                    username: tokenDecoded === null || tokenDecoded === void 0 ? void 0 : tokenDecoded.username,
                    token: tokenDecoded === null || tokenDecoded === void 0 ? void 0 : tokenDecoded.token
                }
            });
            const jwt = login === null || login === void 0 ? void 0 : login.data;
            if (jwt && onLogin) {
                onLogin(true, jwt, false);
                window.location.href = '/';
            }
        } catch (err) {
            console.log('Could not log in with token', err);
            (0, _reactHotToastDefault.default).error((err === null || err === void 0 ? void 0 : err.toasterMessage) || 'Something went wrong');
            onLogin(false);
            window.location.href = '/';
        }
    };
    (0, _react.useEffect)(()=>{
        if (token) window.setTimeout(doLogin, 1000);
    }, [
        token
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "token-login-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _throbberDefault.default), {})
    });
};
exports.default = TokenLogin;

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","react-hot-toast":"jcNGA","./common/throbber":"c8mQZ","../utilities/fetch.js":"hAKRo","./hooks/useStore":"l1Yj7","../../scss/components/tokenLogin.scss":"gbHWm","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"gbHWm":[function() {},{}],"1kpl0":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.load("bWjly").then(()=>module.bundle.root('q9Qa0'));

},{}],"W9TJl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useStore = require("./useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
var _useFetchUsers = require("./fetch/useFetchUsers");
var _useFetchAccounts = require("./fetch/useFetchAccounts");
const useAppState = ()=>{
    var _account_settings, _account_settings1, _account_settings2, _account_settings3, _account_settings4, _account_settings5;
    const clientRef = (0, _useStoreDefault.default)((state)=>state.clientRef);
    const currentUserState = (0, _useStoreDefault.default)((state)=>state.currentUser);
    const setCurrentUser = (0, _useStoreDefault.default)((state)=>state.setCurrentUser);
    const isCurrentUserLoadingState = (0, _useStoreDefault.default)((state)=>state.isCurrentUserLoading);
    const setIsCurrentUserLoading = (0, _useStoreDefault.default)((state)=>state.setIsCurrentUserLoading);
    const settingsState = (0, _useStoreDefault.default)((state)=>state.settings);
    const setSettings = (0, _useStoreDefault.default)((state)=>state.setSettings);
    const isSettingsLoadingState = (0, _useStoreDefault.default)((state)=>state.isSettingsLoading);
    const setIsSettingsLoading = (0, _useStoreDefault.default)((state)=>state.setIsSettingsLoading);
    const { data: user, isLoading: isCurrentUserLoading } = (0, _useFetchUsers.useFetchMe)({
        refetch: false
    });
    const { data: account, isLoading: isSettingsLoading } = (0, _useFetchAccounts.useFetchAccount)({
        account: clientRef || null,
        refetch: false
    });
    const hasAbsence = !!((account === null || account === void 0 ? void 0 : (_account_settings = account.settings) === null || _account_settings === void 0 ? void 0 : _account_settings.holidayModule) && !(user === null || user === void 0 ? void 0 : user.disableHolidayModule));
    const hasEmployee = !!(account === null || account === void 0 ? void 0 : (_account_settings1 = account.settings) === null || _account_settings1 === void 0 ? void 0 : _account_settings1.employmentDb);
    const hasTraining = !!(account === null || account === void 0 ? void 0 : (_account_settings2 = account.settings) === null || _account_settings2 === void 0 ? void 0 : _account_settings2.training);
    const employeeTabs = (account === null || account === void 0 ? void 0 : (_account_settings3 = account.settings) === null || _account_settings3 === void 0 ? void 0 : _account_settings3.dbTabs) || {};
    const moduleAccess = (account === null || account === void 0 ? void 0 : (_account_settings4 = account.settings) === null || _account_settings4 === void 0 ? void 0 : _account_settings4.moduleAccess) || {};
    const hasEditablePages = !!(account === null || account === void 0 ? void 0 : (_account_settings5 = account.settings) === null || _account_settings5 === void 0 ? void 0 : _account_settings5.hasEditablePages);
    const accessLevel = (user === null || user === void 0 ? void 0 : user.accessLevel) || 0;
    const isPayroll = !!(user === null || user === void 0 ? void 0 : user.payroll);
    const isManager = (user === null || user === void 0 ? void 0 : user.accessLevel) === 2;
    const isSeniorManager = (user === null || user === void 0 ? void 0 : user.accessLevel) === 2.5;
    const isHR = (user === null || user === void 0 ? void 0 : user.accessLevel) >= 3;
    const isTopDog = (user === null || user === void 0 ? void 0 : user.accessLevel) >= 3.6;
    const isAbsenceManager = !!!(user === null || user === void 0 ? void 0 : user.disableHolidayModule) && // (isManager || isSeniorManager) &&
    Array.isArray(user === null || user === void 0 ? void 0 : user.groupsDetails) && (user === null || user === void 0 ? void 0 : user.groupsDetails.length) > 0 && (user === null || user === void 0 ? void 0 : user.groupsDetails.findIndex((group)=>(group === null || group === void 0 ? void 0 : group.absenceApproverAccess) === true)) > -1;
    const isLineManager = !!(isManager && Array.isArray(user === null || user === void 0 ? void 0 : user.managedUsers) && (user === null || user === void 0 ? void 0 : user.managedUsers.filter((user)=>{
        return !!(user === null || user === void 0 ? void 0 : user.enabled);
    }).length) > 0);
    const currentUser = {
        ...user,
        accessLevel,
        isPayroll,
        isManager,
        isSeniorManager,
        isHR,
        isAbsenceManager,
        isLineManager,
        isTopDog
    };
    const settings = {
        hasAbsence,
        hasEmployee,
        hasTraining,
        hasEditablePages,
        employeeTabs,
        moduleAccess
    };
    (0, _react.useEffect)(()=>{
        if (JSON.stringify(currentUserState) !== JSON.stringify(currentUser)) setCurrentUser(currentUser);
        if (isCurrentUserLoadingState !== isCurrentUserLoading) setIsCurrentUserLoading(isCurrentUserLoading);
        if (JSON.stringify(settingsState) !== JSON.stringify(settings)) setSettings(settings);
        if (isSettingsLoadingState !== isSettingsLoading) setIsSettingsLoading(isSettingsLoading);
    }, [
        settings,
        settingsState,
        isSettingsLoading,
        isCurrentUserLoading,
        currentUser
    ]);
};
exports.default = useAppState;

},{"react":"6wC8C","./useStore":"l1Yj7","./fetch/useFetchUsers":"4DurT","./fetch/useFetchAccounts":"e8Uk6","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"i7xnh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActivityTracker", ()=>ActivityTracker);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _useDebounce = require("../hooks/useDebounce");
var _useStore = require("../hooks/useStore");
var _useStoreDefault = parcelHelpers.interopDefault(_useStore);
var _inactivityWarning = require("./InactivityWarning");
const ACTIVITY_EVENTS = [
    "mousedown",
    "mousemove",
    "keydown",
    "scroll",
    "touchstart"
];
const DEBOUNCE_DELAY = 100; // 100ms debounce for more responsive updates
const CHECK_INTERVAL = 1000; // 1 second interval for checking inactivity
const DEFAULT_TIMEOUT = 300; // 5 minutes
const MAX_TIMEOUT = 86400; // 1 day
const APP_TIMEOUT = 2592000; // 30 days
const getTimeoutConfig = (currentUser, subdomain)=>{
    // If subdomain is 'app', return 30 days timeout with 1 minute warning
    if (subdomain === "app") return {
        timeout: APP_TIMEOUT,
        warning: 60
    };
    if (subdomain === "admin") return {
        timeout: MAX_TIMEOUT,
        warning: 60
    };
    let timeoutDuration = currentUser === null || currentUser === void 0 ? void 0 : currentUser.uiTimeout;
    // If no timeout specified or invalid, use default
    if (!timeoutDuration || isNaN(timeoutDuration)) timeoutDuration = DEFAULT_TIMEOUT;
    // Ensure timeout is within bounds
    timeoutDuration = Math.min(timeoutDuration, MAX_TIMEOUT);
    // Calculate warning threshold
    const warningThreshold = timeoutDuration <= 60 ? 15 : 60;
    return {
        timeout: timeoutDuration,
        warning: warningThreshold
    };
};
const ActivityTracker = ({ children, onTimeout })=>{
    const [showWarning, setShowWarning] = (0, _react.useState)(false);
    const [isPaused, setIsPaused] = (0, _react.useState)(false);
    const isLoggedIn = localStorage.getItem("loggedIn") === "true";
    const currentUser = (0, _useStoreDefault.default)((state)=>state.currentUser);
    const subdomain = (0, _useStoreDefault.default)((state)=>state.subdomain);
    const [timeoutConfig, setTimeoutConfig] = (0, _react.useState)(getTimeoutConfig(currentUser, subdomain));
    (0, _react.useEffect)(()=>{
        const config = getTimeoutConfig(currentUser, subdomain);
        setTimeoutConfig(config);
    }, [
        currentUser
    ]);
    const updateLastActivity = (0, _react.useCallback)(()=>{
        if (!isPaused && isLoggedIn) localStorage.setItem("lastActivity", Date.now().toString());
    }, [
        isPaused,
        isLoggedIn
    ]);
    const debouncedUpdateActivity = (0, _useDebounce.useDebounce)(updateLastActivity, DEBOUNCE_DELAY);
    const checkIntervalRef = (0, _react.useRef)(null);
    const handleStayLoggedIn = ()=>{
        setShowWarning(false);
        setIsPaused(false);
        // Force an immediate activity update when staying logged in
        localStorage.setItem("lastActivity", Date.now().toString());
    };
    // Setup effect - runs once on mount and when login state changes
    (0, _react.useEffect)(()=>{
        if (!isLoggedIn) {
            localStorage.removeItem("lastActivity");
            setShowWarning(false);
            setIsPaused(false);
        }
        // Add event listeners
        ACTIVITY_EVENTS.forEach((event)=>{
            window.addEventListener(event, debouncedUpdateActivity);
        });
        // Cleanup
        return ()=>{
            ACTIVITY_EVENTS.forEach((event)=>{
                window.removeEventListener(event, debouncedUpdateActivity);
            });
            debouncedUpdateActivity.cancel();
        };
    }, [
        debouncedUpdateActivity,
        isLoggedIn
    ]); // Update when login state changes
    // Timer check effect - separate from event listeners
    (0, _react.useEffect)(()=>{
        checkIntervalRef.current = setInterval(()=>{
            const lastActivityStr = localStorage.getItem("lastActivity");
            if (!lastActivityStr) return; // Skip if no activity timestamp exists
            const lastActivity = parseInt(lastActivityStr, 10);
            if (isNaN(lastActivity)) return; // Skip if timestamp is invalid
            const now = Date.now();
            const secondsSinceLastActivity = Math.floor((now - lastActivity) / 1000);
            // Only show warning if not already shown and not paused
            if (!isPaused && !showWarning && secondsSinceLastActivity >= timeoutConfig.timeout - timeoutConfig.warning) {
                setShowWarning(true);
                setIsPaused(true);
            }
            // Handle timeout
            if (secondsSinceLastActivity >= timeoutConfig.timeout && isLoggedIn) {
                // Clean up all timeout-related state
                localStorage.removeItem("authToken");
                localStorage.removeItem("lastActivity");
                setShowWarning(false);
                setIsPaused(false);
                if (onTimeout) onTimeout();
            }
        }, CHECK_INTERVAL);
        return ()=>{
            if (checkIntervalRef.current) clearInterval(checkIntervalRef.current);
        };
    }, [
        isPaused,
        showWarning,
        isLoggedIn,
        onTimeout,
        timeoutConfig
    ]); // Include all dependencies
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            showWarning && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inactivityWarning.InactivityWarning), {
                onStayLoggedIn: handleStayLoggedIn,
                warningSeconds: timeoutConfig.warning
            }),
            children
        ]
    });
};

},{"react/jsx-runtime":"i3K7E","react":"6wC8C","../hooks/useDebounce":"d0H5u","../hooks/useStore":"l1Yj7","./InactivityWarning":"gfjWp","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"d0H5u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDebounce", ()=>useDebounce);
var _react = require("react");
const useDebounce = (callback, delay)=>{
    const timeoutRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        // Cleanup on unmount
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    const debouncedCallback = (0, _react.useCallback)((...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>{
            callback(...args);
        }, delay);
    }, [
        callback,
        delay
    ]);
    // Add a cancel method similar to lodash's debounce
    debouncedCallback.cancel = ()=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
    return debouncedCallback;
};

},{"react":"6wC8C","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"gfjWp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InactivityWarning", ()=>InactivityWarning);
var _jsxRuntime = require("react/jsx-runtime");
const InactivityWarning = ({ onStayLoggedIn, warningSeconds })=>{
    const styles = {
        overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 99999
        },
        modal: {
            background: "var(--colour-content-background)",
            color: "var(--colour-content-text)",
            padding: "2rem",
            borderRadius: "8px",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem"
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: styles.overlay,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: styles.modal,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: "Session Timeout Warning"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    children: [
                        "You will be logged out in ",
                        warningSeconds,
                        " seconds due to inactivity."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "button",
                    style: styles.button,
                    onClick: onStayLoggedIn,
                    children: "Stay Logged In"
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"i3K7E","@parcel/transformer-js/src/esmodule-helpers.js":"iVc5x"}],"hJioV":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("glxJL");

},{}]},["bjDQT","9jmdF"], "9jmdF", "parcelRequire9b8f", {}, "./", "./")

//# sourceMappingURL=frontend.9c4788fd.js.map
